angular.module('c', [
    'ui.router',
    'ui.mask',

    'elif',

    // 'angular-loading-bar',
    //'ui.select',
    'ngSanitize',
    'ngTable',
    'ngLocale',
    'toaster',
    'dialogs.main',
    'pascalprecht.translate',
    'dialogs.default-translations',

    'sticky',

    //'ui.tree',
    'ui.slimscroll',
    'ui.checkbox',
    'ngAnimate',
    'rzModule',
    'angular-clipboard',
    'angularPromiseButtons',

    //'monospaced.qrcode',
    'angular-click-outside',
    'monospaced.elastic',
    'mgo-angular-wizard',

    'ui.bootstrap',
    /*'ui.bootstrap.datetimepicker',*/
    'mwl.calendar',
    'toggle-switch',
    'FBAngular',
    'ngFileUpload',
    'btford.socket-io',
    'angularMoment',

    //'angular-img-cropper',
    'ipCookie',
    'colorpicker.module',

    'dndLists',
    'oc.lazyLoad',

    'ng.deviceDetector',
    'ckeditor',
    'uiCropper',

    'c.d',
    'c.c',
    'c.s'
    //'ui.utils',
]);

angular.module('c.d', []);

angular.module('c.c', []);

angular.module('c.s', ['ngResource', 'ngStorage', 'fileSaver']);


angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "\u4e0a\u5348",
                "\u4e0b\u5348"
            ],
            "DAY": [
                "\u661f\u671f\u65e5",
                "\u661f\u671f\u4e00",
                "\u661f\u671f\u4e8c",
                "\u661f\u671f\u4e09",
                "\u661f\u671f\u56db",
                "\u661f\u671f\u4e94",
                "\u661f\u671f\u516d"
            ],
            "ERANAMES": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "ERAS": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
                "\u4e00\u6708",
                "\u4e8c\u6708",
                "\u4e09\u6708",
                "\u56db\u6708",
                "\u4e94\u6708",
                "\u516d\u6708",
                "\u4e03\u6708",
                "\u516b\u6708",
                "\u4e5d\u6708",
                "\u5341\u6708",
                "\u5341\u4e00\u6708",
                "\u5341\u4e8c\u6708"
            ],
            "SHORTDAY": [
                "\u5468\u65e5",
                "\u5468\u4e00",
                "\u5468\u4e8c",
                "\u5468\u4e09",
                "\u5468\u56db",
                "\u5468\u4e94",
                "\u5468\u516d"
            ],
            "SHORTMONTH": [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
            "longDate": "y\u5e74M\u6708d\u65e5",
            "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
            "mediumDate": "y\u5e74M\u6708d\u65e5",
            "mediumTime": "ah:mm:ss",
            "short": "yy/M/d ah:mm",
            "shortDate": "yy/M/d",
            "shortTime": "ah:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u00a5",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "\u00a4\u00a0-",
                    "negSuf": "",
                    "posPre": "\u00a4\u00a0",
                    "posSuf": ""
                }
            ]
        },
        "id": "zh-cn",
        "pluralCat": function (n, opt_precision) {
            return PLURAL_CATEGORY.OTHER;
        }
    });
}]);
(function ($) {
    var attachEvent = document.attachEvent,
        stylesCreated = false;

    var jQuery_resize = $.fn.resize;

    $.fn.resize = function (callback) {
        return this.each(function () {
            if (this == window)
                jQuery_resize.call(jQuery(this), callback);
            else
                addResizeListener(this, callback);
        });
    }

    $.fn.removeResize = function (callback) {
        return this.each(function () {
            removeResizeListener(this, callback);
        });
    }

    if (!attachEvent) {
        var requestFrame = (function () {
            var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
                function (fn) {
                    return window.setTimeout(fn, 20);
                };
            return function (fn) {
                return raf(fn);
            };
        })();

        var cancelFrame = (function () {
            var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
                window.clearTimeout;
            return function (id) {
                return cancel(id);
            };
        })();

        function resetTriggers(element) {
            var triggers = element.__resizeTriggers__,
                expand = triggers.firstElementChild,
                contract = triggers.lastElementChild,
                expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };

        function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width ||
                element.offsetHeight != element.__resizeLast__.height;
        }

        function scrollListener(e) {
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function () {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function (fn) {
                        fn.call(element, e);
                    });
                }
            });
        };

        /* Detect CSS Animations support to detect element display/re-attach */
        var animation = false,
            animationstring = 'animation',
            keyframeprefix = '',
            animationstartevent = 'animationstart',
            domPrefixes = 'Webkit Moz O ms'.split(' '),
            startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
            pfx = '';
        {
            var elm = document.createElement('fakeelement');
            if (elm.style.animationName !== undefined) {
                animation = true;
            }

            if (animation === false) {
                for (var i = 0; i < domPrefixes.length; i++) {
                    if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                        pfx = domPrefixes[i];
                        animationstring = pfx + 'Animation';
                        keyframeprefix = '-' + pfx.toLowerCase() + '-';
                        animationstartevent = startEvents[i];
                        animation = true;
                        break;
                    }
                }
            }
        }

        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }

    function createStyles() {
        if (!stylesCreated) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') +
                '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' +
                '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
                head = document.head || document.getElementsByTagName('head')[0],
                style = document.createElement('style');

            style.type = 'text/css';
            if (style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }

            head.appendChild(style);
            stylesCreated = true;
        }
    }

    window.addResizeListener = function (element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
                createStyles();
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' +
                    '<div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);

                /* Listen for a css animation to detect element display/re-attach */
                animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function (e) {
                    if (e.animationName == animationName)
                        resetTriggers(element);
                });
            }
            element.__resizeListeners__.push(fn);
        }
    };

    window.removeResizeListener = function (element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener('scroll', scrollListener);
                element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
            }
        }
    }
}(jQuery));
// moment.js locale configuration
// locale : chinese (zh-cn)
// author : suupic : https://github.com/suupic
// author : Zeno Zeng : https://github.com/zenozeng

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
    } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
    } else {
        factory((typeof global !== 'undefined' ? global : this).moment); // node or other global
    }
}(function (moment) {
    return moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'Ah点mm',
            LTS : 'Ah点m分s秒',
            L : 'YYYY-MM-DD',
            LL : 'YYYY年MMMD日',
            LLL : 'YYYY年MMMD日LT',
            LLLL : 'YYYY年MMMD日ddddLT',
            l : 'YYYY-MM-DD',
            ll : 'YYYY年MMMD日',
            lll : 'YYYY年MMMD日LT',
            llll : 'YYYY年MMMD日ddddLT'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : function () {
                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
            },
            nextDay : function () {
                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
            },
            lastDay : function () {
                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
            },
            nextWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            lastWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            sameElse : 'LL'
        },
        ordinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            m : '1分钟',
            mm : '%d分钟',
            h : '1小时',
            hh : '%d小时',
            d : '1天',
            dd : '%d天',
            M : '1个月',
            MM : '%d个月',
            y : '1年',
            yy : '%d年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));

(function () {
    'use strict';

    angular.module('c.s')
        .factory('SpecialClinicDiseases', SpecialClinicDiseases);

    /** @ngInject */
    function SpecialClinicDiseases($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/heath_manage/special_clinic_diseases/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

})();



angular.module('c.s')
    .factory('Airfare', ['$resource', function ($resource) {
        return $resource('/api/v1/airfares/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('AskForLeave', ['$resource', function ($resource) {
        return $resource('/api/v1/ask_for_leaves/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            batch: {
                method: 'POST',
                params: {
                    action: 'batch'
                }
            },
            is_duty: {
                method: 'POST',
                params: {
                    action: 'is_duty'
                }
            },
            is_dept_leader: {
                method: 'POST',
                params: {
                    action: 'is_dept_leader'
                }
            },
            calcDayNum: {
                method: 'POST',
                params: {
                    action: 'calcDayNum'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('AttachmentType', ['$resource', function ($resource) {
        return $resource('/api/v1/attachment_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);

angular.module('c.s')
    .factory('AttendanceReport', ['$resource', function ($resource) {
        return $resource('/api/v1/attendance_reports/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('AttendanceMember', ['$resource', function ($resource) {
        return $resource('/api/v1/attendance_members/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('Balance', ['$resource', function ($resource) {
        return $resource('/api/v1/balance/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('BBS', function($http, C, F) {
        return {
            list: function (success, error) {
                $http.get(C.URL.FORUM_API + '/discussions.json').success(success).error(error);
            }
        };
    });


angular.module('c.s')
    .factory('Bid', ['$resource', BidService]);

function BidService($resource) {
    return $resource('/api/v1/bids/:action:id', {}, {
        update: {
            method: 'PUT'
        },
        query: {
            method: 'GET'
        },
        collect: {
            method: 'POST',
            params: {
                action: 'collect'
            }
        }
    });
}
angular.module('c.s')
    .factory('BloodStorage', function ($resource) {
        return $resource('/api/v1/blood_storage/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



angular.module('c.s')
    .factory('BloodStorageRecord', function ($resource) {
        return $resource('/api/v1/blood_storage_records/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



angular.module('c.s')
    .factory('Bulletin', ['$resource', BulletinService]);

function BulletinService($resource) {
    return $resource('/api/v1/bulletin/:action:id', {}, {
        update: {
            method: 'PUT'
        },
        query: {
            method: 'GET'
        },
        collect: {
            method: 'POST',
            params: {
                action: 'collect'
            }
        }
    });
}
angular.module('c.s')
    .factory('Cabin1ClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin1/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('Cabin2ClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin2/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('cabin3ClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin3/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('Cabin4ClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin4/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('CabinClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('CabinDrug', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin/cabin_drugs'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('CabinDrugUnit', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin/cabin_drug_units'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('cabinEightClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin_eight/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('CabinFiveClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin_five/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('cabinNineClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin_nine/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('CabinSevenClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin_seven/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('CabinSixClaimMaterialType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/cabin_six/claim_material_types'
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);

angular.module('c.s')
    .factory('Car', ['$resource', function ($resource) {
        return $resource('/api/v1/cars/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('CApply', ['$resource', function ($resource) {
        return $resource('/api/v1/car_applications/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('CarContact', function ($resource) {
        return $resource('/api/v1/car_contacts/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    });



angular.module('c.s')
    .factory('CarDestination', ['$resource', function ($resource) {
        return $resource('/api/v1/car_destinations/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('CarType', ['$resource', function ($resource) {
        return $resource('/api/v1/car_types/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);



angular.module('c.s')
    .factory('CarWaitLocation', ['$resource', function ($resource) {
        return $resource('/api/v1/car_wait_locations/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('CarWarranty', ['$resource', function ($resource) {
        return $resource('/api/v1/car_warranty/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


// angular.module('c.s')
//     .factory('Category', function ($resource) {
//         return $resource('/api/v1/categories/:id');
//     });

angular.module('c.s')
    .factory('CbCar', ['$resource', function ($resource) {
        return $resource('/api/v1/cb_cars/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('commentType', ['$resource', function ($resource) {
        return $resource('/api/v1/comment_types/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('CommonPhone', ['$resource', function ($resource) {
        return $resource('/api/v1/common_phones/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);
angular.module('c.s')
    .factory('ContactGroup', ['$resource', function ($resource) {
        return $resource('/api/v1/contact_groups/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            attach_members: {
                method: 'POST',
                params: {
                    action: 'attach_members'
                }
            },
            detach_members: {
                method: 'POST',
                params: {
                    action: 'detach_members'
                }
            },
            index_members: {
                method: 'GET',
                params: {
                    action: 'index_members'
                }
            },
            set_member_stop: {
                method: 'POST',
                params: {
                    action: 'set_member_stop'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('Contract', ['$resource', function ($resource) {
        return $resource('/api/v1/contracts/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            getUserRole: {
                method: 'POST',
                params: {
                    action: 'get_user_role'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('ContractType', ['$resource', function ($resource) {
        return $resource('/api/v1/contract_types/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


//angular.module('c.s')
//    .factory('Cookie', function($http, urls) {
//        return {
//            token: function (success, error) {
//                $http.get(C.URL.COOKIE).success(success).error(error);
//            }
//        };
//    });
//

angular.module('c.s')
    .factory('DeliveryPlaceAdmin', ['$resource', function ($resource) {
        return $resource('/api/v1/delivery_place_admins/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('DeliveryPlace', ['$resource', function ($resource) {
        return $resource('/api/v1/delivery_places/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            addAdmins: {
                method: 'POST',
                params: {
                    action: 'add_admins'
                }
            },
            deleteAdmin: {
                method: 'POST',
                params: {
                    action: 'delete_admin'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('Dept', ['$resource', function ($resource) {
        return $resource('/api/v1/depts/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('DeptTakeoutPlace', ['$resource', function ($resource) {
        return $resource('/api/v1/dept_takeout_place/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('DeptWardPhone', ['$resource', function ($resource) {
        return $resource('/api/v1/dept_ward_phones/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('DeptPhone', function ($resource) {
        return $resource('/api/v1/dept_phones/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });



angular.module('c.s')
    .factory('DeptType', ['$resource', function ($resource) {
        return $resource('/api/v1/dept_types/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('DeptWard', ['$resource', function ($resource) {
        return $resource('/api/v1/dept_wards/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c.s').factory('Doc', Doc);

    /** @ngInject */
    function Doc($resource, ArrayHelper, C) {
        var docStepResults = ArrayHelper.get('doc_step_results');
        var service = {
            getDocHandlerName: getDocHandlerName,
            getResultIconColor: getResultIconColor,
            getResultIcon: getResultIcon,
            getDocStepResults: getDocStepResults
        };

        return angular.extend(service, $resource('/api/v1/docs/:action/:id',
            {
                id: '@id',
                action: '@action'
            }, {
                update: {
                    method: 'PUT'
                },
                query: {
                    method: 'GET'
                },
                ai_review: {
                    method: 'POST',
                    params: {
                        action: 'ai_review'
                    }
                }
            }));

        /**
         * @param result：预期结果（针对固定流程）
         * @returns {*[]}
         */
        function getDocStepResults(result, prevResult) {
            var results;
            if (angular.isDefined(result) && result != null) {
                results = [];
                if (prevResult == null || (prevResult && prevResult.id != C.DOC.STEP.RESULT.EVAL)) {
                    if (result.id == C.DOC.STEP.RESULT.EXECUTE) {
                        results.push(result);
                        results.push(ArrayHelper.getItem(C.DOC.STEP.RESULT.FAILED, docStepResults));
                        //} else if (result.id == C.DOC.STEP.RESULT.EVAL) {
                        //    results.push({id: result.id, name: '转评估'});
                    } else {
                        results.push({id: result.id, name: '同意'});
                        results.push(ArrayHelper.getItem(C.DOC.STEP.RESULT.REJECT, docStepResults));
                        if (parseInt(result.id) >= 6|| parseInt(result.id) == C.DOC.STEP.RESULT.EXECUTE) {
                            results.push({id: C.DOC.STEP.RESULT.OTHER, name: '其他意见'});
                        }
                    }
                } else {
                    results.push({id: result.id, name: '转评估'});
                }
            } else if (angular.isDefined(prevResult)) {
                if (prevResult != null && prevResult.id == C.DOC.STEP.RESULT.DOWN) {
                    results = [{id: '7', name: '转审批'}, {id: '8', name: '转执行'},
                        {id: '4', name: '未执行'}, {id: '3', name: '已执行'}];
                } else {
                    results = [{id: '7', name: '转审批'}, {id: '8', name: '转执行'}, {id: '10', name: '其他意见'},
                        {id: '2', name: '不同意'}, {id: '1', name: '同意并完成'}];
                }
            } else {
                results = docStepResults;
            }
            return results;
        }

        function getResultIcon(stepId, isEval, evaluated) {
            var icon = 'question-circle';
            if (isEval) {
                //if (evaluated) {
                icon = 'comment';
                //}
            } else {
                switch (stepId) {
                    case C.DOC.STEP.RESULT.OK_END:
                        icon = 'check-circle-o';
                        break;
                    case C.DOC.STEP.RESULT.REJECT:
                        icon = 'ban';
                        break;
                    case C.DOC.STEP.RESULT.EXECUTE:
                        icon = 'tasks';
                        break;
                    case C.DOC.STEP.RESULT.FAILED:
                        icon = 'times-circle';
                        break;
                    case C.DOC.STEP.RESULT.COMMENT:
                        icon = 'comment-o';
                        break;
                    case C.DOC.STEP.RESULT.UP:
                        icon = 'arrow-up';
                        break;
                    case C.DOC.STEP.RESULT.DOWN:
                        icon = 'arrow-down';
                        break;
                    case C.DOC.STEP.RESULT.EVAL:
                        icon = 'arrow-right';
                        break;
                    case C.DOC.STEP.RESULT.OTHER:
                        icon = 'ellipsis-h';
                        break;
                }
            }
            return icon;
        }

        function getResultIconColor(stepId) {
            var color = '';
            switch (stepId) {
                case C.DOC.STEP.RESULT.OK_END:
                case C.DOC.STEP.RESULT.EXECUTE:
                    color = 'success';
                    break;
                case C.DOC.STEP.RESULT.REJECT:
                    color = 'danger';
                    break;
                case C.DOC.STEP.RESULT.FAILED:
                case C.DOC.STEP.RESULT.EVAL:
                case C.DOC.STEP.RESULT.OTHER:
                    color = 'warning';
                    break;
                case C.DOC.STEP.RESULT.UP:
                    color = 'primary';
                    break;
                case C.DOC.STEP.RESULT.DOWN:
                    color = 'info';
                    break;
            }
            return color;
        }

        /**
         * 获得处理人名称
         * @param step 处理步骤
         * @param dept 申请科室
         * @returns {*}
         */
        function getDocHandlerName(step, deptName) {
            var handler = step.handler ? step.handler.name : '';
            switch (step.handler_type) {
                case C.DOC.HANDLE_BY.USER:
                    return handler;
                case C.DOC.HANDLE_BY.DEPT:
                    return step.dept.name + ' ' + handler;
                case C.DOC.HANDLE_BY.DEPT_LEADER:
                    return '科室负责人' + ' ' + handler;
                case C.DOC.HANDLE_BY.HOSPITAL_LEADER:
                    return '分管院领导' + ' ' + handler;
                case C.DOC.HANDLE_BY.MAIN_LEADER:
                    return '主管院领导' + ' ' + handler;
                case C.DOC.HANDLE_BY.APPLICANT:
                    return '申请人' + ' ' + handler;
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.s').factory('DocCustomType', DocCustomType);

    /** @ngInject */
    function DocCustomType($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/doc_custom_types/:id',
            {}, serviceConfObj));
    }

})();



angular.module('c.s')
    .factory('DocType', ['$resource', function ($resource) {
        return $resource('/api/v1/doc_types/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('DocTypeStep', ['$resource', function ($resource) {
        return $resource('/api/v1/doc_type_steps/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('Driver', ['$resource', function ($resource) {
        return $resource('/api/v1/drivers/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);



angular.module('c.s')
    .factory('DutyGroup', ['$resource', function ($resource) {
        return $resource('/api/v1/duty_groups/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            attach_members: {
                method: 'POST',
                params: {
                    action: 'attach_members'
                }
            },
            // add_members: {
            //     method: 'POST',
            //     params: {
            //         action: 'add_members'
            //     }
            // },
            detach_members: {
                method: 'POST',
                params: {
                    action: 'detach_members'
                }
            },
            index_members: {
                method: 'GET',
                params: {
                    action: 'index_members'
                }
            },
            set_member_stop: {
                method: 'POST',
                params: {
                    action: 'set_member_stop'
                }
            },
            update_rolling_days: {
                method: 'POST',
                params: {
                    action: 'update_rolling_days'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('DutyReport', ['$resource', function ($resource) {
        return $resource('/api/v1/duty_reports/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('ReportMember', ['$resource', function ($resource) {
        return $resource('/api/v1/report_members/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('EManual', ['$resource', function ($resource) {
        return $resource('/api/v1/e_manuals/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('EQuestionReport', ['$resource', function ($resource) {
        return $resource('/api/v1/e_question_reports/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);



angular.module('c.s')
    .factory('Email', function ($resource) {
        return $resource('/api/v1/emails/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            withdraw: {
                method: 'POST',
                params: {
                    action: 'withdraw'
                }
            },
            rm_from_inbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_inbox'
                }
            },
            rm_from_outbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_outbox'
                }
            },
            collect: {
                method: 'POST',
                params: {
                    action: 'collect'
                }
            }
        });
    }
);


angular.module('c.s')
    .factory('EntryType', ['$resource', function ($resource) {
        return $resource('/api/v1/entry_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('ExpenseItem', ['$resource', function ($resource) {
        return $resource('/api/v1/expense_items/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);

angular.module('c.s')
    .factory('FileCabinet', ['$resource', function ($resource) {
        return $resource('/api/v1/file_cabinet/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('FrozenAppointment', ['$resource', FrozenAppointmentService]);

function FrozenAppointmentService($resource) {
    return $resource('/api/v1/frozen_appointments/:action:id', {}, {
        update: {
            method: 'PUT'
        },
        query: {
            method: 'GET'
        }
    });
}
angular.module('c.s')
    .factory('GradeWage', ['$resource', function ($resource) {
        return $resource('/api/v1/grade_wages/:id', {}, {
            update: { method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('HelpPage', ['$resource', function ($resource) {
        return $resource('/api/v1/help_pages/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);

angular.module('c.s')
    .factory('HelpContent', ['$resource', function ($resource) {
        return $resource('/api/v1/help_contents/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('HisExtend', ['$resource', function ($resource) {
        return $resource('/api/v1/common_phones/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);
angular.module('c.s')
    .factory('HospitalOverview', ['$resource', function ($resource) {
        return $resource('/api/v1/hospital_overview/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('House', ['$resource', function ($resource) {
        return $resource('/api/v1/houses/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('HousePay', ['$resource', function ($resource) {
        return $resource('/api/v1/house_pay/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('HouseRent', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/house_rents',
            getSituations: getSituations
        };

        function getSituations() {
            return [
                {id: 1, name: '自住'},
                {id: 2, name: '宿舍'},
            ];
        }

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);


(function () {
    'use strict';

    angular.module('c.s')
        .factory('HouseWae', HouseWae)
        .factory('HouseWaeFeePrice', HouseWaeFeePrice)
    ;

    /** @ngInject */
    function HouseWae($resource, serviceConfObj) {
        var service = {};
        return $resource('/api/v1/house_wae/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }

    function HouseWaeFeePrice($resource, serviceConfObj) {
        var BASE = '/api/v1/house_wae_fee_price';
        var service = {
            URL: {
                BASE: BASE,
            },
        };
        return angular.extend(service, $resource(service.URL.BASE + '/:id', {}, serviceConfObj));
    }
})();
angular.module('c.s')
    .factory('Immunity', ['$resource', Immunity]);

function Immunity($resource, serviceConfObj) {
    var service = {
        getStates: getStates
    };

    return angular.extend(service, $resource('/api/v1/immunity/immunities/:id/:action',
        {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

    function getStates() {
        return [
            {id: 1, name: '已申请'},
            {id: 2, name: '已同意'},
            {id: 3, name: '已拒绝'}
        ]
    }
}
angular.module('c.s')
    .factory('IRSchedule', function ($resource) {
        return $resource('/api/v1/ir_schedules/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        });
    });



angular.module('c.s')
    .factory('Keyword', ['$resource', function ($resource) {
        return $resource('/api/v1/keywords/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('Law', ['$resource', function ($resource) {
        return $resource('/api/v1/laws/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('LeaveReason', ['$resource', function ($resource) {
        return $resource('/api/v1/leave_reasons/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('LeaveType', ['$resource', function ($resource) {
        return $resource('/api/v1/leave_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('Major', ['$resource', function ($resource) {
        return $resource('/api/v1/majors/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('ManualType', function ($resource) {
        return $resource('/api/v1/manual_types/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });



angular.module('c.s')
    .factory('MaterialApplication', function ($resource) {
        return $resource('/api/v1/material_applications/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });


angular.module('c.s')
    .factory('MessageRecipient', function ($resource) {
        return $resource('/api/v1/message_recipients/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    });



angular.module('c.s')
    .factory('MedicalInfo', function ($resource) {
        return $resource('/api/v1/medical_info/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



(function () {
    'use strict';

    angular.module('c.s')
        .factory('MedicalInsuranceType', MedicalInsuranceType);

    /** @ngInject */
    function MedicalInsuranceType($resource) {
        var service = {
            getClasses: getClasses
        };

        return angular.extend(service, $resource('/api/v1/medical_insurance_types/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getClasses() {
            return [
                {id: 1, name: "自费"},
                {id: 2, name: "甲类"},
                {id: 3, name: "乙类"}
            ];
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .factory('Meeting', Meeting)
        .factory('MeetingRecord', MeetingRecord)
    ;

    /** @ngInject */
    function Meeting($resource, dialogs, toaster) {
        var resource = $resource('/api/v1/meetings/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            leave: {
                method: 'POST',
                params: {
                    action: 'leave'
                }
            },
            setReminderTime: {
                method: 'POST',
                params: {
                    action: 'set_reminder_time'
                }
            },
            getQrcode: {
                method: 'POST',
                params: {
                    action: 'get_qrcode'
                }
            },
            getAttendance: {
                method: 'POST',
                params: {
                    action: 'get_attendance'
                }
            }
        });
        var service = {
            loadRelevantFun: loadRelevantFun,
            getWithRecords: getWithRecords,
        };

        function loadRelevantFun(vm) {
            vm.leave = function (meeting) {
                dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                    title: '会议请假',
                    icon: 'sign-out',
                    label: '原因'
                }, {

                    size: 'sm'
                }).result.then(function (pa) {
                    var params = {};
                    params['reason'] = pa;
                    params['start_time'] = meeting.start_time;
                    resource.leave({id: meeting.id}, params).$promise.then(
                        function (resp) {
                            switch (resp.result) {
                                case 0:
                                    toaster.success('请假成功');
                                    if (vm.tableParams) {
                                        vm.tableParams.reload();
                                    }
                                    break;
                                case 1:
                                    toaster.warning('请在开会前半小时请假!');
                                    break;
                            }
                        }, function () {
                            toaster.error('请假失败了!');
                        }
                    )
                });
            };

            vm.remind = function (meeting, op) {
                dialogs.confirm('会前提醒', '确定要会前' + (op == 1 ? '半小时' : '一天08:30') + '短信提醒吗?').result.then(function () {
                    resource.setReminderTime({id: meeting.id}, {opt: op}).$promise.then(
                        function (resp) {
                            switch (resp.result) {
                                case 0:
                                    toaster.success('设置成功!');
                                    if (vm.tableParams) {
                                        vm.tableParams.reload();
                                    }
                                    break;
                                case 1:
                                    toaster.warning('请在开会前一小时设置!');
                                    break;
                                case 2:
                                    toaster.warning('该会议已统一设置会前半小时提醒!');
                                    break;
                                case 3:
                                    toaster.warning('请在开会前一天08:30之前设置!');
                                    break;
                            }
                        }, function () {
                            toaster.error('设置失败了!');
                        }
                    )
                });
            };

            vm.cancel = function (meeting) {
                dialogs.confirm('取消会前提醒', '确定要取消会前微信提醒吗?').result.then(function () {
                    resource.setReminderTime({id: meeting.id}, {opt: 3}).$promise.then(
                        function (resp) {
                            switch (resp.result) {
                                case 0:
                                    toaster.success('取消成功!');
                                    if (vm.tableParams) {
                                        vm.tableParams.reload();
                                    }
                                    break;
                                case 1:
                                    toaster.warning('请在开会前一小时取消!');
                                    break;
                            }
                        }, function () {
                            toaster.error('取消失败了!');
                        }
                    )
                });
            };
        }

        return angular.extend(service, resource);
    }


    function getWithRecords() {
        return [
            {id: 0, name: '未记录'},
            {id: 1, name: '记录中'},
            {id: 2, name: '已记录'},
        ];
    }

    /** @ngInject */
    function MeetingRecord($resource, serviceConfObj) {
        var service = {
            getStates: getStates,
        };
        return angular.extend(service, $resource('/api/v1/meeting_records/:action/:id', {
            id: '@id',
            action: '@action'
        }, serviceConfObj));
    }

    function getStates() {
        return [
            {id: 1, name: '未落实'},
            {id: 2, name: '落实中'},
            {id: 3, name: '待验收'},
            {id: 4, name: '已验收'}

        ];
    }


})();



angular.module('c.s')
    .factory('MeetingAsk4Leave', ['$resource', function ($resource) {
        return $resource('/api/v1/meeting_ask_for_leaves/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update:
            {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            setAll: {
                method: 'POST',
                params: {
                    action: 'set_all'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('MeetingAttendance', ['$resource', function ($resource) {
        return $resource('/api/v1/meeting_attendances/:id', {}, {
            update: { method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('MeetingDevice', ['$resource', function ($resource) {
        return $resource('/api/v1/meeting_devices/:id', {}, {
            update: { method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('MeetingRoom', ['$resource', function ($resource) {
        return $resource('/api/v1/meeting_rooms/:id/:action', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            ibeacons: {
                method: 'GET',
                params: {
                    action: 'ibeacons'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('MeetingTopic', ['$resource', function ($resource) {
        return $resource('/api/v1/meeting_topics/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('MeetingType', ['$resource', function ($resource) {
        return $resource('/api/v1/meeting_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('Mission', ['$resource', '$rootScope', "dialogs", "toaster", "MissionReport", "Dlg",
        "Auth",
        function ($resource, $rootScope, dialogs, toaster, MissionReport, Dlg, Auth) {
            var service = {
                API_URL: '/api/v1/missions',
                STATE_WAITING: 1,
                STATE_PROGRESS: 2,
                STATE_COMPLETE: 3,
                STATE_SUSPENSION: 4,
                callStateChangeDlg: callStateChangeDlg,
                loadAssistFunction: loadAssistFunction,
                callSubmitDlg: callSubmitDlg,
                remove: remove,
                getRemindState: getRemindState,
                getWorkTypes: getWorkTypes,
                handleUpdate: handleUpdate
            };

            var api = $resource(service.API_URL + '/:action/:id', {}, {
                update: {
                    method: 'PUT'
                },
                query: {
                    method: 'GET'
                },
                excelImport: {
                    method: 'POST',
                    params: {
                        action: 'excel_import'
                    }
                }
            });

            function getRemindState() {
                return [
                    {id: 0, name: '无提醒', color: ''},
                    {id: 1, name: '新任务', color: 'success'},
                    {id: 2, name: '新提交', color: 'success'},
                    {id: 3, name: '状态更改', color: 'warning'},
                    {id: 4, name: '参与人更改', color: 'danger'},
                ];
            }

            function getWorkTypes() {
                return [
                    {id: 1, name: '例行工作', color: 'success'},
                    {id: 2, name: '临时任务', color: 'warning'},
                ];
            }

            function loadAssistFunction(vm) {
                vm.canSubmit = canSubmit;
                vm.canEdit = canEdit;
                vm.canEnd = canEnd;
            }

            function isProgress(m) {
                return (m.state.id == service.STATE_WAITING || m.state.id == service.STATE_PROGRESS);
            }

            function canSubmit(m) {
                if (angular.isUndefined(m)) return false;
                return isProgress(m) && (m.is_publish || m.is_coworker);
            }

            function canEdit(m) {
                if (angular.isUndefined(m)) return false;
                return m.is_publish || m.is_applicant;
            }

            function canEnd(m) {
                return canEdit(m) && isProgress(m);
            }

            function remove(m) {
                Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的任务吗？', function (resp) {
                    api.delete({id: m.id}).$promise.then(function (resp) {
                        Dlg.s('删除成功');
                        $rootScope.$broadcast('missionStateChange');
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }, '删除任务');
            }

            function getSubmitIds(m) {
                var submits = [];
                angular.forEach(m.coworkers, function (coworker) {
                    submits.push(coworker.id);
                });
                submits.push(m.publish_id);
                return submits;
            }

            function callSubmitDlg(vm, m) {
                if (m.state != service.STATE_PROGRESS && m.state.id != service.STATE_PROGRESS) {
                    Dlg.w('任务未在进行中，无法进行提交');
                    return;
                } else if (!getSubmitIds(m).includes(Auth.getAccount().id)) {
                    Dlg.w('只能由负责人和参与人进行提交进度');
                    return;
                }
                dialogs.create('templates/mission/submit_dlg.html', 'MissionSubmitDlgCtrl', {}, {size: 'md'})
                    .result.then(function (resp
                ) {
                    var params = resp;
                    params['mission_id'] = m.id;
                    params['state_id'] = m.state.id;
                    params['opt'] = 4;
                    MissionReport.save(params).$promise.then(
                        function (resp) {
                            switch (resp.result) {
                                case 0:
                                    Dlg.s('任务进度提交成功');
                                    vm.init(m.id);
                                    break;
                                case 1:
                                    Dlg.w('任务状态错误!');
                            }
                        }, function () {
                            Dlg.e('任务进度提交失败!');
                        }
                    );
                });
            }

            function callStateChangeDlg(vm, m, cb) {
                api.query({
                    dept_id: m.dept.id,
                    opt: 3
                }, function (resp) {
                    dialogs.create('templates/mission/state_dlg.html', 'MissionStateDlgCtrl', {
                        stateId: m.state.id,
                        missionId: m.id,
                        forApplicant: true,
                        type: m.type,
                        urgent: m.urgent,
                        types: resp.types
                    }, {size: 'md'}).result.then(function (resp) {
                        handleUpdate(vm, resp, m);
                        cb();
                    });
                });
            }

            function handleUpdate(vm, resp, m) {
                switch (resp.opt) {
                    case 1 :
                        remove(m);
                        break;
                    case 4 :
                        var params = {opt: 4, urgent: resp.mission.urgent ? 1 : 0};
                        if (resp.mission.state) {
                            params.state_id = resp.mission.state.id;
                        }
                        if (resp.mission.type) {
                            params.type_id = resp.mission.type.id;
                        }
                        api.update({id: m.id}, params).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0 :
                                    toaster.success('任务状态修改成功');
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                                case 1 :
                                    toaster.error('任务已到期,请为任务延期');
                                    break;
                            }
                        }, function () {
                            toaster.error('任务状态修改出错');
                        });
                        break;
                    case 5:
                        api.update({id: m.id}, {
                            opt: 5,
                            delay: resp.mission.delay
                        }).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0 :
                                    toaster.success('任务延期成功');
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        }, function () {
                            toaster.error('任务延期失败');
                        });
                        break;
                    case 12 :
                        api.update({id: m.id}, {
                            opt: 12,
                            publish_id: resp.publish_id,
                            coworkers: resp.coworkers
                        }).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0 :
                                    toaster.success('任务参与人修改成功');
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        }, function () {
                            toaster.error('任务参与人修改出错!');
                        });
                        break;
                }
            }

            return angular.extend(service, api);
        }

    ]);
angular.module('c.s')
    .factory('MissionNew', ['$resource', function ($resource) {
        return $resource('/api/v1/mission_new/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('MissionReport', ['$resource', function ($resource) {
        return $resource('/api/v1/mission_reports/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('MissionType', ['$resource', function ($resource) {
        var service = {
            API_URL: '/api/v1/mission_types',
        };

        var api = $resource(service.API_URL + '/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });

        return angular.extend(service, api);
    }
    ]);
angular.module('c.s')
    .factory('Nodes', ['$resource', nodeService]);

function nodeService($resource) {
    return $resource('/api/v1/nodes/:id');
}
angular.module('c.s')
    .factory('NonRecharge', ['$resource', function ($resource) {
        return $resource('/api/v1/non_recharge/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('NurseSeniority', ['$resource', seniorityService]);

function seniorityService($resource) {
    return $resource('/api/v1/nurse_seniorities/:id', {}, {
        update: {
            method: 'PUT'
        },
        query: {
            method: 'GET'
        }
    });
}
angular.module('c.s')
    .factory('SeniorityStandard', ['$resource', SeniorityStandardService]);

function SeniorityStandardService($resource) {
    return $resource('/api/v1/nurse_seniority_standards/:id', {}, {
        update: {
            method: 'PUT'
        }
    });
}
angular.module('c.s')
    .factory('NursingDutyAttachment', function ($resource) {

        var API_URL = "/api/v1/nursing_duty_attachment";

        var service = {
            API_URL: API_URL,

            NURSING_DUTY_UPLOAD: API_URL + '/upload',
            NURSING_DUTY_DOWNLOAD: API_URL + '/download'
        };

        return angular.extend(service, $resource(service.API_URL + '/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        }));
    });



(function () {
    'use strict';

    angular.module('c.s')
        .factory('OfficeDeptPhone', OfficeDeptPhone)
    ;

    /** @ngInject */
    function OfficeDeptPhone($resource, serviceConfObj) {
        var service = {
        };
        return angular.extend(service, $resource('/api/v1/dept_phone/:id', {
            id: '@id',
            action: '@action'
        }, serviceConfObj,{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
angular.module('c.s')
    .factory('OfficialExpert', ['$resource', function ($resource) {
        return $resource('/api/v1/official_experts/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('OMedicalInfo', ['$resource', function ($resource) {
        return $resource('/api/v1/o_medical_info/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('OpDateSs', function ($resource) {
        return $resource('/api/v1/op_date_ss/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });


(function () {
    'use strict';

    angular.module('c.s')
        .factory('OperationImport', OperationImport);

    /** @ngInject */
    function OperationImport($resource, serviceConfObj) {
        var BASE = '/api/v1/operation_import/operations';
        var service = {
            URL: {
                BASE: BASE
            },
            getKinds: getKinds,
            EXPORT_URL: BASE + '/export',
            EXPORT_DEPT_URL: BASE + '/export_dept',
            EXCEL_DOWNLOAD: BASE + '/download'
        };

        return angular.extend(service, $resource(service.URL.BASE + '/:action/:id', {}, serviceConfObj));

        function getKinds() {
            return [
                {id: 1, name: '⼿术质控'},
                {id: 2, name: '药品质控'},
                {id: 3, name: '诊疗质控'}
            ];
        }
    }

})();

angular.module('c.s')
    .factory('OperationPermit', function ($resource) {
        return $resource('/api/v1/operation_permits/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });


angular.module('c.s')
    .factory('ORRecipient', function ($resource) {
        return $resource('/api/v1/or_recipients/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });



angular.module('c.s')
    .factory('ORSchedule', function ($resource) {
        return $resource('/api/v1/or_schedules/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        });
    });



(function () {
    'use strict';

    angular.module('c.s')
        .factory('Order', Order)
        .factory('MealAdvanceItem', MealAdvanceItem)
        .factory('MealAdvanceRecord', MealAdvanceRecord)
    ;

    /** @ngInject */
    function Order($resource) {
        var service = {
            TYPE: {
                AM: 1,
                PM: 2,
                NIGHT: 3
            },
            getTypes: getTypes,
            getStates: getStates
        };

        function getTypes(noAllDay) {
            var types = [
                {id: 1, name: '早'},
                {id: 2, name: '中'},
                {id: 3, name: '晚'},
            ];
            if (!noAllDay) types.push({id: 4, name: '全'});
            return types;
        }
        //扣款状态：1待扣款，2扣款成功，3扣款失败
        function getStates() {
            var states = [
                {id: 1, name: '待扣款'},
                {id: 2, name: '扣款成功'},
                {id: 3, name: '扣款失败'}
            ];
            return states;
        }

        return angular.extend(service, $resource('/api/v1/orders/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    /** @ngInject */
    function MealAdvanceItem($resource, serviceConfObj) {
        var API_URL = "/api/v1/meal/meal_advance_items";

        var service = {
            API_URL: API_URL
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function MealAdvanceRecord($resource, serviceConfObj) {
        var API_URL = "/api/v1/meal/meal_advance_records";

        var service = {
            API_URL: API_URL
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));
    }
})();
angular.module('c.s')
    .factory('OutPSchedule', function ($resource) {
        return $resource('/api/v1/out_p_schedules/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        });
    });



angular.module('c.s')
    .factory('PaidDetail', ['$resource', paidDetailService]);

function paidDetailService($resource) {
    return $resource('/api/v1/paid_details/:id', {}, {
        update: {
            method: 'PUT'
        },
        query: {
            method: 'GET'
        }
    });
}
angular.module('c.s')
    .factory('ParkRelation', ['$resource', function ($resource) {
        return $resource('/api/v1/park_relations/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('ParkingLot', ['$resource', function ($resource) {
        return $resource('/api/v1/parking_lots/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('ParkingPay', ['$resource', function ($resource) {
        return $resource('/api/v1/parking_pay/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c.s')
        .factory('PatientSearch', PatientSearch)
        .factory('MESPatientHelper', MESPatientHelper)
    ;

    /** @ngInject */
    function PatientSearch($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/home/clinc_patients/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            search: {
                method: 'POST',
                params: {
                    action: 'search'
                }
            }
        }));
    }

    /** @ngInject */
    function MESPatientHelper(Patient, ArrayHelper, $http, ExtHelper, Dlg) {
        var service = {
            readyPatientRelevant: readyPatientRelevant,
            getPatientInfo: getPatientInfo,
            getSexes: getSexes,
            getYesOrNo: getYesOrNo
        };

        function getSexes() {
            return [
                {id: "1", name: "男"},
                {id: "0", name: "女"}
            ];
        }

        function getYesOrNo() {
            return [
                {id: "1", name: "是"},
                {id: "0", name: "否"}
            ];
        }

        return service;

        function getPatientInfo(m) {
            var pa = {
                id_card: m.id_card,
                name: m.name,
                phone: m.phone
            };
            if (m.file_no) pa.file_no = m.file_no;
            if (m.mailing_address) pa.mailing_address = m.mailing_address;
            if (m.address) pa.address = m.address;
            if (m.position) pa.position = m.position.id;
            if (m.nation) pa.nation_id = m.nation.id;
            if (m.soldier){
              pa.soldier = m.soldier;
            } else {
              pa.soldier = false
            }
            return pa;
        }

        function readyPatientRelevant(vm, successFn, failFn, finallyFn) {
            //相关的参数
            vm.positions = Patient.getPositions();
            $http.get('/api/home/nations/', {params: {opt: 2/*INDEX_OPTIONS*/}}).then(function (resp) {
                vm.nations = resp.data.items;
            });

            //相关方法
            vm.readCard = function (m) {
                __readCard(m, function (hasName) {
                    vm.idCardChanged(m, hasName);
                }, vm);
            };

            vm.idCardChanged = function (m, readFromIdcard, register_type) {
                __idCardChanged(vm, m, readFromIdcard, register_type, function (patient) {
                    //成功找到患者
                    vm.patientLoaded = true;
                    successFn(patient, m);
                }, function () {
                    //没有找到患者
                    vm.patientLoaded = true;
                    __clearPatientInfo(m);
                    failFn();
                }, function () {
                    //服务器错误
                    vm.patientLoaded = false;
                }, function () {
                    //身份证不合法
                    vm.patientLoaded = false;
                    delete m.id;
                    delete m.gender;
                    failFn();
                });

                finallyFn();
            };

            vm.clearPatientInfo = function (m) {
                __clearPatientInfo(m);
                vm.Form.$setUntouched();
                vm.Form.$setPristine();
            }
        }

        function __readCard(m, successFn, vm) {
            return ExtHelper.readCard(vm).then(function (cardInfo) {
                m.id_card = cardInfo.idcard;
                m.name = cardInfo.name;
                if (!cardInfo.address && cardInfo.address) m.address = cardInfo.address;
                var hasName = !cardInfo.name && cardInfo.name;
                successFn(hasName);
            }, function (msg) {
                if (msg) Dlg.error(msg);
            });
        }

        /**
         * @param m
         * @param readFromIdcard
         * @param register_type 判断卡类型
         * @param successFn 查找到具体患者
         * @param notFind 没有找到具体患者
         * @param FailFn 服务器错误
         * @param ErrorFn 身份证不合法
         */
        function __idCardChanged(vm, m, readFromIdcard, register_type, successFn, notFind, FailFn, ErrorFn) {
            var idCard = m.id_card;
            vm.errorInfo = false;
            if (idCard && (((idCard.length === 18 || idCard.length === 19 || idCard.length === 15) && !register_type) ||
                ((idCard.length === 9 || idCard.length === 8 || idCard.length === 11) && register_type))) {   //保密单位没有身份证，只有19位卡号,国外移民身份证只有15位,护照8或者9位
                m.gender = (parseInt(idCard.substr(16, 1))) % 2 == 1 ? 1 : 0;
                Patient.get({id: idCard, op: 'byIdcard'}).$promise.then(function (resp) {
                    var patient = resp;
                    if (!readFromIdcard) m.name = patient.name;
                    m.id = patient.id;
                    m.patientId = patient.id;
                    m.phone = patient.phone;
                    m.nation = patient.nation;
                    m.is_male = patient.is_male ? 1 : 0;
                    m.vuid = patient.vuid;
                    if (m.gender !== m.is_male) m.gender = m.is_male;
                    if (patient.position) m.position = ArrayHelper.getItem(patient.position, vm.positions);
                    if (patient.address) m.address = patient.address;
                    if (patient.birthplace) m.birthplace = patient.birthplace;
                    if (patient.mailing_address) m.mailing_address = patient.mailing_address;
                    if (patient.file_no) m.file_no = parseInt(patient.file_no);
                    successFn(patient);
                }, function (error) {
                    if (error.status == 404) {
                        notFind();
                        // Dlg.w('未在系统中找到相关用户，请先前往诊台预约或者微信手机端创建患者档案');
                    } else {
                        FailFn();
                        var resp = error.data;
                        Dlg.error(resp.msg);
                    }
                });
            } else {
                ErrorFn();
            }
        }

        function __clearPatientInfo(m) {
            delete m.patientId;
            delete m.name;
            delete m.phone;
            delete m.nation;
            delete m.position;
            delete m.address;
            delete m.mailing_address;
            delete m.test_no;
            delete m.file_no;
        }
    }

})();



angular.module('c.s')
    .factory('Permission', ['$resource', permService]);

function permService($resource) {
    return $resource('/api/v1/permissions/:id');
}
angular.module('c.s')
    .factory('Practice', ['$resource', function ($resource) {
        return $resource('/api/v1/practices/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            excelImport: {
                method: 'POST',
                params: {
                    action: 'excel_import'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('PracticeFeedback', ['$resource', function ($resource) {
        return $resource('/api/v1/practice_feedback/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('PurchaseHistory', ['$resource', function ($resource) {
        return $resource('/api/v1/purchase_history/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('PurchaseHistoryPathRecord', ['$resource', function ($resource) {
        return $resource('/api/v1/purchase_history_path_records/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


// angular.module('c.s')
//     .factory('Q', function ($resource) {
//         return $resource('/api/v1/questionnaires/:id', {}, {
//             update: {
//                 method: 'PUT'
//             },
//             query: {
//                 method: 'GET'
//             }
//         });
//     }
// );


// angular.module('c.s')
//     .factory('QAnswerSheet', function ($resource) {
//         return $resource('/api/v1/q_answer_sheets/:id', {}, {
//             update: {
//                 method: 'PUT'
//             },
//             query: {
//                 method: 'GET'
//             }
//         });
//     }
// );
//

angular.module('c.s')
    .factory('QOpinion', function ($resource) {
        return $resource('/api/v1/q/q_opinions/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            batch_accept: {
                method: 'POST',
                params: {
                    action: 'batch_accept'
                }
            },
            batch_reject: {
                method: 'POST',
                params: {
                    action: 'batch_reject'
                }
            },
            batch_handle: {
                method: 'POST',
                params: {
                    action: 'batch_handle'
                }
            },
            batch_delete: {
                method: 'POST',
                params: {
                    action: 'batch_delete'
                }
            },
            remind: {
                method: 'POST',
                params: {
                    action: 'remind'
                }
            },
            export: {
                method: 'POST',
                params: {
                    action: 'export'
                }
            },
            remindWx: {
                method: 'POST',
                params: {
                    action: 'remind_wx'
                }
            },
        });
    }
);


// angular.module('c.s')
//     .factory('QSurvey', function ($resource) {
//         return $resource('/api/v1/questionnaire_surveys/:id', {}, {
//             update: {
//                 method: 'PUT'
//             },
//             query: {
//                 method: 'GET'
//             }
//         });
//     }
// );
//

angular.module('c.s')
    .factory('QualificationChangeRemind', ['$resource', function ($resource) {
        return $resource('/api/v1/qualification_change_reminds/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('QuickMenu', ['$resource', quickMenuService]);

function quickMenuService($resource) {
    return $resource('/api/v1/quick_menus/:id');
}
angular.module('c.s')
    .factory('Recharge', ['$resource', function ($resource) {
        return $resource('/api/v1/recharges/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('RechargeItem', ['$resource', function ($resource) {
        return $resource('/api/v1/recharge_items/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            addDepts: {
                method: 'POST',
                params: {
                    action: 'add_depts'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('RechargeItemDept', ['$resource', function ($resource) {
        return $resource('/api/v1/recharge_item_depts/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('RedHeadApprover', ['$resource', function ($resource) {
        return $resource('/api/v1/red_head_approvers/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('RegularMission', ['$resource', '$rootScope', "dialogs", "toaster", "MissionReport", "Dlg", "Auth", "DateHelper",
        function ($resource, $rootScope, dialogs, toaster, MissionReport, Dlg, Auth, DateHelper) {
            var service = {
                API_URL: '/api/v1/regular_missions/:action/:id',
                getRegularTypes: getRegularTypes,
                changeRegularType: changeRegularType,
            };

            var api = $resource(service.API_URL, {}, {
                update: {
                    method: 'PUT'
                },
                query: {
                    method: 'GET'
                }
            });

            function getRegularTypes() {
                return [
                    {id: 1, name: '每年'},
                    {id: 2, name: '每季'},
                    {id: 3, name: '每月'},
                    {id: 5, name: '每周'},
                    {id: 4, name: '每日'},
                ];
            }

            function changeRegularType(m, loadTimeCount) {
                var start = new Date(m.start);
                var end = new Date(m.end);

                if (start > end) {
                    m.regular_times = ['开始时间不能大于结束时间'];
                    return;
                }

                var regular_times = [];
                while (regular_times.length < loadTimeCount + 1) {
                    regular_times.push(DateHelper.date2Str(start) + '~' + DateHelper.date2Str(end));
                    switch (m.regular_type) {
                        case 1://年
                            start = changeMonth(start, 12);
                            end = changeMonth(end, 12);
                            break;
                        case 2://季
                            start = changeMonth(start, 3);
                            end = changeMonth(end, 3);
                            break;
                        case 3://月
                            start = changeMonth(start, 1);
                            end = changeMonth(end, 1);
                            break;
                        case 4://日
                            start = getNextDay(start, 1);
                            end = getNextDay(end, 1);
                            break;
                        case 5://周
                            start = getNextDay(start, 7);
                            end = getNextDay(end, 7);
                            break;
                    }
                }
                m.regular_times = regular_times;
            }

            function changeMonth(date, day) {
                return new Date(date.setMonth(date.getMonth() + day));
            }

            function getNextDay(date, day) {
                return new Date(date.valueOf() + day * 24 * 60 * 60 * 1000);
            }

            return angular.extend(service, api);
        }
    ]);
(function () {
    'use strict';

    angular.module('c.s')
        .factory('Role', Role)
    ;

    /** @ngInject */
    function Role($resource, serviceConfObj) {
        var service = {
            EXPORT: '/api/v1/roles/export'
        };

        return angular.extend(service, $resource('/api/v1/roles/:id',
            {}, serviceConfObj));
    }

})();
angular.module('c.s')
    .factory('Round', ['$resource', function ($resource) {
        return $resource('/api/v1/rounds/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            excelImport: {
                method: 'POST',
                params: {
                    action: 'excel_import'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('Rule', ['$resource', function ($resource) {
        return $resource('/api/v1/rules/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('RuleType', ['$resource', function ($resource) {
        return $resource('/api/v1/rule_types/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('RushPark', ['$resource', function ($resource) {
        return $resource('/api/v1/rush_parks/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('Schedule', ['$resource', function ($resource) {
        return $resource('/api/v1/schedules/:action/:id',{}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            add_shift: {
                method: 'POST',
                params: {
                    action: 'add_shift'
                }
            },
            del_shift: {
                method: 'POST',
                params: {
                    action: 'del_shift'
                }
            },
            edit_shift: {
                method: 'POST',
                params: {
                    action: 'edit_shift'
                }
            },
            attach_shifts: {
                method: 'POST',
                params: {
                    action: 'attach_shifts'
                }
            },
            detach_shifts: {
                method: 'POST',
                params: {
                    action: 'detach_shifts'
                }
            },
            public_schedules: {
                method: 'POST',
                params: {
                    action: 'public_schedules'
                }
            },
            clean_schedules: {
                method: 'POST',
                params: {
                    action: 'clean_schedules'
                }
            },
            cancel_schedules: {
                method: 'POST',
                params: {
                    action: 'cancel_schedules'
                }
            },
            do_schedules: {
                method: 'POST',
                params: {
                    action: 'do_schedules'
                }
            },
            is_leave: {
                method: 'POST',
                params: {
                    action: 'is_leave'
                }
            },
            is_leaves: {
                method: 'POST',
                params: {
                    action: 'is_leaves'
                }
            }
        });
    }]);

angular.module('c.s')
    .factory('SeniorityApproval', ['$resource', function ($resource) {
        return $resource('/api/v1/seniority_approval/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);





(function () {
    'use strict';

    angular.module('c.s')
        .factory('Setting', SettingService);

    /** @ngInject */
    function SettingService($resource) {
        var service = {
            KEY: {
                MAIL_BOX_SIZE: "mail_box_size",
                FILE_BOX_SIZE: "file_box_size",
                WATERMARK_ALPHA: "watermark_alpha",
                DUTY_COUNT_DISABLE: "duty_count_disable",
                //开始挂号时间
                REG_BEGIN_AM: "reg_begin_am",
                REG_BEGIN_PM: "reg_begin_pm",
                REG_BEGIN_NT: "reg_begin_nt",
                //就诊结束时间
                REG_DEADLINE_AM: "reg_deadline_am",
                REG_DEADLINE_PM: "reg_deadline_pm",
                REG_DEADLINE_NT: "reg_deadline_nt",

                DISTRIBUTOR: "distributor",
                CLINC_NOTE: "clinc_note",

                //院领导设置
                DEAN: "dean",
                SECRETARY: "secretary",
                CHIEF_ACCOUNTANT: "chief_accountant",

                //生日祝福设置
                BIRTHDAY: "birthday",
                ADVANCE_EXAM_DAYS: "advance_exam_days",

                //vvip分拣护士设置
                VVIP_NURSE: "vvip_nurse",

                //vip分拣护士设置
                VIP_NURSE: "vip_nurse",

                //his预停替诊通知人
                STOP_PRE_REMINDER_ID: "stop_pre_hospital_reminder_id",

                //his停替诊通知人
                STOP_REMINDER_ID: "stop_reminder_id",

                //his口腔科停替诊通知人
                STOP_MOUTH_REMINDER_ID: "stop_mouth_reminder_id",

                //his分管院停替诊通知人
                STOP_HOSPITAL_REMINDER_ID: "stop_hospital_reminder_id",

                //诊前病情审核微信通知人
                PRE_DIAGNOSIS_WX: "pre_diagnosis_wx",

                //诊前病情审核短信通知人
                PRE_DIAGNOSIS_SMS: "pre_diagnosis_sms",


                //方舱验证码设置
                CABIN_CAPTCHA: "cabin_captcha",

                //方舱符合出舱核酸结果间隔时间设置
                CABIN_DIFFTIME: "cabin_diffTime",

                //拉萨一方舱验证码设置
                WORK_LOAD_ADD_USER_IDS: "work_load_add_user_ids",


                //拉萨一方舱验证码设置
                CABIN1_CAPTCHA: "cabin1_captcha",

                //拉萨一方舱符合出舱核酸结果间隔时间设置
                CABIN1_DIFFTIME: "cabin1_diffTime",

                //拉萨二方舱验证码设置
                CABIN2_CAPTCHA: "cabin2_captcha",

                //拉萨二方舱符合出舱核酸结果间隔时间设置
                CABIN2_DIFFTIME: "cabin2_diffTime",

                //定点医院方舱验证码设置
                CABIN3_CAPTCHA: "cabin3_captcha",

                //定点医院方舱符合出舱核酸结果间隔时间设置
                CABIN3_DIFFTIME: "cabin3_diffTime",

                //方舱3馆验证码设置
                CABIN4_CAPTCHA: "cabin4_captcha",

                //方舱3馆符合出舱核酸结果间隔时间设置
                CABIN4_DIFFTIME: "cabin4_diffTime",

                //五方舱验证码设置
                CABIN_FIVE_CAPTCHA: "cabin_five_captcha",

                //五方舱符合出舱核酸结果间隔时间设置
                CABIN_FIVE_DIFFTIME: "cabin_five_diffTime",


                //六方舱验证码设置
                CABIN_SIX_CAPTCHA: "cabin_six_captcha",

                //六方舱符合出舱核酸结果间隔时间设置
                CABIN_SIX_DIFFTIME: "cabin_six_diffTime",

                //七方舱验证码设置
                CABIN_SEVEN_CAPTCHA: "cabin_seven_captcha",

                //七方舱符合出舱核酸结果间隔时间设置
                CABIN_SEVEN_DIFFTIME: "cabin_seven_diffTime",

                //八方舱验证码设置
                CABIN_EIGHT_CAPTCHA: "cabin_eight_captcha",

                //八方舱符合出舱核酸结果间隔时间设置
                CABIN_EIGHT_DIFFTIME: "cabin_eight_diffTime",

                //九方舱验证码设置
                CABIN_NINE_CAPTCHA: "cabin_nine_captcha",

                //九方舱符合出舱核酸结果间隔时间设置
                CABIN_NINE_DIFFTIME: "cabin_nine_diffTime"
            }
        };

        return angular.extend(service, $resource('/api/v1/settings/:key', {}, {
            update: {
                method: 'PUT'
            }
        }));
    }

})();

angular.module('c.s')
    .factory('Shift', function ($resource) {
        return $resource('/api/v1/shifts/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });


angular.module('c.s')
    .factory('Sms', function($http, C) {
        return {
            send: function (data, success, error) {
                $http.post(C.URL.SMS_SEND, data).success(success).error(error);
            },
            receiveEmails: function (data, success, error) {
                $http.post(C.URL.SMS_RECEIVEEMAILS, data).success(success).error(error);
            },
            remove: function (data, success, error) {
                $http.post(C.URL.SMS_RM, data).success(success).error(error);
            },
            history: function (data, success, error) {
                $http.get(C.URL.SMS_HISTORY, {params: data}).success(success).error(error);
            }
        };
    });


angular.module('c.s')
    .factory('steamedBread', ['$resource', function ($resource) {
        return $resource('/api/v1/steamed_bread_records/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('Store', ['$resource', function ($resource) {
        return $resource('/api/v1/stores/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            addUsers: {
                method: 'POST',
                params: {
                    action: 'add_users'
                }
            },
            deleteUser: {
                method: 'POST',
                params: {
                    action: 'delete_user'
                }
            },
            getCustomersInfo: {
                method: 'POST',
                params: {
                    action: 'customers_info'
                }
            },
            paid: {
                method: 'POST',
                params: {
                    action: 'paid'
                }
            },
            directPaid: {
                method: 'POST',
                params: {
                    action: 'direct_paid'
                }
            },
            refund: {
                method: 'POST',
                params: {
                    action: 'refund'
                }
            },
            setState: {
                method: 'POST',
                params: {
                    action: 'set_state'
                }
            },
            getStirFry: {
                method: 'POST',
                params: {
                    action: 'get_stir_fry'
                }
            },
            setStirFry: {
                method: 'POST',
                params: {
                    action: 'set_stir_fry'
                }
            }
        });
    }]);


angular.module('c.c')
    .factory('StoreTips', ['$resource', function ($resource) {
        return $resource('/api/v1/store_tips/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);
angular.module('c.s')
    .factory('TakeOut', ['$resource', function ($resource) {
        return $resource('/api/v1/take_out/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            storeBatch: {
                method: 'POST',
                params: {
                    action: 'store_batch'
                }
            },
            printAll: {
                method: 'POST',
                params: {
                    action: 'print_all'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('TakeoutSchedule', ['$resource', function ($resource) {
        return $resource('/api/v1/takeout_schedules/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('TakeoutPlace', ['$resource', function ($resource) {
        return $resource('/api/v1/takeout_places/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            addDepts: {
                method: 'POST',
                params: {
                    action: 'add_depts'
                }
            },
            deleteDept: {
                method: 'POST',
                params: {
                    action: 'delete_dept'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('TempRechargeItem', ['$resource', function ($resource) {
        return $resource('/api/v1/temp_recharge_items/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('TibetNemt', ['$resource', function ($resource) {
        var service = {
            getTypes: getTypes
        };

        return angular.extend(service, $resource('/api/v1/tibet_nemt/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getTypes() {
            return [
                {id: 1, name: '高考'},
                {id: 2, name: '中考'},
                {id: 3, name: '小升初'}
            ];
        }
    }]);
angular.module('c.s')
    .factory('TopicDiscussionList', ['$resource', function ($resource) {
        return $resource('/api/v1/topic_discussion_lists/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('TotalDutyRecord', function ($resource) {
        var API = '/api/v1/total_duty_records';
        var service = {
            URL: {
                API: API
            },
            getHnadleStates: getHnadleStates,
            getInfoTypeStates: getInfoTypeStates
        };

        return angular.extend(service, $resource(API + '/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getHnadleStates() {
            return [
                {id: 1, name: '是'},
                {id: 0, name: '否'}
            ]
        }

        function getInfoTypeStates() {
            return [
                {id: 1, name: '总值班'},
                {id: 2, name: '护理总值班'}
            ]
        }
    });

angular.module('c.s')
    .factory('UCashBalance', ['$resource', function ($resource) {
        return $resource('/api/v1/ucash_balance/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function () {
    'use strict';


    angular.module('c.s')
        .factory('User', User)
        .factory('Patient', Patient)
        .factory('JobTitle', JobTitle)
        .factory('DHHisBKDept', DHHisBKDept)
        .factory('DHHisUserExtend', DHHisUserExtend)
    ;

    /** @ngInject */
    function User($resource, ArrayHelper) {
        var service = {
            urls: {
                EXPORT_USER_INFO: '/api/v1/users/exportUsers',
                ExcelDownload: '/api/v1/users/download',
                EXPORT_PAYROLL_CARD: '/api/v1/users/exportPayrollCard',
                EXPORT_LEAVE_USER: '/api/v1/users/leave_user'
            },
            SHOW_TYPES: {
                ALL: 1,
                DUTY: 2,
                ASK_FOR_LEAVE: 3,
                TIBET: 4,
            },
            getDegreeType: getDegreeType,
            getDegree: getDegree,
            getDegrees: getDegrees,
            getTitleLevel: getTitleLevel,
            getJobTypes: getJobTypes,
        };

        return angular.extend(service, $resource('/api/v1/users/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            setSeniority: {
                method: 'POST',
                params: {
                    action: 'set_seniority'
                }
            }
        }));

        function getTitleLevel() {
            return [
                {id: 1, name: '无'},
                {id: 2, name: '初级'},
                {id: 3, name: '中级'},
                {id: 4, name: '副高'},
                {id: 5, name: '正高'}
            ]
        }

        function getJobTypes() {
            return [
                {id: 1, name: '临床'},
                {id: 2, name: '行政'},
            ]
        }

        function getDegreeType(degree) {
            var degreeTypes = ArrayHelper.get('degree_types');
            for (var i = 0; i < degreeTypes.length; i++) {
                var type = degreeTypes[i];
                if (degree.indexOf(type.name) >= 0) {
                    return type;
                }
            }
            return degreeTypes[0];
        }

        function getDegree(degree, type) {
            var degrees = this.getDegrees(type);
            for (var i = 0; i < degrees.length; i++) {
                var d = degrees[i];
                if (degree == d.name) {
                    return d;
                }
            }
            return degrees[0];
        }

        function getDegrees(type) {
            var d = null;
            switch (type) {
                case 2:
                    d = ArrayHelper.get('doctor_degrees');
                    break;
                case 3:
                    d = ArrayHelper.get('master_degrees');
                    break;
                case 4:
                    d = ArrayHelper.get('bachelor_degrees');
                    break;
                case 0:
                    d = ArrayHelper.get('none_degree');
                    break;
            }
            return d;
        }
    }

    /** @ngInject */
    function JobTitle($resource, serviceConfObj) {
        var service = {
            getTypes: getTypes,
            getLevels: getLevels,
            getGrades: getGrades,
            TYPE: {
                OTHER: 99
            }
        };

        // 1医生 2医技 3护理 4工程技术 99其他
        function getTypes() {
            return [
                {id: 1, name: '医生'},
                {id: 2, name: '医技'},
                {id: 3, name: '护理'},
                {id: 4, name: '电子技术工程师'},
                {id: 5, name: '高校教师'},
                {id: 6, name: '科研'},
                {id: 7, name: '管理'},
                {id: 8, name: '工勤'},
                {id: 9, name: '会计（审计）'},
                {id: 10, name: '药剂'},
                {id: 11, name: '经济师'},
                {id: service.TYPE.OTHER, name: '其他'}
            ];
        }

        function getLevels() {
            return [
                {id: 1, name: '无'},
                {id: 2, name: '初级'},
                {id: 3, name: '中级'},
                {id: 4, name: '副高'},
                {id: 5, name: '正高'}
            ];
        }

        function getGrades() {
            return [
                {id: null, name: '暂无'},
                {id: 0, name: '无级别'},
                {id: 1, name: '1级'},
                {id: 2, name: '2级'},
                {id: 3, name: '3级'},
                {id: 4, name: '4级'},
                {id: 5, name: '5级'},
                {id: 6, name: '6级'},
                {id: 7, name: '7级'},
                {id: 8, name: '8级'},
                {id: 9, name: '9级'},
                {id: 10, name: '10级'},
                {id: 11, name: '11级'},
                {id: 12, name: '12级'}
            ];
        }

        return angular.extend(service, $resource('/api/v1/job_titles/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function DHHisBKDept($resource, serviceConfObj) {
        var service = {
            getTypes: getTypes
        };

        function getTypes() {
            return [
                {id: 1, name: '门急诊科室'},
                {id: 2, name: '住院临床科室'},
                {id: 3, name: '医技科室'},
                {id: 4, name: '医辅科室'},
                {id: 5, name: '行政后勤'},
            ];
        }

        return angular.extend(service, $resource('/api/v1/dh_his/depts/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function DHHisUserExtend($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dh_his/user_extends/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            remind: {
                method: 'POST',
                params: {
                    action: 'remind'
                }
            }
        }));
    }

    /** @ngInject */
    function Patient($resource, serviceConfObj) {
        var service = {
            getPositions: getPositions
        };

        function getPositions() {
            return [
                {id: 17, name: '职员'},
                {id: 11, name: '国家公务员'},
                {id: 12, name: '教师'},
                {id: 13, name: '专业技术人员'},
                {id: 21, name: '企业管理人员'},
                {id: 24, name: '工人'},
                {id: 27, name: '农民'},
                {id: 28, name: '宗教职业者'},
                {id: 31, name: '学生'},
                {id: 37, name: '现役军人'},
                {id: 39, name: '律师'},
                {id: 51, name: '自由职业者'},
                {id: 54, name: '个体经营者'},
                {id: 70, name: '无业人员'},
                {id: 80, name: '退（离）休人员'},
                {id: 81, name: '军人'},
                {id: 83, name: '工程师'},
                {id: 133, name: '会计师'},
                {id: 234, name: '医师'},
                {id: 255, name: '护士'},
                {id: 90, name: '其他'}
            ];
        }

        return angular.extend(service, $resource('/api/v1/shared/patients/:id', {}, serviceConfObj));
    }


})();

angular.module('c.s')
    .factory('UserDept', ['$resource', function ($resource) {
        return $resource('/api/v1/user_depts/:id', {}, {
            update: { method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('UGradeWage', ['$resource', function ($resource) {
        return $resource('/api/v1/user_grade_wages/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            addGradeWages: {
                method: 'POST',
                params: {
                    action: 'add_grade_wages'
                }
            },
            cleanGradeWages: {
                method: 'POST',
                params: {
                    action: 'clean_grade_wages'
                }
            },
            genWages: {
                method: 'POST',
                params: {
                    action: 'gen_wages'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('UserKpi', ['$resource', function ($resource) {
        return $resource('/api/v1/user_kpi/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('UserOnType', ['$resource', function ($resource) {
        return $resource('/api/v1/user_on_types/:id', {
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);

angular.module('c.s')
    .factory('UserParking', ['$resource', function ($resource) {
        return $resource('/api/v1/user_parking/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('UserStatus', ['$resource', function ($resource) {
        return $resource('/api/v1/user_statuses/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);

angular.module('c.s')
    .factory('UserStore', ['$resource', function ($resource) {
        return $resource('/api/v1/user_store/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


//angular.module('c.s')
//    .factory('UserTempWage', ['$resource', function ($resource) {
//        return $resource('/api/v1/user_temp_wages/:id', {
//            id: '@id',
//            action: '@action'
//        }, {
//            update: {
//                method: 'PUT'
//            },
//            query: {
//                method: 'GET'
//            }
//        });
//    }]);


angular.module('c.s')
    .factory('UserType', ['$resource', function ($resource) {
        return $resource('/api/v1/user_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('UVariableWage', ['$resource', function ($resource) {
        return $resource('/api/v1/user_variable_wages/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            addVariableWages: {
                method: 'POST',
                params: {
                    action: 'add_variable_wages'
                }
            },
            cleanVariableWages: {
                method: 'POST',
                params: {
                    action: 'clean_variable_wages'
                }
            },
            genWages: {
                method: 'POST',
                params: {
                    action: 'gen_wages'
                }
            }
        });
    }]);


angular.module('c.s')
    .factory('VariableWage', ['$resource', function ($resource) {
        return $resource('/api/v1/variable_wages/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('WageReport', WageReport);

/** @ngInject */
function WageReport($resource, Dlg) {
    var API_URL = "/api/v1/wage_reports";
    var service = {
        API_URL: API_URL,
        EXPORT_ALL_URL: API_URL + '/export_all_year',
        exportYearWageStat: exportYearWageStat
    };

    function exportYearWageStat() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        Dlg.exportMR({
            url: service.EXPORT_ALL_URL,
            title: '所有员工年工资统计',
            isLongDownload: true,
            start: new Date(y - 1, m, 1),
            end: new Date(y, m, 1)
        });
    }

    return angular.extend(service, $resource(service.API_URL + '/:action/:id', {
        id: '@id',
        action: '@action'
    }, {
        update: {
            method: 'PUT'
        },
        query: {
            method: 'GET'
        },
        setStage: {
            method: 'POST',
            params: {
                action: 'set_stage'
            }
        },
        genWages: {
            method: 'POST',
            params: {
                action: 'gen_wages'
            }
        }
    }));
}


angular.module('c.s')
    .factory('WageSpecial', ['$resource', function ($resource) {
        return $resource('/api/v1/wage_special/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('WorkingMeal', ['$resource', function ($resource) {
        return $resource('/api/v1/working_meals/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            adminBatch: {
                method: 'POST',
                params: {
                    action: 'admin_batch'
                }
            },
            storeBatch: {
                method: 'POST',
                params: {
                    action: 'store_batch'
                }
            }
        });
    }]);



(function () {
    'use strict';

    angular.module('c').config(config);

    /** @ngInject */
    function config(calendarConfig) {
        calendarConfig.dateFormatter = 'moment'; //use either moment or angular to format dates on the calendar. Default angular. Setting this will override any date formats you have already set.

        calendarConfig.allDateFormats.moment.date.hour = 'HH:mm'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour
        calendarConfig.allDateFormats.moment.date.datetime = 'MMM D日, h:mm a'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour

        calendarConfig.allDateFormats.moment.title.week = '{year}年 {week}周'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.day = 'dddd MMMM D号'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.month = 'YYYY年 MMMM'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.year = 'YYYY年'; //this will configure the day view title to be shorter

        calendarConfig.showTimesOnWeekView = false;

        calendarConfig.i18nStrings.weekNumber = '{week}周'; //This will set the week number hover label on the month view

    }

})();

(function () {
    'use strict';

    angular.module('c').config(dialogConfig);

    /** @ngInject */
    function dialogConfig(dialogsProvider, $translateProvider) {
        dialogsProvider.useBackdrop('static');
        dialogsProvider.useEscClose(true);
        dialogsProvider.useCopy(false);
        dialogsProvider.setSize('sm');
        dialogsProvider.useAnimation();

        $translateProvider.preferredLanguage('zh-CN');
    }

})();

(function () {
    'use strict';

    angular.module('c').config(lazyLoadConfig);

    /** @ngInject */
    function lazyLoadConfig($ocLazyLoadProvider) {
        var l = '/ocLazyLoad/';
        var m = [
            //0               1       2        3          4         5        6                 7        8              9    10
            'ngHandsontable', 'pdf', 'video', 'uiSelect', 'qrCode', 'chart', 'lunarCalendar', 'pinyin', 'uiCalendar', 'd3', 'g2',
            //11        //12    //14
            'echart', "uiGrid", "watermark"
        ];
        $ocLazyLoadProvider.config({
            modules: [
                {
                    name: m[0],
                    files: [
                        l + m[0] + '/handsontable.full.min.js',
                        l + m[0] + '/handsontable.full.min.css',
                        l + m[0] + '/ngHandsontable.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[1],
                    files: [
                        // l + m[1] + '/compatibility.js',
                        // l + m[1] + '/pdf.js',
                        // l + m[1] + '/angular-pdf.min.js'
                        l + m[1] + '/pdf.sandbox.js',
                        l + m[1] + '/pdf.worker.js',
                        l + m[1] + '/pdf.js',
                        l + m[1] + '/angular-pdf.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[2],
                    files: [
                        l + m[2] + '/vg-overlay-play.min.js',
                        l + m[2] + '/vg-controls.min.js',
                        l + m[2] + '/vg-buffering.min.js',
                        l + m[2] + '/videogular.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[3],
                    files: [
                        l + m[3] + '/select.min.css',
                        l + m[3] + '/select.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[4],
                    files: [
                        l + m[4] + '/qrCode.min.js',
                        l + m[4] + '/angular-qrcode.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[5],
                    files: [
                        l + m[5] + '/chart.min.js',
                        l + m[5] + '/angular-chart.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[6],
                    files: [
                        l + m[6] + '/lunarCalendar.min.js',
                    ],
                    serie: true
                },
                {
                    name: m[7],
                    files: [
                        l + m[7] + '/pinyin_dict_firstletter.js',
                        l + m[7] + '/pinyinUtil.js'
                    ],
                    serie: true
                },
                {
                    name: m[8],
                    files: [
                        l + m[8] + '/fullcalendar.css',
                        //jquery相关
                        l + m[8] + '/jquery.ui.core.js',
                        l + m[8] + '/jquery.ui.widget.js',
                        l + m[8] + '/jquery.ui.mouse.js',
                        l + m[8] + '/jquery.ui.draggable.js',
                        l + m[8] + '/jquery.ui.droppable.js',
                        l + m[6] + '/lunarCalendar.min.js',
                        // //日历插件相关
                        // l + m[8] + '/calendar.js',
                        // l + m[8] + '/fullcalendar.js',
                        // l + m[8] + '/gcal.js'
                    ],
                    serie: true
                },
                {
                    name: m[9],
                    files: [
                        l + m[9] + '/d3.js'
                    ],
                    serie: true
                },
                {
                    name: m[10],
                    files: [
                        l + m[10] + '/g2.min.js',
                        l + m[10] + '/jquery-3.2.1.min.js',
                        l + m[10] + '/data-set.min.js',
                    ],
                    serie: true
                },
                {
                    name: m[11],
                    files: [
                        l + m[11] + '/echart.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[12],
                    files: [
                        l + m[12] + '/ui-grid.min.css',
                        l + m[12] + '/ui-grid.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[13],
                    files: [
                        l + m[13] + '/watermark.js'
                    ],
                    serie: true
                }
            ]
        });
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(otherCfg)
        .run(otherRunner);
    /** @ngInject */
    function otherCfg($provide, $httpProvider, $compileProvider, $localStorageProvider) {
        // Improving Angular performance with 1 line of code
        // https://blog.upstate.agency/improving-angular-performance-with-1-line-of-code-a1fb814a6476
        $compileProvider.debugInfoEnabled(false);

        $provide.constant('$compileProvider', $compileProvider);

        $httpProvider.useApplyAsync(true);

        $localStorageProvider.setKeyPrefix('oa');
    }

    /** @ngInject */
    function otherRunner($anchorScroll, amMoment) {
        $anchorScroll.yOffset = 128;
        amMoment.changeLocale('zh-cn');
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['$urlRouterProvider', modWhenRouter])
        .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', MainRouter])
        .run(stateChangeCfg)
        .factory('RouteHelper', RouteHelper);


    /**
     * ui-router bug
     * http://stackoverflow.com/questions/23658846/angular-ui-router-urlrouterprovider-when-not-working-anymore
     */
    function modWhenRouter($urlRouterProvider) {
        $urlRouterProvider.when('/app/pc/stock', '/app/pc/stock/rooms');
        $urlRouterProvider.when('/app/pc/remind', '/app/pc/remind/rooms');
    }

    function MainRouter($stateProvider, $urlRouterProvider, $httpProvider) {
        $urlRouterProvider.otherwise('/app/home');

        $stateProvider
            //主页
            .state('app', {
                url: '/app',
                templateUrl: 'templates/cache/main.html',
                resolve: {
                    window: ['$window', function ($window) {
                        return $window;
                    }],
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['uiSelect']);
                    }]
                },
                controller: 'MainCtrl',
                //目前能实现注销后路由状态重载的办法，但会引起页面刷新（bad!）
                //2016-7-15,以上方法在手机浏览器和苹果浏览器上会引起注销异常，现在弃用
                //关注：https://github.com/angular-ui/ui-roupermiter/issues/1095
                onExit: function (window) {
                    "ngInject";
                    //window.location.reload();
                },
                data: {
                    requireLogin: true
                }
            })
            .state('app.home', {
                url: '/home?data?hrm',
                templateUrl: 'templates/cache/home.html',
                controller: 'HomeCtrl',
                controllerAs: 'home',
                onEnter: function ($state, Auth) {
                    "ngInject";
                    if (!Auth.getAccount().can_see_home) {
                        $state.go('app.user_profile');
                    }
                }
            })
            // .state('app.user_contacts', {
            //     url: '/contacts',
            //     templateUrl: 'pages/user/contacts.html',
            //     controller: 'ContactsCtrl',
            //     data: {requireLogin: true}
            // })
            // .state('app.user_help', {
            //     url: '/help',
            //     templateUrl: 'pages/user/help.html',
            //     controller: 'UserHelpCtrl',
            //     data: {requireLogin: true}
            // })
            //登录
            .state('login', {
                templateUrl: 'pages/login.html',
                url: '/login',
                controller: 'LoginCtrl',
                data: {
                    requireLogin: false
                }
            })
            .state('blank', {
                templateUrl: 'pages/blank.html',
                url: '/blank',
                data: {
                    requireLogin: false
                },
                //仍然保留此页面的目的是论坛注销时会重定向到这里，为了实现论坛和主站的同步注销
                onEnter: function ($timeout, Auth) {
                    "ngInject";
                    $timeout(function () {
                        Auth.deleteToken();
                        var url = "http://" + window.location.host + "/#/login";
                        window.location.href = url;
                    }, 360);
                }
            })
            .state('temp', {
                templateUrl: 'pages/blank.html',
                url: '/blank',
                data: {requireLogin: false}
            })
            .state('get_wechat_token', {
                url: "/get_wechat_token?code",
                controller: "WechatAuthCtrl",
                data: {requireLogin: false}
            })
            .state('clinc_screen', {
                templateUrl: 'pages/clinc/clincScreen.html',
                url: "/clinc_large_screen",
                controller: "ClincLargeScreenCtrl",
                data: {requireLogin: true},
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        // $http我用了加载不上，只是获得了没有使用起来
                        return $ocLazyLoad.load(['/ocLazyLoad/mod/clinc.js', '/ocLazyLoad/mod/heath_manage.js',
                            '/ocLazyLoad/mod/clinc.css', '/ocLazyLoad/mod/clinc.css']);
                    }]
                }
            })
            .state('eqs_screen', {
                templateUrl: 'pages/eqs/eqsScreen.html',
                url: "/eqs_large_screen",
                controller: "EqsScreenCtrl",
                data: {requireLogin: true},
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        // $http我用了加载不上，只是获得了没有使用起来
                        return $ocLazyLoad.load(['/ocLazyLoad/mod/eqs.js', '/ocLazyLoad/mod/eqs.css']);
                    }]
                }
            })
            .state('hga_index', {
                templateUrl: 'pages/hgaIndex.html',
                url: "/hga_index?code",
                controller: "HgaIndexCtrl",
                data: {requireLogin: false},
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('/ocLazyLoad/mod/hga.js'); // 不如用$http
                    }]
                }
            })
            .state('information', {
                templateUrl: 'pages/party/information.html',
                url: '/party_information',
                controller: 'informationUploadCtrl',
                data: {requireLogin: true},
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['/ocLazyLoad/mod/party.js', 'uiSelect']);
                    }]
                }
            })
            .state('sheetQrcode', {
                // templateUrl: 'pages/user/q/qrcode.html',
                url: '/sheet_qrcode?survey',
                controller: 'sheetQrcodeCtrl',
                data: {requireLogin: true},
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('/ocLazyLoad/mod/q.js', '/ocLazyLoad/mod/q.css');
                    }]
                }
            })
            .state('community_twoWayReferral', {
                templateUrl: 'pages/community/twoWayReferral.html',
                url: '/community_twoWayReferral',
                controller: 'communityTwoWayReferralCtrl',
                data: {
                    requireLogin: true
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('/ocLazyLoad/mod/twoWayReferral.js', '/ocLazyLoad/mod/twoWayReferral.css');
                    }]
                }
            });

        angular.forEach(previewRoutes, function (b) {
            var pa = {
                templateUrl: "/pages/preview/" + b[1],
                url: "/" + b[2],
                data: {
                    requireLogin: true
                }
            };
            $stateProvider.state(b[0], pa);
        });

        angular.forEach(routes, function (r) {
            var pa = {
                url: "/" + r[1] + '?tab&wxnpId&wxnpType&add',
                reloadOnSearch: false,
                controller: r[3],
                params: {data: {}},
                perm: r[4],
                onExit: function () {
                    for (var i in CKEDITOR.instances) {
                        var editor = CKEDITOR.instances[i];
                        if (editor) editor.destroy();
                    }
                }
            };
            if (r[2].charAt(0) == '<') {
                pa.template = '<ui-view></ui-view>';
            } else {
                pa.templateUrl = "pages/" + r[2];
            }
            if (r[5]) {
                pa.resolve = {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(r[5]);
                    }]
                };
            }
            if (r[6]) {
                angular.forEach(r[6], function (c) {
                    $stateProvider.state("app." + r[0] + "." + c[0], {
                        url: "/" + c[1],
                        templateUrl: "pages/" + c[2]
                    });
                });
            }
            $stateProvider.state("app." + r[0], pa);
        });

        var pendingRequests = [];
        $httpProvider.interceptors.push(['$timeout', '$q', '$injector', 'Auth',
            function ($timeout, $q, $injector, Auth) {
                var $state;
                var dialogs;
                var $http;
                var CODE = Auth.CODE;
                $timeout(function () {
                    $state = $injector.get('$state');
                    dialogs = $injector.get('dialogs');
                    $http = $injector.get('$http');
                });

                return {
                    'request': function (config) {
                        config.headers = config.headers || {};
                        if (Auth.hasToken()) {
                            config.headers.Authorization = 'Bearer ' + Auth.getToken();
                        }
                        return config;
                    },
                    'responseError': function (response) {
                        if (response.status === 401) {
                            var code = getCode(response.data);
                            if (code === CODE.TOKEN_DEAD || code === CODE.INVALID) {
                                logout();
                            }
                            if (code !== CODE.TOKEN_EXPIRED) return $q.reject(response);

                            if (pendingRequests.length === 0) {
                                $timeout(function () {
                                    Auth.refreshToken().then(function (resp) {
                                        var token = resp.data;
                                        Auth.setToken(token);
                                        var newAuth = 'Bearer ' + Auth.getToken();
                                        angular.forEach(pendingRequests, function (req) {
                                            req.config.headers.Authorization = newAuth;
                                            req.resolve($http(req.config));
                                        });
                                    }).catch(function () {
                                        angular.forEach(pendingRequests, function (req) {
                                            req.reject();
                                        });
                                        logout(dialogs, $state, Auth);
                                    }).finally(function () {
                                        pendingRequests = [];
                                    });
                                }, 1000);
                            }

                            return $q(function (resolve, reject) {
                                pendingRequests.push({config: response.config, resolve: resolve, reject: reject})
                            });

                        }
                        return $q.reject(response);
                    }
                };
            }]);
    }

    function logout(dialogs, $state, Auth) {
        if (Auth.hasToken()) {
            Auth.deleteToken();
            dialogs.notify('信标已过期', '用于通信的信标已过期，您需要重新登录！')
                .result.then(function () {
                $state.go('login');
            });
        }
    }

    function getCode(body) {
        // 针对文件上传时，响应数据类型为ArrayBuffer的情况
        if (body instanceof ArrayBuffer) {
            var str = String.fromCharCode.apply(null, new Uint8Array(body));
            body = JSON.parse(str)
        }
        return parseInt(body.code);
    }

    /** @ngInject */
    function RouteHelper() {
        var service = {
            getRoutes: getRoutes
        };

        function getRoutes() {
            return routes;
        }

        return service;
    }

    /** @ngInject */
    function stateChangeCfg($rootScope, $state, $window, $uibModalStack, WxHelper, Auth, dialogs) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            //"ngInject";
            var requireLogin = toState.data.requireLogin;
            if (requireLogin && !Auth.hasToken()) {
                event.preventDefault();
                if (WxHelper.isWechatBrowser()) { //微信浏览器
                    $window.location.href = WxHelper.getWechatAuthorizeUrl(toState, toParams);
                } else {
                    $state.go('login');
                }
            } else if (angular.isDefined(toState.params) && angular.isUndefined(toState.can)) {
                event.preventDefault();
                $rootScope.pendingState = toState;
                $rootScope.pendingParams = toParams;
                $state.go("app");
            } else if (toState.can === false) {
                event.preventDefault();
                dialogs.notify("提示", "您没有访问该页面的权限，请求被中止");
            }
            if (angular.isDefined(toState.index))
                $rootScope.collapseVar = toState.index;
        });
        $rootScope.$on('$stateChangeSuccess', function (newVal, oldVal) {
            if (oldVal !== newVal) {
                $uibModalStack.dismissAll();
                if (window.innerWidth < 768) {
                    $rootScope.$broadcast('showSidebar', false);
                }
            }
        });
    }

    var previewRoutes = [
        ["article", "article.html", "articles/:type/:id"],
        ["email", "email.html", "emails/:id"],
        ["covid", "covid.html", "covids/:id"]
        // ["meeting", "meeting.html", "meetings/:id"]
    ];

    var routes = [
        ["user_profile", "user/profile", "user/profile.html", "ProfileCtrl", 1000, ['qrCode']],
        ["coop_email", "coop/email", "user/email.html", null, 1021],
        ["coop_bulletin", "coop/bulletin", "user/bulletin.html", "BulletinCtrl", 1022],
        ["coop_bid", "coop/bid", "user/bid.html", null, 1026],
        ["coop_news", "coop/news", "user/news.html", null, 1023],
        ["coop_file_cabinet", "coop/file_cabinet", "user/file_cabinet.html", null, 1024],
        ["coop_meeting", "coop/meeting", "user/meeting.html", "UserMeetingCtrl", 1025],
        ["user_dept_record", "user/dept_record", "user/dept_record.html", "DeptRecordCtrl", 1001],
        ["user_leave", "user/leave", "user/leave.html", null, 1002],
        ["coop_clinic_stop_application", "coop/clinic_stop_application", "clinic/stop_application.html", null, 10058],
        ["coop_intern_leave_application", "coop/intern_leave_application", "coop/intern_leave_application.html", null, 10059],
        ["user_car_apply", "user/car_apply", "user/car_apply.html", "CarApplyCtrl", 1008],
        ["user_duty", "user/duty", "user/duty.html", "UserDutyCtrl", 1003],
        ["clinc_search", "user/clinc_search", "user/clinc_search.html", null, 1005],
        ["user_ss", "user/ss", "user/ss.html", null, 1009],
        ["user_contact_group", "user/contact_group", "user/contact_group.html", "ContactGroupCtrl", 1006],
        ["user_contacts", "user/contacts", "user/contacts.html", null, 1007],
        ["user_edu", "user/edu", "user/edu.html", null, 1011, ['pdf', 'video']],
        ["user_practice", "user/practice", "user/practice.html", "PracticeWorkController", 1012],
        ["coop_quick_menu", "user/quick_menu", "user/quick_menu/quick_menu.html", "UserQuickMenuCtrl", 1013],
        ["coop_calendar", "user/calendar", "user/calendar/main.html", null, 1014, ['uiCalendar']],
        ["user_diagnosis", "user/diagnosis", "mesStatistics/diagnosis.html", null, 1015],
        // ["user_post_competition", "user/post_competition", "user/postCompetition.html", null, 1016, ['video']],
        ["user_help", "user/help", "user/help.html", "UserHelpCtrl", 1020],
        ["coop_data_collection", "coop/data_collection", "coop/data_collection.html", null, 10034],
        ["health_statistics_workload", 'health_statistics/workload', 'healthStatistics/workload.html', null, 41006],
        ["coop_sms", "coop/sms", "user/sms.html", "SmsCtrl", 10002],
        ["coop_op_notice", "coop/op_notice", "user/op_notice.html", "UserOPNoticeCtrl", 10007],
        ["coop_doc", "coop/doc", "user/doc.html", "UserDocCtrl", 10009],
        // ["coop_performance", "coop/performance", "coop/performance.html", null, 10031],
        // ["coop_overtime_report", "coop/overtime_report", "coop/overtimeReport.html", null, 10032],
        ['coop_car_cost', 'coop/car_cost', 'coop/carCost.html', null, 10028],
        ['coop_car_illegal', 'coop/car_illegal', 'coop/carIllegal.html', null, 10029],
        ["coop_meeting_topic", "coop/meeting_topic", "user/meeting_topic.html", "MeetingTopicCtrl", 10010],
        ["coop_q", "coop/q", "user/q.html", null, 10011],
        ["coop_file", "coop/file", "user/fileCirculate.html", null, 10012],
        ["coop_rule", "coop/rule", "user/rule.html", "UserRuleCtrl", 10013, ['pdf', 'video']],
        ["coop_insurance_feedback", "coop/insurance_feedback", "user/insuranceFeedback.html", null, 10061],
        ["coop_law", "coop/law", "user/law.html", null, 10023, ['pdf']],
        ["coop_mission", "coop/mission", "user/mission.html", null, 10014],
        ["coop_task", "coop/task", "coop/task.html", null, 10045, ["d3"]],
        ["coop_task2", "coop/task_third", "coop/task_third.html", null, 10049, ["d3"]],
        ["user_wage", "user/wage", "user/wage.html", "UserWageCtrl", 10015, ["ngHandsontable"]],
        ["user_meal", "user/meal", "user/meal.html", "UserMealCtrl", 10016],
        ["coop_contract", "coop/contract", "user/contract.html", null, 10017, ['pdf']],
        ["coop_folder", "coop/folder", "coop/folder.html", null, 10018],
        ["coop_qualification", "coop/qualification", "user/qualification.html", null, 10019],
        // ["coop_authorization", "coop/authorization", "user/authorization.html", null, 10024],
        // ["coop_hga", "coop/hga", "user/hga.html", null, 10021],
        ["coop_adverse", "coop/adverse", "coop/adverse.html", null, 10026, ['chart']],
        // ["coop_party_fee", "coop/party_fee", "coop/party_fee.html", null, 10027, ['qrCode']],
        ["coop_copy_paper", "coop/copy_paper", "coop/cp.html", null, 10030],
        ["coop_attendance", "coop/attendance", "coop/attendance.html", null, 10042],
        ["coop_tech", "coop/tech", "coop/tech.html", null, 10057],
        ["coop_nurse_tech", "coop/nurse_tech", "coop/nurse_tech.html", null, 10059],
        ["user_digestion_doc", "user/digestion", "sys/digestion.html", null, 10062],

        ["coop_e_manual", "coop/e_manual", "user/e_manual.html", null, 10022, ['pdf']],
        ["coop_consumable_manual", "coop/consumable_manual", "coop/consumable_manual.html", null, 10060, ['pdf']],
        // ["coop_ap_search", "coop/aq_search", "user/aq_search.html", null, 10025],
        // ["coop_disease_plan", "coop/disease_plan", "user/disease_plan.html", null, 10033],
        // ["coop_tibetan_language", "coop/tibetan_language", "coop/tibetan_language.html", null, 10035],
        // ["coop_his_security", "coop/his_security", "coop/hisSecurity.html", null, 10052],

        // ["coop_inpatientMeal", "coop/inpatientMeal", "coop/inpatientMeal.html", null, 10036],
        // ["coop_clincMeal", "coop/clincMeal", "coop/clincMeal.html", null, 10037],
        // ["coop_handover", "coop/handover", "coop/handover.html", null, 10038],
        ["coop_trade_union", "coop/trade_union", "coop/tradeUnion.html", null, 10039],
        ["coop_tu_interesting_group", "coop/tu_interesting_group", "coop/tuInterestingGroup.html", null, 10040],
        ["coop_tu_activity", "coop/tu_activity", "coop/tuActivity.html", null, 10041],
        // ["coop_rs", "coop/rs", "coop/rs.html", null, 10044],
        // ["coop_ua", "coop/ua", "coop/ua.html", null, 10043],
        // ["coop_immunity", "coop/immunity", "coop/immunity.html", null, 10048],
        ["coop_patient_body_index", "coop/patientBodyIndex", "coop/patientBodyIndex.html", null, 10053, ['chart']],
        ["coop_work_order_manage", "coop/work_order_manage", "coop/workOrderManage.html", null, 10323],
        ["coop_problem_feedback", "coop/problem_feedback", "coop/problemFeedback.html", null, 10324],
        ["coop_seal", "coop/seal", "coop/seal.html", null, 10046],
        // ["coop_operation_consultation", "coop/operationConsultation", "coop/operationConsultation.html", null, 10047],
        ["coop_dc", "coop/dc", "coop/dc.html", null, 10050],
        ["coop_out_q", "coop/out_q", "coop/out_q.html", null, 10051],
        ["coop_invoice", "coop/invoice", "coop/invoice.html", null, 10054],
        ["coop_medical_action", "coop/medical_action", "coop/medicalAction.html", null, 10055],
        ["coop_dean_report", "coop/dean_report", "coop/deanReport.html", null, 10325],
        ["coop_dean_feedback", "coop/dean_feedback", "coop/deanFeedback.html", null, 10326],
        // ["coop_escort_registration", "coop/escort_registration", "coop/escortRegistration.html", null, 10056],

        ["coop_mtv_conference", "coop/mtvConference", "coop/mtvConference.html", null, 10319, ['video']],
        // ["coop_money_refuse", "coop/money_refuse", "coop/manage.html", null, 10302],
        // ["coop_clinic_cash", "coop/clinic_cash", "coop/cash_manage.html", null, 10303],
        ["coop_exam_manage", "coop/exam_manage", "coop/exam_manage.html", null, 10310],
        ["coop_exam_reg", "coop/exam_reg", "coop/exam_reg.html", null, 10311],
        // ["coop_exam_guide", "coop/guide", "coop/guide.html", null, 10312],
        ["coop_keep_post_manage", "coop/keep_post_manage", "coop/keepPostManage.html", null, 10313],
        // ["coop_remote_clinic", "coop/remote_clinic", "coop/remoteClinic.html", null, 10314],
        // ["coop_pretty_tibet", "coop/pretty_tibet", "coop/prettyTibet.html", null, 10315],
        // ["coop_mes_item_suggestion", "coop/mes_item_suggestion", "coop/mesItemSuggestion.html", null, 10316],
        ["coop_mes_report_seek", "coop/mes_report_seek", "coop/mesReportSeek.html", null, 10317],
        ["coop_pneumonia_report", "coop/pneumonia_report", "coop/pneumonia.html", null, 10318],
        ["coop_bed_stat", "coop/bed_stat", "coop/bedStat.html", null, 10320, ['echart', 'uiGrid', 'ngHandsontable']],
        // ["coop_ohmt", "coop/ohmt", "coop/ohmt.html", null, 10321, ['chart']],
        // ["coop_covid", "coop/covid", "coop/covid.html", null, 10322],

        ["coop_material", "coop/material", "user/material.html", "UserMaterialCtrl", 10006],
        ["coop_consumable", "coop/consumable", "user/consumable.html", null, 10020],
        ["my_material_apply", "my_material/apply", "myMaterial/csmbApply.html", null, 16001],
        ["coop_consumable_direct", "coop/consumable_direct", "user/consumable_direct.html", null, 16006],
        ["coop_consumable_direct_op", "coop/consumable_direct_op", "user/consumable_direct_op.html", null, 16008],
        ["coop_consumable_group", "coop/consumable_group", "user/consumable_group.html", null, 16007],
        // ["coop_patrol_record", "coop/patrol_record", "user/patrol_record.html", null, 16002],
        // ["coop_room_repair", "coop/room_repair", "user/room_repair.html", null, 16003],
        ["material_pms_room_patrol", "material/pms_room_patrol", "material/pmsRoomPatrol.html", null, 16009],
        ["material_pms_room_repair", "material/pms_room_repair", "material/pmsRoomRepair.html", null, 16010],
        ["material_pms_room_repairer", "material/pms_room_repairer", "material/pmsRoomRepairer.html", null, 16011],
        ["coop_equipment_apply", "coop/equipment_apply", "user/equipment_apply.html", null, 16004],
        ["coop_equipment_repair", "coop/equipment_repair", "user/equipment_repair.html", null, 16005, ['video']],

        ["duty_scheduler", "duty/scheduler", "duty/scheduler.html", "SchedulerCtrl", 5005],
        ["duty_shift", "duty/shift", "duty/shift.html", "ShiftCtrl", 5006],
        ["duty_group_member", "duty/group_member", "duty/group_member.html", "DutyGroupMemberCtrl", 5007],
        ["duty_fee_declare", "duty/fee_declare", "duty/fee_declare.html", "DutyFeeFilingCtrl", 5008],

        ["dept_leave_approval", "dept_approval/leave_approval", "dept_leader/leave_approval.html", "DeptLeaveApprovalCtrl", 30101],
        ["dept_notice_approval", "dept_approval/notice_approval", "dept_leader/notice_approval.html", "NoticeApprovalCtrl", 30102],
        ["dept_bid_approval", "dept_approval/bid_approval", "dept_leader/bid_approval.html", null, 30114],
        ["dept_meeting", "dept_leader/meeting", "dept_leader/meeting.html", null, 30103],
        ["dept_meeting_topic", "dept_approval/meeting_topic", "dept_leader/meeting_topic.html", "DeptMeetingTopicCtrl", 30104],
        ["dept_q", "dept_approval/q", "dept_leader/q.html", null, 30105],
        ["dept_car", "dept_approval/car", "dept_leader/car.html", "DeptCarPendingCtrl", 30106],
        // ["dept_news", "dept_approval/news", "dept_leader/news.html", "NewsApprovalCtrl", 30107],
        ["dept_contract", "dept_approval/contract", "dept_leader/contract.html", null, 30108, ['pdf']],
        ["dept_purchase", "dept_approval/purchase", "dept_leader/purchase.html", null, 30109],
        // ["dept_op_consultation", "dept_approval/opConsultation", "dept_leader/opConsultation.html", null, 30110],
        // ["dept_covid", "dept_approval/covid", "dept_leader/covid.html", null, 30111],
        ["dept_medical_action", "dept_approval/medical_action", "dept_leader/medicalAction.html", null, 30112],
        ["dept_personal_wage", "dept_personal/wage", "dept_leader/wage.html", null, 30113, ["ngHandsontable"]],

        ["dept_ss", "dept_message/ss", "dept_leader/ss.html", null, 30202],
        ["dept_doc", "dept_message/doc", "dept_leader/doc.html", "DeptDocCtrl", 30203],
        ["dept_copy_paper", "dept_message/copy_paper", "dept_leader/cp.html", null, 30204],
        ["dept_attendance", "dept_message/attendance", "dept_leader/attendance.html", "DeptAttendanceCtrl", 30205],
        ["dept_wage", "dept_message/dept_wage", "dept_leader/dept_wage.html", "DeptWageCtrl", 30206, ["ngHandsontable"]],
        ["dept_phones", "dept_message/phones", "dept_leader/phones.html", "DeptPhonesCtrl", 30207],
        ["dept_file", "dept_message/dept_file", "dept_leader/dept_file.html", null, 30208],
        ["dept_rule", "dept_message/rule", "dept_leader/rule.html", "DeptRuleCtrl", 30209, ['pdf', 'video']],
        ["dept_attendance_card", "dept_message/attendance_card", "dept_leader/deptAttendance.html", null, 30210],
        // ["dept_circulate_handle", "dept_message/circulate_handle", "dept_leader/circulateHandle.html", null, 30211],

        ["dept_member", "dept_performance_manage/members", "dept_leader/members.html", null, 30201],
        ["dept_performance", "dept_performance_manage/performance", "dept_leader/performance.html", null, 30301],
        ["dept_performance_indicator", "dept_performance_manage/dept_indicator", "dept_leader/deptIndicator.html", null, 30302],
        ["dept_hospital_indicator", "dept_performance_manage/hospital_indicator", "dept_leader/hospitalIndicator.html", null, 30304],
        ["dept_overtime_report", "dept_performance_manage/overtimeReport", "dept_leader/overtimeReport.html", null, 30303],
        ["dept_expert_report", "dept_performance_manage/expert_report", "dept_leader/expertReport.html", null, 30305],

        ["dept_edu", "dept_leader/edu", "dept_leader/edu.html", null, 3011, ['pdf', 'video']],
        ["dept_mission", "dept_leader/mission", "dept_leader/mission.html", "DeptMissionCtrl", 3013],
        ["dept_practice", "dept_leader/practice", "dept_leader/practice.html", null, 3014],
        ["dept_round", "dept_leader/round", "dept_leader/round.html", "DeptRoundsCtrl", 3015],
        ["dept_consumable", "dept_leader/consumable", "dept_leader/consumable.html", null, 3018],
        // ["dept_room", "dept_leader/room", "dept_leader/room.html", null, 3019],
        ["dept_data_collection", "dept_leader/data_collection", "dept_leader/data_collection.html", null, 3021],
        ["dept_paper", 'dept_leader/paper', 'dept_leader/paper.html', null, 3022],
        ["dept_temper_feel", 'dept_leader/pneumonia', 'dept_leader/pneumonia.html', null, 3023],
        ["dept_health_code", 'dept_leader/health_code', 'dept_leader/health_code.html', null, 3026],
        ["dept_fruit_research", "dept_leader/fruit_research", "dept_leader/fruit_research.html", null, 3024],
        ["dept_fruit_teaching", "dept_leader/fruit_teaching", "dept_leader/fruit_teaching.html", null, 3025],
        ["dept_fruit_medical", "dept_leader/fruit_medical", "dept_leader/fruit_medical.html", null, 3029],
        ["dept_fruit_other", "dept_leader/fruit_other", "dept_leader/fruit_other.html", null, 3027],
        ["dept_fruit_employee_record", "dept_leader/fruit_employee_record", "dept_leader/fruit_employee_record.html", null, 3028],
        ["dept_clinic_stop_application", "dept_leader/clinic_stop_application", "dept_leader/clinic_stop_application.html", null, 3030],

        ["room_repairer", "room_repairer/manage", "room_repairer/manage.html", null, 27001],

        ["performance_leader_performance_unit", "performance_leader/unit", "performance_leader/unit.html", null, 33001],

        ["room_repairer_root_manage", "room_repairer_root/manage", "room_repairer_root/manage.html", null, 28001],

        ["dept_csmb_query", "dept_csmb/query", "dept_csmb/query.html", null, 15002],
        ["dept_csmb_inventory", "dept_csmb/inventory", "dept_csmb/inventory.html", null, 15003],
        ["dept_csmb_remind", "dept_csmb/remind", "dept_csmb/remind.html", null, 15004],
        ["dept_csmb_return", "dept_csmb/return", "dept_csmb/return.html", null, 15005],
        ["dept_csmb_application", "dept_csmb/application", "dept_csmb/application.html", null, 15006],
        ["dept_csmb_use", "dept_csmb/use", "dept_csmb/use.html", null, 15007],
        ["dept_csmb_direct", "dept_csmb/direct", "dept_csmb/direct.html", null, 15016],
        // ["dept_room_repair", "dept_room/repair", "dept_room/repair.html", null, 15008],
        ["dept_equipment_in", "dept_equipment/in", "dept_equipment/in.html", null, 15009],
        ["dept_equipment_m_fee", "dept_equipment/m_fee", "dept_equipment/m_fee.html", null, 15010],
        ["dept_equipment_inventory", "dept_equipment/inventory", "dept_equipment/inventory.html", null, 15011],
        ["dept_equipment_manage", "dept_equipment/manage", "dept_equipment/manage.html", null, 15012],
        ["dept_equipment_repair", "dept_equipment/repair", "dept_equipment/repair.html", null, 15013],
        ["dept_equipment_analysis", "dept_equipment/analysis", "dept_equipment/analysis.html", null, 15014],
        ["dept_equipment_admin", "dept_equipment/admin", "dept_equipment/admin.html", null, 15015],

        ["keep_post_manage_post", "keep_post_manage/post", "keepPostManage/postManage.html", null, 5301],
        ["keep_post_manage_person", "keep_post_manage/person", "keepPostManage/personManage.html", null, 5302],
        ["keep_post_manage_attendance", "keep_post_manage/attendance", "keepPostManage/attendanceManage.html", null, 5303],
        ["keep_post_manage_all_post", "keep_post_manage/all_post", "keepPostManage/allPostManage.html", null, 5304],
        ["keep_post_manage_un_manage", "keep_post_manage/un_manage", "keepPostManage/unManage.html", null, 5305],
        // ["keep_post_manage_remote_clinic", "keep_post_manage/remote_clinic", "keepPostManage/remoteClinic.html", null, 5306],
        // ["keep_post_manage_pretty_tibet", "keep_post_manage/pretty_tibet", "keepPostManage/prettyTibet.html", null, 5307],

        ["nurse_seniority_approval", "nurse_leader/seniority_approval", "nurse_leader/seniority_approval.html", "NurseSeniorityApprovalCtrl", 3101],

        ["hospital_leave_approval", "hospital_leader/leave_approval", "hospital_leader/leave_approval.html", "DeptLeaveApprovalCtrl", 3200],
        ["hospital_notice_approval", "hospital_leader/notice", "hospital_leader/notice.html", null, 3201],
        ["hospital_bid_approval", "hospital_leader/bid", "hospital_leader/bid.html", null, 3219],
        // ["hospital_news", "hospital_leader/news", "hospital_leader/news.html", "NewsApprovalCtrl", 3210],
        ["hospital_meeting", "hospital_leader/meeting", "hospital_leader/meeting.html", null, 3202],
        ["hospital_meeting_topic", "hospital_leader/meeting_topic", "hospital_leader/meeting_topic.html", "DeptMeetingTopicCtrl", 3203],
        ["hospital_public_topic", "hospital_leader/public_topic", "hospital_leader/public_topic.html", "HospitalPublicTopicCtrl", 3204],
        ["hospital_q", "hospital_leader/q", "hospital_leader/q.html", null, 3206],
        ["hospital_ss", "hocabin3_spital_leader/ss", "hospital_leader/ss.html", null, 3207],
        ["hospital_rule", "hospital_leader/rule", "hospital_leader/rule.html", "DeptRuleCtrl", 3208, ['pdf', 'video']],
        ["hospital_mission", "hospital_leader/mission", "hospital_leader/mission.html", "HospitalMissionCtrl", 3209],
        // ["hospital_contract", "hospital_leader/contract", "hospital_leader/contract.html", null, 3211, ['pdf']],
        ["hospital_consumable", "hospital_leader/consumable", "hospital_leader/consumable.html", null, 3212],
        // ["hospital_hga", "hospital_leader/hga", "hospital_leader/hga.html", null, 3213],
        ["hospital_performance_indicator", "hospital_leader/performance_indicator", "hospital_leader/performanceIndicator.html", null, 3214],
        ["hospital_dept_purchase", "hospital_leader/dept_purchase", "hospital_leader/deptPurchase.html", null, 3215],
        ["hospital_attendance", "hospital_leader/attendance", "hospital_leader/attendance.html", null, 3216],
        // ["hospital_covid", "hospital_leader/covid", "hospital_leader/covid.html", null, 3217],
        ["hospital_clinic_stop_application", "hospital_leader/clinic_stop_application", "hospital_leader/clinic_stop_application.html", null, 3218],

        ["main_leave", "main_leader/main_leave", "main_leader/leave_approval.html", "DeptLeaveApprovalCtrl", 3301],
        ["main_leave_recipient", "main_leader/main_leave_recipient", "main_leader/leave_recipient.html", null, 3302],
        ["main_leader_performance_manage", "main_leader/performance", "main_leader/performance.html", null, 3309],
        // ["main_leader_news_approval", "main_leader/news", "main_leader/news.html", null, 3310],
        ["main_meeting_topic", "main_leader/meeting_topic", "main_leader/meeting_topic.html", 'MeetingTopicMainCtrl', 3303],
        ["main_mission", "main_leader/mission", "main_leader/mission.html", "MainMissionCtrl", 3304],
        ["main_users_info", "main_leader/users_info", "main_leader/user_info.html", "UserInfoCtrl", 3305],
        ["main_all_doc", "main_leader/all_doc", "hospital_office/doc.html", "PartyDocCtrl", 3307],
        ["main_consumable", "main_leader/consumable", "main_leader/consumable.html", null, 3306],
        ["main_contract", "main_leader/contract_search", "hospital_office/contract_search.html", null, 3308, ['pdf']],
        ["main_dean_report", "main_leader/dean_report", "main_leader/deanReport.html", null, 3311],

        ["dean_leave", "dean_leader/leave", "main_leader/leave_approval.html", null, 7404],
        ["dean_meeting_topic", "dean_leader/meeting_topic", "dean/meeting_topic.html", 'MeetingTopicDeanCtrl', 7401],
        ["dean_performance_manage", "dean_leader/performance", "dean/performance.html", null, 7406],
        ["dean_dean_report", "dean/dean_report", "dean/deanReport.html", null, 7407],
        ["dean_users_info", "dean_leader/users_info", "main_leader/user_info.html", "UserInfoCtrl", 7402],
        ["dean_all_doc", "dean_leader/all_doc", "hospital_office/doc.html", "PartyDocCtrl", 7403],
        ["dean_contract", "dean_leader/contract_search", "hospital_office/contract_search.html", null, 7405, ['pdf']],

        ["news_manage", "publicity/news_manage", "publicity/news_manage.html", null, 31001],
        ["news_mtv_conference", "publicity/news_mtv_conference", "publicity/mtvConference.html", null, 31002],
        ["publicity_dean_report", "publicity/dean_report", "publicity/deanReport.html", null, 31003],
        ["publicity_dean_feedback", "publicity/dean_feedback", "publicity/deanFeedback.html", null, 31004],
        // ["news_post_competition", "publicity/post_competition", "publicity/postCompetition.html", null, 31003, ['video']],
        ["copy_record", "shop/copy_record", "shop/copy_record.html", null, 32001],
        ["shop_price_report", "shop/price_report", "shop/price_report.html", null, 32002],
        ["shop_trade_union", "shop/trade_union", "shop/tradeUnion.html", null, 32003],
        ["shop_promote_sale", "shop/promote_sale", "shop/promoteSale.html", null, 32004],

        ["t_accountant_performance_manage", "t_accountant/performance", "t_accountant/performance.html", null, 7501],
        ["t_accountant_csmb_public", "t_accountant/csmb_public", "t_accountant/csmbPublic.html", null, 7502],

        ["performance_progress_hospital_unit", "performance_progress/hospitalUnit", "performance_progress/hospitalUnit.html", null, 7701],
        ["performance_progress_dept", "performance_progress/dept", "performance_progress/dept.html", null, 7702],
        ["performance_progress_self", "performance_progress/self", "performance_progress/self.html", null, 7703],
        ["performance_progress_analysis", "performance_progress/analysis", "performance_progress/analysis.html", null, 7704],

        ["hospital_office_user_info", "hospital_office/user_info", "hospital_office/user_info.html", "HospitalOfficeUserInfoCtrl", 4001],
        ["bulletin_manage", "hospital_office/bulletin_manage", "hospital_office/bulletin_manage.html", "BulletinManageCtrl", 4002],
        ["bid_manage", "hospital_office/bid_manage", "hospital_office/bid_manage.html", null, 4033],
        ["hospital_office_leave", "hospital_office/leave", "hospital_office/leave.html", null, 4032],
        ["party_doc", "hospital_office/doc", "hospital_office/doc.html", "PartyDocCtrl", 4018],
        ["hospital_office_common_phone", "hospital_office/common_phone", "hospital_office/common_phone.html", null, 4020],
        // ["hospital_office_copy_paper", "hospital_office/copy_paper", "hospital_office/cp.html", null, 4030],
        ["hospital_office_dept_phone", "hospital_office/dept_phone", "hospital_office/dept_phone.html", null, 4031],
        ["file_manage", "hospital_office/file_manage", "hospital_office/file_manage.html", null, 4003],
        ["work_arrange", "hospital_office/work_arrange", "hospital_office/work_arrange.html", "WorkArrangeCtrl", 4004],
        ["airfare_manage", "hospital_office/airfare_manage", "hospital_office/airfare_manage.html", "AirfareManageCtrl", 4012],
        ["meeting_manage", "hospital_office/meeting_manage", "hospital_office/meeting_manage.html", "MeetingManageCtrl", 4005],
        ["meeting_topic_manage", "hospital_office/meeting_topic_manage", "hospital_office/meeting_topic_manage.html", "MeetingTopicManageCtrl", 4007],
        ["file_circulate", "hospital_office/file_circulate", "hospital_office/fileCirculate.html", null, 4008],
        ["satisfaction_survey", "hospital_office/ss", "hospital_office/ss.html", null, 4010],
        ["contract_search", "hospital_office/contract_search", "hospital_office/contract_search.html", null, 4013, ['pdf']],
        ["rule_manage", "hospital_office/rule_manage", "hospital_office/rule_manage.html", "RuleManageCtrl", 4009, ['pdf', 'video']],
        ["common_pneumonia", "hospital_office/common_pneumonia", "hospital_office/common_pneumonia.html", null, 4021],
        ["hospital_office_csmb", "hospital_office/csmb", "hospital_office/csmb.html", null, 4022],
        //["car_manage", "hospital_office/cars_manage", "hospital_office/cars_manage.html", "CarManageCtrl", 35],//????
        ["hospital_office_total_duty", "hospital_office/total_duty", "hospital_office/totalDuty.html", null, 4023],
        ["hospital_office_party_fee", "hospital_office/party_fee", "hospital_office/party_fee.html", null, 4024],
        // ["hospital_office_covid", "hospital_office/covid", "hospital_office/covid.html", null, 4025],
        ["hospital_office_dept_member", "hospital_office/dept_member", "hospital_office/deptMember.html", null, 4026],
        ["hospital_office_mission", "hospital_office/mission", "hospital_office/mission.html", null, 4027],

        ["party_meeting_topic", "meeting_topic/party", "meeting_topic/party.html", null, 4101],
        ["office_meeting_topic", "meeting_topic/office", "meeting_topic/office.html", null, 4102],
        ["share_meeting_topic", "meeting_topic/share", "meeting_topic/share.html", null, 4103],
        ["subject_meeting_topic", "meeting_topic/subject", "meeting_topic/subject.html", null, 4104],

        ["car_pending", "car_manage/pending", "car_manage/pending.html", "CarPendingCtrl", 3501],
        ["car_direct", "car_manage/direct", "car_manage/direct.html", "CarDirectCtrl", 3504],
        ["120_direct", "car_manage/120", "car_manage/120_direct.html", "CarDirectCtrl", 3506],
        ["car_record", "car_manage/record", "car_manage/record.html", "CarRecordCtrl", 3505],
        ["car_warranty", "car_manage/warranty", "car_manage/warranty.html", "CarWarrantyCtrl", 3502],
        ["car_scheduler", "car_manage/scheduler", "car_manage/scheduler.html", "CarSchedulerCtrl", 3503],
        ["cm_car_illegal", "car_manage/car_illegal", "car_manage/carIllegal.html", null, 3509],
        ["cm_pay_manage", "car_manage/car_pay_manage", "car_manage/payManage.html", null, 3512],
        ["cm_car_oil", "car_manage/car_oil", "car_manage/carOil.html", null, 3510, ['chart']],
        ["car_as_manage", "car_manage/as_manage", "car_manage/aSManage.html", null, 3508],
        ["car_handler", "car_manage/handler", "car_manage/handler.html", null, 3511],

        ["personnel_user_info", "personnel/user_info", "personnel/user_info.html", "UserInfoCtrl", 2000],
        ["personnel_dept_member", "personnel/dept_member", "personnel/dept_member.html", "DeptMemberCtrl", 2001],
        ["personnel_user_leave", "personnel/user_leave", "personnel/user_leave.html", null, 2002],
        ["personnel_user_reg", "personnel/user_reg", "personnel/user_reg.html", "UserRegCtrl", 2003],
        ["personnel_performance", "personnel/performance", "personnel/performance_manage.html", null, 2015],
        ["personnel_duty_fee_approval", "personnel/duty_fee_approval", "personnel/duty_fee_approval.html", "PersonnelDutyFeeApprovalCtrl", 2004],
        ["personnel_attendance", "personnel/attendance", "personnel/attendance.html", "PersonnelAttendanceCtrl", 2005],
        ["personnel_contact_group", "personnel/contact_group", "personnel/contact_group.html", "PersonnelContactGroupCtrl", 2010],
        ["personnel_leave_approval", "personnel/leave_approval", "personnel/leave_approval.html", "DeptLeaveApprovalCtrl", 2011],
        ["personnel_leave_makeup", "personnel/leave_makeup", "personnel/leave_makeup.html", "PersonnelLeaveMakeupCtrl", 2013],
        ["personnel_leave_recipient", "personnel/leave_recipient", "personnel/leave_recipient.html", null, 2012],
        ["personnel_wage", "personnel/wage", "personnel/wage.html", "PersonnelWageCtrl", 2020, ["ngHandsontable"]],
        ["personnel_round", "personnel/round", "personnel/round.html", "PersonnelRoundsCtrl", 2021],
        ["personnel_meal", "personnel/meal", "personnel/meal.html", "PersonnelMealCtrl", 2028],
        ["personnel_qualification", "personnel/qualification", "personnel/qualification.html", null, 2029],
        ["personnel_qa", "personnel/qa", "personnel/qualification_authority.html", null, 2030],
        ["personnel_retired_worker", "personnel/retired_worker", "personnel/retired_worker.html", null, 2031],
        ["personnel_overtime_report", "personnel/overtime_report", "personnel/overtimeReport.html", null, 2032],
        ["personnel_attendance_card", "personnel/attendance_card", "personnel/attendancePersonnel.html", null, 2033],
        ["personnel_trade_union", "personnel/trade_union", "personnel/tradeUnionPersonnel.html", null, 2034],
        ["personnel_fruit_research_query", "personnel/fruit_research_query", "personnel/fruit_research_query.html", null, 2037],
        ["personnel_fruit_teaching_query", "personnel/fruit_teaching_query", "personnel/fruit_teaching_query.html", null, 2038],
        ["personnel_fruit_medical", "personnel/fruit_medical", "personnel/fruit_medical.html", null, 2039],
        ["personnel_fruit_other", "personnel/fruit_other", "personnel/fruit_other.html", null, 2040],
        ["personnel_fruit_employee_record", "personnel/fruit_employee_record", "personnel/fruit_employee_record.html", null, 2041],
        ["personnel_temperature", "personnel/temperature", "personnel/temperature.html", null, 2042],
        // ["post_competition", "personnel/post_competition", "personnel/postCompetition.html", null, 2043, ['video']],
        ["personnel_task_setting", "personnel/task_setting", "sys/task_setting.html", null, 2044],
        // ["personnel_rs_manage", "personnel/rs_manage", "personnel/rsManage.html", null, 2035],

        ["finance_duty_fee_approval", "finance/duty_fee_approval", "finance/finance_fee_approval.html", "FinanceDutyFeeApprovalCtrl", 2304],
        ["finance_duty_paid_detail", "finance/duty_paid_detail", "finance/duty_paid_detail.html", "FinanceDutyPaidDetailCtrl", 2305],
        ["finance_copy_paper", "finance/copy_paper", "finance/cp.html", null, 2303],
        ["finance_cash_balance", "finance/cash_balance", "finance/cash_balance.html", "CashBalanceCtrl", 2307],
        ["finance_attendance", "finance/attendance", "finance/attendance.html", "FinanceAttendanceCtrl", 2306],
        ["finance_wage", "finance/wage", "finance/wage.html", "FinanceWageCtrl", 2320, ["ngHandsontable"]],
        ["finance_subsidy_paid", "finance/subsidy", "finance/subsidy_paid.html", "SubsidyPaidCtrl", 2309],
        ["finance_round_search", "finance/round", "finance/staff_query.html", "StaffQueryCtrl", 2310],
        ["finance_pending_airfare", "finance/pending_airfare", "finance/airfare.html", "FinanceAirfareCtrl", 2311],
        // ["finance_adverse", "finance/adverse", "finance/adverse.html", null, 2326],
        ["finance_party_fee", "finance/party_fee", "finance/party_fee.html", null, 2327],
        ["finance_csmb_invoice", "finance/csmb_invoice", "finance/csmb_invoice.html", null, 2328],
        ["finance_meal", "finance/meal", "finance/meal.html", null, 2329],
        ["finance_attendance_card", "finance/attendance_card", "finance/financeAttendance.html", null, 2330],
        ["finance_csmb_public", "finance/csmb_public", "finance/csmbPublic.html", null, 2331],

        ["insurance_office_discharge", "insurance/discharge", "insurance/discharge.html", null, 4601],
        ["insurance_office_import", "insurance/import", "insurance/import.html", null, 4602],

        ["medical_seniority", "medical/seniority", "medical/seniority.html", "SeniorityCtrl", 2115],
        ["medical_leave_approval", "medical/leave_approval", "medical/leave_approval.html", "DeptLeaveApprovalCtrl", 2100],
        ["medical_leave_recipient", "medical/leave_recipient", "medical/leave_recipient.html", null, 2105],
        ["medical_duty_fee_approval", "medical/duty_fee_approval", "medical/duty_fee_approval.html", "MedicalDutyFeeApprovalCtrl", 2104],
        ["medical_rule", "medical/rule", "medical/rule.html", "DeptRuleCtrl", 2106, ['pdf', 'video']],
        ["medical_special_patient", "medical/special_patient", "medical/special_patient.html", null, 2107],
        // ["medical_new", "medical/news", "medical/news.html", null, 2108],
        ["edu_law", "edu/law", "edu/law.html", "LawManageCtrl", 2813, ['pdf']],
        ["medical_staff", "medical/staff", "medical/staff.html", 'MedicalStaffCtrl', 2109],

        ["medical_acm", "medical/acm", "medical/acm.html", null, 2110],
        ["medical_seal", "medical/seal", "medical/seal.html", null, 2112],
        // ["medical_operation_consultation", "medical/operationConsultation", "medical/operationConsultation.html", null, 2113],
        ["medical_diagnosis", "medical/diagnosis", "mesStatistics/diagnosis.html", null, 2116],
        ["medical_temperature", "medical/temperature", "medical/temperature.html", null, 2117],
        ["medical_tech", "medical/tech", "medical/tech.html", null, 2118],
        // ["medical_team_leader", "medical/teamLeader", "medical/teamLeader.html", null, 2120],
        // ["medical_two_way_referral", "medical/two_way_referral", "medical/twoWayReferral.html", null, 2119],

        ["fd_performance_p_assign", "fd_performance/p_assign", "fd_performance/pAssign.html", null, 3801],
        ["fd_performance_expert_report", "fd_performance/expert_report", "fd_performance/expertReport.html", null, 3802],

        ["performance_office_indicator", "performance_office/indicator", "performance_office/indicator.html", null, 3901],
        ["performance_office_unit", "performance_office/unit", "performance_office/unit.html", null, 3902],
        ["performance_office_performance_report", "performance_office/performance_report", "performance_office/report.html", null, 3903],
        ["performance_office_consultation", "performance_office/consultation", "performance_office/consultation.html", null, 3904],
        ["performance_office_medical", "performance_office/medical", "performance_office/medical.html", null, 3905],
        ["performance_office_clinc", "performance_office/clinc", "performance_office/clinc.html", null, 3906],
        ["performance_office_expert_report", "performance_office/expert_report", "performance_office/expertReport.html", null, 3907],
        ["performance_office_csmb_public", "performance_office/csmb_public", "performance_office/csmbPublic.html", null, 3908],

        ["nursing_leave_approval", "nursing/leave_approval", "nursing/leave_approval.html", "DeptLeaveApprovalCtrl", 2200],
        ["nursing_leave_recipient", "nursing/leave_recipient", "nursing/leave_recipient.html", null, 2201],
        ["nursing_duty_fee_approval", "nursing/duty_fee_approval", "nursing/duty_fee_approval.html", "NursingDutyFeeApprovalCtrl", 2204],
        ["nursing_seniority", "nursing/seniority", "nursing/seniority.html", "NurseSeniorityCtrl", 2205],
        ["nursing_edu", "nursing/edu", "nursing/edu.html", null, 2211, ['pdf', 'video']],
        ["nursing_practice", "nursing/practice", "nursing/practice.html", null, 2212],
        ["nursing_round", "nursing/round", "nursing/round.html", "NurseRoundsCtrl", 2213],
        // ["nursing_new", "nursing/news", "nursing/news.html", null, 2214],
        ["nursing_leave_makeup", "nursing/leave_makeup", "nursing/leave_makeup.html", "NursingLeaveMakeupCtrl", 2215],
        ["nursing_attendance", "nursing/attendance", "nursing/attendance.html", "FinanceAttendanceCtrl", 2216],

        // ["nursing_bed_appt", "nursing/bed_appt", "nursing/bedAppt.html", null, 2217],
        // ["nursing_bed_manage", "nursing/bed_manage", "nursing/bedManage.html", null, 2218],
        // ["nursing_sys", "nursing/sys", "nursing/sys.html", null, 2219],
        ["nursing_seal", "nursing/seal", "nursing/seal.html", null, 2220],
        ["nursing_date_ss", "nursing/date_ss", "nursing/dateSs.html", null, 2221],
        ["nursing_consumable", "nursing/consumable", "nursing/consumable.html", null, 2223],
        ["nursing_total_duty", "nursing/nursing_total_duty", "nursing/nursingTotalDuty.html", null, 2224],
        ["nursing_temperature", "nursing/nursing_temperature", "nursing/temperature.html", null, 2225],
        ["nursing_appointment_draw_blood", "mes_sys/draw_blood", "mesSys/drawBlood.html", null, 2226],
        ["nursing_tech", "nursing/tech", "nursing/tech.html", null, 2227],
        ["nursing_his_sync", "nursing/his_sync", "nursing/his_sync.html", null, 2228],

        ["security_parking_lot", "security/parking_lot", "security/parking_lot.html", "ParkingLotCtrl", 6001],
        ["security_parking_rent", "security/parking_rent", "security/parking_rent.html", "ParkingRentCtrl", 6002],
        ["security_rush_park", "security/rush_park", "security/rush_park.html", null, 6003],
        ["security_cash", "security/cash", "security/cash.html", "SecurityCashCtrl", 6004],

        ["general_house_manage", "general/house_manage", "general/houseManage.html", null, 6101, ['qrCode']],
        ["general_house_rent", "general/house_rent", "general/house_rent.html", "HouseRentCtrl", 6102],
        ["general_wae_fee", "general/wae_fee", "general/wae_fee.html", "WaeFeeCtrl", 6103],
        ["general_copy_paper", "general/copy_paper", "general/cp.html", null, 6104],
        ["general_pms_room_patrol", "general/pms_room_patrol", "general/pmsRoomPatrol.html", null, 6105],
        ["general_pms_room_repair", "general/pms_room_repair", "general/pmsRoomRepair.html", null, 6106],
        ["general_meal", "general/meal", "general/meal.html", "WaeMealCtrl", 6128],
        ["general_cash", "general/cash", "general/cash.html", "GeneralCashCtrl", 6129],
        ["general_room", "general/room", "general/room.html", null, 6130],
        ["general_room_cost", "general/room_cost", "general/room_cost.html", null, 6131],
        ["general_inpatient_comment", "general/inpatient_comment", "general/inpatientComment.html", null, 6132],
        ["user_meal_comment", "user/meal_comment", "user/meal_comment.html", null, 6133],
        ["general_energy_consumption", "general/energy_consumption", "general/energyConsumption.html", null, 6134],
        ["general_problem_feedback", "general/problem_feedback", "general/problemFeedback.html", null, 6135],


        ["adverse_manage", "adverse/manage", "adverse/manage.html", null, 7601],
        ["adverse_statistic", "adverse/statistic", "adverse/statistic.html", null, 7602, ['chart']],
        ["adverse_check", "adverse/check", "adverse/check.html", null, 7603],
        ["adverse_handler", "adverse/handler", "adverse/handler.html", null, 7604],

        ["equipment_administrative_material", "equipment/administrative_material", "equipment/administrative_material.html", "AdministrativeMaterialCtrl", 2405],
        ["equipment_medical_material", "equipment/medical_material", "equipment/medical_material.html", "MedicalMaterialCtrl", 2406],
        ["equipment_or_material", "equipment/or_material", "equipment/or_material.html", "ORMaterialCtrl", 2407],
        ["equipment_cadre_material", "equipment/cadre_material", "equipment/cadre_material.html", "CADREMaterialCtrl", 2419],
        ["equipment_scrap", "equipment/scrap", "equipment/scrap.html", null, 2408],
        ["equipment_inventory", "equipment/inventory", "equipment/inventory.html", null, 2409],
        ["equipment_allocate", "equipment/allocate", "equipment/allocate.html", null, 2410],
        ["equipment_admin", "equipment/admin", "equipment/admin.html", null, 2411],
        ["equipment_manual", "equipment/manual", "equipment/manual.html", null, 2412, ['pdf']],
        ["equipment_consumable_manual", "equipment/consumable_manual", "equipment/consumable_manual.html", null, 2418, ['pdf']],
        ["equipment_vendor_q", "equipment/vendor_q", "vendor/vendor_q.html", null, 2413],
        ["equipment_csmb_price", "equipment/csmb_price", "equipment/csmb_price.html", null, 2414],
        ["equipment_csmb_invoice", "equipment/csmb_invoice", "equipment/csmb_invoice.html", null, 2415],
        ["equipment_csmb_public", "equipment/csmb_public", "equipment/csmbPublic.html", null, 2416],
        ["equipment_purchase", "equipment/purchase", "equipment/purchase.html", null, 2417],
        ["equipment_medical_representative", "equipment/medical_representative", "equipment/mr.html", null, 2421],
        ["equipment_bid_manage", "equipment/bid_manage", "equipment/bid_manage.html", null, 2422],

        ["hospital_equipment_repair", "hospital_equipment/repair", "hospital_equipment/repair.html", null, 19001],
        ["hospital_equipment_scrap", "hospital_equipment/scrap", "hospital_equipment/scrap.html", null, 19002],
        ["hospital_equipment_inventory", "hospital_equipment/inventory", "hospital_equipment/inventory.html", null, 19003],
        ["hospital_equipment_equipment", "hospital_equipment/equipment", "hospital_equipment/equipment.html", null, 19004],
        ["hospital_equipment_manage", "hospital_equipment/manage", "hospital_equipment/manage.html", null, 19005],

        ["supply_material", "supply/material", "supply/material.html", "SupplyMaterialCtrl", 2505],
        ["supply_disinfect", "supply/disinfect", "supply/disinfect.html", null, 2506],

        ["op_recipient", "or/op_recipient", "or/op_recipient.html", "OPRecipientCtrl", 2600],
        ["op_handle", "or/op_handle", "or/op_handle.html", "OPHandleCtrl", 2601],
        ["op_shifts", "or/op_shifts", "or/op_shifts.html", "OPShiftsCtrl", 2602],
        ["op_his_handle", "or/op_his_handle", "or/op_his_handle.html", null, 2603],
        ["op_workload", "or/op_workload", "or/op_workload.html", null, 2604],
        ["disinfection_registry", "or/disinfection_registry", "or/disinfection_registry.html", null, 2605],


        ["ir_recipient", "ir/recipient", "ir/recipient.html", null, 2700],
        ["ir_handle", "ir/handle", "ir/handle.html", null, 2701],
        ["ir_shifts", "ir/op_shifts", "ir/op_shifts.html", "IRShiftsCtrl", 2702],
        ["ir_his_handle", "ir/his_handle", "ir/his_handle.html", null, 2703],
        ["ir_date_ss", "ir/date_ss", "ir/dateSs.html", null, 2704],

        ["out_p_shifts", "out_p/p", "out_p/p_shifts.html", "OutPShiftsCtrl", 5101],
        ["out_p_recipient", "out_p/recipient", "out_p/recipient.html", null, 5102],
        ["out_p_handle", "out_p/handle", "out_p/handle.html", null, 5103],
        ["out_p_his_handle", "out_p/his_handle", "out_p/his_handle.html", null, 5104],

        ["edu_edu", "edu/edu", "edu/edu.html", null, 2811, ['pdf', 'video']],
        ["edu_practice", "edu/practice", "edu/practice.html", null, 2812],
        ["edu_research", "edu/research", "edu/research.html", null, 2814],
        ["edu_leave", "edu/leave", "edu/leave.html", "DeptLeaveApprovalCtrl", 2815],
        ["edu_paper", 'edu/paper', 'edu/paper.html', null, 2816],
        ["edu_scientific_research", 'edu/scientificResearch', 'edu/scientificResearch.html', null, 2817],
        ["edu_fruit_research", 'edu/fruit_research', 'edu/fruit_research.html', null, 2818],
        ["edu_fruit_teaching", 'edu/fruit_teaching', 'edu/fruit_teaching.html', null, 2819],

        ["lab_nad", "lab/nad", "lab/nad.html", null, 56001],
        ["lab_nad_result", "lab/nad_result", "lab/nadResult.html", null, 56002],
        ["lab_nad_mail", "lab/nad_mail", "lab/nadMail.html", null, 56004],
        ["lab_nad_refund", "lab/nad_refund", "lab/nadRefund.html", null, 56003],


        ["rm_research", "rm/research", "rm/research.html", null, 35001],
        ["rm_scientific_research", "rm/scientificResearch", "rm/scientificResearch.html", null, 35002],

        ["pcm_pcm", "pcm/pcm", "pcm/pcm.html", null, 6801],

        ["tibetan_language_manage", "tibetan_language/manage", "tibetan_language/manage.html", null, 6901],
        ["tibetan_language_type", "tibetan_language/type", "tibetan_language/type.html", null, 6902],
        ["tibetan_language_interpreter", "tibetan_language/interpreter", "tibetan_language/interpreter.html", null, 6903],

        ["edu_hospital", "edu/hospital", "edu/hospital.html", "EduPracticeCtrl", 3701],

        ["clinc_query", "clinc/query", "clinc/query.html", null, 7001, ['qrCode']],
        ["clinc_approval", "clinc/approval", "clinc/approval.html", null, 7002],
        ["clinc_fixed", "clinc/fixed", "clinc/fixed.html", null, 7004],
        ["clinc_temp", "clinc/temp", "clinc/temp.html", null, 7003],
        ["clinc_ap", "clinc/ap", "clinc/ap.html", null, 7005],
        ["patient_manage", "clinc/manage", "clinc/manage.html", null, 7006],
        ["black_list", "clinc/black_list", "black_list/black_list.html", null, 7007],
        ["clinc_analysis", "clinc/analysis", "clinc/analysis.html", null, 7008, ['chart']],
        ["clinc_schedule_change", "clinc/schedule_change", "clinc/schedule_change.html", null, 7009],
        ["clinc_nursing_manage", "clinc/nursing_manage", "nursing/manage.html", null, 7010],
        ["clinc_appointment_detail", "clinc/appointment_detail", "clinc/detail.html", null, 7011],
        ["clinc_fee_per", "clinc/fee_per", "clinc/fee.html", null, 7012],
        ["clinc_monitor", "clinc/monitor", "clinc/monitor.html", null, 7013, ['chart']],
        ["clinc_manage_screen", "clinc/screen", "clinc/screen.html", null, 7014],
        ["clinc_exam", "clinc/exam", "clinc/exam.html", null, 7015],
        ["clinc_patient_source", "clinc/patient_source", "clinc/patientSource.html", null, 7016],
        ["his_clinic_approval", "clinic/his_clinic_approval", "clinic/his_clinic_approval.html", null, 7017],
        ["clinc_pre_diagnosis", "clinc/pre_diagnosis", "clinc/preDiagnosis.html", null, 7018],

        ["clinc_nursing_disease", "clinc/nursing_disease", "nursing/disease.html", null, 30001],
        ["clinc_nursing_cancel", "clinc/cancel", "nursing/cancel.html", null, 30002],
        ["clinc_nursing_chronic_disease", "clinc/chronic_disease", "nursing/chronic_disease.html", null, 30003],
        // ["clinc_nursing_disease_plan", "clinc/disease_plan", "nursing/basic.html", null, 30004],
        ["clinc_nursing_disease_follow_up", "clinc/disease_follow_up", "nursing/follow_up.html", null, 30005],

        ["emergency_reg", "emergency/emergency", "emergency/emergency.html", null, 34001],
        ["emergency_internal", "emergency/internal", "emergency/internal.html", null, 34002],
        ["emergency_surgery", "emergency/surgery", "emergency/surgery.html", null, 34003],

        // ["ap_manage_ap", "manage/ap", "manage/ap.html", null, 7101],
        ["ap_manage_scene", "manage/scene", "manage/scene.html", null, 7102],
        // ["ap_manage_op_consultation_payment", "manage/opConsultationPayment", "manage/opConsultationPayment.html", null, 7103],
        // ["ap_manage_pay", "manage/pay", "manage/pay.html", null, 7103],
        // ["ap_manage_phone", "manage/phone", "manage/phone.html", null, 7104],
        ["ap_manage_emergency", "manage/emergency", "manage/emergency.html", null, 7105],
        ["ap_manage_person", "manage/person", "manage/person.html", null, 7106],
        ["ap_manage_refund", "manage/refund", "manage/refund.html", null, 7107],
        ["ap_manage_all", "manage/all", "manage/all.html", null, 7108],
        ["ap_manage_refund_approval", "manage/refund_approval", "manage/refund_approval.html", null, 7109],
        ["ap_manage_ap", "manage/ap", "manage/ap.html", null, 7110],
        // ["ap_manage_charge", "clinc/charge", "clinc/charge.html", null, 7111],
        ["ap_manage_warning", "clinc/warning", "clinc/warning.html", null, 7112],
        // ["ap_manage_guide", "ap_manage/guide", "ap_manage/guide.html", null, 7113],
        ["ap_manage_patient", "ap_manage/manage", "clinc/manage.html", null, 7114],

        ["doctor_appointment", "doctor/appointment", "doctor/appointment.html", null, 7201],
        ["doctor_search", "doctor/search", "doctor/search.html", null, 7202],
        ["doctor_queue", "doctor/queue", "doctor/queue.html", null, 7203],
        ["doctor_assist", "doctor/assist", "doctor/assist.html", null, 7204],
        ["doctor_stop_replace", "doctor/stop_replace", "doctor/stop_replace.html", null, 7205],

        ["ap_bill_cash", "bill/cash", "bill/cash.html", null, 7301],
        ["ap_bill_cash_wx", "bill/cash_wx", "bill/cash_wx.html", null, 7302],

        ["store_spot", "store/spot", "store/spot.html", null, 8001],
        ["store_delivery", "store/delivery", "store/delivery.html", "StoreDeliveryCtrl", 8002],
        ["store_wm", "store/wm", "store/wm.html", "StoreWmCtrl", 8003],
        ["store_sf", "store/sf", "store/sf.html", null, 8006],
        ["store_goods", "store/goods", "store/goods.html", "GoodsCtrl", 8004],
        ["store_ph_search", "store/ph_search", "store/ph_search.html", "StorePhSearchCtrl", 8005],
        ["store_dept", "store/dept", "store/dept.html", null, 8007],
        ["store_steamed_bread", "store/steamed_bread", "store/steamed.html", null, 8008],


        ["store_ph", "store/ph", "store/ph.html", "StorePhCtrl", 8101],
        // ["store_patient_ph", "store/patientPh", "store/patientPh.html", null, 8102],

        // ["repair_confirm", "repair/confirm", "repair/confirm.html", null, 18001],

        ["hga_catalog", "hga/catalog", "hga/catalog.html", null, 20001],
        ["hga_list", "hga/list", "hga/list.html", null, 20002],
        ["hga_self", "hga/self", "hga/self.html", null, 20003],
        ["hga_monitor", "hga/monitor", "hga/monitor.html", null, 20004],

        ["hga_manage", "hga_admin/manage", "hga_admin/manage.html", null, 21001],

        ["mi_manage_record", "mi_manage/record", "mi_manage/record.html", null, 22001],
        ["mi_manage_confirm", "mi_manage/confirm", "mi_manage/confirm.html", null, 22002],

        ["fd_patient", "family_doctor/patient", "family_doctor/patient.html", null, 23001],
        ["fd_project", "family_doctor/project", "family_doctor/project.html", null, 23002],
        ["fd_clinc", "family_doctor/clinc", "family_doctor/clinc.html", null, 23003],
        ["fd_net", "family_doctor/net", "family_doctor/net.html", null, 23007],
        ["family_group_community", "family_doctor/group_community", "family_doctor/group_community.html", null, 23004],
        ["family_group_special", "family_doctor/group_special", "family_doctor/group_special.html", null, 23005],
        ["family_group_family_doctor", "family_doctor/group_family_doctor", "family_doctor/group_family_doctor.html", null, 23006],

        ["cash_prepaid_advance", "cash_prepaid/advance", "cash_prepaid/advance.html", null, 26001],
        ["cash_prepaid_records", "cash_prepaid/records", "cash_prepaid/records.html", null, 26003],

        ["fdm_project", "fdm/project", "family_doctor_manage/project.html", null, 24001],
        ["fdm_package", "fdm/package", "family_doctor_manage/package.html", null, 24002],
        ["fdm_doctor_manage", "fdm/doctor_manage", "family_doctor_manage/doctor.html", null, 24003],
        ["fdm_fd_manage", "fdm/fd_manage", "family_doctor_manage/fd_manage.html", null, 24004],

        ["bd_patient", "beauty_doctor/patient", "beauty_doctor/patient.html", null, 24101],
        ["bd_project", "beauty_doctor/project", "beauty_doctor/project.html", null, 24102],

        ["bdm_project", "bdm/project", "beauty_doctor_manage/project.html", null, 24201],
        ["bdm_package", "bdm/package", "beauty_doctor_manage/package.html", null, 24202],
        ["bdm_doctor_manage", "bdm/doctor_manage", "beauty_doctor_manage/doctor.html", null, 24203],
        ["bdm_basic", "bdm/basic", "beauty_doctor_manage/basic.html", null, 24204],

        ["special_clinic_patient", "special_clinic/contract", "specialClinic/contract.html", null, 39001],
        ["special_clinic_schedule", "special_clinic/schedule", "specialClinic/schedule.html", null, 39002],
        ["special_clinic_order", "special_clinic/order", "specialClinic/order.html", null, 39003],
        ["special_clinic_basic", "special_clinic/basic", "specialClinic/basic.html", null, 39004],
        // ["special_clinic_confirm", "special_clinic/confirm", "specialClinic/confirm.html", null, 39005],

        //["distribution_task", "consumable/distribution_task", "distribution/task.html", null, 9101],
        ["distribution_distributor", "consumable/distribution_distributor", "distribution/distributor.html", null, 9102],

        ["vendor_profile", "vendor/profile", "vendor/profile.html", null, 11001],
        ["vendor_qualification", "vendor/qualification", "vendor/qualification.html", null, 11002],
        ["vendor_rename", "vendor/rename", "vendor/rename.html", null, 11003],
        ["vendor_qualification_query", "vendor/qualificationQuery", "vendor/qualificationQuery.html", null, 11004],

        ["storeroom_query", "storeroom/query", "storeroom/query.html", null, 12001],
        ["storeroom_inventory", "storeroom/inventory", "storeroom/inventory.html", null, 12002],
        ["storeroom_purchase", "storeroom/purchase", "storeroom/purchase.html", null, 12003, ['qrCode']],
        ["storeroom_in", "storeroom/in", "storeroom/in.html", null, 12005],
        ["storeroom_out", "storeroom/out", "storeroom/out.html", null, 12006],
        ["storeroom_remind", "storeroom/remind", "storeroom/remind.html", null, 12007],
        ["storeroom_return", "storeroom/return", "storeroom/return.html", null, 12008],
        //["storeroom_straight", "storeroom/straight", "storeroom/straight.html", null, 12009],
        //["storeroom_allocate", "storeroom/allocate", "storeroom/allocate.html", null, 12010, ['qrCode']],
        ["storeroom_dept", "storeroom/dept", "storeroom/dept.html", null, 12004, ['qrCode']],
        ["storeroom_dept_direct", "storeroom/dept_direct", "storeroom/dept_direct.html", null, 12013, ['qrCode']],
        ["storeroom_dept_return", "storeroom/dept_return", "storeroom/dept_return.html", null, 12011],
        ["storeroom_dept_use", "storeroom/dept_use", "storeroom/dept_use.html", null, 12012],

        ["dr_medical_info", "dr/medical_info", "dr/medical_info.html", "DRMedicalInfoCtrl", 2902],
        ["dr_car_direct", "dr/car_direct", "car_manage/120_direct.html", "120DirectCtrl", 2904],  //最好不要数字开头
        ["dr_nursing_duty", "dr/nursing_duty", "nursing/allDuty.html", null, 2905],


        ["blood_storage", "blood_bank/blood_storage", "blood_bank/blood_storage.html", "BloodStorageCtrl", 5201],

        ["consumable_category", "consumable/category", "consumable/category.html", null, 13001],
        ["csmb_qualification_application", "consumable/qualification", "consumable/qualification.html", null, 13002],
        ["csmb_two_remind", "consumable/two_remind", "consumable/twoRemind.html", null, 13003],

        ["pc_stock", "pc/stock", "<ui-view></ui-view>", null, 14000, null, [
            ['rooms', 'rooms', 'pc/stock/rooms.html'],
            ['room_stock', 'rooms/:id', 'pc/stock/room_stock.html']
        ]],
        ["pc_remind", "pc/remind", "<ui-view></ui-view>", null, 14002, null, [
            ['rooms', 'rooms', 'pc/remind/rooms.html'],
            ['consumables', 'rooms/:id', 'pc/remind/consumables_remind.html']
        ]],
        ["pc_purchase", "pc/purchase", "pc/purchase.html", null, 14001],
        ["pc_csmb_price", "pc/csmb_price", "pc/csmb_price.html", null, 14004],
        //["pc_allocate", "pc/allocate", "pc/allocate.html", null, 14003],
        ["pc_csmb_in", "pc/csmb_in", "pc/csmb_in.html", null, 14005],
        ["pc_csmb_io", "pc/csmb_io", "pc/csmb_io.html", null, 14006],

        ["mi_csmb_manage", "mi/csmb_manage", "mi/csmb_manage.html", null, 17001],
        ["mi_clinc_special", "mi/clinc_special", "mi/clinc_special.html", null, 17002],
        ["mi_price_control", "mi/price_control", "mi/price_control.html", null, 17003],


        ["cadre_health_vi1000p", "cadre_health/vip", "cadre_health/vip.html", null, 29001],

        ["tu_user", "tu/user", "tu/user.html", null, 7801],
        ["tu_festival_award", "tu/festival_award", "tu/festivalAward.html", null, 7802],
        ["tu_interesting_group", "tu/interesting_group", "tu/interestingGroup.html", null, 7803],
        ["tu_activity", "tu/activity", "tu/activity.html", null, 7804],

        ["exam_manage", "exam/manage", "exam/manage.html", null, 7901],
        ["exam_package", "exam/package", "exam/package.html", null, 7902],
        ["exam_refund", "exam/refund", "exam/refund.html", "ExamRefundCtrl", 7903],

        ["eqs_doctor", "eqs/doctor", "eqs/doctorConsole.html", null, 8701],
        ["eqs_queue", "eqs/queue", "eqs/queue.html", null, 8702],
        ["eqs_schedule", "eqs/schedule", "eqs/schedule.html", null, 8703],
        ["eqs_sys", "eqs/sys", "eqs/sys.html", null, 8704],

        ["mes_appt_me", "mes_appt/me", "mesAppt/me.html", null, 8301, ['qrCode']],
        ["mes_appt_me_deposit", "mes_appt/me_deposit", "mesAppt/deposit.html", null, 8302],
        ["mes_appt_me_pending_payment", "mes_appt/me_pending_payment", "mesAppt/pendingPayment.html", null, 8308],
        ["mes_appt_me_follow_up", "mes_appt/follow_up", "mesAppt/followUp.html", null, 8309],
        ["mes_appt_me_group_fee", "mes_appt/group_fee", "mesAppt/groupFee.html", null, 8310],

        ["mes_appt_me_schedule", "mes_appt/me_schedule", "mesAppt/schedule/me.html", null, 8305],
        ["mes_appt_in", "mes_appt/in", "mesAppt/in.html", null, 8303],
        ["mes_appt_in_schedule", "mes_appt/in_schedule", "mesAppt/schedule/in.html", null, 8306],
        ["mes_appt_out", "mes_appt/out", "mesAppt/out.html", null, 8304],
        ["mes_appt_out_schedule", "mes_appt/out_schedule", "mesAppt/schedule/out.html", null, 8307],

        ["mes_me_doctor", "mes_me/doctor", "mesExam/doctorConsole.html", null, 8401],
        ["mes_me_search", "mes_me/search", "mesExam/search.html", null, 8403],
        ["mes_me_app_details", "mes_me/app_details", "mesExam/appDetails.html", null, 8404],
        ["mes_me_control", "mes_me/general", "mesExam/generalConsole.html", null, 8405],
        ["mes_me_queue", "mes_me/queue", "mesExam/queue.html", null, 8402, ['qrCode']],

        ["mes_after_mail", "mes_after/mail", "mesAfter/mail.html", null, 8601],
        ["mes_after_result", "mes_after/result", "mesAfter/result.html", null, 8602],
        ["mes_after_emergency", "mes_after/emergency", "mesAfter/emergency.html", null, 8603],
        ["mes_after_suggestion", "mes_after/suggestion", "mesAfter/suggestion.html", null, 8604],
        ["mes_after_report", "mes_after/report", "mesAfter/report.html", null, 8605],
        ["mes_after_print", "mes_after/print", "mesAfter/print.html", null, 8606],
        ["mes_after_disease", "mes_after/disease", "mesAfter/disease.html", null, 8607],
        ["mes_after_reception", "mes_after/reception", "mesAfter/reception.html", null, 8608],
        ["mes_after_tibet_reception", "mes_after/tibet_reception", "mesAfter/tibetReception.html", null, 8615],
        ["mes_after_sta", "mes_after/sta", "mesAfter/sta.html", null, 8609],
        ["mes_after_report_seek", "mes_after/report_seek", "mesAfter/reportSeek.html", null, 8610],
        ["mes_after_order_opinion", "mes_after/order_opinion", "mesAfter/orderOpinion.html", null, 8611],
        ["mes_after_hepatitis_b", "mes_after/hepatitis_b", "mesAfter/hepatitisB.html", null, 8612],
        ["mes_after_report_edit", "mes_after/report_edit", "mesAfter/reportEdit.html", null, 8613],
        ["mes_after_patient_print", "mes_after/patient_print", "mesAfter/patientPrint.html", null, 8614],
        ["mes_after_return_visit_record", "mes_after/return_visit_record", "mesAfter/returnVisitRecord.html", null, 8616],

        ["mes_sys_basic", "mes_sys/basic", "mesSys/basic.html", null, 8501],
        ["mes_sys_unit", "mes_sys/unit", "mesSys/unit.html", null, 8502],
        ["mes_sys_item", "mes_sys/item", "mesSys/item.html", null, 8503],
        ["mes_sys_combination_item", "mes_sys/combination_item", "mesSys/combinationItem.html", null, 8504],
        ["mes_sys_exclusive", "mes_sys/exclusive", "mesSys/exclusive.html", null, 8506],
        ["mes_sys_package", "mes_sys/package", "mesSys/package.html", null, 8505],
        ["mes_sys_group", "mes_sys/group", "mesSys/group.html", null, 8507],
        ["mes_me_form", "mes_me/form", "mesExam/form.html", null, 8508],
        ["mes_sys_status", "mesSys/status", "mesSys/status.html", null, 8509],
        ["mes_sys_cm_media", "mesSys/cm_media", "mesSys/cmMedia.html", null, 8510, ['video']],
        ["mes_sys_tibet_nemt", "mesSys/tibet_nemt", "sys/tibetNemt.html", null, 8511],
        ["mes_mes_patient_manage", "mes_patient/manage", "clinc/manage.html", null, 8512],

        ["tm_csmb_public", "tm/csmb_public", "tm/csmbPublic.html", null, 8801],
        ["tm_adverse", "tm/adverse", "tm/adverse.html", null, 8802],
        ["tm_duty_fee_approval", "tm/duty_fee_approval", "tm/tm_fee_approval.html", "TMDutyFeeApprovalCtrl", 8803],
        ["tm_duty_paid_detail", "tm/duty_paid_detail", "tm/duty_paid_detail.html", "TMDutyPaidDetailCtrl", 8804],
        ["tm_attendance", "tm/attendance", "tm/attendance.html", "TMAttendanceCtrl", 8805],
        ["tm_wage", "tm/wage", "tm/wage.html", "TMWageCtrl", 8806, ["ngHandsontable"]],
        // ["tm_operation_consultation", "tm/operationConsultation", "tm/operationConsultation.html", null, 8807],
        ["tm_kpi", "tm/kpi", "tm/kpi.html", null, 8808],
        ["tm_cbft", "tm/cbft", "tm/cbft_manage.html", null, 8809],

        ["cj_meal", "cj/meal", "cj/meal.html", "CjMealCtrl", 8901],
        ["cj_temperature", "cj/temperature", "cj/temperature.html", null, 8902],

        ["mes_statistics_workload", 'mes_statistics/workload', 'mesStatistics/workload.html', null, 41001],
        ["mes_statistics_workload_up", "mes_statistics/workload_up", "mesStatistics/workload_up.html", null, 41002],
        ["mes_statistics_diagnosis", "mes_statistics/diagnosis", "mesStatistics/diagnosis.html", null, 41003],
        ["mes_statistics_time", "mes_statistics/time", "mesStatistics/time.html", null, 41004],
        ["mes_statistics_breakfast", "mes_statistics/breakfast", "mesStatistics/breakfast.html", null, 41005],

        ["recovery_basic", "recovery/basic", "recovery/basic.html", null, 9301],
        ["recovery_appointment", "recovery/appointment", "recovery/appointment.html", null, 9302],
        ["recovery_exam", "recovery/exam", "recovery/exam.html", null, 9303],
        ["recovery_sta", "recovery/sta", "recovery/sta.html", null, 9304],
        ["recovery_after", "recovery/after", "recovery/after.html", null, 9305],

        ["ua_hospital", "ua/hospital", "ua/hospital.html", null, 9401],
        ["ua_dept", "ua/dept", "ua/dept.html", null, 9402],


        ["test", "sys/test", "sys/test/index.html", null, 9991],
        ["sys_basic", "sys/basic", "sys/basic.html", null, 9000],
        ["sys_sign", "sys/sign", "sys/sign.html", "SignCtrl", 9010],
        ["sys_dept", "sys/dept", "sys/dept.html", null, 9003],
        ["sys_car", "sys/car", "sys/car.html", null, 9004],
        ["sys_duty_group", "sys/duty_group", "sys/duty_group.html", "DutyGroupCtrl", 9005],
        ["sys_leave_manage", "sys/leave_manage", "sys/leave_manage.html", "LeaveManageCtrl", 9006],
        ["sys_wage", "sys/wage", "sys/wage.html", "WageCtrl", 9008],
        ["sys_meal", "sys/meal", "sys/meal.html", "MealCtrl", 9018],
        ["sys_meeting", "sys/meeting", "sys/meeting.html", "MeetingCtrl", 9009],
        ["sys_qualification", "sys/qualification", "sys/qualification.html", null, 9012],
        ["sys_material_manage", "sys/material", "sys/material.html", "MaterialManageCtrl", 9013],
        ["sys_mi_manage", "sys/mi_manage", "sys/mi_manage.html", null, 9014],
        ["sys_at_manage", "sys/at_manage", "sys/at_manage.html", null, 9015],
        ["sys_adverse", "sys/adverse", "sys/adverse.html", null, 9026],
        ["sys_supervise_code", "sys/supervise_code", "sys/supervise_code.html", null, 9027],
        ["sys_patientMeal", "sys/patientMeal", "sys/patientMeal.html", null, 9028],
        ["sys_trade_union", "sys/trade_union", "sys/tradeUnion.html", null, 9029],
        ["sys_money_refuse", "sys/money_refuse", "sys/moneyRefuse.html", null, 9030],
        ["sys_ff_manage", "sys/ff_manage", "sys/ffManage.html", null, 9035],
        ["sys_exam", "sys/exam", "sys/exam.html", null, 9992],
        ["sys_dh_his", "sys/dh_his", "sys/dh_his.html", null, 9993],
        ["sys_dh_his_basic", "sys/dh_his_basic", "sys/dh_his_basic.html", null, 9994],

        ["storePatient_manage", "storePatient/manage", "storePatient/manage.html", null, 36001],
        ["storePatient_spot", "storePatient/spot", "storePatient/spot.html", null, 36002],
        // ["storePatient_clinc", "storePatient/clinc", "storePatient/clinc.html", null, 36003],
        ["storePatient_select", "storePatient/select", "storePatient/select.html", null, 36004],
        ["storePatient_inpatient", "storePatient/inpatient", "storePatient/inpatient.html", null, 36005],
        ["storePatient_recharge", "storePatient/recharge", "storePatient/recharge.html", null, 36006],
        ["storePatient_general_manage", "storePatient/general_manage", "storePatient/generalManage.html", null, 36007],

        ["ff_clinc_patient", "ffClinc/patient", "ffClinc/patient.html", null, 36101],
        //
        ["rd_admission", "rd/admission", "residentDoctor/admission.html", null, 37101],
        ["rd_record", "rd/record", "residentDoctor/record.html", null, 37102],
        ["rd_discharge", "rd/discharge", "residentDoctor/discharge.html", null, 37103],

        ["inpatient_nurse_appointment", "inpatient_nurse/manage", "inpatient_nurse/manage.html", null, 8201],
        ["rn_bed_app", "rn/bed_appt", "residentNurse/bedAppt.html", null, 8202],
        ["rn_bed_manage", "rn/bed_manage", "residentNurse/bedManage.html", null, 8203],
        ["rn_record", "rn/record", "residentNurse/record.html", null, 8204],
        ["rn_cancel", "rn/cancel", "residentNurse/cancel.html", null, 8205],

        // ["inoutHospital_balance", "inoutHospital/balance", "inoutHospital/balance.html", null, 37001],
        // ["inoutHospital_recharge", "inoutHospital/recharge", "inoutHospital/recharge.html", null, 37002],
        // ["inoutHospital_wechat", "inoutHospital/wechat", "inoutHospital/wechat.html", null, 37003],
        ["inoutHospital_manage", "inoutHospital/manage", "inoutHospital/manage.html", null, 37004],
        ["inoutHospital_schedule", "inoutHospital/schedule", "inoutHospital/schedule.html", null, 37005],
        ["inoutHospital_admission", "inoutHospital/admission", "inoutHospital/admission.html", null, 37006],
        ["inoutHospital_discharge", "inoutHospital/discharge", "inoutHospital/discharge.html", null, 37007],

        ["chargeManage_finance", "chargeManage/finance", "chargeManage/finance.html", null, 38001],
        ["chargeManage_recharge", "chargeManage/recharge", "chargeManage/recharge.html", null, 38002],

        ["discount_activity_manage", "manage/discountActivity", "manage/discountActivity.html", null, 39101],
        ["discount_activity_search", "search/discountActivity", "search/discountActivity.html", null, 39102],
        ["discount_activity_coupon", "coop/coupon", "coop/coupon.html", null, 39104],
        // ["discount_activity_vacation", "vacation/activityVacation", "vacation/activityVacation.html", null, 39103],
        ["party_management", 'party/management', "party/management.html", null, 4202],
        ["party_work", "party/work", "party/work.html", null, 4203],
        ['party_fee', 'party/fee', 'party/fee.html', null, 4204, ['qrCode']],
        ['party_study', 'party/study', 'party/study.html', null, 4205, ['pdf', 'video']],
        ['party_member_upload', 'party/member_upload', 'party/member_upload.html', null, 4206],
        ['party_fee_manage', 'party/fee_manage', 'party/fee_manage.html', null, 4207],
        ['party_work_upload', 'party/work_upload', 'party/workUpload.html', null, 4208],

        ['paper_outcome', 'user/outcome', 'user/outcome.html', null, 4301],
        ['self_fruit_research', 'self_fruit/research', 'self_fruit/research.html', null, 4701],
        ['self_fruit_teaching', 'self_fruit/teaching', 'self_fruit/teaching.html', null, 4702],
        ['self_fruit_medical', 'self_fruit/medical', 'self_fruit/medical.html', null, 4703],
        ['self_fruit_other', 'self_fruit/other', 'self_fruit/other.html', null, 4704],
        ['self_fruit_employee_record', 'self_fruit/employee_record', 'self_fruit/employee_record.html', null, 4705],


        ['infect_manage', 'infect_manage/temperature', 'infect_manage/temperature.html', null, 4401],
        ['infect_manage_spot_check', 'infect_manage/spot_check', 'infect_manage/spot_check.html', null, 4402],
        ["infect_manage_diagnosis", "infect_manage/diagnosis", "mesStatistics/diagnosis.html", null, 4403],
        ["infect_manage_health_code", "infect_manage/health_code", "infect_manage/health_code.html", null, 4404],

        ['work_order_service', 'work_order/service', 'work_order/service.html', null, 4501],
        ['work_order_manage', 'work_order/manage', 'work_order/manage.html', null, 4502],
        // ['work_order_allocate', 'work_order/allocate', 'work_order/allocate.html', null, 4503],

        ['hospital_video_manage', 'hospital_video/manage', 'hospitalVideo/manage.html', null, 9501, ['qrCode', 'video']],

        ["restaurant_manage_commodity", "manage/commodity", "manage/commodity.html", null, 42001],
        // ["restaurant_manage_room", "manage/room", "manage/room.html", null, 42002],
        ["restaurant_manage_order", "manage/order", "manage/order.html", null, 42003],
        // ["restaurant_manage_package", "manage/package", "manage/package.html", null, 42004],

        ["elderly_care_question", "question/answer", "question/answer.html", null, 43001],

        ["cabin_reg", "cabin/reg", "cabin/reg.html", null, 9601],
        ["cabin_in", "cabin/in", "cabin/in.html", null, 9602],
        ["cabin_in_out", "cabin/in_out", "cabin/inOut.html", null, 9603],
        ["cabin_out", "cabin/out", "cabin/out.html", null, 9604],
        ["cabin_bed", "cabin/bed", "cabin/bed.html", null, 9605],
        ["cabin_volunteer", "cabin/volunteer", "cabin/volunteer.html", null, 9606],
        ["cabin_duty_record", "cabin/duty_record", "cabin/dutyRecord.html", null, 9607],

        ["cabin_six_reg", "cabin_six/reg", "cabinSix/reg.html", null, 9701],
        ["cabin_six_in", "cabin_six/in", "cabinSix/in.html", null, 9702],
        ["cabin_six_in_out", "cabin_six/in_out", "cabinSix/inOut.html", null, 9703],
        ["cabin_six_out", "cabin_six/out", "cabinSix/out.html", null, 9704],
        ["cabin_six_bed", "cabin_six/bed", "cabinSix/bed.html", null, 9705],
        ["cabin_six_volunteer", "cabin_six/volunteer", "cabinSix/volunteer.html", null, 9706],
        ["cabin_six_duty_record", "cabin_six/duty_record", "cabinSix/dutyRecord.html", null, 9707],

        ["cabin_seven_reg", "cabin_seven/reg", "cabinSeven/reg.html", null, 9801],
        ["cabin_seven_in", "cabin_seven/in", "cabinSeven/in.html", null, 9802],
        ["cabin_seven_in_out", "cabin_seven/in_out", "cabinSeven/inOut.html", null, 9803],
        ["cabin_seven_out", "cabin_seven/out", "cabinSeven/out.html", null, 9804],
        ["cabin_seven_bed", "cabin_seven/bed", "cabinSeven/bed.html", null, 9805],
        ["cabin_seven_volunteer", "cabin_seven/volunteer", "cabinSeven/volunteer.html", null, 9806],
        ["cabin_seven_duty_record", "cabin_seven/duty_record", "cabinSeven/dutyRecord.html", null, 9807],

        ["cabin_eight_reg", "cabin_eight/reg", "cabinEight/reg.html", null, 9901],
        ["cabin_eight_in", "cabin_eight/in", "cabinEight/in.html", null, 9902],
        ["cabin_eight_in_out", "cabin_eight/in_out", "cabinEight/inOut.html", null, 9903],
        ["cabin_eight_out", "cabin_eight/out", "cabinEight/out.html", null, 9904],
        ["cabin_eight_bed", "cabin_eight/bed", "cabinEight/bed.html", null, 9905],
        ["cabin_eight_volunteer", "cabin_eight/volunteer", "cabinEight/volunteer.html", null, 9906],
        ["cabin_eight_duty_record", "cabin_eight/duty_record", "cabinEight/dutyRecord.html", null, 9907],

        ["cabin_nine_reg", "cabin_nine/reg", "cabinNine/reg.html", null, 10101],
        ["cabin_nine_in", "cabin_nine/in", "cabinNine/in.html", null, 10102],
        ["cabin_nine_in_out", "cabin_nine/in_out", "cabinNine/inOut.html", null, 10103],
        ["cabin_nine_out", "cabin_nine/out", "cabinNine/out.html", null, 10104],
        ["cabin_nine_bed", "cabin_nine/bed", "cabinNine/bed.html", null, 10105],
        ["cabin_nine_volunteer", "cabin_nine/volunteer", "cabinNine/volunteer.html", null, 10106],
        ["cabin_nine_duty_record", "cabin_nine/duty_record", "cabinNine/dutyRecord.html", null, 10107],

        ["cabin_five_reg", "cabin_five/reg", "cabinFive/reg.html", null, 10401],
        ["cabin_five_in", "cabin_five/in", "cabinFive/in.html", null, 10402],
        ["cabin_five_in_out", "cabin_five/in_out", "cabinFive/inOut.html", null, 10403],
        ["cabin_five_out", "cabin_five/out", "cabinFive/out.html", null, 10404],
        ["cabin_five_bed", "cabin_five/bed", "cabinFive/bed.html", null, 10405],
        ["cabin_five_volunteer", "cabin_five/volunteer", "cabinFive/volunteer.html", null, 10406],
        ["cabin_five_duty_record", "cabin_five/duty_record", "cabinFive/dutyRecord.html", null, 10407],

        ["cabin_all_sta", "cabin_all/sta", "cabinAll/sta.html", null, 10501],

        ["cabin1_reg", "cabin1/reg", "cabin1/reg.html", null, 10601],
        ["cabin1_in", "cabin1/in", "cabin1/in.html", null, 10602],
        ["cabin1_in_out", "cabin1/in_out", "cabin1/inOut.html", null, 10603],
        ["cabin1_out", "cabin1/out", "cabin1/out.html", null, 10604],
        ["cabin1_bed", "cabin1/bed", "cabin1/bed.html", null, 10605],
        ["cabin1_volunteer", "cabin1/volunteer", "cabin1/volunteer.html", null, 10606],
        ["cabin1_duty_record", "cabin1/duty_record", "cabin1/dutyRecord.html", null, 10607],

        ["cabin2_reg", "cabin2/reg", "cabin2/reg.html", null, 10701],
        ["cabin2_in", "cabin2/in", "cabin2/in.html", null, 10702],
        ["cabin2_in_out", "cabin2/in_out", "cabin2/inOut.html", null, 10703],
        ["cabin2_out", "cabin2/out", "cabin2/out.html", null, 10704],
        ["cabin2_bed", "cabin2/bed", "cabin2/bed.html", null, 10705],
        ["cabin2_volunteer", "cabin2/volunteer", "cabin2/volunteer.html", null, 10706],
        ["cabin2_duty_record", "cabin2/duty_record", "cabin2/dutyRecord.html", null, 10707],

        ["cabin3_reg", "cabin3/reg", "cabin3/reg.html", null, 10801],
        ["cabin3_in", "cabin3/in", "cabin3/in.html", null, 10802],
        ["cabin3_in_out", "cabin3/in_out", "cabin3/inOut.html", null, 10803],
        ["cabin3_out", "cabin3/out", "cabin3/out.html", null, 10804],
        ["cabin3_bed", "cabin3/bed", "cabin3/bed.html", null, 10805],
        ["cabin3_volunteer", "cabin3/volunteer", "cabin3/volunteer.html", null, 10806],
        ["cabin3_duty_record", "cabin3/duty_record", "cabin3/dutyRecord.html", null, 10807],

        ["cabin4_reg", "cabin4/reg", "cabin4/reg.html", null, 10901],
        ["cabin4_in", "cabin4/in", "cabin4/in.html", null, 10902],
        ["cabin4_in_out", "cabin4/in_out", "cabin4/inOut.html", null, 10903],
        ["cabin4_out", "cabin4/out", "cabin4/out.html", null, 10904],
        ["cabin4_bed", "cabin4/bed", "cabin4/bed.html", null, 10905],
        ["cabin4_volunteer", "cabin4/volunteer", "cabin4/volunteer.html", null, 10906],
        ["cabin4_duty_record", "cabin4/duty_record", "cabin4/dutyRecord.html", null, 10907],

        ["hxfu_patient", "hxfu/patient", "hxfu/patient.html", null, 11101],
        ["hxfu_research", "hxfu/research", "hxfu/research.html", null, 11102],
        ["hxfu_fu", "hxfu/fu", "hxfu/fu.html", null, 11103],
        ["hxfu_data", "hxfu/data", "hxfu/data.html", null, 11104],

        ['copy_medical_record', 'copy_medical/record', 'copy_medical/record.html', null, 11201],
        ['copy_medical_charge', 'copy_medical/charge', 'copy_medical/charge.html', null, 11202],

        ['pharmacy_seal', 'pharmacy/seal', 'pharmacy/seal.html', null, 11301],
        ["pharmacy_medical_representative", "pharmacy/medical_representative", "pharmacy/mr.html", null, 11302],
        ["pharmacy_practice", "pharmacy/practice", "pharmacy/practice.html", null, 11303],

        ["sys_room", "sys/room", "sys/room.html", null, 9031],
        ["sys_dc", "sys/dc", "sys/dc.html", null, 9032],
        ["sys_task_setting", "sys/task_setting", "sys/task_setting.html", null, 9033],
        ["sys_tech", "sys/tech", "sys/tech.html", null, 9034],
        ["sys_authority", "sys/authority", "sys/authority.html", null, 9001],
        ["sys_help", "sys/help", "sys/help.html", "HelpCtrl", 9020],
        ["sys_app_cfg", "sys/app_cfg", "sys/app_cfg.html", "appCfgCtrl", 9002],
    ];


})();

(function () {
    'use strict';

    angular.module('c')
        .factory('mySocket', socketFactory)
        .run(runSocket)
    ;

    /** @ngInject */
    function runSocket(mySocket) {
    }

    /** @ngInject */
    function socketFactory(socketFactory) {
        // var protocol = window.location.protocol;
        var myIoSocket = io.connect("//" + window.location.hostname +
            ':3000'/*(protocol === 'http:' ? ':3000' : ':2998')*/);

        var mySocket = socketFactory({
            ioSocket: myIoSocket
        });

        mySocket.forward([
            "cbfy_oa:mail.read",
            "cbfy_oa:mail.send",
            "cbfy_oa:mail.withdraw",

            "cbfy_oa:bulletin.send",
            "cbfy_oa:file.release",
            "cbfy_oa:meeting.send",
            "cbfy_oa:meeting.read",
            "cbfy_oa:mission.send",
            "cbfy_oa:news.send",
            "cbfy_oa:rule.send",
            "cbfy_oa:selfAssessment.automatic",
            "cbfy_oa:clinc.analysis",
            "cbfy_oa:clinc.analysis.download",
            "cbfy_oa:clinc.analysis.progress",
            "cbfy_oa:doc.statistic.download",
            "cbfy_oa:clinc.file.download",
            "cbfy_oa:clinc.file.search",
            "cbfy_oa:clinc.file.repay",
            "cbfy_oa:csmb.price",
            "cbfy_oa:csmb.download",
            "cbfy_oa:csmb.remind",
            "cbfy_oa:csmb.remind2",
            "cbfy_oa:csmb.remind3",
            "cbfy_oa:csmb.download3",
            "cbfy_oa:deptCsmb.download",
            "cbfy_oa:deptCsmb.batchDownload",
            "cbfy_oa:group.download",
            "cbfy_oa:orderItemConclusion.download",


            //患者消费推送
            "cbfy_oa:patientMeal.order.pending",
            //体检诊台推送
            "cbfy_oa:mes.screen.update",
            "cbfy_oa:mes.order.stateChange",

            // 专家排队系统推送
            "cbfy_oa:eqs.screen.update",
            "cbfy_oa:eqs.screen.pause",

            "cbfy_oa:task",

            "cbfy_oa:file.zipDownload",

            //"cbfy_oa:question.send",
            "cbfy_oa:wechat.orderPay",
            "cbfy_oa:takeOut.send",
            "cbfy_oa:workingMeal.handle",
            "cbfy_oa:workingMeal.send",
            "cbfy_oa:appointment.notify",
            "cbfy_oa:stirFry.send",
            "cbfy_oa:shop.send",
            "cbfy_oa:festivalAward.spot",
            "cbfy_oa:promoteSale.receive",
            //
            "cbfy_oa:specialClinic.orderPlaced",
            "cbfy_oa:specialClinic.orderConfirm",
            "cbfy_oa:specialClinic.orderRefund",

            //
            "cbfy_oa:inoutHospital.orderPlaced",
            "cbfy_oa:inoutHospital.orderConfirm",
            "cbfy_oa:inoutHospital.orderRefund",

            //
            "cbfy_oa:ph.download",

            //
            "cbfy_oa:paper.approve",
            //
            "cbfy_oa:work_order.message_user",
            //  华西医院随访系统 医生就诊推送
            "cbfy_oa:hxfu.patient.present",
            "cbfy_oa:copyMedical.notify"
        ]);

        return mySocket;
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['uiMask.ConfigProvider', uiMaskConfig])
        .config(uibConfig)
    ;

    /** @ngInject */
    function uiMaskConfig(uiMaskConfigProvider) {
        uiMaskConfigProvider.clearOnBlur(false);
    }

    /** @ngInject */
    function uibConfig(uibDatepickerConfig, uibDatepickerPopupConfig, $uibTooltipProvider) {
        uibDatepickerConfig.startingDay = 1;

        uibDatepickerPopupConfig.currentText = "今天";
        uibDatepickerPopupConfig.clearText = "清除";
        uibDatepickerPopupConfig.closeText = "关闭";

        $uibTooltipProvider.options({
            appendToBody: true
        });
    }

})();

angular.module('c.s')
    .constant('C', {
        P: "socket:cbfy_oa:",

        V: "pages/dlg/",
        T: "templates/",


        STAGE1: {
            /**
             * 科审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 院审：1
             */
            HOSPITAL_APPROVAL: 1,
            /**
             * 科退：2
             */
            DEPT_BACK: 2,
            /**
             * 院退：3
             */
            HOSPITAL_BACK: 3,
            /**
             * 发布：4
             */
            PUBLIC: 4,
            OVER: 5
        },
        STAGE2: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 退回：1
             */
            BACK: 1,
            /**
             * 发布：2
             */
            PUBLIC: 2
        },
        STAGE3: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 发布：1
             */
            PUBLIC: 1,
            /**
             * 退回：2
             */
            BACK: 2
        },

        STAGE4: {
            /**
             * 科审：1
             */
            DEPT_APPROVAL: 1,
            /**
             * 院审：2
             */
            HOSPITAL_APPROVAL: 2,
            /**
             * 不讨论：3
             */
            NOT_DISCUSS: 3,
            /**
             * 待讨论：4
             */
            TO_BE_DISCUSSED: 4,
            /**
             * 已讨论：5
             */
            ALREADY_DISCUSSED: 5,
            /**
             * 会签：6
             */
            COUNTERSIGN: 6
        },
        STAGE5: {
            /**
             * 科审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 院审：1
             */
            HOSPITAL_APPROVAL: 1,
            //个人整改意见
            USER_APPROVAL: 5,
            /**
             * 党政办公室审核：6
             */
            PARTY_APPROVAL: 6,
            /**
             * 接受：7
             */
            ACCEPT: 7,
            /**
             * 拒绝：8
             */
            REJECT: 8,
            /**
             * 退回意见人：9
             */
            BACK: 9
        },
        STAGE6: {
            /**
             * 科审：1
             */
            DEPT_APPROVAL: 1,
            /**
             * 院审：2
             */
            HOSPITAL_APPROVAL: 2,
            /**
             * 会签：4
             */
            COUNTERSIGN: 4,
            /**
             * 待讨论：5
             */
            TO_BE_DISCUSSED: 5,
            /**
             * 发布：6
             */
            PUBLIC: 6,
            /**
             * 停用：7
             */
            DISABLE: 7
        },
        STAGE7: {
            /**
             * 套红头审批中：2
             */
            RED_HEAD_APPROVAL: 2,
            /**
             * 套红头第一步审批人已通过：3
             */
            RED_HEAD_HOSPITAL_APPROVED: 3
        },

        APPROVAL_TYPE: {
            LEAVE: 1,
            BULLETIN: 2,
            NEWS: 3,
            FILE: 4
        },

        DOC: {
            STATE: {
                INIT: 1,
                GOING: 2,
                END: 3
            },
            DESC_BY: {
                FIXED_PROCESS: '1',
                ATTACHMENT: '2'
            },
            HANDLE_BY: {
                DEPT_LEADER: '1',
                HOSPITAL_LEADER: '2',
                MAIN_LEADER: '3',
                DEPT: '4',
                USER: '5',
                APPLICANT: '6'
            },
            STEP: {
                RESULT: {
                    //同意并完成
                    OK_END: '1',
                    //不同意
                    REJECT: '2',
                    //已执行
                    EXECUTE: '3',
                    //因故未执行
                    FAILED: '4',
                    COMMENT: '5',
                    //小于此数字的结果属于已结束
                    MAX_END: '6',
                    //同意并转审批
                    UP: '7',
                    //同意并转执行
                    DOWN: '8',
                    //评估
                    EVAL: '9',
                    OTHER: '10', // 其他意见

                }
            },
            EDIT: '1'
        },

        EDU: {
            Q: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2'
                }
            },
            FOR: {
                DOCTOR: 1,
                NURSE: 2,
                ALL: 3
            },
            P: {
                TYPE: {
                    NORMAL: '1',
                    PACKAGE: '2',
                    PART: '3'
                },
                R_BY: {
                    /**
                     *
                     */
                    DEPT: '1',
                    EDU: '2',
                    NURSE: '3'
                }
            }
            ,
            T: {
                SHOW: {
                    FOR: {
                        PAPER: '1',
                        FILL: '2',
                        ANSWER_SHEET: '3',
                        STATISTIC: '4',
                        ANSWER_COURSE: '5'
                    }
                }
            }
        },

        Q: {
            QUESTION: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2',
                    FILL_BLANK: '3',
                }
            },
            TYPE: {
                NORMAL: '1',
                DEPT: '6',
                USER: '7',
                LEADER: '8',
                CUSTOM: '11'
            }
        },

        Q_SURVEY: {
            TYPE: {
                DEPT: '1',
                HOSPITAL: '2'
            },
            CLOSE: {
                WHEN_EXPIRED: '1',
                WHEN_FINISH: '2',
                WHEN_MANUAL: '3'
            },
            RR: {
                REAL_TIME: '1',
                WHEN_FINISH: '2',
                MANUAL: '3'
            },
            SHOW: {
                FOR: {
                    QUESTIONNAIRE: '1',
                    FILL: '2',
                    ANSWER_SHEET: '3',
                    STATISTIC: '4',
                    APPROVAL: '5',
                    DEPT: '6'
                }
            }
        },

        Q_OPINION: {
            PRIVACY: {
                NONE: '1',
                RESPONDENT: '2',
                ALL: '3'
            }
        },

        OPT: {
            USER: {
                INDEX: {
                    DEPT_MEMBER_OPTIONS: '3'
                }
            },
            SCHEDULE: {
                INDEX: {
                    SCHEDULES: 1,
                    G_S_BY_ROLLING_DAYS: 2,
                    GROUP_MEMBERS_SCHEDULES: 3,
                    DUTY_MEMBERS: 4,
                    G_S_BY_LAST_WEEK: 5
                }
            },
            DOC: {
                INDEX: {
                    USER_APPLIED: 1,
                    USER_HANDLED: 2,
                    DEPT_DOCS: 3,
                    PARTY_DOCS: 4,
                    APPROVAL_LIST: 10,
                    RED: 5,
                    USER_FOLLOW: 6
                },
                EDIT: {
                    SAVE: 3, //保存公文，同时作为后台opt
                    HANDLE: 4, //处理公文
                    COMMENT: 5 //处理公文
                }
            },
            DOC_TYPE: {
                INDEX: {
                    MANAGE: 1,
                    OPTIONS: 2,
                    SIMPLE_OPTIONS: 2
                },
                SHOW: {
                    BODY: 2
                }
            },

            MEETING_TOPIC: {
                INDEX: {
                    USER_APPLIED: 1,
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    DEPT_SEARCH: 4,
                    HOSPITAL_APPROVALED: 5,
                    HOSPITAL_SEARCH: 6,
                    TO_BE_DISCUSSED_MANAGE: 7,
                    MAIN_BACK_TO_ADD: 8,
                    MAIN_NOT_DISCUSS: 9,
                    MAIN_ALREADY_DISCUSSED: 10,
                    MAIN_COUNTERSIGN: 11,
                    MAIN_SEAL_UP: 12,
                    APPROVAL_LIST: 20,
                    USER_HANDLED: 21
                },
                EDIT: {
                    SAVE: 1,
                    PASS: 2,
                    BACK: 3,
                    BACK_TO_ADD: 4,
                    HANDLE: 5,
                    SEAL_UP: 6,
                    ORDER: 8
                }
            },
            DEPT: {
                INDEX: {
                    //所有科室选项
                    DEPTS_OPTIONS: 4,
                    //当前登录用户所属科室列表，用于下拉列表选项
                    USER_DEPTS_OPTIONS: 5,
                    //当前登录用户所负责科室列表，用于下拉列表选项
                    DEPTS_LED_BY: 6,
                    //当前登录用户所属科室列表，用于下拉列表选项,分管院领导可选所管科室
                    USER_DEPTS_OPTIONS2: 12,
                    //查询用户所属科室列表，用于下拉列表选项
                    USER_DEPTS_OPTIONS3: 13,
                    //分管院领导已审核制度的科室列表
                    DEPTS_LED_BY2: 15,
                    //科室物资管理员管理的科室列表
                    DEPTS_CSMB_OPTIONS: 16
                }
            },
            EDU: {
                TEST: {
                    INDEX: {
                        DEPT: 1,
                        NURSE: 2,
                        EDU: 3
                    },
                    SHOW: {
                        SIMPLE: 1,
                        STATISTICS: 2,
                        PKG_STATISTICS: 3,
                        MAKEUP: 4,
                        REMAINING: 5
                    }
                },
                P: {
                    INDEX: {
                        DEPT_P: 1,
                        DEPT_P_OPTIONS: 2,
                        PARTS: 3,
                        NURSE: 7,
                        EDU: 8
                    },
                    EDIT: {
                        SAVE: 3,
                        STOP: 4
                    }
                },
                Q: {
                    INDEX: {
                        USER_Q: 1,
                        NURSING_Q: 2,
                        EDU_Q: 3,
                        ITEM_BANK: 4
                    },
                    EDIT: {
                        APPROVAL: 1,
                        SAVE: 3,
                        STOP: 4
                    }
                },
                C: {
                    INDEX: {
                        USER: 1,
                        DEPT: 2,
                        NURSE: 3,
                        EDU: 4
                    }
                }
            },

            Q: {
                INDEX: {
                    USER_Q: 1,
                    USER_Q_OPTIONS: 2,
                    PARTY_Q: 3,
                    PARTY_Q_OPTIONS: 4
                },
                EDIT: {
                    SAVE: 3,
                    STOP: 4
                },
                EDIT1: 1,
                EDIT2: 2,
                RELEASE: 3,
                SUBMIT: 5
            },
            Q_SURVEY: {
                INDEX: {
                    USER_Q_SURVEY: 1,
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_Q_SURVEY: 4,
                    DEPT_RESULT: 5,
                    DEPT_RESULT4HOSPITAL: 6,
                    RESULT_OPTIONS: 7,
                    OPTION_NOTES: 8,
                    USER_RESULT: 9,
                    APPROVAL_LIST: 10,
                    USER_SS: 11
                },
                SHOW: {
                    SIMPLE: 1,
                    STATISTICS: 2,
                    APPROVAL: 3
                },
                EDIT: {
                    APPROVAL: 1,
                    MANUAL_CLOSE: 2,
                    MANUAL_RR: 3
                },
                APPROVAL: '1'
            },
            Q_ANSWER_SHEET: {
                INDEX: {
                    USER_Q_SHEET: 1,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    FILL: 1
                }
            },
            Q_OPINION: {
                INDEX: {
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_APPROVAL: 4,
                    USER_APPROVAL: 5,
                    USER_OPINION: 6,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    APPROVAL: 1,
                    CHANGE_DEPT: 2,
                    ADD: 3    //补充意见
                }
            },
            FILE: {
                INDEX: {
                    HOSPITAL_OFFICE_FILING: 1,
                    USER_UNREAD: 2,
                    USER_READ: 3,
                    HOSPITAL_OFFICE_SEAL_UP: 4,
                    IS_READING_PRINT: 5,
                    ALREADY_READ_PRINT: 6,
                    SEAL_UP_PRINT: 7,
                    USER_FILING: 8,
                    FILING_PRINT: 9,
                    USER_APPLIED: 10
                },
                EDIT: {
                    SEAL_UP: 1,
                    READ: 2,
                    CIRCULATE: 3,
                    FILING: 4
                }
            },
            SYS_WAGE: {
                INDEX: {
                    ALL_WAGES: 1,
                    STATUS_WAGES: 2
                }
            },
            PERSONNEL_WAGE: {
                INDEX: {
                    ALL_USERS: 1,
                    USER_WAGES: 2
                }
            },
            USER_TEMP_WAGE: {
                INDEX: {
                    ALL_WAGES: 1
                }
            },
            IN_SERIES_WAGE_REPORT: {
                INDEX: {
                    USER_WAGES: 1
                }
            },
            RULE_TYPE: {
                INDEX: {
                    DEPT_MANAGE: 1,
                    HOSPITAL_MANAGE: 2,
                    OPTIONS: 3,
                    NAME_EXCHANGE: 4,
                    CLASS_EXCHANGE: 5
                }
            },
            RULE: {
                INDEX: {
                    USER_APPLIED: 1,
                    USER_HOSPITAL_SEARCH: 2,
                    DEPT_SEARCH: 3,
                    HOSPITAL_APPROVED: 6,
                    HOSPITAL_OFFICE_MANAGE: 7,
                    USER_DEPT_SEARCH: 8,
                    RED_HEAD_SEARCH: 9,
                    RED_HEAD_APPROVAL_LIST: 10,
                    MEDICAL: 11,
                    TYPE_MANAGE: 20,
                    APPROVAL_LIST: 30,
                    FINALLY_SEARCH: 31,
                    INDEX_OFFICE_APPROVED: 34
                },
                EDIT: {
                    SAVE: 1,
                    EXCHANGE: 2,
                    PASS: 3,
                    HANDLE: 4,
                    DEPT_HANDLE: 5,
                    HOSPITAL_HANDLE: 6,
                    CLASS_EXCHANGE: 7,
                    RED_HEAD_MANAGE: 8,
                    RED_HEAD_PASS: 9,
                    RED_HEAD_BACK: 10,
                    BACK: 11
                }
            }
        },

        URL: {
            CHROME: {
                windows: 'download/android/chrome.exe',
                android: 'download/android/chrome.apk'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            },


            //BASE: 'http://' + window.location.host,
            WX_BIND: '/api/wx/bind',

            FORUM_SSO: '/bbs/sso',
            FORUM_API: '/bbs',

            TASK_HAS: '/api/v1/task_has',
            TASK_ALL: '/api/v1/task_all',

            SMS_SEND: '/api/v1/sms/send',
            SMS_RECEIVEEMAILS: '/api/v1/sms/receiveEmails',
            SMS_RM: '/api/v1/sms/remove',
            SMS_HISTORY: '/api/v1/sms/history',

            IMG_UPLOAD: '/api/v1/file/images/upload',

            OP_UPLOAD: '/api/v1/operation_permits/upload',
            OP_DOWNLOAD: '/api/v1/operation_permits/download',
            OR_SCHEDULE_UPLOAD: '/api/v1/or_schedules/upload',
            OR_SCHEDULE_DOWNLOAD: '/api/v1/or_schedules/download',

            IR_SCHEDULE_UPLOAD: '/api/v1/ir_schedules/upload',
            IR_SCHEDULE_DOWNLOAD: '/api/v1/ir_schedules/download',

            OUT_P_SCHEDULE_UPLOAD: '/api/v1/out_p_schedules/upload',
            OUT_P_SCHEDULE_DOWNLOAD: '/api/v1/out_p_schedules/download',

            MEDICAL_INFO_UPLOAD: '/api/v1/medical_info/upload',
            MEDICAL_INFO_DOWNLOAD: '/api/v1/medical_info/download',

            BLOOD_STORAGE_UPLOAD: '/api/v1/blood_storage/upload',
            BLOOD_STORAGE_DOWNLOAD: '/api/v1/blood_storage/download',

            NURSING_DUTY_DOWNLOAD: '/api/v1/nursing_duty_attachment/download',

            MEETING_EXPORT: '/api/v1/meetings/export',
            DEPT_DOCS_DOWNLOAD: '/api/v1/docs/export',
            SCHEDULES_DOWNLOAD: '/api/v1/schedules/export',
            MAIL_UPLOAD: '/api/v1/emails/upload',
            MAIL_DOWNLOAD: '/api/v1/emails/download',
            TASK_DOWNLOAD: '/api/v1/task/tasks/download',
            BULLETIN_UPLOAD: '/api/v1/bulletin/upload',
            BULLETIN_DOWNLOAD: '/api/v1/bulletin/download',
            BID_UPLOAD: '/api/v1/bids/upload',
            BID_DOWNLOAD: '/api/v1/bids/download',
            ATTENDANCE_EXPORT: '/api/v1/attendance_reports/export',
            Q_OPINION_EXPORT: '/api/v1/q/q_opinions/export',
            DUTY_PAID_EXPORT: '/api/v1/paid_details/export',

            FILE_CABINET_UPLOAD: '/api/v1/file_cabinet/upload',
            FILE_CABINET_DOWNLOAD: '/api/v1/file_cabinet/download',

            LEAVE_ATTACHMENT_UPLOAD: '/api/v1/leave_attachment/upload',
            LEAVE_ATTACHMENT_DOWNLOAD: '/api/v1/leave_attachment/download',
            LEAVES_DOWNLOAD: '/api/v1/ask_for_leaves/export',

            NEWS_UPLOAD: '/api/v1/bulletin/upload',
            NEWS_DOWNLOAD: '/api/v1/bulletin/download',

            DOC_UPLOAD: '/api/v1/docs/upload',
            DOC_DOWNLOAD: '/api/v1/docs/download',

            DOC_TYPE_UPLOAD: '/api/v1/doc_types/upload',
            DOC_TYPE_DOWNLOAD: '/api/v1/doc_types/download',

            TOPIC_UPLOAD: '/api/v1/meeting_topics/upload',
            TOPIC_DOWNLOAD: '/api/v1/meeting_topics/download',

            MEETING_UPLOAD: '/api/v1/meetings/upload',
            MEETING_DOWNLOAD: '/api/v1/meetings/download',

            MISSION_UPLOAD: '/api/v1/missions/upload',
            MISSION_DOWNLOAD: '/api/v1/missions/download',
            MISSION_EXPORT: '/api/v1/missions/export',

            REGULAR_MISSION_UPLOAD: '/api/v1/regular_missions/upload',
            REGULAR_MISSION_DOWNLOAD: '/api/v1/regular_missions/download',

            MISSION_REPORT_UPLOAD: '/api/v1/mission_reports/upload',
            MISSION_REPORT_DOWNLOAD: '/api/v1/mission_reports/download',

            QUALIFICATION_REPORT_UPLOAD: '/api/v1/qualifications/upload',
            QUALIFICATION_REPORT_DOWNLOAD: '/api/v1/qualifications/download',

            AUTHORIZATION_REPORT_UPLOAD: '/api/v1/authorizations/upload',
            AUTHORIZATION_REPORT_DOWNLOAD: '/api/v1/authorizations/download',
            AUTHORIZATION_REPORT_EXPORT: '/api/v1/authorizations/export',

            OFFICIAL_OVERVIEW_UPLOAD: '/api/v1/official_overview/upload',
            OFFICIAL_OVERVIEW_DOWNLOAD: '/api/v1/official_overview/download',

            FILE_UPLOAD: '/api/v1/files/upload',
            FILE_DOWNLOAD: '/api/v1/files/download',
            ORDER_IMG_UPLOAD: '/api/v1/orders/upload',
            ORDER_IMG_DOWNLOAD: '/api/v1/orders/download',

            FILE_READER_UPLOAD: '/api/v1/file_readers/upload',
            FILE_READER_DOWNLOAD: '/api/v1/file_readers/download',

            E_QUESTION_DOWNLOAD: '/api/v1/edu_questions/download',

            E_COURSE_UPLOAD: '/api/v1/edu_courses/upload',
            E_COURSE_DOWNLOAD: '/api/v1/edu_courses/download',
            E_UC_DOWNLOAD: '/api/v1/edu_user_courses/export',
            E_SC_DOWNLOAD: '/api/v1/edu_user_courses/signExport',

            RULE_ATTACH_UPLOAD: '/api/v1/rules/upload',
            RULE_ATTACH_DOWNLOAD: '/api/v1/rules/download',

            Q_SURVEY_DOWNLOAD: '/api/v1/q/questionnaire_surveys/export',
            E_TEST_DOWNLOAD: '/api/v1/edu_tests/export',

            CARS_DOWNLOAD: '/api/v1/car_applications/export',
            AIRFARE_DOWNLOAD: '/api/v1/airfares/export',

            FILES_EXPORT: '/api/v1/files/export',

            RWAGE_DOWNLOAD: '/api/v1/wage_reports/export',
            USER_RWAGE_DOWNLOAD: '/api/v1/wage_reports/export_wage',
            ROUND_DOWNLOAD: '/api/v1/rounds/export',

            RUSH_PARK_DOWNLOAD: '/api/v1/rush_parks/export',
            PARKING_RENT_DOWNLOAD: '/api/v1/user_parking/export',

            WORKING_MEALS_DOWNLOAD: '/api/v1/working_meals/export',
            TAKE_OUT_DOWNLOAD: '/api/v1/take_out/export',
            TAKE_OUT_DOWNLOAD2: '/api/v1/take_out/export2',
            PURCHASE_HISTORY_DOWNLOAD: '/api/v1/purchase_history/export',

            CONTRACT_UPLOAD: '/api/v1/contracts/upload',
            CONTRACT_UPLOAD1: '/api/v1/contracts/upload1',
            CONTRACT_DOWNLOAD: '/api/v1/contracts/download',
            CONTRACT_PDF_DOWNLOAD: '/api/v1/contracts/downloadPDF',

            MANUAL_UPLOAD: '/api/v1/e_manuals/upload',
            MANUAL_DOWNLOAD: '/api/v1/e_manuals/download',

            LAW_UPLOAD: '/api/v1/laws/upload',
            LAW_DOWNLOAD: '/api/v1/laws/download',

            VENDOR_UPLOAD: '/api/vendor/vendors/upload',
            VENDOR_DOWNLOAD: '/api/vendor/vendors/download',

            RULE_EXPORT: '/api/v1/rules/export',

            CONTRACT_EXPORT: 'api/v1/contracts/export',

            /**
             * 门诊订单导出
             */
            CLINC_AP_EXPORT: '/api/home/appointments/export',
            CLINC_AP_STATISTIC: '/api/home/appointments/statistic',
            CLINC_EMAP_EXPORT: '/api/home/emergency_appointments/export',
            CLINC_EMAP_STATISTIC: '/api/home/emergency_appointments/statistic',
            CLINC_EMAP_TRIAGE: '/api/home/emergency_appointments/triage',

            CLINC_EXPORT: '/api/home/clinc/export',
            CLINC_FIX: '/api/home/clinc/fix_export',

            CLINC_STOP_EXPORT: '/api/home/replace_clinc/export',
            CLINC_STOP_STATISTIC: '/api/home/clinc_stop_reasons/statistic',

            /**
             * 证书订单导出
             */
            QUALIFICATION_EXPORT: '/api/v1/qualifications/export',
            QUALIFICATION_STATISTIC: '/api/v1/qualifications/statistic',

            /**
             * 报修单图片上传
             */
            ROOM_REPAIR_IMAGES: '/api/v1/room/room_repair_record/images/upload',
            /**
             * 报修单语音上传
             */
            ROOM_REPAIR_VOICES: '/api/v1/room/room_repair_record/voices/upload',
            /**
             * 以后附件上传统一用这个
             */
            UPLOAD_ATTACHMENT: '/api/v1/file/attachments/upload_single',

            HOUSE_WAE_EXPORT: '/api/v1/house_wae/export',

            MEDICAL_STAFF_DOWNLOAD: '/api/v1/users/export'

        }


    });


(function () {
    'use strict';

    angular.module('c')
        .constant('serviceConfObj', {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        });
})();

angular.module('c')
    .filter('bytes', function() {
    return function(bytes) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes == 0) return '0';
        var units = {1: 'KB', 2: 'MB', 3: 'GB', 4: 'TB'},
            measure, floor, precision;
        if (bytes > 1099511627775) {
            measure = 4;
        } else if (bytes > 1048575999 && bytes <= 1099511627775) {
            measure = 3;
        } else if (bytes > 1024000 && bytes <= 1048575999) {
            measure = 2;
        } else if (bytes <= 1024000) {
            measure = 1;
        }
        floor = Math.floor(bytes / Math.pow(1024, measure)).toString().length;
        if (floor > 3) {
            precision = 0
        } else {
            precision = 3 - floor;
        }
        return (bytes / Math.pow(1024, measure)).toFixed(precision) + units[measure];
    }
});

/**
 * 将从laravel服务器传过来的时间格式转换成javascript的格式，在送入内建过滤器date处理
 */
angular.module('c')
    .filter('date2', function ($filter) {
        return function (text, format) {
            if (text != null && text != '') {
                var tempdate = new Date(text.replace(/-/g, "/"));
                return $filter('date')(tempdate, format);
            }
            return text;
        }
    });
angular.module('c')
    .filter('dateInRange', function (uibDateParser) {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (key in params) {
                    var date = item[key];
                    date = uibDateParser.parse(date, 'yyyy-MM-dd');
                    var dateRange = params[key];
                    if ((dateRange.startDate != null && date < dateRange.startDate)
                        || (dateRange.endDate != null && date > dateRange.endDate)) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });

(function () {
    'use strict';

    angular.module('c')
        .filter('defValIfNone', defValIfNone);

    /** @ngInject */
    function defValIfNone() {
        return function (input, val) {
            if (!input) {
                if (angular.isUndefined(val)) {
                    if (input === 0) {
                        val = '无';
                    } else {
                        val = '其他';
                    }
                }
                return val;
            }
            return input;
        }
    }

})();

angular.module('c')
    .filter('exceptItem', function (ArrayHelper) {
        return function (items, exclude) {
            var excludeArray = [];
            if (typeof exclude != 'undefined') {
                if (Array.isArray(exclude)) {
                    excludeArray = exclude;
                } else {
                    excludeArray.push(exclude)
                }
            }
            if (excludeArray && excludeArray.length > 0) {
                var ret = [];
                angular.forEach(items, function (item) {
                    var i = ArrayHelper.indexOfKey(item.id, excludeArray);
                    if (i == -1) {
                        ret.push(item);
                    }
                });
            } else {
                ret = items;
            }
            return ret;
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .filter('highlightSubstr', highlightSubstr);

    /** @ngInject */
    function highlightSubstr() {
        return function (input, start, len) {
            if (!input) return;
            if (start < 0) start = input.length + start;
            var output = '';
            if (start > 0) {
                output += input.substr(0, start);
            }
            output += '<strong>' + input.substr(start, len) + '</strong>';
            if (angular.isDefined(len) && start + len < input.length) {
                output += input.substr(start + len);
            }
            return output;
        }
    }

})();

angular.module('c')
    .filter('numInRange', function () {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (var key in params) {
                    var num = item[key];
                    var numRange = params[key];
                    var start = -Number.MAX_VALUE, end = Number.MAX_VALUE;
                    if (numRange.start != null && numRange.start != '') {
                        start = parseInt(numRange.start);
                    }
                    if (numRange.end != null && numRange.end != '') {
                        end = parseInt(numRange.end);
                    }
                    if (num < start || num > end) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .filter('strLimit', strLimit);

    /** @ngInject */
    function strLimit($filter) {
        return function (input, limit) {
            if (!input) return;
            if (angular.isUndefined(limit)) limit = 20;
            if (input.length <= limit) {
                return input;
            }

            return $filter('limitTo')(input, limit) + '...';
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('HgaIndexCtrl', HgaIndexCtrl);

    /** @ngInject */
    function HgaIndexCtrl($scope, $state, $location, $http, UIHelper, HgaAttachment, dialogs, C, FileHelper) {
        var vm = $scope;
        vm.sectionSelected = sectionSelected;
        vm.getAttachment = getAttachment;
        vm.download = download;
        vm.preview = preview;

        var code = $location.search().code;

        // 发送 get
        $http.get('/api/v1/hga/hga_index?code=' + code).then(function (data) {
            if (data.status == 200) {
                vm.m = data.data;
                vm.type = vm.m.type;
                if (vm.m.type != 1) vm.curSection = vm.m.section;
            }
        }, function () {
            $state.go('login');
        });


        function sectionSelected(section) {
            vm.curSection = section;
        }

        function download(attachment) {
            FileHelper.download1(HgaAttachment.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function preview(m) {
            dialogs.create(C.V + 'hga/attachment_show_dlg.html', 'HgaAttachmentShowDlgCtrl', {id: m.id}, {size: 'md'});
        }

        function getAttachment(m) {
            m.showDetail = !m.showDetail;
            if (!m.attachments) {
                HgaAttachment.query({opt: 4, /*INDEX_USER_SEARCH*/code: m.code}, function (resp) {
                    var items = resp.items;
                    angular.forEach(items, function (item) {
                        item.ico = UIHelper.getIconFromMime(item.mime);
                        item.size = parseInt(item.size);
                    });
                    m.attachments = items;
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c').controller('HomeCtrl', HomeCtrl)
        .controller('BulletinListCtrl', BulletinListCtrl)
        .controller('BidListCtrl', BidListCtrl)
        .controller('NewsListCtrl', NewsListCtrl)
        .controller('FileListCtrl', FileListCtrl)
        .controller('MeetingListCtrl', MeetingListCtrl)
        .controller('CPhoneDlgCtrl', CPhoneDlgCtrl)
        .controller('HisUserExtentDlgCtrl', HisUserExtentDlgCtrl)
        .controller('RuleListCtrl', RuleListCtrl)
        .controller('DiscussionListCtrl', DiscussionListCtrl)
        .controller('CovidListCtrl', CovidListCtrl)
        .controller('parkConfirmDlgCtrl', parkConfirmDlgCtrl)
        .controller('chatBotDlgCtrl', chatBotDlgCtrl)
        .controller('chatBotEntranceDlgCtrl', chatBotEntranceDlgCtrl)
        .controller('feedbackDlgCtrl', feedbackDlgCtrl)
    ;

    /** @ngInject */
    function HomeCtrl($scope, uibDateParser, $http, $filter, C, F, Auth, dialogs, FileHelper, DateHelper, $rootScope, $state, $timeout, Dlg, $stateParams,$document) {
        var vm = this;
        vm.hrm = hrm;
        vm.loadApp = loadApp;
        vm.skipPhone = skipPhone;
        vm.openPhoneDlg = openPhoneDlg;
        vm.download = download;
        vm.today = $filter('date')(new Date(), 'yyyy-MM-dd'); //bulletin-list news-list use
        vm.bulletins = [];
        vm.bids = [];
        vm.covids = [];
        vm.meetings = [];
        vm.ns = [];
        vm.files = [];
        vm.rules = [];
        vm.opShow = opShow;
        vm.dutyShow = dutyShow;
        vm.operationShow = operationShow;
        vm.clickDoc = clickDoc;
        vm.goToTarget = goToTarget;
        init();
        // 初始化拖动功能
        // initDrag();



        // 新增方法：点击按钮跳转到指定界面
        function goToTarget() {
                Dlg.show({
                    template: 'chatBotEntrance.html',
                    ctrl: 'chatBotEntranceDlgCtrl',
                    data: {},
                }).then(function () {
                    vm.tableReload();
                });
        }

        // 初始化拖动功能
        // function initDrag() {
        //     var button = document.getElementById('floatingButton');
        //     var offsetX, offsetY;
        //     var isDragging = false;  // 标志位，判断是否正在拖动
        //     // 鼠标按下时开始拖动
        //     button.addEventListener('mousedown', function (e) {
        //         isDragging = true;
        //         offsetX = e.clientX - button.getBoundingClientRect().left;
        //         offsetY = e.clientY - button.getBoundingClientRect().top;
        //         button.style.transition = 'none'; // 禁用动画过渡，避免拖动时的抖动
        //     });
        //
        //     // 鼠标移动时更新按钮位置
        //     document.addEventListener('mousemove', function (e) {
        //         if (isDragging) {
        //             var newLeft = e.clientX - offsetX;
        //             var newTop = e.clientY - offsetY;
        //
        //             // 确保按钮不超出屏幕右侧
        //             if (newLeft + button.offsetWidth > window.innerWidth) {
        //                 newLeft = window.innerWidth - button.offsetWidth;
        //             }
        //
        //             // 确保按钮不超出屏幕下方
        //             if (newTop + button.offsetHeight > window.innerHeight) {
        //                 newTop = window.innerHeight - button.offsetHeight;
        //             }
        //
        //             // 更新按钮的位置
        //             button.style.left = newLeft + 'px';
        //             button.style.top = newTop + 'px';
        //         }
        //         if (e.clientX < 0 || e.clientY < 0) {
        //             isDragging = false;
        //         }
        //     });
        //
        //     // 鼠标松开时停止拖动
        //     button.addEventListener('mouseup', function () {
        //         isDragging = false;
        //         button.style.transition = 'transform 0.3s ease'; // 恢复平滑过渡
        //     });
        //     // 添加鼠标悬停时放大的效果
        //     button.addEventListener('mouseenter', function() {
        //         button.style.transform = 'scale(1.1)';
        //     });
        //
        //     button.addEventListener('mouseleave', function() {
        //         button.style.transform = 'scale(1)';
        //     });
        //     button.addEventListener('click', function() {
        //         if (!isDragging) {  // 如果按钮没有被拖动
        //             goToTarget()  // 替换为你需要跳转的链接
        //         }
        //     });
        // }
        // ... 其他方法 ...
        function init() {
            $http.get('api/v1/home').then(function (resp) {
                var data = resp.data;
                // vm.hasMission = data.hasMission;
                vm.bulletins = data.bulletins;
                vm.bids = data.bids;
                vm.covids = data.covids;
                vm.meetings = data.meetings;
                loadMeeting($scope, data.meetings, DateHelper, Auth, uibDateParser, $filter, Dlg, C, $stateParams.data);
                vm.ns = data.ns;
                vm.files = data.files;
                vm.rules = data.rules;
                vm.blood = getInfoItem(data.blood, true);
                vm.medical = getInfoItem(data.medical, true);
                vm.allDuty = getInfoItem(data.allDuty, true);
                vm.ors = getInfoItem(data.ors);
                vm.irs = getInfoItem(data.irs);
                vm.outPatient = getInfoItem(data.outPatient);
                vm.covidInfo = data.covidInfo;
                vm.partyMemberHandle = data.partyMemberHandle;
                vm.rushPark = data.rushPark;

                // 新录入用户为党员，填写党员信息
                if (vm.partyMemberHandle != null) {
                    var params = {
                        user: vm.partyMemberHandle
                    };
                    Dlg.show({
                        template: 'pages/dlg/party/information/informationEditDlg.html',
                        ctrl: 'informationEditDlgCtrl',
                        size: 'lg',
                        data: params
                    }).finally(function () {
                        vm.tableReload();
                    });
                }

                if (vm.rushPark == null || vm.rushPark.confirm == 0) {
                    Dlg.show({
                        template: 'templates/rushPark/parkConfirmDlg.html',
                        ctrl: 'parkConfirmDlgCtrl',
                        data: {rushPark: vm.rushPark}
                    });
                }

                $scope.$on('ReadCovid', function (event, data) {
                    var id = data.id;
                    var covid = F.getItem(id, vm.covidInfo);
                    if (covid && covid.type == 1) {
                        if (covid && (covid.recipient == '' || covid.recipient == null)) {
                            vm.covidInfo[0].recipient = true;
                        }
                    }
                    if (covid && covid.type == 2) {
                        if (covid && (covid.recipient == '' || covid.recipient == null)) {
                            if (vm.covidInfo[1] != null) {
                                vm.covidInfo[1].recipient = true;
                            } else {
                                m.covidInfo[0].recipient = true;
                            }
                        }
                    }
                });

                var user = Auth.getAccount();
                // if (data.needHandle) {
                //     dialogs.create(C.T + 'his/user_extend.html', 'HisUserExtentDlgCtrl', {
                //         user: user, isEdit: false
                //     }, {size: 'md'});
                // }
                if ($stateParams.hrm) {
                    console.log(1);
                    hrm();
                }
            });
        }

        function getInfoItem(resp, hideTomorrow) {
            var tomorrow, today;
            if (resp) {

                tomorrow = F.getItem(1, resp);
                today = hideTomorrow ? resp.items[0] : F.getItem(2, resp);
            }
            if (!tomorrow) {
                tomorrow = {id: 1};
            }
            if (!today) {
                today = {id: 2};
            }
            return {tomorrow: tomorrow, today: today};
        }

        function download(m, _url) {
            FileHelper.download1(C.URL[_url], {name: m.name, filename: m.filename, mime: m.mime});
        }

        function opShow() {
            dialogs.create(C.T + 'dateSs.html', 'opDateSsDlgCtrl', {}, {size: 'lg'});
        }

        function dutyShow() {
            dialogs.create(C.T + 'totalDutyRecordDlg.html', 'totalDutyRecordDlgCtrl', {}, {size: 'lg'});
        }

        function operationShow() {
            dialogs.create(C.T + 'operationRecordDlg.html', 'OperationRecordDlgCtrl', {}, {size: 'lg'});
        }

        function hrm() {
            dialogs.create(C.T + 'leave/hrm_dlg.html', 'SimpleDlgCtrl', {}, {size: 'lg'});
        }

        function loadApp() {
            dialogs.create(C.T + 'appQrCode.html', 'AppQrCodeCtrl', {}, {size: 'lg'});
        }

        function skipPhone() {
            window.location.href = '/#/app/user/contacts';
            $timeout(function () {
                $rootScope.$broadcast("skipPhone");
            }, 800);
        }

        function openPhoneDlg() {
            dialogs.create(C.T + 'misc/common_phone.html', 'CPhoneDlgCtrl', {}, {size: 'lg'});
        }

        function clickDoc() {
            $state.go('app.coop_doc', {data: {type_id: 15}, tab: 'new'});
            $timeout(function () {
                $rootScope.$broadcast('docAdd', {type_id: 296});
            }, 800);
        }
    }

    /** @ngInject */
    function BulletinListCtrl($scope, Dlg, C, F, Api, Bulletin) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('bulletin.send', function (event, data) {
                reload();
            });

            $scope.$on('ReadBulletin', function (event, data) {
                var id = data.id;
                var bulletin = F.getItem(id, home.bulletins);
                if (bulletin && bulletin.recipient == null) {
                    bulletin.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            Bulletin.query(pa, function (data) {
                home.bulletins = data.bulletins;
            });
        }

        function read(bulletin) {
            Dlg.show({
                template: C.T + 'article/show_dlg.html',
                ctrl: 'BulletinShowDlgCtrl',
                data: {id: bulletin.id},
                size: 'lg'
            }).finally(function () {
                bulletin.is_new = false;
            });
        }


    }

    /** @ngInject */
    function BidListCtrl($scope, Dlg, C, F, Api, Bid, $ocLazyLoad) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('bid.send', function (event, data) {
                reload();
            });

            $scope.$on('ReadBid', function (event, data) {
                var id = data.id;
                var bid = F.getItem(id, home.bids);
                if (bid && bid.recipient == null) {
                    bid.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 8, sorting: {updated_at: 'desc'}});
            Bid.query(pa, function (data) {
                home.bids = data.bids;
            });
        }

        function read(bid) {
            $ocLazyLoad.load(['/ocLazyLoad/mod/bid.js']).then(function () {
                Dlg.show({
                    template: 'pages/dlg/bid/show_dlg.html',
                    ctrl: 'BidShowDlgCtrl',
                    data: {id: bid.id},
                    size: 'lg'
                }).finally(function () {
                    bid.is_new = false;
                });
            });
        }


    }

    function parkConfirmDlgCtrl(data, Dlg, RushPark, $q, $uibModalInstance, Auth) {
        var vm = this;
        vm.ok = ok;
        var user = Auth.getAccount();

        init(data);

        function init(data) {
            if (data.rushPark) {
                vm.m = data.rushPark;
            } else {
                vm.m = {plate_num: '', plate_num2: ''}
            }
        }

        function ok(m, flag) {
            var defer = $q.defer();
            if (m.id) {
                var id = m.id;
            } else {
                var id = '-'
            }

            if (flag) {
                if (!m.plate_num || m.plate_num == '') {
                    Dlg.e('车牌号不能为空');
                } else {
                    var pa = {
                        plate_num: m.plate_num,
                        rush: 1,
                        confirm: 1,
                        home: true
                    }
                    if (m.plate_num2 || m.plate_num2 != '') {
                        pa.plate_num2 = m.plate_num2;
                    }
                    RushPark.update({id: id}, pa).$promise.then(function () {
                        Dlg.s('操作成功');
                        $uibModalInstance.close();
                    }, function (e) {
                        Dlg.error(e.data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            } else {
                var pa = {
                    plate_num: null,
                    rush: 0,
                    confirm: 1,
                    home: true
                }
                RushPark.update({id: id}, pa).$promise.then(function () {
                    Dlg.s('操作成功');
                    $uibModalInstance.close();
                }, function (e) {
                    Dlg.error(e.data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            }

        }

    }

    /** @ngInject */
    function CovidListCtrl($scope, Dlg, C, F, Api, $http, $ocLazyLoad) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();

        function init() {

            $scope.$on('covid.send', function (event, data) {
                reload();
            });

            $scope.$on('ReadCovid', function (event, data) {
                var id = data.id;
                var covid = F.getItem(id, home.covids);
                if (covid && (covid.recipient == '' || covid.recipient == null)) {
                    covid.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 8, sorting: {release_time: 'desc'}});

            $http.get('api/v1/covid/covids', {
                params: pa
            }).then(function (resp) {
                home.covids = resp.covids;
            });
        }

        function read(covid) {
            $ocLazyLoad.load(['/ocLazyLoad/mod/covid.js', '/ocLazyLoad/mod/covid.css']).then(function () {
                Dlg.show({
                    template: 'pages/coop/covidColumn/showDlg.html',
                    ctrl: 'CovidShowDlgCtrl',
                    data: {id: covid.id, dept: covid.sender_dept, sender: covid.sender, type: covid.type},
                    size: 'lg'
                });
            });
        }

    }

    /** @ngInject */
    function NewsListCtrl($scope, dialogs, C, Api, $http) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('news.send', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({op: 'home_list', page: 1, count: 6, sorting: {updated_at: 'desc'}});//
            // News.query(pa, function (data) {
            //     home.ns = data.items;
            // });
            $http.get('api/v1/news/news', {
                params: pa
            }).then(function (resp) {
                home.ns = resp.data.items;
            });
        }

        function read(n) {
            dialogs.create(C.T + 'article/show_dlg.html', 'NewsMainShowDlgCtrl', {
                id: n.id
            }, {size: 'lg'});
        }
    }

    /** @ngInject */
    function FileListCtrl($scope, C, F, Api, FileCabinet, FileHelper) {
        var vm = $scope;
        var home = $scope.home;
        vm.download = download;

        init();


        function init() {
            $scope.$on('file.release', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            FileCabinet.query(pa, function (data) {
                home.files = data.files;
            });
        }

        function download(m) {
            FileHelper.download1(C.URL.FILE_CABINET_DOWNLOAD, {name: m.name, filename: m.filename, mime: m.mime});
        }
    }

    function loadMeeting(vm, meetings, DateHelper, Auth, uibDateParser, $filter, Dlg, C, isLogin) {
        var account = Auth.getAccount();
        var todaymeeting = false;
        angular.forEach(meetings, function (meeting) {
            meeting.forLeave = false;
            meeting.forRemind = false;
            meeting.forRCancel = false;
            meeting.isApplicant = false;
            meeting.isModerator = false;
            var start = new Date(),
                end = uibDateParser.parse(meeting.start_time, 'yyyy-MM-dd HH:mm:ss');

            var yesterday = new Date(end - 24 * 60 * 60 * 1000),
                time = $filter('date')(yesterday, 'yyyy-MM-dd') + ' ' + '08:30:00',
                y_start = uibDateParser.parse(time, 'yyyy-MM-dd HH:mm:ss');
            if (meeting.applicant_id == account.id) {
                meeting.isApplicant = true;
            }
            if (DateHelper.diffInHours(start, y_start) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forDayRemind = true;
                    }
                }
            }

            if (DateHelper.diffInHours(start, end) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forRemind = true;
                    }
                }
            }

            if (DateHelper.diffInMinutes(start, end) >= 30) {
                if (meeting.attendees.length > 0) {
                    meeting.forLeave = true;
                }
            }

            if (meeting.leavers.length > 0) {
                meeting.forLeave = false;
            }

            if (meeting.moderator_id && meeting.moderator_id == account.id) {
                meeting.isModerator = true;
            }
            console.log('a', meeting.start_time.substr(0, 10));
            console.log('b', $filter('date')(start, 'yyyy-MM-dd'));
            meeting.start_time = meeting.start_time.substr(0, 16);
            if (meeting.start_time > $filter('date')(start, 'yyyy-MM-dd HH:mm:ss') && meeting.start_time.substr(0, 10) == $filter('date')(start, 'yyyy-MM-dd') && meeting.attendees.length > 0) {
                todaymeeting = true;
            }
        });
        if (todaymeeting && isLogin) {
            Dlg.show({
                template: C.T + 'meeting/today_dlg.html',
                ctrl: 'MeetingTodayCtrl',
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function MeetingListCtrl($scope, dialogs, $filter, uibDateParser, C, F, DateHelper, Auth, toaster, Api, Meeting, Dlg) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('meeting.send', function () {
                reload();
            });

            $scope.$on('MeetingRead', function (event, data) {
                var id = data;
                var meeting = F.getItem(id, home.meetings);
                if (meeting && meeting.recipient == null) {
                    meeting.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 6, page: 1, count: 5, sorting: {start_time: 'asc'}});
            Meeting.query(pa, function (data) {
                loadMeeting(vm, data.meetings, DateHelper, Auth, uibDateParser, $filter, Dlg, C);
                home.meetings = data.meetings;
            });
        }

        function read(meeting) {
            dialogs.create(C.T + 'meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                    id: meeting.id,
                    ForLeave: meeting.forLeave,
                    ForRemind: meeting.forRemind,
                    ForDayRemind: meeting.forDayRemind,
                    ForRCancel: meeting.forRCancel,
                    isApplicant: meeting.isApplicant,
                    isModerator: meeting.isModerator
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        leave(meeting);
                        break;
                    case 5:
                        remind(meeting, params.op);
                        break;
                    case 6:
                        remove(meeting);
                        break;
                }
            });
        }


        function leave(meeting) {
            Api.comment({
                title: '会议请假',
                icon: 'sign-out',
                label: '原因'
            }, function (pa) {
                var params = {};
                params['reason'] = pa;
                params['start_time'] = meeting.start_time;
                Meeting.leave({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('请假成功');
                                reload();
                                break;
                            case 1:
                                toaster.warning('请在开会前半小时请假!');
                                break;
                        }
                    }, function () {
                        toaster.error('请假失败了!');
                    }
                )
            });
        }

        function remind(meeting, op) {
            dialogs.confirm('会前提醒', '确定要会前' + (op == 1 ? '半小时' : '一天08:30') + '短信提醒吗?').result.then(function () {
                Meeting.setReminderTime({id: meeting.id}, {opt: op}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('设置成功!');
                                reload();
                                break;
                            case 1:
                                toaster.warning('请在开会前一小时设置!');
                                break;
                            case 2:
                                toaster.warning('已统一设置会前半小时提醒!');
                                break;
                            case 3:
                                toaster.warning('请在开会前一天08:30之前设置!');
                                break;
                        }
                    }, function () {
                        toaster.error('设置失败了!');
                    }
                )
            });
        }

        function remove(meeting) {
            dialogs.confirm('取消会前提醒', '确定要取消会前微信提醒吗?').result.then(function () {
                Meeting.setReminderTime({id: meeting.id}, {opt: 3}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('取消成功!');
                                reload();
                                break;
                            case 1:
                                toaster.warning('请在开会前一小时取消!');
                                break;
                        }
                    }, function () {
                        toaster.error('取消失败了!');
                    }
                )
            });
        }
    }

    /** @ngInject */
    function CPhoneDlgCtrl($scope, $uibModalInstance, CommonPhone, Table) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 2/*INDEX_ALL*/},
                hideOpt: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {'phone': "text"}},
                    {field: "cornet", title: "小号", filter: {'cornet': "text"}}
                ]
            };
            Table.load(vm, options);
        }

    }

    /** @ngInject */
    function HisUserExtentDlgCtrl($scope, $uibModalInstance, FormHelper, ArrayHelper, JobTitle, data, DHHisBKDept, DHHisUserExtend, Dlg, $q) {
        var vm = $scope;
        vm.submit = submit;
        vm.titleTypes = JobTitle.getTypes();
        vm.titleGrades = JobTitle.getGrades();
        vm.titleTypeSelected = titleTypeSelected;
        vm.selectTag = selectTag;
        vm.cancel = $uibModalInstance.dismiss;
        vm.isEdit = false;

        var baseFiled = [
            'type', 'title', 'level', 'license', 'qualification', 'class_a', 'class_b', 'class_c', 'class_d',
            'consultation', 'prescription', 'anaesthesia', 'cancer',
            'antibacterial_a', 'antibacterial_b', 'antibacterial_c', 'class_I_psychotropic'
        ];
        var fileds = baseFiled.concat([
            'need_his', 'toxic', 'class_II_psychotropic', 'note'
        ]);

        function selectTag(m, index, isSelect) {
            if (vm.isEdit) {
                m[index] = isSelect;
            } else {
                Dlg.w('无法进行修改，请于备注中进行错误说明');
            }
        }

        function titleTypeSelected(m) {
            if (m.title_type) {
                var fTitles = ArrayHelper.filter(vm.titles, function (title) {
                    return title.type === m.title_type.id;
                });
                if (!m.title || m.title.type !== m.title_type.id) m.title = fTitles[0];
                vm.fTitles = fTitles;
            }
        }

        var tag1s = [
            {id: 1, name: 'class_a', value: '一级'},
            {id: 2, name: 'class_b', value: '二级'},
            {id: 3, name: 'class_c', value: '三级'},
            {id: 4, name: 'class_d', value: '四级'},
        ];

        var tag2s = [
            {id: 1, name: 'consultation', value: '普会诊权限'},
            {id: 2, name: 'prescription', value: '普通处方权'},
        ];

        var tag3s = [
            {id: 1, name: 'toxic', value: '毒性药品'},
            {id: 2, name: 'anaesthesia', value: '麻醉药品'},
            {id: 3, name: 'cancer', value: '肿瘤药物'},
            {id: 4, name: 'antibacterial_a', value: '非限制使用级抗菌药物'},
            {id: 5, name: 'antibacterial_b', value: ' 限制使用级抗菌药物'},
            {id: 6, name: 'antibacterial_c', value: ' 特殊使用级抗菌药物'},
            {id: 7, name: 'class_I_psychotropic', value: '第一类精神药品'},
            {id: 8, name: 'class_II_psychotropic', value: '第二类精神药品'},
        ];

        init(data.user, data.isEdit);

        function init(user, isEdit) {
            vm.loadingItem = true;
            vm.isEdit = isEdit;
            vm.m = {
                his_depts: [],
                user: user,
                tag1s: tag1s,
                tag2s: tag2s,
                tag3s: tag3s
            };

            $q.all([
                DHHisBKDept.query({op: 'option'}).$promise,
                JobTitle.query({op: 'option'}).$promise,
                DHHisUserExtend.get({id: '-', op: 'by_user_id', user_id: user.id}).$promise
            ]).then(function (respArray) {
                var items = respArray[0].items;
                angular.forEach(items, function (item) {
                    item.typeName = ArrayHelper.getItem(item.type_id, DHHisBKDept.getTypes()).name;
                });
                vm.his_depts = items;

                vm.titles = respArray[1].items;

                var baseItem = respArray[2].base_item;
                var item = respArray[2].item;
                if (item) {
                    loadItem(vm.m, item, fileds);
                    vm.m.his_depts = item.his_depts;
                } else {
                    loadItem(vm.m, baseItem, baseFiled);
                }

                vm.m.title_type = ArrayHelper.getItem(vm.m.type, vm.titleTypes);
                vm.m.title = ArrayHelper.getItem(vm.m.title, vm.titles);
                vm.m.level = ArrayHelper.getItem(vm.m.level, vm.titleGrades);
                titleTypeSelected(vm.m);

            }).finally(function () {
                vm.loadingItem = false;
            });
        }

        function loadItem(m, item, loadKeys) {
            if (item) {
                angular.forEach(loadKeys, function (field) {
                    m[field] = item.hasOwnProperty(field) ? item[field] : null;
                });
            }
        }

        function submit(m) {
            console.log(m);
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    op: 'save_extend',
                    user_id: m.user.id,
                    need_his: m.need_his ? 1 : 0
                };
                if (m.need_his) {
                    loadItem(pa, m, fileds);
                    //处理下数据,bool转int
                    angular.forEach(['class_a', 'class_b', 'class_c', 'class_d', 'consultation', 'prescription', 'toxic', 'anaesthesia', 'need_his',
                            'cancer', 'antibacterial_a', 'antibacterial_b', 'antibacterial_c', 'class_I_psychotropic', 'class_II_psychotropic'],
                        function (field) {
                            pa[field] = !!pa[field] ? 1 : 0;
                        });
                    //授权科室
                    var deptIds = [];
                    angular.forEach(m.his_depts, function (dept) {
                        deptIds.push(dept.id)
                    });
                    pa.dept_ids = deptIds;

                    pa['type'] = pa['title'] ? pa['title']['type'] : null;
                    pa['title'] = pa['title'] ? pa['title']['id'] : null;
                }

                DHHisUserExtend.update({id: '-'}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

    /** @ngInject */
    function RuleListCtrl($scope, $ocLazyLoad, dialogs, C, Api, Rule) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('rule.send', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 2, page: 1, count: 8, sorting: {release_time: 'desc'}});//
            Rule.query(pa, function (data) {
                home.rules = data.rules;
            });
        }

        function read(rule) {
            $ocLazyLoad.load(['pdf', 'video']).then(function () {
                dialogs.create(C.T + 'rule/show_dlg.html', 'RuleShowDlgCtrl', {
                    id: rule.id
                }, {size: 'lg'});
            });
        }
    }

    /** @ngInject */
    function DiscussionListCtrl($scope, $timeout, ipCookie, C, DateHelper, Auth, BBS) {
        var vm = $scope;
        vm.goToDiscussion = goToDiscussion;

        init();


        function init() {
            var maxLen = 5;
            BBS.list(function (resp) {
                var aLen = resp.Announcements.length;
                //var dLen = resp.Discussions.length;
                angular.forEach(resp.Announcements, function (a) {
                    a.LastDate = DateHelper.toLocalTime(a.LastDate, 16);
                });
                angular.forEach(resp.Discussions, function (d) {
                    d.LastDate = DateHelper.toLocalTime(d.LastDate, 16);
                });

                vm.announcements = resp.Announcements;
                vm.aLen = aLen > maxLen ? maxLen : aLen;
                vm.discussions = resp.Discussions;
                vm.dLen = aLen > maxLen ? 0 : (maxLen - aLen);
            }, function () {
            });
        }

        function goToDiscussion(d) {
            var token = Auth.getToken();
            ipCookie('token', token/*, {expires: 1, expirationUnit: 'minutes'}*/);
            $timeout(function () {
                var bbs_url = C.URL.FORUM_SSO;
                if (d) {
                    bbs_url += '?Target=' + d.Url;
                }
                window.location.href = bbs_url;
            }, 360);
        }
    }
    function chatBotDlgCtrl($scope, $uibModalInstance,Auth) {
        var vm = $scope;
        vm.user = Auth.getAccount();
        vm.cancel = $uibModalInstance.dismiss;
        vm.iframeSrc = 'https://www.tcd120.cn/chatBotDify';
        init();
        function init() {
            document.cookie = "oaUserId="+vm.user.id+"; path=/; domain=.tcd120.cn;";
        }
    }
    function chatBotEntranceDlgCtrl($scope, $uibModalInstance,Dlg) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.goToChatBot = goToChatBot;
        vm.goToFeedback = goToFeedback;

        function goToChatBot() {
            Dlg.show({
                template: 'chatBot.html',
                ctrl: 'chatBotDlgCtrl',
                data: {},
            }).then(function () {
                $uibModalInstance.close();
            });
        }
        function goToFeedback() {
            Dlg.show({
                template: 'feedback.html',
                ctrl: 'feedbackDlgCtrl',
                data: {},
            }).then(function () {
                $uibModalInstance.close();
            });
        }
    }
    function feedbackDlgCtrl($scope, $uibModalInstance,$http,Dlg) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;

        function submit(m) {
            $http.post('api/v1/chatBot/chat_bot_opinions', {
                opinion: m.opinion,
            }).then(function (resp) {
                Dlg.s(resp.data.msg);
                $uibModalInstance.close();
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('LoginCtrl', LoginCtrl)
    ;

    /** @ngInject */
    function LoginCtrl($scope, Regex, OS_VERSIONS, $state, Dlg, deviceDetector, Auth, $http, $interval, $location, $timeout,C, $ocLazyLoad) {
        var vm = $scope;
        vm.loginForm = loginForm;
        // vm.openid = $stateParams.data.openid;
        vm.user = {autoLogin: Auth.getAutoLogin()};
        vm.smsLogin = false;
        vm.getSmsPassword = getSmsPassword;
        vm.getSmsBtnText = getSmsBtnText;
        vm.remain = -1;

        init();


        function init() {
            $scope.$watch('smsLogin', function (newValue) {
                vm.regex = newValue ? Regex.CAPTCHA : Regex.PASSWORD;
            });
            var chromeUrls = {
                mac: '#',
                ios: '#',
                windows: '/download/windows/chrome.exe',
                android: '/download/android/chrome.apk'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            };
            console.log(deviceDetector.os);
            vm.chromeUrl = chromeUrls[deviceDetector.os];

            vm.loadingQrCode = true;
            $ocLazyLoad.load({
                serie: true,
                files: [
                    '/ocLazyLoad/wx/wxLogin.js'
                ]
            }).then(function () {
                new WxLogin({
                    self_redirect: false,
                    id: "login_container",
                    appid: "wxf8f6067880fe95de",
                    scope: "snsapi_login",
                    redirect_uri: "https://oa.tcd120.cn/redirect_login_page",
                    state: Math.floor(Math.random() * 100000),
                    style: "white",
                    href: "https://oa.tcd120.cn/ocLazyLoad/wx/wxQrCode.css",
                });
                vm.loadingQrCode = false;
            });


            if (deviceDetector.browser !== 'chrome') {
                if (deviceDetector.os_version === OS_VERSIONS.WINDOWS_XP) {
                    vm.chromeUrl = '/download/chrome/chromeXp.exe'
                }

                if (vm.chromeUrl) {
                    // Dlg.s(deviceDetector.os);
                    Dlg.notify("您正在" + deviceDetector.os + "系统下访问本站,强烈建议您改用<span class='text-red'>" +
                        "chrome浏览器</span>访问,以保证正常使用所有功能" + " 点击<a class='text-red' href=" +
                        vm.chromeUrl + ">" + "这里</a>下载");
                }
            }

            $timeout(function () {
                var searchParams = $location.search();
                if (angular.isDefined(searchParams['wx_code']) && searchParams['wx_code']) {
                    vm.isWxLogin = true;
                    Auth.login({wx_code: searchParams['wx_code']}, function (resp) {
                        $state.go('app.home');
                    }, function (error) {
                        Dlg.e(error.msg);
                    });
                }
            }, 200);
        }


        function loginForm(user, Form) {
            vm.isWxLogin = false
            if (Form.$valid) {
                user.sms_login = vm.smsLogin;
                // if (vm.openid) user.openid = vm.openid;
                Auth.login(user, function (resp) {
                    if (vm.smsLogin) {
                        $state.go('app.user_profile', {data: {requireChangePasswd: true}});
                    } else if (Boolean(resp.account.is_community_role)) {
                        $state.go('community_twoWayReferral');
                    } else {
                        $state.go('app.home', {data:true});
                    }
                }, function (error) {
                    Dlg.e(error.msg);
                });
            } else {
                Form.submitted = true;
            }
        }

        function getSmsPassword() {
            if (!vm.user.username
                || !vm.user.username.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[1235789])\d{8}$/)) {
                Dlg.e('手机号格式不正确');
                return
            }

            $http.post("/auth/sms/password", {
                phone: vm.user.username
            }).then(
                function () {
                    vm.remain = 60;
                    var intervalId = $interval(function () {
                        vm.remain--;
                        if (vm.remain === 0) {
                            $interval.cancel(intervalId)
                        }
                    }, 1000)
                }
            ).catch(function (error) {
                    Dlg.e(error.data.message);
                }
            )
        }

        function getSmsBtnText() {
            return vm.remain > 0 ? '重新获取(' + vm.remain + ')'
                : vm.remain === 0 ? '重新获取' : '获取短信动态密码'
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('MainCtrl', MainCtrl);

    /** @ngInject */
    function MainCtrl($rootScope, $http, $scope, $state, $timeout, $q, dialogs, Dlg, toaster, C, ArrayHelper, Auth,
                      FileHelper, UIHelper, $ocLazyLoad, $filter) {
        var account = Auth.getAccount();
        var vm = $scope;
        vm.offset = false;

        init();


        function init() {
            $timeout(function () {
                if (!vm.$finishedLoading) {
                    vm.$finishedLoading = true;
                }
            }, 500);

            $scope.$on('showSidebar', function (event, showSidebar) {
                vm.offset = showSidebar;
            });

            $scope.$on('state.go', function (event, state) {
                $state.go(state.name, {data: {tab: state.tab}});
            });

            initEditor($rootScope);

            var pusherFnList = {
                'task': taskFn,

                'mail.send': mailSendFn,
                'bulletin.send': bulletinSendFn,
                'file.release': fileReleaseFn,
                'meeting.send': meetingSendFn,
                'mission.send': missionSendFn,
                'news.send': newsSendFn,
                'rule.send': ruleSendFn
            };

            angular.forEach(pusherFnList, function (fn, evtName) {
                $scope.$on(C.P + evtName, fn);
            });


            var defer = $q.defer();
            // 等待header初始化完成
            $scope.$on('headerLoaded', function () {
                defer.resolve();
            });

            $q.all([
                $http.get('api/v1/main'),
                defer.promise
            ]).then(function (respArray) {
                var resp = respArray[0];
                var data = resp.data;
                var header = $scope.header;
                header.mails = data.mails;
                account = data.account;
                setupMenuItems(data.menuItems);

                Auth.setAccount(account);
                Auth.setVisitCnt(data.loginCnt, data.apiCnt);
                header.account = vm.account = account;
                checkIfUnConfirmUpdate(account);
                checkLevel(account);
                setWaterMark(data.watermarkAlpha);
            });

            hasTask();
        }

        function hasTask() {
            $http.get('/api/v1/has_task').then(function (resp) {
                var header = $scope.header;
                var data = resp.data;
                header.hasTask = data.hasTask;
                if (data.laterSeconds && data.laterSeconds > 0) {
                    // 添加延时器
                    $timeout(function () {
                        hasTask();
                    }, data.laterSeconds * 1000);
                }
            });
        }

        function setWaterMark(watermarkAlpha) {
            $ocLazyLoad.load(['watermark']).then(function () {
                var now = new Date();
                var formattedDate = $filter('date')(now, 'yyyyMMdd');
                watermark.init({
                    watermark_txt: account.name + '\n' + formattedDate + ' ' + account.username,
                    watermark_width: 160,
                    watermark_alpha: watermarkAlpha ? watermarkAlpha : 0.1,
                    watermark_parent_node: 'notice',
                });
            });
        }

        function setupMenuItems(menuItems) {
            var pendingState = $rootScope.pendingState;
            var pendingParams = $rootScope.pendingParams;
            var states = $state.get();
            angular.forEach(states, function (s) {
                s.can = angular.isUndefined(s.params);
            });

            var index = 0;
            angular.forEach(menuItems, function (item) {
                index++;
                angular.forEach(item.children, function (m) {
                    m.state = ArrayHelper.getItem(m.id, states, 'perm');
                    if (m.state) {
                        m.state.can = true;
                        m.state.index = index;
                        if (pendingState && pendingState.name === m.state.name) {
                            $timeout(function () {
                                $rootScope.collapseVar = index;
                                $state.go(m.state.name, pendingParams);
                            });
                            delete $rootScope.pendingState;
                            delete $rootScope.pendingParams;
                        }
                    } else {
                        Dlg.notify('未注册菜单:' + m.id);
                    }
                });
            });
            if ($rootScope.pendingState) {
                $timeout(function () {
                    Dlg.notify("您没有访问该页面的权限，请求被中止");
                });
            }
            $scope.sidebar.menuItems = menuItems;

            // var showSidebar = window.innerWidth > 768;

            //东哥要求进入系统手机上默认展开菜单
            var showSidebar = true;
            if (showSidebar !== vm.showSidebar) {
                $rootScope.$broadcast('showSidebar', showSidebar);
            }
        }

        function initEditor(vm) {
            vm.onCKReady = UIHelper.onCKReady;
        }

        function checkIfUnConfirmUpdate(account) {
            if (account.confirm_state === 0) {
                dialogs.create('templates/user_edit_dlg.html', 'UserEditCtrl',
                    {
                        user_id: account.id,
                        user_type: account.type,
                        confirm_state: '1'
                    }, {size: 'lg'}).result.then(function (params) {
                    toaster.success('用户信息已确认');
                    account.confirm_state = 1; //1表示用户已确认
                    account.photo = params.photo;
                    Auth.setAccount(account);
                    $scope.header.account = $scope.account = account;
                });
            }
        }

        function checkLevel(account) {
            if (!account.level) {
                dialogs.create('templates/userLevelDlg.html', 'UserLevelDlgCtrl',
                    {
                        id: account.id
                    }, {size: 'md'}, 'vm');
            }
        }

        function mailSendFn(event, data) {
            // var mail = data.data.mail;
            // if (ArrayHelper.inArray(account.id, mail.recipients) >= 0) {
            //     Dlg.msg('新邮件', "你有一封新邮件《" + mail.subject + "》,点击查阅", function () {
            //         dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
            //             {size: 'lg'}).result.then(function (params) {
            //             switch (params.opt) {
            //                 case 1:
            //                     $state.go('app.coop_email', {
            //                         data: {
            //                             tab: 'write',
            //                             event: 'mailReply',
            //                             mail: params.mail
            //                         }
            //                     });
            //                     break;
            //                 case 2:
            //                     $state.go('app.coop_email', {
            //                         data: {
            //                             tab: 'write',
            //                             event: 'mailForward',
            //                             mail: params.mail
            //                         }
            //                     });
            //                     break;
            //                 case 3:
            //                     Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
            //                         function () {
            //                             $rootScope.$broadcast('mailDel', mail.id);
            //                         },
            //                         function () {
            //                             toaster.error('邮件删除失败!');
            //                         }
            //                     );
            //                     break;
            //             }
            //         });
            //     });
            //     $rootScope.$broadcast("mail.send", mail);
            // }
        }

        function taskFn(event, data) {
            var task = data.data.task;
            if (ArrayHelper.inArray(account.id, task.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: task.task});
            }
        }

        function bulletinSendFn(event, data) {
            // var bulletin = data.data.task;
            // switch (bulletin.is_pass) {
            //     case C.STAGE1.DEPT_APPROVAL:
            //     case C.STAGE1.HOSPITAL_APPROVAL:
            //         if (ArrayHelper.inArray(account.id, bulletin.approvers) >= 0) {
            //             $rootScope.$broadcast("newTask", {task: bulletin.task});
            //         }
            //         break;
            //     case C.STAGE1.PUBLIC:
            //         $rootScope.$broadcast("bulletin.send", bulletin);
            //         Dlg.msg('新公告', bulletin.dept + "发布了新公告《" + bulletin.title + "》,点击查阅", function () {
            //             dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
            //                 id: bulletin.id
            //             }, {
            //                 size: 'lg'
            //             });
            //         });
            //         break;
            // }
        }

        function newsSendFn(event, data) {
            // var news = data.data.task;
            // // if (ArrayHelper.inArray(account.id, news.approvers) >= 0 && (news.is_pass == 0 || news.is_pass == 2)) {
            // //     $rootScope.$broadcast("newTask", {task: news.task});
            // // } else if (news.is_pass == 4 || news.is_pass == 6) {
            // $rootScope.$broadcast("news.send", news);
            // Dlg.msg('新闻', news.dept + "发布了新闻《" + news.title + "》,点击查阅", function () {
            //     dialogs.create('templates/article/show_dlg.html', 'NewsMainShowDlgCtrl', {
            //         id: news.id
            //     }, {
            //         size: 'lg'
            //     });
            // });
            // }
        }

        function meetingSendFn(event, data) {
            // var meeting = data.data.task;
            // switch (meeting.stage) {
            //     case C.STAGE1.DEPT_APPROVAL:
            //     case C.STAGE1.HOSPITAL_APPROVAL:
            //         if (ArrayHelper.inArray(account.id, meeting.approvers) >= 0) {
            //             $rootScope.$broadcast("newTask", {task: meeting.task});
            //         }
            //         break;
            //     case C.STAGE1.PUBLIC:
            //         if (ArrayHelper.inArray(account.id, meeting.attendees) >= 0) {
            //             $rootScope.$broadcast("meeting.send", meeting);
            //             Dlg.msg('新会议', meeting.dept.name + "发布了新会议《" + meeting.name + "》,点击查阅", function () {
            //                 dialogs.create('templates/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
            //                     id: meeting.id
            //                 }, {
            //                     size: 'lg'
            //                 });
            //             });
            //         }
            //         break;
            // }
        }

        function missionSendFn(event, data) {
            // var mission = data.data.task;
            // if (ArrayHelper.inArray(account.id, mission.attendees) >= 0) {
            //     $rootScope.$broadcast("mission.send", mission);
            //     Dlg.msg('任务通知', '您加入了任务《' + mission.name + "》,点击查阅", function () {
            //         dialogs.create('templates/mission/missionShowDlg.html', 'MissionShowDetailDlgCtrl', {
            //             id: mission.id
            //         }, {
            //             size: 'lg'
            //         });
            //     });
            // }
        }

        function fileReleaseFn(event, data) {
            // var file = data.data.task;
            // if (ArrayHelper.inArray(account.id, file.approvers) >= 0) {
            //     $rootScope.$broadcast("newTask", {task: file.task});
            // } else if (file.state == C.STAGE3.PUBLIC &&
            //     ((file.release_type == 2 && ArrayHelper.inArray(account.id, file.receivers) >= 0) || file.release_type == 3)) {
            //     $rootScope.$broadcast("file.release", file);
            //     Dlg.msg('文件发布', file.dept + "发布了文件《" + file.name + "》,点击下载", function () {
            //         var params = {filename: file.filename, mime: file.mime};
            //         file.downloading = true;
            //         FileHelper.download(C.URL.FILE_CABINET_DOWNLOAD, params, function (resp) {
            //             file.downloading = false;
            //             var data = [resp];
            //             var options = {type: file.mime};
            //             SaveAs.download(data, file.name, options);
            //         }, function (error) {
            //             file.downloading = false;
            //             //toaster.error('服务端文件丢失,请联系管理员!');
            //         });
            //     });
            // }
        }

        function ruleSendFn(event, data) {
            // var rule = data.data.task;
            // switch (rule.stage) {
            //     case C.STAGE6.DEPT_APPROVAL:
            //     case C.STAGE6.HOSPITAL_APPROVAL:
            //         if (ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
            //             $rootScope.$broadcast("newTask", {task: rule.task});
            //         }
            //         break;
            //     case C.STAGE6.PUBLIC:
            //         if (rule.class == 1 && ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
            //             $rootScope.$broadcast("rule.send", rule);
            //             Dlg.msg('新规章制度', rule.dept.name + "发布了新规章制度《" + rule.subject + "》,点击查阅", function () {
            //                 dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
            //                     id: rule.id
            //                 }, {
            //                     size: 'lg'
            //                 });
            //             });
            //         }
            //         if (rule.class == 2) {
            //             $rootScope.$broadcast("rule.send", rule);
            //             Dlg.msg('新规章制度', rule.dept.name + "发布了新规章制度《" + rule.subject + "》,点击查阅", function () {
            //                 dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
            //                     id: rule.id
            //                 }, {
            //                     size: 'lg'
            //                 });
            //             });
            //         }
            //         break;
            //     case C.STAGE6.DISABLE:
            //         if (rule.class == 1 && ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
            //             $rootScope.$broadcast("rule.send", rule);
            //             Dlg.msg('停用规章制度', rule.dept.name + "停用了规章制度《" + rule.subject + "》,点击查阅", function () {
            //                 dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
            //                     id: rule.id
            //                 }, {
            //                     size: 'lg'
            //                 });
            //             });
            //         }
            //         if (rule.class == 2) {
            //             $rootScope.$broadcast("rule.send", rule);
            //             Dlg.msg('停用规章制度', rule.dept.name + "停用了规章制度《" + rule.subject + "》,点击查阅", function () {
            //                 dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
            //                     id: rule.id
            //                 }, {
            //                     size: 'lg'
            //                 });
            //             });
            //         }
            //         break;
            // }
            //
            // if ((rule.red_head == C.STAGE7.RED_HEAD_APPROVAL || rule.red_head == C.STAGE7.RED_HEAD_HOSPITAL_APPROVED)
            //     && ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
            //     $rootScope.$broadcast("newTask", {task: rule.task});
            // }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('TabCtrl', TabCtrl);

    /** @ngInject */
    function TabCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();

angular.module('c.c')
    .controller('WechatAuthCtrl', function ($scope, $state, $location, Api, C, F, WxHelper, Auth) {
        // 获取返回参数 code 和 state
        var qs = $location.search();
        var code = qs.code;
        var state = qs.state;
        WxHelper.getWechatToken(code, state).then(function (data) {
            switch (data.result) {
                case 0:
                    Auth.setToken(data.token, false);
                    Auth.setToken(data.token, false);
                    Auth.setAccount(data.account);
                    // $state.go('app.home');
                    if (qs.toState) {
                        if (qs.toParams) {
                            $state.go(qs.toState, JSON.parse(qs.toParams), {
                                location: 'replace'
                            });
                        } else {
                            $state.go(qs.toState, null, {
                                location: 'replace'
                            });
                        }
                    } else {
                        $state.go('app.home', null, {
                            location: 'replace'
                        });
                    }
                    break;
                case 1:
                    Api.e(data.msg);
                    break;
                case 2:  //用户未绑定微信
                case 3:
                    Api.w(data.msg);
                    //$state.go('login');
                    window.location.href = C.URL.WX_BIND;
                    break;
            }
        });
    });
/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Float', Float);

    /** @ngInject */
    function Float() {
        var service = {
            toFixed: toFixed
        };

        return service;


        function toFixed(floatNum, decimal) {
            if (angular.isUndefined(decimal)) decimal = 2;
            return parseFloat(floatNum.toFixed(decimal));
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Api', apiService);

    /** @ngInject */
    function apiService($ocLazyLoad, $compileProvider, toaster, ArrayHelper, Dlg, $http) {
        var service = {

            setStop: setStop,
            /**
             * @deprecated 请用Dlg.delTableItem 替代
             */
            delTableItem: Dlg.delTableItem,
            /**
             * @deprecated 请用Dlg.addEdit 替代
             */
            addEdit: Dlg.addEdit,

            setDisable: setDisable,

            respMsg: respMsg,
            errMsg: errMsg,

            /**
             * @deprecated use Dlg.w instead
             */
            w: Dlg.w,
            /**
             * @deprecated use Dlg.e instead
             */
            e: Dlg.e,
            /**
             * @deprecated use Dlg.s instead
             */
            s: Dlg.s,
            /**
             * @deprecated use Dlg.i instead
             */
            i: Dlg.i,

            /**
             * @deprecated 请用Dlg.exportDR替代
             */
            exportDR: Dlg.exportDR,
            /**
             * @deprecated 请用Dlg.comment替代
             */
            comment: Dlg.comment,

            EDIT: {
                SAVE: 1,
                STOP: 2
            },

            param2Url: param2Url,

            //身份证检查和手机号码检查
            checkId: checkId,
            checkPhone: checkPhone,

            loadQuestionOpt: loadQuestionOpt,

            //数值转化
            numConversion: numConversion,
            getBirthByIdCard: getBirthByIdCard,

            loadMod: loadMod,
            idCardLoadFn: idCardLoadFn,
            usernameLoadFn: usernameLoadFn,
            passPortLoadFn: passPortLoadFn,
        };

        return service;


        function loadMod(mod, fn) {
            var debugEnabled = $compileProvider.debugInfoEnabled();
            if (debugEnabled) {
                fn();
            } else {
                $ocLazyLoad.load(['/ocLazyLoad/mod/' + mod + '.js',
                    '/ocLazyLoad/mod/' + mod + '.css']).then(fn);
            }
        }


        function idCardLoadFn(searchStr) {
            return $http.get('/api/home/patients/idcards?start=' + searchStr);
        }

        function usernameLoadFn(searchStr) {
            return $http.get('/api/v1/users/username?start=' + searchStr)
        }

        function passPortLoadFn(searchStr) {
            return $http.get('/api/home/patients/passPorts?start=' + searchStr);
        }

        function respMsg(resp) {
            if (resp.result === 0) {
                Dlg.s(resp.msg);
                return true;
            } else {
                Dlg.error(resp.msg);
                return false;
            }
        }

        function errMsg(error) {
            var resp = error.data;
            if (resp.msg) Dlg.error(resp.msg);
        }

        /**
         * 停用/启用某数据项，
         * @param s 服务
         * @param m 数据项
         */
        function setStop(s, m) {
            s.update({id: m.id}, {opt: service.EDIT.STOP, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        /**
         * 利用ApiController新写法时推荐用此方法替代setStop
         * @param s service
         * @param m model
         */
        function setDisable(s, m, successFn, otherPa) {
            var requirePa = {
                op: angular.isDefined(s.DISABLE_STOP) ? s.DISABLE_STOP : 'disable',
                is_stop: !m.is_stop
            };
            if (otherPa) {
                angular.extend(requirePa, otherPa);
            }
            s.update({id: m.id}, requirePa).$promise.then(function (resp) {
                if (successFn) {
                    successFn(resp);
                } else {
                    m.is_stop = !m.is_stop;
                }
            });
        }

        ///////////////////////////////////////

        function param2Url(params) {
            var pairs = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var item = params[key],
                        name = encodeURIComponent(key);
                    if (typeof item === "object") {
                        for (var subkey in item) {
                            if (!angular.isUndefined(item[subkey]) && item[subkey] !== "") {
                                var pname = name + "[" + encodeURIComponent(subkey) + "]";
                                pairs[pname] = item[subkey];
                            }
                        }
                    } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== "") {
                        pairs[name] = encodeURIComponent(item);
                    }
                }
            }
            return pairs;
        }

        /////////////////////////////////////

        function checkPhone(phone) {
            var phoneCheck = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
            return phoneCheck.test(phone);
        }

        function checkId(pId) {
            return pId != null && pId.length == 18;
            //检查身份证号码
            // pId = pId.toUpperCase();
            // var arrVerifyCode = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
            // var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            // if (pId.length != 15 && pId.length != 18) return false;
            // var Ai = pId.length == 18 ? pId.substring(0, 17) : pId.slice(0, 6) + "19" + pId.slice(6, 16);
            // if (!/^\d+$/.test(Ai)) return false;
            // var yyyy = Ai.slice(6, 10), mm = Ai.slice(10, 12) - 1, dd = Ai.slice(12, 14);
            // var d = new Date(yyyy, mm, dd), now = new Date();
            // var nowdate = now.getFullYear();
            // var year = d.getFullYear(), mon = d.getMonth(), day = d.getDate();
            // if (year != yyyy || mon != mm || day != dd || d > now || year < 1800) return false;
            // if (nowdate - year < 14) return false;
            // for (var i = 0, ret = 0; i < 17; i++) ret += Ai.charAt(i) * Wi[i];
            // Ai += arrVerifyCode[ret %= 11];
            // return pId.length == 18;
        }


        function numConversion(m, array) {
            angular.forEach(array, function (str) {
                m[str] = !m[str] || m[str] === '0' ? '未填' : m[str]
            });
        }

        function getBirthByIdCard(idCard) {
            var birth = '1975-01-01';
            if (idCard) {
                birth = idCard.substring(6, 10) + "-" + idCard.substring(10, 12) + "-" + idCard.substring(12, 14)
            }
            return birth;
        }


        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        function loadQuestionOpt(vm) {
            vm.upOption = upOption;
            vm.downOption = downOption;
            vm.rmOption = rmOption;
            vm.addOption = addOption;
            vm.optionOnFocus = optionOnFocus;
            vm.correctOptionDesc = correctOptionDesc;
            vm.isMultiSelect = isMultiSelect;
            vm.checkMaxOptions = checkMaxOptions;
        }

        function upOption(question, index) {
            ArrayHelper.swap(question.options, index, index - 1);
        }

        function downOption(question, index) {
            ArrayHelper.swap(question.options, index, index + 1);
        }

        function rmOption(question, index) {
            if (question.options.length === 1) {
                toaster.warning('每个问题至少一个选项!');
            } else {
                question.options.splice(index, 1);
            }
        }

        function addOption(question) {
            question.options.push({
                desc: '选项' + (question.options.length + 1),
            });
        }

        function optionOnFocus(option, $index, $event) {
            if (option.desc === '选项' + $index) {
                $event.target.select();
            }
        }

        function correctOptionDesc(option, index) {
            if (!option.desc.length) {
                option.desc = '选项' + index;
            }
        }

        function isMultiSelect(question) {
            return question.type === 2;
        }

        function checkMaxOptions(question) {
            if (question.type === 2 && question.max_options) {
                if (question.max_options < 1) {
                    toaster.warning('最多可选不能小于2!');
                    question.max_options = '';
                } else if (question.max_options > question.options.length) {
                    toaster.warning('最多可选不能大于选项数!');
                    question.max_options = '';
                }
            }
            return true;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('ArrayHelper', ArrayHelper);

    /** @ngInject */
    function ArrayHelper($timeout, $injector) {
        var service = {
            inArray: inArray,
            indexOf: inArray,
            except: except,
            getItem: getItem,
            indexOfKey: indexOfKey,
            findItem: findItem,
            getItems: getItems,
            listKey: listKey,
            get: get,
            swap: swap,
            mergeObj: mergeObj,
            bitwise2array: bitwise2array,
            array2bitwise: array2bitwise,
            inFirstButNotInSecond: inFirstButNotInSecond,
            shuffle: shuffle,
            map: map,
            filter: filter,
            first: first
        };

        var l = null;
        $timeout(function () {
            var $http = $injector.get('$http');
            $http.get('json/options.json').success(function (resp) {
                l = resp;
            });
        });

        return service;


        function get(key) {
            return l[key];
        }

        function map(arr, mapFn) {
            var mapArr = [];
            angular.forEach(arr, function (item, key) {
                mapArr.push(mapFn(item, key));
            });
            return mapArr;
        }

        /**
         * 打乱数组顺序
         * @param a
         */
        function shuffle(a) {
            var j, x, i;
            for (i = a.length; i; i--) {
                j = Math.floor(Math.random() * i);
                x = a[i - 1];
                a[i - 1] = a[j];
                a[j] = x;
            }
        }

        /**
         * 合并对象
         * @param o1
         * @param o2
         * @returns {*}
         */
        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }

        function array2bitwise(a) {
            var b = 0;
            for (var i = 0; i < a.length; i++) {
                if (a[i]) {
                    b |= (1 << i);
                }
            }
            return b;
        }

        /**
         * 位图转数组
         * @param b
         * @param n
         * @returns {Array}
         */
        function bitwise2array(b, n) {
            var a = [];
            for (var i = 0; i < n; i++) {
                a[i] = (b & 1) === 1;
                b >>= 1;
            }
            return a;
        }

        function swap(arr, indexA, indexB) {
            var temp = arr[indexA];
            arr[indexA] = arr[indexB];
            arr[indexB] = temp;
        }

        function inArray(val, arr) {
            var i = arr.length;
            while (i--) {
                if (angular.equals(val, arr[i])) return i;
            }
            return -1
        }

        function listKey(items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                result.push(items[i][key]);
            }
            return result;
        }

        function getItems(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                if (items[i][key] == value) {
                    result.push(items[i]);
                }
            }
            return result;
        }

        function findItem(value, items) {
            var i = -1;
            while (++i < items.length) {
                if (items[i] == value)
                    return i;
            }
            return -1;
        }

        function except(exceptId, items) {
            var itemsExp = [];
            angular.forEach(items, function (item) {
                if (exceptId != item.id) {
                    itemsExp.push(item);
                }
            });
            return itemsExp;
        }

        function getItem(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return items[i];
            }
            return null;
        }

        function indexOfKey(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return i;
            }
            return -1;
        }

        function filter(arr, filterFn) {
            var filterArr = [];
            angular.forEach(arr, function (item) {
                if (filterFn(item)) filterArr.push(item);
            });
            return filterArr;
        }

        function first(arr, searchFn) {
            if (!searchFn && arr.length > 0) return arr[0];
            for (var i = 0; i < arr.length; i++) {
                var item = arr[i];
                if (searchFn(item)) return item;
            }
            return null;
        }

        function inFirstButNotInSecond(arr1, arr2, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            return filter(arr1, function (item) {
                return indexOfKey(item[key], arr2, key) < 0;
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Auth', Auth);

    /** @ngInject */
    function Auth($timeout, $injector, $localStorage, $sessionStorage) {
        var storage;
        var service = {
            CODE: {
                TOKEN_INVALID: 1,
                TOKEN_EXPIRED: 2,
                TOKEN_DEAD: 3,
                LOGIN: 4
            },

            setAccount: setAccount,
            getAccount: getAccount,
            getAutoLogin: getAutoLogin,
            setAutoLogin: setAutoLogin,
            getVisitCnt: getVisitCnt,
            setVisitCnt: setVisitCnt,
            setToken: setToken,
            getToken: getToken,
            hasToken: hasToken,
            deleteToken: deleteToken,
            register: register,
            login: login,
            logout: logout,
            refreshToken: refreshToken,
        };

        var $http;

        init();

        return service;


        function init() {
            $timeout(function () {
                $http = $injector.get('$http');
            }, 0);
            storage = getAutoLogin() ? $localStorage : $sessionStorage;
        }

        function logout(success) {
            $http.post('/auth/token/revoke').finally(function () {
                deleteToken();
                success();
            });
        }

        function refreshToken() {
            return $http.post('/auth/token/refresh')
        }

        function login(data, successFn, errorFn) {
            $http.post('/auth/token/issue', data).success(function (resp) {
                setAutoLogin(data.autoLogin);
                setToken(resp.token);
                setAccount(resp.account);
                if (successFn) {
                    successFn(resp);
                }
            }).error(function (resp) {
                if (errorFn) {
                    errorFn(resp);
                }
            });
        }

        function getAutoLogin() {
            return !!$localStorage.autoLogin;
        }

        function setAutoLogin(autoLogin) {
            $localStorage.$reset();
            autoLogin = !!autoLogin;
            $localStorage.autoLogin = autoLogin;
            storage = autoLogin ? $localStorage : $sessionStorage;
        }

        function register(data, success, error) {
            $http.post('/auth/register', data).success(success).error(error);
        }

        function deleteToken(excludeAccount) {
            delete storage.token;
            if (!excludeAccount) delete storage.account;
        }

        function hasToken() {
            return storage.token;
        }

        function getToken() {
            return storage.token;
        }

        function setToken(token) {
            storage.token = token;
        }


        function getVisitCnt() {
            if (storage.loginCnt) {
                return {loginCnt: storage.loginCnt, apiCnt: storage.apiCnt};
            }
            return undefined;
        }

        function setVisitCnt(loginCnt, apiCnt) {
            storage.loginCnt = loginCnt;
            storage.apiCnt = apiCnt;
        }

        function getAccount() {
            return storage.account || {};
        }

        function setAccount(account) {
            storage.account = account;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('D3Helper', D3Helper);

    /** @ngInject */
    function D3Helper($rootScope) {
        var service = {
            updateImg: updateImg
        };

        return service;

        function updateImg(source, root, i, duration, diagonal, tree, svg) {
            // Compute the new tree layout.
            var nodes = tree.nodes(root).reverse(),
                links = tree.links(nodes);

            // Normalize for fixed-depth.
            nodes.forEach(function (d) {
                d.y = d.depth * 180;
            });

            // Update the nodes…
            var node = svg.selectAll("g.node")
                .data(nodes, function (d) {
                    return d.id || (d.id = ++i);
                });

            // Enter any new nodes at the parent's previous position.
            var nodeEnter = node.enter().append("g")
                .attr("class", "node")
                .attr("transform", function (d) {
                    return "translate(" + source.y0 + "," + source.x0 + ")";
                })
                .on("click", click);

            nodeEnter.append("circle")
                .attr("r", 1e-6)
                .style("fill", function (d) {
                    return "#fff";
                });

            nodeEnter.append("text")
                .attr("x", function (d) {
                    return d.children || d._children ? -13 : 13;
                })
                .attr("dy", ".35em")
                .attr("text-anchor", function (d) {
                    return d.children || d._children ? "end" : "start";
                })
                .text(function (d) {
                    return d.name;
                })
                .style("fill-opacity", 1e-6);

            // Transition nodes to their new position.
            var nodeUpdate = node.transition()
                .duration(duration)
                .attr("transform", function (d) {
                    return "translate(" + d.y + "," + d.x + ")";
                });

            nodeUpdate.select("circle")
                .attr("r", 10)
                .style("fill", function (d) {
                    return d.color;
                });

            nodeUpdate.select("text")
                .style("fill-opacity", 1);

            // Transition exiting nodes to the parent's new position.
            var nodeExit = node.exit().transition()
                .duration(duration)
                .attr("transform", function (d) {
                    return "translate(" + source.y + "," + source.x + ")";
                })
                .remove();

            nodeExit.select("circle")
                .attr("r", 1e-6);

            nodeExit.select("text")
                .style("fill-opacity", 1e-6);

            // Update the links…
            var link = svg.selectAll("path.link")
                .data(links, function (d) {
                    return d.target.id;
                });

            // Enter any new links at the parent's previous position.
            link.enter().insert("path", "g")
                .attr("class", "link")
                .attr("d", function (d) {
                    var o = {x: source.x0, y: source.y0};
                    return diagonal({source: o, target: o});
                });

            // Transition links to their new position.
            link.transition()
                .duration(duration)
                .attr("d", diagonal);

            // Transition exiting nodes to the parent's new position.
            link.exit().transition()
                .duration(duration)
                .attr("d", function (d) {
                    var o = {x: source.x, y: source.y};
                    return diagonal({source: o, target: o});
                })
                .remove();

            // Stash the old positions for transition.
            nodes.forEach(function (d) {
                d.x0 = d.x;
                d.y0 = d.y;
            });

            // Toggle children on click.
            function click(d) {
                $rootScope.$broadcast('d3NodeClick', d);
                console.log(d);

                //收缩子节点
                // if (d.children) {
                //     d._children = d.children;
                //     d.children = null;
                // } else {
                //     d.children = d._children;
                //     d._children = null;
                // }
                // updateImg(d, root, i, duration, diagonal, tree, svg);
            }
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('DateHelper', DateHelper);

    /** @ngInject */
    function DateHelper($filter, uibDateParser, $ocLazyLoad) {
        var service = {
            date2Str: date2Str,
            datetime2Str: datetime2Str,
            time2Str: time2Str,
            str2Date: str2Date,
            str2Datetime: str2Datetime,
            str2time: str2time,
            getDaysInMonth: getDaysInMonth,
            diffInDays: diffInDays,
            absDiffInDays: absDiffInDays,
            diffInDays2: diffInDays2,
            diffInHours: diffInHours,
            diffInMinutes: diffInMinutes,
            sec2MinSec: sec2MinSec,
            areSameDate: areSameDate,
            linarCalendar: linarCalendar,
            toLocalTime: toLocalTime,

            getWeekdays: getWeekdays,
            weekOfYear: weekOfYear,
            date2LunarStr: date2LunarStr,
            birthdayToAge: birthdayToAge,
            min2DayHourMin: min2DayHourMin,
            isSameDay: isSameDay

        };

        return service;


        function min2DayHourMin(StatusMinute) {
            var day = parseInt(StatusMinute / 60 / 24);
            var hour = parseInt(StatusMinute / 60 % 24);
            var min = parseInt(StatusMinute % 60);
            StatusMinute = "";
            if (day > 0) {
                StatusMinute = day + "天";
            }
            if (hour > 0) {
                StatusMinute += hour + "小时";
            }
            if (min > 0) {
                StatusMinute += parseFloat(min) + "分钟";
            }
            return StatusMinute === "" ? "0分钟" : StatusMinute;
        }


        function sec2MinSec(sec) {
            var r = '';
            var m = Math.floor(sec / 60);
            if (m > 0) {
                r += m + '分';
            }
            var s = sec % 60;
            if (s > 0) {
                r += s + '秒';
            }
            return r;
        }

        function toLocalTime(utcTime) {
            var u = new Date(utcTime);
            var l = u.getTime() - (u.getTimezoneOffset() * 60000);
            l = new Date(l);
            return l;

        }

        function areSameDate(d1, d2) {
            return d1.getFullYear() == d2.getFullYear()
                && d1.getMonth() == d2.getMonth()
                && d1.getDate() == d2.getDate();
        }

        function diffInMinutes(start, end) {
            return Math.floor((end - start) / (1000 * 60));
        }

        function diffInHours(start, end) {
            return Math.floor((end - start) / (1000 * 60 * 60));
        }

        function diffInDays(start, end) {
            return Math.round((end - start) / (1000 * 60 * 60 * 24));
        }

        function absDiffInDays(start, end) {
            start.setHours(0, 0, 0);
            end.setHours(0, 0, 0);
            return Math.abs(diffInDays(start, end));
        }

        function diffInDays2(start, end) {
            var nStart = str2Date(date2Str(start));
            var nEnd = str2Date(date2Str(end));
            return Math.round((nEnd - nStart) / (1000 * 60 * 60 * 24));
        }

        function getDaysInMonth(m, y) {
            return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
        }

        function date2LunarStr(date) {
            $ocLazyLoad.load(['lunarCalendar']).then(function () {
                var lunar = lunarCalendar.solar2lunar(date.getFullYear(), (date.getMonth() + 1), date.getDate());
                return lunar.IMonthCn + ' ' + lunar.IDayCn;
            })
        }

        function date2Str(date, fmt) {
            if (!fmt) fmt = "yyyy-MM-dd";
            return $filter('date')(date, fmt);
        }

        function datetime2Str(datetime) {
            return $filter('date')(datetime, "yyyy-MM-dd HH:mm");
        }

        function time2Str(time) {
            return $filter('date')(time, "HH:mm");
        }

        function str2Date(str) {
            return uibDateParser.parse(str, "yyyy-MM-dd");
        }

        function str2Datetime(str) {
            return uibDateParser.parse(str, "yyyy-MM-dd HH:mm");
        }


        function str2time(str) {
            return uibDateParser.parse(str, "HH:mm:ss");
        }

        function linarCalendar(vm, lunarWeekdays, curr) {
            $ocLazyLoad.load(['lunarCalendar']).then(function () {
                vm.lunarCalendars = [];
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        lunarWeekdays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = lunarWeekdays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        lunarWeekdays[i] = now;
                    }
                    var d = lunarWeekdays[i];
                    var c = lunarCalendar.solar2lunar(d.getFullYear(), (d.getMonth() + 1), d.getDate());
                    var cStr = c.IMonthCn + ' ' + c.IDayCn
                    vm.lunarCalendars.push(cStr);
                }
            });
        }

        function getWeekdays() {
            return [
                {id: 1, name: "周一", alias: "星期一"},
                {id: 2, name: "周二", alias: "星期二"},
                {id: 3, name: "周三", alias: "星期三"},
                {id: 4, name: "周四", alias: "星期四"},
                {id: 5, name: "周五", alias: "星期五"},
                {id: 6, name: "周六", alias: "星期六"},
                {id: 0, name: "周日", alias: "星期天"}
            ];
        }

        function isLeapYear(year) {
            return (year % 400 == 0) || (year % 4 == 0 && year % 100 != 0);
        }

        function getMonthDays(year, month) {
            return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month] || (isLeapYear(year) ? 29 : 28);
        }

        function weekOfYear(date) {
            console.log(date);
            var year = date.getFullYear(),
                month = date.getMonth(),
                days = date.getDate();
            //那一天是那一年中的第多少天
            for (var i = 0; i < month; i++) {
                days += getMonthDays(year, i);
            }

            //那一年第一天是星期几
            var yearFirstDay = new Date(year, 0, 1).getDay() || 7;

            var week = null;
            if (yearFirstDay == 1) {
                week = Math.ceil(days / 7);
            } else {
                days -= (7 - yearFirstDay + 1);
                week = Math.ceil(days / 7);
                if (week == 0) {
                    var lastYear = new Date(year - 1, 11, getMonthDays(year - 1, 11));
                    week = weekOfYear(lastYear);
                }
            }

            console.log(week);
            return week;
        }

        /**
         * 出生日期转年龄
         * @param strBirthday
         * @returns string
         */
        function birthdayToAge(strBirthday) {
            var returnAge;
            var strBirthdayArr = strBirthday.split("-");
            var birthYear = strBirthdayArr[0];
            var birthMonth = strBirthdayArr[1];
            var birthDay = strBirthdayArr[2];

            var d = new Date();
            var nowYear = d.getFullYear();
            var nowMonth = d.getMonth() + 1;
            var nowDay = d.getDate();

            if (nowYear == birthYear) {
                returnAge = 0;//同年 则为0岁
            } else {
                var ageDiff = nowYear - birthYear; //年之差
                if (ageDiff > 0) {
                    if (nowMonth == birthMonth) {
                        var dayDiff = nowDay - birthDay;//日之差
                        if (dayDiff < 0) returnAge = ageDiff - 1;
                        else returnAge = ageDiff;
                    } else {
                        var monthDiff = nowMonth - birthMonth;//月之差
                        if (monthDiff < 0) returnAge = ageDiff - 1;
                        else returnAge = ageDiff;
                    }
                } else returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
            }
            return returnAge;
        }

        function isSameDay(startTime, endTime) {
            var startTimeMs = new Date(startTime).setHours(0,0,0,0);
            var endTimeMs = new Date(endTime).setHours(0,0,0,0);
            return startTimeMs === endTimeMs;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Dlg', Dlg);

    /** @ngInject */
    function Dlg ($q, dialogs, toaster, FormHelper) {
        var service = {
            TP: {  // toast position
                BR: 1,  // bottom right
                TR: 2   // top right
            },
            show: ds,
            notify: dn,
            error: de,
            confirm: dc,

            w: w,
            e: e,
            s: s,
            i: i,

            msg: msg,
            formError: formError,
            delTableItem: delTableItem,
            delTableItem2: delTableItem2,
            addEdit: addEdit,
            addEdit2: addEdit2,
            addEditOk: addEditOk,

            comment: comment,
            exportDR: exportDR,
            exportDRWithParams: exportDRWithParams,
            exportMR: exportMR,
            exportMS: exportMS,
            exportYR: exportYR,
            exportMRC: exportMRC,
            exportDRC: exportDRC,

            batchExportDR: batchExportDR,

            loadScrollbar: loadScrollbar
        };

        return service;


        function addEditOk (vm, service, paFn, args) {
            var m, form, formIdSelector, op;
            var close = true;

            if (angular.isDefined(args)) {
                op = args.op;
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.m) m = args.m;
                if (args.form) form = args.form;
                if (args.close != null) close = args.close
            } else {
                op = 'default';
                formIdSelector = '#Form';
            }
            var closeFn = vm.close;
            if (!m) m = vm.m;
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                var promise;
                var pa = paFn();
                if (m.id) { //修改
                    promise = service.update({id: m.id, op: op}, pa).$promise;
                } else { //添加
                    if (!pa.op) pa.op = op;
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) {
                        s(resp.msg);
                    } else {
                        s('保存成功');
                    }
                    if (close) {
                        if (args && args.closePa) {
                            var closePa = args.closePa;
                            closeFn(closePa instanceof Function ? closePa(resp) : closePa);
                        } else {
                            closeFn(resp);
                        }
                    }
                }, function (error) {
                    var data = error.data;
                    if (data.msg) de(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                FormHelper.handleError(formIdSelector, form);
                defer.reject();
            }
            return defer.promise;
        }


        /**
         * 删除表格中的数据项
         * @param s 服务
         * @param id 数据项id
         * @param vm 关联vm
         * @param itemType 数据项类型名称
         * @param itemName 数据项名称
         */
        function delTableItem (s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                + itemType + '吗？')
                .result.then(function () {
                s.delete({id: id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                });
            });
        }

        /**
         * 针对新的控制器的返回，略微小的改动
         * @param s
         * @param id
         * @param vm
         * @param itemType
         * @param itemName
         */
        function delTableItem2 (s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                + itemType + '吗？')
                .result.then(function () {
                s.delete({id: id}).$promise.then(function (resp) {
                    vm.tableReload();
                    toaster.success(resp.msg);
                }, function (err) {
                    if (err.data.msg) toaster.warning(err.data.msg);
                    else toaster.warning(err.msg);
                });
            });
        }

        function addEdit (vm, dlg, dlgCtrl, m, data, dlgSiz) {
            var pa = data ? data : {};
            if (m) pa.id = m.id;
            if (!dlgSiz) dlgSiz = 'md';
            dialogs.create(dlg, dlgCtrl, pa,
                {size: dlgSiz}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function addEdit2 (vm, dlg, dlgCtrl, m, data, dlgSiz, cb) {
            var pa = data ? data : {};
            if (m) pa.id = m.id;
            if (!dlgSiz) dlgSiz = 'md';
            dialogs.create(dlg, dlgCtrl, pa,
                {size: dlgSiz}, 'vm').result.then(function (resp) {
                if (cb) cb(resp);
            });
        }

        function comment (pa, fn) {
            dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', pa, {
                size: 'sm'
            }).result.then(fn);
        }

        function exportDR (url, title, start, end, icon, withTime) {
            if (typeof (withTime) === 'undefined') withTime = false;
            dialogs.create('templates/export/date_range_dlg.html', 'EDRCtrl',
                {title: title, url: url, icon: icon, start: start, end: end, withTime: withTime},
                {size: 'md'});
        }

        function exportDRWithParams (url, title, params, start, end, icon, withTime) {
            if (typeof (withTime) === 'undefined') withTime = false;
            if (typeof (params) === 'undefined') params = {};
            dialogs.create('templates/export/date_range_dlg.html', 'EDR2Ctrl',
                {title: title, url: url, icon: icon, start: start, end: end, withTime: withTime, params: params},
                {size: 'md'});
        }

        function exportMR (url, title, intro, start, end, icon, isLongDownload, fileFormat) {
            var params = url !== null && typeof url === 'object' ?
                url : {
                    title: title, url: url, icon: icon,
                    start: start, end: end, intro: intro
                };
            if (typeof url === 'object') {
                params.isLongDownload = angular.isDefined('url.isLongDownload') ? url.isLongDownload : false;
            } else {
                params.isLongDownload = angular.isDefined('isLongDownload') ? isLongDownload : false;
            }
            params.fileFormat = angular.isDefined(fileFormat) ? fileFormat : '.xls';
            return dialogs.create('templates/export/month_range_dlg.html', 'EMRCtrl',
                params, {size: 'md'}).result;
        }

        /**
         * custom[] F.E.
         * [{
         *     name: stage
         *     title: 阶段
         *     data: vm.stages
         * }]
         */
        function exportMRC (url, title, intro, custom, start, end, icon, isLongDownload) {
            var params = url !== null && typeof url === 'object' ?
                url : {
                    title: title, url: url, icon: icon,
                    start: start, end: end, intro: intro, custom: custom
                };
            if (typeof url === 'object') {
                params.isLongDownload = angular.isDefined('url.isLongDownload') ? url.isLongDownload : false;
            } else {
                params.isLongDownload = angular.isDefined('isLongDownload') ? isLongDownload : false;
            }
            return dialogs.create('templates/export/month_range_custom_dlg.html', 'EMRCCtrl',
                params, {size: 'md'}).result;
        }

        function exportDRC (url, title, custom, start, end, icon, withTime) {
            if (typeof (withTime) === 'undefined') withTime = false;
            dialogs.create('templates/export/date_range_custom_dlg.html', 'EDRCCtrl',
                {title: title, url: url, icon: icon, start: start, end: end, withTime: withTime, custom: custom},
                {size: 'md'});
        }


        function exportMS (url, title, intro, start, end, icon, isLongDownload) {
            var params = url !== null && typeof url === 'object' ?
                url : {
                    title: title, url: url, icon: icon,
                    start: start, end: end, intro: intro
                };
            if (typeof url === 'object') {
                params.isLongDownload = angular.isDefined('url.isLongDownload') ? url.isLongDownload : false;
            } else {
                params.isLongDownload = angular.isDefined('isLongDownload') ? isLongDownload : false;
            }
            return dialogs.create('templates/export/month_single_dlg.html', 'EMSCtrl',
                params, {size: 'md'}).result;
        }

        function exportYR (url, title, intro, start, end, icon, isYearRange, isLongDownload) {
            var params = url !== null && typeof url === 'object' ?
                url : {
                    title: title, url: url, icon: icon,
                    start: start, end: end, intro: intro,
                    isYearRange: isYearRange
                };
            if (typeof url === 'object') {
                params.isYearRange = angular.isDefined('url.isYearRange') ? url.isYearRange : true;
                params.isLongDownload = angular.isDefined('url.isLongDownload') ? url.isLongDownload : false;
            } else {
                params.isYearRange = angular.isDefined('isYearRange') ? isYearRange : true;
                params.isLongDownload = angular.isDefined('isLongDownload') ? isLongDownload : false;
            }

            return dialogs.create('templates/export/year_range_dlg.html', 'EYRCtrl',
                params, {size: 'md'}).result;
        }

        function batchExportDR (url, title, start, end, icon, withTime) {
            if (typeof (withTime) === 'undefined') withTime = false;
            dialogs.create('templates/export/batch_date_range_dlg.html', 'BEDRCtrl',
                {title: title, url: url, icon: icon, start: start, end: end, withTime: withTime},
                {size: 'md'});
        }

        function loadScrollbar (vm) {
            if (window.innerWidth < 568) {
                vm.bodyStyle = {
                    'min-height': window.innerHeight - 200,
                    width: window.innerWidth - 40
                };
            } else {
                vm.bodyStyle = {
                    height: 480
                };
            }
        }

        function msg (title, body, hideFn, noSound) {
            toaster.pop({
                title: title, body: body, bodyOutputType: 'trustedHtml', toasterId: 1,
                clickHandler: function (toast, isCloseButton) {
                    if (!isCloseButton && !angular.isUndefined(hideFn)) {
                        hideFn();
                    }
                    return true;
                },
                onShowCallback: function () {
                    if (!noSound) {
                        document.getElementById('msgTone1').play();
                    }
                }
            });
        }

        function formError () {
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
        }

        function w (msg) {
            toaster.warning(msg);
        }

        function e (msg) {
            toaster.error(msg);
        }

        function s (msg) {
            toaster.success(msg);
        }

        function i (msg) {
            toaster.info(msg);
        }

        /**
         * 显示对话框
         * @param pa： backdrop: true(非模态) false(无背景) 'static'(默认，模态)
         * @returns {*}
         */
        function ds (pa) {
            var options = {};
            if (pa.name) {
                pa.ctrl = pa.name + 'Ctrl';
                if (!pa.template) pa.template = pa.name;
            }
            if (!pa.data) pa.data = {};
            if (!pa.size) options.size = 'md';
            else options.size = pa.size;
            if (pa.backdrop) options.backdrop = pa.backdrop;
            switch (pa.pos) {
                case 'right':  // 目前仅支持right
                    options.windowClass = 'modal-right';
                    options.backdropClass = 'modal-backdrop-light';
            }
            if (pa.size === 'full') options.windowClass += ' modal-full';
            return dialogs.create(pa.template, pa.ctrl, pa.data, options, 'vm').result;
        }

        function dn (msg, title) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.notify(title, msg).result;
        }

        function de (msg, title) {
            if (angular.isUndefined(title)) {
                title = "出错了";
            }
            return dialogs.error(title, msg).result;
        }

        function dc (msg, cb, title, error) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.confirm(title, msg).result.then(cb, error);
        }


    }
})();

/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('c').factory('ExcelHelper', ExcelHelper);

    /** @ngInject */
    function ExcelHelper() {
        var service = {
            createExcelFile: createExcelFile
        };

        return service;

        function createExcelFile(resp, xlsxName) {
            var items = resp.items;
            var sheetNames = [];
            var sheetsList = {};
            angular.forEach(items, function(item, key) {
                sheetNames.push(item['sheet_name']);
                var sheet = XLSX.utils.aoa_to_sheet(item['data']);
                sheet['!merges'] = handleMerges(item['merges']);
                sheet['!cols'] = fitToColumn(item['data']);
                sheet['!rows'] = fitToRow(sheet, 25);
                sheetsList[item['sheet_name']] = sheet;
            });
            openDownloadDialog(sheets2blob(sheetsList, sheetNames), xlsxName);
        }

        function handleMerges(merges) {
            return merges.map(function(currentValue) {
                return {
                    s: {r: currentValue['start'][0], c: currentValue['start'][1]},
                    e: {r: currentValue['end'][0], c: currentValue['end'][1]}
                }
            });
        }

        function fitToColumn(data) {
            return data[1].map(function(currentValue) {
                return {wch: currentValue.toString().length * 5}
            });
        }

        function fitToRow(sheet, height) {
            var range = XLSX.utils.decode_range(sheet['!ref']);
            var noRows = range.e.r;
            var rowsHeight = [];
            for(var i = 0; i <= noRows; i++) {
                rowsHeight.push({hpx: height})
            }
            return rowsHeight;
        }

        // 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
        function sheets2blob(sheetsList, sheetNames) {
            var workbook = {
                SheetNames: sheetNames,
                Sheets: sheetsList
            };
            // 生成excel的配置项
            var wopts = {
                bookType: 'xlsx', // 要生成的文件类型
                bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
                type: 'binary'
            };
            var wbout = XLSX.write(workbook, wopts);
            var blob = new Blob([s2ab(wbout)], {type: "application/octet-stream"});
            // 字符串转ArrayBuffer
            function s2ab(s) {
                var buf = new ArrayBuffer(s.length);
                var view = new Uint8Array(buf);
                for(var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                return buf;
            }

            return blob;
        }

        function openDownloadDialog(url, saveName) {
            if (typeof url == 'object' && url instanceof Blob) {
                url = URL.createObjectURL(url); // 创建blob地址
            }
            var aLink = document.createElement('a');
            aLink.href = url;
            aLink.download = saveName || '';
            var event;
            if (window.MouseEvent) event = new MouseEvent('click');
            else {
                event = document.createEvent('MouseEvents');
                event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            }
            aLink.dispatchEvent(event);
        }

    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('ExtHelper', ExtHelper);

    /** @ngInject */
    function ExtHelper($q, $timeout, $interval, deviceDetector, dialogs, $http, $state, $rootScope, C, Email) {
        var service = {
            chkCardReadExt: chkCardReadExt,
            readCard: readCard,
            parseIdcardStr: parseIdcardStr,
            registerIdcardChangeListener: registerIdcardChangeListener,
            unregisterIdcardChangeListener: unregisterIdcardChangeListener,
            loadTasks: loadTasks,
            loadMails: loadMails,
            EXT_ID: {
                CARD_READER: "oiigbdbjedaiiogmnfpncpmoaapnfjgl"
            }

        };

        return service;

        function registerIdcardChangeListener(vm, listener, mills) {
            if (angular.isUndefined(mills)) mills = 800;
            var lastReadOutIdcard;
            vm.idcardChangeListener = $interval(function () {
                readCard(vm).then(function (cardInfo) {
                    if (cardInfo.idcard !== lastReadOutIdcard) {
                        listener(cardInfo);
                        lastReadOutIdcard = cardInfo.idcard;
                    }
                }/*, function (msg) {
                 console.log('error msg', msg);
                 }*/);
            }, mills);
        }

        function unregisterIdcardChangeListener(vm) {
            $interval.cancel(vm.idcardChangeListener);
        }

        function chkCardReadExt(vm) {
            vm.extMissing = false;
            var extensionId = service.EXT_ID.CARD_READER;
            vm.envInvalid = !deviceDetector.isDesktop() || deviceDetector.browser !== "chrome";
            if (vm.envInvalid) return;

            if (!!chrome.runtime) {
                chrome.runtime.sendMessage(extensionId, {do: "chk.ext"}, function (resp) {
                    $timeout(function () {
                        vm.extMissing = !resp;
                    });
                });
            } else {
                vm.extMissing = true;
            }
        }

        function readCard(vm, success, error) {
            var defer = $q.defer();
            var extensionId = service.EXT_ID.CARD_READER;
            chrome.runtime.sendMessage(extensionId, {do: "read.card"}, function (resp) {
                $timeout(function () {
                    vm.extMissing = !resp;
                    if (resp && resp.result === 0) {
                        defer.resolve(parseIdcardStr(resp.msg));
                    } else {
                        if (resp && resp.msg) {
                            defer.reject(resp.msg);
                        } else {
                            defer.reject();
                        }
                    }
                });
            });
            return defer.promise;
        }

        function parseIdcardStr(idcardStr) {
            var idcardArr = idcardStr.split(",");
            var cardInfo = {
                idcard: idcardArr[0],
                name: idcardArr[1],
                nation: idcardArr[2],
                birthday: idcardArr[3],
                gender: idcardArr[4]
            };
            if (cardInfo.idcard && cardInfo.idcard.length > 18) cardInfo.idcard = cardInfo.idcard.substr(0, 18);
            if (idcardArr.length > 5) cardInfo.address = idcardArr[5];
            return cardInfo;
        }

        function loadTasks(vm, modelName, modelHas, modelLoading) {
            var taskFnList = {
                23001: meetingLeaveFn,
                17001: carFillFn
            };
            vm.reloadTask = reloadTask;
            vm.toTask = toTask;
            vm.toTaskWithoutSplice = toTaskWithoutSplice;

            function meetingLeaveFn() {
                dialogs.create(C.T + 'meeting/leave.html', 'MeetingLeaveCtrl', {},
                    {size: 'lg'});
            }

            function carFillFn() {
                dialogs.create(C.T + 'car_manage/car_fill.html', 'CarFillCtrl', {},
                    {size: 'lg'});
            }

            function reloadTask(cb) {
                var defer = $q.defer();
                vm[modelLoading] = true;
                $http.post(C.URL.TASK_ALL, {}).success(function (tasks) {
                    angular.forEach(tasks, function (item) {
                        item.id = item.type;
                    });
                    vm[modelName] = tasks;
                    vm[modelHas] = tasks.length > 0;
                    defer.resolve();
                }).finally(function () {
                    vm[modelLoading] = false;
                    defer.reject();
                    if (cb) {
                        cb(vm[modelName]);
                    }
                });
                return defer.promise;
            }

            function toTask(task, index) {
                //  个人业绩:科研业绩 退回页面
                if (task.state == 'app.self_fruit_research' && task.subName == '退回') {
                    $timeout(function () {
                        $rootScope.$broadcast("selfResearchFruitBack");
                    }, 200);
                }
                vm.tasks.splice(index, 1);
                vm.hasTask = vm.tasks.length > 0;
                toTaskWithoutSplice(task);
            }

            function toTaskWithoutSplice(task) {
                var pa = {data: {tag: task.tag}};
                if (task.state) {
                    if ($state.current.name == task.state) {
                        $rootScope.$broadcast("tagChange", pa);
                    } else {
                        $state.go(task.state, pa);
                    }
                } else {
                    //function list
                    var fn = taskFnList[task.type];
                    if (fn) fn();
                    else alert("该事件没有处理方法");
                }
            }
        }

        function loadMails(vm, modelName, modelHas, modelLoading) {
            vm.reloadMail = reloadMail;
            vm.readMail = readMail;

            function reloadMail(cb) {
                var defer = $q.defer();
                vm[modelLoading] = true;
                $http.get('/api/v1/emails', {params: {opt: 1}}).success(function (resp) {
                    vm[modelName] = resp.mails;
                    vm[modelHas] = true;
                    defer.resolve();
                }).finally(function () {
                    vm[modelHas] = false;
                    vm[modelLoading] = false;
                    defer.reject();
                    if (cb) {
                        cb(vm[modelName]);
                    }
                });
                return defer.promise;
            }

            function readMail(mail, $index) {
                dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                    {size: 'lg'}).result.then(function (params) {
                    switch (params.opt) {
                        case 1:
                            $state.go('app.coop_email', {
                                data: {
                                    tab: 'write',
                                    event: 'mailReply',
                                    mail: params.mail
                                }
                            });
                            break;
                        case 2:
                            $state.go('app.coop_email', {
                                data: {
                                    tab: 'write',
                                    event: 'mailForward',
                                    mail: params.mail
                                }
                            });
                            break;
                        case 3:
                            Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
                                function () {
                                    if (vm.mails) {
                                        vm.mails.splice($index, 1);
                                    }
                                    $rootScope.$broadcast('mailDel', mail.id);
                                });
                            break;
                    }
                });
            }
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('FileHelper', fileService);

    /** @ngInject */
    function fileService($q, $http, Upload, SaveAs, C, dialogs, toaster, ArrayHelper) {
        var service = {
            UPLOAD_STATE: {
                UPLOADING: 1,
                UPLOADED: 2,
                FAILED: 3
            },
            uploadSingle: uploadSingle,
            uploadAttachment: uploadAttachment,
            uploadCroppedImage: uploadCroppedImage,
            dnExcel: dnExcel,
            download: download,
            isAttachmentsUploaded: isAttachmentsUploaded,
            loadAttachmentParams: loadAttachmentParams,
            download1: download1,
            upload: upload,
            upload1: upload1,

            humanReadableSizeToValue: humanReadableSizeToValue
        };

        return service;

        function humanReadableSizeToValue(humanReadableSize) {
            var measure = 0;
            var unit = humanReadableSize.substr(-2, 2).toUpperCase();
            switch (unit) {
                case 'TB':
                    measure = 4;
                    break;
                case 'GB':
                    measure = 3;
                    break;
                case 'MB':
                    measure = 2;
                    break;
                case 'KB':
                    measure = 1;
                    break;
            }
            if (measure === 0) return +humanReadableSize;
            return +humanReadableSize.slice(0, -2) * Math.pow(1024, measure);
        }


        function download(url, data, success, error) {
            $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(success).error(error);
        }

        function dnExcel(url, params, filename, cb, err) {
            return $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                var data = [resp];
                var options = { type: 'vnd.ms-excel' };
                SaveAs.download(data, filename, options);
                if (cb) cb();
            }).error(function (content) {
                var enc = new TextDecoder('utf-8')
                var res = JSON.parse(enc.decode(new Uint8Array(content)));
                if (err) err(res);
            });
        }

        /**
         * 上传裁剪后的图片
         * @param image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function uploadCroppedImage(image) {
            var defer = $q.defer();

            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (image.inProgress) {
                defer.reject("正在上传，请稍后再试");
            } else {
                if (!file.$error) {
                    image.inProgress = true;
                    Upload.upload({
                        url: image.toUrl, data: { file: file }
                    }).progress(function (evt) {
                        image.progress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (resp) {
                        defer.resolve(resp.url);
                    }).error(function () {
                        defer.reject("服务器错误");
                    }).finally(function () {
                        image.inProgress = false;
                    });
                } else {
                    defer.reject("图片不能大于20M");
                }
            }
            return defer.promise;
        }

        function uploadAttachment(file, data, e) {
            service.upload(C.URL.UPLOAD_ATTACHMENT, file, data, e);
        }

        function uploadSingle(file, data, e, rename, extra) {
            service.upload1(C.URL.UPLOAD_ATTACHMENT, file, data, e, rename, extra);
        }

        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }

        function byteLength(str) {
            var b = 0, c = 0;
            for (var i = 0; i < str.length; i++) {
                c = str.charCodeAt(i)
                if (c >= 0 && c <= 127) {
                    b++;
                } else {
                    b += 3;
                }
            }
            return b;
        }


        /**
         * 对多附件上传的封装
         * @param url
         * @param file
         * @param data
         * @param e
         */
        function upload(url, file, data, e) {
            if (file == null) {
                return;
            }

            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (byteLength(file.name) >= 200) {
                dialogs.notify('确认', '<strong>文件名过长，请修改后再上传</strong>');
                return;
            }

            var attachment = { name: file.name, progress: 0 };
            data.attachments.push(attachment);
            Upload.upload({
                url: url, file: file
            }).progress(function (evt) {
                attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        attachment.name = resp.name;
                        attachment.mime = resp.mime;
                        attachment.filename = resp.filename;
                        attachment.size = resp.size;
                        break;
                    case 1:
                        attachment.progress = 101;
                        attachment.errorInfo = '服务器空间不足!';
                        break;
                }
                // data.attachments.push(attachment);
            }).error(function () {
                attachment.progress = 102;
                attachment.errorInfo = '服务器错误!';
                // data.attachments.push(attachment);
            });
        }

        /**
         * @deprecated
         * 用于单个附件上传
         * @param url
         * @param file
         * @param data 附件依附对象，其各字段标准为attach_name（附件名称），mime，filename（服务器路径），size
         * @param e
         * @param rename
         * @param extra 额外参数
         * @param cb 返回函数
         */
        function upload1(url, file, data, e, rename, extra, cb) {
            if (file == null) {
                return;
            }

            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            if (byteLength(file.name) >= 200) {
                dialogs.notify('确认', '<strong>文件名过长，请修改后再上传</strong>');
                return;
            }
            data.progress = 0;
            var pa = { file: file, id: data.id, remap: rename };
            if (angular.isDefined(extra) && extra) {
                mergeObj(pa, extra);
            }
            delete data[rename.filename];
            Upload.upload({
                url: url, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        break;
                }
                if (cb) cb(data);
            }).error(function () {
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });
        }

        /**
         * 检查多附件上传中，所有附件是否都已上传并返回服务器文件路径
         * @param data
         * @returns {boolean}
         */
        function isAttachmentsUploaded(data) {
            for (var i = 0; i < data.attachments.length; i++) {
                if (!data.attachments[i].filename) {
                    return false;
                }
            }
            return true;
        }

        function loadAttachmentParams(pa, m) {
            pa.attachments = ArrayHelper.map(m.attachments, function (attachment) {
                return attachment.id ? { id: attachment.id } : {
                    name: attachment.name, mime: attachment.mime,
                    filename: attachment.filename, size: attachment.size
                };
            });
        }

        /**
         * 下载文件
         * @param url 文件资源地址
         * @param data 文件信息数据
         * @param rename 重命名文件信息数据中的字段
         */
        function download1(url, data, rename) {
            if (angular.isUndefined(rename)) {
                rename = {};
            }
            if (!rename.name) rename.name = 'name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            var params = { name: data[rename.name], filename: data[rename.filename], mime: data[rename.mime] };
            data.downloading = true;
            $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                data.downloading = false;
                SaveAs.download([resp], data[rename.name], { type: data[rename.mime] });
            }).error(function (error) {
                data.downloading = false;
                toaster.error('文件丢失');
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('FormHelper', FormHelper);

    /** @ngInject */
    function FormHelper($q, $anchorScroll, $location, $timeout, toaster) {
        var service = {
            handleError: handleError,
            handleSubmit: handleSubmit,
            deleteAttachment: deleteAttachment
        };

        return service;


        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function handleSubmit(vm, cb, args) {
            var form, forms, formIdSelector;
            if (angular.isDefined(args)) {
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.form) form = args.form;
                if (args.forms) forms = args.forms;
            } else {
                formIdSelector = '#Form';
            }
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (forms) {
                __handleSubmitForForms(vm, cb, forms, defer);
            } else {
                if (form.$valid) {
                    if (cb) cb(defer);
                } else {
                    service.handleError(formIdSelector, form);
                    defer.reject();
                }
            }
            return defer.promise;
        }

        function __handleSubmitForForms(vm, cb, forms, defer) {
            var failed = false;
            for (var i = 0; i < forms.length; i++) {
                var form = forms[i];
                var formIdSelector = '#' + form;
                form = vm[form];
                if (!form.$valid) {
                    service.handleError(formIdSelector, form);
                    defer.reject();
                    failed = true;
                    break;
                }
            }
            if (!failed) {
                if (cb) cb(defer);
            }
        }

        function handleError(selector, Form) {
            $timeout(function () {
                var firstInvalid = angular.element(selector)[0].querySelector('.ng-invalid');

                if (firstInvalid) {
                    if ($location.hash() !== firstInvalid.id) {
                        $location.hash(firstInvalid.id);
                    }
                    $anchorScroll();
                    firstInvalid.focus();
                }
            });
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
            Form.$submitted = true;

        }
    }
})();

/**
 * @deprecated 1.模块相关的服务应当放在模块的服务中，而不是这里；
 * 2.不同功能的公共方法应该按功能分类，而不是统一放在这里，
 * 所以F服务从此废弃，不要在往里面放东西了，也尽量不要再用它了。
 */
angular.module('c.s')
    .factory('F', function (ArrayHelper, Table, UIHelper, Float, uibDateParser) {
        return {
            /**
             * @deprecated ArrayHelper.inArray 替代
             */
            inArray: ArrayHelper.inArray,
            /**
             * @deprecated ArrayHelper.indexOf 替代
             */
            indexOf: ArrayHelper.inArray,
            /**
             * @deprecated UIHelper.getIconFromMime 替代
             */
            getIconFromMime: UIHelper.getIconFromMime,
            /**
             * @deprecated Table.getNgTableOpts 替代
             */
            getNgTableOpts: Table.getNgTableOpts,
            /**
             * @deprecated ArrayHelper.except 替代
             */
            except: ArrayHelper.except,
            /**
             * @deprecated 使用 ArrayHelper.getItem替代
             */
            getItem: ArrayHelper.getItem,
            /**
             * @deprecated 使用 ArrayHelper.indexOfKey 替代
             */
            indexOfKey: ArrayHelper.indexOfKey,
            /**
             * @deprecated 使用 ArrayHelper.findItem 替代
             */
            findItem: ArrayHelper.findItem,
            /**
             * @deprecated 使用 ArrayHelper.getItems 替代
             */
            getItems: ArrayHelper.getItems,
            /**
             * @deprecated 使用 ArrayHelper.listKey 替代
             */
            listKey: ArrayHelper.listKey,
            /**
             * @deprecated 使用 ArrayHelper.get 替代
             */
            get: ArrayHelper.get,
            /**
             * @deprecated
             * 公告审批阶段列表
             * @returns {*[]}
             */
            getApprovalStages1: function (appendOverStage) {
                var states = ArrayHelper.get('approval_stages1');
                if (appendOverStage) {
                    var arr = angular.copy(states);
                    arr.push({id: '5', name: '已结束'});
                    return arr;
                }
                return states;
            },
            getApprovalStages8: function (appendOverStage) {
                var states = ArrayHelper.get('approval_stages8');
                if (appendOverStage) {
                    var arr = angular.copy(states);
                    arr.push({id: '5', name: '已结束'});
                    return arr;
                }
                return states;
            },
            /**
             * @deprecated 使用 UIHelper.getProgressType 替代
             */
            getProgressType: UIHelper.getProgressType,
            /**
             * @deprecated 使用 UIHelper.loadTabs 替代
             */
            loadTabs: UIHelper.loadTabs,
            /**
             * @deprecated 使用  UIHelper.loadTab 替代
             */
            loadTab: UIHelper.loadTab,
            bitwise2array: ArrayHelper.bitwise2array,
            array2bitwise: ArrayHelper.array2bitwise,
            checkTime: function (dateTime, beginTime, endTime) {
                var bd = uibDateParser.parse(beginTime, 'HH:mm');
                var ed = uibDateParser.parse(endTime, 'HH:mm');
                var nd = uibDateParser.parse(dateTime, 'HH:mm');
                if (bd > ed && nd > bd) {
                    var edNew = ed.getTime() + 24 * 60 * 60 * 1000;
                    ed = new Date(edNew);
                }
                if (bd > ed && nd < ed) {
                    var bdNew = bd.getTime() - 24 * 60 * 60 * 1000;
                    bd = new Date(bdNew);
                }
                return nd > bd && nd < ed;
            },
            /**
             * @deprecated 使用  Float.toFixed 替代
             */
            toFixed: Float.toFixed,
            getParent: function getParent(type) {
                if (type.parent && type.parent_id != 1) {
                    return getParent(type.parent);
                }
                return type;
            }
        };
    });


/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Pinyin', Pinyin);

    /** @ngInject */
    function Pinyin($ocLazyLoad) {
        var service = {
            getFirstLetter: getFirstLetter
        };

        return service;

        function getFirstLetter(name) {
            return $ocLazyLoad.load(['pinyin']).then(function () {
                return pinyinUtil.getFirstLetter(name);
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('PrintHelper', PrintHelper);

    /** @ngInject */
    function PrintHelper($timeout, $templateRequest, $sce, SaveAs, $ocLazyLoad) {
        var service = {
            print: print,
            printByHtml: printByHtml,
            printAsWord: printAsWord,
            convertCurrency: convertCurrency
        };

        return service;


        function printAsWord(name, styleFile, createBody) {
            if (!!styleFile) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                    html += createBody();
                    html += '</body></html>';
                    $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                        var converted = htmlDocx.asBlob(html + printStyle);
                        SaveAs.download(converted, name + '.docx');
                    });
                });
            } else {
                var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                html += createBody();
                html += '</body></html>';
                $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                    var converted = htmlDocx.asBlob(html);
                    SaveAs.download(converted, name + '.docx');
                });
            }
        }

        /**
         * @param w, 已打开窗口
         * @param styleFile:string, style文件
         * @param createBody:function, 创建<body>元素内的html并返回
         * @param hideHeader:bool, 是否加上抬头
         */
        function print(w, styleFile, createBody, hideHeader) {
            if (typeof (hideHeader) === 'undefined') hideHeader = false;
            if (!!styleFile) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<html>';
                    if (!hideHeader)
                        html += '<p style="text-align:center;font-size:32px;" >西藏自治区人民政府驻成都办事处医院' +
                            '<br>四川大学华西医院西藏成办分院</p>';
                    html += '<body>';

                    html += createBody();
                    html += '</body></html>';
                    w.document.write(html + printStyle);
                    w.document.close();
                    w.focus();
                    $timeout(function () {
                        w.print();
                        w.close();
                    }, 24);
                });
            } else {
                var html = '<html><body>';
                html += createBody();
                html += '</body></html>';
                w.document.write(html);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            }
        }

        function printByHtml(w, styleFile, htmlFile, values, hideHeader) {
            var html = $sce.getTrustedResourceUrl(htmlFile, '');
            $templateRequest(html).then(function (resp) {
                var pattern = /\{\{(.+?)\}\}/g;
                angular.forEach(resp.match(pattern), function (item) {
                    var pageVal = item;
                    var key = item.replace(/[\{\}]/g, "");
                    resp = resp.replace(pageVal, values[key]);
                });
                print(window.open('', '打印预览'), styleFile, function () {
                    return resp;
                }, hideHeader);
            });
        }

        /**
         * 数字金额转换为大写人民币
         * @param money
         * @returns {string}
         */
        function convertCurrency(money) {
            //汉字的数字
            var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
            //基本单位
            var cnIntRadice = ['', '拾', '佰', '仟'];
            //对应整数部分扩展单位
            var cnIntUnits = ['', '万', '亿', '兆'];
            //对应小数部分单位
            var cnDecUnits = ['角', '分', '毫', '厘'];
            //整数金额时后面跟的字符
            var cnInteger = '整';
            //整型完以后的单位
            var cnIntLast = '元';
            //最大处理的数字
            var maxNum = 999999999999999.9999;
            //金额整数部分
            var integerNum;
            //金额小数部分
            var decimalNum;
            //输出的中文金额字符串
            var chineseStr = '';
            //分离金额后用的数组，预定义
            var parts;
            if (money == '') {
                return '';
            }
            money = parseFloat(money);
            if (money >= maxNum) {
                //超出最大处理数字
                return '';
            }
            if (money == 0) {
                chineseStr = cnNums[0] + cnIntLast + cnInteger;
                return chineseStr;
            }
            //转换为字符串
            money = money.toString();
            if (money.indexOf('.') == -1) {
                integerNum = money;
                decimalNum = '';
            } else {
                parts = money.split('.');
                integerNum = parts[0];
                decimalNum = parts[1].substr(0, 4);
            }
            //获取整型部分转换
            if (parseInt(integerNum, 10) > 0) {
                var zeroCount = 0;
                var IntLen = integerNum.length;
                for (var i = 0; i < IntLen; i++) {
                    var n = integerNum.substr(i, 1);
                    var p = IntLen - i - 1;
                    var q = p / 4;
                    var m = p % 4;
                    if (n == '0') {
                        zeroCount++;
                    } else {
                        if (zeroCount > 0) {
                            chineseStr += cnNums[0];
                        }
                        //归零
                        zeroCount = 0;
                        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                    }
                    if (m == 0 && zeroCount < 4) {
                        chineseStr += cnIntUnits[q];
                    }
                }
                chineseStr += cnIntLast;
            }
            //小数部分
            if (decimalNum != '') {
                var decLen = decimalNum.length;
                for (var i = 0; i < decLen; i++) {
                    var n = decimalNum.substr(i, 1);
                    if (n != '0') {
                        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                    }
                }
            }
            if (chineseStr == '') {
                chineseStr += cnNums[0] + cnIntLast + cnInteger;
            } else if (decimalNum == '') {
                chineseStr += cnInteger;
            }
            return chineseStr;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').constant('Regex', {
        IP: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
        PHONE: /^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[1235789])\d{8}$/,
        PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/,
        CAPTCHA: /^[a-zA-Z0-9_\.]{6,}$/
    });

})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('ScanningGun', ScanningGun);

    /** @ngInject */
    function ScanningGun($q, $document, $timeout, $rootScope, Dlg) {
        var service = {
            showPaymentDlg: showPaymentDlg,
            emitPayCompleteEvent: emitPayCompleteEvent,
            emitPayFailEvent: emitPayFailEvent,
            bind: bind
        };
        var scanner = {
            timeoutHandler: null,
            inputString: ''
        };

        return service;

        function bind(scope, cb, element) {
            var defer = $q.defer();
            if (angular.isUndefined(element) || !element) element = $document;

            // element.unbind('keypress');
            var func = function (e) {
                if (scanner.inputString.length > 3 && e.charCode === 13) e.preventDefault();
                if (scanner.timeoutHandler) {
                    $timeout.cancel(scanner.timeoutHandler);
                }
                scanner.inputString += String.fromCharCode(e.which);
                // console.log('String.fromCharCode(e.which)', String.fromCharCode(e.which));

                scanner.timeoutHandler = $timeout(function () {
                    if (scanner.inputString.length <= 3) {
                        scanner.inputString = '';
                        return;
                    }
                    if (cb) {
                        // console.log('scanner.inputString ', scanner.inputString );
                        cb(scanner.inputString);
                    }
                    scanner.inputString = '';
                }, 50);
            };

            element.bind('keypress', func);

            //页面关闭时，销毁监听器
            scope.$on('$destroy', function () {
                element.unbind('keypress', func);
                defer.reject();
            });
            return defer.promise;
        }

        /**
         * 调用扫码对话框
         * @param outTradeNo    订单号
         * @param loadPayFun    扫码成功后调用的方法,可用参数为扫码返回的字符串
         */
        function showPaymentDlg(outTradeNo, loadPayFun, successFun, failFun) {
            return Dlg.show({
                template: 'pages/dialogs/sweep/sweepCode.html',
                ctrl: 'SweepCodePayCtrl',
                data: {cb: loadPayFun, out_trade_no: outTradeNo}
            }).then(function (resp) {
                $document.unbind('keypress');
                $document.unbind('keydown');
                if (angular.isDefined(resp) && resp.result == 0) successFun();
                if (angular.isDefined(resp) && resp.result == 1) failFun();
            });
        }

        /**
         * 回调方法成功时，调用的结束方法
         * @param outTradeNo
         */
        function emitPayCompleteEvent(outTradeNo, resp) {
            $rootScope.$broadcast('SweepCodePaySuccess', {out_trade_no: outTradeNo, resp: resp});
        }

        /**
         * 回调方法失败时，调用的结束方法
         * @param outTradeNo
         */
        function emitPayFailEvent(outTradeNo, resp) {
            $rootScope.$broadcast('SweepCodePayFail', {out_trade_no: outTradeNo, resp: resp});
        }
    }
})();

/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('c.s').factory('Table', TableHelper);

    /** @ngInject */
    function TableHelper(NgTableParams, DateHelper, Dlg) {
        return {
            _1_BTN: 48,
            _2_BTN: 78,
            _3_BTN: 108,
            _4_BTN: 140,
            _5_BTN: 172,
            _6_BTN: 208,

            //对于缩放90%时候的长度
            _1_L_BTN: 48,
            _2_L_BTN: 80,
            _3_L_BTN: 112,
            _4_L_BTN: 150,
            _5_L_BTN: 180,
            _6_L_BTN: 208,

            _1_CHAR: 48,
            _2_CHAR: 72,
            _3_CHAR: 96,
            _4_CHAR: 128,
            _5_CHAR: 170,

            loadMultiSelectedFn: loadMultiSelectedFn,
            getTableData: getTableData,
            /**
             * 方便ngTable获取数据
             * @param service 服务名称
             * @param url 参数
             * @param $defer ngTable的参数
             * @param params ngTable的参数
             * @param items 获取的主要数据项，字符串
             * @param cb 回调函数，可选
             */
            query: queryItems,

            /**
             * @deprecated
             * 加载ngTable
             * @param scope
             * @param options 配置选项
             *  *cols: 数据项
             *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
             *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，justDataCol：是否只显示数据列
             *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
             *  counts: 分页页数选择（默认[10, 30, 50]）, dateFilters：日期范围过滤器数组,
             *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
             * @param cb 回调函数
             */
            loadNgTable: loadNgTable,
            load: loadTable,
            loadItem: loadItem,
            loadTableCols: loadTableCols,
            getNgTableOpts: getNgTableOpts
        };

        function loadItem(resp, startSn, cb) {
            angular.forEach(resp.items, function(item, i) {
                item.sn = startSn + i + 1;
                if (cb) cb(item, i);
            });
        }

        function getNgTableOpts(items) {
            var data = [{id: '', title: '-'}];
            angular.forEach(items, function(item) {
                data.push({id: item.id, title: item.name});
            });
            return data;
        }

        function loadMultiSelectedFn(scope) {
            scope.header = {checkAll: false};
            scope.checkOneFn = function(item, items) {
                if (item.is_checked) {
                    scope.header.checkAll = true;
                } else {
                    var allUnchecked = true;
                    for(var i = 0; i < items.length; i++) {
                        if (items[i].is_checked) {
                            allUnchecked = false;
                            break;
                        }
                    }
                    if (allUnchecked) {
                        scope.header.checkAll = false;
                    }
                }
            };
            scope.checkAllFn = function(checkAll, items) {
                if (checkAll) {
                    angular.forEach(items, function(item) {
                        item.is_checked = true;
                    })
                } else {
                    angular.forEach(items, function(item) {
                        item.is_checked = false;
                    })
                }
            };
            return {
                hasChecked: function(items) {
                    if (!items) items = scope.tableParams.data;
                    return scope.header.checkAll && items && items.length > 0;
                },
                clearChecked: function(items) {
                    scope.header.checkAll = false;
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function(item) {
                        item.is_checked = false;
                    });
                },
                getCheckedIds: function(items, stage) {
                    var ids = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function(item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            ids.push(item.id);
                        }
                    });
                    return ids;
                },
                getChecked: function(items, stage) {
                    var checked = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function(item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            checked.push(item);
                        }
                    });
                    return checked;
                }
            }
        }

        function getTableData(data, $defer, params, $filter) {
            if ($filter) {
                data = params.filter() ?
                    $filter('filter')(data, params.filter()) :
                    data;
                data = params.sorting() ?
                    $filter('orderBy')(data, params.orderBy()) : data;
            }
            params.total(data.length);
            if (params.page() > Math.ceil(data.length / params.count())) {
                params.$params.page = params.page() - 1;
            }
            if (params.page() == 0) {
                params.$params.page = 1;
            }
            $defer.resolve(data.slice((params.page() - 1) * params.count(),
                params.page() * params.count()));
        }

        /**
         * 加载ngtable，后台分页
         * @param scope
         * @param options 配置选项
         *  *cols: 数据项
         *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
         *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，showSn：是否显示序号列
         *  cbWidth: 多选列表中checkbox列宽度
         *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
         *  counts: 分页页数选择（默认[10, 30, 50]）
         *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
         *  primaryFilter: 如果filter中该过滤项为空，则返回暂无数据
         * @param cb 回调函数
         */
        function loadTable(scope, options, cb) {
            var requireWay = arguments[3];
            scope.cols = options.cols;
            angular.forEach(scope.cols, function(col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            scope.optColWidth = options.optColWidth;
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.optSticky = options.optSticky;
            scope.showSn = options.showSn;
            scope.optInFront = options.optInFront;
            scope.cbWidth = options.cbWidth ? options.cbWidth : 62;
            scope.tableParams = new NgTableParams({
                count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                        id: 'desc'
                    }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50],
                getData: function($defer, params) {
                    if ((options.primaryParam && !options.params[options.primaryParam]) || (
                            options.primaryFilter && !params.filter()[options.primaryFilter]
                        )) {
                        //return $defer.resolve([]);
                    } else {
                        var url = params.url();
                        if (requireWay && requireWay == '$http') {
                            if (!options.params.params) options.params.params = {}
                            for(var key in url) {
                                options.params.params[key] = url[key]
                            }
                            return viaHttpLoadItems(options.service, options.params, $defer, params, options.items, cb);
                        } else {
                            for(var index in options.params) {
                                url[index] = options.params[index];
                            }
                            return queryItems(options.service, url, $defer, params, options.items, cb);
                        }
                    }
                }
            });

            scope.clearFilters = function() {
                scope.tableParams.filter({});
            };

            scope.tableReload = function() {
                scope.tableParams.reload();
            };

            return {
                options: function() {
                    return options;
                }
            }
        }

        function loadNgTable(scope, options, cb) {
            scope.cols = options.cols;
            angular.forEach(scope.cols, function(col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            if (options.dateFilters) {
                scope.dateRangeFilter = {};
                scope.$watch('dateRangeFilter',
                    function() {
                        scope.tableParams.reload();
                    }, true
                );
            }
            scope.optColWidth = options.optColWidth;
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.justDataCol = options.justDataCol;
            scope.tableParams = new NgTableParams({
                page: 1, count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                        created_at: 'desc'
                    }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50], total: 0,
                getData: function($defer, params) {
                    if (options.primaryParam && !options.params[options.primaryParam]) {
                        $defer.resolve([]);
                    } else {
                        var url = params.url();
                        for(var index in options.params) {
                            url[index] = options.params[index];
                        }
                        if (options.dateFilters != null && options.dateFilters.length > 0) {
                            angular.forEach(options.dateFilters, function(d) {
                                if (scope.dateRangeFilter[d.name] != null) {
                                    var start = d.start;
                                    var end = d.end;
                                    if (!start) start = 'startDate';
                                    if (!end) end = 'endDate';

                                    url[start] = DateHelper.date2Str(scope.dateRangeFilter[d.name][start]);
                                    url[end] = DateHelper.date2Str(scope.dateRangeFilter[d.name][end]);
                                }
                            });
                        }
                        queryItems(options.service, url, $defer, params, options.items, cb);
                    }
                }
            });

            scope.clearFilters = function() {
                scope.tableParams.filter({});
                if (options.dateFilters) {
                    scope.dateRangeFilter = {};
                }
            };

            scope.clearReload = function() {
                if (angular.equals(scope.tableParams.filter(), {}) &&
                    (!scope.dateRangeFilter || angular.equals(scope.dateRangeFilter, {}))) {
                    scope.tableReload();
                } else {
                    scope.clearFilters();
                }
            };

            scope.tableReload = function() {
                scope.tableParams.reload();
            };

            return {
                options: function() {
                    return options;
                }
            }
        }

        function queryItems(service, url, $defer, params, items, cb) {
            if (items === null || items === undefined) {
                items = 'items';
            }
            service.query(url, function(data) {
                if (data.total > 0 && data[items].length === 0) {
                    params.$params.page = params.page() - 1;
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb)) {
                        cb(data, (params.page() - 1) * params.count());
                    }
                    $defer.resolve(data[items]);
                }
            }, function(err) {
                if (err.data.msg) Dlg.error(err.data.msg);
                $defer.resolve();
            });
        }

        function viaHttpLoadItems(service, url, $defer, params, items, cb) {
            if (items === null || items === undefined) {
                items = 'items';
            }
            service(url).success(function(data) {
                if (data.total > 0 && data[items].length === 0) {
                    params.$params.page = params.page() - 1;
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb) && typeof cb == 'function') {
                        cb(data, (params.page() - 1) * params.count());
                    }
                    $defer.resolve(data[items]);
                }
            }).error(function(data) {
                if (data.msg) Dlg.error(data.msg);
                $defer.resolve();
            });
        }

        function loadTableCols(service, params) {
            var cols = [];
            var serviceCols = service.getCols();
            angular.forEach(params, function(param) {
                cols.push(serviceCols[param]);
            });
            return cols;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('UIHelper', UIHelper);

    /** @ngInject */
    function UIHelper(ArrayHelper, $window, $document, $rootScope, $location, deviceDetector, OS, Upload, dialogs, $timeout) {
        var curExtraParam = null;
        var service = {
            getIconFromMime: getIconFromMime,
            getProgressType: getProgressType,
            isTooDark: isTooDark,
            scrollTo: scrollTo,
            tabTo: tabTo,
            setFocus: setFocus,
            loadSeparatorPage: loadSeparatorPage,
            changeSidebar: changeSidebar,

            loadTabs: loadTabs,
            loadTab: loadTab,

            onCKReady: onCKReady,

            /**
             * Provides read-only equivalent of jQuery's offset function:
             * http://api.jquery.com/offset/
             */
            offset: offset
        };

        return service;

        function onCKReady(editor, fullPath) {
            var editor = CKEDITOR.instances[editor];
            if (!editor) return;

            //目前只支持桌面
            if (deviceDetector.isDesktop()) {
                editor.on('afterInsertHtml', function (evt) {
                    //解决从word拷贝图片的问题...
                    var editable = editor.editable();
                    var imgList = editable.find('img').$;
                    var localImgList = {};
                    angular.forEach(imgList, function (img) {
                        if (img.src.match(/^file:\/\//)) {
                            if (ArrayHelper.indexOfKey(img.src, localImgList, 'src') == -1) {
                                var filename = img.src.replace(/^.*(\\|\/|\:)/, '');
                                localImgList[filename] = img;
                            }
                        }
                    });
                    if (Object.keys(localImgList).length > 0) {
                        if (editor.commands.maximize.state == '1') {
                            editor.execCommand('maximize');
                        }

                        var files = [], startIndex = 7, changeSeparator = false;
                        if (deviceDetector.os == OS.WINDOWS) {
                            startIndex = 8;
                            changeSeparator = true;
                        }
                        var names = Object.keys(localImgList);
                        angular.forEach(names, function (name) {
                            var img = localImgList[name];
                            var path = img.src.substr(startIndex);
                            if (changeSeparator) {
                                path = path.replace(/\//g, "\\");
                            }
                            files.push({name: name, path: path});
                        });
                        dialogs.create('templates/upload/word_images_dlg.html', 'UploadWordImagesDlg', {
                            files: files
                        }, {
                            size: 'md'
                        }).result.then(function (result) {
                            var widgets = editor.widgets.instances,
                                curWidget,
                                i;
                            for (i in widgets) {
                                curWidget = widgets[i];
                                if (curWidget.definition.name == 'image') {
                                    var name = curWidget.parts.image.getAttribute('src').replace(/^.*(\\|\/|\:)/, '');
                                    var url = result[name];
                                    if (url) {
                                        if (fullPath === 'true') {
                                            url = 'http://' + window.location.host + '/' + url
                                        }
                                        curWidget.setData('src', url);
                                    }
                                }
                            }
                            editor.fire('change');
                        });
                    }
                });
            }

            editor.on('fileUploadRequest', function (evt) {
                var loader = evt.data.fileLoader;
                var file = Upload.dataUrltoBlob(loader.data);
                Upload.upload({
                    url: loader.uploadUrl, data: {file: file}
                }).progress(function (evt) {
                    if (!loader.uploadTotal) {
                        loader.uploadTotal = evt.total;
                    }
                    loader.uploaded = evt.loaded;
                    loader.update();
                }).success(function (resp) {
                    if (resp.error && resp.error.message) {
                        loader['message'] = resp.error.message;
                    }
                    if (resp.result == '1') {
                        evt.cancel();
                        loader.changeStatus('error');
                    } else {
                        if (fullPath === 'true') {
                            resp.url = 'http://' + window.location.host + '/' + resp.url
                        }
                        loader['url'] = resp.url;
                        loader['fileName'] = resp.fileName;
                        loader.changeStatus('uploaded');
                        editor.fire('change');
                    }
                }).error(function () {
                    loader.changeStatus('error');
                });
                evt.stop();
            });
        }

        function loadTabs($scope, $stateParams) {
            var vm = $scope;
            var curTab = angular.isDefined($stateParams.data)?$stateParams.data.tag:null;
            if ($stateParams.tab) {
                curTab = $stateParams.tab;
            }
            var curExtraParam = null;
            vm.tabs = [];
            vm.tabSelected = tabSelected;

            if (curTab) {
                vm.tabs[curTab] = true;
            }

            $scope.$on('tagChange', function (event, pa) {
                var tab = pa.data.tag;
                curExtraParam = pa.data.extra;
                // 如果当前标签页正好是审批提醒跳转标签页,则直接发广播,触发刷新;否则改变标签页,通过tabSelected触发刷新
                if (curTab === tab) {
                    $rootScope.$broadcast("reload", {tag: tab, extra: curExtraParam});
                } else {
                    vm.tabs[tab] = true;
                    curTab = tab;
                }
            });

            /**
             * 记录选择的标签页，并触发该页面的重新加载事件
             * <strong>注意：这个函数必须应用的标签页上</strong>
             * @param tab
             * @param skipReloadContent 不触发标签内容更新
             */
            function tabSelected(tab, skipReloadContent) {
                $location.search('tab', tab);

                if (tab !== curTab && !skipReloadContent) {
                    $rootScope.$broadcast("reload", {tag: tab, extra: curExtraParam});
                }
                curTab = tab;
            }
        }

        function loadTab($scope, tab, reloadFn) {
            var vm = $scope;
            $scope.$on("reload", function (event, data) {
                var tag = data.tag;
                if (tag == tab) {
                    if (reloadFn) {
                        if (reloadFn(data.extra)) curExtraParam = null;
                    } else {
                        vm.tableReload();
                    }
                }
            });
        }

        function scrollTo(toElemId, scrollableBodyId, offset, duration) {
            if (angular.isUndefined(scrollableBodyId)) scrollableBodyId = '.modal-body';
            else scrollableBodyId = '#' + scrollableBodyId;
            if (angular.isUndefined(offset)) offset = 0;
            if (angular.isUndefined(duration)) duration = 200;
            var scrollableBody = angular.element(scrollableBodyId)[0];
            var toElemOffset = angular.isUndefined(toElemId) ? 0 :
                angular.element('#' + toElemId)[0].offsetTop;

            var currentTime = 0;
            var increment = 2;
            var from = scrollableBody.scrollTop;
            var to = toElemOffset - offset;
            var change = to - from;

            function __scrollTo() {
                currentTime += increment;
                scrollableBody.scrollTop = __easeInOutQuad(currentTime, from, change, duration);
                if (currentTime < duration) {
                    setTimeout(__scrollTo, increment)
                }
            }

            __scrollTo();
        }

        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        function __easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        function tabTo(tag, extra) {
            $rootScope.$broadcast('tagChange', {data: {tag: tag, extra: extra}});
        }

        function changeSidebar(scope, state) {
            var timeoutHandler = $timeout(function () {
                $rootScope.$broadcast('showSidebar', state);
            }, 2000);

            scope.$on('$destroy', function () {
                $timeout.cancel(timeoutHandler);
            });
        }

        function isTooDark(color, limit) {
            if (angular.isUndefined(limit)) {
                limit = 128;
            }
            var c = color.substring(1);      // strip #
            var rgb = parseInt(c, 16);   // convert rrggbb to decimal
            var r = (rgb >> 16) & 0xff;  // extract red
            var g = (rgb >> 8) & 0xff;  // extract green
            var b = (rgb >> 0) & 0xff;  // extract blue

            var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < limit) {
                return true;
            }
            return false;
        }

        function getIconFromMime(mime) {
            var mime2Ico = ArrayHelper.get('mime2Ico');
            var app2Ico = ArrayHelper.get('app2Ico');

            var len = mime.indexOf('/');
            var type = mime.substr(0, len);

            var ico = mime2Ico[type];
            if (ico == null) {
                var app = mime.substr(len + 1, mime.length);
                ico = app2Ico[app];
                if (ico == null) {
                    ico = 'file-o'
                }
            }
            return ico;
        }

        function getProgressType(index) {
            var progressTypes = ArrayHelper.get('progressTypes');
            return progressTypes[index % progressTypes.length];
        }

        function offset(element) {
            var boundingClientRect = element[0].getBoundingClientRect();
            return {
                width: boundingClientRect.width || element.prop('offsetWidth'),
                height: boundingClientRect.height || element.prop('offsetHeight'),
                top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
                left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
            };
        }

        function setFocus(elId) {
            $timeout(function () {
                var b = document.getElementById(elId);
                b.focus();
            }, 24);
        }

        function loadSeparatorPage(vm, separator, first, second, bindFunctions) {
            vm.onSeparatorMouseDown = onSeparatorMouseDown;
            vm.onMouseMove = onMouseMove;
            vm.onMouseUp = onMouseUp;
            vm.getSeparatorModel = getSeparatorModel;

            separator.onmousedown = onSeparatorMouseDown;

            var md = null;

            function setModel(e) {
                md = {
                    e: e,
                    offsetLeft: separator.offsetLeft,
                    offsetTop: separator.offsetTop,
                    firstWidth: first.offsetWidth,
                    secondWidth: second.offsetWidth,
                    secondHeight: second.offsetHeight
                };
            }

            function onSeparatorMouseDown(e) {
                setModel(e);
                document.onmousemove = onMouseMove;
                document.onmouseup = onMouseUp;
            }

            function getSeparatorModel() {
                if (md === null) setModel(null);
                return md;
            }

            function onMouseMove(e) {
                var delta = {
                    x: e.clientX - md.e.clientX,
                    y: e.clientY - md.e.clientY
                };

                delta.x = Math.min(Math.max(delta.x, -md.firstWidth), md.secondWidth);
                separator.style.left = md.offsetLeft + delta.x + "px";
                first.style.width = (md.firstWidth + delta.x) + "px";
                second.style.width = (md.secondWidth - delta.x) + "px";

                implementFunctions(bindFunctions, 'callMouseMove', md);
            }

            function onMouseUp() {
                document.onmousemove = document.onmouseup = null;
            }
        }

        function implementFunctions(getFunctions, name, resp) {
            return angular.isDefined(getFunctions[name]) ? getFunctions[name](resp) : null;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('WxHelper', WxHelper);

    /** @ngInject */
    function WxHelper ($q, $http, $location) {
        var service = {
            getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            getWechatToken: getWechatToken,
            isWechatBrowser: isWechatBrowser,

            loadWxnp: loadWxnp
        };

        return service;

        /**
         * 判断是否为微信浏览器
         * @returns {boolean}
         */
        function isWechatBrowser () {
            var ua = navigator.userAgent.toLowerCase();
            return ua.match(/MicroMessenger/i) == "micromessenger";
        }

        function getWechatToken (code, state) {
            var deferred = $q.defer();
            // 构造 url
            var url = '/api/wx/get_wechat_token' + "?code=" + code + "&state=" + state;
            // 发送 get
            $http.get(url).then(function (data) {
                deferred.resolve(data.data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        // load wx notice page
        function loadWxnp (cb) {
            var urlParams = $location.search();
            if (urlParams.wxnpId) {
                var id = urlParams.wxnpId;
                var type = urlParams.wxnpType;
                cb(id, type);
                $location.search('wxnpId', null);
                $location.search('wxnpType', null);
            }
        }

        function getWechatAuthorizeUrl (toState, toParams) {
            var appId = 'wx8d575c5c02c4add7',
                //     var appId = 'wx397b903b8e97af13',梁宗的测试号
                // var appId = 'wxc32c627b8b2e7ef3',左迪的测试号
                rUrl = 'https://oa.tcd120.cn/get_wechat_token';
            // input = 'http://cbfy.free.ngrok.cc/get_wechat_token',左迪的测试号
            // input = 'http://cbfy.tunnel.qydev.com/get_wechat_token',梁宗的测试号
            if (toState) {
                rUrl += "?toState=" + toState.name;
                if (toParams) rUrl += "&toParams=" + JSON.stringify(toParams);
            }
            rUrl = window.encodeURIComponent(rUrl);

            var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri='
                + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
            return url;
        }

    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .factory('Streamline', Streamline)
    ;

    /** @ngInject */
    function Streamline($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/ai/streamlines/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));



    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .factory('Country', Country)
        .factory('Province', Province)
        .factory('City', City)
        .factory('County', County)
    ;

    /** @ngInject */
    function Country($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/area/countries/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));



    }


    /** @ngInject */
    function Province($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/area/provinces/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    /** @ngInject */
    function City($resource, serviceConfObj) {
        return $resource('/api/v1/area/cities/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function County($resource, serviceConfObj) {
        return $resource('/api/v1/area/counties/:id', {}, serviceConfObj);
    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .factory('Dept2', Dept2)
    ;

    /** @ngInject */
    function Dept2($resource, serviceConfObj) {
        var BASE = "/api/v1/base/depts";

        var service = {
            URL: {
                BASE: BASE,
            },
            TYPE: {
                CLINICAL: 1,    // 临床
                NURSE: 5,       // 护理
            }
        };

        return angular.extend(service, $resource(service.URL.BASE + '/:id', {}, serviceConfObj));
    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .factory('DeptSwitchLeaderRecord', DeptSwitchLeaderRecord)
    ;

    /** @ngInject */
    function DeptSwitchLeaderRecord($resource, serviceConfObj) {
        var BASE = "/api/v1/dept_switch_leader_records";

        var service = {
            URL: {
                BASE: BASE,
            }
        };

        return angular.extend(service, $resource(service.URL.BASE + '/:id', {}, serviceConfObj));
    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .factory('InsuranceType', InsuranceType)
    ;

    /** @ngInject */
    function InsuranceType($resource, serviceConfObj) {
        var BASE = "/api/v1/base/insurance_types";

        var service = {
            URL: {
                BASE: BASE,
            },
        };

        return angular.extend(service, $resource(service.URL.BASE + '/:id', {}, serviceConfObj));
    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .factory('HomeNation', HomeNation)
    ;

    /** @ngInject */
    function HomeNation($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/home/nations/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));


    }


    /** @ngInject */
    function Province($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/area/provinces/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    /** @ngInject */
    function City($resource, serviceConfObj) {
        return $resource('/api/v1/area/cities/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function County($resource, serviceConfObj) {
        return $resource('/api/v1/area/counties/:id', {}, serviceConfObj);
    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .factory('HisMedicalOperation', HisMedicalOperation)
    ;

    /** @ngInject */
    function HisMedicalOperation($resource, serviceConfObj) {
        var BASE = "/api/v1/medical_patients";

        var service = {
            URL: {
                BASE: BASE,
                BASE_EXPORT: BASE + '/export'
            }
        };

        return angular.extend(service, $resource(service.URL.BASE + '/:id', {}, serviceConfObj));
    }
})();

angular.module('c.s')
    .factory('HomeDept', ['$resource', function ($resource) {
        return $resource('/api/home/depts/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);

angular.module('c.s')
    .factory('Doctor', ['$resource', function ($resource) {
        return $resource('/api/home/doctors/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            sorting: {
                method: 'POST',
                params: {
                    action: 'sorting'
                }
            }
        });
    }]);

(function () {
    'use strict';

    angular.module('c.d')
        .directive('editor', editor);

    // https://github.com/wayou/wayou.github.io/issues/5
    var ckSimpleConfig = {
        height: 120,
        toolbarGroups: [
            {name: 'basicstyles', groups: ['basicstyles']},
            {name: 'paragraph', groups: ['list', 'align']},
            {name: 'styles', groups: ['styles', 'colors']},
            {name: 'insert', groups: ['insert']},
            // {name: 'tools', groups: ['tools']}
        ],
        removeButtons: 'Subscript,Superscript,Styles,Format,JustifyBlock,ShowBlocks,' +
            'Flash,HorizontalRule,Smiley,PageBreak,Iframe,Table'
    };

    /** @ngInject */
    function editor($compile, UIHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                height: '=height'
            },
            require: ['^ngModel', '?^form'],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var id = 'editor' + (new Date()).getTime() + (Math.floor(Math.random() * 100000));
                        var ngModelCtrl = r[0], formCtrl = r[1];
                        var vm = scope;
                        vm.onReady = UIHelper.onCKReady;

                        init();


                        function init() {
                            scope.$on('$destroy', function () {
                                var editor = CKEDITOR.instances[id];
                                if (editor) editor.destroy();
                            });

                            scope.$watch('model', function (newValue, oldValue) {
                                if (angular.isDefined(oldValue)) ngModelCtrl.$setTouched();
                            });

                            var id = 'editor' + (new Date()).getTime() + (Math.floor(Math.random() * 100000));
                            var elem;
                            var fullPath = false;
                            if (angular.isDefined(iAttrs.fullpath)) {
                                fullPath = true;
                            }
                            if (angular.isDefined(iAttrs.simple)) {
                                vm.ckConfig = angular.copy(ckSimpleConfig);
                                if (vm.height) vm.ckConfig.height = vm.height;
                                elem = '<div ckeditor="ckConfig" ng-model="model" ready=onReady("' + id + '","' + fullPath + '") id="' + id + '"></div>';
                            } else {
                                elem = '<div ckeditor ng-model="model" ready=onReady("' + id + '","' + fullPath + '") id="' + id + '"></div>';
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            checkValidity();

                            if (formCtrl) {
                                scope.$watch(function () {
                                    return formCtrl.$submitted;
                                }, function (submitted) {
                                    if (submitted) iElement.addClass('submitted')
                                });
                            }
                        }

                        function checkValidity() {
                            var valid = iAttrs.required ? (!!ngModelCtrl.$viewValue) : true;
                            ngModelCtrl.$setValidity('required', valid);
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('multiSelect', multiSelect);

    /** @ngInject */
    function multiSelect($compile, $timeout, ArrayHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                options: '=options',
                required: '=ngRequired',
                disabled: '=disabled',
                bitNumber: '@bitMode'
            },
            require: ['^ngModel', '?^form'],
            compile: function () {
                return {
                    pre: function (scope, iElement, iAttrs, r) {
                        var ngModelCtrl = r[0], req = r[1], formCtrl = r[2];
                        var vm = scope;
                        var touched = false;
                        var bitMode = angular.isDefined(iAttrs.bitMode);
                        var bitNumber = vm.bitNumber > 0 ? vm.bitNumber : 8;


                        init();


                        function init() {
                            if (bitMode) {
                                scope.$watch('modelArr', function (newValue, oldValue) {
                                    if (angular.isDefined(oldValue)) {
                                        if (newValue !== oldValue && !touched) {
                                            touched = true;
                                            ngModelCtrl.$setTouched();
                                        }
                                        ngModelCtrl.$setViewValue(ArrayHelper.array2bitwise(newValue));
                                        checkValidity();
                                    }
                                }, true);

                                scope.$watch('model', function (newValue, oldValue) {
                                    if (angular.isDefined(oldValue)) {
                                        if (newValue !== oldValue && !touched) {
                                            touched = true;
                                            ngModelCtrl.$setTouched();
                                        }
                                        vm.modelArr = ArrayHelper.bitwise2array(vm.model, bitNumber);
                                    }
                                });
                                if (angular.isUndefined(vm.model)) {
                                    vm.model = 0;
                                    vm.modelArr = ArrayHelper.bitwise2array([], bitNumber);
                                } else {
                                    vm.modelArr = ArrayHelper.bitwise2array(vm.model, bitNumber);
                                }
                            } else {
                                scope.$watch('model', function (newValue, oldValue) {
                                    if (angular.isDefined(oldValue)) {
                                        if (newValue !== oldValue && !touched) {
                                            touched = true;
                                            ngModelCtrl.$setTouched();
                                        }
                                        // ngModelCtrl.$setViewValue(newValue);
                                        checkValidity();
                                    }
                                }, true);
                                if (angular.isUndefined(vm.model)) vm.model = [];
                            }

                            var elem = '<label class="btn btn-default mr-1" ' +
                                'ng-model="model' + (bitMode ? 'Arr' : '') + '[$index]" ' +
                                'ng-repeat="option in options" uib-btn-checkbox ng-disabled="disabled==$index">' +
                                '{{option}}</label>';

                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            $timeout(function () {
                                checkValidity();
                            });

                            if (formCtrl) {
                                scope.$watch(function () {
                                    return formCtrl.$submitted;
                                }, function (submitted) {
                                    if (submitted) iElement.addClass('submitted')
                                });
                            }
                        }

                        function checkValidity() {
                            var valid = scope.required ? hasChecked() : true;
                            ngModelCtrl.$setValidity('required', valid);
                        }

                        function hasChecked() {
                            if (bitMode) return ngModelCtrl.$viewValue > 0;
                            var checked = false;
                            var val = ngModelCtrl.$viewValue;
                            if (val) {
                                for (var i = 0; i < val.length; i++) {
                                    if (val[i]) {
                                        checked = true;
                                        break;
                                    }
                                }
                            }
                            return checked;
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('requireMultiple', requireMultiple);

    /** @ngInject */
    function requireMultiple($parse) {
        return {
            require: 'ngModel',
            link: function postLink(scope, element, attrs, ngModel) {
                var require = $parse(attrs.requireMultiple)();
                if (require !== false) {
                    ngModel.$validators.required = function (value) {
                        return angular.isArray(value) && value.length > 0;
                    };
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('scrollForm', scrollForm);

    /** @ngInject */
    function scrollForm($timeout, $anchorScroll, $location) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('submit', function () {
                    $timeout(function(){
                        var firstInvalid = elem[0].querySelector('.ng-invalid');

                        if (firstInvalid) {
                            if ($location.hash() !== firstInvalid.id) {
                                $location.hash(firstInvalid.id);
                            }
                            $anchorScroll();
                            firstInvalid.focus();
                        }
                    });

                });
            }
        };
    }

})();
// 因为点击选项造成的失去焦点，无法辨别
// (function () {
//     'use strict';
//
//     angular.module('c')
//         .directive('tagOnBlur', tagOnBlur);
//
//     /** @ngInject */
//     function tagOnBlur($timeout) {
//
//         var directive = {
//             require: 'uiSelect',
//             link: link
//         };
//
//         return directive;
//
//         function link(scope, elm, attrs, ctrl) {
//             scope.$on('uis:select', function (event, item) {
//                 ctrl.search = '';
//             });
//             ctrl.searchInput.on('blur', function (e) {
//                 if ((ctrl.items.length > 0 || ctrl.tagging.isActivated)) {
//                     $timeout(function () {
//                         ctrl.searchInput.triggerHandler('tagged');
//                         var newItem = ctrl.search;
//                         if (ctrl.tagging.fct) {
//                             newItem = ctrl.tagging.fct(newItem);
//                         }
//                         if (newItem) ctrl.select(newItem, true);
//                         ctrl.search = '';
//                     });
//                 }
//             });
//         }
//
//     }
//
// })();
angular.module('c.d')
    .directive('compareTo', function () {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };
    });
angular.module('c.d')
    .directive('dateRange', function () {
        return {
            templateUrl: 'templates/date_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'dateRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .directive("errSrc", function () {
            return {
                link: function (scope, element, attrs) {
                    element.bind("error", function () {
                        if (attrs.src != attrs.errSrc) {
                            attrs.$set("src", attrs.errSrc);
                        }
                    });
                }
            }
        })
})();
angular.module('c.d')
    .directive('focusMe', function ($timeout) {
        return {
            link: function (scope, element, attrs) {
                scope.$watch(attrs.focusMe, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
            }
        };
    });
angular.module('c.d')
.directive('ngIndeterminate', function($compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attributes) {
            scope.$watch(attributes['ngIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
});
(function () {
    'use strict';

    angular.module('c.d')
        .directive('loadingContainer', function () {
            return {
                restrict: 'A',
                scope: false,
                link: function (scope, element, attrs) {
                    if (angular.isUndefined(attrs.loadingIcon)) attrs.loadingIcon = 'fa-spinner fa-2x fa-pulse';
                    if (angular.isUndefined(attrs.loadingTitle)) attrs.loadingTitle = '加载中，请稍后...';
                    var elem = '<div class="loading d-flex align-items-center justify-content-center">' +
                        '<div><i class="fa ' + attrs.loadingIcon + ' mr-2"></i>' +
                        (attrs.loadingTitle ? '<span>' + attrs.loadingTitle + '</span></div>' : '') +
                        '</div>';
                    var loadingLayer = angular.element(elem);
                    element.append(loadingLayer);
                    element.addClass('loading-container');
                    scope.$watch(attrs.loadingContainer, function (value) {
                        loadingLayer.toggleClass('ng-hide', !value);
                    });
                }
            };
        });

})();
angular.module('c.d').directive('modalDraggable', function ($document) {
    "use strict";
    return function (scope, element) {
        var startX = 0,
            startY = 0,
            x = 0,
            y = 0;
        element = angular.element(document.getElementsByClassName("modal-dialog"));
        if (element.length > 0) {
            element = element.last();


        }
        element.css({
            position: 'fixed',
            left: '50%',
            transform: 'translateX(-50%)'
        });

        var header = element.find('.modal-header');
        //var footer = element.find('.modal-footer');
        //var body = element.find('.modal-body');
        //
        //body.css({
        //    'min-width': '300px'
        //    //'max-height': '480px',
        //    //'overflow-y': 'scroll'
        //});

        header.on('mousedown', function (event) {
            // Prevent default dragging of selected content
            event.preventDefault();
            x = element.prop('offsetLeft');
            startX = event.screenX - x;
            startY = event.screenY - y;
            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
        });


        function mousemove(event) {
            y = event.screenY - startY;
            x = event.screenX - startX;
            if (y + 60 <= 0 || y + 60 >= window.innerHeight ||
                x <= 0 || x >= window.innerWidth)
                return;

            element.css({
                top: y + 'px',
                left: x + 'px'
            });
        }

        function mouseup() {
            $document.unbind('mousemove', mousemove);
            $document.unbind('mouseup', mouseup);
        }
    };
});
angular.module('c.d')
    .directive('numberRange', function () {
        return {
            templateUrl: 'templates/number_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'numRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
angular.module('c.d')
    .directive('selectOnClick', ['$window', function ($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                if (!$window.getSelection().toString()) {
                    // Required for mobile Safari
                    this.setSelectionRange(0, this.value.length)
                }
            });
        }
    };
}]);
(function () {
    'use strict';

    angular.module('c.d')
        .directive('autoCompleteDropdown', autoCompleteDropdown);

    /** @ngInject */
    function autoCompleteDropdown($compile, $sce, $document, $timeout, ArrayHelper, UIHelper) {
        return {
            restrict: 'A',
            scope: {
                // {data:array|function, trigLen:number}
                option: '=autoCompleteDropdown',
                inputText: '=ngModel'
            },
            require: 'ngModel',
            compile: function () {
                var template =
                    '<ul class="auto-complete-dropdown" is-open="isOpen"' +
                    ' style="visibility:hidden;display:block;top:-9999px;left:-9999px;">' +
                    '<li ng-repeat="i in items" ng-class="{\'selected\':$index===selectedIndex}" ' +
                    'ng-bind-html="highlight(i,inputText)" ng-click="itemSelected(i)"></li></ul>';

                var acdLinker = $compile(template);

                return function (scope, element, attrs, ctrl) {
                    var elem = angular.element(element[0]);
                    if (angular.isUndefined(scope.option.trigLen)) scope.option.trigLen = 1;
                    var acdScope = scope.$new(true);
                    acdScope.selectedIndex = 0;
                    var onSelect = scope.option.onSelect;
                    var acdLinkedScope;
                    var acd;
                    var observers = [];

                    init();


                    function init() {
                        elem.on('focus', show);
                        elem.on('keydown', onKeyDownFn);
                        acdScope.$watch('isOpen', openChanged);
                        $document.on('click', bodyHideAcdBind);
                        scope.$on('$destroy', function onDestroyTooltip() {
                            removeAcd();
                            acdScope = null;
                        });
                    }

                    function onKeyDownFn(e) {
                        if ([13, 38, 40].indexOf(e.keyCode) === -1) return;
                        if (acdLinkedScope && acdLinkedScope.items.length > 0) { // down arrow
                            var n = acdLinkedScope.items.length;
                            var i = acdLinkedScope.selectedIndex;
                            if (e.keyCode === 13) { // enter key
                                var selectedItem = acdLinkedScope.items[i];
                                $timeout(function () {
                                    itemSelected(selectedItem);
                                    elem.blur();
                                });
                                return;
                            }

                            if (e.keyCode === 40) {  // down arrow
                                i = (i + 1) % n;
                            } else if (e.keyCode === 38) { // up arrow
                                i = (n + i - 1) % n;
                            }
                            if (i !== acdLinkedScope.selectedIndex) {
                                acdLinkedScope.$evalAsync(function () {
                                    acdLinkedScope.selectedIndex = i;
                                });
                            }
                            return false;
                        }
                    }

                    function bodyHideAcdBind(e) {
                        if (!acdScope || !acdScope.isOpen || !acd) {
                            return;
                        }

                        if (!element[0].contains(e.target) && !acd[0].contains(e.target)) {
                            hide();
                        }
                    }

                    function inputTextChanged(newVal) {
                        if (newVal) {
                            // 包含中文，长度x2，即将中文字符看做2个字符
                            var len = /[\u3400-\u9FBF]/.test(newVal) ? newVal.length * 2 : newVal.length;
                            if (len >= scope.option.trigLen) {
                                if (angular.isFunction(scope.option.data)) {
                                    scope.option.data(newVal).then(function (value) {
                                        var nowVal = scope.inputText;
                                        if (!nowVal) len = 0;
                                        else len = /[\u3400-\u9FBF]/.test(nowVal) ? nowVal.length * 2 : nowVal.length;
                                        if (len >= scope.option.trigLen) {
                                            acdLinkedScope.inputText = nowVal;
                                            acdLinkedScope.items = value.data;
                                            hideItemsIfJustInputText();
                                        } else {
                                            acdLinkedScope.items = [];
                                        }
                                        acdLinkedScope.selectedIndex = 0;
                                    });
                                } else {
                                    acdLinkedScope.inputText = newVal;
                                    acdLinkedScope.items = ArrayHelper.filter(scope.option.data, function (itemStr) {
                                        return itemStr.indexOf(newVal) === 0;
                                    });
                                    hideItemsIfJustInputText();
                                    acdLinkedScope.selectedIndex = 0;
                                }
                            } else {
                                acdLinkedScope.items = [];
                                acdLinkedScope.selectedIndex = 0;
                            }
                        }
                    }

                    function hideItemsIfJustInputText() {
                        if (acdLinkedScope.items.length === 1) {
                            var item = acdLinkedScope.items[0].split(" ")[0];
                            var input = acdLinkedScope.inputText.split(" ")[0];
                            if (item === input) {
                                acdLinkedScope.items = [];
                            }
                        }
                    }

                    function openChanged(newVal, oldVal) {

                    }

                    function show() {
                        createAcd();
                        acdScope.$evalAsync(function () {
                            acdScope.isOpen = true;
                            positionAcd();
                        });
                    }

                    function hide() {
                        if (!acdScope) return;
                        acdScope.$evalAsync(function () {
                            acdScope.isOpen = false;
                            removeAcd();
                        });
                    }

                    function positionAcd() {
                        if (!acd || !acd.html()) {
                            return;
                        }
                        var hostEl = element;
                        var targetEl = acd;

                        var hostElPos;

                        hostElPos = UIHelper.offset(hostEl);

                        var top = (hostElPos.top + hostElPos.height) + 'px';
                        var left = hostElPos.left + 'px';
                        var width = hostElPos.width + 'px';
                        targetEl.css({top: top, left: left, width: width, visibility: 'visible'});
                    }

                    function createAcd() {
                        if (acd) return;

                        acdLinkedScope = acdScope.$new();
                        acdLinkedScope.highlight = highlight;
                        acdLinkedScope.itemSelected = itemSelected;
                        acd = acdLinker(acdLinkedScope, function (acd) {
                            $document.find('body').append(acd);
                        });
                        prepObservers();
                    }

                    function removeAcd() {
                        unregisterObservers();
                        if (acd) {
                            acd.remove();
                            acd = null;
                        }
                        if (acdLinkedScope) {
                            acdLinkedScope.$destroy();
                            acdLinkedScope = null;
                        }
                    }

                    function prepObservers() {
                        observers.push(
                            scope.$watch('inputText', inputTextChanged)
                        );
                        // observers.push(
                        //     scope.$watch('option.data', optionDataChanged, true)
                        // );
                    }

                    function unregisterObservers() {
                        if (observers.length) {
                            angular.forEach(observers, function (observer) {
                                observer();
                            });
                            observers.length = 0;
                        }
                    }

                    function highlight(text, search) {
                        if (angular.isDefined(scope.option.forFile)) {
                            text = text.split("#id:")[0];
                        }
                        if (!search) return $sce.trustAsHtml(text);
                        return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<strong>$&</strong>'));
                    }

                    function itemSelected(itemText) {
                        var oldVal, newVal;
                        if (angular.isDefined(scope.option.forFile)) {
                            oldVal = scope.inputText;
                            newVal = itemText;
                        } else {
                            oldVal = scope.inputText.split(" ")[0];
                            newVal = itemText.split(" ")[0];
                        }

                        if (oldVal !== newVal) {
                            scope.inputText = newVal;
                            if (attrs.ngChange) {
                                $timeout(function () {
                                    scope.$parent.$eval(attrs.ngChange);
                                });
                            }
                            if (onSelect) {
                                $timeout(function () {
                                    onSelect(newVal);
                                });
                            }
                        }
                        hide();
                    }
                }

            }
        }
    }
})();

(function () {
    'use strict';

    // ng-src改变源时产生淡入切换动画
    angular.module('c.d')
        .directive('imgFadeInToggle', imgFadeInToggle);

    /** @ngInject */
    function imgFadeInToggle() {
        return {
            restrict: 'A',
            scope: {
                src: '=imgFadeInToggle'
            },
            link: function (scope, element, attrs) {
                scope.$watch('src', function (src) {
                    element.hide();
                });
                element.on('load', function () {
                    element.fadeIn(500);
                });
                element.on('error', function () {
                    element.show();
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('c.d')
        .directive('ngSizeChange', ngSizeChange);

    /** @ngInject */
    function ngSizeChange($interval) {
        return {
            restrict: 'A',
            scope: {
                onChange: '=ngSizeChange'
            },
            link: function (scope, element) {
                var container = element[0];
                var w, h, cancelFn;

                init();


                function init() {
                    cancelFn = $interval(function () {
                        var cw = container.clientWidth, ch = container.clientHeight;
                        if (scope.onChange && cw && ch && (w !== cw || h !== ch)) {
                            scope.onChange(cw, ch);
                        }
                        w = cw;
                        h = ch;
                    }, 500);
                    scope.$on('$destroy', function () {
                        $interval.cancel(cancelFn);
                    });
                }

            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.d').directive('scrollPositionObserver', scrollPositionObserver);

    /** @ngInject */
    function scrollPositionObserver() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var content = element.children().first();
                element.addClass("scroll-position-left");
                element.on('scroll', function (e) {
                    var max = content.width() - element.width();
                    var offset = element.scrollLeft();
                    element.removeClass("scroll-position-left scroll-position-right scroll-position-middle");
                    if (offset === 0) {
                        element.addClass("scroll-position-left");
                    } else if (offset === max) {
                        element.addClass("scroll-position-right");
                    } else {
                        element.addClass("scroll-position-middle");
                    }
                });
            }
        };
    }
})();

/**
 * Detect Element Resize
 *
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * version: 0.5.3
 **/

(function () {
    'use strict';

    angular.module('c.d')
        .directive('scrollbarButton', scrollbarButton);

    /** @ngInject */
    function scrollbarButton($interval) {
        return {
            restrict: 'A',
            scope: false,
            compile: function () {
                return {
                    post: function prelink(scope, element, attrs) {
                        var listElem, prevBtn, nextBtn;
                        var intervalFn;

                        init();


                        function init() {
                            prevBtn = "<a><i class='fa fa-arrow-circle-left'></i></a>";
                            nextBtn = "<a ng-click=scrollToNext()><i class='fa fa-arrow-circle-right'></i></a>";

                            prevBtn = angular.element(prevBtn);
                            // prevBtn.css("display", "none");
                            nextBtn = angular.element(nextBtn);

                            prevBtn.on('mousedown', scrollToPrev);
                            prevBtn.on('mouseup', stopScroll);
                            nextBtn.on('mousedown', scrollToNext);
                            nextBtn.on('mouseup', stopScroll);
                            element.resize(onResize);

                            element.css({position: "relative"});
                            prevBtn.css({
                                display: "none", position: "absolute",
                                top: "50%", left: "3px", transform: "translateY(-50%)"
                            });
                            nextBtn.css({
                                display: "none", position: "absolute",
                                top: "50%", right: "3px", transform: "translateY(-50%)"
                            });

                            // nextBtn.css("display", "none");

                            // console.log('element', element.html().trim());
                            listElem = angular.element(element.children()[0]);

                            element.prepend(prevBtn);
                            element.append(nextBtn);
                            if (scope.vm.dateList && scope.vm.dateList.length > 0) {
                                // console.log('vm.vm', vm.vm.dateList);
                                // console.log('element.html()', element.html());
                            }


                            // $compile(element.contents())(scope);
                        }

                        function onResize() {
                            recalculate();
                        }

                        function recalculate() {
                            var containerElemWidth = element.width();
                            var ml = parseInt(listElem.css("marginLeft"));
                            var listElemWidth = listElem.width();
                            var dw = containerElemWidth - listElemWidth;
                            if (ml < 0 && ml < dw) {
                                ml = dw < 0 ? dw : 0;
                                listElem.css({marginLeft: ml + "px"})
                            }
                            prevBtn.css({"display": ml === 0 || dw >= 0 ? "none" : "block"});
                            nextBtn.css({"display": ml === dw || dw >= 0 ? "none" : "block"});
                        }

                        function scrollToPrev(event) {
                            intervalFn = $interval(function () {
                                scrollTo(10);
                            }, 10);
                        }

                        function scrollToNext(event) {
                            intervalFn = $interval(function () {
                                scrollTo(-10);
                            }, 10);
                        }

                        function stopScroll() {
                            if (intervalFn) $interval.cancel(intervalFn);
                        }

                        function scrollTo(d) {
                            var containerElemWidth = element.width();
                            var ml = parseInt(listElem.css("marginLeft"));
                            var listElemWidth = listElem.width();
                            var dw = containerElemWidth - listElemWidth;
                            ml += d;
                            if (ml > 0) ml = 0;
                            if (dw < 0 && ml < dw) ml = dw;
                            listElem.css({marginLeft: ml + "px"});
                            prevBtn.css({"display": ml === 0 ? "none" : "block"});
                            nextBtn.css({"display": ml === dw ? "none" : "block"});
                            if (ml === dw || ml === 0) {
                                stopScroll();
                            }
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.d').directive('stickyLeft', stickyLeft);

    /** @ngInject */
    function stickyLeft() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (attrs.stickyLeft) {
                    element.addClass("position-sticky sticky-left");
                    element.css("left", attrs.stickyLeft);
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('c.d').directive('stickyRight', stickyRight);

    /** @ngInject */
    function stickyRight() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (attrs.stickyRight) {
                    element.addClass("position-sticky sticky-right");
                    element.css("right", attrs.stickyRight);
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('c.d')
        .directive('bindScanningGun', bindScanningGun);


    /** @ngInject */
    function bindScanningGun(ScanningGun) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                ScanningGun.bind(scope, function (result) {
                    ngModelCtrl.$setViewValue(result);
                    ngModelCtrl.$render();
                }, attrs.bindToElement === 'true' ? element : null);
            }
        }
    }
})();
(function(){
    var elif = angular.module('elif', []);

    var CONDITIONALS = 'elif.conditionals';

    // This is copied from AngularJS because it is not
    // part of the public interface.
    var getBlockElements = function(nodes){
        if(!nodes || !nodes.length){
            return angular.element();
        }

        var startNode = nodes[0];
        var endNode = nodes[nodes.length - 1];

        if(startNode === endNode){
            return angular.element(startNode);
        }

        var element = startNode;
        var elements = [element];

        do {
            element = element.nextSibling;
            if(!element){
                break;
            }
            elements.push(element);
        }
        while(element !== endNode);

        return angular.element(elements);
    };

    elif.factory('elif', [
        function(){
            // By requiring the scope have it's own copy of `elif.conditionals`
            // we avoid if/else-if/else structures that span AngularJS scopes.
            var getConditionals = function(scope){
                if(angular.hasOwnProperty.call(scope, CONDITIONALS)){
                    var conditionals = scope[CONDITIONALS];
                    return conditionals[conditionals.length - 1];
                }
            };

            return {
                create: function(scope, fn, callback){
                    var conditionals = [{
                        fn: fn,
                        callback: callback || angular.identity
                    }];
                    var conditionalValues = [];

                    scope.$watch(function(){
                        // Watch the boolean conditionals; we only need
                        // to run through the if/else-if/else chain if one
                        // of them changes.  We can also take the chance to
                        // short-circuit when we've found our first true
                        // condition.
                        var i;
                        var len = conditionals.length;
                        conditionalValues.length = len;
                        for(i = 0; i < len; i++){
                            if((conditionalValues[i] = !!conditionals[i].fn())){
                                i++;
                                break;
                            }
                        }
                        for(; i < len; i++){
                            conditionalValues[i] = false;
                        }
                        return conditionalValues;
                    }, function(conditionalValues){

                        // Update each block; also find first matching if/else-if.
                        var index = -1;
                        for(var i = 0, len = conditionals.length; i < len; i++){
                            if(conditionalValues[i]){
                                conditionals[i].callback(true);
                                index = i;
                            }
                            else {
                                conditionals[i].callback(false);
                            }
                        }

                        // Handle else, if there is one.
                        conditionals.fallthrough && conditionals.fallthrough(index === -1);

                    }, true); // Deep watch; we know that it is a simple list of booleans.

                    // Keep track of if/else-if/else structures per AngularJS scope.
                    if(!angular.hasOwnProperty.call(scope, CONDITIONALS)){
                        scope[CONDITIONALS] = [];
                    }
                    scope[CONDITIONALS].push(conditionals);
                },
                extend: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.extend: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.extend: else-if after else');
                    }

                    conditionals.push({
                        fn: fn,
                        callback: callback
                    });
                },
                fallthrough: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.fallthrough: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.fallthrough: else already found at this level');
                    }
                    conditionals.fallthrough = callback;
                }
            };
        }
    ]);

    // This implementation is basically the built-in `ng-if`, hooked into the `elif` service.
    var elifDirective = function(name, method, getter){
        elif.directive(name, [
            '$animate',
            '$document',
            '$injector',
            'elif',
            function($animate, $document, $injector, elif){
                var getterFn = getter && $injector.invoke(getter);

                return {
                    transclude: 'element',
                    restrict: 'A',
                    priority: 600,
                    terminal: true,
                    link: function(scope, element, attrs, ctrls, transcludeFn){
                        var watchFn = getterFn && getterFn(scope, element, attrs);
                        var childScope;
                        var childElement;
                        var previousElements;

                        elif[method](scope, watchFn, function(value){
                            if(value){
                                if(!childScope){
                                    childScope = scope.$new();
                                    transcludeFn(childScope, function(clone){
                                        clone[clone.length + 1] = $document[0].createComment(' end ' + name + ': ' + attrs[name] + ' ');
                                        childElement = clone;
                                        $animate.enter(clone, element.parent(), element);
                                    });
                                }
                            }
                            else {
                                if(childScope){
                                    childScope.$destroy();
                                    childScope = null;
                                }
                                if(previousElements){
                                    previousElements.remove();
                                    previousElements = null;
                                }
                                if(childElement){
                                    previousElements = getBlockElements(childElement);
                                    $animate.leave(previousElements, function(){
                                        previousElements = null;
                                    });
                                    childElement = null;
                                }
                            }
                        });
                    }
                };
            }
        ]);
    };

    // Reads the attribute given by `name` and converts it to a boolean.
    var getter = function(name){
        return [
            '$parse',
            function($parse){
                return function(scope, element, attrs){
                    var testFn = $parse(attrs[name]);
                    return function(){
                        return !!testFn(scope);
                    };
                };
            }
        ];
    };

    // We rely on the built-in `ng-if` directive to actually perform
    // the transclusion, and simply tie it in to the `elif` service.
    elif.directive('ngIf', [
        '$injector',
        'elif',
        function($injector, elif){
            var getterFn = $injector.invoke(getter('ngIf'));
            return {
                priority: 600,
                link: function(scope, element, attrs){
                    var watchFn = getterFn(scope, element, attrs);
                    elif.create(scope, watchFn);
                }
            }
        }
    ]);

    // Else-if and else perform their own transclusions.
    elifDirective('ngElseIf', 'extend', getter('ngElseIf'));
    elifDirective('ngElif', 'extend', getter('ngElif'));

    // Else doesn't take an argument.
    elifDirective('ngElse', 'fallthrough');
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('BloodStorageCtrl', BloodStorageCtrl);

    /** @ngInject */
    function BloodStorageCtrl($scope, uibDateParser, dialogs, toaster, C, Table,
                              FileHelper, DateHelper, Upload, SaveAs, BloodStorage) {

        var vm = $scope;
        vm.upload = upload;
        vm.download = download;
        vm.remove = remove;
        vm.day = new Date();

        init();


        function init() {
            var options = {
                service: BloodStorage,
                params: {},
                sorting: {'blood_storage.created_at': 'desc'},
                hideOpt: true, hideFilter: true,
                cols: [
                    {field: "blood_storage.name", title: "名称"},
                    {field: "user_id", title: "上传人"},

                    {field: "date", title: "日期"}
                ]
            };

            Table.load(vm, options, function (resp) {
                if (resp.items && resp.items.length > 0 &&
                    DateHelper.areSameDate(uibDateParser.parse(resp.items[0].date, 'yyyy-MM-dd'), new Date())) {
                    vm.today = resp.items[0];
                } else {
                    vm.today = {};
                }
            });
        }


        function upload(file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            if (file == null) {
                return;
            }
            m.progress = 0;
            Upload.upload({
                url: C.URL.BLOOD_STORAGE_UPLOAD, data: {file: file, id: m.id}
            }).progress(function (evt) {
                m.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.name = resp.name;
                        m.mime = resp.mime;
                        m.filename = resp.filename;
                        m.size = resp.size;
                        vm.tableReload();
                        break;
                    case 1:
                        m.progress = 101;
                        m.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                m.progress = 102;
                m.errorInfo = '服务器错误!';
            });
        }

        function download(m) {
            var params = {filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.BLOOD_STORAGE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }

        function remove(m) {
            dialogs.confirm('删除储血量信息', '确定要删除<strong>' + m.name + '</strong>的记录吗?')
                .result.then(function () {
                BloodStorage.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('操作成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('操作失败!');
                });
            });
        }
    }
})();

angular.module('c.c').controller('120DirectCtrl',
    function ($scope, $rootScope, $filter, toaster, C, F, $q, CApply, CarType, Car, Driver, Dept, CarDestination) {

        function time2SliderVal (time) {
            var hour = parseInt(time.substr(0, 2));
            var minute = parseInt(time.substr(3, 2));
            return hour * 12 + minute / 5;
        }

        $scope.CarLFees = F.get('CarLFees');

        $scope.searchIdle = function (car) {
            if (car.s.min == car.s.max) {
                toaster.warning('开始和结束时间不能相等');
            } else {
                var date = $filter('date')(car.date, 'yyyy-MM-dd');
                var start = date + ' ' + car.s.options.translate(car.s.min);
                var end = date + ' ' + car.s.options.translate(car.s.max);
                Car.query({
                    opt: 2,
                    start: start,
                    end: end,
                    type_id: car.type.id,
                    schedule_on: car.schedule_on == true ? 1 : 0
                }, function (resp) {
                    $scope.cars = resp.records;
                    $scope.cars.push({plate_num: '滴滴用车', limit_day: '无'});
                });

                if (car.type.id == '3') {
                    $scope.car['remarks'] = '因公';
                }
            }
        };

        $scope.$watch('car.c', function (newV, oldV) {

            if (newV.plate_num == '滴滴用车') {
                $scope.isDe = true;
                $scope.car.type = F.getItem('企业滴滴', $scope.types, 'name');
            } else {
                $scope.isDe = false;
            }
        });

        $scope.getDept = function () {
            Dept.query({
                    opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS
                }, function (resp) {
                    $scope.depts = resp.depts;
                    if ($scope.car) {
                        $scope.car['dept'] = resp.depts[0];
                    }
                }
            );
        };

        $scope.getDestinations = function () {
            CarDestination.query({opt: 2}, function (resp) {
                var destinations = $scope.CarLFees.concat(resp.items);
                $scope.destinations = destinations;
            });
        };


        $scope.getDriver = function (car) {
            Driver.query({
                opt: 2,
                start: car.start_time,
                end: car.end_time,
                type_id: car.type_id
            }, function (resp) {
                $scope.drivers = resp.duty_drivers;
            });
        };

        $scope.submit = function (car) {
            var defer = $q.defer();
            var isSuccess = true;
            if (car.date == null) {
                toaster.warning('用车日期不能为空');
                isSuccess = false;
            } else if (car.s.min == car.s.max) {
                toaster.warning('开始和结束时间不能相等');
                isSuccess = false;
            } else if (!car.destination) {
                toaster.warning('请选择或输入目的地');
                isSuccess = false;
            } else if (!$scope.isDe) {
                if (!$scope.car.c) {
                    toaster.warning('请选择车辆');
                    isSuccess = false;
                } else if (
                    car.pre_mile != null && car.pre_mile !== '' &&
                    car.later_mile != null && car.later_mile !== '' &&
                    Number(car.pre_mile) >= Number(car.later_mile)
                ) {
                    toaster.warning('出发里程不能大于回程里程，请重新填写');
                    isSuccess = false;
                } else if ($scope.cars.length == 0) {
                    toaster.warning('此时间段已无车可用，请更换时间');
                    isSuccess = false;
                }
            }
            // else if ($scope.isDe) {
            //     if (!car.d_driver) {
            //         toaster.warning('请填入滴滴驾驶员姓名');
            //         isSuccess = false;
            //     } else if (!car.d_plate) {
            //         toaster.warning('请填入滴滴驾驶员姓名');
            //         isSuccess = false;
            //     } else if (!car.d_phone) {
            //         toaster.warning('请填入滴滴车驾驶员联系电话');
            //         isSuccess = false;
            //     } else if (!car.d_pay) {
            //         toaster.warning('请填入滴滴车费用');
            //         isSuccess = false;
            //     }
            // }

            if (isSuccess) {
                var params = {};
                params['type_id'] = car.type.id;
                params['dept_id'] = car.dept.id;
                params['remarks'] = car.remarks;
                params['destination'] = car.destination;
                var date = $filter('date')(car.date, 'yyyy-MM-dd');
                var start = date + ' ' + car.s.options.translate(car.s.min);
                var end = date + ' ' + car.s.options.translate(car.s.max);
                params['start_time'] = start;
                params['end_time'] = end;

                if ($scope.isDe) {
                    params['is_de'] = true;
                    // params['d_driver'] = car.d_driver;
                    // params['d_plate_num'] = car.d_plate;
                    // params['d_pay'] = car.d_pay;
                    // params['d_phone'] = car.d_phone;
                    params['status'] = 8;
                } else {
                    params['car_id'] = car.c.id;
                    params['driver_id'] = car.driver.id;
                    if ((car.pre_mile == '' || car.pre_mile == null) && (car.later_mile == '' || car.later_mile == null)) {
                        params['status'] = 6;    //表明所有信息已填写
                    }
                    if ((car.pre_mile != '' && car.pre_mile != null) && (car.later_mile == '' || car.later_mile == null)) {
                        params['pre_mile'] = car.pre_mile;
                        params['status'] = 7;
                    }
                    if ((car.pre_mile != '' && car.pre_mile != null) && (car.later_mile != '' && car.later_mile != null)) {
                        params['pre_mile'] = car.pre_mile;
                        params['later_mile'] = car.later_mile;
                        params['status'] = 8;    //表明所有信息已填写
                    }
                    params['send_driver'] = car.send_driver;
                    params['set_destination'] = car.set_destination ? 1 : 0;

                    params['fee'] = car.fee;
                    //消毒供应室特殊情况，不收费用
                    if (car.dept.id == 42) {
                        params['fee'] = 0;
                    }
                }

                params['direct'] = true;
                CApply.save(params).$promise.then(function (resp) {
                    toaster.success('用车录入成功!');
                    $scope.reset();
                    $scope.isDe = false;
                    $rootScope.$broadcast('fresh');
                    $scope.tabs['directs'] = true;
                }, function () {
                    toaster.error('用车录入失败了!');
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                defer.reject();
            }
            return defer.promise;
        };


//判断当前时间，是否为周末或者17:30~08:00 为下班，否则则为上班   day  0为星期天
        var date = new Date();
        var day = date.getDay();
        var hour = date.getHours();
        var schedule_on = 0;

        if (day == 0 || day == 6) {
            schedule_on = 0
        } else {
            if (hour >= 8 && hour < 17) {
                schedule_on = 1;
            } else {
                if (hour == 17) {
                    if (date.getMinutes() <= 30) {
                        schedule_on = 1;
                    }
                }
            }
        }

        $scope.reset = function () {
            CarType.query({'opt': 2}, function (resp) {
                    $scope.types = resp.types;
                    var car = {
                        type: $scope.types[1],
                        date: new Date(),
                        s: {
                            min: 144, max: 168, options: {
                                floor: 0,
                                ceil: 288,
                                translate: function (val) {
                                    var h = Math.floor(val / 12);
                                    var m = (val % 12) * 5;
                                    return h + ':' + (m >= 10 ? '' : '0') + m;
                                },
                                onEnd: function () {
                                    var date = $filter('date')($scope.car.date, 'yyyy-MM-dd');
                                    var start = date + ' ' + $scope.car.s.options.translate($scope.car.s.min);
                                    var end = date + ' ' + $scope.car.s.options.translate($scope.car.s.max);
                                    $scope.car['start_time'] = start;
                                    $scope.car['end_time'] = end;
                                    $scope.searchIdle($scope.car);
                                    $scope.getDriver($scope.car);
                                }
                            }
                        },
                        fee: 0,
                        set_destination: false
                    };

                    $scope.isDe = false;

                    var date = $filter('date')(car.date, 'yyyy-MM-dd');
                    car['start_time'] = date + ' ' + car.s.options.translate(car.s.min);
                    car['end_time'] = date + ' ' + car.s.options.translate(car.s.max);
                    $scope.car = car;
                    $scope.searchIdle(car);
                    $scope.getDriver(car);
                    $scope.getDept();
                    $scope.getDestinations();
                }
            );
        };

        $scope.reset();

        $scope.$watch('car.date',
            function () {
                var date = $filter('date')($scope.car.date, 'yyyy-MM-dd');
                var start = date + ' ' + $scope.car.s.options.translate($scope.car.s.min);
                var end = date + ' ' + $scope.car.s.options.translate($scope.car.s.max);
                $scope.car['start_time'] = start;
                $scope.car['end_time'] = end;
                $scope.searchIdle($scope.car);
                $scope.getDriver($scope.car);
            });

        $scope.tagTrans = function (newTag) {
            var item = F.getItem(newTag, $scope.destinations, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        };
    });
angular.module('c.c').controller('CarDirectCtrl',
    function ($scope, $rootScope, $filter, toaster, C, F, $q, CApply, CarType, Car, Driver, Dept, CarWaitLocation, CarContact
        , CarDestination) {

        function time2SliderVal (time) {
            var hour = parseInt(time.substr(0, 2));
            var minute = parseInt(time.substr(3, 2));
            return hour * 12 + minute / 5;
        }

        $scope.CarLFees = F.get('CarLFees');

        $scope.searchIdle = function (car) {
            if (car.s.min == car.s.max) {
                toaster.warning('开始和结束时间不能相等');
            } else {
                var date = $filter('date')(car.date, 'yyyy-MM-dd');
                var start = date + ' ' + car.s.options.translate(car.s.min);
                var end = date + ' ' + car.s.options.translate(car.s.max);
                Car.query({
                    opt: 2,
                    start: start,
                    end: end,
                    type_id: car.type.id,
                    schedule_on: car.schedule_on == true ? 1 : 0
                }, function (resp) {
                    $scope.cars = resp.records;
                    $scope.cars.push({plate_num: '滴滴用车', limit_day: '无'});
                    $scope.duty_caller = resp.duty_caller;
                });

                if (car.type.id == '3') {
                    $scope.car['remarks'] = '因公';
                }
            }
        };

        $scope.$watch('car.c', function (newV, oldV) {

            if (newV.plate_num == '滴滴用车') {
                $scope.isDe = true;
                $scope.car.type = F.getItem('企业滴滴', $scope.types, 'name');
                $scope.car.location = [F.getItem('西藏成办医院门口', $scope.locations, 'name')];
            } else {
                $scope.isDe = false;
                $scope.car.location = null;
            }
        });

        $scope.getCaller = function (car) {
            CarContact.query({
                opt: 2,
                type_id: car.type.id,
                schedule_on: car.schedule_on == true ? 1 : 0
            }, function (resp) {
                $scope.duty_caller = resp[0];
            });

        };

        $scope.getContact = function (car) {
            $scope.car.contact = $scope.car.user;

        };

        $scope.getDept = function (car) {
            Dept.query({
                    opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS3, user_id: car.user.id
                }, function (resp) {
                    var depts = resp.depts;
                    if ($scope.car) {
                        $scope.car.dept = depts[0];
                    }
                    $scope.depts = depts;
                }
            );
            $scope.car.contact = $scope.car.user;
        };


        $scope.getDriver = function (car) {
            Driver.query({
                opt: 2,
                start: car.start_time,
                end: car.end_time,
                type_id: car.type_id
            }, function (resp) {
                $scope.drivers = resp.duty_drivers;
            });
        };

        $scope.getLocations = function () {
            CarWaitLocation.query(function (resp) {
                var locations = resp;
                $scope.locations = locations;
            });

            CarDestination.query({opt: 2}, function (resp) {
                var destinations = $scope.CarLFees.concat(resp.items);
                $scope.destinations = destinations;
            });
        };

        var out_str = '某某-电话-地址（选填）；某某-电话-地址（选填）';
        $scope.submit = function (car) {
            var defer = $q.defer();
            var isSuccess = true;
            if (car.date == null) {
                toaster.warning('用车日期不能为空');
                isSuccess = false;
            } else if (car.s.min == car.s.max) {
                toaster.warning('开始和结束时间不能相等');
                isSuccess = false;
            } else if ($scope.cars.length == 0) {
                toaster.warning('此时间段已无车可用,请更换时间');
                isSuccess = false;
            } else if (car.contact == null) {
                toaster.warning('联系人不能为空');
                isSuccess = false;
            } else if (!car.destination) {
                toaster.warning('请选择或输入目的地');
                isSuccess = false;
            } else if (!$scope.isDe) {
                if (car.driver == null) {
                    toaster.warning('请选择驾驶员');
                    isSuccess = false;
                } else if (!$scope.car.c) {
                    toaster.warning('请选择车辆');
                    isSuccess = false;
                } else if (car.location == null) {
                    toaster.warning('请选择或输入待车地点');
                    isSuccess = false;
                }
            }
            // else if ($scope.isDe) {
            //     if (!car.d_driver) {
            //         toaster.warning('请填入滴滴驾驶员姓名');
            //         isSuccess = false;
            //     } else if (!car.d_plate) {
            //         toaster.warning('请填入滴滴车牌号');
            //         isSuccess = false;
            //     } else if (!car.d_phone) {
            //         toaster.warning('请填入滴滴车驾驶员联系电话');
            //         isSuccess = false;
            //     } else if (!car.d_pay) {
            //         toaster.warning('请填入滴滴车费用');
            //         isSuccess = false;
            //     }
            // }
            if (isSuccess) {
                var params = {};
                params['type_id'] = car.type.id;
                params['user_id'] = car.user.id;
                params['dept_id'] = car.dept.id;

                params['remarks'] = car.remarks;
                params['dept_charge_id'] = car.dept.leader_id;
                params['location'] = car.location;
                params['contact_id'] = car.contact.id;
                params['destination'] = car.destination;
                params['send_driver'] = car.send_driver;

                if (car.out_passenger == out_str) {
                    params['out_passenger'] = '';
                } else {
                    params['out_passenger'] = car.out_passenger;
                }
                var temp = [];
                angular.forEach(car.passengers, function (passenger) {
                    temp.push(passenger.id);
                });
                params['passengers'] = temp;
                var date = $filter('date')(car.date, 'yyyy-MM-dd');
                var start = date + ' ' + car.s.options.translate(car.s.min);
                var end = date + ' ' + car.s.options.translate(car.s.max);
                params['start_time'] = start;
                params['end_time'] = end;
                params['send_out'] = car.send_out == true ? 1 : 0;
                params['send_passenger'] = car.send_passenger == true ? 1 : 0;
                params['set_location'] = car.set_location ? 1 : 0;
                params['set_destination'] = car.set_destination ? 1 : 0;

                if ($scope.isDe) {
                    params['is_de'] = true;
                    params['d_driver'] = car.d_driver;
                    params['d_plate_num'] = car.d_plate;
                    params['d_pay'] = car.d_pay;
                    params['d_phone'] = car.d_phone;
                    params['status'] = 8;
                } else {
                    params['car_id'] = car.c.id;
                    params['driver_id'] = car.driver.id;

                    params['schedule_on'] = car.send_schedule == true ? 1 : 0;
                    params['fee'] = car.fee;
                    //消毒供应室特殊情况，不收费用
                    if (car.dept.id == 42) {
                        params['fee'] = 0;
                    }
                    if ((car.pre_mile == '' || car.pre_mile == null) && (car.later_mile == '' || car.later_mile == null)) {
                        params['status'] = 6;    //表明所有信息已填写
                    }
                    if ((car.pre_mile != '' && car.pre_mile != null) && (car.later_mile == '' || car.later_mile == null)) {
                        params['pre_mile'] = car.pre_mile;
                        params['status'] = 7;
                    }
                    if ((car.pre_mile != '' && car.pre_mile != null) && (car.later_mile != '' && car.later_mile != null)) {
                        params['pre_mile'] = car.pre_mile;
                        params['later_mile'] = car.later_mile;
                        params['status'] = 8;    //表明所有信息已填写
                    }
                }

                params['direct'] = 1;


                CApply.save(params).$promise.then(function (resp) {
                    toaster.success('用车录入成功!');
                    $scope.reset();
                    $scope.isDe = false;
                    $rootScope.$broadcast('fresh');
                    $scope.tabs['directs'] = true;
                }, function () {
                    toaster.error('用车录入失败了!');
                }).finally(function () {
                    defer.resolve();
                });

            } else {
                defer.reject();
            }
            return defer.promise;
        };

//判断当前时间,是否为周末或者17:30~08:00 为下班,否则则为上班   day  0为星期天
        var date = new Date();
        var day = date.getDay();
        var hour = date.getHours();
        var schedule_on = 0;

        if (day == 0 || day == 6) {
            schedule_on = 0
        } else {
            if (hour >= 8 && hour < 17) {
                schedule_on = 1;
            } else {
                if (hour == 17) {
                    if (date.getMinutes() <= 30) {
                        schedule_on = 1;
                    }
                }
            }
        }

        $scope.reset = function () {
            CarType.query({'opt': 2}, function (resp) {
                    $scope.types = resp.types;
                    var car = {
                        type: $scope.types[1],
                        date: new Date(),
                        schedule_on: schedule_on,
                        passengers: [],
                        send_driver: false,
                        s: {
                            min: 144, max: 168, options: {
                                floor: 0,
                                ceil: 288,
                                translate: function (val) {
                                    var h = Math.floor(val / 12);
                                    var m = (val % 12) * 5;
                                    return h + ':' + (m >= 10 ? '' : '0') + m;
                                },
                                onEnd: function () {
                                    var date = $filter('date')($scope.car.date, 'yyyy-MM-dd');
                                    var start = date + ' ' + $scope.car.s.options.translate($scope.car.s.min);
                                    var end = date + ' ' + $scope.car.s.options.translate($scope.car.s.max);
                                    $scope.car['start_time'] = start;
                                    $scope.car['end_time'] = end;
                                    $scope.searchIdle($scope.car);
                                    $scope.getDriver($scope.car);
                                }
                            }
                        },
                        out_passenger: out_str,
                        fee: 0,
                        set_location: false,
                        set_destination: false
                    };

                    $scope.isDe = false;

                    var date = $filter('date')(car.date, 'yyyy-MM-dd');
                    car['start_time'] = date + ' ' + car.s.options.translate(car.s.min);
                    car['end_time'] = date + ' ' + car.s.options.translate(car.s.max);
                    $scope.car = car;
                    $scope.car['send_passenger'] = true;
                    $scope.getCaller(car);
                    $scope.searchIdle(car);
                    $scope.getDriver(car);
                    $scope.getLocations();
                    $scope.getDept(car);
                }
            );
        };

        $scope.reset();

        $scope.$watch('car.date',
            function () {
                var date = $filter('date')($scope.car.date, 'yyyy-MM-dd');
                var start = date + ' ' + $scope.car.s.options.translate($scope.car.s.min);
                var end = date + ' ' + $scope.car.s.options.translate($scope.car.s.max);
                $scope.car['start_time'] = start;
                $scope.car['end_time'] = end;
                $scope.searchIdle($scope.car);
                $scope.getDriver($scope.car);
            });

        $scope.tagTransform = function (newTag) {
            var item = F.getItem(newTag, $scope.locations, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        };

        $scope.tagTrans = function (newTag) {
            var item = F.getItem(newTag, $scope.destinations, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        };

        $scope.$watch('car.user',
            function () {
                $scope.getDept($scope.car);
            });

    });
angular.module('c.c').controller('CarRecordCtrl',
    function ($scope, $rootScope, $filter, toaster, C, F, NgTableParams, dialogs, CApply) {

    });

angular.module('c.c')
    .controller('CarSchedulerCtrl', function ($scope, toaster, F, CarContact) {

        $scope.reload = function () {
            CarContact.query(function (resp) {
                var r = {};
                if (resp) {
                    r['common_on'] = F.getItem(1, resp).phone;
                    r['common_off'] = F.getItem(2, resp).phone;
                    r['oto_on'] = F.getItem(3, resp).phone;
                    r['oto_off'] = F.getItem(4, resp).phone;
                    r['ambulance_on'] = F.getItem(5, resp).phone;
                    r['ambulance_off'] = F.getItem(6, resp).phone;
                }
                $scope.r = r;
            });
        };


        $scope.submit = function (r) {
            if ($scope.s_form.$valid) {
                var params = {};
                params['common_on'] = {id: 1, phone: r.common_on};
                params['common_off'] = {id: 2, phone: r.common_off};
                params['oto_on'] = {id: 3, phone: r.oto_on};
                params['oto_off'] = {id: 4, phone: r.oto_off};
                params['ambulance_on'] = {id: 5, phone: r.ambulance_on};
                params['ambulance_off'] = {id: 6, phone: r.ambulance_off};
                CarContact.update({id: 0}, params).$promise.then(function () {
                    toaster.success('设置成功');
                }, function () {
                    toaster.error('设置失败');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }

        };


        $scope.reset = $scope.reload;
        $scope.reload();

    });









angular.module('c.c')
    .controller('CarStatusesCtrl',
    function ($scope, $filter, dialogs, toaster, NgTableParams, CApply, F) {

        $scope.cols = [
            {title: '车牌号', field: 'plate_num', show: true}, //0
            {title: '车型', show: true}, //6
            {title: '状态', show: true}, //6
            {title: '出发时间', show: true},
            {title: '目的地', show: true}
        ];

        $scope.hideOpt = true;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 14;
                CApply.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };


    });
angular.module('c.c')
    .controller('CarWarrantyCtrl',
    function ($scope, $filter, dialogs, toaster, NgTableParams, CarWarranty, F) {
        var cwTypes = F.getNgTableOpts(F.get('cw_types'));
        $scope.cwTypes = F.get('cw_types');

        $scope.cols = [
            {title: '车牌号', field: 'plate_num', filter: {plate_num: 'select'}, show: true}, //0
            {
                title: '类别',
                sortable: 'car_warranty.type_id',
                filter: {'car_warranty.type_id': 'select'},
                field: 'car_warranty.type_id',
                data: cwTypes,
                show: true
            }, //6
            {
                title: '当前行驶里程',
                sortable: 'distance',
                filter: {distance: 'number_range'},
                field: 'distance',
                show: true
            }, //6
            {
                title: '金额',
                sortable: 'money',
                filter: {money: 'number_range'},
                field: 'money',
                show: true
            }, //6
            {title: '保修说明', filter: {remarks: 'text'}, field: 'remarks', show: true}, //6
            {title: '执行人', field: 'users.name', filter: {'users.name': 'text'}, show: true}, //0
            {title: '维修时间', filter: {created_at: 'date_range'}, field: 'created_at', show: true}
        ];

        $scope.cars_col = $scope.cols[0];
        $scope.optColWidth = 70;

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                var startDate, endDate;
                if ($scope.dateRangeFilter.created_at != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        end: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                CarWarranty.query(url, function (data) {
                    $scope.cars = data.cars;
                    $scope.cars_col.data = F.getNgTableOpts($scope.cars);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.numRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('CarWarrantyDlg.html', 'CarWarrantyDlgCtrl', {types: $scope.cwTypes, cars: $scope.cars}, {
                 size: 'md'
            }).result.then(function (warranty) {
                    CarWarranty.save(warranty).$promise.then(function (data) {
                        toaster.success('维保添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('维保记录添加失败!');
                    });
                });
        };

        $scope.edit = function (record) {
            dialogs.create('CarWarrantyDlg.html', 'CarWarrantyDlgCtrl', {
                    warranty: record, edit: true, types: $scope.cwTypes
                }, {
                     size: 'md'
                }
            ).result.then(function (warranty) {
                    CarWarranty.update({id: record.id}, warranty).$promise.then(function (data) {
                        toaster.success('维保记录修改成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('维保记录修改失败!');
                    });
                });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除维保记录', '确定要删除<strong>' + record.car.plate_num + '</strong>的记录吗？')
                .result.then(function () {
                    CarWarranty.delete({id: record.id}).$promise.then(function (resp) {
                        toaster.success('维保记录删除成功!');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('维保记录删除失败!');
                    });
                });

        };
    })
;


angular.module('c.c').controller('CarWarrantyDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data) {

        $scope.types = data.types;
        $scope.cars = data.cars;
        $scope.edit = data.edit;
        if (data.warranty) {
            var warranty = data.warranty;
            $scope.$edit = true;
            $scope.warranty = {
                type: $scope.types[warranty.type_id - 1],
                car: warranty.car,
                money: warranty.money,
                distance: warranty.distance,
                remarks: warranty.remarks
            }
        } else {
            $scope.warranty = {
                type: data.types[0],
                car: data.cars[0]
            };
        }

        $scope.ok = function (warranty) {
            if ($scope.warranty_form.$valid) {
                var params = {};
                params['car_id'] = warranty.car.id;
                params['type_id'] = warranty.type.id;
                params['distance'] = warranty.distance;
                params['money'] = warranty.money;
                params['remarks'] = warranty.remarks;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.warranty_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    })
;
angular.module('c.c')
    .controller('CarPendingCtrl',
    function ($scope, $stateParams, F) {
        var vm = $scope;
        F.loadTabs(vm, $stateParams);
    });

angular.module('c.c')
    .controller('CjMealCtrl', function (UIHelper, $scope, $stateParams) {
        UIHelper.loadTabs($scope, $stateParams);
    });
(function () {
    'use strict';
    angular.module('c.c')
        .controller('MeetingTopicDeanCtrl', MeetingTopicDeanCtrl);

    /** @ngInject */
    function MeetingTopicDeanCtrl($scope, $rootScope, $stateParams, F) {
        var vm = $scope;
        F.loadTabs(vm, $stateParams, $rootScope);
    }

})();
angular.module('c.c')
    .controller('DeptAttendanceCtrl', function ($scope, $filter, dialogs, toaster, F, Table, AttendanceReport,
                                                Dept, UserKpi, NgTableParams, Dlg) {
        $scope.cols = [
            {title: '姓名', field: 'name', show: true},
            {title: '工号', field: 'username', show: true},
            {title: '编制', field: 'status', show: true},
            {title: '岗位', field: 'type', show: true},
            {title: '入科时间', field: 'entry_time', show: true},
            {title: '离科时间', field: 'leave_time', show: true},
            //{title: '工资天数(扣)', field: 'wage_days', show: true},
            //{title: '奖金天数(扣）', field: 'bonus_days', show: true},
            {title: '绩效系数', filed: 'real_kpi', show: true},
            {title: '请假情况', show: true},
            //{title: '请假明细', field: 'sat', show: true},
            {title: '月份', field: 'month', show: false}

        ];

        $scope.hideFilter = true;
        $scope.hideOpt = true;
        $scope.month_col = $scope.cols[10];

        Dept.query({opt: 11}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.first = true;
                $scope.tableParams.reload();
            }
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        var date = new Date((new Date()).setDate(1));
        var month = date.getMonth();
        $scope.dts = new Date(date.setMonth(date.getMonth() - 1));
        $scope.temp_month = new Date((new Date((new Date()).setDate(1))).setMonth(month - 1));
        $scope.first = true;       //第一次监控时间的变化,则不重新查询
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dts = new Date(curr.setMonth(prev));
            $scope.temp_month = new Date(curr.setMonth(prev));
            $scope.first = false;
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dts = new Date(curr.setMonth(next));
            $scope.temp_month = new Date(curr.setMonth(next));
            $scope.first = false;
        };

        $scope.$watch('dts', function (newVal, oldVal, scope) {
            if (!$scope.first) {
                $scope.tableReload();
            }
        }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 100}, {
            counts: [100], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['filter'] = {};
                    url['filter']['month'] = $filter('date')($scope.temp_month, 'yyyy-MM-dd');
                    url['dept_id'] = $scope.dept.id;
                    url['opt'] = 1;
                    AttendanceReport.query(url, function (resp) {
                        $scope.records = resp.records;

                        $scope.count_num = resp.count_num;
                        $scope.trial_num = resp.trial_num;
                        $scope.absence_num = resp.absence_num;
                        $scope.new_comer = resp.new_comer;
                        $scope.leave_num = resp.leave_num;
                        $scope.leader_id = resp.leader_id;   //本科室科室负责人
                        $scope.r_length = resp.records.length > 0;//如果r_length=0 则表示已确认过的列表,否则未确认,判断数组是否为空
                        $scope.resubmit = resp.resubmit;

                        var formal_members = [];
                        var trial_members = [];
                        if ($scope.r_length) {
                            formal_members = resp.records[0];
                            trial_members = resp.records[1]
                        } else {
                            formal_members = resp.formal_members;
                            trial_members = resp.trial_members;
                        }

                        if ($scope.dts > date) {
                            formal_members = [];
                            trial_members = [];
                        }
                        $scope.trial_members = trial_members;
                        $scope.formal_members = formal_members;
                        Table.getTableData(formal_members, $defer, params, $filter);
                    });
                } else {
                    $defer.resolve([]);
                }

            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
            $scope.first = false;
            //params['dept_id'] = $scope.dept.id;
        };

        $scope.declare = function () {
            var currentDate = new Date();
            var currentDay = currentDate.getDate();
            // if (currentDay === 1 || currentDay === 2 || currentDay === 3) {
                dialogs.confirm('发布考勤记录', '确定要发布<strong>' + $filter('date')($scope.dts, 'yyyy年MM月') + '</strong>的考勤记录吗?')
                    .result.then(function () {
                    var params = {};
                    params['stage'] = 2;
                    var kpi_all = true;
                    if (!$scope.resubmit) {
                        angular.forEach($scope.formal_members, function (member) {
                            if (!member.is_ex && member.kpi.length == 0) {
                                kpi_all = false;
                                toaster.warning(member.name + '绩效系数为空,请编辑绩效系数!');
                            }
                        });
                    }
                    console.log($scope.resubmit);
                    console.log(kpi_all);
                    params['leave_num'] = $scope.leave_num;
                    params['new_comer'] = $scope.new_comer;
                    params['count_num'] = $scope.count_num;
                    params['trial_num'] = $scope.trial_num;
                    params['absence_num'] = $scope.absence_num;
                    params['formal_members'] = $scope.formal_members;
                    params['trial_members'] = $scope.trial_members;
                    if (kpi_all) {
                        if ($scope.resubmit) {
                            params['opt'] = 1;
                            params['month'] = $filter('date')($scope.temp_month, 'yyyy-MM-dd');
                            params['dept_id'] = $scope.dept.id;
                            AttendanceReport.update({id: 0}, params).$promise.then(function (resp) {
                                toaster.success('考勤记录发布成功!');
                                $scope.tableReload();
                            }, function (error) {
                                toaster.error('考勤记录发布失败!');
                            });
                        } else {
                            params['month'] = $filter('date')($scope.dts, 'yyyy-MM-dd');
                            params['dept_id'] = $scope.dept.id;
                            //params['wage_cost'] = $scope.wage_cost;
                            AttendanceReport.save(params).$promise.then(function (resp) {
                                toaster.success('考勤记录发布成功!');
                                $scope.tableReload();
                            }, function (error) {
                                toaster.error('考勤记录发布失败!');
                            });
                        }
                    }
                });
            // } else {
            //     Dlg.w("每月1日0:00至4日0:00开放考勤确认，如有疑问请咨询人事科");
            // }

        };

        $scope.kpi = function (record) {
            var edit = false;
            var user_id = 0;
            if ($scope.r_length) {
                if (record.user.kpi.length > 0) {
                    edit = true;
                }
                user_id = record.user.id;
            }
            if (!$scope.r_length) {
                if (record.kpi.length > 0) {
                    edit = true;
                }
                user_id = record.user_id;
            }

            dialogs.create('templates/kpi/user_kpi.html', 'UserKpiCtrl', {
                user_id: user_id, edit: edit
            }, {
                size: 'md'
            }).result.then(function (kpi) {
                UserKpi.save(kpi).$promise.then(function () {
                    toaster.success('员工绩效系数添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('员工绩效系数添加失败!');
                });
            });
        };

    });
angular.module('c.c')
    .controller('DeptDocCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, C, F, Dept, DocType, Doc) {
        $scope.$on('docPrint', function (event, data) {
            var doc = F.getItem(data.id, $scope.docs);
            if (doc) {
                doc.is_print = '1';
            }
        });

        var states = F.get('handle_states');
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.cols = [
            {title: '主题', filter: {subject: 'text'}, show: true},
            {title: '编号', filter: {number: 'text'}, sortable: 'number', show: true},
            {title: '是否已打印', filter: {is_print: 'select'}, data: yesNoOpts, show: true},
            {title: '类型', filter: {type_name: 'text'}, show: true},
            {title: '状态', show: true},
            {title: '创建人', filter: {applicant: 'text'}, show: true}
        ];

        Dept.query({opt: 6}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.tableParams.reload();
            }
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                number: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = C.OPT.DOC.INDEX.DEPT_DOCS;
                    url['dept_id'] = $scope.dept.id;
                    Doc.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.docs, function (doc) {
                            if (!doc.type) {
                                doc.type = {name: '其他'};
                            }
                            doc.state = F.getItem(doc.state, states);
                        });
                        $defer.resolve(resp.docs);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.export = function () {
            if ($scope.dept) {
                dialogs.create('templates/doc/export_docs_dlg.html', 'ExportDocsCtrl',
                    {dept: $scope.dept},
                    { size: 'md'});
            }
        };

        $scope.detail = function (doc) {
            dialogs.create('templates/doc/show_dlg.html', 'DocShowDlgCtrl', {id: doc.id, forArchive: true},
                { size: 'lg'});
        };
    });
'use strict';

angular.module('c.c')
    .controller('DeptLeaveApprovalCtrl', function ($scope, $stateParams, F) {
        var ApprovedNeedRefresh = false;
        var vm = $scope;
        vm.select = select;

        init($stateParams.data.tag);


        function init(tag) {
            F.loadTabs(vm, $stateParams);

            $scope.$on('ApprovedRefresh', function () {
                ApprovedNeedRefresh = true;
            });
        }

        function select(opt) {
            if (opt == 'approved') {
                if (ApprovedNeedRefresh) {
                    $rootScope.$broadcast('ApprovedRefresh');
                    ApprovedNeedRefresh = false;
                }
            }
        }
    });


(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMeetingCtrl', DeptMeetingCtrl);

    /** @ngInject */
    function DeptMeetingCtrl($scope, $stateParams, F, $rootScope) {
        F.loadTabs($scope, $stateParams, $rootScope);
    }

})();





'use strict';

angular.module('c.c')
    .controller('DeptMeetingTopicCtrl', function ($scope, $stateParams, F) {
        F.loadTabs($scope, $stateParams);
    });



(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptMembersInCtrl', DeptMembersInCtrl)
        .controller('DeptAgentCtrl', DeptAgentCtrl)
        .controller('DeptMembersOutCtrl', DeptMembersOutCtrl);


    function DeptMembersInCtrl($scope, $filter, Dlg, toaster, NgTableParams, Dept, UserDept, F) {
        var vm = $scope;
        vm.save = save;
        vm.edit = edit;
        vm.setAgent = setAgent;
        vm.deptSelectedFn = deptSelectedFn;
        vm.clearFilters = clearFilters;

        init();


        function init() {
            var titles = F.get('titles');
            var posts = F.get('posts');
            var titleOpts = F.getNgTableOpts(F.get('titles'));
            var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            vm.yesNo = F.get('yesNo');

            vm.cols = [
                {
                    title: '姓名',
                    filter: {name: 'text'},
                    field: 'name',
                    show: true
                },
                {title: '工号', filter: {username: 'text'}, field: 'username', show: true},
                {
                    title: '入科时间',
                    //sortable: 'entry_time',
                    filter: {entry_time: 'date_range'},
                    field: 'entry_time',
                    show: true
                },
                {title: '专业', field: 'major_id', show: true},
                {title: '职称', filter: {title: 'select'}, field: 'title', data: titleOpts, show: true},
                {title: '岗位类型', filter: {type_id: 'select'}, field: 'type_id', show: true},
                {title: '编制类型', filter: {status_id: 'select'}, field: 'status_id', show: true},
                {title: '科室职务', filter: {post: 'text'}, field: 'post', show: true},
                {title: '科室绩效系数', filter: {kpi: 'text'}, field: 'kpi', show: true},
                {title: '发放绩效', filter: {performance: 'select'}, field: 'performance', data: yesNoOpts, show: true},
                {title: '排序', field: 'sorting', show: true}
            ];

            vm.optColWidth = 70;
            vm.user_types_col = $scope.cols[5];
            vm.statuses_col = $scope.cols[6];

            vm.dateRangeFilter = {};
            vm.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            Dept.query({opt: 7}, function (resp) {
                $scope.depts = resp.depts;
                if (resp.depts && resp.depts.length > 0) {
                    $scope.dept = resp.depts[0];
                    $scope.tableParams.reload();
                }
            });

            vm.tableParams = new NgTableParams({page: 1, count: 30}, {
                counts: [30, 50, 100], total: 0,
                getData: function ($defer, params) {
                    if ($scope.dept) {
                        var url = params.url();
                        url['opt'] = 4;
                        if ($scope.dateRangeFilter['entry_time']) {
                            url['entry_time_start'] = $filter('date')(
                                $scope.dateRangeFilter['entry_time'].startDate, 'yyyy-MM-dd');
                            url['entry_time_end'] = $filter('date')(
                                $scope.dateRangeFilter['entry_time'].endDate, 'yyyy-MM-dd');
                        }
                        url['dept_id'] = $scope.dept.id;
                        UserDept.query(url, function (resp) {
                            params.total(resp.total);
                            $scope.statuses_col.data = F.getNgTableOpts(resp.statuses);
                            $scope.user_types_col.data = F.getNgTableOpts(resp.types);

                            angular.forEach(resp.users, function (u) {
                                u.title = F.getItem(u.title, titles);
                            });
                            $defer.resolve(resp.users);
                        });
                    } else {
                        $defer.resolve([]);
                    }
                }
            });
        }

        function setAgent(dept) {
            Dlg.show({name: 'DeptAgent', data: {id: dept.id}});
        }

        function deptSelectedFn($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        }

        function clearFilters() {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        }

        function edit(user) {
            user.$edit = true;
            user.$postChanged = user.post;
            user.$sortingChanged = user.sorting;
            user.$kpiChanged = user.kpi;
            user.$peformanceChanged = F.getItem(user.performance, vm.yesNo);
        }

        function save(user) {
            user.$edit = false;

            var data = {};
            data['post'] = user.$postChanged;
            data['sorting'] = user.$sortingChanged;
            data['kpi'] = user.$kpiChanged;
            data['performance'] = user.$peformanceChanged.id;
            UserDept.update({id: user.id}, data).$promise.then(function (resp) {
                toaster.success('修改成功!');
                $scope.tableParams.reload();
            }, function () {
                toaster.error('修改失败!');
            });
        }
    }

    function DeptAgentCtrl($scope, $uibModalInstance, $q, toaster, F, Dept, User, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            Dept.get({id: id}, function (resp) {
                var dept = resp;
                vm.dept = dept;
                var edu_agents = [];
                angular.forEach(dept.edu_agent, function (edu) {
                    edu_agents.push(edu.user);
                });
                dept.edu_agents = edu_agents;
                User.query({opt: 3, dept_id: id}, function (resp) {
                    var users = resp.users;
                    vm.users = users;
                    users.splice(0, 0, {id: 0, name: '空缺'});
                    if (dept.mail_recipient == null) dept.mail_recipient = users[0];
                    if (dept.trainee_agent == null) dept.trainee_agent = users[0];
                    if (dept.csmb_agent == null) dept.csmb_agent = users[0];
                    if (dept.disease_agent == null) dept.disease_agent = users[0];
                });
            });
        }

        function ok(dept) {
            var defer = $q.defer();
            var pa = {
                trainee_agent_id: dept.trainee_agent.id,
                mail_recipient_id: dept.mail_recipient.id,
                csmb_agent_id: dept.csmb_agent.id,
                disease_agent_id: dept.disease_agent.id
            };

            if (dept.leader == null) {
                pa.leader_id = null;
            } else {
                pa.leader_id = dept.leader.id;
            }

            if (dept.hospital_leader == null) {
                pa.hospital_leader_id = null;
            } else {
                pa.hospital_leader_id = dept.hospital_leader.id;
            }
            pa.edu_ids = F.listKey(dept.edu_agents);
            pa.adverse_agent_ids = F.listKey(dept.adverse_agents);
            Dept.update({id: dept.id, opt: 1}, pa).$promise.then(function (resp) {
                toaster.success(resp.msg);
                $uibModalInstance.close();
            }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }
    }

    function DeptMembersOutCtrl($scope, $filter, toaster, NgTableParams, Dept, UserDept, F) {

        $scope.cols = [
            {
                title: '姓名',
                filter: {name: 'text'},
                field: 'name',
                show: true
            },
            {title: '工号', filter: {username: 'text'}, field: 'username', show: true},
            {
                title: '入科时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                width: '20%',
                show: true
            },
            {
                title: '离科时间',
                sortable: 'leave_time',
                filter: {leave_time: 'date_range'},
                field: 'leave_time',
                width: '20%',
                show: true
            },
            {title: '科室职务', filter: {post: 'text'}, field: 'post', show: true},
        ];

        $scope.hideOpt = true;

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        Dept.query({opt: 6}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.tableParams.reload();
            }
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = 5;
                    if ($scope.dateRangeFilter['entry_time']) {
                        url['entry_time_start'] = $filter('date')(
                            $scope.dateRangeFilter['entry_time'].startDate, 'yyyy-MM-dd');
                        url['entry_time_end'] = $filter('date')(
                            $scope.dateRangeFilter['entry_time'].endDate, 'yyyy-MM-dd');
                    }
                    if ($scope.dateRangeFilter['leave_time']) {
                        url['leave_time_start'] = $filter('date')(
                            $scope.dateRangeFilter['leave_time'].startDate, 'yyyy-MM-dd');
                        url['leave_time_end'] = $filter('date')(
                            $scope.dateRangeFilter['leave_time'].endDate, 'yyyy-MM-dd');
                    }
                    url['dept_id'] = $scope.dept.id;
                    UserDept.query(url, function (resp) {
                        params.total(resp.total);
                        $defer.resolve(resp.users);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
    }

})();

angular.module('c.c')
    .controller('DeptMissionCtrl', function ($scope) {

    });
'use strict';

angular.module('c.c')
    .controller('NoticeApprovalCtrl', function ($scope, $filter, deviceDetector, dialogs, toaster, NgTableParams, C, F, Bulletin) {
        $scope.$on('bulletinBack', function (event, data) {
            $scope.tableParams.reload();
        });

        var stages = F.getApprovalStages1();
        var stageOpts = F.getNgTableOpts(stages);
        var isDesktop = deviceDetector.isDesktop();
        $scope.isDesktop = isDesktop;
        $scope.showSn = true;
        $scope.cols = [
            {title: '公告标题', filter: {title: 'text'}, show: true},
            {title: '创建时间', show: isDesktop},
            {title: '作者', filter: {sender: 'text'}, show: isDesktop, width: '10%'},
            {title: '状态', filter: {stage: 'select'}, data: stageOpts, show: true}
        ];

        var skip = false;
        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                if (!skip) {
                    $scope.tableParams.reload();
                } else {
                    skip = false;
                }
            }, true
        );

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //院审3，科审2
                Bulletin.query(url, function (data) {
                    params.total(data.total);
                    angular.forEach(data.bulletins, function (b) {
                        b.stage = F.getItem(b.is_pass, stages);
                    });
                    $defer.resolve(data.bulletins);
                });
            }
        });

        $scope.edit = function (bulletin) {
            if (bulletin.is_pass <= C.STAGE1.HOSPITAL_APPROVAL) {
                dialogs.create('templates/article/bulletin_edit.html', 'ApprovalBulletinCtrl', {
                    id: bulletin.id, is_pass: bulletin.is_pass == C.STAGE1.DEPT_APPROVAL ? C.STAGE1.HOSPITAL_APPROVAL :
                        C.STAGE1.PUBLIC
                }, {
                     size: 'lg'
                }).result.then(function (params) {
                        Bulletin.update({id: bulletin.id}, params).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 1:
                                    toaster.success('该公告已发布!');
                                    break;
                                case 0:
                                    toaster.success('审批成功!');
                                    break;
                            }
                            $scope.tableParams.reload();
                        }, function () {
                            toaster.error('审批失败!');
                        })
                    });
            } else {
                dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                    id: bulletin.id
                }, {
                     size: 'lg'
                });
            }
        };

        $scope.clearFilters = function () {
            skip = true;
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
    });

angular.module('c.c').controller('BulletinBackDlgCtrl',
    function ($scope, $uibModalInstance, toaster, C, Bulletin, data) {

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            var params = {};
            var back_stage;
            if (data.stage == C.STAGE1.HOSPITAL_APPROVAL)
                back_stage = C.STAGE1.DEPT_BACK;
            if (data.stage == C.STAGE1.PUBLIC)
                back_stage = C.STAGE1.HOSPITAL_BACK;
            params['remark'] = $scope.remark;
            params['is_pass'] = back_stage;
            $uibModalInstance.close(params);
        }
    });

angular.module('c.c').controller('DeptCarPendingCtrl',
    function ($scope, $stateParams, F) {
        var vm = $scope;
        F.loadTabs(vm, $stateParams);
    });



(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptPhonesCtrl', DeptPhonesCtrl)
        .controller('DeptPhoneDlgCtrl', DeptPhoneDlgCtrl)
    ;

    function DeptPhonesCtrl($scope, toaster, Api, Table, Dept, DeptPhone) {
        var vm = $scope;
        vm.deptSelectedFn = deptSelectedFn;
        vm.addEdit = addEdit;
        vm.remove = remove;

        init();


        function init() {
            var options = {
                service: DeptPhone,
                params: {opt: 1}, sorting: {sorting: 'asc'},
                primaryFilter: 'dept_id',
                hideFilter: true, optColWidth: Table._3_BTN,
                cols: [
                    {title: '名称', field: 'name'}, //0
                    {title: '电话', field: 'phone'}, //1
                    {title: '短号', field: 'cornet'}, //1
                    {title: '排序', sortable: 'sorting', field: 'sorting'} //6
                ]
            };
            Table.load(vm, options);

            Dept.query({opt: 6}, function (resp) {
                vm.depts = resp.depts;
                if (resp.depts && resp.depts.length > 0) {
                    deptSelectedFn(0);
                }
            });
        }

        function deptSelectedFn($index) {
            vm.dept = vm.depts[$index];
            vm.tableParams.filter({dept_id: vm.dept.id});
        }

        function addEdit(m) {
            if (vm.dept) {
                Api.addEdit(vm, 'DeptPhoneDlg.html', 'DeptPhoneDlgCtrl', m, {dept: vm.dept});
            } else {
                toaster.warning('没有相关科室');
            }
        }

        function remove(m) {
            Api.delTableItem(DeptPhone, m.id, vm, '科室电话', m.name);
        }
    }

    function DeptPhoneDlgCtrl($scope, $uibModalInstance, $q, DeptPhone, toaster, F, data) {
        var vm = $scope;
        vm.dept = data.dept;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);


        function init(id) {
            if (id) {
                DeptPhone.get({id: id}, function (resp) {
                    var phone = resp;
                    vm.m = phone;
                });
            } else {
                vm.m = {sorting: 100, dept_id: data.dept.id};
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                validFailed = false;
                var promise;
                var pa = {
                    name: m.name, phone: m.phone, cornet: m.cornet, memo: m.memo, dept_id: m.dept_id,
                    sorting: m.sorting
                };
                if (m.id) { //修改
                    promise = DeptPhone.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = DeptPhone.save(pa).$promise;
                }
                promise.then(function (resp) {
                    toaster.success(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }


})();

angular.module('c.c')
    .controller('DeptPracticeCtrl', function ($scope) {

    });
angular.module('c.c')
    .controller('DeptRoundsCtrl', function ($scope, $stateParams, F) {
        var vm = $scope;
        F.loadTabs(vm, $stateParams);
    });
'use strict';

angular.module('c.c')
    .controller('DeptRuleCtrl', function ($scope, $stateParams, F) {
        F.loadTabs($scope, $stateParams);
    });



angular.module('c.c')
    .controller('UserKpiCtrl', function ($scope, $uibModalInstance, dialogs, toaster, F, UserKpi, data) {

        $scope.user_id = data.user_id;
        $scope.kpi_edu_bgs = F.get('kpi_edu_bgs');
        $scope.hospital_years = F.get('hospital_years');
        $scope.working_years = F.get('working_years');
        $scope.kpi_titles = F.get('kpi_titles');
        $scope.special_coa = F.get('special_coa');
        $scope.duty_levels = F.get('duty_levels');
        $scope.risk_levels = F.get('risk_levels');
        $scope.skill_levels = F.get('skill_levels');
        $scope.workspaces = F.get('workspaces');
        $scope.workloads = F.get('workloads');

        $scope.options = [{'name': '学历及学位', code: 'edu_bg', value: $scope.kpi_edu_bgs}, {
            'name': '院龄', code: 'hospital_year',
            value: $scope.hospital_years
        }, {'name': '工龄', code: 'working_year', value: $scope.working_years}, {
            'name': '职称', code: 'title',
            value: $scope.kpi_titles
        }, {
            'name': '岗位特殊证书', code: 'special_coa',
            value: $scope.special_coa
        }, {'name': '工作责任大小', code: 'duty_level', value: $scope.duty_levels}, {
            'name': '工作风险程度', code: 'risk_level',
            value: $scope.risk_levels
        }, {
            'name': '工作技术含量高低', code: 'skill_level',
            value: $scope.skill_levels
        }, {'name': '工作环境', code: 'workspace', value: $scope.workspaces}, {
            'name': '工作量大小',
            code: 'workload',
            value: $scope.workloads
        }];

        if (data.edit) {
            UserKpi.query({opt: 1, user_id: $scope.user_id}, function (resp) {
                var kpi = resp.records;
                for (var i = 0; i < $scope.options.length; i++) {
                    var option = $scope.options[i];
                    option.choice = F.getItem(kpi[option.code], option.value);
                }
            });

        }


        $scope.ok = function () {
            var q_score = 0;
            var params = {};
            for (var i = 0; i < $scope.options.length; i++) {
                var option = $scope.options[i];
                var choice = option.choice;
                if (!choice) {
                    toaster.warning('绩效' + option.name + '还没有填写');
                    return;
                } else {
                    q_score += +choice.score;   //绩效总分
                    params[option.code] = choice.id;
                }
            }
            params['user_id'] = $scope.user_id;
            params['score'] = q_score;
            params['real_kpi'] = q_score * 2.0 / 100;
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    });
'use strict';

angular.module('c.c')
    .controller('DeptWageCtrl', function ($scope) {

    });


angular.module('c.c')
    .controller('DRCarCtrl', function ($scope, toaster, C, F) {

    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('DRMedicalInfoCtrl', DRMedicalInfoCtrl);

    /** @ngInject */
    function DRMedicalInfoCtrl($scope, uibDateParser, dialogs, toaster, C, Table,
                               FileHelper, DateHelper, Upload, SaveAs, MedicalInfo) {

        var vm = $scope;
        vm.upload = upload;
        vm.download = download;
        vm.remove = remove;
        vm.day = DateHelper.date2Str(new Date());

        init();


        function init() {
            var options = {
                service: MedicalInfo,
                params: {opt: 1/*ORDER.INDEX_ALL*/},
                sorting: {'medical_informations.created_at': 'desc'},
                hideOpt: true, hideFilter: true,
                cols: [
                    {field: "medical_informations.name", title: "名称"},
                    {field: "user_id", title: "上传人"},

                    {field: "date", title: "日期"}
                ]
            };

            Table.load(vm, options, function (resp) {
                if (resp.items && resp.items.length > 0 &&
                    DateHelper.areSameDate(uibDateParser.parse(resp.items[0].date, 'yyyy-MM-dd'), new Date())) {
                    vm.today = resp.items[0];
                } else {
                    vm.today = {};
                }
                angular.forEach(resp.items, function (item) {
                    item.attachment = {'name': item};
                });
            });
        }


        function upload(file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            if (file == null) {
                return;
            }
            m.progress = 0;
            Upload.upload({
                url: C.URL.MEDICAL_INFO_UPLOAD, data: {file: file, id: m.id}
            }).progress(function (evt) {
                m.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.name = resp.name;
                        m.mime = resp.mime;
                        m.filename = resp.filename;
                        m.size = resp.size;
                        vm.tableReload();
                        break;
                    case 1:
                        m.progress = 101;
                        m.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                m.progress = 102;
                m.errorInfo = '服务器错误!';
            });
        }

        function download(m) {
            var params = {filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.MEDICAL_INFO_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }

        function remove(m) {
            dialogs.confirm('删除总值班信息', '确定要删除<strong>' + m.name + '</strong>的记录吗?')
                .result.then(function () {
                MedicalInfo.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('操作成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('操作失败!');
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DutyNoDeclareCtrl', DutyNoDeclareCtrl);

    /** @ngInject */
    function DutyNoDeclareCtrl($scope, DateHelper, Table, Dlg, DutyReport, DutyGroup, F) {
        var vm = $scope;
        var date = new Date((new Date()).setDate(1));
        var dts = new Date(date.setMonth(date.getMonth() - 1));
        var group_types = F.get('dutyGroupTypes');
        vm.member = member;
        vm.hide = hide;
        init();


        function init() {

            var options = {
                service: DutyReport,
                params: {opt: 9, month: DateHelper.date2Str(dts)},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "值班组名称"},
                    {field: "leader", title: "负责人"},
                    {
                        field: "type",
                        title: "类型"
                    }
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = F.getItem(item.type, group_types);
                })
            });
        }

        function member(m) {
            Dlg.show({
                template: 'CheckMembersDlg.html',
                ctrl: 'CheckMembersCtrl',
                data: {
                    group: m, month: dts
                }
            }).then(function (resp) {
                vm.tableReload();
            });
        }

        function hide(m) {
            DutyGroup.update({id: m.id}, {is_hide: !m.is_hide}).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }
    }

})();



// angular.module('c.c')
//     .controller('DutyNoDeclareCtrl', function ($scope, $filter, dialogs, toaster, DutyReport, F) {
//
//         var date = new Date((new Date()).setDate(1));
//         $scope.dts = new Date(date.setMonth(date.getMonth() - 1));
//
//         $scope.group_types = F.get('dutyGroupTypes');
//
//         DutyReport.query({'month': $filter('date')($scope.dts, 'yyyy-MM-dd'), 'opt': 9}, function (resp) {
//             $scope.groups = resp.records;
//         });
//
//         $scope.tableReload = function () {
//             DutyReport.query({'month': $filter('date')($scope.dts, 'yyyy-MM-dd'), 'opt': 9}, function (resp) {
//                 $scope.groups = resp.records;
//             });
//         };
//
//         $scope.member = function (group) {
//             dialogs.create('CheckMembersDlg.html', 'CheckMembersCtrl',
//                 {group: group, month: $scope.dts}, {      //view区分两种添加成员次数方法
//                      size: 'md'
//                 }).result.then(function () {
//                     $scope.tableReload();
//                 });
//         };
//
//     });

angular.module('c.c').controller('CheckMembersCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs,
              toaster, F, DutyGroup, DutyReport, data) {
        $scope.group = data.group;
        $scope.month = data.month;
        var dte = new Date(data.month.getFullYear(), data.month.getMonth() + 1, 0);

        $scope.rated_count = dte.getDate() * data.group.num;
        $scope.left_count = 0;


        $scope.cols = [
            {title: '姓名', field: 'name', show: true}, //0
            {title: '工号', field: 'username', width: '30%', show: true}, //0
            {title: '值班次数', field: 'count', width: '15%', show: true} //6
        ];

        $scope.hideOpt = true;
        $scope.hideFilter = true;

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 8;
                url['month'] = $filter('date')($scope.month, 'yyyy-MM-dd');
                url['group_id'] = data.group.id;
                DutyReport.query(url, function (resp) {
                    $defer.resolve(resp.members);
                    params.total(resp.members.length);
                    $scope.leftCount(resp.members);
                });
            }
        });


        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.leftCount = function (members) {
            console.log(2);
            var countAll = 0;
            angular.forEach(members, function (member) {
                if (member.count) {
                    countAll = countAll + parseInt(member.count);
                }
            });
            if ($scope.rated_count < countAll) {
                $scope.left_count = 0;
            } else {
                $scope.left_count = $scope.rated_count - parseInt(countAll);
            }
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DutyFeeFilingCtrl', DutyFeeFilingCtrl)
        .controller('DutyReportDlgCtrl', DutyReportDlgCtrl)
        .controller('DutyReportMembersCtrl', DutyReportMembersCtrl)

    ;

    /** @ngInject */
    function DutyFeeFilingCtrl($scope, dialogs, toaster, NgTableParams, DutyReport, F) {

        var yesOrNo = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '值班月份', sortable: 'duty_reports.month', filter: {month: 'date_range'}, field: 'month', show: true},
            {
                title: '值班组',
                sortable: 'duty_reports.group_id',
                filter: {group_id: 'select'},
                field: 'group_id',
                width: '15%',
                show: true
            },
            {
                title: '额定总值班人次',
                sortable: 'rated_count',
                filter: {rated_count: 'number_range'},
                field: 'rated_count',
                width: '10%',
                show: true
            }, //6
            {
                title: '实际总值班人次',
                sortable: 'total_count',
                filter: {total_count: 'number_range'},
                field: 'total_count',
                width: '10%',
                show: true
            }, //6
            {
                title: '总值班费用',
                sortable: 'total_fee',
                filter: {total_fee: 'number_range'},
                field: 'total_fee',
                width: '10%',
                show: true
            }, //6
            {title: '申报人', filter: {'users.name': 'text'}, field: 'declarant', width: '10%', show: true}, //0
            {
                title: '是否申报',
                filter: {is_declared: 'select'},
                field: 'is_declared',
                width: '8%',
                data: yesOrNo,
                show: true
            }, //6
            {title: '申报时间', filter: {declare_time: 'date_range'}, field: 'declare_time', show: true},
            {
                title: '是否确认',
                filter: {'duty_reports.is_confirmed': 'select'},
                field: 'is_confirmed',
                width: '8%',
                data: yesOrNo,
                show: true
            }, //6
            {title: '是否发放', filter: {is_payed: 'select'}, field: 'is_payed', width: '8%', data: yesOrNo, show: true} //6
        ];
        $scope.optColWidth = 70;
        $scope.groups_col = $scope.cols[1];

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({page: 1, count: 12}, {
            counts: [12, 24, 36], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.rated_count) {
                    url['rated_count_start'] = $scope.numRangeFilter.rated_count.start;
                    url['rated_count_end'] = $scope.numRangeFilter.rated_count.end;
                }
                if ($scope.numRangeFilter.total_count) {
                    url['total_count_start'] = $scope.numRangeFilter.total_count.start;
                    url['total_count_end'] = $scope.numRangeFilter.total_count.end;
                }
                url['date_range_filters'] = $scope.dateRangeFilter;
                DutyReport.query(url, function (resp) {
                    $scope.duty_set = resp.duty_set;
                    $scope.duty_groups = resp.dlg_groups;
                    $scope.groups_col.data = F.getNgTableOpts(resp.dlg_groups);
                    params.total(resp.total);
                    $defer.resolve(resp.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('DutyReportDlg.html', 'DutyReportDlgCtrl', {duty_groups: $scope.duty_groups}, {
                size: 'md'
            }).result.then(function (report) {
                DutyReport.save(report).$promise.then(function (data) {
                    $scope.tableReload();
                    DutyReport.query({
                        opt: 8,
                        month: report['month'],
                        group_id: report['group_id']
                    }, function (resp) {
                        angular.forEach(resp.members, function (m) {
                            m['is_checked'] = false;
                        });
                        dialogs.create('DutyReportMembersDlg.html', 'DutyReportMembersCtrl',
                            {report: resp.report, duty_set: resp.duty_set, members: resp.members, opt: 1}, {
                                size: 'md'
                            }).result.then(function () {
                            $scope.tableParams.reload();
                        });
                    });
                }, function () {
                    toaster.error('申报月份重复,申报失败!');
                });
            });
        };

        $scope.member = function (report) {
            dialogs.create('DutyReportMembersDlg.html', 'DutyReportMembersCtrl',
                {report: report, opt: 1, view: 1, duty_set: $scope.duty_set}, {      //view区分两种添加成员次数方法
                    size: 'md'
                }).result.then(function () {
                $scope.tableReload();
            });
        };

        $scope.declare = function (report) {
            var para = {};
            para['is_declared'] = 1;
            DutyReport.update({id: report.id}, para).$promise.then(function (data) {
                toaster.success('值班组申报成功!');
                $scope.tableReload();
            }, function (error) {
                toaster.error('值班组申报失败!');
            });
        };

        $scope.delete = function (report) {
            dialogs.confirm('删除科室记录', '确定要删除<strong>' + report.group_name + '</strong>的值班申报吗?')
                .result.then(function () {
                DutyReport.delete({id: report.id}).$promise.then(function () {
                    toaster.success('值班组申报删除成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('值班组申报删除失败!');
                });
            });

        };
    }

    /** @ngInject */
    function DutyReportDlgCtrl($scope, $uibModalInstance, toaster, $filter, DateHelper, data) {
        $scope.duty_groups = data.duty_groups;
        var month = new Date();
        month.setMonth(month.getMonth() - 1);
        if (data.duty_groups[0] != null) {
            $scope.report = {group: $scope.duty_groups[0], month: month};
        } else {
            $scope.report = {};
        }
        $scope.ok = function (report) {
            if (report.group == null) {
                toaster.warning('请选择值班组!');
            } else {
                var params = {};
                var y = report.month.getFullYear();
                var m = report.month.getMonth() + 1;
                var day = DateHelper.getDaysInMonth(m, y);
                params['month'] = $filter('date')(report.month.setDate(1), 'yyyy-MM-dd');
                params['group_id'] = report.group.id;
                params['rated_count'] = day * report.group.num;
                $uibModalInstance.close(params);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function DutyReportMembersCtrl($scope, $uibModalInstance, NgTableParams, dialogs,
                                   toaster, ReportMember, DutyReport, data) {

        $scope.duty_set = data.duty_set;   //系统设置中值班次数是否可以修改
        $scope.direct = data.direct;      //是否为科室直接上报
        $scope.opt = data.opt;
        $scope.report = data.report;
        $scope.view = data.view;
        $scope.rated_count = data.report.rated_count;
        $scope.real_count = false;

        if (data.members) {
            $scope.members = data.members;
        } else {
            $scope.members = [];
        }

        if (data.report.is_declared == 1 || !data.direct) {
            $scope.justDataCol = true;     //将多选框还有删除图标去掉
        }
        $scope.cols = [
            {title: '姓名', field: 'name', show: true}, //0
            {title: '工号', field: 'username', width: '30%', show: true}, //0
            {title: '值班次数', field: 'count', width: '15%', show: true}, //6
            {title: '有效值班次数（与总值班冲突时）', field: 'real_count', width: '15%', show: ($scope.report.group_type==4||$scope.report.group_type==5)} //6
        ];
        //$scope.optColWidth = 62;
        $scope.hideOpt = true;
        $scope.hideFilter = true;

        $scope.tableParams = new NgTableParams({page: 1, count: 9999}, {
            // counts: [30, 50, 100],
            counts: [],
            total: 0,
            getData: function ($defer, params) {
                if (data.view == 1) {
                    var url = params.url();
                    $scope.idNullMembers = "";
                    url['report_id'] = data.report.id;

                    ReportMember.query(url, function (resp) {
                        var used_count = 0;
                        if (resp.members.length == 0) {
                            DutyReport.query({
                                opt: 8,
                                month: data.report.month,
                                group_id: data.report.group_id
                            }, function (rs) {
                                angular.forEach(rs.members, function (m) {
                                    m['is_checked'] = false;
                                });
                                $scope.members = rs.members;
                                $scope.duty_set = rs.duty_set;
                                $scope.opt = 1;
                                var members_ids = [];                                   //嵌套不同表query查询，执行顺序待考证，次数会先执行第一个，再执行第二个，若不写此段代码
                                var used_count = 0;                                   //$scope.members的值将会为0
                                angular.forEach($scope.members, function (m) {
                                    if (!m.id) {
                                        $scope.idNullMembers += m.name + ' ';
                                    }
                                    members_ids.push({id: m.id});
                                    used_count += parseInt(m.count);
                                });
                                if (data.report.total_count != 0) {
                                    $scope.left_count = $scope.rated_count - data.report.total_count;
                                } else {
                                    if ((data.report.by_week == 1 && used_count >= 8 && used_count <= 10)) {
                                        $scope.left_count = 0;
                                    } else {
                                        $scope.left_count = $scope.rated_count - used_count;
                                    }
                                }
                                $scope.members_ids = members_ids;
                            });
                        } else {
                            $scope.members = resp.members;
                            angular.forEach($scope.members, function (m) {
                                if (!m.id) {
                                    $scope.idNullMembers += m.name + ' ';
                                }
                            });
                        }
                        params.total(resp.total);
                    });
                }
                $defer.resolve($scope.members);
                params.total($scope.members.length);
            }
        });

        var members_ids = [];
        var used_count = 0;
        angular.forEach($scope.members, function (m) {
            members_ids.push({id: m.id});
            used_count += parseInt(m.count);
        });
        if (data.report.total_count != 0) {
            $scope.left_count = $scope.rated_count - data.report.total_count;
        } else {
            if ((data.report.by_week == 1 && used_count >= 8 && used_count <= 10)) {
                $scope.left_count = 0;
            } else {
                $scope.left_count = $scope.rated_count - used_count;
            }
        }
        $scope.members_ids = members_ids;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (member, members) {
            if (member.is_checked) {
                $scope.header.checkAll = true;
            } else {
                var allUnchecked = true;
                for (var i = 0; i < members.length; i++) {
                    if (members[i].is_checked) {
                        allUnchecked = false;
                        break;
                    }
                }
                if (allUnchecked) {
                    $scope.header.checkAll = false;
                }
            }
        };

        $scope.leftCount = function () {
            var countAll = 0;
            angular.forEach($scope.members, function (member) {
                if (member.count) {
                    countAll = countAll + parseInt(member.count);
                }
            });
            if ($scope.rated_count < countAll) {
                $scope.left_count = 0;
            } else {
                $scope.left_count = $scope.rated_count - parseInt(countAll);
            }
        };

        $scope.checkAllFn = function (checkAll, members) {
            if (checkAll) {
                angular.forEach(members, function (member) {
                    member.is_checked = true;
                })
            } else {
                angular.forEach(members, function (member) {
                    member.is_checked = false;
                })
            }
        };

        $scope.add = function () {
            var para = {
                title: '添加' + data.report.group_name + '成员', multiSelect: true, existMembers: $scope.members_ids,
                showDutyGroupMember: true, dutyGroupId: data.report.group_id
            };
            if ($scope.report.group_type == 2) {
                para['userType'] = 2;
            }
            dialogs.create('directives/form/user-selector/user_selector_dlg.html', 'UserSelectCtrl', para
                , {
                    size: 'md'
                }).result.then(function (params) {
                angular.forEach(params, function (m) {
                    $scope.members.push(m);
                    $scope.members_ids.push({'id': m.id});
                });
            });
        };

        $scope.delete = function (m) {
            dialogs.confirm('移除成员', '确定要移除成员吗?')
                .result.then(function () {
                var temp_mem = [];
                if (angular.isArray(m)) {
                    for (var i = 0; i < m.length; i++) {
                        if (!m[i].is_checked) {
                            temp_mem.push(m[i]);
                        } else {
                            $scope.members_ids.splice(i, 1);
                        }
                    }
                    $scope.members = temp_mem;
                } else {
                    for (var j = 0; j < $scope.members.length; j++) {
                        if ($scope.members[j].id == m.id) {
                            $scope.members.splice(j, 1);
                            $scope.members_ids.splice(j, 1);
                        }
                    }
                }
            });
        };

        $scope.memberAdd = function (members, want_declare) {
            var rm = [];
            var total_count = 0;
            var real_total_count = 0;
            var flag = false;
            for (var m in members) {
                if (!members[m].count) {
                    members[m].count = 0;
                }
                var params = {};
                if (!members[m].id) {
                    console.log("略过系统中没有的成员", m);
                    continue;
                }
                params['member_id'] = members[m].id;
                params['report_id'] = data.report.id;
                params['count'] = members[m].count;
                // 2 表示临床护士 7 表示听班护士  DutyGroup中定义
                if ($scope.report.group_type != 2 || $scope.report.group_is_nc_performance != 1) {
                    params['duty_fee'] = members[m].count * data.report.group_fee;
                }
                if ($scope.report.group_type == 4 || $scope.report.group_type == 5) {
                    params['real_count'] = members[m].real_count;
                    params['duty_fee'] = members[m].real_count * data.report.group_fee;
                    real_total_count = real_total_count + parseInt(members[m].real_count);
                }
                var month = data.report.month.split("-");
                var day = new Date(month[0], month[1], 0).getDate();
                if (members[m].count > day) {
                    toaster.warning('个人值班次数大于' + day + ',请检查错误,重新填写');
                    rm = [];
                    total_count = 0;
                    flag = false;
                    break;
                } else {
                    flag = true;
                }
                total_count = total_count + parseInt(members[m].count);
                rm.push(params);
            }
            $scope.flag = flag;
            var dataParams ={
                'rm': rm,
                'report_id': data.report.id,
                'total_count': total_count
            };
            if ($scope.report.group_type == 4 || $scope.report.group_type == 5) {
                dataParams['real_total_count'] = real_total_count;
            }
            if (total_count > data.report.rated_count) {
                //toaster.warning('实际总值班人次大于额定值班人次,请重新填写或联系值班组长!');
                toaster.warning('实际总值班人次大于额定值班人次,请联系值班组长!');
            } else if (total_count <= data.report.rated_count && flag) {
                if (total_count < data.report.rated_count) {
                    dialogs.confirm('确定吗?', '实际总值班人次小于额定值班人次')
                        .result.then(function () {
                        ReportMember.save(dataParams).$promise.then(function () {
                            if (want_declare) {
                                var para = {};
                                para['is_declared'] = 1;
                                if ($scope.direct) {
                                    para['is_confirmed'] = 1;
                                }
                                DutyReport.update({id: data.report.id}, para).$promise.then(function (data) {
                                    toaster.success('值班组申报成功!');
                                    $uibModalInstance.close();
                                }, function (error) {
                                    var data = error.data;
                                    if (data.msg) Dlg.e(data.msg);
                                    else toaster.error('值班组申报失败!');
                                })
                            } else {
                                toaster.success('成员保存成功!');
                                $uibModalInstance.close();
                            }
                        }, function (error) {
                            var data = error.data;
                            if (data.msg) toaster.error(data.msg);
                        });
                    });
                } else if (total_count == data.report.rated_count) {
                    ReportMember.save(dataParams).$promise.then(function () {
                        if (want_declare) {
                            var para = {};
                            para['is_declared'] = 1;
                            DutyReport.update({id: data.report.id}, para).$promise.then(function (data) {
                                toaster.success('值班组申报成功!');
                                $uibModalInstance.close();
                            }, function (error) {
                                var data = error.data;
                                if (data.msg) Dlg.e(data.msg);
                                else toaster.error('值班组申报失败!');
                            })
                        } else {
                            toaster.success('成员保存成功!');
                            $uibModalInstance.close();
                        }
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) toaster.error(data.msg);
                    });
                }
            }
        };
        $scope.confirm = function (report, is_confirmed) {
            var para = {};
            para['is_confirmed'] = is_confirmed;
            if (data.opt == 3) {
                para['is_payed'] = is_confirmed;
            }
            para['memo'] = report.memo;

            DutyReport.update({id: report.id}, para).$promise.then(function (resp) {
                toaster.success('值班审核确认成功!');
                $uibModalInstance.close();
            }, function (error) {
                toaster.error('值班审核确认失败!');
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

angular.module('c.c')
    .controller('DutyGroupMemberCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyGroup, F, Dlg) {

        $scope.cols = [
            {title: '值班组名称', field: 'name', show: true}, //0
            {title: '值班组类型', field: 'duty_type', show: true}, //0
            {
                title: '值班费标准',
                sortable: 'duty_fee',
                field: 'duty_fee',
                width: '15%',
                show: true
            }, //0
            {title: '日/周值班人次', field: 'num', width: '15%', show: true}, //6
            {title: '类别', field: 'type', width: '10%', show: true}, //1
            {title: '备注', field: 'remark', width: '10%', show: true}, //1
            {title: '成员数', field: 'members_count', width: '10%', show: true} //1
        ];
        $scope.optColWidth = 120;
        $scope.hideFilter = true;

        var types = F.get('dutyGroupTypes');
        var dutyTypes = F.get('dutyTypes');
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                DutyGroup.query({opt: 3}, function (resp) {
                    angular.forEach(resp.groups, function (group) {
                        group.type = F.getItem(group.type, types);
                        group.duty_type = F.getItem(group.duty_type, dutyTypes);
                    });
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.member = function (group) {
            dialogs.create('DutyGroupMembersDlg.html', 'DutyGroupMembersCtrl',
                {group: group}, {size: 'lg'}).result.then(function () {
            }, function () {
                $scope.tableParams.reload();
            });
        };

        $scope.manager = function (group) {
            Dlg.confirm('<strong class="text-danger">修改后您的值班管理权限将变更给他人，请谨慎操作</strong>，确认更改值班组管理员吗?', function () {
                Dlg.show({
                    template: 'directives/form/user-selector/user_selector_dlg.html',
                    ctrl: 'UserSelectCtrl',
                    data: {
                        title: '修改管理员设置', multiSelect: false, forReceive: false
                    }
                }).then(function (pa) {
                    var leaderId = pa.length > 0 ? pa[0].id : null;
                    DutyGroup.update({id: group.id}, {opt: 4, leader_id: leaderId}).$promise.then(function () {
                        toaster.success('操作成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('操作失败!');
                    });
                });
            }, '更改值班组管理员').then(function () {
                // $scope.tableParams.reload();
            });
        };

        $scope.editRemarks = function (group) {
            group.$edit = true;
            group.$remarkChanged = group.remark;
        };

        $scope.saveRemarks = function (group) {
            if (group.$remarkChanged.length > 255) {
                toaster.warning('备注应该在255字以内!');
                return;
            }

            group.$edit = false;
            if (group.$remarkChanged != group.remark) {
                DutyGroup.update({id: group.id}, {remark: group.$remarkChanged}).$promise.then(function () {
                    group.remark = group.$remarkChanged;
                    toaster.success('备注保存成功!');
                }, function () {
                    toaster.error('备注保存失败!');
                });
            }
        };
    });

angular.module('c.c').controller('DutyGroupMembersCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs,
              toaster, F, DutyGroup, data,Dlg) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.group = data.group;

        $scope.cols = [
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', show: true}, //0
            {title: '工号', filter: {'users.username': 'text'}, field: 'username', width: '30%', show: true}, //0
            {title: '滚动天数', filter: {'rolling_days': 'text'}, field: 'rolling_days', width: '15%', show: true}, //0
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
            {title: '排列顺序', field: 'sorting', width: '10%', show: true} //0
        ];
        $scope.optColWidth = 70;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['id'] = data.group.id;
                DutyGroup.index_members(url, function (resp) {
                    params.total(resp.total);
                    var members = [];
                    angular.forEach(resp.members, function (m) {
                        members.push({id: m.member_id});
                        m.$rdChanged = m.rolling_days;
                        m.$sortingChanged = m.sorting;
                    });
                    $scope.members_ids = members;
                    $defer.resolve(resp.members);
                    $scope.members = resp.members;
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (member, members) {
            if (member.is_checked) {
                $scope.header.checkAll = true;
            } else {
                var allUnchecked = true;
                for (var i = 0; i < members.length; i++) {
                    if (members[i].is_checked) {
                        allUnchecked = false;
                        break;
                    }
                }
                if (allUnchecked) {
                    $scope.header.checkAll = false;
                }
            }
        };

        $scope.checkAllFn = function (checkAll, members) {
            if (checkAll) {
                angular.forEach(members, function (member) {
                    member.is_checked = true;
                })
            } else {
                angular.forEach(members, function (member) {
                    member.is_checked = false;
                })
            }
        };

        $scope.add = function () {
            dialogs.create('directives/form/user-selector/user_selector_dlg.html', 'UserSelectCtrl',
                {
                    title: '添加' + data.group.name + '成员', multiSelect: true, existMembers: $scope.members_ids,
                    userType: data.group.type.id == 2 ? 2 : null
                }, {

                    size: 'md'
                }).result.then(function (params) {
                if (params.length > 0) {
                    var members_ids = [];
                    angular.forEach(params, function (m) {
                        members_ids.push(m.id)
                    });
                    DutyGroup.attach_members({id: data.group.id}, {members: members_ids}).$promise.then(function (resp) {
                        // if (resp.result==0){
                            toaster.success('添加成功!');
                        // }else if (resp.result==1){
                        //     var $msg=''
                        //     angular.forEach(resp.memberRepeats, function (m) {
                        //         $msg+=m.name+' ';
                        //     });
                        //     Dlg.confirm('成员<strong class="text-danger">'+$msg+'</strong>已在其他排班组!确认添加成员'+$msg+'吗?添加后这些成员在其他组会移除，请谨慎操作', function () {
                        //         DutyGroup.add_members({id: data.group.id}, {members: members_ids}).$promise.then(function (resp) {
                        //             toaster.success('添加成功!');
                        //             $scope.tableParams.reload();
                        //         });
                        //     }, '添加成员提醒').then(function () {
                        //          $scope.tableParams.reload();
                        //     });
                        // }
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('添加失败!');
                    });
                }
            });
        };

        $scope.resetRD = function (members) {
            angular.forEach(members, function (m) {
                m.$rdChanged = m.rolling_days;
                m.$sortingChanged = m.sorting;
            });
        };

        $scope.saveRD = function (members) {
            pa = [];
            angular.forEach(members, function (m) {
                pa.push({id: m.id, rolling_days: m.$rdChanged, sorting: m.$sortingChanged});
            });
            DutyGroup.update_rolling_days({rolling_days: pa}).$promise.then(
                function () {
                    $scope.tableParams.reload();
                    toaster.success('保存成功!');
                }, function () {
                    toaster.error('保存失败!');
                }
            );
        };

        $scope.delete = function (m) {
            dialogs.confirm('移除成员', '确定要移除成员吗?')
                .result.then(function () {
                var members = [];
                if (angular.isArray(m)) {
                    angular.forEach(m, function (member) {
                        if (member.is_checked) {
                            members.push(member.member_id);
                        }
                    });
                } else {
                    members.push(m.member_id);
                }
                DutyGroup.detach_members({id: data.group.id}, {members: members}).$promise.then(
                    function (resp) {
                        if (resp.result == 0) {
                            toaster.success(resp.msg);
                        } else {
                            toaster.warning(resp.msg);
                        }
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('移除失败!');
                    }
                );
            });
        };

        $scope.setStop = function (m, stop) {
            DutyGroup.set_member_stop({id: m.id, is_stop: stop}).$promise.then(function (resp) {
                if (resp.result == 0) {
                    m.is_stop = stop ? '1' : '0';
                } else {
                    toaster.error(resp.msg);
                }
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('SchedulerCtrl', function ($scope, $filter, $timeout, dialogs, toaster,
                                           $templateRequest, $sce, Shift, ArrayHelper,
                                           DutyGroup, Schedule, NgTableParams, F, SeniorityStandard, Dlg) {

        $scope.dt = new Date();
        $scope.prevWeek = function (curr) {
            var prev = curr.getDate() - curr.getDay() - 6;
            $scope.dt = new Date(curr.setDate(prev));
        };
        $scope.nextWeek = function (curr) {
            var next = curr.getDate() - curr.getDay() + 8;
            $scope.dt = new Date(curr.setDate(next));
        };

        DutyGroup.query({opt: 8}, function (resp) {
            $scope.groups = resp.groups;
            if (resp.groups && resp.groups.length > 0) {
                $scope.groupSelectedFn(0);
            }
        });

        SeniorityStandard.query(function (resp) {
            // console.log('resp', resp);
            $scope.standards = resp;
        });

        $scope.groupSelectedFn = function ($index) {
            $scope.group = $scope.groups[$index];
            $scope.tableParams.$params.page = 1;
            Shift.query({opt: 2, group_id: $scope.group.id}, function (resp) {
                $scope.shifts = resp.shifts;
            });
            $scope.tableParams.reload();
        };

        var week_days = F.get('weekdays');
        $scope.weekDays = [];
        $scope.$watch('dt', function (newVal, oldVal, scope) {
            var curr = newVal;
            if ($scope.weekDays.length == 0 || (curr < scope.weekDays[0] || curr > scope.weekDays[6])) {
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        scope.weekDays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = scope.weekDays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        scope.weekDays[i] = now;
                    }
                    var d = scope.weekDays[i];
                    $scope.cols[i + 1].title = week_days[i].name + ' ' + d.getDate();
                    $scope.cols[i + 1].field = $filter('date')(d, 'yyyy-MM-dd');
                }
                $scope.tableParams.reload();
            }
        }, true);

        $scope.cols = [
            {title: '成员', field: 'member', width: '12.5%', show: true},
            {title: '周一', field: 'mon', width: '12.5%', show: true},
            {title: '周二', field: 'tue', width: '12.5%', show: true},
            {title: '周三', field: 'wed', width: '12.5%', show: true},
            {title: '周四', field: 'thu', width: '12.5%', show: true},
            {title: '周五', field: 'fri', width: '12.5%', show: true},
            {title: '周六', field: 'sat', width: '12.5%', show: true},
            {title: '周日', field: 'sun', width: '12.5%', show: true}
        ];

        $scope.hideFilter = true;
        $scope.hideOpt = true;
        $scope.justDataCol = true;
        $scope.tableParams = new NgTableParams({page: 1, count: 50, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.group && $scope.weekDays.length == 7) {
                    var url = params.url();
                    url['opt'] = 1;
                    url['group_id'] = $scope.group.id;
                    url['start'] = $scope.cols[1].field;
                    url['end'] = $scope.cols[7].field;
                    Schedule.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.members, function (m) {
                            m.dateKeySchedules = [];
                            angular.forEach(m.schedules, function (s) {
                                m.dateKeySchedules[s.shift_date] = s;
                            });
                        });
                        angular.forEach(resp.members, function (m) {
                            if (m.member.type_id == 2 && m.member.nurse_seniority) {
                                m.standard = ArrayHelper.getItem(m.member.nurse_seniority.seniority_id, $scope.standards);
                            }
                        });

                        $scope.members = resp.members;

                        angular.forEach(resp.temp_members, function (m) {
                            m.dateKeySchedules = [];
                            angular.forEach(m.schedules, function (s) {
                                m.dateKeySchedules[s.shift_date] = s;
                            });
                        });
                        $scope.temp_members = resp.temp_members;

                        $defer.resolve(resp.members);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        function doAutoSchedule(method) {
            dialogs.create('AutoScheduleDlg.html', 'AutoScheduleCtrl',
                {
                    group_id: $scope.group.id, weekDays: $scope.weekDays, cols: $scope.cols,
                    shifts: $scope.shifts, method: method
                },
                {size: 'lg'})
                .result.then(function (resp) {
                $scope.tableParams.reload();
            });
        }

        $scope.autoSchedule = function (members, method) {
            var clear = true;
            for (var i = 0; i < members.length; i++) {
                if (Object.keys(members[i].dateKeySchedules).length > 0) {
                    clear = false;
                    break;
                }
            }
            if (clear) {
                doAutoSchedule(method);
            } else {
                dialogs.confirm('自动排班确认', '自动排班会覆盖排班草稿,而不会保留已发布或已确认的排班,你确定要这样做吗?')
                    .result.then(
                    function () {
                        doAutoSchedule(method);
                    }
                );
            }
        };

        $scope.delShift = function ($event, m, d, $index) {
            $event.stopPropagation();
            var schedule = m.dateKeySchedules[d];
            if (schedule && schedule.stage != 1) {
                dialogs.notify('提示', '排班已发布,操作前请先撤销发布');
                return 0;
            }
            var shift = schedule.shifts[$index];
            var params = {schedule_id: schedule.id, shift_id: shift.id};
            Schedule.del_shift(params).$promise.then(function (resp) {
                schedule.shifts.splice($index, 1);
                if (resp.result == 0) {
                    schedule.is_duty = resp.result.is_duty;
                } else if (resp.result == 1) {
                    m.dateKeySchedules[d] = null;
                }
            }, function () {
                toaster.error('删除出错');
            });
        };

        $scope.addShift = function (m, d, s) {
            var schedule = m.dateKeySchedules[d];
            if (schedule && schedule.stage != 1) {
                dialogs.notify('提示', '排班已发布,操作前请先撤销发布');
                return 0;
            }

            var params = {group_id: $scope.group.id, user_id: m.member_id, shift_id: s.id};
            params['shift_date'] = d;
            Schedule.add_shift(params).$promise.then(function (resp) {
                if (resp.result){
                    $scope.tableParams.reload();
                    toaster.error('该用户当天已有值班,添加失败');
                }else {
                    if (m.dateKeySchedules[d]) {
                        m.dateKeySchedules[d].is_duty = resp.is_duty;
                        m.dateKeySchedules[d].shifts.push(s);
                    } else {
                        m.dateKeySchedules[d] = resp;
                    }
                }
            }, function () {
                $scope.tableParams.reload();
                toaster.error('保存出错,请重试');
            });
        };

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/table.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.printSchedules = function (members) {
            if (!$scope.group) {
                return;
            }

            var w = window.open("", "打印预览");

            var html = '<html><body>';

            var start = $scope.weekDays[0];
            var end = $scope.weekDays[6];
            start = $filter('date')(start, 'yyyy年MM月dd日');
            end = $filter('date')(end, 'yyyy年MM月dd日');

            html += '<table class="print">' +
                '<caption>' + start + ' - ' + end + $scope.group.name + '排班表</caption>' +
                '<thead><tr>';
            angular.forEach($scope.cols, function (c) {
                html += '<th>' + c.title + '</th>';
            });
            html += '</tr></thead><tbody>';

            angular.forEach($scope.members, function (m) {
                html += '<tr>';
                angular.forEach($scope.cols, function (c) {
                    html += '<td>';
                    if (c.field == 'member') {
                        html += m.member.name;
                    } else {
                        var schedule = m.dateKeySchedules[c.field];
                        if (schedule && schedule.stage != 1) {
                            var shifts = schedule.shifts;
                            html += '<div class="cell">';
                            angular.forEach(shifts, function (s) {
                                html += '<div class="shift-item">';

                                var name = s.name;
                                if (s.type_id == 3) {//TYPE_ASK4LEAVE
                                    name = '<strong>' + name + '</strong>';
                                }
                                html += name + '</div>'
                            });
                            html += '</div>';
                        }
                    }
                    html += '</td>';
                });
                html += '</tr>';
            });

            html += '</tbody></table>' + '<br><br><br><br><br>' +
                '<div style="padding-left:20"><textarea rows="10" cols="88"></textarea></div>' + '</body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };

        $scope.publicSchedules = function () {
            var params = {};
            params['group_id'] = $scope.group.id;
            params['start'] = $scope.cols[1].field;
            params['end'] = $scope.cols[7].field;
            Schedule.is_leaves(params).$promise.then(function (resp) {  //检查并提示是否有请假
                if(resp.result == 1){
                    dialogs.create('pages/duty/schedulerLeaveDlg.html', 'schedulerLeaveDlgCtrl', {
                        leave_user_name : resp.leave_user_name, leave_user_username : resp.leave_user_username, leave_shift_dates : resp.leave_shift_dates
                    }, {size: 'md'});
                }
                if(resp.result == 0){
                    Schedule.public_schedules(params).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 1:
                                toaster.warning($scope.group.name + '每周值班次数不能大于' + $scope.group.num + '次,发布失败!');
                                break;
                            case 0:
                                toaster.success('已发布');
                                $scope.tableParams.reload();
                                break;
                        }
                    }, function () {
                        toaster.error('发布出错');
                    });
                }
            });
        };

        $scope.cleanSchedules = function (members) {
            var clear = true;
            for (var i = 0; i < members.length; i++) {
                if (Object.keys(members[i].dateKeySchedules).length > 0) {
                    clear = false;
                    break;
                }
            }
            if (!clear) {
                dialogs.confirm('清除本周排班', '只能清除处于草稿状态的排班,你确定要这么做吗?').result.then(
                    function () {
                        var params = {};
                        params['group_id'] = $scope.group.id;
                        params['start'] = $scope.cols[1].field;
                        params['end'] = $scope.cols[7].field;
                        Schedule.clean_schedules(params).$promise.then(function (resp) {
                            $scope.tableParams.reload();
                        }, function () {
                            toaster.error('清除出错');
                        });
                    }
                );
            }
        };

        $scope.cancelSchedules = function () {
            var params = {};
            params['group_id'] = $scope.group.id;
            params['start'] = $scope.cols[1].field;
            params['end'] = $scope.cols[7].field;
            Schedule.cancel_schedules(params).$promise.then(function (resp) {
                $scope.tableParams.reload();
            }, function () {
                toaster.error('取消发布出错');
            });
        };

        $scope.exportSchedules = function () {
            if ($scope.group) {
                dialogs.create('templates/export_schedule_dlg.html', 'ExportScheduleCtrl',
                    {
                        group: $scope.group, start: $scope.weekDays[0], end: $scope.weekDays[6]
                    },
                    {size: 'md'});
            }
        };

        $scope.publicSchedule = function (m, d) {
            var schedule = m.dateKeySchedules[d];
            var params = {};
            params['id'] = schedule.id;
            Schedule.is_leave(params).$promise.then(function (resp) { //检查并提示是否有请假
                if (resp.result == 1) {
                    Dlg.notify("<strong class=\"text-red\"> "+ m.member.name +" </strong>在<strong class=\"text-red\"> "+ resp.shift_date +" </strong>已申请请假，无法发布该排班!");
                }
                if (resp.result == 0) {
                    Schedule.update({id: schedule.id}, {stage: 3}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 1:
                                toaster.warning($scope.group.name + '每周值班次数不能大于' + $scope.group.num + '次,发布失败!');
                                break;
                            case 0:
                                toaster.success('已发布');
                                schedule['stage'] = 3;
                                break;
                        }
                    }, function () {
                        toaster.error('发布出错');
                    });
                }
            }, function () {
                toaster.error('请假添加失败!');
            });
        };

        $scope.cancelSchedule = function (m, d) {
            var schedule = m.dateKeySchedules[d];
            Schedule.update({id: schedule.id}, {stage: 1}).$promise.then(function (resp) {
                toaster.success('已撤销');
                schedule['stage'] = 1;
            }, function () {
                toaster.error('撤销发布出错');
            });
        };

        $scope.coor = {x: 0, y: 0};
        $scope.leaveTable = function () {
            $scope.coor.x = 0;
            $scope.coor.y = 0;
        };

        $scope.hoverCell = function (x, y) {
            $scope.coor.x = x;
            $scope.coor.y = y;
        };

        $scope.showShifts = function (x, y) {
            return $scope.coor.x == x && $scope.coor.y == y;
        };
    });

angular.module('c.c').controller('AutoScheduleCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs, toaster, C, F, Table, Schedule, data) {
        $scope.weekDays = data.weekDays;
        $scope.cols = data.cols;
        $scope.shifts = data.shifts;
        var opt = C.OPT.SCHEDULE.INDEX.G_S_BY_ROLLING_DAYS;
        if (data.method == '2') {
            $scope.forNurse = true;
            opt = C.OPT.SCHEDULE.INDEX.G_S_BY_LAST_WEEK;
        }

        $scope.hideFilter = true;
        $scope.hideOpt = true;
        $scope.justDataCol = true;
        $scope.tableParams = new NgTableParams({page: 1, count: 50}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if (!$scope.members) {
                    var url = params.url();
                    url['opt'] = opt;
                    url['group_id'] = data.group_id;
                    url['end'] = $scope.cols[1].field;
                    Schedule.query(url, function (resp) {
                        angular.forEach(resp.members, function (m) {
                            m.dateKeySchedules = [];
                            angular.forEach(m.schedules, function (s) {
                                m.dateKeySchedules[s.shift_date] = s;
                            });
                        });
                        $scope.members = resp.members;
                        Table.getTableData(resp.members, $defer, params);
                    });
                } else {
                    Table.getTableData($scope.members, $defer, params);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.members = null;
            $scope.tableParams.reload();
        };

        $scope.delShift = function ($event, m, d, $index) {
            $event.stopPropagation();
            var schedule = m.dateKeySchedules[d];
            schedule.shifts.splice($index, 1);
            if (schedule.shifts.length == 0) {
                m.dateKeySchedules[d] = null;
            }
        };

        $scope.addShift = function (m, d, s) {
            if (m.dateKeySchedules[d]) {
                m.dateKeySchedules[d].shifts.push(s);
            } else {
                m.dateKeySchedules[d] = {
                    group_id: data.group_id,
                    user_id: m.member_id, shift_date: d, shifts: [s]
                };
            }
        };

        $scope.coor = {x: 0, y: 0};
        $scope.leaveTable = function () {
            $scope.coor.x = 0;
            $scope.coor.y = 0;
        };

        $scope.hoverCell = function (x, y) {
            $scope.coor.x = x;
            $scope.coor.y = y;
        };

        $scope.showShifts = function (x, y) {
            return $scope.coor.x == x && $scope.coor.y == y;
        };

        $scope.swapTwo = function (toIndex, fromIndex, members, reload) {
            var to = members[toIndex];
            var from = members[fromIndex];

            angular.forEach(from.schedules, function (s) {
                s.user_id = to.member_id;
            });

            angular.forEach(to.schedules, function (s) {
                s.user_id = from.member_id;
            });

            var temp = to.schedules;
            to.schedules = from.schedules;
            from.schedules = temp;

            temp = to.dateKeySchedules;
            to.dateKeySchedules = from.dateKeySchedules;
            from.dateKeySchedules = temp;

            temp = members[toIndex];
            members[toIndex] = members[fromIndex];
            members[fromIndex] = temp;

            if (reload) {
                $scope.tableParams.reload();
            }
        };

        $scope.uncheckAll = function (members) {
            angular.forEach(members, function (m) {
                m.is_checked = false;
            });
        };

        $scope.rollMembers = function (toIndex, members) {
            var k = 0;
            for (var i = toIndex - 1; i >= 0; i--) {
                var from = members[i];
                if (from.is_checked) {
                    for (var j = i + 1; j < toIndex - k; j++) {
                        $scope.swapTwo(j, j + 1, members);
                    }
                    $scope.swapTwo(i, toIndex - k, members);
                    k++;
                }
            }

            k = 0;
            for (var i = toIndex + 1; i < members.length; i++) {
                var from = members[i];
                if (from.is_checked) {
                    for (var j = i - 1; j > toIndex + k; j--) {
                        $scope.swapTwo(j, j - 1, members);
                    }
                    $scope.swapTwo(i, toIndex + k, members);
                    k++;
                }
            }

            angular.forEach(members, function (m) {
                m.is_checked = false;
            });
            $scope.tableParams.reload();
        };

        $scope.ok = function (members) {
            var params = {};
            var members_schedules = {};
            angular.forEach(members, function (m) {
                var schedules = {};
                for (var i = 1; i < $scope.cols.length; i++) {
                    var d = $scope.cols[i].field;
                    if (i <= m.rolling_days) {
                        if (m.dateKeySchedules[d]) {
                            shifts = [];
                            angular.forEach(m.dateKeySchedules[d].shifts, function (s) {
                                shifts.push({id: s.id, type_id: s.type_id});
                            });
                            schedules[d] = shifts;
                        }
                    } else {
                        var pd = $scope.cols[i - m.rolling_days].field;
                        if (schedules[pd]) {
                            schedules[d] = schedules[pd];
                        }
                    }
                }
                members_schedules[m.member_id] = schedules;
            });
            params['members_schedules'] = members_schedules;
            params['group_id'] = data.group_id;
            params['start'] = $scope.cols[1].field;
            params['end'] = $scope.cols[7].field;
            if ($scope.forNurse) {
                var members_sorting = [];
                for (var i = 0; i < members.length; i++) {
                    members_sorting.push({id: members[i].id, sorting: i + 1});
                }
                params['members_sorting'] = members_sorting;
            }

            $scope.doScheduling = true;
            Schedule.do_schedules(params).$promise.then(function (resp) {
                $uibModalInstance.close();
            }, function () {
                toaster.error('自动排班出错');
            }).finally(function () {
                $scope.doScheduling = false;
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('schedulerLeaveDlgCtrl', schedulerLeaveDlgCtrl);

    /** @ngInject */
    function schedulerLeaveDlgCtrl($scope, $q, TotalDutyRecord, DateHelper, ArrayHelper, UIHelper,
                                   Table, FileHelper, Dlg, data, NgTableParams,$uibModalInstance) {
        var vm = $scope;
        vm.leave_shift_dates = data.leave_shift_dates;
        vm.leave_user_name = data.leave_user_name;
        vm.leave_user_username = data.leave_user_username;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok =$uibModalInstance.dismiss;
        vm.init = init;

        init();


        function init() {

            vm.hideOpt=true;
            vm.hideFilter=true;
            vm.cols=[
                {title: "姓名", width: 120, show: true},
                {title: "工号", width: 120, show: true},
                {title: "请假时间", show: true}
            ];
            $scope.tableParams = new NgTableParams({
                page: 1, count: 10, sorting: {
                    number: 'desc'
                }
            }, {
                counts: [10, 30, 50], total: 0
            });
        }
    }

})();
angular.module('c.c')
    .controller('ShiftCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyGroup, Shift, F, Dlg) {

        DutyGroup.query({opt: 5}, function (resp) {
            $scope.groups = resp.groups;
            if (resp.groups && resp.groups.length > 0) {
                $scope.group = resp.groups[0];
                $scope.tableParams.reload();
            }
        });

        $scope.groupSelectedFn = function ($index) {
            $scope.group = $scope.groups[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.types = F.get('shift_type_list');
        //var typeOpts = F.getNgTableOpts($scope.types);
        $scope.yesNo = F.get('yesNo');
        //var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '名称', /*filter: {'name': 'text'},*/ field: 'name', show: true}, //0
            {
                title: '类型', /*filter: {'type_id': 'select'}, data: typeOpts, */
                field: 'type_id',
                width: '128',
                show: true
            }, //0
            {title: '是否在岗', field: 'is_duty', width: '128', show: true}, //0
            {title: '在岗时间', field: 'duty_at', show: true}, //0
            {title: '颜色', field: 'color', width: '128', show: true}, //0
            {title: '备注', field: 'remark', width: '30%', show: true}, //0
            {
                title: '是否停用', /*filter: {is_stop: 'select'}, data: yesNoOpts,*/
                field: 'is_stop',
                width: '90',
                show: true
            }
        ];

        var isDarkness = F.isTooDark;

        $scope.hideFilter = true;
        $scope.optColWidth = 70;
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.group) {
                    var url = params.url();
                    url['opt'] = 1;
                    url['group_id'] = $scope.group.id;
                    Shift.query(url, function (resp) {
                        params.total(resp.total);
                        $defer.resolve(resp.shifts);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ShiftDlg.html', 'ShiftDlgCtrl', {group: $scope.group}, {
                size: 'md'
            }).result.then(function (shift) {
                Shift.save(shift).$promise.then(function (data) {
                    toaster.success('排班班次添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('排班班次添加失败!');
                });
            });
        };

        $scope.edit = function (shift) {
            shift.$edit = true;
            shift.$nameChanged = shift.name;
            shift.$remarkChanged = shift.remark;
            shift.$is_duty = shift.is_duty == 1 ? true : false;
            shift.$is_dutyChanged = (shift.type_id == '3');
            shift.$is_stopChanged = shift.is_stop == '1';

            shift.$colorChanged = shift.color;
            shift.$fore_color = shift.fore_color;
            shift.unwatch = $scope.$watch(function () {
                return shift.$colorChanged;
            }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    var color = newVal;
                    shift.$fore_color = isDarkness(color) ? 'white' : 'black';
                }
            });
        };

        $scope.dutyEdit = function (shift) {
            Dlg.show({
                template: 'pages/duty/shiftEditDlg.html',
                ctrl: 'ShiftEditDlgCtrl',
                data: {id: shift.id},
                size: 'md'
            }).then(function (resp) {
                $scope.tableReload();
            });
        };

        $scope.cancel = function (shift) {
            shift.$edit = false;
            shift.unwatch();
        };

        $scope.save = function (shift) {
            shift.$edit = false;
            shift.unwatch();
            if (shift.$nameChanged == "") {
                toaster.warning('名称不能为空!')
            } else {
                var data = {};
                data['name'] = shift.$nameChanged;
                data['remark'] = shift.$remarkChanged;
                data['type_id'] = shift.$is_dutyChanged ? '3' : '2';
                data['is_duty'] = shift.$is_duty;
                data['color'] = shift.$colorChanged;
                data['fore_color'] = shift.$fore_color;
                data['is_stop'] = shift.$is_stopChanged;
                Shift.update({id: shift.id}, data).$promise.then(function (resp) {
                    toaster.success('排班班次修改成功!');
                    shift.name = shift.$nameChanged;
                    shift.remark = shift.$remarkChanged;
                    shift.type_id = shift.$is_dutyChanged ? '3' : '2';
                    shift.is_duty = shift.$is_duty;
                    shift.is_stop = shift.$is_stopChanged ? '1' : '0';
                    shift.color = shift.$colorChanged;
                    shift.fore_color = shift.$fore_color;
                }, function (error) {
                    toaster.error('排班班次修改失败!');
                });
            }
        };

        $scope.delete = function (shift) {
            dialogs.confirm('删除排班班次', '确定要删除<strong>' + shift.name + '</strong>排班班次吗?'
                + '删除一个班次会连带删除用这个班次排班的排班记录!')
                .result.then(function () {
                Shift.delete({id: shift.id}).$promise.then(function (resp) {
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('删除排班班次!');
                });
            });
        };

    });

angular.module('c.c').controller('ShiftDlgCtrl',
    function ($scope, $uibModalInstance, $timeout, dialogs, Dlg, UIHelper, data, DateHelper, FormHelper) {
        $scope.group = data.group;
        $scope.shift = {
            is_stop: false,
            is_duty: false,
            group_id: data.group.id,
            color: '#ffffff',
            on_duty_time_items: []
        };
        $scope.on_duty_times = [];
        var i = 1;
        var date = new Date('2022-01-01 00:00');
        for (i; i <= 48; i++) {
            if (i === 1) {
                date.setMinutes(date.getMinutes());
            } else {
                date.setMinutes(date.getMinutes() + 30);
            }
            $scope.on_duty_times.push({
                id: i,
                name: (DateHelper.datetime2Str(date)).substr(11, 6)
            });
        }
        $scope.on_duty_times.push({id: i, name: '24:00'});
        if ($scope.shift.on_duty_time_items.length === 0) {
            var item = {
                start: null,
                end: null
            };
            $scope.shift.on_duty_time_items.push(item);
        }

        $scope.addDutyTime = function () {
            var item = {
                start: null,
                end: null
            };
            $scope.shift.on_duty_time_items.push(item);
        };

        $scope.rmDutyTimeIndex = function (shift, index) {
            $scope.shift.on_duty_time_items.splice(index, 1);
        };

        // $scope.dutyFn = function (is_duty) {
        //     if (is_duty) {
        //         $scope.shift.color = '#ff0000';
        //     }
        // };

        // $scope.$on('colorpicker-shown', function () {
        //     if ($scope.shift.is_duty) {
        //         $scope.shift.color = '#ff0000';
        //         $timeout(function () {
        //             $scope.open = false;
        //             dialogs.notify('提示', '值班类型只能使用红色!');
        //         }, 0);
        //     }
        // });

        $scope.ok = function (shift) {
            return FormHelper.handleSubmit($scope, function (defer) {
                var params = {};
                var duty_at = '';
                params['name'] = shift.name;
                params['group_id'] = shift.group_id;
                params['type_id'] = shift.is_duty ? 3 : 2; //TYPE_NORMAL:2, TYPE_DUTY:3
                params['result_id'] = 1; //RESULT_NONE
                params['remark'] = shift.remark;
                params['is_stop'] = shift.is_stop;
                params['color'] = shift.color;
                params['fore_color'] = UIHelper.isTooDark(shift.color) ? 'white' : 'black';
                params['is_duty'] = shift.is_on_duty;
                if (shift.is_on_duty) {
                    for (var i = 0; i < shift.on_duty_time_items.length; i++) {
                        if (i != 0) {
                            duty_at += '，';
                        }
                        duty_at += shift.on_duty_time_items[i]['start'].name + '-' +
                            shift.on_duty_time_items[i]['end'].name;
                    }
                    params['duty_at'] = duty_at;
                }
                $uibModalInstance.close(params);
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';
    angular.module('c.c')
        .controller('ShiftEditDlgCtrl', ShiftEditDlgCtrl);

    /** @ngInject */
    function ShiftEditDlgCtrl($scope, $uibModalInstance, Dlg, data, DateHelper, FormHelper, Shift, ArrayHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.on_duty_times = [];
        vm.addDutyTime = addDutyTime;
        vm.rmDutyTimeIndex = rmDutyTimeIndex;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            vm.loading = true;
            vm.m = {id: id, on_duty_time_items: []};
            var date = new Date('2022-01-01 00:00');
            for (var i = 1; i <= 48; i++) {
                if (i === 1) {
                    date.setMinutes(date.getMinutes());
                } else {
                    date.setMinutes(date.getMinutes() + 30);
                }
                vm.on_duty_times.push({
                    id: i,
                    name: (DateHelper.datetime2Str(date)).substr(11, 6)
                });
            }
            vm.on_duty_times.push({id: i, name: '24:00'});

            var url = {};
            url['opt'] = 8;
            url['shift_id'] = id;
            Shift.query(url, function (resp) {
                if (resp.shifts[0].duty_at) {
                    var duty_at_items = resp.shifts[0].duty_at.split("，");
                    angular.forEach(duty_at_items, function (item) {
                        var arr = item.split("-");
                        vm.m.on_duty_time_items.push({
                            start: ArrayHelper.getItem(arr[0], vm.on_duty_times, 'name'),
                            end: ArrayHelper.getItem(arr[1], vm.on_duty_times, 'name')
                        });
                    });
                }

                if (vm.m.on_duty_time_items.length === 0) {
                    var item = {
                        start: null,
                        end: null
                    };
                    vm.m.on_duty_time_items.push(item);
                }
                vm.loading = false;
            });
            $scope.$watch('vm.m.on_duty_time_items', function () {
                var invalid;
                if (vm.m.on_duty_time_items.length > 1) {
                    for (var i = 1; i < vm.m.on_duty_time_items.length; i++) {
                        if (vm.m.on_duty_time_items[i].start != null && vm.m.on_duty_time_items[i - 1].end != null) {
                            invalid = vm.m.on_duty_time_items[i - 1].end.id > vm.m.on_duty_time_items[i].start.id;
                            vm.Form['start' + i].$setValidity('end', !invalid);
                        }
                    }
                }
            }, true);
        }

        function addDutyTime(m) {
            var item = {
                start: null,
                end: null
            };
            m.on_duty_time_items.push(item);
        }

        function rmDutyTimeIndex(m, index) {
            m.on_duty_time_items.splice(index, 1);
        }


        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {};
                var duty_at = '';
                for (var i = 0; i < m.on_duty_time_items.length; i++) {
                    if (i != 0) {
                        duty_at += '，';
                    }
                    duty_at += m.on_duty_time_items[i]['start'].name + '-' + m.on_duty_time_items[i]['end'].name;
                }
                pa['duty_at'] = duty_at;
                Shift.update({id: m.id}, pa).$promise.then(function (data) {
                    Dlg.s('修改成功!');
                    vm.close();
                }, function () {
                    Dlg.e('修改失败!');
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('LawManageCtrl', LawManageCtrl)
        .controller('LawApplyCtrl', LawApplyCtrl)
        .controller('LawShowCtrl', LawShowCtrl);


    function LawManageCtrl($scope, Law, F, dialogs, toaster, Table) {
        var vm = $scope;
        vm.show = show;
        vm.init = init;
        vm.remove = remove;

        vm.$on("reload", function () {
            vm.tableReload();
        });

        vm.types = F.get("law_types");
        function init(opt) {
            var options = {
                service: Law,
                params: {opt: opt/*INDEX_SEARCH*/},
                optColWidth: Table._2_BTN,
                sorting: {created_at: 'desc'},
                showSn: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "type", title: "类型", filter: {type_id: "select"}},
                    {field: "creator", title: "上传人", filter: {creator: "text"}},
                    {field: "created_at", title: "上传时间"}
                ]
            };

            options.cols[1].data = F.getNgTableOpts(vm.types);
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (i) {
                    i.type = F.getItem(i.type_id, vm.types);
                });
            });
        }

        function show(manual) {
            dialogs.create('pages/edu/law/show.html', 'LawShowCtrl',
                {id: manual.id},
                {size: 'lg'});
        }

        function remove(law) {
            dialogs.confirm('删除文档', '确定要删除<strong>' + law.name + '</strong>吗?')
                .result.then(function () {
                    Law.delete({id: law.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('删除文档成功');
                                vm.tableReload();
                                break;
                            case 1:
                                toaster.error('删除文档失败');
                                break;

                        }
                    });
                });
        }

    }

    function LawApplyCtrl($scope, toaster, F, C, Law, $rootScope, FileHelper) {
        var vm = $scope;
        vm.upload = upload;
        vm.submit = submit;
        vm.reset = reset;
        vm.types = F.get('law_types');

        reset();
        function reset() {
            vm.m = {
                name: '',
                'memo': '',
                pdf_attach: {},
                type: vm.types[0]
            };
        }

        function submit(form, law) {
            form.submitted = true;
            if (form.$valid) {
                var params = {};
                params['name'] = law.name;
                params['memo'] = law.memo;
                params['type_id'] = law.type.id;

                if (law.pdf_attach.filename == null) {
                    toaster.warning('请等一小会儿,附件还在路上');
                    return;
                }
                params['mime'] = law.pdf_attach.mime;
                params['size'] = law.pdf_attach.size;
                params['filename'] = law.pdf_attach.filename;
                params['tmp_dir'] = law.pdf_attach.tmp_dir;

                Law.save(params).$promise.then(function (resp) {
                    toaster.success('文档上传成功!');
                    vm.tabs['manage'] = true;
                    $rootScope.$broadcast('reload');
                }, function () {
                    toaster.error('文档上传失败!');
                });
            } else {
                toaster.warning('请检查表单无误');
            }
        }

        //单个pdf附件的上传
        function upload(file, pdf_attach, e) {
            if (file) {
                pdf_attach.name = file.name;
                delete pdf_attach.filename;
            }
            FileHelper.upload1(C.URL.LAW_UPLOAD, file, pdf_attach, e, {name: 'tmp_dir'}, {tmp_dir: pdf_attach.tmp_dir});
        }
    }

    function LawShowCtrl($scope, Law, $uibModalInstance, toaster, F, data) {
        var types = F.get("law_types");

        Law.get({id: data.id}).$promise.then(function (resp) {
            var law = resp;
            law.type = F.getItem(law.type_id, types);
            $scope.pdfUrl = false;
            if (law.pdf_attach) {
                var type = law.mime.substr(law.mime.indexOf('/') + 1, law.mime.length);
                if (type == 'pdf') {
                    $scope.pdfUrl = law.pdf_attach;
                }
            }
            $scope.m = law;
        }, function () {
            toaster.pop({
                type: 'warning', title: '文档不存在', body: '文档可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
angular.module('c.c')
    .controller('EduPracticeCtrl', function () {

    });
angular.module('c.c')
    .controller('EqsScreenCtrl', function ($scope, C, EQSSchedule, $interval, $location) {
        var vm = $scope;

        var rowNum = 2;
        var colNum = 3;
        vm.loading = false;
        var timer;//定时器
        var startAt = new Date();

        init();

        function init() {
            vm.date = startAt.getFullYear() + '年' + (startAt.getMonth() + 1) + '月' + startAt.getDate() + '日';
            vm.weekday = "星期" + "日一二三四五六".charAt(startAt.getDay());
            timeUpdate();

            timer = $interval(function () {
                timeUpdate();
                if ($location.path() !== '/eqs_large_screen') {
                    destroyInterval();
                }
            });
            //页面关闭时，销毁定时器
            $scope.$on('destroy', function () {
                destroyInterval();
            });

            $scope.$on(C.P + 'eqs.screen.update', function (event, data) {
                console.log(data);
                updateSchedules(data.schedule.id, data.normalList, data.checkingList);

            });

            setView();
            getSchedules();
        }


        function timeToStr(time) {
            if (time < 10) {
                time = '0' + time;
            }
            return time;
        }

        function timeUpdate() {
            var now = new Date();
            vm.now = timeToStr(now.getHours()) + ':' + timeToStr(now.getMinutes()) + ':' + timeToStr(now.getSeconds());
        }

        function destroyInterval() {
            $interval.cancel(timer);
            timer = null;
        }

        function getSchedules() {
            vm.loading = true;
            EQSSchedule.query({op: 'reg_with_patients'}).$promise.then(function (resp) {
                var items = resp.items;
                items = loadSchedules(items);
                setView(items);
            }).finally(function () {
                vm.loading = false;
            });
        }

        function updateSchedules(scheduleId, items, checkingList) {
            for (var i = 0; i < vm.rows.length; i++) {
                vm.rows[i].map(function (col) {
                    var c = col;
                    if (col.scheduleId == scheduleId) {
                        c.patients = items.map(function (p) {
                            return {name: p.patient.name, id_card: p.patient.id_card};
                        });
                        if (checkingList.length > 0) {
                            var checking = checkingList[0];
                            c.handle = {name: checking.patient.name, id_card: checking.patient.id_card};
                        } else {
                            c.handle = null;
                        }
                    }
                    return c;
                })
            }
        }

        function loadSchedules(items) {
            items = items.map(function (item) {
                var patients = [];
                var handle = null;
                if (item.queues.length > 0) {
                    angular.forEach(item.queues, function (q) {
                        if (q.state == 3) {
                            handle = {name: q.patient.name, id_card: q.patient.id_card};
                        } else {
                            patients.push({name: q.patient.name, id_card: q.patient.id_card});
                        }
                    });
                }
                var unitName = item.unit.name;
                unitName = unitName.replace("(", "︵");
                unitName = unitName.replace("（", "︵");
                unitName = unitName.replace(")", "︶");
                unitName = unitName.replace("）", "︶");
                return {
                    scheduleId: item.id,
                    unitName: unitName,
                    handle: handle,
                    patients: patients
                };
            });

            return items;
        }

        function setView(items) {
            console.log(items);
            var rN = rowNum;
            // if (angular.isDefined(items)) {
            //     rN = parseInt(items.length / colNum) + 1;
            // }
            // console.log(rN);
            var rows = new Array(rN);
            for (var i = 0; i < rows.length; i++) {
                var cols = [];
                for (var j = 0; j < colNum; j++) {
                    if (angular.isUndefined(items)) {
                        cols.push({
                            scheduleId: null,
                            unitName: '读取中...',
                            patients: []
                        });
                    } else {
                        var key = i * colNum + j;
                        if (items.hasOwnProperty(key)) {
                            cols.push(items[key]);
                        } else {
                            //格子放不满的情况
                            cols.push({
                                scheduleId: null,
                                unitName: '',
                                patients: []
                            });
                        }
                    }
                }
                rows[i] = cols;
            }
            vm.rows = rows;
        }
    });
angular.module('c.c')
    .controller('AdministrativeMaterialCtrl', function ($rootScope, $scope) {
        var PendingNeedRefresh = false;
        var ProcessedNeedRefresh = false;
        $scope.$on('MAConfirmed', function () {
            ProcessedNeedRefresh = true;
        });
        $scope.$on('MACancel', function () {
            PendingNeedRefresh = true;
        });
        $scope.select = function (opt) {
            if (opt == 'pending') {
                if (PendingNeedRefresh) {
                    $rootScope.$broadcast('MAPendingRefresh');
                    PendingNeedRefresh = false;
                }
            } else if (opt == 'processed') {
                if (ProcessedNeedRefresh) {
                    $rootScope.$broadcast('MAProcessedRefresh');
                    ProcessedNeedRefresh = false;
                }
            }
        }

        $scope.type = {id: 1, name: '行政物资'};
    });



angular.module('c.c')
    .controller('CADREMaterialCtrl', function ($rootScope, $scope) {
        var PendingNeedRefresh = false;
        var ProcessedNeedRefresh = false;
        $scope.$on('MAConfirmed', function () {
            ProcessedNeedRefresh = true;
        });
        $scope.$on('MACancel', function () {
            PendingNeedRefresh = true;
        });
        $scope.select = function (opt) {
            if (opt == 'pending') {
                if (PendingNeedRefresh) {
                    $rootScope.$broadcast('MAPendingRefresh');
                    PendingNeedRefresh = false;
                }
            } else if (opt == 'processed') {
                if (ProcessedNeedRefresh) {
                    $rootScope.$broadcast('MAProcessedRefresh');
                    ProcessedNeedRefresh = false;
                }
            }
        };

        $scope.type = {id: 5, name: '干保物资'};
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('ManualManageCtrl', ManualManageCtrl)
        .controller('ManualApplyCtrl', ManualApplyCtrl)
        .controller('ManualShowCtrl', ManualShowCtrl);


    function ManualManageCtrl($scope, EManual, F, dialogs, ManualType, Table, toaster, FileHelper, C) {
        var vm = $scope;
        vm.show = show;
        vm.init = init;
        vm.remove = remove;
        vm.edit = edit;
        vm.ok = ok;
        vm.download = download;

        vm.$on("reload", function () {
            vm.tableReload();
        });

        function init(opt) {
            var options = {
                service: EManual,
                params: {opt: opt/*INDEX_SEARCH*/},
                optColWidth: opt === 1 ? Table._4_BTN : Table._2_BTN,
                sorting: {created_at: 'desc'},
                showSn: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "type", title: "类型", filter: {type: "select"}},
                    //{field: "is_stop", title: "是否停用", filter: {is_stop: "select"}},
                    {field: "creator", title: "上传人", filter: {creator: "text"}},
                    {field: "created_at", title: "上传时间"}
                ]
            };

            ManualType.query({opt: 1/*INDEX_OPTIONS*/}, function (resp) {
                vm.types = resp.types;
                options.cols[1].data = F.getNgTableOpts(vm.types);
            });

            Table.load(vm, options);
        }

        function show(manual) {
            dialogs.create('pages/equipment/manual/show.html', 'ManualShowCtrl',
                {id: manual.id},
                {size: 'lg'});
        }

        function remove(manual) {
            dialogs.confirm('删除手册', '确定要删除<strong>' + manual.name + '</strong>吗?')
                .result.then(function () {
                EManual.delete({id: manual.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除手册成功');
                            vm.tableReload();
                            break;
                    }
                });
            }, function () {
                toaster.error('删除失败!');
            });
        }

        function edit(m) {
            m.$edit = true;
            m.$nameChanged = m.name;
        }

        function ok(m) {
            m.$edit = false;
            if (m.$nameChanged === "") {
                toaster.error('名称不能为空!');
            } else if (m.name !== m.$nameChanged) {
                var params = {};
                params['name'] = m.$nameChanged;
                EManual.update({id: m.id}, params).$promise.then(function (resp) {
                    toaster.success(resp.msg);
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('修改失败!');
                });

            }
        }

        function download(m) {
            FileHelper.download1(C.URL.MANUAL_DOWNLOAD, m, {filename: 'pdf_attach'});
        }

    }

    function ManualApplyCtrl($scope, toaster, ManualType, F, C, EManual, $rootScope, FileHelper) {
        var vm = $scope;
        vm.upload = upload;
        vm.submit = submit;
        vm.reset = reset;

        reset();

        function reset() {
            vm.m = {
                name: '',
                'memo': '',
                pdf_attach: {}
            };
            ManualType.query({opt: 1/*INDEX_OPTIONS*/}, function (resp) {
                vm.types = resp.types;
                vm.m.type = vm.types[0];
            });
        }

        function submit(form, manual) {
            form.submitted = true;
            if (form.$valid) {
                if (vm.types.length == 0) {
                    toaster.warning('请联系管理员添加手册类型');
                } else {
                    var params = {};
                    params['name'] = manual.name;
                    params['memo'] = manual.memo;
                    params['type_id'] = manual.type.id;

                    if (manual.pdf_attach.filename == null) {
                        toaster.warning('请等一小会儿,附件还在路上');
                        return;
                    }
                    params['mime'] = manual.pdf_attach.mime;
                    params['size'] = manual.pdf_attach.size;
                    params['filename'] = manual.pdf_attach.filename;
                    params['tmp_dir'] = manual.pdf_attach.tmp_dir;
                }

                EManual.save(params).$promise.then(function (resp) {
                    toaster.success('说明手册上传成功!');
                    vm.tabs['manage'] = true;
                    $rootScope.$broadcast('reload');
                }, function () {
                    toaster.error('说明手册上传失败!');
                });
            } else {
                toaster.warning('请检查表单无误');
            }
        }

        //单个pdf附件的上传
        function upload(file, pdf_attach, e) {
            if (file) {
                pdf_attach.name = file.name;
                delete pdf_attach.filename;
            }
            FileHelper.upload1(C.URL.MANUAL_UPLOAD, file, pdf_attach, e, {name: 'tmp_dir'}, {tmp_dir: pdf_attach.tmp_dir});
        }
    }

    function ManualShowCtrl($scope, EManual, $uibModalInstance, toaster, data, FileHelper, C) {

        EManual.get({id: data.id}).$promise.then(function (resp) {
            var manual = resp;
            $scope.pdfUrl = false;
            if (manual.pdf_attach) {
                var type = manual.mime.substr(manual.mime.indexOf('/') + 1, manual.mime.length);
                if (type == 'pdf') {
                    $scope.pdfUrl = manual.pdf_attach;
                }
            }
            $scope.m = manual;
        }, function () {
            toaster.pop({
                type: 'warning', title: '手册不存在', body: '设备手册可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.download = function (m) {
            FileHelper.download1(C.URL.MANUAL_DOWNLOAD, m, {filename: 'pdf_attach'});
        }

    }
})();
angular.module('c.c')
    .controller('MedicalMaterialCtrl', function ($rootScope, $scope) {
        var PendingNeedRefresh = false;
        var ProcessedNeedRefresh = false;
        $scope.$on('MAConfirmed', function () {
            ProcessedNeedRefresh = true;
        });
        $scope.$on('MACancel', function () {
            PendingNeedRefresh = true;
        });
        $scope.select = function (opt) {
            if (opt == 'pending') {
                if (PendingNeedRefresh) {
                    $rootScope.$broadcast('MAPendingRefresh');
                    PendingNeedRefresh = false;
                }
            } else if (opt == 'processed') {
                if (ProcessedNeedRefresh) {
                    $rootScope.$broadcast('MAProcessedRefresh');
                    ProcessedNeedRefresh = false;
                }
            }
        }

        $scope.type = {id: 2, name: '医疗物资'};
    });
angular.module('c.c')
    .controller('ORMaterialCtrl', function ($rootScope, $scope) {
        var PendingNeedRefresh = false;
        var ProcessedNeedRefresh = false;
        $scope.$on('MAConfirmed', function () {
            ProcessedNeedRefresh = true;
        });
        $scope.$on('MACancel', function () {
            PendingNeedRefresh = true;
        });
        $scope.select = function (opt) {
            if (opt == 'pending') {
                if (PendingNeedRefresh) {
                    $rootScope.$broadcast('MAPendingRefresh');
                    PendingNeedRefresh = false;
                }
            } else if (opt == 'processed') {
                if (ProcessedNeedRefresh) {
                    $rootScope.$broadcast('MAProcessedRefresh');
                    ProcessedNeedRefresh = false;
                }
            }
        };

        $scope.type = {id: 3, name: '手术室物资'};
    });
angular.module('c.c')
    .controller('PendingMaterialCtrl', function($rootScope, $scope, $filter, dialogs, toaster, NgTableParams,
                                                MaterialApplication, F) {
        $scope.$on('MAPendingRefresh', function() {
            $scope.tableParams.reload();
        });

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '申请物资', field: 'desc', show: true, filter: {'desc': 'text'}}, //0
            {
                title: '是否急需',
                field: 'is_urgent',
                filter: {'is_urgent': 'select'},
                sortable: 'is_urgent',
                data: yesNoOpts,
                width: '96',
                show: true
            }, //1
            {title: '申请人', field: 'applicant', filter: {'applicant': 'text'}, width: '73', show: true}, //6
            {title: '申请科室', field: 'dept', filter: {'dept': 'text'}, width: '118', show: true}, //6
            {title: '申请时间', field: 'created_at', sortable: 'created_at', width: '130', show: true} //6
        ];

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {is_urgent: 'desc', created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function($defer, params) {
                var url = params.url();
                url['opt'] = 2;
                url['type_id'] = $scope.type.id;
                MaterialApplication.query(url, function(resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.materials);
                });
            }
        });

        //$scope.hideFilter = true;
        $scope.optColWidth = 70;

        $scope.tableReload = function() {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function() {
            $scope.tableParams.filter({});
        };

        $scope.confirm = function(m) {
            MaterialApplication.update({id: m.id}, {stage: 2}).$promise.then(function() {
                toaster.success('确认成功!');
                $scope.tableParams.reload();
                $rootScope.$broadcast('MAConfirmed');
            }, function(error) {
                toaster.error('确认失败!');
            });
        };

        //$scope.delete = function (m) {
        //    dialogs.confirm('删除物资申请', '确定要删除该物资申请记录吗?')
        //        .result.then(function () {
        //            MaterialApplication.delete({id: m.id}).$promise.then(function (resp) {
        //                $scope.tableReload();
        //            }, function () {
        //                toaster.error('删除物资申请!');
        //            });
        //        });
        //};

    });
angular.module('c.c')
    .controller('ProcessedMaterialCtrl', function($rootScope, $scope, $filter, dialogs,
                                                  toaster, NgTableParams, MaterialApplication) {
        $scope.$on('MAProcessedRefresh', function() {
            $scope.tableParams.reload();
        });

        $scope.cols = [
            {title: '申请物资', field: 'desc', show: true, filter: {'desc': 'text'}}, //0
            {title: '申请人', field: 'applicant', filter: {'applicant': 'text'}, width: '73', show: true}, //6
            {title: '申请科室', field: 'dept', filter: {'dept': 'text'}, width: '118', show: true}, //6
            {
                title: '申请时间',
                field: 'created_at',
                filter: {'created_at': 'date_range'},
                sortable: 'created_at',
                width: '130',
                show: true
            }, //6
            {title: '确认人', field: 'operator', filter: {'operator': 'text'}, width: '73', show: true}, //6
            {title: '确认时间', field: 'updated_at', width: '130', show: true}, //6
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function(newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function($defer, params) {
                var url = params.url();
                url['opt'] = 3;
                url['type_id'] = $scope.type.id;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                MaterialApplication.query(url, function(resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.materials);
                });
            }
        });

        //$scope.hideFilter = true;
        $scope.optColWidth = 70;

        $scope.tableReload = function() {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function() {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.cancel = function(m) {
            dialogs.confirm('撤销物资申请', '确定要撤销对该物资申请的确认吗?')
                .result.then(function() {
                MaterialApplication.update({id: m.id}, {stage: 1}).$promise.then(function() {
                    toaster.success('撤销成功!');
                    $scope.tableParams.reload();
                    $rootScope.$broadcast('MACancel');
                }, function(error) {
                    toaster.error('撤销失败!');
                });
            });
        };

        //$scope.delete = function (m) {
        //    dialogs.confirm('删除物资申请', '确定要删除该物资申请记录吗?')
        //        .result.then(function () {
        //            MaterialApplication.delete({id: m.id}).$promise.then(function (resp) {
        //                $scope.tableReload();
        //            }, function () {
        //                toaster.error('删除物资申请!');
        //            });
        //        });
        //};
    });
(function () {
  'use strict';

  angular.module('c').controller('AppQrCodeCtrl', AppQrCodeCtrl);

  /** @ngInject */
  function AppQrCodeCtrl($scope, $uibModalInstance,ScanningGun, $timeout, Dlg) {
    var vm = $scope;
    // vm.qrCode = qrCode;
    vm.cancel = $uibModalInstance.dismiss;
    vm.close = $uibModalInstance.close;

    init();


    function init() {
      vm.m = {
        mode: '1'
      }
      console.log(vm.m)
    }

  }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('BulletinShowDlgCtrl', BulletinShowDlgCtrl);

    /** @ngInject */
    function BulletinShowDlgCtrl($rootScope, $scope, $sce, dialogs, $uibModalInstance, C, Auth,
                                 ArrayHelper, FileHelper, PrintHelper, Dlg,
                                 SaveAs, toaster, Bulletin, data, $state) {
        function initData() {
            $scope.approval = data.approval;
            $scope.checkRead = false;

            Bulletin.get({id: data.id}, function (resp) {
                var bulletin = resp;
                $scope.article = {
                    id: bulletin.id,
                    sender: bulletin.sender,
                    release_time: bulletin.release_time,
                    title: bulletin.title,
                    dept: bulletin.dept,
                    body: bulletin.body,
                    attachment: bulletin.attachments,
                    recipient: bulletin.recipient,
                    public: bulletin.public,
                    start: bulletin.start
                };
                $scope.article.body_sce = $sce.trustAsHtml(bulletin.body);
                // 期望查看是否已读的阅读人
                if (resp.recipients && resp.recipients.length > 0) {
                    var partIn = [], notPartIn = [];
                    angular.forEach(resp.recipients, function (r) {
                        if (r.is_read) {
                            partIn.push(r);
                        } else {
                            notPartIn.push(r);
                        }
                    });
                    $scope.article.partIn = partIn;
                    $scope.article.notPartIn = notPartIn;
                    $scope.article.recipients = resp.recipients;
                    $scope.article.canSendWxRemind = Auth.getAccount().id == resp.sender_id; // 暂时只允许发布人微信提醒
                }
                if (!bulletin.recipient || (!bulletin.recipient.is_read && !bulletin.recipient.is_read_observer)) {
                    var params = {};
                    params['opt'] = 1;
                    params['bulletin_id'] = bulletin.id;
                    params['start'] = bulletin.start;
                    Bulletin.collect(params).$promise.then(function () {
                        $rootScope.$broadcast('ReadBulletin', {id: bulletin.id});
                    });
                }

                if (!bulletin.recipient.is_read && bulletin.recipient.is_read_observer) {
                    dialogs.notify("提示", "请在阅读后<strong class='text-red'>勾选知晓同意</strong>再关闭!!");
                }
            });
        }

        if (data.id === 0) {
            var preview = data.preview;
            $scope.article = {
                title: preview.title,
                body_sce: $sce.trustAsHtml(preview.body),
                dept: preview.dept.name,
                sender: Auth.getAccount()
            }
        }

        $scope.sendWxRemind = function (bulletin) {
            return Bulletin.collect({opt: 4 /*  微信通知未读员工*/, bulletin_id: bulletin.id}).$promise.then(function () {
                Dlg.i("提醒成功");
            }, function (err) {
                if (err.status === 429) {
                    Dlg.error(err.data.msg);
                }
            });
        };

        $scope.collect = function (article) {
            var params = {};
            params['opt'] = 2;
            params['bulletin_id'] = article.id;
            Bulletin.collect(params).$promise.then(function (data) {
                article.recipient = {};
                article.recipient['is_collect'] = 1;
                $rootScope.$broadcast('Collect');
                toaster.success('已收藏!');
            });
        };

        $scope.cancel_collect = function (article) {
            var params = {};
            params['opt'] = 3;
            params['bulletin_id'] = article.id;
            Bulletin.collect(params).$promise.then(function () {
                article.recipient.is_collect = 0;
                $rootScope.$broadcast('CancelCollect');
                toaster.success('已取消收藏!');
            });
        };

        initData();

        $scope.back = function (article) {
            dialogs.create('templates/article/back.html', 'BulletinBackDlgCtrl', {
                stage: 4
            }, {
                size: 'xs'
            }).result.then(function (params) {
                Bulletin.update({id: article.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('bulletinBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            })
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.BULLETIN_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.print = function (article) {

            PrintHelper.print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">发布科室:' + article.dept + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        };

        $scope.cancel = function (article) {
            if (article.recipient && !article.recipient.is_read && article.recipient.is_read_observer) {
                if (!$scope.checkRead) {
                    toaster.error('请勾选知晓同意!');
                } else {
                    var params = {};
                    params['opt'] = 1;
                    params['bulletin_id'] = article.id;
                    params['start'] = article.start;
                    Bulletin.collect(params).$promise.then(function () {
                        $rootScope.$broadcast('ReadBulletin', {id: article.id});
                        $uibModalInstance.dismiss('cancel');
                    });
                }
            } else {
                $uibModalInstance.dismiss('cancel');
            }
        };

        $scope.applyMission = function (m) {
            $state.go('app.coop_mission', {
                data: {
                    tab: 'apply',
                    event: 'missionApplyByArticle',
                    content: m
                }
            });
        };
    }

})();

angular.module('c.c')
    .controller('CarFillCtrl', function ($scope, $uibModalInstance, dialogs, toaster, NgTableParams, C, F, $filter, CApply) {

        $scope.cols = [
            {title: '车型', show: true},
            {title: '申请人', show: true},
            {title: '出发时间', show: true},
            {title: '返程时间', show: true},
            {title: '目的地', show: true},
            {title: '更多', show: true}
        ];

        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'asc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 10;
                CApply.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.records);
                });
            }
        });

        //出发前里程填写
        $scope.pre_fill = function (record) {
            dialogs.create('templates/basic/float_dlg.html', 'FloatDlgCtrl', {
                title: '出车里程填写',
                icon: 'reply',
                label: '出发里程',
                label_time: '修改出发时间'
            }, {

                size: 'md'
            }).result.then(function (pa) {
                    var params = {};
                    params['pre_mile'] = pa.mile;
                    params['change_time'] = pa.change_time == true ? 1 : 0;
                    params['status'] = 7;
                    CApply.update({id: record.id}, params).$promise.then(function () {
                        toaster.success('出发里程填写成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('出发里程填写失败!');
                    })
                });
        };

        //回程里程填写
        $scope.later_fill = function (record) {
            dialogs.create('templates/basic/float_dlg.html', 'FloatDlgCtrl', {
                title: '派车里程填写',
                icon: 'reply',
                label: '回程里程',
                label_time: '修改回程时间'
            }, {

                size: 'md'
            }).result.then(function (pa) {
                    var params = {};
                    params['later_mile'] = pa.mile;
                    params['change_time'] = pa.change_time == true ? 1 : 0;
                    params['status'] = 8;
                    if (pa.mile <= record.pre_mile) {
                        toaster.warning('回程数不能低于或等于出程数,请重新填写!');
                    } else if (pa.mile - record.pre_mile > 1000) {
                        toaster.warning('回程数与出程数相差过大,请确认后重新填写!');
                    } else {
                        CApply.update({id: record.id}, params).$promise.then(function () {
                            toaster.success('回程里程填写成功!');
                            $scope.tableParams.reload();
                        }, function () {
                            toaster.error('回程里程填写失败!');
                        })
                    }
                });
        };

        $scope.cancel = $uibModalInstance.dismiss;
    });
angular.module('c.c').controller('ContactGroupMembersCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs, Table,
              toaster, F, ContactGroup, data) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.group = data.group;

        $scope.cols = [
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', show: true}, //0
            {title: '工号', filter: {'users.username': 'text'}, field: 'username', width: '30%', show: true}, //0
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
        ];
        $scope.optColWidth = 70;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['id'] = data.group.id;
                ContactGroup.index_members(url, function (resp) {
                    params.total(resp.total);
                    var members = [];
                    angular.forEach(resp.members, function (m) {
                        members.push({id: m.member_id});
                    });
                    $scope.members_ids = members;
                    $defer.resolve(resp.members);
                    $scope.members = resp.members;
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        Table.loadMultiSelectedFn($scope);

        $scope.add = function () {
            dialogs.create('directives/form/user-selector/user_selector_dlg.html', 'UserSelectCtrl',
                {
                    title: '添加' + data.group.name + '成员', multiSelect: true, existMembers: $scope.members_ids
                }, {

                    size: 'md'
                }).result.then(function (params) {
                if (params.length > 0) {
                    var members_ids = [];
                    angular.forEach(params, function (m) {
                        members_ids.push(m.id)
                    });
                    ContactGroup.attach_members({id: data.group.id}, {members: members_ids}).$promise.then(function (resp) {
                        toaster.success('添加成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('添加失败!');
                    });
                }
            });
        };

        $scope.delete = function (m) {
            dialogs.confirm('移除成员', '确定要移除成员吗?')
                .result.then(function () {
                var members = [];
                if (angular.isArray(m)) {
                    angular.forEach(m, function (member) {
                        if (member.is_checked) {
                            members.push(member.member_id);
                        }
                    });
                } else {
                    members.push(m.member_id);
                }
                ContactGroup.detach_members({id: data.group.id}, {members: members}).$promise.then(
                    function () {
                        toaster.success('移除成功!');
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('移除失败!');
                    }
                );
            });
        };

        $scope.setStop = function (m, stop) {
            ContactGroup.set_member_stop({id: m.id, is_stop: stop}).$promise.then(function () {
                m.is_stop = stop ? '1' : '0';
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('DeptRecordDlgCtrl', function ($scope, $uibModalInstance, dialogs, toaster, NgTableParams, F,
                                               UserDept, data) {

        $scope.user = data.user;
        $scope.cols = [
            {title: '科室名称', field: 'name', show: true}, //0
            {title: '科室内职务', field: 'post', show: true}, //6
            {title: '是否主科室', field: 'is_main', show: true}, //6
            {title: '进入时间', field: 'entry_time', sortable: 'entry_time', show: true}, //6
            {title: '离开时间', field: 'leave_time', sortable: 'leave_time', show: true}, //6
        ];
        $scope.hideFilter = true;
        // if (data.hideOpt) {
        $scope.hideOpt = true;
        // } else {
        //     $scope.optColWidth = 56;
        // }

        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {entry_time: 'desc'}}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;  //INDEX_DEPTS_IN_MEMBER
                url['user_id'] = $scope.user.id;
                UserDept.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.depts, function (m) {
                        m.is_main = m.is_main == '1';
                    });
                    $defer.resolve(resp.depts);
                });
            }
        });

        $scope.delete = function (dept) {
            dialogs.confirm('删除科室记录', '确定要删除<strong>' + dept.name + '</strong>的科室记录吗?')
                .result.then(function () {
                UserDept.delete({id: dept.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('科室记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('这是员工当前所在的主科室记录,无法直接删除');
                            break;
                    }
                    $scope.tableReload();
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('科室记录删除失败!');
                });
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c').controller('ExportScheduleCtrl', ExportScheduleCtrl);

    /** @ngInject */
    function ExportScheduleCtrl($scope, $uibModalInstance, $filter, toaster, C, DateHelper, FileHelper, SaveAs, data) {
        $scope.s = {type: 1, start: data.start, end: data.end};
        $scope.group_name = data.group.name;

        $scope.ok = function (s) {
            if ($scope.s_form.$valid) {
                if (s.type > 2 && DateHelper.diffInDays(s.start, s.end) > 30 && s.type != 5) {
                    toaster.warning('导出全院值班时,日期范围不能超过30天!');
                    return;
                } else if (s.start > s.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                params['type'] = s.type;
                params['group_id'] = (s.type < 3 || s.type == 5) ? data.group.id : 0;
                params['start'] = $filter('date')(s.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(s.end, 'yyyy-MM-dd');
                s.downloading = true;
                FileHelper.download(C.URL.SCHEDULES_DOWNLOAD, params, function (resp) {
                    s.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = params['start'] + '到' + params['end'];
                    switch (s.type) {
                        case 1:
                        case 2:
                            filename += '排班情况.xls';
                            break;
                        case 3:
                            filename += '全院值班情况.xls';
                            break;
                        case 4:
                            filename += '全院排班情况.xls';
                            break;
                        case 5:
                            filename += '排班类型统计.xls';
                            break;
                    }
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function (error) {
                    s.downloading = false;
                    toaster.error('导出失败!');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

angular.module('c.c')
    .controller('LeaveUserListCtrl', function ($scope, dialogs, $filter, toaster, NgTableParams, F, AskForLeave) {
        $scope.cols = [
            {title: '工号', filter: {'users.username': 'text'}, show: true},
            {title: '姓名', filter: {'users.name': 'text'}, show: true},
            {title: '科室', filter: {'depts.name': 'text'}, show: true, width: '25%'},
            {title: '临时负责人', width: '110', show: true},
            {title: '类型', filter: {'leave_type_id': 'select'}, show: true},
            {title: '起止时间', show: true}
        ];

        $scope.leave_type_col = $scope.cols[3];
        $scope.dt = new Date();
        $scope.prevDay = function (curr) {
            $scope.dt = new Date(curr.setDate(curr.getDate() - 1));
        };
        $scope.nextDay = function (curr) {
            $scope.dt = new Date(curr.setDate(curr.getDate() + 1));
        };

        $scope.$watch('dt', function (newVal, oldVal, scope) {
            scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        }, true);

        $scope.hideOpt = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                'created_at': 'asc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 22;
                url['time'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                AskForLeave.query(url, function (resp) {
                    $scope.leave_types = resp.leave_types;
                    $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                    params.total(resp.total);
                    $defer.resolve(resp.records);
                });
            }
        });
      $scope.tableParams.filter()['is_hospital_leader'] = true;
      $scope.tableParams.filter()['is_dept_leader'] = true;
    });

angular.module('c.c')
    .controller('DutyUserListCtrl', function ($scope, dialogs, $filter, toaster, NgTableParams, OS, WxHelper,
                                              deviceDetector, C, F, Schedule) {
        // var isWx = WxHelper.isWechatBrowser();
        $scope.cols = [
            {title: '姓名', filter: {'users.name': 'text'}, show: true},
            {title: '工号', filter: {'username': 'text'}, show: true},
            {title: '值班组', filter: {'duty_groups.name': 'text'}, show: true},
            {title: '值班班次', show: true}
        ];

        $scope.dt = new Date();
        $scope.prevDay = function (curr) {
            $scope.dt = new Date(curr.setDate(curr.getDate() - 1));
        };
        $scope.nextDay = function (curr) {
            $scope.dt = new Date(curr.setDate(curr.getDate() + 1));
        };

        $scope.$watch('dt', function (newVal, oldVal, scope) {
            scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        }, true);

        $scope.hideOpt = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                'created_at': 'asc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.SCHEDULE.INDEX.DUTY_MEMBERS;
                url['day'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                Schedule.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.members);
                });
            }
        });

        $scope.getCallUrl = function (phone) {
            var index = phone.indexOf('转');
            var temp = phone;
            if (index !== -1) {
                temp = phone.slice(0, index);
            }
            // if (isWx && deviceDetector.os !== OS.IOS) return url + '#weixin.qq.com';
            return 'tel:' + temp;
        }
    });

angular.module('c.c')
    .controller('RoundUserListCtrl', function ($scope, dialogs, $filter, toaster, DateHelper, NgTableParams, C, F, Round) {
        var roundState = F.get('test_stages');
        var ngRoundState = F.getNgTableOpts(roundState);
        $scope.cols = [
            {title: '工号', filter: {username: 'text'}, show: true, width: '15%'},
            {title: '姓名', filter: {name: 'text'}, show: true, width: '15%'},
            {title: '轮转科室', filter: {dept: 'text'}, show: true, width: '25%'},
            {title: '轮转时间', filter: {work_time: 'date_range'}, show: true, width: '30%'},
            {title: '轮转状态', filter: {day_state: 'select'}, show: true, data: ngRoundState, width: '15%'}
        ];

        $scope.dt = new Date();
        $scope.prevDay = function (curr) {
            $scope.dt = new Date(curr.setDate(curr.getDate() - 1));
        };
        $scope.nextDay = function (curr) {
            $scope.dt = new Date(curr.setDate(curr.getDate() + 1));
        };

        $scope.$watch('dt', function (newVal, oldVal, scope) {
            scope.tableParams.$params.page = 1;
            $scope.clearFilters();
            $scope.tableParams.reload();
        }, true);

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.init = function (is_nurse) {
            $scope.hideOpt = true;
            $scope.tableParams = new NgTableParams({
                page: 1, count: 10, sorting: {
                    'created_at': 'asc'
                }
            }, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = 3;
                    url['day'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                    url['is_nurse'] = is_nurse;
                    if ($scope.dateRangeFilter.work_time != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.work_time.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.work_time.endDate, 'yyyy-MM-dd');
                    }
                    Round.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.users, function (user) {
                            var entry_time = DateHelper.str2Datetime(user.entry_time);
                            var leave_time = user.leave_time == null ? null : DateHelper.str2Datetime(user.leave_time);
                            user.day_state = roundState[0];
                            if ($scope.dt > entry_time) {
                                if (leave_time != null && $scope.dt > leave_time) {
                                    user.day_state = roundState[2];
                                } else {
                                    user.day_state = roundState[1];
                                }
                            }
                            user.time_range = user.entry_time.substr(0, 16) + ' - ';
                            if (leave_time == null) {
                                user.time_range += '以后';
                            } else {
                                user.time_range += user.leave_time.substr(0, 16);
                            }
                        });
                        $defer.resolve(resp.users);
                    });
                }
            });
        }
    });

angular.module('c.c')
    .controller('PracticeUserListCtrl', function ($scope, dialogs, $filter, toaster,
                                                  NgTableParams, C, F, DateHelper, Practice) {
            var roundState = F.get('test_stages');
            var ngRoundState = F.getNgTableOpts(roundState);
            $scope.cols = [
                {title: '姓名', filter: {name: 'text'}, show: true, width: '15%'},
                {title: '实习科室', filter: {dept: 'text'}, show: true, width: '25%'},
                {title: '带教老师', filter: {teacher: 'text'}, show: true, width: '15%'},
                {title: '实习时间', filter: {work_time: 'date_range'}, show: true, width: '30%'},
            ];

            $scope.dt = new Date();
            $scope.prevDay = function (curr) {
                $scope.dt = new Date(curr.setDate(curr.getDate() - 1));
            };
            $scope.nextDay = function (curr) {
                $scope.dt = new Date(curr.setDate(curr.getDate() + 1));
            };

            $scope.$watch('dt', function (newVal, oldVal, scope) {
                scope.tableParams.$params.page = 1;
                $scope.clearFilters();
                $scope.tableParams.reload();
            }, true);

            $scope.clearFilters = function () {
                $scope.tableParams.filter({});
                $scope.dateRangeFilter = {};
            };

            $scope.dateRangeFilter = {};
            $scope.$watch('dateRangeFilter',
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true);

            $scope.init = function (is_nurse) {
                $scope.hideOpt = true;
                $scope.tableParams = new NgTableParams({
                    page: 1, count: 10, sorting: {
                        'created_at': 'asc'
                    }
                }, {
                    counts: [10, 30, 50], total: 0,
                    getData: function ($defer, params) {
                        var url = params.url();
                        url['opt'] = 4;
                        url['day'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                        url['is_nurse'] = is_nurse;
                        if ($scope.dateRangeFilter.work_time != null) {
                            url['startDate'] = $filter('date')($scope.dateRangeFilter.work_time.startDate, 'yyyy-MM-dd');
                            url['endDate'] = $filter('date')($scope.dateRangeFilter.work_time.endDate, 'yyyy-MM-dd');
                        }
                        Practice.query(url, function (resp) {
                            params.total(resp.total);
                            angular.forEach(resp.users, function (user) {
                                var entry_time = DateHelper.str2Datetime(user.entry_time);
                                var leave_time = user.leave_time == null ? null : DateHelper.str2Datetime(user.leave_time);
                                user.day_state = roundState[0];
                                if ($scope.dt > entry_time) {
                                    if (leave_time != null && $scope.dt > leave_time) {
                                        user.day_state = roundState[2];
                                    } else {
                                        user.day_state = roundState[1];
                                    }
                                }
                                user.time_range = user.entry_time.substr(0, 16) + ' - ';
                                if (leave_time == null) {
                                    user.time_range += '以后';
                                } else {
                                    user.time_range += user.leave_time.substr(0, 16);
                                }
                            });
                            $defer.resolve(resp.users);
                        });
                    }
                });
            }
        }
    )
;

angular.module('c.c').controller('NewsMainShowDlgCtrl',
    function ($scope, $sce, $uibModalInstance, C, F, FileHelper, Auth, SaveAs, toaster, $http, data, PrintHelper) {
        $scope.isNews = true;

        $http.get('/api/v1/news/news/' + data.id ).success(function (resp) {
            $scope.article = resp;
            $scope.article.body_sce = $sce.trustAsHtml(resp.body);
        });
        // News.get({id: data.id}, function (resp) {
        //     $scope.article = resp;
        //     $scope.article.body_sce = $sce.trustAsHtml(resp.body);
        // });


        if (data.id === 0) {
            var preview = data.preview;
            $scope.article = {
                title: preview.title,
                body_sce: $sce.trustAsHtml(preview.body),
                dept: preview.dept.name,
                sender: Auth.getAccount()
            }
        }

        $scope.print = function (article) {

            PrintHelper.print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">新闻类型：' + article.type + '&nbsp;&nbsp;&nbsp;发布科室:'
                    + article.dept + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.NEWS_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function () {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };
    });
angular.module('c.c').controller('opDateSsDlgCtrl', function ($scope, $uibModalInstance) {
    $scope.cancel = $uibModalInstance.dismiss;
});
(function () {
    'use strict';

    angular.module('c.s')
        .controller('OperationRecordDlgCtrl', OperationRecordDlgCtrl)
    ;

    /** @ngInject */
    function OperationRecordDlgCtrl($scope, OperationImport, Table, $uibModalInstance) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            var options = {
                service: OperationImport,
                params: {op: 'all'},
                optInFront: true,
                // optColWidth: Table._2_BTN,
                showSn: true,
                hideOpt: true,
                cols: [
                    {
                        field: "dept",
                        title: '科室',
                        filter: {dept: 'text'}
                    },
                    {field: "violation",title: '违反规则', filter: {violation: 'text'}},
                    {field: "type",title: '违规类型', filter: {type: 'text'}},
                    {field: "subject",title: '违规项目', filter: {subject: 'text'}},
                    {field: "reason",title: '原因', filter: {reason: 'text'}},
                    {field: "according",title: '依据', filter: {according: 'text'}},
                    {field: "date",title: '规范落实日期', filter: {date: 'date_range'}},
                    {field: "measure",title: '整改措施', filter: {measure: 'text'}},
                    {field: "one_later_question",title: '第1月后质控出现问题', filter: {one_later_question: 'text'}},
                    {field: "two_later_question",title: '第2月后质控出现问题', filter: {two_later_question: 'text'}},
                    {field: "three_later_question",title: '第3月后质控出现问题', filter: {three_later_question: 'text'}},
                    {field: "important_time",title: '考察期后仍未整改例数', filter: {important_time: 'text'}},
                    {field: "punishment",title: '处理措施', filter: {punishment: 'text'}},
                    {field: "result",title: '整改效果', filter: {result: 'text'}}
                ]
            };

            Table.load(vm, options);
        }
    }
})();

angular.module('c.c').controller('RichEditDlgCtrl', function ($scope, $uibModalInstance, data) {
    $scope.body = data.body;
    $scope.ok = function (body) {
        $uibModalInstance.close(body);
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c.c').controller('RushParkDlgCtrl',
    function RushParkDlgCtrl($scope, $uibModalInstance, toaster, data) {
        var vm = $scope;
        vm.add = data.add;
        vm.edit = data.edit;
        vm.changeNum = false;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            var park = data.park;
            if (park) {
                vm.park = {'plate_num': park.plate_num,'plate_num2': park.plate_num2, 'rush': park.rush == '1', chaneg_reason: '新购车辆'}
            } else {
                vm.park = {};
            }
        }

        function ok(park) {
            if (vm.rush_form.$valid) {
                var params = {};
                if (vm.edit) {
                    params['plate_num'] = park.plate_num;
                    if(park.plate_num2&&park.plate_num2!=''){
                        params['plate_num2'] = park.plate_num2;
                    }
                    params['chaneg_reason'] = park.chaneg_reason ? park.chaneg_reason : undefined;
                }
                params['rush'] = park.rush == true ? '1' : '0';
                if (vm.add) {
                    params['plate_num'] = park.plate_num;
                    params['user_id'] = park.user.id;
                    params['confirm'] = '1';
                    if(park.plate_num2&&park.plate_num2!=''){
                        params['plate_num2'] = park.plate_num2;
                    }
                }
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                vm.rush_form.submitted = true;
            }
        }
    });
angular.module('c.c').controller('SimpleDlgCtrl', function ($scope, $uibModalInstance) {
    $scope.cancel = $uibModalInstance.dismiss;
});
angular.module('c.c').controller('SmsShowDlgCtrl',
    function ($scope, $uibModalInstance, data) {
        $scope.sms = data.sms;

        $scope.edit = function (sms) {
            var params = {opt: 5, sms: sms};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserLevelDlgCtrl', UserLevelDlgCtrl);

    /** @ngInject */
    function UserLevelDlgCtrl($uibModalInstance, ArrayHelper, Dlg, User, JobTitle, data) {
        var vm = this;
        vm.ok = ok;
        vm.close = $uibModalInstance.close;
        vm.titleTypes = JobTitle.getTypes();
        vm.titleLevels = JobTitle.getLevels();
        vm.titleTypeSelected = titleTypeSelected;
        var required = {
            titleLv: true, title: true
        };


        init(data.id);


        function init(id) {
            vm.cfg = {
                required: required
            };

            JobTitle.query({op: 'option'}, function (resp) {
                vm.titles = resp.items;
                vm.m = {
                    id: id
                }
            })

        }

        function titleTypeSelected(m) {
            if (m.title_type) {
                var fTitles = ArrayHelper.filter(vm.titles, function (title) {
                    return title.type === m.title_type.id;
                });
                if (!m.title || m.title.type !== m.title_type.id) m.title = fTitles[0];
                vm.fTitles = fTitles;
            }
        }


        function ok(m) {
            return Dlg.addEditOk(vm, User, function () {
                return {
                    opt: 1,
                    title_id: m.title.id,
                    level: m.title_level.id
                };
            });
        }
    }

})();

angular.module('c.c')
    .controller('UserEditCtrl',
        function ($scope, $uibModalInstance, $http, $filter, uibDateParser, F, dialogs, toaster, User, NurseSeniority,
                  SeniorityStandard, Major, JobTitle, data, ArrayHelper) {
            if (data.sys_edit) {
                $scope.reg_stage = true;
                $scope.dept_disable = true;
                $scope.on_type_disable = true;
                $scope.password_not_req = true;
            } else {
                $scope.confirm_stage = true;
            }
            $scope.sexes = F.get('sexes');
            $scope.edu_bgs = F.get('edu_bg_list');
            $scope.degree_types = F.get('degree_types');
            $scope.en_lvs = F.get('eg_lv_list');
            $scope.titles = F.get('titles');
            $scope.posts = F.get('posts');
            $scope.jobTypes = User.getJobTypes();
            $scope.titleLeaves = User.getTitleLevel();
            $scope.titleTypes = JobTitle.getTypes();

            var username_regex_list = [
                /^\d{4,5}$/,  //正式员工
                /^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[1235789])\d{8}$/,  //试用实习均使用手机号注册
            ];
            $scope.username_regex = username_regex_list[0];

            Major.query({opt: 1}, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                $scope.majors = types;
            });

            User.get({id: data.user_id, info_type: 0}, function (resp) {
                var user = resp.user;
                $scope.titles = resp.titles;
                $scope.types = resp.types;
                $scope.statuses = resp.statuses;
                $scope.standards = resp.standards;
                $scope.performances = resp.performances;
                //暂时去掉 实习和试用
                //$scope.statuses.splice(2, 2);

                $scope.entry_types = resp.entry_types;
                $scope.nations = resp.nations;
                $scope.political_statuses = resp.political_statuses;
                $scope.depts = resp.depts;

                user['is_cadre'] = user['is_cadre'] == '1';
                user['sex'] = F.getItem(user['sex'], $scope.sexes);
                user['edu_bg'] = F.getItem(user['edu_bg'], $scope.edu_bgs);
                user['degree_type'] = User.getDegreeType(user['degree']);
                $scope.degrees = User.getDegrees(user['degree_type'].id);
                user['degree'] = User.getDegree(user['degree'], user['degree_type'].id);
                user['en_lv'] = F.getItem(user['en_lv'], $scope.en_lvs);
                //user['title'] = F.getItem(user['title'], $scope.titles);
                user['post'] = F.getItem(user['post'], $scope.posts);

                if (user['level']) {
                    user['level'] = F.getItem(user['level'], $scope.titleLeaves);
                }

                if (user['job_type']) {
                    user['job_type'] = F.getItem(user['job_type'], $scope.jobTypes);
                }

                user['birthday'] = uibDateParser.parse(user.birthday, 'yyyy-MM-dd');
                user['entry_time'] = uibDateParser.parse(user.entry_time, 'yyyy-MM-dd');
                user['started_work'] = uibDateParser.parse(user.started_work, 'yyyy-MM-dd');

                user['graduate_time'] = uibDateParser.parse(user.graduate_time, 'yyyy-MM-dd');
                user['post_time'] = uibDateParser.parse(user.post_time, 'yyyy-MM-dd');
                user['title_time'] = uibDateParser.parse(user.title_time, 'yyyy-MM-dd');
                user['majorS'] = user.majorS;

                if (user['type_id'] == 2 && user['nurse_seniority']) {
                    user['standard'] = F.getItem(user['nurse_seniority'].seniority_id, $scope.standards);
                } else {
                    user['standard'] = $scope.standards[0];
                }

                if (user.depts.length > 0) {
                    user.dept = {id: user.depts[0].id, name: user.depts[0].name};
                } else {
                    user.dept = $scope.depts[0];
                }
                if (data.confirm_state) {
                    user['confirm_state'] = data.confirm_state;
                }
                $scope.statusSelectedFn(user.status, user);
                if (user.dept.name == '实习医生' || user.dept.name == '实习护士') {
                    $scope.practice_stage = true;
                }

                if (user.title) {
                    user.title_type = ArrayHelper.getItem(user.title.type, $scope.titleTypes);
                    $scope.titleTypeSelected(user);
                }
                $scope.user = user;
            });

            $scope.titleTypeSelected = function (m) {
                if (m.title_type) {
                    var fTitles = ArrayHelper.filter($scope.titles, function (title) {
                        return title.type === m.title_type.id;
                    });
                    if (!m.title || m.title.type !== m.title_type.id) m.title = fTitles[0];
                    $scope.fTitles = fTitles;
                }
            };

            $scope.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1)
            };

            $scope.degreeTypeSelectedFn = function (type) {
                $scope.degrees = User.getDegrees(type.id);
                $scope.user['degree'] = $scope.degrees[0];
            };

            $scope.statusSelectedFn = function (status, user) {
                if (status.id == 3 || status.id == 4 || status.id == 6 || status.id == 8 || status.id == 11) { //试用
                    $scope.username_regex = username_regex_list[1];
                } else {
                    $scope.username_regex = username_regex_list[0];
                }
            };

            $scope.deptTypeFn = function (d) {
                return d.type.name;
            };

            $scope.onTypeSelectedFn = function (type, user) {

            };

            $scope.addUserPhoto = function (user) {
                dialogs.create('templates/upload/userpic_dlg.html',
                    'UploadUserpicDlg', {user_id: user.id}, {size: 'md'}
                ).result.then(function (resp) {
                    user.photo = resp;
                });
            };

            function saveAndExit(user) {

                var pa = {};
                //账户信息
                pa['username'] = user.username;
                if (user.password && user.password.length > 0) {
                    pa['password'] = user.password;
                }

                //基本信息
                pa['name'] = user.name;
                // pa['idcard'] = user.idcard;
                pa['social_insurance'] = user.social_insurance;
                if (user.idcard) {
                    var len = user.idcard.length - 1;
                    if (user.idcard[len] === 'x') {
                        pa['idcard'] = user.idcard.substr(0, len) + 'X';
                    } else {
                        pa['idcard'] = user.idcard;
                    }
                }
                pa['sex'] = user.sex.id;
                pa['birthday'] = $filter('date')(user.birthday, 'yyyy-MM-dd');
                pa['nation_id'] = user.nation.id;
                pa['native_place'] = user.native_place;
                pa['level'] = user.level.id;
                pa['job_type'] = user.job_type.id;

                //工作相关
                pa['photo'] = user.photo;
                pa['status_id'] = user.status.id;
                pa['type_id'] = user.type.id;
                if (user.type.id == 2) {
                    pa['standard'] = user.standard.id;
                }
                //  主要科室...
                //pa['dept_id'] = user.dept.id;
                pa['is_cadre'] = user.is_cadre;
                pa['entry_type_id'] = user.entry_type.id;
                pa['entry_time'] = $filter('date')(user.entry_time, 'yyyy-MM-dd');
                //pa['salary_card'] = user.salary_card;
                pa['started_work'] = $filter('date')(user.started_work, 'yyyy-MM-dd');

                //教育背景
                pa['graduate_school'] = user.graduate_school;
                pa['graduate_time'] = $filter('date')(user.graduate_time, 'yyyy-MM-dd');
                pa['major'] = user.major;
                pa['edu_bg'] = user.edu_bg.id;
                pa['degree'] = user.degree.name;
                pa['en_lv'] = user.en_lv.id;
                //联系方式
                pa['phone'] = user.phone;
                pa['cornet'] = user.cornet;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                pa['office_cornet'] = user.office_cornet;
                pa['email'] = user.email;
                pa['qq'] = user.qq;
                pa['address'] = user.address;
                pa['comments'] = user.comments;

                pa['confirm_state'] = user.confirm_state;
                pa['post_time'] = $filter('date')(user.post_time, 'yyyy-MM-dd');
                pa['title_time'] = $filter('date')(user.title_time, 'yyyy-MM-dd');
                if (user.major_s) {
                    pa['major_id'] = user.major_s.id;
                }
                if (user.title) {
                    pa['title_id'] = user.title.id;
                }
                if (user.post) {
                    pa['post'] = user.post.id;
                }
                if (user.political_status) {
                    pa['political_status_id'] = user.political_status.id;
                }

                if (user.performance) {
                    pa['performance_id'] = user.performance.id;
                }
                pa['opt'] = 1;

                User.update({id: data.user_id}, pa).$promise.then(function (resp) {
                    $uibModalInstance.close(pa);
                }, function (error) {
                    if (error.data.code == 23000) {
                        var m = error.data.msg;
                        if (m.indexOf('users_username_unique') > 0) {
                            msg = '用户名已被注册!';
                        } else if (m.indexOf('users_phone_unique') > 0) {
                            msg = '手机号已被注册!';
                        } else if (m.indexOf('users_email_unique') > 0) {
                            msg = '邮箱已被注册!';
                            //} else if (m.indexOf('users_id_card_unique') > 0) {
                            //    msg = '身份证号已被注册!';
                        }
                    } else {
                        msg = '员工记录修改失败!';
                    }
                    toaster.error(msg);
                });
            }

            $scope.submit = function (user) {
                if (!$scope.u_form.$valid) {
                    toaster.warning('表单中有错误!');
                    $scope.u_form.$submitted = true;
                } else if (!user.photo) {
                    if (!$scope.practice_stage) {
                        dialogs.confirm('提示', '您未添加工作照头像,这将影响系统某些功能的使用,确定要保存吗?')
                            .result.then(function () {
                            saveAndExit(user);
                        });
                    } else {
                        dialogs.confirm('提示', '您未添加工作照头像,实习用户必须添加工作头像!')
                            .result.then(function () {
                            $scope.addUserPhoto(user);
                        });
                    }
                } else {
                    saveAndExit(user);
                }
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        });

angular.module('c.c')
    .controller('FinanceAirfareCtrl', function () {

    });


angular.module('c.c')
    .controller('FinanceAttendanceCtrl', function ($scope, $filter, dialogs, toaster, FileHelper,
                                                   NgTableParams, AttendanceReport, F, C, SaveAs) {

        var yesOrNo = [{id: '', title: '-'}, {id: '3', title: '是'}, {id: '2', title: '否'}];

        $scope.cols = [
            {title: '月份', sortable: 'month', field: 'month', show: true},
            {
                title: '科室',
                sortable: 'depts.name',
                filter: {'depts.name': 'text'},
                field: 'dept_name',
                show: true
            },
            {title: '考勤总人数', field: 'count_num', show: true},
            {title: '全勤人数', field: 'count_num', show: true},
            {title: '缺勤人数', 'field': 'absence_num', show: true},
            {title: '新入科员工', field: 'new_comer', show: true},
            {title: '请假人数', show: true},
            {title: '人均系数', field: 'stage', show: true},
            {title: '是否确认', filter: {stage: 'select'}, field: 'stage', data: yesOrNo, show: true},
            {title: '月份', field: 'month', filter: {month: 'text'}, show: false}//6
        ];
        $scope.optColWidth = 70;
        $scope.dept_col = $scope.cols[1];

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.first = true;       //第一次监控时间的变化，则不重新查询
        var date = new Date((new Date()).setDate(1));
        var month = date.getMonth();
        $scope.dts = new Date(date.setMonth(month - 1));
        $scope.dte = new Date(date.getFullYear(), month, 0);
        $scope.temp_month = new Date((new Date((new Date()).setDate(1))).setMonth(month - 1));
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dts = new Date(curr.setMonth(prev));
            $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
            $scope.temp_month = new Date(curr.setMonth(prev));
            $scope.first = false;
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dts = new Date(curr.setMonth(next));
            $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
            $scope.temp_month = new Date(curr.setMonth(next));
            $scope.first = false;
        };

        $scope.can_opt = false;   //与人事科拥有共同的界面，是否有退回功能

        $scope.$watch('dts', function (newVal, oldVal, scope) {
            if (!$scope.first) {
                $scope.tableReload();
            }
        }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                var filter = params.filter();
                if ($scope.numRangeFilter.bonus_count) {
                    url['bonus_count_start'] = $scope.numRangeFilter.bonus_count.start;
                    url['bonus_count_end'] = $scope.numRangeFilter.bonus_count.end;
                }

                filter['month'] = $filter('date')($scope.temp_month, 'yyyy-MM-dd');
                url['filter'] = filter;
                url['opt'] = 2;   //财务科与人事科有相同的界面，只是财务科不能操作
                $scope.month = {
                    startDate: $filter('date')($scope.temp_month, 'yyyy-MM-dd'),
                    endDate: $filter('date')($scope.dte, 'yyyy-MM-dd')
                };
                AttendanceReport.query(url, function (resp) {
                    $scope.dept_col.data = F.getNgTableOpts(resp.depts);
                    params.total(resp.total);
                    $scope.no_declare = resp.no_declare;
                    $scope.reports = resp.records;
                    $defer.resolve(resp.records);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
            $scope.first = false;
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.tableParams.filter({});
        };


        $scope.member = function (report) {
            dialogs.create('AttendanceReportMembers.html', 'AttendanceReportMembersCtrl',
                {report: report, month: $filter('date')($scope.month, 'yyyy-MM-dd')}, {
                     size: 'lg'
                }).result.then(function () {
                    $scope.tableReload();
                });
        };

        $scope.export = function () {
            var params = {};
            params['month'] = $filter('date')($scope.dts, 'yyyy-MM-dd');
            FileHelper.download(C.URL.ATTENDANCE_EXPORT, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = $filter('date')($scope.dts, 'yyyy年MM月') + '考勤绩效统计情况.xls';
                SaveAs.download(data, filename, options);
            }, function () {
                toaster.error('导出失败!');
            });
        };


    });
angular.module('c.c')
    .controller('CashBalanceCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, UCashBalance, C, Table) {
        var vm = $scope;
        vm.add = add;
        init();

        function init() {
            var options = {
                service: UCashBalance,
                params: {opt: 1},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                showSn: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "dept", title: "科室"},
                    {field: "rent_fee", title: "住房"},
                    {field: "park_fee", title: "停车"},
                    {field: "money", title: "金额"},
                    {field: "balance", title: "余额"},
                    {field: "created_at", title: "充值时间", filter: {created_at: "date_range"}},
                    {field: "handler_id", title: "充值人", filter: {handler_id: "text"}}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('CashBalanceDlg.html', 'CashBalanceDlgCtrl', {}, { size: 'md'})
                .result.then(function (cash) {
                    UCashBalance.save(cash).$promise.then(function () {
                        toaster.success('保存成功');
                        vm.tableReload();
                    });
                });
        }


    });

angular.module('c.c').controller('CashBalanceDlgCtrl',
    function ($scope, $uibModalInstance, toaster) {

        var vm = $scope;
        vm.ok = ok;
        vm.cash = {};
        vm.cancel = $uibModalInstance.dismiss;

        function ok(cash) {
            if (!cash.user) {
                toaster.warning('充值对象必选!');
            } else if (vm.Form.$valid) {
                var pa = {};
                pa['user_id'] = cash.user.id;
                pa['money'] = cash.money;
                pa['remark'] = cash.remark;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });


angular.module('c.c')
    .controller('FinanceDutyFeeApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyReport, F) {

        var yesOrNo = F.getNgTableOpts(F.get('yesNo'));

        $scope.group_types = F.get('dutyGroupTypes');
        var group_types = F.getNgTableOpts($scope.group_types);

        $scope.cols = [
            {title: '值班月份', sortable: 'duty_reports.month', field: 'month', show: true},
            {
                title: '值班组',
                sortable: 'duty_reports.group_id',
                filter: {'duty_groups.name': 'text'},
                field: 'group_name',
                show: true
            },
            {
                title: '类型',
                filter: {type_id: 'select'},
                field: 'type_id',
                data: group_types,
                show: true
            },
            {
                title: '负责人',
                filter: {'users.name': 'text'},
                field: 'leader',
                show: true
            },
            {
                title: '额定总值班人次',
                sortable: 'rated_count',
                filter: {rated_count: 'number_range'},
                field: 'rated_count',
                width: '8%',
                show: true
            }, //6
            {
                title: '实际总值班人次',
                sortable: 'total_count',
                filter: {total_count: 'number_range'},
                field: 'total_count',
                width: '8%',
                show: true
            }, //6
            {
                title: '总值班费用',
                sortable: 'total_fee',
                filter: {total_fee: 'number_range'},
                field: 'total_fee',
                width: '8%',
                show: true
            }, //6
            {title: '是否确认', filter: {is_payed: 'select'}, field: 'is_payed', width: '8%', data: yesOrNo, show: true}, //6
            {title: '发放时间', filter: {pay_time: 'date_range'}, field: 'pay_time', show: true}
        ];
        $scope.optColWidth = 70;
        $scope.groups_col = $scope.cols[1];

        var month = new Date();
        month.setMonth(month.getMonth() - 1);
        $scope.para = {month: month};
        var year = month.getYear();
        $scope.dateRangeFilter = {
            month: {
                startDate: new Date(year + 1900, month.getMonth(), 1),
                endDate: new Date(year + 1900, month.getMonth() + 1, 0)
            }
        };


        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.getReports = function (para) {
            if (para.month) {
                var year = para.month.getYear();
                $scope.dateRangeFilter = {
                    month: {
                        startDate: new Date(year + 1900, para.month.getMonth(), 1),
                        endDate: new Date(year + 1900, para.month.getMonth() + 1, 0)
                    }
                };
            }
        };

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.rated_count) {
                    url['rated_count_start'] = $scope.numRangeFilter.rated_count.start;
                    url['rated_count_end'] = $scope.numRangeFilter.rated_count.end;
                }
                if ($scope.numRangeFilter.total_count) {
                    url['total_count_start'] = $scope.numRangeFilter.total_count.start;
                    url['total_count_end'] = $scope.numRangeFilter.total_count.end;
                }
                url['date_range_filters'] = $scope.dateRangeFilter;
                url['opt'] = 7;
                DutyReport.query(url, function (resp) {
                    $scope.duty_groups = resp.duty_groups;
                    $scope.groups_col.data = F.getNgTableOpts(resp.duty_groups);
                    params.total(resp.total);
                    $scope.reports = resp.records;
                    $scope.groups = resp.groups;
                    $defer.resolve(resp.records);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
            $scope.dateRangeFilter = {};
        };

        $scope.confirm = function (report) {
            var para = {};
            para['is_payed'] = 1;
            DutyReport.update({id: report.id}, para).$promise.then(function (resp) {
                toaster.success('值班费发放成功!');
                $scope.tableReload();
            }, function (error) {
                toaster.error('值班费发放失败!');
            });
        };
        $scope.checked = [];
        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (report, reports) {
            if (report.is_checked) {
                $scope.checked.push(report.id);
            } else if (!report.is_checked) {
                $scope.checked = [];
                angular.forEach(reports, function (r) {
                    if (r.is_checked) {
                        $scope.checked.push(r.id);
                    }
                });
            }
        };

        $scope.confirmAll = function () {
            dialogs.confirm('值班费发放', '确定要发放值班费吗?')
                .result.then(function () {
                if ($scope.checked.length == 0) {
                    toaster.warning('未选择,请选择要发放的值班组')
                } else {
                    var para = {};
                    para['is_payed'] = 1;
                    para['ids'] = $scope.checked;
                    DutyReport.update({id: $scope.reports[0].id}, para).$promise.then(function (resp) {
                        toaster.success('值班费发放成功!,请在值班费明细中打印报表');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('值班费发放失败!');
                    });
                }
            });
        };

        $scope.back = function (report) {
            dialogs.confirm('值班费退回', '确定要退回值班费吗?')
                .result.then(function () {
                var para = {};
                para['is_declared'] = false;
                para['is_confirmed'] = false;
                para['is_payed'] = false;
                para['back'] = 1;
                DutyReport.update({id: report.id}, para).$promise.then(function (resp) {
                    if (resp.msg) {
                        toaster.error(resp.msg);
                    } else {
                        toaster.success('值班费退回成功');
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('值班费退回失败!');
                });
            });
        };

    });

angular.module('c.c')
    .controller('FinanceDutyPaidDetailCtrl', function ($scope, $filter, dialogs, toaster,
                                                       FileHelper, SaveAs, NgTableParams, F, C, PaidDetail) {

        $scope.cols = [
            {title: '姓名', filter: {name: 'text'}, field: 'name', show: true},
            {title: '工牌号', filter: {username: 'text'}, field: 'username', show: true},
            {title: '值班组', filter: {group_name: 'text'}, field: 'group_name', show: true},
            {title: '主科室', filter: {dept: 'text'}, field: 'dept', show: true},
            {title: '工资卡号', filter: {salary_card: 'text'}, field: 'salary_card', show: true},
            {title: '值班月份', field: 'month', show: true},
            {
                title: '值班次数',
                sortable: 'count',
                filter: {count: 'number_range'},
                field: 'count',
                show: true
            }, //6
            {
                title: '值班费标准',
                sortable: 'fee_standard',
                filter: {fee_standard: 'number_range'},
                field: 'fee_standard',
                show: true
            }, //6
            {
                title: '值班费',
                sortable: 'duty_fee',
                filter: {duty_fee: 'number_range'},
                field: 'duty_fee',
                show: true
            },
            {title: '发放时间', field: 'created_at', show: true}
        ];

        $scope.hideOpt = true;
        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.dateRangeFilter = {};

        var month = new Date();
        month.setMonth(month.getMonth() - 1);
        $scope.para = {month: month, groups: [{'id': 0, 'name': '全部'}]};
        var year = month.getYear();
        $scope.dateRangeFilter = {
            month: {
                startDate: new Date(year + 1900, month.getMonth(), 1),
                endDate: new Date(year + 1900, month.getMonth() + 1, 0)
            }
        };

        $scope.filter_groups = '全部';
        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.count) {
                    url['count_start'] = $scope.numRangeFilter.count.start;
                    url['count_end'] = $scope.numRangeFilter.count.end;
                }
                if ($scope.numRangeFilter.fee_standard) {
                    url['fee_standard_start'] = $scope.numRangeFilter.fee_standard.start;
                    url['fee_standard_end'] = $scope.numRangeFilter.fee_standard.end;
                }
                if ($scope.numRangeFilter.fee_standard) {
                    url['duty_fee_start'] = $scope.numRangeFilter.duty_fee.start;
                    url['duty_fee_end'] = $scope.numRangeFilter.duty_fee.end;
                }

                if ($scope.dateRangeFilter.month != null) {
                    var startDate = $filter('date')($scope.dateRangeFilter.month.startDate, 'yyyy-MM-dd');
                    var endDate = $filter('date')($scope.dateRangeFilter.month.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        month: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }

                if ($scope.filter_groups.length > 0) {
                    url['groups'] = $scope.filter_groups;
                }

                $scope.url = url;
                PaidDetail.query(url, function (resp) {
                    $scope.groups = resp.groups;
                    $scope.groups.unshift({'id': 0, 'name': '全部'});
                    params.total(resp.total);
                    $scope.records = resp.records;
                    $defer.resolve(resp.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
            $scope.dateRangeFilter = {};
        };

        $scope.getReports = function (para) {
            if (para.month) {
                var year = para.month.getYear();
                $scope.dateRangeFilter = {
                    month: {
                        startDate: new Date(year + 1900, para.month.getMonth(), 1),
                        endDate: new Date(year + 1900, para.month.getMonth() + 1, 0)
                    }
                };
                var groups = para.groups;
                var temp = '';
                if (groups.length > 0) {
                    for (var i in groups) {
                        if (i == groups.length) {
                            temp = temp + groups[i].name;
                        } else {
                            temp = temp + groups[i].name + ",";
                        }
                    }
                    $scope.filter_groups = temp;
                } else {
                    $scope.filter_groups = ['全部'];
                    $scope.para = {month: para.month, groups: [{'id': 0, 'name': '全部'}]};
                }
                $scope.tableReload();
            }
        };


        $scope.exportReportToExcel = function () {

            var params = {};
            params['groups'] = $scope.filter_groups;
            params['month'] = $scope.records[0].month;
            FileHelper.download(C.URL.DUTY_PAID_EXPORT, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = $scope.records[0].month + $scope.filter_groups + '值班费发放明细.xls';
                SaveAs.download(data, filename, options);
            }, function () {
                toaster.error('导出失败!');
            });

        };


    });

//angular.module('c.c')
//    .controller('HouseFeeCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, HousePay, F) {
//
//        $scope.pay_types = F.get('pay_types');
//        var pay_types = F.getNgTableOpts($scope.pay_types);
//        $scope.cols = [
//            {title: '员工姓名', field: 'user_name', filter: {'users.name': 'text'}, show: true}, //0
//            {
//                title: '房屋编号',
//                field: 'house_code',
//                filter: {'houses.code': 'text'},
//                width: '15%',
//                show: true
//            }, //0
//            {
//                title: '月份',
//                sortable: 'house_wae_records.month',
//                filter: {month: 'date_range'},
//                field: 'house_wae_records.month',
//                show: true
//            },
//            {
//                title: '支付方式',
//                filter: {pay_type: 'select'},
//                field: 'house_rents.pay_type',
//                width: '10%',
//                data: pay_types,
//                show: true
//            }, //6
//            {
//                title: '交纳金额',
//                sortable: 'money',
//                filter: {money: 'number_range'},
//                field: 'money',
//                width: '10%',
//                show: true
//            },
//            {
//                title: '余额',
//                sortable: 'balance',
//                filter: {balance: 'number_range'},
//                field: 'balance',
//                width: '10%',
//                show: true
//            },
//            {
//                title: '交费时间',
//                sortable: 'updated_at',
//                //filter: {updated_at: 'date_range'},
//                field: 'updated_at',
//                width: '10%',
//                show: true
//            }
//        ];
//        $scope.optColWidth = 96;
//
//        $scope.numRangeFilter = {};
//        $scope.$watch(
//            function () {
//                return $scope.numRangeFilter;
//            },
//            function (newValue, oldValue) {
//                $scope.tableParams.reload();
//            }, true
//        );
//
//        var date = new Date((new Date()).setDate(1));
//        $scope.dts = new Date(date.setMonth(date.getMonth() - 1));
//        $scope.dte = new Date(date.getFullYear(), date.getMonth() + 1, 0);
//        $scope.prevMonth = function (curr) {
//            var prev = curr.getMonth() - 1;
//            $scope.dts = new Date(curr.setMonth(prev));
//            $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
//        };
//        $scope.nextMonth = function (curr) {
//            var next = curr.getMonth() + 1;
//            $scope.dts = new Date(curr.setMonth(next));
//            $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
//        };
//
//        $scope.$watch('dts', function (newVal, oldVal, scope) {
//            $scope.tableParams.reload();
//        }, true);
//
//        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
//            counts: [5, 10], total: 0,
//            getData: function ($defer, params) {
//                var url = params.url();
//                if ($scope.numRangeFilter.balance) {
//                    url['balance_start'] = $scope.numRangeFilter.balance.start;
//                    url['balance_end'] = $scope.numRangeFilter.balance.end;
//                }
//                if ($scope.numRangeFilter.money) {
//                    url['money_start'] = $scope.numRangeFilter.money.start;
//                    url['money_end'] = $scope.numRangeFilter.money.end;
//                }
//
//                //if ($scope.dateRangeFilter.updated_at != null) {
//                //    var startDate = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
//                //    var endDate = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
//                //    url['date_range_filters']['updated_at'] = {
//                //        startDate: startDate,
//                //        endDate: endDate
//                //    };
//                //}
//                url['date_range_filters'] = {
//                    'house_wae_records.month': {
//                        startDate: $filter('date')($scope.dts, 'yyyy-MM-dd'),
//                        endDate: $filter('date')($scope.dte, 'yyyy-MM-dd')
//                    }
//                };
//                url['opt'] = 2;
//                HousePay.query(url, function (resp) {
//                    params.total(resp.total);
//                    $scope.rents = resp.rents;
//                    $scope.except_users = resp.except_users;
//                    $defer.resolve(resp.records);
//                });
//            }
//        });
//
//        $scope.tableReload = function () {
//            $scope.tableParams.reload();
//        };
//
//        $scope.clearFilters = function () {
//            $scope.numRangeFilter = {};
//            $scope.dateRangeFilter = {};
//            $scope.tableParams.filter({});
//        };
//
//        $scope.add = function () {
//            dialogs.create('HouseFeeDlg.html', 'HouseFeeDlgCtrl', {except_users: $scope.except_users}, {
//                 size: 'md'
//            }).result.then(function (house_fee) {
//                    HousePay.save(house_fee).$promise.then(function () {
//                        toaster.success('交纳记录添加成功!');
//                        $scope.tableReload();
//                    }, function () {
//                        toaster.error('交纳记录添加失败!');
//                    });
//                });
//        };
//
//
//        $scope.edit = function (record) {
//            record.$edit = true;
//            record.$moneyChanged = record.money;
//        };
//
//        $scope.save = function (record) {
//            record.$edit = false;
//            if (record.$moneyChanged == "") {
//                toaster.warning('交纳金额不能为空!');
//            } else {
//                var data = {};
//                data['money'] = record.$moneyChanged;
//                HousePay.update({id: record.id}, data).$promise.then(function () {
//                    toaster.success('交纳金额修改成功!');
//                    record.money = record.$moneyChanged;
//                }, function (error) {
//                    toaster.error('交纳金额修改失败!');
//                });
//            }
//        };
//
//        $scope.delete = function (record) {
//            dialogs.confirm('删除交纳记录', '确定要删除<strong>' + record.user_name + '</strong>的交纳记录吗?')
//                .result.then(function () {
//                    HousePay.delete({id: record.id}).$promise.then(function () {
//                        toaster.success('交纳记录删除成功!');
//                        $scope.tableReload();
//                    }, function (error) {
//                        toaster.error('交纳删除失败!');
//                    });
//                });
//
//        };
//
//    });
//
//angular.module('c.c').controller('HouseFeeDlgCtrl',
//    function ($scope, $modalInstance, toaster, $filter, data) {
//
//        $scope.except_users = data.except_users;
//        var month = new Date();
//        month.setMonth(month.getMonth() - 1);
//        $scope.house_fee = {month: month};
//
//        $scope.ok = function (house_fee) {
//            if (house_fee.user == null) {
//                toaster.warning('请选择员工!');
//            } else if ($scope.house_fee_form.$valid) {
//                var params = {};
//                params['user_id'] = house_fee.user.id;
//                params['month'] = $filter('date')(house_fee.month.setDate(1), 'yyyy-MM-dd');
//                params['money'] = house_fee.money;
//                $modalInstance.close(params);
//            } else {
//                toaster.warning('表单中有错误!');
//                $scope.house_fee_form.submitted = true;
//            }
//        };
//
//        $scope.cancel = function () {
//            $modalInstance.dismiss('cancel');
//        };
//    });
//

angular.module('c.c')
    .controller('PayrollCardCtrl', function ($scope, $filter, toaster, NgTableParams, User, C, Table, FileHelper) {
        var vm = $scope;
        vm.edit = edit;
        vm.save = save;
        vm.exportPayrollCard = exportPayrollCard;

        init();

        function init() {
            var options = {
                service: User,
                params: {opt: 18},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "dept", title: "科室"},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "idcard", title: "身份证号", filter: {idcard: "text"}},
                    {field: "salary_card", title: "工资卡号"},
                    {field: "bank_of_deposit", title: "开户行"}
                ]
            };
            Table.load(vm, options);
        }

        function edit(user) {
            user.$edit = true;
            user.$salaryChanged = user.salary_card;
        }

        function save(user) {
            user.$edit = false;
            if (user.$salaryChanged == "") {
                toaster.warning('工资卡号不能为空!');
            } else {
                var data = {};
                data['salary_card'] = user.$salaryChanged;
                data['bank_of_deposit'] = user.bankOfDeposit;
                User.update({id: user.id}, data).$promise.then(function () {
                    toaster.success('工资卡号修改成功!');
                    vm.tableReload();
                }, function (error) {
                    toaster.error('卡号修改失败!');
                });

            }
        }

        function exportPayrollCard() {
            FileHelper.dnExcel(User.urls.EXPORT_PAYROLL_CARD, {}, '工资卡统计表.xls');
        }


    });


'use strict';

angular.module('c.c')
    .controller('StaffQueryCtrl', function () {
    });


angular.module('c.c')
    .controller('SubsidyPaidCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, AskForLeave, F) {
        
    });

'use strict';

angular.module('c.c')
    .controller('FinanceWageCtrl', function () {
    });


angular.module('c.c')
    .controller('GeneralCashCtrl', function ($scope, $filter, dialogs, toaster) {

    });


angular.module('c.c')
    .controller('HouseManageCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, House, F) {
        $scope.house_types = F.get('house_types');
        var house_types = F.getNgTableOpts($scope.house_types);
        $scope.sexes = [{id: 0, title: '女'}, {id: 1, title: '男'}, {id: 2, title: '男女混租'}, {id: 3, title: '空闲'}];
        $scope.house_sources = F.get('house_sources');
        var house_sources = F.getNgTableOpts($scope.house_sources);
        $scope.is_hiss = F.get('is_hiss');
        var is_hiss = F.getNgTableOpts($scope.is_hiss);
        $scope.cols = [
            {title: '编号', sortable: 'code', filter: {code: 'text'}, field: 'code', show: true},
            {title: '类型', filter: {type: 'select'}, field: 'type', width: '50', data: house_types, show: true},
            {title: '来源', filter: {source: 'select'}, data: house_sources, field: 'source', show: true},
            {title: '管理类型', filter: {is_his: 'select'}, data: is_hiss, field: 'is_his', show: true},
            {
                title: '剩余可住',
                sortable: 'left_num',
                filter: {left_num: 'number_range'},
                field: 'left_num',
                show: true
            },
            {
                title: '平均租金',
                sortable: 'average_rent',
                filter: {average_rent: 'number_range'},
                field: 'average_rent',
                show: true
            },
            {
                title: '已住性别',
                sortable: 'sex',
                filter: {sex: 'select'},
                field: 'sex',
                data: $scope.sexes,
                show: true
            }, {
                title: '更多',
                show: true
            }
        ];

        $scope.optColWidth = 70;
        $scope.optInFront = true;
        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            sorting: {
                code: 'asc'
            }
        }, {
            counts: [5, 10],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                House.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.tableParams.filter({});
        };


        $scope.add = function () {
            dialogs.create('HouseDlg.html', 'HouseDlgCtrl',
                {
                    house_types: $scope.house_types,
                    house_sources: $scope.house_sources,
                    is_hiss: $scope.is_hiss,
                    sexes: $scope.sexes
                }, {size: 'md'})
                .result.then(function (house) {
                House.save(house).$promise.then(function (resp) {
                    toaster.success('房屋添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('房屋添加失败!');
                })
            });
        };

        $scope.member = function (record) {
            dialogs.create('/templates/house_member.html', 'HouseMemberCtrl',
                {house: record}, {size: 'md'})
        };

        $scope.edit = function (record) {
            dialogs.create('HouseDlg.html', 'HouseDlgCtrl',
                {
                    house_types: $scope.house_types,
                    house_sources: $scope.house_sources,
                    is_hiss: $scope.is_hiss,
                    sexes: $scope.sexes,
                    house: record
                }, {

                    size: 'md'
                }).result.then(function (house) {
                House.update({id: record.id}, house).$promise.then(function (resp) {
                    toaster.success('房屋信息修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('房屋信息修改失败!');
                })
            });
        };


        $scope.delete = function (record) {
            console.log(record)
            dialogs.confirm('删除房屋', '确定要删除<strong>' + record.code + '</strong>的房屋信息?')
                .result.then(function () {
                House.delete({id: record.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('房屋删除成功!');
                            break;
                        case 1:
                            toaster.warning('该房屋尚有用户租住,不能删除!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('房屋删除失败!');
                });
            });
        };

        $scope.setStop = function (record) {
            if (record.sex!=3){
                return  toaster.warning('该房屋尚有用户租住,不能停用!');
            }
            var isStopRoom;
            record.is_stop==1?isStopRoom='启用':isStopRoom='停用';
            dialogs.confirm(isStopRoom+'房屋', '确定要'+isStopRoom+'房屋<strong>' + record.code + '</strong>吗?')
                .result.then(function () {
                House.update({id: record.id},{is_stop:record.is_stop==0?record.is_stop=1:record.is_stop=0}).$promise.then(function (resp) {
                    toaster.success('房屋'+isStopRoom+'成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('房屋'+isStopRoom+'失败!');
                });
            });
        };
    });

angular.module('c.c').controller('HouseDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data, F) {
        $scope.sexes = data.sexes;
        $scope.house_types = data.house_types;
        $scope.house_sources = data.house_sources;
        $scope.is_hiss = data.is_hiss;
        var house = data.house;
        if (house) {
            $scope.house = {
                'code': house.code,
                'type': F.getItem(house.type, $scope.house_types),
                'area': house.area,
                'floor': house.floor,
                'source': F.getItem(house.source, $scope.house_sources),
                'is_his': F.getItem(house.is_his, $scope.is_hiss),
                'original_rent': house.original_rent,
                'allow_num': house.allow_num,
                'average_rent': house.average_rent,
                'remark': house.remark,
                'land_name': house.land_name,
                'phone': house.phone,
                'sex': F.getItem(house.sex, $scope.sexes)
            };
        } else {
            $scope.house = {type: data.house_types[0], source: data.house_sources[0], is_his: data.is_hiss[0]};
        }
        $scope.ok = function (house) {
            if ($scope.house_form.$valid) {
                var params = {};
                params['code'] = house.code;
                params['type'] = house.type.id;
                params['area'] = house.area;
                params['floor'] = house.floor;
                params['source'] = house.source.id;
                params['is_his'] = house.is_his.id;
                params['original_rent'] = house.original_rent;
                params['allow_num'] = house.allow_num;
                params['average_rent'] = house.average_rent;
                params['sort'] = house.sort;
                params['land_name'] = house.land_name;
                params['phone'] = house.phone;
                params['remark'] = house.remark;
                if (data.house) {
                    params['sex'] = house.sex.id;
                }
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.house_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('HouseMemberCtrl',
    function ($scope, $uibModalInstance, toaster, data, HouseRent) {
        $scope.house = data.house;
        $scope.showAllMember = true;
        HouseRent.query({'opt': 2, 'house_id': data.house.id}, function (data) {
            $scope.records = data.records;
            angular.forEach($scope.records, function (record) {
                record.show = record.rent_end == null;
            })
        });

        $scope.showAll = function () {
            $scope.showAllMember = false;
            angular.forEach($scope.records, function (record) {
                record.show = true;
            })
        };
        $scope.showNow = function () {
            $scope.showAllMember = true;
            angular.forEach($scope.records, function (record) {
                record.show = record.rent_end == null;
            })
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('HouseRentCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, HouseRent, F) {


    });

angular.module('c.c').controller('HouseRentDlgCtrl',
    function ($scope, $uibModalInstance, toaster, $filter, data, Dlg) {

        $scope.houses = data.houses;
        $scope.situations = data.situations;
        $scope.pay_types = data.pay_types;
        $scope.rent_users = data.rent_users;
        $scope.house_rent = {
            rent_start: new Date(),
            rent_end: new Date(),
            pay_type: data.pay_types[0],
            house: data.houses[0]
        };

        $scope.ok = function (house_rent) {
            if (house_rent.user == null) {
                toaster.warning('请选择员工!');
            }
            if (house_rent.situation == null) {
                Dlg.w('请选择房屋情况!');
            } else if ($scope.house_rent_form.$valid) {
                var params = {};
                params['user_id'] = house_rent.user.id;
                params['house_id'] = house_rent.house.id;
                params['rent_start'] = $filter('date')(house_rent.rent_start, 'yyyy-MM-dd');
                params['situation'] = house_rent.situation.id;
                params['pay_type'] = house_rent.pay_type.id;
                params['remarks'] = house_rent.remarks;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.house_rent_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });



angular.module('c.c')
    .controller('WaeMealCtrl', function (UIHelper, $scope, $stateParams) {
        UIHelper.loadTabs($scope, $stateParams);
    });
(function () {
        'use strict';

        angular.module('c.c')
            .controller('houseUnitPrice', houseUnitPrice);

        /** @ngInject */
        function houseUnitPrice($scope, Table, UIHelper, Dlg, dialogs, Auth, ArrayHelper,HouseWaeFeePrice,HouseWae) {

            var vm = $scope;
            vm.add = add;
            vm.deleteRoom = deleteRoom;
            vm.edit = edit;
            vm.setStop = setStop;

            init();


            function init() {
                var options = {
                    service: HouseWaeFeePrice,
                    optInFront: true,
                    showSn: true,
                    params: {},
                    cols: [
                        {field: "name", title: '名字', filter: {name: 'text'}, width: '40%'},
                        {field: "price", title: '价格', filter: {price: 'text'}, width: '40%'},
                        {field: "sorting", title: '排序', filter: {sorting: 'text'}, width: '20%'},
                    ]
                };
                Table.load(vm, options);
                $scope.$on('addUnitPrice', function () {
                    vm.tableReload();
                });
            }

            function add() {
                Dlg.show({
                    template: 'pages/general/wae_fee/dlg/addUnitPriceDlg.html',
                    ctrl: 'addUnitPriceDlgCtrl',
                    data: {},
                    size: 'md'
                }).then(function () {
                    vm.tableReload();
                });
            }

            function edit(m) {
                Dlg.show({
                    template: 'pages/general/wae_fee/dlg/addUnitPriceDlg.html',
                    ctrl: 'addUnitPriceDlgCtrl',
                    data: {id: m.id, edit: true},
                    size: 'md'
                }).then(function () {
                    vm.tableReload();
                });
            }

            function setStop(m) {
                m.is_stop = m.is_stop == 1 ? 0 : 1;
                var pa = {op: 'is_stop', is_stop: m.is_stop};
                HouseWaeFeePrice.update({id: m.id, opt: '1'}, pa).$promise.finally(function () {
                    vm.tableReload();
                    defer.resolve();
                });
            }

            function deleteRoom(m) {
                Dlg.confirm('确定要删除<strong>' + m.name + '</strong>吗？', function () {
                    HouseWaeFeePrice.delete({id: m.id, opt: '1'}).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        vm.tableReload();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }, '删除单价');
            }
        }
    }

)();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('WaeFeeCtrl', WaeFeeCtrl)
        .controller('HouseWaeDlgCtrl', HouseWaeDlgCtrl);

    /** @ngInject */
    function WaeFeeCtrl($scope, $filter, dialogs, toaster, NgTableParams, FileHelper, F, C, HouseWae) {

        $scope.cols = [
            {title: '月份', sortable: 'month', field: 'month', show: true}, //0
            {
                title: '房屋编号',
                field: 'house_code',
                filter: {'houses.code': 'text'},
                show: true
            }, //0
            {
                title: '水费',
                sortable: 'water_rate',
                field: 'water_rate',
                show: true
            },
            {
                title: '电费',
                sortable: 'power_rate',
                field: 'power_rate',
                show: true
            },
            {
                title: '清洁费',
                sortable: 'clean_fee',
                field: 'clean_fee',
                show: true
            },
            {
                title: '光纤',
                sortable: 'web_rate',
                field: 'web_rate',
                show: true
            },
            {
                title: '物管',
                sortable: 'pty',
                field: 'pty',
                show: true
            }
        ];
        $scope.optColWidth = 60;

        var date = new Date((new Date()).setDate(1));
        var month = date.getMonth();
        $scope.dts = new Date(date.setMonth(month - 1));
        $scope.dte = new Date(date.getFullYear(), month, 0);
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dts = new Date(curr.setMonth(prev));
            $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dts = new Date(curr.setMonth(next));
            $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
        };

        $scope.$watch('dts', function (newVal, oldVal, scope) {
            $scope.tableReload();
        }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['month'] = $filter('date')($scope.dts, 'yyyy-MM-dd');
                HouseWae.query(url, function (resp) {
                    params.total(resp.total);
                    //$scope.houses = resp.houses;
                    $scope.no_declare = resp.no_declare;
                    $defer.resolve(resp.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.direct = function (house) {
            dialogs.create('HouseWaeDlg.html', 'HouseWaeDlgCtrl', {
                house: house, month: $filter('date')($scope.dts, 'yyyy-MM-dd')
            }, {
                size: 'md'
            }).result.then(function (house_wae) {
                HouseWae.save(house_wae).$promise.then(function () {
                    toaster.success('水电费记录添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('此房间已添加过费用!');
                });
            });
        };


        $scope.edit = function (house) {
            // record.$edit = true;
            // record.$waterRateChanged = record.water_rate;
            // record.$powerRateChanged = record.power_rate;
            // record.$webRateChanged = record.web_rate;
            // record.$cleanFeeChanged = record.clean_fee;
            // record.$ptyChanged = record.pty;
            dialogs.create('HouseWaeDlg.html', 'HouseWaeDlgCtrl', {
                house: house,edit:true
            }, {
                size: 'md'
            }).result.then(function (house_wae) {
                HouseWae.update({id: house.id}, house_wae).$promise.then(function (resp) {
                    toaster.success('水电费修改成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('水电费修改失败!');
                });
            });
        };

        $scope.save = function (record) {
            record.$edit = false;
            if (record.water_rate != record.$waterRateChanged ||
                record.power_rate != record.$powerRateChanged || record.web_rate != record.$webRateChanged
                || record.clean_fee != record.$cleanFeeChanged || record.pty != record.$ptyChanged) {
                var data = {};
                data['water_rate'] = record.$waterRateChanged;
                data['power_rate'] = record.$powerRateChanged;
                data['web_rate'] = record.$webRateChanged;
                data['clean_fee'] = record.$cleanFeeChanged;
                data['pty'] = record.$ptyChanged;
                HouseWae.update({id: record.id}, data).$promise.then(function (resp) {
                    toaster.success('水电费修改成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('水电费修改失败!');
                });
            }
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除水电费记录', '确定要删除<strong>' + record.house_code + '</strong>的水电费记录吗?')
                .result.then(function () {
                HouseWae.delete({id: record.id}).$promise.then(function () {
                    toaster.success('水电费记录删除成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('水电费记录删除失败!');
                });
            });

        };

        $scope.member = function (record) {
            var house = {'id': record.house_id, 'code': record.house_code};
            dialogs.create('/templates/house_member.html', 'HouseMemberCtrl',
                {house: house}, {size: 'md'})
        };

        $scope.export = function () {
            FileHelper.dnExcel(C.URL.HOUSE_WAE_EXPORT, {'start': $filter('date')($scope.dts, 'yyyy-MM-dd')}, $filter('date')($scope.dts, 'yyyy年MM月') + '水电费统计表.xls');
        }

    }

    function HouseWaeDlgCtrl($scope,$q, $uibModalInstance, toaster, $filter, data,HouseWaeFeePrice) {

        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.changeWater = changeWater;
        vm.changePower = changePower;
        vm.house_wae = {'power_rate': 0, 'web_rate': 0, 'clean_fee': 0, 'pty': 0};
        init()

        function init() {
            if (data.edit){
                HouseWaeFeePrice.get({id:data.house.id,op:'edit'},function (resp){
                    vm.house_wae=resp.item[0];
                    HouseWaeFeePrice.query({op:'unabated'}, function (resp2) {
                        vm.prices = resp2.items;
                        if (vm.prices.length == 0) {
                            Dlg.w('暂无单价，请先前往添加');
                            $uibModalInstance.close();
                        }
                    });
                });
            }else {
                HouseWaeFeePrice.get({id:data.house.id,op:'new'},function (resp){
                    HouseWaeFeePrice.query({op:'unabated'}, function (resp2) {
                        vm.prices = resp2.items;
                        if (vm.prices.length == 0) {
                            Dlg.w('暂无单价，请先前往添加');
                            $uibModalInstance.close();
                        }
                        if (resp.item.power_unit_price!=null){
                            vm.house_wae.power_unit_price=resp.item.power_unit_price
                        }
                        if (resp.item.water_unit_price!=null){
                            vm.house_wae.water_unit_price=resp.item.water_unit_price
                        }
                        if (resp.item.water_end!=null){
                            vm.house_wae.water_start=resp.item.water_end
                        }
                        if (resp.item.power_end!=null){
                            vm.house_wae.power_start=resp.item.power_end
                        }
                    });
                });
            }
        }

        function changeWater(house_wae) {
            if (house_wae.water_end!=null&&house_wae.water_start!=null&&house_wae.water_unit_price!=null){
                house_wae.water_rate = (parseFloat(house_wae.water_unit_price.price)*(parseFloat(house_wae.water_end)-parseFloat(house_wae.water_start))).toFixed(2) ;
            }
        }
        function changePower(house_wae) {
            if (house_wae.power_end!=null&&house_wae.power_start!=null&&house_wae.power_unit_price!=null){
                house_wae.power_rate  = (parseFloat(house_wae.power_unit_price.price)*(parseFloat(house_wae.power_end)-parseFloat(house_wae.power_start))).toFixed(2) ;
            }
        }

        function ok(house_wae) {
            if (parseFloat(house_wae.water_start)>parseFloat(house_wae.water_end)||parseFloat(house_wae.power_start)>parseFloat(house_wae.power_end)){
                toaster.warning('止数不能小于底数!');
            }else {
                if (vm.house_wae_form.$valid) {
                    var params = {};
                    params['house_id'] = data.house.id;
                    params['month'] = data.month;
                    params['water_start'] = house_wae.water_start;
                    params['water_end'] = house_wae.water_end;
                    params['water_unit_price'] = house_wae.water_unit_price.id;
                    params['water_rate'] = house_wae.water_rate;
                    params['power_start'] = house_wae.power_start;
                    params['power_end'] = house_wae.power_end;
                    params['power_unit_price'] = house_wae.power_unit_price.id;
                    params['power_rate'] = house_wae.power_rate;
                    params['web_rate'] = house_wae.web_rate;
                    params['clean_fee'] = house_wae.clean_fee;
                    params['pty'] = house_wae.pty;
                    $uibModalInstance.close(params);
                } else {
                    toaster.warning('表单中有错误!');
                    vm.house_wae_form.submitted = true;
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalMeetingCtrl', HospitalMeetingCtrl);

    /** @ngInject */
    function HospitalMeetingCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();





angular.module('c.c')
    .controller('HospitalMissionCtrl', function ($scope) {

    });
'use strict';

angular.module('c.c')
    .controller('NoticeHandledCtrl', function ($scope, $filter, deviceDetector, dialogs, toaster, NgTableParams, C, F, Bulletin) {
        $scope.$on('bulletinBack', function (event, data) {
            $scope.tableParams.reload();
        });

        var stages = F.getApprovalStages1();
        var stageOpts = F.getNgTableOpts(stages);
        var isDesktop = deviceDetector.isDesktop();
        $scope.isDesktop = isDesktop;
        $scope.hideOpt = true;
        $scope.showSn = true;
        $scope.cols = [
            {title: '公告标题', filter: {title: 'text'}, show: true},
            {title: '创建时间', show: isDesktop},
            {title: '作者', filter: {sender: 'text'}, show: isDesktop, width: '10%'},
            {title: '状态', filter: {stage: 'select'}, data: stageOpts, show: true}
        ];

        var skip = false;
        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                if (!skip) {
                    $scope.tableParams.reload();
                } else {
                    skip = false;
                }
            }, true
        );

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //院审3，科审2, 院已处理12
                Bulletin.query(url, function (data) {
                    params.total(data.total);
                    angular.forEach(data.bulletins, function (b) {
                        b.stage = F.getItem(b.is_pass, stages);
                    });
                    $defer.resolve(data.bulletins);
                });
            }
        });
        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
    });
'use strict';

angular.module('c.c')
    .controller('HospitalPublicTopicCtrl', function ($scope) {

    });



angular.module('c.c').controller('RuleHospitalApprovedController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Table, C, RuleType, Dept, Rule) {
        $scope.$on('ruleApproved', function () {
            $scope.tableParams.reload();
        });

        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);
        $scope.states = F.get('rule_states');
        var statesOpts = F.getNgTableOpts($scope.states);

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_LED_BY2}, function (resp) {
            var depts = resp.depts;
            if (depts && depts.length > 0) {
                $scope.dept = depts[0];
                $scope.tableParams.reload();
            }
            $scope.depts = depts;
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };


        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            {title: '类型', sortable: 'type_id', filter: {type_id: 'select'}, show: true},
            {title: '发布时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '审核类型', filter: {state: 'select'}, data: statesOpts, show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        var typeCol = $scope.cols[2];
        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = C.OPT.RULE.INDEX.HOSPITAL_APPROVED;
                    url['dept_id'] = $scope.dept.id;
                    if ($scope.dateRangeFilter.created_at != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                    }
                    Table.query(Rule, url, $defer, params, 'rules', function (data) {
                        typeCol.data = F.getNgTableOpts(data.rule_types);
                        angular.forEach(data.rules, function (rule) {
                            rule.stage = F.getItem(rule.stage, $scope.stages);
                            rule.state = F.getItem(rule.state, $scope.states);
                        });
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {id: rule.id}, {

                size: 'lg'
            });
        }
    });



(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateSsDlgCtrl', IrDateSsDlgCtrl);

    /** @ngInject */
    function IrDateSsDlgCtrl($uibModalInstance, Dlg, Api, $timeout, OpDateSs, ArrayHelper, DateHelper, FileHelper, FormHelper, Upload, C) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.submit = submit;
        vm.upload = upload;


        init();


        function init() {
            vm.m = {
                mode: '0',
                doc: {}
            };
        }

        function submit(m) {
            // if (Object.keys(m.doc).length == 0) {
            //     Dlg.w('请上传附件');
            //     return;
            // }
            console.log(m);

            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    op: 'default',
                    items: m.items,
                    type: 2
                };
                if (m.mode == 0) {
                    pa.start = DateHelper.date2Str(m.start);
                    pa.end = DateHelper.date2Str(m.end);
                }
                OpDateSs.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.close();
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }


        function upload(file, data, e, rename, extra) {
            if (file == null) {
                return;
            }
            vm.loading = true;
            vm.m.items = [];
            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                ArrayHelper.mergeObj(pa, extra);
            }
            delete data[rename.filename];
            Upload.upload({
                url: C.URL.UPLOAD_ATTACHMENT, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        OpDateSs.save({
                            op: 'upload',
                            filename: resp[rename.filename],
                            type: vm.forPO ? 1 : (vm.forFinance ? 2 : 0)
                        }, function (excelData) {
                            vm.m.items = excelData.items;
                            vm.loading = false;
                            Dlg.s('上传完毕')
                        }, function (error) {
                            vm.loading = false;
                            Dlg.e('上传失败');
                        });
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });
        }
    }

})();



angular.module('c.c')
    .controller('IRShiftsCtrl', function ($scope, dialogs, toaster, C, F, FileHelper, Upload, SaveAs, IRSchedule) {

        $scope.reload = function () {
            IRSchedule.query(function (resp) {
                var tomorrow, today;
                if (resp) {
                    tomorrow = F.getItem(1, resp);
                    today = F.getItem(2, resp);
                }
                if (!tomorrow) {
                    tomorrow = {id: 1};
                }
                if (!today) {
                    today = {id: 2};
                }
                $scope.tomorrow = tomorrow;
                $scope.today = today;
            });
        };

        $scope.moveDown = function () {
            IRSchedule.exchange(function () {
                $scope.reload();
            });
        };

        $scope.upload = function (file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file == null) {
                return;
            }

            m.progress = 0;
            Upload.upload({
                url: C.URL.IR_SCHEDULE_UPLOAD, data: {file: file, id: m.id}
            }).progress(function (evt) {
                m.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.name = resp.name;
                        m.mime = resp.mime;
                        m.filename = resp.filename;
                        m.size = resp.size;
                        break;
                    case 1:
                        m.progress = 101;
                        m.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                m.progress = 102;
                m.errorInfo = '服务器错误!';
            });
        };

        $scope.download = function (m) {
            var params = {name: m.name, filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.IR_SCHEDULE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.reload();
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('IRRecipientCtrl', IRRecipientCtrl);

    /** @ngInject */
    function IRRecipientCtrl($scope, ORRecipient, Dlg) {
        var vm = $scope;
        vm.reload = reload;
        vm.submit = submit;

        init();


        function init() {
            ORRecipient.query({type: 3}, function (resp) {
                var users = [];
                angular.forEach(resp.records, function (r) {
                    users.push(r.user);
                });
                vm.users = users;
            });
        }

        function reload() {
            init();
        }

        function submit(m) {
            var params = {'type': 3, 'user_ids': []};
            if (m) {
                angular.forEach(m, function (u) {
                    params['user_ids'].push(u.id);
                });
            }
            ORRecipient.update({id: 0}, params).$promise.then(function () {
                Dlg.s('设置成功');
            }, function () {
                Dlg.e('设置失败');
            });
        }
    }

})();



angular.module('c.c')
    .controller('AirfareManageCtrl', function ($scope, $stateParams, F) {
        F.loadTabs($scope, $stateParams);
    });

angular.module('c.c').controller('BulletinManageCtrl',
    function ($scope, dialogs, toaster, $filter, NgTableParams, C, F, Bulletin, Rule) {
        $scope.$on('bulletinBack', function (event, data) {
            $scope.tableParams.reload();
        });

        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');

        var stages = F.getApprovalStages1();
        var stagesOpts = F.getNgTableOpts(stages);

        $scope.cols = [
            {title: '科室', filter: {dept: 'text'}, show: true, width: '10%'},
            {title: '公告标题', filter: {title: 'text'}, show: true},
            {title: '发布时间', filter: {release_time: 'date_range'}, show: true},
            {title: '作者', filter: {sender: 'text'}, field: 'sender', show: true, width: '10%'},
            {title: '状态', data: stagesOpts, filter: {is_pass: 'select'}, show: true, width: '10%'}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.top = function (bulletin) {
            dialogs.create('TopDlg.html', 'BulletinTopCtrl', {id: bulletin.id}, {
                size: 'md'
            }).result.then(function () {
                $scope.tableParams.reload();
            })
        };

        $scope.cancel_top = function (bulletin) {
            dialogs.create('CancelTopDlg.html', 'CancelBulletinTopCtrl', {bulletin: bulletin}, {
                size: 'sm'
            }).result.then(function () {
                $scope.tableParams.reload();
            });
        };

        $scope.optColWidth = 96;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                release_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 4;
                if ($scope.dateRangeFilter.release_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.release_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.release_time.endDate, 'yyyy-MM-dd');
                }
                Bulletin.query(url, function (data) {
                    params.total(data.total);
                    angular.forEach(data.bulletins, function (bulletin) {
                        bulletin.stage = F.getItem(bulletin.is_pass, stages);
                    });
                    $defer.resolve(data.bulletins);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.edit = function (bulletin) {
            dialogs.create('templates/article/bulletin_edit.html', 'EditBulletinCtrl', {
                id: bulletin.id
            }, {
                size: 'lg'
            }).result.then(function (params) {
                Bulletin.update({id: bulletin.id}, params).$promise.then(function () {
                    toaster.success('提交成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('提交失败!');
                });
            });
        };

        $scope.see = function (bulletin) {
            dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id, approval: true
            }, {
                size: 'lg'
            });
        };

        $scope.pass = function (bulletin) {
            dialogs.create('templates/article/bulletin_edit.html', 'ApprovalBulletinCtrl', {
                id: bulletin.id, is_pass: C.STAGE1.PUBLIC
            }, {
                size: 'lg'
            }).result.then(function (params) {
                Bulletin.update({id: bulletin.id}, params).$promise.then(function () {
                    toaster.success('提交成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('提交失败!');
                });
            });
        };

        $scope.delete = function (bulletin) {
            dialogs.confirm('删除公告', '确定要删除该公告吗?')
                .result.then(function () {
                Bulletin.delete({id: bulletin.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功!');
                            break;
                        case 1:
                            toaster.warning('!');
                            break;
                    }
                    $scope.tableParams.reload();
                }, function (error) {
                    toaster.error('删除失败!');
                });
            });
        };


        $scope.b2r = function (bulletin) {
            dialogs.create(C.T + 'article/bulletin2rule.html', 'B2RDlgCtrl', {bulletin: bulletin},
                {size: 'lg'}).result.then(function (params) {
                Rule.save(params).$promise.then(function () {
                    toaster.success('转制度发布成功!');
                }, function () {
                    toaster.error('转制度发布失败了!');
                });
            });
        };

    });

angular.module('c.c').controller('BulletinTopCtrl',
    function ($scope, $filter, $uibModalInstance, toaster, Bulletin, data) {
        $scope.dateOptions = {
            minDate: new Date()
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.ok = function () {
            if ($scope.end_time) {
                var params = {};
                params['top_time'] = $filter('date')($scope.end_time, 'yyyy-MM-dd');
                params['pass'] = true;
                params['skip_wx_remind'] = true;
                Bulletin.update({id: data.id}, params).$promise.then(function () {
                    toaster.success('提交成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('提交失败!');
                });
            } else {
                toaster.warning('请输入置顶结束时间')
            }
        }
    });

angular.module('c.c').controller('CancelBulletinTopCtrl',
    function ($scope, $filter, $uibModalInstance, toaster, Bulletin, data) {
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        var bulletin = data.bulletin;
        $scope.end_time = bulletin.top_time;
        $scope.ok = function () {
            var params = {};
            params['top_time'] = bulletin.release_time;
            params['skip_wx_remind'] = true;
            Bulletin.update({id: bulletin.id}, params).$promise.then(function () {
                toaster.success('提交成功!');
                $uibModalInstance.close();
            }, function () {
                toaster.error('提交失败!');
            })
        }
    });

angular.module('c.c').controller('B2RDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, toaster, C, F, Rule, RuleType, Dept, Keyword, data, FileHelper) {
        var deleteAttachments = [];
        var vm = $scope;
        vm.classSelectedFn = classSelectedFn;
        vm.reload = reload;
        vm.tagTransform = tagTransform;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.bulletin);

        function init(m) {
            Dept.query({opt: 14, /*INDEX_DEPT_BY_NAME*/name: m.dept}, function (resp) {
                vm.dept = resp.depts[0];
                vm.rule_types = F.get('rule_types');
                vm.rule = {
                    subject: m.title,
                    body: m.body,
                    class: vm.rule_types[1],
                    dept: vm.dept,
                    keywords: [],
                    ccdepts: [],
                    sender_id: m.sender_id,
                    is_bulletin: true,
                    rule_attach: '',
                    mime: '',
                    size: ''
                };
                if (m.attachments.length > 0) {
                    vm.rule['rule_attach'] = m.attachments[0].filename;
                    vm.rule['mime'] = m.attachments[0].mime;
                    vm.rule['size'] = m.attachments[0].size;
                    vm.rule['attachments'] = m.attachments;

                }

                RuleType.query({
                    opt: C.OPT.RULE_TYPE.INDEX.OPTIONS,
                    class: vm.rule_types[1].id,
                    dept: vm.dept.id
                }, function (resp) {
                    vm.types = resp.types;
                    vm.types.splice(0, 0, {id: 0, name: '其他'});
                    vm.rule['type'] = vm.types[0];
                });

                Keyword.query(function (resp) {
                    vm.keywords = resp;
                });

                Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
                    vm.cc_depts = resp.depts;
                });
            });

        }

        function tagTransform(newTag) {
            var item = F.getItem(newTag, vm.keywords, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        }

        function classSelectedFn(item) {
            vm.classId = item.id;
            vm.reload();
        }

        function reload() {
            vm.rule['type'] = null;

            if (!vm.classId) {
                vm.classId = vm.rule_types[0].id;
            }

            RuleType.query({
                opt: C.OPT.RULE_TYPE.INDEX.OPTIONS,
                class: vm.classId,
                dept: vm.dept.id
            }, function (resp) {
                vm.types = resp.types;
                vm.types.splice(0, 0, {id: 0, name: '其他'});
                vm.rule['type'] = vm.types[0];
            });
        }

        $scope.upload = function (file, rule, e) {
            FileHelper.upload(C.URL.BULLETIN_UPLOAD, file, rule, e);
        };

        $scope.deleteAttachment = function ($index, rule) {
            if (rule.attachments[$index].bulletin_id)
                deleteAttachments.push(rule.attachments[$index].id);
            rule.attachments.splice($index, 1);
        };

        function ok(rule) {
            if (rule.subject == null || rule.subject == "") {
                toaster.warning('标题不能为空!');
            } else if ((rule.body == null || rule.body == "")) {
                toaster.warning('内容不能为空!');
            } else if (rule.red_head && rule.ccdepts.length == 0) {
                toaster.warning('抄送科室不能为空!');
            } else {
                var params = {};
                params['subject'] = rule.subject;
                params['class'] = rule.class.id;
                params['dept_id'] = rule.dept.id;
                params['type_id'] = rule.type.id;
                params['keywords'] = rule.keywords;
                params['body'] = rule.body;
                params['ccdepts'] = [];
                angular.forEach(rule.ccdepts, function (dept) {
                    params['ccdepts'].push(dept.id);
                });
                params['red_head'] = rule.red_head ? '1' : '0';
                params['sender_id'] = rule.sender_id;
                params['is_bulletin'] = rule.is_bulletin;
                if (data.bulletin.attachments) {
                    params['rule_attach'] = rule.rule_attach;
                    params['mime'] = rule.mime;
                    params['size'] = rule.size;
                }
                $uibModalInstance.close(params);
            }
        }


    });




(function () {
    'use strict';

    angular.module('c.s')
        .controller('CommonPhoneCtrl', CommonPhoneCtrl)
        .controller('CommonPhoneDlgCtrl', CommonPhoneDlgCtrl);

    /** @ngInject */
    function CommonPhoneCtrl($scope, dialogs, toaster, Table, CommonPhone, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {phone: "text"}},
                    {field: "cornet", title: "小号", filter: {cornet: "text"}},
                    {field: "sort", title: "排序"},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }


        function add() {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                CommonPhone.save(m).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit(m) {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {id: m.id}, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                CommonPhone.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                CommonPhone.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }

    }

    /** @ngInject */
    function CommonPhoneDlgCtrl($scope, $uibModalInstance, toaster, F, CommonPhone, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                CommonPhone.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                    sort: m.sort,
                    is_stop: m.is_stop ? '1' : '0'
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }
})();


angular.module('c.c')
    .controller('PartyDeptMemberCtrl', PartyDeptMemberCtrl);

function PartyDeptMemberCtrl($scope, dialogs, toaster, Table, Dept) {
    var vm = $scope;
    var optionFn;
    vm.leader = leader;
    vm.member = member;

    init();


    function init() {
        var options = {
            service: Dept,
            params: {opt: 1, type_id: 9},
            optColWidth: Table._3_BTN,
            items: 'depts',
            cols: [
                {title: "序号", field: "sn", width: Table._1_CHAR},
                {title: '科室名称', field: 'name', filter: {name: 'text'}}, //0
                {title: '科室负责人', field: 'leader', filter: {leader: 'text'}}, //6
                {title: '科室秘书', field: 'assistant', filter: {assistant: 'text'}}, //6
                {title: '分管院领导', field: 'hospital_leader', filter: {hospital_leader: 'text'}}, //6
                {title: '邮件接收人', field: 'mail_recipient', filter: {mail_recipient: 'text'}}, //6
                {title: '成员数', field: 'members_count'} //6
            ]
        };

        optionFn = Table.load(vm, options, function (resp, startSn) {
            angular.forEach(resp.depts, function (item, i) {
                item.sn = startSn + i + 1;
            });
        }).options;
    }

    function leader(dept) {
        dialogs.create('LeaderDlg.html', 'SelectPartyLeaderCtrl',
            {dept: dept}, {size: 'md'}).result.then(function (params) {
            params['opt'] = 1;
            Dept.update({id: dept.id}, params).$promise.then(function (resp) {
                if (resp.result == 1) {
                    toaster.error(resp.msg);
                } else {
                    toaster.success('设置成功!');
                    $scope.tableParams.reload();
                }
            }, function () {
                toaster.error('设置失败!');
            });
        });
    }

    function member(dept) {
        dialogs.create('MemberDlg.html', 'PartyMemberCtrl', {dept: dept}, {size: 'lg'})
            .result.then(function () {
        }, function () {
            $scope.tableParams.reload();
        });
    }
}

angular.module('c.c').controller('PartyMemberCtrl',
    function ($scope, $uibModalInstance, NgTableParams, Dlg, F, UserDept, data, Table) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.add = add;
        vm.edit = edit;
        vm.leave = leave;
        vm.transfer = transfer;
        $scope.dept = data.dept;
        $scope.members = [];
        var optionFn;

        init();


        function init() {
            var options = {
                service: UserDept,
                params: {opt: 2, dept_id: data.dept.id, need_users: 1},
                optColWidth: Table._3_BTN,
                cols: [
                    {title: '姓名', field: 'name', filter: {name: 'text'}}, //0
                    {title: '工号', field: 'username'}, //0
                    {title: '科室内职务', field: 'post'}, //6
                    {title: '是否主科室', field: 'is_main'}, //6
                    {title: '进入时间', field: 'entry_time'}, //6
                    {title: '排序', field: 'sorting'} //6
                ]
            };

            optionFn = Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (m) {
                    m.is_main = m.is_main == '1';
                });
                angular.forEach(resp.members, function (m) {
                    $scope.members.push({id: m.user_id});
                });
            }).options;
        }

        function add() {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddPartyMemberCtrl',
                data: {
                    members: $scope.members
                }
            }).then(function (pa) {
                pa['dept_id'] = data.dept.id;
                UserDept.save(pa).$promise.then(function (resp) {
                    if (resp.result == 1) {
                        Dlg.e('科室没有对应的工会小组，请联系工会管理人员添加!');
                    } else {
                        Dlg.s('添加成功!');
                    }
                    vm.tableReload();
                }, function () {
                    Dlg.e('添加失败!');
                });
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddPartyMemberCtrl',
                data: {
                    user: m
                }
            }).then(function (pa) {
                pa['dept_id'] = data.dept.id;
                pa['opt'] = 1;
                UserDept.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('修改成功!');
                            vm.tableReload();
                            break;
                        case 1:
                            Dlg.w('员工必须拥有一个主科室!');
                            break;
                        case 2:
                            Dlg.w('科室没有对应的工会小组，请联系工会管理人员添加!');
                            break;
                    }
                }, function () {
                    Dlg.e('修改失败!');
                });
            });
        }

        function leave(m) {
            Dlg.show({
                template: 'LeaveMemberDlg.html',
                ctrl: 'LeavePartyMemberCtrl',
                data: {
                    user: m,
                    dept: data.dept
                }
            }).then(function (pa) {
                pa['opt'] = 2;
                UserDept.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('科室转出成功!');
                            vm.tableReload();
                            break;
                        case 1:
                            Dlg.w('员工必须拥有一个主科室!');
                            break;
                    }
                }, function () {
                    Dlg.e('科室转出失败!');
                });
            });
        }

        function transfer(m) {
            Dlg.show({
                template: 'TransMemberDlg.html',
                ctrl: 'TransPartyMemberCtrl',
                data: {
                    user: m,
                    dept: data.dept
                }
            }).then(function (pa) {
                pa['opt'] = 3;
                UserDept.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('转科成功!');
                            vm.tableReload();
                            break;
                        case 1:
                            Dlg.w('该员工已经在目标科室了!');
                            break;
                        case 2:
                            Dlg.w('目标科室没有对应的工会小组，请联系工会管理人员添加!');
                            break;
                    }
                }, function () {
                    Dlg.e('转科失败!');
                });
            });
        }
    });

angular.module('c.c').controller('TransPartyMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, Dept, data) {
        $scope.m = {
            leave_time: new Date(),
            entry_time: new Date(),
            post: data.user.post
        };
        $scope.user = data.user;
        $scope.dept = data.dept;

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            initDate: new Date()
        };

        Dept.query({opt: 4}, function (resp) {
            $scope.depts = F.except(data.dept.id, resp.depts);
            $scope.m['dept'] = $scope.depts[0];
        });

        $scope.ok = function (m) {
            if ($scope.u_form.$valid) {
                var p = {};
                p['leave_time'] = $filter('date')(m.leave_time, 'yyyy-MM-dd');
                p['user_id'] = data.user.user_id;
                p['dept_id'] = m.dept.id;
                p['post'] = m.post;
                p['entry_time'] = $filter('date')(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = data.user.is_main;
                //p['kpi'] = m.kpi;
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('LeavePartyMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, data) {
        $scope.m = {leave_time: new Date()};
        $scope.user = data.user;
        $scope.dept = data.dept;

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            //maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if ($scope.u_form.$valid) {
                var p = {};
                p['leave_time'] = $filter('date')(m.leave_time, 'yyyy-MM-dd');
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('AddPartyMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, uibDateParser, F, data) {

        if (data.user) {
            $scope.$edit = true;
            var user = data.user;
            $scope.m = {
                user: {id: user.user_id, name: user.name}, is_main: user.is_main,
                kpi: user.kpi, entry_time: uibDateParser.parse(user.entry_time, 'yyyy-MM-dd'),
                post: user.post, sorting: user.sorting
            };
        } else {
            $scope.m = {is_main: false, entry_time: new Date(), sorting: 100};
            $scope.members = data.members;
        }

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if (m.user == null) {
                toaster.warning('成员未选择!');
            } else if ($scope.u_form.$valid) {
                var p = {};
                p['user_id'] = m.user.id;
                p['post'] = m.post;
                p['entry_time'] = $filter('date')(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = m.is_main;
                p['sorting'] = m.sorting;
                //p['kpi'] = m.kpi;
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('SelectPartyLeaderCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, User, data) {
        $scope.dept = {
            name: data.dept.name,
            leader: data.dept.leader, /*nurse_leader: data.dept.nurse_leader,*/
            hospital_leader: data.dept.hospital_leader, mail_recipient: data.dept.mail_recipient,
            assistant: data.dept.assistant
        };

        User.query({opt: 3, dept_id: data.dept.id}, function (resp) {
            $scope.users = resp.users;
            $scope.users.splice(0, 0, {id: 0, name: '空缺'});
            if ($scope.dept.leader == null) $scope.dept.leader = $scope.users[0];
            //if ($scope.dept.nurse_leader == null) $scope.dept.nurse_leader = $scope.users[0];
            if ($scope.dept.hospital_leader == null) $scope.dept.hospital_leader = $scope.users[0];
            if ($scope.dept.mail_recipient == null) $scope.dept.mail_recipient = $scope.users[0];
            if ($scope.dept.assistant == null) $scope.dept.assistant = $scope.users[0];
        });

        $scope.ok = function (dept) {
            if ($scope.u_form.$valid) {
                var params = {
                    mail_recipient_id: dept.mail_recipient.id,
                    assistant_id: dept.assistant.id
                };

                if (dept.leader == null || dept.leader.id == 0) {
                    params.leader_id = null;
                } else {
                    params.leader_id = dept.leader.id;
                }

                if (dept.hospital_leader == null || dept.hospital_leader.id == 0) {
                    params.hospital_leader_id = null;
                } else {
                    params.hospital_leader_id = dept.hospital_leader.id;
                }

                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


(function () {
    'use strict';

    angular.module('c.s')
        .controller('OfficeDeptPhoneDlgCtrl', OfficeDeptPhoneDlgCtrl)
        .controller('OfficeDeptPhoneCtrl', OfficeDeptPhoneCtrl);

    /** @ngInject */
    function OfficeDeptPhoneCtrl(DeptPhone, $scope, Dlg, dialogs, Dept, toaster, OfficeDeptPhone, DeptWard, DeptWardPhone) {
        var vm = $scope;
        vm.remove = remove;
        vm.add = add;
        vm.edit = edit;
        vm.typeSelectedFn = typeSelectedFn;
        vm.selectDeptPhone = selectDeptPhone;
        vm.selectDeptWardPhone = selectDeptWardPhone;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.wardVisible = wardVisible;
        vm.toggleWardNode = toggleWardNode;
        vm.cancel = cancel;

        init();

        function init() {
            vm.selectTypes = [
                {id: 1, name: '科室', exAll: false, fresh: true},
            ];
            vm.curType = $scope.selectTypes[0];
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            var toType = $scope.selectTypes[$index];
            $(window).resize(function () {
                var width = $(window).width();
                if (width > 768) {
                    $scope.hideList = false;
                    $scope.showDetail = true;
                } else {
                    $scope.hideList = false;
                    $scope.showDetail = false;
                }
            });
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            $scope.curType = toType;
        }

        function cancel() {
            vm.selectedDept = false;
            vm.selectedWard = false;
        }

        function selectDeptPhone(dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            vm.selectedWard = false;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function selectDeptWardPhone(ward) {
            showDetailAccordingToScreenSize();

            vm.selected = ward;
            vm.selectedDept = true;
            vm.selectedWard = true;
            DeptWardPhone.query({ward_id: ward.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }

        function showDetailAccordingToScreenSize() {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }


        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            return (visible && !dept.dept_ward_id) || (!visible && dept.name.indexOf(vm.search.dept) !== -1);
            // return !(vm.search.dept && vm.search.dept.length > 0
            //     && dept.name.indexOf(vm.search.dept) === -1);
        }

        function wardVisible() {
            return !(vm.search.dept && vm.search.dept.length > 0);
        }

        function toggleWardNode(ward, toggle, node) {
            if (ward.depts) {
                toggle(node);
            } else {
                DeptWard.query({op: 'options', ward_id: ward.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        ward.depts = resp.items;
                        toggle(node);
                    }
                });
            }
        }

        function remove(m) {
            Dlg.confirm('确定删除该记录吗？').then(function () {
                var Service;
                if (vm.selectedWard) {
                    Service = DeptWardPhone
                } else {
                    Service = OfficeDeptPhone
                }
                Service.delete({
                    id: m,
                }).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    if (vm.selectedWard) {
                        selectDeptWardPhone(vm.selected)
                    } else {
                        selectDeptPhone(vm.selected)
                    }
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }

        function add(dept) {
            dialogs.create('OfficeDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {
                dept: dept,
                selectedWard: vm.selectedWard
            }, {size: 'md'}).result.then(function () {
                if (vm.selectedWard) {
                    selectDeptWardPhone(vm.selected)
                } else {
                    selectDeptPhone(vm.selected)
                }
            });
        }

        function edit(m) {
            dialogs.create('OfficeDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {
                id: m.id,
                dept: vm.selected,
                selectedWard: vm.selectedWard
            }, {size: 'md'}).result.then(function () {
                if (vm.selectedWard) {
                    selectDeptWardPhone(vm.selected)
                } else {
                    selectDeptPhone(vm.selected)
                }
            });
        }
    }

    function OfficeDeptPhoneDlgCtrl($scope, $uibModalInstance, toaster, Dlg, FormHelper, OfficeDeptPhone, DeptWardPhone, data) {
        var vm = $scope;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;
        vm.dept = data.dept;
        vm.close = $uibModalInstance.close;
        var Service;
        if (data.selectedWard) {
            Service = DeptWardPhone
        } else {
            Service = OfficeDeptPhone
        }

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                Service.get({id: id}, function (resp) {
                    vm.m = resp;
                });
            } else {
                vm.m = {};
            }
        }

        function submit(m) {
            return Dlg.addEditOk(vm, Service, function () {
                var pa = {
                    name: m.name,
                    dept_id: data.dept.id,
                    dept_ward_id: data.dept.id,
                    phone: m.phone,
                    cornet: m.cornet ? m.cornet : '',
                };
                return pa;
            });
        }
    }


})();



angular.module('c.c')
    .controller('PartyDocCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, C, F, Table, Dept, DocType, Doc) {

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var states = F.get('handle_states');
        var stateOpts = F.getNgTableOpts(states);
        $scope.cols = [
            {title: '主题', filter: {subject: 'text'}, show: true},
            {title: '编号', filter: {number: 'text'}, sortable: 'number', show: true},
            {title: '归档科室', filter: {dept: 'text'}, show: true},
            {title: '类型', filter: {type_name: 'text'}, show: true},
            {title: '申请人', filter: {applicant: 'text'}, show: true},
            {title: '申请科室', filter: {dept_from: 'text'}, show: true},
            {title: '状态', filter: {state: 'select'}, data: stateOpts, show: true}
        ];

        Dept.query({opt: 6}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.tableParams.reload();
            }
        });

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                number: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.DOC.INDEX.PARTY_DOCS;
                Table.query(Doc, url, $defer, params, 'docs', function (resp) {
                    angular.forEach(resp.docs, function (doc) {
                        doc.state = F.getItem(doc.state, states);
                        if (!doc.type) {
                            doc.type = {name: '其他'};
                        }
                    });
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.export = function (opt) {
            dialogs.create('templates/doc/export_docs_dlg.html', 'ExportDocsCtrl', {opt: opt},
                {size: 'md'});
        };

        $scope.detail = function (doc) {
            dialogs.create('templates/doc/show_dlg.html', 'DocShowDlgCtrl', {
                    id: doc.id,
                    forHospitalOffice: +doc.state.id > 2
                },
                {size: 'lg'});
        };
    });
(function () {
    angular.module('c.d')
        .controller('HospitalOfficeLeaveSearchCtrl', HospitalOfficeLeaveSearchCtrl)

    ;

    /** @ngInject */
    function HospitalOfficeLeaveSearchCtrl($scope, Table, ArrayHelper, AskForLeave,
                                           $q, LeaveType) {
        var vm = $scope;

        init();

        function init() {
            $q.all([
                LeaveType.query({opt: 2}).$promise
            ]).then(function (respArray) {
                var leaveTypes = respArray[0];

                var options = {
                    service: AskForLeave,
                    params: {opt: 24 /**/},
                    hideOpt: true,
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "users.name", title: "姓名", filter: {'users.name': "text"}},
                        {field: "depts.name", title: "科室"},
                        {
                            field: "leave_type_id",
                            title: "类别",
                            filter: {leave_type_id: "select"},
                            width: Table._3_CHAR,
                            data: Table.getNgTableOpts(leaveTypes)
                        },
                        {field: "leave_reason", title: "事由", filter: {leave_reason: "text"}},
                        {field: "day_num", title: "天数"},
                        {field: "start", title: "开始时间", width: Table._4_CHAR},
                        {field: "end", title: "结束时间", width: Table._4_CHAR}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.leave_type = ArrayHelper.getItem(item.leave_type_id, leaveTypes);
                    })
                });
            })
        }
    }
})();
angular.module('c.c').controller('MeetingManageCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Meeting, MeetingType, Dept) {
        $scope.$on('meetingBack', function (event, data) {
            $scope.tableParams.reload();
        });
        var stages = F.getApprovalStages8();
        var stagesOpts = F.getNgTableOpts(stages);
        $scope.cols = [
            {title: '科室', sortable: 'dept_id', filter: {dept: 'text'}, width: '10%', show: true},
            {title: '名称', filter: {name: 'text'}, width: '20%', show: true},
            {title: '类型', sortable: 'type_id', filter: {type_id: 'select'}, width: '10%', show: true},
            {title: '申请人', filter: {applicant: 'text'}, width: '10%', show: true},
            {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '开会时间', sortable: 'start_time', filter: {start_time: 'date_range'}, width: '20%', show: true},
            {title: '开会地点', width: '10%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        var typeCol = $scope.cols[2];
        MeetingType.query({opt: 2}, function (resp) {
            $scope.types = resp;
            typeCol.data = F.getNgTableOpts($scope.types);
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 5;
                url['date_range_filters'] = {};
                if ($scope.dateRangeFilter.created_at != null) {
                    url['date_range_filters'] = {
                        created_at: {
                            startDate: $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                if ($scope.dateRangeFilter.start_time != null) {
                    url['date_range_filters'] = {
                        start_time: {
                            startDate: $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                Meeting.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.meetings, function (meeting) {
                        meeting.stage = F.getItem(meeting.stage, stages);
                        meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                    });
                    $defer.resolve(resp.meetings);
                    $scope.meetings = resp.meetings;
                    console.log($scope.meetings);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.exportMeeting = function () {
            dialogs.create('templates/export_meeting_dlg.html', 'ExportMeetingCtrl', {},
                {size: 'md'});
        };

        $scope.approval = function (meeting) {
            dialogs.create('templates/meeting/edit_dlg.html', 'MeetingEditDlgCtrl', {
                id: meeting.id, ForApproval: true, deptId: meeting.dept_id, isHospitalOffice: true
            }, {
                size: 'lg'
            }).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议审批成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('会议室冲突');
                                break;
                            case 2:
                                toaster.warning('设备冲突');
                                break;
                            case 3:
                                toaster.warning('该会议已发布');
                                break;
                        }
                    }, function () {
                        toaster.error('会议审批失败了!');
                    }
                );
            });
        };

        $scope.edit = function (meeting) {
            dialogs.create('templates/meeting/edit_dlg.html', 'MeetingEditDlgCtrl', {
                    id: meeting.id, ForEdit: true, deptId: meeting.dept_id
                },
                {size: 'lg'}).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议修改成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('会议室冲突,请重新修改');
                                break;
                            case 2:
                                toaster.warning('设备冲突,请重新修改');
                                break;
                        }
                    }, function () {
                        toaster.error('会议修改失败了!');
                    }
                );
            });
        };

        $scope.show = function (meeting) {
            dialogs.create('templates/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                    id: meeting.id,
                    ForManage: true, SmsAgain: true,
                    ForApproval: meeting.stage.id != 4
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 1:
                        $scope.edit(meeting);
                        break;
                    case 3:
                        $scope.approval(meeting);
                        break;
                }
            });
        };

        $scope.qrcode = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl',
                {
                    meeting: meeting,
                    type: 'in',
                    qrCodeName: '签到'
                },
                {size: 'md'});
        };

        $scope.qrcode2 = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl',
                {
                    meeting: meeting,
                    type: 'out',
                    qrCodeName: '签退'
                },
                {size: 'md'});
        };

        $scope.delete = function (meeting) {
            dialogs.confirm('删除会议', '确定要删除<strong>' + meeting.name + '</strong>吗?')
                .result.then(function () {
                Meeting.delete({id: meeting.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        $scope.cancel = function (meeting) {
            dialogs.confirm('取消会议', '确定要取消<strong>' + meeting.name + '</strong>吗?')
                .result.then(function () {
                Meeting.update({id: meeting.id}).$promise.then(function (resp) {
                    toaster.success('取消成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('取消失败!');
                });
            });
        }
    });

angular.module('c.c').controller('ExportMeetingCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, C, F, SaveAs, FileHelper, data) {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        $scope.meeting = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0)
        };

        $scope.ok = function (meeting) {
            if ($scope.m_form.$valid) {
                if (meeting.start > meeting.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                params['start'] = $filter('date')(meeting.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(meeting.end, 'yyyy-MM-dd');
                params['opt'] = 1;
                meeting.downloading = true;
                FileHelper.download(C.URL.MEETING_EXPORT, params, function (resp) {
                    meeting.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = params['start'] + '到' + params['end'] + '会议考勤统计情况.xls';
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function () {
                    meeting.downloading = false;
                    toaster.error('导出失败!');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.m_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });




(function () {
    'use strict';
    MeetingTopicManageCtrl
    angular.module('c.c')
        .controller('MeetingTopicManageCtrl', MeetingTopicManageCtrl);

    /** @ngInject */
    function MeetingTopicManageCtrl($scope, $rootScope, $stateParams, F) {
        var vm = $scope;
        F.loadTabs(vm, $stateParams, $rootScope);
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('NewsApprovalCtrl', NewsApprovalCtrl)
        .controller('NewsTopCtrl', NewsTopCtrl)
        .controller('CancelNewsTopCtrl', CancelNewsTopCtrl)
        .controller('DeptEditNewsCtrl', DeptEditNewsCtrl)
    ;

    function NewsApprovalCtrl ($scope, $filter, dialogs, toaster, Table, F, News, NewsType) {
        var types;
        var vm = $scope;
        vm.approval = approval;
        vm.check = check;
        vm.edit = edit;
        vm.remove = remove;
        vm.top = top;
        vm.cancelTop = cancelTop;
        vm.stages = F.get('NewsStages');
        vm.yesNo = F.get('YesNo');
        vm.today = $filter('date')(new Date(), 'yyyy-MM-dd');

        init();


        function init () {
            NewsType.query(function (data) {
                types = data.types;
            });
            var options = {
                service: News,
                params: {opt: 8},
                optColWidth: Table._4_BTN,
                showSn: true,
                cols: [
                    {field: "title", title: "标题", filter: {title: "text"}},
                    {
                        field: 'updated_at',
                        title: '发布时间',
                        sortable: 'updated_at',
                        filter: {updated_at: 'date_range'}
                    },
                    {
                        field: "type",
                        title: "新闻类型",
                        filter: {type: "select"},
                        data: F.getNgTableOpts(types)
                    },
                    {
                        field: "out",
                        title: "发布外网",
                        filter: {out: "select"},
                        data: F.getNgTableOpts(vm.yesNo)
                    },
                    {
                        field: "is_pass",
                        title: "状态",
                        filter: {is_pass: "select"},
                        data: F.getNgTableOpts(vm.stages)
                    },
                    {field: "sender_id", title: "申请人", filter: {send_id: "text"}}
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (i) {
                    i.stage = F.getItem(i.is_pass, vm.stages);
                })
            });
        }

        function edit (news) {
            dialogs.create('templates/article/news_edit.html', 'DeptEditNewsCtrl', {
                id: news.id, types: types, edit: true
            }, {
                size: 'lg'
            }).result.then(function () {
                vm.tableParams.reload();
            });
        }

        function approval (news) {
            dialogs.create('templates/article/news_edit.html', 'DeptEditNewsCtrl', {
                id: news.id, types: types
            }, {
                size: 'lg'
            }).result.then(function () {
                vm.tableParams.reload();
            });
        }

        function check (news) {
            dialogs.create('templates/article/show_dlg.html', 'NewsShowDlgCtrl', {
                id: news.id
            }, {
                size: 'lg'
            });
        }


        function remove (news) {
            dialogs.confirm('删除新闻', '确定要删除该新闻吗?')
                .result.then(function () {
                News.delete({id: news.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('新闻删除成功!');
                            break;
                        case 1:
                            toaster.warning('!');
                            break;
                    }
                    vm.tableParams.reload();
                }, function (error) {
                    toaster.error('新闻删除失败!');
                });
            });

        }

        function top (news) {
            dialogs.create('TopDlg.html', 'NewsTopCtrl', {id: news.id}, {
                size: 'md'
            }).result.then(function () {
                vm.tableParams.reload();
            });
        }

        function cancelTop (news) {
            dialogs.create('CancelTopDlg.html', 'CancelNewsTopCtrl', {news: news}, {
                size: 'sm'
            }).result.then(function () {
                $scope.tableParams.reload();
            });
        }
    }

    function NewsTopCtrl ($scope, $filter, $uibModalInstance, toaster, News, data) {
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.dateOptions = {
            minDate: new Date()
        };

        $scope.ok = function () {
            if ($scope.end_time) {
                var params = {};
                params['pass'] = true;
                params['top_time'] = $filter('date')($scope.end_time, 'yyyy-MM-dd');
                News.update({id: data.id}, params).$promise.then(function () {
                    toaster.success('提交成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('提交失败!');
                });
            }
            else {
                toaster.warning('请输入置顶结束时间')
            }

        }
    }

    function CancelNewsTopCtrl ($scope, $uibModalInstance, toaster, News, data) {
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        var news = data.news;
        $scope.end_time = news.top_time;
        $scope.ok = function () {
            var params = {};
            params['top_time'] = news.release_time;
            News.update({id: news.id}, params).$promise.then(function () {
                toaster.success('提交成功!');
                $uibModalInstance.close();
            }, function () {
                toaster.error('提交失败!');
            })
        }
    }

    function DeptEditNewsCtrl ($scope, $sce, $uibModalInstance, dialogs, C, FileHelper, SaveAs, toaster,
                               NewsType, News, data) {
        $scope.edit = data.edit;
        $scope.approval = true;
        $scope.isNews = true;

        if (data.types) {
            $scope.types = data.types;
        } else {
            NewsType.query(function (resp) {
                $scope.types = resp.types;
            });
        }

        $scope.loading = true;
        News.get({id: data.id}, function (resp) {
            var article = resp;
            $scope.article = {
                type: {name: article.type},
                id: article.id,
                sender: article.sender,
                release_time: article.release_time,
                title: article.title,
                dept: {name: article.dept},
                body: article.body,
                attachment: article.attachments,
                is_pass: article.is_pass,
                out: article.out == '1'
            };
            $scope.article.body_sce = $sce.trustAsHtml(article.body);
            $scope.loading = false;
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.NEWS_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function () {
                attachment.downloading = false;
            });
        };

        $scope.ok = function (article) {
            if (article.title == null || article.title == '') {
                toaster.warning('标题不能为空');
            } else if (article.body == null || article.body == '') {
                toaster.warning('内容不能为空');
            } else {
                var params = {is_draft: false};
                params['dept'] = article.dept.name;
                params['title'] = article.title;
                params['body'] = article.body;
                params['type'] = article.type.name;
                params['out'] = article.out == true ? '1' : '0';
                params['opt'] = 1;  //opt为1 表明为编辑
                News.update({id: article.id}, params).$promise.then(function () {
                    toaster.success('提交成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('提交失败!');
                });
                $uibModalInstance.close(params);
            }
        };

        $scope.pass = function (article, agree) {
            if (article.title == null || article.title == '') {
                toaster.warning('标题不能为空');
            } else if (article.body == null || article.body == '') {
                toaster.warning('内容不能为空');
            } else {
                dialogs.confirm('新闻审批', '确定该新闻通过审批吗?')
                    .result.then(function () {
                    var params = {};
                    params['dept'] = article.dept.name;
                    params['title'] = article.title;
                    params['body'] = article.body;
                    params['type'] = article.type.name;
                    params['opt'] = 2;  //opt为2表明审核
                    params['out'] = article.out == true ? '1' : '0';
                    params['home'] = data.home;
                    params['agree'] = agree;   //表明此次审批是通过还是拒绝

                    News.update({id: article.id}, params).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 1:
                                toaster.success('该新闻已发布!');
                                break;
                            case 0:
                                toaster.success('审核成功!');
                                break;
                        }
                        $uibModalInstance.close();
                    }, function () {
                        toaster.error('审核失败!');
                    })
                });
            }
        };

        $scope.back = function (news) {
            dialogs.create('templates/article/back.html', 'NewsBackDlgCtrl', {
                id: news.id,
                is_pass: $scope.article.is_pass
            }, {
                size: 'xs'
            }).result.then(function (data) {
                News.update({id: news.id}, data).$promise.then(function () {
                    toaster.success('退回成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('退回失败!');
                });
            });
        };
    }

})();

angular.module('c.c').controller('RuleManageCtrl',
    function () {
    });


(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalOfficeUserInfoCtrl', HospitalOfficeUserInfoCtrl)
        .controller('UserChangeTypeCtrl', UserChangeTypeCtrl)
        .controller('ChangeTypeRecordCtrl', ChangeTypeRecordCtrl)
        .controller('KpiRecordCtrl', KpiRecordCtrl)
        .controller('AddKpiCtrl', AddKpiCtrl)
        .controller('ExportUserInfoDlgCtrl', ExportUserInfoDlgCtrl)
    ;

    /** @ngInject */
    function HospitalOfficeUserInfoCtrl($scope, $q, $filter, dialogs, Dlg, toaster, NgTableParams, User, UserOnType, F, ArrayHelper, JobTitle) {
        var sexesOpts = F.getNgTableOpts(F.get('sexes'));
        var eduBgs = F.get('edu_bg_list');
        var eduBgOpts = F.getNgTableOpts(eduBgs);
        var enLvs = F.get('eg_lv_list');
        var posts = F.get('posts');
        var enLvOpts = F.getNgTableOpts(enLvs);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        //var titleOpts = F.getNgTableOpts(F.get('titles'));
        var postOpts = F.getNgTableOpts(F.get('posts'));
        $scope.titleTypes = JobTitle.getTypes();
        var typeOpts = F.getNgTableOpts($scope.titleTypes);
        $scope.titleLevels = User.getTitleLevel();
        var levelOpts = F.getNgTableOpts($scope.titleLevels);

        $scope.hospital = hospital;
        $scope.change = change;

        $scope.cols = [
            /* 基本信息 */
            {title: '姓名', sortable: 'name', filter: {name: 'text'}, field: 'name', type: 0xff}, //0
            { //1
                title: '主科室',
                filter: {main_dept: 'text'},
                field: 'main_dept',
                type: 0x01
            },
            { //2
                title: '性别',
                filter: {sex: 'select'},
                data: sexesOpts,
                field: 'sex',
                type: 0x01
            },
            { //3
                title: '出生日期',
                sortable: 'birthday',
                filter: {birthday: 'date_range'},
                field: 'birthday',
                type: 0x01
            },
            { //4
                title: '民族',
                sortable: 'nation_id',
                field: 'nation_id',
                filter: {nation_id: 'select'},
                type: 0x01
            },
            { //5
                title: '籍贯',
                sortable: 'native_place',
                field: 'native_place',
                filter: {native_place: 'text'},
                type: 0x01
            },
            /*账户信息*/
            { //7
                title: '用户名',
                sortable: 'username',
                filter: {username: 'text'},
                field: 'username',
                type: 0x02
            },
            {title: '邮箱', sortable: 'email', filter: {email: 'text'}, field: 'email', type: 0x02},//8

            /*教育背景*/
            { //9
                title: '毕业学校',
                filter: {graduate_school: 'text'},
                field: 'graduate_school',
                type: 0x04
            },
            {  //10
                title: '政治面貌',
                filter: {political_status_id: 'select'},
                field: 'political_status_id',
                type: 0x04
            },
            //{title: '所学专业', filter: {major: 'text'}, field: 'major', type: 0x04},//11
            {  //11
                title: '专业',
                sortable: 'major_id',
                filter: {major_id: 'select'},
                field: 'major_id',
                type: 0x04
            },
            {  //12
                title: '学历',
                sortable: 'edu_bg',
                filter: {edu_bg: 'select'},
                data: eduBgOpts,
                field: 'edu_bg',
                type: 0x04
            },
            {title: '学位', sortable: 'degree', filter: {degree: 'text'}, field: 'degree', type: 0x04},//13
            { //14
                title: '英语等级',
                filter: {en_lv: 'select'},
                data: enLvOpts,
                field: 'en_lv',
                type: 0x04
            },

            /* 联系方式 */
            {title: '手机', filter: {phone: 'text'}, field: 'phone', type: 0x08}, //15
            {title: '手机集团小号', filter: {cornet: 'text'}, field: 'cornet', type: 0x08},//16
            {title: '备用手机', filter: {phone2: 'text'}, field: 'phone2', type: 0x08},//17
            {//18
                title: '办公室电话',
                filter: {office_phone: 'text'},
                field: 'office_phone',
                type: 0x08
            },
            {//19
                title: '办公室小号',
                filter: {office_cornet: 'text'},
                field: 'office_cornet',
                type: 0x08
            },

            {title: 'QQ', filter: {qq: 'text'}, field: 'qq', type: 0x08},//20
            {title: '联系地址', filter: {address: 'text'}, field: 'address', type: 0x08},//21

            /* 工作相关 */
            { //22
                title: '编制类型',
                sortable: 'status_id',
                filter: {status_id: 'select'},
                field: 'status_id', type: 0x10
            },
            { //23
                title: '类别',
                sortable: 'type_id',
                filter: {type_id: 'select'},
                field: 'type_id', type: 0x10
            },
            {  //24
                title: '工资卡',
                filter: {salary_card: 'text'},
                field: 'salary_card',
                type: 0x10
            },
            { //24
                title: '参加工作时间',
                sortable: 'started_work',
                filter: {started_work: 'date_range'},
                field: 'started_work',
                type: 0x10
            },
            { //25
                title: '入职时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                type: 0x10
            },
            { //26
                title: '入职类型',
                sortable: 'entry_type_id',
                filter: {entry_type_id: 'select'},
                field: 'entry_type_id', type: 0x10
            },
            { //27
                title: '中层以上干部',
                filter: {is_cadre: 'select'},
                data: yesNoOpts,
                field: 'is_cadre', type: 0x10
            },
            { //27
                title: '职称',
                filter: {title_id: 'select'},
                field: 'title', type: 0x10
            },
            { //27
                title: '职务',
                filter: {post: 'select'},
                data: postOpts,
                field: 'post', type: 0x10
            },
            { //27
                title: '职称类型',
                filter: {title_type: 'select'},
                data: typeOpts,
                field: 'title_type', type: 0x10
            },
            { //27
                title: '等级',
                filter: {level: 'select'},
                data: levelOpts,
                field: 'level', type: 0x10
            },
            { //27
                title: '钉钉号',
                field: 'dd_user_id', type: 0x10
            },
            // { //28
            //     title: '全院调查对象',
            //     filter: {is_hospital_respondent: 'select'},
            //     data: yesNoOpts,
            //     field: 'is_hospital_respondent', type: 0x01
            // },
            {title: '备注', filter: {comments: 'text'}, field: 'comments', type: 0x08},//29
            { //30
                title: '毕业时间',
                sortable: 'graduate_time',
                filter: {graduate_time: 'date_range'},
                field: 'graduate_time',
                type: 0x10
            },
            { //31
                title: '专技聘任时间',
                sortable: 'title_time',
                filter: {title_time: 'date_range'},
                field: 'title_time',
                type: 0x10
            },
            { //32
                title: '专职聘任时间',
                sortable: 'post_time',
                filter: {post_time: 'date_range'},
                field: 'post_time',
                type: 0x10
            },
            {//33
                title: '身份证号',
                filter: {idcard: 'text'},
                field: 'idcard',
                type: 0x08
            }

        ];

        $scope.optColWidth = 45;

        //$scope.depts_col = $scope.cols[1];
        $scope.nations_col = $scope.cols[4];
        $scope.political_statuses_col = $scope.cols[9];
        $scope.statuses_col = $scope.cols[21];
        $scope.user_types_col = $scope.cols[22];
        $scope.entry_types_col = $scope.cols[26];
        $scope.majors_col = $scope.cols[10];
        $scope.title_col = $scope.cols[28];
        //$scope.leave_reasons_col = $scope.cols[30];

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.visibleOptions = [
            {title: '基本信息', value: 0x01},
            {title: '账户信息', value: 0x02},
            {title: '教育背景', value: 0x04},
            {title: '联系方式', value: 0x08},
            {title: '工作相关', value: 0x10},
            //{divider: true},
            {title: '全部信息', value: 0xff}
        ];
        $scope.option = {title: '基本信息', value: 1};

        $scope.optionSelectedFn = function (option) {
            $scope.option = option;
            angular.forEach($scope.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                } else {
                    col.show = false;
                }
            });
        };

        $scope.optionSelectedFn($scope.option);

        $scope.optInFront = true;
        $scope.hideOpt = true;
        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 30
        }, {
            counts: [30, 50, 100],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['date_range_filters'] = $scope.dateRangeFilter;
                url['opt'] = 1;
                url['show_unconfirmed'] = !$scope.showAllUsers;
                url['is_leaved'] = 0;
                User.query(url, function (data) {
                    var users = data.users;
                    $scope.statuses = data.statuses;
                    angular.forEach(users, function (u) {
                        u.edu_bg = F.getItem(u.edu_bg, eduBgs);
                        u.en_lv = F.getItem(u.en_lv, enLvs);
                        u.post = F.getItem(u.post, posts);
                        u.level = F.getItem(u.level, $scope.titleLevels);
                        if (u.title && u.title.type) {
                            u.title_type = ArrayHelper.getItem(u.title.type, $scope.titleTypes);
                        }
                    });

                    //$scope.depts_col.data = F.getNgTableOpts(data.depts);
                    $scope.nations_col.data = F.getNgTableOpts(data.nations);
                    $scope.majors_col.data = F.getNgTableOpts(data.majors);
                    $scope.statuses_col.data = F.getNgTableOpts(data.statuses);
                    $scope.user_types_col.data = F.getNgTableOpts(data.types);
                    $scope.entry_types_col.data = F.getNgTableOpts(data.entry_types);
                    //$scope.leave_reasons_col.data = F.getNgTableOpts(data.leave_reasons);
                    $scope.political_statuses_col.data = F.getNgTableOpts(data.political_statuses);
                    $scope.title_col.data = F.getNgTableOpts(data.titles);

                    params.total(data.total);
                    $defer.resolve(users);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.showAllUsers = true;
        $scope.filterConfirmState = function () {
            $scope.showAllUsers = !$scope.showAllUsers;
            $scope.tableParams.reload();
        };

        $scope.edit = function (user) {
            dialogs.create('templates/user_edit_dlg.html', 'UserEditCtrl',
                {user_id: user.id, sys_edit: true, confirm_state: '2'}, {

                    size: 'lg'
                }).result.then(function (params) {
                toaster.success('用户信息修改成功!');
                if (user.id == $scope.account.id) {
                    $scope.account.confirm_state = 2; //2表示人事科已确认
                }
                $scope.tableReload();
            });
        };

        $scope.exportDn = function () {
            Dlg.show({
                template: 'templates/export/ExportUserInfoDlg.html',
                ctrl: 'ExportUserInfoDlgCtrl',
                data: {}
            }).then(function () {
                Dlg.s('用户信息导出成功!');
            })
        };

        $scope.changeType = function (user) {              //修改用户编制信息
            dialogs.create('changeOnTypeDlg.html', 'UserChangeTypeCtrl',
                {user: user, statuses: $scope.statuses}, {

                    size: 'md'
                }).result.then(function (user) {
                UserOnType.save(user).$promise.then(function () {
                    toaster.success('用户编制信息修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('用户编制信息修改失败!');
                });

            });
        };

        $scope.changeRecord = function (user) {              //查看编制修改记录
            dialogs.create('changeTypeRecord.html', 'ChangeTypeRecordCtrl',
                {user: user}, {

                    size: 'md'
                });
        };

        $scope.kpi = function (user) {              //查看绩效系数记录
            dialogs.create('kpiRecord.html', 'KpiRecordCtrl',
                {user: user}, {

                    size: 'md'
                });
        };

        $scope.changePwd = changePwd;

        function changePwd(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: user}
            }).then(function () {
                $scope.tableReload();
            });
        }

        $scope.clearWxBind = clearWxBind;
        $scope.bindDingTalk = bindDingTalk;


        function clearWxBind(user) {
            User.update({id: user.id}, {
                opt: 4 // OPT_CLEAR_BIND
            }).$promise.then(function (resp) {
                if (resp.result == 0) {
                    Dlg.s('解绑成功');
                    user.wx_bind = null;
                }
            });
        }

        function bindDingTalk(user) {
            Dlg.comment({title: '绑定钉钉号(空置解绑)', label: '钉钉号', notRequired: true}, function (ddId) {
                User.update({id: user.id}, {
                    opt: 10, dd_user_id: ddId ? ddId : null
                }).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $scope.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            });
        }

        $scope.delete = function (user) {
            dialogs.confirm('删除员工记录', '确定要删除<strong>' + user.name + '</strong>的员工记录吗?')
                .result.then(function () {
                User.delete({id: user.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('员工记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('该员工属于科室成员,无法直接删除');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('员工记录删除失败!');
                });
            });
        };

        $scope.transfer = function (user) {
            dialogs.create('templates/dept_record_dlg.html', 'DeptRecordDlgCtrl',
                {user: user, hideOpt: false}, {

                    size: 'lg'
                });
        };

        function hospital() {
            Dlg.show({
                template: 'directives/form/user-selector/user_selector_dlg.html',
                ctrl: 'UserSelectCtrl',
                data: {
                    title: '全院调查对象设置', multiSelect: true, forReceive: true
                }
            }).then(function (pa) {
                if (pa.selected.length > 0) {
                    var params = {};
                    params['opt'] = 11;
                    params['members'] = ArrayHelper.listKey(pa.selected);
                    params['result'] = pa.result;
                    User.update({id: '-'}, params).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $scope.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                        else console.log('error', error);
                    });
                }
            });
        }

        function change(user) {
            var params = {};
            params['opt'] = 11;
            params['members'] = [user.id];
            params['result'] = user.is_hospital_respondent == 0;
            User.update({id: '-'}, params).$promise.then(function (resp) {
                $scope.tableReload();
            }, function (error) {
                if (error.data) Dlg.e(error.data.msg);
                else console.log('error', error);
            });
        }
    }

    /** @ngInject */
    function UserChangeTypeCtrl($scope, $uibModalInstance, toaster, User, data) {
        var user = data.user;
        $scope.statuses = data.statuses;
        $scope.user = {id: user.id, username: user.username, status: user.status, time: new Date()};
        $scope.ok = function (user) {
            if ($scope.otype_form.$valid) {
                var pa = {};
                pa['username'] = user.username;
                pa['status_id'] = user.status.id;
                pa['user_id'] = user.id;
                pa['time'] = user.time;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                $scope.otype_form.submitted = true;
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function ChangeTypeRecordCtrl($scope, $uibModalInstance, toaster, NgTableParams, UserOnType, Table, F, $filter, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                Table.query(UserOnType, url, $defer, params, 'onTypes');
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function KpiRecordCtrl($scope, $uibModalInstance, toaster, NgTableParams, UserKpi, dialogs, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                url['opt'] = 2;
                UserKpi.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.add_kpi = function (user) {              //人事科对人员进行评估或直接输入绩效系数
            dialogs.create('add_kpi.html', 'AddKpiCtrl',
                {user: user}, {

                    size: 'md'
                }).result.then(function (pa) {
                if (pa) {
                    UserKpi.save(pa).$promise.then(function () {
                        toaster.success('用户绩效系数添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('用户绩效系数添加失败!');
                    });
                } else {
                    $scope.tableReload();
                }
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function AddKpiCtrl($scope, $uibModalInstance, toaster, User, dialogs, UserKpi, data) {
        var user = data.user;

        $scope.user_kpi = {direct: '1'};
        $scope.ok = function (user_kpi) {
            if (user_kpi.direct == 1) {
                if (!user_kpi.real_kpi) {
                    toaster.warning('请输入员工绩效系数!');
                } else {
                    var pa = {};
                    pa['user_id'] = user.id;
                    pa['real_kpi'] = user_kpi.real_kpi;
                    $uibModalInstance.close(pa);
                }
            } else {
                $scope.cancel();
            }
        };

        $scope.kpi = function () {
            dialogs.create('templates/kpi/user_kpi.html', 'UserKpiCtrl', {
                record: {user_id: user.id}
            }, {
                size: 'md'
            }).result.then(function (kpi) {
                UserKpi.save(kpi).$promise.then(function () {
                    toaster.success('员工绩效系数添加成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('员工绩效系数添加失败!');
                });
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function ExportUserInfoDlgCtrl($uibModalInstance, User, FileHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.m = {is_cadre: 0};

        init();


        function init() {
            User.get({id: 0}).$promise.then(function (resp) {
                vm.depts = resp.depts;
                if (vm.depts && vm.depts.length > 0) {
                    vm.depts.splice(0, 0, {name: '全部科室'});
                    vm.m.dept = vm.depts[0];
                }
                vm.types = resp.types;
            })
        }

        function ok(m) {
            var pa = {
                dept_id: m.dept ? m.dept.id : undefined,
                is_cadre: m.is_cadre,
                types: []
            };
            angular.forEach(m.type, function (type) {
                pa.types.push(type.id)
            });

            FileHelper.dnExcel(User.urls.EXPORT_USER_INFO,
                pa, '员工信息表.xls', function () {
                    vm.close();
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('WorkArrangeCtrl', WorkArrangeCtrl)
        .controller('WorkArrangeDlgCtrl', WorkArrangeDlgCtrl)
    ;

    /** @ngInject */
    function WorkArrangeCtrl($scope, $filter, $stateParams, $timeout, dialogs, toaster, FileHelper,
                             NgTableParams, AskForLeave, SaveAs, C, F, Dlg, Api) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');

        $scope.cols = [
            {title: '人员', width: '25%', show: true}, //6
            {
                title: '类别',
                sortable: 'leave_type_id',
                filter: {leave_type_id: 'select'},
                field: 'leave_type_id',
                width: '8%',
                show: true
            }, //6
            {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
            {title: '天数', field: 'day_num', show: true}, //6
            {
                title: '附件',
                field: 'has_paper',
                show: true
            }, //6
            {
                title: '附件类型',
                sortable: 'type_id',
                filter: {'type_id': 'select'},
                field: 'type_id',
                width: '100',
                show: true
            }, //6
            {
                title: '是否补助',
                sortable: 'is_subsidy',
                filter: {is_subsidy: 'select'},
                field: 'is_subsidy',
                width: '100',
                data: yesNoOpts,
                show: true
            }, //6
            {title: '开始时间', filter: {start: 'date_range'}, field: 'start', width: '10%', show: true},
            {title: '结束时间', filter: {end: 'date_range'}, field: 'end', width: '10%', show: true}
        ];

        $scope.leave_type_col = $scope.cols[1];
        $scope.attach_type_col = $scope.cols[5];

        if ($stateParams.data.fileId) {
            var fileId = $stateParams.data.fileId;
            var fileSubject = $stateParams.data.fileSubject;
            $timeout(function () {
                add(fileId, fileSubject);
            }, 1000);
        }

        $scope.download = function (m) {
            var params = {name: m.attach_name, filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.optColWidth = 30;
        $scope.optInFront = true;
        $scope.hideOpt = false;

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );


        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.dateRangeFilter.start != null) {
                    var startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                    var endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        start: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.end != null) {
                    var startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                    var endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        end: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                url['opt'] = 15;
                AskForLeave.query(url, function (data) {
                    $scope.expense_items = data.expense_items;
                    $scope.dept = data.dept;
                    $scope.leave_types = data.leave_types;
                    $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                    $scope.attach_types = data.attach_types;
                    $scope.attach_type_col.data = F.getNgTableOpts($scope.attach_types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = add;

        function add(fileId, fileSubject) {
            Api.loadMod('file_circulate', function () {
                dialogs.create('templates/leave/work_arrange_dlg.html', 'WorkArrangeDlgCtrl', {
                    leave_types: $scope.leave_types,
                    attach_types: $scope.attach_types,
                    is_arrange: 1,
                    expense_items: $scope.expense_items,
                    fileId: fileId, fileSubject: fileSubject
                }, {
                    size: 'md'
                }).result.then(function (leave) {
                    AskForLeave.save(leave).$promise.then(function (data) {
                        toaster.success('差务安排成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('差务安排失败!');
                    });
                });
            });
        }

        $scope.edit = function (record) {
            dialogs.create('templates/leave/work_arrange_dlg.html', 'WorkArrangeDlgCtrl', {
                leave: record,
                leave_types: $scope.leave_types,
                attach_types: $scope.attach_types,
                expense_items: $scope.expense_items
            }, {
                size: 'md'
            }).result.then(function (leave) {
                AskForLeave.update({id: record.id}, leave).$promise.then(function (data) {
                    toaster.success('差务安排修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('差务安排修改失败!');
                });
            });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除请假记录', '确定要删除编号为<strong>' + record.id + '</strong>的记录吗?')
                .result.then(function () {
                AskForLeave.delete({id: record.id}).$promise.then(function (resp) {
                    toaster.success('请假记录删除成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('请假记录删除失败!');
                });
            });

        };

        $scope.showFile = function (m) {
            if (m.file_id) {
                Api.loadMod('file_circulate', function () {
                    Dlg.show({
                        template: 'pages/dlg/file_circulate/show_dlg.html',
                        ctrl: 'FileShowDlgCtrl',
                        data: {
                            id: m.file_id,
                            ForPrint: true
                        },
                        size: 'lg'
                    });
                });
            }
        };
    }

    /** @ngInject */
    function WorkArrangeDlgCtrl($scope, $uibModalInstance, $filter, C, toaster, Upload,
                                dialogs, uibDateParser, File, data, DateHelper, AskForLeave, Dlg) {
        $scope.leave_types = data.leave_types;
        $scope.attach_types = data.attach_types;
        $scope.is_arrange = data.is_arrange;
        $scope.expense_items = data.expense_items;

        if (data.leave) {
            var leave = data.leave;
            $scope.$edit = true;
            $scope.leave = {
                leave_type: leave.leave_type,
                has_paper: leave.has_paper == '1',
                start: uibDateParser.parse(leave.start, 'yyyy-MM-dd'),
                end: uibDateParser.parse(leave.end, 'yyyy-MM-dd'),
                start_spot: leave.start_spot,
                end_spot: leave.end_spot,
                is_subsidy: leave.is_subsidy == '1',
                attach_type: leave.type,
                leave_reason: leave.leave_reason,
                attach_name: leave.attach_name, attach_mime: leave.attach_mime,
                attach_filename: leave.attach_filename, attach_size: leave.attach_size,
                users: leave.all_users
            }
        } else {
            $scope.leave = {
                leave_type: $scope.leave_types[0],
                has_paper: false,
                start: new Date(),
                end: new Date(),
                start_spot: '1',
                end_spot: '0',
                is_subsidy: false,
                attach_type: $scope.attach_types[0],
                airfare: false
            };
            if (data.fileId) {
                $scope.leave.file = {id: data.fileId, subject: data.fileSubject};
            }

            $scope.go = {};
            $scope.be_back = {};
        }
        $scope.$watch('leave.start', leaveTimeChanged);
        $scope.$watch('leave.end', leaveTimeChanged);
        $scope.$watch('leave.start_spot', leaveTimeChanged);
        $scope.$watch('leave.end_spot', leaveTimeChanged);

        function leaveTimeChanged(n, o) {
            var invalid, m = $scope.leave;

            if (angular.isDefined(n) && angular.isUndefined(o)) return;

            $scope.leave.day_num = NaN;
            $scope.leave.dayNumTip = false;

            $scope.work_arrange_form.day_num.$setValidity('zero', true);

            var valid = isNaN($scope.leave.day_num) ? true : Number.isInteger($scope.leave.day_num * 2);
            $scope.work_arrange_form.day_num.$setValidity('dayNumFormat', valid);

            if (!m.start || !m.end) return;

            var days = DateHelper.diffInDays(m.start, m.end);
            var start_spot = m.start_spot == 1 ? 0 : 0.5;
            var end_spot = m.end_spot == 1 ? 0.5 : 1;
            //  年休假5 育儿假44 支援西藏疫情后休假39 只算工作日
            if (m.leave_type.id == 5 || m.leave_type.id == 44 || m.leave_type.id == 39) {
                $scope.calculating = true;
                // 开始计算年休假的请假时间...
                AskForLeave.calcDayNum({
                    start: DateHelper.date2Str(m.start),
                    start_spot: m.start_spot == 1 ? false : true,
                    end: DateHelper.date2Str(m.end),
                    end_spot: m.end_spot == 1 ? false : true
                }).$promise.then(function (resp) {
                    if (resp.result === 1) {
                        $scope.leave.day_num = resp.num;
                        $scope.leave.dayNumTip = resp.tip;
                        $scope.work_arrange_form.day_num.$setValidity('zero', $scope.leave.day_num > 0);
                    } else {
                        Dlg.w('结束时间不能小于开始时间');
                    }

                }).finally(function () {
                    $scope.calculating = false;
                });
            } else {
                $scope.leave.day_num = days + (end_spot - start_spot);
                $scope.work_arrange_form.day_num.$setValidity('zero', $scope.leave.day_num > 0);
            }
        }

        $scope.dayNumChange = function () {
            var valid = isNaN($scope.leave.day_num) ? true : Number.isInteger($scope.leave.day_num * 2);
            $scope.work_arrange_form.day_num.$setValidity('dayNumFormat', valid);
            $scope.work_arrange_form.day_num.$setValidity('zero', $scope.leave.day_num > 0);
        };

        var getFileInfo = true;
        $scope.upload = function (file, leave) {
            if (file == null) {
                return;
            }

            if (file.$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + file.$errorParam + '</strong>' + '\n' + file.name);
                return;
            }
            if (!file.$error) {
                $scope.progress = 0;
                getFileInfo = false;
                Upload.upload({
                    url: C.URL.OP_UPLOAD, file: file
                }).progress(function (evt) {
                    $scope.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (resp) {
                    switch (resp.result) {
                        case 0:
                            leave.attach_name = resp.attach_name;
                            leave.attach_mime = resp.attach_mime;
                            leave.attach_filename = resp.attach_filename;
                            leave.attach_size = resp.attach_size;
                            getFileInfo = true;
                            break;
                        case 1:
                            $scope.progress = -1;
                            $scope.errorInfo = '服务器空间不足!';
                            break;
                    }
                }).error(function () {
                    $scope.progress = -1;
                    $scope.errorInfo = '服务器错误!';
                });
            }
        };

        $scope.airfare = function () {
            dialogs.create('/templates/airfare/oairfare_dlg.html', 'OAirfareDlgCtrl', {
                leave: $scope.leave,
                users: $scope.leave.users,
                go: $scope.go,
                be_back: $scope.be_back
            }, {
                size: 'md'
            }).result.then(function (para) {
                $scope.para = para;
                $scope.go = para['go'];
                $scope.be_back = para['be_back'];
                $scope.users = para['users'];
                $scope.leave.airfare = true;
            });
        };

        $scope.ok = function (leave) {
            if ($scope.work_arrange_form.$valid) {
                if (leave.start > leave.end) {
                    toaster.warning('请假中开始时间不能大于结束时间,请仔细检查!');
                    $scope.work_arrange_form.submitted = true;
                } else if (!getFileInfo) {
                    toaster.warning('附件可能还没传完,请再等待2秒钟!');
                } else {
                    var params = {};
                    params['start'] = $filter('date')(leave.start, 'yyyy-MM-dd');
                    params['end'] = $filter('date')(leave.end, 'yyyy-MM-dd');
                    params['leave_type_id'] = leave.leave_type.id;
                    params['leave_reason'] = leave.leave_reason;
                    params['has_paper'] = leave.has_paper;
                    params['leave_reason'] = leave.leave_reason;
                    params['opt'] = 2;    //表明为差务安排
                    params['start_spot'] = leave.start_spot;
                    params['end_spot'] = leave.end_spot;
                    params['day_num'] = leave.day_num;
                    params['is_arrange'] = data.is_arrange;  //数据库表明为差务安排\
                    if ($scope.users) {
                        params['users'] = $scope.users;
                    } else {
                        params['users'] = leave.users;
                    }
                    if (leave.file) params['file_id'] = leave.file.id;

                    if (leave.has_paper) {
                        params['type_id'] = leave.attach_type.id;
                        params['attach_name'] = leave.attach_name;
                        params['attach_mime'] = leave.attach_mime;
                        params['attach_filename'] = leave.attach_filename;
                        params['attach_size'] = leave.attach_size;
                    }
                    params['is_subsidy'] = leave.is_subsidy == true ? 1 : 0;
                    if (leave.is_subsidy) {
                        var items = [];
                        for (var i = 0; i < $scope.expense_items.length; i++) {
                            if ($scope.expense_items[i].is_checked) {
                                items.push($scope.expense_items[i].id);
                            }
                            params['items'] = items;
                        }
                    }

                    params['airfare'] = leave.airfare;
                    if (leave.airfare) {
                        params['go'] = $scope.go;
                        params['be_back'] = $scope.be_back;
                    }
                    $uibModalInstance.close(params);
                }
            } else {
                toaster.warning('表单中有错误!');
                $scope.work_arrange_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.refreshFiles = function ($select) {
            $select.refreshing = true;

            File.query({op: 'search', search_str: $select.search}).$promise.then(function (resp) {
                $scope.files = resp.items;
            }).finally(function () {
                $select.refreshing = false;
            });
        };

        $scope.clearFileSelected = function (m) {
            delete m.file;
        };
    }

})();

(function () {
    'use strict';
    angular.module('c.c')
        .controller('MeetingTopicMainCtrl', MeetingTopicMainCtrl);

    /** @ngInject */
    function MeetingTopicMainCtrl($scope, $rootScope, $stateParams, F) {
        var vm = $scope;
        F.loadTabs(vm, $stateParams, $rootScope);
    }

})();


angular.module('c.c')
    .controller('MainMissionCtrl', function ($scope) {

    });
(function () {
    'use strict';

    angular.module('c')
        .controller('MeetingNoticeDlgCtrl', MeetingNoticeDlgCtrl);

    /** @ngInject */
    function MeetingNoticeDlgCtrl($uibModalInstance, data, Dlg, Meeting) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.ok = ok;

        init();


        function init() {
            //vm.existMembers = data.existMembers;
            vm.file = {
                wx_remind: true,
                sms_remind: false
            }
        }

        function ok(m) {
            var pa = {
                wx_remind: m.wx_remind,
                sms_remind: m.sms_remind,
            };
            Meeting.update({id: data.id, opt: 7 /* 微信通知*/}, pa).$promise.then(function (resp) {
                Dlg.s('通知成功');
                vm.close();
            }, function (e) {
                Dlg.e(e);
            });
        }

    }

})();
angular.module('c.c')
    .controller('MedicalDutyFeeApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyReport, F) {

    });

angular.module('c.d')
    .controller('MedicalStaffCtrl', ['$scope', '$q', '$filter', 'dialogs', 'toaster', 'NgTableParams',
        'User', 'UserOnType', 'F', 'C', 'FileHelper', 'SaveAs', 'JobTitle',
        function ($scope, $q, $filter, dialogs, toaster, NgTableParams, User, UserOnType, F, C, FileHelper, SaveAs, JobTitle) {
            var sexesOpts = F.getNgTableOpts(F.get('sexes'));
            var eduBgs = F.get('edu_bg_list');
            var eduBgOpts = F.getNgTableOpts(eduBgs);
            var enLvs = F.get('eg_lv_list');
            //var titles = F.get('titles');
            var posts = F.get('posts');
            var enLvOpts = F.getNgTableOpts(enLvs);
            var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            //var titleOpts = F.getNgTableOpts(F.get('titles'));
            var postOpts = F.getNgTableOpts(F.get('posts'));
            $scope.titleTypes = JobTitle.getTypes();
            var typeOpts = F.getNgTableOpts($scope.titleTypes);
            $scope.titleLevels = User.getTitleLevel();
            var levelOpts = F.getNgTableOpts($scope.titleLevels);

            $scope.cols = [
                { //7
                    title: '工号',
                    sortable: 'username',
                    filter: {username: 'text'},
                    field: 'username',
                    type: 0xff
                },
                {title: '姓名', sortable: 'name', filter: {name: 'text'}, field: 'name', type: 0xff}, //1
                { //2
                    title: '主科室',
                    filter: {main_dept: 'text'},
                    field: 'main_dept',
                    type: 0x01
                },
                { //3
                    title: '性别',
                    filter: {sex: 'select'},
                    data: sexesOpts,
                    field: 'sex',
                    type: 0x01
                },
                { //4
                    title: '民族',
                    sortable: 'nation_id',
                    field: 'nation_id',
                    filter: {nation_id: 'select'},
                    type: 0x01
                },
                {title: '邮箱', sortable: 'email', filter: {email: 'text'}, field: 'email', type: 0x01},//5
                {title: '手机', filter: {phone: 'text'}, field: 'phone', type: 0x01}, //6
                {title: '手机集团小号', filter: {cornet: 'text'}, field: 'cornet', type: 0x01},//7

                {  //8
                    title: '专业',
                    sortable: 'major_id',
                    filter: {major_id: 'select'},
                    field: 'major_id',
                    type: 0x02
                },
                {  //9
                    title: '学历',
                    sortable: 'edu_bg',
                    filter: {edu_bg: 'select'},
                    data: eduBgOpts,
                    field: 'edu_bg',
                    type: 0x02
                },
                {title: '学位', sortable: 'degree', filter: {degree: 'text'}, field: 'degree', type: 0x02},//10
                { //11
                    title: '英语等级',
                    filter: {en_lv: 'select'},
                    data: enLvOpts,
                    field: 'en_lv',
                    type: 0x02
                },

                { //12
                    title: '编制类型',
                    sortable: 'status_id',
                    filter: {status_id: 'select'},
                    field: 'status_id', type: 0x02
                },
                { //13
                    title: '类别',
                    sortable: 'type_id',
                    filter: {type_id: 'select'},
                    field: 'type_id', type: 0x02
                },
                { //14
                    title: '中层以上干部',
                    filter: {is_cadre: 'select'},
                    data: yesNoOpts,
                    field: 'is_cadre', type: 0x02
                },
                { //15
                    title: '职称',
                    filter: {title_id: 'select'},
                    field: 'title', type: 0x02
                },
                { //16
                    title: '职务',
                    filter: {post: 'select'},
                    data: postOpts,
                    field: 'post', type: 0x02
                },
                { //27
                    title: '职称类型',
                    filter: {title_type: 'select'},
                    data: typeOpts,
                    field: 'title_type', type: 0x02
                },
                { //27
                    title: '等级',
                    filter: {level: 'select'},
                    data: levelOpts,
                    field: 'level', type: 0x02
                }
            ];

            $scope.optColWidth = 45;

            $scope.nations_col = $scope.cols[4];
            $scope.majors_col = $scope.cols[8];
            $scope.statuses_col = $scope.cols[12];
            $scope.user_types_col = $scope.cols[23];
            $scope.title_col = $scope.cols[15];

            $scope.visibleOptions = [
                {title: '基本信息', value: 0x01},
                {title: '工作相关', value: 0x02}
            ];
            $scope.option = {title: '基本信息', value: 1};

            $scope.optionSelectedFn = function (option) {
                $scope.option = option;
                angular.forEach($scope.cols, function (col) {
                    if (col.type & option.value) {
                        col.show = true;
                    } else {
                        col.show = false;
                    }
                });
            };

            $scope.optionSelectedFn($scope.option);

            $scope.tableParams = new NgTableParams({
                page: 1,
                count: 30
            }, {
                counts: [30, 50, 100],
                total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = 20;   //医务科临床医技人员查询
                    User.query(url, function (data) {
                        var users = data.users;
                        $scope.statuses = data.statuses;
                        angular.forEach(users, function (u) {
                            u.edu_bg = F.getItem(u.edu_bg, eduBgs);
                            u.en_lv = F.getItem(u.en_lv, enLvs);
                            //u.title = F.getItem(u.title, titles);
                            u.post = F.getItem(u.post, posts);
                            u.level = F.getItem(u.level, $scope.titleLevels);
                            if (u.title) {
                                u.title_type = F.getItem(u.title.type, $scope.titleTypes);
                            }
                        });

                        $scope.nations_col.data = F.getNgTableOpts(data.nations);
                        $scope.majors_col.data = F.getNgTableOpts(data.majors);
                        $scope.statuses_col.data = F.getNgTableOpts(data.statuses);
                        $scope.title_col.data = F.getNgTableOpts(data.titles);

                        params.total(data.total);
                        $defer.resolve(users);
                    });
                }
            });

            $scope.clearFilters = function () {
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };
            $scope.showAllUsers = true;

            $scope.setStop = function setStop(user) {
                user.team_leader = user.team_leader == 1 ? 0 : 1;
                var params = {};
                params['opt'] = 12;
                params['team_leader'] = user.team_leader;
                User.update({id: user.id}, params).$promise.then(function (resp) {
                    $scope.tableReload();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                });
            };

            $scope.export = function () {
                var params = {};
                FileHelper.download(C.URL.MEDICAL_STAFF_DOWNLOAD, params, function (resp) {
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = '临床医技员工信息表.xls';
                    SaveAs.download(data, filename, options);
                }, function (error) {
                    toaster.error('导出失败!');
                });
            };

        }]);
angular.module('c.c')
    .controller('SeniorityCtrl', function ($scope, dialogs, toaster, $filter, C, F, Table, SeniorityStandard, User) {

        $scope.init = function (type) {
            var options = {
                service: User,
                params: {opt: 12, type: type}, //INDEX_USER_SENIORITY
                optColWidth: 53,
                hideOpt: true,
                dateFilters: [{name: 'entry_time'}],
                items: 'users',
                cols: [
                    {title: '科室', filter: {dept_name: 'text'}},
                    {title: '姓名', filter: {name: 'text'}},
                    {title: '工号', filter: {username: 'text'}},
                    {title: '入院时间', filter: {entry_time: 'date_range'}},
                    {title: '年资', filter: {seniority: 'select'}}
                ]
            };

            var options = Table.loadNgTable($scope, options, function (data) {
                $scope.users = data.users;
            }).options;

            //type == 1 => 医生, 3 => 其他
            SeniorityStandard.query({type: type}, function (resp) {
                $scope.standards = resp;
                $scope.standards.splice(0, 0, {id: 0, name: '暂无'});
                options().cols[4].data = F.getNgTableOpts($scope.standards);
            });
        };

        var checker = Table.loadMultiSelectedFn($scope);

        $scope.setSeniority = function (stdId, users) {
            if (!stdId || stdId == 0) {
                toaster.warning('没有指定年资标准');
                return;
            }
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }
            User.setSeniority({users: checker.getCheckedIds(users), std_id: stdId}, function () {
                toaster.success('设置成功');
                $scope.tableReload();
            });
        };
    });


angular.module('c.c')
    .controller('NurseSeniorityApprovalCtrl', function ($scope, dialogs, toaster, $filter
        , NgTableParams, SeniorityStandard, Dept, SeniorityApproval, NurseSeniority, User) {
        var nurses = [];
        $scope.std = [{id: 0, title: '全部标准'}];
        $scope.init = function () {
            SeniorityStandard.query({type: 2}, function (resp) {
                $scope.standards = resp;
                angular.forEach($scope.standards, function (standard, index) {
                    $scope.std.push({id: index + 1, title: standard.name});
                });
            });
            User.query({'opt': 8}, function (data) {
                nurses = data.nurses;
            })
        };
        $scope.init();

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.cols = [
            {title: '科室', field: 'dept_id', show: true, width: "20%"},
            {title: '姓名', filter: {name: 'text'}, field: 'name', show: true, width: "20%"},
            {title: '工号', filter: {numb: 'text'}, field: 'numb', show: true, width: "20%"},
            {title: '入院时间', filter: {updated_at: 'date_range'}, field: 'name', show: true, width: "20%"},
            {
                title: '年资标准',
                data: $scope.std,
                filter: {seniority_id: 'select'},
                field: 'seniority_id',
                show: true,
                width: "20%"
            }

        ];

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [5, 10, 15], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 4;
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                SeniorityApproval.query(url, function (data) {
                    $scope.nurses = data.nurses;
                    params.total(data.total);
                    $defer.resolve(data.nurses);
                });

            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            angular.forEach($scope.nurses, function (nurse) {
                nurses.push({id: nurse.id})
            });
            dialogs.create('NurseSeniorityDlg.html', 'NurseSeniorityDlgCtrl', {
                standards: $scope.standards,
                except_nurses: nurses
            }, {
                 size: 'md'
            }).result.then(function (seniority) {
                seniority['ap_state'] = 1;
                NurseSeniority.save(seniority).$promise.then(function (data) {
                    toaster.success('护士年资添加添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('护士年资添加添加失败!');
                });
            });
        };
        $scope.edit = function (nurse) {
            nurse['standard'] = $scope.standards[nurse.seniority_id - 1];
            nurse['flag'] = true;
        };
        $scope.cancel = function (nurse) {
            nurse['flag'] = false;
        };
        $scope.examine = function (nurse) {
            var params = {};
            nurse['flag'] = false;
            if (nurse.standard)
                params['seniority_id'] = nurse.standard.id;
            params['ap_state'] = 1;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('提交成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('提交失败!');
            });

            $scope.tableReload();
        }
    });


angular.module('c.c').controller('MeetingTopicConfirmCtrl',
    function ($scope, $rootScope, $filter, $timeout, dialogs, toaster, NgTableParams, F, C, MeetingTopic) {
        $scope.$on('topicApproved', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        if ($scope.opt === '16' || $scope.opt === '17' || $scope.opt === '18') {
            F.loadTab($scope, 'confirm');
        }

        var stages = F.get('approval_stages4');
        var stagesOpts = F.getNgTableOpts(stages);
        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        $timeout(function () {
            if ($scope.opt == C.OPT.MEETING_TOPIC.INDEX.HOSPITAL_SEARCH) {
                $scope.cols[0].show = false;
                $scope.cols[5].data = stagesOpts.slice(5, 8);
            }
            if ($scope.opt == C.OPT.MEETING_TOPIC.INDEX.HOSPITAL_APPROVALED) {
                $scope.cols[5].data = stagesOpts.slice(3, 8);
            }
            if ($scope.opt == C.OPT.MEETING_TOPIC.INDEX.DEPT_SEARCH) {
                $scope.cols[5].data = stagesOpts.slice(0, 8);
            }
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //科室议题4，分管院领导已审批议题5,分管院领导查询公开议题6
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                        topic.stage = F.getItem(topic.stage, stages);
                    });
                    $defer.resolve(resp.topics);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {id: topic.id},
                {size: 'lg'});

            if ($scope.opt == '16' || $scope.opt == '17') {   //书记或院长确认
                MeetingTopic.update({id: topic.id}, {'read': 1}).$promise.then(
                    $scope.tableParams.reload()
                );
            }
            if ($scope.opt == '18') {
                MeetingTopic.update({id: topic.id}, {'office_read': 1}).$promise.then(
                    $scope.tableParams.reload()
                );
            }
        };
    });



angular.module('c.c').controller('MeetingTopicSearch2Ctrl',
    function ($scope, $rootScope, $filter, $timeout, $state, dialogs, toaster, NgTableParams, F, C, MeetingTopic, Doc) {
        $scope.$on('topicApproved', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {title: '处理时间', sortable: 'updated_at', filter: {updated_at: 'date_range'}, width: '20%', show: true},
            {title: '处理人', filter: {handler: 'text'}, show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 108;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //退回补充议题8，不讨论议题,9，已讨论议题10，会签议题11
                url['type'] = $scope.type; //1党委会，2办公会，3股东会
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                    });
                    $defer.resolve(resp.topics);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {id: topic.id, ForSealUp: true},
                {size: 'lg'});
        };

        //File.add_readers().$promise.then(function (resp) {
        //    switch (resp.result) {
        //        case 0:
        //            $scope.canCirculate = false;
        //            break;
        //        case 1:
        //            $scope.canCirculate = true;
        //            break;
        //    }
        //});

        //$scope.newFile = function (topic) {
        //    $state.go('app.file_circulate', {
        //        data: {
        //            tab: 'new',
        //            event: 'topic2File',
        //            topic: topic
        //        }
        //    });
        //};

        //$scope.newFile2 = function (topic) {
        //    if ($scope.canCirculate) {
        //        $state.go('app.coop_file', {
        //            data: {
        //                tab: 'new',
        //                event: 'topic2File',
        //                topic: topic
        //            }
        //        });
        //    }
        //};

        $scope.topic2doc = function (topic) {
            dialogs.create('templates/rule/rule2doc.html', 'Rule2DocDlgCtrl', {topic: topic, isTopic: true},
                {size: 'lg'}).result.then(function (params) {
                Doc.save(params).$promise.then(function () {
                    toaster.success('转会签提交成功!');
                }, function () {
                    toaster.error('转会签提交失败!');
                });
            });
        }

    });


angular.module('c.c').controller('MeetingTopicToBeDiscussedCtrl',
    function ($scope, $rootScope, $filter, dialogs, toaster, NgTableParams, F, C, MeetingTopic, Dlg) {
        $scope.$on('topicEdit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '申请科室', filter: {dept: 'text'}, show: true},
            {
                title: '分管院领导审批时间',
                filter: {hospital_approval_time: 'date_range'},
                width: '20%',
                show: true
            }
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10
            // , sorting: {
            //     hospital_approval_time: 'desc'
            // }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //退回补充议题8，不讨论议题,9，已讨论议题10，会签议题11
                url['type'] = $scope.type; //1党委会，2办公会，3股东会，4专题会
                if ($scope.dateRangeFilter.hospital_approval_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.hospital_approval_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.hospital_approval_time.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                    });
                    $defer.resolve(resp.topics);
                    $scope.topics = resp.topics;
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {
                    id: topic.id, ForHandle: true, ForUserToEdit: true
                },
                {size: 'lg'});
        };
        $scope.sort = function () {
            var url = [];

            dialogs.create('templates/meeting_topic/sort_dlg.html', 'TopicSortDlgCtrl as vm', {
                opt: $scope.opt,//退回补充议题8，不讨论议题25，已讨论议题10，会签议题11
                type: $scope.type //1党委会，2办公会，3股东会}
            } , {size: 'lg'}).result.then(function () {
                $scope.tableParams.reload();
            }, function () {
                $scope.tableParams.reload();
            }
            );
        };

        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (topic, topics) {
            if (topic.is_checked) {
                $scope.header.checkAll = true;
            } else {
                var allUnchecked = true;
                for (var i = 0; i < topics.length; i++) {
                    if (topics[i].is_checked) {
                        allUnchecked = false;
                        break;
                    }
                }
                if (allUnchecked) {
                    $scope.header.checkAll = false;
                }
            }
        };

        $scope.checkAllFn = function (checkAll, topics) {
            if (checkAll) {
                angular.forEach(topics, function (topic) {
                    topic.is_checked = true;
                })
            } else {
                angular.forEach(topics, function (topic) {
                    topic.is_checked = false;
                })
            }
        };

        $scope.print = function (data) {
            var topics = [];
            if (angular.isArray(data)) {
                angular.forEach(data, function (topic) {
                    if (topic.is_checked) {
                        topics.push({
                            id: topic.id, subject: topic.subject,
                            type: topic.type.id, sender: topic.applicant.name,
                            rapporteurs: topic.rapporteurs, observers: topic.observers
                        });
                    }
                });
            } else {
                topics.push({
                    id: data.id, subject: data.subject,
                    type: data.type.id, sender: data.applicant.name,
                    rapporteurs: data.rapporteurs, observers: data.observers
                });
            }
            dialogs.create('templates/meeting_topic/print_dlg.html', 'TopicPrintDlgCtrl', {
                    topics: topics,
                    account: $scope.account
                },
                {size: 'md'});
        }
    });






(function () {
    'use strict';

    angular.module('c.c')
        .controller('NursingAllDutyCtrl', NursingAllDutyCtrl);

    /** @ngInject */
    function NursingAllDutyCtrl($scope, uibDateParser, dialogs, toaster, C, Table,
                                FileHelper, DateHelper, Upload, SaveAs, NursingDutyAttachment) {

        var vm = $scope;
        vm.upload = upload;
        vm.download = download;
        vm.remove = remove;
        vm.day = new Date();

        init();


        function init() {
            var options = {
                service: NursingDutyAttachment,
                params: {},
                sorting: {'nursing_duty_attachments.created_at': 'desc'},
                hideOpt: true, hideFilter: true,
                cols: [
                    {field: "blood_storage.name", title: "名称"},
                    {field: "user_id", title: "上传人"},

                    {field: "date", title: "日期"}
                ]
            };

            Table.load(vm, options, function (resp) {
                if (resp.items && resp.items.length > 0 &&
                    DateHelper.areSameDate(uibDateParser.parse(resp.items[0].date, 'yyyy-MM-dd'), new Date())) {
                    vm.today = resp.items[0];
                } else {
                    vm.today = {};
                }
            });
        }


        function upload(file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            if (file == null) {
                return;
            }
            m.progress = 0;
            Upload.upload({
                url: NursingDutyAttachment.NURSING_DUTY_UPLOAD, data: {file: file, id: m.id}
            }).progress(function (evt) {
                m.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.name = resp.name;
                        m.mime = resp.mime;
                        m.filename = resp.filename;
                        m.size = resp.size;
                        vm.tableReload();
                        break;
                    case 1:
                        m.progress = 101;
                        m.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                m.progress = 102;
                m.errorInfo = '服务器错误!';
            });
        }

        function download(m) {
            var params = {filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.BLOOD_STORAGE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }

        function remove(m) {
            dialogs.confirm('删除储血量信息', '确定要删除<strong>' + m.name + '</strong>的记录吗?')
                .result.then(function () {
                BloodStorage.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('操作成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('操作失败!');
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('OrDateSsDlgCtrl', OrDateSsDlgCtrl);

    /** @ngInject */
    function OrDateSsDlgCtrl($uibModalInstance, Dlg, Api, $timeout, OpDateSs, ArrayHelper, DateHelper, FileHelper, FormHelper, Upload, C) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.submit = submit;
        vm.upload = upload;


        init();


        function init() {
            vm.m = {
                mode: '0',
                doc: {}
            };
        }

        function submit(m) {
            // if (Object.keys(m.doc).length == 0) {
            //     Dlg.w('请上传附件');
            //     return;
            // }
            console.log(m);

            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    op: 'default',
                    items: m.items
                };
                if (m.mode == 0) {
                    pa.start = DateHelper.date2Str(m.start);
                    pa.end = DateHelper.date2Str(m.end);
                }
                OpDateSs.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.close();
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }


        function upload(file, data, e, rename, extra) {
            if (file == null) {
                return;
            }
            vm.loading = true;
            vm.m.items = [];
            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                ArrayHelper.mergeObj(pa, extra);
            }
            delete data[rename.filename];
            Upload.upload({
                url: C.URL.UPLOAD_ATTACHMENT, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        OpDateSs.save({
                            op: 'upload',
                            filename: resp[rename.filename],
                            type: vm.forPO ? 1 : (vm.forFinance ? 2 : 0)
                        }, function (excelData) {
                            vm.m.items = excelData.items;
                            vm.loading = false;
                            Dlg.s('上传完毕')
                        }, function (error) {
                            vm.loading = false;
                            Dlg.e('上传失败');
                        });
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });
        }
    }

})();




angular.module('c.c')
    .controller('NursingDutyFeeApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyReport, F) {

    });

'use strict';

angular.module('c.c').controller('NursingLeaveMakeupCtrl',
    function ($scope, $filter, dialogs, toaster, FileHelper, NgTableParams, AskForLeave, SaveAs, C, F) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');

        $scope.cols = [
            {title: '编号', field: 'id', width: '50', show: true}, //0
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', width: '100', show: true}, //0
            {title: '科室', filter: {'depts.name': 'text'}, field: 'dept_id', width: '100', show: true}, //0
            {
                title: '类别',
                sortable: 'leave_type_id',
                filter: {leave_type_id: 'select'},
                field: 'leave_type_id',
                show: true
            }, //6
            {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
            {title: '天数', field: 'day_num', show: true}, //6
            {
                title: '附件',
                field: 'has_paper',
                show: true
            }, //6
            {
                title: '附件类型',
                sortable: 'type_id',
                filter: {'type_id': 'select'},
                field: 'type_id',
                width: '100',
                show: true
            }, //6
            {
                title: '是否补助',
                sortable: 'is_subsidy',
                filter: {is_subsidy: 'select'},
                field: 'is_subsidy',
                width: '100',
                data: yesNoOpts,
                show: true
            }, //6
            {title: '开始时间', filter: {start: 'date_range'}, field: 'start', width: '10%', show: true},
            {title: '结束时间', filter: {end: 'date_range'}, field: 'end', width: '10%', show: true},
            {title: '状态', show: true},
            //{title: '最终状态', show: true}
        ]
        ;
        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };
        $scope.leave_type_col = $scope.cols[3];
        $scope.attach_type_col = $scope.cols[7];

        $scope.optInFront = true;
        $scope.hideOpt = true;
        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );


        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                var startDate, endDate;
                if ($scope.dateRangeFilter.start != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        start: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.end != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        end: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                url['opt'] = 10;
                AskForLeave.query(url, function (data) {
                    $scope.dept = data.dept;
                    $scope.expense_items = data.expense_items;
                    $scope.leave_types = data.leave_types;
                    $scope.attach_types = data.attach_types;
                    $scope.attach_type_col.data = F.getNgTableOpts($scope.attach_types);
                    $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('templates/leave/work_arrange_dlg.html', 'WorkArrangeDlgCtrl', {
                leave_types: $scope.leave_types,
                attach_types: $scope.attach_types,
                is_arrange: 2
            }, {
                size: 'md'
            }).result.then(function (leave) {
                AskForLeave.save(leave).$promise.then(function (data) {
                    toaster.success('假条补录成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('假条补录!');
                });
            });
        };

        $scope.edit = function (record) {
            dialogs.create('templates/leave/edit_leave.html', 'PendingLeaveDlgCtrl', {
                    leave: record, edit: true, leave_types: $scope.leave_types, expense_items: $scope.expense_items,
                    attach_types: $scope.attach_types, personnel_edit: true
                }, {
                    size: 'md'
                }
            ).result.then(function (leave) {
                AskForLeave.update({id: record.id}, leave).$promise.then(function () {
                    toaster.success('假条改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('假条修改失败!');
                });
            });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除假条补录', '确定要删除编号为<strong>' + record.id + '</strong>的记录吗?')
                .result.then(function () {
                AskForLeave.delete({id: record.id}).$promise.then(function (resp) {
                    toaster.success('假条补录删除成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('假条补录删除失败!');
                });
            });

        };

        $scope.export = function () {
            dialogs.create('templates/leave/export_leaves_dlg.html', 'ExportLeavesCtrl', {},
                {size: 'md'});
        };
    })
;


angular.module('c.c').controller('ExportLeavesCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, C, F, FileHelper,
              UserType, LeaveType, UserStatus, SaveAs, data) {

        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        $scope.opt = data.opt;
        $scope.s = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0)
        };
        UserType.query({}, function (data) {
            $scope.user_types = data;
            $scope.user_types.unshift({'id': null, 'name': '全部'});
            $scope.s['type'] = data[0];
        });

        LeaveType.query({}, function (data) {
            $scope.leave_types = data;
            $scope.leave_types.unshift({'id': null, 'name': '全部'});
            $scope.s['leave_type'] = $scope.leave_types[0];
        });

        UserStatus.query({}, function (data) {
            $scope.user_status = data;
            $scope.user_status.unshift({'id': null, 'name': '全部'});
            $scope.s['status'] = $scope.user_status[0];
        });

        $scope.ok = function (s) {
            if ($scope.s_form.$valid) {
                if (s.start > s.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                params['start'] = $filter('date')(s.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(s.end, 'yyyy-MM-dd');
                params['type_id'] = s.type.id;
                params['leave_type_id'] = s.leave_type.id;
                params['status_id'] = s.status.id;
                s.downloading = true;
                FileHelper.download(C.URL.LEAVES_DOWNLOAD, params, function (resp) {
                    s.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = params['start'] + '到' + params['end'] + s.type.name + '请假统计表.xls';
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function (error) {
                    s.downloading = false;
                    toaster.error('导出失败!');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


angular.module('c.c')
    .controller('NursePracticeCtrl', function () {

    });
angular.module('c.c')
    .controller('NurseRoundsCtrl', function ($scope, Auth) {
        $scope.userId = Auth.getAccount().id;
    });

angular.module('c.c')
    .controller('NurseSeniorityCtrl', function ($scope) {

    });


angular.module('c.c')
    .controller('OutPShiftsCtrl', function ($scope, dialogs, toaster, FileHelper, C, F, Upload, SaveAs, OutPSchedule) {

        $scope.reload = function () {
            OutPSchedule.query(function (resp) {
                var tomorrow, today;
                if (resp) {
                    tomorrow = F.getItem(1, resp);
                    today = F.getItem(2, resp);
                }
                if (!tomorrow) {
                    tomorrow = {id: 1};
                }
                if (!today) {
                    today = {id: 2};
                }
                $scope.tomorrow = tomorrow;
                $scope.today = today;
            });
        };

        $scope.moveDown = function () {
            OutPSchedule.exchange(function () {
                $scope.reload();
            });
        };

        $scope.upload = function (file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file == null) {
                return;
            }

            m.progress = 0;
            Upload.upload({
                url: C.URL.OUT_P_SCHEDULE_UPLOAD, data: {file: file, id: m.id}
            }).progress(function (evt) {
                m.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.name = resp.name;
                        m.mime = resp.mime;
                        m.filename = resp.filename;
                        m.size = resp.size;
                        break;
                    case 1:
                        m.progress = 101;
                        m.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                m.progress = 102;
                m.errorInfo = '服务器错误!';
            });
        };

        $scope.download = function (m) {
            var params = {name: m.name, filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.OUT_P_SCHEDULE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.reload();
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('OutPRecipientCtrl', OutPRecipientCtrl);

    /** @ngInject */
    function OutPRecipientCtrl($scope, ORRecipient, Dlg) {
        var vm = $scope;
        vm.reload = reload;
        vm.submit = submit;

        init();


        function init() {
            ORRecipient.query({type: 2}, function (resp) {
                var users = [];
                angular.forEach(resp.records, function (r) {
                    users.push(r.user);
                });
                vm.users = users;
            });
        }

        function reload() {
            init();
        }

        function submit(m) {
            var params = {'type': 2, 'user_ids': []};
            if (m) {
                angular.forEach(m, function (u) {
                    params['user_ids'].push(u.id);
                });
            }
            ORRecipient.update({id: 0}, params).$promise.then(function () {
                Dlg.s('设置成功');
            }, function () {
                Dlg.e('设置失败');
            });
        }
    }

})();



angular.module('c.c')
    .controller('informationUploadCtrl', function ($scope, ArrayHelper, $q, Dlg,PartyInformation, DateHelper, FormHelper) {
        var vm = $scope;
        vm.cancel = cancel;
        vm.submit = submit;
        vm.preProcess = preProcess;
        vm.getBirthday = getBirthday;
        vm.is_farmer = [
            { id: 0, name: '否' },
            { id: 1, name: '是' }
        ];
        vm.nations = PartyInformation.getNations();
        vm.edu_bg = PartyInformation.getEduBg();
        vm.types = PartyInformation.getTypes();
        vm.jobs = PartyInformation.getJobs();

        init();

        function init() {
            PartyInformation.query({op: 'default'}, function (resp) {
                if (resp.item.finish !== 0) {
                    Dlg.error('已提交或未在支部名单内的无法填写，如需填写或修改请向支部书记申请或等待打回');
                    // todo 路由跳出
                } else {
                    preProcess(resp.item);
                }
            });
        }

        function preProcess(user) {
            // 预处理选项信息
            user.edu_bg = user.edu_bg ? vm.edu_bg[user.edu_bg - 1] : null;
            user.type = user.type ? vm.types[user.type - 1] : null;
            user.job = user.job ? vm.jobs[user.job - 1] : null;
            user.is_farmer = user.is_farmer ? vm.is_farmer[1] : vm.is_farmer[0];
            user.nation_id = user.nation_id ? vm.nations[user.nation_id - 1] : null;
            vm.user = user;
            if (vm.user.id_card) getBirthday(vm.user.id_card);

        }

        function getBirthday(idcard) {
            if (idcard !== null) {
                vm.user.birthday = idcard.substring(6, 14);
                vm.user.gender = (parseInt(idcard.substring(16, 17), 10) % 2);
            }

            var todayYear = new Date().getFullYear();
            var todayMonth = new Date().getMonth();
            var today = new Date().getDay();
            var year = idcard.substring(6, 10);
            var month = idcard.substring(10, 12);
            var day = idcard.substring(12, 14);
            var age = todayYear - year;
            if (month - todayMonth > 0) {
                age++;
            } else if (month - todayMonth === 0) {
                if (day - today >= 0) {
                    age ++;
                }
            }
            vm.user.age = age;
        }

        function submit (form, user, submit) {
            if (submit) {
                return FormHelper.handleSubmit(vm, function (defer) {
                    PartyInformation.update({
                        id: user.id,
                        op: 'save',
                        submit: submit
                    }, user).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        // 跳回主页
                    }).finally(function () {
                        defer.resolve();
                    })
                });
            } else {
                PartyInformation.update({
                    id: user.id,
                    op: 'save',
                    submit: submit
                }, user).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    // 跳回主页
                }).catch(function (e) {
                    console.log(e);
                    Dlg.e('表单填写有误');
                })
            }
        }

        function cancel() {

        }

    });



angular.module('c.c')
    .controller('OPHandleCtrl', function ($rootScope, $scope, dialogs, F, ORRecipient) {
        var PendingNeedRefresh = false;
        var ProcessedNeedRefresh = false;
        $scope.$on('OPConfirmed', function () {
            ProcessedNeedRefresh = true;
        });
        $scope.$on('OPCancel', function () {
            PendingNeedRefresh = true;
        });
        $scope.select = function (opt) {
            if (opt == 'pending') {
                if (PendingNeedRefresh) {
                    $rootScope.$broadcast('OPPendingRefresh');
                    PendingNeedRefresh = false;
                }
            } else if (opt == 'processed') {
                if (ProcessedNeedRefresh) {
                    $rootScope.$broadcast('OPProcessedRefresh');
                    ProcessedNeedRefresh = false;
                }
            }
        };

        //ORRecipient.query(function (resp) {
        //    var is_r = false;
        //    if (resp) {
        //        var r = F.getItem(1, resp);
        //        if (r.user_id == $scope.account.id) {
        //            is_r = true;
        //        }
        //    }
        //    if (!is_r) {
        //        dialogs.notify('提示', '您不是指定的手术接单人，因此无法在此获取全院的手术单!');
        //    }
        //});
    });
angular.module('c.c')
    .controller('OPRecipientCtrl', function ($scope, toaster, F, ORRecipient) {
        $scope.reload = function () {
            ORRecipient.query({type: 1}, function (resp) {
                var users = [];
                angular.forEach(resp.records, function (r) {
                    users.push(r.user);
                });
                $scope.users = users;
            });
        };

        $scope.submit = function (users) {
            var params = {'type': 1, 'user_ids': []};
            if (users) {
                angular.forEach(users, function (u) {
                    params['user_ids'].push(u.id);
                });
            }
            ORRecipient.update({id: 0}, params).$promise.then(function () {
                toaster.success('设置成功');
            }, function () {
                toaster.error('设置失败');
            });
        };

        $scope.reset = $scope.reload;
        $scope.reload();
    });
angular.module('c.c')
    .controller('OPShiftsCtrl', function ($scope, dialogs, toaster, C, F, FileHelper, Upload, SaveAs, ORSchedule) {

        $scope.reload = function () {
            ORSchedule.query(function (resp) {
                var tomorrow, today;
                if (resp) {
                    tomorrow = F.getItem(1, resp);
                    today = F.getItem(2, resp);
                }
                if (!tomorrow) {
                    tomorrow = {id: 1};
                }
                if (!today) {
                    today = {id: 2};
                }
                $scope.tomorrow = tomorrow;
                $scope.today = today;
            });
        };

        $scope.moveDown = function () {
            ORSchedule.exchange(function () {
                $scope.reload();
            });
        };

        $scope.upload = function (file, m, e) {
            FileHelper.upload1(C.URL.OR_SCHEDULE_UPLOAD, file, m, e, {name: 'name'});
        };

        $scope.download = function (m) {
            var params = {name: m.name, filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.OR_SCHEDULE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.reload();
    });
angular.module('c.c')
    .controller('PendingOPCtrl', function ($rootScope, $scope, $filter, dialogs, toaster, NgTableParams,
                                           FileHelper, OperationPermit, SaveAs, C, F) {
        $scope.$on('OPPendingRefresh', function () {
            $scope.tableParams.reload();
        });

        $scope.types = F.get('or_types');
        var typeOpts = F.getNgTableOpts($scope.types);

        $scope.cols = [
            {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name', width: '20%', show: true}, //0
            {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id', show: true}, //1
            {title: '递交人', field: 'applicant', filter: {applicant: 'text'}, width: '10%', show: true}, //6
            {title: '递交科室', filter: {dept: 'text'}, field: 'dept', show: true}, //1
            {
                title: '递交时间',
                filter: {created_at: 'date_range'},
                sortable: 'created_at',
                field: 'created_at',
                width: '15%',
                show: true
            }, //6
            {title: '备注', field: 'remark', width: '20%', show: true} //1
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 2;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                OperationPermit.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.permits, function (m) {
                        m.type = F.getItem(m.type_id, $scope.types);
                    });
                    $defer.resolve(resp.permits);
                });
            }
        });

        $scope.optColWidth = 96;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.confirm = function (m) {
            OperationPermit.update({id: m.id}, {stage: 2, type: 1}).$promise.then(function () {
                toaster.success('确认成功!');
                $scope.tableParams.reload();
                $rootScope.$broadcast('OPConfirmed');
            }, function (error) {
                toaster.error('确认失败!');
            });
        };

        $scope.returnOP = function (m) {
            dialogs.confirm('退回手术通知单', '确定要退回此手术通知单吗?')
                .result.then(function () {
                    OperationPermit.update({id: m.id}, {stage: 3}).$promise.then(function () {
                        toaster.success('已退回!');
                        $scope.tableParams.reload();
                        //$rootScope.$broadcast('OPConfirmed');
                    }, function (error) {
                        toaster.error('操作失败!');
                    });
                });
        };

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        //$scope.delete = function (m) {
        //    dialogs.confirm('删除物资申请', '确定要删除该物资申请记录吗?')
        //        .result.then(function () {
        //            OperationPermit.delete({id: m.id}).$promise.then(function (resp) {
        //                $scope.tableReload();
        //            }, function () {
        //                toaster.error('删除物资申请!');
        //            });
        //        });
        //};

    });
angular.module('c.c')
    .controller('ProcessedOPCtrl', function ($rootScope, $scope, $filter, dialogs, C, F, FileHelper,
                                             toaster, NgTableParams, SaveAs, OperationPermit) {
        $scope.$on('OPProcessedRefresh', function () {
            $scope.tableParams.reload();
        });

        $scope.types = F.get('or_types');
        var typeOpts = F.getNgTableOpts($scope.types);

        $scope.cols = [
            {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name', width: '20%', show: true}, //0
            {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, width: '90', field: 'type_id', show: true}, //1
            {title: '递交人', field: 'applicant', filter: {applicant: 'text'}, width: '72', show: true}, //6
            {title: '递交科室', filter: {dept: 'text'}, field: 'dept', width: '72', show: true}, //1
            {
                title: '递交时间',
                filter: {created_at: 'date_range'},
                sortable: 'created_at',
                field: 'created_at',
                width: '15%',
                show: true
            }, //6
            {title: '确认时间', field: 'updated_at', width: '118', show: true}, //6
            {title: '备注', field: 'remark', width: '20%', show: true} //1
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                OperationPermit.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.permits, function (m) {
                        m.type = F.getItem(m.type_id, $scope.types);
                    });
                    $defer.resolve(resp.permits);
                });
            }
        });

        //$scope.hideFilter = true;
        $scope.optColWidth = 70;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.cancel = function (m) {
            dialogs.confirm('撤销手术通知单', '确定要撤销对该手术通知单的确认吗?')
                .result.then(function () {
                    OperationPermit.update({id: m.id}, {stage: 1}).$promise.then(function () {
                        toaster.success('撤销成功!');
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('OPCancel');
                    }, function (error) {
                        toaster.error('撤销失败!');
                    });
                });
        };

        //$scope.delete = function (m) {
        //    dialogs.confirm('删除手术通知单', '确定要删除该手术通知单记录吗?')
        //        .result.then(function () {
        //            OperationPermit.delete({id: m.id}).$promise.then(function (resp) {
        //                $scope.tableReload();
        //            }, function () {
        //                toaster.error('删除手术通知单!');
        //            });
        //        });
        //};

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };
    });
angular.module('c.c')
    .controller('PersonnelAttendanceCtrl', function ($scope, $filter, dialogs, toaster, FileHelper, Table,
                                                     NgTableParams, AttendanceReport, F, C, SaveAs) {

        var yesOrNo = [{id: '', title: '-'}, {id: '3', title: '是'}, {id: '2', title: '否'}];

        $scope.cols = [
            {title: '月份', sortable: 'month', field: 'month', show: true},
            {
                title: '科室',
                sortable: 'depts.name',
                filter: {'depts.name': 'text'},
                field: 'dept_name',
                show: true
            },
            {title: '考勤总人数', field: 'count_num', show: true},
            {title: '全勤人数', field: 'count_num', show: true},
            {title: '缺勤人数', 'field': 'absence_num', show: true},
            {title: '新入科员工', field: 'new_comer', show: true, width: 150},
            {title: '请假人数', show: true},
            {title: '人均系数', field: 'stage', show: true},
            {title: '是否确认', filter: {stage: 'select'}, field: 'stage', data: yesOrNo, show: true},
            {title: '月份', field: 'month', filter: {month: 'text'}, show: false}//6
        ];
        $scope.optColWidth = Table._4_BTN;
        $scope.dept_col = $scope.cols[1];

        $scope.can_opt = true;   //与财务科拥有共同的界面，是否有操作权限

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.first = true;       //第一次监控时间的变化，则不重新查询
        var date = new Date((new Date()).setDate(1));
        var month = date.getMonth();
        $scope.dts = new Date(date.setMonth(month - 1));
        $scope.dte = new Date(date.getFullYear(), month, 0);
        $scope.temp_month = new Date((new Date((new Date()).setDate(1))).setMonth(month - 1)); //这样设置跨年月份变化会有bug？
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dts = new Date(curr.setMonth(prev));
            $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
            $scope.temp_month = new Date(curr.setMonth(prev));
            $scope.first = false;
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dts = new Date(curr.setMonth(next));
            $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
            $scope.temp_month = new Date(curr.setMonth(next));
            $scope.first = false;
        };

        $scope.$watch('dts', function (newVal, oldVal, scope) {
            if (!$scope.first) {
                $scope.tableReload();
            }
        }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                var filter = params.filter();
                filter['month'] = $filter('date')($scope.temp_month, 'yyyy-MM-dd');
                url['filter'] = filter;
                url['opt'] = 2;
                $scope.month = {
                    startDate: $filter('date')($scope.temp_month, 'yyyy-MM-dd'),
                    endDate: $filter('date')($scope.dte, 'yyyy-MM-dd')
                };
                AttendanceReport.query(url, function (resp) {
                    $scope.dept_col.data = F.getNgTableOpts(resp.depts);
                    $scope.no_declare = resp.no_declare;
                    params.total(resp.total);
                    $scope.reports = resp.records;
                    $defer.resolve(resp.records);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
            $scope.first = false;
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.back = function (report) {
            dialogs.confirm('考勤退回', '确定要退回' + report.dept_name + '考勤记录吗?')
                .result.then(function () {
                var para = {};
                para['stage'] = 4;
                AttendanceReport.update({id: report.id}, para).$promise.then(function () {
                    toaster.success('考勤记录退回成功');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('考勤记录退回失败!');
                });
            });
        };

        $scope.member = function (report) {
            dialogs.create('AttendanceReportMembers.html', 'AttendanceReportMembersCtrl',
                {report: report, month: $filter('date')($scope.month, 'yyyy-MM-dd')}, {
                    size: 'lg'
                }).result.then(function () {
                $scope.tableReload();
            });
        };

        $scope.export = function () {
            var params = {};
            params['month'] = $filter('date')($scope.dts, 'yyyy-MM-dd');
            FileHelper.download(C.URL.ATTENDANCE_EXPORT, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = $filter('date')($scope.dts, 'yyyy年MM月') + '考勤绩效统计情况.xls';
                SaveAs.download(data, filename, options);
            }, function () {
                toaster.error('导出失败!');
            });
        };

        $scope.d_direct = function (dept) {
            dialogs.create('AttendanceReportMembers.html', 'AttendanceReportMembersCtrl',
                {dept: dept, month: $filter('date')($scope.dts, 'yyyy-MM-dd'), direct: 1}, {
                    size: 'lg'
                }).result.then(function () {
                $scope.tableReload();
            });
        };

    });

angular.module('c.c').controller('AttendanceReportMembersCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs, UserKpi,
              toaster, F, AttendanceMember, AttendanceReport, data) {

        $scope.report = data.report;
        $scope.month = data.month;
        var direct = data.direct;
        $scope.direct = direct;
        $scope.dept = data.dept;

        $scope.cols = [
            {title: '姓名', field: 'name', show: true},
            {title: '工号', field: 'username', show: true},
            {title: '编制', field: 'status', show: true},
            {title: '岗位', field: 'type', show: true},
            {title: '入科时间', field: 'entry_time', show: true},
            {title: '离科时间', field: 'leave_time', show: true},
            //{title: '工资天数(扣)', field: 'wage_days', show: true},
            //{title: '奖金天数(扣', field: 'bonus_days', show: true},
            {title: '绩效系数', field: 'real_kpi', show: true},
            {title: '请假情况', show: true}
        ];
        $scope.hideOpt = true;
        $scope.hideFilter = true;
        //$scope.justDataCol = true;     //将多选框还有删除图标去掉

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100],
            total: 0,
            getData: function ($defer, params) {

                var url = params.url();
                var filter = {};

                url['filter'] = filter;
                url['opt'] = 1;       //保持考勤界面与科室考勤界面一致

                if (direct == 1) {
                    filter['month'] = data.month;
                    url['dept_id'] = data.dept.id;
                } else {
                    filter['month'] = data.report.month;
                    url['dept_id'] = data.report.dept_id;
                }
                AttendanceReport.query(url, function (resp) {
                    $scope.records = resp.records;
                    $scope.count_num = resp.count_num;
                    $scope.trial_num = resp.trial_num;
                    $scope.absence_num = resp.absence_num;
                    $scope.leave_num = resp.leave_num;
                    $scope.new_comer = resp.new_comer;
                    $scope.leader_id = resp.leader_id;   //本科室科室负责人
                    $scope.r_length = resp.records.length > 0;//如果r_length=0 则表示已确认过的列表，否则未确认,判断数组是否为空
                    $scope.resubmit = resp.resubmit;

                    var formal_members = [];
                    var trial_members = [];
                    if ($scope.r_length) {
                        formal_members = resp.records[0];
                        trial_members = resp.records[1]
                    } else {
                        formal_members = resp.formal_members;
                        trial_members = resp.trial_members;
                    }

                    $scope.trial_members = trial_members;
                    $scope.formal_members = formal_members;
                    $defer.resolve(formal_members);
                });
            }
        });

        $scope.kpi = function (record) {
            var edit = false;
            var user_id = 0;
            if ($scope.r_length) {
                if (record.user.kpi.length > 0) {
                    edit = true;
                }
                user_id = record.user.id;
            }
            if (!$scope.r_length) {
                if (record.kpi.length > 0) {
                    edit = true;
                }
                user_id = record.user_id;
            }

            dialogs.create('templates/kpi/user_kpi.html', 'UserKpiCtrl', {
                user_id: user_id, edit: edit
            }, {
                size: 'md'
            }).result.then(function (kpi) {
                UserKpi.save(kpi).$promise.then(function () {
                    toaster.success('员工绩效系数添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('员工绩效系数添加失败!');
                });
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.confirm = function (report, stage) {
            if (direct) {
                dialogs.confirm('发布考勤记录', '确定要发布<strong>' + $filter('date')($scope.month, 'yyyy年MM月') + '</strong>的考勤记录吗?')
                    .result.then(function () {
                    var params = {};
                    params['stage'] = 3;
                    var kpi_all = true;
                    if (!$scope.resubmit) {
                        angular.forEach($scope.formal_members, function (member) {
                            //确认不是member.user.kpi？
                            if (!member.is_ex&&member.kpi.length == 0) {
                                kpi_all = false;
                                toaster.warning(member.name + '绩效系数为空,请编辑绩效系数!');
                            }
                        });
                    }
                    params['leave_num'] = $scope.leave_num;
                    params['new_comer'] = $scope.new_comer;
                    params['count_num'] = $scope.count_num;
                    params['trial_num'] = $scope.trial_num;
                    params['absence_num'] = $scope.absence_num;
                    params['formal_members'] = $scope.formal_members;
                    params['trial_members'] = $scope.trial_members;
                    if (kpi_all) {
                        //if ($scope.resubmit) {
                        //    params['opt'] = 1;
                        //    params['month'] = $filter('date')($scope.month, 'yyyy-MM-dd');
                        //    params['dept_id'] = $scope.dept.id;
                        //    AttendanceReport.update({id: 0}, params).$promise.then(function (resp) {
                        //        toaster.success('考勤记录发布成功!');
                        //        $uibModalInstance.close();
                        //    }, function (error) {
                        //        toaster.error('考勤记录发布失败!');
                        //    });
                        //} else {

                        params['month'] = $filter('date')($scope.month, 'yyyy-MM-dd');
                        params['dept_id'] = $scope.dept.id;
                        AttendanceReport.save(params).$promise.then(function (resp) {
                            if (resp.result == 1) {
                                toaster.error(resp.msg);
                            } else {
                                toaster.success('考勤记录发布成功!');
                                $uibModalInstance.close();
                            }
                        }, function (error) {
                            toaster.error('考勤记录发布失败!');
                        });
                    }
                    //}
                });

            } else {
                var para = {};
                para['stage'] = stage;
                para['opt'] = 2;
                AttendanceReport.update({id: report.id}, para).$promise.then(function (resp) {
                    toaster.success('考勤确认成功!');
                    $uibModalInstance.close();
                }, function (error) {
                    console.log(error);
                    toaster.error('考勤确认失败!');
                });
            }
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('PersonnelContactGroupCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, Dept, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true, filter: {name: 'text'}}, //0
            {title: '排序', field: 'sorting', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1
            {
                title: '是否公开',
                filter: {is_public: 'select'},
                data: yesNoOpts,
                field: 'is_public',
                width: '10%',
                show: true
            }, //6
            {title: '是否停用', data: yesNoOpts, field: 'is_stop', width: '10%', show: true,
                filter: {is_stop: 'select'},
            }, //6
            {title: '创建人', field: 'creator_id', width: '10%', show: true} //6
        ];
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 5;
                ContactGroup.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (group) {
                    ContactGroup.save(group).$promise.then(function (data) {
                        toaster.success('群添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('群添加失败!');
                    });
                });
        };

        $scope.bind = function (group) {
            dialogs.create('templates/contactGroupBindDlg.html', 'ContactGroupBindDlgCtrl', {group: group}, {
                size: 'md'
            }).result.then(function (data) {
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('绑定信息修改成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('绑定信息修改失败!');
                });
            });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$sortingChanged = group.sorting;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
            if (group.dept_id){
                group.$deptChanged ={id: group.dept_id, name: group.dept.name};
            } else {
                group.$deptChanged ={id: null, name: '暂无'};
            }
            group.$creatorChanged = {id: group.creator_id, name: group.creator.name};
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['sorting'] = group.$sortingChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                data['creator_id'] = group.$creatorChanged.id;
                data['dept_id'] = group.$deptChanged.id;

                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.sorting = group.$sortingChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                    group.creator = group.$creatorChanged;
                    group.dept = group.$deptChanged;
                    group.dept_id = group.$deptChanged.id;
                    group.creator_id = group.$creatorChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                    ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('群记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该群的成员,因此无法删除该群!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('群记录删除失败!');
                    });
                });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, { size: 'md'}).result.then(function () {
                }, function () {
                    $scope.tableParams.reload();
                });
        };

    });

angular.module('c.c')
    .controller('DeptMemberCtrl', DeptMemberCtrl);

function DeptMemberCtrl($scope, dialogs, toaster, Table, Dept) {
    var vm = $scope;
    var optionFn;
    vm.leader = leader;
    vm.member = member;
    vm.typeSelectedFn = typeSelectedFn;

    vm.type = {id: 0, name: '全部科室'};

    init();


    function init() {
        var options = {
            service: Dept,
            params: {opt: 1, type_id: 0},
            optColWidth: Table._3_BTN,
            items: 'depts',
            cols: [
                {title: "序号", field: "sn", width: Table._1_CHAR},
                {title: '科室名称', field: 'name', filter: {name: 'text'}}, //0
                {title: '科室负责人', field: 'leader', filter: {leader: 'text'}}, //6
                {title: '科室秘书', field: 'assistant', filter: {assistant: 'text'}}, //6
                {title: '分管院领导', field: 'hospital_leader', filter: {hospital_leader: 'text'}}, //6
                {title: '邮件接收人', field: 'mail_recipient', filter: {mail_recipient: 'text'}}, //6
                {title: '打卡考勤代管人', field: 'attendance_agent', filter: {attendance_agent: 'text'}}, //6
                {title: '成员数', field: 'members_count'} //6
            ]
        };

        optionFn = Table.load(vm, options, function (resp, startSn) {
            vm.types = resp.types;
            vm.types.splice(0, 0, {id: 0, name: '全部科室'});
            angular.forEach(resp.depts, function (item, i) {
                item.sn = startSn + i + 1;
            });
        }).options;
    }

    //
    // $scope.cols = [
    //     {title: '科室名称', field: 'name', show: true}, //0
    //     {title: '科室负责人', field: 'leader', show: true}, //6
    //     {title: '科室秘书', field: 'assistant', show: true}, //6
    //     {title: '分管院领导', field: 'hospital_leader', show: true}, //6
    //     {title: '邮件接收人', field: 'mail_recipient', show: true}, //6
    //     {title: '成员数', field: 'members_count', show: true}, //6
    // ];
    // $scope.hideFilter = true;


    // $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
    //     counts: [30, 50, 100], total: 0,
    //     getData: function ($defer, params) {
    //         var url = params.url();
    //         url['opt'] = 1;
    //         url['type_id'] = $scope.type.id;
    //         Dept.query(url, function (resp) {
    //             $scope.types = resp.types;
    //             $scope.types.splice(0, 0, {id: 0, name: '全部科室'});
    //             params.total(resp.total);
    //             $defer.resolve(resp.depts);
    //         });
    //     }
    // });

    function typeSelectedFn(type) {
        vm.type = type;
        optionFn().params['type_id'] = type.id;
        vm.tableReload();
    }

    function leader(dept) {
        dialogs.create('LeaderDlg.html', 'SelectLeaderCtrl',
            {dept: dept}, {size: 'md'}).result.then(function (params) {
            params['opt'] = 1;
            Dept.update({id: dept.id}, params).$promise.then(function (resp) {
                if (resp.result == 1) {
                    toaster.error(resp.msg);
                } else {
                    toaster.success('设置成功!');
                    $scope.tableParams.reload();
                }
            }, function () {
                toaster.error('设置失败!');
            });
        });
    }

    function member(dept) {
        dialogs.create('MemberDlg.html', 'MemberCtrl', {dept: dept}, {size: 'lg'})
            .result.then(function () {
        }, function () {
            $scope.tableParams.reload();
        });
    }
}

angular.module('c.c').controller('MemberCtrl',
    function ($scope, $uibModalInstance, NgTableParams, Dlg, F, UserDept, data, Table) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.add = add;
        vm.edit = edit;
        vm.leave = leave;
        vm.transfer = transfer;
        $scope.dept = data.dept;
        $scope.members = [];
        var optionFn;

        init();


        function init() {
            var options = {
                service: UserDept,
                params: {opt: 2, dept_id: data.dept.id, need_users: 1},
                optColWidth: Table._3_BTN,
                cols: [
                    {title: '姓名', field: 'name', filter: {name: 'text'}}, //0
                    {title: '工号', field: 'username'}, //0
                    {title: '科室内职务', field: 'post'}, //6
                    {title: '是否主科室', field: 'is_main'}, //6
                    {title: '进入时间', field: 'entry_time'}, //6
                    {title: '排序', field: 'sorting'} //6
                ]
            };

            optionFn = Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (m) {
                    m.is_main = m.is_main == '1';
                });
                angular.forEach(resp.members, function (m) {
                    $scope.members.push({id: m.user_id});
                });
            }).options;
        }

        function add() {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddMemberCtrl',
                data: {
                    members: $scope.members
                }
            }).then(function (pa) {
                pa['dept_id'] = data.dept.id;
                UserDept.save(pa).$promise.then(function (resp) {
                    if (resp.result == 1) {
                        Dlg.e('科室没有对应的工会小组，请联系工会管理人员添加!');
                    } else {
                        Dlg.s('添加成功!');
                    }
                    vm.tableReload();
                }, function () {
                    Dlg.e('添加失败!');
                });
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddMemberCtrl',
                data: {
                    user: m
                }
            }).then(function (pa) {
                pa['dept_id'] = data.dept.id;
                pa['opt'] = 1;
                UserDept.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('修改成功!');
                            vm.tableReload();
                            break;
                        case 1:
                            Dlg.w('员工必须拥有一个主科室!');
                            break;
                        case 2:
                            Dlg.w('科室没有对应的工会小组，请联系工会管理人员添加!');
                            break;
                    }
                }, function () {
                    Dlg.e('修改失败!');
                });
            });
        }

        function leave(m) {
            Dlg.show({
                template: 'LeaveMemberDlg.html',
                ctrl: 'LeaveMemberCtrl',
                data: {
                    user: m,
                    dept: data.dept
                }
            }).then(function (pa) {
                pa['opt'] = 2;
                UserDept.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('科室转出成功!');
                            vm.tableReload();
                            break;
                        case 1:
                            Dlg.w('员工必须拥有一个主科室!');
                            break;
                    }
                }, function () {
                    Dlg.e('科室转出失败!');
                });
            });
        }

        function transfer(m) {
            Dlg.show({
                template: 'TransMemberDlg.html',
                ctrl: 'TransMemberCtrl',
                data: {
                    user: m,
                    dept: data.dept
                }
            }).then(function (pa) {
                pa['opt'] = 3;
                UserDept.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('转科成功!');
                            vm.tableReload();
                            break;
                        case 1:
                            Dlg.w('该员工已经在目标科室了!');
                            break;
                        case 2:
                            Dlg.w('目标科室没有对应的工会小组，请联系工会管理人员添加!');
                            break;
                    }
                }, function () {
                    Dlg.e('转科失败!');
                });
            });
        }
    });

angular.module('c.c').controller('TransMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, Dept, data) {
        $scope.m = {
            leave_time: new Date(),
            entry_time: new Date(),
            post: data.user.post
        };
        $scope.user = data.user;
        $scope.dept = data.dept;

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            initDate: new Date()
        };

        Dept.query({opt: 4}, function (resp) {
            $scope.depts = F.except(data.dept.id, resp.depts);
            $scope.m['dept'] = $scope.depts[0];
        });

        $scope.ok = function (m) {
            if ($scope.u_form.$valid) {
                var p = {};
                p['leave_time'] = $filter('date')(m.leave_time, 'yyyy-MM-dd');
                p['user_id'] = data.user.user_id;
                p['dept_id'] = m.dept.id;
                p['post'] = m.post;
                p['entry_time'] = $filter('date')(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = data.user.is_main;
                //p['kpi'] = m.kpi;
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('LeaveMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, data) {
        $scope.m = {leave_time: new Date()};
        $scope.user = data.user;
        $scope.dept = data.dept;

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            //maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if ($scope.u_form.$valid) {
                var p = {};
                p['leave_time'] = $filter('date')(m.leave_time, 'yyyy-MM-dd');
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('AddMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, uibDateParser, F, data) {

        if (data.user) {
            $scope.$edit = true;
            var user = data.user;
            $scope.m = {
                user: {id: user.user_id, name: user.name}, is_main: user.is_main,
                kpi: user.kpi, entry_time: uibDateParser.parse(user.entry_time, 'yyyy-MM-dd'),
                post: user.post, sorting: user.sorting
            };
        } else {
            $scope.m = {is_main: false, entry_time: new Date(), sorting: 100};
            $scope.members = data.members;
        }

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if (m.user == null) {
                toaster.warning('成员未选择!');
            } else if ($scope.u_form.$valid) {
                var p = {};
                p['user_id'] = m.user.id;
                p['post'] = m.post;
                p['entry_time'] = $filter('date')(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = m.is_main;
                p['sorting'] = m.sorting;
                //p['kpi'] = m.kpi;
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('SelectLeaderCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, User, data) {
        $scope.dept = {
            name: data.dept.name,
            leader: data.dept.leader, /*nurse_leader: data.dept.nurse_leader,*/
            hospital_leader: data.dept.hospital_leader, mail_recipient: data.dept.mail_recipient,
            assistant: data.dept.assistant,
            attendance_agent: data.dept.attendance_agent
        };

        User.query({opt: 3, dept_id: data.dept.id}, function (resp) {
            $scope.users = resp.users;
            $scope.users.splice(0, 0, {id: 0, name: '空缺'});
            if ($scope.dept.leader == null) $scope.dept.leader = $scope.users[0];
            //if ($scope.dept.nurse_leader == null) $scope.dept.nurse_leader = $scope.users[0];
            if ($scope.dept.hospital_leader == null) $scope.dept.hospital_leader = $scope.users[0];
            if ($scope.dept.mail_recipient == null) $scope.dept.mail_recipient = $scope.users[0];
            if ($scope.dept.assistant == null) $scope.dept.assistant = $scope.users[0];
            if ($scope.dept.attendance_agent == null) $scope.dept.attendance_agent = $scope.users[0];
        });

        $scope.ok = function (dept) {
            if ($scope.u_form.$valid) {
                var params = {
                    mail_recipient_id: dept.mail_recipient.id,
                    assistant_id: dept.assistant ? dept.assistant.id : 0,
                    attendance_agent_id: dept.attendance_agent ? dept.attendance_agent.id : 0
                };

                if (dept.leader == null || dept.leader.id == 0) {
                    params.leader_id = null;
                } else {
                    params.leader_id = dept.leader.id;
                }

                if (dept.hospital_leader == null || dept.hospital_leader.id == 0) {
                    params.hospital_leader_id = null;
                } else {
                    params.hospital_leader_id = dept.hospital_leader.id;
                }

                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


angular.module('c.c')
    .controller('PersonnelDutyFeeApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyReport, F) {

    });

'use strict';

angular.module('c.c').controller('PersonnelLeaveMakeupCtrl',
    function ($scope, $filter, dialogs, toaster, FileHelper, NgTableParams, AskForLeave, SaveAs, C, F) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');

        $scope.cols = [
            {title: '编号', field: 'id', width: '50', show: true}, //0
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', width: '100', show: true}, //0
            {title: '科室', filter: {'depts.name': 'text'}, field: 'dept_id', width: '100', show: true}, //0
            {
                title: '类别',
                sortable: 'leave_type_id',
                filter: {leave_type_id: 'select'},
                field: 'leave_type_id',
                show: true
            }, //6
            {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
            {title: '天数', field: 'day_num', show: true}, //6
            {
                title: '附件',
                field: 'has_paper',
                show: true
            }, //6
            {
                title: '附件类型',
                sortable: 'type_id',
                filter: {'type_id': 'select'},
                field: 'type_id',
                width: '100',
                show: true
            }, //6
            {
                title: '是否补助',
                sortable: 'is_subsidy',
                filter: {is_subsidy: 'select'},
                field: 'is_subsidy',
                width: '100',
                data: yesNoOpts,
                show: true
            }, //6
            {title: '开始时间', filter: {start: 'date_range'}, field: 'start', width: '10%', show: true},
            {title: '结束时间', filter: {end: 'date_range'}, field: 'end', width: '10%', show: true},
            {title: '状态', show: true},
            //{title: '最终状态', show: true}
        ]
        ;
        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };
        $scope.leave_type_col = $scope.cols[3];
        $scope.attach_type_col = $scope.cols[7];

        $scope.optInFront = true;
        $scope.hideOpt = false;
        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );


        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                var startDate, endDate;
                if ($scope.dateRangeFilter.start != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        start: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.end != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        end: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                //url['opt'] = 20;
                AskForLeave.query(url, function (data) {
                    $scope.dept = data.dept;
                    $scope.expense_items = data.expense_items;
                    $scope.leave_types = data.leave_types;
                    $scope.attach_types = data.attach_types;
                    $scope.attach_type_col.data = F.getNgTableOpts($scope.attach_types);
                    $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('templates/leave/work_arrange_dlg.html', 'WorkArrangeDlgCtrl', {
                leave_types: $scope.leave_types,
                attach_types: $scope.attach_types,
                expense_items: $scope.expense_items,
                is_arrange: 2
            }, {
                size: 'md'
            }).result.then(function (leave) {
                    AskForLeave.save(leave).$promise.then(function (data) {
                        toaster.success('假条补录成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('假条补录!');
                    });
                });
        };

        $scope.edit = function (record) {
            dialogs.create('templates/leave/edit_leave.html', 'PendingLeaveDlgCtrl', {
                    leave: record, edit: true, leave_types: $scope.leave_types, expense_items: $scope.expense_items,
                    attach_types: $scope.attach_types, personnel_edit: true
                }, {
                    size: 'md'
                }
            ).result.then(function (leave) {
                    AskForLeave.update({id: record.id}, leave).$promise.then(function () {
                        toaster.success('假条改成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('假条修改失败!');
                    });
                });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除假条补录', '确定要删除编号为<strong>' + record.id + '</strong>的记录吗?')
                .result.then(function () {
                    AskForLeave.delete({id: record.id}).$promise.then(function (resp) {
                        toaster.success('假条补录删除成功!');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('假条补录删除失败!');
                    });
                });

        };

        $scope.export = function () {
            dialogs.create('templates/leave/export_leaves_dlg.html', 'ExportLeavesCtrl', {},
                {size: 'md'});
        };
    })
;


angular.module('c.c').controller('ExportLeavesCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, C, F, FileHelper,
              UserType, LeaveType, UserStatus, SaveAs, data) {

        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        $scope.opt = data.opt;
        $scope.s = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0)
        };
        UserType.query({}, function (data) {
            $scope.user_types = data;
            $scope.user_types.unshift({'id': null, 'name': '全部'});
            $scope.s['type'] = data[0];
        });

        LeaveType.query({}, function (data) {
            $scope.leave_types = data;
            $scope.leave_types.unshift({'id': null, 'name': '全部'});
            $scope.s['leave_type'] = $scope.leave_types[0];
        });

        UserStatus.query({}, function (data) {
            $scope.user_status = data;
            $scope.user_status.unshift({'id': null, 'name': '全部'});
            $scope.s['status'] = $scope.user_status[0];
        });

        $scope.ok = function (s) {
            if ($scope.s_form.$valid) {
                if (s.start > s.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                params['start'] = $filter('date')(s.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(s.end, 'yyyy-MM-dd');
                params['type_id'] = s.type.id;
                params['leave_type_id'] = s.leave_type.id;
                params['status_id'] = s.status.id;
                s.downloading = true;
                FileHelper.download(C.URL.LEAVES_DOWNLOAD, params, function (resp) {
                    s.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = params['start'] + '到' + params['end'] + s.type.name + '请假统计表.xls';
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function (error) {
                    s.downloading = false;
                    toaster.error('导出失败!');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


angular.module('c.c')
    .controller('PersonnelMealCtrl', function ($scope, Recharge, Table, F) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Recharge,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "money", title: "金额", filter: {money: "num_range"}},
                    {
                        field: "is_cost",
                        title: "计入科室成本",
                        filter: {is_cost: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    },
                    {field: "created_at", title: "充值时间", filter: {created_at: "date_range"}},
                    {field: "handler", title: "充值人", filter: {handler: "text"}},
                    {field: "note", title: "充值理由", filter: {note: "text"}}
                ]
            };
            Table.load(vm, options);
        }
    });


angular.module('c.c')
    .controller('PersonnelRoundsCtrl', function () {

    });
(function () {
    'use strict';

    angular.module('c')
        .controller('UserInfoCtrl', UserInfoCtrl)
        .controller('UserChangeTypeCtrl', UserChangeTypeCtrl)
        .controller('ChangeTypeRecordCtrl', ChangeTypeRecordCtrl)
        .controller('KpiRecordCtrl', KpiRecordCtrl)
        .controller('AddKpiCtrl', AddKpiCtrl)
        .controller('ExportUserInfoDlgCtrl', ExportUserInfoDlgCtrl)
    ;

    /** @ngInject */
    function UserInfoCtrl($scope, $q, $filter, dialogs, Dlg, toaster, NgTableParams, User, UserOnType, F, ArrayHelper, JobTitle) {
        var sexesOpts = F.getNgTableOpts(F.get('sexes'));
        var eduBgs = F.get('edu_bg_list');
        var eduBgOpts = F.getNgTableOpts(eduBgs);
        var enLvs = F.get('eg_lv_list');
        var posts = F.get('posts');
        var enLvOpts = F.getNgTableOpts(enLvs);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        //var titleOpts = F.getNgTableOpts(F.get('titles'));
        var postOpts = F.getNgTableOpts(F.get('posts'));
        $scope.titleTypes = JobTitle.getTypes();
        var typeOpts = F.getNgTableOpts($scope.titleTypes);
        $scope.titleLevels = User.getTitleLevel();
        var levelOpts = F.getNgTableOpts($scope.titleLevels);

        $scope.hospital = hospital;
        $scope.change = change;

        $scope.cols = [
            /* 基本信息 */
            {title: '姓名', sortable: 'name', filter: {name: 'text'}, field: 'name', type: 0xff}, //0
            { //1
                title: '主科室',
                filter: {main_dept: 'text'},
                field: 'main_dept',
                type: 0x01
            },
            { //2
                title: '性别',
                filter: {sex: 'select'},
                data: sexesOpts,
                field: 'sex',
                type: 0x01
            },
            { //3
                title: '出生日期',
                sortable: 'birthday',
                filter: {birthday: 'date_range'},
                field: 'birthday',
                type: 0x01
            },
            { //4
                title: '民族',
                sortable: 'nation_id',
                field: 'nation_id',
                filter: {nation_id: 'select'},
                type: 0x01
            },
            { //5
                title: '籍贯',
                sortable: 'native_place',
                field: 'native_place',
                filter: {native_place: 'text'},
                type: 0x01
            },
            /*账户信息*/
            { //7
                title: '用户名',
                sortable: 'username',
                filter: {username: 'text'},
                field: 'username',
                type: 0x02
            },
            {title: '邮箱', sortable: 'email', filter: {email: 'text'}, field: 'email', type: 0x02},//8

            /*教育背景*/
            { //9
                title: '毕业学校',
                filter: {graduate_school: 'text'},
                field: 'graduate_school',
                type: 0x04
            },
            {  //10
                title: '政治面貌',
                filter: {political_status_id: 'select'},
                field: 'political_status_id',
                type: 0x04
            },
            //{title: '所学专业', filter: {major: 'text'}, field: 'major', type: 0x04},//11
            {  //11
                title: '专业',
                sortable: 'major_id',
                filter: {major_id: 'select'},
                field: 'major_id',
                type: 0x04
            },
            {  //12
                title: '学历',
                sortable: 'edu_bg',
                filter: {edu_bg: 'select'},
                data: eduBgOpts,
                field: 'edu_bg',
                type: 0x04
            },
            {title: '学位', sortable: 'degree', filter: {degree: 'text'}, field: 'degree', type: 0x04},//13
            { //14
                title: '英语等级',
                filter: {en_lv: 'select'},
                data: enLvOpts,
                field: 'en_lv',
                type: 0x04
            },

            /* 联系方式 */
            {title: '手机', filter: {phone: 'text'}, field: 'phone', type: 0x08}, //15
            {title: '手机集团小号', filter: {cornet: 'text'}, field: 'cornet', type: 0x08},//16
            {title: '备用手机', filter: {phone2: 'text'}, field: 'phone2', type: 0x08},//17
            {//18
                title: '办公室电话',
                filter: {office_phone: 'text'},
                field: 'office_phone',
                type: 0x08
            },
            {//19
                title: '办公室小号',
                filter: {office_cornet: 'text'},
                field: 'office_cornet',
                type: 0x08
            },

            {title: 'QQ', filter: {qq: 'text'}, field: 'qq', type: 0x08},//20
            {title: '联系地址', filter: {address: 'text'}, field: 'address', type: 0x08},//21

            /* 工作相关 */
            { //22
                title: '编制类型',
                sortable: 'status_id',
                filter: {status_id: 'select'},
                field: 'status_id', type: 0x10
            },
            { //23
                title: '类别',
                sortable: 'type_id',
                filter: {type_id: 'select'},
                field: 'type_id', type: 0x10
            },
            {  //24
                title: '工资卡',
                filter: {salary_card: 'text'},
                field: 'salary_card',
                type: 0x10
            },
            { //24
                title: '参加工作时间',
                sortable: 'started_work',
                filter: {started_work: 'date_range'},
                field: 'started_work',
                type: 0x10
            },
            { //25
                title: '入职时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                type: 0x10
            },
            { //26
                title: '入职类型',
                sortable: 'entry_type_id',
                filter: {entry_type_id: 'select'},
                field: 'entry_type_id', type: 0x10
            },
            { //27
                title: '中层以上干部',
                filter: {is_cadre: 'select'},
                data: yesNoOpts,
                field: 'is_cadre', type: 0x10
            },
            { //27
                title: '职称',
                filter: {title_id: 'select'},
                field: 'title', type: 0x10
            },
            { //27
                title: '职务',
                filter: {post: 'select'},
                data: postOpts,
                field: 'post', type: 0x10
            },
            { //27
                title: '职称类型',
                filter: {title_type: 'select'},
                data: typeOpts,
                field: 'title_type', type: 0x10
            },
            { //27
                title: '等级',
                filter: {level: 'select'},
                data: levelOpts,
                field: 'level', type: 0x10
            },
            { //27
                title: '钉钉号',
                field: 'dd_user_id', type: 0x10
            },
            { //28
                title: '全院调查对象',
                filter: {is_hospital_respondent: 'select'},
                data: yesNoOpts,
                field: 'is_hospital_respondent', type: 0x01
            },
            {title: '备注', filter: {comments: 'text'}, field: 'comments', type: 0x08},//29
            { //30
                title: '毕业时间',
                sortable: 'graduate_time',
                filter: {graduate_time: 'date_range'},
                field: 'graduate_time',
                type: 0x10
            },
            { //31
                title: '专技聘任时间',
                sortable: 'title_time',
                filter: {title_time: 'date_range'},
                field: 'title_time',
                type: 0x10
            },
            { //32
                title: '专职聘任时间',
                sortable: 'post_time',
                filter: {post_time: 'date_range'},
                field: 'post_time',
                type: 0x10
            },
            {//33
                title: '身份证号',
                filter: {idcard: 'text'},
                field: 'idcard',
                type: 0x08
            }

        ];

        $scope.optColWidth = 45;

        //$scope.depts_col = $scope.cols[1];
        $scope.nations_col = $scope.cols[4];
        $scope.political_statuses_col = $scope.cols[9];
        $scope.statuses_col = $scope.cols[21];
        $scope.user_types_col = $scope.cols[22];
        $scope.entry_types_col = $scope.cols[26];
        $scope.majors_col = $scope.cols[10];
        $scope.title_col = $scope.cols[28];
        //$scope.leave_reasons_col = $scope.cols[30];

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.visibleOptions = [
            {title: '基本信息', value: 0x01},
            {title: '账户信息', value: 0x02},
            {title: '教育背景', value: 0x04},
            {title: '联系方式', value: 0x08},
            {title: '工作相关', value: 0x10},
            //{divider: true},
            {title: '全部信息', value: 0xff}
        ];
        $scope.option = {title: '基本信息', value: 1};

        $scope.optionSelectedFn = function (option) {
            $scope.option = option;
            angular.forEach($scope.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                } else {
                    col.show = false;
                }
            });
        };

        $scope.optionSelectedFn($scope.option);

        $scope.optInFront = true;
        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 30
        }, {
            counts: [30, 50, 100],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['date_range_filters'] = $scope.dateRangeFilter;
                url['opt'] = 1;
                url['show_unconfirmed'] = !$scope.showAllUsers;
                url['is_leaved'] = 0;
                User.query(url, function (data) {
                    var users = data.users;
                    $scope.statuses = data.statuses;
                    angular.forEach(users, function (u) {
                        u.edu_bg = F.getItem(u.edu_bg, eduBgs);
                        u.en_lv = F.getItem(u.en_lv, enLvs);
                        u.post = F.getItem(u.post, posts);
                        u.level = F.getItem(u.level, $scope.titleLevels);
                        if (u.title && u.title.type) {
                            u.title_type = ArrayHelper.getItem(u.title.type, $scope.titleTypes);
                        }
                    });

                    //$scope.depts_col.data = F.getNgTableOpts(data.depts);
                    $scope.nations_col.data = F.getNgTableOpts(data.nations);
                    $scope.majors_col.data = F.getNgTableOpts(data.majors);
                    $scope.statuses_col.data = F.getNgTableOpts(data.statuses);
                    $scope.user_types_col.data = F.getNgTableOpts(data.types);
                    $scope.entry_types_col.data = F.getNgTableOpts(data.entry_types);
                    //$scope.leave_reasons_col.data = F.getNgTableOpts(data.leave_reasons);
                    $scope.political_statuses_col.data = F.getNgTableOpts(data.political_statuses);
                    $scope.title_col.data = F.getNgTableOpts(data.titles);

                    params.total(data.total);
                    $defer.resolve(users);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.showAllUsers = true;
        $scope.filterConfirmState = function () {
            $scope.showAllUsers = !$scope.showAllUsers;
            $scope.tableParams.reload();
        };

        $scope.edit = function (user) {
            dialogs.create('templates/user_edit_dlg.html', 'UserEditCtrl',
                {user_id: user.id, sys_edit: true, confirm_state: '2'}, {

                    size: 'lg'
                }).result.then(function (params) {
                toaster.success('用户信息修改成功!');
                if (user.id == $scope.account.id) {
                    $scope.account.confirm_state = 2; //2表示人事科已确认
                }
                $scope.tableReload();
            });
        };

        $scope.exportDn = function () {
            Dlg.show({
                template: 'templates/export/ExportUserInfoDlg.html',
                ctrl: 'ExportUserInfoDlgCtrl',
                data: {}
            }).then(function () {
                Dlg.s('用户信息导出成功!');
            })
        };

        $scope.changeType = function (user) {              //修改用户编制信息
            dialogs.create('changeOnTypeDlg.html', 'UserChangeTypeCtrl',
                {user: user, statuses: $scope.statuses}, {

                    size: 'md'
                }).result.then(function (user) {
                UserOnType.save(user).$promise.then(function () {
                    toaster.success('用户编制信息修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('用户编制信息修改失败!');
                });

            });
        };

        $scope.changeRecord = function (user) {              //查看编制修改记录
            dialogs.create('changeTypeRecord.html', 'ChangeTypeRecordCtrl',
                {user: user}, {

                    size: 'md'
                });
        };

        $scope.kpi = function (user) {              //查看绩效系数记录
            dialogs.create('/templates/kpi/kpiDlg.html', 'KpiRecordCtrl',
                {user: user}, {
                    size: 'md'
                });
        };

        $scope.changePwd = changePwd;

        function changePwd(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: user}
            }).then(function () {
                $scope.tableReload();
            });
        }

        $scope.clearWxBind = clearWxBind;
        $scope.bindDingTalk = bindDingTalk;


        function clearWxBind(user) {
            User.update({id: user.id}, {
                opt: 4 // OPT_CLEAR_BIND
            }).$promise.then(function (resp) {
                if (resp.result == 0) {
                    Dlg.s('解绑成功');
                    user.wx_bind = null;
                }
            });
        }

        function bindDingTalk(user) {
            Dlg.comment({title: '绑定钉钉号(空置解绑)', label: '钉钉号', notRequired: true}, function (ddId) {
                User.update({id: user.id}, {
                    opt: 10, dd_user_id: ddId ? ddId : null
                }).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $scope.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            });
        }

        $scope.delete = function (user) {
            dialogs.confirm('删除员工记录', '确定要删除<strong>' + user.name + '</strong>的员工记录吗?')
                .result.then(function () {
                User.delete({id: user.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('员工记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('该员工属于科室成员,无法直接删除');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('员工记录删除失败!');
                });
            });
        };

        $scope.transfer = function (user) {
            dialogs.create('templates/dept_record_dlg.html', 'DeptRecordDlgCtrl',
                {user: user, hideOpt: false}, {

                    size: 'lg'
                });
        };

        function hospital() {
            Dlg.show({
                template: 'directives/form/user-selector/user_selector_dlg.html',
                ctrl: 'UserSelectCtrl',
                data: {
                    title: '全院调查对象设置', multiSelect: true, forReceive: true
                }
            }).then(function (pa) {
                if (pa.selected.length > 0) {
                    var params = {};
                    params['opt'] = 11;
                    params['members'] = ArrayHelper.listKey(pa.selected);
                    params['result'] = pa.result;
                    User.update({id: '-'}, params).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $scope.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                        else console.log('error', error);
                    });
                }
            });
        }

        function change(user) {
            var params = {};
            params['opt'] = 11;
            params['members'] = [user.id];
            params['result'] = user.is_hospital_respondent == 0;
            User.update({id: '-'}, params).$promise.then(function (resp) {
                $scope.tableReload();
            }, function (error) {
                if (error.data) Dlg.e(error.data.msg);
                else console.log('error', error);
            });
        }
    }

    /** @ngInject */
    function UserChangeTypeCtrl($scope, $uibModalInstance, toaster, User, data) {
        var user = data.user;
        $scope.statuses = data.statuses;
        $scope.user = {id: user.id, username: user.username, status: user.status, time: new Date()};
        $scope.ok = function (user) {
            if ($scope.otype_form.$valid) {
                var pa = {};
                pa['username'] = user.username;
                pa['status_id'] = user.status.id;
                pa['user_id'] = user.id;
                pa['time'] = user.time;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                $scope.otype_form.submitted = true;
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function ChangeTypeRecordCtrl($scope, $uibModalInstance, toaster, NgTableParams, UserOnType, Table, F, $filter, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                Table.query(UserOnType, url, $defer, params, 'onTypes');
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function KpiRecordCtrl($scope, $uibModalInstance, toaster, NgTableParams, UserKpi, dialogs, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                url['opt'] = 2;
                UserKpi.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.add_kpi = function (user) {              //人事科对人员进行评估或直接输入绩效系数
            dialogs.create('/templates/kpi/addKpiDlg.html', 'AddKpiCtrl',
                {user: user}, {
                    size: 'md'
                }).result.then(function (pa) {
                if (pa) {
                    UserKpi.save(pa).$promise.then(function () {
                        toaster.success('用户绩效系数添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('用户绩效系数添加失败!');
                    });
                } else {
                    $scope.tableReload();
                }
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function AddKpiCtrl($scope, $uibModalInstance, toaster, User, dialogs, UserKpi, data) {
        var user = data.user;

        $scope.user_kpi = {direct: '1'};
        $scope.ok = function (user_kpi) {
            if (user_kpi.direct == 1) {
                if (!user_kpi.real_kpi) {
                    toaster.warning('请输入员工绩效系数!');
                } else {
                    var pa = {};
                    pa['user_id'] = user.id;
                    pa['real_kpi'] = user_kpi.real_kpi;
                    $uibModalInstance.close(pa);
                }
            } else {
                $scope.cancel();
            }
        };

        $scope.kpi = function () {
            dialogs.create('templates/kpi/user_kpi.html', 'UserKpiCtrl', {
                record: {user_id: user.id}
            }, {
                size: 'md'
            }).result.then(function (kpi) {
                UserKpi.save(kpi).$promise.then(function () {
                    toaster.success('员工绩效系数添加成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('员工绩效系数添加失败!');
                });
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function ExportUserInfoDlgCtrl($uibModalInstance, User, FileHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.m = {is_cadre: 0};

        init();


        function init() {
            User.get({id: 0}).$promise.then(function (resp) {
                vm.depts = resp.depts;
                if (vm.depts && vm.depts.length > 0) {
                    vm.depts.splice(0, 0, {name: '全部科室'});
                    vm.m.dept = vm.depts[0];
                }
                vm.types = resp.types;
            })
        }

        function ok(m) {
            var pa = {
                dept_id: m.dept ? m.dept.id : undefined,
                is_cadre: m.is_cadre,
                types: []
            };
            angular.forEach(m.type, function (type) {
                pa.types.push(type.id)
            });

            FileHelper.dnExcel(User.urls.EXPORT_USER_INFO,
                pa, '员工信息表.xls', function () {
                    vm.close();
                });
        }
    }
})();


(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserRegCtrl', UserRegCtrl);

    /** @ngInject */
    function UserRegCtrl($scope, $filter, dialogs, toaster, F, User, ArrayHelper, JobTitle) {
        $scope.sexes = F.get('sexes');
        $scope.edu_bgs = F.get('edu_bg_list');
        $scope.degree_types = F.get('degree_types');
        $scope.en_lvs = F.get('eg_lv_list');
        $scope.titleLeaves = User.getTitleLevel();
        $scope.titleTypes = JobTitle.getTypes();
        $scope.posts = F.get('posts');
        $scope.reg_stage = true;
        $scope.hide_photo = true;
        $scope.jobTypes = User.getJobTypes();

        var username_regex_list = [
            /^\d{4,5}$/,  //正式员工
            /^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[1235789])\d{8}$/,  //试用实习均使用手机号注册
        ];
        $scope.username_regex = username_regex_list[0];

        $scope.submit = function (user) {
            if ($scope.u_form.$valid) {
                var pa = {};
                //账户信息
                pa['username'] = user.username;
                pa['password'] = user.password;

                pa['level'] = user.level.id;

                //基本信息
                pa['name'] = user.name;
                //if (user.id_card) {
                //    var len = user.id_card.length - 1;
                //    if (user.id_card[len] === 'x') {
                //        pa['id_card'] = user.id_card.substr(0, len) + 'X';
                //    } else {
                //        pa['id_card'] = user.id_card;
                //    }
                //}
                pa['sex'] = user.sex.id;
                pa['birthday'] = $filter('date')(user.birthday, 'yyyy-MM-dd');
                pa['nation_id'] = user.nation.id;
                pa['native_place'] = user.native_place;
                pa['political_status_id'] = user.political_status.id;

                //工作相关
                pa['photo'] = user.photo;
                pa['status_id'] = user.status.id;
                pa['type_id'] = user.type.id;
                if (user.type.id == 2) {
                    pa['standard'] = user.standard.id;
                }
                if (user.post) {
                    pa['post'] = user.post.id;
                }
                if (user.title) {
                    pa['title_id'] = user.title.id;
                }
                //  主要科室...
                pa['dept_id'] = user.dept.id;
                pa['is_cadre'] = user.is_cadre;
                pa['entry_type_id'] = user.entry_type.id;
                pa['entry_time'] = $filter('date')(user.entry_time, 'yyyy-MM-dd');
                //pa['salary_card'] = user.salary_card;
                pa['started_work'] = $filter('date')(user.started_work, 'yyyy-MM-dd');

                //教育背景
                pa['graduate_school'] = user.graduate_school;
                pa['major'] = user.major;
                pa['edu_bg'] = user.edu_bg.id;
                pa['degree'] = user.degree.name;
                pa['en_lv'] = user.en_lv.id;

                //联系方式
                pa['phone'] = user.phone;
                pa['cornet'] = user.cornet;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                pa['office_cornet'] = user.office_cornet;
                pa['email'] = user.email;
                pa['address'] = user.address;

                //$scope.xxx = pa;
                User.save(pa).$promise.then(function () {
                    toaster.success('员工记录添加成功!');
                    $scope.reset();
                }, function (error) {
                    var msg = '员工记录添加失败!';
                    if (error.data.code == 23000) {
                        var m = error.data.msg;
                        if (m.indexOf('users_username_unique') > 0) {
                            msg = '所填用户名已被注册!';
                        } else if (m.indexOf('users_phone_unique') > 0) {
                            msg = '所填手机号已被注册!';
                        } else if (m.indexOf('users_email_unique') > 0) {
                            msg = '所填邮箱已被注册!';
                            //} else if (m.indexOf('users_id_card_unique') > 0) {
                            //    msg = '所填身份证号已被注册!';
                        }
                    }
                    toaster.error(msg);
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }

        };

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date(1990, 0, 1)
        };

        $scope.titleTypeSelected = function (m) {
            if (m.title_type) {
                var fTitles = ArrayHelper.filter($scope.titles, function (title) {
                    return title.type === m.title_type.id;
                });
                if (!m.title || m.title.type !== m.title_type.id) m.title = fTitles[0];
                $scope.fTitles = fTitles;
            }
        };

        $scope.degreeTypeSelectedFn = function (type) {
            $scope.degrees = User.getDegrees(type.id);
            $scope.user['degree'] = $scope.degrees[0];
        };

        $scope.statusSelectedFn = function (status, user) {
            if (status.id == 3 || status.id == 4 || status.id == 6 || status.id == 8 || status.id == 11) { //试用
                $scope.username_regex = username_regex_list[1];
            } else {
                $scope.username_regex = username_regex_list[0];
            }
        };

        $scope.deptTypeFn = function (d) {
            return d.type.name;
        };

        $scope.onTypeSelectedFn = function (type, user) {
            if (type.id == 2) {
                user.standard = $scope.standards[0];
            }
        };

        $scope.addUserPhoto = function (user) {
            dialogs.create('templates/upload/userpic_dlg.html',
                'UploadUserpicDlg', {}, {size: 'md'}
            ).result.then(function (resp) {
                user.photo = resp;
            });
        };

        var init = function () {
            $scope.user = {is_cadre: false, password: "Tcd120cn"};
            $scope.user['sex'] = $scope.sexes[0];
            $scope.user['edu_bg'] = $scope.edu_bgs[0];
            $scope.user['degree_type'] = $scope.degree_types[0];
            $scope.degrees = User.getDegrees($scope.user['degree_type'].id);
            $scope.user['degree'] = $scope.degrees[0];
            $scope.user['en_lv'] = $scope.en_lvs[0];

            //$scope.$watch('user.id_card', function (newVal, oldVal) {
            //    var id_card = newVal;
            //    if (id_card != oldVal && id_card != '' && id_card != null) {
            //        var native = id_card.substr(0, 6);
            //        var birthday = id_card.substr(6, 8);
            //        var sex = $scope.sexes[(parseInt(id_card.substr(16, 1)) + 1) % 2];
            //        $scope.user.birthday = uibDateParser.parse(birthday, 'yyyyMMdd');
            //        $scope.user.sex = sex;
            //        $http.post("http://" + window.location.host + '/api/v1/native_place',
            //            {id_native: native}).success(function (resp) {
            //                switch (resp.result) {
            //                    case 0:
            //                        $scope.user.native_place = resp.native_place;
            //                        break;
            //                    case 1:
            //                        toaster.warning('没有找到和您输入的身份证号对应的籍贯信息，请检查身份证号前6位是否有误!');
            //                        break;
            //                }
            //            });
            //    }
            //});
        };

        $scope.reload = function () {
            init();
            User.get({id: 0}, function (resp) {
                $scope.titles = resp.titles;
                $scope.types = resp.types;
                $scope.statuses = resp.statuses;
                $scope.standards = resp.standards;
                //暂时去掉 实习和试用
                //$scope.statuses.splice(2, 2);

                $scope.entry_types = resp.entry_types;
                $scope.nations = resp.nations;
                $scope.political_statuses = resp.political_statuses;
                $scope.depts = resp.depts;
                $scope.performances = resp.performances;

                $scope.user['type'] = resp.types[0];
                $scope.user['status'] = resp.statuses[0];
                $scope.user['entry_type'] = resp.entry_types[0];
                $scope.user['nation'] = resp.nations[0];
                $scope.user['political_status'] = resp.political_statuses[0];
                $scope.user['dept'] = resp.depts[0];
                $scope.user['performance'] = ArrayHelper.getItem(13, $scope.performances);   //绩效层级默认无层级
            });

            if ($scope.u_form) {
                $scope.u_form.$submitted = false;
                $scope.u_form.$setPristine(true);
            }
        };

        $scope.reset = function () {
            init();

            $scope.user['type'] = $scope.types[0];
            $scope.user['status'] = $scope.statuses[0];
            $scope.user['entry_type'] = $scope.entry_types[0];
            $scope.user['nation'] = $scope.nations[0];
            $scope.user['political_status'] = $scope.political_statuses[0];
            $scope.user['dept'] = $scope.depts[0];

            $scope.u_form.$submitted = false;
            $scope.u_form.$setPristine(true);
        };

        $scope.reload();
    }

})();





'use strict';

angular.module('c.c')
    .controller('PersonnelWageCtrl', function () {
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('ArticleCtrl', ArticleCtrl);

    /** @ngInject */
    function ArticleCtrl($stateParams, $http, $sce, C, Auth, FileHelper, WxHelper, deviceDetector, Bulletin, OS, Dlg, Bid) {
        var isNews = $stateParams.type === 'news';
        var isBulletin = $stateParams.type === 'bulletin';
        var isBid = $stateParams.type === 'bids';
        var vm = this;
        vm.download = download;
        vm.sendWxRemind = sendWxRemind;
        vm.ok = ok;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            var path = isNews ? 'news' : isBulletin ? 'bulletin' : 'bids';
            $http.get('/api/v1/' + path + '/' + id).then(function (resp) {
                var article = resp = resp.data;
                article.body = $sce.trustAsHtml(article.body);
                if (path === 'bids') {
                    article.dept = article.dept.name;
                }
                vm.article = article;
                if (isBulletin || isBid) {
                    var bulletin = resp;
                    // 期望查看是否已读的阅读人
                    if (resp.recipients && resp.recipients.length > 0) {
                        var partIn = [], notPartIn = [];
                        angular.forEach(resp.recipients, function (r) {
                            if (r.is_read) {
                                partIn.push(r);
                            } else {
                                notPartIn.push(r);
                            }
                        });
                        vm.article.partIn = partIn;
                        vm.article.notPartIn = notPartIn;
                        vm.article.recipients = resp.recipients;
                        vm.article.canSendWxRemind = Auth.getAccount().id == resp.sender_id; // 暂时只允许发布人微信提醒
                    }
                    if (!bulletin.recipient || (!bulletin.recipient.is_read && !bulletin.recipient.is_read_observer)) {
                        var params = {};
                        params['opt'] = 1;
                        params['start'] = bulletin.start;
                        if (isBulletin) {
                            params['bulletin_id'] = bulletin.id;
                            Bulletin.collect(params);
                        } else {
                            params['bid_id'] = bulletin.id;
                            Bid.collect(params);
                        }
                    }
                    if (!bulletin.recipient.is_read && bulletin.recipient.is_read_observer) {
                        Dlg.notify("请在阅读后<strong class='text-red'>点击知晓同意</strong>再关闭!!");
                    }
                }
            }, function (e) {
                if (path === 'news') {
                    vm.error2 = '没有找到该新闻';
                } else if (path === 'bulletin') {
                    vm.error2 = '没有找到该公告';
                } else if (path === 'bids') {
                    vm.error2 = '没有找到该招标采购';
                }
            });
        }

        function sendWxRemind(bulletin) {
            if (isBulletin) {
                return Bulletin.collect({
                    opt: 4 /*  微信通知未读员工*/,
                    bulletin_id: bulletin.id
                }).$promise.then(function () {
                    Dlg.i("提醒成功");
                }, function (err) {
                    if (err.status === 429) {
                        Dlg.error(err.data.msg);
                    }
                });
            } else {
                return Bid.collect({
                    opt: 4 /*  微信通知未读员工*/,
                    bid_id: bulletin.id
                }).$promise.then(function () {
                    Dlg.i("提醒成功");
                }, function (err) {
                    if (err.status === 429) {
                        Dlg.error(err.data.msg);
                    }
                });
            }

        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.BULLETIN_DOWNLOAD, attachment);
            }
        }

        function ok(m) {
            if (isBulletin) {
                var params = {};
                params['opt'] = 1;
                params['bulletin_id'] = m.id;
                params['start'] = m.start;
                Bulletin.collect(params).$promise.then(function () {
                    Dlg.i("提交成功");
                });
            }
            if (isBid) {
                var params = {};
                params['opt'] = 1;
                params['bid_id'] = m.id;
                params['start'] = m.start;
                Bid.collect(params).$promise.then(function () {
                    Dlg.i("提交成功");
                });
            }

        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('CovidCtrl', CovidCtrl);

    /** @ngInject */
    function CovidCtrl(Api, $stateParams, $http, $sce, deviceDetector, OS) {
        var vm = this;

        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('api/v1/covid/covids', {
                params: {
                    op: 'preview',
                    id: id
                }
            }).then(function (resp) {
                vm.covid = resp.data.items[0];
                if (vm.covid) {
                    vm.covid.body = $sce.trustAsHtml(vm.covid.body);
                } else {
                    vm.error = '没有找到该疫情防控通知';
                }

            }, function (e) {
                vm.error = '没有找到该疫情防控通知';
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('EmailShowCtrl', EmailShowCtrl);

    /** @ngInject */
    function EmailShowCtrl($stateParams, $http, $sce, C, WxHelper, FileHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/emails/' + id).then(function (resp) {
                var m = resp.data.mail;
                m.body = $sce.trustAsHtml(m.body);
                vm.m = m;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                }
                else {
                    vm.error2 = '没有找到该邮件';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MAIL_DOWNLOAD, attachment);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('MeetingPreviewCtrl', MeetingPreviewCtrl);

    /** @ngInject */
    function MeetingPreviewCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/meeting/meetings/' + id).then(function (resp) {
                var meeting = resp.data.meeting;
                meeting.content = $sce.trustAsHtml(meeting.content);
                meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                vm.meeting = meeting;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                } else {
                    vm.error2 = '没有找到该会议';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: att, name: scope.name}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('MissionPreviewCtrl', MissionPreviewCtrl);

    /** @ngInject */
    function MissionPreviewCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {

        var vm = this;
        vm.download = download;

        init($stateParams.id);

        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/mission/missions/' + id).then(function (resp) {
                var mission = resp.data.mission;
                mission.content = $sce.trustAsHtml(mission.content);
                mission.time_range = mission.start_time.substr(0, 16) + ' - ' + mission.end_time.substr(0, 16);
                vm.mission = mission;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                }
                else {
                    vm.error2 = '没有找到该任务';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: att, name: scope.name}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MISSION_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('PreviewShowDlgCtrl', PreviewShowDlgCtrl);

    /** @ngInject */
    function PreviewShowDlgCtrl($uibModalInstance, $sce, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.url, data.name);


        function init(url, name) {
            vm.name = name;
            vm.url = $sce.trustAsResourceUrl(url);
        }
    }

})();

angular.module('c.c')
    .controller('ClincLargeScreenCtrl', function ($scope, ClincSchedule, $interval, Clinc, ArrayHelper, ClincDoctor, $location, Setting) {
        var vm = $scope;
        vm.count = 0;
        vm.getRowNum = getRowNum;

        var timer, items;//定时器
        vm.page = 1;//显示页面记录
        vm.pageCountr = 0;
        vm.schedules = [];
        vm.scheduleList = [];
        vm.rowNum = 0;
        vm.total = 0;
        vm.note = '';
        var $parent = $('.js-slide-list');
        var shifts = Clinc.getShifts();
        var types = ClincDoctor.getTypes();
        var startAt = new Date();

        var PAGE_COUNT = 7;//页面数据显示量
        var REFRESH_TIME = 2.4;//刷新页面时间(秒)

        init();

        function init() {
            vm.clientHeight = document.documentElement.clientHeight;
            window.onresize = function temp() {
                vm.clientHeight = document.documentElement.clientHeight;
            };
            vm.loading = true;

            Setting.get({key: Setting.KEY.CLINC_NOTE}, function (resp) {
                vm.note = resp.note;
            });

            vm.date = startAt.getFullYear() + '年' + (startAt.getMonth() + 1) + '月' + startAt.getDate() + '日';
            vm.weekday = "星期" + "日一二三四五六".charAt(startAt.getDay());
            timeUpdate();

            timer = $interval(function () {
                timeUpdate();
                if ($location.path() !== '/clinc_large_screen') {
                    destroyInterval();
                }
            }, 1000);

            //初始化数据
            items = $interval(function () {
                var $first = $parent.find('li:first');
                var height = $first.height();
                if (vm.schedules.length <= 2)
                    getData(function () {
                        pageChange($first, height)
                    });
                else
                    pageChange($first, height);

            }, 1000 * REFRESH_TIME);

            //页面关闭时，销毁定时器
            $scope.$on('destroy', function () {
                destroyInterval();
            });
        }

        function destroyInterval() {
            $interval.cancel(timer);
            $interval.cancel(items);
            timer = items = null;
        }

        function pageChange($first, height) {
            //有一个1px的横条
            height = height + 1;
            if (vm.total <= PAGE_COUNT || vm.scheduleList.length === 0) {
                // var changed = vm.scheduleList !== vm.schedules;
                vm.scheduleList = angular.copy(vm.schedules);
                vm.schedules = [];
                // if (changed) $scope.$apply();
            } else {
                $first.animate({
                    marginTop: -height + 'px'
                }, REFRESH_TIME * 1000 / 3, function () {
                    $first.remove();
                    vm.scheduleList.shift();
                    vm.scheduleList.push(vm.schedules.shift());
                });
            }
        }

        function getRowNum() {
            vm.rowNum++;
            return vm.rowNum % 2;
        }

        function getData(cb) {
            ClincSchedule.query({opt: 4/*INDEX_NORMAL_TODAY*/, count: PAGE_COUNT + 1, page: vm.page}, function (resp) {
                angular.forEach(resp.items, function (item) {
                    loadItem(item);
                    vm.schedules.push(item);
                });
                if (vm.page * (PAGE_COUNT + 1) >= resp.total) {
                    vm.page = 1;
                } else {
                    vm.page++;
                }
                vm.total = resp.total;
                if (vm.total <= PAGE_COUNT) {
                    vm.count = 0;
                }
                if (vm.loading) vm.loading = false;

                if (angular.isDefined(cb)) cb();
            });
        }

        function timeUpdate() {
            var now = new Date();
            vm.now = timeToStr(now.getHours()) + ':' + timeToStr(now.getMinutes()) + ':' + timeToStr(now.getSeconds());
        }

        function timeToStr(time) {
            if (time < 10) {
                time = '0' + time;
            }
            return time;
        }

        function loadItem(item) {
            item.count = vm.count++;
            item.shift = ArrayHelper.getItem(item.shift, shifts).name;
            item.error = item.state == 3 || item.quantity == 0;
            if (item.state == 3) {
                item.quantity = '停诊'
            }
            item.doctor.titleName = item.doctor.distinguished_title ? item.doctor.distinguished_title : item.doctor.title.name;
        }
    });
angular.module('c.c')
    .controller('SecurityCashCtrl', function ($scope, $filter, dialogs, toaster) {

    });


angular.module('c.c')
    .controller('ParkingLotCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ParkingLot, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);
        $scope.cols = [
            {title: '名称', filter: {name: 'text'}, field: 'name', width: "18%", show: true},
            {title: '租金', sortable: 'rent', filter: {rent: 'number_range'}, field: 'rent', show: true},
            {title: '剩余数量', sortable: 'num', filter: {num: 'number_range'}, field: 'num', show: true},
            {title: '已用数量', sortable: 'used_num', field: 'used_num', show: true},
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: "15%", show: true}
        ];

        $scope.optColWidth = 76;
        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            filter: {}
        }, {
            counts: [5, 10],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.rent) {
                    url['rent_start'] = $scope.numRangeFilter.rent.start;
                    url['rent_end'] = $scope.numRangeFilter.rent.end;
                }
                ParkingLot.query(url, function (data) {
                    params.total(data.total);
                    var records = data.records;
                    angular.forEach(records, function (record) {
                        record.is_stop = F.getItem(record.is_stop, $scope.yesNo);
                    });
                    $defer.resolve(records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.tableParams.filter({});
        };


        $scope.add = function () {
            dialogs.create('ParkingLotDlg.html', 'ParkingLotDlgCtrl',
                {}, { size: 'md'})
                .result.then(function (type) {
                    ParkingLot.save(type).$promise.then(function (resp) {
                        toaster.success('车位添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('此停车位已存在,添加失败!');
                    })
                });
        };

        $scope.edit = function (record) {
            record.$edit = true;
            record.$nameChanged = record.name;
            record.$rentChanged = record.rent;
            record.$numChanged = record.num;
            record.$is_stopChanged = record.is_stop;
        };

        $scope.save = function (record) {
            record.$edit = false;
            if (record.$nameChanged == "") {
                toaster.error('名称不能为空!');
            } else if (record.name != record.$nameChanged || record.rent != record.$rentChanged || record.is_stop != record.$is_stopChanged.id) {
                var data = {};
                data['name'] = record.$nameChanged;
                data['rent'] = record.$rentChanged;
                data['num'] = record.$numChanged;
                data['is_stop'] = record.$is_stopChanged.id;
                ParkingLot.update({id: record.id}, data).$promise.then(function () {
                    toaster.success('停车位修改成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('停车位修改失败!');
                });

            }
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除停车位', '确定要删除<strong>' + record.name + '</strong>的车位吗?')
                .result.then(function () {
                    ParkingLot.delete({id: record.id}).$promise.then(function (data) {
                        switch (data.result) {
                            case 0:
                                toaster.success('车位删除成功!');
                                break;
                            case 1:
                                toaster.warning('该车位尚在租期,不能删除!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('车位删除失败!');
                    });
                });
        };
    });

angular.module('c.c').controller('ParkingLotDlgCtrl',
    function ($scope, $modalInstance, toaster, data) {
        $scope.parking = {};

        $scope.ok = function (parking) {
            if ($scope.parking_form.$valid) {
                var params = {};
                params['name'] = parking.name;
                params['rent'] = parking.rent;
                params['num'] = parking.num;
                $modalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.parking_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });


angular.module('c.c')
    .controller('ParkingRentCtrl', function ($scope, $filter, dialogs, toaster, FileHelper,
                                             NgTableParams, UserParking, C, F, SaveAs) {

        $scope.pay_types = F.get('pay_types');
        var pay_types = F.getNgTableOpts($scope.pay_types);
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);
        $scope.cols = [
            {title: '员工姓名', field: 'user_name', filter: {'users.name': 'text'}, show: true}, //0
            {title: '科室', field: 'dept_name', filter: {'depts.name': 'text'}, show: true}, //0
            {title: '电话', field: 'phone', filter: {'users.phone': 'text'}, show: true}, //0
            {title: '车牌号', field: 'plate_num', filter: {'rush_parks.plate_num': 'text'}, show: true}, //0
            {
                title: '停车位',
                field: 'park_name',
                filter: {'parking_lots.name': 'text'},
                show: true
            }, //0
            {title: '起租时间', filter: {rent_start: 'date_range'}, field: 'rent_start', show: true},
            {title: '停租时间', filter: {rent_end: 'date_range'}, field: 'rent_end', sortable: 'rent_end', show: true},
            {
                title: '支付方式',
                filter: {pay_type: 'select'},
                field: 'pay_type',
                data: pay_types,
                show: true
            },
            // {
            //     title: '是否长期停车',
            //     filter: {'rush_parks.rush': 'select'},
            //     data: yesNoOpts,
            //     field: 'rush_parks.rush',
            //     show: true
            // }
        ];
        $scope.optColWidth = 96;

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                rent_end: 'asc'
            }
        }, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.balance) {
                    url['balance_start'] = $scope.numRangeFilter.balance.start;
                    url['balance_end'] = $scope.numRangeFilter.balance.end;
                }

                url['date_range_filters'] = {};
                if ($scope.dateRangeFilter.rent_start != null) {
                    var startDate = $filter('date')($scope.dateRangeFilter.rent_start.startDate, 'yyyy-MM-dd');
                    var endDate = $filter('date')($scope.dateRangeFilter.rent_start.endDate, 'yyyy-MM-dd');
                    url['date_range_filters']['rent_start'] = {
                        startDate: startDate,
                        endDate: endDate
                    };
                }
                if ($scope.dateRangeFilter.rent_end != null) {
                    var startDate = $filter('date')($scope.dateRangeFilter.rent_end.startDate, 'yyyy-MM-dd');
                    var endDate = $filter('date')($scope.dateRangeFilter.rent_end.endDate, 'yyyy-MM-dd');
                    url['date_range_filters']['rent_end'] = {
                        startDate: startDate,
                        endDate: endDate
                    };
                }
                $scope.url = url;
                UserParking.query(url, function (resp) {
                    $scope.rent_users = resp.rent_users;
                    params.total(resp.total);
                    $scope.parking_lots = resp.parking_lots;
                    $defer.resolve(resp.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('ParkingRentDlg.html', 'ParkingRentDlgCtrl', {
                parking_lots: $scope.parking_lots,
                pay_types: $scope.pay_types,
                rent_users: $scope.rent_users
            }, {
                 size: 'md'
            }).result.then(function (user_parking) {
                    UserParking.save(user_parking).$promise.then(function (resp) {
                        toaster.success('员工车位添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('此用户已租有车位,添加失败!');
                    });
                });
        };


        $scope.edit = function (record) {
            record.$edit = true;
            record.$userChanged = {id: record.user_id, name: record.user_name};
            record.$parkChanged = {id: record.park_id, name: record.park_name};
            record.$rent_startChanged = record.rent_start;
            record.$rent_endChanged = record.rent_end;
            record.$pay_typeChanged = $scope.pay_types[record.pay_type - 1];
        };

        $scope.save = function (record) {
            record.$edit = false;
            if (record.$userChanged == "") {
                toaster.warning('用户不能为空!');
            } else if (record.$parkChanged == "") {
                toaster.warning('停车位不能为空');
            } else if (record.$rent_startChanged == null) {
                toaster.warning('起租时间不能为空');
            } else {
                var data = {};
                data['user_id'] = record.$userChanged.id;
                data['park_id'] = record.$parkChanged.id;
                data['rent_start'] = $filter('date')(record.$rent_startChanged, 'yyyy-MM-dd');
                data['rent_end'] = $filter('date')(record.$rent_endChanged, 'yyyy-MM-dd');
                data['pay_type'] = record.$pay_typeChanged.id;
                UserParking.update({id: record.id}, data).$promise.then(function (resp) {
                    toaster.success('车位出租修改成功!');
                    record.user_name = record.$userChanged.name;
                    record.park_name = record.$parkChanged.name;
                    record.rent_start = $filter('date')(record.$rent_startChanged, 'yyyy-MM-dd');
                    record.rent_end = $filter('date')(record.$rent_endChanged, 'yyyy-MM-dd')
                    record.pay_type = record.$pay_typeChanged.id;
                }, function (error) {
                    toaster.error('车位出租修改失败!');
                });
            }
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除停车位出租记录', '确定要删除<strong>' + record.user_name + '</strong>的出租记录吗?')
                .result.then(function () {
                    UserParking.delete({id: record.id}).$promise.then(function () {
                        toaster.success('车位出租记录删除成功!');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('车位出租记录删除失败!');
                    });
                });

        };

        $scope.stop = function (record) {
            dialogs.create('/templates/time_only.html', 'TimeOnlyCtrl', {}, {
                 size: 'md'
            }).result.then(function (para) {
                    var data = {};
                    data['rent_end'] = para;
                    data['opt'] = 1;   //表明为停租
                    UserParking.update({id: record.id}, data).$promise.then(function () {
                        toaster.success('车位停租成功!');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('车位停租失败!');
                    });
                });
        };

        //导出停车位信息
        $scope.export = function () {
            FileHelper.download(C.URL.PARKING_RENT_DOWNLOAD, {}, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = '车位出租表.xls';
                SaveAs.download(data, filename, options);
            }, function () {
                toaster.error('导出失败!');
            });

        };


    });


angular.module('c.c').controller('ParkingRentDlgCtrl',
    function ($scope, $modalInstance, $filter, toaster, data) {

        $scope.parking_lots = data.parking_lots;
        $scope.pay_types = data.pay_types;
        $scope.rent_users = data.rent_users;
        $scope.user_parking = {
            rent_start: new Date(),
            rent_end: new Date(),
            pay_type: data.pay_types[0],
            park: data.parking_lots[0]
        };

        $scope.ok = function (user_parking) {
            if (user_parking.user == null) {
                toaster.warning('请选择员工!');
            } else if ($scope.user_parking_form.$valid) {
                var params = {};
                params['user_id'] = user_parking.user.id;
                params['park_id'] = user_parking.park.id;
                params['rent_start'] = $filter('date')(user_parking.rent_start, 'yyyy-MM-dd');
                params['pay_type'] = user_parking.pay_type.id;
                $modalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.user_parking_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('TimeOnlyCtrl',
    function ($scope, $modalInstance, $filter) {

        $scope.time = new Date();

        $scope.ok = function (time) {
            var para = $filter('date')(time, 'yyyy-MM-dd');
            $modalInstance.close(para);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });


//angular.module('c.c')
//    .controller('RushParkCtrl', function ($scope, $filter, dialogs, toaster, FileHelper,
//                                          RushPark, C, SaveAs, F, Table) {
//        $scope.$on('practiceRoundChange', function () {
//            $scope.tableReload();
//        });
//        $scope.$on('practiceInfChange', function () {
//            $scope.tableReload();
//        });
//
//        var yesNo = F.getNgTableOpts(F.get('yesNo'));
//
//        $scope.init = function () {
//            var options = {
//                service: RushPark,
//                params: {},
//                optColWidth: 120,
//                sorting: {'rush_parks.user_id': 'desc', 'rush_parks.confirm': 'asc'},
//                items: 'records',
//                cols: [
//                    {title: '姓名', filter: {'users.name': 'text'}},
//                    {title: '工号', filter: {'users.username': 'text'}},
//                    {title: '手机号', filter: {'users.phone': 'text'}},
//                    {title: '科室', filter: {'depts.name': 'text'}},
//                    {title: '车牌号', filter: {'plate_num': 'text'}},
//                    {title: '申请电子通行证', filter: {rush: 'select'}, data: yesNo},
//                    {title: '是否确认', filter: {confirm: 'select'}, data: yesNo}
//                ]
//            };
//            Table.loadNgTable($scope, options, function (data) {
//            });
//        };
//
//        $scope.init();
//
//        //修改车辆信息
//        $scope.edit = function (park) {
//            dialogs.create('templates/rush_park.html', 'RushParkDlgCtrl', {'park': park, 'edit': true}, {
//                size: 'md'
//            }).result.then(function (rush) {
//                RushPark.update({'id': park.id}, rush).$promise.then(function () {
//                    toaster.success('车辆信息修改成功!');
//                    $scope.tableReload();
//                }, function () {
//                    toaster.error('此车牌信息已被占用或您已登记过!');
//                });
//            });
//        };
//
//        $scope.delete = function (record) {
//            dialogs.confirm('删除车牌', '确认要删除' + record.user_name + '的车牌吗?').result.then(function () {
//                RushPark.delete({id: record.id}).$promise.then(function (resp) {
//                    toaster.success('删除成功!');
//                    $scope.tableReload();
//                }, function () {
//                    toaster.error('删除失败!');
//                });
//            });
//        };
//
//        //添加车牌号信息
//        $scope.add = function () {
//            dialogs.create('templates/rush_park.html', 'RushParkDlgCtrl', {'add': true}, {
//                size: 'md'
//            }).result.then(function (rush) {
//                RushPark.save(rush).$promise.then(function () {
//                    toaster.success('车辆信息添加成功!');
//                    $scope.tableReload();
//                }, function () {
//                    toaster.error('此车牌信息已被占用或您已登记过!');
//                });
//            });
//        };
//
//        //确认
//        $scope.confirm = function (park) {
//            RushPark.update({'id': park.id}, {'confirm': 1}).$promise.then(function () {
//                toaster.success('车辆信息确认成功!');
//                $scope.tableReload();
//            }, function () {
//                toaster.error('车辆信息确认失败!');
//            });
//        };
//
//        $scope.export = function () {
//            FileHelper.download(C.URL.RUSH_PARK_DOWNLOAD, {}, function (resp) {
//                var data = [resp];
//                var options = {type: 'vnd.ms-excel'};
//                var filename = '车牌号列表.xls';
//                SaveAs.download(data, filename, options);
//            }, function () {
//                toaster.error('导出失败!');
//            });
//
//        };
//
//
//    });
//

angular.module('c.c')
    .controller('StoreDeliveryCtrl', function ($scope) {

    });


angular.module('c.c')
    .controller('GoodsCtrl', function ($scope, Store, UIHelper, $stateParams) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams);
        Store.query({opt: 8/*INDEX_TIPS*/}, function (resp) {
            vm.show = resp.is_show;
        });
    });

angular.module('c.c')
    .controller('StorePhCtrl', function ($scope, $rootScope, UIHelper, $stateParams) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    });





angular.module('c.c')
    .controller('StoreSteamedCtrl', function ($scope, UIHelper, $stateParams) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams);

    });

angular.module('c.c')
    .controller('StoreWmCtrl', function ($scope) {

    });


angular.module('c.c')
    .controller('SupplyMaterialCtrl', function ($rootScope, $scope) {
        var PendingNeedRefresh = false;
        var ProcessedNeedRefresh = false;
        $scope.$on('MAConfirmed', function () {
            ProcessedNeedRefresh = true;
        });
        $scope.$on('MACancel', function () {
            PendingNeedRefresh = true;
        });
        $scope.select = function (opt) {
            if (opt == 'pending') {
                if (PendingNeedRefresh) {
                    $rootScope.$broadcast('MAPendingRefresh');
                    PendingNeedRefresh = false;
                }
            } else if (opt == 'processed') {
                if (ProcessedNeedRefresh) {
                    $rootScope.$broadcast('MAProcessedRefresh');
                    ProcessedNeedRefresh = false;
                }
            }
        };

        $scope.type = {id: 4, name: '供应室物资'};
    });
angular.module('c.c')
    .controller('appCfgCtrl', function ($scope, toaster, Setting, $filter, uibDateParser, F, dialogs, $ocLazyLoad, $state) {
        $scope.dataSettings = ['reg_deadline_am', 'reg_deadline_pm', 'reg_deadline_night', 'reg_begin_am', 'reg_begin_pm',
            'reg_begin_nt'];
        $scope.m = {date: new Date()}
        $scope.reload = function () {
            Setting.query(function (resp) {
                var setting = {};
                angular.forEach(resp, function (s) {
                    setting[s.name] = s.value;
                    if (s.name == 'duty_count_disable') {
                        setting[s.name] = s.value == '1';
                    }
                    if (F.findItem(s.name, $scope.dataSettings) >= 0) {
                        setting[s.name] = uibDateParser.parse(s.value, "HH:mm");
                    }
                    console.log(s);

                    if (s.name == Setting.KEY.DEAN || s.name == Setting.KEY.SECRETARY || s.name == Setting.KEY.CHIEF_ACCOUNTANT || s.name == Setting.KEY.VVIP_NURSE|| s.name == Setting.KEY.VIP_NURSE) {
                        setting[s.name] = JSON.parse(s.value);
                    }
                });
                $scope.setting = setting;
                $scope.backup = angular.copy(setting);
                $scope.params_diff = false;
            });
            $scope.tab = 1;
        };

        $scope.qrcode = function (m, type) {
            m.type = type;
            var m = angular.copy(m);
            $ocLazyLoad.load(['qrCode']).then(function () {
                dialogs.create('templates/emergency/ea_qrcode.html', 'EAqrcodeCtrl', {m: m}, {
                    size: 'sm'
                });
            });
        };

        $scope.submit = function (setting) {
            var params = {};
            var params_check = $scope.params_check;

            for (var k in params_check) {
                params[k] = setting[k];
                if (F.findItem(k, $scope.dataSettings) >= 0) {
                    params[k] = $filter('date')(setting[k], "HH:mm");
                }

                if (k == Setting.KEY.DEAN || k == Setting.KEY.SECRETARY || k == Setting.KEY.CHIEF_ACCOUNTANT || k == Setting.KEY.VVIP_NURSE|| k == Setting.KEY.VIP_NURSE) {
                    if (setting[k] == null) {
                        toaster.warning('人员设置不能为空');
                        return
                    }
                    var item = {id: setting[k].id, name: setting[k].name};
                    params[k] = JSON.stringify(item);
                }
            }

            Setting.update({key: '-'}, params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('应用配置修改成功!');
                        $scope.reload();
                        break;
                    case 1:
                        toaster.warning('应用配置修改失败,因为参数格式错误!');
                        break;
                }
            }, function () {
                toaster.error('应用配置修改失败!');
            });
        };

        $scope.largeScreen = function () {
            $state.go("clinc_screen");
        };

        $scope.reset = $scope.reload;
        $scope.reload();

        $scope.params_check = {};
        $scope.$watch('setting', function (newVal, oldVal, scope) {
            scope.params_diff = false;
            for (var k in newVal) {
                if (!angular.equals(newVal[k], scope.backup[k])) {
                    scope.params_check[k] = true;
                    scope.params_diff = true;
                } else {
                    delete scope.params_check[k];
                }
            }
            console.log(scope.params_check);
        }, true);

        $scope.syncDD = function (m) {
            if (!m.date) {
                toaster.warning('同步日期不能为空');
                return
            }
            dialogs.confirm('同步钉钉考勤', '确定要同步所选日期钉钉考勤吗?').result.then(function () {
                Setting.update({key: 'sync'}, {date: $filter('date')(m.date, 'yyyy-MM-dd')}).$promise.then(function () {
                    toaster.success('同步成功!');
                }, function () {
                    toaster.error('同步失败!');
                });
            });
        };
    });





(function () {
    'use strict';

    angular.module('c.c')
        .controller('AuthorityCtrl', AuthorityCtrl)
        .controller('RoleUsersCtrl', RoleUsersCtrl)
        .controller('PermSetDlgCtrl', PermSetDlgCtrl)
        .controller('RoleAddDlgCtrl', RoleAddDlgCtrl)
    ;

    /** @ngInject */
    function AuthorityCtrl($scope, Dlg, Table, Role, FileHelper) {
        var vm = $scope;
        vm.maxProtectId = 2;
        vm.addEdit = addEdit;
        // vm.edit = edit;
        vm.roleUsers = roleUsers;
        vm.setPerms = setPerms;
        vm.remove = remove;
        vm.download = download;
        vm.clearSelectUser = clearSelectUser;
        vm.user = null;
        var firstLoad = true;

        init();

        function init() {
            var options = {
                service: Role,
                params: {op: 'sys'/*INDEX_ALL*/},
                optColWidth: Table._4_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "角色名称", filter: {name: "text"}},
                    {field: "description", title: "备注", filter: {description: "text"}}
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.roles = [];
                angular.forEach(resp.items, function (i) {
                    vm.roles.push(i.name);
                })
            });

            $scope.$watch('user', function (newValue) {
                if (firstLoad) {
                    firstLoad = false;
                    return;
                }
                if (newValue) {
                    vm.tableParams.filter()['user_id'] = newValue.id;
                } else {
                    vm.tableParams.filter()['user_id'] = null;
                }
            });
        }

        function addEdit(m) {
            var pa = {roles: vm.roles};
            if (m) {
                pa.id = m.id;
                pa.name = m.name;
            }
            Dlg.show({
                template: 'RoleAddDlg.html',
                ctrl: 'RoleAddDlgCtrl',
                data: pa
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的角色吗？', function (resp) {
                Role.delete({id: m.id, op: 'sys'}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除角色');
        }

        function setPerms(m) {
            Dlg.show({
                template: 'PermSetDlg.html',
                ctrl: 'PermSetDlgCtrl',
                data: {
                    role: m
                }
            }).then(function (params) {
                params['op'] = 'setPerms';
                Role.update({id: m.id}, params).$promise.then(function (success) {
                    Dlg.s(m.display_name + '权限设置成功!');
                }, function (error) {
                    Dlg.e(m.display_name + '权限设置失败!');
                });
            });
        }


        function roleUsers(m) {
            Dlg.show({
                template: 'RoleUsersDlg.html',
                ctrl: 'RoleUsersCtrl',
                data: {
                    role: m
                },
                size: 'lg'
            });
        }

        function clearSelectUser() {
            vm.user = null;
        }

        function download() {
            FileHelper.dnExcel(Role.EXPORT, {}, '菜单权限导出.xls');
        }
    }

    /** @ngInject */
    function RoleUsersCtrl($scope, $uibModalInstance, Table, Dlg, User, Role, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.add = add;
        vm.remove = remove;


        init(data.role.id);

        function init(id) {
            var options = {
                service: User,
                params: {opt: 4/*INDEX_ALL*/, role_id: id},
                optColWidth: Table._1_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "roles", title: "角色"}
                ]
            };

            // Table.load(vm, options);
            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {

                });
            });
        }

        function add() {
            Dlg.show({
                template: 'directives/form/user-selector/user_selector_dlg.html',
                ctrl: 'UserSelectCtrl',
                data: {
                    title: '添加' + data.role.name + '用户', multiSelect: true, existMembers: $scope.members
                }
            }).then(function (members) {
                if (members.length > 0) {
                    var params = {};
                    params['op'] = 'attachUsers';
                    params['members'] = members;
                    //为角色添加用户
                    Role.update({id: data.role.id}, params).$promise.then(function (resp) {
                        Dlg.s('添加成功!');
                        vm.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                        else console.log('error', error);
                    });
                }
            });
        }

        function remove(user) {
            Dlg.confirm('确定要删除名为<strong>' + user.name + '</strong>的<strong>' + data.role.name + '</strong>角色吗？', function (resp) {
                var params = {};
                params['op'] = 'detachUsers';
                params['members'] = [{id: user.id}];
                Role.update({id: data.role.id}, params).$promise.then(function () {
                    Dlg.s('角色移除成功!');
                    vm.tableReload();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                });
            }, '去掉员工角色');
        }
    }

    /** @ngInject */
    function PermSetDlgCtrl($uibModalInstance, Permission, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.setCheckedAll = setCheckedAll;
        vm.onChange = onChange;
        vm.ok = ok;
        vm.loading = true;

        var setParentOfChildren = function (node) {
            angular.forEach(node.children, function (child) {
                child.parent = node;
                if (child.children != null && child.children.length > 0) {
                    setParentOfChildren(child);
                }
            });
        };

        Permission.get({id: data.role.id}).$promise.then(function (data) {
            setParentOfChildren(data[1]);
            vm.data = data[1];
        }, function (error) {
        }).finally(function () {
            vm.loading = false;
        });

        function setCheckedAll(node, checked) {
            node.is_checked = checked;
            setCheckedChildren(node);
        }

        function setCheckedChildren(node) {
            if (node.children != null && node.children.length > 0) {
                angular.forEach(node.children, function (child) {
                    child.is_checked = node.is_checked;
                    setCheckedChildren(child);
                });
            }
        }

        function setCheckedAncestors(node) {
            if (node.parent) {
                if (node.is_checked) {
                    if (!node.parent.is_checked) {
                        node.parent.is_checked = node.is_checked;
                        setCheckedAncestors(node.parent);
                    }
                } else {
                    if (node.parent.is_checked) {
                        var allUnchecked = true;
                        var children = node.parent.children;
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].is_checked) {
                                allUnchecked = false;
                                break;
                            }
                        }
                        if (allUnchecked) {
                            node.parent.is_checked = node.is_checked;
                            setCheckedAncestors(node.parent);
                        }
                    }
                }
            }
        }

        function onChange(node) {
            setCheckedChildren(node);
            setCheckedAncestors(node);
        }

        function ok(data) {
            var perms = [];

            function setPerms(node) {
                if (node.is_checked) {
                    perms.push({id: node.permission.id});
                }
                if (node.children != null && node.children.length > 0) {
                    angular.forEach(node.children, function (child) {
                        setPerms(child);
                    });
                }
            }

            setPerms(data);
            $uibModalInstance.close({permissions: perms});
        }
    }

    /** @ngInject */
    function RoleAddDlgCtrl($uibModalInstance, data, Dlg, Role, $q, FormHelper) {
        var vm = this;
        vm.roles = data.roles;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            if (id) {
                Role.get({id: id, op: 'sys'}, function (resp) {
                    vm.role = resp;
                });
            } else {
                vm.role = {};
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    name: m.name,
                    display_name: m.name,
                    description: m.description,
                    op: 'sys'
                };
                var promise;
                if (m.id) {
                    promise = Role.update({id: m.id}, pa).$promise;
                } else {
                    promise = Role.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                }).finally(function () {
                    defer.resolve();
                });
            }

            return defer.promise;
        }
    }


})();

angular.module('c.c')
    .controller('DutyGroupCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);
        $scope.weekDay = F.get('weekDay');
        var weekOrDay = F.getNgTableOpts($scope.weekDay);
        $scope.types = F.get('dutyGroupTypes');
        $scope.dutyTypes = F.get('dutyTypes');
        var typeOpts = F.getNgTableOpts($scope.types);
        var dutyTypeOpts = F.getNgTableOpts($scope.dutyTypes);

        $scope.cols = [
            {title: '值班组名称', filter: {'duty_groups.name': 'text'}, field: 'group_name', show: true}, //0
            {title: '值班组类型', filter: {duty_type: 'select'}, data: dutyTypeOpts, field: 'duty_type', width: '10%', show: true}, //1
            {title: '负责人', filter: {'users.name': 'text'}, field: 'leader_name', width: '10%', show: true}, //0
            {title: '值班计数方式', filter: {by_week: 'select'}, data: weekOrDay, field: 'by_week', width: '10%', show: true}, //6
            {title: '日/周值班人次', sortable: 'num', filter: {num: 'number_range'}, field: 'num', width: '15%', show: true}, //6
            {title: '类别', filter: {type: 'select'}, data: typeOpts, field: 'type', width: '10%', show: true}, //1
            // {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true} //6
            {
                title: '值班费是否由护士年资决定',
                filter: {is_nc_performance: 'select'},
                data: yesNoOpts,
                field: 'is_nc_performance',
                width: '10%',
                show: true
            }, //1
            {
                title: '值班费标准',
                sortable: 'duty_fee',
                filter: {fee: 'number_range'},
                field: 'fee',
                width: '15%',
                show: true
            }, //0
        ];
        $scope.optColWidth = 70;

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.fee) {
                    url['fee_start'] = $scope.numRangeFilter.fee.start;
                    url['fee_end'] = $scope.numRangeFilter.fee.end;
                }
                if ($scope.numRangeFilter.num) {
                    url['num_start'] = $scope.numRangeFilter.num.start;
                    url['num_end'] = $scope.numRangeFilter.num.end;
                }
                DutyGroup.query(url, function (resp) {
                    angular.forEach(resp.groups, function (group) {
                        group.type = F.getItem(group.type, $scope.types);
                        group.duty_type = F.getItem(group.duty_type, $scope.dutyTypes);

                    });
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('DutyGroupDlg.html', 'DutyGroupDlgCtrl', {}, {
                size: 'md'
            }).result.then(function (group) {
                DutyGroup.save(group).$promise.then(function (data) {
                    toaster.success('值班组添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('值班组添加失败!');
                });
            });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$shiftsChanged = group.shifts;
            group.$feeChanged = group.duty_fee;
            group.$dutyTypeChanged = group.duty_type;
            group.$leaderChanged = {id: group.leader_id, name: group.leader_name, username: group.leader_username};
            group.$numChanged = group.num;
            group.$typeChanged = group.type;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_nc_performanceChanged = F.getItem(group.is_nc_performance, $scope.yesNo);
            group.$by_weekChanged = F.getItem(group.by_week, $scope.weekDay);
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else if (group.$feeChanged == "" || group.$feeChanged >= 1000) {
                toaster.warning('值班费必填,且应少于1000!');
            } else if (group.$numChanged == "" || group.$numChanged >= 100) {
                toaster.warning('每日值班人数必填,且应少于100!');
            } else if ((group.$typeChanged.id == 4||group.$typeChanged.id == 5)&&group.$dutyTypeChanged== null) {
                toaster.warning('值班组类型必选！');
            }else {
                var data = {};
                data['name'] = group.$nameChanged;
                group.$shiftsChanged = group.$shiftsChanged ? group.$shiftsChanged.replace(/，/g, ',') : null;
                data['shifts'] = group.$shiftsChanged;
                // 2025.4.16,要求允许听班设置费用
                if (group.$typeChanged.id == 2) {
                    data['duty_fee'] = 0;
                    data['is_nc_performance'] = group.$is_nc_performanceChanged.id;
                    if (group.$is_nc_performanceChanged.id != 1) {
                        data['duty_fee'] = group.$feeChanged;
                    }
                } else {
                    data['duty_fee'] = group.$feeChanged;
                }
                data['leader_id'] = group.$leaderChanged.id;
                data['num'] = group.$numChanged;
                data['type'] = group.$typeChanged.id;
                if(group.$typeChanged.id == 4||group.$typeChanged.id == 5){
                    data['duty_type'] = group.$dutyTypeChanged.id;
                }else {
                    data['duty_type'] = null;
                }
                data['is_stop'] = group.$is_stopChanged.id;
                data['by_week'] = group.$by_weekChanged.id;
                data['opt'] = 1;
                DutyGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('值班组信息修改成功!');
                    group.name = group.$nameChanged;
                    group.shifts = group.$shiftsChanged;
                    group.duty_fee = group.$feeChanged;
                    group.leader_id = group.$leaderChanged.id;
                    group.leader_name = group.$leaderChanged.name;
                    group.leader_username = group.$leaderChanged.username;
                    group.num = group.$numChanged;
                    group.type_id = group.$typeChanged.id;
                    group.type = group.$typeChanged;
                    if (group.$dutyTypeChanged!=null){
                        group.duty_type_id = group.$dutyTypeChanged.id;
                        group.duty_type = group.$dutyTypeChanged;
                    }
                    // group.is_stop = group.$is_stopChanged.id;
                    group.by_week = group.$by_weekChanged.id;
                    group.is_nc_performance = group.$is_nc_performanceChanged.id;
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('值班组信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除值班组记录', '确定要删除<strong>' + group.group_name + '</strong>的值班组吗?')
                .result.then(function () {
                DutyGroup.delete({id: group.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('值班组记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该值班组的成员,因此无法删除该值班组!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('值班组记录删除失败!');
                });
            });

        };

        $scope.setStop = function (m) {
            DutyGroup.update({id: m.id}, {opt: 2, is_stop: !(m.is_stop == '1')})
                .$promise.then(function () {
                m.is_stop = !(m.is_stop == '1');
                $scope.tableReload();
            })
        };
    });

angular.module('c.c').controller('DutyGroupDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.yesNo = F.get('yesNo');
        $scope.types = F.get('dutyGroupTypes');
        $scope.dutyTypes = F.get('dutyTypes');

        $scope.group = {type: $scope.types[0], by_week: false, is_stop: false, is_nc_performance: true,duty_type:$scope.dutyTypes[0]};

        $scope.typeSelectedFn = function (group, type) {
            if (type.id == 2 || type.id == 7) {
                group.duty_fee = 0;
            }
        };

        $scope.ok = function (group) {
            if (group.leader == null) {
                toaster.warning('请选择值班组负责人!');
            } else if (group.duty_type== null&&(group.type.id==4||group.type.id==5)) {
                toaster.warning('请选择值班组类别!');
            }else if ($scope.g_form.$valid) {
                var params = {};
                params['name'] = group.name;
                params['duty_fee'] = group.duty_fee;
                params['leader_id'] = group.leader.id;
                params['num'] = group.num;
                params['type'] = group.type.id;
                params['by_week'] = group.by_week;
                params['is_stop'] = group.is_stop;
                params['is_nc_performance'] = group.type.id == 2 ? group.is_nc_performance : false;
                if (group.type.id==4||group.type.id==5){
                    params['duty_type'] = group.duty_type.id;
                }
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('HelpCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams,
                                      HelpPage, HelpContent, Table) {
        $scope.cols = [
            {title: '标题', filter: {title: 'text'}, show: true}, //0
            {title: '链接', width: '55%', show: true}
        ];

        $scope.optColWidth = 73;
        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if (!$scope.pages) {
                    HelpPage.query(function (data) {
                        angular.forEach(data, function (page) {
                            page.items = [];
                        });
                        $scope.pages = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.pages;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.tableReload = function () {
            $scope.pages = null;
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.save(page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.edit = function (page) {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {page: page}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.update({id: page.id}, page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.delete = function (page) {
            dialogs.confirm('删除页面', '确定要删除页面<strong>' + page.title + '</strong>吗?')
                .result.then(function () {
                HelpPage.delete({id: page.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        $scope.visible = function (item, query) {
            return !(query && query.length > 0
            && item.title.indexOf(query) == -1);
        };

        function convert2MenuItem(items, menu) {
            angular.forEach(items, function (item) {
                var menuItem = {page_id: item.id, subject: item.title};
                menu.children.push(menuItem);
                if (item.items && item.items.length > 0) {
                    menuItem.children = [];
                    convert2MenuItem(item.items, menuItem);
                }
            });
        }

        $scope.save = function (content) {
            var menu = {children: []};
            convert2MenuItem(content, menu);
            HelpContent.save({menu: menu}, function (content) {
                toaster.success('保存成功');
            });
        };

        function convert2Item(menus, content) {
            angular.forEach(menus, function (menu) {
                var item = {id: menu.page.id, title: menu.page.title, items: []};
                content.push(item);
                if (menu.children && menu.children.length > 0) {
                    convert2Item(menu.children, item.items);
                }
            });
        }

        $scope.contentReload = function () {
            HelpContent.get({id: 1}).$promise.then(function (resp) {
                var content = [];
                if (resp.root && resp.root['1']) {
                    var children = resp.root['1'].children;
                    convert2Item(children, content);
                }
                $scope.content = content;
            });
        };

        $scope.contentReload();
    });


angular.module('c.c').controller('PageDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $http, toaster, data) {
        if (data.page) {
            $scope.page = data.page;
            var url = $sce.getTrustedResourceUrl(data.page.url);
            $http.get(url + "?" + new Date().toString()).success(function (resp) {
                $scope.page.body = resp;
            });
            $scope.$edit = true;
        } else {
            $scope.page = {title: ''};
        }

        $scope.ok = function (page) {
            if (page.title == '') {
                toaster.warning('标题不能为空');
            } else if (page.body == '') {
                toaster.warning('内容不能为空');
            } else {
                $uibModalInstance.close(page);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c')
    .controller('LeaveManageCtrl',
    function ($scope, $filter, dialogs, toaster, FileHelper, NgTableParams, AskForLeave, SaveAs, C, F) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var yesNo = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');

        $scope.cols = [
            {title: '编号', field: 'id', width: '50', show: true}, //0
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', width: '100', show: true}, //0
            {title: '科室', filter: {'depts.name': 'text'}, field: 'dept_id', width: '100', show: true}, //0
            {
                title: '类别',
                sortable: 'leave_type_id',
                filter: {leave_type_id: 'select'},
                field: 'leave_type_id',
                width: '8%',
                show: true
            }, //6
            {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
            {title: '天数', field: 'day_num', show: true}, //6
            {
                title: '附件',
                field: 'has_paper',
                show: true
            }, //6
            {
                title: '附件类型',
                sortable: 'type_id',
                filter: {'type_id': 'select'},
                field: 'type_id',
                width: '100',
                show: true
            }, //6
            {
                title: '是否补助',
                sortable: 'is_subsidy',
                filter: {is_subsidy: 'select'},
                field: 'is_subsidy',
                width: '100',
                data: yesNoOpts,
                show: true
            }, //6
            {
                title: '是否离开大成都范围',
                sortable: 'is_leave_cd',
                filter: {is_leave_cd: 'select'},
                field: 'is_leave_cd',
                width: '105',
                data: yesNoOpts,
                show: true
            },
            {title: '开始时间', filter: {start: 'date_range'}, field: 'start', width: '10%', show: true},
            {title: '结束时间', filter: {end: 'date_range'}, field: 'end', width: '10%', show: true}
        ];

        $scope.optInFront = true;

        $scope.leave_type_col = $scope.cols[3];
        $scope.attach_type_col = $scope.cols[7];

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.optColWidth = 45;

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                var startDate, endDate;
                if ($scope.dateRangeFilter.start != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        start: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.end != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        end: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                AskForLeave.query(url, function (data) {
                    $scope.leave_types = data.leave_types;
                    $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                    $scope.attach_types = data.attach_types;
                    $scope.attach_type_col.data = F.getNgTableOpts($scope.attach_types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除请假记录', '确定要删除编号为<strong>' + record.id + '</strong>的记录吗?')
                .result.then(function () {
                    AskForLeave.delete({id: record.id}).$promise.then(function (resp) {
                        toaster.success('请假记录删除成功!');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('请假记录删除失败!');
                    });
                });

        };
    });

angular.module('c.c')
    .controller('LeaveTypeCtrl', function ($rootScope, $scope, $filter, dialogs, toaster, NgTableParams,
                                           Table, LeaveType, ArrayHelper) {
        $scope.yesNo = ArrayHelper.get('yesNo');
        var yesNoOpts = Table.getNgTableOpts($scope.yesNo);
        $scope.leaveResults = ArrayHelper.get('ask4leave_result_list');
        var leaveResults = Table.getNgTableOpts($scope.leaveResults);
        $scope.leaveTypes = ArrayHelper.get('ask4leave_type_list');
        var leaveTypes = Table.getNgTableOpts($scope.leaveTypes);

        $scope.cols = [
            {title: '名称', filter: {name: 'text'}, field: 'name', width: "100", show: true},
            {
                title: '工资奖金关系',
                filter: {result_id: 'select'},
                field: 'result_id',
                data: leaveResults,
                show: true
            },
            {
                title: '绩效关系',
                filter: {type: 'select'},
                field: 'type',
                data: leaveTypes,
                show: true
            },
            {
                title: '工资发放比例',
                field: 'sp',
                show: true
            },
            {
                title: '工资科室分担比例',
                field: 'sdp',
                show: true
            },
            {
                title: '奖金发放比例',
                field: 'bp',
                show: true
            },
            {
                title: '奖金科室分担比例',
                field: 'bdp',
                show: true
            },
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', show: true}
        ];

        $scope.optColWidth = 56;

        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            filter: {}
        }, {
            counts: [5, 10],
            total: 0,
            getData: function ($defer, params) {
                if (!$scope.cachedData) {
                    LeaveType.query(function (data) {
                        angular.forEach(data, function (d) {
                            d.sp = (d.sp * 100).toFixed(1);
                            d.sdp = (d.sdp * 100).toFixed(1);
                            d.bp = (d.bp * 100).toFixed(1);
                            d.bdp = (d.bdp * 100).toFixed(1);
                        });
                        $scope.cachedData = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.cachedData;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };


        $scope.add = function () {
            dialogs.create('LeaveTypeDlg.html', 'LeaveTypeDlgCtrl',
                {yesNo: $scope.yesNo, leaveResults: $scope.leaveResults, leaveTypes: $scope.leaveTypes}, {size: 'md'})
                .result.then(function (type) {
                LeaveType.save(type).$promise.then(function (resp) {
                    toaster.success('请假类型添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('请假类型添加失败!');
                })
            });
        };

        $scope.edit = function (type) {
            type.$edit = true;
            type.$nameChanged = type.name;
            type.$spChanged = type.sp;
            type.$sdpChanged = type.sdp;
            type.$bpChanged = type.bp;
            type.$bdpChanged = type.bdp;
            type.$is_stopChanged = ArrayHelper.getItem(type.is_stop, $scope.yesNo);
            type.$resultChanged = $scope.leaveResults[type.result_id - 1];
            type.$typeChanged = $scope.leaveTypes[type.type - 1];
        };

        $scope.save = function (type) {
            type.$edit = false;
            if (type.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else if (type.$spChanged == "") {
                toaster.warning('工资发放比例不能为空!');
            } else if (type.$sdpChanged == "") {
                toaster.warning('工资科室分担比例不能为空!');
            } else if (type.$bpChanged == "") {
                toaster.warning('奖金发放比例不能为空!');
            } else if (type.$bdpChanged == "") {
                toaster.warning('工资科室分担比例不能为空!');
            } else if (type.$spChanged > 100 || type.$sdpChanged > 100 || type.$bpChanged > 100 || type.$bdpChanged > 100) {
                toaster.warning('发放比例不能大于100,请仔细检查!');
            } else {
                var data = {};
                data['name'] = type.$nameChanged;
                data['sp'] = type.$spChanged / 100.0;
                data['sdp'] = type.$sdpChanged / 100.0;
                data['bp'] = type.$bpChanged / 100.0;
                data['bdp'] = type.$bdpChanged / 100.0;
                data['is_stop'] = type.$is_stopChanged.id;
                data['result_id'] = type.$resultChanged.id;
                data['type'] = type.$typeChanged.id;
                LeaveType.update({id: type.id}, data).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('请假类型修改成功!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('请假类型修改失败!');
                });

            }
        };

        $scope.delete = function (type) {

            dialogs.confirm('删除请假类型', '确定要删除<strong>' + type.name + '</strong>的请假类型吗?')
                .result.then(function () {
                LeaveType.delete({id: type.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('请假类型删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该请假类型的假条,因此无法删除该请假类型!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('请假类型删除失败!');
                });
            });
        };

    });


angular.module('c.c').controller('LeaveTypeDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {

        $scope.yesNo = data.yesNo;
        $scope.leaveResults = data.leaveResults;
        $scope.leaveTypes = data.leaveTypes;
        $scope.type = {
            is_stop: 0,
            result: data.leaveResults[0],
            type: data.leaveTypes[0],
            sp: 100,
            sdp: 100,
            bp: 100,
            bdp: 100
        };

        $scope.ok = function (type) {
            if ($scope.l_type_form.$valid) {
                if (type.sp > 100 || type.sdp > 100 || type.bp > 100 || type.bdp > 100) {
                    toaster.warning('表单中发放比例不能大于100,请仔细检查!');
                    $scope.l_type_form.submitted = true;
                } else {
                    var params = {};
                    params['name'] = type.name;
                    params['sp'] = type.sp / 100.0;
                    params['sdp'] = type.sdp / 100.0;
                    params['bp'] = type.bp / 100.0;
                    params['bdp'] = type.bdp / 100.0;
                    params['is_stop'] = type.is_stop;
                    params['result_id'] = type.result.id;
                    params['type'] = type.type.id;
                    $uibModalInstance.close(params);
                }
            } else {
                toaster.warning('表单中有错误!');
                $scope.l_type_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('MajorCtrl', MajorCtrl)

    ;


    function MajorCtrl($scope, $q, Api, dialogs, Major) {
        var vm = $scope;
        vm.add = add;
        vm.ok = ok;
        vm.save = save;
        vm.rmItem = rmItem;
        vm.reload = reload;
        //vm.remove = remove;

        init();


        function init() {
            vm.types = [];
            vm.op = {};
            reload();
        }

        function add(parent) {
            var nItem = {name: '新专业', children: []};
            nItem.nameChange = nItem.name;
            vm.op.eItem = nItem;
            if (angular.isDefined(parent)) {
                parent.children.push(nItem);
            } else {
                vm.types.push(nItem);
            }
        }

        function ok(item) {
            if (item.nameChange) {
                item.name = item.nameChange;
                vm.op.eItem = null;
            }
        }

        function convert(types) {
            angular.forEach(types, function (type) {
                delete type.nameChange;
                if (type.children && type.children.length > 0) {
                    convert(type.children);
                }
            });
        }

        function save(types) {
            var defer = $q.defer();
            vm.op.eItem = null;
            convert(types);
            Major.save(types, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;

                Api.s(resp.msg);

                defer.resolve();
            });
            return defer.promise;
        }

        function rmItem(item, rmFn, self) {
            if (item.id) {
                dialogs.confirm('删除专业类型', '确定要删除<strong>' + item.name + '</strong>类型吗？')
                    .result.then(function () {
                    Major.delete({id: item.id}, function (resp) {
                        if (resp.result != 0) {
                            Api.w(resp.msg);
                        } else {
                            rmFn(self);
                        }
                    });
                });
            }
            else {
                rmFn(self);
            }
        }

        function reload() {
            var defer = $q.defer();
            Major.query({opt: 1}, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;
                defer.resolve();
            });
            return defer.promise;
        }


    }


})();


angular.module('c.c')
    .controller('MaterialManageCtrl', function () {
    });


angular.module('c.c')
    .controller('MealCtrl', function () {

    });
angular.module('c.c')
    .controller('MeetingCtrl', function () {
    });

angular.module('c.c')
    .controller('SeniorityStandardCtrl', function ($rootScope, $scope, $filter, dialogs, Table,
                                                   toaster, NgTableParams, SeniorityStandard, F) {
        $scope.types = F.get('seniorityTypes');
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);
        $scope.cols = [
            {title: '名称', show: true},
            {title: '类型', show: true, width: '60'},
            {title: '描述', show: true},
            {title: '值班费', sortable: 'duty_fee', show: true, width: '80'},
            {title: '是否停用', sortable: 'is_stop', show: true, width: '100'}
        ];

        $scope.$watch('type', function (type, old, scope) {
            var params = scope.tableParams;
            var filter = params.filter();
            if (type) {
                filter['type'] = F.getItem(type, $scope.types);
            } else {
                delete filter['type'];
            }
            params.filter(filter);
        });

        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            filter: {}
        }, {
            counts: [10, 30],
            total: 0,
            getData: function ($defer, params) {
                if (!$scope.cachedData) {
                    SeniorityStandard.query(function (data) {
                        angular.forEach(data, function (item) {
                            if (item.description == null) {
                                item.description = "";
                            }
                            item.type = F.getItem(item.type, $scope.types);
                        });
                        $scope.cachedData = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.cachedData;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('SeniorityStandardDlg.html', 'SeniorityStandardDlgCtrl',
                {}, {size: 'md'})
                .result.then(function (std) {
                SeniorityStandard.save(std).$promise.then(function (resp) {
                    toaster.success('年资标准添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('年资标准添加失败!');
                })
            });
        };

        $scope.edit = function (std) {
            std.$edit = true;
            std.$nameChanged = std.name;
            std.$typeChanged = F.getItem(std.type.id, $scope.types);
            std.$descriptionChanged = std.description;
            std.$dutyFeeChanged = std.duty_fee;
            std.$is_stopChanged = F.getItem(std.is_stop, $scope.yesNo);
        };

        $scope.save = function (std) {
            std.$edit = false;
            if (std.$nameChanged == "") {
                toaster.error('名称不能为空!');
            } else if (std.$dutyFeeChanged >= 1000) {
                toaster.error('值班费应该小于1000元!');
            } else {
                var data = {};
                data['name'] = std.$nameChanged;
                data['type'] = std.$typeChanged.id;
                data['description'] = std.$descriptionChanged;
                data['duty_fee'] = std.$dutyFeeChanged;
                data['is_stop'] = std.$is_stopChanged.id;
                SeniorityStandard.update({id: std.id}, data).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('年资标准修改成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该年资标准的护士,因此无法停用该标准!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('年资标准修改失败!');
                });

            }
        };

        $scope.delete = function (std) {

            dialogs.confirm('删除年资标准', '确定要删除<strong>' + std.name + '</strong>的护士年资标准吗?')
                .result.then(function () {
                SeniorityStandard.delete({id: std.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('年资标准删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该年资标准的护士,因此无法删除该年资标准!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('年资标准删除失败!');
                });
            });
        };

    });


angular.module('c.c').controller('SeniorityStandardDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {

        $scope.yesNo = F.get('yesNo');
        $scope.types = F.get('seniorityTypes');
        $scope.std = {is_stop: false, type: $scope.types[1]};

        $scope.ok = function (std) {
            if ($scope.s_form.$valid) {
                var params = {};
                params['name'] = std.name;
                params['type'] = std.type.id;
                params['description'] = std.description;
                if (std.type.id == '2') {
                    params['duty_fee'] = std.duty_fee;
                }
                params['is_stop'] = std.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c')
    .controller('SignCtrl', function ($scope, $filter, dialogs, toaster, $sce, $templateRequest,
                                      $timeout, User, F, Table) {
        var vm = $scope;

        init();
        function init() {
            var options = {
                service: User,
                params: {opt: 11/*INDEX_USER_SIGN*/},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "type", title: "类别", filter: {type: "text"}},
                    {field: "dept", title: "主科室", filter: {dept: "text"}},
                    {field: "sign", title: "签名", filter: {no_sign: "checkbox"}, data: "未传签名"},
                    {field: "seal", title: "印鉴", filter: {no_seal: "checkbox"}, data: "未传印鉴"}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.signature) {
                        item.sign = item.signature.sign;
                    }
                    if (item.seal) {
                        item.seal = item.seal.seal;
                    }
                });
            });
        }

        $scope.edit = function (user) {
            dialogs.create('pages/user/userSignDlg.html', 'SignDlgCtrl', {user: user}, {
                size: 'md'
            }).result.then(function (params) {
                params['opt'] = 5;
                User.update({id: user.id}, params).$promise.then(function () {
                    toaster.success('签名设置成功!');
                    user.sign = params['sign'];
                }, function () {
                    toaster.error('签名设置失败!');
                });
            });
        };

        $scope.seal = function (user) {
            dialogs.create('pages/user/userSealDlg.html', 'SealDlgCtrl', {user: user}, {
                size: 'md'
            }).result.then(function (params) {
                params['opt'] = 7/*OPT_SEAL*/;
                User.update({id: user.id}, params).$promise.then(function () {
                    toaster.success('印鉴设置成功!');
                    user.seal = params['seal'];
                }, function () {
                    toaster.error('印鉴设置失败!');
                });
            });
        };

        //$scope.delete = function (user) {
        //    dialogs.confirm('删除数字签名', '确定要删除<strong>' + user.name + '</strong>的数字签名吗?')
        //        .result.then(function () {
        //            User.delete({id: dept.id}).$promise.then(function (resp) {
        //                toaster.success('签名删除成功!');
        //            });
        //            user.sign = null;
        //        }, function (error) {
        //            toaster.error('科室记录删除失败!');
        //        });
        //};

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/table2.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });

        $scope.print = function () {

            var w = window.open("", "打印预览");

            var html = '<html><body><table><tbody>';
            html += '<tr><td>工号</td>';
            html += '<td>姓名</td>';
            html += '<td>签名</td>';
            html += '</tr>';
            angular.forEach($scope.users, function (user) {
                html += '<tr>';
                html += '<td>' + user.username + '</td>';
                html += '<td>' + user.name + '</td>';
                html += '<td><img height="50" width="160" src="' + user.sign + '"/></td>';
                html += '</tr>';
            });
            html += '</tbody></table></body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };

    });
angular.module('c.c')
    .controller('WageCtrl', function () {
    });

angular.module('c.c')
    .controller('WageSpecialCtrl', function ($scope, dialogs, toaster, WageSpecial, Table) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        init();

        function init() {
            var options = {
                service: WageSpecial,
                params: {},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "dept", title: "科室"},
                    {field: "out_tax", title: "不扣税"},
                    {field: "out_percent", title: "100%发放"}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('WageSpecialDlg.html', 'WageSpecialDlgCtrl', {}, {size: 'md'})
                .result.then(function (pa) {
                WageSpecial.save(pa).$promise.then(function (resp) {
                    toaster.success('添加成功');
                    vm.tableReload();
                });
            });
        }

        function edit(record) {
            dialogs.create('WageSpecialDlg.html', 'WageSpecialDlgCtrl', {
                record: record
            }, {size: 'md'})
                .result.then(function (pa) {
                WageSpecial.update({id: record.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }


        function remove(m) {
            dialogs.confirm('删除用户', '确定要删除<strong>' + m.user.name + '</strong>特殊工资用户吗?')
                .result.then(function () {
                WageSpecial.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    });

angular.module('c.c').controller('WageSpecialDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, WageSpecial, data) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.record);

        function loadModel(record) {
            if (record) {
                vm.special = {
                    'user': record.user,
                    'out_tax': record.out_tax == '1',
                    'out_percent': record.out_percent == '1'
                }
            } else {
                vm.special = {'out_tax': '1', out_percent: '1'}
            }
        }

        function ok(special) {
            if (vm.Form.$valid) {
                var pa = {
                    user_id: special.user.id,
                    out_tax: special.out_tax == true ? '1' : '0',
                    out_percent: special.out_percent == true ? '1' : '0'
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误,请仔细核查!');
                vm.Form.submitted = true;
            }
        }
    });

angular.module('c.c')
    .controller('TMAttendanceCtrl', function ($scope, $filter, dialogs, toaster, FileHelper,
                                                   NgTableParams, AttendanceReport, F, C, SaveAs) {

        var yesOrNo = [{id: '', title: '-'}, {id: '3', title: '是'}, {id: '2', title: '否'}];

        $scope.cols = [
            {title: '月份', sortable: 'month', field: 'month', show: true},
            {
                title: '科室',
                sortable: 'depts.name',
                filter: {'depts.name': 'text'},
                field: 'dept_name',
                show: true
            },
            {title: '考勤总人数', field: 'count_num', show: true},
            {title: '全勤人数', field: 'count_num', show: true},
            {title: '缺勤人数', 'field': 'absence_num', show: true},
            {title: '新入科员工', field: 'new_comer', show: true},
            {title: '请假人数', show: true},
            {title: '人均系数', field: 'stage', show: true},
            {title: '是否确认', filter: {stage: 'select'}, field: 'stage', data: yesOrNo, show: true},
            {title: '月份', field: 'month', filter: {month: 'text'}, show: false}//6
        ];
        $scope.optColWidth = 70;
        $scope.dept_col = $scope.cols[1];

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.first = true;       //第一次监控时间的变化，则不重新查询
        var date = new Date((new Date()).setDate(1));
        var month = date.getMonth();
        $scope.dts = new Date(date.setMonth(month - 1));
        $scope.dte = new Date(date.getFullYear(), month, 0);
        $scope.temp_month = new Date((new Date((new Date()).setDate(1))).setMonth(month - 1));
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dts = new Date(curr.setMonth(prev));
            $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
            $scope.temp_month = new Date(curr.setMonth(prev));
            $scope.first = false;
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dts = new Date(curr.setMonth(next));
            $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
            $scope.temp_month = new Date(curr.setMonth(next));
            $scope.first = false;
        };

        $scope.can_opt = false;   //与人事科拥有共同的界面，是否有退回功能

        $scope.$watch('dts', function (newVal, oldVal, scope) {
            if (!$scope.first) {
                $scope.tableReload();
            }
        }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                var filter = params.filter();
                if ($scope.numRangeFilter.bonus_count) {
                    url['bonus_count_start'] = $scope.numRangeFilter.bonus_count.start;
                    url['bonus_count_end'] = $scope.numRangeFilter.bonus_count.end;
                }

                filter['month'] = $filter('date')($scope.temp_month, 'yyyy-MM-dd');
                url['filter'] = filter;
                url['opt'] = 2;   //财务科与人事科有相同的界面，只是财务科不能操作
                $scope.month = {
                    startDate: $filter('date')($scope.temp_month, 'yyyy-MM-dd'),
                    endDate: $filter('date')($scope.dte, 'yyyy-MM-dd')
                };
                AttendanceReport.query(url, function (resp) {
                    $scope.dept_col.data = F.getNgTableOpts(resp.depts);
                    params.total(resp.total);
                    $scope.no_declare = resp.no_declare;
                    $scope.reports = resp.records;
                    $defer.resolve(resp.records);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
            $scope.first = false;
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.tableParams.filter({});
        };


        $scope.member = function (report) {
            dialogs.create('AttendanceReportMembers.html', 'AttendanceReportMembersCtrl',
                {report: report, month: $filter('date')($scope.month, 'yyyy-MM-dd')}, {
                    size: 'lg'
                }).result.then(function () {
                $scope.tableReload();
            });
        };

        $scope.export = function () {
            var params = {};
            params['month'] = $filter('date')($scope.dts, 'yyyy-MM-dd');
            FileHelper.download(C.URL.ATTENDANCE_EXPORT, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = $filter('date')($scope.dts, 'yyyy年MM月') + '考勤绩效统计情况.xls';
                SaveAs.download(data, filename, options);
            }, function () {
                toaster.error('导出失败!');
            });
        };


    });
angular.module('c.c')
    .controller('TMDutyFeeApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, DutyReport, F) {

        var yesOrNo = F.getNgTableOpts(F.get('yesNo'));

        $scope.group_types = F.get('dutyGroupTypes');
        var group_types = F.getNgTableOpts($scope.group_types);

        $scope.cols = [
            {title: '值班月份', sortable: 'duty_reports.month', field: 'month', show: true},
            {
                title: '值班组',
                sortable: 'duty_reports.group_id',
                filter: {'duty_groups.name': 'text'},
                field: 'group_name',
                show: true
            },
            {
                title: '类型',
                filter: {type: 'select'},
                field: 'type',
                data: group_types,
                show: true
            },
            {
                title: '负责人',
                filter: {'users.name': 'text'},
                field: 'leader',
                show: true
            },
            {
                title: '额定总值班人次',
                sortable: 'rated_count',
                filter: {rated_count: 'number_range'},
                field: 'rated_count',
                width: '8%',
                show: true
            }, //6
            {
                title: '实际总值班人次',
                sortable: 'total_count',
                filter: {total_count: 'number_range'},
                field: 'total_count',
                width: '8%',
                show: true
            }, //6
            {
                title: '总值班费用',
                sortable: 'total_fee',
                filter: {total_fee: 'number_range'},
                field: 'total_fee',
                width: '8%',
                show: true
            }, //6
            {title: '是否确认', filter: {is_payed: 'select'}, field: 'is_payed', width: '8%', data: yesOrNo, show: true}, //6
            {title: '发放时间', filter: {pay_time: 'date_range'}, field: 'pay_time', show: true}
        ];
        $scope.optColWidth = 70;
        $scope.groups_col = $scope.cols[1];

        var month = new Date();
        month.setMonth(month.getMonth() - 1);
        $scope.para = {month: month};
        var year = month.getYear();
        $scope.dateRangeFilter = {
            month: {
                startDate: new Date(year + 1900, month.getMonth(), 1),
                endDate: new Date(year + 1900, month.getMonth() + 1, 0)
            }
        };


        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.getReports = function (para) {
            if (para.month) {
                var year = para.month.getYear();
                $scope.dateRangeFilter = {
                    month: {
                        startDate: new Date(year + 1900, para.month.getMonth(), 1),
                        endDate: new Date(year + 1900, para.month.getMonth() + 1, 0)
                    }
                };
            }
        };

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.rated_count) {
                    url['rated_count_start'] = $scope.numRangeFilter.rated_count.start;
                    url['rated_count_end'] = $scope.numRangeFilter.rated_count.end;
                }
                if ($scope.numRangeFilter.total_count) {
                    url['total_count_start'] = $scope.numRangeFilter.total_count.start;
                    url['total_count_end'] = $scope.numRangeFilter.total_count.end;
                }
                url['date_range_filters'] = $scope.dateRangeFilter;
                url['opt'] = 7;
                DutyReport.query(url, function (resp) {
                    $scope.duty_groups = resp.duty_groups;
                    $scope.groups_col.data = F.getNgTableOpts(resp.duty_groups);
                    params.total(resp.total);
                    $scope.reports = resp.records;
                    $scope.groups = resp.groups;
                    $defer.resolve(resp.records);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
            $scope.dateRangeFilter = {};
        };

        $scope.confirm = function (report) {
            var para = {};
            para['is_payed'] = 1;
            DutyReport.update({id: report.id}, para).$promise.then(function (resp) {
                toaster.success('值班费发放成功!');
                $scope.tableReload();
            }, function (error) {
                toaster.error('值班费发放失败!');
            });
        };
        $scope.checked = [];
        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (report, reports) {
            if (report.is_checked) {
                $scope.checked.push(report.id);
            } else if (!report.is_checked) {
                $scope.checked = [];
                angular.forEach(reports, function (r) {
                    if (r.is_checked) {
                        $scope.checked.push(r.id);
                    }
                });
            }
        };

        $scope.confirmAll = function () {
            dialogs.confirm('值班费发放', '确定要发放值班费吗?')
                .result.then(function () {
                if ($scope.checked.length == 0) {
                    toaster.warning('未选择,请选择要发放的值班组')
                } else {
                    var para = {};
                    para['is_payed'] = 1;
                    para['ids'] = $scope.checked;
                    DutyReport.update({id: $scope.reports[0].id}, para).$promise.then(function (resp) {
                        toaster.success('值班费发放成功!,请在值班费明细中打印报表');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('值班费发放失败!');
                    });
                }
            });
        };

        $scope.back = function (report) {
            dialogs.confirm('值班费退回', '确定要退回值班费吗?')
                .result.then(function () {
                var para = {};
                para['is_declared'] = false;
                para['is_confirmed'] = false;
                para['is_payed'] = false;
                para['back'] = 1;
                DutyReport.update({id: report.id}, para).$promise.then(function (resp) {
                    if (resp.msg) {
                        toaster.error(resp.msg);
                    } else {
                        toaster.success('值班费退回成功');
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('值班费退回失败!');
                });
            });
        };

    });

angular.module('c.c')
    .controller('TMDutyPaidDetailCtrl', function ($scope, $filter, dialogs, toaster, ArrayHelper,
                                                  FileHelper, SaveAs, NgTableParams, F, C, PaidDetail) {

        $scope.cols = [
            {title: '姓名', filter: {name: 'text'}, field: 'name', show: true},
            {title: '工牌号', filter: {username: 'text'}, field: 'username', show: true},
            {title: '值班组', filter: {group_name: 'text'}, field: 'group_name', show: true},
            {title: '主科室', filter: {dept: 'text'}, field: 'dept', show: true},
            {title: '工资卡号', filter: {salary_card: 'text'}, field: 'salary_card', show: true},
            {title: '值班月份', field: 'month', show: true},
            {
                title: '值班次数',
                sortable: 'count',
                filter: {count: 'number_range'},
                field: 'count',
                show: true
            }, //6
            {
                title: '值班费标准',
                sortable: 'fee_standard',
                filter: {fee_standard: 'number_range'},
                field: 'fee_standard',
                show: true
            }, //6
            {
                title: '值班费',
                sortable: 'duty_fee',
                filter: {duty_fee: 'number_range'},
                field: 'duty_fee',
                show: true
            },
            {title: '发放时间', field: 'created_at', show: true}
        ];

        $scope.hideOpt = true;
        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.dateRangeFilter = {};

        var month = new Date();
        month.setMonth(month.getMonth() - 1);
        $scope.para = {month: month, groups: [{'id': 0, 'name': '全部', 'full_name': '全部'}]};
        var year = month.getYear();
        $scope.dateRangeFilter = {
            month: {
                startDate: new Date(year + 1900, month.getMonth(), 1),
                endDate: new Date(year + 1900, month.getMonth() + 1, 0)
            }
        };

        $scope.filter_groups = '全部';
        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.count) {
                    url['count_start'] = $scope.numRangeFilter.count.start;
                    url['count_end'] = $scope.numRangeFilter.count.end;
                }
                if ($scope.numRangeFilter.fee_standard) {
                    url['fee_standard_start'] = $scope.numRangeFilter.fee_standard.start;
                    url['fee_standard_end'] = $scope.numRangeFilter.fee_standard.end;
                }
                if ($scope.numRangeFilter.fee_standard) {
                    url['duty_fee_start'] = $scope.numRangeFilter.duty_fee.start;
                    url['duty_fee_end'] = $scope.numRangeFilter.duty_fee.end;
                }

                if ($scope.dateRangeFilter.month != null) {
                    var startDate = $filter('date')($scope.dateRangeFilter.month.startDate, 'yyyy-MM-dd');
                    var endDate = $filter('date')($scope.dateRangeFilter.month.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        month: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }

                if ($scope.filter_groups.length > 0) {
                    url['groups'] = $scope.filter_groups;
                }

                $scope.url = url;
                PaidDetail.query(url, function (resp) {
                    var getGroups = [];
                    angular.forEach(resp.groups, function (g) {
                        var addValue = g.shifts ? ("[" + g.shifts + "]") : "";
                        getGroups.push({'id': g.id, 'name': g.name, 'full_name': g.name + addValue});
                    });
                    $scope.groups = getGroups;
                    $scope.groups.unshift({'id': 0, 'name': '全部', 'full_name': '全部'});
                    params.total(resp.total);
                    angular.forEach(resp.records, function (r) {
                        r.group_shifts = ArrayHelper.getItem(r.group_name, resp.groups, 'name').shifts;
                    });
                    $scope.records = resp.records;
                    $defer.resolve(resp.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
            $scope.dateRangeFilter = {};
        };

        $scope.getReports = function (para) {
            if (para.month) {
                var year = para.month.getYear();
                $scope.dateRangeFilter = {
                    month: {
                        startDate: new Date(year + 1900, para.month.getMonth(), 1),
                        endDate: new Date(year + 1900, para.month.getMonth() + 1, 0)
                    }
                };
                var groups = para.groups;
                var temp = '';
                if (groups.length > 0) {
                    for (var i in groups) {
                        if (i == groups.length) {
                            temp = temp + groups[i].name;
                        } else {
                            temp = temp + groups[i].name + ",";
                        }
                    }
                    $scope.filter_groups = temp;
                } else {
                    $scope.filter_groups = ['全部'];
                    $scope.para = {month: para.month, groups: [{'id': 0, 'name': '全部', 'full_name': '全部'}]};
                }
                $scope.tableReload();
            }
        };


        $scope.exportReportToExcel = function () {

            var params = {};
            params['groups'] = $scope.filter_groups;
            params['month'] = $scope.records[0].month;
            FileHelper.download(C.URL.DUTY_PAID_EXPORT, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = $scope.records[0].month + $scope.filter_groups + '值班费发放明细.xls';
                SaveAs.download(data, filename, options);
            }, function () {
                toaster.error('导出失败!');
            });

        };


    });

(function () {
        'use strict';

        angular.module('c.c')
            .controller('TMKpiCtrl', TMKpiCtrl);

        /** @ngInject */
        function TMKpiCtrl($scope, ArrayHelper, Table, User, Dlg) {
            var vm = $scope;
            var sexes = ArrayHelper.get('sexes');
            vm.kpi = kpi;

            init();

            function init() {
                var options = {
                    service: User,
                    params: {opt: 101/*INDEX_SEARCH_USERS*/, with_info: 1},
                    sorting: {id: 'asc'},
                    optInFront: true,
                    showSn: true,
                    optColWidth: Table._1_BTN,
                    cols: [
                        {title: '姓名', sortable: 'name', filter: {name: 'text'}, field: 'name'}, //0
                        { //1
                            title: '主科室',
                            filter: {main_dept: 'text'},
                            field: 'main_dept'
                        },
                        { //2
                            title: '性别',
                            filter: {sex: 'select'},
                            data: Table.getNgTableOpts(sexes),
                            field: 'sex'
                        },
                        { //3
                            title: '出生日期',
                            sortable: 'birthday',
                            filter: {birthday: 'date_range'},
                            field: 'birthday'
                        },
                        { //4
                            title: '民族',
                            sortable: 'nation_id',
                            field: 'nation',
                            filter: {nation: 'text'}
                        },
                        { //5
                            title: '籍贯',
                            sortable: 'native_place',
                            field: 'native_place',
                            filter: {native_place: 'text'}
                        }
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (i) {
                        i.sex = ArrayHelper.getItem(i.sex, sexes);
                    });
                });
            }


            function kpi(user) {
                Dlg.show({
                    template: '/templates/kpi/kpiDlg.html',
                    ctrl: 'KpiRecordCtrl',
                    data: {user: user}
                });
            }
        }


    }
)();

'use strict';

angular.module('c.c')
    .controller('TMWageCtrl', function () {
    });


'use strict';

angular.module('c.c')
    .controller('BulletinCtrl', function ($scope, $stateParams, $rootScope, $timeout) {
        if ($stateParams.data.tab) {
            $scope.tabs = [];
            var data = $stateParams.data;
            $scope.tabs[data.tab] = true;
            $timeout(function () {
                $rootScope.$broadcast(data.event, data.content);
            }, 200);
        }
    });


angular.module('c.c')
    .controller('CarApplyCtrl', function CarApplyCtrl($scope) {
        
    }
);


angular.module('c.c')
    .controller('ContactGroupCtrl', function ($scope, DeliveryPlaceAdmin, UIHelper, $stateParams) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams);
    });

(function () {
    'use strict';

    angular.module('c')
        .controller('ContactsCtrl', ContactsCtrl);

    /** @ngInject */
    function ContactsCtrl($scope, $q, ContactGroup, ArrayHelper, Api, Dept, DeptPhone, DeptWard, DeptWardPhone, SaveAs, Dlg,
                          WxHelper, deviceDetector, OS, User, SeniorityStandard, CommonPhone, FileHelper, JobTitle, $http) {
        var isWx = WxHelper.isWechatBrowser();
        var cacheGroup;
        var vm = $scope;

        vm.typeSelectedFn = typeSelectedFn;
        vm.clearQuery = clearQuery;
        vm.clearQueryPhone = clearQueryPhone;

        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleWardNode = toggleWardNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectContactGroupMembers = selectContactGroupMembers;
        vm.selectWardDeptMembers = selectWardDeptMembers;
        vm.selectDeptMembers = selectDeptMembers;

        vm.selectDeptPhone = selectDeptPhone;
        vm.selectDeptWardPhone = selectDeptWardPhone;
        vm.pageChanged = pageChanged;
        vm.selectUser = selectUser;
        vm.queryUser = queryUser;

        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.wardVisible = wardVisible;

        vm.getCallUrl = getCallUrl;
        vm.hasCallUrl = hasCallUrl;

        vm.initCommonPhoneSelector = initCommonPhoneSelector;
        vm.download = download;

        vm.userStatusSelectFn = userStatusSelectFn;
        vm.userTypeSelectFn = userTypeSelectFn;
        vm.userTitleSelectFn = userTitleSelectFn;
        vm.getUserDataes = getUserDataes;
        vm.groupByTitle = groupByTitle;

        vm.tuGroupVisible = tuGroupVisible;
        vm.toggleTuGroupNode = toggleTuGroupNode;

        vm.tab=[];


        init();


        function init() {
            vm.selectTypes = [
                {id: 1, name: '科室', exAll: false, fresh: true},
                {id: 10, name: '主科室', fresh: true},
                // {id: 2, name: '角色', exAll: false, fresh: true},
                {id: 3, name: '姓名/工号', fresh: true},
                {id: 5, name: '群', fresh: true},
                {id: 6, name: '年资', fresh: true},
                {id: 7, name: '值班电话', fresh: true},
                {id: 8, name: '组合查询', fresh: true},
                {id: 9, name: '工会', fresh: true},
            ];
            vm.curType = $scope.selectTypes[0];
            vm.selected = null; //所有选中的人
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);

        }
        $scope.$on('skipPhone', function () {
            vm.curType = $scope.selectTypes[5];
            vm.typeSelectedFn(5);
        });

        function getCallUrl(phone) {
            var index = phone.indexOf('转');
            var temp = phone;
            if (index != -1) {
                temp = phone.slice(0, index);
            }
            var url = 'tel:' + temp;
            if (isWx && deviceDetector.os !== OS.IOS) return url + '#weixin.qq.com';
            return url;
        }

        function hasCallUrl(phone) {
            return !deviceDetector.isDesktop() && phone
        }

        function typeSelectedFn($index) {
            vm.tab[$index]=true;
            var toType = $scope.selectTypes[$index];
            // $(window).resize(function () {
            //     var width = $(window).width();
            //     if (width > 768) {
            //         $scope.hideList = false;
            //         $scope.showDetail = true;
            //     } else {
            //         $scope.hideList = false;
            //         $scope.showDetail = false;
            //     }
            // });
            vm.pager = {total: 0, page: 1, count: 10};
            var width = $(window).width();
            if (width > 768) {
                $scope.hideList = false;
                $scope.showDetail = true;
            } else {
                $scope.hideList = false;
                $scope.showDetail = false;
            }
            switch (toType.id) {
                case 1:
                case 10:
                    if (toType.fresh || toType.id != $scope.curType.id) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                // case 2:
                //     if (toType.fresh) {
                //         initRoleSelector();
                //         toType.fresh = false;
                //     }
                //     break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 6:
                    if (toType.fresh) {
                        initSenioritySelector();
                        toType.fresh = false;
                    }
                    break;
                case 7:
                    initCommonPhoneSelector();
                    break;
                case 8:
                    initMixSearchSelector();
                    break;
                case 9:
                    if (toType.fresh) {
                        initTradeUnionSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            $scope.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function clearQueryPhone() {
            vm.queryPhone = undefined;
            initCommonPhoneSelector(vm.queryPhone);
        }

        function initMixSearchSelector() {
            vm.loading = true;
            $q.all([
                User.query({opt: 100}).$promise
            ]).then(function (respArray) {
                vm.loading = false;
                vm.userTypes = respArray[0].types;
                vm.userStatuses = respArray[0].statuses;
                vm.userTitles = respArray[0].titles;
                vm.getUserDataes(vm.pager.page, vm.pager.count);
            });
        }

        function initTradeUnionSelector() {
            vm.loading = true;
            $http.get('api/v1/trade_union/trade_union_groups?op=option').then(function (data) {
                if (data.status == 200) {
                    var items = data.data.items;
                    angular.forEach(items, function (item) {
                        angular.forEach(item.users, function (user) {
                            user.isLeader = ArrayHelper.indexOfKey(user.user_id, item.leaders, 'leader_id') >= 0;
                        });
                    });
                    vm.loading = false;
                    vm.tuGroups = items;
                }
            }, function () {
                vm.loading = false;
            });
        }

        function getUserDataes(page, count) {
            var pa = {
                opt: 101,
                page: page,
                count: count,
                type: vm.userType ? vm.userType.id : undefined,
                title: vm.userTitle ? vm.userTitle.id : undefined,
                status: vm.userStatus ? vm.userStatus.id : undefined
            };
            User.query(pa, function (resp) {
                vm.pager.total = resp.total;
                vm.mixUsers = resp.items;
            });
        }

        function userTitleSelectFn(item) {
            vm.userTitle = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userTypeSelectFn(item) {
            vm.userType = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userStatusSelectFn(item) {
            vm.userStatus = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function groupByTitle(item) {
            var titleTypes = JobTitle.getTypes();
            return titleTypes[item.type - 1].name;
        }

        function initCommonPhoneSelector(qStr) {
            vm.showDetail = false;
            vm.loading = true;
            vm.queryPhone = qStr;
            CommonPhone.query({
                opt: 2,
                queryStr: qStr,
                page: vm.pager.page,
                count: vm.pager.count
            }, function (resp) {
                vm.loading = false;
                vm.pager.total = resp.total;
                vm.commonPhones = resp.items;
            }, function () {
                vm.loading = false;
            })
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 5/*INDEX_USER_INFO_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.name = qStr;
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.queryStr);
        }

        function selectDeptPhone(dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            vm.selectedWard = false;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function selectDeptWardPhone(ward) {
            showDetailAccordingToScreenSize();

            vm.selected = ward;
            vm.selectedDept = true;
            vm.selectedWard = true;
            DeptWardPhone.query({ward_id: ward.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function selectUser(user) {
            showDetailAccordingToScreenSize();

            vm.selected = user;
            vm.selectedDept = false;
            User.get({id: user.id, info_type: 3}, function (resp) {
                vm.contact = resp.user;
            });
        }


        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }

        function showDetailAccordingToScreenSize() {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }

        // function initRoleSelector() {
        //     vm.loading = true;
        //     User.query({opt: 6}, function (resp) {
        //         vm.loading = false;
        //         vm.roles = resp.roles;
        //     }, function () {
        //         vm.loading = false;
        //     });
        // }

        function initNameSelector() {

        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                vm.loading = false;
                cacheGroup = resp.groups;

                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, creatorName: g.creator.name, memberNumbers: g.members.length};
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initSenioritySelector() {
            vm.loading = true;

            SeniorityStandard.query({opt: 1}, function (resp) {
                vm.loading = false;
                vm.standards = resp;
            }, function () {
                vm.loading = false;
            });
        }

        function tagDeptLeader(dept) {
            var index, item;
            // if (dept.mail_recipient_id) {
            //     index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
            //     if (index > 0) {
            //         item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
            //         dept.members.splice(index, 1);
            //         dept.members.splice(0, 0, item);
            //     }
            // }

            // if (dept.type_id != 1 && dept.type_id != 5&&  dept.leader_id) {
            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
        }

        function isOnlyMain() {
            return vm.curType.id == 10 ? 1 : 0;
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                Dept.query({opt: 3, dept_id: dept.id, only_main: isOnlyMain()}, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        toggle(node);
                    }
                });
            }
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                group.members = ArrayHelper.getItem(group.id, cacheGroup).members;
            }
            toggle(node);
        }

        function toggleTuGroupNode(group, toggle, node) {
            if (!group.users) {
                group.users = ArrayHelper.getItem(group.id, vm.tuGroups).users;
            }
            toggle(node);
        }

        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                Dept.query({
                    opt: 3,
                    dept_id: dept.id,
                    user_type: data.userType,
                    only_main: isOnlyMain()
                }, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        vm.selectUsers(dept.members);
                    }
                });
            }
        }

        function selectContactGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.members = members;
            }
            vm.selectUsers(group.members);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function tuGroupVisible(group) {
            return !(vm.search.tuGroup && vm.search.tuGroup.length > 0
                && group.name.indexOf(vm.search.tuGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            return (visible && !dept.dept_ward_id) || (!visible && dept.name.indexOf(vm.search.dept) !== -1);
            // return !(vm.search.dept && vm.search.dept.length > 0
            //     && dept.name.indexOf(vm.search.dept) === -1);
        }

        function wardVisible() {
            return !(vm.search.dept && vm.search.dept.length > 0);
        }

        function toggleWardNode(ward, toggle, node) {
            if (ward.depts) {
                toggle(node);
            } else {
                DeptWard.query({op: 'options', ward_id: ward.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        ward.depts = resp.items;
                        toggle(node);
                    }
                });
            }
        }

        function selectWardDeptMembers(ward, $event) {
            $event.stopPropagation();
            DeptWard.query({op: 'ward_member', ward_id: ward.id, only_main: isOnlyMain()}, function (resp) {
                console.log('resp', resp);
                var items = resp.items;
                if (items.length > 0) {
                    vm.selectUsers(items);
                }
            });
        }

        function download(type) {
            var defer = $q.defer();
            var url, title;
            if (type == 1) {
                url = '/api/v1/dept_phones/download';
                title = '科室电话明细.xls';

                FileHelper.download(url, {
                    filename: "/dept_phone.xlsx",
                    mime: 'application/wps-office.xlsx'
                }, function (resp) {
                    var data = [resp];
                    var options = {type: "application/wps-office.xlsx"};
                    SaveAs.download(data, title, options);
                }, function () {
                    Dlg.e('服务端文件丢失，请联系管理员!');
                });
            } else {
                url = '/api/v1/common_phones/download';
                title = '值班电话明细.xls';

                FileHelper.dnExcel(url, {}, title)
                    .finally(function () {
                        defer.resolve();
                    });
            }
            return defer.promise;
        }
    }

})();

angular.module('c.c')
    .controller('DeptRecordCtrl', function ($scope, dialogs, toaster, NgTableParams, F,
                                            UserDept) {

        $scope.cols = [
            {title: '科室名称', field: 'name', show: true}, //0
            {title: '科室内职务', field: 'post', show: true}, //6
            {title: '是否主科室', field: 'is_main', show: true}, //6
            {title: '进入时间', field: 'entry_time', sortable: 'entry_time', show: true}, //6
            {title: '离开时间', field: 'leave_time', sortable: 'leave_time', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.hideOpt = true;

        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {entry_time: 'desc'}}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;  //INDEX_DEPTS_IN_MEMBER
                url['user_id'] = $scope.account.id;
                UserDept.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.depts, function (m) {
                        m.is_main = m.is_main == '1';
                    });
                    $defer.resolve(resp.depts);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserDocCtrl', UserDocCtrl);

    /** @ngInject */
    function UserDocCtrl($scope, $stateParams, UIHelper, RedHeadApprover) {
        var vm = $scope;

        vm.isRedHeadApprover = false;
        RedHeadApprover.get({id: 1}).$promise.then(function (resp) {
            if ($scope.account.id == resp.first_approver_id || $scope.account.id == resp.second_approver_id) {
                vm.isRedHeadApprover = true;
            }
        });
        UIHelper.loadTabs(vm, $stateParams);
    }

})();
angular.module('c.c')
    .controller('UserDutyCtrl', function ($scope) {

    });

angular.module('c.c')
    .controller('UserHelpCtrl', function ($scope, $sce, $http,
                                          HelpPage, HelpContent, C, F) {

        HelpPage.query(function (data) {
            $scope.pages = data;
            if (data.length > 0) {
                var page = data[0];
                $scope.selectPage(page);
            }
        });

        HelpContent.get({id: 1}).$promise.then(function (resp) {
            if (resp.root && resp.root['1']) {
                $scope.content = resp.root['1'].children;
            }
        });

        $scope.selectPage = function (page) {
            var url = $sce.getTrustedResourceUrl(page.url);
            $http.get(url).success(function (resp) {
                $scope.curPage.body = $sce.trustAsHtml(resp);
            });
            $scope.curPage = page;
        }

    });


(function () {
    'use strict';

    angular.module('c.s')
        .controller('UserInsuranceFeedbackCtrl', UserInsuranceFeedbackCtrl)
    ;

    /** @ngInject */
    function UserInsuranceFeedbackCtrl($scope, OperationImport, Table, Dlg,ArrayHelper) {
        var vm = $scope;
        var kinds = OperationImport.getKinds();
        vm.edit = edit;
        vm.download = download;

        init();

        function init() {

            var options = {
                service: OperationImport,
                params: {op: 'dept'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                showSn: true,
                // hideOpt: true,
                cols: [
                    {
                        field: "dept",
                        title: '科室',
                        filter: {dept: 'text'}
                    },
                    {
                        field: "kind",
                        title: '医保质控类型',
                        filter: {kind_id: 'select'},
                        data: Table.getNgTableOpts(kinds)
                    },
                    {field: "measure", title: '科室整改措施', filter: {measure: 'text'}},
                    {field: "user", title: '科室整改措施填写人', filter: {user: 'text'}},
                    {field: "violation", title: '违反规则', filter: {violation: 'text'}},
                    {field: "type", title: '违规类型', filter: {type: 'text'}},
                    {field: "subject", title: '违规项目', filter: {subject: 'text'}},
                    {field: "reason", title: '整改建议', filter: {reason: 'text'}},
                    {field: "according", title: '依据', filter: {according: 'text'}},
                    {field: "happened_date", title: '发生日期', filter: {happened_date: 'date_range'}},
                    {field: "date", title: '规范落实日期', filter: {date: 'date_range'}},
                    {field: "one_later_question", title: '第1月后质控出现问题', filter: {one_later_question: 'text'}},
                    {field: "two_later_question", title: '第2月后质控出现问题', filter: {two_later_question: 'text'}},
                    {field: "three_later_question", title: '第3月后质控出现问题', filter: {three_later_question: 'text'}},
                    {field: "important_time", title: '考察期后仍未整改例数', filter: {important_time: 'text'}},
                    {field: "punishment", title: '处理措施', filter: {punishment: 'text'}},
                    {field: "result", title: '整改效果', filter: {result: 'text'}}
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                    item.kind = ArrayHelper.getItem(item.kind_id, kinds);
                });
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'pages/insurance/import/userEditDlg.html',
                ctrl: 'userInsuranceEditDlgCtrl',
                data: {id: m.id}
            }).then(function () {
                vm.tableReload();
            });
        }

        function download() {
            Dlg.show({
                template: 'pages/insurance/import/exportDlg.html',
                ctrl: 'insuranceExportDlgCtrl',
                data: {kind_id: 0}
            }).then(function () {
                Dlg.s('导出成功!');
            });
        }
    }


})();


angular.module('c.c')
    .controller('UserMaterialCtrl', function ($scope, $stateParams, NgTableParams, dialogs, toaster,
                                              F, Dept, MaterialApplication) {
        $scope.types = F.get('material_types');
        $scope.yesNo = F.get('yesNo');

        $scope.cols = [
            {title: '申请物资', field: 'desc', show: true}, //0
            {title: '类型', field: 'type_id', width: '121', show: true}, //1
            {title: '是否急需', field: 'is_urgent', width: '100', show: true}, //1
            {title: '申请人', field: 'applicant', width: '73', show: true}, //6
            {title: '申请时间', sortable: 'created_at', field: 'created_at', width: '118', show: true}, //6
            {title: '处理时间', sortable: 'updated_at', field: 'updated_at', width: '118', show: true}, //6
            {title: '状态', field: 'stage', width: '60', show: true}//1
        ];

        Dept.query({opt: 12}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.tableParams.reload();
            }
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.changeJustMe = function() {
            $scope.tableParams.reload();
        };

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = 1;
                    url['dept_id'] = $scope.dept.id;
                    url['just_me'] = $scope.just_me;
                    MaterialApplication.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.materials, function (m) {
                            m.type = F.getItem(m.type_id, $scope.types);
                        });
                        $defer.resolve(resp.materials);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.hideFilter = true;
        $scope.optColWidth = 70;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('UserMaterialDlg.html', 'UserMaterialDlgCtrl', {dept: $scope.dept}, {
                 size: 'md'
            }).result.then(function (material) {
                    MaterialApplication.save(material).$promise.then(function (data) {
                        toaster.success('物资申请添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('物资申请添加失败!');
                    });
                });
        };

        $scope.canEdit = function (m) {
            return $scope.account.id == m.applicant_id && m.stage != 2;
        };

        $scope.edit = function (m) {
            m.$edit = true;
            m.$descChanged = m.desc;
            m.$typeChanged = m.type;
            m.$is_urgentChanged = m.is_urgent == '1';
        };

        $scope.save = function (m) {
            m.$edit = false;
            if (m.$descChanged == "") {
                toaster.warning('物资申请说明不能为空!')
            } else {
                var data = {};
                data['desc'] = m.$descChanged;
                data['type_id'] = m.$typeChanged.id;
                data['is_urgent'] = m.$is_urgentChanged;
                MaterialApplication.update({id: m.id}, data).$promise.then(function (resp) {
                    toaster.success('物资申请修改成功!');
                    m.desc = m.$descChanged;
                    m.type = m.$typeChanged;
                    m.type_id = m.type.id;
                    m.is_urgent = m.$is_urgentChanged ? '1' : '0';
                }, function (error) {
                    toaster.error('物资申请修改失败!');
                });
            }
        };

        $scope.delete = function (m) {
            dialogs.confirm('删除物资申请', '确定要删除该物资申请记录吗?')
                .result.then(function () {
                    MaterialApplication.delete({id: m.id}).$promise.then(function (resp) {
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('删除物资申请!');
                    });
                });
        };

    });

angular.module('c.c').controller('UserMaterialDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.types = F.get('material_types');
        $scope.dept = data.dept;
        $scope.m = {is_urgent: false, type: $scope.types[0], dept_id: data.dept.id};

        $scope.ok = function (m) {
            if ($scope.m_form.$valid) {
                var params = {};
                params['desc'] = m.desc;
                params['dept_id'] = m.dept_id;
                params['type_id'] = m.type.id;
                params['is_urgent'] = m.is_urgent;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('请填写物资申请说明并保证少于255字符!');
                $scope.m_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c')
    .controller('UserMealCtrl', function ($scope, DeliveryPlaceAdmin, UIHelper, $stateParams) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams);
        DeliveryPlaceAdmin.query({opt: 3/*INDEX_USER_ADMIN_PLACE*/}, function (resp) {
            var places = resp.items;
            vm.isAdmin = places && places.length > 0;
            vm.places = places;
        });
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserCommentCtrl', UserCommentCtrl);

    /** @ngInject */
    function UserCommentCtrl($scope, UIHelper, Dlg, Table, PurchaseHistory, ArrayHelper, commentType) {
        var vm = $scope;
        var comment_types = [];
        vm.show = show;

        init();


        function init() {
            commentType.query({op: 'sys'}).$promise.then(function (resp){

                comment_types = resp.items;

                var options = {
                    service: PurchaseHistory,
                    // params: {op: 'comment'},
                    params: {opt: 7/*INDEX_All_SEARCH*/},
                    optColWidth: Table._2_BTN,
                    optInFront: false,
                    cols: [
                        {
                            field: "comment_type",
                            title: "评论类型",
                            filter: {comment_type: "select"},
                            data: Table.getNgTableOpts(comment_types),
                            width:0.2
                        },
                        {field: "user", title: "消费用户", filter: {user: "text"},width:0.2},
                        {field: "self_paid", title: "实扣金额",width:0.1},
                        {field: "total_paid", title: "欲扣金额",width:0.1},
                        {field: "store", title: "商家", filter: {store: "text"},width:0.2},
                        {field: "time", title: "消费时间", filter: {time: "date_range"},width:0.2}
                    ]
                };
                Table.load(vm, options, function (resp, startSn) {
                    Table.loadItem(resp, startSn, function (item) {
                        item.comment_type = ArrayHelper.getItem(item.comment_type_id, comment_types);
                    });
                });
            });
        }


        function show(m) {
            Dlg.show({
                template: 'pages/user/userCommentDlg.html',
                ctrl: 'userCommentDlgCtrl',
                data: m.id
            }).then(function () {
                vm.tableReload();
            });
        }
    }

})();


angular.module('c.c')
    .controller('UserMeetingCtrl', function ($scope) {

    });


angular.module('c.c')
    .controller('MeetingTopicCtrl', function ($scope) {

    });


angular.module('c.c')
    .controller('UserMissionCtrl', function ($scope, $stateParams, $rootScope, $timeout, UIHelper) {
        if ($stateParams.data.tab) {
            console.log($stateParams.data);
            var data = $stateParams.data;
            console.log($scope.tabs);
            $scope.tabs = [];
            if (data.tab) {
                $scope.tabs[data.tab] = true;
            }
            $timeout(function () {
                $rootScope.$broadcast(data.event, data.content);
            }, 200);
        }

    });
angular.module('c.c')
    .controller('UserOPNoticeCtrl', function ($scope, $filter, NgTableParams, dialogs, toaster, Sms, FileHelper,
                                              C, F, SaveAs, Dept, ORRecipient, OperationPermit) {
        $scope.types = F.get('or_types');
        var typeOpts = F.getNgTableOpts($scope.types);
        var stages = F.get('stage_list');
        var stageOpts = F.getNgTableOpts(stages);

        $scope.cols = [
            {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name', width: '20%', show: true}, //0
            {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id', show: true}, //1
            {title: '递交人', field: 'applicant', filter: {applicant: 'text'}, width: '10%', show: true}, //6
            {
                title: '递交时间',
                filter: {created_at: 'date_range'},
                sortable: 'created_at',
                field: 'created_at',
                width: '15%',
                show: true
            }, //6
            {title: '状态', filter: {stage: 'select'}, data: stageOpts, field: 'stage', width: '10%', show: true},//1
            {title: '备注', field: 'remark', width: '20%', show: true} //1
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        ORRecipient.query({type: 1}, function (resp) {
            $scope.recipients = resp.records;
        });

        Dept.query({opt: 10}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.tableParams.reload();
            }
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.changeJustMe = function () {
            $scope.tableParams.reload();
        };

        $scope.optColWidth = 76;
        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = 1;
                    url['dept_id'] = $scope.dept.id;
                    url['just_me'] = $scope.just_me;
                    if ($scope.dateRangeFilter.created_at != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                    }
                    OperationPermit.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.permits, function (m) {
                            m.type = F.getItem(m.type_id, $scope.types);
                        });
                        $defer.resolve(resp.permits);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('OPDlg.html', 'OPDlgCtrl', {dept: $scope.dept}, {
                size: 'md'
            }).result.then(function (permit) {
                var recipients = [];
                ORRecipient.query({type: permit.type_id}, function (resp) {
                    var recipients = resp.records;
                    console.log(recipients);
                    OperationPermit.save(permit).$promise.then(function (data) {
                        toaster.success('手术通知单递交成功!');
                        $scope.tableReload();
                        if ($scope.recipients.length > 0) {
                            var pa = {};
                            pa['sign'] = '【西藏自治区人民政府驻成都办事处医院】';
                            pa['content'] = '请处理手术通知单' + permit.attach_name;
                            pa['content'] += '(' + $scope.account.name + $scope.account.phone + ')';
                            var recipient_ids = [];
                            angular.forEach(recipients, function (r) {
                                recipient_ids.push(r.user_id);
                            });
                            pa['recipients'] = recipient_ids;
                            Sms.send(pa, function (success) {
                                toaster.success('短信请求成功!');
                            }, function (resp) {
                                toaster.error('短信请求失败!');
                            });
                        }
                    }, function () {
                        toaster.error('手术通知单递交失败!');
                    });
                });
            });
        };

        $scope.canEdit = function (m) {
            return $scope.account.id == m.applicant_id && m.stage == 1;
        };

        $scope.canRm = function (m) {
            return $scope.account.id == m.applicant_id && m.stage != 2;
        };

        $scope.edit = function (m) {
            dialogs.create('OPDlg.html', 'OPDlgCtrl', {dept: $scope.dept, permit: m}, {
                size: 'md'
            }).result.then(function (permit) {
                OperationPermit.update({id: m.id}, permit).$promise.then(function (data) {
                    toaster.success('手术通知单修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('手术通知单修改失败!');
                });
            });
        };

        $scope.delete = function (m) {
            dialogs.confirm('删除手术通知单申请', '确定要删除该手术通知单申请吗?')
                .result.then(function () {
                OperationPermit.delete({id: m.id}).$promise.then(function (resp) {
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('删除手术通知单申请!');
                });
            });
        };

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失,请联系管理员!');
            });
        };
    });

angular.module('c.c').controller('OPDlgCtrl',
    function ($scope, $uibModalInstance, toaster, dialogs, C, F, Upload, data) {
        $scope.types = F.get('or_types');
        $scope.dept = data.dept;
        if (data.permit) {
            var m = data.permit;
            $scope.$edit = true;
            $scope.m = {
                remark: m.remark, dept_id: data.dept.id, type: m.type,
                attach_name: m.attach_name, attach_mime: m.attach_mime,
                attach_filename: m.attach_filename, attach_size: m.attach_size
            };
        } else {
            $scope.m = {type: $scope.types[0], dept_id: data.dept.id};
        }

        $scope.progress = 0;
        $scope.upload = function (file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file == null) {
                return;
            }

            Upload.upload({
                url: C.URL.OP_UPLOAD, file: file
            }).progress(function (evt) {
                $scope.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.attach_name = resp.attach_name;
                        m.attach_mime = resp.attach_mime;
                        m.attach_filename = resp.attach_filename;
                        m.attach_size = resp.attach_size;
                        break;
                    case 1:
                        $scope.progress = 101;
                        $scope.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                $scope.progress = 102;
                $scope.errorInfo = '服务器错误!';
            });
        };

        $scope.ok = function (m) {
            if (m.attach_name == null) {
                toaster.warning('必须上传手术通知单作为附件!');
            } else if ($scope.m_form.$valid) {
                var params = {};
                params['remark'] = m.remark;
                params['dept_id'] = m.dept_id;
                params['type_id'] = m.type.id;

                params['attach_name'] = m.attach_name;
                params['attach_mime'] = m.attach_mime;
                params['attach_filename'] = m.attach_filename;
                params['attach_size'] = m.attach_size;

                $uibModalInstance.close(params);
            } else {
                toaster.warning('备注长度不能超过255字符!');
                $scope.m_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('c.c')
    .controller('UserPayCtrl', function ($scope) {

    });


angular.module('c.d')
    .controller('ProfileCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, User, F, $ocLazyLoad,
                                         Auth, RushPark, $stateParams, Dlg) {
        $scope.reload = function (requireChangePasswd) {
            $scope.account = Auth.getAccount();
            User.get({id: $scope.account.id, info_type: 0, only_show: 1}, function (data) {
                var user = data.user;
                user.edu_bg = F.getItem(user.edu_bg, F.get('edu_bg_list'));
                user.en_lv = F.getItem(user.en_lv, F.get('eg_lv_list'));
                if (user.level) {
                    user.level = F.getItem(user.level, $scope.titleLeaves);
                }
                //if (user.title) {
                //    user.title = F.getItem(user.title, F.get('titles'));
                //}
                if (user.post) {
                    user.post = F.getItem(user.post, F.get('posts'));
                }
                if (user.signature) {
                    user.sign = user.signature.sign;
                }
                if (user.seal) {
                    user.seal = user.seal.seal;
                }
                $scope.user = user;

                if (requireChangePasswd) {
                    Dlg.show({
                        template: 'pages/personnel/userInfo/changePasswordDlg.html',
                        ctrl: 'changePasswordDlgCtrl',
                        data: {user: user}
                    });
                }
                $ocLazyLoad.load(['qrCode'], {cache: false, timeout: 0}).then(function () {
                    $scope.qrCode = {id: user.id, username: user.username, type: 'oa.user_info'};
                });
            });
        };

        $scope.titleLeaves = User.getTitleLevel();

        $scope.reload($stateParams.data.requireChangePasswd);

        $scope.addUserPhoto = function (user) {
            dialogs.create('templates/upload/userpic_dlg.html',
                'UploadUserpicDlg', {}, {size: 'md'}
            ).result.then(function (photo) {
                User.update({id: user.id}, {opt: 1, photo: photo}).$promise.then(
                    function (resp) {
                        user.photo = photo;
                        $scope.account.photo = photo;
                        Auth.setAccount($scope.account);
                    }
                );
            });
        };

        $scope.edit = function (user) {
            if (user.confirm_state == 2) {
                Dlg.show({
                    template: 'pages/personnel/userInfo/changePasswordDlg.html',
                    ctrl: 'changePasswordDlgCtrl',
                    data: {user: user}
                });
                $scope.account.more_contact_info = false;
                Auth.setAccount($scope.account);
            } else {
                dialogs.create('templates/user_edit_dlg.html', 'UserEditCtrl',
                    {user_id: user.id, confirm_state: '1'}, {size: 'lg'}).result.then(function (pa) {
                    toaster.success('用户信息确认成功!');
                    $scope.account.confirm_state = 1; //1表示用户已确认
                    $scope.account.phone = pa['phone'];
                    $scope.account.email = pa['email'];
                    $scope.account.username = pa['email'];
                    $scope.account.photo = pa['email'];
                    Auth.setAccount($scope.account);
                    $scope.reload();
                });
            }

        };

        $scope.editSign = function (user) {
            dialogs.create('pages/user/userSignDlg.html', 'SignDlgCtrl', {user: user}, {
                size: 'md'
            }).result.then(function (params) {
                params['opt'] = 5;
                User.update({id: user.id}, params).$promise.then(function () {
                    toaster.success('签名设置成功!');
                    user.sign = params['sign'];
                }, function () {
                    toaster.error('签名设置失败!');
                });
            });
        };

        $scope.editSeal = function (user) {
            dialogs.create('pages/user/userSealDlg.html', 'SealDlgCtrl', {user: user}, {
                size: 'md'
            }).result.then(function (params) {
                params['opt'] = 7/*OPT_SEAL*/;
                User.update({id: user.id}, params).$promise.then(function () {
                    toaster.success('印鉴设置成功!');
                    user.seal = params['seal'];
                }, function () {
                    toaster.error('印鉴设置失败!');
                });
            });
        };

        $scope.editContact = function (user) {
            dialogs.create('templates/contact_info_dlg.html', 'ContactInfoCtrl',
                {user_id: user.id}, {size: 'md'}).result.then(function (pa) {
                pa['opt'] = 1;
                User.update({id: user.id}, pa).$promise.then(function (resp) {
                    toaster.success('联系信息修改成功!');
                    $scope.account.phone = pa['phone'];
                    $scope.account.email = pa['email'];
                    Auth.setAccount($scope.account);
                    $scope.reload();
                }, function () {
                    toaster.error('联系信息修改失败!');
                });
            });
            $scope.account.more_contact_info = false;
            Auth.setAccount($scope.account);
        };

        //修改车辆信息
        $scope.rush = function (park) {
            dialogs.create('templates/rush_park.html', 'RushParkDlgCtrl', {'park': park}, {
                size: 'md'
            }).result.then(function (rush) {
                RushPark.update({'id': park.id}, rush).$promise.then(function () {
                    toaster.success('车辆信息修改成功!');
                    $scope.reload();
                }, function () {
                    toaster.error('此车牌信息已被占用或您已登记过!');
                });
            });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除车牌', '确认要删除车牌吗?').result.then(function () {
                RushPark.delete({id: record.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

    });

angular.module('c.c')
    .controller('ContactInfoCtrl', function ($scope, $uibModalInstance, toaster, User, data) {
        $scope.first_login = true;
        User.get({id: data.user_id, info_type: 3}, function (resp) {
            $scope.user = resp.user;
        });
        $scope.submit = function (user) {
            if ($scope.u_form.$valid) {
                var pa = {};
                pa['phone'] = user.phone;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                pa['office_cornet'] = user.office_cornet;
                pa['email'] = user.email;
                pa['address'] = user.address;

                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c')
    .controller('UserRuleCtrl', function ($scope, $http) {
        var vm = $scope;

        $http.post('/api/v1/rules/check_op').then(function (resp) {
            vm.visable = resp.data.isOp;
        });
    });


angular.module('c.c')
    .controller('SmsCtrl', function ($rootScope, $scope, $stateParams, $timeout) {
        if ($stateParams.data.tab) {
            $scope.tabs = [];
            var data = $stateParams.data;
            $scope.tabs[data.tab] = true;
            $timeout(function () {
               $rootScope.$broadcast(data.event, data.mail);
            }, 200);
        }
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('userCommentDlgCtrl', userCommentDlgCtrl);

    /** @ngInject */
    function userCommentDlgCtrl($uibModalInstance, $scope, $q, Auth, $filter, ArrayHelper, $rootScope,
                                DateHelper, PurchaseHistory, FormHelper, Dlg, data, toaster,
                                commentType, PurchaseHistoryPathRecord) {
        var vm = this;
        vm.ok = ok;

        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data);

        function init(id) {

            $q.all([
                commentType.query({op: 'sys'}).$promise,
                PurchaseHistory.get({id: id}).$promise,
                PurchaseHistoryPathRecord.get({id: id}).$promise
            ]).then(function (respArr){
                vm.comment_types = respArr[0].items;
                vm.m = respArr[1];
                vm.m.comment_type = ArrayHelper.getItem(vm.m.comment_type_id, vm.comment_types);
                vm.paths = respArr[2].record;
            });
        }

        function ok(m) {

            var pa = {
                comment_type_id: m.comment_type_id,
                comment: m.comment,
                comment_result: m.commentResult
            };

            var promise;
            promise = PurchaseHistory.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
            promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success(resp.msg);
                        $q.defer().resolve();
                        break;
                    default:
                        toaster.warning(resp.msg);
                        $q.defer().reject();
                }
                vm.close();
            });
            return $q.defer().promise;

        }
    }

})();


angular.module('c.c').controller('SealDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.image = {croppedDataUrl: ''};
    $scope.user = data.user;

    $scope.ok = function (image) {
        if (image.croppedDataUrl == '') {
            toaster.warning('请先选择印鉴图片!');
        } else {
            var params = {};
            params['user_id'] = data.user.id;
            params['seal'] = image.croppedDataUrl;
            $uibModalInstance.close(params);
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c.c').controller('SignDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.image = {croppedDataUrl: ''};
    $scope.user = data.user;

    $scope.ok = function (image) {
        if (image.croppedDataUrl == '') {
            toaster.warning('请先选择签名图片!');
        } else {
            var params = {};
            params['user_id'] = data.user.id;
            params['sign'] = image.croppedDataUrl;
            $uibModalInstance.close(params);
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
'use strict';

angular.module('c.c')
    .controller('UserWageCtrl', function ($scope) {

    });


angular.module('c.c').controller('MeetingBackAttendanceDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data) {
        $scope.meetingId = data.meetingId;
        $scope.meeting = {
            state: true,
            attendances: []
        };


        $scope.ok = function (meeting) {
            if (meeting.attendances.length == 0) {
                toaster.warning('出席人不能为空!');
            } else {
                var params = {};
                params['state'] = '1';
                params['meetingId'] = $scope.meetingId;
                params['attendances'] = [];
                angular.forEach(meeting.attendances, function (attendance) {
                    params['attendances'].push(attendance.id);
                });
                $uibModalInstance.close(params);
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });



(function () {
    'use strict';

    angular.module('c.c')
        .controller('meetingPreviewDlgCtrl', meetingPreviewDlgCtrl);

    function meetingPreviewDlgCtrl(FormHelper, Dlg, $uibModalInstance, data, DateHelper, $sce) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data);


        function init(data) {
            vm.meeting = data.meeting;
            vm.meeting.time_range = DateHelper.date2Str(vm.meeting.date) + ' ' +
                vm.meeting.s.options.translate(vm.meeting.s.min) + '-' +
                vm.meeting.s.options.translate(vm.meeting.s.max);
            vm.meeting.meetingContent = $sce.trustAsHtml(vm.meeting.content);
        }

    }
})();

angular.module('c').controller('MeetingRecordDlgCtrl',
    function ($scope, Meeting, uibDateParser, $uibModalInstance, $filter, data, MeetingRecord, MeetingAttendance, Dlg, $q) {
        var vm = $scope;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.addProcess = addProcess;
        vm.rmProcess = rmProcess;

        init();

        function init() {
            $q.all([
                Meeting.get({id: data.id}).$promise,
                MeetingAttendance.get({id: data.id}).$promise
            ]).then(function (respArray) {
                var m = respArray[0].meeting;

                m.process = [{
                    agenda: '',
                    resolution: '',
                    estimated_time: null,
                    dept: null,
                }];
                m.date = m.start_time.substr(0, 16) + '-' + m.end_time.substr(11, 5);
                m.users = respArray[1].records;
                vm.m = m;
            });
        }

        function addProcess(m) {
            m.process.push({
                agenda: '',
                resolution: '',
                estimated_time: null,
                dept: null,
            });
        }

        function rmProcess(m, index) {
            m.process.splice(index, 1);
        }

        function submit(m) {
            var err = false;
            var pa = {
                process: m.process,
                meeting_id: m.id
            };
            for (var i = 0; i < m.process.length; i++) {
                pa.process[i].estimated_time = $filter('date')(m.process[i].estimated_time, 'yyyy-MM-dd') + '';
                if (!pa.process[i].agenda || !pa.process[i].resolution || !pa.process[i].dept || pa.process[i].estimated_time == null) {
                    err = true;
                }
            }
            if (err) {
                Dlg.w('议程、决议、科室、时间等不能为空');
            } else {
                MeetingRecord.save(pa).$promise.then(function (resp) {
                    if (resp.msg) {
                        Dlg.s(resp.msg);
                    }
                }, function (error) {
                    Dlg.e(error);
                });
                $uibModalInstance.dismiss('cancel');
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
);



(function () {
  'use strict';

  angular.module('c.c')
  .controller('MeetingTodayCtrl', MeetingTodayCtrl);

  /** @ngInject */
  function MeetingTodayCtrl($scope, $q, Meeting, DateHelper, ArrayHelper, UIHelper, Table,$uibModalInstance, NgTableParams, uibDateParser, $filter) {
    var vm = $scope;
    vm.init = init;
    vm.cancel = $uibModalInstance.dismiss;

    init();

    function init() {

      $scope.cols =[
        {field: "name", title: '名称', filter: {name: 'text'}, width: '20%', show: true},
        {field: "type", title: '类型',  width: '20%', show: true},
        {field: "start_time", title: '开会时间', width: '20%', show: true},
        {field: "room" ,title: '开会地点', width: '10%', show: true},
        {field: "dept" ,title: '科室',  width: '10%', show: true},
        {field: "applicant" ,title: '申请人',  show: true}
      ];

      $scope.hideOpt = true;
      $scope.tableParams = new NgTableParams({
        page: 1, count: 10
      }, {
        counts: [10, 30, 50], total: 0,
        getData: function ($defer, params) {
          var url = params.url();
          url['opt'] = 16;//2 查找会议 9 我的会议
          Meeting.query(url, function (resp) {
            params.total(resp.total);
            angular.forEach(resp.meetings, function (meeting) {
              meeting.forLeave = false;
              meeting.forRemind = false;
              meeting.isLeaver = false;
              meeting.forRCancel = false;
              meeting.forDayRemind = false;
              meeting.isModerator = false;
              meeting.isApplicant = false;
              meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);

            });
            $defer.resolve(resp.meetings);
            $scope.meetings = resp.meetings;
          });
        }
      });

    }




  }

})();
angular.module('c').controller('MeetingWorkableDlgCtrl',
    function ($scope, $uibModalInstance, data, MeetingRecord, Dlg, $filter) {
        var vm = $scope;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.finish = data.finish;
        vm.acceptance = data.acceptance;
        vm.wait = data.wait;

        init();

        function init() {
            MeetingRecord.get({id: data.id}).$promise.then(function (resp) {
                vm.m = resp.item;
                vm.m.estimated_time = vm.m.estimated_time.substr(0, 10);
                if (vm.m.finish_time.substr(0, 4) === '0000') {
                    vm.m.finish_time = null;
                } else {
                    vm.m.finish_time = vm.m.finish_time.substr(0, 10);
                }
                vm.m.myself = false;
            });
        }


        function submit(m) {
            if (data.finish) {
                var prompt = '确认完成落实？';
                if (m.content === '') {
                    Dlg.w('落实内容不能为空');
                } else {
                    if (m.myself) {
                        prompt = '确认落实并验收该决议？'
                    }
                    Dlg.confirm(prompt, function () {
                        m.finish_time = $filter('date')(m.finish_time, 'yyyy-MM-dd') + '';
                        var pa = {
                            id: m.id,
                            finish: data.finish,
                            content: m.content,
                            myself: m.myself,
                            comment: (m.comment ? m.comment : null),
                            finish_time: (m.finish_time ? m.finish_time : null)
                        };
                        ok(pa);
                    });
                }

            } else if (data.acceptance) {
                Dlg.confirm('确认验收该决议？', function () {
                    m.finish_time = $filter('date')(m.finish_time, 'yyyy-MM-dd') + '';
                    var pa = {
                        id: m.id,
                        acceptance: data.acceptance,
                        comment: m.comment,
                        finish_time: m.finish_time
                    };
                    ok(pa);
                });
            }
            else {
                Dlg.confirm('确认开始落实？', function () {
                    ok({id: m.id});
                });
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function ok(pa) {
            MeetingRecord.update(pa).$promise.then(function (resp) {
                if (resp.msg) {
                    Dlg.s(resp.msg);
                }
            }, function (error) {
                Dlg.e(error);
            });
            $uibModalInstance.close();
        }
    }
);



(function () {
    'use strict';

    angular.module('c')
        .directive('cascader', cascader);


    /** @ngInject */
    function cascader($compile, $document, UIHelper, ArrayHelper, $sce, $timeout) {
        return {
            templateUrl: 'directives/form/cascader/cascader.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                required: '=ngRequired',
                placeHolder: '@',
                disabled: '=?',
                option: '=?',
                onSelect: '&',
                labelWidth: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var cas, casLinkedScope, casScope, menuLists = [], valueList = [], searchScope, searchElem, searchItems;
                casScope = scope.$new(true);

                var html = '<div class="cascader" style="visibility:hidden;display:block;top:-9999px;left:-9999px;">' +
                    '<div class="cascader-menus"></div></div>';

                var template;

                template = '<ul class="cascader-menu">' +
                    '<li ng-repeat="i in items" class="cascader-menu-item" ng-class="{\'selected\':$index===selectedIndex}" ' +
                    'ng-click="itemSelected(i,$index,node)"><div ng-style="{width:{{labelWidth}}+\'px\'}" class="cascader-menu-item-content" ng-bind="i.name" title="{{i.name}}"></div>' +
                    '<div class="cascader-menu-item-icon" ng-show="i.children.length>0"><i class="fa fa-angle-right"></i></div>' +
                    '</li></ul>';


                var searchHtml =
                    '<ul class="cascader-serach-menu"><li class="cascader-serach-menu-item" ng-repeat="i in items" ng-bind-html="highlight(i,inputText)" ng-click="searchSelected(i)"></li></ul>';

                var casLinker = $compile(html);
                scope.searchText = null;
                scope.clearValue = clearValue;


                init();


                function init() {
                    scope.$watch(function () {
                        return scope.option;
                    }, function (option) {
                        if (option) {
                            scope.$watch(function () {
                                return scope.model;
                            }, function (model) {
                                if (model && !scope.value) {
                                    show();
                                    if (!searchItems) searchItems = getItems(scope.option, []);
                                    searchSelected(getSelectItem(searchItems, model.id));
                                }
                            });
                        }
                    });


                    angular.element('.cascader-search').on('focus', show);
                    $document.on('click', bodyHideCasBind);
                    scope.$on('$destroy', function () {
                        removeCas(true);
                        casScope = null;
                    });

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function getSelectItem(items, id) {
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].item.id == id) {
                            return items[i];
                        }
                    }
                }

                function clearValue() {
                    scope.model = null;
                    scope.value = null;
                    scope.searchText = null;
                    hide();
                }


                function removeCas(force) {
                    angular.element('.cascader-menu').addClass('cascader-hidden');
                    scope.searchText = null;
                    if (cas && (!scope.value || force)) {
                        cas.remove();
                        cas = null;
                    }
                    if (casLinkedScope && (!scope.value || force)) {
                        casLinkedScope.$destroy();
                        casLinkedScope = null;
                    }
                }

                function checkValidity() {
                    var valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function show() {
                    if (!angular.isArray(scope.option)) {
                        var option = [];
                        angular.forEach(scope.option, function (value) {
                            option.push(value);
                        });
                        scope.option = option;
                    }
                    if (scope.option.length > 0) {
                        createCas();
                        casScope.$evalAsync(function () {
                            positionCas();
                        });
                    }
                }


                function hide() {
                    if (!casScope) return;
                    casScope.$evalAsync(function () {
                        removeCas();
                    });
                }


                function createCas() {
                    if (cas) {
                        angular.element('.cascader').removeClass('cascader-hidden');
                        angular.element('.cascader-menu').removeClass('cascader-hidden');
                        angular.forEach(menuLists, function (list) {
                            if (list.elem) list.elem[0].scrollTop = list.scope.selectedIndex * 25;
                        });
                        return;
                    }
                    casLinkedScope = casScope.$new();
                    cas = casLinker(casLinkedScope, function (cas) {
                        angular.element('body').append(cas);
                    });
                    createMenus(scope.option, 0);
                    scope.$watch('searchText', modelChanged);
                }


                function createMenus(option, node) {
                    var newScope = casScope.$new()
                    newScope.itemSelected = itemSelected;
                    newScope.items = option;
                    newScope.node = node;
                    newScope.labelWidth = scope.labelWidth;
                    var elem = $compile(template)(newScope);
                    angular.element('.cascader-menus').append(elem);
                    menuLists[node] = {'scope': newScope, 'elem': elem};
                }

                function bodyHideCasBind(e) {
                    if (!casScope || !cas) {
                        return;
                    }
                    if (!iElement[0].contains(e.target) && !cas[0].contains(e.target)) {
                        hide();
                    }
                }

                function getItems(items, newItems, parentName, node) {
                    for (var i = 0; i < items.length; i++) {
                        var name = parentName ? parentName + '/' + items[i].name : items[i].name;
                        var item = {name: name, item: items[i], node: []}
                        if (node) {
                            item.node = node.concat([{text: items[i], i: i}]);
                        } else {
                            item.node.push({text: items[i], i: i});
                        }
                        if (items[i].children.length > 0) {
                            getItems(items[i].children, newItems, name, item.node);
                        } else {
                            newItems.push(item);
                        }
                    }
                    return newItems;
                }

                function getSearchItems(items, search) {
                    var newItems = [];
                    if (!searchItems) searchItems = getItems(items, []);
                    angular.forEach(searchItems, function (value) {
                        if (value.name.indexOf(search) != -1) {
                            newItems.push({'name': value.name, 'item': value.item, 'node': value.node});
                        }
                    });
                    return newItems;
                }

                function searchSelected(text) {
                    scope.value = text.name;
                    scope.model = text.item;

                    //重新渲染
                    angular.forEach(text.node, function (value, index) {
                        itemSelected(value.text, value.i, index);
                    });

                    angular.element('.cascader').addClass('cascader-hidden');
                    removeSearch();
                }

                function modelChanged(newVal) {
                    if (newVal) {
                        angular.element('.cascader-menu').addClass('cascader-hidden');
                        if (getSearchItems(scope.option, newVal).length > 0) {
                            if (!searchElem) {
                                searchScope = casScope.$new()
                                searchScope.searchSelected = searchSelected;
                                searchScope.highlight = highlight;
                                searchElem = $compile(searchHtml)(searchScope);
                                angular.element('.cascader-menus').append(searchElem);
                            }

                            if (searchScope) {
                                searchScope.items = getSearchItems(scope.option, newVal);
                                searchScope.inputText = newVal;
                            }
                        } else {
                            removeSearch();
                        }

                    } else {
                        removeSearch();
                    }
                }

                function removeSearch() {
                    if (searchElem) {
                        searchElem.remove();
                        searchElem = null;
                    }
                    if (searchScope) {
                        searchScope.$destroy();
                        searchScope = null;
                    }
                }

                function positionCas() {
                    if (!cas || !cas.html()) {
                        return;
                    }
                    var hostEl = iElement;
                    var targetEl = cas;

                    var hostElPos;

                    hostElPos = UIHelper.offset(hostEl);

                    var top = (hostElPos.top + hostElPos.height) + 'px';
                    var left = hostElPos.left + 'px';
                    targetEl.css({top: top, left: left, visibility: 'visible'});
                }

                function highlight(text, search) {
                    var name = text.name;
                    if (!search) return $sce.trustAsHtml(name);
                    return $sce.trustAsHtml(name.replace(new RegExp(search, 'gi'), '<strong>$&</strong>'));
                }

                function itemSelected(text, i, node) {
                    menuLists[node].scope.selectedIndex = i;
                    valueList.splice(node);
                    valueList[node] = text.name;

                    //删掉同级及下级已有的append
                    angular.forEach(menuLists, function (list, key) {
                        if (key > node) {
                            if (list.elem) {
                                list.elem.remove();
                                list.elem = null;
                            }
                            if (list.scope) {
                                list.scope.$destroy();
                                list.scope = null;
                            }
                        }
                    });
                    //如果有子项，继续append
                    if (angular.isDefined(text.children) && text.children.length > 0) {
                        //增加下级显示
                        createMenus(text.children, node + 1);
                    } else {
                        scope.value = valueList.join('/');
                        scope.model = text;
                        hide();
                        $timeout(function () {
                            if (scope.onSelect) {
                                scope.onSelect({selectedItem: scope.model});
                            }
                        }, 300)

                    }
                }
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('deptSelector', deptSelector)
        .controller('DeptSelectCtrl', DeptSelectCtrl);

    /** @ngInject */
    function deptSelector(Dlg) {
        return {
            templateUrl: 'directives/form/dept-selector/dept-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                onSelect: '&',
                updateMod: '=?', // 是否修改模式，否则是追加模式
                multiSelect: '=?',
                existDepts: '=?',
                placeHolder: '@',
                disabled: '=?',
                account: '=?'// 是否核算科室
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectDeptFn = selectDeptFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    vm.updateMod = angular.isDefined(iAttrs.updateMod);

                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.updateMod)) vm.updateMod = false;
                    if (angular.isUndefined(vm.multiSelect)) vm.multiSelect = false;
                    if (angular.isUndefined(vm.existDepts)) vm.existDepts = [];
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择科室';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.account)) {
                        vm.account = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectDeptFn(multiSelect, existDepts) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/dept-selector/dept_selector_dlg.html',
                        ctrl: 'DeptSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existDepts: existDepts,
                            updateMod: vm.updateMod,
                            account: vm.account
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (vm.updateMod) {
                                    vm.model = params;
                                } else {
                                    angular.forEach(params, function (dept) {
                                        vm.model.push(dept);
                                    });
                                }
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedDept: vm.model});
                        }
                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function DeptSelectCtrl($scope, $uibModalInstance, F, Dept, data, DeptWard) {
        var vm = $scope;
        var updateMod;
        vm.selectTypes = [
            {id: 1, name: '按类型选择', exAll: false, fresh: true},
            {id: 3, name: '按名称选择', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.loading = false;

        vm.typeSelectedFn = typeSelectedFn;
        vm.selectTypeDepts = selectTypeDepts;
        vm.selectWardDepts = selectWardDepts;
        vm.selectDepts = selectDepts;
        vm.removeSelected = removeSelected;
        vm.clearQuery = clearQuery;
        vm.queryDept = queryDept;
        vm.selectDept = selectDept;
        vm.toggleWardNode = toggleWardNode;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '科室选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.updateMod)) {
                updateMod = false;
            } else {
                updateMod = data.updateMod;
            }
            if (angular.isUndefined(data.existDepts)) {
                data.existDepts = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) data.model = [];
            }
            if (vm.multiSelect && updateMod) {
                vm.selected = angular.copy(data.model);
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        //
        function selectDept(dept) {
            if (vm.multiSelect) {
                var index = F.indexOfKey(dept.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(dept);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, dept);
                } else {
                    vm.selected.push(dept);
                }
            }
        }


        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9, account: data.account ? '1' : '0'}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
                angular.forEach(vm.types, function (type) {
                    angular.forEach(type.depts, function (dept) {
                        if (F.indexOfKey(dept.id, data.existDepts) !== -1 ||
                            (!updateMod && vm.multiSelect && F.indexOfKey(dept.id, data.model) !== -1)) {
                            dept.hide = true;
                        }
                    });
                });
            }, function () {
                vm.loading = false;
            });
        }

        function selectTypeDepts(type) {
            vm.selectDepts(type.depts);
        }

        function selectWardDepts(ward) {
            if (ward.depts) {
                vm.selectDepts(ward.depts);
            } else {
                DeptWard.query({op: 'options', ward_id: ward.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        ward.depts = resp.items;
                        angular.forEach(ward.depts, function (dept) {
                            if (F.indexOfKey(dept.id, data.existDepts) !== -1 ||
                                (!updateMod && vm.multiSelect && F.indexOfKey(dept.id, data.model) !== -1)) {
                                dept.hide = true;
                            }
                        });
                        vm.selectDepts(ward.depts);
                    }
                });
            }
        }

        function selectDepts(depts) {
            angular.forEach(depts, function (d) {
                if (!d.hide) {
                    selectDept(d);
                }
            });
        }

        function toggleWardNode(ward, toggle, node) {
            if (ward.depts) {
                toggle(node);
            } else {
                DeptWard.query({op: 'options', ward_id: ward.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        ward.depts = resp.items;
                        angular.forEach(ward.depts, function (dept) {
                            if (F.indexOfKey(dept.id, data.existDepts) !== -1 ||
                                (!updateMod && vm.multiSelect && F.indexOfKey(dept.id, data.model) !== -1)) {
                                dept.hide = true;
                            }
                        });
                        toggle(node);
                    }
                });
            }
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function clearQuery() {
            vm.depts = [];
            vm.filterName = '';
        }

        function queryDept(name) {
            if (name != null && name.length > 0) {
                vm.filterName = name;
                vm.loading = true;
                Dept.query({opt: 4, name: name, account: data.account ? '1' : '0'}, function (resp) {
                    var depts = resp.depts;
                    angular.forEach(depts, function (dept) {
                        if (F.indexOfKey(dept.id, data.existDepts) !== -1 ||
                            (!updateMod && vm.multiSelect && F.indexOfKey(dept.id, data.model) !== -1)) {
                            dept.hide = true;
                        }
                    });
                    vm.depts = depts;
                }).$promise.then(function () {

                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                // toaster.warning('请输入科室名称');
                clearQuery();
            }
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('planSelector', planSelector)
        .controller('PlanSelectCtrl', PlanSelectCtrl);

    /** @ngInject */
    function planSelector(Dlg) {
        return {
            templateUrl: 'directives/form/disease-plan-selector/plan-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                onSelect: '&',
                existMembers: '=?',
                placeHolder: '@',
                disabled: '=?',
                meetingId: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                            return !vm.model || vm.model.length === 0;
                        } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择计划';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect, existMembers) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/disease-plan-selector/plan_selector_dlg.html',
                        ctrl: 'PlanSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existMembers: existMembers
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                vm.model = angular.copy(params);
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function PlanSelectCtrl($scope, $uibModalInstance, ArrayHelper, Api, DiseasePlanType, DiseasePlan, data) {
        var vm = $scope;
        vm.selectTypes = [
            {id: 1, name: '计划类型', exAll: false, fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;

        vm.clearQuery = clearQuery;
        vm.typeSelectedFn = typeSelectedFn;
        vm.toggleTypeNode = toggleTypeNode;
        vm.removeSelected = removeSelected;
        vm.selectPlan = selectPlan;

        vm.cancel = $uibModalInstance.dismiss;
        vm.removeAll = removeAll;
        vm.ok = ok;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '计划选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }
            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function clearQuery() {
            vm.plans = [];
            vm.pager.total = 0;
        }

        function selectPlan(plan) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(plan.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(plan);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, plan);
                } else {
                    vm.selected.push(plan);
                }
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            DiseasePlanType.query({op: 'options'}, function (resp) {
                vm.loading = false;
                vm.types = resp.items;
            }, function () {
                vm.loading = false;
            });
        }

        function toggleTypeNode(type, toggle, node) {
            if (type.plans) {
                toggle(node);
            } else {
                DiseasePlan.query({op: 'select_type_plan', type_id: type.id}, function (resp) {
                    type.plans = resp.items;
                    toggle(node);
                });
            }
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }

})();
angular.module('c.d')
    .directive('examPackageSelector', function () {
        return {
            templateUrl: 'directives/form/exam-package-selector/exam-package-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'multiSelect': '=?',
                'placeHolder': '@',
                'disabled': '=?',
                'filter': '=?'
            },
            controller: function ($scope, dialogs, F) {
                if (angular.isUndefined($scope.multiSelect)) {
                    $scope.multiSelect = false;
                }
                if (angular.isUndefined($scope.model)) {
                    if ($scope.multiSelect) {
                        $scope.model = [];
                    }
                }
                if (angular.isUndefined($scope.placeHolder)) {
                    $scope.placeHolder = '选择套餐';
                }
                if (angular.isUndefined($scope.disabled)) {
                    $scope.disabled = false;
                }
                if (angular.isUndefined($scope.filter)) {
                    $scope.filter = {};
                }

                $scope.selectPackageFn = function (multiSelect) {
                    $scope.activeMatchIndex = -1;
                    dialogs.create('directives/form/exam-package-selector/exam_package_selector_dlg.html',
                        'PackageSelectorDlgCtrl',
                        {
                            multiSelect: multiSelect,
                            model: $scope.model,
                            filter: $scope.filter
                        }, {
                            size: 'lg'
                        }).result.then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                $scope.model = params[0];
                            } else {
                                $scope.model = [];
                                angular.forEach(params, function (m) {
                                    $scope.model.push(m);
                                });

                                angular.forEach($scope.model, function (m) {
                                    m.total_fee = F.toFixed(parseFloat(m.origin_fee) * parseFloat(m.count), 1);
                                })
                            }
                        } else {
                            if (!multiSelect) {
                                $scope.model = null;
                            } else {
                                $scope.model = [];
                            }
                        }
                    });
                };

                $scope.selectTag = function ($event, $index) {
                    $event.stopPropagation();
                    $scope.activeMatchIndex = $index;
                };

                $scope.removeChoice = function ($event, $index) {
                    $scope.activeMatchIndex = -1;
                    $event.stopPropagation();
                    $scope.model.splice($index, 1);
                };
            }
        }
    });

angular.module('c.c').controller('PackageSelectorDlgCtrl',
    function ($scope, $uibModalInstance, uibDateParser, Dlg, ExamPackageType, Order, data, Float, ArrayHelper, ExamPackage) {
        var vm = $scope;
        vm.total_fee = 0;
        vm.total_number = 0;
        vm.total_project = 0;

        vm.filter = angular.copy(data.filter);

        var SELECT_TYPE = 1;
        var SELECT_NAME = 3;

        vm.selectTypes = [
            {id: SELECT_TYPE, name: '类型', exAll: false, fresh: true},
            {id: SELECT_NAME, name: '名称', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的商品
        vm.loading = false;

        vm.selectPackage = selectPackage;
        vm.filterChange = filterPackage;
        vm.clearFilter = clearFilter;

        vm.typeSelectedFn = typeSelectedFn;
        vm.removeSelected = removeSelected;

        vm.queryPackage = queryPackage;
        vm.clearQuery = clearQuery;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '套餐选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            } else {
                if (data.multiSelect) {
                    angular.forEach(data.model, function (m) {
                        vm.selected.push(m);
                        vm.total_fee += m.origin_fee;
                        vm.total_project += m.project_count;
                        vm.total_number += 1;
                    });
                    vm.total_fee = Float.toFixed(vm.total_fee, 1);
                } else {
                    var m = angular.copy(data.model);
                    vm.selected = [m];
                    if (m) {
                        vm.total_fee = m.origin_fee;
                        vm.total_project = m.project_count;
                        vm.total_number = 1;
                    }
                }
            }
            typeSelectedFn(0);
        }

        function filterPackageHide(p, filter) {
            p.hide = false;
        }

        function filterTypePackage() {
            angular.forEach(vm.types, function (type) {
                angular.forEach(type.packages, function (p) {
                    filterPackageHide(p, vm.filter);
                });
            });
        }

        function filterQueryOrder() {
            angular.forEach(vm.packages, function (p) {
                filterPackageHide(p, vm.filter);
            });
        }

        function filterPackage(type) {
            switch (type) {
                case SELECT_TYPE:
                    filterTypePackage();
                    break;
                case SELECT_NAME:
                    filterQueryOrder();
                    break;
            }
        }

        function clearFilter(type) {
            vm.filter = {};
            filterPackage(type);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case SELECT_TYPE:
                    if (toType.fresh) {
                        initPackageSelector();
                        toType.fresh = false;
                    } else {
                        filterTypePackage();
                    }
                    break;
                case SELECT_NAME:
                    filterQueryOrder();
                    break;
            }
            vm.curType = toType;
        }

        function selectPackage(p) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(p.id, vm.selected);
                if (index == -1) {
                    vm.selected.push(p);
                    vm.total_number++;
                    vm.total_project += p.project_count;
                    vm.total_fee += p.origin_fee;
                    vm.total_fee = Float.toFixed(vm.total_fee, 1);
                }
            } else {
                vm.total_number = 1;
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, p);
                } else {
                    vm.selected.push(p);
                }
                vm.total_project = p.project_count;
                vm.total_fee = p.origin_fee;
            }
        }

        function loadPackage(p) {
            p.fee = parseFloat(p.fee);
            p.discount = parseFloat(p.discount);
            p.origin_fee = parseFloat(p.origin_fee);
            p.sex_restrict = ArrayHelper.getItem(p.sex_restrict, ExamPackage.getSexRestricts());
            filterPackageHide(p, vm.filter);
        }

        function initPackageSelector() {
            vm.loading = true;
            ExamPackageType.query({op: 'selector'}, function (resp) {
                vm.loading = false;
                vm.types = resp.items;
                angular.forEach(vm.types, function (type) {
                    angular.forEach(type.packages, function (package) {
                        loadPackage(package);
                    });
                });
            });
        }

        function removeSelected($index, p) {
            vm.total_fee -= p.origin_fee;
            vm.total_fee = Float.toFixed(vm.total_fee, 1);
            vm.total_number -= 1;
            vm.total_project -= p.project_count;
            vm.selected.splice($index, 1);
        }

        function queryPackage(qStr) {
            if (qStr) {
                vm.loading = true;
                ExamPackage.query({op: 'selector', name: qStr}).$promise.then(function (resp) {
                    var items = resp.items;
                    angular.forEach(items, function (p) {
                        loadPackage(p);
                    });
                    vm.packages = items;
                }).finally(function () {
                    vm.loading = false;
                    vm.queryStr = qStr;
                });
            } else {
                clearQuery();
                Dlg.w('请输入套餐名称');
            }
        }


        function clearQuery() {
            vm.packages = [];
            vm.queryStr = '';
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
);
angular.module('c.d')
    .directive('examProjectSelector', function () {
        return {
            templateUrl: 'directives/form/exam-project-selector/exam-project-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'multiSelect': '=?',
                'placeHolder': '@',
                'disabled': '=?',
                'onSelect': '&',
                'filter': '=?'
            },
            controller: function ($scope, dialogs, F, Dlg) {
                if (angular.isUndefined($scope.multiSelect)) {
                    $scope.multiSelect = false;
                }
                if (angular.isUndefined($scope.model)) {
                    if ($scope.multiSelect) {
                        $scope.model = [];
                    }
                }
                if (angular.isUndefined($scope.placeHolder)) {
                    $scope.placeHolder = '选择项目';
                }
                if (angular.isUndefined($scope.disabled)) {
                    $scope.disabled = false;
                }
                if (angular.isUndefined($scope.filter)) {
                    $scope.filter = {};
                }

                $scope.selectProjectFn = function (multiSelect) {
                    $scope.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/exam-project-selector/exam_project_selector_dlg.html',
                        ctrl: 'ProjectSelectorDlgCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: $scope.model,
                            filter: $scope.filter
                        },
                        size: 'full'
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                $scope.model = params[0];
                            } else {
                                $scope.model = [];
                                angular.forEach(params, function (m) {
                                    $scope.model.push(m);
                                });

                                angular.forEach($scope.model, function (m) {
                                    m.total_fee = F.toFixed(parseFloat(m.fee) * parseFloat(m.count), 1);
                                })
                            }
                        } else {
                            if (!multiSelect) {
                                $scope.model = null;
                            } else {
                                $scope.model = [];
                            }
                        }
                        if ($scope.onSelect) {
                            $scope.onSelect({$selected: $scope.model});
                        }
                    });
                };

                $scope.selectTag = function ($event, $index) {
                    $event.stopPropagation();
                    $scope.activeMatchIndex = $index;
                };

                $scope.removeChoice = function ($event, $index) {
                    $scope.activeMatchIndex = -1;
                    $event.stopPropagation();
                    $scope.model.splice($index, 1);
                };
            }
        }
    });

angular.module('c.c').controller('ProjectSelectorDlgCtrl',
    function ($scope, $uibModalInstance, uibDateParser, Dlg, ExamProjectType, data, Float, ArrayHelper, ExamProject) {
        var vm = $scope;
        vm.total_fee = 0;
        vm.total_number = 0;
        vm.total_project = 0;

        vm.filter = angular.copy(data.filter);

        var SELECT_TYPE = 1;
        var SELECT_NAME = 3;

        vm.selectTypes = [
            {id: SELECT_TYPE, name: '类型', exAll: false, fresh: true},
            {id: SELECT_NAME, name: '名称', fresh: true}
        ];

        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的商品
        vm.loading = false;

        vm.selectProject = selectProject;
        vm.filterChange = filterProject;
        vm.clearFilter = clearFilter;
        vm.toggleNode = toggleNode;
        vm.selectTypeMembers = selectTypeMembers;

        vm.typeSelectedFn = typeSelectedFn;
        vm.removeSelected = removeSelected;

        vm.queryProject = queryProject;
        vm.clearQuery = clearQuery;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '项目选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            } else {
                if (data.multiSelect) {
                    angular.forEach(data.model, function (m) {
                        vm.selected.push(m);
                        vm.total_fee += m.fee;
                        vm.total_number += 1;
                    });
                    vm.total_fee = Float.toFixed(vm.total_fee, 1);
                }
            }
            typeSelectedFn(SELECT_TYPE);
        }

        function filterProjectHide(p, filter) {
            p.hide = false;
        }

        function filterTypeProject() {
            angular.forEach(vm.types, function (type) {
                angular.forEach(type.projects, function (p) {
                    filterProjectHide(p, vm.filter);
                });
            });
        }

        function filterQueryOrder() {
            angular.forEach(vm.projects, function (p) {
                filterProjectHide(p, vm.filter);
            });
        }


        function selectTypeMembers(type, $event) {
            $event.stopPropagation();
            ExamProject.query({op: 'node_type', type_id: type.id}, function (resp) {
                if (resp.items && resp.items.length > 0) {
                    selectProjects(resp.items);
                }
            });
        }

        function filterProject(type) {
            switch (type) {
                case SELECT_TYPE:
                    filterTypeProject();
                    break;
                case SELECT_NAME:
                    filterQueryOrder();
                    break;
            }
        }

        function clearFilter(type) {
            vm.filter = {};
            filterProject(type);
        }

        function toggleNode(node, t, cb) {
            if (node.is_type) {
                //点击类型事件
                //没有加载则第一次加载项目
                if (node.children.length == 0) {
                    node.loading = true;
                    ExamProjectType.get({id: node.id, op: 'with_sub_node_and_project'}).$promise.then(function (resp) {
                        node.loading = false;
                        var types = ArrayHelper.map(resp.nodes, loadTypes);
                        var projects = ArrayHelper.map(resp.projects, loadProjects);
                        node.children = types.concat(projects);
                    }).finally(function () {
                        //触发收缩事件
                        cb(t);
                    });
                } else {
                    //触发收缩事件
                    cb(t);
                }
            } else {
                //点击项目事件
                selectProject(node);
            }
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case SELECT_TYPE:
                    if (toType.fresh) {
                        initProjectSelector();
                        toType.fresh = false;
                    } else {
                        filterTypeProject();
                    }
                    break;
                case SELECT_NAME:
                    filterQueryOrder();
                    break;
            }
            vm.curType = toType;
        }

        function selectProjects(members) {
            angular.forEach(members, function (m) {
                if (!m.hide) selectProject(m);
            });
        }

        function selectProject(p) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(p.id, vm.selected);
                if (index == -1) {
                    vm.selected.push(p);
                    vm.total_number++;
                    vm.total_project += p.project_count;
                    vm.total_fee += p.fee;
                    vm.total_fee = Float.toFixed(vm.total_fee, 1);
                }
            } else {
                vm.total_number = 1;
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, p);
                } else {
                    vm.selected.push(p);
                }
                vm.total_project = p.project_count;
                vm.total_fee = p.fee;
            }
        }

        function loadProject(p) {
            p.fee = parseFloat(p.fee);
            p.fasting = ArrayHelper.getItem(p.fasting, ExamProject.getFastingRequires());
            filterProjectHide(p, vm.filter);
        }

        function initProjectSelector() {
            vm.loading = true;
            ExamProjectType.query({op: 'root_node'}, function (resp) {
                vm.loading = false;
                vm.types = ArrayHelper.map(resp.nodes, loadTypes);
            });
        }

        function loadTypes(type) {
            type.is_type = true;
            type.children = [];
            return type;
        }

        function loadProjects(p) {
            p.is_type = false;
            p.fee = parseFloat(p.fee);
            p.fasting = ArrayHelper.getItem(p.fasting, ExamProject.getFastingRequires());
            filterProjectHide(p, vm.filter);
            return p;
        }

        function removeSelected($index, p) {
            vm.total_fee -= p.fee;
            vm.total_fee = Float.toFixed(vm.total_fee, 1);
            vm.total_number -= 1;
            vm.selected.splice($index, 1);
        }

        function queryProject(qStr) {
            if (qStr) {
                vm.loading = true;
                ExamProject.query({op: 'selector', name: qStr}).$promise.then(function (resp) {
                    var items = resp.items;
                    angular.forEach(items, function (p) {
                        loadProject(p);
                    });
                    vm.projects = items;
                }).finally(function () {
                    vm.loading = false;
                    vm.queryStr = qStr;
                });
            } else {
                clearQuery();
                Dlg.w('请输入项目名称');
            }
        }


        function clearQuery() {
            vm.projects = [];
            vm.queryStr = '';
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
);
(function () {
    'use strict';
    angular.module('c.d')
    /** @deprecated */
        .directive('formInputDate', formInputDate);

    /** @ngInject */
    function formInputDate() {
        return {
            templateUrl: 'directives/form/form-input-date/form-input-date.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'minMode': '@',
                'mode': '@',
                'format': '@',
                'showButtonBar': '=',
                'rst': '='
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.minMode)) {
                    $scope.minMode = 'day';
                }

                if (angular.isUndefined($scope.mode)) {
                    $scope.mode = 'year';
                }

                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

                if (angular.isUndefined($scope.showButtonBar)) {
                    $scope.showButtonBar = true;
                }


            }

        }
    }
})();

angular.module('c.d')
    .directive('formInputDatetime', function () {
        return {
            templateUrl: 'directives/form/form-input-datetime/form-input-datetime.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'format':'@'
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

            }

        }
    });
angular.module('c.d')
    .directive('formInputFloat', function () {
        return {
            templateUrl: 'directives/form/form-input-float/form-input-float.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'decimal': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'labelTip': '@',
                'tip': '@',
                'change': '='
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }
            }
        }
    });
angular.module('c.d')
    .directive('formInputNumber', function () {
        return {
            templateUrl: 'directives/form/form-input-number/form-input-number.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@',
                'labelCol': '@',
                'formCol': '@',
                'rst': '='
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }

                if ($scope.labelCol == undefined || $scope.labelCol == null) {
                    $scope.labelCol = "col-md-4 control-label";
                }

                if ($scope.formCol == undefined || $scope.formCol == null) {
                    $scope.formCol = "col-md-6";
                }
            }
        }
    });
angular.module('c.d')
    .directive('formInputText', function () {
        return {
            templateUrl: 'directives/form/form-input-text/form-input-text.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'maxLen': '@',
                'minLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@',
                'rst': '='
            }

        };
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('hisDeptSelector', hisDeptSelector)
        .controller('HisDeptSelectCtrl', HisDeptSelectCtrl);

    /** @ngInject */
    function hisDeptSelector(Dlg) {
        return {
            templateUrl: 'directives/form/his-dept-selector/his-dept-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                onSelect: '&',
                multiSelect: '=?',
                placeHolder: '@',
                updateMod: '=?', // 是否修改模式，否则是追加模式
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectDeptFn = selectDeptFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    vm.updateMod = angular.isDefined(iAttrs.updateMod);

                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.updateMod)) vm.updateMod = false;
                    if (angular.isUndefined(vm.multiSelect)) vm.multiSelect = false;
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择HIS科室';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectDeptFn(multiSelect) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/his-dept-selector/his-dept_selector_dlg.html',
                        ctrl: 'HisDeptSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            updateMod: vm.updateMod
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (vm.updateMod) {
                                    vm.model = params;
                                } else {
                                    angular.forEach(params, function (dept) {
                                        vm.model.push(dept);
                                    });
                                }
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedDept: vm.model});
                        }
                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function HisDeptSelectCtrl($scope, $uibModalInstance, F, DHHisBKDept, data, DeptWard, ArrayHelper) {
        var vm = $scope;
        var updateMod;
        vm.selectTypes = [
            {id: 1, name: '按类型选择', exAll: false, fresh: true},
            {id: 3, name: '按名称选择', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.loading = false;

        vm.typeSelectedFn = typeSelectedFn;
        vm.selectTypeDepts = selectTypeDepts;
        vm.selectDepts = selectDepts;
        vm.removeSelected = removeSelected;
        vm.clearQuery = clearQuery;
        vm.queryDept = queryDept;
        vm.selectDept = selectDept;
        vm.toggleWardNode = toggleWardNode;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = 'HIS科室选择(可多选)';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.updateMod)) {
                updateMod = false;
            } else {
                updateMod = data.updateMod;
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) data.model = [];
            }
            if (vm.multiSelect && updateMod) {
                vm.selected = angular.copy(data.model);
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        //
        function selectDept(dept) {
            if (vm.multiSelect) {
                var index = F.indexOfKey(dept.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(dept);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, dept);
                } else {
                    vm.selected.push(dept);
                }
            }
        }


        function initDeptSelector() {
            vm.loading = true;
            DHHisBKDept.query({op: 'selector'}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }

        function selectTypeDepts(type) {
            vm.selectDepts(type.depts);
        }

        function selectDepts(depts) {
            angular.forEach(depts, function (d) {
                if (!d.hide) {
                    selectDept(d);
                }
            });
        }

        function toggleWardNode(ward, toggle, node) {
            if (ward.depts) {
                toggle(node);
            } else {
                DeptWard.query({op: 'options', ward_id: ward.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        ward.depts = resp.items;
                        toggle(node);
                    }
                });
            }
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function clearQuery() {
            vm.depts = [];
            vm.filterName = '';
        }

        function queryDept(name) {
            if (name != null && name.length > 0) {
                vm.filterName = name;
                vm.loading = true;
                DHHisBKDept.query({op: 'query', name: name}, function (resp) {
                    var depts = resp.depts;
                    angular.forEach(depts, function (dept) {
                        dept.selector_type = ArrayHelper.getItem(dept.selector_type, [
                            {id: 1, name: '门急诊科室'},
                            {id: 2, name: '住院科室'},
                            {id: 3, name: '医技医辅'},
                            {id: 4, name: '护理单元'},
                        ]);
                    });
                    console.log(depts);
                    vm.depts = depts;
                }).$promise.then(function () {

                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                // toaster.warning('请输入科室名称');
                clearQuery();
            }
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('inpatientSelector', inpatientSelector)
        .controller('InpatientSelectCtrl', InpatientSelectCtrl);

    /** @ngInject */
    function inpatientSelector(ArrayHelper, Dlg) {
        return {
            templateUrl: 'directives/form/inpatient-selector/inpatient-selector.html',
            restrict: 'E',
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                min: "=?",
                max: '=?',
                maxLimit: '@', // 限制只能选择max人，多的自动截取
                onSelect: '&',
                existMembers: '=?',
                placeHolder: '@',
                disabled: '=?',
                // showMeetingAbsentUser: '=?',
                // meetingId: '=?',
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;
                vm.removeAll = removeAll;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) vm.model = [];
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择成员';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    // if (angular.isUndefined(vm.showMeetingAbsentUser)) {
                    //     vm.showMeetingAbsentUser = false;
                    // }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        var min = vm.min > 0 ? vm.min : 0;
                        var max = angular.isDefined(vm.max) ? vm.max : 9999;
                        var minValid, maxValid;
                        if (iAttrs.required) {
                            if (ngModelCtrl.$viewValue) {
                                minValid = ngModelCtrl.$viewValue.length >= min;
                                maxValid = ngModelCtrl.$viewValue.length <= max;
                            } else {
                                minValid = maxValid = true;
                            }
                            valid = ngModelCtrl.$viewValue.length > 0;
                        } else {
                            valid = true;
                        }
                        if (min > 0) ngModelCtrl.$setValidity('min', minValid);
                        if (angular.isDefined(vm.max)) ngModelCtrl.$setValidity('max', maxValid);
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect, existMembers) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/inpatient-selector/inpatient_selector_dlg.html',
                        ctrl: 'InpatientSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existMembers: existMembers,
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (angular.isDefined(vm.maxLimit) && vm.max > 0 && params.length > vm.max) {
                                    vm.model = params.splice(0, vm.max);
                                    scope.$emit('inpatientSelector.maxLimit', {id: iAttrs.id, max: vm.max});
                                } else vm.model = angular.copy(params);
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }

                function removeAll($event) {
                    $event.stopPropagation();
                    vm.model = ArrayHelper.filter(vm.model, function (item) {
                        return item._fixed;
                    });
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function InpatientSelectCtrl($scope, $uibModalInstance, $localStorage, ArrayHelper, Api, DeptType, Dept, User,
                                 $http, data) {
        var vm = $scope;
        vm.query = {};

        vm.selectTypes = [
            {id: 1, name: '病房', exAll: false, fresh: true},
            {id: 3, name: '姓名/身份证', fresh: true},
            // {id: 4, name: '科管组', fresh: true},
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};

        vm.clearQuery = clearQuery;
        vm.queryUser = queryUser;
        vm.typeSelectedFn = typeSelectedFn;
        vm.pageChanged = pageChanged;

        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.toggleDeptNode = toggleDeptNode;

        vm.selectDeptMembers = selectDeptMembers;
        vm.selectUsers = selectUsers;
        vm.selectUser = selectUser;
        vm.removeSelected = removeSelected;
        vm.removeAll = removeAll;
        vm.deptVisible = deptVisible;

        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;


        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '住院患者选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }

            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];

            // if (angular.isUndefined(data.showMeetingAbsentUser)) {
            //     vm.showMeetingAbsentUser = false;
            // } else {
            //     vm.showMeetingAbsentUser = data.showMeetingAbsentUser;
            // }

            // if (data.showMeetingAbsentUser) {
            //     vm.selectTypes.splice(0, 0, {id: 6, name: '会议缺席住院患者', fresh: true});
            // }
            var initIdx = $localStorage.userSelectTypeIdx;
            vm.curTypeId = initIdx ? initIdx : 0;
            vm.typeSelectedFn(vm.curTypeId);
        }

        function typeSelectedFn($index) {
            $localStorage.userSelectTypeIdx = $index;
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    opt: 3,
                    page: vm.pager.page,
                    count: vm.pager.count,
                    inHospital: true
                });
                urlParams.Str = qStr;
                vm.loading = true;
                $http.get('/api/v1/heath_manage/fd_patients/', {params: urlParams}).then(function (resp) {
                    vm.users = resp.data.items;
                    vm.pager.total = resp.data.total;
                    tagHideIfInExistMembers(vm.users);
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.query.str);
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(user.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(user);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: '4', type_id: 5 /*护理单元*/}, function (resp) {
                vm.depts = resp.depts;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function initNameSelector() {

        }


        function tagDeptLeaderAndHide(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
            tagHideIfInExistMembers(dept.members);
        }

        function toggleDeptTypeNode(type, toggle, node) {
            if (type.depts) {
                toggle(node);
            } else {
                DeptType.getDepts(type.id).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        type.depts = items;
                        toggle(node);
                    }
                });
            }
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                $http.get('/api/v1/heath_manage/fd_patients/', {
                    params: {
                        opt: 3,
                        WardId: dept.id,
                        inHospital: true
                    }
                }).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        dept.members = items;
                        toggle(node);
                    }
                });
            }
        }


        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                $http.get('/api/v1/heath_manage/fd_patients/', {
                    params: {
                        opt: 3,
                        WardId: dept.id,
                        inHospital: true
                    }
                }).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        dept.members = items;
                        tagDeptLeaderAndHide(dept);
                        vm.selectUsers(dept.members);
                    }
                });

            }
        }


        function selectUsers(members) {
            angular.forEach(members, function (m) {
                if (!m.hide) selectUser(m);
            });
        }

        function tagHideIfInExistMembers(members) {
            if (data.existMembers && data.existMembers.length > 0) {
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1) {
                        m.hide = true;
                    }
                });
            }
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }

})();

angular.module('c.d').
    directive('inputFloat', function ($filter) {
        var FLOAT_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/; //Numbers like: 1.123,56
        var FLOAT_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/; //Numbers like: 1,123.56
        var FLOAT_REGEXP_3 = /^\$?\d+(\.\d*)?$/; //Numbers like: 1123.56
        var FLOAT_REGEXP_4 = /^\$?\d+(\,\d*)?$/; //Numbers like: 1123,56

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }
                var decimal_digit = scope.$eval(attrs.inputFloat);
                var positive = scope.$eval(attrs.positive);

                ngModelCtrl.$parsers.push(function (val) {
                    if (angular.isUndefined(val)) {
                        var val = '';
                    }
                    var minus = val[0] == '-';
                    var clean = val.replace(/[^0-9\.]/g, '');
                    var decimalCheck = clean.split('.');

                    if (!angular.isUndefined(decimalCheck[1])) {
                        decimalCheck[1] = decimalCheck[1].slice(0, decimal_digit);
                        clean = decimalCheck[0] + '.' + decimalCheck[1];
                    }

                    if (minus&&!positive)
                        clean = '-' + clean;

                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        }
    });
angular.module('c.d').
    directive('inputNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var minus = text[0] == '-';
                    var allow_minus = scope.$eval(attr.inputNumber);
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if (minus && allow_minus)
                        transformedInput = '-' + transformedInput;
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;  // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });
// function inputTableItemPaste(e) {
//     var scope = angular.element(e.srcElement).scope();
//     scope.itemsPaste(e, scope.$parent.$index, scope.$index);
//     e.preventDefault = true;
//     return false;
// }

(function () {
    'use strict';

    angular.module('c.d')
        .directive('inputTable', inputTable);

    function inputTable() {
        return {
            templateUrl: 'directives/form/inputTable/inputTable.html',
            // replace: true,
            restrict: 'EA',
            scope: {
                cols: '=',
                rows: '=',
                $data: '=ngModel',
                changed: '&',
                params: '='
            },
            require: ['^ngModel', '?^form'],
            link: link
        }
    }


    function link(scope, iElement, iAttrs, r) {
        var ngModelCtrl = r[0], formCtrl = r[1];
        var vm = scope;
        var rowCnt = vm.rows;
        var colCnt = vm.cols.length;
        vm.rowCnt = new Array(rowCnt);

        init();


        function init() {
            if (angular.isUndefined(vm.$data)) {
                vm.$data = {};
            } else {
                for (var key in vm.$data) {
                    if (isNaN(parseInt(key))) {
                        delete vm.$data[key];
                    }
                }
            }

            if (formCtrl) {
                scope.$watch(function () {
                    return formCtrl.$submitted;
                }, function (submitted) {
                    if (submitted) {
                        checkValidity(vm.$data);
                        iElement.addClass('submitted')
                    }
                });
            }
        }

        function checkValidity($data) {
            var valid = true;
            if (!!iAttrs.required) {
                for (var i = 0; i < rowCnt; i++) {
                    if ($data[i]) {
                        for (var j = 0; j < colCnt; j++) {
                            if ($data[i][j] === "") {
                                delete $data[i][j];
                            }
                        }
                        if (angular.equals($data[i], {})) {
                            delete $data[i];
                        }
                    }
                }
                vm.$invalidItems = {};
                if (angular.equals($data, {})) {
                    valid = false;
                } else {
                    for (var i = 0; i < rowCnt; i++) {
                        if ($data[i] && Object.keys($data[i]).length < colCnt) { // 此行有数据
                            valid = false;
                            for (var j = 0; j < colCnt; j++) {
                                if (!$data[i][j]) {
                                    if (!vm.$invalidItems[i]) vm.$invalidItems[i] = {};
                                    vm.$invalidItems[i][j] = true;
                                }
                            }
                        }
                    }
                }
            }
            ngModelCtrl.$setValidity('required', valid);
        }


        scope.$watch('$data', function ($data) {
            checkValidity($data);
            ngModelCtrl.$setTouched();
            if (vm.changed) {
                vm.changed({params: vm.params});
            }

        }, true);

    }

})();
(function () {
    'use strict';

    angular.module('c')
        .controller('journalDlgCtrl', journalDlgCtrl);

    /** @ngInject */
    function journalDlgCtrl($uibModalInstance, Dlg, FormHelper, $http, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.journal);


        function init(journal) {
            vm.m = angular.copy(journal);
            if (journal.id) {
                if (journal.issn) {
                    issnSplit = journal.issn.split('-');
                    journal.issnStart = issnSplit[0];
                    journal.issnEnd = issnSplit[1];
                }
                if (journal.eissn) {
                    eissnSplit = journal.eissn.split('-');
                    journal.eissnStart = eissnSplit[0];
                    journal.eissnEnd = eissnSplit[1];
                }
                if (journal.cn) {
                    cnSplit = journal.cn.split('/');
                    journal.cnArea = cnSplit[1];
                    cnSplit = cnSplit[0].split('-');
                    journal.cnStart = cnSplit[0];
                    journal.cnEnd = cnSplit[1];
                }
            }
            $http.get('/api/v1/fruit/journal_types', { params: { op: 'option' } }).then(function (resp) {
                vm.types = resp.data.items;
            });
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    name_abbr: m.name_abbr,
                    type_id: m.type.id,
                    issn: m.issnStart ? m.issnStart + '-' + m.issnEnd : null,
                    eissn: m.eissnStart ? m.eissnStart + '-' + m.eissnEnd : null,
                    cn: m.cnStart ? m.cnStart + '-' + m.cnEnd + '/' + m.cnArea : null,
                };
                var promise;
                if (m.id) {

                } else {
                    promise = $http.post('/api/v1/fruit/journals', pa);
                }
                promise.then(function (resp) {
                    vm.close(resp.data.item);
                }, function (err) {
                    if (err.data && err.data.msg) {
                        Dlg.e(err.data.msg);
                    }
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('journalSelector', journalSelector);

    /** @ngInject */
    function journalSelector($http, $compile, ArrayHelper, Dlg) {
        return {
            // templateUrl: 'directives/form/journal-selector/journalSelector.html',
            restrict: 'E',
            // replace: true,
            scope: {
                onSelect: '&',
                model: '=ngModel'
                // allowCreate
                // multiple
            },
            require: ['^ngModel', '?^form'],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var API_BASE = '/api/v1/fruit/journals';
                        var ngModelCtrl = r[0], formCtrl = r[1];
                        var isMultiple = false;
                        var allowCreate = angular.isDefined(iAttrs.allowCreate);
                        var vm = scope;
                        vm.pager = { total: 0, page: 1, count: 10 };
                        vm.refreshJournals = refreshJournals;
                        vm.queryJournals = queryJournals;
                        vm.createNewJournal = createNewJournal;
                        vm.touch = touch;
                        vm.onSelectItem = onSelectItem;
                        vm.onRemoveItem = onRemoveItem;

                        init();


                        function init() {
                            isMultiple = angular.isDefined(iAttrs.multiple);
                            var elem = '<div class="journal-selector" ng-click="touch()">' +
                                '<ui-select ng-model="model"' + (isMultiple ? ' multiple close-on-select="false" on-remove="onRemoveItem($item)" ' : ' ') +
                                'title="请输入期刊名称/ISSN号/E-ISSN号/CN号查询期刊后，在期刊列表中选择期刊" ' +
                                'on-select="onSelectItem($item)" spinner-enabled="true">' +
                                ' <ui-select-match placeholder="请输入期刊名称/ISSN号/E-ISSN号/CN号查询期刊后，在期刊列表中选择期刊">' +
                                (isMultiple ? '<span title={{$item.name}}>{{$item.name}}</span>'
                                    : '<span title={{$select.selected.name}}>{{$select.selected.name}}</span>') +
                                '</ui-select-match>' +
                                '<ui-select-choices repeat="journal in journals" ui-disable-choice="journal.isPager||journal.isNew" ' +
                                'refresh="refreshJournals($select)" refresh-delay="500" position="down">' +
                                '<div class="journal-selector__item">' +
                                '<div class="journal-pager" ng-if="journal.isPager" title="">' +
                                '<uib-pagination total-items="pager.total" ng-model="pager.page" items-per-page="pager.count" ' +
                                'rotate="true" class="pagination-sm" ng-change="queryJournals($select.search)" max-size="5"' +
                                'previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;">' +
                                '</uib-pagination></div>' +
                                '<div class="journal-new" ng-elif="journal.isNew" ng-click="createNewJournal($select.search, $select)" title="">' +
                                '创建新期刊：<strong>{{$select.search}}</strong></div>' +
                                '<div ng-else title={{journal.name}}>' +
                                '<div class="journal-name" ng-bind-html="journal.name | highlight: $select.search"></div>' +
                                '<div class="journal-info">' +
                                '<div><span ng-if="journal.name_abbr" ng-bind-html="journal.name_abbr | highlight: $select.search"></span>' +
                                '<span ng-else>--</span> / <span ng-if="journal.level">{{journal.level}}级</span><span ng-else>--</span></div>' +
                                '<div>Factor： <span ng-if="journal.impact_factor">{{journal.impact_factor }}</span><span ng-else>--</span></div>' +
                                '</div>' +
                                '<div class="journal-number"><div>ISSN： <span ng-if="journal.issn" ng-bind-html="journal.issn | highlight: $select.search"></span>' +
                                '<span ng-else>--</span></div>' +
                                '<div>E-ISSN：<span ng-if="journal.eissn" ng-bind-html="journal.eissn | highlight: $select.search"></span>' +
                                '<span ng-else>--</span></div>' +
                                '<div>CN号：<span ng-if="journal.cn" ng-bind-html="journal.cn | highlight: $select.search"></span>' +
                                '<span ng-else>--</span></div></div></div></div>' +
                                '</ui-select-choices>' +
                                '</ui-select>' +
                                '</div>';


                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            checkValidity();
                            if (formCtrl) {
                                scope.$watch(function () {
                                    return formCtrl.$submitted;
                                }, function (submitted) {
                                    if (submitted) {
                                        checkValidity();
                                        iElement.addClass('submitted');
                                    }
                                });
                            }
                        }

                        function touch() {
                            ngModelCtrl.$setTouched();
                        }

                        function onSelectItem(item) {
                            if (isMultiple) {
                                vm.model.push(item);
                                // ngModelCtrl.$setViewValue(vm.model);
                            } else {
                                ngModelCtrl.$setViewValue(item);
                            }
                            checkValidity();
                            if (scope.onSelect()) {
                                scope.onSelect()(model)
                            }
                        }

                        function onRemoveItem(item) {
                            if (isMultiple) {
                                var i = ArrayHelper.getItem(item.id, vm.model);
                                vm.model.splice(i, 1);
                                // ngModelCtrl.$setViewValue(vm.model);
                                if (ngModelCtrl.$viewValue.length === 0) checkValidity();
                            }
                        }

                        function createNewJournal(searchStr, $select) {
                            Dlg.show({
                                template: 'directives/form/journal-selector/journalDlg.html',
                                ctrl: 'journalDlgCtrl',
                                data: { journal: { name: searchStr } }
                            }).then(function (newJournal) {
                                $select.selected = newJournal;
                                ngModelCtrl.$setViewValue(newJournal);
                                checkValidity();
                                $select.close();
                            });
                        }

                        function queryJournals(searchStr) {
                            return $http.get(API_BASE, {
                                params: {
                                    op: 'option',
                                    searchStr: searchStr,
                                    page: vm.pager.page,
                                    count: vm.pager.count
                                }
                            }).then(function (resp) {
                                vm.pager.total = resp.data.total;
                                var journals = resp.data.items;
                                if (hasNewItem(journals, searchStr)) {
                                    journals.splice(0, 0, { isNew: true });
                                }
                                if (vm.pager.total > vm.pager.count) {
                                    journals.push({ isPager: true });
                                }
                                vm.journals = journals;
                            })
                        }

                        function hasNewItem(journals, searchStr) {
                            var hasNew = true;
                            if (!allowCreate || !searchStr) hasNew = false;
                            else if (journals.length > 0) {
                                for (var i = 0; i < journals.length; i++) {
                                    var journal = journals[i];
                                    if (journal.name == searchStr || journal.issn == searchStr ||
                                        journal.eissn == searchStr || journal.cn == searchStr) {
                                        hasNew = false;
                                        break;
                                    }
                                }
                            }
                            return hasNew;
                        }

                        function refreshJournals($select) {
                            $select.refreshing = true;
                            vm.pager.page = 1;
                            return queryJournals($select.search).finally(function () {
                                $select.refreshing = false;
                            });
                        }

                        function checkValidity() {
                            var valid;
                            if (isMultiple) {
                                valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                            } else {
                                valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                            }
                            ngModelCtrl.$setValidity('required', valid);
                        }

                    }
                }
            },
        }
    }
})();

angular.module('c.d')
    .directive('orderSelector', function () {
        return {
            templateUrl: 'directives/form/order-selector/order-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'multiSelect': '=?',
                'isSpot': '=?',
                'placeHolder': '@',
                'disabled': '=?',
                /**
                 * filter = {hide: true|false, is_delivery: true|false, is_wm: true|false, type: '0'|'1'|'2'|'3'}
                 */
                'filter': '=?'
            },
            controller: function ($scope, dialogs, F) {
                if (angular.isUndefined($scope.multiSelect)) {
                    $scope.multiSelect = false;
                }
                if (angular.isUndefined($scope.isSpot)) {
                    $scope.isSpot = false;
                }
                if (angular.isUndefined($scope.model)) {
                    if ($scope.multiSelect) {
                        $scope.model = [];
                    }
                }
                if (angular.isUndefined($scope.placeHolder)) {
                    $scope.placeHolder = '选择商品';
                }
                if (angular.isUndefined($scope.disabled)) {
                    $scope.disabled = false;
                }
                if (angular.isUndefined($scope.filter)) {
                    $scope.filter = {};
                }

                $scope.selectOrderFn = function (multiSelect) {
                    $scope.activeMatchIndex = -1;
                    dialogs.create('directives/form/order-selector/order_selector_dlg.html', 'OrderSelectorDlgCtrl',
                        {
                            multiSelect: multiSelect,
                            isSpot: $scope.isSpot,
                            model: $scope.model,
                            filter: $scope.filter
                        }, {

                            size: 'lg'
                        }).result.then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                $scope.model = params[0];
                            } else {
                                $scope.model = [];
                                angular.forEach(params, function (m) {
                                    $scope.model.push(m);
                                });
                                angular.forEach($scope.model, function (m) {
                                    m.total_paid = F.toFixed(parseFloat(m.paid) * parseFloat(m.count), 1);
                                })
                            }
                        } else {
                            if (!multiSelect) {
                                $scope.model = null;
                            } else {
                                $scope.model = [];
                            }
                        }
                    });
                };

                $scope.selectTag = function ($event, $index) {
                    $event.stopPropagation();
                    $scope.activeMatchIndex = $index;
                };

                $scope.removeChoice = function ($event, $index) {
                    $scope.activeMatchIndex = -1;
                    $event.stopPropagation();
                    $scope.model.splice($index, 1);
                };
            }
        }
    });

angular.module('c.c').controller('OrderSelectorDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, uibDateParser, F,
              Store, Order, data) {
        var vm = $scope;
        var orderTypes = F.get('orderTypes');
        vm.changeCount = changeCount;
        vm.total_paid = 0;
        vm.total_number = 0;

        vm.filter = angular.copy(data.filter);

        vm.selectTypes = [
            {id: 3, name: '按名称选择', fresh: true},
            {id: 1, name: '按店铺选择', exAll: false, fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的商品
        vm.loading = false;

        vm.selectOrder = selectOrder;
        vm.setTimeFilter = setTimeFilter;
        vm.filterChange = filterOrder;
        vm.clearFilter = clearFilter;

        vm.typeSelectedFn = typeSelectedFn;
        vm.removeSelected = removeSelected;

        vm.queryOrder = queryOrder;
        vm.clearQuery = clearQuery;

        vm.addCount = addCount;
        vm.reduceCount = reduceCount;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '商品选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            } else {
                if (data.multiSelect) {
                    angular.forEach(data.model, function (m) {
                        vm.selected.push(m);
                        vm.total_paid += m.total_paid;
                        vm.total_number += m.count;
                    });
                    vm.total_paid = F.toFixed(vm.total_paid, 1);
                }
            }
            if (angular.isUndefined(data.isSpot)) {
                vm.isSpot = false;
            } else {
                vm.isSpot = data.isSpot;
            }
            if (angular.isUndefined(vm.filter.is_delivery))
                vm.filter.is_delivery = false;
            if (angular.isUndefined(vm.filter.is_wm))
                vm.filter.is_wm = false;
            if (angular.isUndefined(vm.filter.type))
                vm.filter.type = '0';
            typeSelectedFn(0);
        }

        function filterOrderHide(order, filter) {
            order.hide = (filter.is_delivery && order.is_delivery == '0') ||
                (filter.is_wm && order.is_working_meal_allowed == '0') ||
                (filter.type != '0' && order.type.id != filter.type) ||
                (
                    filter.time &&
                    ((order.limit_mode == '1' && filter.time > order.start && filter.time < order.end) ||
                        (order.limit_mode == '2' && (filter.time < order.start || filter.time > order.end)))
                );
        }

        function setTimeFilter(time) {
            if (angular.isUndefined(time)) {
                time = new Date();
            }
            time.setYear(1900);
            time.setMonth(0);
            time.setDate(1);
            vm.filter.time = time;
            filterOrder(vm.curType.id);
        }

        function filterTypeOrder() {
            angular.forEach(vm.types, function (type) {
                angular.forEach(type.orders, function (order) {
                    filterOrderHide(order, vm.filter);
                });
            });
        }

        function filterQueryOrder() {
            angular.forEach(vm.orders, function (order) {
                filterOrderHide(order, vm.filter);
            });
        }

        function filterOrder(type) {
            switch (type) {
                case 1:
                    filterTypeOrder();
                    break;
                case 3:
                    filterQueryOrder();
                    break;
            }
        }

        function clearFilter(type) {
            vm.filter = {is_delivery: false, type: '0', is_wm: false};
            filterOrder(type);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initStoreSelector();
                        toType.fresh = false;
                    } else {
                        filterTypeOrder();
                    }
                    break;
                case 3:
                    if (toType.fresh) {
                        queryOrder();
                        toType.fresh = false;
                    } else {
                        filterQueryOrder();
                    }
                    break;
            }
            vm.curType = toType;
        }

        function selectOrder(order) {
            if (order.type.id != '4' && parseInt(order.residue_supply) == 0 && vm.filter.is_delivery == false) {
                toaster.warning('商品剩余量不足');
                return;
            }
            if (vm.multiSelect) {
                var index = F.indexOfKey(order.id, vm.selected);
                if (index == -1) {
                    order.count = 1;
                    vm.selected.push(order);
                    vm.total_number++;
                    vm.total_paid += order.paid;
                    vm.total_paid = F.toFixed(vm.total_paid, 1);
                }
            } else {
                vm.total_number = 1;
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, order);
                } else {
                    vm.selected.push(order);
                }
                vm.total_paid = order.paid;
            }
        }

        function loadOrder(order) {
            order.self_paid = parseFloat(order.self_paid);
            order.subsidy = parseFloat(order.subsidy);
            order.paid = F.toFixed(order.self_paid + order.subsidy, 1);
            order.start = uibDateParser.parse(order.start, 'HH:mm');
            order.end = uibDateParser.parse(order.end, 'HH:mm');
            order.type = F.getItem(order.type, orderTypes);
            filterOrderHide(order, vm.filter);
        }

        function initStoreSelector() {
            vm.loading = true;
            Store.query({
                opt: 3 /*STORE.INDEX_ALL_IN_TYPE*/,
                has_price: vm.multiSelect ? 1 : 0 /*如果是多选，则必须都是定价商品*/, is_spot: vm.isSpot ? 1 : 0
            }, function (resp) {
                vm.loading = false;
                vm.types = resp.stores;
                angular.forEach(vm.types, function (type) {
                    angular.forEach(type.orders, function (order) {
                        loadOrder(order);
                    });
                });
            });
        }

        function removeSelected($index, order) {
            vm.total_paid -= order.paid * order.count;
            vm.total_paid = F.toFixed(vm.total_paid, 1);
            vm.total_number -= order.count;
            vm.selected.splice($index, 1);
        }

        // function queryOrder(name) {
        //     if (name != null && name.length > 0) {
        //         Order.query({opt: 4, name: name, is_spot: vm.isSpot ? 1 : 0}, function (resp) {
        //             var orders = resp.orders;
        //             angular.forEach(orders, function (order) {
        //                 loadOrder(order);
        //             });
        //             vm.orders = orders;
        //         });
        //     } else {
        //         toaster.warning('请输入商品名称');
        //     }
        // }

        function queryOrder(name) {
            vm.filterName = name;
            vm.loading = true;
            Order.query({
                opt: 4,
                name: name,
                is_spot: vm.isSpot ? 1 : 0,
            }).$promise.then(function (resp) {
                var orders = resp.orders;
                angular.forEach(orders, function (order) {
                    loadOrder(order);
                });
                vm.orders = orders;
            }).finally(function () {
                vm.loading = false;
            });
        }

        function clearQuery() {
            vm.filterName = '';
            queryOrder();
        }

        function addCount(order) {
            order.count++;
            vm.total_paid += order.paid;
            vm.total_paid = F.toFixed(vm.total_paid, 1);
            vm.total_number++;
        }

        function reduceCount(order) {
            if (order.count > 1) {
                order.count--;
                vm.total_paid -= order.paid;
                vm.total_paid = F.toFixed(vm.total_paid, 1);
                vm.total_number--;
            }
        }

        function changeCount(order, newCnt, oldCnt) {
            if (!newCnt || +newCnt == 0) {
                order.count = newCnt = '1'; //注意count这里是字符串
            }
            if (newCnt != oldCnt) {
                var diff = (+newCnt) - (+oldCnt);
                vm.total_number += diff;
                vm.total_paid += F.toFixed(diff * order.paid, 1);
                vm.total_paid = F.toFixed(vm.total_paid, 1);
            }
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
);
(function () {
    'use strict';

    angular.module('c')
        .directive('patientSelector', patientSelector)
        .controller('PatientSelectCtrl', PatientSelectCtrl)
    ;

    /** @ngInject */
    function patientSelector(Dlg) {
        return {
            templateUrl: 'directives/form/patient-selector/patient-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&',
                model: '=ngModel',
                multiSelect: '=?',
                manage: '=?',
                existMembers: '=?',
                placeHolder: '@',
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectPatientFn = selectPatientFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();

                function init() {
                    if (angular.isUndefined(vm.multiSelect)) {
                        vm.multiSelect = false;
                    }
                    if (angular.isUndefined(vm.manage)) {
                        vm.manage = false;
                    }
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择患者';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectPatientFn(multiSelect, existMembers, manage) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/patient-selector/patient_selector_dlg.html',
                        ctrl: 'PatientSelectCtrl',
                        data: {
                            multiSelect: multiSelect, model: vm.model,
                            existMembers: existMembers, manage: manage
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                angular.forEach(params, function (m) {
                                    vm.model.push(m);
                                });
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (scope.onSelect()) {
                            scope.onSelect()(vm.model)
                        }
                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                }
            }
        }
    }

    /** @ngInject */
    function PatientSelectCtrl($scope, $uibModalInstance, F, Api,
                               $http, data) {
        var vm = $scope;
        vm.selectTypes = [
            {id: 1, name: '姓名 / 电话 / 身份证', fresh: true}
        ];
        vm.pager = {total: 0, page: 1, count: 5};
        vm.curType = vm.selectTypes[0];
        vm.clearQuery = clearQuery;
        vm.queryPatient = queryPatient;
        vm.selectUser = selectUser;
        vm.pageChanged = pageChanged;
        vm.removeSelected = removeSelected;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init();

        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '患者选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.manage)) {
                vm.manage = false;
            } else {
                vm.manage = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }

            vm.selected = []; //所有选中的人
        }

        function clearQuery() {
            vm.users = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function queryPatient(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 3/*INDEX_PATIENT_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count,
                    manage: data.manage
                    // exclude: data.existMembers
                });
                urlParams.Str = qStr;
                vm.loading = true;
                $http.get('/api/v1/heath_manage/fd_patients/', {params: urlParams}).then(function (resp) {
                    vm.patients = resp.data.items;
                    angular.forEach(resp.data.items, function (m) {
                        if (F.indexOfKey(m.id, data.existMembers) != -1) {
                            m.hide = true;
                        }
                    });
                    vm.pager.total = resp.data.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryPatient(vm.queryStr);
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = F.indexOfKey(user.id, vm.selected);
                if (index == -1) {
                    vm.selected.push(user);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('pmsRoomSelectCtrl', pmsRoomSelectCtrl);

    /** @ngInject */
    function pmsRoomSelectCtrl($scope, $uibModalInstance, ArrayHelper, Api, PmsRoom, PmsRoomRepair,
                               SeniorityStandard, data, PmsRoomPatrolPlan) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.selectTypes = [
            {id: 1, name: '楼栋', exAll: false, fresh: true},
            {id: 2, name: '房屋编号查询', fresh: true},
            {id: 3, name: '房屋性质', fresh: true},
            {id: 4, name: '未安排巡查计划房间', fresh: true},
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的房屋
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};

        vm.clearQuery = clearQuery;
        vm.queryRoom = queryRoom;
        vm.typeSelectedFn = typeSelectedFn;

        vm.selectRooms = selectRooms;
        vm.selectNoPatrolRooms = selectNoPatrolRooms;
        vm.selectPropertyRooms = selectPropertyRooms;
        vm.selectRoom = selectRoom;

        vm.removeSelected = removeSelected;

        vm.removeAll = removeAll;
        vm.ok = ok;
        vm.set = set;

        init();

        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '房屋选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }
            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];

            vm.typeSelectedFn(0);
        }


        function clearQuery() {
            vm.rooms = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function queryRoom(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 5,
                    page: vm.pager.page,
                    count: vm.pager.count,
                });
                urlParams.name = qStr;
                vm.loading = true;
                PmsRoom.query(urlParams).$promise.then(function (resp) {
                    vm.rooms = resp.items;
                    angular.forEach(vm.rooms, function (room) {
                        room.buildingName = room.building.name;
                    });
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }


        function typeSelectedFn($index) {
            vm.pager = {total: 0, page: 1, count: 5};
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initRoomSelector();
                        toType.fresh = false;
                    }
                    break;
                case 2:
                    break;
                case 3:
                    if (toType.fresh) {
                        initPropertyRoomSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initNoPatrolRoomSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function initRoomSelector() {
            vm.loading = true;
            PmsRoom.query({op: 'building', opt: '1'}, function (resp) {
                vm.loading = false;
                vm.types = resp.items;
                angular.forEach(resp.items, function (item) {
                    angular.forEach(item.rooms, function (room) {
                        room.buildingName = item.name;
                    });
                });
            }, function () {
                vm.loading = false;
            });
        }
        function initPropertyRoomSelector() {
            vm.loading = true;
            vm.properties = PmsRoom.getProperties();
            angular.forEach(vm.properties, function (property) {
                PmsRoom.query({op: 'building', opt: '3', property: property.id}, function (resp) {
                    vm.loading = false;
                    property.types = resp.items;
                    angular.forEach(resp.items, function (item) {
                        angular.forEach(item.rooms, function (room) {
                            room.buildingName = item.name;
                        });
                    });
                });
            });
            vm.loading = false;
        }

        function initNoPatrolRoomSelector() {
            vm.loading = true;
            vm.timeTypes = PmsRoomPatrolPlan.getTimeTypes();
            angular.forEach(vm.timeTypes, function (timeType) {
                PmsRoom.query({op: 'building', opt: '4', time_type: timeType.id}, function (resp) {
                    vm.loading = false;
                    timeType.types = resp.items;
                    angular.forEach(resp.items, function (item) {
                        angular.forEach(item.rooms, function (room) {
                            room.buildingName = item.name;
                        });
                    });
                });
            });
            vm.loading = false;
        }


        function selectRooms(building, $event) {
            $event.stopPropagation();
            angular.forEach(building.rooms, function (room) {
                selectRoom(room);
            });
        }

        function selectNoPatrolRooms(timeType, $event) {
            $event.stopPropagation();
            angular.forEach(timeType.types, function (type) {
                angular.forEach(type.rooms, function (room) {
                    selectRoom(room);
                });
            });
        }

        function selectPropertyRooms(property, $event) {
            $event.stopPropagation();
            angular.forEach(property.types, function (type) {
                angular.forEach(type.rooms, function (room) {
                    selectRoom(room);
                });
            });
        }
        function selectRoom(room) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(room.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(room);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, room);
                } else {
                    vm.selected.push(room);
                }
            }
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }

        function set(selected, result) {
            $uibModalInstance.close({selected: selected, result: result});
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('pmsRoomSelector', pmsRoomSelector)

    /** @ngInject */
    function pmsRoomSelector(Dlg) {
        return {
            templateUrl: 'directives/form/pms-room-selector/pmsRoomSelector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                placeHolder: '@',
                disabled: '=?',
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择房屋';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/pms-room-selector/pmsRoomDlg.html',
                        ctrl: 'pmsRoomSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,

                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                vm.model = params;
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('productSelector', productSelector)
        .controller('productSelectCtrl', productSelectCtrl);


    /** @ngInject */
    function productSelector() {
        return {
            templateUrl: 'directives/form/product-selector/product-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'multiSelect': '=?',
                'isSpot': '=?',
                'isClinc': '=?',
                'booking': '=?',
                'placeHolder': '@',
                'disabled': '=?',
                /**
                 * filter = {hide: true|false, type: '0'|'1'|'2'|'4'}
                 */
                'filter': '=?'
            },
            controller: function ($scope, dialogs, Float) {
                if (angular.isUndefined($scope.multiSelect)) {
                    $scope.multiSelect = false;
                }
                if (angular.isUndefined($scope.isSpot)) {
                    $scope.isSpot = false;
                }
                if (angular.isUndefined($scope.isClinc)) {
                    $scope.isClinc = false;
                }
                if (angular.isUndefined($scope.model)) {
                    if ($scope.multiSelect) {
                        $scope.model = [];
                    }
                }
                if (angular.isUndefined($scope.placeHolder)) {
                    $scope.placeHolder = '选择商品';
                }
                if (angular.isUndefined($scope.disabled)) {
                    $scope.disabled = false;
                }
                if (angular.isUndefined($scope.booking)) {
                    $scope.booking = false;
                }
                if (angular.isUndefined($scope.filter)) {
                    $scope.filter = {};
                }

                $scope.selectOrderFn = function (multiSelect) {
                    $scope.activeMatchIndex = -1;
                    dialogs.create('directives/form/product-selector/product_selector_dlg.html', 'productSelectCtrl',
                        {
                            multiSelect: multiSelect,
                            isSpot: $scope.isSpot,
                            isClinc: $scope.isClinc,
                            booking: $scope.booking,
                            model: $scope.model,
                            filter: $scope.filter
                        }, {

                            size: 'lg'
                        }).result.then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                $scope.model = params[0];
                            } else {
                                $scope.model = [];
                                angular.forEach(params, function (m) {
                                    $scope.model.push(m);
                                });
                                angular.forEach($scope.model, function (m) {
                                    m.total_paid = (parseFloat(m.price) * parseFloat(m.count));
                                })
                            }
                        } else {
                            if (!multiSelect) {
                                $scope.model = null;
                            } else {
                                $scope.model = [];
                            }
                        }
                    });
                };

                $scope.selectTag = function ($event, $index) {
                    $event.stopPropagation();
                    $scope.activeMatchIndex = $index;
                };

                $scope.removeChoice = function ($event, $index) {
                    $scope.activeMatchIndex = -1;
                    $event.stopPropagation();
                    $scope.model.splice($index, 1);
                };
            }
        }
    }

    /** @ngInject */
    function productSelectCtrl($scope, $uibModalInstance, dialogs, Float, ArrayHelper, toaster, uibDateParser, $http, data) {

        var vm = $scope;
        var supplyTypes = [
            {id: 1, name: '早'},
            {id: 2, name: '中'},
            {id: 4, name: '晚'},
            {id: 3, name: '早、中'},
            {id: 5, name: '早、晚'},
            {id: 6, name: '中、晚'},
            {id: 7, name: '全天'},
            {id: 8, name: '即时配送'},
            {id: 9, name: '早、即时配送'},
            {id: 10, name: '中、即时配送'},
            {id: 11, name: '晚、即时配送'},
            {id: 12, name: '早、中、即时配送'},
            {id: 13, name: '早、晚、即时配送'},
            {id: 14, name: '中、晚、即时配送'},
            {id: 15, name: '全天、即时配送'}
        ];
        vm.changeCount = changeCount;
        vm.total_paid = 0;
        vm.total_number = 0;

        vm.filter = angular.copy(data.filter);

        vm.selectTypes = [
            {id: 3, name: '按名称选择', fresh: true}];
        vm.filterName = '';
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的商品
        vm.loading = false;

        vm.selectOrder = selectOrder;
        vm.filterChange = filterOrder;
        vm.clearFilter = clearFilter;

        vm.typeSelectedFn = typeSelectedFn;
        vm.removeSelected = removeSelected;

        vm.queryOrder = queryOrder;
        vm.addCount = addCount;
        vm.reduceCount = reduceCount;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '商品选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            } else {
                if (data.multiSelect) {
                    angular.forEach(data.model, function (m) {
                        vm.selected.push(m);
                        vm.total_paid += m.total_paid;
                        vm.total_number += m.count;
                    });
                    vm.total_paid = Float.toFixed(vm.total_paid, 1);
                }
            }
            if (angular.isUndefined(data.isSpot)) {
                vm.isSpot = false;
            } else {
                vm.isSpot = data.isSpot;
            }
            if (angular.isUndefined(data.isClinc)) {
                vm.isClinc = false;
            } else {
                vm.isClinc = data.isClinc;
            }
            if (angular.isUndefined(data.booking)) {
                vm.booking = false;
            } else {
                vm.booking = data.booking;
            }
            if (angular.isUndefined(vm.filter.supply_type))
                vm.filter.supply_type = '1';
            typeSelectedFn(0);
        }

        function filterOrderHide(product, filter) {
            var typeFilter;
            switch (filter.supply_type) {
                case '1':
                    typeFilter = (product.supply_type.id != '1') &&
                        (product.supply_type.id != '3') &&
                        (product.supply_type.id != '5') &&
                        (product.supply_type.id != '7') &&
                        (product.supply_type.id != '9') &&
                        (product.supply_type.id != '12') &&
                        (product.supply_type.id != '13') &&
                        (product.supply_type.id != '15');
                    break;
                case '2':
                    typeFilter = (product.supply_type.id != '2') &&
                        (product.supply_type.id != '3') &&
                        (product.supply_type.id != '6') &&
                        (product.supply_type.id != '7') &&
                        (product.supply_type.id != '10') &&
                        (product.supply_type.id != '12') &&
                        (product.supply_type.id != '14') &&
                        (product.supply_type.id != '15');
                    break;
                case '3':
                    typeFilter = (product.supply_type.id != '4') &&
                        (product.supply_type.id != '5') &&
                        (product.supply_type.id != '6') &&
                        (product.supply_type.id != '7') &&
                        (product.supply_type.id != '11') &&
                        (product.supply_type.id != '13') &&
                        (product.supply_type.id != '14') &&
                        (product.supply_type.id != '15');
                    break;
                case '4':
                    typeFilter = (product.supply_type.id != '8') &&
                        (product.supply_type.id != '9') &&
                        (product.supply_type.id != '10') &&
                        (product.supply_type.id != '11') &&
                        (product.supply_type.id != '12') &&
                        (product.supply_type.id != '13') &&
                        (product.supply_type.id != '14') &&
                        (product.supply_type.id != '15');
                    break;
            }
            product.supplyType = filter.supply_type;
            product.hide = typeFilter;
        }


        function filterTypeOrder() {
            angular.forEach(vm.types, function (type) {
                angular.forEach(type.product, function (product) {
                    filterOrderHide(product, vm.filter);
                });
            });
        }

        function filterQueryOrder() {
            queryOrder(vm.filterName);
        }

        function filterOrder(type) {
            switch (type) {
                case 1:
                    filterTypeOrder();
                    break;
                case 3:
                    filterQueryOrder();
                    break;
            }
        }

        function clearFilter(type) {
            vm.filter = {supply_type: '1'};
            filterOrder(type);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initStoreSelector();
                        toType.fresh = false;
                    } else {
                        filterTypeOrder();
                    }
                    break;
                case 3:
                    queryOrder();
                    break;
            }
            vm.curType = toType;
        }

        function selectOrder(product) {
            if (vm.multiSelect) {
                var np = true;
                var nc = true;
                if (vm.selected.length > 0) {
                    angular.forEach(vm.selected, function (item) {
                        if (item.id === product.id) {
                            np = false;
                            if (item.supplyType !== product.supplyType) {
                                np = true;
                            } else {
                                nc = false;
                            }
                        }
                    });
                    if (np && nc) {
                        vm.selected.push({
                            id: product.id,
                            name: product.name,
                            count: 1,
                            supplyType: product.supplyType,
                            price: product.price,
                            type_id: product.type_id,
                            unit: product.unit,
                            store_id: product.store_id,
                            quantity: product.quantity
                        });
                        vm.total_number++;
                        vm.total_paid += parseFloat(product.price);
                        // vm.total_paid = Float.toFixed(vm.total_paid, 1);
                    }
                } else {
                    vm.selected.push({
                        id: product.id,
                        name: product.name,
                        count: 1,
                        supplyType: product.supplyType,
                        price: product.price,
                        type_id: product.type_id,
                        unit: product.unit,
                        store_id: product.store_id,
                        quantity: product.quantity
                    });
                    vm.total_number++;
                    vm.total_paid += parseFloat(product.price);
                }
            } else {
                vm.total_number = 1;
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, order);
                } else {
                    vm.selected.push(order);
                }
                vm.total_paid = product.price;
            }
        }

        function loadOrder(product) {
            product.price = parseFloat(product.price);
            product.supply_type = ArrayHelper.getItem(product.supply_type, supplyTypes);
            filterOrderHide(product, vm.filter);
        }

        function initStoreSelector() {
            vm.loading = true;
            $http.get('/api/v1/patient_meal/meal_stores', {
                params: {
                    op: 'now'
                }
            }).then(function (resp) {
                vm.loading = false;
                vm.types = resp.data.items;
                angular.forEach(vm.types, function (type) {
                    angular.forEach(type.product, function (product) {
                        loadOrder(product);
                    });
                });
            });
        }

        function removeSelected($index, product) {
            vm.total_paid -= parseFloat(product.price) * parseFloat(product.count);
            vm.total_number -= product.count;
            vm.selected.splice($index, 1);
        }

        function queryOrder(name) {
            vm.filterName = name;
            vm.products = [];
            $http.get('/api/v1/patient_meal/meal_products', {
                params: {
                    op: 'all',
                    name: name,
                    type: vm.filter.supply_type
                }
            }).then(function (resp) {
                var products = resp.data.items;
                angular.forEach(products, function (product) {
                    loadOrder(product);
                });
                vm.products = products;
            });
        }

        function addCount(product) {
            product.count++;
            vm.total_paid += parseFloat(product.price);
            vm.total_number++;
        }

        function reduceCount(product) {
            if (product.count > 1) {
                product.count--;

                vm.total_paid -= parseFloat(product.price);
                vm.total_number--;
            }
        }

        function changeCount(product, newCnt, oldCnt) {
            if (!newCnt || +newCnt == 0) {
                product.count = newCnt = '1'; //注意count这里是字符串
            }
            if (newCnt != oldCnt) {
                var diff = (+newCnt) - (+oldCnt);
                vm.total_number += diff;

                vm.total_paid += parseFloat(diff) * parseFloat(product.price);
            }
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('taskUserSelector', taskUserSelector)
        .controller('TakUserSelectCtrl', TakUserSelectCtrl);

    /** @ngInject */
    function taskUserSelector(Dlg, $ocLazyLoad) {
        return {
            templateUrl: 'directives/form/task-user-selector/task-user-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                onSelect: '&',
                placeHolder: '@',
                disabled: '=?',
                showDutyGroupMember: '=?',
                isSpot: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    $ocLazyLoad.load(
                        {
                            serie: true,
                            files: [
                                '/ocLazyLoad/d3/d3.js',
                                '/ocLazyLoad/pie/gradientPie.js'
                            ]
                        });

                    if (angular.isUndefined(vm.model)) {
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择任务负责人';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.isSpot)) {
                        vm.isSpot = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn() {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/task-user-selector/task_user_selector_dlg.html',
                        ctrl: 'TakUserSelectCtrl',
                        data: {
                            model: vm.model,
                            isSpot: vm.isSpot
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            vm.model = params[0];
                        } else {
                            vm.model = null;
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function TakUserSelectCtrl($scope, $uibModalInstance, ArrayHelper, Api, Dept, User, DutyGroup, ContactGroup, Meeting,
                               SeniorityStandard, data, DeptType, JobTitle, $q, $http, DeptWard, Task) {
        var cacheGroup;
        var vm = $scope;
        vm.selectTypes = [
            {id: 1, name: '科室', exAll: false, fresh: true},
            // {id: 2, name: '按角色选择', exAll: false, fresh: true},
            {id: 3, name: '姓名/工号', fresh: true},
            {id: 5, name: '群', fresh: true},
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};
        vm.labels = [];

        vm.clearQuery = clearQuery;
        vm.queryUser = queryUser;
        vm.typeSelectedFn = typeSelectedFn;
        vm.pageChanged = pageChanged;

        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleWardNode = toggleWardNode;

        vm.selectWardDeptMembers = selectWardDeptMembers;
        vm.selectDeptMembers = selectDeptMembers;
        vm.selectDeptTypeMembers = selectDeptTypeMembers;

        vm.selectUsers = selectUsers;
        vm.selectUser = selectUser;

        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.wardVisible = wardVisible;

        vm.cancel = $uibModalInstance.dismiss;
        vm.removeAll = removeAll;
        vm.ok = ok;


        vm.forReceive = data.forReceive;
        vm.set = set;
        var pieSvg;
        vm.loadPie = loadPie;

        function loadPie(counts) {
            console.log(counts);
            if (counts.length === 0) {
                return null;
            }

            if (!pieSvg) {
                pieSvg = d3.select("#task-pie").append("svg").attr("width", 175.3).attr("height", 145);

                pieSvg.append("g").attr("id", "salespie");

                gradPie.draw("salespie", getCountData(counts), 88, 75, 66);
            } else {
                gradPie.transition("salespie", getCountData(counts), 66);

            }

            function getCountData(counts) {
                var salesData = [
                    {label: "process", color: "#409eff", name: '进行', className: 'state-circle-progress'},
                    {label: "error", color: "#f56c6c", name: '中止', className: 'state-circle-refund'},
                    {label: "success", color: "#67c23a", name: '完成', className: 'state-circle-success'}
                ];
                var items = salesData.map(function (d, index) {
                    var item = ArrayHelper.getItem(index, counts, 'base_state');
                    return {
                        label: d.label,
                        value: item ? item.stateCount : 0,
                        color: d.color,
                        name: d.name,
                        className: d.className
                    };
                });
                console.log(items);
                vm.labels = items;
                return items;
            }
        }

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '员工选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            vm.selected = data.model;

            if (angular.isUndefined(data.showDutyGroupMember)) {
                vm.showDutyGroupMember = false;
            } else {
                vm.showDutyGroupMember = data.showDutyGroupMember;
            }
            if (angular.isUndefined(data.showMeetingAbsentUser)) {
                vm.showMeetingAbsentUser = false;
            } else {
                vm.showMeetingAbsentUser = data.showMeetingAbsentUser;
            }
            if (angular.isUndefined(data.isSpot)) {
                vm.isSpot = false;
            } else {
                vm.isSpot = data.isSpot;
            }

            if (data.showDutyGroupMember) {
                vm.selectTypes.splice(0, 0, {id: 4, name: '值班组成员', fresh: true});
            }
            if (data.showMeetingAbsentUser) {
                vm.selectTypes.splice(0, 0, {id: 6, name: '会议缺席员工', fresh: true});
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            vm.pager = {total: 0, page: 1, count: 5};
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function queryUser(qStr) {
            var exclude = [];
            angular.forEach(data.existMembers, function (item) {
                exclude.push(item.id);
            });
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 5/*INDEX_USER_INFO_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count,
                    withDept: true,
                    exclude: exclude
                });
                urlParams.name = qStr;
                urlParams.isSpot = vm.isSpot ? '1' : '0';
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    angular.forEach(vm.users, function (user) {
                        if (user.phone && user.phone.substr(0, 4) == '0086') {
                            user.phone = user.phone.substring(user.phone.length - 11);
                        }
                    });
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.queryStr);
        }

        function selectUser(user) {
            vm.selected = user;
            if (!user.pie) {
                Task.query({op: 'user_simple', user_id: user.id}).$promise.then(function (resp) {
                    user.pie = resp.items;
                    vm.loadPie(user.pie);
                });
            } else {
                vm.loadPie(user.pie);
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }

        function initNameSelector() {

        }

        function tagDeptLeader(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            angular.forEach(dept.members, function (m) {
                if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                    (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                    m.hide = true;
                }
            });
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                Dept.query({opt: 3, dept_id: dept.id, user_type: data.userType}, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        toggle(node);
                    }
                });
            }
        }

        function toggleWardNode(ward, toggle, node) {
            if (ward.depts) {
                toggle(node);
            } else {
                DeptWard.query({op: 'options', ward_id: ward.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        ward.depts = resp.items;
                        toggle(node);
                    }
                });
            }
        }

        function selectWardDeptMembers(ward, $event) {
            $event.stopPropagation();
            DeptWard.query({op: 'ward_member', ward_id: ward.id}, function (resp) {
                var items = resp.items;
                if (items.length > 0) {
                    vm.selectUsers(items);
                }
            });
        }

        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                Dept.query({opt: 3, dept_id: dept.id, user_type: data.userType}, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        vm.selectUsers(dept.members);
                    }
                });
            }
        }

        function selectDeptTypeMembers(type, $event) {
            $event.stopPropagation();
            Dept.query({opt: 20, type_id: type.id}, function (resp) {
                var items = resp.items;
                if (items.length > 0) {
                    vm.selectUsers(items);
                }
            });
        }

        function selectUsers(members) {
            angular.forEach(members, function (m) {
                if (!m.hide) selectUser(m);
            });
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function wardVisible() {
            return !(vm.search.dept && vm.search.dept.length > 0);
        }

        function deptVisible(dept) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            return (visible && !dept.dept_ward_id) || (!visible && dept.name.indexOf(vm.search.dept) !== -1);
        }

        function removeAll() {
            vm.selected = null
        }

        function ok(selected) {
            $uibModalInstance.close([selected]);
        }

        function set(selected, result) {
            $uibModalInstance.close({selected: selected, result: result});
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('userSelector', userSelector)
        .controller('UserSelectCtrl', UserSelectCtrl);

    /** @ngInject */
    function userSelector(Dlg) {
        return {
            templateUrl: 'directives/form/user-selector/user-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                onSelect: '&',
                existMembers: '=?',
                placeHolder: '@',
                userType: '=?',
                disabled: '=?',
                showDutyGroupMember: '=?',
                dutyGroupId: '=?',
                showMeetingAbsentUser: '=?',
                meetingId: '=?',
                isSpot: '=?',
                includeQuit: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择成员';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.showDutyGroupMember)) {
                        vm.showDutyGroupMember = false;
                    }
                    if (angular.isUndefined(vm.showMeetingAbsentUser)) {
                        vm.showMeetingAbsentUser = false;
                    }
                    if (angular.isUndefined(vm.isSpot)) {
                        vm.isSpot = false;
                    }
                    if (angular.isUndefined(vm.includeQuit)) {
                        vm.includeQuit = false;
                    }
                    //if (angular.isUndefined(vm.userType)) {
                    //    vm.userType = null;
                    //}
                    //if (angular.isUndefined(vm.dutyGroupId)) {
                    //    vm.dutyGroupId = null;
                    //}

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect, existMembers, userType) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/user-selector/user_selector_dlg.html',
                        ctrl: 'UserSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existMembers: existMembers,
                            userType: userType,
                            showDutyGroupMember: vm.showDutyGroupMember,
                            dutyGroupId: vm.dutyGroupId,
                            showMeetingAbsentUser: vm.showMeetingAbsentUser,
                            meetingId: vm.meetingId,
                            isSpot: vm.isSpot,
                            includeQuit: vm.includeQuit
                        },
                        size: 'lg'
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                angular.forEach(params, function (m) {
                                    vm.model = angular.copy(params);
                                });
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function UserSelectCtrl($scope, $uibModalInstance, ArrayHelper, Api, Dept, User, DutyGroup, ContactGroup, Meeting,
                            SeniorityStandard, data, DeptType, JobTitle, $q, $http, DeptWard) {
        var cacheGroup;
        var vm = $scope;
        vm.selectTypes = [
            {id: 1, name: '科室', exAll: false, fresh: true},
            {id: 10, name: '主科室', fresh: true},
            // {id: 2, name: '按角色选择', exAll: false, fresh: true},
            {id: 3, name: '姓名/工号', fresh: true},
            {id: 5, name: '群', fresh: true},
            {id: 7, name: '年资', fresh: true},
            {id: 8, name: '组合查询', fresh: true},
            {id: 9, name: '工会', fresh: true},
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};

        vm.clearQuery = clearQuery;
        vm.queryUser = queryUser;
        vm.typeSelectedFn = typeSelectedFn;
        vm.pageChanged = pageChanged;

        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleWardNode = toggleWardNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;
        vm.toggleTuGroupNode = toggleTuGroupNode;


        vm.selectContactGroupMembers = selectContactGroupMembers;
        vm.selectTuGroupMembers = selectTuGroupMembers;
        vm.selectWardDeptMembers = selectWardDeptMembers;
        vm.selectDeptMembers = selectDeptMembers;
        vm.selectDeptTypeMembers = selectDeptTypeMembers;

        vm.selectUsers = selectUsers;
        vm.removeSelected = removeSelected;
        vm.selectUser = selectUser;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.tuGroupVisible = tuGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.wardVisible = wardVisible;

        vm.userStatusSelectFn = userStatusSelectFn;
        vm.userTypeSelectFn = userTypeSelectFn;
        vm.userTitleSelectFn = userTitleSelectFn;
        vm.userTitleTypeSelectedFn = userTitleTypeSelectedFn;
        vm.userDeptSelectFn = userDeptSelectFn;
        vm.userDeptTypeSelectedFn = userDeptTypeSelectedFn;
        vm.userPerformanceSelectFn = userPerformanceSelectFn;
        vm.getUserDataes = getUserDataes;
        vm.groupByTitle = groupByTitle;

        vm.cancel = $uibModalInstance.dismiss;
        vm.removeAll = removeAll;
        vm.ok = ok;


        vm.forReceive = data.forReceive;
        vm.set = set;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '员工选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }
            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];

            if (angular.isUndefined(data.showDutyGroupMember)) {
                vm.showDutyGroupMember = false;
            } else {
                vm.showDutyGroupMember = data.showDutyGroupMember;
            }
            if (angular.isUndefined(data.showMeetingAbsentUser)) {
                vm.showMeetingAbsentUser = false;
            } else {
                vm.showMeetingAbsentUser = data.showMeetingAbsentUser;
            }
            if (angular.isUndefined(data.isSpot)) {
                vm.isSpot = false;
            } else {
                vm.isSpot = data.isSpot;
            }
            if (angular.isUndefined(data.includeQuit)) {
                vm.includeQuit = false;
            } else {
                vm.includeQuit = data.includeQuit;
            }

            if (data.showDutyGroupMember) {
                vm.selectTypes.splice(0, 0, {id: 4, name: '值班组成员', fresh: true});
            }
            if (data.showMeetingAbsentUser) {
                vm.selectTypes.splice(0, 0, {id: 6, name: '会议缺席员工', fresh: true});
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            vm.pager = {total: 0, page: 1, count: 9999};
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                case 10:
                    if (toType.fresh || toType.id != $scope.curType.id) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                // case 2:
                //     if (toType.fresh) {
                //         initRoleSelector();
                //         toType.fresh = false;
                //     }
                //     break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDutyGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 6:
                    if (toType.fresh) {
                        initMeetingAbsentUsersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 7:
                    if (toType.fresh) {
                        initSenioritySelector();
                        toType.fresh = false;
                    }
                    break;
                case 8:
                    initMixSearchSelector();
                    break;
                case 9:
                    if (toType.fresh) {
                        initTuGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function initMixSearchSelector() {
            vm.loading = true;
            $q.all([
                User.query({opt: 100}).$promise
            ]).then(function (respArray) {
                vm.loading = false;
                vm.userTypes = respArray[0].types;
                vm.userStatuses = respArray[0].statuses;
                vm.userTitles = respArray[0].titles;
                vm.fTitles = respArray[0].titles;
                vm.userTitleTypes = JobTitle.getTypes();
                vm.userPerformances = respArray[0].performances;
                vm.userDeptTypes = respArray[0].deptTypes;
                vm.userDepts = respArray[0].depts;
                vm.fUserDepts = respArray[0].depts;
                vm.getUserDataes(vm.pager.page, vm.pager.count);
            });
        }

        function getUserDataes(page, count) {
            var exclude = [];
            angular.forEach(data.existMembers, function (item) {
                exclude.push(item.id);
            });
            var pa = Api.param2Url({
                opt: 101,
                page: page,
                count: count,
                exclude: exclude,
                type: vm.userType ? vm.userType.id : undefined,
                title: vm.userTitle ? vm.userTitle.id : undefined,
                title_type: vm.userTitleType ? vm.userTitleType.id : undefined,
                status: vm.userStatus ? vm.userStatus.id : undefined,
                user_dept: vm.userDept ? vm.userDept.id : undefined,
                user_dept_type: vm.userDeptType ? vm.userDeptType.id : undefined,
                performance_id: vm.userPerformance ? vm.userPerformance.id : undefined
            });
            User.query(pa, function (resp) {
                vm.pager.total = resp.total;
                vm.mixUsers = resp.items;
            });
        }

        function userPerformanceSelectFn(item) {
            vm.userPerformance = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userTitleSelectFn(item) {
            vm.userTitle = item;
            if (item) {
                vm.userTitleName = item.name;
            }
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userTitleTypeSelectedFn(item) {
            vm.userTitleType = item;
            if (vm.userTitleType) {
                var filterTitles = ArrayHelper.filter(vm.userTitles, function (title) {
                    return title.type === vm.userTitleType.id;
                });
                vm.fTitles = filterTitles;
                if (vm.userTitle && vm.userTitle.type !== vm.userTitleType.id) {
                    vm.userTitle = vm.fTitles[0];
                    vm.userTitleName = vm.userTitle.name;
                }
            } else{
                vm.fTitles = vm.userTitles;
            }
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userDeptSelectFn(item) {
            vm.userDept = item;
            if (item) {
                vm.userDeptName = item.name;
            }
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userDeptTypeSelectedFn(item) {
            vm.userDeptType = item;
            if (vm.userDeptType) {
                var filterDeptTypes = ArrayHelper.filter(vm.userDepts, function (dept) {
                    return dept.type_id == vm.userDeptType.id;
                });
                vm.fUserDepts = filterDeptTypes;
                if (vm.userDept && vm.userDept.type_id != vm.userDeptType.id) {
                    vm.userDept = vm.fUserDepts[0];
                    vm.userDeptName = vm.userDept.name;
                }
            }else{
                vm.fUserDepts = vm.userDepts;
            }
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userTypeSelectFn(item) {
            vm.userType = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userStatusSelectFn(item) {
            vm.userStatus = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function groupByTitle(item) {
            var userTitleTypes = JobTitle.getTypes();
            return userTitleTypes[item.type - 1].name;
        }

        function clearQuery() {
            vm.users = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function queryUser(qStr) {
            var exclude = [];
            angular.forEach(data.existMembers, function (item) {
                exclude.push(item.id);
            });
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 5/*INDEX_USER_INFO_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count,
                    withDept: true,
                    exclude: exclude
                });
                urlParams.name = qStr;
                urlParams.isSpot = vm.isSpot ? '1' : '0';
                urlParams.includeQuit = vm.includeQuit ? '1' : '0';
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    angular.forEach(vm.users, function (user) {
                        if (user.phone && user.phone.substr(0, 4) == '0086') {
                            user.phone = user.phone.substring(user.phone.length - 11);
                        }
                    });
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.queryStr);
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(user.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(user);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function initMeetingAbsentUsersSelector() {
            vm.loading = true;
            Meeting.getAttendance({opt: 2, id: data.meetingId}, function (resp) {
                vm.loading = false;
                vm.meeting_absent_users = resp.absent_users;
                angular.forEach(resp.absent_users, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }

        // function initRoleSelector() {
        //     vm.loading = true;
        //     User.query({opt: 6}, function (resp) {
        //         vm.loading = false;
        //         vm.roles = resp.roles;
        //         angular.forEach(resp.roles, function (role) {
        //             angular.forEach(role.users, function (m) {
        //                 if (ArrayHelper.indexOfKey(m.id, data.existMembers) != -1 ||
        //                     (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) != -1)) {
        //                     m.hide = true;
        //                 }
        //             });
        //         });
        //     }, function () {
        //         vm.loading = false;
        //     });
        // }

        function initNameSelector() {

        }

        function initDutyGroupMembersSelector() {
            vm.loading = true;
            DutyGroup.index_members({opt: 1, id: data.dutyGroupId}, function (resp) {
                vm.loading = false;
                vm.duty_group_members = resp.members;
                angular.forEach(resp.members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                vm.loading = false;
                cacheGroup = resp.groups;

                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name};
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initTuGroupMembersSelector() {
            vm.loading = true;
            $http.get('api/v1/trade_union/trade_union_groups?op=option').then(function (data) {
                if (data.status == 200) {
                    var items = data.data.items;
                    vm.loading = false;
                    angular.forEach(items, function (item) {
                        angular.forEach(item.users, function (user) {
                            user.id = user.user_id;
                            user.name = user.user.name;
                            user.username = user.user.username;
                            user.dept_id = user.user.dept_id;
                            user.isLeader = ArrayHelper.indexOfKey(user.id, item.leaders, 'leader_id') >= 0;
                        });
                    });
                    vm.tuGroups = items;
                }
            }, function () {
                vm.loading = false;
            });
        }

        function initSenioritySelector() {
            vm.loading = true;
            SeniorityStandard.query({opt: 1}, function (resp) {
                vm.loading = false;
                vm.standards = resp;
                angular.forEach(resp, function (standard) {
                    angular.forEach(standard.nurses, function (m) {
                        if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                            (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                            m.hide = true;
                        }
                    });
                });
            }, function () {
                vm.loading = false;
            });
        }

        function tagDeptLeader(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            angular.forEach(dept.members, function (m) {
                if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                    (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                    m.hide = true;
                }
            });
        }

        function isOnlyMain() {
            return vm.curType.id == 10 ? 1 : 0;
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                Dept.query({
                    opt: 3,
                    dept_id: dept.id,
                    user_type: data.userType,
                    only_main: isOnlyMain()
                }, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        toggle(node);
                    }
                });
            }
        }

        function toggleWardNode(ward, toggle, node) {
            if (ward.depts) {
                toggle(node);
            } else {
                DeptWard.query({op: 'options', ward_id: ward.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        ward.depts = resp.items;
                        toggle(node);
                    }
                });
            }
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.members = members;
            }
            toggle(node);
        }

        function toggleTuGroupNode(group, toggle, node) {
            if (!group.users) {
                var members = ArrayHelper.getItem(group.id, vm.tuGroups).users;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.users = users;
            }
            toggle(node);
        }

        function selectWardDeptMembers(ward, $event) {
            $event.stopPropagation();
            DeptWard.query({op: 'ward_member', ward_id: ward.id, only_main: isOnlyMain()}, function (resp) {
                var items = resp.items;
                if (items.length > 0) {
                    vm.selectUsers(items);
                }
            });
        }

        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                Dept.query({
                    opt: 3,
                    dept_id: dept.id,
                    user_type: data.userType,
                    only_main: isOnlyMain()
                }, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        vm.selectUsers(dept.members);
                    }
                });
            }
        }

        function selectDeptTypeMembers(type, $event) {
            $event.stopPropagation();
            Dept.query({opt: 20, type_id: type.id, only_main: isOnlyMain()}, function (resp) {
                var items = resp.items;
                if (items.length > 0) {
                    vm.selectUsers(items);
                }
            });
        }


        function selectContactGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.members = members;
            }
            vm.selectUsers(group.members);
        }

        function selectTuGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.users) {
                var members = ArrayHelper.getItem(group.id, vm.tuGroups).users;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.users = users;
            }
            vm.selectUsers(group.users);
        }

        function selectUsers(members) {
            angular.forEach(members, function (m) {
                if (!m.hide) selectUser(m);
            });
        }

        function deptGroupVisible(group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
                && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function tuGroupVisible(group) {
            return !(vm.search.tuGroup && vm.search.tuGroup.length > 0
                && group.name.indexOf(vm.search.tuGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function wardVisible() {
            return !(vm.search.dept && vm.search.dept.length > 0);
        }

        function deptVisible(dept) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            return (visible && !dept.dept_ward_id) || (!visible && dept.name.indexOf(vm.search.dept) !== -1);
            // return !(vm.search.dept && vm.search.dept.length > 0
            //     && dept.name.indexOf(vm.search.dept) === -1);
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }

        function set(selected, result) {
            $uibModalInstance.close({selected: selected, result: result});
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('clincDoctorSelector', clincDoctorSelector)
        .controller('clincDoctorSelectCtrl', clincDoctorSelectCtrl);

    /** @ngInject */
    function clincDoctorSelector(Dlg) {
        return {
            templateUrl: 'directives/home/clinc-doctor-selector/clinc-doctor-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                placeHolder: '@',
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectClincDoctorFn = selectClincDoctorFn;

                init();


                function init() {
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择门诊医生';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectClincDoctorFn() {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/home/clinc-doctor-selector/clinc_doctor_selector_dlg.html',
                        ctrl: 'clincDoctorSelectCtrl',
                        data: {model: vm.model}
                    }).then(function (params) {
                        vm.model = params.length > 0 ? params[0] : null;
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }
            }
        }
    }

    /** @ngInject */
    function clincDoctorSelectCtrl($scope, $uibModalInstance, F, HomeDept, data) {
        var vm = $scope;
        vm.selected = []; //所有选中的人
        vm.loading = false;

        vm.selectClincDept = selectClincDept;
        vm.getClincDeptPinyin = getClincDeptPinyin;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '门诊科室选择';
            } else {
                vm.title = data.title;
            }

            getClincDeptPinyin();
        }

        function getClincDeptPinyin() {
            HomeDept.query({opt: 5/*INDEX_PINYIN_CLINC*/}, function (resp) {
                vm.pinyins = resp.items;
            });
        }

        function selectClincDept(dept) {

        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
})();
//angular.module('c.d')
//    .directive('discussionList', function () {
//        var controller =
//            function ($scope, $timeout, ipCookie, C, F, BBS) {
//                var maxLen = 7;
//                BBS.list(function (resp) {
//                    var aLen = resp.Announcements.length;
//                    //var dLen = resp.Discussions.length;
//                    angular.forEach(resp.Announcements, function (a) {
//                        a.LastDate = DateHelper.toLocalTime(a.LastDate, 16);
//                    });
//                    angular.forEach(resp.Discussions, function (d) {
//                        d.LastDate = DateHelper.toLocalTime(d.LastDate, 16);
//                    });
//
//                    $scope.announcements = resp.Announcements;
//                    $scope.aLen = aLen > maxLen ? maxLen : aLen;
//                    $scope.discussions = resp.Discussions;
//                    $scope.dLen = aLen > maxLen ? 0 : (maxLen - aLen);
//                }, function () {
//                });
//
//                $scope.goToDiscussion = function (d) {
//                    var token = Auth.getToken();
//                    ipCookie('token', token/*, {expires: 1, expirationUnit: 'minutes'}*/);
//                    $timeout(function () {
//                        var bbs_url = C.URL.FORUM_SSO;
//                        bbs_url += '?Target=' + d.Url;
//                        window.location.href = bbs_url;
//                    }, 360);
//                }
//            };
//
//
//        return {
//            templateUrl: 'directives/home/discussion-list/discussion-list.html',
//            restrict: 'E',
//            replace: true,
//            scope: {},
//            controller: controller
//
//        }
//    }
//);


angular.module('c.d')
    .directive('homeUserSelector', function (ClincUser) {
            var link =
                function (scope, iElement, iAttrs, r) {
                    var ngModelCtrl = r[0], formCtrl = r[1];
                    var vm = scope;
                    vm.pager = {total: 0, page: 1, count: 10};
                    vm.pageChanged = pageChanged;
                    vm.refreshUsers = refreshUsers;
                    vm.touch = touch;
                    vm.onSelectItem = onSelectItem;
                    vm.clearQuery = clearQuery;

                    init();


                    function init() {
                        checkValidity();

                        if (formCtrl) {
                            scope.$watch(function () {
                                return formCtrl.$submitted;
                            }, function (submitted) {
                                if (submitted) iElement.addClass('submitted')
                            });
                        }

                        queryUsers();
                    }

                    function touch() {
                        ngModelCtrl.$setTouched();
                    }

                    function onSelectItem(model) {
                        ngModelCtrl.$setViewValue(model);
                        checkValidity();
                        if (scope.onSelect()) {
                            scope.onSelect()(model)
                        }
                    }


                    function pageChanged() {
                        queryUsers(vm.queryStr);
                    }

                    function queryUsers(qStr) {
                        return ClincUser.query({
                            opt: 3/*INDEX_SELECTOR*/,
                            name: qStr,
                            page: vm.pager.page,
                            count: vm.pager.count
                        }).$promise.then(function (resp) {
                            angular.forEach(resp.items, function (user) {
                                user.desc = user.name + '/' + user.username;
                            });
                            vm.users = resp.items;
                            vm.pager.total = resp.total;
                            vm.users.splice(0, 0, {action: true});
                        })
                    }

                    function refreshUsers($select) {
                        $select.refreshing = true;
                        vm.pager.page = 1;
                        vm.queryStr = $select.search;
                        return queryUsers($select.search).finally(function () {
                            $select.refreshing = false;
                        });
                    }

                    function checkValidity() {
                        var valid = iAttrs.required ? ngModelCtrl.$viewValue : true;
                        ngModelCtrl.$setValidity('required', valid);
                    }

                    function clearQuery() {
                        vm.queryStr = '';
                        queryUsers(vm.queryStr);
                    }
                };


            return {
                templateUrl: 'directives/home/homeUserSelector/homeUserSelector.html',
                restrict: 'E',
                replace: true,
                scope: {
                    onSelect: '&',
                    model: '=ngModel'
                },
                require: ['^ngModel', '?^form'],
                link: link

            }
        }
    );


(function () {
    'use strict';

    angular.module('c.d')
        .directive('cabinBedFilter', cabinBedFilter);

    function cabinBedFilter() {
        return {
            templateUrl: 'directives/table/cabinBedFilter/cabinBedFilter.html',
            restrict: 'E',
            scope: {
                curOptionId: '=ngModel',
                filterName: '@',
                tagTitle: '@',
                optionSelect: '&',
                cabin: '@',
            },
            require: ['^ngModel'],
            link: link
        }
    }


    function link(scope) {
        if (angular.isUndefined(scope.cabin)) {
            scope.options = [
                {name: '全部', id: '0'},
                {name: 'A1', id: '1'},
                {name: 'A2', id: '2'},
                {name: 'B1', id: '3'},
                {name: 'B2', id: '4'},
                {name: 'B3', id: '5'},
                {name: 'B4', id: '6'},
                {name: 'B5', id: '7'},
                {name: 'B6', id: '8'},
                {name: 'C1', id: '9'},
                {name: 'C2', id: '10'},
                {name: 'D1', id: '11'},
                {name: 'D2', id: '12'},
                {name: 'D3', id: '13'},
            ];
        }

        if (angular.isDefined(scope.cabin)) {

            if (scope.cabin == 'five' || scope.cabin == '1') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: 'A', id: '1'},
                    {name: 'B', id: '2'},
                    {name: 'C', id: '3'}
                ];
            }

            if (scope.cabin == '3') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: 'A1', id: '1'}
                ];
            }

            if (scope.cabin == '4') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: 'A', id: '1'},
                    {name: 'B', id: '2'},
                    // {name: 'C', id: '3'},
                    // {name: 'D', id: '4'}
                ];
            }


            if (scope.cabin == 'six') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: 'A', id: '1'},
                    {name: 'B', id: '2'},
                    {name: 'C', id: '3'}
                ];
            }

            if (scope.cabin == '6plus') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: 'A1', id: '1'},
                    {name: 'A2', id: '2'},
                    {name: 'A3', id: '3'},
                    {name: 'B1', id: '4'},
                    {name: 'B2', id: '5'},
                    {name: 'B3', id: '6'},
                    {name: 'C1', id: '7'},
                    {name: 'C2', id: '8'},
                    {name: 'C3', id: '9'}
                ];
            }

            if (scope.cabin == 'seven') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: '一楼', val: 'A', id: '1'},
                    {name: '二楼', val: 'B', id: '2'},
                    {name: '三楼', val: 'C', id: '3'}
                ];
            }

            if (scope.cabin == 'eight') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: 'A1', id: '1'},
                    {name: 'A2', id: '2'},
                    {name: 'A3', id: '3'},
                    {name: 'A4', id: '4'},
                    {name: 'B1', id: '5'},
                    {name: 'B2', id: '6'},
                    {name: 'B3', id: '7'},
                    {name: 'B4', id: '8'},
                    {name: 'C1', id: '9'},
                    {name: 'C2', id: '10'},
                    {name: 'C3', id: '11'},
                    {name: 'C4', id: '12'},
                    {name: 'C5', id: '13'},
                ];
            }

            if (scope.cabin == 'nine') {
                scope.options = [
                    {name: '全部', id: '0'},
                    {name: 'A1', id: '1'},
                    {name: 'A2', id: '2'},
                    {name: 'A3', id: '3'},
                    {name: 'A4', id: '4'},
                    {name: 'A5', id: '5'},
                    {name: 'A6', id: '6'},
                    {name: 'A7', id: '7'},
                    {name: 'A8', id: '8'},
                    {name: 'A9', id: '9'},
                    {name: 'A10', id: '10'},
                    {name: 'A11', id: '11'},
                    {name: 'A12', id: '12'},
                    {name: 'A13', id: '13'},
                    {name: 'A14', id: '14'},
                    {name: 'A15', id: '15'},
                    {name: 'A16', id: '16'},
                    {name: 'A17', id: '17'},
                    {name: 'A18', id: '18'},
                    {name: 'B1', id: '19'},
                    {name: 'B2', id: '20'},
                    {name: 'B3', id: '21'},
                    {name: 'B4', id: '22'},
                    {name: 'B5', id: '23'},
                    {name: 'B6', id: '24'},
                    {name: 'B7', id: '25'},
                    {name: 'B8', id: '26'},
                    {name: 'B9', id: '27'},
                    {name: 'C1', id: '28'},
                    {name: 'C2', id: '29'},
                    {name: 'C3', id: '30'},
                    {name: 'C4', id: '31'}
                ];
            }

        }

        scope.filterName = 'room';

        var parentCtrl = scope.$parent;
        scope.optionSelected = optionSelected;

        function optionSelected(option) {
            var filter = parentCtrl.tableParams.filter();
            if (angular.isDefined(option.val)) {
                scope.curOptionId = option.name;
                filter[scope.filterName] = option.val;
            } else {
                scope.curOptionId = filter[scope.filterName] = option.name;
            }
            if (option.id == '0') delete filter[scope.filterName];

            if (scope.optionSelect()) {
                scope.optionSelect()(option);
            } else {
                parentCtrl.tableParams.filter(filter);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.d')
        .directive('dateSpinner', dateSpinner);

    /** @ngInject */
    function dateSpinner($compile, DateHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                otherData: '=',
                maxDate: '=',
                minDate: '=',
                mode: '@',
                maxDateToday: '@',
                onChange: '&',
                customClass: '@'
            },
            require: '^ngModel',
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, ngModelCtrl) {
                        var mode = iAttrs.mode;
                        var maxDateToday = angular.isDefined(iAttrs.maxDateToday);
                        var vm = scope;
                        vm.prev = prev;
                        vm.next = next;
                        vm.testPrev = testPrev;
                        vm.testNext = testNext;


                        init();


                        function init() {
                            switch (mode) {
                                case 'day':
                                case 'month':
                                case 'year':
                                    vm.dateOptions = {datepickerMode: mode, minMode: mode};
                                    break;
                                default:
                                    vm.dateOptions = {datepickerMode: 'day'};
                                    if (mode !== 'week') mode = 'day';
                            }

                            if (maxDateToday) vm.dateOptions.maxDate = new Date();
                            else if (angular.isDefined(vm.maxDate)) {
                                vm.dateOptions.maxDate = vm.maxDate.setHours(0, 0, 0, 0);
                            }
                            if (angular.isDefined(vm.minDate)) {
                                vm.dateOptions.minDate = vm.minDate.setHours(0, 0, 0, 0);
                            }
                            if (angular.isUndefined(vm.customClass)) vm.customClass = 'text-muted';

                            if (!vm.model && !angular.isDefined(vm.otherData)) {
                                vm.model = new Date();
                            } else if (!vm.model && angular.isDefined(vm.otherData)) {
                                vm.model = vm.otherData;
                            }

                            scope.$watch('model', function (newValue) {
                                if (newValue) {
                                    var dateText = getDateText(newValue, mode);
                                    if (vm.dateText !== dateText) {
                                        if (vm.onChange) {
                                            vm.onChange({date: newValue, dateText: dateText});
                                        }
                                        vm.dateText = dateText;
                                    }
                                }
                            });

                            var elem =
                                '<span><div class="btn-group mr-2">' +
                                '<button ng-click="prev(model)" class="btn btn-default btn-sm btn-narrow" ng-disabled="!testPrev(model)">' +
                                '<i class="fa fa-angle-left text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="opened=true" class="btn btn-default btn-sm" uib-datepicker-popup' +
                                ' datepicker-mode="dateOptions.minMode" is-open="opened" datepicker-options="dateOptions"' +
                                ' min-date="dateOptions.minDate" max-date="dateOptions.maxDate"' +
                                ' ng-model="model">' +
                                '<i class="fa fa-calendar text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="next(model)" style="margin-left:-1px" ' +
                                'class="btn btn-default btn-sm btn-narrow" ng-disabled="!testNext(model)">' +
                                '<i class="fa fa-angle-right text-muted"></i>' +
                                '</button>' +
                                '</div><span class={{customClass}}>{{dateText}}</span></span>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                        }

                        function getDateText(d, mode) {
                            switch (mode) {
                                case 'day':
                                    return DateHelper.date2Str(d, 'yyyy-MM-dd EEEE');
                                case 'week':
                                    //周末的情况，显示上一周的日期
                                    var monday, sunday, diffDays;
                                    diffDays = d.getDay() === 0 ? 0 : 7;
                                    monday = new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay() - 6 + diffDays);
                                    sunday = new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay() + diffDays);
                                    return DateHelper.date2Str(monday, 'MM月dd日') + ' - ' + DateHelper.date2Str(sunday, 'MM月dd日/yyyy年');
                                case 'month':
                                    return DateHelper.date2Str(d, 'yyyy-MM');
                                case 'year':
                                    return DateHelper.date2Str(d, 'yyyy') + '年';
                            }
                        }

                        function prev(curr) {
                            vm.model = getPrev(curr);
                        }

                        function next(curr) {
                            vm.model = getNext(curr);
                        }

                        function testPrev(curr) {
                            if (angular.isUndefined(vm.dateOptions.minDate)) return true;
                            return getPrev(curr) >= vm.dateOptions.minDate;
                        }

                        function testNext(curr) {
                            if (angular.isUndefined(vm.dateOptions.maxDate)) return true;
                            return getNext(curr) <= vm.dateOptions.maxDate;
                        }

                        function getPrev(curr) {
                            curr = angular.copy(curr);
                            var tmp, newDate, diffDays;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() - 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    diffDays = curr.getDay() === 0 ? -13 : -6;
                                    tmp = curr.getDate() - curr.getDay() + diffDays;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() - 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() - 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            return newDate;
                        }

                        function getNext(curr) {
                            curr = angular.copy(curr);
                            var tmp, newDate, diffDays;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() + 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    diffDays = curr.getDay() === 0 ? 1 : 8;
                                    tmp = curr.getDate() - curr.getDay() + diffDays;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() + 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() + 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            return newDate;
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.d')
        .directive('tableOptionTab', tableOptionTab);

    function tableOptionTab() {
        return {
            templateUrl: 'directives/table/tableOptionTab/tableOptionTab.html',
            restrict: 'E',
            scope: {
                options: '=',
                curOptionId: '=ngModel',
                filterName: '@',
                tagTitle: '@',
                optionSelect: '&'
            },
            require: ['^ngModel'],
            link: link
        }
    }


    function link(scope) {
        var parentCtrl = scope.$parent;
        scope.optionSelected = optionSelected;

        function optionSelected(option) {
            var filter = parentCtrl.tableParams.filter();
            scope.curOptionId = filter[scope.filterName] = option.id;
            if (!option.id) delete filter[scope.filterName];

            if (scope.optionSelect()) {
                scope.optionSelect()(option);
            } else {
                parentCtrl.tableParams.filter(filter);
            }
        }
    }

})();
angular.module('c.d')
    .directive('advice', function () {
        return {
            templateUrl: 'directives/main/advice/advice.html',
            restrict: 'E',
            replace: true,
            scope: {
                'warning': '@',
                'danger': '@'
            }
        }
    });
angular.module('c.d')
    .directive('airfareTable', function () {
        var controller = function ($scope, $filter, $rootScope, dialogs, toaster, $sce, $timeout,
                                   $templateRequest, Api, NgTableParams, Airfare, AskForLeave, C, F) {

            var types = F.getNgTableOpts(F.get('airfare_types'));
            $scope.types = F.get('airfare_types');

            $scope.$on('fresh', function () {
                $scope.tableParams.reload();
            });
            $scope.cols = [
                {
                    title: '类别',
                    sortable: status,
                    filter: {status: 'select'},
                    field: 'status',
                    data: types,
                    show: true
                },
                {
                    title: '状态',
                    field: 'step',
                    show: false
                },
                {title: '姓名', filter: {'users.name': 'text'}, field: 'name', show: true}, //0
                {title: '手机', filter: {'users.phone': 'text'}, field: 'phone', show: true}, //0
                {title: '身份证号', filter: {id_card: 'text'}, field: 'id_card', show: true}, //6
                {title: '出发地', filter: {from: 'text'}, field: 'from', show: true}, //6
                {title: '目的地', filter: {to: 'text'}, field: 'to', show: true}, //6
                {
                    title: '出发日期',
                    filter: {from_time: 'date_range'},
                    sortable: 'from_time',
                    field: 'from_time',
                    show: true
                },
                {title: '计划起飞时间', filter: {plane_time: 'text'}, field: 'plane_time', show: true}, //6
                {title: '航空公司', filter: {airline: 'text'}, field: 'airline', show: true}, //6
                {title: '航班号', filter: {flight_num: 'text'}, field: 'flight_num', show: true}, //6
                {title: '备注', filter: {remark: 'text'}, field: 'remark', show: true}, //6
                {title: '原因', show: true} //6
            ];

            $scope.state_cols = $scope.cols[1];
            if ($scope.opt == '3') {
                $scope.state_cols.show = true;
            }
            $scope.optInFront = true;
            $scope.optColWidth = 45;
            $scope.dateRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );
            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['step'] = $scope.step;
                    url['opt'] = $scope.opt;
                    var startDate, endDate;
                    if ($scope.dateRangeFilter.start != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.from_time.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.from_time.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            from_time: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    Airfare.query(url, function (data) {
                        params.total(data.total);
                        $defer.resolve(data.records);
                    });
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            $scope.confirm = function (record) {
                dialogs.create('/templates/airfare/office_airfare_dlg.html', 'OfficeAirfareDlgCtrl', {
                    step: $scope.step,
                    airfare: record
                }, {
                    size: 'md'
                }).result.then(function (airfare) {
                        Airfare.update({id: record.id}, airfare).$promise.then(function () {
                            toaster.success('机票状态改变成功!');
                            if ($scope.step == 0 || $scope.step == 1 || $scope.step == 2 || $scope.step == 3 || $scope.step == 4) {
                                $rootScope.$broadcast('fresh');
                            }
                            $scope.tableReload();
                        }, function () {
                            toaster.error('机票状态改变成功!');
                        });
                    });
            };

            $scope.refund = function (record) {
                dialogs.confirm('退票', '确定要对<strong>' + record.user_name + '</strong>退票吗?')
                    .result.then(function () {
                        var para = {};
                        para['step'] = 4;
                        Airfare.update({id: record.id}, para).$promise.then(function () {
                            toaster.success('退票成功!');
                            $scope.tableReload();
                        }, function () {
                            toaster.error('退票失败!');
                        });
                    });
            };

            $scope.agree = function (record) {
                var para = {};
                para['stage'] = 3;
                Airfare.update({id: record.id}, para).$promise.then(function () {
                    toaster.success('审批成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('审批失败!');
                });
            };

            //审批拒绝
            $scope.back = function (record) {
                dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                    title: '退回机票申请',
                    icon: 'reply',
                    label: '原因'
                }, {
                    size: 'sm'
                }).result.then(function (pa) {
                        var params = {};
                        params['memo'] = pa;
                        if ($scope.opt == '1') {  //财务科审批
                            params['stage'] = 2;
                        } else if ($scope.opt == '3') {  //院办审批
                            params['stage'] = 4;
                        }
                        Airfare.update({id: record.id}, params).$promise.then(function () {
                            toaster.success('退回成功!');
                            $rootScope.$broadcast('fresh');
                        }, function () {
                            toaster.error('退回失败!');
                        })
                    });
            };

            $scope.export = function () {
                Api.exportDR(C.URL.AIRFARE_DOWNLOAD, "机票统计");
            };

            var templateUrl = $sce.getTrustedResourceUrl('templates/print/table2.html');
            var printStyle;
            $templateRequest(templateUrl).then(function (resp) {
                printStyle = resp;
            });

            $scope.print = function (record) {

                AskForLeave.get({id: record.leave_id}).$promise.then(function (data) {
                    var leave = data.leave;
                    var w = window.open("", "打印预览");

                    var html = '<html><body>';

                    html += '<table class="print">' +
                    '<caption>成办医院请假审批单</caption>' +
                    '<tbody><tr>';
                    html += '<td width="120">编号</td>';
                    html += '<td width="520">' + leave.id + '</td>';

                    html += '</tr>';

                    html += '<tr><td width="120">请假人</td>';
                    html += '<td width="520">' + leave.user.name + '</td>';
                    html += '</tr>';
                    html += '<tr><td width="120">请假类别</td>';
                    html += '<td width="520">' + leave.leave_type.name + '</td>';
                    html += '</tr>';
                    html += '<tr>';
                    html += '<td width="120">请假开始时间</td>';
                    html += '<td width="520">' + leave.start;
                    if (record.start_spot == 1) {
                        html += '&nbsp;13:30'
                    }
                    if (record.start_spot == 0) {
                        html += '&nbsp;8:00'
                    }
                    html += '</td></tr>';
                    html += '<td width="120">请假结束时间</td>';
                    html += '<td width="520">' + leave.end;
                    if (record.end_spot == 1) {
                        html += '&nbsp;12:00'
                    }
                    if (record.end_spot == 0) {
                        html += '&nbsp;17:00'
                    }
                    html += '</td></tr>';
                    html += '<tr>';
                    html += '<td width="120">请假事由</td>';
                    html += '<td width="520">' + leave.leave_reason + '</td>';
                    html += '</tr>';
                    html += '<tr>';
                    html += '<td width="120">附件</td>';
                    html += '<td width="520">';
                    if (leave.attach_name == '') {
                        html += '无'
                    } else {
                        html += leave.attach_name;
                    }
                    html += '</td></tr>';
                    html += '<tr><td colspan="2">';
                    if (leave.dept_charge_opinion == 2) {
                        html += '科室负责人:' + leave.dept_charge.name + ' ';
                        if (leave.dept_charge.signature) {
                            html += '<img height="50" width="160" src="' + leave.dept_charge.signature.sign + '"/> ';
                        }
                        html += leave.dept_charge_time.substr(0, 16) + ' ';
                    }
                    html += '<br/>';
                    if (record.medical_opinion == 2) {
                        html += '医务科:' + leave.medical_approval.name + ' ';
                        if (leave.medical_approval.signature) {
                            html += '<img height="50" width="160" src="' + leave.medical_approval.signature.sign + '"/> ';
                        }
                        html += leave.medical_time.substr(0, 16) + ' ';
                    }
                    html += '<br/>';
                    if (leave.nurse_opinion == '2') {
                        html += '护理部:' + leave.nurse_approval.name + ' ';
                        if (leave.nurse_approval.signature) {
                            html += '<img height="50" width="160" src="' + leave.nurse_approval.signature.sign + '"/> ';
                        }
                        html += leave.nurse_time.substr(0, 16) + ' ';
                    }
                    html += '<br/>';
                    if (leave.hospital_leader_opinion == '2') {
                        html += '分管院领导:' + leave.hospital_leader.name + ' ';
                        if (leave.hospital_leader.signature) {
                            html += '<img height="50" width="160" src="' + leave.hospital_leader.signature.sign + '"/> ';
                        }
                        html += leave.hospital_leader_time.substr(0, 16) + ' ';
                    }
                    html += '<br/>';
                    if (leave.main_leader_opinion == '2') {
                        html += '主管院领导:' + leave.main_leader.name + ' ';
                        if (leave.main_leader.signature) {
                            html += '<img height="50" width="160" src="' + leave.main_leader.signature.sign + '"/> ';
                        }
                        html += leave.main_leader_time.substr(0, 16) + ' ';
                    }
                    html += '<br/>';
                    if (leave.personnel_opinion == '2') {
                        html += '人事科:' + leave.personnel_approval.name + ' ';
                        if (leave.personnel_approval.signature) {
                            html += '<img height="50" width="160" src="' + leave.personnel_approval.signature.sign + '"/> ';
                        }
                        html += leave.personnel_time.substr(0, 16) + ' ';
                    }
                    html += '<br/>';
                    html += '</td></tr>';
                    html += '</tbody></table></body></html>';

                    w.document.write(html + printStyle);
                    w.document.close();
                    w.focus();
                    $timeout(function () {
                        w.print();
                        w.close();
                    }, 24);
                }, function () {

                });
            };

        };

        return {
            templateUrl: 'directives/main/airfare-table/airfare-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'step': '@',   //表明是哪个步骤在审批
                'opt': '@'   //表明哪个部门在审核
            },
            controller: controller
        }
    });

angular.module('c.c').controller('OfficeAirfareDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, $filter, Airfare, data) {
        $scope.airfare = data.airfare;
        $scope.step = data.step;
        $scope.edited = false;

        if ($scope.step == 1) {
            $scope.message = {
                'info': '已为您订购' + $scope.airfare.from_time + '出发,从' + $scope.airfare.from + '到'
                + $scope.airfare.to + $scope.airfare.airline + '机票,航班号为' + $scope.airfare.flight_num
            };
        } else {
            $scope.message = {};
        }


        $scope.edit = function () {
            dialogs.create('/templates/airfare/airfare_edit.html', 'AirfareEditCtrl', {airfare: data.airfare}, {
                size: 'md'
            }).result.then(function (airfare) {
                    $scope.airfare_edit = airfare;
                    $scope.edited = true;
                });
        };

        $scope.ok = function (message) {
            var params = {};
            if (message.send) {
                params['m_info'] = message.info;
            }
            if ($scope.edited) {
                params['id_card'] = $scope.airfare_edit.id_card;
                params['from'] = $scope.airfare_edit.from;
                params['to'] = $scope.airfare_edit.to;
                params['from_time'] = $filter('date')($scope.airfare_edit.from_time, 'yyyy-MM-dd');
                params['plane_time'] = $scope.airfare_edit.plane_time;
                params['airline'] = $scope.airfare_edit.airline;
                params['flight_num'] = $scope.airfare_edit.flight_num;
                params['remark'] = $scope.airfare_edit.remark;
            }
            params['step'] = parseInt($scope.step) + 1;
            $uibModalInstance.close(params);
        };
        to

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


angular.module('c.c').controller('AirfareEditCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, $filter, Airfare, uibDateParser, data) {
        var airfare = data.airfare;
        $scope.airfare = {
            id_card: airfare.id_card,
            from: airfare.from,
            to: airfare.to,
            from_time: uibDateParser.parse(airfare.from_time, 'yyyy-MM-dd'),
            plane_time: airfare.plane_time,
            airline: airfare.airline,
            flight_num: airfare.flight_num,
            remark: airfare.remark
        };

        $scope.ok = function (airfare) {
            if ($scope.airfare_edit_form.$valid) {
                var params = {};
                params['id_card'] = airfare.id_card;
                params['from'] = airfare.from;
                params['to'] = airfare.to;
                params['from_time'] = $filter('date')(airfare.from_time, 'yyyy-MM-dd');
                params['plane_time'] = airfare.plane_time;
                params['airline'] = airfare.airline;
                params['flight_num'] = airfare.flight_num;
                params['remark'] = airfare.remark;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.airfare_edit_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });









angular.module('c.d')
    .directive('approvedLeaveTable', function () {
        var controller = function ($scope, $filter, dialogs, toaster, FileHelper,
                                   NgTableParams, AskForLeave, SaveAs, C, F) {

            var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            $scope.yesNo = F.get('yesNo');
            var processStatues = F.getNgTableOpts(F.get('processStatus'));
            $scope.statues = F.get('processStatus');

            $scope.$on('ApprovedRefresh', function () {
                $scope.tableParams.reload();
            });

            $scope.cols = [
                {title: '姓名', filter: {'users.name': 'text'}, field: 'name', width: '60', show: true}, //0
                {title: '科室', filter: {'depts.name': 'text'}, field: 'dept_id', width: '80', show: true}, //0
                {
                    title: '类别',
                    sortable: 'leave_type_id',
                    filter: {leave_type_id: 'select'},
                    field: 'leave_type_id',
                    width: '100',
                    show: true
                }, //6
                {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', width: '180', show: true}, //6
                {title: '天数', field: 'day_num', width: '110', show: true}, //6
                {title: '临时负责人', field: 'dept_agents', width: '110', show: true}, //6
                {title: '开始时间', filter: {start: 'date_range'}, field: 'start', width: '130', show: true},
                {title: '结束时间', filter: {end: 'date_range'}, field: 'end', width: '130', show: true},
                {
                    title: '附件',
                    field: 'has_paper',
                    width: '100',
                    show: true
                }, //6
                {
                    title: '附件类型',
                    sortable: 'type_id',
                    filter: {'type_id': 'select'},
                    field: 'type_id',
                    width: '90',
                    show: true
                }, //6
                {
                    title: '补助与机票',
                    sortable: 'is_subsidy',
                    filter: {is_subsidy: 'select'},
                    field: 'is_subsidy',
                    data: yesNoOpts,
                    width: '105',
                    show: true
                }, //6
                {
                    title: '我的意见',
                    //filter: {status: 'select'},
                    field: 'status',
                    data: processStatues,
                    width: '90',
                    show: true
                }, //6
                {
                    title: '最终状态',
                    width: '90',
                    show: true
                }, //6
                {title: '申请时间', filter: {created_at: 'date_range'}, field: 'created_at', width: '130', show: true},
                // {
                //     title: '离开大成都范围',
                //     filter: {is_leave_cd: 'select'},
                //     field: 'is_leave_cd',
                //     data: yesNoOpts,
                //     width: '140',
                //     show: true
                // } //6
            ];

            $scope.leave_type_col = $scope.cols[2];
            $scope.attach_type_col = $scope.cols[8];
            $scope.opinion_col = $scope.cols[10];

            $scope.dateRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.download = function (m) {
                var params = {filename: m.attach_filename, mime: m.attach_mime};
                m.downloading = true;
                FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                    m.downloading = false;
                    var data = [resp];
                    var options = {type: m.attach_mime};
                    SaveAs.download(data, m.attach_name, options);
                }, function (error) {
                    m.downloading = false;
                    //toaster.error('服务端文件丢失,请联系管理员!');
                });
            };

            $scope.hideOpt = true;
            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = $scope.opt;
                    var startDate, endDate;
                    if ($scope.dateRangeFilter.start != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            start: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    if ($scope.dateRangeFilter.end != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            end: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    AskForLeave.query(url, function (data) {
                        switch ($scope.opt) {
                            case '4':
                                $scope.opinion_col.filter = {dept_charge_opinion: 'select'};
                                break;
                            case '6':
                                $scope.opinion_col.filter = {personnel_opinion: 'select'};
                                break;
                            case '8':
                                $scope.opinion_col.filter = {medical_opinion: 'select'};
                                break;
                            case '10':
                                $scope.opinion_col.filter = {nurse_opinion: 'select'};
                                break;
                            case '12':
                                $scope.opinion_col.filter = {hospital_leader_opinion: 'select'};
                                break;
                            case '14':
                                $scope.opinion_col.filter = {main_leader_opinion: 'select'};
                                break;
                            default:
                                break;
                        }
                        $scope.leave_types = data.leave_types;
                        $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                        $scope.attach_types = data.attach_types;
                        $scope.attach_type_col.data = F.getNgTableOpts($scope.attach_types);
                        params.total(data.total);
                        $defer.resolve(data.records);
                    });
                }
            });

            $scope.tableReload = function () {
                $scope.cachedData = null;
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.tableParams.filter({});
            };
        };

        return {
            templateUrl: 'directives/main/approved-leave-table/approved-leave-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@'   //表明是在看哪个步骤的审批
            },
            controller: controller
        }
    });
angular.module('c.d')
    .directive('backLeaveConfirmTable', function () {
        var controller = function ($scope, $filter, dialogs, toaster, NgTableParams, AskForLeave, SaveAs, F, Table, ArrayHelper) {

            // var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            // $scope.yesNo = F.get('yesNo');

            $scope.cols = [
                {title: '姓名', filter: {'users.name': 'text'}, field: 'name', width: '100', show: true}, //0
                {
                    title: '类别',
                    sortable: 'leave_type_id',
                    filter: {leave_type_id: 'select'},
                    field: 'leave_type_id',
                    width: '8%',
                    show: true
                }, //6
                {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
                {title: '开始时间', filter: {start: 'date_range'}, field: 'start', width: '10%', show: true},
                {title: '结束时间', filter: {end: 'date_range'}, field: 'end', width: '10%', show: true},
                {title: '上班时间', filter: {on_time: 'date_range'}, field: 'on_time', width: '10%', show: true}
                // {
                //     title: '离开大成都范围',
                //     filter: {is_leave_cd: 'select'},
                //     field: 'is_leave_cd',
                //     data: yesNoOpts,
                //     width: '105',
                //     show: true
                // }
            ];

            $scope.leave_type_col = $scope.cols[1];

            $scope.dateRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function () {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.optColWidth = 60;
            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = $scope.step;
                    var startDate, endDate;
                    if ($scope.dateRangeFilter.start != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            start: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    if ($scope.dateRangeFilter.end != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            end: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    if ($scope.dateRangeFilter.on_time != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.on_time.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.on_time.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            on_time: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    AskForLeave.query(url, function (data) {
                        $scope.leave_types = data.leave_types;
                        $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                        params.total(data.total);
                        $scope.records = data.records;
                        $defer.resolve(data.records);
                    });
                }
            });

            $scope.confirm = function (record) {
                dialogs.confirm('销假确认', '确定要确认<strong>' + record.user.name + '</strong>的假条吗?')
                    .result.then(function () {
                    var data = {};
                    data['step'] = $scope.step;
                    AskForLeave.update({id: record.id}, data).$promise.then(function () {
                        toaster.success('确认成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('确认失败!');
                    });
                });
            };


            $scope.reject = function (record) {
                dialogs.confirm('拒绝销假', '确定要拒绝<strong>' + record.user.name + '</strong>的销假条吗?')
                    .result.then(function () {
                    var params = {};
                    params['on_time'] = null;
                    params['later_end'] = null;
                    params['attachments'] = ArrayHelper.map(record.attachments, function (attachment) {
                        return {
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        };
                    });
                    params['reject'] = 1;
                    AskForLeave.update({id: record.id}, params).$promise.then(function () {
                        toaster.success('拒绝成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('拒绝失败!');
                    });
                });
            };

            $scope.tableReload = function () {
                $scope.cachedData = null;
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            var checker = Table.loadMultiSelectedFn($scope);

            $scope.batch = function (records) {
                if (!checker.hasChecked()) {
                    toaster.warning('请选择处理对象');
                    return;
                }
                dialogs.confirm('提示', '确定要批量确认销假吗?')
                    .result.then(function () {
                    AskForLeave.batch({ids: checker.getCheckedIds(records), step: $scope.step}, function (resp) {
                        toaster.success(resp.msg);
                        $scope.tableReload();
                    });
                });
            };

        };

        return {
            templateUrl: 'directives/main/back-leave-confirm-table/back-leave-confirm-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'step': '@'   //表明是哪个步骤在审批
            },
            controller: controller
        }
    });





angular.module('c.d')
    .directive('baseData', function () {
        return {
            templateUrl: 'directives/main/base-data/base-data.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'service': '@',
                'maxProtectId': '@'
            },
            controller: controller
        };

        function controller($scope, $injector, Api, Table) {
            var vm = $scope;
            var service = $injector.get(vm.service);
            vm.addEdit = addEdit;
            vm.setStop = setStop;
            vm.remove = remove;

            init();

            function init() {
                if (angular.isUndefined(vm.maxProtectId)) {
                    vm.maxProtectId = 0;
                } else {
                    vm.maxProtectId = parseInt(vm.maxProtectId);
                }

                Table.load(vm, {
                    service: service,
                    params: {opt: 1/*INDEX_ALL*/},
                    sorting: {sorting: 'asc'},
                    optColWidth: Table._3_BTN,
                    hideFilter: true,
                    optInFront: true,
                    cols: [
                        {field: "name", title: "名称"},
                        {field: "sorting", title: "排序"}
                    ]
                });
            }

            function remove(m) {
                Api.delTableItem(service, m.id, vm, vm.title, m.name);
            }

            function setStop(m) {
                Api.setStop(service, m);
            }

            function addEdit(m) {
                Api.addEdit(vm, 'BaseDataDlg', 'BaseDataDlgCtrl', m, {service: service, title: vm.title});
            }
        }
    });

angular.module('c.c').controller('BaseDataDlgCtrl',
    function ($scope, $uibModalInstance, $q, toaster, F, data) {
        var vm = $scope;
        var service = data.service;
        vm.title = data.title;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);


        function loadModel(id) {
            if (id) {
                vm.m = service.get({id: id});
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (vm.Form.$valid) {
                var promise;
                var pa = {
                    name: m.name,
                    sorting: m.sorting
                };
                if (m.id) { //修改
                    promise = service.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    toaster.success(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    });
angular.module('c.d')
    .directive('basicDataTable', function () {
        var controller = function ($rootScope, $scope, $filter, $injector, dialogs, toaster, NgTableParams, Table) {
            var Data = $injector.get($scope.serverName);
            if (angular.isUndefined($scope.maxProtectId)) {
                $scope.maxProtectId = 0;
            } else {
                $scope.maxProtectId = parseInt($scope.maxProtectId);
            }
            var item = $scope.title;

            $scope.optColWidth = 56;

            $scope.tableParams = new NgTableParams({
                page: 1,
                count: 10,
                sorting: {
                    sorting: 'asc'
                }
            }, {
                counts: [5, 10, 15],
                total: 0,
                getData: function ($defer, params) {
                    if (!$scope.cachedData) {
                        Data.query(function (data) {
                            $scope.cachedData = data;
                            angular.forEach(data, function (data) {
                                data.sorting = parseInt(data.sorting);
                                data.id = parseInt(data.id)
                            });
                            if (data.length > 0 && typeof data[0]['is_stop'] != 'undefined') {
                                $scope.has_stop = true;
                            }
                            Table.getTableData(data, $defer, params, $filter);
                        });
                    } else {
                        Table.getTableData($scope.cachedData, $defer, params, $filter);
                    }
                }
            });

            $scope.tableReload = function () {
                $scope.cachedData = null;
                $scope.tableParams.reload();
            };

            $scope.add = function () {
                dialogs.create('templates/basic/data_dlg.html', 'BasicDataDlgCtrl', {title: $scope.title}, {
                    size: 'md'
                }).result.then(function (data) {
                    Data.save(data).$promise.then(function (data) {
                        toaster.success(item + '添加成功!');
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '添加失败!');
                    })
                });
            };

            $scope.edit = function (data) {
                data.$edit = true;
                data.$nameChanged = data.name;
                data.$sortingChanged = data.sorting;
            };

            $scope.save = function (data) {
                data.$edit = false;
                if (data.$nameChanged == "") {
                    toaster.error(item + '名称不能为空!');
                } else if (data.name != data.$nameChanged || data.sorting != data.$sortingChanged) {
                    var params = {};
                    params['name'] = data.$nameChanged;
                    params['sorting'] = data.$sortingChanged;
                    Data.update({id: data.id}, params).$promise.then(function () {
                        toaster.success(item + '修改成功!');
                        data.name = data.$nameChanged;
                        data.sorting = parseInt(data.$sortingChanged);
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function (error) {
                        toaster.error(item + '修改失败!');
                    });
                }
            };

            $scope.delete = function (data) {
                dialogs.confirm('删除' + item, '确定要删除<strong>' + data.name + '</strong>' + item + '吗?')
                    .result.then(function () {
                    Data.delete({id: data.id}).$promise.then(function (data) {
                        switch (data.result) {
                            case 0:
                                toaster.success(item + '删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该' + item + '的员工记录,因此无法删除该分类!');
                                break;
                        }
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '删除失败!');
                    });
                });
            };
        };

        return {
            templateUrl: 'directives/main/basic-data-table/basic-data-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'serverName': '@',
                'maxProtectId': '@'
            },
            controller: controller
        }
    });
angular.module('c.d')
    .directive('breadcrumb', function () {
        return {
            templateUrl: 'templates/cache/breadcrumb.html',
            restrict: 'E',
            replace: true,
            scope: {
                'current': '@',
                'parent': '@'
            },

            controller: function ($scope, dialogs, Auth, C, $rootScope, $state, $timeout, Schedule) {
                $scope.clickToHis = function () {
                    dialogs.create('directives/main/his-dlg/his-dlg.html',
                        'HisLinkDlgCtrl', {}, {
                            size: 'lg'
                        }).result.then(function (params) {

                    });
                };
                $scope.clickHisForm = function () {
                    var user = Auth.getAccount();

                    dialogs.create(C.T + 'his/user_extend.html', 'HisUserExtentDlgCtrl', {
                        user: user, isEdit: false
                    }, {size: 'md'});
                };
                //  信息科当前值班信息
                Schedule.query({opt: 8}, function (resp) {
                    $scope.infoDeptDuty = resp.infoDeptDuty;
                });
            }
        }
    });
angular.module('c.d')
    .directive('carPendingTable', function () {
        var controller = function ($scope, $filter, $rootScope, dialogs, toaster, NgTableParams, CApply,
                                   $templateRequest, $sce, $timeout, Auth, F) {
                var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
                $scope.yesNo = F.get('yesNo');
                var stage_list2 = F.getNgTableOpts(F.get('stage_list2'));
                $scope.stage_list2 = F.get('stage_list2');

                $scope.cols = [
                    {title: '详情', field: 'more', show: true},
                    {
                        title: '状态',
                        filter: {'car_applications.status': 'select'},
                        field: 'status',
                        data: stage_list2,
                        show: true
                    },
                    {
                        title: '申请人',
                        filter: {'users.name': 'text'},
                        field: 'users.name',
                        show: true
                    }
                    , //6
                    {
                        title: '科室',
                        field: 'dept_id',
                        show: true
                    }
                    , //6
                    {
                        title: '车型',
                        filter: {'car_applications.type_id': 'select'},
                        field: 'type_id',
                        show: true
                    }
                    , //6
                    {
                        title: '出发时间', filter: {start_time: 'date_range'},
                        field: 'start_time', show: true
                    }
                    ,
                    {
                        title: '返程时间', filter: {end_time: 'date_range'},
                        field: 'end_time', show: true
                    }
                    ,
                    {
                        title: '申请时间', filter: {created_at: 'date_range'},
                        field: 'created_at', show: true
                    }
                    ,
                    {
                        title: '是否滴滴用车', filter: {is_de: 'select'},
                        field: 'is_de', show: true, data: yesNoOpts
                    }

                ];

                $scope.$on('fresh', function () {
                    $scope.tableParams.reload();
                });
                $scope.type_cols = $scope.cols[4];
                $scope.user_cols = $scope.cols[2];
                $scope.optColWidth = 70;
                $scope.optInFront = true;
                $scope.dateRangeFilter = {};

                if ($scope.opt == 1 || $scope.opt == 2 || $scope.opt == 11) {
                    $scope.user_cols.show = false;
                }

                if ($scope.opt == 2 || $scope.opt == 4 || $scope.opt == 11) {
                    $scope.hideOpt = true;
                }

                $scope.$watch(
                    function () {
                        return $scope.dateRangeFilter;
                    },
                    function () {
                        $scope.tableParams.reload();
                    }, true
                );

                $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                    counts: [10, 30, 50], total: 0,
                    getData: function ($defer, params) {
                        var url = params.url();
                        url['opt'] = $scope.opt;
                        var startDate, endDate;
                        if ($scope.dateRangeFilter.created_at != null) {
                            startDate = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                            endDate = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                            url['date_range_filters'] = {
                                created_at: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            };
                        }
                        if ($scope.dateRangeFilter.start_time != null) {
                            startDate = $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd');
                            endDate = $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd');
                            url['date_range_filters'] = {
                                start_time: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            };
                        }
                        if ($scope.dateRangeFilter.end_time != null) {
                            startDate = $filter('date')($scope.dateRangeFilter.end_time.startDate, 'yyyy-MM-dd');
                            endDate = $filter('date')($scope.dateRangeFilter.end_time.endDate, 'yyyy-MM-dd');
                            url['date_range_filters'] = {
                                end_time: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            };
                        }
                        CApply.query(url, function (data) {
                            $scope.types = data.types;
                            $scope.type_cols.data = F.getNgTableOpts(data.types);
                            params.total(data.total);
                            $defer.resolve(data.records);
                        });
                    }
                });
                $scope.tableReload = function () {
                    $scope.tableParams.reload();
                };

                $scope.clearFilters = function () {
                    $scope.dateRangeFilter = {};
                    $scope.tableParams.filter({});
                };

                //编辑用车申请
                $scope.edit = function (record) {
                    $scope.tabs['apply'] = true;
                    $timeout(function () {
                        $rootScope.$broadcast('carEdit', record);
                    }, 200);
                };
                //删除用车申请
                $scope.delete = function (record) {
                    dialogs.confirm('删除用车申请', '确定要删除<strong>' + record.type.name + '</strong>的记录吗?')
                        .result.then(function () {
                        CApply.delete({id: record.id}).$promise.then(function () {
                            toaster.success('用车申请删除成功!');
                            $scope.tableReload();
                        }, function () {
                            toaster.error('用车申请删除失败!');
                        });
                    });
                };

                //分配车辆
                $scope.assign = function (record) {
                    dialogs.create('/templates/car_manage/car_pending_dlg.html', 'CarPendingDlgCtrl', {
                        record: record
                    }, {
                        size: 'lg'
                    }).result.then(function (para) {
                        $scope.tableReload();
                        $rootScope.$broadcast('fresh');
                    });
                };

                //审批同意
                $scope.agree = function (record) {
                    dialogs.confirm('用车审批', '确定要同意<strong>' + record.user_name + '</strong>的用户申请吗?')
                        .result.then(function () {
                        var data = {};
                        data['status'] = 3;
                        CApply.update({id: record.id}, data).$promise.then(function () {
                            $rootScope.$broadcast('fresh');
                        }, function (error) {
                            toaster.error('审批失败!');
                        });
                    });

                };

                //审批拒绝
                $scope.disagree = function (record) {
                    dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                        title: '退回车辆申请',
                        icon: 'reply',
                        label: '原因'
                    }, {
                        size: 'sm'
                    }).result.then(function (pa) {
                        var user = Auth.getAccount();
                        var params = {};
                        params['refuse'] = pa;
                        if ($scope.opt == 3) {  //如果是科室审批
                            params['status'] = 2;
                        } else if ($scope.opt == 5) {  //院办审批
                            params['status'] = 4;
                        }
                        params['confirm_id'] = user.id;
                        params['confirm_time'] = $filter('date')(new Date(), 'yyyy-MM-dd MM:HH');
                        CApply.update({id: record.id}, params).$promise.then(function () {
                            toaster.success('退回成功!');
                            $rootScope.$broadcast('fresh');
                        }, function () {
                            toaster.error('退回失败!');
                        })
                    });
                };

                //撤消派车
                $scope.cancel = function (record) {
                    dialogs.confirm('用车撤消', '确定要撤消<strong>' + record.user_name + '</strong>的派车吗?')
                        .result.then(function () {
                        var data = {};
                        data['status'] = 5;
                        CApply.update({id: record.id}, data).$promise.then(function () {
                            toaster.success('撤消成功!');
                            $rootScope.$broadcast('fresh');
                        }, function (error) {
                            toaster.error('审批失败!');
                        });
                    });
                };

                //出发前里程填写
                $scope.pre_fill = function (record) {
                    dialogs.create('templates/basic/float_dlg.html', 'FloatDlgCtrl', {
                        title: '派车里程填写',
                        icon: 'reply',
                        label: '出发里程'
                    }, {

                        size: 'md'
                    }).result.then(function (pa) {
                        var params = {};
                        params['pre_mile'] = pa;
                        params['status'] = 7;
                        CApply.update({id: record.id}, params).$promise.then(function () {
                            toaster.success('出发里程填写成功!');
                            $scope.tableReload();
                        }, function () {
                            toaster.error('出发里程填写失败!');
                        })
                    });
                };

                //回程里程填写
                $scope.later_fill = function (record) {
                    dialogs.create('templates/basic/float_dlg.html', 'FloatDlgCtrl', {
                        title: '派车里程填写',
                        icon: 'reply',
                        label: '回程里程'
                    }, {

                        size: 'md'
                    }).result.then(function (pa) {
                        var params = {};
                        params['later_mile'] = pa;
                        params['status'] = 8;
                        CApply.update({id: record.id}, params).$promise.then(function () {
                            toaster.success('回程里程填写成功!');
                            $scope.tableReload();
                        }, function () {
                            toaster.error('回程里程填写失败!');
                        })
                    });
                };


                //打印派车单
                var templateUrl = $sce.getTrustedResourceUrl('templates/print/table2.html');
                var printStyle;
                $templateRequest(templateUrl).then(function (resp) {
                    printStyle = resp;
                });
                $scope.print = function (record) {
                    var w = window.open("", "打印预览");

                    var html = '<html><body>';

                    html += '<table class="print">' +
                        '<caption>成办医院派车单</caption>' +
                        '<tbody><tr>';
                    html += '<td width="120" rowspan="4">申请部门填写</td>';
                    html += '<td width="180">用车事由</td>';
                    html += '<td colspan="5" width="600">' + record.remarks + '</td>';

                    html += '</tr>';

                    html += '<tr><td width="120">目的地</td>';
                    html += '<td colspan="5">' + (record.de ? record.de.name : record.destination) + '</td>';
                    html += '</tr>';
                    html += '<tr><td width="180">搭乘人员</td>';
                    html += '<td colspan="5" width="200">';
                    angular.forEach(record.passengers, function (u) {
                        html += u.user.name + '&nbsp;';
                    });
                    html += record.out_passenger;
                    html += '</td>';
                    html += '</tr>';
                    html += '<tr><td width="120">出发时间</td>';
                    html += '<td width="200">' + record.start_time + '</td>';
                    html += '<td width="120">申请人</td>';
                    html += '<td width="200">' + record.user_name + '</td>';
                    html += '<td width="120">科室负责人</td>';
                    html += '<td width="200">' + record.dept_charge.name + '</td>';
                    html += '</tr>';
                    html += '<tr>';
                    html += '<td width="120">审核部门填写</td>';
                    html += '<td width="120">车牌号</td>';
                    html += '<td width="200">' + record.plate_num + '</td>';
                    html += '<td width="120">驾驶员</td>';
                    html += '<td width="200">' + record.driver.name + '</td>';
                    html += '<td width="120">派车人</td>';
                    html += '<td width="200">' + record.confirm.name + '</td>';
                    html += '</tr>';
                    html += '<tr>';
                    html += '<td width="120">驾驶员填写</td>';
                    html += '<td width="120">出车前里程</td>';
                    html += '<td width="200">' + record.pre_mile + '</td>';
                    html += '<td width="120">收车后里程</td>';
                    html += '<td width="200">' + record.later_mile + '</td>';
                    html += '<td width="120">收车时间</td>';
                    html += '<td width="300">' + record.end_time + '</td>';
                    html += '</tr>';
                    html += '</tbody></table></body></html>';

                    w.document.write(html + printStyle);
                    w.document.close();
                    w.focus();
                    $timeout(function () {
                        w.print();
                        w.close();
                    }, 24);
                };


            }
        ;

        return {
            templateUrl: 'directives/main/car-pending-table/car-pending-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@',   //表明是哪个步骤在审批
                'approved': '@'
            },
            controller: controller
        }
    });

angular.module('c.c').controller('CarPendingDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, $filter, toaster, CApply, Car, Driver,
              Auth, F, uibDateParser, data, FormHelper) {

        $scope.CarLFees = F.get('CarLFees');
        var apply = data.record;
        $scope.apply = apply;
        $scope.apply['send_driver'] = true;
        $scope.apply['send_passenger'] = true;

        var item = F.getItem(apply.destination, $scope.CarLFees, 'name');
        if (item) {
            $scope.apply['fee'] = item.money;
            //消毒供应室申请车辆时不扣费
            if (apply.dept_id == 42) {
                $scope.apply['fee'] = 0;
            }
            if (apply.type_id == 3) {
                $scope.apply['fee'] = 0;
            }
        }

        var user = Auth.getAccount();

        $scope.$watch('apply.car', function (newV, oldV) {

            if (newV.plate_num == '滴滴用车') {
                $scope.isDe = true;
            } else {
                $scope.isDe = false;
            }
        });


        $scope.is_common = apply.type_id == 1 || apply.type_id == 2;

        // console.log($scope.is_common);
        // console.log($scope.isDe);
        // console.log($scope.is_common&&!$scope.isDe);
        if (!$scope.is_common) {
            $scope.offset = "col-md-offset-3";
        } else {
            $scope.offset = '';
        }

        Car.query({opt: 2, start: apply.start_time, end: apply.end_time, type_id: apply.type_id}, function (resp) {
            $scope.cars = resp.records;
            $scope.apply['car'] = $scope.cars[0];
            $scope.cars.push({plate_num: '滴滴用车', limit_day: '无'});
        });

        Driver.query({opt: 2, start: apply.start_time, end: apply.end_time, type_id: apply.type_id}, function (resp) {
            $scope.drivers = resp.duty_drivers;
        });

        $scope.ok = function (apply) {
            if ($scope.c_form.$valid) {
                var params = {};
                if ($scope.isDe) {//滴滴用车
                    params['is_de'] = true;
                    params['d_driver'] = apply.d_driver;
                    params['d_plate_num'] = apply.d_plate;
                    params['d_pay'] = apply.d_pay;
                    params['d_phone'] = apply.d_phone;
                    params['status'] = 8;
                } else {
                    params['car_id'] = apply.car.id;
                    params['driver_id'] = apply.driver.id;
                    params['send_driver'] = apply.send_driver;
                    params['fee'] = apply.fee;
                    params['status'] = 6;
                }
                params['confirm_id'] = user.id;
                params['confirm_time'] = $filter('date')(new Date(), 'yyyy-MM-dd MM:HH');
                params['send_passenger'] = apply.send_passenger == true ? 1 : 0;
                CApply.update({id: apply.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('审批成功!');
                            $uibModalInstance.close(1);
                            break;
                        case 1:
                            toaster.warning('有同事审批过啦,此申请已处理!');
                            $uibModalInstance.close(1);
                            break;
                    }
                }, function () {
                    toaster.error('审批失败!');
                })
            } else {
                // toaster.warning('请填写预估费用!');
                FormHelper.handleError('#Form', $scope.c_form);
            }

        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });






angular.module('c.d')
    .directive('cashTable', function () {
        var controller = function ($scope, $filter, $rootScope, dialogs, toaster, NgTableParams, UCashBalance, Table) {

            var vm = $scope;
            vm.add = add;
            vm.check = check;
            init();

            function init() {
                var options = {
                    service: UCashBalance,
                    params: {opt: vm.opt},
                    optColWidth: Table._2_BTN,
                    showSn: true,
                    hideOpt: true,
                    cols: [
                        {field: "user", title: "姓名", filter: {user: "text"}},
                        {field: "dept", title: "科室"},
                        {field: "rent_fee", title: "住房"},
                        {field: "park_fee", title: "停车"},
                        {field: "money", title: "金额"},
                        {field: "balance", title: "余额"},
                        {field: "created_at", title: "充值时间", filter: {created_at: "date_range"}},
                        {field: "handler_id", title: "充值人"}
                    ]
                };
                Table.load(vm, options);
            }

            function add() {
                dialogs.create('/templates/cash/cash_dlg.html', 'CashBalanceDlgCtrl', {}, {size: 'md'})
                    .result.then(function (cash) {
                    UCashBalance.save(cash).$promise.then(function () {
                        toaster.success('保存成功');
                        vm.tableReload();
                    });
                });
            }

            function check(record) {
                dialogs.create('templates/cash/check.html', 'CashCheckCtrl', {
                    record: record
                }, {
                    size: 'lg'
                });
            }

        };

        return {
            templateUrl: 'directives/main/cash-table/cash-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@'   //表明是哪个步骤在审批
            },
            controller: controller
        }
    });

angular.module('c.c').controller('CashBalanceDlgCtrl',
    function ($scope, $uibModalInstance, toaster) {

        var vm = $scope;
        vm.ok = ok;
        vm.cash = {};
        vm.cancel = $uibModalInstance.dismiss;

        function ok(cash) {
            if (!cash.user) {
                toaster.warning('充值对象必选!');
            } else if (vm.Form.$valid) {
                var pa = {};
                pa['user_id'] = cash.user.id;
                pa['money'] = cash.money;
                pa['remark'] = cash.remark;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });

angular.module('c.c').controller('CashCheckCtrl',
    function ($scope, $uibModalInstance, toaster, data, F, Table, UCashBalance) {

        var vm = $scope;
        vm.record = data.record;
        vm.cancel = $uibModalInstance.dismiss;
        init();

        function init() {
            var options = {
                service: UCashBalance,
                params: {opt: 4, user_id: vm.record.user_id},
                showSn: true,
                hideFilter: true,
                hideOpt: true,
                cols: [
                    {field: "rent_fee", title: "住房"},
                    {field: "park_fee", title: "停车"},
                    {field: "money", title: "金额"},
                    {field: "balance", title: "余额"},
                    {field: "created_at", title: "充值时间"}
                ]
            };
            Table.load(vm, options);
        }


    });







angular.module('c.d')
    .directive('directFeeApprovalTable', function () {
        var controller = function ($scope, $filter, dialogs, toaster, NgTableParams, DutyReport, DateHelper, F,
                                   DutyGroup, Dlg) {

            var yesOrNo = F.getNgTableOpts(F.get('yesNo'));
            $scope.group_types = F.get('dutyGroupTypes');
            var group_types = F.getNgTableOpts($scope.group_types);

            $scope.cols = [
                //{
                //    title: '值班月份',
                //    sortable: 'duty_reports.month',
                //    filter: {month: 'date_range'},
                //    field: 'month',
                //    show: true
                //},
                {
                    title: '值班组',
                    sortable: 'duty_reports.group_id',
                    filter: {group_id: 'select'},
                    field: 'group_id',
                    show: true
                },
                {
                    title: '额定总值班人次',
                    sortable: 'rated_count',
                    filter: {rated_count: 'number_range'},
                    field: 'rated_count',
                    width: '15%',
                    show: true
                }, //6
                {
                    title: '实际总值班人次',
                    sortable: 'total_count',
                    filter: {total_count: 'number_range'},
                    field: 'total_count',
                    width: '15%',
                    show: true
                }, //6
                {
                    title: '总值班费用',
                    sortable: 'total_fee',
                    filter: {total_fee: 'number_range'},
                    field: 'total_fee',
                    width: '15%',
                    show: true
                }, //6
                //{title: '申报人', filter: {'users.name': 'text'}, field: 'declarant', width: '10%', show: true}, //0
                {title: '申报时间', field: 'declare_time', show: true}
                //{
                //    title: '是否确认',
                //    filter: {'duty_reports.is_confirmed': 'select'},
                //    field: 'is_confirmed',
                //    width: '10%',
                //    data: yesOrNo,
                //    show: true
                //} //6
            ];
            $scope.optColWidth = 70;
            $scope.groups_col = $scope.cols[0];

            $scope.numRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.numRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            var date = new Date((new Date()).setDate(1));
            $scope.dts = new Date(date.setMonth(date.getMonth() - 1));
            $scope.dte = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $scope.prevMonth = function (curr) {
                var prev = curr.getMonth() - 1;
                $scope.dts = new Date(curr.setMonth(prev));
                $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
            };
            $scope.nextMonth = function (curr) {
                var next = curr.getMonth() + 1;
                $scope.dts = new Date(curr.setMonth(next));
                $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
            };

            $scope.$watch('dts', function (newVal, oldVal, scope) {
                $scope.tableParams.reload();
            }, true);

            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                counts: [5, 10], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    if ($scope.numRangeFilter.rated_count) {
                        url['rated_count_start'] = $scope.numRangeFilter.rated_count.start;
                        url['rated_count_end'] = $scope.numRangeFilter.rated_count.end;
                    }
                    if ($scope.numRangeFilter.total_count) {
                        url['total_count_start'] = $scope.numRangeFilter.total_count.start;
                        url['total_count_end'] = $scope.numRangeFilter.total_count.end;
                    }
                    url['date_range_filters'] = {
                        month: {
                            startDate: $filter('date')($scope.dts, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dte, 'yyyy-MM-dd')
                        }
                    };
                    url['opt'] = $scope.opt;
                    DutyReport.query(url, function (resp) {
                        $scope.duty_set = resp.duty_set;
                        $scope.duty_groups = resp.duty_groups;
                        // console.log('sey',resp.duty_groups);

                        for (var i = 0; i < resp.duty_groups.length; i++) {
                            if (resp.duty_groups[i].shifts != null) {
                                resp.duty_groups[i].name = resp.duty_groups[i].name + '('+resp.duty_groups[i].shifts+')';
                            }
                        }
                        // console.log('y',resp.duty_groups);
                        $scope.groups_col.data = F.getNgTableOpts(resp.duty_groups);
                        params.total(resp.total);
                        $scope.groups = resp.groups;
                        $defer.resolve(resp.records);
                    });
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.numRangeFilter = {};
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            $scope.add = function () {
                dialogs.create('templates/duty_fee/duty_report_dlg.html', 'DutyReportDlgCtrl', {
                    duty_groups: $scope.duty_groups
                }, {
                    size: 'md'
                }).result.then(function (report) {
                    report['direct'] = 1;
                    DutyReport.save(report).$promise.then(function (data) {
                        $scope.tableReload();
                        DutyReport.query({
                            opt: 8,
                            month: report['month'],
                            group_id: report['group_id'],
                            from_nurse: $scope.opt == 5 ? 1 : 0,
                        }, function (resp) {
                            angular.forEach(resp.members, function (m) {
                                m['is_checked'] = false;
                            });
                            dialogs.create('DutyReportMembersDlg.html', 'DutyReportMembersCtrl',
                                {
                                    report: resp.report,
                                    duty_set: $scope.duty_set,
                                    direct: true,
                                    members: resp.members,
                                    opt: 1
                                }, {
                                    size: 'md'
                                }).result.then(function () {
                                $scope.tableParams.reload();
                            });
                        });
                    }, function () {
                        toaster.error('申报月份重复,申报失败!');
                    });
                });
            };

            // 申报值班组值班费
            $scope.g_direct = function (group) {
                var params = {};
                var y = $scope.dte.getFullYear();
                var m = $scope.dte.getMonth() + 1;
                var day = DateHelper.getDaysInMonth(m, y);
                params['direct'] = 1;
                params['group_id'] = group.id;
                params['month'] = $filter('date')($scope.dts, 'yyyy-MM-dd');
                //以前没有区分是否按周  不知道前几个月的数据是如何生成的
                if (group.by_week == '1') {
                    params['rated_count'] = 4 * group.num;
                } else {
                    params['rated_count'] = day * group.num;
                }
                DutyReport.save(params).$promise.then(function (data) {
                    DutyReport.query({
                        opt: 8,
                        month: params['month'],
                        group_id: params['group_id'],
                        from_nurse: $scope.opt == 5 ? 1 : 0,
                    }, function (resp) {
                        dialogs.create('DutyReportMembersDlg.html', 'DutyReportMembersCtrl',
                            {
                                report: resp.report,
                                duty_set: $scope.duty_set,
                                direct: true,
                                members: resp.members,
                                opt: 1
                            }, {
                                size: 'md'
                            });
                    });
                }).finally(function () {
                    $scope.tableParams.reload();
                });
            };

            $scope.member = function (report) {
                dialogs.create('DutyReportMembersDlg.html', 'DutyReportMembersCtrl',
                    {report: report, opt: 1, view: 1, duty_set: $scope.duty_set}, {
                        size: 'md'
                    }).result.then(function () {
                    $scope.tableParams.reload();
                });
            };

            $scope.declare = function (report) {
                var para = {};
                para['is_confirmed'] = 1;
                para['is_declared'] = 1;
                DutyReport.update({id: report.id}, para).$promise.then(function (data) {
                    toaster.success('值班组申报成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('值班组申报失败!');
                });
            };

            $scope.hide = function (m) {
                DutyGroup.update({id: m.id}, {opt: 3, is_hide: !m.is_hide}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $scope.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            };

            $scope.delete = function (report) {
                dialogs.confirm('删除科室记录', '确定要删除<strong>' + report.group_name + '</strong>的值班申报吗?')
                    .result.then(function () {
                    DutyReport.delete({id: report.id}).$promise.then(function () {
                        toaster.success('值班组申报删除成功!');
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('值班组申报删除失败!');
                    });
                });

            };
        };

        return {
            templateUrl: 'directives/main/direct-fee-approval/direct-fee-approval-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@'
            },
            controller: controller
        }
    });





//angular.module('c.d')
//    .directive('dutyFeeApprovalTable', function () {
//        var controller = function ($scope, $filter, dialogs, toaster, NgTableParams, DutyReport, F) {
//
//
//            var yesOrNo = F.getNgTableOpts(F.get('yesNo'));
//
//            $scope.cols = [
//                //{
//                //    title: '值班月份',
//                //    sortable: 'duty_reports.month',
//                //    filter: {month: 'date_range'},
//                //    field: 'month',
//                //    show: true
//                //},
//                {
//                    title: '值班组',
//                    sortable: 'duty_reports.group_id',
//                    filter: {group_id: 'select'},
//                    field: 'group_id',
//                    show: true
//                },
//                {
//                    title: '额定总值班人次',
//                    sortable: 'rated_count',
//                    filter: {rated_count: 'number_range'},
//                    field: 'rated_count',
//                    width: '15%',
//                    show: true
//                }, //6
//                {
//                    title: '实际总值班人次',
//                    sortable: 'total_count',
//                    filter: {total_count: 'number_range'},
//                    field: 'total_count',
//                    width: '15%',
//                    show: true
//                }, //6
//                {
//                    title: '总值班费用',
//                    sortable: 'total_fee',
//                    filter: {total_fee: 'number_range'},
//                    field: 'total_fee',
//                    width: '15%',
//                    show: true
//                }, //6
//                {title: '申报人', filter: {'users.name': 'text'}, field: 'declarant', width: '10%', show: true}, //0
//                {title: '申报时间', field: 'declare_time', show: true},
//                {
//                    title: '是否确认',
//                    filter: {'duty_reports.is_confirmed': 'select'},
//                    field: 'is_confirmed',
//                    width: '10%',
//                    data: yesOrNo,
//                    show: true
//                } //6
//            ];
//            $scope.optColWidth = 70;
//            $scope.groups_col = $scope.cols[0];
//
//            $scope.numRangeFilter = {};
//            $scope.$watch(
//                function () {
//                    return $scope.numRangeFilter;
//                },
//                function (newValue, oldValue) {
//                    $scope.tableParams.reload();
//                }, true
//            );
//
//            var date = new Date((new Date()).setDate(1));
//            $scope.dts = new Date(date.setMonth(date.getMonth() - 1));
//            $scope.dte = new Date(date.getFullYear(), date.getMonth() + 1, 0);
//            $scope.prevMonth = function (curr) {
//                var prev = curr.getMonth() - 1;
//                $scope.dts = new Date(curr.setMonth(prev));
//                $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
//            };
//            $scope.nextMonth = function (curr) {
//                var next = curr.getMonth() + 1;
//                $scope.dts = new Date(curr.setMonth(next));
//                $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
//            };
//
//            $scope.$watch('dts', function (newVal, oldVal, scope) {
//                $scope.tableParams.reload();
//            }, true);
//
//            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
//                counts: [5, 10], total: 0,
//                getData: function ($defer, params) {
//                    var url = params.url();
//                    if ($scope.numRangeFilter.rated_count) {
//                        url['rated_count_start'] = $scope.numRangeFilter.rated_count.start;
//                        url['rated_count_end'] = $scope.numRangeFilter.rated_count.end;
//                    }
//                    if ($scope.numRangeFilter.total_count) {
//                        url['total_count_start'] = $scope.numRangeFilter.total_count.start;
//                        url['total_count_end'] = $scope.numRangeFilter.total_count.end;
//                    }
//                    url['date_range_filters'] = {
//                        month: {
//                            startDate: $filter('date')($scope.dts, 'yyyy-MM-dd'),
//                            endDate: $filter('date')($scope.dte, 'yyyy-MM-dd')
//                        }
//                    };
//                    url['opt'] = $scope.opt;
//                    DutyReport.query(url, function (resp) {
//
//                        $scope.duty_groups = resp.duty_groups;
//                        $scope.groups_col.data = F.getNgTableOpts(resp.duty_groups);
//                        params.total(resp.total);
//                        $defer.resolve(resp.records);
//                    });
//                }
//            });
//
//            $scope.tableReload = function () {
//                $scope.tableParams.reload();
//            };
//
//            $scope.clearFilters = function () {
//                $scope.numRangeFilter = {};
//                $scope.dateRangeFilter = {};
//                $scope.tableParams.filter({});
//            };
//
//            $scope.member = function (report) {
//                dialogs.create('DutyReportMembersDlg.html', 'DutyReportMembersCtrl',
//                    {report: report, opt: 2, view: 1}, {
//                         size: 'md'
//                    }).result.then(function () {
//                        $scope.tableParams.reload();
//                    });
//            };
//        };
//
//        return {
//            templateUrl: 'directives/main/duty-fee-approval/duty-fee-approval-table.html',
//            restrict: 'E',
//            replace: true,
//            scope: {
//                'opt': '@'
//            },
//            controller: controller
//        }
//    });
//
//
//
//

(function () {
    'use strict';

    angular.module('c.d')
        .directive('footer', footer);

    /** @ngInject */
    function footer(Auth) {
        return {
            templateUrl: 'templates/cache/footer.html',
            restrict: 'E',
            replace: true,
            link: function (scope) {
                scope.vc = Auth.getVisitCnt();
            }
        }
    }
})();

angular.module('c.d')
    .directive('handleNewsTable', function () {
        var controller = function ($scope, $state, $filter, dialogs, toaster, F, Table, News, NewsType) {
            var vm = $scope;
            vm.approval = approval;
            vm.check = check;
            vm.stages = F.get('NewsStages');
            vm.yesNo = F.get('yesNo');
            init();

            var types;

            NewsType.query(function (data) {
                types = data.types;
            });

            function init() {
                var options = {
                    service: News,
                    params: {opt: vm.opt/*SEARCH NEWS*/},
                    optColWidth: Table._4_BTN,
                    showSn: true,
                    cols: [
                        {field: "title", title: "标题", filter: {title: "text"}},
                        {
                            field: 'created_at',
                            title: '发布时间',
                            sortable: 'created_at',
                            filter: {created_at: 'date_range'}
                        },
                        {
                            field: "type",
                            title: "新闻类型",
                            filter: {type: "select"},
                            data: F.getNgTableOpts(types)
                        },
                        {
                            field: "out",
                            title: "发布外网",
                            filter: {out: "select"},
                            data: F.getNgTableOpts(vm.yesNo)
                        },
                        {
                            field: "is_pass",
                            title: "状态",
                            filter: {is_pass: "select"},
                            data: F.getNgTableOpts(vm.stages)
                        },
                        {field: "sender_id", title: "申请人", filter: {send_id: "text"}}
                    ]
                };
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (i) {
                        i.stage = F.getItem(i.is_pass, vm.stages);
                    })
                });
            }

            function approval(news) {
                dialogs.create('templates/article/news_edit.html', 'DeptEditNewsCtrl', {
                    id: news.id, types: types, edit: false, opt: vm.opt
                }, {
                     size: 'lg'
                }).result.then(function () {
                        vm.tableParams.reload();
                    });
            }

            function check(news) {
                dialogs.create('templates/article/show_dlg.html', 'NewsShowDlgCtrl', {
                    id: news.id
                }, {
                     size: 'lg'
                });
            }

        };

        return {
            templateUrl: 'directives/main/handle-news-table/handle-news-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@'
            },
            controller: controller
        }
    });






(function () {
    'use strict';
    angular.module('c.d')
        .directive('header', function () {
            return {
                templateUrl: 'templates/cache/header.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'header'
            }
        });

    /** @ngInject */
    function ctrl($rootScope, $scope, $state, $timeout, $http, $q, dialogs, C, Regex,
                  ArrayHelper, Auth, Email, ipCookie, RouteHelper, ExtHelper) {
        var ss = window.innerWidth > 768;
        var vm = this;
        vm.toggleSidebar = toggleSidebar;
        //header-notification
        vm.mails = [];
        vm.tasks = [];
        vm.menus = [];
        vm.account = Auth.getAccount();
        var firstToggle = true;
        var firstMenu = true;
        vm.toggleTaskD = toggleTaskD;
        vm.callFrozenDlg = callFrozenDlg;
        vm.callAiDlg = callAiDlg;
        vm.callImmunityDlg = callImmunityDlg;
        vm.reloadMenu = reloadMenu;
        vm.toggleMenuD = toggleMenuD;
        vm.goMenu = goMenu;
        vm.forum = forum;
        vm.homeCS = homeCS;
        vm.toEQS = toEQS;
        vm.logout = logout;
        vm.toLongDownload = toLongDownload;

        init();


        function init() {
            // $http.post(C.URL.TASK_HAS, {}).success(function (resp) { // main.js 统一加载
            //     vm.hasTask = resp.has;
            // });

            $scope.$on('showSidebar', function (event, showSidebar) {
                ss = showSidebar;
            });

            $scope.$on(C.P + 'mail.withdraw', function (event, data) {
                var mail = data.data.mail;

                var i = ArrayHelper.indexOfKey(mail.id, vm.mails);
                if (i >= 0) {
                    vm.mails.splice(i, 1);
                }
            });

            $scope.$on('mail.send', function (event, data) {
                var mail = data;
                vm.mails.splice(0, 0, {id: mail.id, subject: mail.subject, created_at: mail.created_at});
            });

            $scope.$on('mailRead', function (event, data) {
                vm.mails = ArrayHelper.except(data, vm.mails);
            });

            $scope.$on('mailDel', function (event, data) {
                if (data) {
                    var id = data;
                    var i = ArrayHelper.indexOfKey(id, vm.mails);
                    if (i >= 0) {
                        vm.mails.splice(i, 1);
                    }
                } else {
                    loadUnreadMail();
                }
            });

            $scope.$on('openTaskD', function () {
                vm.showArrow = true;
            });

            $scope.$on('newTask', function (evt, data) {
                var task = data.task;

                if (firstToggle) {
                    firstToggle = false;
                    $http.post(C.URL.TASK_ALL, {}).success(function (tasks) {
                        vm.tasks = tasks;
                        vm.hasTask = tasks.length > 0;
                        addTask(task);
                    });
                } else {
                    addTask(task);
                }

                function addTask(task) {
                    var index = ArrayHelper.indexOfKey(task.type, vm.tasks, 'type');
                    if (index === -1) {
                        task.isNew = true;
                        vm.tasks.unshift(task);
                    } else {
                        vm.tasks[index].isNew = true;
                        var tmp = vm.tasks[index];
                        vm.tasks[index] = vm.tasks[0];
                        vm.tasks[0] = tmp;
                    }
                    vm.hasTask = vm.tasks.length > 0;

                    document.getElementById('msgTone2').play();
                    vm.shakePoint = true;
                    $timeout(function () {
                        vm.shakePoint = false;
                    }, 2000);
                }

            });

            $scope.$on('quickMenuChange', function () {
                reloadMenu();
            });

            ExtHelper.loadTasks(vm, 'tasks', 'hasTask', 'taskLoading');
            ExtHelper.loadMails(vm, 'mails', 'hasMail', 'mailLoading');

            // 到main.js中统一加载
            $rootScope.$broadcast('headerLoaded');
        }

        function toLongDownload() {
            var pa = {data: {tag: task.tag}};
            vm.tasks.splice(index, 1);
            vm.hasTask = vm.tasks.length > 0;
            if (task.state) {
                if ($state.current.name == task.state) {
                    $rootScope.$broadcast("tagChange", pa);
                } else {
                    $state.go(task.state, pa);
                }
            } else {
                //function list
                var fn = taskFnList[task.type];
                if (fn) fn();
                else alert("该事件没有处理方法");
            }
        }

        function toggleSidebar() {
            ss = !ss;
            $rootScope.$broadcast('showSidebar', ss);
        }

        ////////////////////////////////////////////////////////////////////////
        ////////////////////////header-notification
        function homeCS() {
            var token = Auth.getToken();
            var base = window.location.hostname;
            var cs;
            if (base.match(Regex.IP)) {
                cs = 'http://' + base + ':8086/admin#/sso';
            } else {
                //cs = 'http://home.' + base.replace("www.", "") + '/admin#/sso';
                cs = 'https://www.tcd120.cn/admin#/sso';
            }
            window.location.href = cs + '?token=' + token + "&backUrl=" + base;
        }

        function toEQS() {
            window.location.href = '/#/eqs_large_screen';
        }

        function toggleTaskD() {
            if (firstToggle) {
                vm.reloadTask();
                firstToggle = false;
            }
        }

        function toggleMenuD() {
            if (firstMenu) {
                reloadMenu();
                firstMenu = false;
            }
        }

        function reloadMenu() {
            var defer = $q.defer();
            vm.menuLoading = true;
            $http.get('/api/v1/quick_menus', {params: {op: 'user'}}).success(function (resp) {
                vm.menus = resp.items;
                var menus = [];
                angular.forEach(vm.menus, function (m) {
                    menus.push(parseInt(m.id));
                });
                console.log(menus);
                var routes = RouteHelper.getRoutes();
                angular.forEach(routes, function (r) {
                    var index = menus.indexOf(r[4]);
                    if (index >= 0) {
                        vm.menus[index].routeName = "app." + r[0];
                    }
                });
                defer.resolve();
            }).finally(function () {
                vm.menuLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function goMenu(menu) {
            // $state.go('app.coop_email');
            // console.log();
            // var routeName = menu.name.replace(/\./g, "_");
            // routeName = 'app.' + routeName.substring(4, routeName.length);
            // console.log(routeName);
            $state.go(menu.routeName, {});
        }

        function callFrozenDlg() {
            dialogs.create('templates/frozen/frozenAppointmentDlg.html', 'FrozenAppointmentDlgCtrl', {},
                {size: 'lg'}).result.then(function (params) {

            });
        }

        function callAiDlg() {
            dialogs.create('templates/ai/streamline.html', 'AIStreamlineDlgCtrl', {},
                {
                    size: 'lg',
                    backdrop: false,
                    windowClass: 'modal-right',
                    backdropClass: 'modal-backdrop-light',
                })
                .result.then(function (params) {
            });
        }

        function callImmunityDlg() {
            dialogs.create('templates/immunity/immunityDlg.html', 'ImmunityDlgCtrl', {},
                {size: 'md'}).result.then(function (params) {
            });
        }

        function loadUnreadMail() {
            // 只会拿最多10个
            Email.query({opt: 1}, function (resp) {
                vm.mails = resp.mails;
            });
        }

        function forum() {
            var token = Auth.getToken();
            ipCookie('token', token/*, {expires: 1, expirationUnit: 'minutes'}*/);
            $timeout(function () {
                var bbsUrl = C.URL.FORUM_SSO;
                window.location.href = bbsUrl;
            }, 360);
        }

        function logout() {
            Auth.logout(function () {
                watermark.remove();
                $state.go('login');
            });
        }
    }
})();

angular.module('c.d')
    .directive('hisBasicDataTable', function () {
        var controller = function ($rootScope, $scope, $filter, $injector, dialogs, toaster, NgTableParams, Table) {
            var Data = $injector.get($scope.serverName);
            if (angular.isUndefined($scope.maxProtectId)) {
                $scope.maxProtectId = 0;
            } else {
                $scope.maxProtectId = parseInt($scope.maxProtectId);
            }
            var item = $scope.title;

            $scope.optColWidth = 56;

            $scope.tableParams = new NgTableParams({
                page: 1,
                count: 10,
                sorting: {
                    sorting: 'asc'
                }
            }, {
                counts: [5, 10, 15],
                total: 0,
                getData: function ($defer, params) {
                    if (!$scope.cachedData) {
                        Data.query(function (data) {
                            $scope.cachedData = data;
                            angular.forEach(data, function (data) {
                                data.sorting = parseInt(data.sorting);
                                data.his_id = parseInt(data.his_id)
                                data.id = parseInt(data.id)
                            });
                            if (data.length > 0 && typeof data[0]['is_stop'] != 'undefined') {
                                $scope.has_stop = true;
                            }
                            Table.getTableData(data, $defer, params, $filter);
                        });
                    } else {
                        Table.getTableData($scope.cachedData, $defer, params, $filter);
                    }
                }
            });

            $scope.tableReload = function () {
                $scope.cachedData = null;
                $scope.tableParams.reload();
            };

            $scope.add = function () {
                dialogs.create('templates/basic/his_person_data_dlg.html', 'BasicDataDlgCtrl', {title: $scope.title}, {
                    size: 'md'
                }).result.then(function (data) {
                    Data.save(data).$promise.then(function (data) {
                        toaster.success(item + '添加成功!');
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '添加失败!');
                    })
                });
            };

            $scope.edit = function (data) {
                data.$edit = true;
                data.$nameChanged = data.name;
                data.$sortingChanged = data.sorting;
                data.$hisIdChanged = data.his_id;
            };

            $scope.save = function (data) {
                data.$edit = false;
                if (data.$nameChanged == "") {
                    toaster.error(item + '名称不能为空!');
                } else if (data.name != data.$nameChanged || data.sorting != data.$sortingChanged || data.his_id != data.$hisIdChanged) {
                    var params = {};
                    params['name'] = data.$nameChanged;
                    params['sorting'] = data.$sortingChanged;
                    params['his_id'] = data.$hisIdChanged;
                    Data.update({id: data.id}, params).$promise.then(function () {
                        toaster.success(item + '修改成功!');
                        data.name = data.$nameChanged;
                        data.sorting = parseInt(data.$sortingChanged);
                        data.his_id = parseInt(data.$hisIdChanged);
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function (error) {
                        toaster.error(item + '修改失败!');
                    });
                }
            };

            $scope.delete = function (data) {
                dialogs.confirm('删除' + item, '确定要删除<strong>' + data.name + '</strong>' + item + '吗?')
                    .result.then(function () {
                    Data.delete({id: data.id}).$promise.then(function (data) {
                        switch (data.result) {
                            case 0:
                                toaster.success(item + '删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该' + item + '的员工记录,因此无法删除该分类!');
                                break;
                        }
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '删除失败!');
                    });
                });
            };
        };

        return {
            templateUrl: 'directives/main/his-basic-data-table/his-basic-data-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'serverName': '@',
                'maxProtectId': '@'
            },
            controller: controller
        }
    });

angular.module('c.c').controller('HisLink2DlgCtrl',
    function ($scope, $uibModalInstance) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        vm.mainLink = 'http://10.104.84.4/imedical/web/csp/dhc.logon.csp';

        vm.accounts = [
            {
                id: 1,
                ico: 'file-archive-o',
                filename: "his_docs/dhzip.rar",
                mime: "application/zip",
                name: "医为浏览器一键安装配置.rar",
                size: "368249025"
            }
        ];
    }
);
angular.module('c.c').controller('HisLinkDlgCtrl',
    function ($scope, $uibModalInstance, dialogs) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        vm.mainLink = 'http://10.104.81.4/imedical/web';
        // vm.mainLink = 'http://10.104.81.4/imedical/web/csp/dhc.logon.csp';

        vm.accounts = [
            {
                id: 1,
                ico: 'file-excel-o',
                filename: "his_docs/o8ehRCPz.xlsx",
                mime: "application/wps-office.xlsx",
                name: "所有测试账号.xlsx",
                size: "13453"
            },
            {
                id: 2,
                ico: 'file-excel-o',
                filename: "his_docs/yizhu.xlsx",
                mime: "application/wps-office.xlsx",
                name: "测试医嘱列表.xlsx",
                size: "9457"
            }
        ];

        vm.openHisDlg = function () {
            dialogs.create('directives/main/his-dlg/his-dlg-2.html',
                'HisLink2DlgCtrl', {}, {
                    size: 'lg'
                }).result.then(function (params) {

            });
        };
    }
);
angular.module('c.d')
    .directive('houseRentTable', function () {
        var controller = function ($scope, $filter, $rootScope, dialogs, toaster, NgTableParams, HouseRent, F,$q,FileHelper) {

            $scope.$on('fresh', function () {
                $scope.tableParams.reload();
            });

            $scope.pay_types = F.get('pay_types');
            var pay_types = F.getNgTableOpts($scope.pay_types);
            $scope.situations = HouseRent.getSituations();
            var situations = F.getNgTableOpts($scope.situations);
            var sexes = F.getNgTableOpts(F.get('sexes'));
            $scope.cols = [
                {title: '员工姓名', field: 'user_name', filter: {'users.name': 'text'}, show: true}, //0
                {title: '员工性别', field: 'user_sex', filter: {'users.sex': 'select'}, data: sexes, show: true}, //0
                {
                    title: '房屋编号',
                    field: 'house_code',
                    filter: {'houses.code': 'text'},
                    show: true
                }, //0
                {
                    title: '房屋情况',
                    filter: {situation: 'select'},
                    field: 'situation',
                    data: situations,
                    show: true
                },
                {title: '起租时间', filter: {rent_start: 'date_range'}, field: 'rent_start', show: true},
                {title: '停租时间', filter: {rent_end: 'date_range'}, field: 'rent_end', sortable: 'rent_end', show: true},
                {
                    title: '支付方式',
                    filter: {pay_type: 'select'},
                    field: 'pay_type',
                    data: pay_types,
                    show: true
                }, //6
                {
                    title: '备注',
                    field: 'remarks',
                    show: true
                }
            ];
            $scope.optColWidth = 96;
            $scope.numRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.numRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.dateRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.tableParams = new NgTableParams({
                page: 1, count: 10, sorting: {
                    rent_end: 'asc'
                }
            }, {
                counts: [5, 10], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    if ($scope.numRangeFilter.balance) {
                        url['balance_start'] = $scope.numRangeFilter.balance.start;
                        url['balance_end'] = $scope.numRangeFilter.balance.end;
                    }

                    url['date_range_filters'] = {};
                    if ($scope.dateRangeFilter.rent_start != null) {
                        var startDate = $filter('date')($scope.dateRangeFilter.rent_start.startDate, 'yyyy-MM-dd');
                        var endDate = $filter('date')($scope.dateRangeFilter.rent_start.endDate, 'yyyy-MM-dd');
                        url['date_range_filters']['rent_start'] = {
                            startDate: startDate,
                            endDate: endDate
                        };
                    }

                    if ($scope.dateRangeFilter.rent_end != null) {
                        var startDate = $filter('date')($scope.dateRangeFilter.rent_end.startDate, 'yyyy-MM-dd');
                        var endDate = $filter('date')($scope.dateRangeFilter.rent_end.endDate, 'yyyy-MM-dd');
                        url['date_range_filters']['rent_end'] = {
                            startDate: startDate,
                            endDate: endDate
                        };
                    }
                    url['opt'] = $scope.opt;
                    HouseRent.query(url, function (resp) {
                        params.total(resp.total);
                        $scope.houses = resp.houses;
                        $scope.rent_users = resp.rent_users;
                        $defer.resolve(resp.records);
                    });
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.numRangeFilter = {};
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            $scope.add = function () {
                dialogs.create('HouseRentDlg.html', 'HouseRentDlgCtrl', {
                    houses: $scope.houses,
                    situations: $scope.situations,
                    pay_types: $scope.pay_types,
                    rent_users: $scope.rent_users
                }, {
                     size: 'md'
                }).result.then(function (house_rent) {
                        HouseRent.save(house_rent).$promise.then(function (resp) {
                            toaster.success('租房信息添加成功!');
                            $scope.tableReload();
                        }, function () {
                            toaster.error('此用户已租过房屋,添加失败!');
                        });
                    });
            };

            $scope.exportRent = function () {
                var defer = $q.defer();
                var title = '房屋出租统计导出表';
                FileHelper.dnExcel('/api/v1/house_rents/export', {
                }, title + '.xls')
                    .finally(function () {
                        defer.resolve();
                    });
            };


            $scope.edit = function (record) {
                record.$edit = true;
                record.$userChanged = {id: record.user_id, name: record.user_name};
                record.$houseChanged = {id: record.house_id, name: record.house_code};
                record.$rent_startChanged = record.rent_start;
                record.$rent_endChanged = record.rent_end;
                record.$pay_typeChanged = $scope.pay_types[record.pay_type - 1];
                record.$situationChanged = $scope.situations[record.situation - 1];
            };

            $scope.save = function (record) {
                record.$edit = false;
                if (record.$userChanged == "") {
                    toaster.warning('用户不能为空!');
                } else if (record.$houseChanged == "") {
                    toaster.warning('房屋不能为空');
                }
                else if (record.$rent_startChanged == null) {
                    toaster.warning('起租时间不能为空');
                }else if (record.$situationChanged == "") {
                    toaster.warning('房屋情况不能为空');
                } else {
                    var data = {};
                    data['user_id'] = record.$userChanged.id;
                    data['house_id'] = record.$houseChanged.id;
                    data['rent_start'] = $filter('date')(record.$rent_startChanged, 'yyyy-MM-dd');
                    data['rent_end'] = $filter('date')(record.$rent_endChanged, 'yyyy-MM-dd');
                    data['pay_type'] = record.$pay_typeChanged.id;
                    data['situation'] = record.$situationChanged.id;
                    HouseRent.update({id: record.id}, data).$promise.then(function () {
                        toaster.success('房屋出租修改成功!');
                        record.user_name = record.$userChanged.name;
                        record.house_code = record.$houseChanged.name;
                        record.rent_start = $filter('date')(record.$rent_startChanged, 'yyyy-MM-dd');
                        record.rent_end = $filter('date')(record.$rent_endChanged, 'yyyy-MM-dd');
                        record.pay_type = record.$pay_typeChanged.id;
                        record.situation = record.$situationChanged.id;
                    }, function (error) {
                        toaster.error('房屋出租修改失败!');
                    });
                }
            };

            $scope.delete = function (record) {
                dialogs.confirm('删除房屋出租记录', '确定要删除<strong>' + record.user_name + '</strong>的出租记录吗?')
                    .result.then(function () {
                        HouseRent.delete({id: record.id}).$promise.then(function () {
                            toaster.success('房屋出租记录删除成功!');
                            $scope.tableReload();
                        }, function (error) {
                            toaster.error('房屋出租记录删除失败!');
                        });
                    });

            };

            $scope.member = function (record) {
                var house = {'id': record.house_id, 'code': record.house_code};
                dialogs.create('/templates/house_member.html', 'HouseMemberCtrl',
                    {house: house}, { size: 'md'})
            };


            $scope.stop = function (record) {
                dialogs.create('/templates/time_only.html', 'TimeOnlyCtrl', {}, {
                     size: 'md'
                }).result.then(function (para) {
                        var data = {};
                        data['rent_end'] = para;
                        data['opt'] = 1;   //表明为停租
                        HouseRent.update({id: record.id}, data).$promise.then(function () {
                            toaster.success('房屋停租成功!');
                            $rootScope.$broadcast('fresh');
                            $scope.tableReload();
                        }, function (error) {
                            toaster.error('房屋停租失败!');
                        });
                    });
            };
        };

        return {
            templateUrl: 'directives/main/house-rent-table/house-rent-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@'
            },
            controller: controller
        }
    });

angular.module('c.c').controller('OfficeAirfareDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, $filter, Airfare, data) {
        $scope.airfare = data.airfare;
        $scope.step = data.step;
        $scope.edited = false;

        if ($scope.step == 1) {
            $scope.message = {
                'info': '已为您订购' + $scope.airfare.from_time + '出发,从' + $scope.airfare.from + '到'
                + $scope.airfare.to + $scope.airfare.airline + '机票,航班号为' + $scope.airfare.flight_num
            };
        } else {
            $scope.message = {};
        }


        $scope.edit = function () {
            dialogs.create('/templates/airfare/airfare_edit.html', 'AirfareEditCtrl', {airfare: data.airfare}, {
                 size: 'md'
            }).result.then(function (airfare) {
                    $scope.airfare_edit = airfare;
                    $scope.edited = true;
                });
        };

        $scope.ok = function (message) {
            var params = {};
            if (message.send) {
                params['m_info'] = message.info;
            }
            if ($scope.edited) {
                params['id_card'] = $scope.airfare_edit.id_card;
                params['from'] = $scope.airfare_edit.from;
                params['to'] = $scope.airfare_edit.to;
                params['from_time'] = $filter('date')($scope.airfare_edit.from_time, 'yyyy-MM-dd');
                params['plane_time'] = $scope.airfare_edit.plane_time;
                params['airline'] = $scope.airfare_edit.airline;
                params['flight_num'] = $scope.airfare_edit.flight_num;
                params['remark'] = $scope.airfare_edit.remark;
            }
            params['step'] = parseInt($scope.step) + 1;
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


angular.module('c.c').controller('AirfareEditCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, $filter, Airfare, uibDateParser, data) {
        var airfare = data.airfare;
        $scope.airfare = {
            id_card: airfare.id_card,
            from: airfare.from,
            to: airfare.to,
            from_time: uibDateParser.parse(airfare.from_time, 'yyyy-MM-dd'),
            plane_time: airfare.plane_time,
            airline: airfare.airline,
            flight_num: airfare.flight_num,
            remark: airfare.remark
        };

        $scope.ok = function (airfare) {
            if ($scope.airfare_edit_form.$valid) {
                var params = {};
                params['id_card'] = airfare.id_card;
                params['from'] = airfare.from;
                params['to'] = airfare.to;
                params['from_time'] = $filter('date')(airfare.from_time, 'yyyy-MM-dd');
                params['plane_time'] = airfare.plane_time;
                params['airline'] = airfare.airline;
                params['flight_num'] = airfare.flight_num;
                params['remark'] = airfare.remark;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.airfare_edit_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });









(function () {
    'use strict';

    angular.module('c.d')
        .directive('messageRecipient', messageRecipient);

    function messageRecipient() {
        return {
            templateUrl: 'directives/main/message-recipient/message-recipient.html',
            restrict: 'E',
            scope: {
                // 表明是哪个科室的短信提醒人
                'type': '@',
                'title': '@',
                'desc': '@'
            },
            controller: controller
        }
    }

    /** @ngInject */
    function controller($scope, $q, toaster, MessageRecipient) {
        $scope.title = $scope.title ? $scope.title : '请假提醒人';
        $scope.desc = $scope.desc ? $scope.desc : '设置相应的短信提醒人';

        $scope.reload = function () {
            MessageRecipient.get({id: $scope.type}, function (resp) {
                var r = resp.item;
                if (!r) r = {id: $scope.type};
                $scope.r = r;
            });
        };

        $scope.submit = function (r) {
            var defer = $q.defer();
            if (r.id) {
                var params = {user_id: r.user ? r.user.id : null};
                MessageRecipient.update({id: r.id}, params).$promise.then(function () {
                    toaster.success('设置成功');
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                defer.reject();
            }
            return defer.promise;
        };

        $scope.reset = $scope.reload;
        $scope.reload();
    }

})();









angular.module('c.d')
    .directive('pendingLeaveTable', function () {
        var controller = function ($scope, $filter, $rootScope, FileHelper,
                                   dialogs, toaster, NgTableParams, AskForLeave, SaveAs, C, F) {

            var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            $scope.yesNo = F.get('yesNo');

            $scope.cols = [
                {title: '姓名', filter: {'users.name': 'text'}, field: 'name', width: '60', show: true}, //0
                {title: '科室', filter: {'depts.name': 'text'}, field: 'dept_id', width: '80', show: true}, //0
                {
                    title: '类别',
                    sortable: 'leave_type_id',
                    filter: {leave_type_id: 'select'},
                    field: 'leave_type_id',
                    width: '100',
                    show: true
                }, //6
                {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', width: '180', show: true}, //6
                {title: '来院/参工时间', width: '110', show: true}, //6
                {title: '申请时间', filter: {created_at: 'date_range'}, field: 'created_at', width: '130', show: true},
                {title: '天数', field: 'day_num', width: '50', show: true}, //6
                {title: '请假开始', filter: {start: 'date_range'}, field: 'start', width: '130', show: true},
                {title: '请假结束', filter: {end: 'date_range'}, field: 'end', width: '130', show: true},
                {
                    title: '附件',
                    field: 'has_paper',
                    width: '100',
                    show: true
                }, //6
                {
                    title: '附件类型',
                    sortable: 'type_id',
                    filter: {type_id: 'select'},
                    field: 'type_id',
                    width: '90',
                    show: true
                }, //6
                {
                    title: '补助与机票',
                    sortable: 'is_subsidy',
                    filter: {is_subsidy: 'select'},
                    field: 'is_subsidy',
                    width: '105',
                    data: yesNoOpts,
                    show: true
                }
                // {
                //     title: '离开大成都范围',
                //     sortable: 'is_leave_cd',
                //     filter: {is_leave_cd: 'select'},
                //     field: 'is_leave_cd',
                //     width: '105',
                //     data: yesNoOpts,
                //     show: true
                // }

            ];

            $scope.dept_col = $scope.cols[1];
            $scope.leave_type_col = $scope.cols[2];
            $scope.attach_type_col = $scope.cols[10];
            $scope.optInFront = true;

            $scope.dateRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.download = function (m) {
                var params = {filename: m.attach_filename, mime: m.attach_mime};
                m.downloading = true;
                FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                    m.downloading = false;
                    var data = [resp];
                    var options = {type: m.attach_mime};
                    SaveAs.download(data, m.attach_name, options);
                }, function (error) {
                    m.downloading = false;
                    //toaster.error('服务端文件丢失，请联系管理员!');
                });
            };

            $scope.optColWidth = 160;
            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = $scope.step;
                    var startDate, endDate;
                    if ($scope.dateRangeFilter.start != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            start: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    if ($scope.dateRangeFilter.end != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            end: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    if ($scope.dateRangeFilter.created_at != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            created_at: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    AskForLeave.query(url, function (data) {
                        $scope.leave_types = data.leave_types;
                        $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                        $scope.attach_types = data.attach_types;
                        $scope.attach_type_col.data = F.getNgTableOpts($scope.attach_types);
                        params.total(data.total);
                        $defer.resolve(data.records);
                    });
                }
            });


            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            $scope.xxx;
            $scope.agree = function (record, type) {
                var message = '确定要同意<strong>' + record.user.name + '</strong>的假条吗?';
                if (record.dept_charge_opinion == 1 && record.hospitalLeaderId == 53) {
                    message += '<br/><strong class="text-red">请谨慎审批，保证工作正常开展，科室正常运行！！！</strong>';
                    AskForLeave.query({
                        opt: 29, start: record.start, end: record.end, dept: record.dept_id, user: record.user_id
                    }, function (resp) {
                        if (resp.over) {
                            message += '<br/><strong class="text-red">你管理的科室同时段请假人数已达预警线！请谨慎审批！</strong>';
                        }
                        confirm(record, type, message)
                    });
                } else {
                    confirm(record, type, message)
                }
            };

            function confirm(record, type, message) {
                dialogs.confirm('审批请假', message)
                    .result.then(function () {
                    var data = {};
                    data['opinion'] = type;    //备用,在服务端进行判断是否拒绝，拒绝的话，假条流程结束
                    data['step'] = $scope.step;   //科室负责人已批假条
                    AskForLeave.update({id: record.id}, data).$promise.then(function (resp) {
                        switch (resp['result']) {
                            case 0:
                                toaster.success('审批成功!');
                                break;
                            case 1:
                                toaster.warning('此假条已被其他领导审批通过啦～无需审批～!');
                                break;
                        }
                        $scope.tableReload();
                        $rootScope.$broadcast('ApprovedRefresh');
                    }, function (error) {
                        toaster.error('审批失败!');
                    });
                });
            }

            $scope.disagree = function (record, type) {
                dialogs.create('templates/leave/leave_disagree_dlg.html', 'LeaveDisagreeDlgCtrl', {
                    record: record,
                    type: type,
                    step: $scope.step
                }, {
                    size: 'md'
                }).result.then(function (para) {
                    AskForLeave.update({id: record.id}, para).$promise.then(function (resp) {
                        switch (resp['result']) {
                            case 0:
                                toaster.success('驳回成功');
                                break;
                            case 1:
                                toaster.warning('此假条已被其他领导审批通过啦～无需审批～!');
                                break;
                        }
                        $scope.tableReload();
                        $rootScope.$broadcast('ApprovedRefresh');
                    }, function () {
                        toaster.error('驳回失败');
                    });
                });
            };

            $scope.personAgree = function (record, type) {
                dialogs.create('templates/leave/person_agree_dlg.html', 'PersonAgreeDlgCtrl', {
                    record: record,
                    type: type,
                    step: $scope.step
                }, {
                    size: 'md'
                }).result.then(function (para) {
                    AskForLeave.update({id: record.id}, para).$promise.then(function () {
                        toaster.success('审批成功');
                        $scope.tableReload();
                        $rootScope.$broadcast('ApprovedRefresh');
                    }, function () {
                        toaster.error('审批失败');
                    });
                });
            };

            $scope.check = function (record) {     //查看过去请假情况
                dialogs.create('templates/leave/check_leave_dlg.html', 'CheckLeaveCtrl',
                    {record: record}, {
                        size: 'md'
                    })
            };

        };

        return {
            templateUrl: 'directives/main/pending-leave-table/pending-leave-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'step': '@'   //表明是哪个步骤在审批
            },
            controller: controller
        }
    });

angular.module('c.c').controller('LeaveDisagreeDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.record = data.record;
        var step = data.step;
        var type = data.type;

        $scope.ok = function (record) {
            if ($scope.disagree_form.$valid) {
                var params = {};
                params['dept_charge_opinion'] = type;
                params['opinion'] = type;
                params['step'] = step;
                params['memo'] = record.memo;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.disagree_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('PersonAgreeDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.record = data.record;
        var step = data.step;
        var type = data.type;
        $scope.record.receive_attachment = false;

        $scope.ok = function (record) {
            var params = {};
            params['opinion'] = type;
            params['step'] = step;
            params['receive_attachment'] = record.receive_attachment;
            params['day_num'] = record.day_num;
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


angular.module('c.c').controller('CheckLeaveCtrl',
    function ($scope, $uibModalInstance, NgTableParams, toaster, AskForLeave, F, $filter, data) {

        $scope.record = data.record;
        if (data.month) {
            $scope.month = new Date(data.month);
        }

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                $scope.url = params.url();
                url['filter'] = {};
                url['filter']['user_id'] = data.record.user_id;
                if (data.month) {
                    var last_day = new Date($scope.month.getFullYear(), $scope.month.getMonth() + 1, 0);
                    url['date_range_filters'] = {
                        start: {
                            endDate: $filter('date')(last_day, 'yyyy-MM-dd')
                        },
                        end: {
                            startDate: $filter('date')($scope.month, 'yyyy-MM-dd')
                        }
                    };
                }
                url['opt'] = 19;
                AskForLeave.query(url, function (data) {
                    $scope.data_types = data.dataTypes;
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });





(function () {
    'use strict';

    angular.module('c.d')
        .directive('sidebar', function () {
            return {
                templateUrl: 'templates/cache/sidebar.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'sidebar',
                link: link
            }
        });

    function link(scope) {
        var jqWindow = $(window);
        scope.menuHeight = window.innerHeight - 50;
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function () {
            jqWindow.off('resize', _onWindowResize);
        });
        scope.lastWidth = window.innerWidth;
        function _onWindowResize() {
            var newMenuHeight = window.innerHeight - 50;
            if (scope.menuHeight !== newMenuHeight) {
                scope.$apply(function () {
                    scope.menuHeight = newMenuHeight;
                });
            }
            if (scope.lastWidth < 992 && window.innerWidth >= 992) {
                scope.$apply(function () {
                    scope.$root.$broadcast('showSidebar', true);
                });
            }
            if (scope.lastWidth >= 568 && window.innerWidth < 568) {
                scope.$apply(function () {
                    scope.$root.$broadcast('showSidebar', false);
                });
            }
            scope.lastWidth = window.innerWidth;
        }

    }

    /** @ngInject */
    function ctrl($scope, Auth) {
        var vm = this;
        vm.account = Auth.getAccount();
        vm.showSidebar = false;
        vm.firstLvVisible = firstLvVisible;
        vm.secondLvVisible = secondLvVisible;


        init();


        function init() {
            $scope.$root.collapseVar = 0;

            $scope.$on('showSidebar', function (event, showSidebar) {
                if (vm.showSidebar !== showSidebar) {
                    vm.showSidebar = showSidebar;
                }
            });

            $scope.check = function (x) {
                if (x === $scope.$root.collapseVar) {
                    $scope.$root.collapseVar = 0;
                } else {
                    $scope.$root.collapseVar = x;
                }
            };
        }

        function firstLvVisible(item) {
            var search = vm.search;
            if (!search) return true;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) {
                if (secondLv) {  // 二级菜单检索
                    for (var i = 0; i < item.children.length; i++) {
                        var subItem = item.children[i];
                        if (subItem.display_name.indexOf(search) !== -1) {
                            visible = true;
                            break;
                        }
                    }
                } else {
                    visible = item.display_name.indexOf(search) !== -1
                }
            }
            return visible;
        }

        function secondLvVisible(item) {
            var search = vm.search;
            if (!search) return item.state;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) { // 有输入
                visible = secondLv ? item.display_name.indexOf(search) !== -1 : true;
            }
            return visible && item.state;
        }

    }

})();
angular.module('c.d')
    .directive('statisticLeaveTable', function () {
        var controller = function ($scope, $filter, dialogs, toaster, NgTableParams, Shift, Table) {
            var created_at = new Date();
            created_at.setMonth(created_at.getMonth() - 1);
            $scope.para = {created_at: created_at};
            var year = created_at.getYear();
            $scope.dateRangeFilter = {
                'created_at': {
                    startDate: $filter('date')(new Date(year + 1900, created_at.getMonth(), 1), 'yyyy-MM-dd'),
                    endDate: $filter('date')(new Date(year + 1900, created_at.getMonth() + 1, 0), 'yyyy-MM-dd')
                }
            };

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.getReports = function (para) {
                if (para.created_at) {
                    var year = para.created_at.getYear();
                    $scope.dateRangeFilter = {
                        'created_at': {
                            startDate: $filter('date')(new Date(year + 1900, para.created_at.getMonth(), 1), 'yyyy-MM-dd'),
                            endDate: $filter('date')(new Date(year + 1900, para.created_at.getMonth() + 1, 0), 'yyyy-MM-dd')
                        }
                    };
                    $scope.tableReload();
                }
            };

            $scope.hideOpt = true;

            $scope.tableParams = new NgTableParams({
                page: 1,
                count: 10
            }, {
                counts: [5, 10, 15],
                total: 0,
                getData: function ($defer, params) {
                    var url = [];
                    url['opt'] = $scope.opt;
                    if ($scope.dateRangeFilter.created_at != null) {
                        url['date_range_filters'] = {
                            'ask_for_leaves.created_at': {
                                startDate: $scope.dateRangeFilter.created_at.startDate,
                                endDate: $scope.dateRangeFilter.created_at.endDate
                            }
                        };
                    }
                    Shift.query(url, function (data) {
                        $scope.shifts = data.shifts;
                        $scope.cachedData = data.shifts;
                        Table.getTableData(data.shifts, $defer, params, $filter);
                    })
                }
            });
        };

        return {
            templateUrl: 'directives/main/statistic-leave-table/statistic-leave-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@'
            },
            controller: controller
        }
    });



angular.module('c.d')
    .directive('subsidyPaidTable', function () {
        var controller = function ($scope, $filter, $rootScope, dialogs, toaster, NgTableParams, $sce, $timeout,
                                   $templateRequest, AskForLeave, F, C, FileHelper, SaveAs) {

            var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            $scope.yesNo = F.get('yesNo');

            $scope.$on('reload', function () {
                $scope.tableParams.reload();
            });

            $scope.cols = [
                {
                    title: '状态与补助',
                    sortable: 'subsidy_paid',
                    filter: {subsidy_paid: 'select'},
                    field: 'subsidy_paid',
                    data: yesNoOpts,
                    show: true
                }, //6
                {title: '编号', filter: {'id': 'text'}, field: 'id', show: true}, //0
                {title: '姓名', filter: {'users.name': 'text'}, field: 'name', show: true}, //0
                {title: '科室', filter: {'depts.name': 'text'}, field: 'dept_id', show: true}, //0
                {
                    title: '类别',
                    sortable: 'leave_type_id',
                    filter: {leave_type_id: 'select'},
                    field: 'leave_type_id',
                    show: true
                }, //6
                {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
                {title: '天数', field: 'day_num', show: true}, //6
                {title: '开始时间', filter: {start: 'date_range'}, field: 'start', show: true},
                {title: '结束时间', filter: {end: 'date_range'}, field: 'end', show: true}
            ];

            $scope.optInFront = true;
            $scope.dept_col = $scope.cols[3];
            $scope.leave_type_col = $scope.cols[4];
            $scope.dateRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.optColWidth = 45;
            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = 18;    //差务补助确认
                    url['step'] = $scope.step;
                    var startDate, endDate;
                    if ($scope.dateRangeFilter.start != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            start: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    if ($scope.dateRangeFilter.end != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            end: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    AskForLeave.query(url, function (data) {
                        $scope.expense_items = data.expense_items;
                        $scope.leave_types = data.leave_types;
                        $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                        params.total(data.total);
                        $defer.resolve(data.records);
                    });
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            $scope.confirm = function (record) {
                dialogs.create('/templates/subsidy_paid/finance_confirm_dlg.html', 'FinanceConfirmDlgCtrl', {
                    step: $scope.step,
                    leave: record
                }, {
                    size: 'md'
                }).result.then(function (leave) {
                    AskForLeave.update({id: record.id}, leave).$promise.then(function () {
                        toaster.success('补助状态改变成功!');
                        if ($scope.step == 0 || $scope.step == 1 || $scope.step == 2 || $scope.step == 3) {
                            $rootScope.$broadcast('reload');
                        }
                        $scope.tableReload();
                    }, function () {
                        toaster.error('补助状态改变成功!');
                    });
                });
            };

            $scope.edit_expense = function (record) {
                dialogs.create('/templates/subsidy_paid/edit_expense_dlg.html', 'EditExpenseDlgCtrl', {
                    leave: record, expense_items: $scope.expense_items
                }, {
                    size: 'md'
                }).result.then(function (items) {
                    AskForLeave.update({id: record.id}, {
                        'items': items,
                        'edit_expense': true
                    }).$promise.then(function () {
                        toaster.success('报销项目改变成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('报销项目改变失败!');
                    });
                });
            };

            $scope.download = function (m) {
                var params = {filename: m.attach_filename, mime: m.attach_mime};
                m.downloading = true;
                FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                    m.downloading = false;
                    var data = [resp];
                    var options = {type: m.attach_mime};
                    SaveAs.download(data, m.attach_name, options);
                }, function (error) {
                    m.downloading = false;
                    //toaster.error('服务端文件丢失，请联系管理员!');
                });
            };

            var templateUrl = $sce.getTrustedResourceUrl('templates/print/table2.html');
            var printStyle;
            $templateRequest(templateUrl).then(function (resp) {
                printStyle = resp;
            });
            $scope.print = function (record) {
                var w = window.open("", "打印预览");

                var html = '<html><body>';

                html += '<table class="print">' +
                    '<caption>成办医院差务报销申请单</caption>' +
                    '<tbody><tr>';
                html += '<td width="120">编号</td>';
                html += '<td width="520">' + record.id + '</td>';

                html += '</tr>';

                html += '<tr><td width="120">请假人</td>';
                html += '<td width="520">' + record.user.name + '</td>';
                html += '</tr>';
                html += '<tr><td width="120">请假类别</td>';
                html += '<td width="520">' + record.leave_type.name + '</td>';
                html += '</tr>';
                html += '<tr>';
                html += '<td width="120">请假开始时间</td>';
                html += '<td width="520">' + record.start;
                if (record.start_spot == '1') {
                    html += '&nbsp;08:00'
                }
                if (record.start_spot == '0') {
                    html += '&nbsp;13:30'
                }
                html += '</td></tr>';
                html += '<td width="120">请假结束时间</td>';
                html += '<td width="520">' + record.end;
                if (record.end_spot == '1') {
                    html += '&nbsp;12:00'
                }
                if (record.end_spot == '0') {
                    html += '&nbsp;17:00'
                }
                html += '</td></tr>';
                html += '<tr>';
                html += '<td width="120">请假事由</td>';
                html += '<td width="520">' + record.leave_reason + '</td>';
                html += '</tr>';
                html += '<tr>';
                html += '<td width="120">附件</td>';
                html += '<td width="520">';
                if (record.attach_name == '') {
                    html += '无'
                } else {
                    html += record.attach_name;
                }
                html += '</td></tr>';
                html += '<tr>';
                html += '<td width="120">申请报销项目</td>';
                html += '<td width="520">';
                angular.forEach(record.leave_expenses, function (item) {
                    html += item.expense.name + '&nbsp;';
                });
                html += '</td></tr>';
                html += '<tr><td colspan="2">';
                if (record.dept_charge_opinion == 2) {
                    html += '科室负责人:' + record.dept_charge.name + ' ';
                    if (record.dept_charge.signature) {
                        html += '<img height="50" width="160" src="' + record.dept_charge.signature.sign + '"/> ';
                    }
                    html += record.dept_charge_time.substr(0, 16) + ' ';
                }
                html += '<br/>';
                if (record.medical_opinion == 2) {
                    html += '医务科:' + record.medical_approval.name + ' ';
                    if (record.medical_approval.signature) {
                        html += '<img height="50" width="160" src="' + record.medical_approval.signature.sign + '"/> ';
                    }
                    html += record.medical_time.substr(0, 16) + ' ';
                }
                html += '<br/>';
                if (record.nurse_opinion == '2') {
                    html += '护理部:' + record.nurse_approval.name + ' ';
                    if (record.nurse_approval.signature) {
                        html += '<img height="50" width="160" src="' + record.nurse_approval.signature.sign + '"/> ';
                    }
                    html += record.nurse_time.substr(0, 16) + ' ';
                }
                html += '<br/>';
                if (record.edu_opinion == '2') {
                    html += '科教科:' + record.edu.name + ' ';
                    if (record.edu.signature) {
                        html += '<img height="50" width="160" src="' + record.edu.signature.sign + '"/> ';
                    }
                    html += record.edu_time.substr(0, 16) + ' ';
                }
                html += '<br/>';
                if (record.hospital_leader_opinion == '2') {
                    html += '分管院领导:' + record.hospital_leader.name + ' ';
                    if (record.hospital_leader.signature) {
                        html += '<img height="50" width="160" src="' + record.hospital_leader.signature.sign + '"/> ';
                    }
                    html += record.hospital_leader_time.substr(0, 16) + ' ';
                }
                html += '<br/>';
                if (record.main_leader_opinion == '2') {
                    html += '主管院领导:' + record.main_leader.name + ' ';
                    if (record.main_leader.signature) {
                        html += '<img height="50" width="160" src="' + record.main_leader.signature.sign + '"/> ';
                    }
                    html += record.main_leader_time.substr(0, 16) + ' ';
                }
                html += '<br/>';
                console.log('6666666');
                if (record.personnel_opinion == '2') {
                    html += '人事科:' + record.personnel_approval.name + ' ';
                    if (record.personnel_approval.signature) {
                        html += '<img height="50" width="160" src="' + record.personnel_approval.signature.sign + '"/> ';
                    }
                    html += record.personnel_time.substr(0, 16) + ' ';
                }
                html += '<br/>';
                html += '</td></tr>';
                html += '</tbody></table></body></html>';

                w.document.write(html + printStyle);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            };

        };

        return {
            templateUrl: 'directives/main/subsidy-paid-table/subsidy-paid-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'step': '@'   //表明是哪个步骤在审批
            },
            controller: controller
        }
    });

angular.module('c.c').controller('FinanceConfirmDlgCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, F, data) {
        $scope.leave = data.leave;
        $scope.step = data.step;
        $scope.finance_message = F.get('finance_paid_message');
        if ($scope.step == 1) {
            $scope.message = {'info': $scope.finance_message[0].name};
        } else {
            $scope.message = {};
        }
        $scope.info = function (template, info) {
            if (template == true) {
                $scope.message['info'] = info.name;
            }
        };

        $scope.ok = function (message) {
            if ($scope.confirm_form.$valid) {
                var params = {};
                if (message.send) {
                    params['m_info'] = message.info;
                }
                params['subsidy_paid'] = parseInt($scope.step) + 1;
                params['finance_paid'] = 1;  //表明为财务科财务补助操作
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.airfare_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('EditExpenseDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data) {
        $scope.expense_items = data.expense_items;

        angular.forEach(data.leave.leave_expenses, function (expense) {
            angular.forEach($scope.expense_items, function (item) {
                if (expense.expense_id == item.id) {
                    item.is_checked = true;
                }
            });
        });

        $scope.ok = function (message) {
            var items = [];
            for (var i = 0; i < $scope.expense_items.length; i++) {
                if ($scope.expense_items[i].is_checked) {
                    items.push($scope.expense_items[i].id);
                }
            }
            if (items.length == 0) {
                toaster.warning('报销的项目不能为空,请重新选择!');
            } else {
                $uibModalInstance.close(items);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });







angular.module('c.d')
    .directive('sysWageTable', function () {
        var controller = function ($scope, $filter, dialogs, toaster, NgTableParams, UserStatus, GradeWage, VariableWage,
                                   C, F, Table) {

            var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            $scope.yesNo = F.get('yesNo');

            $scope.cols = [
                {title: '条目名称', filter: {name: 'text'}, field: 'name', show: true},
                {title: '金额', sortable: 'money', filter: {money: 'number_range'}, field: 'money', show: true}, //6
                {title: '类型', filter: {status_id: 'select'}, field: 'status_id', show: true}, //6
                {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', show: true}, //6
                {title: '计入科室成本', filter: {is_cost: 'select'}, data: yesNoOpts, field: 'is_cost', show: true}, //6
                {title: '计入个税', filter: {is_tax: 'select'}, data: yesNoOpts, field: 'is_tax', show: true}, //6
                {title: '计入缺勤扣费', filter: {is_ad: 'select'}, data: yesNoOpts, field: 'is_ad', show: true}, //6
                {title: '计入工资', filter: {is_wage: 'select'}, data: yesNoOpts, field: 'is_wage', show: true}, //6
                {title: '排列顺序', sortable: 'sorting', field: 'sorting', show: true} //6
            ];

            var typeCol = $scope.cols[2];
            UserStatus.query(function (resp) {
                $scope.statuses = resp;
                typeCol.data = F.getNgTableOpts($scope.statuses);
            });

            $scope.numRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.numRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.optColWidth = 67;
            $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {sorting: 'asc'}}, {
                counts: [5, 10], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = C.OPT.SYS_WAGE.INDEX.ALL_WAGES;   //获得薪级工资或者可变工资的所有条目
                    if ($scope.numRangeFilter.money != null) {
                        url['startMoney'] = $scope.numRangeFilter.money.start;
                        url['endMoney'] = $scope.numRangeFilter.money.end;
                    }

                    if ($scope.type == 1) {
                        Table.query(GradeWage, url, $defer, params, 'wages');
                    } else if ($scope.type == 2) {
                        Table.query(VariableWage, url, $defer, params, 'wages');
                    }
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.numRangeFilter = {};
                $scope.tableParams.filter({});
            };

            $scope.add = function () {
                dialogs.create('/templates/wage/sys_wage_dlg.html', 'SysWageDlgCtrl', {
                    statuses: $scope.statuses,
                    type: $scope.type
                }, {
                    size: 'md'
                }).result.then(function (g) {
                        if ($scope.type == 1) {
                            GradeWage.save(g).$promise.then(function (data) {
                                toaster.success('薪级工资条目添加成功!');
                                $scope.tableReload();
                            }, function () {
                                toaster.error('薪级工资条目添加失败!');
                            });
                        } else if ($scope.type == 2) {
                            VariableWage.save(g).$promise.then(function (data) {
                                toaster.success('可变工资条目添加成功!');
                                $scope.tableReload();
                            }, function () {
                                toaster.error('可变工资条目添加失败!');
                            });
                        }
                    });
            };

            function editWage(W, g, pa) {
                W.update({id: g.id}, pa).$promise.then(function (data) {
                    toaster.success('工资条目修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('工资条目修改失败!');
                });
            }

            $scope.edit = function (g) {
                dialogs.create('/templates/wage/sys_wage_dlg.html', 'SysWageDlgCtrl', {
                    wage: g,
                    statuses: $scope.statuses,
                    type: $scope.type
                }, {
                    size: 'md'
                }).result.then(function (pa) {
                        if ($scope.type == 1) {
                            editWage(GradeWage, g, pa);
                        } else if ($scope.type == 2) {
                            editWage(VariableWage, g, pa);
                        }
                    });
            };

            function delWage(W, g) {
                W.delete({id: g.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('工资条目删除成功!');
                            $scope.tableReload();
                            break;
                        case 1:
                            toaster.warning('存在引用该工资条目的工资,因此无法删除该条目!');
                            break;
                    }
                }, function (error) {
                    toaster.error('工资条目删除失败!');
                });
            }

            $scope.delete = function (g) {
                dialogs.confirm('删除工资条目', '确定要删除<strong>' + g.name + '</strong>条目吗?')
                    .result.then(function () {
                        if ($scope.type == 1) {
                            delWage(GradeWage, g);
                        } else if ($scope.type == 2) {
                            delWage(VariableWage, g);
                        }
                    });
            };
        };

        return {
            templateUrl: 'directives/main/sys-wage-table/sys-wage-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'type': '@'
            },
            controller: controller
        }
    });

angular.module('c.c').controller('SysWageDlgCtrl', function ($scope, $uibModalInstance, toaster, data, F) {
    $scope.statuses = data.statuses;
    $scope.type = data.type;

    if (data.type == 1) {
        $scope.wage_headers = F.get('wage_grade_headers');   //获得所有薪级工资条目（在编，招聘,试用，返聘）
    } else if (data.type == 2) {
        $scope.wage_headers = F.get('wage_variable_headers');   //获得所有可变工资条目（在编，招聘，试用，返聘）
    }

    if (data.wage) {
        $scope.$edit = true;
        var w = data.wage;
        $scope.g = {
            name: w.name, money: w.money, is_cost: w.is_cost == '1', is_tax: w.is_tax == '1', is_ad: w.is_ad == '1',
            is_wage: w.is_wage == '1', is_stop: w.is_stop == '1', sorting: w.sorting
        };
        $scope.g['status'] = data.statuses[w.status_id - 1];
    } else {
        $scope.g = {
            is_cost: true, is_tax: true, is_ad: true, is_wage: true, is_stop: false, sorting: 100
        };
        $scope.g['status'] = data.statuses[0];
    }

    $scope.ok = function (g) {
        if (!g.header) {
            toaster.warning('请选择对应表头!');
        } else if ($scope.g_form.$valid) {
            var pa = {};
            pa['name'] = g.name;
            pa['money'] = g.money;
            pa['status_id'] = g.status.id;
            pa['is_cost'] = g.is_cost ? '1' : '0';
            pa['is_tax'] = g.is_tax ? '1' : '0';
            pa['is_ad'] = g.is_ad ? '1' : '0';
            pa['is_wage'] = g.is_wage ? '1' : '0';
            pa['is_stop'] = g.is_stop ? '1' : '0';
            pa['sorting'] = g.sorting;
            pa['header'] = g.header;
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('表单中有错误!');
            $scope.g_form.submitted = true;
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});






angular.module('c.d')
    .directive('tabInclude', [function ($parse) {
        var selfIndex = function (element) {
            var arr = element.parent().children();
            var val = element[0];
            var i = arr.length;
            while (i--) {
                if (val == arr[i]) return i;
            }
            return -1
        };

        return {
            require: ['^uibTab', '^uibTabset'],
            restrict: 'A',
            priority: 100,
            compile: function (element, attrs, transclude) {

                var elem = angular.element('<div></div>');
                elem.attr('ng-include', '$include[' + (attrs.ngRepeat ? '$index' : selfIndex(element)) + ']');
                element.append(elem);

                return function postLink(scope, element, attrs) {
                    if (scope.$include == null) {
                        scope.$include = [];
                    }
                    scope.$include.push('');
                    var isolatedScope = scope.$$childTail;
                    // element.isolateScope().$watch('active',
                    isolatedScope.$watch('active',
                        function (newValue) {

                            if (newValue) {
                                scope.$include[scope.$index ? scope.$index : selfIndex(element)] = attrs.tabInclude;
                            }
                        }
                    );
                };
            }
        };
    }]);
(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentDownload', attachmentDownload);

    /** @ngInject */
    function attachmentDownload($compile, Dlg, WxHelper, FileHelper, deviceDetector) {
        return {
            restrict: 'EA',
            scope: {
                attachmentDownload: '=attachmentDownload', // 作为属性时用这个，作为元素时用下面的model
                model: '=ngModel',
                customClass: '@customClass',
                name: '@attachFieldName',
                url: '@',   // 下载访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/download
                type: '@',  // 附件类型
                mod: '@'    // 模块名称
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {

                        var vm = scope;
                        var att = scope.model ? scope.model : scope.attachmentDownload;
                        var url;

                        vm.download = download;

                        init();


                        function init() {
                            if (scope.attachmentDownload) {
                                $(iElement).click(function () {
                                    download();
                                });
                            } else {
                                var original = iElement.html().trim();
                                if (!original) original = '下载';
                                var elem = '<span>' +
                                    '<a ng-class="customClass" ng-click="download()">' + original;
                                if (angular.isUndefined(iAttrs.hideLoading)) {
                                    elem += '<span ng-show="model.downloading" class="fa fa-circle-o-notch fa-spin text-muted"></span>';
                                }
                                elem += '</a></span>';

                                var layer = angular.element(elem);
                                var el = $compile(layer.contents())(scope);
                                iElement.replaceWith(el);
                            }


                            if (scope.url) {
                                url = scope.url;
                            } else {
                                url = "/api/v1/";
                                if (scope.mod) url += scope.mod + "/";
                                if (scope.type) url += scope.type + "/";
                                url += "download";
                            }
                        }

                        function download() {
                            if (WxHelper.isWechatBrowser() || deviceDetector.isMobile()) {
                                Dlg.show({
                                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                                    ctrl: 'attachmentDownloadDlgCtrl',
                                    data: {attachment: att, name: scope.name},
                                    size: 'sm'
                                });
                            } else {
                                var rename = scope.name ? {name: scope.name} : {};
                                FileHelper.download1(url, att, rename);
                            }
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('attachmentDownloadDlgCtrl', attachmentDownloadDlgCtrl);

    /** @ngInject */
    function attachmentDownloadDlgCtrl($scope, $uibModalInstance, UIHelper, $http, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;


        init(data.attachment, data.name);


        function init(att, name) {
            var attachment = {
                name: name ? name : att.name,
                filename: att.filename,
                mime: att.mime,
                size: att.size,
            };

            attachment.ico = UIHelper.getIconFromMime(attachment.mime);
            attachment.size = parseInt(attachment.size);

            vm.attachment = attachment;

            $http.post('api/v1/file/download/mk_pub_link', {filename: attachment.filename})
                .success(function (resp) {
                    vm.url = resp;
                });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentList', attachmentList);

    /** @ngInject */
    function attachmentList($http, $timeout, FileHelper, ArrayHelper, Dlg, WxHelper, deviceDetector) {
        return {
            templateUrl: 'directives/ui/attachmentList/attachmentList.html',
            restrict: 'E',
            scope: {
                // model.attachments
                model: '=ngModel',
                required: '=ngRequired',
                name: '@attachFieldName',
                url: '@',   // 下载访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/download
                type: '@',  // 附件类型
                mod: '@',    // 模块名称
                size: '@'    // 尺寸 sm/md/lg
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var STATE = FileHelper.UPLOAD_STATE;
                var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
                var pdf = ['pdf'];
                var img = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
                var url;
                var vm = scope;
                vm.editable = angular.isDefined(iAttrs.editable);
                var ngModelCtrl = r[0], formCtrl = r[1];
                vm.deleteAttachment = deleteAttachment;
                vm.preview = preview;
                vm.download = download;

                init();


                function init() {
                    scope.attachments = [];
                    scope.$watch('model', function (newVal, oldVal) {
                        if (angular.isDefined(newVal)) {
                            if (scope.model instanceof Array) {
                                scope.attachments = scope.model;
                            } else {
                                scope.attachments = scope.model.attachments;
                            }
                            // ngModelCtrl.$setViewValue(scope.attachments);
                        }
                    });
                    if (vm.url) {
                        url = vm.url;
                    } else {
                        url = "/api/v1/";
                        if (vm.mod) url += vm.mod + "/";
                        if (vm.type) url += vm.type + "/";
                        url += "download";
                    }
                    if (formCtrl) {
                        scope.$watch(function () {
                            checkValidity();
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted');
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    valid = iAttrs.required ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function deleteAttachment(i) {
                    if (vm.attachments[i].upload) vm.attachments[i].$upload.abort();
                    vm.attachments.splice(i, 1);
                    ngModelCtrl.$setTouched();
                    // ngModelCtrl.$setViewValue(vm.attachments);
                    if (ngModelCtrl.$viewValue.length === 0) checkValidity();
                }

                function download(attachment) {
                    if (WxHelper.isWechatBrowser() || deviceDetector.isMobile()) {
                        Dlg.show({
                            template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                            ctrl: 'attachmentDownloadDlgCtrl',
                            data: {attachment: attachment, name: attachment.name},
                            size: 'sm'
                        });
                    } else {
                        var rename = scope.name ? {name: scope.name} : {};
                        FileHelper.download1(url, attachment, rename);
                    }
                }


                function preview(attachment) {
                    var extension = attachment.filename.split('.').pop().toLowerCase();
                    var type = undefined;
                    if (ArrayHelper.inArray(extension, office) !== -1) {
                        type = 1;  // office
                    } else if (ArrayHelper.inArray(extension, pdf) !== -1) {
                        type = 2;  // pdf
                    } else if (ArrayHelper.inArray(extension, img) !== -1) {
                        type = 3;  // img
                    }
                    if (!type) {
                        Dlg.i('不支持的预览该类型附件');
                        return;
                    }
                    if (attachment.state == STATE.UPLOADING || attachment.state == STATE.FAILED) {
                        Dlg.i('附件未上传成功，无法预览');
                        return;
                    }
                    $http.post('api/v1/file/preview/mk_pub_link', {filename: attachment.filename})
                        .success(function (resp) {
                            var docFullUrl = location.protocol + "//" + location.host + resp;
                            var url = type === 1 ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + docFullUrl:
                                "/api/v1/file/preview?type=2" + "&filename=" + resp + "&name=" + attachment.name;
                            if (deviceDetector.isDesktop()) {
                                var win = window.open(url);
                                $timeout(function () {
                                    win.document.title = attachment.name;
                                });
                            } else {
                                Dlg.show({
                                    template: 'pages/preview/showDlg.html',
                                    ctrl: 'PreviewShowDlgCtrl',
                                    data: {url: url, name: attachment.name},
                                    pos: 'right', backdrop: false, size: 'full'
                                });
                            }
                        }).error(function (err) {
                        if (err.msg) Dlg.e(err.msg);
                    });
                }
            },
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentPreview', attachmentPreview);

    /** @ngInject */
    function attachmentPreview($compile, $http, $timeout, ArrayHelper, Dlg, deviceDetector, OS) {
        var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        var pdf = ['pdf'];
        var img = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];


        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                name: '@attachFieldName',
                customClass: '@customClass'
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var vm = scope;
                        vm.op = {};
                        vm.preview = preview;
                        var type = null;
                        var att = scope.model;
                        var name = scope.name ? att[scope.name] : att.name;

                        init();


                        function init() {
                            var original = iElement.html().trim();
                            if (!original) original = '预览';
                            var elem =
                                '<span>' +
                                '<a class="attachment-preview" ng-class="customClass" ' +
                                'ng-if="type" ng-click="preview(op)"' + 'popover-trigger="outsideClick">' + original + '</a></span>';


                            var layer = angular.element(elem);
                            var el = $compile(layer.contents())(scope);
                            iElement.replaceWith(el);


                            vm.ios = deviceDetector.os === OS.IOS;
                            vm.os = deviceDetector.os;
                            if (!att.filename) return;
                            var extension = att.filename.split('.').pop().toLowerCase();
                            if (ArrayHelper.inArray(extension, office) !== -1) {
                                type = 1;  // office
                            } else if (ArrayHelper.inArray(extension, pdf) !== -1) {
                                type = 2;  // pdf
                            } else if (ArrayHelper.inArray(extension, img) !== -1) {
                                type = 3;  // img
                            }
                            vm.type = type;
                        }

                        function preview() {
                            $http.post('api/v1/file/preview/mk_pub_link', {filename: att.filename})
                                .success(function (resp) {
                                    var docFullUrl = location.protocol + "//" + location.host + resp;
                                    var url = type === 1 ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + docFullUrl:
                                        "/api/v1/file/preview?type=" + type + "&filename=" + resp + "&name=" + name;
                                    if (deviceDetector.isDesktop()) {
                                        var win = window.open(url);
                                        $timeout(function () {
                                            win.document.title = name;
                                        });
                                    } else {
                                        Dlg.show({
                                            template: 'pages/preview/showDlg.html',
                                            ctrl: 'PreviewShowDlgCtrl',
                                            data: {url: url, name: name},
                                            pos: 'right', backdrop: false, size: 'full'
                                        });
                                    }
                                }).error(function (err) {
                                if (err.msg) Dlg.e(err.msg);
                            });
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentUploadBtn', attachmentUploadBtn);

    /** @ngInject */
    function attachmentUploadBtn($compile, Dlg, FileHelper, ArrayHelper, Upload) {
        return {
            restrict: 'E',
            scope: {
                // model.attachments
                model: '=ngModel',
                customClass: '@',
                name: '@attachFieldName',
                maxSize: '@maxSize',
                url: '@',   // 上传访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/upload
                // 如：/api/v1/emails/upload
                type: '@',  // 附件类型
                acceptType: '@',  // 指定附件类型
                mod: '@',   // 模块名称
                ngfResize: '@',    // 压缩文件
                // single
                // multiple 默认
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var STATE = FileHelper.UPLOAD_STATE;
                        var single = angular.isDefined(iAttrs.single);
                        var acceptType = iAttrs.acceptType;
                        var ngfResize = iAttrs.ngfResize;
                        var url;
                        if (!scope.maxSize) scope.maxSize = '100MB';
                        var maxSize = FileHelper.humanReadableSizeToValue(scope.maxSize);

                        scope.uploadFiles = uploadFiles;

                        init();


                        function init() {
                            scope.attachments = [];
                            scope.$watch('model', function (newVal, oldVal) {
                                if (angular.isDefined(newVal)) {
                                    if (scope.model instanceof Array) {
                                        scope.attachments = scope.model;
                                    } else {
                                        scope.attachments = scope.model.attachments;
                                    }
                                }
                            });
                            var original = iElement.html().trim();

                            if (single) {
                                if (!original) {
                                    original = '<i class="fa fa-paperclip"></i>\n' +
                                        '<span ng-if="attachments.length>0">重新上传</span>\n' +
                                        '<span ng-else>添加附件</span>\n';
                                }
                                if (scope.ngfResize) {
                                    var elem = '<a type="file" name="attachments" href="#" ' + 'accept={{acceptType}} ' + 'ngf-resize={{ngfResize}} ' +
                                        'ng-class="customClass" ' + 'ngf-select="uploadFiles($files)">' + original + '</a>';
                                } else {
                                    var elem = '<a type="file" name="attachments" href="#" ' + 'accept={{acceptType}} ' +
                                        'ng-class="customClass" ' + 'ngf-select="uploadFiles($files)">' + original + '</a>';
                                }
                            } else {
                                if (!original) {
                                    original = '<i class="fa fa-paperclip"></i>\n' +
                                        '<span ng-if="attachments.length>0">继续添加</span>\n' +
                                        '<span ng-else>添加附件</span>\n';
                                }
                                if (scope.ngfResize) {
                                    var elem = '<a type="file" name="attachments" href="#" ' + 'accept={{acceptType}} ' + 'ngf-resize={{ngfResize}} ' +
                                        'ng-class="customClass" ' + 'ngf-select="uploadFiles($files)" ' +
                                        'multiple="multiple">' + original + '</a>';
                                } else {
                                    var elem = '<a type="file" name="attachments" href="#" ' + 'accept={{acceptType}} ' +
                                        'ng-class="customClass" ' + 'ngf-select="uploadFiles($files)" ' +
                                        'multiple="multiple">' + original + '</a>';
                                }
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            if (scope.url) {
                                url = scope.url;
                            } else if (scope.mod || scope.type) {
                                url = "/api/v1/";
                                if (scope.mod) url += scope.mod + "/";
                                if (scope.type) url += scope.type + "/";
                                url += "upload";
                            } else {
                                url = '/api/v1/file/attachments/upload_single'
                            }
                        }

                        function uploadFiles(files) {
                            if (!files) return;
                            var uploadFiles = ArrayHelper.filter(files, function (file) {
                                return file.size <= maxSize;
                            });
                            if (uploadFiles.length === 0) {
                                Dlg.error("上传文件大小不能超过" + scope.maxSize);
                                return;
                            }
                            if (uploadFiles.length < files.length) {
                                Dlg.notify("已忽略超过限制大小（" + scope.maxSize + "）的文件");
                            }
                            for (var i = 0; i < uploadFiles.length; i++) {
                                uploadFile(uploadFiles[i]);
                            }
                        }

                        function uploadFile(file) {
                            var attachment = {name: file.name, progress: 0};
                            var pa = {
                                url: url, file: file
                            };
                            if (single) {
                                scope.attachments.splice(0, 1, attachment);
                            } else {
                                scope.attachments.push(attachment);
                            }
                            attachment.$state = STATE.UPLOADING;
                            attachment.$upload = Upload.upload(pa).progress(function (evt) {
                                attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
                            }).success(function (resp) {
                                switch (resp.result) {
                                    case 0:
                                        attachment.name = resp.name;
                                        attachment.mime = resp.mime;
                                        attachment.filename = resp.filename;
                                        attachment.size = resp.size;
                                        attachment.$state = STATE.UPLOADED;
                                        break;
                                    case 1:
                                        attachment.progress = 101;
                                        attachment.errorInfo = '服务器空间不足!';
                                        attachment.$state = STATE.FAILED;
                                        break;
                                }
                            }).error(function () {
                                attachment.progress = 102;
                                attachment.errorInfo = '服务器错误!';
                                attachment.$state = STATE.FAILED;
                            });
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('backTop', backTop)
        .directive('contentBackTop', contentBackTop)
    ;

    /** @ngInject */
    function contentBackTop(UIHelper) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var e = element[0];

                var backTopIcon = '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>';
                backTopIcon = angular.element(backTopIcon);
                backTopIcon.css('position', 'fixed');
                backTopIcon.css('bottom', '80px');
                element.append(backTopIcon);
                backTopIcon.bind('click', function () {
                    UIHelper.scrollTo(undefined, e.id === '' ? undefined : e.id);
                });

                element.bind('scroll', function () {
                    var top = e.scrollTop;
                    if (top > 200) {
                        backTopIcon.fadeIn();
                    } else {
                        backTopIcon.fadeOut();
                    }
                });
            }
        };
    }

    /** @ngInject */
    function backTop() {
        return {
            restrict: 'E',
            template: '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>',
            controller: function () {
                $('#backTop').backTop({
                    'position': 200,
                    'speed': 100
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c.d')
        .directive('integerSpinner', integerSpinner);

    /** @ngInject */
    function integerSpinner() {
        return {
            templateUrl: 'directives/ui/integerSpinner/integerSpinner.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                disabled: '=?',
                onChange: '&'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var min = angular.isDefined(iAttrs.min) ? parseInt(iAttrs.min) : 0;
                var max = angular.isDefined(iAttrs.max) ? parseInt(iAttrs.max) : 99999;
                var vm = scope;
                vm.increase = increase;
                vm.decrease = decrease;
                vm.numChanged = numChanged;

                init();


                function init() {
                }

                function numChanged(num) {
                    if (typeof num !== 'number') {
                        num = typeof num === 'undefined' ? min
                            : parseInt(num.replace(/[^0-9]/g, ''));
                    }

                    if (isNaN(num)) {
                        num = min;
                    } else {
                        if (num < min) {
                            num = min;
                        } else if (num > max) {
                            num = max;
                        }
                    }
                    vm.model = num;

                    if (vm.onChange) vm.onChange({num: num});
                }

                function increase() {
                    numChanged(vm.model + 1);
                }

                function decrease() {
                    numChanged(vm.model - 1);
                }


            }
        }
    }

})();
(function () {
    'use strict';
    angular.module('c.d')
        .directive('taskStep', function () {
            return {
                templateUrl: 'directives/task/taskStep/taskStep.html',
                restrict: 'E',
                scope: {
                    model: '=ngModel',
                    hideLeader: '=',
                    currentStep: '=',
                    hideEnd: '='
                },
                require: ['^ngModel'],
                controller: ctrl
            }
        });

    /** @ngInject */
    function ctrl($rootScope, $scope, Dlg) {
        var vm = $scope;
        vm.rmStep = rmStep;
        vm.addStep = addStep;
        vm.getStepToolTip = getStepToolTip;
        vm.addBatchStep = addBatchStep;
        vm.removeStepGroup = removeStepGroup;
        vm.addStepGroup = addStepGroup;
        var parentScope = vm.$parent;
        parentScope.vm.addStepGroup = addStepGroup;

        init();

        function init() {

        }

        function addStepGroup(m) {
            m.push([]);
            vm.model = m;
        }

        function rmStep(index, groupIndex, m) {
            m[groupIndex].splice(index, 1);
            vm.model = m;
        }

        function removeStepGroup(groupIndex, m) {
            var canRemove = true;
            angular.forEach(m[groupIndex], function (item) {
                if (item.isDisabled) canRemove = false;
            })
            if (canRemove) {
                m.splice(groupIndex, 1);
                vm.model = m;
            } else {
                Dlg.w('存在进行中的任务，无法阶段删除');
            }
        }

        function getStepToolTip(stepIndex, stepGroups) {
            return '阶段' + (stepIndex + 1) + '(步骤' + (stepGroups[stepIndex].length + 1) + ')';
        }

        function addStep(stepIndex, stepGroups) {
            stepGroups[stepIndex].push(
                {
                    'name': '',
                }
            );
        }

        function addBatchStep(stepIndex, stepGroups) {
            Dlg.show({
                template: 'pages/dlg/task/addEdit/batchAddChildTask.html',
                ctrl: 'BatchAddChildTaskCtrl'
            }).then(function (resp) {
                var users = resp.users;
                var name = resp.name;
                var end = resp.end;
                angular.forEach(users, function (user) {
                    stepGroups[stepIndex].push(
                        {
                            'name': name,
                            'leader': user,
                            'end': end,
                        }
                    );
                });

            });
        }
    }
})();

(function () {
    'use strict';
    angular.module('c.d')
        .directive('taskStepLine', function () {
            return {
                templateUrl: 'directives/task/taskStepLine/taskStepLine.html',
                restrict: 'E',
                scope: {
                    model: '=ngModel'
                },
                require: ['^ngModel'],
                controller: ctrl
            }
        });

    /** @ngInject */
    function ctrl($rootScope, $scope) {
        console.log('taskStepLine');
    }
})();

angular.module('c.c').controller('CAFeeCtrl',
    function ($scope, $rootScope, $filter, toaster, NgTableParams, dialogs, CApply) {

        $scope.cols = [
            {title: '科室', show: true},
            {
                title: '次数',
                show: true
            },
            {
                title: '金额',
                field: 'depts.name',
                show: true
            }
        ];

        $scope.optColWidth = 45;

        var date = new Date((new Date()).setDate(1));
        $scope.dts = new Date(date.setMonth(date.getMonth() - 1));
        $scope.dte = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dts = new Date(curr.setMonth(prev));
            $scope.dte = new Date(curr.getFullYear(), prev + 1, 0);
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dts = new Date(curr.setMonth(next));
            $scope.dte = new Date(curr.getFullYear(), next + 1, 0);
        };

        $scope.$watch('dts', function (newVal, oldVal, scope) {
            $scope.tableParams.reload();
        }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 15;
                url['start'] = $filter('date')($scope.dts, 'yyyy-MM-dd');
                url['end'] = $filter('date')($scope.dte, 'yyyy-MM-dd');
                CApply.query(url, function (data) {
                    $scope.types = data.types;
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.check = function (record) {
            dialogs.create('CheckCarRecord.html', 'CheckCarRecordCtrl',
                {
                    'record': record,
                    'start': $filter('date')($scope.dts, 'yyyy-MM-dd'),
                    'end': $filter('date')($scope.dte, 'yyyy-MM-dd')
                },
                { size: 'lg'});
        };

    });

angular.module('c.c').controller('CheckCarRecordCtrl',
    function ($scope, $uibModalInstance, CApply, data, NgTableParams) {

        $scope.dept = data.record;
        $scope.hideOpt = true;
        $scope.hideFilter = true;


        $scope.cols = [
            {title: '开始时间', show: true},
            {
                title: '结束时间',
                show: true
            },
            {
                title: '金额',
                show: true
            },
            {
                title: '原因',
                show: true
            }
        ];

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                $scope.url = params.url();
                url['start'] = data.start;
                url['end'] = data.end;
                url['dept_id'] = data.record.id;
                url['opt'] = 16;
                CApply.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });


        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('CARecordCtrl',
    function ($scope, $rootScope, $filter, toaster, C, F, Api, NgTableParams, dialogs, CApply) {

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');
        var stage_list2 = F.getNgTableOpts(F.get('stage_list2'));
        $scope.stage_list2 = F.get('stage_list2');

        $scope.cols = [
            {title: '详情', field: 'more', show: true},
            {
                title: '状态',
                filter: {'car_applications.status': 'select'},
                field: 'status',
                data: stage_list2,
                show: true
            },
            {
                title: '申请人',
                show: true
            },
            {
                title: '申请科室',
                filter: {'depts.name': 'text'},
                field: 'depts.name',
                show: true
            },
            {
                title: '车型',
                sortable: 'type_id',
                filter: {'car_applications.type_id': 'select'},
                field: 'type_id',
                show: true
            },
            {
                title: '车牌',
                filter: {'plate_num': 'text'},
                field: 'plate_num',
                show: true
            },
            {
                title: '驾驶员 ',
                filter: {'users.name': 'text'},
                field: 'users.name',
                show: true
            },
            {
                title: '审批人 ',
                show: true
            },
            {
                title: '是否滴滴用车', filter: {is_de: 'select'},
                field: 'is_de', show: true, data: yesNoOpts
            }
        ];

        $scope.type_cols = $scope.cols[4];
        $scope.hideOpt = true;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 13;
                CApply.query(url, function (data) {
                    $scope.types = data.types;
                    $scope.type_cols.data = F.getNgTableOpts(data.types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        //$scope.edit = function (record) {
        //    record.$edit = true;
        //    record.$remarkChanged = record.remarks;
        //    record.$desChanged = record.destination;
        //    record.$preMileChanged = record.pre_mile;
        //    record.$laterMileChanged = record.later_mile;
        //    record.$feeChanged = record.fee;
        //};
        //
        //$scope.ok = function (record) {
        //    var params = {};
        //    params['remarks'] = record.$remarkChanged;
        //    params['destination'] = record.$desChanged;
        //    params['pre_mile'] = record.$preMileChanged;
        //    params['later_mile'] = record.$laterMileChanged;
        //    params['fee'] = record.$feeChanged;
        //    CApply.update({id: record.id}, params).$promise.then(function () {
        //        record.$edit = false;
        //        record.remarks = record.$remarkChanged;
        //        record.destination = record.$desChanged;
        //        record.pre_mile = record.$preMileChanged;
        //        record.later_mile = record.$laterMileChanged;
        //        record.fee = record.$feeChanged;
        //    }, function () {
        //        toaster.error('更改失败!');
        //    });
        //};

        $scope.edit = function (record) {
            dialogs.create('templates/car_manage/edit_record.html', 'CREditCtrl', {
                    'record': record
                }, {
                    size: 'md'
                }
            ).result.then(function (c_record) {
                CApply.update({id: record.id}, c_record).$promise.then(function () {
                    toaster.success('更改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('更改失败!');
                });
            });
        };

        $scope.export = function () {
            Api.exportDR(C.URL.CARS_DOWNLOAD, "用车统计");
        };

    });

angular.module('c.c').controller('CREditCtrl',
    function ($scope, $uibModalInstance, $filter, uibDateParser, toaster, data, ArrayHelper, CarDestination, F) {
        $scope.CarLFees = F.get('CarLFees');

        CarDestination.query({opt: 2}, function (resp) {
            $scope.destinations = $scope.CarLFees.concat(resp.items);
            var record = data.record;

            var destination;
            if (record.de) {
                destination = [record.de];
            } else {
                var de = ArrayHelper.getItem(record.destination, $scope.destinations, 'name');
                destination = [de != null ? de : {name: record.destination}];
            }

            $scope.car = {
                destination: destination,
                remarks: record.remarks,
                pre_mile: record.pre_mile,
                later_mile: record.later_mile,
                fee: record.fee,
                start_time: uibDateParser.parse(record.start_time, 'yyyy-MM-dd HH:mm:ss'),
                end_time: uibDateParser.parse(record.end_time, 'yyyy-MM-dd HH:mm:ss'),
                set_destination: false
            };
        });

        $scope.ok = function (record) {
            if ($scope.cr_form.$valid) {
                if (record.start_time > record.end_time) {
                    toaster.warning('开始日期必须大于结束日期,请仔细检查!');
                    $scope.cr_form.submitted = true;
                } else {
                    var params = {};
                    params['start_time'] = $filter('date')(record.start_time, 'yyyy-MM-dd HH:mm:ss');
                    params['end_time'] = $filter('date')(record.end_time, 'yyyy-MM-dd HH:mm:ss');
                    params['destination'] = record.destination;
                    params['remarks'] = record.remarks;
                    params['pre_mile'] = record.pre_mile;
                    params['later_mile'] = record.later_mile;
                    params['later_mile'] = record.later_mile;
                    if (record.later_mile && record.later_mile != 0) {
                        params['status'] = 8; //回程已填
                    }
                    params['fee'] = record.fee;
                    params['set_destination'] = record.set_destination ? 1 : 0;

                    $uibModalInstance.close(params);
                }
            }
            else {
                toaster.warning('表单中有错误!');
                $scope.l_form.submitted = true;
            }
        }
        ;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.tagTrans = function (newTag) {
            var item = ArrayHelper.getItem(newTag, $scope.destinations, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        }
    });

angular.module('c.c').controller('ExportCarCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, C, F, FileHelper, SaveAs, data) {

        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        $scope.s = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0)
        };

        $scope.ok = function (s) {
            if ($scope.s_form.$valid) {
                if (s.start > s.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                params['start'] = $filter('date')(s.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(s.end, 'yyyy-MM-dd');
                s.downloading = true;
                FileHelper.download(C.URL.CARS_DOWNLOAD, params, function (resp) {
                    s.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = params['start'] + '到' + params['end'] + '用车统计.xls';
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function (error) {
                    s.downloading = false;
                    toaster.error('导出失败!');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('CjBalanceCtrl', function ($scope, Balance, Table) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Balance,
                params: {opt: 1/*INDEX_ALL*/, forCj: 1},
                sorting: {user_id: 'asc'},
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "main_dept", title: "科室", filter: {main_dept: "text"}},
                    {field: "balance", title: "金额", filter: {balance: "num_range"}}
                ]
            };
            Table.load(vm, options);
        }
    });


angular.module('c.c')
    .controller('CjMealHandleCtrl', function ($scope, $rootScope, $q, PurchaseHistory, C, F,
                                              Table, FileHelper, dialogs, toaster, Store, Dlg) {
        var vm = $scope;
        vm.init = init;
        vm.setState = setState;
        vm.export1 = exportPH1;
        vm.export2 = exportPH2;

        function init(data) {
            vm.$on('phCjHandle', function () {
                vm.tableReload();
            });

            vm.type = data;

            var options = {
                service: PurchaseHistory,
                params: {opt: 4/*PURCHASE_HISTORY.INDEX_HOSPITAL_HANDLE*/, type: data, forCj: 1},
                sorting: {time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: "dept", title: '科室', filter: {dept: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time', filter: {time: 'date_range'}},
                    {
                        field: 'pay_time',
                        title: '慈济支付时间',
                        sortable: 'time',
                        filter: {pay_time: 'date_range'},
                        show: data == 3
                    }
                ]
            };

            var optionsFn = null;

            Store.query({opt: 2/*STORE.INDEX_OPTIONS*/}, function (resp) {
                vm.stores = resp.items;
                if (vm.stores && vm.stores.length > 0) {
                    options.params.storeId = vm.stores[0].id;
                    vm.store = vm.stores[0];
                }
                optionsFn = Table.load(vm, options, function (resp) {
                    vm.periodTotal = resp.periodTotal;
                }).options;
            });


            vm.storeSelectedFn = function (s) {
                vm.store = s;
                optionsFn().params.storeId = s.id;
                vm.tableParams.$params.page = 1;
                vm.tableReload();
            }
        }

        function exportPH1() {
            dialogs.create('PHE.html', 'PHECtrl', {
                day: vm.dt,
                url: C.URL.PURCHASE_HISTORY_DOWNLOAD,
                forCj: 1,
                title: '慈济餐补统计导出表.xls'
            }, {size: 'md'});
        }


        function exportPH2() {
            dialogs.create('PHPE.html', 'PHPECtrl',
                {title: '慈济餐补统计导出(以支付时间为准)', url: '/api/v1/purchase_history/pay_export', forCj: 1}, {size: 'md'});
        }


        function setState() {
            dialogs.confirm(vm.type == 1 ? '接收申请' : '慈济付款', vm.type == 1 ? '确定要接收所选商家的销账申请吗?' : '确定要付款给所选商家吗?')
                .result.then(function () {
                var opt = vm.type == 1 ? 3 : 4;
                Store.setState({
                    storeId: vm.store.id,
                    opt: opt,/*STORE.BATCH_APPLY*/
                    forCj: 1
                }).$promise.then(function (resp) {
                    toaster.success(resp.msg);
                    if (vm.type == 1) {
                        vm.tabs['handle'] = true;
                    } else {
                        vm.tabs['pay'] = true;
                    }
                    $rootScope.$broadcast('phCjHandle');
                    vm.tableReload();
                });
            });
        }
    });

(function () {
    'use strict';

    angular.module('c.c').controller('PHPECtrl', PHPECtrl);

    /** @ngInject */
    function PHPECtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data, $http, SaveAs, Dlg, C) {
        var vm = $scope;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        $scope.$on(C.P + 'ph.download', function (event, data) {
            var params = data.data.data;
            FileHelper.download('api/home/appointments/download', params, function (resp) {
                SaveAs.download([resp], params.name, {type: params.mime});
                vm.downloading = false;
            }, function () {
                Dlg.w('下载失败,重新尝试');
                vm.downloading = false;
            });
        });

        init();


        function init() {
            var date = new Date(), y = date.getFullYear(), m = date.getMonth();
            vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
        }

        function ok(m, Form) {
            // var defer = $q.defer();
            // var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    // validFailed = false;
                    var start, end, title;
                    start = DateHelper.date2Str(m.start);
                    end = DateHelper.date2Str(m.end);
                    title = start + '到' + end + data.title + '.xls';
                    var pa = {start: start, end: end, forCj: data.forCj};
                    vm.downloading = true;
                    $http.post(data.url, pa);
                    // FileHelper.dnExcel(data.url, pa, title, function () {
                    //     $uibModalInstance.close();
                    // }).finally(function () {
                    //     defer.resolve();
                    // });
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            // if (validFailed) {
            //     defer.reject();
            // }
            // return defer.promise;
        }
    }
})();
angular.module('c.c')
    .controller('CjRechargeCtrl', function ($scope, Recharge, Table, F) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Recharge,
                params: {opt: 1/*INDEX_ALL*/,forCj: 1},
                sorting: {created_at: 'desc'},
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "money", title: "金额", filter: {money: "num_range"}},
                    {
                        field: "is_cost",
                        title: "计入科室成本",
                        filter: {is_cost: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    },
                    {field: "created_at", title: "充值时间", filter: {created_at: "date_range"}},
                    {field: "handler", title: "充值人", filter: {handler: "text"}},
                    {field: "note", title: "充值理由", filter: {note: "text"}}
                ]
            };
            Table.load(vm, options);
        }
    });


angular.module('c.c')
    .controller('CjMealSearchCtrl', function ($scope, PurchaseHistory, C, F, Table,
                                                   $ocLazyLoad, dialogs, toaster, Store) {
        var vm = $scope;
        vm.pHStates = F.get('pHStates');

        init();

        function init() {
            var options = {
                service: PurchaseHistory,
                params: {opt: 5/*PURCHASE_HISTORY.INDEX_HOSPITAL_SEARCH*/,forCj: 1},
                sorting: {time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time', filter: {time: 'date_range'}},
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: F.getNgTableOpts(vm.pHStates)
                    },
                    {field: "handler", title: '操作人', filter: {handler: 'text'}},
                ]
            };

            var optionsFn = null;

            Store.query({opt: 2/*STORE.INDEX_OPTIONS*/}, function (resp) {
                vm.stores = resp.items;
                if (vm.stores && vm.stores.length > 0) {
                    options.params.storeId = vm.stores[0].id;
                    vm.store = vm.stores[0];
                }
                optionsFn = Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (i) {
                        i.state = F.getItem(i.state, vm.pHStates);
                    });
                    vm.periodTotal = resp.periodTotal;
                }).options;
            });


            vm.storeSelectedFn = function (s) {
                vm.store = s;
                optionsFn().params.storeId = s.id;
                vm.tableParams.$params.page = 1;
                vm.tableReload();
            }
        }
    });





angular.module('c.c')
    .controller('CjWMCtrl', function ($scope, $filter, dialogs, toaster, WorkingMeal, Store, Table, C, F) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: WorkingMeal,
                params: {opt: 6 /*WORKINGMEAL.INDEX_GENERAL_SEARCH*/, forCj: 1},
                sorting: {handler_time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "num", title: "数量"},
                    {
                        field: "handler_time",
                        width: '20%',
                        title: "确认时间",
                        filter: {handler_time: "date_range"},
                        sortable: "handler_time"
                    },
                    {field: "handler", title: "处理人", filter: {handler: "text"}}
                ]
            };

            var optionsFn = null;

            Store.query({opt: 2/*STORE.INDEX_OPTIONS*/}, function (resp) {
                vm.stores = resp.items;
                if (vm.stores && vm.stores.length > 0) {
                    options.params.storeId = vm.stores[0].id;
                    vm.store = vm.stores[0];
                }
                optionsFn = Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (i) {
                        i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                    });
                }).options;
            });

            vm.storeSelectedFn = function (s) {
                vm.store = s;
                optionsFn().params.storeId = s.id;
                vm.tableParams.$params.page = 1;
                vm.tableReload();
            }
        }
    });




angular.module('c.c')
    .controller('MeetingApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, C, F, Meeting, UIHelper) {
        UIHelper.loadTab($scope, 'meeting_approval');
        $scope.$on('meetingBack', function (event, data) {
            $scope.tableParams.reload();
        });

        var stages = F.getApprovalStages8();
        var stagesOpts = F.getNgTableOpts(stages);

        $scope.cols = [
            {title: '名称', width: '20%', show: true},
            {title: '类型', width: '20%', show: true},
            //{title: '开会时间', width: '20%', show: true},
            //{title: '开会地点', width: '10%', show: true},
            {title: '申请人', show: true},
            {title: '申请时间', show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        $scope.optColWidth = 53;
        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //科审3,院审4
                Meeting.query(url, function (data) {
                    params.total(data.total);
                    angular.forEach(data.meetings, function (meeting) {
                        meeting.stage = F.getItem(meeting.stage, stages);
                    //    meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                    });
                    $defer.resolve(data.meetings);
                });
            }
        });

        $scope.approval = function (meeting) {
            dialogs.create('templates/meeting/edit_dlg.html', 'MeetingEditDlgCtrl', {
                id: meeting.id, ForApproval: true, deptId: meeting.dept_id
            }, {
                size: 'lg'
            }).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议审批成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('会议室冲突');
                                break;
                            case 2:
                                toaster.warning('设备冲突');
                                break;
                            case 3:
                                toaster.warning('该会议已发布');
                                break;
                        }
                    }, function () {
                        toaster.error('会议审批失败了!');
                    }
                );
            });
        };
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('MeetingWorkableCtrl', MeetingWorkableCtrl);

    /** @ngInject */
    function MeetingWorkableCtrl($scope, ArrayHelper, Table, Dlg, MeetingRecord, UIHelper) {
        var vm = $scope;
        vm.edit = edit;
        vm.finish = finish;
        vm.show = show;

        init();


        function init() {
            UIHelper.loadTab($scope, 'workable');
            var states = MeetingRecord.getStates();
            var options = {
                service: MeetingRecord,
                params: {op: 'workable'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "会议名称", filter: {name: "text"}},
                    {field: "resolution", title: "决议", filter: {resolution: "text"}},
                    {field: "start_time", title: "开会时间", width: Table._1_CHAR},
                    {field: "estimated_time", title: "拟完成时间", width: Table._1_CHAR},
                    {
                        field: "state", title: "状态", filter: {state: "select"}, width: Table._1_CHAR,
                        data: Table.getNgTableOpts(states),
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = ArrayHelper.getItem(item.state, states);

                });
            });

        }

        function edit(m) {
            Dlg.show({
                template: 'templates/meeting/workableDlg.html',
                ctrl: 'MeetingWorkableDlgCtrl',
                data: {
                    id: m.id
                },
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'templates/meeting/workableDlg.html',
                ctrl: 'MeetingWorkableDlgCtrl',
                data: {
                    id: m.id,
                },
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });

        }

        function finish(m) {
            Dlg.show({
                template: 'templates/meeting/workableDlg.html',
                ctrl: 'MeetingWorkableDlgCtrl',
                data: {
                    id: m.id,
                    finish: true,
                },
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }
    }

})();


angular.module('c.c')
    .controller('TopicApprovalCtrl', function ($rootScope, $scope, $filter, dialogs, toaster, NgTableParams, C, F, MeetingTopic) {
        $scope.$on('topicBack', function () {
            $scope.tableParams.reload();
        });

        var stages = F.get('approval_stages4');
        var topic_types = F.get('topic_types');

        $scope.cols = [
            {title: '标题', width: '20%', show: true},
            {title: '类型', width: '20%', show: true},
            {title: '申请人', show: true},
            {title: '申请时间', show: true},
            {title: '状态', show: true}
        ];

        $scope.optColWidth = 53;
        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //科审2,院审3,13书记审，14院长审 15 书记院长已审核 19 党办审批
                MeetingTopic.query(url, function (data) {
                    params.total(data.total);
                    angular.forEach(data.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                        topic.stage = F.getItem(topic.stage, stages);
                    });
                    $defer.resolve(data.topics);
                });
            }
        });

        $scope.approval = function (topic) {
            dialogs.create('templates/meeting_topic/edit_dlg.html', 'TopicEditDlgCtrl', {
                id: topic.id, ForApproval: true, deptId: topic.dept_id
            }, {
                size: 'lg'
            }).result.then(function (params) {
                MeetingTopic.update({id: topic.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('议题审批成功');
                                $scope.tableParams.reload();
                                $rootScope.$broadcast('topicApproved');
                                break;
                            case 2:
                                toaster.warning('该议题已审批');
                                break;
                        }
                    }, function () {
                        toaster.error('议题审批失败了!');
                    }
                );
            });
        };
    });


angular.module('c.c').controller('TopicSearchController',
    function ($scope, $rootScope, $filter, $timeout, dialogs, toaster, NgTableParams, F, C, MeetingTopic) {
        $scope.$on('topicApproved', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        if ($scope.opt === '16' || $scope.opt === '17' || $scope.opt === '18') {
            F.loadTab($scope, 'confirm');
        }

        var stages = F.get('approval_stages4');
        var stagesOpts = F.getNgTableOpts(stages);
        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '类型', sortable: 'type', filter: {type: 'select'}, data: topic_typesOpts, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        $timeout(function () {
            if ($scope.opt == C.OPT.MEETING_TOPIC.INDEX.HOSPITAL_SEARCH) {
                $scope.cols[0].show = false;
                $scope.cols[5].data = stagesOpts.slice(5, 8);
            }
            if ($scope.opt == C.OPT.MEETING_TOPIC.INDEX.HOSPITAL_APPROVALED) {
                $scope.cols[5].data = stagesOpts.slice(3, 8);
            }
            if ($scope.opt == C.OPT.MEETING_TOPIC.INDEX.DEPT_SEARCH) {
                $scope.cols[5].data = stagesOpts.slice(0, 8);
            }
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //科室议题4，分管院领导已审批议题5,分管院领导查询公开议题6
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                        topic.stage = F.getItem(topic.stage, stages);
                    });
                    $defer.resolve(resp.topics);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {id: topic.id},
                {size: 'lg'});

            if ($scope.opt == '16' || $scope.opt == '17') {   //书记或院长确认
                MeetingTopic.update({id: topic.id}, {'read': 1}).$promise.then(
                    $scope.tableParams.reload()
                );
            }
            if ($scope.opt == '18') {
                MeetingTopic.update({id: topic.id}, {'office_read': 1}).$promise.then(
                    $scope.tableParams.reload()
                );
            }
        };
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptLeaderMissionStatisticCtrl', DeptLeaderMissionStatisticCtrl);

    function DeptLeaderMissionStatisticCtrl ($scope, $filter, Dlg, Mission, Auth, DateHelper) {
        var vm = $scope;
        vm.tableReload = tableReload;

        init();


        function init () {
            var preMonth = new Date();
            preMonth.setMonth(preMonth.getMonth() - 1);
            preMonth.setDate(1);

            vm.m = {
                start: preMonth,
                end: new Date()
            };

            tableReload(vm.m.start, vm.m.end, '-');
        }

        var nowDeptId = null;

        function tableReload (start, end, deptId) {
            vm.loading = true;
            Mission.query({
                opt: 20/*INDEX_STATISTICS*/,
                start: DateHelper.date2Str(start),
                end: DateHelper.date2Str(end),
                dept_id: deptId
            }).$promise.then(function (resp) {
                vm.items = resp.items;
                nowDeptId = resp.dept.id;
                vm.m.dept = resp.dept;
            }).finally(function () {
                vm.loading = false;
            });
        }
    }

})();

angular.module('c.c').controller('PracticeWorkController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, F, Table,
              Practice, Dept, PracticeFeedback, C) {

        var practiceStates = F.getNgTableOpts(F.get('round_stages'));
        var practiceTypes = F.getNgTableOpts(F.get('wage_variable_headers'));

        $scope.init = function (param) {
            Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_LED_BY, with_agent: 2 /*practice*/}, function (resp) {
                $scope.depts = resp.depts;

                var options = {
                    service: Practice,
                    params: {opt: 1, is_work: 1},
                    optColWidth: 53,
                    dateFilters: [{name: 'practice_time'}],
                    items: 'practicers',
                    filter: {dept_id: $scope.depts[0]},
                    hideOpt: false,
                    cols: [
                        {title: '是否评价', filter: {is_feedback: 'select'}},
                        {title: '姓名', filter: {name: 'text'}},
                        {title: "实习科室", filter: {dept: 'text'}},
                        {title: '带教老师', filter: {teacher: 'text'}},
                        {title: '科室实习时间', filter: {practice_time: 'date_range'}},
                        {title: '实习类型', filter: {practice_type: 'select'}, data: practiceTypes},
                        {title: '实习状态', filter: {state: 'select'}, data: practiceStates},
                        {title: '备注'}
                    ]
                };

                if (param == 0) {
                    options.params.is_work = 1;
                    options.cols.splice(0, 1);
                    options.cols.splice(1, 1);
                } else if (param == 1) {
                    options.params.is_work = 0;
                    options.hideOpt = true;
                    options.cols.splice(0, 1);
                    options.cols.splice(1, 1);
                    options.cols.splice(4, 1);
                } else {
                    options.params.is_work = 1;
                    options.params.opt = 0;
                    options.cols.splice(5, 1);
                    options.cols.splice(6, 1);
                }
                get_options = Table.loadNgTable($scope, options, function (data) {
                    angular.forEach(data.practicers, function (practicer) {
                        if (practicer.state && practicer.state.length > 0) {
                            if (practicer.state == 1 && practicer.is_confirm == 0) {
                                practicer.state = {id: '4', name: '科室未确认'};
                            } else {
                                practicer.state = F.getItem(practicer.state, F.get('test_stages'));
                            }
                        } else {
                            practicer.state.name = '状态为空';
                        }
                        practicer.is_feedback = practicer.practice_feedback.length != 0 ? 1 : 0;
                        practicer.time_range = practicer.entry_time.substr(0, 16) + ' - ' + practicer.leave_time.substr(0, 16);
                    });
                }).options;
            });
        };

        $scope.edit = function (practicer) {
            dialogs.create('templates/practice/dept_edit.html', 'PracticeDeptStateCtrl'
                , {is_confirm: practicer.is_confirm, teacher: practicer.teacher, dept_id: practicer.dept_id}, {
                     size: 'md'
                }).result.then(function (params) {
                params['opt'] = 3;
                params['practicer'] = practicer;
                params.practicer.state_id = practicer.state.id;
                Practice.update({id: practicer.id}, params).$promise.then(function () {
                    $scope.tableReload();
                }, function () {
                    toaster.error('更新信息失败!');
                });
            });
        };

        $scope.feedback = function (practicer) {
            if (practicer.state.id != 2) {
                toaster.warning('请实习结束后再评价');
            } else if (practicer.is_feedback) {
                toaster.warning('已评价');
            } else {
                var createUrl = '';
                var is_doctor = 0;
                if (practicer.user.depts[0]['name'] != '实习护士') {
                    createUrl = 'templates/practice/feedback_doctor.html';
                    is_doctor = 1;
                } else {
                    createUrl = 'templates/practice/feedback.html';
                }
                dialogs.create(createUrl, 'PracticeFeedback',
                    {teacher: practicer.teacher, dept: practicer.dept, opt: 1, is_doctor: is_doctor}, {

                        size: 'lg'
                    }).result.then(function (params) {
                    params['user_id'] = practicer.user_id;
                    params['dept_id'] = practicer.dept_id;
                    params['practice_id'] = practicer.id;
                    params['get_teacher_id'] = practicer.teacher_id;
                    PracticeFeedback.save(params).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('存储评价成功');
                                $scope.tableReload();
                                break;
                        }
                    }, function () {
                        toaster.error('存储评价失败');
                    });
                })
            }
        };
    });
angular.module('c.c').controller('DeptRoundController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Table,
              Round, Dept) {

        var roundStates = F.getNgTableOpts(F.get('round_stages'));
        var yesOrNoOpt = F.getNgTableOpts(F.get('yesNo'));

        $scope.init = function (param) {
            Dept.query({opt: 6}, function (resp) {
                $scope.depts = resp.depts;
                var options = {
                    service: Round,
                    params: {opt: 1, is_work: 1},
                    optColWidth: 53,
                    dateFilters: [{name: 'practice_time'}],
                    items: 'users',
                    filter: {dept_id: $scope.depts[0]},
                    hideOpt: false,
                    cols: [
                        {title: '科室确认', filter: {is_confirm: 'select'}, data: yesOrNoOpt},
                        {title: '姓名', filter: {name: 'text'}},
                        {title: '轮转科室', filter: {dept: 'text'}},
                        {title: '工号', filter: {username: 'text'}},
                        {title: '主科室', filter: {dept: 'text'}},
                        {title: '科室工作时间', filter: {work_time: 'date_range'}},
                        {title: '轮转状态', filter: {state: 'select'}, data: roundStates},
                        {title: '备注'}
                    ]
                };

                if (param == 0) {
                    options.params.is_work = 1;
                    options.cols.splice(2, 1);
                } else if (param == 1) {
                    options.params.is_work = 0;
                    options.hideOpt = true;
                    options.cols.splice(0, 1);
                    options.cols.splice(1, 1);
                    options.cols.splice(4, 1);
                }

                get_options = Table.loadNgTable($scope, options, function (data) {
                    angular.forEach(data.users, function (user) {
                        if (user.state && user.state.length > 0) {
                            if (user.state == 1 && user.is_confirm == 0) {
                                user.state = {id: '3', name: '科室未确认'};
                            } else {
                                user.state = F.getItem(user.state, F.get('test_stages'));
                            }
                        } else {
                            user.state.name = '状态为空';
                        }
                        if (angular.isDefined(user.leave_time) && user.leave_time != null) {
                            user.time_range = user.entry_time.substr(0, 16) + ' - ' + user.leave_time.substr(0, 16);
                        } else {
                            user.time_range = user.entry_time.substr(0, 16) + "之后";
                        }
                    });
                }).options;
            });
        };

        $scope.edit = function (round) {
            //console.log(round);
            dialogs.create('templates/round/dept_edit.html', 'RoundDeptStateCtrl'
                , {is_confirm: round.is_confirm, user_dept: round.user_dept}, {
                    size: 'md'
                }).result.then(function (params) {
                params.opt = 1;
                params.old_round = round;
                Round.update({id: round.id}, params).$promise.then(function (resp) {
                    //console.log(resp);
                    $scope.tableReload();
                }, function () {
                    toaster.error('轮转确认失败');
                })
            });
        }
    });
angular.module('c.c')
    .controller('RuleApprovalCtrl', function ($rootScope, $scope, $filter, dialogs, toaster, NgTableParams, C, F, Rule,
                                              MeetingTopic, Bulletin, Doc, Table) {
        $scope.stages = F.get('approval_stages6');
        $scope.states = F.get('rule_states');

        $scope.$on('ruleNewBack', function () {
            $scope.tableParams.reload();
        });

        $scope.$on('ruleHandle', function () {
            $scope.tableParams.reload();
        });

        $scope.cols = [
            {title: '标题', show: true},
            {title: '关键词', show: true},
            // {title: '类型', show: true},
            {title: '发布人/科室', show: true},
            {title: '发布时间', show: true},
            {title: '审核类型', show: true},
            {title: '状态', show: true}
        ];

        $scope.optColWidth = 53;
        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //科审4，院审5
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    angular.forEach(data.rules, function (rule) {
                        rule.stage = F.getItem(rule.stage, $scope.stages);
                        rule.state = F.getItem(rule.state, $scope.states);
                    });
                });
            }
        });

        $scope.rule2doc = function (rule) {
            dialogs.create('templates/rule/rule2doc.html', 'Rule2DocDlgCtrl', {rule: rule, isRule: true},
                { size: 'lg'}).result.then(function (params) {
                Doc.save(params).$promise.then(function () {
                    toaster.success('转会签提交成功!');
                }, function () {
                    toaster.error('转会签提交失败!');
                });
            });
        };

        $scope.rule2topic = function (rule) {
            dialogs.create('templates/rule/rule2topic.html', 'Rule2TopicDlgCtrl', {rule: rule},
                { size: 'lg'}).result.then(function (params) {
                MeetingTopic.save(params).$promise.then(function () {
                    toaster.success('转议题提交成功!');
                }, function () {
                    toaster.error('转议题提交失败了!');
                });
            });
        };

        $scope.edit = function (rule) {
            dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                    id: rule.id, ForEdit: true, isHospitalLeader: true
                },
                { size: 'lg'}).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function () {
                        toaster.success('规章制度修改成功');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('规章制度修改失败了!');
                    }
                );
            });
        };

        $scope.approval = function (rule) {
            if (rule.state.id == 1) {
                dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                    id: rule.id, ForNewApproval: true
                }, {
                     size: 'lg'
                }).result.then(function (params) {
                    Rule.update({id: rule.id}, params).$promise.then(
                        function (resp) {
                            switch (resp.result) {
                                case 0:
                                    toaster.success('新发布规章制度审批成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('ruleApproved');
                                    break;
                                case 1:
                                    toaster.warning('该规章制度已审批');
                                    break;
                            }
                        }, function () {
                            toaster.error('新发布规章制度审批失败了!');
                        }
                    );
                });
            } else if (rule.state.id == 2) {
                dialogs.confirm('规章制度停用审批', '停用原因：<strong class="text-red">' + rule.reason +
                        '</strong>,确定要通过该规章制度的停用审批吗?')
                    .result.then(function () {
                    dialogs.create('templates/rule/handle_dlg.html', 'RuleHandleDlgCtrl', {
                            dept_id: rule.dept_id,
                            stage: rule.stage.id,
                            state: rule.state.id,
                            reason: rule.reason,
                            with_sms: rule.with_sms
                        },
                        { size: 'md'}).result.then(function (params) {
                        var pa = {};
                        pa['stage'] = params.stage;
                        pa['dept_id'] = rule.dept_id;
                        pa['opt'] = C.OPT.RULE.EDIT.HOSPITAL_HANDLE;

                        Rule.update({id: rule.id}, pa).$promise.then(
                            function () {
                                toaster.success('规章制度处理成功');
                                $rootScope.$broadcast('ruleHandle');
                            }, function () {
                                toaster.error('规章制度处理失败了!');
                            }
                        );


                        if (params.stage == C.STAGE6.COUNTERSIGN) {
                            dialogs.create('templates/rule/rule2doc.html', 'Rule2DocDlgCtrl', {rule: rule, isRule: true},
                                { size: 'lg'}).result.then(function (params) {
                                Doc.save(params).$promise.then(function () {
                                    toaster.success('提交成功!');
                                    $uibModalInstance.dismiss('cancel');
                                }, function () {
                                    toaster.error('提交失败!');
                                });
                            });
                        }

                        if (params.stage == C.STAGE6.TO_BE_DISCUSSED) {
                            dialogs.create('templates/rule/rule2topic.html', 'Rule2TopicDlgCtrl', {rule: rule},
                                { size: 'lg'}).result.then(function (params) {
                                MeetingTopic.save(params).$promise.then(function () {
                                    toaster.success('议题申请成功!');
                                    $uibModalInstance.dismiss('cancel');
                                }, function () {
                                    toaster.error('议题申请失败了!');
                                });
                            });
                        }
                    });
                });
            } else {
                dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                    id: rule.id, ForExchangeHospitalApproval: true
                }, { size: 'lg'});
            }
        }
    });


angular.module('c.c').controller('RuleDeptSearchController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Table, C, RuleType, Dept, Rule) {
        $scope.$on('ruleApproved', function () {
            $scope.tableParams.reload();
        });

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_LED_BY}, function (resp) {
            var depts = resp.depts;
            if (depts && depts.length > 0) {
                $scope.dept = depts[0];
                $scope.tableParams.reload();
            }
            $scope.depts = depts;
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };


        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);
        $scope.states = F.get('rule_states');
        var statesOpts = F.getNgTableOpts($scope.states);

        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            // {title: '类型', sortable: 'type_id', filter: {type_id: 'select'}, show: true},
            {title: '发布时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '审核类型', filter: {state: 'select'}, data: statesOpts, show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        var typeCol = $scope.cols[2];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = C.OPT.RULE.INDEX.DEPT_SEARCH;
                    url['dept_id'] = $scope.dept.id;
                    if ($scope.dateRangeFilter.created_at != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                    }
                    Table.query(Rule, url, $defer, params, 'rules', function (data) {
                        typeCol.data = F.getNgTableOpts(data.rule_types);
                        angular.forEach(data.rules, function (rule) {
                            rule.stage = F.getItem(rule.stage, $scope.stages);
                            rule.state = F.getItem(rule.state, $scope.states);
                        });
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {id: rule.id, ForPrint: true}, {

                size: 'lg'
            });
        };

        $scope.disable = function (rule) {
            dialogs.create('templates/rule/handle_dlg.html', 'RuleHandleDlgCtrl', {
                    stage: rule.stage,
                    class: rule.class,
                    dept: true,
                    subject: rule.subject,
                    dept_id: rule.dept_id,
                    state: rule.state,
                    reason: rule.reason,
                    with_sms: rule.with_sms
                },
                {size: 'md'}).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function () {
                        toaster.success('规章制度处理成功');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('规章制度处理失败了!');
                    }
                );
            });
        };

        $scope.classExchange = function (rule) {
            dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                id: rule.id, ForExchangeDeptApproval: true
            }, {
                size: 'lg'
            }).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function () {
                        toaster.success('规章制度转换分类申请成功');
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('ruleApproved');
                    }, function () {
                        toaster.error('规章制度转换分类申请失败了!');
                    }
                );
            });
        };

        $scope.export = function () {
            dialogs.create('templates/rule/export_dlg.html', 'RuleExportCtrl', {isDept: true},
                {size: 'md'});
        };

        $scope.edit = function (rule) {
            dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                    id: rule.id, ForEdit: true, isDeptLeader: true
                },
                {size: 'lg'}).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function () {
                        toaster.success('规章制度修改成功');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('规章制度修改失败了!');
                    }
                );
            });
        };
    });

angular.module('c.c')
    .controller('RuleTypeCtrl', function ($scope, dialogs, toaster, NgTableParams, RuleType, Dept, F, Table, C) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);
        $scope.rule_types = F.get('rule_types');

        $scope.cols = [
            {title: '名称', filter: {'name': 'text'}, show: true},
            {title: '属性', width: '10%', show: true},
            {title: '所属科室', filter: {dept_id: 'select'}, show: true},
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, width: '10%', show: true}
        ];

        var deptCol = $scope.cols[2];
        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_LED_BY}, function (resp) {
            var depts = resp.depts;
            deptCol.data = F.getNgTableOpts(depts);
            $scope.depts = depts;
        });

        var opt = null;
        $scope.init4Dept = function () {
            opt = C.OPT.RULE_TYPE.INDEX.DEPT_MANAGE;
        };

        $scope.init4Hospital = function () {
            opt = C.OPT.RULE_TYPE.INDEX.HOSPITAL_MANAGE;
            deptCol.show = false;
            $scope.isHospitalOffice = true;
        };

        $scope.optColWidth = 70;

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = opt; //1科室分类管理 2院办分类管理
                Table.query(RuleType, url, $defer, params, 'types', function (data) {
                    angular.forEach(data.types, function (type) {
                        type.class = F.getItem(type.class, $scope.rule_types);
                    });
                });
            }
        });

        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('templates/rule_type/new_dlg.html', 'RuleTypeDlgCtrl', {isHospitalOffice: $scope.isHospitalOffice}, {
                 size: 'md'
            }).result.then(function (type) {
                RuleType.save(type).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('规章制度类型添加成功!');
                            $scope.tableReload();
                            break;
                        case 1:
                            toaster.warning('该科室已有相同名称的科内类型,请重新添加!');
                            break;
                        case 2:
                            toaster.warning('已有相同名称的全院类型,请重新添加!');
                            break;
                    }
                }, function () {
                    toaster.error('规章制度类型添加失败!');
                });
            });
        };

        $scope.edit = function (type) {
            type.$edit = true;
            type.$nameChanged = type.name;
            type.$is_stopChanged = F.getItem(type.is_stop, $scope.yesNo);
        };

        $scope.ok = function (type) {
            type.$edit = false;
            if (type.$nameChanged == "") {
                toaster.error('名称不能为空!');
            } else if (type.name != type.$nameChanged || type.is_stop != type.$is_stopChanged.id) {
                var params = {};
                params['name'] = type.$nameChanged;
                params['class'] = type.class.id;
                if(!$scope.isHospitalOffice){
                    params['dept_id'] = type.dept_id;
                }
                params['is_stop'] = type.$is_stopChanged.id;
                RuleType.update({id: type.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('规章制度类型修改成功!');
                            break;
                        case 1:
                            toaster.warning('该科室已有相同名称的科内类型,请重新修改!');
                            break;
                        case 2:
                            toaster.warning('存在属于该类型的规章制度,请转移后再停用!');
                            break;
                        case 3:
                            toaster.warning('已有相同名称的全院类型,请重新修改!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('规章制度类型修改失败!');
                });

            }
        };

        $scope.detail = function (type) {
            dialogs.create('templates/rule_type/rule_dlg.html', 'RuleDlgCtrl', {
                type: type,
                isHospitalOffice: $scope.isHospitalOffice
            }, {
                 size: 'lg'
            })
        };

        $scope.delete = function (type) {
            dialogs.confirm('删除规章制度类型', '确定要删除<strong>' + type.name + '</strong>的规章制度类型吗?')
                .result.then(function () {
                RuleType.delete({id: type.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('规章制度类型删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该类型的规章制度,请转移后再删除!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('规章制度类型删除失败!');
                });
            });
        }
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('EduApprovedLeaveCtrl', EduApprovedLeaveCtrl)
        .controller('EduExportLeavesCtrl', EduExportLeavesCtrl)
    ;

    /** @ngInject */
    function EduApprovedLeaveCtrl($scope, DateHelper, FileHelper, ArrayHelper, Table,
                                  NgTableParams, AskForLeave, SaveAs, C, Dlg) {
        var yesNoOpts = Table.getNgTableOpts(ArrayHelper.get('yesNo'));
        $scope.yesNo = ArrayHelper.get('yesNo');
        var processStatues = Table.getNgTableOpts(ArrayHelper.get('processStatus'));
        $scope.statues = ArrayHelper.get('processStatus');

        $scope.$on('ApprovedRefresh', function () {
            $scope.tableParams.reload();
        });

        $scope.cols = [
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', width: '100', show: true}, //0
            {title: '科室', filter: {'depts.name': 'text'}, field: 'dept_id', width: '100', show: true}, //0
            {
                title: '类别',
                sortable: 'leave_type_id',
                filter: {leave_type_id: 'select'},
                field: 'leave_type_id',
                show: true
            }, //6
            {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
            {title: '天数', field: 'day_num', show: true}, //6
            {title: '开始时间', filter: {start: 'date_range'}, field: 'start',  show: true},
            {title: '结束时间', filter: {end: 'date_range'}, field: 'end',  show: true},
            {
                title: '附件',
                field: 'has_paper',
                show: true
            }, //6
            {
                title: '附件类型',
                sortable: 'type_id',
                filter: {'type_id': 'select'},
                field: 'type_id',
                show: true
            }, //6
            {
                title: '补助与机票',
                sortable: 'is_subsidy',
                filter: {is_subsidy: 'select'},
                field: 'is_subsidy',
                data: yesNoOpts,
                show: true
            }, //6
            {
                title: '我的意见',
                //filter: {status: 'select'},
                field: 'status',
                data: processStatues,
                show: true
            }, //6
            {
                title: '最终状态',
                show: true
            }, //6
            {title: '申请时间', filter: {created_at: 'date_range'}, field: 'created_at', width: '15%', show: true}
        ];

        $scope.leave_type_col = $scope.cols[2];
        $scope.attach_type_col = $scope.cols[8];
        $scope.opinion_col = $scope.cols[10];

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失,请联系管理员!');
            });
        };

        $scope.hideOpt = true;
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = '26';
                var startDate, endDate;
                if ($scope.dateRangeFilter.start != null) {
                    startDate = DateHelper.date2Str($scope.dateRangeFilter.start.startDate);
                    endDate = DateHelper.date2Str($scope.dateRangeFilter.start.endDate);
                    url['date_range_filters'] = {
                        start: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.end != null) {
                    startDate = DateHelper.date2Str($scope.dateRangeFilter.end.startDate);
                    endDate = DateHelper.date2Str($scope.dateRangeFilter.end.endDate);
                    url['date_range_filters'] = {
                        end: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                AskForLeave.query(url, function (data) {
                    switch ($scope.opt) {
                        case '4':
                            $scope.opinion_col.filter = {dept_charge_opinion: 'select'};
                            break;
                        case '6':
                            $scope.opinion_col.filter = {personnel_opinion: 'select'};
                            break;
                        case '8':
                            $scope.opinion_col.filter = {medical_opinion: 'select'};
                            break;
                        case '10':
                            $scope.opinion_col.filter = {nurse_opinion: 'select'};
                            break;
                        case '12':
                            $scope.opinion_col.filter = {hospital_leader_opinion: 'select'};
                            break;
                        case '14':
                            $scope.opinion_col.filter = {main_leader_opinion: 'select'};
                            break;
                        default:
                            break;
                    }
                    $scope.leave_types = data.leave_types;
                    $scope.leave_type_col.data = Table.getNgTableOpts($scope.leave_types);
                    $scope.attach_types = data.attach_types;
                    $scope.attach_type_col.data = Table.getNgTableOpts($scope.attach_types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.export = function () {
            Dlg.show({
                template: 'templates/leave/export_leaves_dlg.html',
                ctrl: 'EduExportLeavesCtrl',
                data: {}
            });
        };
    }

    /** @ngInject */
    function EduExportLeavesCtrl($scope, $uibModalInstance, DateHelper, C, FileHelper,
                                 UserType, UserStatus, SaveAs, data) {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        $scope.opt = data.opt;
        $scope.leave_types = [
            {id: 9, name: '培训'},
            {id: 10, name: '会议'}
        ];

        $scope.s = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0),
            leave_type: $scope.leave_types[0]
        };
        UserType.query({}, function (data) {
            $scope.user_types = data;
            $scope.user_types.unshift({'id': null, 'name': '全部'});
            $scope.s['type'] = data[0];
        });

        UserStatus.query({}, function (data) {
            $scope.user_status = data;
            $scope.user_status.unshift({'id': null, 'name': '全部'});
            $scope.s['status'] = $scope.user_status[0];
        });

        $scope.ok = function (s) {
            if ($scope.s_form.$valid) {
                if (s.start > s.end) {
                    Dlg.w('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};

                params['start'] = DateHelper.date2Str(s.start);
                params['end'] = DateHelper.date2Str(s.end);
                params['type_id'] = s.type.id;
                params['leave_type_id'] = s.leave_type.id;
                params['status_id'] = s.status.id;
                s.downloading = true;
                FileHelper.download(C.URL.LEAVES_DOWNLOAD, params, function (resp) {
                    s.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = params['start'] + '到' + params['end'] + s.type.name + '请假统计表.xls';
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function (error) {
                    s.downloading = false;
                    Dlg.e('导出失败!');
                });
            } else {
                Dlg.w('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();



angular.module('c.c').controller('PracticeLeaveCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Table, User, Practice) {

        $scope.$on('practiceRemoveChange', function () {
            $scope.tableReload();
        });

        var sexesOpts = F.getNgTableOpts(F.get('sexes'));

        $scope.init = function (practice_type) {
            var options = {
                service: User,
                params: {opt: 13, is_leaved: 1, practice_type: practice_type},
                optColWidth: 53,
                sorting: {entry_time: 'desc'},
                dateFilters: [{name: 'leave_time'}],
                items: 'users',
                cols: [
                    {title: '姓名', filter: {name: 'text'}},
                    {title: '性别', filter: {sex: 'select'}, data: sexesOpts, width: "10%"},
                    {title: '学校', filter: {graduate_school: 'text'}},
                    {title: '实习结束时间', sortable: 'leave_time', filter: {leave_time: 'date_range'}},
                    {title: '电话号码', filter: {phone: 'text'}},
                    {title: '邮箱', filter: {email: 'text'}}
                ]
            };
            Table.loadNgTable($scope, options, function (data) {
                $scope.depts = data.depts;
            });
        };

        $scope.repractice = function (practicer) {
            dialogs.confirm('恢复实习', '请确认要恢复实习生<strong>' + practicer.name + '</strong>的实习吗?')
                .result.then(function () {
                var params = {};
                params['opt'] = 1;
                Practice.update({id: practicer.id}, params).$promise.then(function () {
                    $rootScope.$broadcast('practiceAdd');
                    $scope.tableReload();
                }, function () {
                    toaster.error('恢复实习失败!');
                });
            });
        }

        $scope.round_manager = function (practicer,edit) {
            dialogs.create('templates/practice/round_manager_dlg.html', 'PracticeRoundDlgCtrl', {
                    user_id: practicer.id,
                    depts: $scope.depts,
                    edit:edit
                },
                { size: 'md'}).result.then(function (params) {
                Practice.update({id: practicer.id}, params).$promise.then(
                    function () {
                        toaster.success('轮转修改成功');
                        $rootScope.$broadcast('practiceRoundChange');
                        $scope.tableReload();
                    }
                );
            });
        };

        $scope.delete = function (practicer) {
            dialogs.confirm('删除员工记录', '<span class="text-red">删除该记录也将删除由该员工创建的其他信息记录</span>，'
                + '确定要删除<strong>' + practicer.name + '</strong>的员工记录吗?')
                .result.then(function () {
                User.delete({id: practicer.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.pop('success', '员工记录删除成功!');
                            break;
                        case 1:
                            toaster.pop('warning', '该员工属于科室成员,无法直接删除');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.pop('error', '员工记录删除失败!');
                });
            });
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('PracticeRegCtrl', PracticeRegCtrl);

    /** @ngInject */
    function PracticeRegCtrl($scope, $filter, toaster, F, User, $rootScope, Dlg, Upload, FileHelper) {
        $scope.sexes = F.get('sexes');
        $scope.edu_bgs = F.get('edu_bg_list');
        $scope.degree_types = F.get('degree_types');
        $scope.en_lvs = F.get('eg_lv_list');

        $scope.reg_stage = true;
        $scope.hide_photo = true;


        var username_regex_list = /^(0|86|17951)?(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[1235789])[0-9]{8}$/; //试用实习均使用手机号注册
        $scope.username_regex = username_regex_list;

        $scope.batchImport = function (file) {
            $scope.loading = true;
            Upload.upload({url: '/api/v1/users/batch_import', file: file}).success(function (resp) {
                $scope.loading = false;
                Dlg.notify(resp.msg);
                $scope.tableReload();
            }).error(function (err) {
                if (err.msg) Dlg.notify(err.msg, '导入失败');
                $scope.loading = false;
                $scope.tableReload();
            });
        }

        $scope.download = function () {
            FileHelper.download1(User.urls.ExcelDownload, {
                filename: 'docTemp/userBatchExport.xlsx',
                mime: 'application/wps-office.xlsx',
                name: '实习生批量导入模板.xlsx',
            })
        }

        $scope.submit = function (user) {
            if ($scope.u_form.$valid) {
                var pa = {};
                //账户信息
                pa['username'] = user.username;
                pa['password'] = user.password;

                //基本信息
                pa['name'] = user.name;
                pa['sex'] = user.sex.id;
                pa['birthday'] = $filter('date')(user.birthday, 'yyyy-MM-dd');
                pa['nation_id'] = user.nation.id;
                pa['native_place'] = user.native_place;
                pa['political_status_id'] = user.political_status.id;

                //工作相关
                pa['photo'] = user.photo;
                pa['status_id'] = user.status.id;
                pa['type_id'] = user.type.id;
                pa['current_work_unit'] = user.current_work_unit;
                if (user.type.id == 2) {
                    user.standard = $scope.standards[0];
                    pa['standard'] = user.standard.id;
                }
                //  主要科室...
                pa['dept_id'] = user.dept.id;
                pa['entry_type_id'] = user.entry_type.id;
                pa['entry_time'] = $filter('date')(user.entry_time, 'yyyy-MM-dd');

                //教育背景
                pa['graduate_school'] = user.graduate_school;
                pa['major'] = user.major;
                pa['edu_bg'] = user.edu_bg.id;
                pa['degree'] = user.degree.name;
                pa['en_lv'] = user.en_lv.id;

                //联系方式
                pa['phone'] = user.phone;
                pa['cornet'] = user.cornet;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                pa['email'] = user.email;
                pa['address'] = user.address;

                //$scope.xxx = pa;
                User.save(pa).$promise.then(function () {
                    var note = ['实习医生', '实习护士', '实习药师'][$scope.practiceType];
                    toaster.success(note + '添加成功!');
                    $rootScope.$broadcast('practiceAdd');
                    $scope.reset();
                }, function (error) {
                    var msg = '添加失败!';
                    if (error.data.code == 23000) {
                        var m = error.data.msg;
                        if (m.indexOf('users_username_unique') > 0) {
                            msg = '所填用户名已被注册!';
                        } else if (m.indexOf('users_phone_unique') > 0) {
                            msg = '所填手机号已被注册!';
                        } else if (m.indexOf('users_email_unique') > 0) {
                            msg = '所填邮箱已被注册!';
                            //} else if (m.indexOf('users_id_card_unique') > 0) {
                            //    msg = '所填身份证号已被注册!';
                        }
                    }
                    toaster.error(msg);
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.$submitted = true;
            }

        };

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date(1990, 0, 1)
        };

        $scope.degreeTypeSelectedFn = function (type) {
            $scope.degrees = User.getDegrees(type.id);
            $scope.user['degree'] = $scope.degrees[0];
        };

        $scope.statusSelectedFn = function (status, user) {
            $scope.username_regex = username_regex_list;
        };

        $scope.deptTypeFn = function (d) {
            return d.type.name;
        };


        var init = function () {
            $scope.user = {password: "Tcd120cn"};
            $scope.user['sex'] = $scope.sexes[0];
            $scope.user['edu_bg'] = $scope.edu_bgs[0];
            $scope.user['degree_type'] = $scope.degree_types[0];
            $scope.degrees = User.getDegrees($scope.user['degree_type'].id);
            $scope.user['degree'] = $scope.degrees[0];
            $scope.user['en_lv'] = $scope.en_lvs[0];
        };

        $scope.reload = function (practice_type) {
            console.log(practice_type);
            init();
            console.log(practice_type);
            $scope.practiceType = practice_type;
            User.get({id: 0, is_practice: 1, practice_type: practice_type}, function (resp) {
                $scope.types = resp.types;
                $scope.statuses = resp.statuses;
                $scope.standards = resp.standards;
                $scope.entry_types = resp.entry_types;
                $scope.nations = resp.nations;
                $scope.political_statuses = resp.political_statuses;
                $scope.depts = resp.depts;

                $scope.user['type'] = resp.types[0];
                $scope.user['status'] = resp.statuses[0];
                $scope.user['entry_type'] = resp.entry_types[0];
                $scope.user['nation'] = resp.nations[0];
                $scope.user['political_status'] = resp.political_statuses[0];
                $scope.user['dept'] = resp.depts[0];
            });

            if ($scope.u_form) {
                $scope.u_form.$submitted = false;
                $scope.u_form.$setPristine(true);
            }
        };

        $scope.reset = function () {
            init();

            $scope.user['type'] = $scope.types[0];
            $scope.user['status'] = $scope.statuses[0];
            $scope.user['entry_type'] = $scope.entry_types[0];
            $scope.user['nation'] = $scope.nations[0];
            $scope.user['political_status'] = $scope.political_statuses[0];
            $scope.user['dept'] = $scope.depts[0];

            $scope.u_form.$submitted = false;
            $scope.u_form.$setPristine(true);
        };

    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('PracticeRoundCtrl', PracticeRoundCtrl)
        .controller('PracticeRoundExcelImportDlgCtrl', PracticeRoundExcelImportDlgCtrl)
    ;

    function PracticeRoundCtrl($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Table, User, Practice, Dlg) {
        var vm = $scope;
        vm.init = init;
        vm.edit = edit;
        vm.delete = deleteItem;
        vm.round_manager = round_manager;
        vm.importExcel = importExcel;

        $scope.$on('practiceRoundChange', function () {
            $scope.tableReload();
        });
        $scope.$on('practiceInfChange', function () {
            $scope.tableReload();
        });

        var practiceStates = F.getNgTableOpts(F.get('round_stages'));
        var all_depts = [];

        init();

        function init(practice_type) {
            var options = {
                service: Practice,
                params: {opt: 2, practice_type: practice_type},
                optColWidth: 53,
                sorting: {user_id: 'desc'},
                dateFilters: [{name: 'practice_time'}],
                items: 'practicers',
                cols: [
                    {title: '姓名', filter: {name: 'text'}},
                    {title: '实习科室', filter: {dept: 'text'}},
                    {title: '带教老师', filter: {teacher: 'text'}},
                    {title: '科室实习时间', filter: {practice_time: 'date_range'}},
                    {title: '实习状态', filter: {state: 'select'}, data: practiceStates}
                ]
            };
            Table.loadNgTable($scope, options, function (data) {
                angular.forEach(data.practicers, function (practicer) {
                    if (practicer.state && practicer.state.length > 0) {
                        if (practicer.state == 1 && practicer.is_confirm == 0) {
                            practicer.state = {id: '4', name: '科室未确认'};
                        } else {
                            practicer.state = F.getItem(practicer.state, F.get('test_stages'));
                        }
                    } else {
                        practicer.state.name = '状态为空';
                    }
                    practicer.time_range = practicer.entry_time.substr(0, 16) + ' - ' + practicer.leave_time.substr(0, 16);
                });
                all_depts = data.depts;
            });
        }

        function round_manager(practicer) {
            dialogs.create('templates/practice/round_manager_dlg.html', 'PracticeRoundDlgCtrl', {
                    user_id: practicer.user_id,
                    depts: all_depts
                },
                {size: 'md'}).result.then(function (params) {
                Practice.update({id: practicer.id}, params).$promise.then(function () {
                    $rootScope.$broadcast('roundChange');
                    toaster.success('轮转安排成功');
                }, function () {
                    toaster.error('轮转安排成功');
                });
            });
        }

        function edit(practicer) {
            dialogs.create('templates/practice/round_dlg.html', 'RoundDlgCtrl',
                {depts: all_depts, user_id: practicer.user_id, round_id: practicer.id}, {
                    size: 'md'
                }).result.then(function (round) {
                var params = {};
                params.round = round;
                params.opt = 2;
                params.user_id = practicer.user_id;
                Practice.update({id: practicer.id}, params).$promise.then(function () {
                    toaster.success('轮转修改成功');
                    $scope.tableReload();
                    $rootScope.$broadcast('roundChange');
                }, function () {
                    toaster.error('轮转修改失败!');
                });
            });
        }

        function deleteItem(practicer) {
            dialogs.confirm('删除轮转', '确认要删除此轮转吗?').result.then(function () {
                var params = {};
                params.user_id = practicer.user_id;
                Practice.delete({id: practicer.id}, params).$promise.then(function (resp) {
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }

        function importExcel() {
            Dlg.show({
                template: 'PracticeRoundExcelImportDlg.html',
                ctrl: 'PracticeRoundExcelImportDlgCtrl',
                data: {}
            }).then(function (pa) {
                vm.tableReload();
            });
        }
    }

    function PracticeRoundExcelImportDlgCtrl($scope, $uibModalInstance, FileHelper, Practice, Dlg) {
        var vm = $scope;
        vm.submit = submit;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.cancel = $uibModalInstance.dismiss;

        vm.templateDownloads = [
            {
                id: 1,
                ico: 'file-excel-o',
                filename: "practice/lzdrb.xlsx",
                mime: "application/wps-office.xlsx",
                name: "轮转导入样表.xlsx",
                size: "8797"
            }
        ];

        init();

        function init() {
            vm.m = {
                file: {}
            };
        }

        function upload(file, m, e) {
            FileHelper.uploadSingle(file, m, e);
        }

        function deleteAttachment(m) {
            m.filename = null;
        }

        function submit(m) {
            var file = m.file;
            if (!file.filename) {
                Dlg.w('请上传预约附件!');
            } else {
                var pa = {
                    op: 'default',
                    file: {
                        name: file.attach_name,
                        filename: file.filename,
                        mime: file.mime,
                        size: file.size,
                    }
                };

                Practice.excelImport(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            break;
                        default:
                            Dlg.e(resp.msg);
                            break;
                    }
                    init();
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                });
            }
        }
    }
})();

angular.module('c.c').controller('PracticeWorkforceCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, $q, F, Table, User, Practice) {

        $scope.$on('roundChange', function () {
            $scope.tableReload();
        });
        $scope.$on('practiceAdd', function () {
            $scope.tableReload();
        });

        var sexesOpts = F.getNgTableOpts(F.get('sexes'));
        var checker = Table.loadMultiSelectedFn($scope);

        $scope.init = function (practice_type) {
            var options = {
                service: User,
                params: {opt: 13, is_leaved: 0, practice_type: practice_type},
                optColWidth: 53,
                sorting: {entry_time: 'desc'},
                items: 'users',
                cols: [
                    {title: '姓名', filter: {name: 'text'}},
                    {title: '实习科室', filter: {practice_dept: 'text'}},
                    {title: '性别', filter: {sex: 'select'}, data: sexesOpts, width: "10%"},
                    {title: '学校', filter: {graduate_school: 'text'}},
                    {title: '电话号码', filter: {phone: 'text'}},
                    {title: '邮箱', filter: {email: 'text'}},
                    {title: '聘用类型', filter: {status_id: 'select'}}
                ]
            };
            Table.loadNgTable($scope, options, function (data) {
                $scope.depts = data.depts;
                $scope.sexs = F.get('sexes');
                options.cols[6].data = F.getNgTableOpts(data.statuses);
            });
        };

        $scope.edit = function (practicer) {
            dialogs.create('templates/practice/practice_edit_dlg.html', 'PracticeEditDlgCtrl',
                {practicer_id: practicer.id, sys_edit: true}, {
                    size: 'lg'
                }).result.then(function (params) {
                toaster.success('用户信息修改成功!');
                $rootScope.$broadcast('practiceInfChange');
                $scope.tableReload();
            });
        };
        $scope.round_manager = function (practicer, edit) {
            dialogs.create('templates/practice/round_manager_dlg.html', 'PracticeRoundDlgCtrl', {
                    user_id: practicer.id,
                    depts: $scope.depts,
                    edit: edit
                },
                {size: 'md'}).result.then(function (params) {
                Practice.update({id: practicer.id}, params).$promise.then(
                    function () {
                        toaster.success('轮转修改成功');
                        $rootScope.$broadcast('practiceRoundChange');
                        $scope.tableReload();
                    }
                );
            });
        };

        $scope.batch = function () {
          var defer = $q.defer();
          if (!checker.hasChecked()) {
            toaster.warning('请选择处理对象');
            return;
          }
          dialogs.confirm('实习结束', '请确认要批量结束所选实习生的实习吗?')
          .result.then(function () {
            var Ids = checker.getCheckedIds();
            Practice.update({id: '-'}, {opt: 4, ids: Ids}).$promise.then(function (data) {
              toaster.success('批量处理成功!');
              $scope.tableReload();
              }, function () {
              toaster.error('批量设置失败!');
            });
          });
        };
        $scope.internship_end = function (practicer) {
            dialogs.confirm('实习结束', '请确认要结束实习生<strong>' + practicer.name + '</strong>的实习吗?')
                .result.then(function () {
                var params = {};
                params['opt'] = 0;
                Practice.update({id: practicer.id}).$promise.then(function () {
                    $rootScope.$broadcast('practiceRemoveChange');
                    $scope.tableReload();
                }, function () {
                    toaster.error('结束实习失败!');
                });
            });
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('AIStreamlineDlgCtrl', AIStreamlineDlgCtrl)
    ;

    /** @ngInject */
    function AIStreamlineDlgCtrl($scope, $uibModalInstance, Streamline, DateHelper, Dlg, dialogs, C) {
        var vm = $scope;
        vm.loadStreamline = loadStreamline;
        vm.showDialog = showDialog;
        vm.cancel = $uibModalInstance.dismiss;
        vm.streamlineModelNames = ['新闻', '公告'];

        init();

        function init() {
            vm.dateOptions = {
                minDate: new Date(new Date().setDate(new Date().getDate() - 6))
            };
            vm.selectTab = 1;
            vm.date = new Date();

            $scope.$watch('date', function (newValue) {
                loadStreamline(newValue);
            });
        }

        function showDialog(item) {
            switch (item.model_name) {
                case '新闻':
                    Dlg.show({
                        template: C.T + 'article/show_dlg.html',
                        ctrl: 'NewsMainShowDlgCtrl',
                        data: {id: item.note_id},
                        size: 'lg'
                    });
                    break;
                case '公告':
                    Dlg.show({
                        template: C.T + 'article/show_dlg.html',
                        ctrl: 'BulletinShowDlgCtrl',
                        data: {id: item.note_id},
                        size: 'lg'
                    });
                    break;
            }
        }

        function loadStreamline(date) {
            Streamline.get({
                op: 'base',
                // date: '2023-10-26'
                date: DateHelper.date2Str(date),
            }, function (resp) {
                var data = [];
                angular.forEach(resp.items, function (m) {
                    var itemModelName = m.model_name;
                    if (data.hasOwnProperty(itemModelName)) {
                        data[itemModelName].push(m);
                    } else {
                        data[itemModelName] = [m];
                    }
                });
                vm.streamlineData = data;
            });
        }
    }
})();


(function () {
    'use strict';

    angular.module('c.c')
        .controller('CommentDlgCtrl', CommentDlgCtrl);

    /** @ngInject */
    function CommentDlgCtrl($scope, $uibModalInstance, toaster, ArrayHelper, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        var params = {
            title: data.title,
            label: data.label ? data.label : '理由',
            icon: data.icon ? data.icon : 'edit',
            withRate: data.withRate,
            notRequired: data.notRequired
        };

        vm.params = params;

        if (data.withRate) {
            vm.satLvs = ArrayHelper.get('satisfaction_lv');
        }

        if (data.text) {
            vm.opinion = data.text;
        }

        vm.ok = function (opinion, tmp_rate) {
            if (vm.Form.$valid) {
                if (data.withRate) {
                    if (!tmp_rate || tmp_rate == 0) {
                        toaster.warning('至少要给1星,^_^');
                        return;
                    }
                    $uibModalInstance.close({rate: tmp_rate, opinion: opinion});
                } else {
                    $uibModalInstance.close(opinion);
                }
            } else {
                toaster.warning(params.label + '不能为空');
            }
        };
    }

})();

angular.module('c.c').controller('BasicDataDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.data = {title: data.title};
    $scope.ok = function (data) {
        if ($scope.data_form.$valid) {
            $uibModalInstance.close(data);
        } else {
            $scope.data_form.submitted = true;
            toaster.warning('表单中有错误!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c.c').controller('FloatDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.pa = {title: data.title, label: data.label, icon: data.icon, label_time: data.label_time};

    $scope.put_int = data.put_int;
    $scope.ok = function (pa) {
        if ($scope.c_form.$valid) {
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('请填写数值!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c.c').controller('ExportDocsCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, FileHelper, C, F, SaveAs, data, $http) {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        $scope.opt = data.opt;
        $scope.s = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0)
        };
        $scope.dept = data.dept;

        $scope.$on(C.P + 'doc.statistic.download', function (event, data) {
            var params = data.data.data;
            FileHelper.download('api/home/appointments/download', params, function (resp) {
                $scope.downloading = false;
                SaveAs.download([resp], params.name, {type: params.mime});
            }, function () {
                $scope.downloading = false;
                Dlg.w('下载失败,重新尝试');
            });
        });

        $scope.ok = function (s) {
            if ($scope.s_form.$valid) {
                if (s.start > s.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                if (data.dept) {
                    params['dept_id'] = data.dept.id;
                }
                params['start'] = $filter('date')(s.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(s.end, 'yyyy-MM-dd');
                params['opt'] = data.opt;

                s.downloading = true;
                $scope.downloading = true;
                if (data.opt == 1/*HOSPITAL*/) {
                    $http.post(C.URL.DEPT_DOCS_DOWNLOAD, params);
                } else {
                    FileHelper.download(C.URL.DEPT_DOCS_DOWNLOAD, params, function (resp) {
                        s.downloading = false;
                        var data = [resp];
                        var options = {type: 'vnd.ms-excel'};
                        var filename = params['start'] + '到' + params['end'] + ($scope.dept ? $scope.dept.name : '全院') + data.opt == '1' ? '公文情况统计.xls' : '医德医风统计.xls';
                        SaveAs.download(data, filename, options);
                        $uibModalInstance.close();
                    }, function (error) {
                        s.downloading = false;
                        $scope.downloading = false;
                        toaster.error('导出失败!');
                    });
                }
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DocHandleDlgCtrl', DocHandleDlgCtrl);

    /** @ngInject */
    function DocHandleDlgCtrl($scope, $uibModalInstance, C, Doc, Dlg, Dept, ArrayHelper, FileHelper, data) {
        Dlg.loadScrollbar($scope);
        var btn = window.document.getElementsByTagName('textarea');
        if (btn) {
            window.addEventListener('focusin', function() {
                window.document.getElementById('red').style.marginTop="100px";
                // btn.scrollIntoView();
            });
        }
        // window.addEventListener('resize',function() {
        //     if (document.activeElement.tagName == 'TEXTAREA') {
        //         window.setTimeout(function() {
        //             document.activeElement.scrollIntoViewIfNeeded();
        //         }, 100);
        //     }
        // });

        var doc = {
            rate: data.doc.rate,
            dept_from: data.doc.dept_from,
            applicant: data.doc.applicant,
            attachments: [],
            created_at: data.doc.created_at,
            // type: data.doc.type
        };
        var steps = data.doc.steps;
        $scope.steps = steps;
        var agree = 0, disagree = 0, abstention = 0, unfinish = 0;
        angular.forEach($scope.steps, function (step) {
            if (step.is_vote) {
                $scope.is_vote = true;
                switch (step.opinion) {
                    case '1':
                        agree++;
                        break;
                    case '3':
                        disagree++;
                        break;
                    case '2':
                        abstention++;
                        break;
                    default:
                        unfinish++;
                        break;
                }
            }

        });
        $scope.agree = agree;
        $scope.disagree = disagree;
        $scope.abstention = abstention;
        $scope.unfinish = unfinish;

        if (!data.forComment) { //公文评论也用这个控制器，所以区分一下
            var step = null, prev_result = null;
            for (var i = 0; i < steps.length; i++) {
                if ((!steps[i].result && steps[i].is_ready == '1') ||
                    (steps[i].is_eval == '1' && !steps[i].opinion && data.account_id == steps[i].handler_id)) {
                    step = steps[i];
                    break;
                }
                prev_result = steps[i].result;
            }

            var is_tmp_eval = step.is_eval == '1';
            $scope.is_tmp_eval = is_tmp_eval;  //是临时插入评估

            var is_fix_eval = is_tmp_eval != '1' && (prev_result && prev_result.id == C.DOC.STEP.RESULT.EVAL);
            $scope.is_fix_eval = is_fix_eval; //是固定步骤评估
            var is_eval = is_fix_eval || is_tmp_eval; //是评估步骤
            $scope.is_eval = is_eval;
            $scope.is_vote = step.is_vote;

            var result = null, nextStep = null;
            if (!is_tmp_eval) { //非临时插入评估
                var type = data.doc.type;
                //如果是固定流程则找出预期结果
                if (type && type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS) {
                    if (step.step != '0') {
                        result = ArrayHelper.getItem(step.step, type.steps, 'step').result;
                    } else {
                        result = {id: C.DOC.STEP.RESULT.UP};
                    }
                    nextStep = +step.step + 1; //可能为空
                    nextStep = ArrayHelper.getItem(nextStep, type.steps, 'step');
                }
                //有预期结果，说明是固定步骤，则从预期结果拿到数据，没有预期结果，则根据前一步处理结果拿到数据，否则拿到所有数据
                $scope.results = Doc.getDocStepResults(result, prev_result);
                if (result) {
                    result = ArrayHelper.getItem(result.id, $scope.results);
                }
                $scope.tResults = [{id: '7', name: '转审批'}, {id: '8', name: '转执行'}];
            } // else  $scope.results == null 说明是临时插入评估

            $scope.result = result;
            $scope.nextStep = nextStep;

            Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
                $scope.depts = resp.depts;
            });
        } else {
            $scope.forComment = data.forComment;
        }

        function needHandlerCheck(result, doc) {
            return is_tmp_eval ? false :
                doc.isTmpStep ? !doc.isFront :
                    result ? +result.id > +C.DOC.STEP.RESULT.MAX_END : false;
        }

        $scope.isNeedHandler = function (result, doc) {
            return needHandlerCheck(result, doc);
        };

        function getFixedHandler(doc, step) {
            if (step && step.handler_type) {
                doc['handler_type'] = step.handler_type;
                switch (step.handler_type) {
                    case C.DOC.HANDLE_BY.DEPT:
                        doc['dept_to'] = step.dept;
                        break;
                    case C.DOC.HANDLE_BY.USER:
                        doc['handler'] = step.handler;
                        break;
                }
            }
        }

        $scope.handlerName = function (step, docName) {
            return Doc.getDocHandlerName(step, docName);
        };

        $scope.insertPosChange = function (isFront, doc) {
            //固定步骤的最后一步，不能选择向后插入
            if (!isFront && result && !nextStep) {
                Dlg.notify('固定步骤的最后一步,不能选择向后插入!');
                doc.isFront = true;
            }
        };

        $scope.ok = function (doc) {
            if (data.forComment) { //公文评论也用这个控制器，所以区分一下
                if (doc.tmp_rate == 0) {
                    Dlg.w('至少要给1星,^_^');
                    return;
                }
                $uibModalInstance.close({rate: doc.tmp_rate, opinion: doc.opinion});
            } else {
                if ($scope.is_vote) {
                    if (!doc.opinion) {
                        Dlg.w('请投票');
                        return;
                    } else {
                        switch (doc.opinion) {
                            case '1':
                                doc.opinion = '赞成';
                                break;
                            case '2':
                                doc.opinion = '弃权';
                                break;
                            case '3':
                                doc.opinion = '反对';
                                break;
                        }
                    }
                }
                var needHandler = needHandlerCheck(doc.result, doc);
                if (needHandler && doc.handler_type == C.DOC.HANDLE_BY.USER && doc.handler == null) {
                    // if ((needHandler || doc.isTmpApprovalStep) && doc.handler_type == C.DOC.HANDLE_BY.USER && doc.handler == null) {
                    Dlg.w('请填写处理人!');
                } else if (!is_eval && !doc.result && !(doc.isTmpStep)) {
                    // } else if (!is_eval && !doc.result && !(doc.isTmpStep || doc.isTmpApprovalStep)) {
                    Dlg.w('请选择处理结果!');
                } else if (doc.isTmpStep && doc.evaluators.length == 0) {
                    Dlg.w('请选择评估人!');
                }
                // else if (doc.isTmpApprovalStep && doc.approver == null) {
                //     Dlg.w('请选择审批人!');
                // }
                else if (needHandler && doc.handler_type == C.DOC.HANDLE_BY.DEPT && doc.dept_to == null) {
                    Dlg.w('请选择职能科室!');
                } else if (!FileHelper.isAttachmentsUploaded(doc)) {
                    Dlg.w('请等一小会儿,部分附件还在路上');
                } else {
                    if (doc.opinion == null || doc.opinion == '') {
                        var reason = null;
                        if (is_eval) {
                            reason = '评估意见';
                        } else {
                            if (!(doc.isTmpStep)) {
                                if (doc.result.id == C.DOC.STEP.RESULT.FAILED) {
                                    reason = '未执行原因';
                                } else if (doc.result.id == C.DOC.STEP.RESULT.REJECT) {
                                    reason = '拒绝理由';
                                }
                            }
                        }
                        if (reason) {
                            Dlg.w('请填写' + reason);
                            return;
                        }
                    }
                    var params = {step_id: step.id, is_eval: is_tmp_eval};
                    if (!is_tmp_eval) { //临时插入步骤
                        params['isTmpStepVote'] = false;
                        params['isTmpStep'] = doc.isTmpStep;
                        // params['isTmpApprovalStep'] = doc.isTmpApprovalStep;
                        if (doc.isTmpStep) {
                            params['evaluators'] = [];
                            angular.forEach(doc.evaluators, function (evaluator) {
                                params['evaluators'].push(evaluator.id);
                            });
                            params['isFront'] = doc.isFront;
                            if (doc.isFront) {
                                if (prev_result) {
                                    params['tResult'] = prev_result.id;
                                } else {
                                    params['tResult'] = C.DOC.STEP.RESULT.UP;
                                }
                            } else {
                                if (result) {
                                    params['tResult'] = result.id;
                                } else {
                                    params['tResult'] = doc.tResult.id;
                                }
                            }
                            // } else if (doc.isTmpApprovalStep) {
                            //     params['approver_id'] = doc.approver.id;
                            //     params['isFront'] = false;
                            //     params['result'] = 7; //默认同意
                            //     if (doc.isFront) {
                            //         if (prev_result) {
                            //             params['tResult'] = prev_result.id;
                            //         } else {
                            //             params['tResult'] = C.DOC.STEP.RESULT.UP;
                            //         }
                            //     } else {
                            //         if (result) {
                            //             params['tResult'] = result.id;
                            //         } else {
                            //             params['tResult'] = doc.tResult.id;
                            //         }
                            //     }
                        } else { //如果不是插入评估，则应该有处理结果
                            params['result'] = doc.result.id;
                            if ((doc.result.id == '2' || doc.result.id == '4') && doc.with_sms) {
                                params['with_sms'] = true;
                            }
                        }
                        if (needHandler) {
                            params['handler_type'] = doc.handler_type;
                            switch (doc.handler_type) {
                                case C.DOC.HANDLE_BY.DEPT:
                                    params['dept_to_id'] = doc.dept_to.id;
                                    break;
                                case C.DOC.HANDLE_BY.USER:
                                    params['handler_id'] = doc.handler.id;
                                    break;
                            }
                        }
                        // if (doc.isTmpApprovalStep) {
                        //     params['handler_type'] = doc.handler_type;
                        //     switch (doc.handler_type) {
                        //         case C.DOC.HANDLE_BY.DEPT:
                        //             params['dept_to_id'] = doc.dept_to.id;
                        //             break;
                        //         case C.DOC.HANDLE_BY.USER:
                        //             params['handler_id'] = doc.handler.id;
                        //             break;
                        //     }
                        // }
                    }
                    params['attachments'] = [];
                    angular.forEach(doc.attachments, function (attachment) {
                        params['attachments'].push({
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        });
                    });
                    params['opinion'] = doc.opinion;
                    $uibModalInstance.close(params);
                }
            }
        };

        $scope.handlerName = function (step, docName) {
            return Doc.getDocHandlerName(step, docName);
        };

        $scope.getResultIconColor = function (stepId, isEval, evaluated) {
            return Doc.getResultIconColor(stepId, isEval, evaluated);
        };

        $scope.getResultIcon = function (stepId, isEval, evaluated) {
            return Doc.getResultIcon(stepId, isEval, evaluated);
        };

        $scope.isResultEnd = function (stepId) {
            return parseInt(stepId) <= parseInt(C.DOC.STEP.RESULT.MAX_END);
        };

        $scope.upload = function (file, doc, e) {
            FileHelper.upload(C.URL.DOC_UPLOAD, file, doc, e);
        };

        $scope.download = function (m) {
            FileHelper.download1(C.URL.DOC_DOWNLOAD, m);
        };

        $scope.deleteAttachment = function ($index, m) {
            m.attachments.splice($index, 1);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        if (!data.forComment) {
            if (!is_tmp_eval) {
                //doc['result'] = result ? result : $scope.results[0];
                if (is_fix_eval) {
                    doc['result'] = result;
                }
                doc['tResult'] = $scope.tResults[0];
            }
            doc['isTmpStep'] = false;
            // doc['isTmpApprovalStep'] = false;
            doc['isFront'] = true;
            doc['handler_type'] = C.DOC.HANDLE_BY.DEPT_LEADER;
            if (nextStep) {
                getFixedHandler(doc, nextStep);
            }
        } else {
            $scope.satLvs = ArrayHelper.get('satisfaction_lv');
            doc['tmp_rate'] = 4;
        }
        $scope.doc = doc;
    }
    // window.document.getElementById('top').scrollIntoView();
   //  var inputTextBox = document.getElementById('top');
   //
   //  setInterval(function(){
   //
   //      inputTextBox.scrollIntoView(false);
   //
   //  },200);

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('ProcessDlgCtrl', ProcessDlgCtrl);

    /** @ngInject */
    function ProcessDlgCtrl($scope, $uibModalInstance, C, Doc, data, FileHelper) {
        $scope.steps = data.steps;
        $scope.doc = data.doc;

        $scope.is_vote = false;
        var agree = 0, disagree = 0, abstention = 0, unfinish = 0;
        angular.forEach($scope.steps, function (step) {
            if (step.is_vote) {
                $scope.is_vote = true;
                switch (step.opinion) {
                    case '1':
                        agree++;
                        break;
                    case '3':
                        disagree++;
                        break;
                    case '2':
                        abstention++;
                        break;
                    default:
                        unfinish++;
                        break;
                }
            }

        });
        $scope.agree = agree;
        $scope.disagree = disagree;
        $scope.abstention = abstention;
        $scope.unfinish = unfinish;

        $scope.handlerName = function (step, docName) {
            return Doc.getDocHandlerName(step, docName);
        };

        $scope.getResultIconColor = function (stepId, isEval, evaluated) {
            return Doc.getResultIconColor(stepId, isEval, evaluated);
        };

        $scope.getResultIcon = function (stepId, isEval, evaluated) {
            return Doc.getResultIcon(stepId, isEval, evaluated);
        };

        $scope.isResultEnd = function (stepId) {
            return parseInt(stepId) <= parseInt(C.DOC.STEP.RESULT.MAX_END);
        };

        $scope.download = function (m) {
            FileHelper.download1(C.URL.DOC_DOWNLOAD, m);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

angular.module('c.c').controller('DocShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce,
              $filter, $timeout, dialogs, toaster, SaveAs, C, ArrayHelper, UIHelper, Doc, data, $state, FileHelper, PrintHelper) {
        $scope.forHandle = data.forHandle;
        $scope.forArchive = data.forArchive;
        $scope.forHospitalOffice = data.forHospitalOffice;
        $scope.canEdit = data.canEdit;
        $scope.onlyShow = data.onlyShow ? true : false;
        $scope.breakPrint = false;


        console.log($scope.onlyShow);

        var states = ArrayHelper.get('handle_states');
        var results = Doc.getDocStepResults();

        Doc.get({
            id: data.id,
            for_archive: data.forArchive,
            forHospitalOffice: data.forHospitalOffice
        }).$promise.then(function (resp) {
            var doc = resp.doc;
            doc.state = ArrayHelper.getItem(doc.state, states);
            angular.forEach(doc.attachments, function (attachment) {
                attachment.ico = UIHelper.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });
            angular.forEach(doc.steps, function (step) {
                step.result = ArrayHelper.getItem(step.result, results);
            });
            if (doc.type && doc.type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS) {
                angular.forEach(doc.type.steps, function (step) {
                    step.result = ArrayHelper.getItem(step.result, results);

                });
            }

            $scope.docContent = $sce.trustAsHtml(doc.body);
            $scope.wait4Comment = !doc.rate && (doc.state.id == '3' || doc.state.id == '4');
            $scope.doc = doc;
        }, function () {
            toaster.pop({
                type: 'warning', title: '公文不存在', body: '该公文可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.detail = function (doc) {
            dialogs.create('templates/doc/process_dlg.html', 'ProcessDlgCtrl', {doc: doc, steps: doc.steps}, {
                size: 'md'
            });
        };

        $scope.detailStd = function (type) {
            if (type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS) {
                dialogs.create('templates/doc/process_dlg.html', 'ProcessDlgCtrl', {steps: type.steps}, {
                    size: 'md'
                });
            } else {
                FileHelper.download1(C.URL.DOC_TYPE_DOWNLOAD, type, {name: 'attach_name'});
            }
        };

        $scope.download = function (doc, attachment) {
            FileHelper.download1(C.URL.DOC_DOWNLOAD, attachment);
        };

        $scope.handle = function (doc) {
            $scope.handling = true;
            dialogs.create('templates/doc/handle_dlg.html', 'DocHandleDlgCtrl', {
                    doc: doc,
                    account_id: data.account_id
                },
                {size: 'md'}).result.then(function (params) {
                params['opt'] = C.OPT.DOC.EDIT.HANDLE;
                Doc.update({id: doc.id}, params).$promise.then(
                    function () {
                        toaster.success('处理成功');
                        $rootScope.$broadcast('DocHandled');
                        $uibModalInstance.dismiss();
                        if (params.result == 3 || params.result == 1) {
                            dialogs.confirm('创建任务', '公文已经审批完成,是否创建任务?')
                                .result.then(function () {
                                $scope.apply(doc);
                            });
                        }
                    }
                ).finally(function () {
                    $scope.handling = false;
                });
            }, function (reason) {
                $scope.handling = false;
            });
        };

        $scope.comment = function (doc) {
            $scope.handling = true;
            dialogs.create('templates/doc/handle_dlg.html', 'DocHandleDlgCtrl', {
                    doc: doc, forComment: $scope.wait4Comment
                },
                {size: 'md'}).result.then(function (params) {
                params['opt'] = C.OPT.DOC.EDIT.COMMENT;
                Doc.update({id: doc.id}, params).$promise.then(
                    function () {
                        toaster.success('评论成功');
                        $rootScope.$broadcast('DocHandled');
                        $uibModalInstance.dismiss();
                    }
                ).finally(function () {
                    $scope.handling = false;
                });
            }, function (reason) {
                $scope.handling = false;
            });
        };

        $scope.follow = function (doc) {
            Doc.update({id: doc.id}, {opt: 7/*UPDATE_FOLLOW*/, follow: doc.is_follow ? 0 : 1}).$promise
                .then(function () {
                    toaster.success(doc.is_follow ? '取消成功' : '关注成功');
                    doc.is_follow = !doc.is_follow;
                    $rootScope.$broadcast('DocFollow');
                });
        };

        $scope.print = function (doc) {
            if (doc.is_print == '0') {
                Doc.update({id: doc.id, opt: C.OPT.DOC.EDIT.SAVE}, {is_print: '1'}).$promise.then(function () {
                    $rootScope.$broadcast('docPrint', {id: doc.id});
                });
            }
            print(doc);
        };

        $scope.print2 = function (doc) {
            print(doc);
        };

        function print(doc) {
            PrintHelper.print(window.open('', '打印预览'), 'templates/print/table2.html', function () {
                var html = '<table class="print">' +
                    '<caption>成办医院OA公文号：' + doc.number + '</caption>' +
                    '<tbody><tr>';
                html += '<td width="60">标题</td>';
                html += '<td colspan="7">' + doc.subject + '</td>';

                html += '</tr>';

                html += '<tr><td width="60">申请人</td>';
                html += '<td width="110">' + doc.applicant.name + '</td>';
                html += '<td width="65">申请科室</td>';
                html += '<td width="125">' + doc.dept_from.name + '</td>';
                html += '<td width="65">申请时间</td>';
                html += '<td width="125" colspan="3">' + doc.created_at.substr(0, 13) + '时</td>';
                html += '</tr>';

                html += '<tr><td width="60">类型</td>';
                html += '<td width="110">' + (doc.type ? doc.type.name : '其他') + '</td>';
                html += '<td width="65">归档科室</td>';
                html += '<td width="125">' + doc.dept.name + '</td>';
                html += '<td width="65">是否急件</td>';
                html += '<td>' + (doc.is_urgent == '1' ? '是' : '否') + '</td>';
                html += '<td width="65">打印时间</td>';
                var now = new Date();
                if (doc.id == 32552) {
                    html += '<td>' + '2020-01-03 9时</td>';
                } else if (doc.id == 34256) {
                    html += '<td>' + '2020-02-28 8时</td>';
                } else {
                    html += '<td>' + $filter('date')(now, 'yyyy-MM-dd HH') + '时</td>';
                }
                html += '</tr>';

                html += '<tr><td width="60">附件</td>';
                html += '<td colspan="7">';
                if (doc.attachments && doc.attachments.length > 0) {
                    angular.forEach(doc.attachments, function (attachment) {
                        html += attachment.name + '<br/>';
                    });
                } else {
                    html += '无';
                }

                html += '</td></tr>';

                html += '<tr height="200"><td width="60">内容</td>';
                html += '<td colspan="7">' + doc.body + '</td></tr>';

                if ($scope.breakPrint) {
                    html += '<tr style="page-break-before: always;"><td colspan="8">';
                } else {
                    html += '<tr><td colspan="8">';
                }
                angular.forEach(doc.steps, function (step) {
                    if (step.result && step.result.id != C.DOC.STEP.RESULT.COMMENT) {
                        html += step.handler.name + ' ';
                        if (step.handler.signature) {
                            html += '<img height="50" width="160" src="' + step.handler.signature.sign + '"/> ';
                        }
                        if (step.handle_time) {
                            html += step.handle_time.substr(0, 16) + ' ';
                        }
                        html += step.result.name + ' ';
                        if (step.opinion) {
                            html += step.opinion;
                        }
                        html += '<br/>';
                    }
                });
                html += '</td></tr>';

                html += '</tbody></table>';
                return html;
            });
        }

        $scope.edit2 = function (doc) {
            $uibModalInstance.close({opt: C.DOC.EDIT, doc: doc});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.apply = function (doc) {
            $state.go('app.coop_mission', {
                data: {
                    tab: 'apply',
                    event: 'missionApply',
                    content: doc
                }
            });
        };

        $scope.applyNew = function (doc) {
            $state.go('app.coop_news', {
                data: {
                    tab: 'release',
                    event: 'newsRelease',
                    content: doc
                }
            });
        };
        $scope.applyBulletin = function (doc) {
            $state.go('app.coop_bulletin', {
                data: {
                    tab: 'release',
                    event: 'bulletinRelease',
                    content: doc
                }
            });
        };

        $scope.changePrint = function () {
            $scope.breakPrint = !$scope.breakPrint;
        }
    });

angular.module('c.c').controller('EAqrcodeCtrl',
    function ($scope, $uibModalInstance, F, PrintHelper, toaster, data, Float) {
        var vm = $scope;
        vm.print = print;
        vm.download = download;
        vm.cancel = $uibModalInstance.dismiss;

        initQrCode(data.m);

        function initQrCode(m) {
            console.log('m', m);
            vm.m = getTypeAtt(m);
        }

        function getPrintHtml(m) {
            var html = '';
            var qrUrl = $('#emQr .qrcode')[0].toDataURL();
            html += '<div><img src="' + qrUrl + '"></div>';
            html += '<div class="info">' + m.typeName + '<strong>' + '</strong>￥:' + m.typeFee + '元</div>';
            return html;
        }

        function print(m) {
            PrintHelper.print(window.open('', '打印预览'), 'templates/print/order.html', function () {
                var html = getPrintHtml(m);
                return html;
            });
        }

        function download(m) {
            PrintHelper.printAsWord(m.typeName, 'templates/print/order.html',
                function () {
                    var html = getPrintHtml(m);
                    return html;
                });
        }


        function getTypeAtt(m) {
            var typeId = m.type;
            var emFee = 17;
            var emClincFee = 11;

            switch (typeId) {
                case 1:
                    m.typeName = '急诊内科';
                    m.typeFee = angular.isUndefined(m.emergency_im_fee) ? emFee : m.emergency_im_fee;
                    m.typeStr = 'oa.emergency_im_fee';
                    break;
                case 2:
                    m.typeName = '急诊外科';
                    m.typeFee = angular.isUndefined(m.emergency_surgery_fee) ? emFee : m.emergency_surgery_fee;
                    m.typeStr = 'oa.emergency_surgery_fee';
                    break;
                case 3:
                    m.typeName = '急诊门诊内科';
                    m.typeFee = angular.isUndefined(m.emergency_clinc_im_fee) ? emClincFee : m.emergency_clinc_im_fee;
                    m.typeStr = 'oa.emergency_clinc_im_fee';
                    break;
                case 4:
                    m.typeName = '急诊门诊外科';
                    m.typeFee = angular.isUndefined(m.emergency_clinc_surgery_fee) ? emClincFee : m.emergency_clinc_surgery_fee;
                    m.typeStr = 'oa.emergency_clinc_surgery_fee';
                    break;
                case 5:
                    m.typeName = '发热腹泻门诊';
                    m.typeFee = angular.isUndefined(m.emergency_diarrhea_fee) ? emClincFee : m.emergency_diarrhea_fee;
                    m.typeStr = 'oa.emergency_diarrhea_fee';
                    break;
            }

            m.codeData = {type: m.typeStr, price: Float.toFixed(Number(m.typeFee, 1))};
            return m;
        }
    });
(function () {
    'use strict';

    angular.module('c.c').controller('BEDRCtrl', BEDRCtrl);

    /** @ngInject */
    function BEDRCtrl($scope, $uibModalInstance, $q, $http, Dlg, FileHelper, DateHelper, data) {
        var vm = $scope;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.withTime = data.withTime;
        vm.ok = ok;
        vm.batch = batch;
        vm.download = download;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                if (data.withTime) {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0, 23, 59)};
                } else {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
                }
            }
        }

        $scope.$watch('m.start', function (newVal, oldVal) {
            if (newVal) {
                ok(vm.m, vm.Form);
            }
        }, true);

        $scope.$watch('m.end', function (newVal, oldVal) {
            if (newVal) {
                ok(vm.m, vm.Form);
            }
        }, true);


        function ok(m, Form) {
            vm.items = [];
            vm.results = [];
            vm.count = null;
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    Dlg.w('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title;
                    if (data.withTime) {
                        start = DateHelper.datetime2Str(m.start);
                        end = DateHelper.datetime2Str(m.end) + ':59';
                        title = start + '到' + DateHelper.datetime2Str(m.end) + data.title + '.xls'
                    } else {
                        start = DateHelper.date2Str(m.start);
                        end = DateHelper.date2Str(m.end);
                        title = start + '到' + end + data.title + '.xls'
                    }

                    vm.title = title;
                    vm.start = start;
                    vm.end = end;
                    var pa = {start: start, end: end};

                    $http.post(data.url, pa).then(function (data) {
                        vm.items = data.data.items;
                        console.log(vm.items);
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            } else {
                Dlg.w('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }

        function batch(items, count) {
            if (count == null || count == '' || count == 0) {
                Dlg.w('请输入个数!');
            } else {
                var results = [];
                for (var i = 0, len = items.length; i < len; i += +count) {
                    results.push(items.slice(i, i + +count));
                }
                vm.results = results;
                console.log(results);
            }
        }

        function download(result, index) {
            var defer = $q.defer();
            var pa = {items: result, start: vm.start, end: vm.end};
            var title;
            title = vm.title;
            if (vm.results.length > 1) {
                title = '(子表' + index + ')' + vm.title;
            }
            FileHelper.dnExcel(data.url, pa, title, function () {
                result.download = true;
            }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c').controller('EDRCtrl', EDRCtrl);

    /** @ngInject */
    function EDRCtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data) {
        var vm = $scope;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.withTime = data.withTime;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                if (data.withTime) {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0, 23, 59)};
                } else {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
                }
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title;
                    if (data.withTime) {
                        start = DateHelper.datetime2Str(m.start);
                        end = DateHelper.datetime2Str(m.end) + ':59';
                        title = start + '到' + DateHelper.datetime2Str(m.end) + data.title + '.xls'
                    } else {
                        start = DateHelper.date2Str(m.start);
                        end = DateHelper.date2Str(m.end);
                        title = start + '到' + end + data.title + '.xls'
                    }
                    var pa = {start: start, end: end};
                    FileHelper.dnExcel(data.url, pa, title, function () {
                        $uibModalInstance.close();
                    }, function (err) {
                        if (err) toaster.error(err.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c').controller('EDR2Ctrl', EDR2Ctrl);

    /** @ngInject */
    function EDR2Ctrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data) {
        var vm = $scope;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.withTime = data.withTime;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                if (data.withTime) {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0, 23, 59)};
                } else {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
                }
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title;
                    if (data.withTime) {
                        start = DateHelper.datetime2Str(m.start);
                        end = DateHelper.datetime2Str(m.end) + ':59';
                        title = start + '到' + DateHelper.datetime2Str(m.end) + data.title + '.xls'
                    } else {
                        start = DateHelper.date2Str(m.start);
                        end = DateHelper.date2Str(m.end);
                        title = start + '到' + end + data.title + '.xls'
                    }
                    var pa = {start: start, end: end};
                    if (angular.isDefined(data.params)) {
                        for (var prop in data.params) {
                            pa[prop] = data.params[prop];
                        }
                    }
                    FileHelper.dnExcel(data.url, pa, title, function () {
                        $uibModalInstance.close();
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c').controller('EDRCCtrl', EDRCCtrl);

    /** @ngInject */
    function EDRCCtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data, Table) {
        var vm = $scope;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.withTime = data.withTime;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.custom = data.custom;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                if (data.withTime) {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0, 23, 59)};
                } else {
                    vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
                }
            }

            vm.custom.forEach((function (cus) {
                cus.data = Table.getNgTableOpts(cus.data)
                cus.value = cus.value ? cus.value : ''
            }))
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title;
                    if (data.withTime) {
                        start = DateHelper.datetime2Str(m.start);
                        end = DateHelper.datetime2Str(m.end) + ':59';
                        title = start + '到' + DateHelper.datetime2Str(m.end) + data.title + '.xls'
                    } else {
                        start = DateHelper.date2Str(m.start);
                        end = DateHelper.date2Str(m.end);
                        title = start + '到' + end + data.title + '.xls'
                    }
                    var pa = {start: start, end: end};
                    vm.custom.forEach(function (cus) {
                        pa[cus.type] = cus.value.id
                    })
                    FileHelper.dnExcel(data.url, pa, title, function () {
                        $uibModalInstance.close();
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('c.c').controller('EMRCtrl', EMRCtrl);

    /** @ngInject */
    function EMRCtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data, $http, ExcelHelper) {
        var vm = $scope;
        vm.title = data.title;
        vm.intro = data.intro;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.isLongDownload = data.isLongDownload;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m, 1)};
            }

            if (data.fileFormat) {
                vm.fileFormat = angular.isDefined(data.fileFormat) ? data.fileFormat : '.xls';
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title;
                    start = DateHelper.date2Str(m.start).substr(0, 7);
                    end = DateHelper.date2Str(m.end).substr(0, 7);
                    title = start + '到' + end + data.title + vm.fileFormat;
                    var pa = {start: start + '-01', end: end + '-01'};
                    if (vm.isLongDownload) {
                        $http({
                            url: data.url,
                            method: "POST",
                            data: pa
                        }).success(function(resp) {
                            ExcelHelper.createExcelFile(resp, title);
                            $uibModalInstance.close();
                        }).finally(function() {
                            defer.resolve();
                        })
                    } else {
                        FileHelper.dnExcel(data.url, pa, title, function() {
                            $uibModalInstance.close();
                        }).finally(function() {
                            defer.resolve();
                        });
                    }
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('c.c').controller('EMRCCtrl', EMRCCtrl);

    /** @ngInject */
    function EMRCCtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data, $http, ExcelHelper, Table) {
        var vm = $scope;
        vm.title = data.title;
        vm.intro = data.intro;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.isLongDownload = data.isLongDownload;
        vm.custom = data.custom

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m, 1)};
            }
            vm.custom.forEach((function (cus) {
                cus.data = Table.getNgTableOpts(cus.data)
                cus.value = cus.value ? cus.value : ''
            }))
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title;
                    start = DateHelper.date2Str(m.start).substr(0, 7);
                    end = DateHelper.date2Str(m.end).substr(0, 7);
                    title = start + '到' + end + data.title + '.xls';
                    var pa = {start: start + '-01', end: end + '-01'};
                    vm.custom.forEach(function (cus) {
                        pa[cus.type] = cus.value.id
                    })
                    if (vm.isLongDownload) {
                        $http({
                            url: data.url,
                            method: "POST",
                            data: pa
                        }).success(function(resp) {
                            ExcelHelper.createExcelFile(resp, title);
                            $uibModalInstance.close();
                        }).finally(function() {
                            defer.resolve();
                        })
                    } else {
                        FileHelper.dnExcel(data.url, pa, title, function() {
                            $uibModalInstance.close();
                        }).finally(function() {
                            defer.resolve();
                        });
                    }
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('c.c').controller('EMSCtrl', EMSCtrl);

    /** @ngInject */
    function EMSCtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data, $http, ExcelHelper) {
        var vm = $scope;
        vm.title = data.title;
        vm.intro = data.intro;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.isLongDownload = data.isLongDownload;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1)};
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                validFailed = false;
                var start, title;
                start = DateHelper.date2Str(m.start).substr(0, 7);
                title = start + data.title + '.xls';
                var pa = {start: start + '-01'};
                if (vm.isLongDownload) {
                    $http({
                        url: data.url,
                        method: "POST",
                        data: pa
                    }).success(function(resp) {
                        ExcelHelper.createExcelFile(resp, title);
                        $uibModalInstance.close();
                    }).finally(function() {
                        defer.resolve();
                    })
                } else {
                    FileHelper.dnExcel(data.url, pa, title, function() {
                        $uibModalInstance.close();
                    }).finally(function() {
                        defer.resolve();
                    });
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('c.c').controller('EYRCtrl', EYRCtrl);

    /** @ngInject */
    function EYRCtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data, $http, ExcelHelper) {
        var vm = $scope;
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        vm.title = data.title;
        vm.intro = data.intro;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.isYearRange = data.isYearRange;
        vm.isLongDownload = data.isLongDownload;
        vm.m = {};

        init();


        function init() {
            if (data.start) {
                if (vm.isYearRange) {
                    vm.m.start = data.start;
                }
                vm.m.end = data.end;
            } else if (data.end) {
                vm.m.end = data.end;
            } else {
                vm.m.end = new Date(y, m, 1);
                if (vm.isYearRange) {
                    vm.m.start = new Date(y, m, 1)
                }
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (vm.isYearRange && m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title;
                    end = DateHelper.date2Str(m.end).substr(0, 4);
                    var pa = {end: end + '-01'};
                    if (vm.isYearRange) {
                        start = DateHelper.date2Str(m.start).substr(0, 4);
                        title = start + '到' + end + data.title + '.xls';
                        pa.start = start + '-01';
                    } else {
                        title = end + data.title + '.xls';
                    }
                    if (vm.isLongDownload) {
                        $http({
                            url: data.url,
                            method: "POST",
                            data: pa
                        }).success(function(resp) {
                            ExcelHelper.createExcelFile(resp, title);
                            $uibModalInstance.close();
                        }).finally(function() {
                            defer.resolve();
                        })
                    } else {
                        FileHelper.dnExcel(data.url, pa, title, function() {
                            $uibModalInstance.close();
                        }).finally(function() {
                            defer.resolve();
                        });
                    }
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('FrozenAppointmentDlgCtrl', FrozenAppointmentDlgCtrl)
    ;

    /** @ngInject */
    function FrozenAppointmentDlgCtrl($scope, $uibModalInstance, FrozenAppointment, Table, DateHelper, Dlg, FileHelper, FormHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.initForm = initForm;
        vm.submit = submit;
        vm.remove = remove;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;

        var optionFn;
        vm.today = new Date();
        vm.showDetail = false;
        vm.templateDownloads = [
            {
                id: 1,
                ico: 'file-excel-o',
                filename: "frozen_attachments/病理学检查申请单-20210202-154436-243190-0000.xlsx",
                mime: "application/wps-office.xlsx",
                name: "病理学检查申请单.xlsx",
                size: "16896"
            }
        ];

        vm.attachments = [
            {
                id: 1,
                ico: 'file-excel-o',
                filename: "frozen_attachments/收费打包.xlsx",
                mime: "application/wps-office.xlsx",
                name: "附件1.收费打包.xlsx",
                size: "13532"
            },
            {
                id: 2,
                ico: 'file-o',
                filename: "frozen_attachments/成办病理科物价表2021版.docx",
                mime: "application/wps-office.docx",
                name: "附件2.成办病理科物价表2021版.docx",
                size: "24743"
            },
            {
                id: 3,
                ico: 'file-excel-o',
                filename: "frozen_attachments/病理检查项目明细.xlsx",
                mime: "application/wps-office.xlsx",
                name: "附件3.病理检查项目明细.xlsx",
                size: "9620"
            },
            {
                id: 4,
                ico: 'file-o',
                filename: "frozen_attachments/病理检查申请单.docx",
                mime: "application/wps-office.docx",
                name: "附件4.病理检查申请单.docx",
                size: "15062"
            }
        ];

        init();

        function init() {
            initForm();
            var options = loadTableData();

            $scope.$watch('m.date', function () {
                options.params.date = DateHelper.date2Str(vm.m.date);
                vm.tableReload();
            }, true);
            // $scope.$watch('appointment.start', function (newVal, oldVal) {
            //     if (DateHelper.diffInDays(newVal, oldVal) >= 1) {
            //         getLoad(DateHelper.date2Str(newVal));
            //     }
            // }, true);
        }

        function loadTableData() {
            var getDate = new Date();
            getDate.setDate(getDate.getDate() + 1);
            vm.m = {
                date: getDate
            };
            var options = {
                service: FrozenAppointment,
                params: {op: 'default', date: DateHelper.date2Str(vm.m.date)},
                optColWidth: Table._1_BTN,
                hideFilter: true,
                optInFront: true,
                sorting: {date: 'asc'},
                cols: [
                    {field: "date", title: "预约时间", width: 160},
                    {field: "user", title: "预约人", width: 120},
                    {field: "dept", title: "预约科室", width: 120},
                    {field: "phone", title: "联系方式", width: 120},
                    {field: "patient_name", title: "姓名", width: 120},
                    {field: "patient_reg_no", title: "登记号", width: 120},
                    {field: "sample_site", title: "取材部位", width: 120},
                    {field: "note", title: "备注", width: 160},
                ],
                counts: [],
                count: 999
            };

            optionFn = Table.load(vm, options, function (resp) {
                vm.items = resp.items;
            }).options;

            return options;
        }

        function initForm() {
            var getDate = new Date();
            getDate.setDate(getDate.getDate() + 1);
            getDate.setHours(9);
            getDate.setMinutes(0);

            vm.appointment = {
                date: getDate,
                note: '',
                patient_name: '',
                patient_reg_no: '',
                sample_site: ''
            };
        }

        function upload(file, m, e) {
            FileHelper.uploadSingle(file, m, e);
        }

        function deleteAttachment(m) {
            m.filename = null;
        }

        function submit(appointment) {
            var file = appointment.file;
            if (appointment.date == '' || appointment.date == null) {
                Dlg.w('请填写正确的预约时间!');
            } else {
                return FormHelper.handleSubmit(vm, function (defer) {
                    var pa = {
                        op: 'default',
                        date: DateHelper.datetime2Str(appointment.date),
                        note: appointment.note,
                        patient_name: appointment.patient_name,
                        patient_reg_no: appointment.patient_reg_no,
                        sample_site: appointment.sample_site,
                    };

                    FrozenAppointment.save(pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        initForm();
                        vm.tableReload();
                    }, function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            }
        }

        function remove(appointment) {
            Dlg.delTableItem2(FrozenAppointment, appointment.id, vm, '冰冻预约记录',
                appointment.date.substr(0, 16));
        }
    }
})();


(function () {
    'use strict';

    angular.module('c.c').controller('QrCodePayCtrl', QrCodePayCtrl);

    /** @ngInject */
    function QrCodePayCtrl($uibModalInstance, Dlg, $document, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.close;
        vm.service = data.service;
        var code = '', lastTime, nextTime;
        var lastCode, nextCode;

        init();

        function init() {
        }

        $document.bind('keydown', function (e) {
            if (e.which == 27) {
                $uibModalInstance.close();
            }
        });

        $document.bind('keypress', function (e) {
            nextCode = e.which;
            nextTime = new Date().getTime();

            if (lastCode != null && lastTime != null && nextTime - lastTime <= 30) {
                code += String.fromCharCode(lastCode);
            } else if (lastCode != null && lastTime != null && nextTime - lastTime > 100) {
                code = "";
            }

            lastCode = nextCode;
            lastTime = nextTime;

            if (e.which == 13) {
                // if (code.length == 18) {
                //     console.log('resp', code);
                //         $uibModalInstance.close();
                // } else {
                //     Dlg.w('请出示正确的付款码');
                // }
                // if (code.length == 18) {
                //     vm.service.save({op: 'pay', code: code}).$promise.then(function (resp) {
                //         if ((resp.msg.pay_status == '1') && (resp.msg.return_code = '0')) {
                //             Dlg.s('交易成功');
                //         } else {
                //             Dlg.e('付款失败');
                //         }
                        $uibModalInstance.close(code);
                //     });
                // } else {
                //     Dlg.w('请出示正确的付款码');
                // }
                // code = "";
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('ImmunityDlgCtrl', ImmunityDlgCtrl)
    ;

    /** @ngInject */
    function ImmunityDlgCtrl($scope, $uibModalInstance, Immunity, Table, DateHelper, Dlg, Api, MESPatientHelper, User, FormHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.selectDept = selectDept;
        vm.setImg = setImg;
        vm.delImg = delImg;
        vm.ok = ok;
        vm.idCardAcdOption = {trigLen: 3, data: Api.idCardLoadFn};

        vm.today = new Date();

        init();

        function init() {
            //读卡相关函数声明
            MESPatientHelper.readyPatientRelevant(vm, function (patient) {
                patient.age = DateHelper.birthdayToAge(patient.birthday);
                vm.m.patient = patient;
            }, function () {
                //读卡失败，清空现在已有的数据
                vm.m.patient = {};
            }, function () {
                // 读卡后的最后操作
            });

            initForm();
        }

        function initForm() {
            var getDate = new Date();
            vm.submitType = 1;

            vm.m = {
                date: getDate,
                images: [],
                patient: {}
            };
        }

        function setImg(m) {
            Dlg.show({
                template: 'templates/upload/img_ui_cropped.html',
                ctrl: 'imageCroppedUploadCtrl', data: {title: '上传病理图片', width: '500px', height: '800px'}
            }).then(function (url) {
                m.images.push({path: url});
            });
        }

        function delImg(m, index) {
            Dlg.confirm('确认要移除该图片?', function () {
                m.images.splice(index, 1);
            });
        }

        function selectDept(dept) {
            vm.m.doctor = null;
            vm.doctors = [];
            User.query({
                opt: 3/*INDEX_DEPT_MEMBER_OPTIONS*/,
                dept_id: dept.id
            }, function (resp) {
                vm.doctors = resp.users;
            });
        }

        function ok(m, submitType) {
            console.log(submitType);
            //选择填写上传
            if (submitType == 1 && !vm.m.patient.id) {
                Dlg.e('请选择正确的患者');
                return;
                //选择图片上传
            } else if (submitType == 2 && m.images.length === 0) {
                Dlg.e('请选择上传图片');
                return;
            }

            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    date: DateHelper.date2Str(m.date),
                    dept_id: m.dept.id,
                    doctor_id: m.doctor.id
                };
                if (submitType == 1) {
                    pa['patient_id'] = m.patient.id
                    pa['number'] = m.number;
                    pa['area'] = m.area;
                    pa['pathology_number'] = m.pathology_number;
                    pa['diagnosis'] = m.diagnosis;
                } else if (submitType == 2) {
                    var images = [];
                    angular.forEach(m.images, function (image) {
                        images.push({
                            'path': image.path
                        });
                    });
                    pa['images'] = images;
                }
                Immunity.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, Api.errMsg).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();


(function () {
    'use strict';

    angular.module('c.c')
        .controller('deptAgentDlgCtrl', deptAgentDlgCtrl)
    ;

    /** @ngInject */
    function deptAgentDlgCtrl($scope, $uibModalInstance, Immunity, Table, DateHelper, Dlg, Api, MESPatientHelper, toaster, data,Auth) {
        var vm = $scope;
        vm.leave_type_id = data.leave_type_id;
        vm.m = {
            user: null
        };
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            if (m.user == null || m.user == "") {
                toaster.warning('请选择科室代理人!');
            }else if (vm.leave_type_id != 28 && Auth.getAccount().id == m.user.id) {    //科室代管人：只有外出报备类型 28 才能选自己
                toaster.warning('除外出报备类型之外，科室代管人不能选择自己!');
            }else {
                var params = {};
                params['dept_agent_id'] = m.user.id;
                $uibModalInstance.close(params);
            }

        }
    }
})();


(function () {
    'use strict';

    angular.module('c.c')
        .controller('deptTemporaryDlgCtrl', deptTemporaryDlgCtrl)
    ;

    /** @ngInject */
    function deptTemporaryDlgCtrl($scope, $uibModalInstance, Immunity, Table, DateHelper, Dlg) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.m = {
            user: null
        };
        vm.ok = ok;

        function ok(m) {
            if (m.user == null || m.user == "") {
                Dlg.w('请选择科室的线下临时负责人!');
            } else {
                var params = {};
                params['dept_temporary_id'] = m.user.id;
                $uibModalInstance.close(params);
            }

        }
    }
})();


angular.module('c.c').controller('OrderQrCodeCtrl',
    function ($scope, $uibModalInstance, F, PrintHelper, toaster, data) {
        var vm = $scope;
        var order = data.order;
        vm.print = print;
        vm.download = download;
        vm.cancel = $uibModalInstance.dismiss;

        initQrCode(order);

        function initQrCode(o) {
            var m = {type: 'oa.order', id: o.id, has_price: o.has_price == '1'};
            if (m.has_price) {
                m.price = F.toFixed(parseFloat(o.self_paid) + parseFloat(o.subsidy), 1);
            }
            vm.m = m;
        }

        function getPrintHtml(m, order) {
            var html = '';
            var qrUrl = $('#orderQr .qrcode')[0].toDataURL();
            html += '<div><img src="' + qrUrl + '"></div>';
            html += '<div class="info">' + order.store.name + '<strong>' + order.name
                + '</strong>,￥:' + m.price + '元</div>';
            html += '<div class="info">供应类型:<strong>' + order.type.name
                + '</strong></div>';
            if (order.type.id != 4/*全天*/) {
                html += '<div class="info">供应时间:<strong>' + order.start + '~' + order.end
                    + '</strong></div>';
            }
            return html;
        }

        function print(m) {
            if (m.price) {
                PrintHelper.print(window.open('', '打印预览'), 'templates/print/order.html', function () {
                    var html = getPrintHtml(m, order);
                    return html;
                });
            } else {
                toaster.warning('请给定价格');
            }
        }

        function download(m) {
            if (m.price) {
                PrintHelper.printAsWord(order.store.name + order.name + '二维码消费', 'templates/print/order.html',
                    function () {
                        var html = getPrintHtml(m, order);
                        html += '<div class="info">' + (order.is_delivery == '1' ? '支持外送 ' : '')
                            + (order.is_working_meal_allowed == '1' ? '支持手术餐 ' : '')
                            + (order.subsidy > 0 ? '医院补贴' : '')
                            + '</div>';
                        html += '<div class="info">已售出:<strong>' + order.total
                            + '份(获' + order.positive + '个赞)'
                            + '</strong></div>';
                        if (order.intro) {
                            html += '<div class="info">介绍:' + order.intro + '</div>';
                        }
                        return html;
                    });
            } else {
                toaster.warning('请给定价格');
            }
        }
    });
angular.module('c.c').controller('DeliveryPlaceAdminsDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, C, F, Table,
              DeliveryPlaceAdmin, DeliveryPlace, data) {
        var vm = $scope;
        var selfId =  data.selfId;
        vm.place = data.place;
        vm.add = add;
        vm.remove = remove;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.place.id);


        function init(id) {
            var options = {
                service: DeliveryPlaceAdmin,
                params: {opt: 1/*DELIVERYPLACEADMIN.INDEX_ALL*/, place_id: id, need_users: true},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "phone", title: "联系电话", filter: {phone: "text"}}
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.userIds = [];
                angular.forEach(resp.users, function (u) {
                    vm.userIds.push({id: u.id});
                });
            });
        }

        function add() {
            dialogs.create('DeliveryPlaceAdminDlg.html', 'DeliveryPlaceAdminDlgCtrl', {existMembers: vm.userIds}, {

                size: 'md'
            }).result.then(function (pa) {
                    DeliveryPlace.addAdmins({id: vm.place.id}, pa).$promise.then(function () {
                        toaster.success('添加成功');
                        vm.tableReload();
                    });
                });
        }

        function remove(m) {
            if (selfId && selfId == m.id) {
                toaster.warning('不能把自己给删了');
                return;
            }

            dialogs.confirm('删除管理员', '确定要删除<strong>' + vm.place.name + '的' +
                m.name + '</strong>吗?'
            ).result.then(function () {
                    DeliveryPlace.deleteAdmin({id: vm.place.id}, {admin_id: m.id}).$promise.then(function (resp) {
                        toaster.success('删除成功');
                        vm.tableReload();
                    });
                });
        }
    });

angular.module('c.c').controller('DeliveryPlaceAdminDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        var vm = $scope;
        vm.existMembers = data.existMembers;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            vm.m = {admins: []};
        }

        function ok(m) {
            if (m.admins && m.admins.length == 0) {
                toaster.warning('请选择管理员');
            } else {
                var pa = {};
                if (m.admins) {
                    var adminIds = [];
                    angular.forEach(m.admins, function (a) {
                        adminIds.push(a.id);
                    });
                    pa.admins = adminIds;
                }
                $uibModalInstance.close(pa);
            }
        }
    });
angular.module('c.c').controller('WMECtrl',
    function ($scope, $uibModalInstance, $filter, data, Dlg) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.meal = {day: data.day, end_day: data.end_day, time: '1'};

        function ok(meal) {
            if (meal.day > meal.end_day) {
                Dlg.w('开始时间不能大于结束时间');
            } else {
                var params = {};
                params['day'] = $filter('date')(meal.day, 'yyyy-MM-dd');
                params['end_day'] = $filter('date')(meal.end_day, 'yyyy-MM-dd');
                params['time'] = meal.time;
                params['storeId'] = data.storeId;
                $uibModalInstance.close(params);
            }
        }
    });
angular.module('c.c').controller('MeetingAddAttendanceDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data) {
        $scope.meetingId = data.meetingId;
        $scope.meeting = {
            state: true,
            attendances: []
        };

        $scope.ok = function (meeting) {
            if (meeting.attendances.length == 0) {
                toaster.warning('出席人不能为空!');
            } else {
                var params = {};
                params['state'] = meeting.state ? '1' : '0';
                params['meetingId'] = $scope.meetingId;
                params['attendances'] = [];
                angular.forEach(meeting.attendances, function (attendance) {
                    params['attendances'].push(attendance.id);
                });
                $uibModalInstance.close(params);
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });



angular.module('c.c').controller('MeetingAddLeaveDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data) {
        $scope.meetingId = data.meetingId;
        $scope.meeting = {
            state: true,
            leavers: []
        };

        $scope.ok = function (meeting) {
            if (meeting.leavers.length == 0) {
                toaster.warning('请假人不能为空!');
            } else {
                var params = {};
                params['meetingId'] = $scope.meetingId;
                params['leavers'] = [];
                params['reason'] = meeting.reason;
                angular.forEach(meeting.leavers, function (leaver) {
                    params['leavers'].push(leaver.id);
                });
                $uibModalInstance.close(params);
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });



angular.module('c.c').controller('MeetingAttendanceDetailCtrl',
    function ($scope, $uibModalInstance, $sce, $templateRequest, $timeout, uibDateParser,
              data, toaster, Meeting) {
        Meeting.getAttendance({opt: 1, id: data.id}).$promise.then(
            function (resp) {
                $scope.record = resp;
                $scope.showMore = false;
                var start = new Date(),
                    end = uibDateParser.parse($scope.record.meeting.start_time, 'yyyy-MM-dd HH:mm:ss');
                if (start >= end) {
                    $scope.showMore = true;
                }
            }, function () {
                toaster.pop({
                    type: 'warning', title: '记录不存在', body: '该会议可能已被删除!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            }
        );

        function getDetail(array1, array2) {
            angular.forEach(array1, function (u) {
                array2.push(u.user_name + '<' + u.dept_name + '>');
            });
            return array2;
        }

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/meeting_attendance.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.print = function (record) {
            var meeting = record.meeting,
                attendance_users = [],
                late_users = [],
                leavers = [],
                absent_users = [];

            attendance_users = getDetail(record.attendance_users, attendance_users);
            late_users = getDetail(record.late_users, late_users);
            leavers = getDetail(record.leavers, leavers);
            absent_users = getDetail(record.absent_users, absent_users);

            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
            var w = window.open("", "打印预览");
            var html = '<html><body>';
            html += '<h1 class="title">会议考勤统计情况</h1>';
            html += '<p>会议名称：' + meeting.name + '</p>';
            html += '<p>会议时间：' + meeting.time_range + '</p>';
            if (meeting.room_id) {
                html += '<p>会议地点：' + meeting.room.name + '</p>';
            } else {
                html += '<p>会议地点：' + meeting.place + '</p>';
            }
            if (meeting.moderator_id) {
                html += '<p>申请人：' + meeting.applicant.name + '&emsp;&emsp;&emsp;' + '主持人：' + meeting.moderator.name + '</p>';
            } else {
                html += '<p>申请人：' + meeting.applicant.name + '</p>';
            }
            if ($scope.showMore) {
                html += '<p>出席人次：' + record.attendance_total + '</p>';
                if (record.attendance_users.length > 0) {
                    html += '<p>出席具体情况：' + attendance_users.join('、') + '</p>';
                }
            }
            if ($scope.showMore) {
                html += '<p>迟到人次：' + record.late_total + '</p>';
                if (record.late_users.length > 0) {
                    html += '<p>迟到具体情况：' + late_users.join('、') + '</p>';
                }
            }
            html += '<p>请假人次：' + record.leaver_total + '</p>';
            if (record.leavers.length > 0) {
                html += '<p>请假具体情况：' + leavers.join('、') + '</p>';
            }
            if ($scope.showMore) {
                html += '<p>缺席人次：' + record.absent_total + '</p>';
                if (record.absent_users.length > 0) {
                    html += '<p>缺席具体情况：' + absent_users.join('、') + '</p>';
                }
            }
            html += '</body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
)
;
angular.module('c.c').controller('MeetingAttendanceDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, dialogs, toaster, C, F, Table, data, MeetingAttendance) {
        $scope.isApplicant = data.isApplicant ? true : false;
        $scope.ForManage = data.ForManage ? true : false;
        $scope.isModerator = data.isModerator ? true : false;

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var options = {
            service: MeetingAttendance,
            params: {meeting_id: data.id, op: 'sign'},
            hideOpt: !$scope.isApplicant && !$scope.ForManage && !$scope.isModerator,
            items: 'records',
            cols: [
                {title: '签到员工', filter: {name: 'text'}},
                {title: '签到时间'},
                {title: '是否迟到', filter: {is_late: 'select'}, data: yesNoOpts},
                {title: '是否签退', filter: {leave_early: 'select'}, data: yesNoOpts}
            ]
        };

        Table.loadNgTable($scope, options);

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.add = function () {
            dialogs.create('templates/meeting/add_attendance_dlg.html', 'MeetingAddAttendanceDlgCtrl', {meetingId: data.id},
                { size: 'lg'}).result.then(function (params) {
                MeetingAttendance.save(params).$promise.then(function () {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除签到信息', '删除<strong>' + record.user.name + '</strong>的签到信息吗?')
                .result.then(function () {
                MeetingAttendance.delete({id: record.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

    });
angular.module('c.c').controller('DevDetailCtrl',
    function ($rootScope, $scope, $uibModalInstance, dialogs, toaster, $filter, C, F, data, MeetingRoom, Meeting) {
        $scope.date = data.date;

        $scope.$watch('date',
            function () {
                $scope.reload();
            });

        $scope.reload = function () {
            var date = $filter('date')($scope.date, 'yyyy-MM-dd'),
                start = date + ' ' + '00:00:00',
                end = date + ' ' + '23:59:59';
            Meeting.query({opt: 8, start: start, end: end}, function (resp) {
                var meetings = resp.meetings;
                angular.forEach(meetings, function (meeting) {
                    meeting.time_range = meeting.start_time.substr(11, 5) + ' - ' + meeting.end_time.substr(11, 5);
                });
                $scope.meetings = meetings;
            });
        };

        $scope.showDevs = function () {
            dialogs.create('templates/meeting/dev_dlg.html', 'DevDlgCtrl', {},
                { size: 'lg'});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('DevDlgCtrl',
    function ($scope, $filter, $uibModalInstance, dialogs, toaster, NgTableParams, MeetingDevice, F) {
        $scope.dev_types = F.get('device_types');
        var dev_typesOpts = F.getNgTableOpts( $scope.dev_types);


        $scope.cols = [
            {title: '设备名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '设备类型',  filter: {type: 'select'},  data: dev_typesOpts, field: 'type', show: true}, //6
            {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true}, //6
            {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name',  show: true}, //6
            {title: '备注', field: 'remark',  width: '30%',show: true} //6
        ];

        $scope.hideOpt = true;
        $scope.optColWidth = 67;
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                MeetingDevice.query(url, function (resp) {
                    angular.forEach(resp.devices, function (d) {
                        d.type = F.getItem(d.type, $scope.dev_types);
                    });
                    params.total(resp.total);
                    $defer.resolve(resp.devices);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MeetingEditDlgCtrl',
    function ($rootScope, $scope, $filter, $uibModalInstance, $timeout, toaster, dialogs, Upload, FileHelper,
              SaveAs, C, F, Meeting, MeetingRoom, MeetingDevice, MeetingType, uibDateParser, data, Dlg) {
        $scope.ForApproval = data.ForApproval;
        $scope.ForEdit = data.ForEdit;
        $scope.sendWeiXin = data.sendWeiXin;

        function time2SliderVal(time) {
            var hour = parseInt(time.substr(0, 2));
            var minute = parseInt(time.substr(3, 2));
            return hour * 12 + minute / 5;
        }

        Meeting.get({id: data.id}).$promise.then(function (resp) {
            var meeting = resp.meeting;
            meeting['all_attend'] = meeting.all_attend == '1';
            meeting['all_medical'] = meeting.all_medical == '1';
            meeting['all_nurse'] = meeting.all_nurse == '1';
            meeting['all_doctor'] = meeting.all_doctor == '1';
            meeting['is_public'] = meeting.is_public == '1';
            meeting['mdt'] = meeting.mdt == '1';
            meeting['is_dept'] = meeting.is_dept == '1';
            meeting['with_sms'] = meeting.with_sms == '1';
            meeting['with_sms2'] = meeting.with_sms2 == '1';
            if (meeting.reminder_time != null) {
                meeting['is_remind'] = true;
            } else {
                meeting['is_remind'] = false;
            }
            meeting['date'] = uibDateParser.parse(meeting.start_time.substr(0, 10), 'yyyy-MM-dd');
            meeting.s = {
                min: time2SliderVal(meeting.start_time.substr(11, 5)),
                max: time2SliderVal(meeting.end_time.substr(11, 5)),
                options: {
                    floor: 96,
                    ceil: 276,
                    translate: function (val) {
                        var h = Math.floor(val / 12);
                        var m = (val % 12) * 5;
                        return h + ':' + (m >= 10 ? '' : '0') + m;
                    }
                }
            };
            //if (meeting.moderator != null) {
            //    var index = F.indexOfKey(meeting.moderator.id, meeting.attendees);
            //    if (index >= 0) {
            //        meeting.attendees.splice(index, 1);
            //    }
            //}
            $scope.meeting = meeting;
            $scope.searchIdle($scope.meeting);
        }, function () {
            toaster.pop({
                type: 'warning', title: '会议不存在', body: '该会议可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.$watch('meeting.all_attend',
            function (newValue, oldValue) {
                if (newValue) {
                    $scope.meeting.is_public = true;
                    $scope.meeting.is_dept = false;
                    $scope.meeting.attendees = []
                }
            }, true);

        $scope.today = new Date();
        MeetingType.query({opt: 2}, function (resp) {
            $scope.types = resp;
        });

        $scope.deleteAttachment = function ($index, meeting) {
            meeting.attachments.splice($index, 1);
        };

        $scope.upload = function (file, meeting, e) {
            FileHelper.upload(C.URL.MEETING_UPLOAD, file, meeting, e);
        };

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
        };

        $scope.searchIdle = function (meeting) {
            if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else {
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                MeetingRoom.query({
                    opt: 2,
                    start: start,
                    end: end,
                    excludeMeeting: meeting.id,
                    date: date
                }, function (resp) {
                    $scope.rooms = resp.rooms;
                    $scope.rooms.splice(0, 0, {name: '无'});
                    if (meeting.room == null) {
                        meeting.room = $scope.rooms[0];
                    } else {
                        meeting.room = F.getItem(meeting.room.id, $scope.rooms);
                    }
                });

                MeetingDevice.query({opt: 2, start: start, end: end, excludeMeeting: meeting.id}, function (resp) {
                    $scope.devices = resp.devices;
                    var backup = meeting.devices;
                    meeting.devices = [];
                    $timeout(function () {
                        var devices = [];
                        angular.forEach(backup, function (dev) {
                            var device = F.getItem(dev.id, resp.devices);
                            if (device) {
                                devices.push(device);
                            }
                        });
                        meeting.devices = devices;
                    });
                });
            }
        };

        $scope.pass = function (meeting) {
            dialogs.confirm('会议审批', '确定该会议通过审批吗?')
                .result.then(function () {
                    if (meeting.name == null || meeting.name == "") {
                        toaster.warning('名称不能为空!');
                    } else if (!meeting.date) {
                        toaster.warning('会议日期不能为空');
                    } else if (meeting.s.min == meeting.s.max) {
                        toaster.warning('会议开始和结束时间不能相等');
                    } else if (meeting.place == null && meeting.room == null) {
                        toaster.warning('请备注会议地点!');
                    } else if (meeting.place == null && meeting.room.id == null) {
                        toaster.warning('请备注会议地点!');
                    }
                        // else if (meeting.moderator == null) {
                        //     toaster.warning('请填写主持人!');
                    // }
                    else if (!meeting.all_attend && meeting.attendees.length == 0) {
                        toaster.warning('请填写参会人!');
                    } else if (meeting.content == "") {
                        toaster.warning('内容不能为空!');
                    } else if (!FileHelper.isAttachmentsUploaded(meeting)) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                    } else {
                        var params = {};
                        params['name'] = meeting.name;
                        var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                        var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                        var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                        params['start_time'] = start;
                        params['end_time'] = end;
                        params['content'] = meeting.content;
                        params['all_doctor'] = meeting.all_doctor ? '1' : '0';
                        params['all_medical'] = meeting.all_medical ? '1' : '0';
                        params['all_nurse'] = meeting.all_nurse ? '1' : '0';
                        params['all_attend'] = meeting.all_attend ? '1' : '0';
                        params['is_public'] = meeting.is_public ? '1' : '0';
                        params['is_dept'] = meeting.is_dept ? '1' : '0';
                        params['type_id'] = meeting.type.id;
                        if (meeting.room == null) {
                            params['room_id'] = null;
                        } else {
                            if (meeting.room.id == null) {
                                params['room_id'] = null;
                            } else {
                                params['room_id'] = meeting.room.id;
                            }
                        }
                        params['place'] = meeting.place;
                        params['dept_id'] = data.deptId;
                        params['moderator_id'] = meeting.moderator ? meeting.moderator.id : null;
                        params['attendees'] = [];
                        // params['with_sms'] = meeting.with_sms ? '1' : '0';
                        params['with_sms'] = '0';
                        params['mdt'] = meeting.mdt ? '1' : '0';
                        params['is_remind'] = meeting.is_remind ? '1' : '0';
                        params['with_sms2'] = meeting.with_sms2 ? '1' : '0';
                        angular.forEach(meeting.attendees, function (attendee) {
                            params['attendees'].push(attendee.id);
                        });
                        //if (meeting.moderator != null) {
                        //    params['moderator_id'] = meeting.moderator.id;
                        //    var index = F.indexOf(meeting.moderator.id, params['attendees']);
                        //    if (index >= 0) {
                        //        params['attendees'].splice(index, 1);
                        //    }
                        //}
                        params['devices'] = [];
                        angular.forEach(meeting.devices, function (dev) {
                            params['devices'].push(dev.id);
                        });
                        params['attachments'] = [];
                        angular.forEach(meeting.attachments, function (attachment) {
                            params['attachments'].push({
                                name: attachment.name, mime: attachment.mime,
                                filename: attachment.filename, size: attachment.size
                            });
                        });
                        params['opt'] = 1;
                        params['isHospitalOffice'] = data.isHospitalOffice;
                        $uibModalInstance.close(params);
                    }
                }
            )
        };

        $scope.back = function (meeting) {
            dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                title: '退回会议',
                icon: 'reply',
                label: '原因'
            }, {

                size: 'sm'
            }).result.then(function (pa) {
                var params = {};
                params['remark'] = pa;
                params['dept_id'] = data.deptId;
                params['opt'] = 2;
                Meeting.update({id: meeting.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('meetingBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            });
        };

        $scope.ok = function (meeting, checkLeave, leaveUserIds) {
            if (meeting.name == null || meeting.name == "") {
                toaster.warning('名称不能为空!');
            } else if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else if (meeting.place == null && meeting.room == null) {
                toaster.warning('请备注会议地点!');
            } else if (meeting.place == null && meeting.room.id == null) {
                toaster.warning('请备注会议地点!');
            } else if (meeting.moderator == null) {
                toaster.warning('请填写主持人!');
            } else if (!meeting.all_attend && !meeting.all_nurse && !meeting.all_medical
                && !meeting.all_doctor && meeting.attendees.length == 0) {
                toaster.warning('请填写参会人!');
            } else if (meeting.content == "") {
                toaster.warning('内容不能为空!');
            } else {
                for (var i = 0; i < meeting.attachments.length; i++) {
                    if (meeting.attachments[i].filename == null) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                        return;
                    }
                }
                var params = {};
                params['name'] = meeting.name;
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                params['start_time'] = start;
                params['end_time'] = end;
                params['content'] = meeting.content;
                params['all_attend'] = meeting.all_attend ? '1' : '0';
                params['is_public'] = meeting.is_public ? '1' : '0';
                params['all_doctor'] = meeting.all_doctor ? '1' : '0';
                params['all_medical'] = meeting.all_medical ? '1' : '0';
                params['all_nurse'] = meeting.all_nurse ? '1' : '0';
                params['is_dept'] = meeting.is_dept ? '1' : '0';
                params['type_id'] = meeting.type.id;
                params['sendWeiXin'] = meeting.sendWeiXin;
                if (meeting.room == null) {
                    params['room_id'] = null;
                } else {
                    if (meeting.room.id == null) {
                        params['room_id'] = null;
                    } else {
                        params['room_id'] = meeting.room.id;
                    }
                }
                params['place'] = meeting.place;
                params['dept_id'] = data.deptId;
                params['moderator_id'] = meeting.moderator.id;
                params['attendees'] = [];
                params['with_sms'] = meeting.with_sms ? '1' : '0';
                params['mdt'] = meeting.mdt ? '1' : '0';
                params['is_remind'] = meeting.is_remind ? '1' : '0';
                params['with_sms2'] = meeting.with_sms2 ? '1' : '0';
                angular.forEach(meeting.attendees, function (attendee) {
                    params['attendees'].push(attendee.id);
                });
                //if (meeting.moderator != null) {
                //    params['moderator_id'] = meeting.moderator.id;
                //    var index = F.indexOf(meeting.moderator.id, params['attendees']);
                //    if (index >= 0) {
                //        params['attendees'].splice(index, 1);
                //    }
                //}
                params['devices'] = [];
                angular.forEach(meeting.devices, function (dev) {
                    params['devices'].push(dev.id);
                });
                params['attachments'] = [];
                angular.forEach(meeting.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                params['opt'] = 3;

                params['checkLeave'] = angular.isUndefined(checkLeave) ? 1 : checkLeave;
                params['leaveUserIds'] = angular.isUndefined(leaveUserIds) ? [] : leaveUserIds;
                if (params['checkLeave']) {
                    Meeting.update({id: meeting.id}, params).$promise.then(
                        function (resp) {
                            switch (resp.result) {
                                case 0:
                                    if (resp.leaveUsers.length > 0) {
                                        showLeaves(resp.leaveUsers, meeting);
                                    } else {
                                        $uibModalInstance.close(params);
                                    }
                                    break;
                                case 1:
                                    toaster.warning('会议室冲突,请重新修改');
                                    break;
                                case 2:
                                    toaster.warning('设备冲突,请重新修改');
                                    break;
                            }
                        }, function () {
                            toaster.error('会议修改失败了!');
                        }
                    );
                } else {
                    $uibModalInstance.close(params);
                }
            }

        };

        function showLeaves(users, meeting) {
            Dlg.show({
                template: 'templates/meeting/show_leave.html',
                ctrl: 'MeetingShowLeaveDlgCtrl',
                data: {
                    users: users
                },
                size: 'md'
            }).then(function (resp) {
                $scope.ok(meeting, 0, resp);
            });
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.roomDetail = function () {
            dialogs.create('templates/meeting/room_detail.html', 'RoomDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        };

        $scope.devDetail = function () {
            dialogs.create('templates/meeting/dev_detail.html', 'DevDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        };
    });



angular.module('c.c').controller('MeetingLeaveCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, C, F, Table, Meeting) {
        var vm = $scope;
        vm.approval = approval;
        vm.cancel = $uibModalInstance.dismiss;

        init();
        function init() {
            var options = {
                service: Meeting, params: {opt: 11}, optColWidth: 68, items: 'meetings', hideFilter: true,
                cols: [{title: '会议名称'}, {title: '类型'}, {title: '开会时间'}, {title: '开会地点'}]
            };

            Table.loadNgTable(vm, options, function (data) {
                angular.forEach(data.meetings, function (meeting) {
                    meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                });
            });
        }

        function approval(meeting) {
            dialogs.create('templates/meeting/leave_dlg.html', 'MeetingLeaveDlgCtrl'
                , {id: meeting.id, isApprovalList: true, isApplicant: true}, {
                     size: 'lg'
                }).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(function () {
                    toaster.success('确认成功!');
                    vm.tableReload();
                });
            });
        }
    });
angular.module('c.c').controller('MeetingLeaveDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, Table,
              data, MeetingAsk4Leave) {
        $scope.isApplicant = data.isApplicant ? true : false;
        $scope.ForManage = data.ForManage ? true : false;
        $scope.isModerator = data.isModerator ? true : false;
        $scope.isApprovalList = data.isApprovalList;
        $scope.meeting_id = data.id;

        var options = {
            service: MeetingAsk4Leave,
            params: {meeting_id: $scope.meeting_id, opt: 1},
            optColWidth: 68,
            hideFilter: true,
            hideOpt: !$scope.isApplicant && !$scope.ForManage && !$scope.isModerator,
            items: 'records',
            cols: [
                {title: '请假员工'},
                {title: '请假时间'},
                {title: '请假原因', show: $scope.isApplicant || $scope.ForManage || $scope.isModerator},
                {title: '状态'}
            ]
        };

        Table.loadNgTable($scope, options, function (data) {
            $scope.users = data.records;
        });

        $scope.set = function (u) {
            dialogs.confirm('确认请假信息', '确认<strong>' + u.name + '</strong>的请假信息吗?')
                .result.then(function () {
                MeetingAsk4Leave.update({id: u.id}, {opt: 1}).$promise.then(function (resp) {
                    toaster.success('设置成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设置失败!');
                });
            });
        };

        $scope.unset = function (u) {
            dialogs.confirm('取消请假信息', '取消<strong>' + u.name + '</strong>的请假信息吗?')
                .result.then(function () {
                MeetingAsk4Leave.update({id: u.id}, {opt: 2}).$promise.then(function (resp) {
                    toaster.success('设置成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设置失败!');
                });
            });
        };

        $scope.delete = function (u) {
            dialogs.confirm('删除请假信息', '删除<strong>' + u.name + '</strong>的请假信息吗?')
                .result.then(function () {
                MeetingAsk4Leave.delete({id: u.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        var checker = Table.loadMultiSelectedFn($scope);

        function batch(users, opt) {
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }
            MeetingAsk4Leave.setAll({leaveIds: checker.getCheckedIds(users), opt: opt}, function () {
                toaster.success('设置成功');
                $scope.tableReload();
            });
        }

        $scope.setAll = function (users) {
            batch(users, 1)
        };

        $scope.unsetAll = function (users) {
            batch(users, 2)
        };

        $scope.deleteAll = function (users) {
            batch(users, 3)
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            dialogs.confirm('会议请假信息确认', '确认后不会在首页集中审批提醒,但仍可在请假详情中修改,是否确认?')
                .result.then(function () {
                    var params = {};
                    params['opt'] = 5;
                    $uibModalInstance.close(params);
                }
            )
        };
    })
angular.module('c.c')
    .controller('M2CDlgCtrl', function ($scope, $uibModalInstance, $filter, $sce, C, F, dialogs, toaster,
                                        uibDateParser, ECourse, ESubject, EProject, Meeting, data, FileHelper) {

        $scope.meeting = data.meeting;

        ESubject.query({opt: 4 /*INDEX_ALL_WITH_PROJECT_OPTIONS*/, with_pj: true}, function (resp) {
            $scope.subjects = resp.subjects;
            $scope.grpSubject = function (s) {
                if (s.is_nurse == '1') {
                    return '护理';
                } else {
                    return '非护理';
                }
            };

            angular.forEach(resp.subjects, function (subject) {
                subject.projects.splice(0, 0, {name: '无'})
            });
        });

        function arrayUnique(array) {
            var a = array.concat();
            for (var i = 0; i < a.length; ++i) {
                for (var j = i + 1; j < a.length; ++j) {
                    if (a[i].id === a[j].id)
                        a.splice(j--, 1);
                }
            }
            return a;
        }

        Meeting.getAttendance({opt: 1, id: $scope.meeting.id}).$promise.then(
            function (resp) {
                var attendance_users = resp.attendance_users,
                    leavers = resp.leavers,
                    absent_users = resp.absent_users;
                angular.forEach(attendance_users, function (u) {
                    u.type = '出席';
                });
                angular.forEach(leavers, function (u) {
                    u.type = '请假';
                });
                angular.forEach(absent_users, function (u) {
                    u.type = '缺席';
                });
                $scope.pass_users = attendance_users;
                var continue_users = arrayUnique(leavers.concat(absent_users));
                $scope.users = arrayUnique(continue_users.concat(attendance_users));
                $scope.c = {
                    pass_score: 60,
                    is_retry_allowed: false,
                    for: 1,
                    dept: $scope.meeting.dept,
                    course_ware: {},
                    limit_time: uibDateParser.parse('00:30', 'HH:mm'),
                    title: $scope.meeting.name,
                    pass_users: $scope.pass_users,
                    users: continue_users
                };
            }
        );


        function prompt(c, type) {
            if (c.paper) {
                dialogs.notify('提示', '修改课程' + type + '并不会改变配套测试题中的题目的' + type + ', ' +
                    '若需改变题目' + type + ',请进入测试题中编辑相应题目');
            }
        }

        $scope.subSelectedFn = function (subject, c) {
            $scope.projects = subject.projects;
            c.project = subject.projects[0];
            prompt(c, '学科');
        };

        $scope.pjSelectedFn = function (project, c) {
            prompt(c, '专题');
        };

        $scope.addPaper = function (c) {
            dialogs.create('templates/edu/p/edit_dlg.html', 'EPaperEditDlgCtrl',
                {
                    hideRelease: true,
                    defTitle: (c.title ? c.title : '') + '测试卷',
                    defSubject: c.subject,
                    defProject: c.project
                }, {

                    size: 'lg'
                }).result.then(function (pa) {
                c.paper = pa;
            });
        };

        $scope.editPaper = function (c) {
            dialogs.create('templates/edu/p/edit_dlg.html', 'EPaperEditDlgCtrl',
                {
                    hideRelease: true,
                    paper: c.paper,
                    defSubject: c.subject,
                    defProject: c.project
                }, {

                    size: 'lg'
                }).result.then(function (pa) {
                c.paper = pa;
            });
        };

        $scope.removePaper = function (c) {
            dialogs.confirm('提示', '确定要删除测试题吗?').result.then(function () {
                delete c.paper;
                delete c.pass_score;
                delete c.is_retry_allowed;
            });
        };


        $scope.upload = function (file, courseWare, e) {
            $scope.courseWare = courseWare;
            if (file) {
                courseWare.name = file.name;
                delete courseWare.filename;
            }
            FileHelper.upload1(C.URL.E_COURSE_UPLOAD, file, courseWare, e, {name: 'tmp_dir'}, {tmp_dir: courseWare.tmp_dir});
        };

        function existsSameValues(array1, array2) {
            var array3 = [];
            for (var s in array1) {
                for (var x in array2) {
                    if (array1[s] == array2[x]) {
                        array3.push(array1[s]);
                    }
                }
            }
            return array3;
        }

        $scope.ok = function (c) {
            if (c.users && c.pass_users) {
                var same = existsSameValues(c.users, c.pass_users),
                    sameName = [];
                angular.forEach(same, function (s) {
                    sameName.push(s.user_name)
                });
            }
            if (!c.course_ware.filename) {
                toaster.warning('课件还未上传或正在上传中!');
            } else if (c.subject == null) {
                toaster.warning('请选择所属学科');
            } else if (c.limit_time == '' || c.limit_time == null) {
                toaster.warning('请设置学习时间限制');
            } else if (c.pass_users && c.users && same.length > 0) {
                toaster.warning('获得学分和继续学习存在相同学员' + sameName);
            } else {
                if ($scope.c_form.$valid) {
                    var params = {
                        title: c.title,
                        intro: c.intro,
                        dept_id: c.dept.id,
                        for: c.for,
                        paper: c.paper,
                        pass_score: c.pass_score,
                        credit: c.credit,
                        is_retry_allowed: c.is_retry_allowed,
                        mime: c.course_ware.mime,
                        size: c.course_ware.size,
                        filename: c.course_ware.filename,
                        tmp_dir: c.course_ware.tmp_dir,
                        subject_id: c.subject.id,
                        project_id: c.project.id,
                        limit_time: $filter('date')(c.limit_time, 'HH:mm'),
                        users: F.listKey(c.users),
                        pass_users: F.listKey(c.pass_users)
                    };
                    $uibModalInstance.close(params);
                } else {
                    toaster.warning('表单中有错误!');
                    $scope.c_form.submitted = true;
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MeetingQrcodeDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $templateRequest, $timeout, toaster, C, F, data, Meeting) {
        $scope.meeting = data.meeting;
        $scope.qrCodeName = '会议' + data.qrCodeName;

        Meeting.getQrcode({id: $scope.meeting.id, type: data.type}).$promise.then(
            function (resp) {
                switch (resp.result) {
                    case 0:
                        $scope.url = resp.url;
                        $scope.expired_at = resp.expired_at;
                        break;
                    case 1:
                        break;
                }
            }, function () {
                toaster.error('生成失败了!');
            }
        );

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/meeting_qrcode.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.print = function (meeting) {
            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
            var w = window.open("", "打印预览");
            var html = '<html><body>';
            html += '<h1 class="title">会议微信扫码' + data.qrCodeName + '</h1>';
            html += '<div class="qrcode"><img height="100" width="100" src="' + $scope.url + '"/></div>';
            html += '<div style="font-size: 10px;"><p>会议名称：' + meeting.name + '</p>';
            html += '<p>会议时间：' + meeting.time_range + '</p>';
            if (meeting.moderator_id) {
                html += '<p>申请人：' + meeting.applicant.name + '&emsp;&emsp;&emsp;' + '主持人:' + meeting.moderator.name + '</p>';
            } else {
                html += '<p>申请人：' + meeting.applicant.name + '</p>';
            }
            html += '</div><p>' + meeting.content + '</p>';
            html += '</body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    });
angular.module('c.c').controller('RoomDetailCtrl',
    function ($rootScope, $scope, $uibModalInstance, dialogs, toaster, $filter, C, F, data, MeetingRoom, Meeting) {
        $scope.date = data.date;

        $scope.$watch('date',
            function () {
                $scope.reload();
            });

        $scope.reload = function () {
            var date = $filter('date')($scope.date, 'yyyy-MM-dd'),
                start = date + ' ' + '00:00:00',
                end = date + ' ' + '23:59:59';
            Meeting.query({opt: 7, start: start, end: end}, function (resp) {
                var meetings = resp.meetings;
                angular.forEach(meetings, function (meeting) {
                    meeting.time_range = meeting.start_time.substr(11, 5) + ' - ' + meeting.end_time.substr(11, 5);
                });
                $scope.meetings = meetings;
            });
        };

        $scope.showRooms = function () {
            dialogs.create('templates/meeting/room_dlg.html', 'RoomDlg2Ctrl', {},
                { size: 'lg'});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('RoomDlg2Ctrl',
    function ($scope, $filter, $uibModalInstance, dialogs, toaster, NgTableParams, MeetingRoom, F) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesOrNo2'));
        $scope.yesNo = F.get('yesOrNo2');

        $scope.cols = [
            {title: '会议室名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '容纳人数', sortable: 'capacity', filter: {capacity: 'number_range'}, field: 'capacity', show: true}, //6
            {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true}, //6
            {title: '投影仪', filter: {has_projector: 'select'}, data: yesNoOpts, field: 'has_projector', show: true}, //6
            {title: '音响', filter: {has_audio: 'select'}, data: yesNoOpts, field: 'has_audio', show: true}, //6
            {title: '电脑', filter: {has_computer: 'select'}, data: yesNoOpts, field: 'has_computer', show: true}, //6
            {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name', show: true}, //6
            {title: '备注', field: 'remark', width: '61', show: true} //6
        ];

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.hideOpt = true;
        $scope.optColWidth = 67;
        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                if ($scope.numRangeFilter.capacity != null) {
                    url['startCap'] = $scope.numRangeFilter.capacity.start;
                    url['endCap'] = $scope.numRangeFilter.capacity.end;
                }
                MeetingRoom.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.rooms);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MeetingShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, Dlg, SaveAs, C, F, data, Meeting,
              MeetingAttendance, MeetingAsk4Leave, Sms, FileHelper, MeetingRecord, PrintHelper, $q) {
        $scope.ForApplied = data.ForApplied;
        $scope.ForManage = data.ForManage;
        $scope.ForApproval = data.ForApproval;
        $scope.ForLeave = data.ForLeave;
        $scope.isRecorder = data.isRecorder;
        $scope.ForRemind = data.ForRemind;
        $scope.ForDayRemind = data.ForDayRemind;
        $scope.ForRCancel = data.ForRCancel;
        $scope.isApplicant = data.isApplicant;
        $scope.isModerator = data.isModerator;
        $scope.SmsAgain = data.SmsAgain;
        Meeting.get({id: data.id}).$promise.then(function (resp) {
            var meeting = resp.meeting;
            angular.forEach(meeting.attachments, function (attachment) {
                attachment.ico = F.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });
            $scope.meetingContent = $sce.trustAsHtml(meeting.content);
            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
            //if (meeting.moderator != null) {
            //    var index = F.indexOfKey(meeting.moderator.id, meeting.attendees);
            //    if (index >= 0) {
            //        meeting.attendees.splice(index, 1);
            //    }
            //}
            $scope.meeting = meeting;
            if (!meeting.recipient) {
                $rootScope.$broadcast('MeetingRead', data.id);
            }
            if (data.isRecorder || data.isApplicant || data.ForManage) {
                $q.all([
                    MeetingRecord.get({id: '-', meeting_id: data.id}).$promise,
                    MeetingAttendance.get({id: data.id}).$promise
                ]).then(function (respArray) {
                    var resp = respArray[0];
                    for (var i = 0; i < resp.item.length; i++) {
                        resp.item[i].estimated_time = resp.item[i].estimated_time.substr(0, 10);
                        if (resp.item[i].finish_time.substr(0, 4) === '0000') {
                            resp.item[i].finish_time = null;
                        } else {
                            resp.item[i].finish_time = resp.item[i].finish_time.substr(0, 10);
                        }
                    }
                    $scope.users = respArray[1].records;
                    $scope.records = resp.item;
                });
            }
        }, function () {
            toaster.pop({
                type: 'warning', title: '会议不存在', body: '该会议可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.print = function (meeting, records, users) {
            var i = 1;
            var joinName = '';
            var leaveName = '';
            PrintHelper.print(window.open('', '打印预览'), '/templates/print/table2.html', function () {
                var html = '<table><tbody><tr><td width="75">会议名称</td>';
                html += '<td colspan="5">' + meeting.name + '</td>';
                html += '</tr>';
                html += '<tr><td width="75">时间</td>';
                html += '<td width="250">' + meeting.release_time.substr(0, 10) + '</td>';
                html += '<td width="75">编号</td>';
                html += '<td width="250">' + meeting.release_time.substr(0, 4) + meeting.release_time.substr(5, 2)
                    + meeting.release_time.substr(8, 2) + '-' + meeting.type.number + '-' + meeting.dept.number + '-' + meeting.order + '</td>';
                html += '</tr>';

                html += '<tr><td width="75">类型</td>';
                html += '<td width="250">' + meeting.type.name + '</td>';
                html += '<td width="75">申请科室</td>';
                html += '<td>' + meeting.dept.name + '</td>';
                html += '</tr>';
                html += '<tr><td width="75">主持人</td>';
                html += '<td width="250">' + (meeting.moderator ? meeting.moderator.name : '无') + '</td>';
                html += '<td width="75">记录人</td>';
                html += '<td width="250">' + meeting.recorder.name + '</td>';
                html += '</tr>';

                angular.forEach(records, function (record) {
                    html += '<tr height="120" line-height="120"><td width="75">记录' + i + '</td>';
                    html += '<td colspan="5">' + '议程：' + record.resolution;
                    html += '<br>决议：' + record.agenda;
                    html += '<br>落实科室：' + record.dept.name;
                    html += '<br>落实内容：' + (record.content ? record.content : '无');
                    html += '<br>拟完成时间：' + record.estimated_time;
                    if (record.finish_time) {
                        html += '<br>实际完成时间：' + (record.finish_time ? record.finish_time : '无');
                        html += '<br>评语：' + (record.comment ? record.comment : '无');
                        html += '<br>验收人签字：' + '<img src="' + record.user.signature.sign + '" width="120" height="20"/></td>';
                    }
                    html += '</tr>';
                    i++;
                });
                angular.forEach(users, function (u) {
                    joinName += u.user.name + '、';
                    if (u.leave_early == 1) {
                        leaveName += u.user.name + '、'
                    }
                });

                html += '<tr><td width="75">签到</td>';
                html += '<td colspan="5">' + joinName + '</td></tr>';
                html += '<tr><td width="75">签退</td>';
                html += '<td colspan="5">' + leaveName + '</td></tr>';
                html += '</tbody></table>';


                return html;
            });

        };

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
        };

        //再次短信通知
        $scope.send = function (meeting) {
            Dlg.show({
                template: 'pages/meeting/noticeDlg.html',
                ctrl: 'MeetingNoticeDlgCtrl',
                data: {
                    id: meeting.id,
                },
                size: 'md'
            }).then(function (resp) {
            });
            // dialogs.confirm('发送短信', '确定要通知主持及参会人吗?')
            //     .result.then(function () {
            //     var attendees = [];
            //     angular.forEach(meeting.attendees, function (attendee) {
            //         attendees.push(attendee.id);
            //     });
            //
            //     function sendSms(content, recipients) {
            //         var pa = {};
            //         pa['sign'] = '【西藏自治区人民政府驻成都办事处医院】';
            //         pa['content'] = content;
            //         pa['recipients'] = recipients;
            //         Sms.send(pa, function () {
            //             toaster.success('短信请求成功!');
            //         }, function () {
            //             toaster.error('短信请求失败!');
            //         });
            //     }
            //
            //     var content = '请于' + meeting.start_time.substr(0, 16);
            //     if (meeting.room != null) {
            //         content += '到' + meeting.room.name;
            //     } else {
            //         content += '到' + meeting.place;
            //     }
            //     content += '参加《' + meeting.name + '》会议,详情见通知!('
            //         + meeting.applicant.name + meeting.applicant.phone + ')';
            //     sendSms(content, attendees);
            //
            //     content = '请于' + meeting.start_time.substr(0, 16);
            //     if (meeting.room != null) {
            //         content += '到' + meeting.room.name;
            //     } else {
            //         content += '到' + meeting.place;
            //     }
            //     content += '主持《' + meeting.name + '》会议,详情见通知!('
            //         + meeting.applicant.name + meeting.applicant.phone + ')';
            //     sendSms(content, [meeting.moderator.id]);
            // });
        };

        //审批
        $scope.approval = function (meeting) {
            var params = {opt: 3, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //修改
        $scope.edit1 = function (meeting) {
            var params = {opt: 1, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //重新编辑
        $scope.edit2 = function (meeting) {
            var params = {opt: 2, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //请假
        $scope.leave = function (meeting) {
            var params = {opt: 4, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //会前提醒
        $scope.remind1 = function (meeting, op) {
            var params = {opt: 5, meeting: meeting, op: op};
            $uibModalInstance.close(params);
        };

        //取消会前提醒
        $scope.remind2 = function (meeting) {
            var params = {opt: 6, meeting: meeting};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.detail = function (meeting) {
            dialogs.create('templates/meeting/leave_dlg.html', 'MeetingLeaveDlgCtrl', {
                    id: meeting.id,
                    isApplicant: data.isApplicant,
                    isModerator: data.isModerator,
                    ForManage: data.ForManage
                },
                {size: 'lg'});
        };

        $scope.qrcode = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {meeting: meeting},
                {size: 'md'});
        };

        $scope.attendance = function (meeting) {
            dialogs.create('templates/meeting/attendance_dlg.html', 'MeetingAttendanceDlgCtrl', {
                    id: meeting.id,
                    isApplicant: data.isApplicant,
                    isModerator: data.isModerator,
                    ForManage: data.ForManage
                },
                {size: 'lg'});
        };

        $scope.statistic = function (meeting) {
            dialogs.create('templates/meeting/attendance_detail.html', 'MeetingAttendanceDetailCtrl', {id: meeting.id},
                {size: 'lg'});
        };

        $scope.add = function () {
            dialogs.create('templates/meeting/add_attendance_dlg.html', 'MeetingAddAttendanceDlgCtrl', {meetingId: data.id},
                {size: 'md'}).result.then(function (params) {
                MeetingAttendance.save(params).$promise.then(function () {
                    toaster.success('签到成功!');
                }, function () {
                    toaster.error('签到失败!');
                });
            });
        };

        $scope.back = function () {
            dialogs.create('templates/meeting/backAttendanceDlg.html', 'MeetingBackAttendanceDlgCtrl', {meetingId: data.id},
                {size: 'md'}).result.then(function (params) {
                MeetingAttendance.update({id: '-'}, params).$promise.then(function () {
                    toaster.success('签退成功!');
                }, function () {
                    toaster.error('签退失败!');
                });
            });
        };

        $scope.addLeave = function () {
            dialogs.create('templates/meeting/add_leave_dlg.html', 'MeetingAddLeaveDlgCtrl', {meetingId: data.id},
                {size: 'md'}).result.then(function (params) {
                MeetingAsk4Leave.save(params).$promise.then(function () {
                    toaster.success('添加成功!');
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };
    });
(function () {
    'use strict';

    angular.module('c.c').controller('MeetingShowLeaveDlgCtrl', MeetingShowLeaveDlgCtrl);

    /** @ngInject */
    function MeetingShowLeaveDlgCtrl($scope, $uibModalInstance, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.setAll = setAll;

        init(data.users);


        function init(users) {
            angular.forEach(users, function (user) {
                user.selected = true;
            });
            vm.users = users;
        }

        function setAll(type) {
            angular.forEach(vm.users, function (user) {
                user.selected = type;
            });
        }

        function ok(users) {
            var userIds = [];
            angular.forEach(users, function (user) {
                if (user.selected) userIds.push(user.id);
            });
            $uibModalInstance.close(userIds);
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('FileAttachmentDlgCtrl', FileAttachmentDlgCtrl);

    /** @ngInject */
    function FileAttachmentDlgCtrl($uibModalInstance, data, UIHelper, MeetingTopic, Api,
                                   Dlg, $rootScope, ArrayHelper, FileHelper, FormHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.uploadAttachment = uploadAttachment;
        vm.deleteAttachment = deleteAttachment;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            // MeetingTopic.get({id: id, op: 'default', for_print: false}).$promise.then(function (resp) {
            //     vm.m = resp.item;
            //     angular.forEach(vm.m.attachments, function (attachment) {
            //         attachment.ico = UIHelper.getIconFromMime(attachment.mime);
            //         attachment.size = parseInt(attachment.size);
            //     });
            // }, function (e) {
            //     vm.error = e.data.msg ? e.data.msg : '该文件不存在';
            //     Dlg.e(vm.error);
            //     $uibModalInstance.close();
            // });
            vm.m = {attachments: []};
        }

        function uploadAttachment(file, m, e) {
            FileHelper.uploadAttachment(file, m, e);
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function ok(m) {
            var pa = {
                opt: 7,
                attachments: []
            };
            FileHelper.loadAttachmentParams(pa, m);

            MeetingTopic.update({id: data.id}, pa).$promise.then(
                function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('议题处理成功');
                            $rootScope.$broadcast('topicHandle');
                            $uibModalInstance.dismiss('cancel');
                            break;
                        case 1:
                            Dlg.w('该议题已处理,请刷新再次查看');
                            break;
                    }
                }, function () {
                    Dlg.e('议题处理失败了!');
                }
            );
        }
    }

})();

angular.module('c.c').controller('TopicEditDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, Upload, SaveAs, C, F, data,
              MeetingTopic, Dept, FileHelper) {
        $scope.ForApproval = data.ForApproval;
        $scope.ForEdit = data.ForEdit;
        $scope.topic_types = F.get('topic_types');

        Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS2}, function (resp) {
            $scope.depts = resp.depts;
        });

        MeetingTopic.get({id: data.id}).$promise.then(function (resp) {
            var topic = resp.topic;
            topic['type'] = F.getItem(topic.type, $scope.topic_types);
            topic['is_public'] = topic.is_public == '1';
            topic['is_urgent'] = topic.is_urgent == '1';
            topic['is_triple'] = topic.is_triple == '1';
            $scope.topic = topic;
            // $scope.topicContent = $sce.trustAsHtml(topic.body);
        }, function () {
            toaster.pop({
                type: 'warning', title: '议题不存在', body: '该议题可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.deleteAttachment = function ($index, topic) {
            topic.attachments.splice($index, 1);
        };

        $scope.upload = function (file, topic, e) {
            FileHelper.upload(C.URL.TOPIC_UPLOAD, file, topic, e);
        };

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.TOPIC_DOWNLOAD, attachment);
        };

        $scope.ok = function (topic) {
            if (topic.subject == null || topic.subject == "") {
                toaster.warning('标题不能为空!');
            } else if (topic.body == null || topic.body == "") {
                toaster.warning('正文内容不能为空!');
            } else if (!FileHelper.isAttachmentsUploaded(topic)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {};
                params['subject'] = topic.subject;
                params['body'] = topic.body;
                params['dept_id'] = topic.dept.id;
                params['type'] = topic.type.id;
                params['is_public'] = topic.is_public ? '1' : '0';
                params['is_urgent'] = topic.is_urgent ? '1' : '0';
                params['is_triple'] = topic.is_triple ? '1' : '0';
                params['rapporteurs'] = [];
                angular.forEach(topic.rapporteurs, function (dev) {
                    params['rapporteurs'].push(dev.id);
                });
                params['observers'] = [];
                angular.forEach(topic.observers, function (dev) {
                    params['observers'].push(dev.id);
                });
                //当为专题会时候，读取主持人\记录人
                if (topic.type.id == 4) {
                    params['hosts'] = [];
                    angular.forEach(topic.hosts, function (dev) {
                        params['hosts'].push(dev.id);
                    });
                    params['recorders'] = [];
                    angular.forEach(topic.recorders, function (dev) {
                        params['recorders'].push(dev.id);
                    });
                }
                params['attachments'] = [];
                angular.forEach(topic.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                params['opt'] = C.OPT.MEETING_TOPIC.EDIT.SAVE;
                $uibModalInstance.close(params);
            }
        };

        $scope.pass = function (topic) {
            dialogs.confirm('议题审批', '确定该议题通过审批吗?')
                .result.then(function () {
                    if (topic.subject == null || topic.subject == "") {
                        toaster.warning('标题不能为空!');
                    } else if (topic.body == null || topic.body == "") {
                        toaster.warning('正文内容不能为空!');
                    } else {
                        for (var i = 0; i < topic.attachments.length; i++) {
                            if (topic.attachments[i].filename == null) {
                                toaster.warning('请等一小会儿,部分附件还在路上');
                                return;
                            }
                        }
                        var params = {};
                        params['subject'] = topic.subject;
                        params['body'] = topic.body;
                        params['dept_id'] = data.deptId;
                        params['type'] = topic.type.id;
                        params['is_public'] = topic.is_public ? '1' : '0';
                        params['is_urgent'] = topic.is_urgent ? '1' : '0';
                        params['is_triple'] = topic.is_triple ? '1' : '0';
                        params['rapporteurs'] = [];
                        angular.forEach(topic.rapporteurs, function (dev) {
                            params['rapporteurs'].push(dev.id);
                        });
                        params['observers'] = [];
                        angular.forEach(topic.observers, function (dev) {
                            params['observers'].push(dev.id);
                        });
                        params['hosts'] = [];
                        angular.forEach(topic.hosts, function (dev) {
                            params['hosts'].push(dev.id);
                        });
                        params['recorders'] = [];
                        angular.forEach(topic.recorders, function (dev) {
                            params['recorders'].push(dev.id);
                        });
                        params['attachments'] = [];
                        angular.forEach(topic.attachments, function (attachment) {
                            params['attachments'].push({
                                name: attachment.name, mime: attachment.mime,
                                filename: attachment.filename, size: attachment.size
                            });
                        });
                        params['opt'] = C.OPT.MEETING_TOPIC.EDIT.PASS;
                        $uibModalInstance.close(params);
                    }
                }
            )
        };

        $scope.back1 = function (topic) {
            dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                title: '不讨论议题',
                icon: 'reply',
                label: '原因'
            }, {

                size: 'sm'
            }).result.then(function (pa) {
                var params = {};
                params['remark'] = pa;
                params['dept_id'] = data.deptId;
                params['opt'] = C.OPT.MEETING_TOPIC.EDIT.BACK;
                MeetingTopic.update({id: topic.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('topicBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            });
        };

        $scope.back2 = function (topic) {
            dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                title: '退回补充议题',
                icon: 'reply',
                label: '原因'
            }, {

                size: 'sm'
            }).result.then(function (pa) {
                var params = {};
                params['remark'] = pa;
                params['dept_id'] = data.deptId;
                params['opt'] = C.OPT.MEETING_TOPIC.EDIT.BACK_TO_ADD;
                MeetingTopic.update({id: topic.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('topicBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });



angular.module('c.c').controller('TopicHandleDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, toaster, C) {
        $scope.stages = [{id: '3', name: '不讨论'}, {id: '4', name: '退回补充'},
            {id: '6', name: '已讨论'}, {id: '7', name: '会签'}, {id: '8', name: '封存'}];

        $scope.topic = {
            stage: $scope.stages[0]
        };

        $scope.ok = function (topic) {
            // if ((topic.remark == null || topic.remark == "") && (topic.stage.id == 3 || topic.stage.id == 4)) {
            //     toaster.warning('备注不能为空!');
            // } else {
                var params = {};
                params['remark'] = topic.remark;
                params['stage'] = topic.stage.id;
                params['opt'] = C.OPT.MEETING_TOPIC.EDIT.HANDLE;
                $uibModalInstance.close(params);
            // }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('TopicPrintDlgCtrl',
    function ($scope, $uibModalInstance, $templateRequest, $filter, $timeout, toaster, data, $sce, F, C,
              TopicDiscussionList, Sms) {
        function arrayUnique(array) {
            var a = array.concat();
            for (var i = 0; i < a.length; ++i) {
                for (var j = i + 1; j < a.length; ++j) {
                    if (a[i].id === a[j].id)
                        a.splice(j--, 1);
                }
            }

            return a;
        }

        $scope.topic = {
            type: '1',
            selected: null
        };
        $scope.today = new Date();

        $scope.$watch('topic.type',
            function () {
                $scope.reload();
            });

        function init(type) {
            $scope.topics = F.getItems(type, data.topics, 'type');
            var observers = [],
                topic_observers = [];
            angular.forEach($scope.topics, function (topic) {
                observers = arrayUnique(topic.observers.concat(topic.rapporteurs));
                angular.forEach(observers, function (o) {
                    topic_observers.push({
                        id: o.id,
                        name: o.name,
                        username: o.username
                    });
                });
            });
            var inital_observers = [{id: '71', name: '曾以萍', username: '0198'},
                    {id: '53', name: '邬云红', username: '0076'},
                    {id: '5', name: '吴小东', username: '0827'}],

                list_observers = arrayUnique(topic_observers.concat(inital_observers));

            $scope.topic['date'] = $scope.today;
            $scope.topic['time'] = new Date();
            if (type == 1) {
                $scope.topic['moderator'] = {id: '989', name: '刘辉'};

                $scope.topic['attendees'] = [
                    {id: '328', name: '李国平', username: '1056'},
                    {id: '27', name: '孙亚川', username: '0095'}
                ];
            } else {
                $scope.topic['moderator'] = {id: '328', name: '李国平'};
                $scope.topic['attendees'] = [
                    {id: '989', name: '刘辉', username: '1235'},
                    {id: '27', name: '孙亚川', username: '0095'}
                ];
            }

            angular.forEach($scope.topic['attendees'], function (a) {
                var index1 = F.indexOfKey(a.id, list_observers);
                if (index1 >= 0) {
                    list_observers.splice(index1, 1);
                }
            });

            var index2 = F.indexOfKey($scope.topic['moderator'].id, list_observers);
            if (index2 >= 0) {
                list_observers.splice(index2, 1);
            }

            $scope.topic['observers'] = list_observers;
        }

        $scope.reload = function () {
            init($scope.topic.type);
        };

        $scope.swap = function (arr, indexA, indexB) {
            var temp = arr[indexA];
            arr[indexA] = arr[indexB];
            arr[indexB] = temp;
        };

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/topic.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.print = function () {

            var date = $filter('date')($scope.topic.date, 'yyyy-MM-dd'),
                time = $filter('date')($scope.topic.time, 'HH:mm:ss'),
                discussion_time = date + ' ' + time,
                moderator = $scope.topic.moderator.name,
                attendees = [],
                observers = [];

            angular.forEach($scope.topic.attendees, function (attendee) {
                attendees.push(attendee.name);
            });
            var index3 = F.indexOf(moderator, attendees);
            if (index3 >= 0) {
                attendees.splice(index3, 1);
            }

            angular.forEach($scope.topic.observers, function (observer) {
                observers.push(observer.name);
            });
            var index4 = F.indexOf(moderator, observers);
            if (index4 >= 0) {
                observers.splice(index4, 1);
            }
            angular.forEach(attendees, function (a) {
                var index5 = F.indexOf(a, observers);
                if (index5 >= 0) {
                    observers.splice(index5, 1);
                }
            });

            var w = window.open("", "打印预览");

            var html = '<html><body>';
            html += '<h2 class="center">待讨论议题(' + ($scope.topic.type == '1' ? '党委会' : '办公会') + ')</h2>';
            html += '<p>主持人：' + moderator + '</p>';
            html += '<p>参会人：' + attendees.join('、') + '</p>';
            html += '<p>列席人：' + observers.join('、') + '</p>';
            html += '<p>讨论时间：' + discussion_time.substr(0, 16) + '</p>';
            html += '<h4>议题列表：</h4><ol>';
            angular.forEach($scope.topics, function (t) {
                html += '<li><topic>' + t.subject + '</topic><name>发起人：' + t.sender + '</name></li>';
            });
            html += '</ol></body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);

            var params = {};
            params['time'] = discussion_time;
            params['moderator_id'] = $scope.topic.moderator.id;
            params['topicIds'] = [];
            angular.forEach($scope.topics, function (topic) {
                params['topicIds'].push(topic.id);
            });
            params['attendees'] = [];
            angular.forEach($scope.topic.attendees, function (attendee) {
                params['attendees'].push(attendee.id);
            });
            var index6 = F.indexOf(params['moderator_id'], params['attendees']);
            if (index6 >= 0) {
                params['attendees'].splice(index6, 1);
            }
            params['observers'] = [];
            angular.forEach($scope.topic.observers, function (observer) {
                params['observers'].push(observer.id);
            });
            var index7 = F.indexOf(params['moderator_id'], params['observers']);
            if (index7 >= 0) {
                params['observers'].splice(index7, 1);
            }
            angular.forEach(params['attendees'], function (a) {
                var index8 = F.indexOf(a, params['observers']);
                if (index8 >= 0) {
                    params['observers'].splice(index8, 1);
                }
            });

            //var recipients = params['observers'].concat(params['attendees']);
            //recipients.push($scope.topic.moderator.id);
            //
            //
            //function sendSms(content, recipients) {
            //    var pa = {};
            //    pa['sign'] = '【西藏自治区人民政府驻成都办事处医院】';
            //    pa['content'] = content;
            //    pa['recipients'] = recipients;
            //    Sms.send(pa, function () {
            //        toaster.success('短信请求成功!');
            //    }, function () {
            //        toaster.error('短信请求失败!');
            //    });
            //}
            //
            //var content = '请于' + discussion_time.substr(0, 16);
            //content += '参加' + ($scope.topic.type == '1' ? '党委会' : '办公会') + '!('
            //    + data.account.name + data.account.phone + ')';
            //sendSms(content, recipients);

            TopicDiscussionList.save(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('TopicShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, data,
              MeetingTopic, FileHelper, PrintHelper, Auth) {
        $scope.ForEdit = data.ForEdit;
        $scope.ForHandle = data.ForHandle;
        $scope.ForUserToEdit = data.ForUserToEdit;
        $scope.ForBackToAdd = data.ForBackToAdd;
        $scope.ForSealUp = data.ForSealUp;
        $scope.account = Auth.getAccount();

        var topic_types = F.get('topic_types');
        var stages = F.get('approval_stages4');

        init(data);

        function init(data) {
            console.log('ForUserToEdit', data);

            if (data.id === 0) {
                var preview = data.preview;
                $scope.topic = {
                    preview: true,
                    subject: preview.subject,
                    type: topic_types[0],
                    applicant: $scope.account,
                    created_at: new Date()
                }
                $scope.topicContent = $sce.trustAsHtml(preview.body);

            } else {
                MeetingTopic.get({id: data.id}).$promise.then(function (resp) {
                    var topic = resp.topic;
                    topic.type = F.getItem(topic.type, topic_types);
                    topic.stage = F.getItem(topic.stage, stages);
                    angular.forEach(topic.attachments, function (attachment) {
                        attachment.ico = F.getIconFromMime(attachment.mime);
                        attachment.size = parseInt(attachment.size);
                    });
                    $scope.topicContent = $sce.trustAsHtml(topic.body);
                    $scope.topic = topic;
                }, function () {
                    toaster.pop({
                        type: 'warning', title: '议题不存在', body: '该议题可能已被删除!', onHideCallback: function () {
                            $uibModalInstance.dismiss('cancel');
                        }
                    });
                });
            }
        }

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.TOPIC_DOWNLOAD, attachment);
        };

        //修改
        $scope.edit = function (topic) {
            dialogs.create('templates/meeting_topic/edit_dlg.html', 'TopicEditDlgCtrl', {
                    id: topic.id, ForEdit: data.ForEdit
                },
                {size: 'lg'}).result.then(function (params) {
                MeetingTopic.update({id: topic.id}, params).$promise.then(
                    function () {
                        toaster.success('议题修改成功');
                        $rootScope.$broadcast('topicEdit');
                        $uibModalInstance.dismiss('cancel');
                    }, function () {
                        toaster.error('议题修改失败了!');
                    }
                );
            });
        };

        //修改汇报人、列席人
        $scope.edit2 = function (topic) {
            dialogs.create('templates/meeting_topic/edit_dlg2.html', 'TopicEditDlgCtrl', {
                    id: topic.id, ForEdit: data.ForEdit
                },
                {size: 'lg'}).result.then(function (params) {
                MeetingTopic.update({id: topic.id}, params).$promise.then(
                    function () {
                        toaster.success('议题修改成功');
                        $rootScope.$broadcast('topicEdit');
                        $uibModalInstance.dismiss('cancel');
                    }, function () {
                        toaster.error('议题修改失败了!');
                    }
                );
            });
        };

        //处理
        $scope.handle = function (topic) {
            dialogs.create('templates/meeting_topic/handle_dlg.html', 'TopicHandleDlgCtrl', {id: topic.id},
                {size: 'md'}).result.then(function (params) {
                MeetingTopic.update({id: topic.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('议题处理成功');
                                $rootScope.$broadcast('topicHandle');
                                $uibModalInstance.dismiss('cancel');
                                break;
                            case 1:
                                toaster.warning('该议题已处理,请刷新再次查看');
                                break;
                        }
                    }, function () {
                        toaster.error('议题处理失败了!');
                    }
                );
            });
        };

        //封存
        $scope.sealup = function (topic) {
            dialogs.confirm('封存议题', '确定要封存<strong>' + topic.subject + '</strong>吗?')
                .result.then(function () {
                var params = {};
                params['opt'] = C.OPT.MEETING_TOPIC.EDIT.SEAL_UP;
                MeetingTopic.update({id: topic.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('议题封存成功');
                                $rootScope.$broadcast('topicHandle');
                                $uibModalInstance.dismiss('cancel');
                                break;
                            case 2:
                                toaster.warning('该议题已封存,请刷新再次查看');
                                break;
                        }
                    }, function () {
                        toaster.error('议题封存失败了!');
                    }
                );
            });
        };

        //重新编辑
        $scope.edit1 = function (topic) {
            var params = {opt: 1, topic: topic};
            $uibModalInstance.close(params);
        };

        //打印
        $scope.print = function (topic) {
            PrintHelper.print(window.open('', '打印预览'), '/templates/print/table2.html', function () {
                var html = '<table><tbody><tr><td width="60">标题</td>';
                html += '<td colspan="5">' + topic.subject + '</td>';
                html += '</tr>';
                html += '<tr><td width="60">申请人</td>';
                html += '<td width="120">' + topic.applicant.name + '</td>';
                html += '<td width="75">申请时间</td>';
                html += '<td width="135">' + topic.created_at.substr(0, 10) + '</td>';
                html += '<td width="75">申请科室</td>';
                html += '<td>' + topic.dept.name + '</td>';
                html += '</tr>';

                html += '<tr><td width="60">类型</td>';
                html += '<td width="120">' + topic.type.name + '</td>';
                html += '<td width="75">汇报人</td>';
                var rapporteurs = [];
                angular.forEach(topic.rapporteurs, function (r) {
                    rapporteurs.push(r.name)
                });
                html += '<td width="135">' + rapporteurs.join('，') + '</td>';
                html += '<td width="75">列席人</td>';
                var observers = [];
                angular.forEach(topic.observers, function (o) {
                    observers.push(o.name)
                });
                html += '<td>' + observers.join('，') + '</td>';
                html += '</tr>';
                html += '<tr><td width="60">是否公开</td>';
                html += '<td width="120">' + (topic.is_public == '1' ? '是' : '否') + '</td>';
                html += '<td width="75">是否加急</td>';
                html += '<td width="135">' + (topic.is_urgent == '1' ? '是' : '否') + '</td>';
                html += '<td width="75">是否三重一大</td>';
                html += '<td>' + (topic.is_triple == '1' ? '是' : '否') + '</td>';
                html += '</tr>';

                //如果为专题会则打印主持人和记录人
                if (topic.type.id == 4) {
                    html += '<tr><td width="60">主持人</td>';
                    var hosts = [];
                    angular.forEach(topic.hosts, function (h) {
                        hosts.push(h.name)
                    });
                    html += '<td width="195">' + hosts.join('，') + '</td>';
                    html += '<td width="210">记录人</td>';

                    var recorders = [];
                    angular.forEach(topic.recorders, function (r) {
                        recorders.push(r.name)
                    });
                    html += '<td>' + recorders.join('，') + '</td>';
                    html += '</tr>';
                }

                html += '<tr><td width="60">备注</td>';
                html += '<td colspan="5">' + (topic.remark ? topic.remark : '暂无') + '</td>';
                html += '<tr><td width="60">附件</td>';
                html += '<td colspan="5">';
                if (topic.attachments && topic.attachments.length > 0) {
                    angular.forEach(topic.attachments, function (attachment) {
                        html += attachment.name + '<br/>';
                    });
                } else {
                    html += '无';
                }

                html += '</td></tr>';

                html += '<tr height="200"><td width="60">内容</td>';
                html += '<td colspan="5">' + topic.body + '</td></tr>';

                html += '<tr><td colspan="6">';
                html += '申请人：' + topic.applicant.name + ' ';
                if (topic.applicant.signature) {
                    html += '<img height="50" width="160" src="' + topic.applicant.signature.sign + '"/> ';
                }
                html += topic.created_at.substr(0, 10);
                html += '<br/>';
                if (topic.dept_leader) {
                    html += '科室责任人：' + topic.dept_leader.name + ' ';
                    if (topic.dept_leader.signature) {
                        html += '<img height="50" width="160" src="' + topic.dept_leader.signature.sign + '"/> ';
                    }
                    html += topic.dept_approval_time.substr(0, 10);
                    html += '<br/>';
                }
                if (topic.office_leader) {
                    var title = '院办审核人：';
                    if (topic.type.id == '1') {
                        title = '党办审核人：';
                    }
                    html += title + topic.office_leader.name + ' ';
                    if (topic.office_leader.signature) {
                        html += '<img height="50" width="160" src="' + topic.office_leader.signature.sign + '"/> ';
                    }
                    html += topic.office_approval_time.substr(0, 10);
                    html += '<br/>';
                }
                if (topic.hospital_leader) {
                    html += '分管院领导：' + topic.hospital_leader.name + ' ';
                    if (topic.hospital_leader.signature) {
                        html += '<img height="50" width="160" src="' + topic.hospital_leader.signature.sign + '"/> ';
                    }
                    html += topic.hospital_approval_time.substr(0, 10);
                    html += '<br/>';
                }
                if (topic.main_leader) {
                    html += '主管院领导：' + topic.main_leader.name + ' ';
                    if (topic.main_leader.signature) {
                        html += '<img height="50" width="160" src="' + topic.main_leader.signature.sign + '"/> ';
                    }
                    html += topic.main_leader_time.substr(0, 10);
                    html += '<br/>';
                }
                html += '</td></tr>';

                html += '</tbody></table>';


                return html;
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // $scope.upAttachment = function (m) {
        //     Dlg.show({
        //         template: 'templates/meeting_topic/attachmentDlg.html',
        //         ctrl: 'FileAttachmentDlgCtrl',
        //         data: {
        //             id: m.id
        //         }
        //     });
        // };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('TopicSortDlgCtrl', TopicSortDlgCtrl);

    function TopicSortDlgCtrl($scope, $rootScope, $filter, dialogs, toaster, NgTableParams, F, C,
                              MeetingTopic, $uibModalInstance, $timeout, ArrayHelper, $q, Dlg,data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        vm.dragStartCallback = dragStartCallback;
        vm.moveCallback = moveCallback;
        // vm.ok = ok;

        init(data);


        function init(data) {
            var url = [];
            url['opt'] = data.opt; //不讨论议题25
            url['type'] = data.type; //1党委会，2办公会，3股东会
            MeetingTopic.query(url, function (resp) {
                vm.topicsList = resp.topics;
            });
        }

        // function ok(){
        //     $uibModalInstance.dismiss('cancel');
        // }

        function dragStartCallback() {
            vm.originList = angular.copy(vm.topicsList);
        }

        function moveCallback(srcIdx, queue) {
            var defer = $q.defer();
            var list =  vm.topicsList;
            var origin = vm.originList;
            list.splice(srcIdx, 1);

            $timeout(function () {
                if (origin.length === list.length) {
                    __moveFromQueueingToQueueing(srcIdx, queue, defer, origin);
                }

            });
            return defer.promise;
        }

        function __moveFromQueueingToQueueing(srcIdx, queue, defer, origin) {
            $timeout(function () {
                var topics = vm.topicsList;
                var dstIdx = ArrayHelper.indexOfKey(queue.id, topics);
                if ((srcIdx !== dstIdx && srcIdx - 1 !== dstIdx)) {
                    var prevId = srcIdx > dstIdx ? (dstIdx > 0 ? origin[dstIdx - 1].id : null)
                        : origin[dstIdx].id;
                    var params = {};
                    params['prevId'] = prevId;
                    params['opt'] = C.OPT.MEETING_TOPIC.EDIT.ORDER;//调整议题顺序8
                    params['type'] = data.type; //1党委会，2办公会，3股东会
                    __changeOrder(queue, defer, params);
                }
            });
        }

        function __changeOrder(queue, defer, pa) {
            MeetingTopic.update({id: queue.id}, pa).$promise.then(function () {
                toaster.success('顺序修改成功!');
            }, function () {
                toaster.error('顺序修改失败!');
            });
            defer.resolve();
        }
    }

})();
angular.module('c.c').controller('MissionShowDetailDlgCtrl',
    function ($rootScope, $uibModalInstance, $sce, Dlg, Table, MissionReport, $q,
              Auth, C, data, Mission, MissionNew, $state, FileHelper, UIHelper, ArrayHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.user = Auth.getAccount();

        vm.ForSubmit = data.ForSubmit;
        vm.ForHistory = data.ForHistory;
        vm.ForState = data.ForState;
        vm.showMsg = true;

        vm.download = download;
        vm.submit = submit;
        vm.finish = finish;
        vm.state = state;
        vm.history = history;
        vm.init = init;
        vm.sms = sms;
        vm.complete = complete;
        vm.suspension = suspension;
        vm.editPublishJob = editPublishJob;
        vm.editExpectWhs = editExpectWhs;
        vm.changeFollow = changeFollow;


        init(data.id);

        function init(id) {
            loadItem(id, function () {
                Mission.loadAssistFunction(vm);
            });
        }

        function loadItem(id, cb) {
            $q.all([
                Mission.get({id: id, load_mission_users: 1}).$promise,
                MissionReport.query({opt: 1, mission_id: id}).$promise
            ]).then(function (respArray) {
                vm.missionUsers = respArray[0].users;
                vm.reports = respArray[1].reports;

                var m = respArray[0].mission;
                var mission_new = respArray[0].mission_new;
                if (mission_new && mission_new.new == '1') {
                    MissionNew.update({id: mission_new.id}, {new: '0'});
                    $rootScope.$broadcast('missionRead');
                }

                angular.forEach(m.attachments, function (attachment) {
                    attachment.ico = UIHelper.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });

                vm.missionContent = $sce.trustAsHtml(m.content);
                m.state = ArrayHelper.getItem(m.state, ArrayHelper.get('handle_states'));
                m.time_range = m.start_time.substr(0, 16) + ' - ' + m.end_time.substr(0, 16);
                vm.m = m;
                $rootScope.$broadcast('missionReading');

                if (cb) cb();
            });
        }

        function download(attachment) {
            FileHelper.download1(C.URL.MISSION_DOWNLOAD, attachment);
        }

        function submit(m) {
            Mission.callSubmitDlg(vm, m);
        }

        function finish(m) {
            Mission.update({id: m.id}, {
                opt: 14
            }).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }

        function state(m) {
            Mission.callStateChangeDlg(vm, m, function () {
                $uibModalInstance.close();
            });
        }

        function history(m) {
            MissionReport.query({opt: 1, mission_id: m.id, orderBy: 'desc'}, function (resp) {
                vm.historys = resp.reports;
            });
        }

        function sms(m) {
            var participant = m.coworkers;
            participant.unshift(m.publish);
            if (m.publish.id != m.applicant.id)
                participant.unshift(m.applicant);
            $state.go('app.coop_sms', {
                data: {
                    tab: 'send',
                    event: 'missionSms',
                    mail: participant
                }
            });
        }

        function complete(m) {
            var params = {opt: 4, state_id: Mission.STATE_COMPLETE};
            __updateMission(m, params, function () {
                $uibModalInstance.close();
            });
        }

        function suspension(m) {
            var params = {opt: 4, state_id: Mission.STATE_SUSPENSION};
            __updateMission(m, params, function () {
                $uibModalInstance.close();
            });
        }

        function __updateMission(m, params, cb) {
            Mission.update({id: m.id}, params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0 :
                        Dlg.s('任务状态修改成功');
                        $rootScope.$broadcast('missionStateChange');
                        init(m.id);
                        break;
                    case 1 :
                        Dlg.e('任务已到期,请为任务延期');
                        break;
                }
                if (cb) cb();
            }, function () {
                Dlg.e('任务状态修改出错');
            });
        }

        function editPublishJob(user, m) {
            Dlg.show({
                template: 'templates/mission/editPublishJobDlg.html',
                ctrl: 'MissionEditPublishJobDlgCtrl',
                data: {
                    m: m,
                    user: user
                },
                size: 'md'
            }).then(function (resp) {
                loadItem(m.id);
            });
        }

        function editExpectWhs(m) {
            Dlg.show({
                template: 'templates/mission/editExpectWhsDlg.html',
                ctrl: 'MissionEditExpectWhsDlgCtrl',
                data: {
                    m: m
                },
                size: 'md'
            }).then(function (resp) {
                loadItem(m.id);
            });
        }

        function changeFollow(m, isFollow) {
            Mission.update({
                id: m.id,
                opt: 17/*INDEX_EDIT_CHANGE_FOLLOW*/
            }, {is_follow: isFollow ? 1 : 0}).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0 :
                        Dlg.s(resp.msg);
                        loadItem(m.id);
                        $rootScope.$broadcast('missionStateChange');
                        break;
                    case 1 :
                        Dlg.e(resp.msg);
                        break;
                }
            }, function () {
                Dlg.e('服务器错误');
            });
        }
    });

angular.module('c.c').controller('MissionEditExpectWhsDlgCtrl',
    function ($rootScope, $uibModalInstance, $sce, Dlg, Table, MissionReport, $q,
              Auth, C, data, FormHelper, Mission, RegularMission) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.m, data.isRegular);

        function init(m, isRegular) {
            vm.m = {
                mission_id: m.id,
                name: m.name,
                expect_whs: m.expect_whs,
                isRegular: angular.isDefined(isRegular) ? isRegular : false
            };
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    opt: 16/*INDEX_EDIT_EXPECT_WHS*/,
                    expect_whs: m.expect_whs
                };

                if (m.isRegular) {
                    RegularMission.update({id: m.mission_id}, pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                } else {
                    Mission.update({id: m.mission_id}, pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }
            });
        }
    });
angular.module('c.c').controller('MissionEditPublishJobDlgCtrl',
    function ($rootScope, $uibModalInstance, $sce, Dlg, Table, MissionReport, $q,
              Auth, C, data, FormHelper, Mission, RegularMission) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        console.log(data);
        init(data.m, data.user, data.isRegular);

        function init(m, user, isRegular) {
            vm.m = {
                mission_id: m.id,
                user: user,
                expect_whs: user.expect_whs,
                job: user.job,
                isRegular: angular.isDefined(isRegular) ? isRegular : false
            };
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    opt: 15/*INDEX_EDIT_PUBLISH_JOB*/,
                    user_id: m.user.id,
                    expect_whs: m.expect_whs,
                    job: m.job
                };

                if (m.isRegular) {
                    RegularMission.update({id: m.mission_id}, pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                } else {
                    Mission.update({id: m.mission_id}, pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }
            });
        }
    });
angular.module('c.c').controller('MissionHistoryDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, Table,
              data, MissionReport, FileHelper) {

        $scope.publish_id = data.publish_id;
        $scope.applicant_id = data.applicant_id;

        var options = {
            service: MissionReport,
            params: {opt: 1, mission_id: data.id, mission_publish_id: data.publish_id},
            optColWidth: 53,
            items: 'reports',
            hideFilter: true,
            hideOpt: true,
            cols: [
                {title: '提交人'},
                {title: '提交时间', sortable: 'created_at', filter: {created_at: 'select'}, field: 'created_at'},
                {title: '查看', width: '10%'}
            ]
        };

        Table.loadNgTable($scope, options, function (resp) {
            angular.forEach(resp.reports, function (report) {
                if (report.publisher_id == resp.userId ||
                    $scope.publish_id == resp.userId ||
                    $scope.applicant_id == resp.userid) {
                    report.forDelete = true;
                    report.showDetail = true;
                }
                angular.forEach(report.attachments, function (attachment) {
                    attachment.ico = F.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
            });
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.delete_report = function (report) {
            dialogs.confirm('删除提交内容', '确定要删除提交吗?')
                .result.then(function () {
                MissionReport.delete({id: report.id}).$promise.then(function () {
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                })
            })
        };
        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.MISSION_REPORT_DOWNLOAD, attachment);
        };
    });
angular.module('c.c').controller('RegularMissionEditDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F,
              data, RegularMission, Sms) {
        var vm = $scope;
        vm.cancel = cancel;
        vm.submit = submit;

        init();
        function init() {
            RegularMission.get({id: data.id}, function (resp) {
                var mission = resp.item;
                mission.publishers = [];
                mission.coworkers = [];
                angular.forEach(mission.participants, function (participant) {
                    if (participant.is_publish == 1) {
                        mission.publishers.push(participant.user);
                    } else {
                        mission.coworkers.push(participant.user);
                    }
                });
                mission.source = F.getItem(mission.source, F.get('mission_sources'));
                mission.start_time = parseInt(mission.start_time);
                if (mission.is_month_end == 1) {
                    mission.end_time = 28;
                } else {
                    mission.end_time = parseInt(mission.end_time);
                }
                console.log(resp.item);
                vm.mission = resp.item;
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        //提交操作
        function submit(mission) {
            if (mission.is_delay) {
                params = {opt: 5, mission: mission};
            } else if (mission.is_manage) {
                params = {opt: 12};
                params['publish_id'] = mission.publish.id;
                params['coworkers'] = [];
                angular.forEach(mission.coworkers, function (coworker) {
                    params['coworkers'].push(coworker.id);
                });
                var index = F.indexOf(mission.publish.id, params['coworkers']);
                if (index >= 0) {
                    params['coworkers'].splice(index, 1);
                }
            } else {
                params = {opt: 4, mission: mission};
            }
            $uibModalInstance.close(params);
        }
    });
angular.module('c.c').controller('RegularManageDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $templateRequest, $timeout, dialogs, toaster, C, F, Table,
              Mission, SaveAs, data, MissionReport) {
        var vm = $scope;
        vm.show = show;
        vm.submit = submit;
        vm.edit = edit;
        vm.cancel = cancel;
        var states = F.getNgTableOpts(F.get('handle_states'));

        init();


        function init() {
            var options = {
                service: Mission,
                showSn: true,
                params: {opt: 13/*MISSION.INDEX_MISSION_REGULAR*/, regular_mission_id: data.regular_mission_id},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "state", title: '状态', filter: {state: 'select'}, data: states},
                    {field: "name", title: '名称', filter: {name: 'text'}},
                    {field: "time", title: '任务时间', width: '25%'},
                    {field: "publish", title: '负责人', filter: {publish: 'text'}},
                    {
                        field: "created_at",
                        title: '申请时间',
                        sortable: 'created_at',
                        width: '12%',
                        filter: {created_at: 'date_range'}
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.created_at = item.created_at.substr(0, 10);
                    item.time = item.start_time.substr(0, 10) + '~' + item.end_time.substr(0, 10);
                    item.state = F.getItem(item.state, F.get('handle_states'));
                });
            });
        }

        function show(mission) {
            dialogs.create('templates/mission/missionShowDlg.html', 'MissionShowDetailDlgCtrl', {
                    id: mission.id,
                    ForSubmit: true,
                    ForHistory: true
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        vm.submit(mission);
                        break;
                }
            });
        }

        function submit(mission) {
            Mission.callSubmitDlg(vm, mission);
        }

        function edit(mission) {
            Mission.callStateChangeDlg($scope, mission, function () {
                $scope.tableParams.reload();
            });
        }

        function cancel() {
            $uibModalInstance.close();
        }
    });
angular.module('c.c').controller('RegularMissionShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster,
              SaveAs, C, F, data, RegularMission, $state, FileHelper, ArrayHelper, UIHelper, Auth, Dlg) {

        var vm = $scope;
        vm.cancel = cancel;
        vm.download = download;
        vm.editPublishJob = editPublishJob;
        vm.editExpectWhs = editExpectWhs;
        vm.canEdit = canEdit;
        vm.changeRegularType = RegularMission.changeRegularType;
        var user = Auth.getAccount();
        vm.loadTimeCount = 2;

        var missionSources = ArrayHelper.get('mission_sources');
        var regularTypes = RegularMission.getRegularTypes();

        init(data.id);

        function init(id) {
            RegularMission.get({id: id}).$promise.then(function (resp) {
                var mission = resp.item;
                angular.forEach(mission.attachments, function (attachment) {
                    attachment.ico = UIHelper.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
                $scope.missionContent = $sce.trustAsHtml(mission.content);
                mission.source = ArrayHelper.getItem(mission.source, missionSources);


                mission.time_range = mission.start.substr(0, 16) + ' ~ ' + mission.end.substr(0, 16);
                mission.publishers = [];
                mission.coworkers = [];
                angular.forEach(mission.participants, function (participant) {
                    participant.name = participant.user.name;
                    participant.id = participant.user.id;
                    if (participant.is_publish == 1) {
                        mission.publishers.push(participant.user);
                    } else {
                        mission.coworkers.push(participant.user);
                    }
                });
                mission.regularTypeName = ArrayHelper.getItem(mission.regular_type, regularTypes);

                vm.changeRegularType(mission, vm.loadTimeCount);
                console.log(mission);
                vm.mission = mission;
            }, function () {
                toaster.pop({
                    type: 'warning', title: '任务不存在', body: '该任务可能已被删除!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            });
        }

        function download(attachment) {
            FileHelper.download1(C.URL.REGULAR_MISSION_DOWNLOAD, attachment);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function editPublishJob(user, m) {
            Dlg.show({
                template: 'templates/mission/editPublishJobDlg.html',
                ctrl: 'MissionEditPublishJobDlgCtrl',
                data: {
                    m: m,
                    user: user,
                    isRegular: true
                },
                size: 'md'
            }).then(function (resp) {
                init(m.id);
            });
        }

        function editExpectWhs(m) {
            Dlg.show({
                template: 'templates/mission/editExpectWhsDlg.html',
                ctrl: 'MissionEditExpectWhsDlgCtrl',
                data: {
                    m: m,
                    isRegular: true
                },
                size: 'md'
            }).then(function (resp) {
                init(m.id);
            });
        }

        function canEdit(m) {
            if (angular.isUndefined(m)) return false;
            return m.applicant_id == user.id;
        }
    });
angular.module('c.c').controller('MissionShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs,
              Auth, C, F, data, Mission, MissionNew, $state, FileHelper) {
        $scope.user = Auth.getAccount();
        $scope.ForSubmit = data.ForSubmit;
        $scope.ForHistory = data.ForHistory;
        $scope.ForState = data.ForState;
        Mission.get({id: data.id}).$promise.then(function (resp) {
                var mission = resp.mission;
                var mission_new = resp.mission_new;
                if (mission_new && mission_new.new == '1') {
                    MissionNew.update({id: mission_new.id}, {'new': '0'});
                    $rootScope.$broadcast('missionRead');
                }
                if (mission.is_read == '1') {
                    Mission.update({id: mission.id}, {'is_read': '0'});
                    $rootScope.$broadcast('missionRead');
                }

                $scope.isCoworkers = false;
                for (var i = 0; i < mission.coworkers.length; i++) {
                    if (mission.coworkers[i].id == $scope.user.id) {
                        $scope.isCoworkers = true;
                        break;
                    }
                }

                angular.forEach(mission.attachments, function (attachment) {
                    attachment.ico = F.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
                $scope.missionContent = $sce.trustAsHtml(mission.content);
                mission.state = F.getItem(mission.state, F.get('handle_states'));
                mission.source = F.getItem(mission.source, F.get('mission_sources'));
                mission.time_range = mission.start_time.substr(0, 16) + ' - ' + mission.end_time.substr(0, 16);
                $scope.mission = mission;
                $rootScope.$broadcast('MissionRead');
            },
            function () {
                toaster.pop({
                    type: 'warning', title: '任务不存在', body: '该任务可能已被删除!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            }
        )
        ;

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.MISSION_DOWNLOAD, attachment);
        };


//提交操作
        $scope.submit = function (mission) {
            var params = {opt: 4, mission: mission};
            $uibModalInstance.close(params);
        };

        $scope.finish = function (mission) {
            Mission.update({id: mission.id}, {
                opt: 14
            }).$promise.then(function (resp) {
                toaster.success('任务状态修改成功，任务结束提醒');
            }, function () {
                toaster.error('任务状态修改出错');
            });
        };

        $scope.state = function (mission) {
            Mission.callStateChangeDlg($scope, mission, function () {
            });
        };

        $scope.history = function (mission) {
            dialogs.create('templates/mission/history_dlg.html', 'MissionHistoryDlgCtrl', {
                    id: mission.id,
                    publish_id: mission.publish.id,
                    applicant_id: mission.applicant.id
                },
                {size: 'lg'});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.sms = function (mission) {
            participant = mission.coworkers;
            participant.unshift(mission.publish);
            if (mission.publish.id != mission.applicant.id)
                participant.unshift(mission.applicant);
            $state.go('app.coop_sms', {
                data: {
                    tab: 'send',
                    event: 'missionSms',
                    mail: participant
                }
            });
        };
    })
;
angular.module('c.c').controller('MissionStateDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, data, Mission, Dlg) {
        var params;
        $scope.forApplicant = data.forApplicant;

        $scope.reset = function () {
            $scope.states = F.get('handle_states');
            $scope.state_id = data.stateId;
            $scope.mission_types = data.types;

            //默认为修改信息
            $scope.change = 1;
            //任务能进行的状态转换
            var params = [];
            if ($scope.state_id == 1) {
                params = [2, 4];
            } else if ($scope.state_id == 2) {
                params = [3, 4];
            } else if ($scope.state_id == 4) {
                params = [2, 3];
            }
            var states = [];
            angular.forEach(params, function (item) {
                states.push($scope.states[item - 1]);
            });
            $scope.mission_states = states;
            $scope.mission = {
                type: data.type,
                urgent: data.urgent,
                is_delay: false,
                delay: 0
            };
            getPerson();
        };
        $scope.reset();

        //提交操作
        $scope.submit = function (mission) {
            switch ($scope.change) {
                case 1://修改任务状态
                    params = {opt: 4, mission: mission};
                    break;
                case 2://延期
                    params = {opt: 5, mission: mission};
                    break;
                case 3://修改协助人
                    params = {opt: 12};
                    if (mission.publish == null || mission.publish == {}) {
                        Dlg.w('负责人不能为空');
                        return;
                    }
                    params['publish_id'] = mission.publish.id;
                    params['coworkers'] = [];
                    angular.forEach(mission.coworkers, function (coworker) {
                        params['coworkers'].push(coworker.id);
                    });
                    var index = F.indexOf(mission.publish.id, params['coworkers']);
                    if (index >= 0) {
                        params['coworkers'].splice(index, 1);
                    }
                    break;
            }
            $uibModalInstance.close(params);
        };


        function getPerson() {
            Mission.get({id: data.missionId}).$promise.then(function (resp) {
                var mission = resp.mission;
                $scope.mission['publish'] = mission.publish;
                $scope.mission['coworkers'] = mission.coworkers;
            }, function () {
                toaster.pop({
                    type: 'warning', title: '任务不存在', body: '该任务可能已被删除!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            });
        }

        $scope.delete = function () {
            var params = {opt: 1};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MissionSubmitDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, FileHelper) {
        $scope.submit = function (report) {
            if (report.note == null || report.note == "") {
                toaster.warning('提交内容不能为空!');
            } else if (report.real_whs < 0) {
                toaster.warning('实际工时必须为正整数!');
            } else {
                var params = {};
                for (var i = 0; i < report.attachments.length; i++) {
                    if (report.attachments[i].filename == null) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                        return;
                    }
                }
                params['note'] = report.note;
                params['real_whs'] = report.real_whs;
                params['attachments'] = [];
                angular.forEach(report.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                $uibModalInstance.close(params);
            }
        };
        $scope.reset = function () {
            $scope.report = {
                note: '',
                real_whs: null,
                attachments: []
            };
        };
        $scope.reset();
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.deleteAttachment = function ($index, report) {
            report.attachments.splice($index, 1);
        };

        $scope.upload = function (file, mission, e) {
            FileHelper.upload(C.URL.MISSION_REPORT_UPLOAD, file, mission, e);
        };
    });
angular.module('c.c').controller('OrderImgDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, C, Upload, data) {
        var vm = $scope;
        vm.image = {progress: 0, croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(image) {
            var imageBlob = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (!imageBlob.$error) {
                Upload.upload({
                    url: C.URL.ORDER_IMG_UPLOAD, data: {file: imageBlob, store: data.store}
                }).progress(function (evt) {
                    image.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (resp) {
                    switch (resp.result) {
                        case 0:
                            image.progress = 0;
                            image.url = resp.url;
                            $uibModalInstance.close(image.url);
                            break;
                        case 1:
                            image.progress = 101;
                            image.errorInfo = '服务器空间不足!';
                            break;
                    }
                }).error(function () {
                    image.progress = 102;
                    image.errorInfo = '服务器错误!';
                });
            }
        }
    });
angular.module('c.c').controller('PracticeDeptStateCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, toaster, SaveAs, C, F, data, User) {

        var dept_id = data.dept_id;
        //提交操作
        $scope.submit = function (practice) {
            if(practice.is_confirm == false){
                toaster.warning('请确认实习生的实习情况!');
            } else if(practice.is_confirm == true && practice.teacher == null){
                toaster.warning('确认实习时,必须指定其带教老师!');
            }else{
                var params = {};
                params['is_confirm'] = practice.is_confirm? 1:0;
                params['teacher_id'] = practice.teacher.id;
                $uibModalInstance.close(params);
            }
        };

        $scope.reset =function () {
            $scope.practice = {
                is_confirm: data.is_confirm == 1,
                teacher : data.teacher
            };
            User.query({opt: 3, dept_id: dept_id}, function (resp) {
                $scope.dept_users = resp.users;
            });
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c')
    .controller('PracticeFeedback', function ($scope, $filter, data, toaster, $uibModalInstance,
                                              uibDateParser, PracticeFeedback, $templateRequest, $sce, $timeout) {

        $scope.reset = function () {
            $scope.practice_type = data.practice_type;
            if (data.opt == 1) {
                $scope.data = data;
                if (data.teacher == null) {
                    PracticeFeedback.query({opt: 1, dept_id: data.dept.id}, function (resp) {
                        $scope.teachers = resp.users;
                    });
                }
                $scope.questions = {
                    teacher_score: [],
                    dept_score: [],
                    teacher_total_score: 0,
                    dept_total_scope: 0
                };
            } else {
                PracticeFeedback.query({opt: 2, practice_id: data.practice_id}, function (resp) {
                    $scope.dept_scores = resp.dept_scores;
                    $scope.teacher_scores = resp.teacher_scores;
                    $scope.teacher_total_score = resp.teacher_total_score;
                    $scope.dept_total_score = resp.dept_total_score;
                    $scope.total_score = resp.total_score;
                    $scope.teacher_name = resp.practice_info.teacher.name;
                    $scope.dept_name = resp.practice_info.dept.name;
                    $scope.assess = resp.assess;
                });
            }
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.submit = function (questions) {
            var have_empty = true;
            console.log(questions);
            var question_number = [];
            if ($scope.practice_type == 1 || $scope.practice_type == 2) {
                question_number = [12, 7]
            } else {
                question_number = [14, 7];
            }
            if (questions.teacher_score.length == question_number[0] && questions.dept_score.length == question_number[1]) {
                for (var i = 0; i < question_number[0]; i++) {
                    if (questions.teacher_score[i] === undefined) {
                        break;
                    }
                }
                for (var j = 0; j < question_number[1]; j++) {
                    if (questions.dept_score[j] === undefined) {
                        break;
                    }
                }
                console.log(1);
                if (i == question_number[0] && j == question_number[1]) {
                    have_empty = false;
                }
            }
            if (questions.teacher_total_score == '输入错误' || questions.dept_total_scope == '输入错误') {
                toaster.warning('输入数值不对,请输入范围之内的分值');
            } else if (have_empty) {
                toaster.warning('表中有错误数值');
            } else if (questions.teacher == null && data.teacher == null) {
                toaster.warning('请填入你的带教老师');
            } else if (questions.assess == null || questions.assess == '') {
                toaster.warning('评价内容不能为空');
            } else {
                var params = {};
                params['teacher_total_score'] = questions.teacher_total_score;
                params['dept_total_scope'] = questions.dept_total_scope;

                params['dept_score'] = questions.dept_score;
                params['teacher_score'] = questions.teacher_score;

                params['assess'] = questions.assess;

                if (questions.teacher != null) {
                    params['teacher_id'] = questions.teacher.id;
                } else {
                    params['teacher_id'] = data.teacher.id;
                }

                params['opt'] = 1;
                $uibModalInstance.close(params);
            }
        };

        $scope.total = function (type, questions) {
            if (type == 0) {
                questions.teacher_total_score = 0;
                angular.forEach(questions.teacher_score, function (score) {
                    questions.teacher_total_score += score;
                });
                if (isNaN(questions.teacher_total_score)) {
                    questions.teacher_total_score = '输入错误';
                }
            } else {
                questions.dept_total_scope = 0;
                angular.forEach(questions.dept_score, function (score) {
                    questions.dept_total_scope += score;
                });
                if (isNaN(questions.dept_total_scope)) {
                    questions.dept_total_scope = '输入错误';
                }
            }
        };

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/feedback.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.print = function () {
            var w = window.open("", "打印预览");

            var html = '<html><body>';
            if ($scope.practice_type == 1 || $scope.practice_type == 2) {
                html += '<h2 class="text-center">临床、医技实习生对带教老师评价表</h3>' +
                    '<p class="text-center">' +
                    '<span>带教老师:' + $scope.teacher_name + '</span>' +
                    '</p>' +
                    '<table class="table">' +
                    '<tr>' +
                    '<td colspan="2" class="text-center table-length-1">项目</td>' +
                    '<td colspan="3" class="text-center table-length-2">考核细则</td>' +
                    '<td class="text-center table-length-3">分值</td>' +
                    '<td class="text-center table-length-3">得分</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td rowspan="12" class="text-center">带教老师评价</td>' +
                    '<td rowspan="4" class="text-center">带教作用及态度</td>' +
                    '<td colspan="3">1、有良好的医德医风</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[0] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">2、服务态度良好</td>' +
                    '<td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[1] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">3、严格要求,带教耐心,关心学生生活</td>' +
                    '<td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[2] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">4、及时耐心的解答学生提出的问题</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[3] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td rowspan="6" class="text-center">带教水平</td>' +
                    '<td colspan="3">1、讲解基本概念,基本理论准确</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[4] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">2、带教内容适合,主次分明,表达清楚</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[5] + '</td></tr><tr><td colspan="3">3、及时纠正学生不足</td>' +
                    '<td class="text-center">10</td><td class="text-center">' + $scope.teacher_scores[6] + '</td></tr><tr>' +
                    '<td colspan="3">4、启发带教,善于诱导学生的临床思维</td> <td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[7] + '</td></tr><tr><td colspan="3">5、给学生创造独立思维,动手操作的机会</td>' +
                    '<td class="text-center">10</td><td class="text-center">' + $scope.teacher_scores[8] + '</td>' +
                    '</tr><tr><td colspan="3">6、介绍新知识、新技术及新进展</td><td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[9] + '</td></tr><tr>' +
                    '<td rowspan="2" class="text-center">带教效果</td><td colspan="3">1、能独立完成基本的操作项目</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[10] + '</td></tr><tr>' +
                    '<td colspan="3">2、对带教工作的满意度</td><td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[11] + '</td> </tr> <tr>' +
                    '<td colspan="5" class="text-center">共计</td> <td class="text-center">100</td>' +
                    '<td class="text-center">' + $scope.teacher_total_score + '</td>' +
                    '</tr>' +
                    '</table>' +
                    '<br/><h2 class="text-center">临床、医技实习生对实习科室带教情况反馈</h2>' +
                    '<p class="text-center"><span>实习科室：' + $scope.dept_name + '</span></p>' +
                    '<table class="table">' +
                    '<tr>' +
                    '<td colspan="2" class="text-center table-length-1">项目</td>' +
                    '<td colspan="3" class="text-center table-length-2">考核细则</td>' +
                    '<td class="text-center table-length-3">分值</td>' +
                    '<td class="text-center table-length-3">得分</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td rowspan="7" class="text-center">科室带教管理</td>' +
                    '<td rowspan="3" class="text-center">管理方面</td>' +
                    '<td colspan="3">1、实习教学管理制度健全</td> <td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.dept_scores[0] + '</td>' +
                    '</tr> <tr> <td colspan="3">2、科室领导对实习教学的态度</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[1] + '</td>' +
                    '</tr> <tr> <td colspan="3">3、病房有专人管理实习教学</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[2] + '</td>' +
                    '</tr> <tr> <td rowspan="2" class="text-center">教学方面</td>' +
                    '<td colspan="3">1、护士的协作与教学</td> <td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[3] + '</td>' +
                    '</tr> <tr> <td colspan="3">2、所在治疗小组老师的教学态度</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[4] + '</td>' +
                    '</tr> <tr>' +
                    '<td rowspan="2" class="text-center">授课方面</td>' +
                    '<td colspan="3">1、每周小讲课情况,质量效果评估</td> <td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[5] + '</td>' +
                    '</tr> <tr> <td colspan="3">2、参与护理查房的机会</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[6] + '</td>' +
                    '</tr> <tr>' +
                    '<td colspan="5" class="text-center">共计</td>' +
                    '<td class="text-center">100</td>' +
                    '<td class="text-center">' + $scope.dept_total_score + '</td>' +
                    '</tr>' +
                    '</table>';
            } else {
                html += '<h2 class="text-center">护理实习生对带教老师评价表</h3>' +
                    '<p class="text-center">' +
                    '<span>带教老师:' + $scope.teacher_name + '</span>' +
                    '</p>' +
                    '<table class="table">' +
                    '<tr>' +
                    '<td colspan="2" class="text-center table-length-1">项目</td>' +
                    '<td colspan="3" class="text-center table-length-2">考核细则</td>' +
                    '<td class="text-center table-length-3">分值</td>' +
                    '<td class="text-center table-length-3">得分</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td rowspan="14" class="text-center">带教老师评价</td>' +
                    '<td rowspan="5" class="text-center">带教作用及态度</td>' +
                    '<td colspan="3">1、有良好的医德医风</td>' +
                    '<td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[0] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">2、服务态度良好</td>' +
                    '<td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[1] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">3、严格要求,带教耐心,关心学生生活</td>' +
                    '<td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[2] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">4、及时耐心的解答学生提出的问题</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[3] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">5、及时指导护理各项操作</td>' +
                    '<td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[4] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td rowspan="6" class="text-center">带教水平</td>' +
                    '<td colspan="3">1、讲解基本概念,基本理论准确</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[5] + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="3">2、带教内容适合,主次分明,表达清楚</td>' +
                    '<td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[6] + '</td></tr><tr><td colspan="3">3、及时纠正学生不足</td>' +
                    '<td class="text-center">10</td><td class="text-center">' + $scope.teacher_scores[7] + '</td></tr><tr>' +
                    '<td colspan="3">4、启发带教,善于诱导学生的临床思维</td> <td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[8] + '</td></tr><tr><td colspan="3">5、给学生创造独立思维,动手操作的机会</td>' +
                    '<td class="text-center">10</td><td class="text-center">' + $scope.teacher_scores[9] + '</td>' +
                    '</tr><tr><td colspan="3">6、介绍新知识、新技术及新进展</td><td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[10] + '</td></tr><tr>' +
                    '<td rowspan="3" class="text-center">带教效果</td><td colspan="3">1、能独立完成基本的操作项目</td>' +
                    '<td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[11] + '</td></tr><tr> ' +
                    '<td colspan="3">2、能基本掌握科室常见病的护理</td>' +
                    '<td class="text-center">10</td> ' +
                    '<td class="text-center">' + $scope.teacher_scores[12] + '</td></tr><tr>' +
                    '<td colspan="3">3、对带教工作的满意度</td><td class="text-center">5</td>' +
                    '<td class="text-center">' + $scope.teacher_scores[13] + '</td> </tr> <tr>' +
                    '<td colspan="5" class="text-center">共计</td> <td class="text-center">100</td>' +
                    '<td class="text-center">' + $scope.teacher_total_score + '</td>' +
                    '</tr>' +
                    '</table>' +
                    '<br/><h2 class="text-center">护理实习生对实习科室带教情况反馈</h2>' +
                    '<p class="text-center"><span>实习科室：' + $scope.dept_name + '</span></p>' +
                    '<table class="table">' +
                    '<tr>' +
                    '<td colspan="2" class="text-center table-length-1">项目</td>' +
                    '<td colspan="3" class="text-center table-length-2">考核细则</td>' +
                    '<td class="text-center table-length-3">分值</td>' +
                    '<td class="text-center table-length-3">得分</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td rowspan="7" class="text-center">科室带教管理</td>' +
                    '<td rowspan="3" class="text-center">管理方面</td>' +
                    '<td colspan="3">1、实习教学管理制度健全</td> <td class="text-center">10</td>' +
                    '<td class="text-center">' + $scope.dept_scores[0] + '</td>' +
                    '</tr> <tr> <td colspan="3">2、科室领导对实习教学的态度</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[1] + '</td>' +
                    '</tr> <tr> <td colspan="3">3、病房有专人管理实习教学</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[2] + '</td>' +
                    '</tr> <tr> <td rowspan="2" class="text-center">教学方面</td>' +
                    '<td colspan="3">1、护士的协作与教学</td> <td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[3] + '</td>' +
                    '</tr> <tr> <td colspan="3">2、所在治疗小组老师的教学态度</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[4] + '</td>' +
                    '</tr> <tr>' +
                    '<td rowspan="2" class="text-center">授课方面</td>' +
                    '<td colspan="3">1、每周小讲课情况,质量效果评估</td> <td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[5] + '</td>' +
                    '</tr> <tr> <td colspan="3">2、参与护理查房的机会</td>' +
                    '<td class="text-center">15</td>' +
                    '<td class="text-center">' + $scope.dept_scores[6] + '</td>' +
                    '</tr> <tr>' +
                    '<td colspan="5" class="text-center">共计</td>' +
                    '<td class="text-center">100</td>' +
                    '<td class="text-center">' + $scope.dept_total_score + '</td>' +
                    '</tr>' +
                    '</table>';
            }

            html += '<h3 class="text-center">总体评价</h3>' +
                '<table>' +
                '<tr><td style="padding: 10px 18px;">' + $scope.assess + '</td></tr>' +
                '</table>';

            html += '</body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        }
    });

angular.module('c.c')
    .controller('PracticeEditDlgCtrl',
        function ($scope, $uibModalInstance, $http, $filter, uibDateParser, F, dialogs, toaster,
                  User, NurseSeniority, SeniorityStandard, data) {
            $scope.practice_stage = true;
            $scope.reg_stage = true;
            $scope.password_not_req = true;
            $scope.sexes = F.get('sexes');
            $scope.edu_bgs = F.get('edu_bg_list');
            $scope.degree_types = F.get('degree_types');
            $scope.en_lvs = F.get('eg_lv_list');

            var username_regex_list = /^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[1235789])\d{8}$/; //试用实习均使用手机号注册
            $scope.username_regex = username_regex_list;

            User.get({id: data.practicer_id, info_type: 0}, function (resp) {
                var user = resp.user;
                $scope.types = resp.types;
                $scope.statuses = resp.statuses;
                $scope.standards = resp.standards;
                $scope.entry_types = resp.entry_types;
                $scope.nations = resp.nations;
                $scope.political_statuses = resp.political_statuses;
                $scope.depts = resp.depts;

                user['is_cadre'] = user['is_cadre'] == '1';
                user['sex'] = F.getItem(user['sex'], $scope.sexes);
                user['edu_bg'] = F.getItem(user['edu_bg'], $scope.edu_bgs);
                user['degree_type'] = User.getDegreeType(user['degree']);
                $scope.degrees = User.getDegrees(user['degree_type'].id);
                user['degree'] = User.getDegree(user['degree'], user['degree_type'].id);
                user['en_lv'] = F.getItem(user['en_lv'], $scope.en_lvs);

                user['birthday'] = uibDateParser.parse(user.birthday, 'yyyy-MM-dd');
                user['entry_time'] = uibDateParser.parse(user.entry_time, 'yyyy-MM-dd');
                user['started_work'] = uibDateParser.parse(user.started_work, 'yyyy-MM-dd');

                if (user['type_id'] == 2 && user['nurse_seniority']) {
                    user['standard'] = F.getItem(user['nurse_seniority'].seniority_id, $scope.standards);
                } else {
                    user['standard'] = $scope.standards[0];
                }

                if (user.depts.length > 0) {
                    user.dept = {id: user.depts[0].id, name: user.depts[0].name};
                } else {
                    user.dept = $scope.depts[0];
                }
                $scope.statusSelectedFn(user.status, user);
                $scope.user = user;
            });

            $scope.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1)
            };

            $scope.degreeTypeSelectedFn = function (type) {
                $scope.degrees = User.getDegrees(type.id);
                $scope.user['degree'] = $scope.degrees[0];
            };

            $scope.statusSelectedFn = function (status, user) {
                $scope.username_regex = username_regex_list;
            };

            $scope.deptTypeFn = function (d) {
                return d.type.name;
            };

            $scope.onTypeSelectedFn = function (type, user) {

            };

            $scope.addUserPhoto = function (user) {
                dialogs.create('templates/upload/userpic_dlg.html',
                    'UploadUserpicDlg', {user_id: user.id}, {size: 'md'}
                ).result.then(function (resp) {
                    user.photo = resp;
                });
            };

            function saveAndExit(user) {
                var pa = {};
                //账户信息
                pa['username'] = user.username;
                if (user.password && user.password.length > 0) {
                    pa['password'] = user.password;
                }

                //基本信息
                pa['name'] = user.name;
                pa['sex'] = user.sex.id;
                pa['birthday'] = $filter('date')(user.birthday, 'yyyy-MM-dd');
                pa['nation_id'] = user.nation.id;
                pa['native_place'] = user.native_place;
                pa['political_status_id'] = user.political_status.id;

                //工作相关
                pa['photo'] = user.photo;
                pa['status_id'] = user.status.id;
                pa['type_id'] = user.type.id;
                if (user.type.id == 2) {
                    pa['standard'] = user.standard.id;
                }
                //  主要科室...
                pa['is_cadre'] = user.is_cadre;
                pa['entry_type_id'] = user.entry_type.id;
                pa['entry_time'] = $filter('date')(user.entry_time, 'yyyy-MM-dd');
                pa['salary_card'] = user.salary_card;
                pa['started_work'] = $filter('date')(user.started_work, 'yyyy-MM-dd');

                //教育背景
                pa['graduate_school'] = user.graduate_school;
                pa['major'] = user.major;
                pa['edu_bg'] = user.edu_bg.id;
                pa['degree'] = user.degree.name;
                pa['en_lv'] = user.en_lv.id;
                //联系方式
                pa['phone'] = user.phone;
                pa['cornet'] = user.cornet;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                pa['office_cornet'] = user.office_cornet;
                pa['email'] = user.email;
                pa['qq'] = user.qq;
                pa['address'] = user.address;

                pa['opt'] = 1;
                User.update({id: data.practicer_id}, pa).$promise.then(function (resp) {
                    $uibModalInstance.close(pa);
                }, function (error) {
                    if (error.data.code == 23000) {
                        var m = error.data.msg;
                        if (m.indexOf('users_username_unique') > 0) {
                            msg = '用户名已被注册!';
                        } else if (m.indexOf('users_phone_unique') > 0) {
                            msg = '手机号已被注册!';
                        } else if (m.indexOf('users_email_unique') > 0) {
                            msg = '邮箱已被注册!';
                        }
                    } else {
                        msg = '员工记录修改失败!';
                    }
                    toaster.error(msg);
                });
            }

            $scope.submit = function (user) {
                if (!$scope.u_form.$valid) {
                    toaster.warning('表单中有错误!');
                    $scope.u_form.$submitted = true;
                } else if (!user.photo) {
                    dialogs.confirm('提示', '您未添加工作照头像,这将影响系统某些功能的使用,确定要保存吗?')
                        .result.then(function () {
                        saveAndExit(user);
                    });
                } else {
                    saveAndExit(user);
                }
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        });
angular.module('c.c')
    .controller('RoundDlgCtrl',function ($scope, $filter, data, toaster, $uibModalInstance,uibDateParser , Practice) {

        $scope.depts = data.depts;
        var edit_round = false;

        $scope.reset = function () {
            if(data.round){
                $scope.round = data.round;
                edit_round = true;
            }else if(data.round_id){
                Practice.get({id: data.round_id, opt : 1}).$promise.then(function (resp) {
                    $scope.round = resp.round;
                    $scope.round.entry_time =  new Date(resp.round.entry_time);
                    $scope.round.leave_time =  new Date(resp.round.leave_time);
                }, function () {
                    toaster.pop({
                        type: 'warning', title: '轮转记录不存在', body: '该轮转记录可能已被删除!', onHideCallback: function () {
                            $uibModalInstance.dismiss('cancel');
                        }
                    });
                });
                edit_round = true;
            }else{
                $scope.round = {
                    dept: $scope.depts[0],
                    entry_time: new Date(),
                    leave_time: new Date(new Date().valueOf() + 1 * 24 * 60 * 60 * 1000),   //自动加一天
                    remark: ''
                };
            }
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.submit = function (round) {
            if(round.dept == null){
                toaster.warning('请填入实习科室!');
            }else if(round.entry_time == null||round.leave_time ==null){
                toaster.warning('请填入正确的实习日期!');
            }else if(round.entry_time == round.leave_time){
                toaster.warning('开始时间不能等于结束时间!');
            }else if(round.entry_time > round.leave_time){
                toaster.warning('开始时间不能大于结束时间!');
            }else{
                var params = {};
                params['dept'] = round.dept;
                params['dept_id'] = round.dept.id;
                params['user_id'] = data.user_id;
                params['entry_time'] = $filter('date')(round.entry_time, 'yyyy-MM-dd');
                params['leave_time'] = $filter('date')(round.leave_time, 'yyyy-MM-dd');
                params['teacher'] = null;
                params['teacher_id'] = null;
                if(round.teacher != null){
                    params['teacher'] = round.teacher;
                    params['teacher_id'] = round.teacher.id;
                }
                params['remark'] = round.remark;
                if(edit_round){
                    params['id'] = round.id;
                    params['is_confirm'] = round.is_confirm;
                }
                $uibModalInstance.close(params);
            }
        };
    });
angular.module('c.c').controller('PracticeRoundDlgCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster,
              NgTableParams, F, Practice, data, $uibModalInstance) {

        $scope.depts = data.depts;
        $scope.edit=data.edit;
        $scope.rounds = [];
        var firstRounds = true;
        var change_rounds = {
            edit_rounds: [],
            del_rounds: []
        };

        function init() {
            Practice.get({id: data.user_id, opt: 0}).$promise.then(function (resp) {
                if(resp.result == 0) {
                    if(resp.rounds != null && resp.rounds.length != 0){
                        $scope.rounds = resp.rounds;
                        firstRounds = false;
                    }
                }
            },function () {
                toaster.pop({
                    type: 'warning', title: '轮转信息不存在', body: '无法找到这个人的轮转信息!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            });
        };
        init();
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.addRound = function () {
            dialogs.create('templates/practice/round_dlg.html', 'RoundDlgCtrl', {depts: $scope.depts, user_id: data.user_id}, {
                 size: 'md'
            }).result.then(function (round) {
                if(!firstRounds){
                    change_rounds.edit_rounds.push(round);
                }
                $scope.rounds.push(round);
            });
        };

        $scope.editRound = function (index) {
            dialogs.create('templates/practice/round_dlg.html', 'RoundDlgCtrl',
                {depts: $scope.depts, user_id: data.user_id, round: $scope.rounds[index]}, {
                 size: 'md'
            }).result.then(function (round) {
                if(!firstRounds){
                    change_rounds.edit_rounds.push(round);
                }
                $scope.rounds[index] = round;
            });
        };

        $scope.deleteRound = function (index) {
            var getRounds = $scope.rounds.splice(index, 1);
            if(!firstRounds && getRounds[0].id != null){
                change_rounds.del_rounds.push(getRounds[0]);
            }
        };

        $scope.ok = function () {
            var params = {};
            params.user_id = data.user_id;
            params.change_rounds = change_rounds;
            params.rounds = $scope.rounds;
            params.opt= firstRounds?0:1;
            angular.forEach($scope.rounds, function (round) {
                round.dept_id = round.dept.id;
                if(round.teacher_id != null){
                    round.teacher_id = round.teacher.id;
                }
            });
            Practice.save(params).$promise.then(function (resp) {
                toaster.success('轮转修改成功!');
                $uibModalInstance.dismiss('cancel');
            },function () {
                toaster.error('轮转修改失败了!');
            });
        };
    });

angular.module('c.c').controller('RoundDeptStateCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, toaster, SaveAs, C, F, data, User) {

        //提交操作
        $scope.submit = function (round) {
            if(round.is_confirm == false){
                toaster.warning('请确认员工的轮转!');
            }else{
                var params = {};
                params['is_confirm'] = round.is_confirm? 1:0;
                params['post'] = round.post;
                $uibModalInstance.close(params);
            }
        };

        $scope.reset =function () {
            $scope.round = {};
            $scope.round.is_confirm = data.is_confirm == 1;
            if(data.user_dept != null){
                $scope.round.post = data.user_dept.post;
            }else{
                $scope.round.post = '轮转员工';
            }
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c')
    .controller('EditRoundDlgCtrl', function ($scope, $filter, data, toaster, $uibModalInstance, dialogs, Round) {
        var change_round = false;
        var haved_rounds = null;
        var add_info = null;

        $scope.reset = function () {
            if (data.round) {
                $scope.depts = data.depts;
                add_info = data.round;
                $scope.round = {
                    id: data.round.id,
                    dept: data.round.dept,
                    entry_time: new Date(data.round.entry_time),
                    leave_time: data.round.leave_time == null ? '' : new Date(data.round.leave_time),
                    remark: data.round.remark,
                    is_main: data.round.is_main == 1,
                    is_flex: data.round.is_flex == 1
                };
                haved_rounds = data.haved_rounds.slice();
                haved_rounds.splice(data.index, 1);
                change_round = true;
            } else if (data.round_id) {
                Round.get({id: data.round_id, opt: 2, user_id: data.user_id}).$promise.then(function (resp) {
                    $scope.depts = resp.depts;
                    add_info = resp.round;
                    $scope.round = {
                        dept: resp.round.dept,
                        entry_time: new Date(resp.round.entry_time),
                        leave_time: resp.round.leave_time == null ? '' : new Date(resp.round.leave_time),
                        remark: resp.round.remark,
                        is_main: resp.round.is_main == 1,
                        is_flex: resp.round.is_flex == 1
                    };
                    haved_rounds = resp.haved_rounds;
                }, function () {
                    toaster.pop({
                        type: 'warning', title: '轮转信息不存在', body: '无法找到此条轮转信息!', onHideCallback: function () {
                            $uibModalInstance.dismiss('cancel');
                        }
                    });
                });
                change_round = true;
            } else {
                $scope.depts = data.depts;
                $scope.round = {
                    dept: $scope.depts[0],
                    entry_time: new Date(),
                    leave_time: new Date(new Date().valueOf() + 1 * 24 * 60 * 60 * 1000),   //自动加一天
                    remark: '',
                    is_main: true,
                    is_flex: false
                };
                haved_rounds = data.haved_rounds;
            }
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.submit = function (round) {
            var repeat = false, repeat_round = null;
            if (round.is_main) {
                angular.isObject(round.entry_time) ? round.entry_time.setHours(8, 0, 0, 0)
                    : round.entry_time = null;
                angular.isObject(round.leave_time) ? round.leave_time.setHours(8, 0, 0, 0)
                    : round.leave_time = null;
                if (haved_rounds != null) {
                    var round_entry = null, round_leave = null;
                    angular.forEach(haved_rounds, function (haved_round) {
                        round_entry = new Date(haved_round.entry_time);
                        if (haved_round.leave_time == null) {
                            if (round.leave_time == null || round.leave_time > round_entry) {
                                repeat = true;
                                repeat_round = haved_round;
                            }
                        } else {
                            round_leave = new Date(haved_round.leave_time);
                            if (!(round_leave <= round.entry_time || round_entry >= round.leave_time)) {
                                repeat = true;
                                repeat_round = haved_round;
                            }
                        }
                    })
                }
            }
            if (round.dept == null) {
                toaster.warning('请填入轮转科室');
            } else if (round.entry_time == round.leave_time) {
                toaster.warning('开始时间不能等于结束时间');
            } else if (round.leave_time != null && round.entry_time > round.leave_time) {
                toaster.warning('开始时间不能大于结束时间');
            } else if (repeat && repeat_round.is_main == 1) {
                toaster.warning('添加轮转与' + repeat_round.dept.name + '轮转冲突');
            } else {
                if (repeat) {
                    dialogs.confirm('轮转冲突', '要添加的轮转与<strong>' + repeat_round.dept.name + '</strong>轮转时间上冲突,是否确认添加?')
                        .result.then(function () {
                        save(round);
                    });
                } else {
                    save(round);
                }
            }
        };

        function save(round) {
            var params = {};
            params['is_confirm'] = 0;
            if (add_info != null) {
                params['user_dept_id'] = add_info.user_dept_id;
                params['is_confirm'] = add_info.is_confirm;
                params['user_dept'] = add_info.user_dept;
            }
            params['dept'] = round.dept;
            params['dept_id'] = round.dept.id;
            params['user_id'] = data.user_id;
            params['entry_time'] = $filter('date')(round.entry_time, 'yyyy-MM-dd');
            params['leave_time'] = $filter('date')(round.leave_time, 'yyyy-MM-dd');
            params['remark'] = round.remark ? round.remark : '';
            params['is_main'] = round.is_main ? 1 : 0;
            params['is_flex'] = round.is_flex ? 1 : 0;
            if (change_round) {
                params['id'] = round.id;
            }
            $uibModalInstance.close(params);
        }
    });

angular.module('c.c').controller('UserRoundDlgCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster,
              NgTableParams, F, Round, data, $uibModalInstance) {

        $scope.depts = data.depts;
        $scope.rounds = [];
        var firstTime = true;
        var change_rounds = {
            edit_rounds: [],
            del_rounds: []
        };

        function init() {
            Round.get({id: data.user_id, opt: 0}).$promise.then(function (resp) {
                if(resp.result == 0) {
                    if(resp.rounds != null && resp.rounds.length != 0){
                        $scope.rounds = resp.rounds;
                        firstTime = false;
                    }
                }
            },function () {
                toaster.pop({
                    type: 'warning', title: '轮转信息不存在', body: '无法找到这个人的轮转信息!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            });
        };
        init();
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.addRound = function () {
            dialogs.create('templates/round/edit_round_dlg.html', 'EditRoundDlgCtrl',
                {depts: $scope.depts, user_id: data.user_id, haved_rounds: $scope.rounds}, {
                 size: 'md'
            }).result.then(function (round) {
                if(!firstTime){
                    change_rounds.edit_rounds.push(round);
                }
                $scope.rounds.push(round);
            });
        };

        $scope.editRound = function (index) {
            dialogs.create('templates/round/edit_round_dlg.html', 'EditRoundDlgCtrl',
                {depts: $scope.depts, user_id: data.user_id, round: $scope.rounds[index],
                    haved_rounds: $scope.rounds, index:index}, {
                 size: 'md'
            }).result.then(function (round) {
                if(!firstTime){
                    change_rounds.edit_rounds.push(round);
                }
                $scope.rounds[index] = round;
            });
        };

        $scope.deleteRound = function (index) {
            var getRounds = $scope.rounds.splice(index, 1);
            if(!firstTime && getRounds[0].id != null){
                change_rounds.del_rounds.push(getRounds[0]);
            }
        };

        $scope.ok = function () {
            var params = {};
            params.user_id = data.user_id;
            params.change_rounds = change_rounds;
            params.rounds = $scope.rounds;
            params.opt= firstTime ? 0 : 1;
            Round.save(params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('轮转修改成功!');
                        $uibModalInstance.close({result: 0});
                        break;
                    default:
                        toaster.error(resp.msg);
                }
            }, function () {
                toaster.error('轮转修改失败了!');
            });
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('RuleCommentDlgCtrl', RuleCommentDlgCtrl);

    function RuleCommentDlgCtrl($uibModalInstance, Table, data, Rule, Dlg) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.ok = ok;

        init(data.id);

        function init(id) {
            vm.m = {id: id};
        }

        function ok(m) {
            return Dlg.addEditOk(vm, Rule, function () {
                var pa = {
                    opt: 12,
                    remark: m.remark,
                    anonymous: m.anonymous ? 1 : 0
                };
                return pa;
            });
        }
    }
})();
angular.module('c.c').controller('RuleEditDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, $timeout, dialogs, toaster, C, F, FileHelper,
              data, Rule, SaveAs, RuleType, Keyword, Dept, MeetingTopic, Doc, $sce) {
        $scope.ForNewApproval = data.ForNewApproval;
        $scope.ForExchangeHospitalApproval = data.ForExchangeHospitalApproval;
        $scope.ForExchangeDeptApproval = data.ForExchangeDeptApproval;
        $scope.ForEdit = data.ForEdit;
        $scope.ForRedHead = data.ForRedHead;
        $scope.rule_types = F.get('rule_types');

        Rule.get({id: data.id}).$promise.then(function (resp) {
            var rule = resp.rule;

            $scope.pdfUrl = false;
            if (rule.rule_attach) {
                var type = rule.mime.substr(rule.mime.indexOf('/') + 1, rule.mime.length);
                if (type == 'pdf') {
                    $scope.pdfUrl = rule.rule_attach;
                    $scope.hasPdf = true;
                    //rule['rule_attach'] = {'filename': resp.rule.rule_attach,''};
                    rule.rule_attach = {
                        filename: resp.rule.rule_attach,
                        size: rule.size,
                        mime: rule.mime,
                        name: resp.rule.rule_attach + '.' + type
                    };
                }
            }

            Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
                $scope.cc_depts = resp.depts;
            });
            Keyword.query(function (resp) {
                $scope.keywords = resp;
                var keywords = [];
                var ccdepts = [];
                var backup1 = rule.keywords;
                var backup2 = rule.ccdepts;
                rule.keywords = [];
                rule.ccdepts = [];
                $timeout(function () {
                    angular.forEach(backup1, function (k) {
                        var keyword = F.getItem(k.id, $scope.keywords);
                        if (keyword) {
                            keywords.push(keyword);
                        }
                    });
                    angular.forEach(backup2, function (d) {
                        var ccdept = F.getItem(d.id, $scope.cc_depts);
                        if (ccdept) {
                            ccdepts.push(ccdept);
                        }
                    });
                    rule.keywords = keywords;
                    rule.ccdepts = ccdepts;
                });
            });
            rule['class'] = F.getItem(rule.class, $scope.rule_types);
            rule['red_head'] = rule.red_head != '0';
            rule['with_sms'] = rule.with_sms == '1';
            if ($scope.ForExchangeDeptApproval) {
                RuleType.query({
                    opt: C.OPT.RULE_TYPE.INDEX.CLASS_EXCHANGE,
                    class: rule.class.id,
                    dept: rule.dept_id
                }, function (resp) {
                    $scope.types = resp.types;
                    $scope.types.splice(0, 0, {id: 0, name: '其他'});
                    rule['type'] = $scope.types[0];
                });
                rule['class'] = rule.class.id == 1 ? {id: '2', name: '全院'} : {id: '1', name: '科内'};
            } else {
                RuleType.query({
                    opt: C.OPT.RULE_TYPE.INDEX.OPTIONS,
                    class: rule.class.id,
                    dept: rule.dept_id
                }, function (resp) {
                    $scope.types = resp.types;
                    $scope.types.splice(0, 0, {id: 0, name: '其他'});
                });
            }
            $scope.rule = rule;

        }, function () {
            toaster.pop({
                type: 'warning', title: '規章制度不存在', body: '该規章制度可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.classSelectedFn = function (item) {
            $scope.classId = item.id;
            $scope.reload();
        };

        $scope.reload = function () {
            $scope.rule['type'] = null;
            $scope.deptId = $scope.rule.dept_id;

            RuleType.query({
                opt: C.OPT.RULE_TYPE.INDEX.OPTIONS,
                class: $scope.classId,
                dept: $scope.deptId
            }, function (resp) {
                $scope.types = resp.types;
                $scope.types.splice(0, 0, {id: 0, name: '其他'});
                $scope.rule['type'] = $scope.types[0];
            });
        };

        $scope.upload = function (file, rule_attach, e) {
            if (file) {
                rule_attach.name = file.name;
                delete rule_attach.filename;
            }
            FileHelper.upload1(C.URL.RULE_ATTACH_UPLOAD, file, rule_attach, e, {name: 'tmp_dir'}, {tmp_dir: rule_attach.tmp_dir});
        };

        $scope.download = function (rule) {
            var params = {filename: rule.rule_attach.filename, mime: rule.rule_attach.mime};
            rule.downloading = true;
            FileHelper.download(C.URL.RULE_ATTACH_DOWNLOAD, params, function (resp) {
                rule.downloading = false;
                var data = [resp];
                var options = {type: rule.rule_attach.mime};
                SaveAs.download(data, rule.subject, options);
            }, function () {
                rule.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };


        $scope.ok = function (rule) {
            if ($scope.pdfUrl && !rule.rule_attach.filename) {
                toaster.warning('pdf文档还未上传或正在上传中!');
            } else if (rule.subject == null || rule.subject == "") {
                toaster.warning('标题不能为空!');
            } else if (!$scope.pdfUrl && (rule.body == null || rule.body == "")) {
                toaster.warning('内容不能为空!');
            } else if (rule.red_head && rule.ccdepts.length == 0) {
                toaster.warning('抄送科室不能为空!');
            } else {
                var params = {};
                params['subject'] = rule.subject;
                params['class'] = rule.class.id;
                params['dept_id'] = rule.dept.id;
                params['type_id'] = rule.type.id;
                params['keywords'] = rule.keywords;
                params['body'] = rule.body;
                params['ccdepts'] = [];
                angular.forEach(rule.ccdepts, function (dept) {
                    params['ccdepts'].push(dept.id);
                });

                params['has_attach'] = $scope.pdfUrl ? '1' : '0';
                if ($scope.pdfUrl) {
                    params['mime'] = rule.rule_attach.mime;
                    params['size'] = rule.rule_attach.size;
                    params['filename'] = rule.rule_attach.filename;
                    params['tmp_dir'] = rule.rule_attach.tmp_dir;
                }
                params['red_head'] = rule.red_head ? '1' : '0';
                params['with_sms'] = rule.with_sms ? '1' : '0';
                params['opt'] = C.OPT.RULE.EDIT.SAVE;
                params['isHospitalOffice'] = data.isHospitalOffice;
                params['isHospitalLeader'] = data.isHospitalLeader;
                params['isDeptLeader'] = data.isDeptLeader;
                $uibModalInstance.close(params);
            }
        };

        $scope.newPass = function (rule) {
            dialogs.confirm('新发布规章制度审批', '确定该规章制度通过审批吗?')
                .result.then(function () {
                    if ($scope.pdfUrl && !rule.rule_attach.filename) {
                        toaster.warning('pdf文档还未上传或正在上传中!');
                    } else if (rule.subject == null || rule.subject == "") {
                        toaster.warning('标题不能为空!');
                    } else if (!$scope.pdfUrl && (rule.body == null || rule.body == "")) {
                        toaster.warning('内容不能为空!');
                    } else if (rule.red_head && rule.ccdepts.length == 0) {
                        toaster.warning('抄送科室不能为空!');
                    } else {
                        var params = {};
                        params['subject'] = rule.subject;
                        params['class'] = rule.class.id;
                        params['dept_id'] = rule.dept.id;
                        params['type_id'] = rule.type.id;
                        params['keywords'] = rule.keywords;
                        params['body'] = rule.body;
                        params['ccdepts'] = [];

                        params['has_attach'] = $scope.pdfUrl ? '1' : '0';
                        if ($scope.pdfUrl) {
                            params['mime'] = rule.rule_attach.mime;
                            params['size'] = rule.rule_attach.size;
                            params['filename'] = rule.rule_attach.filename;
                            params['tmp_dir'] = rule.rule_attach.tmp_dir;
                        }
                        angular.forEach(rule.ccdepts, function (dept) {
                            params['ccdepts'].push(dept.id);
                        });
                        params['red_head'] = rule.red_head ? '1' : '0';
                        params['with_sms'] = rule.with_sms ? '1' : '0';
                        params['opt'] = C.OPT.RULE.EDIT.PASS;
                        $uibModalInstance.close(params);
                    }
                }
            )
        };

        //处理
        $scope.handle = function (rule) {
            dialogs.create('templates/rule/handle_dlg.html', 'RuleHandleDlgCtrl', {
                    dept_id: rule.dept_id,
                    stage: rule.stage,
                    state: rule.state,
                    reason: rule.reason,
                    with_sms: rule.with_sms
                },
                {size: 'md'}).result.then(function (params) {
                if (rule.subject == null || rule.subject == "") {
                    toaster.warning('标题不能为空!');
                } else if (!$scope.pdfUrl && (rule.body == null || rule.body == "")) {
                    toaster.warning('内容不能为空!');
                } else if (rule.red_head && rule.ccdepts.length == 0) {
                    toaster.warning('抄送科室不能为空!');
                } else {
                    var pa = {};
                    pa['subject'] = rule.subject;
                    pa['class'] = rule.class.id;
                    pa['dept_id'] = rule.dept.id;
                    pa['type_id'] = rule.type.id;
                    pa['keywords'] = rule.keywords;
                    pa['body'] = rule.body;
                    pa['ccdepts'] = [];
                    angular.forEach(rule.ccdepts, function (dept) {
                        pa['ccdepts'].push(dept.id);
                    });
                    pa['red_head'] = rule.red_head ? '1' : '0';
                    pa['with_sms'] = rule.with_sms ? '1' : '0';
                    pa['stage'] = params.stage;
                    pa['reason'] = params.reason;
                    pa['stage_id'] = params.stage_id;
                    pa['opt'] = params.opt;
                    pa['is_hospital_leader'] = true;

                    Rule.update({id: rule.id}, pa).$promise.then(
                        function () {
                            toaster.success('规章制度处理成功');
                            $rootScope.$broadcast('ruleHandle');
                            $uibModalInstance.dismiss('cancel');
                        }, function () {
                            toaster.error('规章制度处理失败了!');
                        }
                    );

                }

                if (params.stage == C.STAGE6.COUNTERSIGN) {
                    dialogs.create('templates/rule/rule2doc.html', 'Rule2DocDlgCtrl', {rule: rule, isRule: true},
                        {size: 'lg'}).result.then(function (params) {
                        Doc.save(params).$promise.then(function () {
                            toaster.success('提交成功!');
                            $uibModalInstance.dismiss('cancel');
                        }, function () {
                            toaster.error('提交失败!');
                        });
                    });
                }

                if (params.stage == C.STAGE6.TO_BE_DISCUSSED) {
                    dialogs.create('templates/rule/rule2topic.html', 'Rule2TopicDlgCtrl', {rule: rule},
                        {size: 'lg'}).result.then(function (params) {
                        MeetingTopic.save(params).$promise.then(function () {
                            toaster.success('议题申请成功!');
                            $uibModalInstance.dismiss('cancel');
                        }, function () {
                            toaster.error('议题申请失败了!');
                        });
                    });
                }
            });
        };

        $scope.deptPass = function (rule) {
            dialogs.confirm('规章制度转换分类申请', '确定该规章制度转换分类吗?')
                .result.then(function () {
                    if (rule.subject == null || rule.subject == "") {
                        toaster.warning('标题不能为空!');
                    } else if (!$scope.pdfUrl && (rule.body == null || rule.body == "")) {
                        toaster.warning('内容不能为空!');
                    } else if (rule.red_head && rule.ccdepts.length == 0) {
                        toaster.warning('抄送科室不能为空!');
                    } else {
                        var params = {};
                        params['subject'] = rule.subject;
                        params['class'] = rule.class.id;
                        params['dept_id'] = rule.dept.id;
                        params['type_id'] = rule.type.id;
                        params['keywords'] = rule.keywords;
                        params['body'] = rule.body;
                        params['ccdepts'] = [];
                        angular.forEach(rule.ccdepts, function (dept) {
                            params['ccdepts'].push(dept.id);
                        });
                        params['red_head'] = rule.red_head ? '1' : '0';
                        params['with_sms'] = rule.with_sms ? '1' : '0';
                        params['opt'] = C.OPT.RULE.EDIT.CLASS_EXCHANGE;
                        $uibModalInstance.close(params);
                    }
                }
            )
        };

        $scope.redHeadPass = function (rule) {
            dialogs.confirm('套红头规章制度审批', '确定该规章制度套红头吗?')
                .result.then(function () {
                    if (rule.subject == null || rule.subject == "") {
                        toaster.warning('标题不能为空!');
                    } else if (!$scope.pdfUrl && (rule.body == null || rule.body == "")) {
                        toaster.warning('内容不能为空!');
                    } else if (rule.red_head && rule.ccdepts.length == 0) {
                        toaster.warning('抄送科室不能为空!');
                    } else {
                        var params = {};
                        params['subject'] = rule.subject;
                        params['class'] = rule.class.id;
                        params['dept_id'] = rule.dept.id;
                        params['type_id'] = rule.type.id;
                        params['keywords'] = rule.keywords;
                        params['body'] = rule.body;
                        params['ccdepts'] = [];
                        angular.forEach(rule.ccdepts, function (dept) {
                            params['ccdepts'].push(dept.id);
                        });
                        params['red_head'] = rule.red_head;
                        params['with_sms'] = rule.with_sms ? '1' : '0';
                        params['opt'] = C.OPT.RULE.EDIT.RED_HEAD_PASS;
                        $uibModalInstance.close(params);
                    }
                }
            )
        };

        $scope.back = function (rule) {
            dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                title: '退回套红头规章制度',
                icon: 'reply',
                label: '原因'
            }, {

                size: 'sm'
            }).result.then(function (pa) {
                var params = {};
                params['remark'] = pa;
                params['opt'] = C.OPT.RULE.EDIT.RED_HEAD_BACK;
                Rule.update({id: rule.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('ruleBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            });
        };

        $scope.newBack = function (rule) {
            dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                title: '退回新发布规章制度',
                icon: 'reply',
                label: '原因'
            }, {

                size: 'sm'
            }).result.then(function (pa) {
                var params = {};
                params['opinion'] = pa;
                params['dept_id'] = rule.dept.id;
                params['opt'] = C.OPT.RULE.EDIT.BACK;
                Rule.update({id: rule.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('ruleNewBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            });
        };

        $scope.tagTransform = function (newTag) {
            var item = F.getItem(newTag, $scope.keywords, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    })
;



angular.module('c.c').controller('RuleExportCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, C, F, FileHelper, SaveAs, data, Dept) {
        $scope.isDept = data.isDept;
        $scope.isOffice = data.isOffice;
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_LED_BY}, function (resp) {
            $scope.depts = resp.depts;
            var rule = {
                start: new Date(y, m, 1),
                end: new Date(y, m + 1, 0)
            };
            if ($scope.isDept) {
                rule['dept'] = $scope.depts[0];
                rule['class'] = '1';
            } else {
                rule['class'] = '2';
                rule['export_type'] = '1';
            }
            $scope.rule = rule;
        });

        $scope.ok = function (rule) {
            if ($scope.m_form.$valid) {
                var params = {};
                params['class'] = rule.class;
                if ($scope.isDept) {
                    params['dept_id'] = rule.dept.id;
                }
                params['start'] = $filter('date')(rule.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(rule.end, 'yyyy-MM-dd');
                params['export_type'] = rule.export_type;
                rule.downloading = true;
                FileHelper.download(C.URL.RULE_EXPORT, params, function (resp) {
                    rule.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    if (rule.export_type == '1') {
                        var filename = params['start'] + '到' + params['end'] + ($scope.isDept ? rule.dept.name : '全院') +
                            '已发布规章制度';
                    } else {
                        var filename = params['start'] + '到' + params['end'] + ($scope.isDept ? rule.dept.name : '全院') +
                            '已停用规章制度';
                    }

                    if ($scope.isDept) {
                        filename += '(' + (rule.class == 1 ? '科内' : '全院') + ')'
                    }
                    filename += '情况统计.xls';
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function () {
                    rule.downloading = false;
                    toaster.error('导出失败!');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.m_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('RuleHandleDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, toaster, data, C) {
        $scope.reason = data.reason;
        $scope.dept = data.dept;
        $scope.class = data.class;

        if (data.state == 1 || data.state.id == 1 || data.state == 3 || data.state.id == 3) {
            if (data.stage.id == 4 || data.stage == 4) {
                $scope.stages = [{id: 6, name: '发布'}, {id: 7, name: '停用'}, {id: 5, name: '待讨论'}];
            } else if (data.stage.id == 5 || data.stage == 5) {
                $scope.stages = [{id: 6, name: '发布'}, {id: 7, name: '停用'}, {id: 4, name: '会签'}];
            } else if (data.stage.id == 6 || data.stage == 6) {
                $scope.stages = [{id: 7, name: '停用'}];
            } else if (data.stage.id == 9 || data.stage == 9 || data.state == 10 || data.state.id == 10) {
                $scope.stages = [{id: 6, name: '发布'}, {id: 7, name: '停用'}];
            } else {
                $scope.stages = [{id: 6, name: '发布'}, {id: 4, name: '会签'}, {id: 5, name: '待讨论'}, {
                    id: 7, name: '停用'
                }];
            }
        } else if (data.state == 2) {
            if (data.stage.id == 4 || data.stage == 4) {
                $scope.stages = [{id: 7, name: '停用'}, {id: 5, name: '待讨论'}];
            } else if (data.stage.id == 5 || data.stage == 5) {
                $scope.stages = [{id: 7, name: '停用'}, {id: 4, name: '会签'}];
            } else {
                $scope.stages = [{id: 7, name: '停用'}, {id: 4, name: '会签'}, {id: 5, name: '待讨论'}];
            }
        }

        $scope.handle = {
            stage: $scope.stages[0],
            with_sms: data.with_sms == '1'
        };

        $scope.ok = function (handle) {
            if ((handle.reason == null || handle.reason == "") && handle.stage.id == 7 && $scope.reason == null) {
                toaster.warning('停用原因不能为空!');
            } else {
                var params = {};
                if (handle.stage.id == 7) {
                    params['reason'] = handle.reason;
                }
                params['stage'] = handle.stage.id;
                params['opt'] = data.dept ? C.OPT.RULE.EDIT.DEPT_HANDLE : C.OPT.RULE.EDIT.HANDLE; //判断是科室处理还是院办处理
                params['class'] = data.class;
                params['subject'] = data.subject;
                params['dept_id'] = data.dept_id;
                params['stage_id'] = data.stage.id ? data.stage.id : data.stage;
                params['with_sms'] = handle.with_sms;
                $uibModalInstance.close(params);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('RuleReplyDlgCtrl', RuleReplyDlgCtrl);

    function RuleReplyDlgCtrl($uibModalInstance, Table, data, Rule, Dlg) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.ok = ok;

        init(data.ruleId);

        function init(id) {
            vm.m = {id: id, commentId: data.id};
        }

        function ok(m) {
            return Dlg.addEditOk(vm, Rule, function () {
                var pa = {
                    opt: 13,
                    reply: m.reply,
                    commentId: m.commentId
                };
                return pa;
            });
        }
    }
})();
angular.module('c.c').controller('Rule2BulletinDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, dialogs, toaster, Upload, C, F, data, FileHelper) {
        $scope.deleteAttachment = function ($index) {
            $scope.bulletin.attachments.splice($index, 1);
        };

        $scope.upload = function (file, bulletin, e) {
            FileHelper.upload(C.URL.BULLETIN_UPLOAD, file, bulletin, e);
        };

        $scope.ok = function (bulletin) {
            if (bulletin.title == null) {
                toaster.warning('公告标题不能为空!');
            } else if (bulletin.body == null) {
                toaster.warning('公告内容不能为空!');
            } else {
                for (var i = 0; i < bulletin.attachments.length; i++) {
                    if (bulletin.attachments[i].filename == null) {
                        toaster.warning('请等一小会儿,部分附件信息还在路上!');
                        return;
                    }
                }

                var params = {};
                params['is_rule'] = bulletin.is_rule;
                params['dept'] = bulletin.dept.name;
                params['title'] = bulletin.title;
                params['body'] = bulletin.body;
                params['attachments'] = [];
                angular.forEach(bulletin.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });
                $uibModalInstance.close(params);
            }
        };

        $scope.reset = function () {
            var rule = data.rule;
            $scope.bulletin = {
                title: rule.subject,
                dept: {id: "43", name: "党政办公室"},
                body: rule.body,
                attachments: [],
                is_rule: true
            }
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    });



(function () {
    'use strict';

    angular.module('c.c')
        .controller('Rule2DocDlgCtrl', Rule2DocDlgCtrl);

    /** @ngInject */
    function Rule2DocDlgCtrl($scope, $uibModalInstance, dialogs, toaster,
                             data, C, F, Doc, DocType, FileHelper) {
        $scope.isRule = data.isRule;
        $scope.isTopic = data.isTopic;
        var results = Doc.getDocStepResults();

        DocType.query({opt: C.OPT.DOC_TYPE.INDEX.OPTIONS}, function (resp) {
            var types = resp.types;
            angular.forEach(types, function (type) {
                angular.forEach(type.steps, function (step) {
                    step.result = F.getItem(step.result, results);
                });
            });
            $scope.types = types;
            if ($scope.doc && !$scope.doc.type) {
                $scope.doc.type = F.getItem('会签申请', $scope.types, 'name');
            }
        });

        $scope.typeDetail = function (type) {
            dialogs.create('templates/doc/process_dlg.html', 'ProcessDlgCtrl', {steps: type.steps}, {
                size: 'md'
            });
        };


        $scope.deleteAttachment = function ($index, doc) {
            doc.attachments.splice($index, 1);
        };

        $scope.upload = function (file, doc, e) {
            FileHelper.upload(C.URL.DOC_UPLOAD, file, doc, e);
        };

        $scope.submit = function (doc) {
            if (doc.subject == null || doc.subject == "") {
                toaster.warning('公文主题不能为空!');
            } else if (doc.body == null || doc.body == "") {
                toaster.warning('公文内容不能为空!');
            } else if (!FileHelper.isAttachmentsUploaded(doc)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {};
                params['subject'] = doc.subject;
                params['dept_from_id'] = doc.dept_from.id;
                params['type_id'] = doc.type.id;
                params['dept_id'] = doc.type.dept.id;
                params['pass_handler_type'] = doc.type.steps[0].handler_type;
                params['handler_type'] = doc.type.steps[1].handler_type;
                params['handler_id'] = doc.type.steps[1].handler_id;
                params['is_urgent'] = doc.is_urgent ? '1' : '0';
                params['body'] = doc.body;
                params['attachments'] = [];
                angular.forEach(doc.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                params['is_exchange'] = doc.is_exchange;
                params['applicant_id'] = doc.applicant_id;
                // params['pass_handler_time'] = doc.hospital_approval_time;
                // params['pass_handler_id'] = doc.hospital_leader_id;
                $uibModalInstance.close(params);
            }
        };

        function reset(temp) {
            var doc = {
                is_urgent: false,
                body: temp.body,
                attachments: temp.attachments ? temp.attachments : [],
                subject: temp.subject,
                dept_from: temp.dept,
                applicant_id: data.isRule ? temp.sender_id : temp.applicant_id,
                // hospital_approval_time: temp.hospital_approval_time,
                // hospital_leader_id: temp.hospital_leader_id,
                is_exchange: true
            };

            if ($scope.types) {
                doc['type'] = F.getItem('会签申请', $scope.types, 'name');
            }
            $scope.doc = doc;
        }

        $scope.reset = function () {
            if ($scope.isRule) {
                reset(data.rule);
            }
            if ($scope.isTopic) {
                reset(data.topic);
            }
        };

        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }


    }

})();

angular.module('c.c').controller('Rule2TopicDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, dialogs, toaster, Upload, C, F, data, FileHelper) {
        $scope.topic_types = F.get('topic_types');

        $scope.deleteAttachment = function ($index, topic) {
            topic.attachments.splice($index, 1);
        };

        $scope.upload = function (file, topic, e) {
            FileHelper.upload(C.URL.TOPIC_UPLOAD, file, topic, e);
        };

        $scope.ok = function (topic) {
            if (topic.subject == null || topic.subject == "") {
                toaster.warning('标题不能为空!');
            } else if (topic.body == null || topic.body == "") {
                toaster.warning('正文内容不能为空!');
            } else {
                for (var i = 0; i < topic.attachments.length; i++) {
                    if (topic.attachments[i].filename == null) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                        return;
                    }
                }
                var params = {};
                params['subject'] = topic.subject;
                params['body'] = topic.body;
                params['dept_id'] = topic.dept.id;
                params['type'] = topic.type.id;
                params['is_public'] = topic.is_public ? '1' : '0';
                params['is_urgent'] = topic.is_urgent ? '1' : '0';
                params['rapporteurs'] = [];
                angular.forEach(topic.rapporteurs, function (r) {
                    params['rapporteurs'].push(r.id);
                });
                params['observers'] = [];
                angular.forEach(topic.observers, function (o) {
                    params['observers'].push(o.id);
                });
                params['attachments'] = [];
                angular.forEach(topic.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                params['applicant_id'] = topic.applicant_id;
                params['dept_leader_id'] = topic.dept_leader_id;
                params['dept_approval_time'] = topic.dept_approval_time;
                params['hospital_leader_id'] = topic.hospital_leader_id;
                params['hospital_approval_time'] = topic.hospital_approval_time;
                params['is_rule'] = topic.is_rule;
                $uibModalInstance.close(params);
            }
        };

        $scope.reset = function () {
            var rule = data.rule;
            $scope.topic = {
                subject: rule.subject,
                dept: rule.dept,
                is_public: true,
                is_urgent: false,
                body: rule.body,
                attachments: [],
                rapporteurs: [{
                    id: rule.sender.id,
                    name: rule.sender.name,
                    username: rule.sender.username
                }],
                observers: [{id: rule.sender.id, name: rule.sender.name, username: rule.sender.username}],
                type: $scope.topic_types[1],
                applicant_id: rule.sender_id,
                dept_leader_id: rule.dept_leader_id,
                dept_approval_time: rule.dept_approval_time,
                hospital_leader_id: rule.hospital_leader_id,
                hospital_approval_time: rule.hospital_approval_time,
                is_rule: true
            }
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    });



(function () {
    'use strict';

    angular.module('c.c')
        .controller('RuleShowCommentDlgCtrl', RuleShowCommentDlgCtrl);

    function RuleShowCommentDlgCtrl($scope, $uibModalInstance, Table, data, Rule, FileHelper, $q) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.download = download;

        init(data.id);

        function init(id) {
            var options = {
                service: Rule,
                params: {opt: 35, rule_id: id, forAll: data.forAll ? 1 : 0},
                hideFilter: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: "用户", width: Table._3_CHAR},
                    {field: "remark", title: "评论"},
                    {field: "created_at", title: "时间", width: Table._4_CHAR},
                    {field: "reply", title: "回复"},
                    {field: "handler", title: "回复人", width: Table._2_CHAR}
                ]
            };
            Table.load(vm, options);
        }

        function download() {
            var defer = $q.defer();
            FileHelper.dnExcel('/api/v1/rules/comment', {rule_id: data.id, forAll: data.forAll ? 1 : 0}, '制度评论表.xls')
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }
    }
})();
angular.module('c.c').controller('RuleShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, toaster, dialogs,
              FileHelper, C, F, SaveAs, data, Rule, Doc, MeetingTopic, Dlg) {
        $scope.ForPrint = data.ForPrint;
        $scope.ForEdit = data.ForEdit;
        $scope.ForHandle = data.ForHandle;
        $scope.ForBack = data.ForBack;
        $scope.stages = F.get('approval_stages6');
        $scope.red_heads = F.get('approval_stages7');

        Rule.get({id: data.id}).$promise.then(function (resp) {
            var rule = resp.rule;
            $scope.pdfUrl = false;
            if (rule.rule_attach) {
                var type = rule.mime.substr(rule.mime.indexOf('/') + 1, rule.mime.length);
                if (type == 'pdf') {
                    $scope.pdfUrl = rule.rule_attach;
                    $scope.hasPdf = true;
                }
            }
            rule.stage = F.getItem(rule.stage, $scope.stages);
            rule.red_head = F.getItem(rule.red_head, $scope.red_heads);
            $scope.ruleContent = $sce.trustAsHtml(rule.body);
            $scope.rule = rule;
        }, function () {
            toaster.pop({
                type: 'warning', title: '规章制度不存在', body: '该规章制度可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        //修改
        $scope.edit = function (rule) {
            dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                    id: rule.id, ForEdit: data.ForEdit
                },
                {size: 'lg'}).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function () {
                        toaster.success('规章制度修改成功');
                        $rootScope.$broadcast('ruleEdit');
                        $uibModalInstance.dismiss('cancel');
                    }, function () {
                        toaster.error('规章制度修改失败了!');
                    }
                );
            });
        };

        //处理
        $scope.handle = function (rule) {
            dialogs.create('templates/rule/handle_dlg.html', 'RuleHandleDlgCtrl', {
                    dept_id: rule.dept_id,
                    stage: rule.stage,
                    state: rule.state,
                    reason: rule.reason,
                    with_sms: rule.with_sms
                },
                {size: 'md'}).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function () {
                        toaster.success('规章制度处理成功');
                        $rootScope.$broadcast('ruleHandle');
                        $uibModalInstance.dismiss('cancel');
                    }, function () {
                        toaster.error('规章制度处理失败了!');
                    }
                );

                if (params.stage == C.STAGE6.COUNTERSIGN) {
                    dialogs.create('templates/rule/rule2doc.html', 'Rule2DocDlgCtrl', {rule: rule, isRule: true},
                        {size: 'lg'}).result.then(function (params) {
                        Doc.save(params).$promise.then(function () {
                            toaster.success('提交成功!');
                            $uibModalInstance.dismiss('cancel');
                        }, function () {
                            toaster.error('提交失败!');
                        });
                    });
                }

                if (params.stage == C.STAGE6.TO_BE_DISCUSSED) {
                    dialogs.create('templates/rule/rule2topic.html', 'Rule2TopicDlgCtrl', {rule: rule},
                        {size: 'lg'}).result.then(function (params) {
                        MeetingTopic.save(params).$promise.then(function () {
                            toaster.success('议题申请成功!');
                            $uibModalInstance.dismiss('cancel');
                        }, function () {
                            toaster.error('议题申请失败了!');
                        });
                    });
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        //重新编辑
        $scope.edit1 = function (rule) {
            var params = {opt: 1, rule: rule};
            $uibModalInstance.close(params);
        };
        //附件下载
        $scope.download = function (rule) {
            var params = {filename: rule.rule_attach, mime: rule.mime};
            rule.downloading = true;
            FileHelper.download(C.URL.RULE_ATTACH_DOWNLOAD, params, function (resp) {
                rule.downloading = false;
                var data = [resp];
                var options = {type: rule.mime};
                SaveAs.download(data, rule.subject, options);
            }, function () {
                rule.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.print = function (rule) {
            if ($scope.pdfUrl) {
                toaster.warning('此规章制度为附件,请下载打印~');
            } else {
                var keywords = [],
                    ccdepts = [];
                angular.forEach(rule.keywords, function (keword) {
                    keywords.push(keword.name);
                });
                angular.forEach(rule.ccdepts, function (dept) {
                    ccdepts.push(dept.name);
                });

                var w = window.open("", "打印预览");
                var html = '<html><body>';
                html += '<h2 style="text-align: center">' + rule.subject + '[' + (rule.class == '1' ? '科内' : '全院') + ']</h2>';
                html += '<p style="margin-left: 80px">发布科室：' + rule.dept.name + '&ensp;&ensp;发布人：' + rule.sender.name +
                    '&ensp;&ensp;发布时间：' + rule.release_time.substr(0, 16) + '</p>';
                html += '<p style="margin-left: 80px">制度类型：' + rule.type.name + '</p>';
                if (keywords.length > 0) {
                    html += '<p style="margin-left: 80px">关键词：' + keywords.join('、') + '</p>';
                }
                if (ccdepts.length > 0 && rule.red_head.id == 5) {
                    html += '<p style="margin-left: 80px">抄送科室：' + ccdepts.join('、') + '</p>';
                }
                html += '<h4 style="margin-left: 80px">正文：</h4>';
                html += '<p>' + rule.body + '</p>';
                html += '</body></html>';

                w.document.write(html);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            }

        };

        //评论
        $scope.comment = function (rule) {
            Dlg.show({
                template: 'templates/rule/comment_dlg.html',
                ctrl: 'RuleCommentDlgCtrl',
                data: {id: rule.id}
            });
        };
    });
angular.module('c.c').controller('RuleTypeExchangeCtrl',
    function ($scope, $uibModalInstance, toaster, C, data, RuleType) {
        $scope.rule = data.rule;
        $scope.isHospitalOffice = data.isHospitalOffice;
        RuleType.query({
            opt: C.OPT.RULE_TYPE.INDEX.NAME_EXCHANGE,
            class: $scope.rule.class,
            dept: $scope.rule.dept_id,
            name: $scope.rule.type.name
        }, function (resp) {
            $scope.types = resp.types;
            $scope.rule = {
                type: $scope.types[0]
            }
        });

        $scope.ok = function (rule) {
            var params = {};
            params['type_id'] = rule.type.id;     //转移后的类型id
            params['opt'] = C.OPT.RULE.EDIT.EXCHANGE;
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    });

angular.module('c.c').controller('RuleTypeDlgCtrl',
    function ($scope, $uibModalInstance, toaster, C, F, Dept, data) {
        $scope.isHospitalOffice = data.isHospitalOffice;
        if ($scope.isHospitalOffice) {
            $scope.type = {
                is_stop: false,
                class: '2'
            };
        } else {
            Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_LED_BY}, function (resp) {
                $scope.depts = resp.depts;
                $scope.type = {
                    is_stop: false,
                    class: '1',
                    dept: $scope.depts[0]
                };
            });
        }

        $scope.ok = function (type) {
            if ($scope.r_form.$valid) {
                var params = {};
                params['name'] = type.name;
                params['class'] = type.class;
                if (!$scope.isHospitalOffice) {
                    params['dept_id'] = type.dept.id;
                }
                params['is_stop'] = type.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.r_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    });

angular.module('c.c').controller('RuleDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, C, F, data, Rule) {
        $scope.Ruletype = data.type;
        $scope.stages = F.get('approval_stages6');

        $scope.tableReload = function () {
            Rule.query({
                opt: C.OPT.RULE.INDEX.TYPE_MANAGE,
                type: $scope.Ruletype.id
            }, function (resp) {
                $scope.rules = resp.rules;
                angular.forEach($scope.rules, function (rule) {
                    rule.stage = F.getItem(rule.stage, $scope.stages);
                });
            });
        };
        $scope.tableReload();

        $scope.exchange = function (rule) {
            dialogs.create('templates/rule_type/exchange_dlg.html', 'RuleTypeExchangeCtrl', {
                rule: rule,
                isHospitalOffice: data.isHospitalOffice
            }, {
                 size: 'md'
            }).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(function (data) {
                    toaster.success('规章制度类型转移成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('规章制度类型转移失败!');
                });
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
    });

(function () {
    'use strict';

    angular.module('c.c').controller('SweepCodePayCtrl', SweepCodePayCtrl);

    /** @ngInject */
    function SweepCodePayCtrl($uibModalInstance, Dlg, $document, data, $scope) {
        var vm = this;
        vm.cancel = $uibModalInstance.close;
        vm.service = data.service;
        var code = '', lastTime, nextTime;
        var lastCode, nextCode;
        vm.loading = false;
        vm.payQcode = null;

        init(data.cb, data.out_trade_no);

        function init(cb, outTradeNo) {
            vm.cb = cb;
            vm.outTradeNo = outTradeNo;
            //绑定按压事件
            keyDownBind();
            //绑定按下事件
            keyPressBind();

            //监听支付成功事件
            $scope.$on('SweepCodePaySuccess', function (event, data) {
                if (data.out_trade_no == vm.outTradeNo) {
                    vm.loading = false;
                    var resp = data.resp;
                    if (resp.result == 0) {
                        Dlg.s('扫码支付成功');
                        $uibModalInstance.close(resp);
                    } else {
                        Dlg.e('扫码失败，请重新扫码');
                    }
                }
            });

            //监听支付失败事件
            $scope.$on('SweepCodePayFail', function (event, data) {
                if (data.out_trade_no == vm.outTradeNo) {
                    vm.loading = false;
                    var resp = data.resp;
                    if (resp.result == 1) {
                        Dlg.e('扫码支付失败，患者没有正常付款');
                        $uibModalInstance.close(resp);
                    } else if (resp.result == 2) {
                        Dlg.e('扫码支付失败，工行接口出错，请使用其他支付方式，并联系系统管理员');
                        $uibModalInstance.close(resp);
                    }
                }
            });

            //页面关闭时，销毁监听器
            $scope.$on('destroy', function () {
                destroyKeyListener();
            });
        }

        function destroyKeyListener() {
            $document.unbind('keypress');
            $document.unbind('keydown');
        }

        var KEY_CANCEL = 27;

        function keyDownBind() {
            $document.bind('keydown', function (e) {
                if (e.which === KEY_CANCEL) {
                    $uibModalInstance.close();
                }
            });
        }

        var KEY_ENTER = 13;
        var SWEEP_CODE_LENGTH = 18;

        function keyPressBind() {
            $document.bind('keypress', function (e) {
                nextCode = e.which;
                nextTime = new Date().getTime();
                //如果不是第一次输入的情况
                if (lastCode != null && lastTime != null) {
                    //如果为连续输入，则拼接支付
                    if (nextTime - lastTime <= 30) code += String.fromCharCode(lastCode);
                    //不是连续输入则清空输入
                    if (nextTime - lastTime > 100) code = '';
                }

                lastCode = nextCode;
                lastTime = nextTime;
                //不是回车意味输入还未结束
                if (e.which !== KEY_ENTER) return;
                //长度不符合
                if (code.length !== SWEEP_CODE_LENGTH) {
                    Dlg.w('请出示正确的付款码');
                    code = "";
                    $scope.$apply();
                    return;
                }

                //按下回车，确认输入后，长度符合规则，则调用付款接口
                console.log('页面刷新');
                vm.loading = true;
                $scope.$apply();
                var enterCode = code;
                code = '';
                vm.cb(enterCode);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('totalDutyExportDlgCtrl', totalDutyExportDlgCtrl);

    /** @ngInject */
    function totalDutyExportDlgCtrl(TotalDutyRecord, FileHelper, FormHelper, $uibModalInstance) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.submit = submit;

        init();


        function init() {
            vm.m = {};
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var title = m.info_type == 1 ? '总值班记录' : '护理总值班记录';
                FileHelper.dnExcel(TotalDutyRecord.URL.API + '/export', {
                    info_type: m.info_type,
                    title: title
                }, title + ".xls", function () {
                    vm.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('totalDutyHandleDlgCtrl', totalDutyHandleDlgCtrl);

    /** @ngInject */
    function totalDutyHandleDlgCtrl($scope, TotalDutyRecord, Table, DateHelper, Dlg, FileHelper, ArrayHelper, FormHelper,
                                    data, $uibModalInstance) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.initForm = initForm;
        vm.submit = submit;

        init();


        function init() {
            var getDate = new Date();

            vm.report = {
                reply_at: getDate,
                reply_content: ''

            };
        }

        function initForm() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            init();
        }

        function submit(report) {

            return FormHelper.handleSubmit(vm, function (defer) {
                if (report.reply_at == '' || report.reply_at == null) {
                    Dlg.w('请填写正确的发生时间!');
                }
                if (report.is_handled == null) {
                    Dlg.w('请选择是否处理完毕的状态!');
                }
                else {
                    var pa = {
                        op: 'reply',
                        reply_at: DateHelper.datetime2Str(report.reply_at),
                        reply_content: report.reply_content,
                        is_handled : report.is_handled,
                        total_duty_id: data.id
                        
                    };
                    TotalDutyRecord.save(pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var resp = error.data;
                        Dlg.error(resp.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('totalDutyRecordCtrl', totalDutyRecordCtrl);

    /** @ngInject */
    function totalDutyRecordCtrl($scope, $q, TotalDutyRecord, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var handleStates = TotalDutyRecord.getHnadleStates();
        var infoTypeStates = TotalDutyRecord.getInfoTypeStates();
        var vm = $scope;
        vm.reply = reply;
        vm.clearFilters = clearFilters;
        vm.download = download;
        vm.init = init;
        var options;

        init();


        function init() {
            UIHelper.loadTab(vm, 'dutyRecord');
            options = {
                service: TotalDutyRecord,
                params: {
                    op: 'default'
                },
                hideOpt: true,
                cols: [
                    {field: "happen_at", title: "发生时间", width: 140,filter: {happen_at: "text"}},
                    {field: "reporter", title: "报告人", width: 95,filter: {reporter: "text"}},
                    {field: "reporter_dept", title: "科室", width: 95, filter: {reporter_dept: "text"}},
                    {field: "info_type", title: "值班组", width: 115, filter: {info_type: "select"},
                     data: Table.getNgTableOpts(infoTypeStates)
                    },
                    {field: "content", title: "内容"},
                ]
            };
            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                    item.is_handled = ArrayHelper.getItem(item.is_handled, handleStates);
                    item.info_type = ArrayHelper.getItem(item.info_type, infoTypeStates);
                });
            });
        }

        function reply(m) {
            Dlg.addEdit(vm, 'templates/total_duty_record/totalDutyHandleDlg.html',
                'totalDutyHandleDlgCtrl', m);
        }

        function clearFilters() {
            $scope.tableParams.filter({});
        }

        function download() {
            Dlg.show({
                template: 'templates/total_duty_record/totalDutyExportDlg.html',
                ctrl: 'totalDutyExportDlgCtrl',
                backdrop: false,
                size: 'md'
            }).then(function () {
                Dlg.s('总值班记录导出成功!');
            })
        }
    }

})();
angular.module('c.c')
    .controller('totalDutyRecordDlgCtrl', function ($scope, $uibModalInstance) {
    $scope.cancel = $uibModalInstance.dismiss;
});
(function () {
    'use strict';

    angular.module('c.c')
        .controller('totalDutyReportCtrl', totalDutyReportCtrl);

    /** @ngInject */
    function totalDutyReportCtrl($scope, TotalDutyRecord, Table, DateHelper, Dlg, FileHelper, ArrayHelper, FormHelper) {
        var vm = this;
        vm.initForm = initForm;
        vm.submit = submit;
        vm.uploadAttachment = upload;
        vm.deleteAttachment = deleteAttachment;

        init();


        function init() {
            var getDate = new Date();

            vm.report = {
                happen_at: getDate,
                attachments: [],
                content: '',
                is_handled: 1,
                info_type: ''

            };
        }

        function initForm() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            init();
        }

        function upload(file, m, e) {
            FileHelper.uploadAttachment(file, m, e);
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function submit(report) {
            return FormHelper.handleSubmit(vm, function (defer) {
                if (report.happen_at == '' || report.happen_at == null) {
                    Dlg.w('请填写正确的发生时间!');
                } else {
                    var pa = {
                        op: 'default',
                        happen_at: DateHelper.datetime2Str(report.happen_at),
                        content: report.content,
                        is_handled: report.is_handled,
                        info_type: report.info_type
                    };
                    pa.attachments = ArrayHelper.map(report.attachments, function (attachment) {
                        return {
                            id: attachment.id, name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        };
                    });
                    TotalDutyRecord.save(pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        initForm();
                    }, function (error) {
                        var resp = error.data;
                        Dlg.error(resp.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('c.c').controller('imageCroppedUploadCtrl', imageCroppedUploadCtrl);

    /** @ngInject */
    function imageCroppedUploadCtrl($scope, $uibModalInstance, toaster, FileHelper, C, data) {
        var vm = $scope;
        vm.title = data.title;
        vm.width = data.width;
        vm.height = data.height;
        vm.m = {toUrl: C.URL.IMG_UPLOAD, croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            FileHelper.uploadCroppedImage(m).then(function (url) {
                $uibModalInstance.close(url);
            }, function (errMsg) {
                toaster.error(errMsg);
            });
        }
    }

})();

//angular.module('c.c').controller('UploadImageDlg',
//    function ($scope, $uibModalInstance, Upload, C, dialogs) {
//        $scope.image = {progress: 0, height: 240};
//
//        $scope.upload = function (file, image, e) {
//            if (e && e[0] && e[0].$error == 'maxSize') {
//                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
//                return;
//            }
//
//            if (file == null) {
//                return;
//            }
//
//            Upload.upload({
//                url: C.URL.IMG_UPLOAD, file: file
//            }).progress(function (evt) {
//                image.progress = parseInt(100.0 * evt.loaded / evt.total);
//            }).success(function (resp) {
//                switch (resp.result) {
//                    case 0:
//                        image.progress = 0;
//                        image.link = resp.link;
//                        image.height = resp.height * 320 / resp.width;
//                        break;
//                    case 1:
//                        image.progress = 101;
//                        image.errorInfo = '服务器空间不足!';
//                        break;
//                }
//            }).error(function () {
//                image.progress = 102;
//                image.errorInfo = '服务器错误!';
//            });
//        };
//
//        $scope.insert = function (image) {
//            $uibModalInstance.close(image.link);
//        };
//
//        $scope.cancel = function () {
//            $uibModalInstance.dismiss('cancel');
//        };
//    });
angular.module('c.c').controller('UploadUserpicDlg',
    function ($scope, $uibModalInstance, Upload, C, data) {
        $scope.image = {progress: 0, croppedDataUrl: ''};

        $scope.upload = function (image) {
            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (!file.$error) {
                Upload.upload({
                    url: C.URL.IMG_UPLOAD, data: {file: file, is_user_photo: true, user_id: data.user_id}
                }).progress(function (evt) {
                    image.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (resp) {
                    switch (resp.result) {
                        case 0:
                            image.progress = 0;
                            image.url = resp.url;
                            $uibModalInstance.close(image.url);
                            break;
                        case 1:
                            image.progress = 101;
                            image.errorInfo = '服务器空间不足!';
                            break;
                    }
                }).error(function () {
                    image.progress = 102;
                    image.errorInfo = '服务器错误!';
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('UploadWordImagesDlg',
    function ($scope, $uibModalInstance, clipboard, Upload, deviceDetector, OS, OS_VERSIONS, C, dialogs, data) {

        var canOpenMultiFile = false;
        //多个文件同时上传受到windows文件打开窗口文件路径输入框可接受字符串长度限制，现在暂时都按照逐一打开文件处理
        //if (deviceDetector.os == OS.WINDOWS) {
        //    canOpenMultiFile = [
        //        OS_VERSIONS.WINDOWS_VISTA,
        //        OS_VERSIONS.WINDOWS_7,
        //        OS_VERSIONS.WINDOWS_8_1,
        //        OS_VERSIONS.WINDOWS_8,
        //        OS_VERSIONS.WINDOWS_10
        //    ].some(function (item) {
        //            return deviceDetector.os_version == item;
        //        });
        //}
        $scope.canOpenMultiFile = canOpenMultiFile;
        var paths = '';
        if (canOpenMultiFile) {
            angular.forEach(data.files, function (file) {
                paths += '"' + file.path + '" ';
            });
        } else {
            $scope.files2Upload = data.files;
        }

        $scope.getDataFromClipboard = function (path) {
            if (path) {
                clipboard.copyText(path);
            } else {
                clipboard.copyText(paths);
            }
        };

        var result = [];
        $scope.uploadFile = function ($file, file, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if ($file == null) {
                return;
            }

            Upload.upload({
                url: C.URL.IMG_UPLOAD, file: $file
            }).progress(function (evt) {
                file.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        file.progress = 0;
                        file.fileName = resp.fileName;
                        result[file.name] = resp.url;
                        break;
                    case 1:
                        file.progress = 101;
                        file.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                file.progress = 102;
                file.errorInfo = '服务器错误!';
            });
        };

        //$scope.uploadFiles = function (files, e) {
        //    $scope.filesUploaded = files;
        //    if (e && e[0] && e[0].$error == 'maxSize') {
        //        dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
        //        return;
        //    }
        //
        //    if (files == null) {
        //        return;
        //    }
        //
        //    var count = 0;
        //    angular.forEach(files, function (file) {
        //        Upload.upload({
        //            url: C.URL.IMG_UPLOAD, file: file
        //        }).progress(function (evt) {
        //            file.progress = parseInt(100.0 * evt.loaded / evt.total);
        //        }).success(function (resp) {
        //            switch (resp.result) {
        //                case 0:
        //                    file.progress = 0;
        //                    result[file.name] = resp.url;
        //                    break;
        //                case 1:
        //                    file.progress = 101;
        //                    file.errorInfo = '服务器空间不足!';
        //                    break;
        //            }
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        }).error(function () {
        //            file.progress = 102;
        //            file.errorInfo = '服务器错误!';
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        });
        //    });
        //};

        $scope.ok = function () {
            $uibModalInstance.close(result);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('WageTaxDlgCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, data, C, F) {
        var vm = $scope;
        vm.cancel = cancel;
        vm.ok = ok;
        vm.changeAfter = changeAfter;
        $scope.opt = data.opt;
        //$scope.items = [{field: 'wtd', name: '个税'}, {field: 'css', name: '单位缴付保险'}, {field: 'ss', name: '自付保险'}];

        init();

        function init() {
            vm.wages = [];
            vm.tableSettings = {
                manualColumnResize: true, colWidths: 150, stretchH: 'default',
                columnSorting: true, sortIndicator: true
            };
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function ok() {
            var keepGoing = true;
            if (vm.wages.length - 1 == 0) {
                keepGoing = false;
                toaster.warning('请输入数据!');
            } else {
                if ($scope.opt == '1') {
                    for (var i = 0; i < vm.wages.length - 1; i++) {
                        if (vm.wages[i].username == null || (vm.wages[i].username != null && angular.isUndefined(vm.wages[i].wtd))
                            || (vm.wages[i].username != null && vm.wages[i].wtd == null)) {
                        }
                    }
                } else if ($scope.opt == '2') {
                    for (var i = 0; i < vm.wages.length - 1; i++) {
                        if (vm.wages[i].username != null && typeof(vm.wages[i].css) !== 'undefined' && vm.wages[i].css != null &&
                            typeof(vm.wages[i].css) !== 'undefined' && vm.wages[i].ss != null) {

                        } else {
                            keepGoing = false;
                            toaster.warning('表格中存在错误!');
                            break;
                        }
                    }
                }
            }


            if (keepGoing) {
                toaster.success('导入成功，请保存变更工资!');
                $uibModalInstance.close(vm.wages);
            }
        }

        function changeAfter(a) {

            if (a) {
                if (a[0].length > 0) {
                    for (var i = 0; i < a.length; i++) {
                        var row = a[i][0],
                            column = a[i][1],
                            old_value = a[i][2],
                            new_value = a[i][3];

                        var w = $scope.wages[row];
                        if (column != 'username') {
                            if (isNaN(new_value)) {
                                w[column] = old_value;
                                toaster.warning('请输入数字!');
                            } else if (new_value.length == 0) {
                                w[column] = old_value;
                                toaster.warning('输入不能为空!');
                            } else if (new_value < 0) {
                                w[column] = old_value;
                                toaster.warning('不能输入负数!');
                            }
                        }
                    }
                }
            }
        }

    }
)
;
//angular.module('c.c').controller('TempWageDlgCtrl',
//    function ($scope, $uibModalInstance, $filter, toaster, data, UserTempWage, C, F) {
//        if (data.wage) {
//            $scope.$edit = true;
//            var w = data.wage;
//            $scope.w = {
//                name: w.name, money: w.money,
//                is_cost: w.is_cost == '1', is_tax: w.is_tax == '1', is_ad: w.is_ad == '1',
//                is_wage: w.is_wage == '1', user: {id: w.user_id, name: w.user_name}
//            };
//        } else {
//            $scope.w = {
//                is_cost: true, is_tax: true, is_ad: true, is_wage: true
//            };
//        }
//
//        $scope.ok = function (w) {
//            if (!w.user) {
//                toaster.warning('请选择员工!');
//            } else if ($scope.w_form.$valid) {
//                var pa = {};
//                pa['name'] = w.name;
//                pa['money'] = w.money;
//                pa['is_cost'] = w.is_cost ? '1' : '0';
//                pa['is_tax'] = w.is_tax ? '1' : '0';
//                pa['is_ad'] = w.is_ad ? '1' : '0';
//                pa['is_wage'] = w.is_wage ? '1' : '0';
//                pa['user_id'] = w.user.id;
//                pa['month'] = $filter('date')(data.dt, 'yyyy-MM-01');
//                $uibModalInstance.close(pa);
//            } else {
//                toaster.warning('表单中有错误!');
//                $scope.w_form.submitted = true;
//            }
//        };
//
//        $scope.cancel = function () {
//            $uibModalInstance.dismiss('cancel');
//        };
//    });
angular.module('c.c')
    .controller('RoundSearchCtrl', function () {

    });
angular.module('c.c')
    .controller('GeneralBalanceCtrl', function ($scope, Balance, Table) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Balance,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {user_id: 'asc'},
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "main_dept", title: "科室", filter: {main_dept: "text"}},
                    {field: "balance", title: "金额", filter: {balance: "num_range"}}
                ]
            };
            Table.load(vm, options);
        }
    });


angular.module('c.c')
    .controller('GeneralMealCJSearchCtrl', function ($scope, $q, PurchaseHistory, C, F, Table, UIHelper,
                                                     $ocLazyLoad, dialogs, toaster, Store, FileHelper) {
        var vm = $scope;
        vm.export = exportPH;
        vm.pHStates = F.get('pHStates');

        init();

        function init() {
            UIHelper.loadTab(vm, 'cj');
            var options = {
                service: PurchaseHistory,
                params: {opt: 6/*PURCHASE_HISTORY.INDEX_CJ_SEARCH*/},
                sorting: {time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time', filter: {time: 'date_range'}},
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: F.getNgTableOpts(vm.pHStates)
                    },
                    {field: "handler", title: '操作人', filter: {handler: 'text'}},
                ]
            };

            var optionsFn = null;

            Store.query({opt: 2/*STORE.INDEX_OPTIONS*/}, function (resp) {
                vm.stores = resp.items;
                if (vm.stores && vm.stores.length > 0) {
                    options.params.storeId = vm.stores[0].id;
                    vm.store = vm.stores[0];
                }
                optionsFn = Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (i) {
                        i.state = F.getItem(i.state, vm.pHStates);
                    });
                    vm.periodTotal = resp.periodTotal;
                }).options;
            });


            vm.storeSelectedFn = function (s) {
                vm.store = s;
                optionsFn().params.storeId = s.id;
                vm.tableParams.$params.page = 1;
                vm.tableReload();
            }
        }

        function exportPH() {
            dialogs.create('PHE1.html', 'PHE1Ctrl', {
                day: vm.dt,
                url: '/api/v1/purchase_history/cj_export',
                title: '慈济餐补统计导出表.xls'
            }, {size: 'md'});
        }

    });





angular.module('c.c')
    .controller('GeneralMealHandleCtrl', function ($scope, $rootScope, $q, PurchaseHistory, C, F,
                                                   Table, FileHelper, dialogs, toaster, Store, Dlg) {
        var vm = $scope;
        vm.init = init;
        vm.setState = setState;
        vm.export1 = exportPH1;
        vm.export2 = exportPH2;

        function init(data) {
            vm.$on('phHospitalHandle', function () {
                vm.tableReload();
            });

            vm.type = data;

            var options = {
                service: PurchaseHistory,
                params: {opt: 4/*PURCHASE_HISTORY.INDEX_HOSPITAL_HANDLE*/, type: data},
                sorting: {time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: "dept", title: '科室', filter: {dept: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time', filter: {time: 'date_range'}},
                    {
                        field: 'pay_time',
                        title: '医院支付时间',
                        sortable: 'time',
                        filter: {pay_time: 'date_range'},
                        show: data == 3
                    }
                ]
            };

            var optionsFn = null;

            Store.query({opt: 2/*STORE.INDEX_OPTIONS*/}, function (resp) {
                vm.stores = resp.items;
                if (vm.stores && vm.stores.length > 0) {
                    options.params.storeId = vm.stores[0].id;
                    vm.store = vm.stores[0];
                }
                optionsFn = Table.load(vm, options, function (resp) {
                    vm.periodTotal = resp.periodTotal;
                }).options;
            });


            vm.storeSelectedFn = function (s) {
                vm.store = s;
                optionsFn().params.storeId = s.id;
                vm.tableParams.$params.page = 1;
                vm.tableReload();
            }
        }

        function exportPH1() {
            dialogs.create('PHE.html', 'PHECtrl', {
                day: vm.dt,
                url: C.URL.PURCHASE_HISTORY_DOWNLOAD,
                title: '餐补统计导出表.xls'
            }, {size: 'md'});
        }

        function exportPH2() {
            dialogs.create('PHPE.html', 'PHPECtrl',
                {title: '餐补统计导出(以支付时间为准)', url: '/api/v1/purchase_history/pay_export'}, {size: 'md'});
        }

        function setState() {
            dialogs.confirm(vm.type == 1 ? '接收申请' : '医院付款', vm.type == 1 ? '确定要接收所选商家的销账申请吗?' : '确定要付款给所选商家吗?')
                .result.then(function () {
                var opt = vm.type == 1 ? 3 : 4;
                Store.setState({storeId: vm.store.id, opt: opt/*STORE.BATCH_APPLY*/}).$promise.then(function (resp) {
                    toaster.success(resp.msg);
                    if (vm.type == 1) {
                        vm.tabs['handle'] = true;
                    } else {
                        vm.tabs['pay'] = true;
                    }
                    $rootScope.$broadcast('phHospitalHandle');
                    vm.tableReload();
                });
            });
        }
    });

angular.module('c.c').controller('PHECtrl',
    function ($scope, $q, $uibModalInstance, toaster, $filter, data, FileHelper, C, SaveAs, Dlg, $http) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        $scope.$on(C.P + 'ph.download', function (event, data) {
            var params = data.data.data;
            FileHelper.download('api/home/appointments/download', params, function (resp) {
                vm.downloading = false;
                SaveAs.download([resp], params.name, {type: params.mime});
            }, function () {
                vm.downloading = false;
                Dlg.w('下载失败,重新尝试');
            });
        });

        vm.m = {type: true, time: new Date(), forCj: data.forCj};

        function ok(m) {
            // var defer = $q.defer();
            m.time = $filter('date')(m.time, 'yyyy-MM');
            vm.downloading = true;
            $http.post(data.url, m);

            // FileHelper.dnExcel(data.url, m, m.time.substr(0, 4) + '年' + (m.type ? (m.time.substr(5, 2)
            //     + '月') : '') + data.title, function () {
            //     $uibModalInstance.close();
            // }).finally(function () {
            //     defer.resolve();
            // });
            // return defer.promise;
        }
    });

angular.module('c.c').controller('PHE1Ctrl',
    function ($scope, $q, $uibModalInstance, toaster, $filter, data, FileHelper) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        vm.m = {type: true, time: new Date()};

        function ok(m) {
            var defer = $q.defer();
            m.time = $filter('date')(m.time, 'yyyy-MM');
            FileHelper.dnExcel(data.url, m, m.time.substr(0, 4) + '年' + (m.type ? (m.time.substr(5, 2)
                + '月') : '') + data.title, function () {
                $uibModalInstance.close();
            }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }
    });
angular.module('c.c')
    .controller('GeneralRechargeCtrl', function ($scope, Recharge, Table, F) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Recharge,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "money", title: "金额", filter: {money: "num_range"}},
                    {
                        field: "is_cost",
                        title: "计入科室成本",
                        filter: {is_cost: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    },
                    {field: "created_at", title: "充值时间", filter: {created_at: "date_range"}},
                    {field: "handler", title: "充值人", filter: {handler: "text"}},
                    {field: "note", title: "充值理由", filter: {note: "text"}}
                ]
            };
            Table.load(vm, options);
        }
    });


angular.module('c.c')
    .controller('GeneralMealSearchCtrl', function ($scope, PurchaseHistory, C, F, Table,
                                                   $ocLazyLoad, dialogs, toaster, Store) {
        var vm = $scope;
        vm.pHStates = F.get('pHStates');

        init();

        function init() {
            var options = {
                service: PurchaseHistory,
                params: {opt: 5/*PURCHASE_HISTORY.INDEX_HOSPITAL_SEARCH*/},
                sorting: {time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time', filter: {time: 'date_range'}},
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: F.getNgTableOpts(vm.pHStates)
                    },
                    {field: "handler", title: '操作人', filter: {handler: 'text'}},
                ]
            };

            var optionsFn = null;

            Store.query({opt: 2/*STORE.INDEX_OPTIONS*/}, function (resp) {
                vm.stores = resp.items;
                if (vm.stores && vm.stores.length > 0) {
                    options.params.storeId = vm.stores[0].id;
                    vm.store = vm.stores[0];
                }
                optionsFn = Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (i) {
                        i.state = F.getItem(i.state, vm.pHStates);
                    });
                    vm.periodTotal = resp.periodTotal;
                }).options;
            });


            vm.storeSelectedFn = function (s) {
                vm.store = s;
                optionsFn().params.storeId = s.id;
                vm.tableParams.$params.page = 1;
                vm.tableReload();
            }
        }
    });





angular.module('c.c')
    .controller('GeneralWMCtrl', function ($scope, $filter, dialogs, toaster, WorkingMeal, Store, Table, C, F) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: WorkingMeal,
                params: {opt: 6 /*WORKINGMEAL.INDEX_GENERAL_SEARCH*/},
                sorting: {handler_time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "num", title: "数量"},
                    {
                        field: "handler_time",
                        width: '20%',
                        title: "确认时间",
                        filter: {handler_time: "date_range"},
                        sortable: "handler_time"
                    },
                    {field: "handler", title: "处理人", filter: {handler: "text"}}
                ]
            };

            var optionsFn = null;

            Store.query({opt: 2/*STORE.INDEX_OPTIONS*/}, function (resp) {
                vm.stores = resp.items;
                if (vm.stores && vm.stores.length > 0) {
                    options.params.storeId = vm.stores[0].id;
                    vm.store = vm.stores[0];
                }
                optionsFn = Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (i) {
                        i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                    });
                }).options;
            });

            vm.storeSelectedFn = function (s) {
                vm.store = s;
                optionsFn().params.storeId = s.id;
                vm.tableParams.$params.page = 1;
                vm.tableReload();
            }
        }
    });




//angular.module('c.c')
//    .controller('WMealSCtrl', function ($scope, $rootScope, $q, dialogs, toaster, WorkingMeal, C, $filter, F) {
//        var vm = $scope;
//        var date = new Date((new Date()).setDate(1));
//        var month = date.getMonth();
//        vm.dts = new Date(date.setMonth(date.getMonth() - 1));
//        vm.prevMonth = function (curr) {
//            var prev = curr.getMonth() - 1;
//            vm.dts = new Date(curr.setMonth(prev));
//        };
//        vm.nextMonth = function (curr) {
//            var next = curr.getMonth() + 1;
//            vm.dts = new Date(curr.setMonth(next));
//        };
//
//        vm.$watch('dts', function (newVal, oldVal, scope) {
//            vm.tableReload();
//        }, true);
//
//        init();
//
//        function init() {
//            var options = {
//                service: WorkingMeal,
//                params: {opt: 6, month_start: $filter('date')(vm.dts, 'yyyy-MM-dd')},
//                sorting: {'depts.id': 'desc'},
//                hideOpt: true,
//                cols: [
//                    {field: "dept", title: "科室", filter: {'depts.name': "text"}},
//                    {
//                        field: "times",
//                        title: "次数"
//                    },
//                    {field: "money", title: "送餐地点", filter: {place: "text"}},
//                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
//                    {field: "num", title: "数量"}
//                ]
//            };
//            Table.load(vm, options, function (resp) {
//            });
//        }
//
//    });
//

(function () {
    'use strict';

    angular.module('c.c')
        .controller('decisionAcceptanceCtrl', decisionAcceptanceCtrl);

    /** @ngInject */
    function decisionAcceptanceCtrl($scope, ArrayHelper, Table, Dlg, MeetingRecord) {
        var vm = $scope;
        vm.edit = edit;
        vm.show = show;

        init();


        function init() {
            var states = MeetingRecord.getStates();
            var options = {
                service: MeetingRecord,
                params: {op: 'acceptance'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "会议名称", filter: {name: "text"}},
                    {field: "resolution", title: "决议", filter: {resolution: "text"}},
                    {field: "start_time", title: "开会时间", width: Table._1_CHAR},
                    {field: "dept", title: "落实科室", width: Table._1_CHAR},
                    {
                        field: "state", title: "状态", filter: {state: "select"}, width: Table._1_CHAR,
                        data: Table.getNgTableOpts(states),
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = ArrayHelper.getItem(item.state, states);

                });
            });

        }

        function edit(m) {

            Dlg.show({
                template: 'templates/meeting/workableDlg.html',
                ctrl: 'MeetingWorkableDlgCtrl',
                data: {
                    id: m.id,
                    acceptance: true,
                },
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'templates/meeting/workableDlg.html',
                ctrl: 'MeetingWorkableDlgCtrl',
                data: {
                    id: m.id,
                    acceptance: true,
                },
                size: 'md'
            });
        }

    }

})();


(function () {
    'use strict';

    angular.module('c.s')
        .controller('insuranceExportDlgCtrl', insuranceExportDlgCtrl);

    /** @ngInject */
    function insuranceExportDlgCtrl($scope, OperationImport, FileHelper, FormHelper, $uibModalInstance, data, DateHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.submit = submit;

        init(data);


        function init(data) {
            vm.kind_id = data.kind_id;

            var date = new Date(), y = date.getFullYear();
            vm.m = {
                start: new Date('2000-01-01').setFullYear(y - 1),
                end: new Date('2000-12-31').setFullYear(y - 1)
            };
            $scope.$watch('vm.m.start', timeChange, true);
            $scope.$watch('vm.m.end', timeChange, true);
        }

        function timeChange() {
            var invalid, m = vm.m;
            vm.Form.end.$setValidity('startDate', true);

            if (m.start && m.end) {
                invalid = m.start > m.end;
                vm.Form.end.$setValidity('startDate', !invalid);
            }
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var title = data.kind_id === 1 ? '手术质控记录表' : (data.kind_id === 2 ? '药品质控记录表' : (data.kind_id === 3 ? '诊疗质控记录表' : '医保质控记录表'));
                var url = data.kind_id === 0 ? OperationImport.EXPORT_DEPT_URL : OperationImport.EXPORT_URL;
                FileHelper.dnExcel(url, {
                    start: DateHelper.date2Str(m.start),
                    end: DateHelper.date2Str(m.end),
                    kind_id: data.kind_id,
                    title: title
                }, title + ".xls", function () {
                    vm.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .controller('OperationImportCtrl', OperationImportCtrl)
        .controller('DrugImportCtrl', DrugImportCtrl)
        .controller('TreatmentImportCtrl', TreatmentImportCtrl)
        .controller('ImportOperationDlgCtrl', ImportOperationDlgCtrl)
        .controller('ImportOperationEditDlgCtrl', ImportOperationEditDlgCtrl)
    ;

    /** @ngInject */
    function OperationImportCtrl($scope, OperationImport, Table, UIHelper, Dlg) {
        var vm = $scope;
        vm.excelImport = excelImport;
        vm.edit = edit;
        vm.remove = remove;
        vm.download = download;

        init();

        function init() {
            UIHelper.loadTab(vm, 'operation');

            var options = {
                service: OperationImport,
                params: {op: 'all'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                showSn: true,
                // hideOpt: true,
                cols: [
                    {
                        field: "dept",
                        title: '科室',
                        filter: {dept: 'text'}
                    },
                    {field: "violation", title: '违反规则', filter: {violation: 'text'}},
                    {field: "type", title: '违规类型', filter: {type: 'text'}},
                    {field: "subject", title: '违规项目', filter: {subject: 'text'}},
                    {field: "reason", title: '整改建议', filter: {reason: 'text'}},
                    {field: "according", title: '依据', filter: {according: 'text'}},
                    {field: "happened_date", title: '发生日期', filter: {happened_date: 'date_range'}},
                    {field: "date", title: '规范落实日期', filter: {date: 'date_range'}},
                    {field: "measure", title: '科室整改措施', filter: {measure: 'text'}},
                    {field: "user", title: '科室整改措施填写人', filter: {user: 'text'}},
                    {field: "one_later_question", title: '第1月后质控出现问题', filter: {one_later_question: 'text'}},
                    {field: "two_later_question", title: '第2月后质控出现问题', filter: {two_later_question: 'text'}},
                    {field: "three_later_question", title: '第3月后质控出现问题', filter: {three_later_question: 'text'}},
                    {field: "important_time", title: '考察期后仍未整改例数', filter: {important_time: 'text'}},
                    {field: "punishment", title: '处理措施', filter: {punishment: 'text'}},
                    {field: "result", title: '整改效果', filter: {result: 'text'}}
                ]
            };

            Table.load(vm, options);
        }

        function edit(m) {
            Dlg.show({
                template: 'templates/importOperationEditDlg.html',
                ctrl: 'ImportOperationEditDlgCtrl',
                data: {id: m.id}
            }).then(function () {
                vm.tableReload();
            });
        }

        function excelImport() {
            Dlg.show({
                template: 'templates/importOperationDlg.html',
                ctrl: 'ImportOperationDlgCtrl',
                data: {kind_id: 1}
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除记录吗？', function () {
                OperationImport.delete({id: m.id}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                });
            });
        }

        function download() {
            Dlg.show({
                template: 'pages/insurance/import/exportDlg.html',
                ctrl: 'insuranceExportDlgCtrl',
                data: {kind_id: 1}
            }).then(function () {
                Dlg.s('手术质控记录表导出成功!');
            });
        }
    }

    /** @ngInject */
    function DrugImportCtrl($scope, OperationImport, Table, UIHelper, Dlg) {
        var vm = $scope;
        vm.excelImport = excelImport;
        vm.edit = edit;
        vm.remove = remove;
        vm.download = download;

        init();

        function init() {
            UIHelper.loadTab(vm, 'drug');

            var options = {
                service: OperationImport,
                params: {op: 'all_drug'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                showSn: true,
                // hideOpt: true,
                cols: [
                    {
                        field: "dept",
                        title: '科室',
                        filter: {dept: 'text'}
                    },
                    {field: "violation", title: '违反规则', filter: {violation: 'text'}},
                    {field: "type", title: '违规类型', filter: {type: 'text'}},
                    {field: "subject", title: '违规药品', filter: {subject: 'text'}},
                    {field: "reason", title: '整改建议', filter: {reason: 'text'}},
                    {field: "according", title: '依据', filter: {according: 'text'}},
                    {field: "happened_date", title: '发生日期', filter: {happened_date: 'date_range'}},
                    {field: "date", title: '规范落实日期', filter: {date: 'date_range'}},
                    {field: "measure", title: '科室整改措施', filter: {measure: 'text'}},
                    {field: "user", title: '科室整改措施填写人', filter: {user: 'text'}},
                    {field: "one_later_question", title: '第1月后质控出现问题', filter: {one_later_question: 'text'}},
                    {field: "two_later_question", title: '第2月后质控出现问题', filter: {two_later_question: 'text'}},
                    {field: "three_later_question", title: '第3月后质控出现问题', filter: {three_later_question: 'text'}},
                    {field: "important_time", title: '考察期后仍未整改例数', filter: {important_time: 'text'}},
                    {field: "punishment", title: '处理措施', filter: {punishment: 'text'}},
                    {field: "result", title: '整改效果', filter: {result: 'text'}}
                ]
            };

            Table.load(vm, options);
        }

        function edit(m) {
            Dlg.show({
                template: 'templates/importOperationEditDlg.html',
                ctrl: 'ImportOperationEditDlgCtrl',
                data: {id: m.id}
            }).then(function () {
                vm.tableReload();
            });
        }

        function excelImport() {
            Dlg.show({
                template: 'templates/importOperationDlg.html',
                ctrl: 'ImportOperationDlgCtrl',
                data: {kind_id: 2}
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除记录吗？', function () {
                OperationImport.delete({id: m.id}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                });
            });
        }

        function download() {
            Dlg.show({
                template: 'pages/insurance/import/exportDlg.html',
                ctrl: 'insuranceExportDlgCtrl',
                data: {kind_id: 2}
            }).then(function () {
                Dlg.s('药品质控记录表导出成功!');
            });
        }
    }

    /** @ngInject */
    function TreatmentImportCtrl($scope, OperationImport, Table, UIHelper, Dlg) {
        var vm = $scope;
        vm.excelImport = excelImport;
        vm.edit = edit;
        vm.remove = remove;
        vm.download = download;

        init();

        function init() {
            UIHelper.loadTab(vm, 'treatment');

            var options = {
                service: OperationImport,
                params: {op: 'all_treatment'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                showSn: true,
                // hideOpt: true,
                cols: [
                    {
                        field: "dept",
                        title: '科室',
                        filter: {dept: 'text'}
                    },
                    {field: "violation", title: '违反规则', filter: {violation: 'text'}},
                    {field: "type", title: '违规类型', filter: {type: 'text'}},
                    {field: "subject", title: '违规项目', filter: {subject: 'text'}},
                    {field: "reason", title: '整改建议', filter: {reason: 'text'}},
                    {field: "according", title: '依据', filter: {according: 'text'}},
                    {field: "happened_date", title: '发生日期', filter: {happened_date: 'date_range'}},
                    {field: "date", title: '规范落实日期', filter: {date: 'date_range'}},
                    {field: "measure", title: '科室整改措施', filter: {measure: 'text'}},
                    {field: "user", title: '科室整改措施填写人', filter: {user: 'text'}},
                    {field: "one_later_question", title: '第1月后质控出现问题', filter: {one_later_question: 'text'}},
                    {field: "two_later_question", title: '第2月后质控出现问题', filter: {two_later_question: 'text'}},
                    {field: "three_later_question", title: '第3月后质控出现问题', filter: {three_later_question: 'text'}},
                    {field: "important_time", title: '考察期后仍未整改例数', filter: {important_time: 'text'}},
                    {field: "punishment", title: '处理措施', filter: {punishment: 'text'}},
                    {field: "result", title: '整改效果', filter: {result: 'text'}}
                ]
            };

            Table.load(vm, options);
        }

        function edit(m) {
            Dlg.show({
                template: 'templates/importOperationEditDlg.html',
                ctrl: 'ImportOperationEditDlgCtrl',
                data: {id: m.id}
            }).then(function () {
                vm.tableReload();
            });
        }

        function excelImport() {
            Dlg.show({
                template: 'templates/importOperationDlg.html',
                ctrl: 'ImportOperationDlgCtrl',
                data: {kind_id: 3}
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除记录吗？', function () {
                OperationImport.delete({id: m.id}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                });
            });
        }

        function download() {
            Dlg.show({
                template: 'pages/insurance/import/exportDlg.html',
                ctrl: 'insuranceExportDlgCtrl',
                data: {kind_id: 3}
            }).then(function () {
                Dlg.s('诊疗质控记录表导出成功!');
            });
        }

    }

    function ImportOperationDlgCtrl($uibModalInstance, $q, Dlg, OperationImport, FormHelper, FileHelper, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.upload = upload;
        vm.download = download;

        init();


        function init() {
            vm.m = {
                doc: {}
            };
        }

        function upload(file, m, e) {
            FileHelper.uploadSingle(file, m, e);
        }

        function ok(m) {
            var defer = $q.defer();
            if (vm.Form.$valid) {
                if (!m.doc.filename) {
                    var name = data.kind_id === 1 ? '手术' : (data.kind_id === 2 ? '药品' : '诊疗');
                    Dlg.w('请上传' + name + '质控的excel文档');
                    defer.reject();
                } else {
                    OperationImport.query({
                        op: 'excel',
                        filename: m.doc.filename,
                        kind_id: data.kind_id
                    }, function (resp) {
                        var msg = '上传完毕' + resp.msg;
                        vm.loading = false;
                        Dlg.s(msg);
                        $uibModalInstance.close();
                    }, function () {
                        vm.loading = false;
                        Dlg.e('上传失败');
                    });
                    defer.reject();
                }
            } else {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            }
            return defer.promise;
        }

        function download() {
            FileHelper.download1(OperationImport.EXCEL_DOWNLOAD, {
                filename: 'docTemp/insuranceExport.xlsx',
                mime: 'application/wps-office.xlsx',
                name: '医保质控导入模板.xlsx'
            });
        }
    }

    function ImportOperationEditDlgCtrl($scope, Table, UIHelper, Dlg, data, FileHelper, DateHelper,
                                        $uibModalInstance, ArrayHelper, FormHelper, Auth, OperationImport) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;

        init(data.id);

        function init(id) {
            if (id) {
                OperationImport.get({
                    id: id,
                }).$promise.then(function (resp) {
                    vm.m = resp.item;
                });
            } else {
                vm.m = {}
            }
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    dept: m.dept,
                    violation: m.violation,
                    type: m.type,
                    subject: m.subject,
                    reason: m.reason,
                    according: m.according,
                    happened_date: DateHelper.date2Str(m.happened_date),
                    date: DateHelper.date2Str(m.date),
                    measure: m.measure,
                    one_later_question: m.one_later_question,
                    two_later_question: m.two_later_question,
                    three_later_question: m.three_later_question,
                    important_time: m.important_time,
                    punishment: m.punishment,
                    result: m.result,
                    note: m.note,
                    op: 'default'
                };

                OperationImport.update({id: m.id}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('c.s')
        .controller('userInsuranceEditDlgCtrl', userInsuranceEditDlgCtrl);

    /** @ngInject */
    function userInsuranceEditDlgCtrl($scope, OperationImport, FileHelper, FormHelper, $uibModalInstance, data, Dlg) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.submit = submit;

        init(data.id);

        function init(id) {
            if (id) {
                OperationImport.get({
                    id: id,
                }).$promise.then(function (resp) {
                    vm.m = resp.item;
                });
            } else {
                vm.m = {};
            }
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    measure: m.measure,
                    op: 'feedback'
                };

                OperationImport.update({id: m.id}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateSsDeptCtrl', IrDateSsDeptCtrl);

    /** @ngInject */
    function IrDateSsDeptCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = deptExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];
        init();

        function init() {
            UIHelper.loadTab(vm, 'dept');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'dept', start: DateHelper.date2Str(vm.start), end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val,
                    type: 2
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "dept", title: "科室", width: 150, filter: {dept: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}

                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);

            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function deptExport() {
            Dlg.show({
                template: 'pages/ir/dateSs/exportDlg.html',
                ctrl: 'IrDateExportDlgCtrl',
                data: {type: '科室', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }


    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateSsDetailsCtrl', IrDateSsDetailsCtrl);

    /** @ngInject */
    function IrDateSsDetailsCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        vm.add = add;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = detailsExport;
        vm.sort = {val: 'start', name: '开台时间'};
        vm.sorts = [{val: 'start', name: '开台时间'}, {val: 'end', name: '结束时间'}, {val: 'interval', name: '接台时间'}];
        var options;

        init();

        function init() {
            UIHelper.loadTab(vm, 'dateSs');
            options = {
                service: OpDateSs,
                params: {
                    op: 'default',
                    start: DateHelper.date2Str(vm.start),
                    end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val,
                    type: 2
                },
                hideOpt: true,
                cols: [
                    {field: "name", title: "医生", width: 120, filter: {name: "text"}},
                    {field: "nurse", title: "护士", width: 120, filter: {nurse: "text"}},
                    {field: "dept", title: "科室", width: 120, filter: {dept: "text"}},
                    {field: "room", title: "手术间", width: 60, filter: {room: "text"}},
                    {field: "ns", title: "台次", width: 60, filter: {ns: "text"}},
                    {field: "date", title: "日期", filter: {date: "text"}},
                    {field: "start", title: "开始时间"},
                    {field: "end", title: "结束时间"},
                    {field: "interval", title: "接台时间"}


                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);


            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function add() {
            Dlg.show({
                template: 'pages/ir/dateSsDlg.html',
                ctrl: 'IrDateSsDlgCtrl',
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function detailsExport() {
            Dlg.show({
                template: 'pages/ir/dateSs/exportDlg.html',
                ctrl: 'IrDateExportDlgCtrl',
                data: {type: '详情', start: now, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }

    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateSsDoctorCtrl', IrDateSsDoctorCtrl);

    /** @ngInject */
    function IrDateSsDoctorCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = doctorExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];
        init();

        function init() {
            UIHelper.loadTab(vm, 'doctor');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'doctor', start: DateHelper.date2Str(vm.start), end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val,
                    type: 2
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "name", title: "医生", width: 120, filter: {name: "text"}},
                    {field: "dept", title: "科室", width: 120, filter: {dept: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}

                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);


            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function doctorExport() {
            Dlg.show({
                template: 'pages/ir/dateSs/exportDlg.html',
                ctrl: 'IrDateExportDlgCtrl',
                data: {type: '医生', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }


    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateExportDlgCtrl', IrDateExportDlgCtrl);

    /** @ngInject */
    function IrDateExportDlgCtrl($uibModalInstance, Dlg, FileHelper, data, ArrayHelper, DateHelper, $q) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.submit = submit;

        init(data);


        function init(data) {
            vm.loading = true;
            vm.m = {start: data.start, end: data.end};
            vm.loading = false;

        }

        function submit(m, Form) {
            console.log(m);
            var defer = $q.defer();
            if (Form.$valid) {
                var pa = {
                    start: DateHelper.date2Str(m.start),
                    end: DateHelper.date2Str(m.end),
                    type: data.type,
                    type2: 2
                };

                FileHelper.dnExcel('/api/v1/op_date_ss/export', pa, DateHelper.date2Str(m.start) + '到' + DateHelper.date2Str(m.end) + data.type + '手术时间统计表.xls', function () {
                    vm.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateSsNotPunctualCtrl', IrDateSsNotPunctualCtrl);

    /** @ngInject */
    function IrDateSsNotPunctualCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        vm.add = add;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = detailsExport;
        vm.sort = {val: 'start', name: '开始时间'};
        vm.sorts = [{val: 'start', name: '开始时间'}, {val: 'end', name: '结束时间'}];
        var options;

        init();

        function init() {
            UIHelper.loadTab(vm, 'dateSs');
            options = {
                service: OpDateSs,
                params: {
                    op: 'not_punctual',
                    start: DateHelper.date2Str(vm.start),
                    end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val,
                    type: 2
                },
                hideOpt: true,
                cols: [
                    {field: "name", title: "医生", width: 120, filter: {name: "text"}},
                    {field: "nurse", title: "护士", width: 120, filter: {nurse: "text"}},
                    {field: "dept", title: "科室", width: 120, filter: {dept: "text"}},
                    {field: "room", title: "手术间", width: 60, filter: {room: "text"}},
                    {field: "date", title: "日期", filter: {date: "text"}},
                    {field: "start", title: "开始时间"},
                    {field: "end", title: "结束时间"}
                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);


            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function add() {
            Dlg.show({
                template: 'pages/ir/dateSsDlg.html',
                ctrl: 'IrDateSsDlgCtrl',
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function detailsExport() {
            Dlg.show({
                template: 'pages/ir/dateSs/exportDlg.html',
                ctrl: 'IrDateExportDlgCtrl',
                data: {type: '未准时', start: now, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }

    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateSsNurseCtrl', IrDateSsNurseCtrl);

    /** @ngInject */
    function IrDateSsNurseCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = nurseExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];
        init();

        function init() {
            UIHelper.loadTab(vm, 'nurse');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'nurse', start: DateHelper.date2Str(vm.start), end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val,
                    type: 2
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "name", title: "护士", width: 150, filter: {name: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}
                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);

            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function nurseExport() {
            Dlg.show({
                template: 'pages/ir/dateSs/exportDlg.html',
                ctrl: 'IrDateExportDlgCtrl',
                data: {type: '护士', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }


    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('IrDateSsRoomCtrl', IrDateSsRoomCtrl);

    /** @ngInject */
    function IrDateSsRoomCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = roomExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];

        init();

        function init() {
            UIHelper.loadTab(vm, 'room');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'room',
                    start: DateHelper.date2Str(vm.start),
                    end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val,
                    type: 2
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "name", title: "手术间", width: 150, filter: {name: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}
                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);

            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function roomExport() {
            Dlg.show({
                template: 'pages/ir/dateSs/exportDlg.html',
                ctrl: 'IrDateExportDlgCtrl',
                data: {type: '手术间', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }
    }

})();

(function() {
    'use strict';

    angular.module('c.c')
        .controller('IRPendingCtrl', IRPendingCtrl);

    /** @ngInject */
    function IRPendingCtrl($scope, UIHelper, Table, SaveAs, FileHelper, C, OperationPermit,
                           ArrayHelper, Dlg) {
        var vm = $scope;
        var types = ArrayHelper.get('or_types');
        vm.confirm = confirm;
        vm.returnOP = returnOP;
        vm.download = download;


        init();


        function init() {
            UIHelper.loadTab(vm, 'pending');
            var typeOpts = Table.getNgTableOpts(types);
            var options = {
                service: OperationPermit,
                params: {opt: 6},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name'}, //0
                    {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id'}, //1
                    {title: '递交人', field: 'applicant', filter: {applicant: 'text'}}, //6
                    {title: '递交科室', filter: {dept: 'text'}, field: 'dept'},
                    {
                        title: '递交时间',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }, //6
                    {title: '备注', field: 'remark'} //1
                ]
            };

            Table.load(vm, options, function(resp) {
                angular.forEach(resp.items, function(m) {
                    m.type = ArrayHelper.getItem(m.type_id, types);
                });
            });
        }

        function confirm(m) {
            OperationPermit.update({id: m.id}, {stage: 2, type: 3}).$promise.then(function() {
                Dlg.s('确认成功!');
                vm.tableReload();
            }, function() {
                Dlg.e('确认失败!');
            });
        }

        function returnOP(m) {
            Dlg.confirm('确定要退回此手术通知单吗?', function() {
                OperationPermit.update({id: m.id}, {stage: 3}).$promise.then(function() {
                    Dlg.s('已退回!');
                    vm.tableReload();
                }, function() {
                    Dlg.e('操作失败!');
                });
            }, '退回手术通知单');
        }

        function download(m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function(resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function() {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('IRProcessedCtrl', IRProcessedCtrl);

    /** @ngInject */
    function IRProcessedCtrl($scope, UIHelper, Table, SaveAs, FileHelper, C, OperationPermit,
                             ArrayHelper, Dlg) {
        var vm = $scope;
        var types = ArrayHelper.get('or_types');
        vm.cancel = cancel;
        vm.download = download;


        init();


        function init() {
            UIHelper.loadTab(vm, 'processed');
            var typeOpts = Table.getNgTableOpts(types);
            var options = {
                service: OperationPermit,
                params: {opt: 7},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name'}, //0
                    {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id'}, //1
                    {title: '递交人', field: 'applicant', filter: {applicant: 'text'}}, //6
                    {title: '递交科室', filter: {dept: 'text'}, field: 'dept'},
                    {
                        title: '递交时间',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }, //6
                    {title: '确认时间', field: 'updated_at'}, //6
                    {title: '备注', field: 'remark'} //1
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (m) {
                    m.type = ArrayHelper.getItem(m.type_id, types);
                });
            });
        }

        function cancel(m) {
            Dlg.confirm('确定要退回此手术通知单吗?', function () {
                OperationPermit.update({id: m.id}, {stage: 3}).$promise.then(function () {
                    Dlg.s('已退回!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('操作失败!');
                });
            }, '撤销手术通知单');
        }

        function download(m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalOfficeTopicController', HospitalOfficeTopicController);

    /** @ngInject */
    function HospitalOfficeTopicController($scope, Table, ArrayHelper, MeetingTopic, UIHelper,
                                           NgTableParams, Dlg) {
        var vm = $scope;
        vm.detail = detail;

        init();

        function init() {
            UIHelper.loadTab(vm, 'applied');
            var stages = ArrayHelper.get('approval_stages4');
            var stagesOpts = Table.getNgTableOpts(stages);
            var topic_types = ArrayHelper.get('topic_types');
            var topic_typesOpts = Table.getNgTableOpts(topic_types);
            var yesNoOpts = Table.getNgTableOpts(ArrayHelper.get('yesNo'));
            var options = {
                service: MeetingTopic,
                params: {opt: 100},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: 'is_public', title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, width: '10%'},
                    {field: 'is_triple', title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, width: '10%'},
                    {field: 'subject', title: '标题', filter: {subject: 'text'}},
                    {
                        field: 'type',
                        title: '类型',
                        sortable: 'type',
                        filter: {type: 'select'},
                        data: topic_typesOpts,
                        width: '10%'
                    },
                    {field: 'dept', title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}},
                    {
                        field: 'created_at',
                        title: '申请时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        width: '20%'
                    },
                    {field: 'stage', title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%'}
                ]
            };


            loadTable(vm, options, function (resp) {
                angular.forEach(resp.topics, function (item) {
                    item.stage = ArrayHelper.getItem(item.stage, stages);
                    item.type = ArrayHelper.getItem(item.type, topic_types);
                });
            });
        }

        function loadTable(scope, options, cb) {
            scope.cols = options.cols;
            angular.forEach(scope.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            scope.optColWidth = options.optColWidth;
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.showSn = options.showSn;
            scope.optInFront = options.optInFront;
            scope.cbWidth = options.cbWidth ? options.cbWidth : 62;
            scope.tableParams = new NgTableParams({
                count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                        id: 'desc'
                    }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50],
                getData: function ($defer, params) {
                    if ((options.primaryParam && !options.params[options.primaryParam]) || (
                            options.primaryFilter && !params.filter()[options.primaryFilter]
                        )) {
                        //return $defer.resolve([]);
                    } else {
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        return queryItems(options.service, url, $defer, params, null, cb);
                    }
                }
            });

            scope.clearFilters = function () {
                scope.tableParams.filter({});
            };

            scope.tableReload = function () {
                scope.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }
        
        function detail(m) {
            Dlg.show({
                template: 'templates/meeting_topic/show_dlg.html',
                ctrl: 'TopicShowDlgCtrl',
                data: {id:m.id},
                size: 'lg'
            });
        }

        function queryItems(service, url, $defer, params, items, cb) {
            if (items === null) {
                items = 'items';
            }
            service.query(url, function (data) {
                if (data.total > 0 && data['topics'].length === 0) {
                    params.$params.page = params.page() - 1;
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb)) {
                        cb(data, (params.page() - 1) * params.count());
                    }
                    $defer.resolve(data['topics']);
                }
            });
        }
    }

})();


angular.module('c.c').controller('TopicSearch2Controller',
    function ($scope, $rootScope, $filter, $timeout, $state, dialogs, toaster, NgTableParams, F, C, MeetingTopic, Doc) {
        $scope.$on('topicApproved', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '类型', sortable: 'type', filter: {type: 'select'}, data: topic_typesOpts, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {title: '处理时间', sortable: 'updated_at', filter: {updated_at: 'date_range'}, width: '20%', show: true},
            {title: '处理人', filter: {handler: 'text'}, show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //退回补充议题8，不讨论议题,9，已讨论议题10，会签议题11
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                    });
                    $defer.resolve(resp.topics);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {id: topic.id, ForSealUp: true},
                {size: 'lg'});
        };

        //File.add_readers().$promise.then(function (resp) {
        //    switch (resp.result) {
        //        case 0:
        //            $scope.canCirculate = false;
        //            break;
        //        case 1:
        //            $scope.canCirculate = true;
        //            break;
        //    }
        //});

        //$scope.newFile = function (topic) {
        //    $state.go('app.file_circulate', {
        //        data: {
        //            tab: 'new',
        //            event: 'topic2File',
        //            topic: topic
        //        }
        //    });
        //};

        //$scope.newFile2 = function (topic) {
        //    if ($scope.canCirculate) {
        //        $state.go('app.coop_file', {
        //            data: {
        //                tab: 'new',
        //                event: 'topic2File',
        //                topic: topic
        //            }
        //        });
        //    }
        //};

        $scope.topic2doc = function (topic) {
            dialogs.create('templates/rule/rule2doc.html', 'Rule2DocDlgCtrl', {topic: topic, isTopic: true},
                {size: 'lg'}).result.then(function (params) {
                Doc.save(params).$promise.then(function () {
                    toaster.success('转会签提交成功!');
                }, function () {
                    toaster.error('转会签提交失败!');
                });
            });
        }

    });


angular.module('c.c').controller('TopicManageController',
    function ($scope, $rootScope, $filter, dialogs, toaster, NgTableParams, F, C, MeetingTopic) {
        $scope.$on('topicEdit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '类型', sortable: 'type', filter: {type: 'select'}, data: topic_typesOpts, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {
                title: '分管院领导审批时间',
                sortable: 'hospital_approval_time',
                filter: {hospital_approval_time: 'date_range'},
                width: '20%',
                show: true
            }
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                hospital_approval_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.MEETING_TOPIC.INDEX.TO_BE_DISCUSSED_MANAGE;
                if ($scope.dateRangeFilter.hospital_approval_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.hospital_approval_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.hospital_approval_time.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                    });
                    $defer.resolve(resp.topics);
                    $scope.topics = resp.topics;
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {
                    id: topic.id, ForHandle: true
                },
                {size: 'lg'});
        };

        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (topic, topics) {
            if (topic.is_checked) {
                $scope.header.checkAll = true;
            } else {
                var allUnchecked = true;
                for (var i = 0; i < topics.length; i++) {
                    if (topics[i].is_checked) {
                        allUnchecked = false;
                        break;
                    }
                }
                if (allUnchecked) {
                    $scope.header.checkAll = false;
                }
            }
        };

        $scope.checkAllFn = function (checkAll, topics) {
            if (checkAll) {
                angular.forEach(topics, function (topic) {
                    topic.is_checked = true;
                })
            } else {
                angular.forEach(topics, function (topic) {
                    topic.is_checked = false;
                })
            }
        };

        $scope.print = function (data) {
            var topics = [];
            if (angular.isArray(data)) {
                angular.forEach(data, function (topic) {
                    if (topic.is_checked) {
                        topics.push({
                            id: topic.id, subject: topic.subject,
                            type: topic.type.id, sender: topic.applicant.name,
                            rapporteurs: topic.rapporteurs, observers: topic.observers
                        });
                    }
                });
            } else {
                topics.push({
                    id: data.id, subject: data.subject,
                    type: data.type.id, sender: data.applicant.name,
                    rapporteurs: data.rapporteurs, observers: data.observers
                });
            }
            dialogs.create('templates/meeting_topic/print_dlg.html', 'TopicPrintDlgCtrl', {
                    topics: topics,
                    account: $scope.account
                },
                {size: 'md'});
        }
    });






angular.module('c.c').controller('TopicManageBackupController',
    function ($scope, $rootScope, $filter, dialogs, toaster, NgTableParams, F, C, MeetingTopic) {
        $scope.$on('topicEdit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '类型', sortable: 'type', filter: {type: 'select'}, data: topic_typesOpts, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {
                title: '分管院领导审批时间',
                sortable: 'hospital_approval_time',
                filter: {hospital_approval_time: 'date_range'},
                width: '20%',
                show: true
            }
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                hospital_approval_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.MEETING_TOPIC.INDEX.TO_BE_DISCUSSED_MANAGE;
                if ($scope.dateRangeFilter.hospital_approval_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.hospital_approval_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.hospital_approval_time.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                    });
                    $defer.resolve(resp.topics);
                    $scope.topics = resp.topics;
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {
                    id: topic.id, ForHandle: true, ForUserToEdit: true
                },
                {size: 'lg'});
        };

        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (topic, topics) {
            if (topic.is_checked) {
                $scope.header.checkAll = true;
            } else {
                var allUnchecked = true;
                for (var i = 0; i < topics.length; i++) {
                    if (topics[i].is_checked) {
                        allUnchecked = false;
                        break;
                    }
                }
                if (allUnchecked) {
                    $scope.header.checkAll = false;
                }
            }
        };

        $scope.checkAllFn = function (checkAll, topics) {
            if (checkAll) {
                angular.forEach(topics, function (topic) {
                    topic.is_checked = true;
                })
            } else {
                angular.forEach(topics, function (topic) {
                    topic.is_checked = false;
                })
            }
        };

        $scope.print = function (data) {
            var topics = [];
            if (angular.isArray(data)) {
                angular.forEach(data, function (topic) {
                    if (topic.is_checked) {
                        topics.push({
                            id: topic.id, subject: topic.subject,
                            type: topic.type.id, sender: topic.applicant.name,
                            rapporteurs: topic.rapporteurs, observers: topic.observers
                        });
                    }
                });
            } else {
                topics.push({
                    id: data.id, subject: data.subject,
                    type: data.type.id, sender: data.applicant.name,
                    rapporteurs: data.rapporteurs, observers: data.observers
                });
            }
            dialogs.create('templates/meeting_topic/print_dlg.html', 'TopicPrintDlgCtrl', {
                    topics: topics,
                    account: $scope.account
                },
                {size: 'md'});
        }
    });






(function () {
    'use strict';

    angular.module('c.c')
        .controller('RuleHospitalOfficeApprovalCommentCtrl', RuleHospitalOfficeApprovalCommentCtrl);

    function RuleHospitalOfficeApprovalCommentCtrl($scope, Table, Rule, UIHelper, Dlg) {
        var vm = $scope;
        vm.approval = approval;
        vm.show = show;

        init();

        function init() {
            UIHelper.loadTab(vm, 'approvalComment');
            var options = {
                service: Rule,
                params: {opt: 36, forApproval: 1},
                optColWidth: Table._2_BTN,
                optInFront: true,
                cols: [
                    {field: "sn", title: "序号", width: Table._1_CHAR},
                    {field: "rule", title: "制度", filter: {rule: "text"}, width: Table._5_CHAR},
                    {field: "remark", title: "评论", filter: {remark: "text"}},
                    {field: "user", title: "用户", filter: {user: "text"}, width: Table._2_CHAR},
                    {field: "created_at", title: "时间", filter: {created_at: "date_range"}, width: Table._3_CHAR}
                ]
            };
            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn);
            });
        }

        function approval(m) {
            Dlg.addEdit(vm, 'templates/rule/reply_dlg.html', 'RuleReplyDlgCtrl', m, {ruleId: m.rule_id});
        }

        function show(m) {
            Dlg.show({
                template: 'templates/rule/show_dlg.html',
                ctrl: 'RuleShowDlgCtrl',
                data: {id: m.rule_id},
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('RuleHospitalOfficeApprovedCommentCtrl', RuleHospitalOfficeApprovedCommentCtrl);

    function RuleHospitalOfficeApprovedCommentCtrl($scope, Table, Rule, UIHelper, Dlg) {
        var vm = $scope;
        vm.download = download;
        vm.show = show;

        init();

        function init() {
            UIHelper.loadTab(vm, 'approvedComment');
            var options = {
                service: Rule,
                params: {opt: 36, forApproved: 1},
                optColWidth: Table._1_BTN,
                hideOpt: true,
                cols: [
                    {field: "sn", title: "序号", width: Table._1_CHAR},
                    {field: "rule", title: "制度", filter: {rule: "text"}, width: Table._5_CHAR},
                    {field: "remark", title: "评论", filter: {remark: "text"}},
                    {field: "user", title: "用户", filter: {user: "text"}, width: Table._2_CHAR},
                    {field: "created_at", title: "时间", filter: {created_at: "date_range"}, width: Table._3_CHAR},
                    {field: "reply", title: "回复", filter: {reply: "text"}},
                    {field: "handler", title: "回复人", filter: {handler: "text"}, width: Table._2_CHAR},
                ]
            };
            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn);
            });
        }

        function download() {
            Dlg.exportDR('/api/v1/rules/comment', '制度评论表');
        }

        function show(m) {
            Dlg.show({
                template: 'templates/rule/show_dlg.html',
                ctrl: 'RuleShowDlgCtrl',
                data: {id: m.rule_id},
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
angular.module('c.c').controller('RuleHospitalOfficeManageCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, Table, F, C, RuleType, Dept, Rule,
              Doc, MeetingTopic, Bulletin) {
        $scope.$on('ruleHandle', function () {
            $scope.tableParams.reload();
        });

        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);
        $scope.states = F.get('rule_states');
        var statesOpts = F.getNgTableOpts($scope.states);

        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            // {title: '类型', sortable: 'type_id', filter: {type: 'text'}, show: true},
            // {title: '发布科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {title: '发布时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '审核类型', filter: {state: 'select'}, data: statesOpts, show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts.slice(2, 8), width: '10%', show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = Table._5_BTN;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.RULE.INDEX.HOSPITAL_OFFICE_MANAGE;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    $scope.types = data.rule_types;
                    $scope.types.unshift({id: '', name: '全部'});
                    angular.forEach(data.rules, function (rule) {
                        rule.stage = F.getItem(rule.stage, $scope.stages);
                        rule.state = F.getItem(rule.state, $scope.states);
                    });
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
                id: rule.id,
                ForHandle: true,
                ForPrint: true
            }, {

                size: 'lg'
            });
        };

        $scope.rule2doc = function (rule) {
            dialogs.create('templates/rule/rule2doc.html', 'Rule2DocDlgCtrl', {rule: rule, isRule: true},
                {size: 'lg'}).result.then(function (params) {
                Doc.save(params).$promise.then(function () {
                    toaster.success('转会签提交成功!');
                }, function () {
                    toaster.error('转会签提交失败!');
                });
            });
        };

        $scope.rule2topic = function (rule) {
            dialogs.create('templates/rule/rule2topic.html', 'Rule2TopicDlgCtrl', {rule: rule},
                {size: 'lg'}).result.then(function (params) {
                MeetingTopic.save(params).$promise.then(function () {
                    toaster.success('转议题提交成功!');
                }, function () {
                    toaster.error('转议题提交失败了!');
                });
            });
        };

        $scope.rule2bulletin = function (rule) {
            dialogs.create('templates/rule/rule2bulletin.html', 'Rule2BulletinDlgCtrl', {rule: rule},
                {size: 'lg'}).result.then(function (params) {
                Bulletin.save(params).$promise.then(function () {
                    toaster.success('转公告发布成功!');
                }, function () {
                    toaster.error('转公告发布失败了!');
                });
            });
        };

        $scope.export = function () {
            dialogs.create('templates/rule/export_dlg.html', 'RuleExportCtrl', {isOffice: true},
                {size: 'md'});
        };

        $scope.edit = function (rule) {
            dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                    id: rule.id, ForEdit: true, isHospitalOffice: true
                },
                {size: 'lg'}).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function () {
                        toaster.success('规章制度修改成功');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('规章制度修改失败了!');
                    }
                );
            });
        };

        $scope.redHead = function (rule) {
            dialogs.confirm('规章制度套红头', '确定该规章制度进行套红头审批吗?')
                .result.then(function () {
                Rule.update({id: rule.id}, {
                    opt: C.OPT.RULE.EDIT.RED_HEAD_MANAGE,
                    subject: rule.subject,
                    with_sms: rule.with_sms
                })
                    .$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('规章制度套红头成功');
                            $scope.tableParams.reload();
                            $scope.tabs['red_head'] = true;
                            $rootScope.$broadcast('ruleRedHead');
                            break;
                        case 2:
                            toaster.warning('请先在基础设置中设置套红头审批人!');
                            break;
                    }
                }, function () {
                    toaster.error('规章制度套红头失败了!!');
                });
            });
        }


        $scope.deleteRule = function (rule) {
            dialogs.confirm('删除规章制度', '确定要删除<strong>' + rule.subject + '</strong>吗?').result.then(function () {
                Rule.delete({id: rule.id}).$promise.then(
                    function (resp) {
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('删除失败!');
                    }
                );
            });
        }

        $scope.showComment = function (rule) {
            dialogs.create(
                'templates/rule/show_comment_dlg.html',
                'RuleShowCommentDlgCtrl',
                {id: rule.id, forAll: true},
                {
                    size: 'lg'
                }
            );
        };
    });


angular.module('c.c').controller('RuleRedHeadSearchController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, Table, F, C, RuleType, Dept, Rule) {
        $scope.$on('ruleRedHead', function () {
            $scope.tableParams.reload();
        });

        $scope.stages = F.get('approval_stages7');
        var stagesOpts = F.getNgTableOpts($scope.stages);

        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            {title: '类型', sortable: 'type_id', filter: {type: 'text'}, show: true},
            {title: '发布科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {title: '发布时间', sortable: 'release_time', filter: {release_time: 'date_range'}, width: '20%', show: true},
            {title: '状态', filter: {red_head: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                release_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.RULE.INDEX.RED_HEAD_SEARCH;
                if ($scope.dateRangeFilter.release_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.release_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.release_time.endDate, 'yyyy-MM-dd');
                }
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    angular.forEach(data.rules, function (rule) {
                        rule.red_head = F.getItem(rule.red_head, $scope.stages);
                    });
                });
            }
        });

        $scope.redHead = function (rule) {
            dialogs.confirm('规章制度套红头', '确定该规章制度进行套红头审批吗?')
                .result.then(function () {
                Rule.update({id: rule.id}, {
                    opt: C.OPT.RULE.EDIT.RED_HEAD_MANAGE,
                    subject: rule.subject,
                    with_sms: rule.with_sms
                })
                    .$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('规章制度套红头成功');
                            $scope.tableParams.reload();
                            break;
                        case 2:
                            toaster.warning('请先在基础设置中设置套红头审批人!');
                            break;
                    }
                }, function () {
                    toaster.error('规章制度套红头失败了!!');
                });
            });
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {id: rule.id}, {

                size: 'lg'
            });
        }
    });


angular.module('c.c').controller('RuleOfficeApprovedController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Table, C, RuleType, Dept, Rule) {
        $scope.$on('ruleApproved', function () {
            $scope.tableParams.reload();
        });

        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);
        $scope.states = F.get('rule_states');
        var statesOpts = F.getNgTableOpts($scope.states);


        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            {title: '科室', filter: {dept: 'text'}, show: true},
            {title: '发布时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '审核类型', filter: {state: 'select'}, data: statesOpts, show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = Table._2_BTN;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.RULE.INDEX.INDEX_OFFICE_APPROVED;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    angular.forEach(data.rules, function (rule) {
                        rule.stage = F.getItem(rule.stage, $scope.stages);
                        rule.state = F.getItem(rule.state, $scope.states);
                    });
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {id: rule.id}, {
                size: 'lg'
            });
        }

        $scope.showComment = function (rule) {
            dialogs.create(
                'templates/rule/show_comment_dlg.html',
                'RuleShowCommentDlgCtrl',
                {id: rule.id, forAll: true},
                {
                    size: 'lg'
                }
            );
        };
    });


angular.module('c.c').controller('MedicalRuleCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, Table, F, C, RuleType, Dept, Rule) {
        $scope.$on('ruleHandle', function () {
            $scope.tableParams.reload();
        });

        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);
        $scope.states = F.get('rule_states');
        var statesOpts = F.getNgTableOpts($scope.states);

        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            // {title: '类型', sortable: 'type_id', filter: {type: 'text'}, show: true},
            {title: '发布科室', sortable: 'dept_id', filter: {dept: 'text'}, show: true},
            {title: '发布时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '审核类型', filter: {state: 'select'}, data: statesOpts, show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts.slice(2, 8), width: '10%', show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.RULE.INDEX.MEDICAL;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    angular.forEach(data.rules, function (rule) {
                        rule.stage = F.getItem(rule.stage, $scope.stages);
                        rule.state = F.getItem(rule.state, $scope.states);
                    });
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
                id: rule.id,
                ForHandle: true,
                ForPrint: true
            }, {

                size: 'lg'
            });
        };

        $scope.export = function () {
            dialogs.create('templates/rule/export_dlg.html', 'RuleExportCtrl', {isOffice: true},
                {size: 'md'});
        };

        $scope.edit = function (rule) {
            dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                    id: rule.id, ForEdit: true, isHospitalOffice: true
                },
                {size: 'lg'}).result.then(function (params) {
                    Rule.update({id: rule.id}, params).$promise.then(
                        function () {
                            toaster.success('规章制度修改成功');
                            $scope.tableParams.reload();
                        }, function () {
                            toaster.error('规章制度修改失败了!');
                        }
                    );
                });
        };

        $scope.redHead = function (rule) {
            dialogs.confirm('规章制度套红头', '确定该规章制度进行套红头审批吗?')
                .result.then(function () {
                    Rule.update({id: rule.id}, {
                        opt: C.OPT.RULE.EDIT.RED_HEAD_MANAGE,
                        subject: rule.subject,
                        with_sms: rule.with_sms
                    })
                        .$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0:
                                    toaster.success('规章制度套红头成功');
                                    $scope.tableParams.reload();
                                    $scope.tabs['red_head'] = true;
                                    $rootScope.$broadcast('ruleRedHead');
                                    break;
                                case 2:
                                    toaster.warning('请先在基础设置中设置套红头审批人!');
                                    break;
                            }
                        }, function () {
                            toaster.error('规章制度套红头失败了!!');
                        });
                });
        }
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('OrDateSsDeptCtrl', OrDateSsDeptCtrl);

    /** @ngInject */
    function OrDateSsDeptCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = deptExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];
        init();

        function init() {
            UIHelper.loadTab(vm, 'dept');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'dept', start: DateHelper.date2Str(vm.start), end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "dept", title: "科室", width: 150, filter: {dept: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}

                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);

            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function deptExport() {
            Dlg.show({
                template: 'pages/nursing/dateSs/exportDlg.html',
                ctrl: 'OpDateExportDlgCtrl',
                data: {type: '科室', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }


    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('OrDateSsDetailsCtrl', OrDateSsDetailsCtrl);

    /** @ngInject */
    function OrDateSsDetailsCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        vm.add = add;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = detailsExport;
        vm.sort = {val: 'start', name: '开台时间'};
        vm.sorts = [{val: 'start', name: '开台时间'}, {val: 'end', name: '结束时间'}, {val: 'interval', name: '接台时间'}];
        var options;

        init();

        function init() {
            UIHelper.loadTab(vm, 'dateSs');
            options = {
                service: OpDateSs,
                params: {
                    op: 'default',
                    start: DateHelper.date2Str(vm.start),
                    end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val
                },
                hideOpt: true,
                cols: [
                    {field: "name", title: "医生", width: 120, filter: {name: "text"}},
                    {field: "nurse", title: "护士", width: 120, filter: {nurse: "text"}},
                    {field: "dept", title: "科室", width: 120, filter: {dept: "text"}},
                    {field: "room", title: "手术间", width: 60, filter: {room: "text"}},
                    {field: "ns", title: "台次", width: 60, filter: {ns: "text"}},
                    {field: "date", title: "日期", filter: {date: "text"}},
                    {field: "start", title: "开始时间"},
                    {field: "end", title: "结束时间"},
                    {field: "interval", title: "接台时间"}


                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);


            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function add() {
            Dlg.show({
                template: 'pages/nursing/dateSsDlg.html',
                ctrl: 'OrDateSsDlgCtrl',
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function detailsExport() {
            Dlg.show({
                template: 'pages/nursing/dateSs/exportDlg.html',
                ctrl: 'OpDateExportDlgCtrl',
                data: {type: '详情', start: now, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }

    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('OrDateSsDoctorCtrl', OrDateSsDoctorCtrl);

    /** @ngInject */
    function OrDateSsDoctorCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = doctorExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];
        init();

        function init() {
            UIHelper.loadTab(vm, 'doctor');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'doctor', start: DateHelper.date2Str(vm.start), end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "name", title: "医生", width: 120, filter: {name: "text"}},
                    {field: "dept", title: "科室", width: 120, filter: {dept: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}

                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);


            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function doctorExport() {
            Dlg.show({
                template: 'pages/nursing/dateSs/exportDlg.html',
                ctrl: 'OpDateExportDlgCtrl',
                data: {type: '医生', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }


    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('OpDateExportDlgCtrl', OpDateExportDlgCtrl);

    /** @ngInject */
    function OpDateExportDlgCtrl($uibModalInstance, Dlg, FileHelper, data, ArrayHelper, DateHelper, $q) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.submit = submit;

        init(data);


        function init(data) {
            vm.loading = true;
            vm.m = {start: data.start, end: data.end};
            vm.loading = false;

        }

        function submit(m, Form) {
            console.log(m);
            var defer = $q.defer();
            if (Form.$valid) {
                var pa = {
                    start: DateHelper.date2Str(m.start),
                    end: DateHelper.date2Str(m.end),
                    type: data.type
                };

                FileHelper.dnExcel('/api/v1/op_date_ss/export', pa, DateHelper.date2Str(m.start) + '到' + DateHelper.date2Str(m.end) + data.type + '手术时间统计表.xls', function () {
                    vm.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('OrDateSsNotPunctualCtrl', OrDateSsNotPunctualCtrl);

    /** @ngInject */
    function OrDateSsNotPunctualCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        vm.add = add;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = detailsExport;
        vm.sort = {val: 'start', name: '开始时间'};
        vm.sorts = [{val: 'start', name: '开始时间'}, {val: 'end', name: '结束时间'}];
        var options;

        init();

        function init() {
            UIHelper.loadTab(vm, 'dateSs');
            options = {
                service: OpDateSs,
                params: {
                    op: 'not_punctual',
                    start: DateHelper.date2Str(vm.start),
                    end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val
                },
                hideOpt: true,
                cols: [
                    {field: "name", title: "医生", width: 120, filter: {name: "text"}},
                    {field: "nurse", title: "护士", width: 120, filter: {nurse: "text"}},
                    {field: "dept", title: "科室", width: 120, filter: {dept: "text"}},
                    {field: "room", title: "手术间", width: 60, filter: {room: "text"}},
                    {field: "date", title: "日期", filter: {date: "text"}},
                    {field: "start", title: "开始时间"},
                    {field: "end", title: "结束时间"}
                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);


            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function add() {
            Dlg.show({
                template: 'pages/nursing/dateSsDlg.html',
                ctrl: 'OrDateSsDlgCtrl',
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function detailsExport() {
            Dlg.show({
                template: 'pages/nursing/dateSs/exportDlg.html',
                ctrl: 'OpDateExportDlgCtrl',
                data: {type: '未准时', start: now, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }

    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('OrDateSsNurseCtrl', OrDateSsNurseCtrl);

    /** @ngInject */
    function OrDateSsNurseCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = nurseExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];
        init();

        function init() {
            UIHelper.loadTab(vm, 'nurse');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'nurse', start: DateHelper.date2Str(vm.start), end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "name", title: "护士", width: 150, filter: {name: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}
                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);

            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function nurseExport() {
            Dlg.show({
                template: 'pages/nursing/dateSs/exportDlg.html',
                ctrl: 'OpDateExportDlgCtrl',
                data: {type: '护士', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }


    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('OrDateSsRoomCtrl', OrDateSsRoomCtrl);

    /** @ngInject */
    function OrDateSsRoomCtrl($scope, $q, OpDateSs, DateHelper, ArrayHelper, UIHelper, Table, FileHelper, Dlg) {
        var optionFn;
        var vm = $scope;
        vm.init = init;
        var now = new Date;
        var last = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
        vm.end = now;
        vm.start = last;
        vm.export = roomExport;
        vm.sort = {val: 'open_time', name: '开台时间'};
        vm.sorts = [{val: 'open_time', name: '开台时间'},
            {val: 'end_time', name: '结束时间'},
            {val: 'interval_time', name: '接台时间'},
            {val: 'punctuality', name: '准时开台率'}
        ];

        init();

        function init() {
            UIHelper.loadTab(vm, 'room');
            var options = {
                service: OpDateSs,
                params: {
                    op: 'room',
                    start: DateHelper.date2Str(vm.start),
                    end: DateHelper.date2Str(vm.end),
                    sort: vm.sort.val
                },
                hideOpt: true,
                cols: [
                    {field: "rank", title: "倒数排名", width: 80},
                    {field: "name", title: "手术间", width: 150, filter: {name: "text"}},
                    {field: "open_time", title: "平均开台时间"},
                    {field: "end_time", title: "平均结束时间"},
                    {field: "interval_time", title: "平均接台时间(分)"},
                    {field: "allCount", title: "首台数"},
                    {field: "punctualityCount", title: "准时开台数"},
                    {field: "punctuality", title: "准时开台率"}
                ]
            };

            optionFn = Table.load(vm, options).options;

            $scope.$watch('start', function () {
                options.params.start = DateHelper.date2Str(vm.start);
                vm.tableReload();
            }, true);
            $scope.$watch('end', function () {
                options.params.end = DateHelper.date2Str(vm.end);
                vm.tableReload();
            }, true);

            $scope.$watch('sort', function () {
                options.params.sort = vm.sort.val;
                vm.tableReload();
            }, true);

        }

        function roomExport() {
            Dlg.show({
                template: 'pages/nursing/dateSs/exportDlg.html',
                ctrl: 'OpDateExportDlgCtrl',
                data: {type: '手术间', start: last, end: now}
            }).then(function () {
                Dlg.s('导出成功!');
            })
        }
    }

})();
angular.module('c.c').controller('PracticeFeedbackController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, F, Table,
              Practice, PracticeFeedback) {

        var yesOrNos = F.getNgTableOpts(F.get('yesNo'));

        $scope.init = function (practice_type) {
            $scope.practice_type = practice_type;
            var options = {
                service: Practice,
                params: {opt: 5, practice_type: practice_type},
                optColWidth: 53,
                items: 'practicers',
                cols: [
                    {title: '是否评价', filter: {is_feedback: 'select'}, data: yesOrNos},
                    {title: '姓名', filter: {name: 'text'}},
                    {title: "实习科室", filter: {dept: 'text'}},
                    {title: '带教老师', filter: {teacher: 'text'}},
                    {title: '科室评分', width: '8%'},
                    {title: '带教老师评分', width: '8%'},
                    {title: '总评分', width: '8%'}
                ]
            };
            Table.loadNgTable($scope, options, function (data) {
                angular.forEach(data.practicers, function (practicer) {
                    if (practicer.practice_feedback.length == 0) {
                        practicer.is_feedback = 0;
                        practicer.teacher_total_score = '';
                        practicer.dept_total_score = '';
                        practicer.total_score = '';
                    } else {
                        practicer.is_feedback = 1;
                        angular.forEach(practicer.practice_feedback, function (feedback) {
                            if (feedback.dept_id == null) {
                                practicer.teacher_total_score = feedback.score;
                            } else if (feedback.teacher_id == null) {
                                practicer.dept_total_score = feedback.score;
                            } else {
                                practicer.total_score = feedback.score;
                            }
                        })
                    }
                });
            });
        }

        $scope.show = function (practicer) {
            if (practicer.is_feedback == 0) {
                toaster.warning('该用户尚未评价');
            } else {
                var createUrl = '';
                if ($scope.practice_type == 1 || $scope.practice_type == 2) {
                    createUrl = 'templates/practice/feedback_print_doctor.html';
                } else {
                    createUrl = 'templates/practice/feedback_print.html';
                }
                dialogs.create(createUrl, 'PracticeFeedback'
                    , {opt: 2, practice_id: practicer.id, practice_type: $scope.practice_type}, {
                        size: 'md'
                    });
            }
        };
    });

angular.module('c.c')
    .controller('NursingNurseSeniorityApprovalCtrl', function ($scope, dialogs, toaster, $filter
        , NgTableParams, SeniorityStandard, Dept, SeniorityApproval, NurseSeniority, User, Table) {
        var nurses = [];
        $scope.std = [{id: 0, title: '全部标准'}];
        $scope.init = function () {
            SeniorityStandard.query({type: 2}, function (resp) {
                $scope.standards = resp;
                angular.forEach($scope.standards, function (standard, index) {
                    $scope.std.push({id: index + 1, title: standard.name});
                });
            });
            User.query({'opt': 8}, function (data) {
                nurses = data.nurses;
            })
        };

        $scope.init();

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.cols = [
            {title: '科室', filter: {dept: 'text'}, field: 'dept', show: true, width: "20%"},
            {title: '姓名', filter: {name: 'text'}, field: 'name', show: true, width: "20%"},
            {title: '工号', filter: {numb: 'text'}, field: 'numb', show: true, width: "20%"},
            {title: '入院时间', filter: {updated_at: 'date_range'}, field: 'name', show: true, width: "20%"},
            {
                title: '年资标准',
                data: $scope.std,
                filter: {seniority_id: 'select'},
                field: 'seniority_id',
                show: true,
                width: "20%"
            }
        ];

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [5, 10, 15], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 4;
                url['approval'] = true;
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                SeniorityApproval.query(url, function (data) {
                    $scope.nurses = data.nurses;
                    params.total(data.total);
                    $defer.resolve(data.nurses);
                });

            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.pass = function (nurse) {
            var params = {};
            params['seniority_id'] = nurse.seniority_id;
            params['ap_state'] = 2;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('提交成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('提交失败!');
            });
            $scope.tableReload();
        };

        $scope.add = function () {

            angular.forEach($scope.nurses, function (nurse) {
                nurses.push({id: nurse.id})
            });
            dialogs.create('NurseSeniorityDlg.html', 'NurseSeniorityDlgCtrl', {
                standards: $scope.standards,
                except_nurses: nurses
            }, {
                size: 'md'
            }).result.then(function (seniority) {
                seniority['ap_state'] = 1;
                NurseSeniority.save(seniority).$promise.then(function (data) {
                    toaster.success('护士年资添加添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('护士年资添加添加失败!');
                });
            });
        };
        $scope.edit = function (nurse) {
            nurse['standard'] = $scope.standards[nurse.seniority_id - 1];
            nurse['flag'] = true;
        };
        $scope.cancel = function (nurse) {
            nurse['flag'] = false;
        };
        $scope.examine = function (nurse) {
            var params = {};
            nurse['flag'] = false;
            if (nurse.standard)
                params['seniority_id'] = nurse.standard.id;
            params['ap_state'] = 2;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('提交成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('提交失败!');
            });
            $scope.tableReload();
        };

        var checker = Table.loadMultiSelectedFn($scope);

        $scope.setSeniority = function (stdId, users) {
            if (!stdId) {
                toaster.warning('没有指定年资标准');
                return;
            }
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }

            var params = {};
            params['seniority_id'] = stdId;
            params['ap_state'] = 2;
            params['examine'] = true;
            params['nurse_id'] = checker.getCheckedIds(users);
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('设置成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('设置失败!');
            });
            $scope.tableReload();
        };
    });

angular.module('c.c')
    .controller('NurseSeniorityManageCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, F, SeniorityStandard, NurseSeniority, Dept) {
        var dep = [{id: 0, title: '全部科室'}];
        $scope.std = [{id: 0, title: '全部标准'}];
        var nurses = [];
        $scope.init = function () {
            Dept.query({'opt': '4'}, function (resp) {
                $scope.depts = resp.depts;
                angular.forEach($scope.depts, function (dept, index) {
                    dep.push({id: index + 1, title: dept.name});
                });
            });
            SeniorityStandard.query({type: 2}, function (resp) {
                $scope.standards = resp;
                angular.forEach($scope.standards, function (standard, index) {
                    $scope.std.push({id: index + 1, title: standard.name});
                });
            });
            var url = {};
            url['id'] = 1;
            url['all_nurse'] = true;
            NurseSeniority.get(url, function (resp) {
                angular.forEach(resp.all_nurse, function (nurse) {
                    nurses.push({id: nurse.nurse_id})
                })
            })
        };
        $scope.init();
        $scope.cols = [
            {title: '科室', filter: {dept: 'text'}, field: 'dept', show: true, width: "20%"},
            {title: '姓名', filter: {'name': 'text'}, field: 'name', show: true}, //0
            {title: '工牌号', filter: {'numb': 'text'}, field: 'numb', show: true}, //0
            {
                title: '年资标准',
                data: $scope.std,
                filter: {seniority_id: 'select'},
                field: 'seniority_id',
                show: true,
                width: "20%"
            }
        ];
        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                NurseSeniority.query(url, function (data) {
                    $scope.nurses = data.nurses;
                    params.total(data.total);
                    $defer.resolve(data.nurses);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('NurseSeniorityDlg.html', 'NurseSeniorityDlgCtrl', {
                standards: $scope.standards,
                except_nurses: nurses
            }, {
                 size: 'md'
            }).result.then(function (seniority) {
                    seniority['ap_state'] = 2;
                    NurseSeniority.save(seniority).$promise.then(function (data) {
                        toaster.success('护士年资添加添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('护士年资添加添加失败!');
                    });
                });
        };

        $scope.edit = function (nurse) {
            nurse['standard_name'] = {id: '', name: nurse.standard_name};
            nurse['$edit'] = true;
        };
        $scope.cancel = function (nurse) {
            nurse['standard_name'] = nurse.standard_name.name;
            nurse['$edit'] = false;
        };

        $scope.examine = function (nurse) {
            var params = {};
            nurse['$edit'] = false;
            if (nurse.standard_name)
                params['seniority_id'] = nurse.standard_name.id;
            params['ap_state'] = 2;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('提交成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('提交失败!');
            });
            $scope.tableReload();
        };
    });

angular.module('c.c').controller('NurseSeniorityDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.except_nurses = data.except_nurses;
        $scope.standards = data.standards;

        $scope.seniority = {standard: $scope.standards[0]};

        $scope.ok = function (seniority) {
            if ($scope.s_form.$valid) {
                if (seniority.nurse.length == 0) {
                    toaster.warning('表单中有错误!');
                    $scope.g_form.submitted = true;
                }
                var params = {};
                var nurse_ids = [];
                angular.forEach(seniority.nurse, function (nu) {
                    nurse_ids.push(nu.id);
                });
                params['nurse_id'] = nurse_ids;
                if (seniority.standard.id != null)
                    params['seniority_id'] = seniority.standard.id;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('OutPPendingCtrl', OutPPendingCtrl);

    /** @ngInject */
    function OutPPendingCtrl($scope, UIHelper, Table, SaveAs, FileHelper, C, OperationPermit,
                             ArrayHelper, Dlg) {
        var vm = $scope;
        var types = ArrayHelper.get('or_types');
        vm.confirm = confirm;
        vm.returnOP = returnOP;
        vm.download = download;


        init();


        function init() {
            UIHelper.loadTab(vm, 'result');
            var typeOpts = Table.getNgTableOpts(types);
            var options = {
                service: OperationPermit,
                params: {opt: 4},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name'}, //0
                    {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id'}, //1
                    {title: '递交人', field: 'applicant', filter: {applicant: 'text'}}, //6
                    {title: '递交科室', filter: {dept: 'text'}, field: 'dept'},
                    {
                        title: '递交时间',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }, //6
                    {title: '备注', field: 'remark'} //1
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (m) {
                    m.type = ArrayHelper.getItem(m.type_id, types);
                });
            });
        }

        function confirm(m) {
            OperationPermit.update({id: m.id}, {stage: 2, type: 2}).$promise.then(function () {
                Dlg.s('确认成功!');
                vm.tableReload();
            }, function () {
                Dlg.e('确认失败!');
            });
        }

        function returnOP(m) {
            Dlg.confirm('确定要退回此手术通知单吗?', function () {
                OperationPermit.update({id: m.id}, {stage: 3}).$promise.then(function () {
                    Dlg.s('已退回!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('操作失败!');
                });
            }, '退回手术通知单');
        }

        function download(m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('OutPProcessedCtrl', OutPProcessedCtrl);

    /** @ngInject */
    function OutPProcessedCtrl($scope, UIHelper, Table, SaveAs, FileHelper, C, OperationPermit,
                             ArrayHelper, Dlg) {
        var vm = $scope;
        var types = ArrayHelper.get('or_types');
        vm.cancel = cancel;
        vm.download = download;


        init();


        function init() {
            UIHelper.loadTab(vm, 'result');
            var typeOpts = Table.getNgTableOpts(types);
            var options = {
                service: OperationPermit,
                params: {opt: 5},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name'}, //0
                    {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id'}, //1
                    {title: '递交人', field: 'applicant', filter: {applicant: 'text'}}, //6
                    {title: '递交科室', filter: {dept: 'text'}, field: 'dept'},
                    {
                        title: '递交时间',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }, //6
                    {title: '确认时间', field: 'updated_at'}, //6
                    {title: '备注', field: 'remark'} //1
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (m) {
                    m.type = ArrayHelper.getItem(m.type_id, types);
                });
            });
        }

        function cancel(m) {
            Dlg.confirm('确定要退回此手术通知单吗?', function () {
                OperationPermit.update({id: m.id}, {stage: 3}).$promise.then(function () {
                    Dlg.s('已退回!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('操作失败!');
                });
            }, '撤销手术通知单');
        }

        function download(m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }
    }

})();

angular.module('c.c')
    .controller('PersonnelBalanceCtrl', function ($scope, Balance, Table) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Balance,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {user_id: 'asc'},
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "main_dept", title: "科室", filter: {main_dept: "text"}},
                    {field: "balance", title: "金额", filter: {balance: "num_range"}}
                ]
            };
            Table.load(vm, options);
        }
    });


angular.module('c.c')
    .controller('PersonnelRechargeCtrl', function ($scope, Recharge, Table, F) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Recharge,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "money", title: "金额", filter: {money: "num_range"}},
                    {
                        field: "is_cost",
                        title: "计入科室成本",
                        filter: {is_cost: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    },
                    {field: "created_at", title: "充值时间", filter: {created_at: "date_range"}},
                    {field: "handler", title: "充值人", filter: {handler: "text"}},
                    {field: "note", title: "充值理由", filter: {note: "text"}}
                ]
            };
            Table.load(vm, options);
        }
    });


angular.module('c.c').controller('UserArrangeRoundsCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, F, Table, User, Round) {

        var yesOrNo = F.getNgTableOpts(F.get('yesOrNo2'));
        var sexOpt = F.getNgTableOpts(F.get('sexes'));

        var options = {
            service: User,
            params: {opt: 14, is_nurse: $scope.is_nurse, fresh: $scope.fresh},
            optColWidth: 53,
            sorting: {id: 'asc'},
            dateFilters: [{name: 'entry_time'}],
            items: 'users',
            cols: [
                {title: '有无轮转', filter: {is_arrange: 'select'}, data: yesOrNo},
                {title: '姓名', filter: {name: 'text'}},
                {title: '工号', filter: {username: 'text'}},
                {title: '性别', filter: {sex: 'select'}, data: sexOpt},
                {title: '科室', filter: {dept: 'text'}},
                {title: '来院工作时间', filter: {entry_time: 'date_range'}}
            ]
        };

        $scope.init = function (is_nurse, fresh) {
            $scope.is_nurse = is_nurse;
            $scope.fresh = fresh;
            Table.loadNgTable($scope, options, function (data) {
                $scope.depts = data.depts;
                angular.forEach(data.users, function (user) {
                    user.is_arrange = false;
                    if (user.user_round.length != 0) {
                        user.is_arrange = true;
                    }
                });
            });
        };
        $scope.manage = function (user) {
            dialogs.create('templates/round/manage_dlg.html', 'UserRoundDlgCtrl', {
                    user_id: user.id,
                    depts: $scope.depts
                },
                { size: 'md'}).result.then(function (params) {
                    if (params.result == 0) {
                        $scope.tableParams.reload();
                    }
                });
        };
        $scope.delete = function (user) {
            dialogs.confirm('删除轮转', '确定要删除<strong>' + user.name + '</strong>的所有轮转吗?')
                .result.then(function () {
                    Round.delete({id: user.id, opt: 0}).$promise.then(function (resp) {
                        resp = resp.result;
                        if (resp.result == 0) {
                            toaster.success(resp.msg);
                        } else {
                            toaster.error(resp.msg);
                        }
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('删除失败!');
                    });
                });
        };

        $scope.change = function (user) {
            dialogs.confirm('应届《=》在职', '确定要将<strong>' + user.name + '</strong>' + '转换属性吗?')
                .result.then(function () {
                    User.update({id: user.id, fresh: user.fresh == true ? '0' : '1'}).$promise.then(function (resp) {
                        toaster.success('属性转换成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('属性转换失败!');
                    });
                });
        };

        $scope.$watch('fresh', function (fresh, old, scope) {
            options.params.fresh = fresh;
            options.params.is_nurse = $scope.is_nurse;
            $scope.tableReload();

        });


    })
;

(function () {
    'use strict';

    angular.module('c.c')
        .controller('RoundLogCtrl', RoundLogCtrl);

    /** @ngInject */
    function RoundLogCtrl($scope, UIHelper) {
        var vm = $scope;

        init();


        function init() {
            UIHelper.loadTab(vm, 'log');

            console.log('RoundLogCtrl');
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserMangeRoundsCtrl', UserMangeRoundsCtrl)
        .controller('NurseRoundExcelImportDlgCtrl', NurseRoundExcelImportDlgCtrl)
    ;

    function UserMangeRoundsCtrl($scope, $rootScope, $timeout, $filter, dialogs, toaster, Api, F, Table, User, C, Round, Dlg) {
        var vm = $scope;
        vm.init = init;
        vm.edit = edit;
        vm.deleteItem = deleteItem;
        vm.exportExcel = exportExcel;
        vm.importExcel = importExcel;
        var sexOpt = F.getNgTableOpts(F.get('sexes'));
        var roundStateOpt = F.getNgTableOpts(F.get('round_stages'));
        var yesOrNo = F.getNgTableOpts(F.get('yesNo'));

        function init(opt, is_nurse) {
            console.log('批量导入');
            var options = {
                service: Round,
                params: {opt: opt, is_nurse: is_nurse},
                optColWidth: 53,
                sorting: {user_id: 'asc'},
                dateFilters: [{name: 'entry_time'}],
                items: 'users',
                cols: [
                    {title: '主科室轮转', filter: {is_main: 'select'}, data: yesOrNo},
                    {title: '是否机动', filter: {is_flex: 'select'}, data: yesOrNo},
                    {title: '姓名', filter: {name: 'text'}},
                    {title: '工号', filter: {username: 'text'}},
                    {title: '性别', filter: {sex: 'select'}, data: sexOpt},
                    {title: '轮转科室', filter: {dept: 'text'}},
                    {title: '轮转日期', filter: {entry_time: 'date_range'}},
                    {title: '当前状态', filter: {state: 'select'}, data: roundStateOpt}
                ]
            };
            Table.loadNgTable($scope, options, function (data) {
                angular.forEach(data.users, function (user) {
                    if (angular.isDefined(user.leave_time) && user.leave_time != null) {
                        user.round_time = user.entry_time.substr(0, 16) + ' - ' + user.leave_time.substr(0, 16);
                    } else {
                        user.round_time = user.entry_time.substr(0, 16) + "之后";
                    }
                    if (user.state && user.state.length > 0) {
                        if (user.state == 1 && user.is_confirm == 0) {
                            user.state = {id: '3', name: '科室未确认'};
                        } else {
                            user.state = F.getItem(user.state, F.get('test_stages'));
                        }
                    } else {
                        user.state.name = '状态为空';
                    }
                });
            });
        }

        function edit(user_round) {
            dialogs.create('templates/round/edit_round_dlg.html', 'EditRoundDlgCtrl',
                {round_id: user_round.id, user_id: user_round.user_id}, {
                    size: 'md'
                }).result.then(function (round) {
                round.opt = 0;
                round.user_dept = user_round.user_dept;
                Round.update({id: user_round.id}, round).$promise.then(function (resp) {
                    if (resp.result == 0) {
                        toaster.success('修改轮转成功');
                    } else {
                        toaster.error(resp.msg);
                    }
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('轮转修改失败!');
                })
            });
        }

        function deleteItem(user_round) {
            dialogs.confirm('删除轮转', '确定要删除<strong>' + user_round.user.name + '</strong>在<strong>' + user_round.dept.name + '</strong>的轮转吗?')
                .result.then(function () {
                Round.delete({
                    id: user_round.id,
                    opt: 1,
                    user_dept_id: user_round.user_dept_id
                }).$promise.then(function (resp) {
                    resp = resp.result;
                    if (resp.result == 0) {
                        toaster.success(resp.msg);
                    } else {
                        toaster.error(resp.msg);
                    }
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }

        function exportExcel() {
            Api.exportDR(C.URL.ROUND_DOWNLOAD, "轮转统计");
        }

        function importExcel() {
            Dlg.show({
                template: 'NurseRoundExcelImportDlg.html',
                ctrl: 'NurseRoundExcelImportDlgCtrl',
                data: {}
            }).then(function (pa) {

            });
        }
    }

    function NurseRoundExcelImportDlgCtrl($scope, $uibModalInstance, FileHelper, Round, Dlg) {
        var vm = $scope;
        vm.submit = submit;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.cancel = $uibModalInstance.dismiss;

        vm.templateDownloads = [
            {
                id: 1,
                ico: 'file-excel-o',
                filename: "rounds/gzrzyb.xlsx",
                mime: "application/wps-office.xlsx",
                name: "护士轮转导入样表.xlsx",
                size: "8797"
            }
        ];

        init();

        function init() {
            vm.m = {
                file: {}
            };
        }

        function upload(file, m, e) {
            FileHelper.uploadSingle(file, m, e);
        }

        function deleteAttachment(m) {
            m.filename = null;
        }

        function submit(m) {
            var file = m.file;
            if (!file.filename) {
                Dlg.w('请上传预约附件!');
            } else {
                var pa = {
                    op: 'default',
                    file: {
                        name: file.attach_name,
                        filename: file.filename,
                        mime: file.mime,
                        size: file.size,
                    }
                };

                Round.excelImport(pa).$promise.then(function (resp) {
                    switch(resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            break;
                        default:
                            Dlg.e(resp.msg);
                            break;
                    }
                    init();
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('changePasswordDlgCtrl', changePasswordDlgCtrl);

    /** @ngInject */
    function changePasswordDlgCtrl($uibModalInstance, Dlg, data, User,
                                   FormHelper, $q) {
        var vm = this;
        vm.m = data.user;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            var defer = $q.defer();
            if (!vm.password_form.$valid) {
                FormHelper.handleError('#password_form', vm.password_form);
                defer.reject();
            } else {
                User.update({id: m.id}, {
                    password: m.password,
                    opt: 1
                }).$promise.then(function (resp) {
                    if (resp.result == 0) {
                        Dlg.s('修改成功');
                        $uibModalInstance.close();
                    }
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }

})();



'use strict';
angular.module('c.c')
    .controller('IncumbencyUserCtrl', function ($rootScope, $scope, dialogs, NgTableParams, F, User) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var eduBgs = F.get('edu_bg_list');
        var eduBgOpts = F.getNgTableOpts(eduBgs);
        $scope.ed = ['', '高中', '中专', '大专', '成人本科', '本科', '硕士', '博士', '其他'];
        $scope.yes_no = yesNoOpts;
        $scope.cols = [
            {
                title: '姓名',
                sortable: 'name',
                filter: {name: 'text'},
                field: 'name',
                type: 0xff,
                show: true,
                width: '10%'
            }, //1
            {title: '主科室', field: 'main_dept', type: 1, show: true, width: '10%'},
            {
                title: '编制类型', sortable: 'status_id', filter: {status_id: 'select'}, field: 'status_id'
                , type: 8, show: true, width: '10%'
            },
            {
                title: '类别',
                sortable: 'type_id',
                filter: {type_id: 'select'},
                field: 'type_id',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '入职时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '入职类型',
                sortable: 'entry_type_id',
                filter: {entry_type_id: 'select'},
                field: 'entry_type_id',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '所学专业',
                sortable: 'major',
                filter: {major: 'text'},
                field: 'major',
                type: 2,
                show: true,
                width: '10%'
            },//9
            {
                title: '学历',
                sortable: 'edu_bg',
                filter: {edu_bg: 'select'},
                data: eduBgOpts,
                field: 'edu_bg',
                type: 2,
                show: true,
                width: '10%'
            },
            {
                title: '中层以上干部',
                sortable: 'is_cadre',
                filter: {is_cadre: 'select'},
                data: yesNoOpts,
                field: 'is_cadre',
                type: 8,
                show: true,
                width: '10%'
            }
        ];
        $scope.statuses_col = $scope.cols[2];
        $scope.user_types_col = $scope.cols[3];
        $scope.entry_types_col = $scope.cols[5];
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
        $scope.$on('user_recover', function (event, data) {
            $scope.tableReload();
        });

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
        $scope.tableParams = new NgTableParams({
            page: 1, count: 30, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                url['is_leaved'] = 0;
                url['date_range_filters'] = $scope.dateRangeFilter;
                User.query(url, function (data) {
                    $scope.users = data.users;
                    $scope.leave_reason = data.leave_reasons;
                    $scope.statuses_col.data = F.getNgTableOpts(data.statuses);
                    $scope.user_types_col.data = F.getNgTableOpts(data.types);
                    $scope.entry_types_col.data = F.getNgTableOpts(data.entry_types);
                    params.total(data.total);
                    $defer.resolve($scope.users);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
        $scope.user_leave = function (user) {
            dialogs.create('UserLeaveDlg.html', 'LeaveCtrl', {user: user, reason: $scope.leave_reason, id: user.id}, {
                 size: 'md'
            }).result.then(function () {
                    $scope.tableReload();
                });
        }
    });
angular.module('c.c').controller('LeaveCtrl', function LeaveCtrl($rootScope, $scope, $filter, toaster, NgTableParams, F, User, $uibModalInstance, data) {
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    $scope.reasons = data.reason;
    $scope.leave_reason = $scope.reasons[0];
    $scope.user = {
        leave_reason: $scope.reasons[0],
        name: data.user.name,
        id: data.user.username,
        leave_time: new Date()
    };
    $scope.ok = function (user) {
        if (user.leave_reason == null)
            toaster.warning('离职原因不能为空!');
        else {
            var params = {};
            params['opt'] = 2;
            params['leave_time'] = $filter('date')(user.leave_time, 'yyyy-MM-dd');
            params['leave_reason_id'] = user.leave_reason.id;
            User.update({id: data.id}, params).$promise.then(function () {
                toaster.success('提交成功!');
                $rootScope.$broadcast('userLeave');
                $uibModalInstance.close();
            }, function () {
                toaster.error('提交失败!');
            })
        }
    }
});
(function () {
    'use strict';

    angular.module('c.c')
        .controller('LeavedUserCtrl', LeavedUserCtrl)
        .controller('LeavedUserRecoverDlgCtrl', LeavedUserRecoverDlgCtrl)
    ;

    /** @ngInject */
    function LeavedUserCtrl($scope, Dlg, F, NgTableParams, User, FileHelper) {
        $scope.cols = [
            {
                title: '姓名',
                sortable: 'name',
                filter: {name: 'text'},
                field: 'name',
                type: 0xff,
                show: true,
                width: '15%'
            }, //1
            {
                title: '用户名',
                sortable: 'username',
                filter: {username: 'text'},
                field: 'username',
                type: 0xff,
                show: true
            }, //1
            {
                title: '联系电话',
                sortable: 'phone',
                filter: {phone: 'text'},
                field: 'phone',
                type: 0xff,
                show: true
            }, //1
            {title: '原主科室', field: 'main_dept', type: 1, show: true, width: '15%'},
            {
                title: '类别',
                sortable: 'type_id',
                filter: {type_id: 'select'},
                field: 'type_id',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '入职时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '入职类型',
                sortable: 'entry_type_id',
                filter: {entry_type_id: 'select'},
                field: 'entry_type_id',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '离职时间',
                sortable: 'leave_time',
                filter: {leave_time: 'date_range'},
                field: 'leave_time',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '离职原因',
                sortable: 'leave_reason_id',
                filter: {leave_reason_id: 'select'},
                field: 'leave_reason_id',
                type: 8,
                show: true,
                width: '10%'
            }
        ];

        $scope.$on('userLeave', function (event, data) {
            $scope.tableParams.reload();
        });
        $scope.user_types_col = $scope.cols[4];
        $scope.entry_types_col = $scope.cols[6];
        $scope.leave_reasons_col = $scope.cols[8];

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
        $scope.tableParams = new NgTableParams({
            page: 1, count: 30, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                url['is_leaved'] = 1;
                url['date_range_filters'] = $scope.dateRangeFilter;
                User.query(url, function (data) {
                    $scope.users = data.users;
                    $scope.user_types_col.data = F.getNgTableOpts(data.types);
                    $scope.entry_types_col.data = F.getNgTableOpts(data.entry_types);
                    $scope.leave_reasons_col.data = F.getNgTableOpts(data.leave_reasons);
                    params.total(data.total);
                    $defer.resolve($scope.users);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.recover = function (user) {
            Dlg.show({
                template: 'LeavedUserRecoverDlg',
                ctrl: 'LeavedUserRecoverDlgCtrl',
                data: {
                    id: user.id
                }
            }).then(function () {
                $scope.tableParams.reload();
            });
        };

        $scope.download = function () {
            var title = '离职员工表';
            FileHelper.dnExcel(User.urls.EXPORT_LEAVE_USER, {
                title: title
            }, title + ".xls");
        };
    }

    /** @ngInject */
    function LeavedUserRecoverDlgCtrl($rootScope, User, $uibModalInstance, data, Dlg, FormHelper, $q) {
        var vm = this;
        vm.close = $uibModalInstance.close;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            User.get({id: id}, function (resp) {
                vm.m = resp.user;
            })
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    opt: 6,
                    dept_id: m.dept.id,
                    leave_time: null,
                    leave_reason_id: null
                };
                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('员工恢复成功!');
                            break;
                        case 1:
                            Dlg.w('!');
                            break;
                    }
                    $rootScope.$broadcast('user_recover');
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e('员工恢复失败!');
                }).finally(function () {
                    defer.resolve();
                });

            }

            return defer.promise;
        }
    }

})();



angular.module('c.c').controller('UserWageExportDlgCtrl', function ($uibModalInstance, DateHelper,
                                                                    $q, FormHelper, FileHelper, Dlg, data) {
    var vm = this;
    vm.ok = ok;
    vm.cancel = $uibModalInstance.dismiss;

    init();

    function init() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        vm.m = {start: new Date(y, m - 1, 1), end: new Date(y, m, 2)};
    }


    function ok(m, form) {
        var defer = $q.defer();
        if (!m.user) {
            Dlg.w('请选择需导出的员工');
        } else if (form.$valid) {

            var sY = m.start.getFullYear(), sM = m.start.getMonth();
            var eY = m.end.getFullYear(), eM = m.end.getMonth();

            var userName = m.user.name;
            var pa = {
                user_id: m.user.id,
                start: DateHelper.date2Str(m.start),
                end: DateHelper.date2Str(m.end)
            };
            FileHelper.dnExcel(data.url, pa,
                sY + '年' + (sM + 1) + '月到' + eY + '年' + (1 + eM) + '月' + userName + '的工资表.xls',
                function () {
                    Dlg.s('导出成功');
                    vm.cancel();
                });

        } else {
            FormHelper.handleError('#Form', form);
            defer.reject();
        }
        return defer.promise;
    }

});


angular.module('c.c').controller('InSeriesWageCtrl',
    function ($scope, $filter, dialogs, toaster, Dept, WageReport, C, F, FileHelper, SaveAs, $timeout, Dlg) {
        $scope.$on('wageItemSumbit', function () {
            $scope.reload();
            $scope.canSave = true;
            $scope.canGen = false;
            $scope.canSubmit = false;
            $scope.editAwd = false;
            $scope.canSave2 = false;
        });

        var allData;
        var table, commentsPlugin, sortIndex, tableData;

        $scope.change_users = [];

        $scope.exportAll = WageReport.exportYearWageStat;

        $scope.tableSettings = {
            //search: true,
            afterInit: function () {
                table = this;
                commentsPlugin = table.getPlugin('comments');
            },
            manualColumnResize: true, fixedColumnsLeft: 5, colWidths: 80, stretchH: 'all',
            columnSorting: true, sortIndicator: true, comments: true,
            afterColumnSort: function () {
                sortIndex = table.sortIndex;
                tableData = table.getSourceData();

                var wages = [];
                if (sortIndex.length != 0) {
                    for (var i = 0; i < sortIndex.length; i++) {
                        var index = sortIndex[i][0];
                        wages.push(tableData[index])
                    }
                    $scope.wages = wages;
                }
            },
            afterOnCellMouseDown: function (event, c, TD) {
                //console.log('event', event);
                //console.log('c', c);
                //console.log('TD', TD);
                var row = $scope.wages[c.row];
                if (c.col === 5) {
                    $scope.change_users.push(row.id);
                }
                // //console.log('row', row);
                // if (c.col === 32) {
                //     dialogs.create(C.T + 'wage/wage_other_dlg.html', 'WageOtherDlgCtrl', {}, {
                //         size: 'md'
                //     }).result.then(function (pa) {
                //             if (c.col === 32) {
                //                 row.i_od = parseFloat(row.i_od) + parseFloat(pa.money);
                //                 row.remark = row.remark + ';' + pa.remark;
                //
                //                 //计算扣款合计
                //                 row.i_td = getTd(row);
                //             }
                //             //计算实发合计
                //             row.i_np = getNp(row);
                //             table.updateSettings(row, 1);
                //             $scope.change_users.push(row.id);
                //         }
                //     );
                // }


            }
        };

        $scope.dt = new Date((new Date()).setDate(1));
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dt = new Date(curr.setMonth(prev));
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dt = new Date(curr.setMonth(next));
        };

        $scope.myCustomRenderer = function (hotInstance, td, row, col, prop, value, cellProperties) {
            value = value === null ? '' : value;
            if (prop === 'diff') {
                td.innerHTML = '<span class="htDimmed-red">' + value + '</span>';
            }
            if (prop === 'opinion') {
                td.innerHTML = '<span class="htDimmed-green">' + value + '</span>';
            }
        };

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
            $scope.depts = resp.depts;
            if ($scope.depts && $scope.depts.length > 0) {
                $scope.depts.splice(0, 0, {name: '全部科室'});
            }
        });

        $scope.query = {dept: {name: '全部科室'}};
        $scope.change = function (query) {
            var wages = $filter('filter')(allData, {name: query.name});
            $scope.wages = $filter('filter')(wages, {dept_id: query.dept.id}, true);

            $timeout(function () {
                var comments = [];
                angular.forEach($scope.wages, function (wage, index) {
                    if (wage.i_np < 0) {
                        comments.push({
                            row: index,
                            col: 2,
                            comment: "实发合计为负,预扣款合计为" + -wage.i_np
                        });
                    }
                });
                table.updateSettings({});
            }, 1000);

        };


        $scope.$watch('dt', function (newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.reload();
            }
        });

        //计算基本工资倍数
        function getBgw(wage) {
            var total1 = eval(wage.i_bw + '+' + wage.i_gw);
            //var total1 = wage.i_bw + wage.i_gw;
            return (total1 * 0.8).toFixed(2);
        }

        //计算教护补贴
        function getEsa(wage) {
            var total2 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw);
            //var total2 = wage.i_bw + wage.i_gw + wage.i_bgw;
            return (total2 * 0.1).toFixed(0);
        }

        //计算百分百合计
        // function getHpw(wage) {
        //     var total3 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_tca + '+' + wage.i_allowance
        //     + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_ocf
        //     + '+' + wage.i_rw + '+' + wage.i_ow + '+' + wage.i_css + '+' +wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa
        //         + '+' + wage.i_ma + '+' + wage.chaf);
        //     return total3.toFixed(2);
        // }

        //计算应发差额合计
        // function getTbw(wage) {
        //     var total4 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_tca + '+' + wage.i_allowance
        //         + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_ocf
        //         + '+' + wage.i_rw + '+' + wage.i_ow);
        //     var total5=0;
        //     if (wage.out_percent == '1') {
        //          total5=eval(total4+"+"+ wage.i_css + '+' +wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa
        //              + '+' + wage.i_ma + '+' + wage.chaf);
        //     }else{
        //         total5=eval(total4*0.86.toFixed(2)+"+"+ wage.i_css + '+' +wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa
        //         + '+' + wage.i_ma + '+' + wage.chaf);
        //     }
        //     return total5;
        // }

        //计算百分百合计 岗位工资+薪级工资+基本工资倍数+西藏津补贴+津补贴+教护补贴+工改保留工资+住房补贴+在藏折算工龄补贴+独子费+基本工资补发+其他补发
        function getHpw(wage) {
            // var total3 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_tca + '+' + wage.i_allowance
            //     + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_ocf
            //     + '+' + wage.i_rw + '+' + wage.i_ow + '+' + wage.i_allowance_new);

            var total3 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_allowance + '+' + wage.i_allowance_new
                + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_ocf
                + '+' + wage.i_rw + '+' + wage.i_ow);
            return total3.toFixed(2);
        }

        //计算应发差额合计 应发差额的计算公式，变成  （百分百合计-住房补贴-在藏折算工龄补贴-基本工资补发）* 0.86  +住房补贴+在藏折算工龄补贴+基本工资补发（2024.3.4杨莹莹提出）
        // 应发差额=（基本工资+薪级工资+基本工资倍数+西藏津补贴+津补贴+教护补贴+工改保留工资+独子费）*0.86+在藏折算工资+基本工资补发+住房补贴+其他费用（2024.3.6杨莹莹提出）

        function getTbw(wage) {
            var total4 = getHpw(wage);
            if (wage.out_percent == '1') {
                return total4;
            }
            // return (total4 * 0.86).toFixed(2);
            return (eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_allowance + '+' + wage.i_allowance_new
                + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ocf) * 0.86 + eval(wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_rw + '+' + wage.i_ow)).toFixed(2);
        }


        //计算应发合计
        function getTw(wage) {
            var total5 = eval(getTbw(wage) + '+' + wage.i_kpiw);
            //var total5 = getTbw(wage) + wage.i_kpiw;
            return total5.toFixed(2);
        }

        //计算个人医保
        function getMi(wage) {
            var total6 = getHpw(wage);
            return (total6 * 0.02).toFixed(2);
        }

        //计算个人公积金
        function getHaf(wage) {
            var total7 = Math.round(getHpw(wage) / 10) * 10;
            return total7 * 0.12;
        }

        //计算个人月度失业金
        function getUc(wage) {
            var total8 = getHpw(wage);
            return (total8 * 0.005).toFixed(2);
        }

        //计算个人预扣社保及年金
        function getSsap(wage) {
            var total9 = getHpw(wage) - wage.i_ha;
            return (total9 * 0.12).toFixed(2);
        }

        //
        ////计算扣税基数
        //function getTdb(wage) {
        //    var total10 = eval(getTbw(wage) + '-' + wage.i_mi + '-' + wage.i_haf + '-' + wage.i_uc + '-' +
        //    wage.i_ssap + '-' + wage.i_pension);
        //    //var total10 = getTbw(wage) - wage.i_mi - wage.i_haf - wage.i_uc - wage.i_ssap - wage.i_pension;
        //    return total10.toFixed(2);
        //}

        //计算扣款合计 扣款合计=自付医保+自付公积金+自付失业金+自付养老保险+自付职业年金+水电+物管费+房租+清洁费+补扣保险+其他扣款+14%差额扣款+停车费+考勤扣除工资
        function getTd(wage) {
            // var total11 = eval(wage.i_mi + '+' + wage.i_haf + '+' + wage.i_uc + '+' + wage.i_pension
            //     + '+' + wage.i_wae + '+' + wage.i_pty + '+' + wage.i_rent + '+' + wage.i_cf + '+' + wage.i_of + '+' + wage.i_di + '+' + wage.i_ocfd
            //     + '+' + wage.i_od + '+' + wage.i_lf + '+' + wage.i_pf + '+' + wage.i_kpid + '+' + wage.i_ss + '+' + wage.i_ap + '+' + wage.i_awd);
            //var total11 = wage.i_mi + wage.i_haf + wage.i_uc + wage.i_pension + wage.i_wtd + wage.i_wae + wage.i_rent
            //    + wage.i_cf + wage.i_of + wage.i_ocfd + wage.i_od + wage.i_lf + wage.i_pf + wage.i_kpid + wage.i_ssap + wage.i_awd;
            var total11 = eval(wage.i_mi + '+' + wage.i_haf + '+' + wage.i_uc + '+' + wage.i_ss + '+' + wage.i_ap
                + '+' + wage.i_wae + '+' + wage.i_pty + '+' + wage.i_rent + '+' + wage.i_cf + '+' + wage.i_di
                + '+' + wage.i_od + '+' + wage.i_pf + '+' + wage.i_awd + '+' + getLf(wage));
            return total11.toFixed(2);
        }

        //单位负担五险二金扣款合计=单位负担医疗生育工伤大病险+单位负担养老保险+单位负担失业保险+单位负担职业年金+单位负担公积金
        function getSpf(wage) {
            var totalspf = eval(wage.i_css + '+' + wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa + '+' + wage.i_chaf);
            return totalspf.toFixed(2);
        }


        //计算实发合计 改为应发差额合计-扣款合计（杨莹莹2024.3.7提出）->百分之百分计-扣款合计
        function getNp(wage) {
            // var total12 = eval(wage.i_ha + '+' + wage.i_tsa) * 0.14;
            // if (wage.out_percent != null) {
            //     total12 = 0;
            // }
            // var total13 = eval(total12 + '+' + getTw(wage) + '-' + getTd(wage));
            //var total12 = (wage.i_ha + wage.i_tsa) * 0.14;
            //var total13 = total12 + getTw(wage) - getTd(wage);

            // var total13 = eval(getTbw(wage) + '-' + getTd(wage));
            var total13 = eval(getHpw(wage) + '-' + getTd(wage));
            return total13.toFixed(2);
        }

        function getLf(wage) {
            var total14 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_allowance + '+' + wage.i_allowance_new
                + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ocf) * 0.14;
            return total14.toFixed(2);
        }

        $scope.init = function (opt) {
            $scope.opt = opt;//5.人事科 6.财务科
            $scope.reload = function () {
                $scope.stage = null;
                $scope.loading = true;
                var params = [];
                params['opt'] = opt;
                params['month'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                WageReport.query(params, function (resp) {
                    $scope.loading = false;
                    var wages = resp.wages;
                    if (wages.length > 0) {
                        $scope.stage = wages[0].stage;
                        $scope.reportId = wages[0].report_id;
                    }
                    var comments = [];
                    angular.forEach(wages, function (wage, index) {
                        if (wage.other) wage.opinion = wage.other.remark;
                        if (opt == 5 || opt == 21) {
                            if (wage.i_np < 0) {
                                comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.i_np});
                            }

                            //计算基本工资倍数
                            wage.i_bgw = getBgw(wage);

                            if (wage.i_esa == 9999) {
                                //计算教护补贴
                                wage.i_esa = getEsa(wage);
                            }

                            //计算百分百合计
                            wage.i_hpw = getHpw(wage);

                            //计算应发差额合计
                            wage.i_tbw = getTbw(wage);


                        }

                        if (opt == 6) {
                            // console.log(wage.i_np == 0);
                            // if (wage.i_np == 0) {
                                //计算应发合计
                                wage.i_tw = getTw(wage);
                                //计算14%差额扣款
                                wage.i_lf = getLf(wage);
                                ////计算医保
                                //if (wage.i_mi == 0) {
                                //    wage.i_mi = getMi(wage);
                                //}

                                ////计算公积金
                                //if (wage.i_haf == 0) {
                                //    wage.i_haf = getHaf(wage);
                                //}

                                ////计算月度失业金
                                //if (wage.i_uc == 0) {
                                //    wage.i_uc = getUc(wage);
                                //}

                                //计算预扣社保及年金
                                //wage.i_ssap = getSsap(wage);

                                ////计算扣税基数
                                //wage.i_tdb = getTdb(wage);

                                ////计算个税
                                //if (wage.i_wtd == 0 && (wage.out_tax == '0' || wage.out_tax == null)) {
                                //    wage.i_wtd = F.getTax(wage.i_tdb).toFixed(2);
                                //}

                                //计算扣款合计
                                wage.i_td = getTd(wage);

                                //计算实发合计
                                wage.i_np = getNp(wage);
                            // }

                            if (wage.i_np < 0) {
                                comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.i_np});
                            }
                        }
                    });
                    $scope.wages = allData = wages;
                    $timeout(function () {
                        table.updateSettings({
                            cell: comments
                        });
                    }, 1000);
                });
            };
            $scope.reload();
        };


        $scope.tableReload = function () {
            $scope.reload();
        };

        $scope.submitting = false;
        $scope.genWages = function () {
            $scope.canSubmit = true;
            $scope.editAwd = true;
            $scope.canGen = false;
            $scope.submitting = true;
            var params = {};
            params['opt'] = $scope.opt;
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            WageReport.genWages(params).$promise.then(function () {
                $scope.reload();
                toaster.success('计算成功');
                $scope.submitting = false;
            }, function () {
                $scope.submitting = false;
            });
        };

        $scope.canSave = true;

        $scope.save = function (type) {
            if (type == 1) {
                $scope.canSave = false;
                $scope.canGen = true;
            } else {
                $scope.canSubmit = true;
                $scope.canSave2 = false;
            }
            var params = {};
            params['wages'] = $scope.wages;
            params['opt'] = $scope.opt;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            params['change_users'] = $scope.change_users;
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
            });
        };

        $scope.edit = function () {
            dialogs.confirm('修改考勤工资', '<strong class="text-red">修改后请保存并提交,否则会被计算的考勤工资覆盖数据</strong>')
                .result.then(function () {
                $scope.editAwd = false;
                $scope.canSave2 = true;
                $scope.canSubmit = false;
                table.updateSettings({
                    cells: function (row, col, prop) {
                        var cellProperties = {};
                        if ((col == 31 && $scope.opt != 21) || (col == 32 && $scope.opt == 21)) {
                            cellProperties.readOnly = false;
                        } else {
                            cellProperties.readOnly = true;
                        }
                        return cellProperties;
                    }
                });
            });
        };

        $scope.submit = function () {
            if ($scope.opt == 5 || $scope.opt == 21) {
                dialogs.confirm('提交至' + ($scope.opt == 21 ? '财务科' : '科室负责人'), '<strong class="text-red">提交后无法再修改工资,是否提交?</strong>')
                    .result.then(function () {
                    $scope.submitting = true;
                    var params = {};
                    params['opt'] = $scope.opt;
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['change_users'] = $scope.change_users;
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('提交成功');
                        $scope.submitting = false;
                    }, function () {
                        $scope.submitting = false;
                    });
                });
            }

            if ($scope.opt == 6) {
                dialogs.confirm('发放在编员工月工资', '发放后仍可以修改,是否确定?')
                    .result.then(function () {
                    var params = {};
                    params['opt'] = $scope.opt;
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('发放成功');
                    });
                });
            }

        };

        $scope.back = function (type) {
            if (type == 1) {
                opinionHandle(type);
            } else {
                dialogs.confirm('在编员工月工资退回', '保存审批意见并退回，是否确定?')
                    .result.then(function () {
                    opinionHandle(type);
                });
            }
        };

        function opinionHandle(type) {
            $scope.submitting = true;
            var params = {};
            params['wages'] = $scope.wages;
            params['opt'] = 99;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if (type == 2) {
                params['stage'] = 1;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            params['change_users'] = $scope.change_users;
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
                $scope.submitting = false;
                $scope.change_users = [];
            });
        }

        $scope.end = function () {
            dialogs.confirm('在编员工月工资月结', '月结后不可修改,是否确定?')
                .result.then(function () {
                var params = {};
                if ($scope.reportId) {
                    params['report_id'] = $scope.reportId;
                }
                params['opt'] = 7;
                WageReport.setStage(params).$promise.then(function () {
                    $scope.reload();
                    toaster.success('月结成功');
                });
            });
        };

        $scope.export = function (opt) {
            var y = $scope.dt.getFullYear(), m = $scope.dt.getMonth() + 1;
            var params = {};
            params['start'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
            params['opt'] = opt;
            FileHelper.download(C.URL.RWAGE_DOWNLOAD, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = y + '年' + m + '月' + '员工月工资报表' + '.xls';
                SaveAs.download(data, filename, options);
            }, function (error) {
                toaster.error('导出失败!');
            });
        };

        $scope.selectExport = function () {
            Dlg.show({
                template: 'templates/wage/wageExportDlg.html',
                ctrl: 'UserWageExportDlgCtrl',
                data: {
                    url: C.URL.USER_RWAGE_DOWNLOAD
                }
            });
        };

        $scope.import = function () {
            dialogs.create('templates/wage/tax_dlg.html', 'WageTaxDlgCtrl', {opt: 1},
                {size: 'md'}).result.then(function (data) {
                angular.forEach(data, function (wage) {
                    var index = F.indexOfKey(wage.username, $scope.wages, 'username');
                    if (index >= 0) {
                        $scope.wages[index].i_wtd = wage.wtd;
                        ////计算扣款合计
                        //$scope.wages[index].i_td = getTd($scope.wages[index]);
                        //
                        ////计算实发合计
                        //$scope.wages[index].i_np = getNp($scope.wages[index]);
                    }
                });
            });
        };


        //function addComments(row, string, value) {
        //    table.getCellMeta(row, 2).comment = string + '，预扣款合计为' + value;
        //    commentsPlugin.showAtCell(row, 2);
        //    commentsPlugin.saveCommentAtCell(row, 2);
        //}

        $scope.changeAfter = function (a) {
            if (a) {
                if (a[0].length > 0) {
                    $scope.canSave = true;
                    $scope.canGen = false;
                    $scope.canSubmit = false;
                    $scope.editAwd = false;
                    $scope.canSave2 = false;
                    for (var i = 0; i < a.length; i++) {
                        var row = a[i][0],
                            column = a[i][1],
                            old_value = a[i][2],
                            new_value = a[i][3];

                        var w = $scope.wages[row];

                        if (column == 'i_awd') {
                            $scope.canSave = false;
                            $scope.canSave2 = true;
                        }

                        if (column != 'remark' && column != 'remark_finance' &&column != 'opinion') {
                            if (isNaN(new_value)) {
                                w[column] = old_value;
                                toaster.warning('请输入数字!');
                                $scope.isFullscreen = false;
                            } else if (new_value.length == 0) {
                                w[column] = old_value;
                                toaster.warning('输入不能为空!');
                                $scope.isFullscreen = false;
                            } else {
                                if (new_value < 0 && column != 'i_od') {
                                    w[column] = old_value;
                                    toaster.warning('不能输入负数!');
                                    $scope.isFullscreen = false;
                                } else {
                                    if ($scope.opt == 5 || $scope.opt == 21) {
                                        //计算百分百合计
                                        w.i_hpw = getHpw(w);

                                        //计算应发差额合计
                                        w.i_tbw = getTbw(w);
                                    }

                                    if ($scope.opt == 6) {
                                        commentsPlugin.removeCommentAtCell(row, 2);
                                        //计算百分百合计
                                        w.i_hpw = getHpw(w);

                                        //计算应发差额合计
                                        w.i_tbw = getTbw(w);
                                        //计算14%差额扣款
                                        w.i_lf = getLf(w);

                                        ////计算医保
                                        //w.i_mi = getMi(w);
                                        //
                                        ////计算公积金
                                        //w.i_haf = getHaf(w);
                                        //
                                        ////计算月度失业金
                                        //w.i_uc = getUc(w);
                                        //
                                        ////计算预扣社保及年金
                                        //w.i_ssap = getSsap(w);

                                        //计算应发合计
                                        w.i_tw = getTw(w);

                                        ////计算扣税基数
                                        //w.i_tdb = getTdb(w);

                                        ////计算个税
                                        //if (column != 'i_wtd' && (w.out_tax == '0' || w.out_tax == null)) {
                                        //    w.i_wtd = F.getTax(w.i_tdb).toFixed(2);
                                        //}

                                        //自付公积金跟单位缴付公积金一样
                                        w.i_chaf = w.i_haf;

                                        //计算单位负担社保及公积金->五险二金扣款合计
                                        w.i_spf = getSpf(w);

                                        //计算扣款合计
                                        w.i_td = getTd(w);

                                        //计算实发合计
                                        w.i_np = getNp(w);

                                        //if (w.i_np < 0) {
                                        //    addComments(row, '实发合计为负', -w.i_np);
                                        //    w.s = 0.00
                                        //} else {
                                        //    w.s = w.i_np;
                                        //    commentsPlugin.removeCommentAtCell(row, 2);
                                        //}
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    });


angular.module('c.c').controller('ProbationWageCtrl',
    function ($scope, $filter, dialogs, toaster, Dept, WageReport, C, F, SaveAs, $timeout, FileHelper, Dlg) {
        $scope.$on('wageItemSumbit', function () {
            $scope.reload();
            $scope.canSave = true;
            $scope.canGen = false;
            $scope.canSubmit = false;
            $scope.editAwd = false;
            $scope.canSave2 = false;
        });

        var allData;
        var table, commentsPlugin, sortIndex, tableData;

        $scope.change_users = [];

        $scope.tableSettings = {
            //search: true,
            afterInit: function () {
                table = this;
                commentsPlugin = table.getPlugin('comments');
            },
            manualColumnResize: true, fixedColumnsLeft: 5, colWidths: 60, stretchH: 'all', columnSorting: true,
            sortIndicator: true, comments: true,
            afterColumnSort: function () {
                sortIndex = table.sortIndex;
                tableData = table.getSourceData();

                var wages = [];
                if (sortIndex.length != 0) {
                    for (var i = 0; i < sortIndex.length; i++) {
                        var index = sortIndex[i][0];
                        wages.push(tableData[index])
                    }
                    $scope.wages = wages;
                }
            },
            afterOnCellMouseDown: function (event, c, TD) {
                var row = $scope.wages[c.row];
                if (c.col === 5) {
                    $scope.change_users.push(row.id);
                }
            }
        };

        $scope.myCustomRenderer = function (hotInstance, td, row, col, prop, value, cellProperties) {
            value = value === null ? '' : value;
            if (prop === 'diff') {
                td.innerHTML = '<span class="htDimmed-red">' + value + '</span>';
            }
            if (prop === 'opinion') {
                td.innerHTML = '<span class="htDimmed-green">' + value + '</span>';
            }
        };

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
            $scope.depts = resp.depts;
            if ($scope.depts && $scope.depts.length > 0) {
                $scope.depts.splice(0, 0, {name: '全部科室'});
            }
        });

        $scope.query = {dept: {name: '全部科室'}};
        $scope.change = function (query) {
            var wages = $filter('filter')(allData, {name: query.name});
            $scope.wages = $filter('filter')(wages, {dept_id: query.dept.id}, true);

        };


        var date = new Date((new Date()).setDate(1));
        $scope.dt = new Date(date.setMonth(date.getMonth() - 1));
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dt = new Date(curr.setMonth(prev));
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dt = new Date(curr.setMonth(next));
        };

        $scope.$watch('dt', function (newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.reload();
            }
        });

        //计算应发合计
        function getTw(wage) {
            var total2 = eval(wage.p_bw + '+' + wage.p_css+ '+' + wage.p_chaf + '+' + wage.p_ow + '+' + wage.p_ma + '+'
                + wage.p_rw);
            return total2.toFixed(2);
        }


        //计算扣款合计(排除特殊请假情况)
        function getTd(wage) {
            var total4 = eval(wage.p_rent + '+' + wage.p_weof + '+' + wage.p_pss + '+' + wage.p_ss + '+' +
                wage.p_phaf + '+' + wage.p_haf + '+' + wage.p_mad + '+' + wage.p_pf + '+' + wage.p_rwd + '+' + wage.p_od + '+' + wage.p_wtd + '+' +
                wage.p_awd);
            return total4.toFixed(2);
        }

        $scope.init = function (opt) {
            $scope.opt = opt;
            $scope.reload = function () {
                $scope.stage = null;
                $scope.loading = true;
                var params = [];
                params['opt'] = opt;
                params['month'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                WageReport.query(params, function (resp) {
                    $scope.loading = false;
                    var wages = resp.wages;
                    if (wages.length > 0) {
                        $scope.stage = wages[0].stage;
                        $scope.reportId = wages[0].report_id;
                    }

                    var comments = [];
                    angular.forEach(wages, function (wage, index) {
                        if (wage.other) wage.opinion = wage.other.remark
                        //if (wage.p_np < 0) {
                        //    comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.p_np});
                        //}

                        switch (wage.p_awd) {
                            case '-1.00':
                                wage.p_awd = '全月病假';
                                comments.push({row: index, col: 2, comment: "全月病假,预扣款合计为" + wage.p_td});
                                break;
                            case '-2.00':
                                wage.p_awd = '全月事假';
                                comments.push({row: index, col: 2, comment: "全月事假,预扣款合计为" + wage.p_td});
                                break;
                            case '-3.00':
                                wage.p_awd = '全月事病假';
                                comments.push({row: index, col: 2, comment: "全月事病假,预扣款合计为" + wage.p_td});
                                break;
                        }

                        if (wage.p_np == 0) {
                            switch (wage.p_awd) {
                                case '-1.00':
                                case '-2.00':
                                case '-3.00':
                                    wage.p_tw = wage.p_td = getTw(wage);
                                    break;
                                default:
                                    wage.p_tw = getTw(wage);
                                    wage.p_td = getTd(wage);
                                    //计算实发合计
                                    wage.p_np = eval(wage.p_tw + '-' + wage.p_td).toFixed(2);
                            }
                        }
                    });
                    $scope.wages = allData = wages;
                    $timeout(function () {
                        table.updateSettings({
                            cell: comments
                        }, 1000);
                    });
                });
            };
            $scope.reload();
        };


        $scope.tableReload = function () {
            $scope.reload();
        };

        $scope.submitting = false;
        $scope.genWages = function () {
            $scope.canSubmit = true;
            $scope.editAwd = true;
            $scope.canGen = false;
            $scope.submitting = true;
            var params = {};
            params['opt'] = $scope.opt;
            WageReport.genWages(params).$promise.then(function () {
                $scope.submitting = false;
                $scope.reload();
                toaster.success('计算成功');
            }, function () {
                $scope.submitting = false;
            });
        };

        $scope.canSave = true;

        $scope.save = function (type) {
            if (type == 1) {
                $scope.canSave = false;
                $scope.canGen = true;
            } else {
                $scope.canSubmit = true;
                $scope.canSave2 = false;
            }

            var wages = $scope.wages;
            angular.forEach(wages, function (wage) {
                switch (wage.p_awd) {
                    case '全月病假':
                        wage.p_awd = -1.00;
                        break;
                    case '全月事假':
                        wage.p_awd = -2.00;
                        break;
                    case '全月事病假':
                        wage.p_awd = -3.00;
                        break;
                }
            });
            var params = {};
            params['wages'] = wages;
            params['opt'] = $scope.opt;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
            });
        };

        $scope.edit = function () {
            dialogs.confirm('修改考勤工资', '<strong class="text-red">修改后请保存并提交,否则会被计算的考勤工资覆盖数据</strong>')
                .result.then(function () {
                $scope.editAwd = false;
                $scope.canSave2 = true;
                $scope.canSubmit = false;
                table.updateSettings({
                    cells: function (row, col, prop) {
                        var cellProperties = {};
                        if ((col == 18 && $scope.opt != 22) || (col == 19 && $scope.opt == 22)) {
                            cellProperties.readOnly = false;
                        } else {
                            cellProperties.readOnly = true;
                        }
                        return cellProperties;
                    }
                });
            });
        };

        $scope.submit = function () {
            if (($scope.opt == 8 || $scope.opt == 22) && !$scope.submitting) {
                dialogs.confirm('提交至'+ ($scope.opt == 22 ? '财务科' : '科室负责人'), '<strong class="text-red">提交后无法再修改工资,是否提交?</strong>')
                    .result.then(function () {
                    $scope.submitting = true;
                    var params = {};
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['opt'] = $scope.opt;
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('提交成功');
                        $scope.submitting = false;
                    }, function () {
                        $scope.submitting = false;
                    });
                });
            }

            if ($scope.opt == 9) {
                dialogs.confirm('发放试用员工月工资', '发放后仍可以修改,是否确定?')
                    .result.then(function () {
                    var params = {};
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['opt'] = $scope.opt;
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('发放成功');
                    });
                });
            }

        };

        $scope.back = function (type) {
            if (type == 1) {
                opinionHandle(type);
            } else {
                dialogs.confirm('试用员工月工资退回', '保存审批意见并退回，是否确定?')
                    .result.then(function () {
                    opinionHandle(type);
                });
            }
        };

        function opinionHandle(type) {
            $scope.submitting = true;
            var params = {};
            params['wages'] = $scope.wages;
            params['opt'] = 99;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if (type == 2) {
                params['stage'] = 1;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            params['change_users'] = $scope.change_users;
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
                $scope.submitting = false;
                $scope.change_users = [];
            });
        }

        $scope.end = function () {
            dialogs.confirm('试用员工月工资月结', '月结后不可修改,是否确定?')
                .result.then(function () {
                var params = {};
                if ($scope.reportId) {
                    params['report_id'] = $scope.reportId;
                }
                params['opt'] = 10;   //月结
                WageReport.setStage(params).$promise.then(function () {
                    $scope.reload();
                    toaster.success('月结成功');
                });
            });
        };

        $scope.export = function (opt) {
            var y = $scope.dt.getFullYear(), m = $scope.dt.getMonth() + 1;
            var params = {};
            params['start'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
            params['opt'] = opt;
            FileHelper.download(C.URL.RWAGE_DOWNLOAD, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = y + '年' + m + '月' + '员工月工资报表' + '.xls';
                SaveAs.download(data, filename, options);
            }, function (error) {
                toaster.error('导出失败!');
            });
        };

        $scope.selectExport = function () {
            Dlg.show({
                template: 'templates/wage/wageExportDlg.html',
                ctrl: 'UserWageExportDlgCtrl',
                data: {
                    url: C.URL.USER_RWAGE_DOWNLOAD
                }
            });
        };

        $scope.import = function () {
            dialogs.create('templates/wage/tax_dlg.html', 'WageTaxDlgCtrl', {opt: 1},
                {size: 'md'}).result.then(function (data) {
                angular.forEach(data, function (wage) {
                    var index = F.indexOfKey(wage.username, $scope.wages, 'username');
                    if (index >= 0) {
                        $scope.wages[index].r_wtd = wage.wtd;
                    }
                });
            });
        };

        $scope.importInsurance = function () {
            dialogs.create('templates/wage/tax_dlg.html', 'WageTaxDlgCtrl', {opt: 2},
                {size: 'md'}).result.then(function (data) {
                angular.forEach(data, function (wage) {
                    var index = F.indexOfKey(wage.username, $scope.wages, 'username');
                    if (index >= 0) {
                        $scope.wages[index].p_css = wage.css;
                        $scope.wages[index].p_ss = wage.ss;
                        $scope.wages[index].p_pss = wage.css;
                    }
                });
            });

        };

        $scope.changeAfter = function (a) {
            if (a) {
                if (a[0].length > 0) {
                    $scope.canSave = true;
                    $scope.canGen = false;
                    $scope.canSubmit = false;
                    $scope.editAwd = false;
                    $scope.canSave2 = false;
                    for (var i = 0; i < a.length; i++) {
                        var row = a[i][0],
                            column = a[i][1],
                            old_value = a[i][2],
                            new_value = a[i][3];
                        var w = $scope.wages[row];

                        if (column == 'p_awd') {
                            $scope.canSave = false;
                            $scope.canSave2 = true;
                        }

                        if (column != 'remark' && column != 'opinion') {
                            if (isNaN(new_value)) {
                                w[column] = old_value;
                                toaster.warning('请输入数字!');
                                $scope.isFullscreen = false;
                            } else if (new_value.length == 0) {
                                w[column] = old_value;
                                toaster.warning('输入不能为空!');
                                $scope.isFullscreen = false;
                            } else {
                                if (new_value < 0 && column != 'p_rwd') {
                                    w[column] = old_value;
                                    toaster.warning('不能输入负数!');
                                    $scope.isFullscreen = false;
                                } else {
                                    if ($scope.opt == 8|| $scope.opt == 22) {   //人事科试用
                                        w.p_pss = w.p_css;
                                    }
                                    if ($scope.opt == 9) {   //财务科试用
                                        commentsPlugin.removeCommentAtCell(row, 2);
                                        w.p_phaf = w.p_haf = w.p_chaf;
                                        if (w.p_awd == '全月病假' || w.p_awd == '全月事假' || w.p_awd == '全月事病假') {
                                            //计算扣款合计、应发合计
                                            w.p_tw = w.p_td = getTw(w);
                                        } else {
                                            //计算扣款合计、应发合计
                                            w.p_tw = getTw(w);
                                            w.p_td = getTd(w);
                                            //实发合计
                                            w.p_np = eval(w.p_tw + '-' + w.p_td).toFixed(2);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    });

angular.module('c.c').controller('RecruitmentWageCtrl',
    function ($scope, $filter, dialogs, toaster, Dept, WageReport, C, F, FileHelper, SaveAs, $timeout, Dlg) {
        $scope.$on('wageItemSumbit', function () {
            $scope.reload();
            $scope.canSave = true;
            $scope.canGen = false;
            $scope.canSubmit = false;
            $scope.editAwd = false;
            $scope.canSave2 = false;
        });

        var allData;
        var table, commentsPlugin, sortIndex, tableData;

        $scope.change_users = [];

        $scope.tableSettings = {
            //search: true,
            afterInit: function () {
                table = this;
                commentsPlugin = table.getPlugin('comments');
            },
            manualColumnResize: true, fixedColumnsLeft: 5, colWidths: 60, stretchH: 'all', columnSorting: true,
            sortIndicator: true, comments: true,
            afterColumnSort: function () {
                sortIndex = table.sortIndex;
                tableData = table.getSourceData();

                var wages = [];
                if (sortIndex.length != 0) {
                    for (var i = 0; i < sortIndex.length; i++) {
                        var index = sortIndex[i][0];
                        wages.push(tableData[index])
                    }
                    $scope.wages = wages;
                }
            },
            afterOnCellMouseDown: function (event, c, TD) {
                var row = $scope.wages[c.row];
                if (c.col === 5) {
                    $scope.change_users.push(row.id);
                }
            }
        };

        $scope.myCustomRenderer = function (hotInstance, td, row, col, prop, value, cellProperties) {
            value = value === null ? '' : value;
            if (prop === 'diff') {
                td.innerHTML = '<span class="htDimmed-red">' + value + '</span>';
            }
            if (prop === 'opinion') {
                td.innerHTML = '<span class="htDimmed-green">' + value + '</span>';
            }
        };

        //$scope.change = function search(query) {
        //    table.search.query(query);
        //    table.render();
        //};

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
            $scope.depts = resp.depts;
            if ($scope.depts && $scope.depts.length > 0) {
                $scope.depts.splice(0, 0, {name: '全部科室'});
            }
        });

        $scope.query = {dept: {name: '全部科室'}};
        $scope.change = function (query) {
            var wages = $filter('filter')(allData, {name: query.name});
            $scope.wages = $filter('filter')(wages, {dept_id: query.dept.id}, true);

            $timeout(function () {
                var comments = [];
                angular.forEach($scope.wages, function (wage, index) {
                    if (wage.r_td > 0) {
                        switch (wage.r_awd) {
                            case '全月病假':
                                comments.push({
                                    row: index,
                                    col: 2,
                                    comment: "全月病假,预扣款合计为" + wage.r_td
                                });
                                break;
                            case '全月事假':
                                comments.push({
                                    row: index,
                                    col: 2,
                                    comment: "全月事假,预扣款合计为" + wage.r_td
                                });
                                break;
                            case '全月事病假':
                                comments.push({
                                    row: index,
                                    col: 2,
                                    comment: "全月事病假,预扣款合计为" + wage.r_td
                                });
                                break;
                        }
                    }

                    if (wage.r_np < 0) {
                        comments.push({
                            row: index,
                            col: 2,
                            comment: "实发合计为负,预扣款合计为" + -wage.r_np
                        });
                    }
                });
                table.updateSettings({
                    cell: comments
                });
            }, 1000);

        };


        var date = new Date((new Date()).setDate(1));
        $scope.dt = new Date(date.setMonth(date.getMonth() - 1));
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dt = new Date(curr.setMonth(prev));
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dt = new Date(curr.setMonth(next));
        };

        $scope.$watch('dt', function (newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.reload();
            }
        });

        //计算教护补贴
        function getEsa(wage) {
            var total0 = eval(wage.r_bw + '+' + wage.r_gw);
            return (total0 * 0.1).toFixed(2);
        }

        //计算公积金
        function getHaf(wage) {
            //var total1 = eval(wage.r_bw + '+' + wage.r_gw + '+' + wage.r_ha + '+' + wage.r_pw + '+' +
            //    wage.r_ocf + '+' + wage.r_ilt + '+' + wage.r_oshn + '+' + wage.r_ow)
            var total1 = eval(wage.r_bw + '+' + wage.r_gw + '+' + wage.r_esa + '+' +
                wage.r_ocf + '+' + wage.r_ow);
            return (total1 * 0.06).toFixed(0);
        }

        //计算应发合计
        function getTw(wage) {
            //var total2 = eval(wage.r_bw + '+' + wage.r_gw + '+' + wage.r_ha + '+' + wage.r_pw + '+' + wage.r_ocf + '+'
            //    + wage.r_ilt + '+' + wage.r_oshn + '+' + wage.r_ow + '+' + wage.r_css + '+' + wage.r_chaf + '+' +
            //    wage.r_ma + '+' + wage.r_rw + '+' + wage.r_kpiw);
            var total2 = eval(wage.r_bw + '+' + wage.r_gw + '+' + wage.r_esa + '+' + wage.r_ocf + '+' + wage.r_ow + '+'
                + wage.r_css + '+' + wage.r_chaf + '+' + wage.r_ma + '+' + wage.r_rw + '+' + wage.r_kpiw);
            return total2.toFixed(2);
        }

        //计算计税基数
        function getTdb(wage) {
            //var total3 = eval(wage.r_bw + '+' + wage.r_gw + '+' + wage.r_ha + '+' + wage.r_pw + '+' +
            //    wage.r_ilt + '+' + wage.r_oshn + '+' + wage.r_css + '+' + wage.r_ma + '+' + wage.r_ow
            //    + '+' + wage.r_kpiw + '-' + wage.r_pss + '-' + wage.r_ss + '-' + wage.r_haf + '-' + wage.r_od);
            var total3 = eval(wage.r_bw + '+' + wage.r_gw + '+' + wage.r_esa + '+' + wage.r_css + '+' + wage.r_ma + '+'
                + wage.r_ow + '+' + wage.r_kpiw + '-' + wage.r_pss + '-' + wage.r_ss + '-' + wage.r_haf + '-' + wage.r_od);
            return total3.toFixed(2);
        }

        //计算扣款合计(排除特殊请假情况)
        function getTd(wage) {
            var total4 = eval(wage.r_rent + '+' + wage.r_weof + '+' + wage.r_pty + '+' + wage.r_pss + '+' + wage.r_ss + '+' +
                wage.r_phaf + '+' + wage.r_haf + '+' + wage.r_mad + '+' + wage.r_pf + '+' + wage.r_rwd + '+' +
                wage.r_od + '+' + wage.r_kpid + '+' + wage.r_rwtd + '+' + wage.r_awd + '+' + wage.r_wtd);
            return total4.toFixed(2);
        }

        $scope.init = function (opt) {
            $scope.opt = opt;//1.人事科 2.财务科
            $scope.reload = function () {
                $scope.stage = null;
                $scope.loading = true;
                var params = [];
                params['opt'] = opt;
                params['month'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                WageReport.query(params, function (resp) {
                    $scope.loading = false;
                    var wages = resp.wages;
                    if (wages.length > 0) {
                        $scope.stage = wages[0].stage;
                        $scope.reportId = wages[0].report_id;
                    }

                    var comments = [];
                    angular.forEach(wages, function (wage, index) {
                        if (wage.other) wage.opinion = wage.other.remark
                        if (opt == 1 || opt == 20) {
                            //护士计算教护补贴
                            if (wage.type_id == '2') {
                                wage.r_esa = getEsa(wage);
                            }

                            if (wage.r_np < 0) {
                                comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.r_np});
                            }

                            if (wage.r_td > 0) {
                                switch (wage.r_awd) {
                                    case '-1.00':
                                        comments.push({
                                            row: index,
                                            col: 2,
                                            comment: "全月病假,预扣款合计为" + wage.r_td
                                        });
                                        break;
                                    case '-2.00':
                                        comments.push({
                                            row: index,
                                            col: 2,
                                            comment: "全月事假,预扣款合计为" + wage.r_td
                                        });
                                        break;
                                    case '-3.00':
                                        comments.push({
                                            row: index,
                                            col: 2,
                                            comment: "全月事病假,预扣款合计为" + wage.r_td
                                        });
                                        break;
                                }
                            }
                        }

                        if (opt == 2) {
                            if (wage.r_np == 0) {
                                ////计算公积金
                                //if (wage.r_chaf == 0) {
                                //    wage.r_chaf = wage.r_phaf = wage.r_haf = getHaf(wage);
                                //}

                                //计算计税基数
                                wage.r_tdb = getTdb(wage);

                                ////计算个税
                                //if (wage.out_tax == '0' || wage.out_tax == null) {
                                //    wage.r_wtd = F.getTax(wage.r_tdb).toFixed(2);
                                //}

                                //计算扣款合计、应发合计
                                //var t1 = eval(wage.r_ss + '+' + wage.r_haf);//自付公积金和保险
                                //var t2 = eval(wage.r_css + '+' + wage.r_chaf);//单位缴纳公积金和保险
                                //var t3 = eval(wage.r_rent + '+' + wage.r_weof + '+' + wage.r_pf + '+' + wage.r_rwd
                                //    + '+' + wage.r_od + '+' + wage.r_rwtd);

                                //var t1 = wage.r_ss + wage.r_haf;//自付公积金和保险
                                //var t2 = wage.r_css + wage.r_chaf;//单位缴纳公积金和保险
                                //var t3 = wage.r_rent + wage.r_weof + wage.r_pf + wage.r_rwd + wage.r_od + wage.r_rwtd;
                                switch (wage.r_awd) {
                                    case '-1.00':
                                    case '-2.00':
                                    case '-3.00':
                                        wage.r_tw = wage.r_td = getTw(wage);
                                        break;
                                    //case '-1.00':
                                    //    wage.r_tw = wage.r_td = (t1 + t3).toFixed(2);
                                    //    comments.push({row: index, col: 2, comment: "全月病假,预扣款合计为" + wage.r_td});
                                    //    break;
                                    //case '-2.00':
                                    //    wage.r_tw = wage.r_td = (t1 + t2 + t3).toFixed(2);
                                    //    comments.push({row: index, col: 2, comment: "全月事假,预扣款合计为" + wage.r_td});
                                    //    break;
                                    //case '-3.00':
                                    //    var params = [];
                                    //    params['opt'] = 10; //获得请假信息
                                    //    params['user_id'] = wage.user_id;
                                    //    WageReport.query(params, function (resp) {
                                    //        wage.sick_days = resp.sick_days;
                                    //        wage.affair_days = resp.affair_days;
                                    //        wage.days = resp.days;
                                    //        wage.r_tw = wage.r_td = (t1 / wage.days * wage.sick_days + (t1 + t2) / wage.days * wage.affair_days + t3).toFixed(2);
                                    //        comments.push({row: index, col: 2, comment: "全月事病假,预扣款合计为" + wage.r_td});
                                    //    });
                                    //    break;
                                    default:
                                        wage.r_tw = getTw(wage);
                                        wage.r_td = getTd(wage);
                                        //计算实发合计
                                        wage.r_np = eval(wage.r_tw + '-' + wage.r_td).toFixed(2);
                                }
                            }

                            if (wage.r_np < 0) {
                                comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.r_np});
                            }
                        }

                        switch (wage.r_awd) {
                            case '-1.00':
                                wage.r_awd = '全月病假';
                                break;
                            case '-2.00':
                                wage.r_awd = '全月事假';
                                break;
                            case '-3.00':
                                wage.r_awd = '全月事病假';
                                break;
                        }
                    });
                    $scope.wages = allData = wages;
                    $timeout(function () {
                        table.updateSettings({
                            cell: comments
                        }, 1000);
                    });
                });
            };
            $scope.reload();
        };


        $scope.tableReload = function () {
            $scope.reload();
        };

        $scope.submitting = false;
        $scope.genWages = function () {
            $scope.canSubmit = true;
            $scope.editAwd = true;
            $scope.canGen = false;
            $scope.submitting = true;
            var params = {};
            params['opt'] = $scope.opt;
            WageReport.genWages(params).$promise.then(function () {
                $scope.submitting = false;
                $scope.reload();
                toaster.success('计算成功');
            }, function () {
                $scope.submitting = false;
            });
        };

        $scope.canSave = true;

        $scope.save = function (type) {
            if (type == 1) {
                $scope.canSave = false;
                $scope.canGen = true;
            } else {
                $scope.canSubmit = true;
                $scope.canSave2 = false;
            }

            var wages = $scope.wages;
            angular.forEach(wages, function (wage) {
                switch (wage.r_awd) {
                    case '全月病假':
                        wage.r_awd = -1.00;
                        break;
                    case '全月事假':
                        wage.r_awd = -2.00;
                        break;
                    case '全月事病假':
                        wage.r_awd = -3.00;
                        break;
                }
            });
            var params = {};
            params['wages'] = wages;
            params['opt'] = $scope.opt;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
            });
        };

        $scope.edit = function () {
            dialogs.confirm('修改考勤工资', '<strong class="text-red">修改后请保存并提交,否则会被计算的考勤工资覆盖数据</strong>')
                .result.then(function () {
                $scope.editAwd = false;
                $scope.canSave2 = true;
                $scope.canSubmit = false;
                table.updateSettings({
                    cells: function (row, col, prop) {
                        var cellProperties = {};
                        if ((col == 22 && $scope.opt != 20) || (col == 23 && $scope.opt == 20)) {
                            cellProperties.readOnly = false;
                        } else {
                            cellProperties.readOnly = true;
                        }
                        return cellProperties;
                    }
                });
            });
        };

        $scope.submit = function () {
            if (($scope.opt == 1 || $scope.opt == 20) && !$scope.submitting) {
                dialogs.confirm('提交至' + ($scope.opt == 20 ? '财务科' : '科室负责人'), '<strong class="text-red">提交后无法再修改工资,是否提交?</strong>')
                    .result.then(function () {
                    $scope.submitting = true;
                    var params = {};
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['opt'] = $scope.opt;
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('提交成功');
                        $scope.submitting = false;
                    }, function () {
                        $scope.submitting = false;
                    });
                });
            }

            if ($scope.opt == 2) {
                dialogs.confirm('发放招聘员工月工资', '发放后仍可以修改,是否确定?')
                    .result.then(function () {
                    var params = {};
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['opt'] = $scope.opt;
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('发放成功');
                    });
                });
            }

        };

        $scope.back = function (type) {
            if (type == 1) {
                opinionHandle(type);
            } else {
                dialogs.confirm('招聘员工月工资退回', '保存审批意见并退回，是否确定?')
                    .result.then(function () {
                    opinionHandle(type);
                });
            }
        };

        function opinionHandle(type) {
            $scope.submitting = true;
            var params = {};
            params['wages'] = $scope.wages;
            params['opt'] = 99;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if (type == 2) {
                params['stage'] = 1;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            params['change_users'] = $scope.change_users;
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
                $scope.submitting = false;
                $scope.change_users = [];
            });
        }

        $scope.end = function () {
            dialogs.confirm('招聘员工月工资月结', '月结后不可修改,是否确定?')
                .result.then(function () {
                var params = {};
                if ($scope.reportId) {
                    params['report_id'] = $scope.reportId;
                }
                params['opt'] = 3;
                WageReport.setStage(params).$promise.then(function () {
                    $scope.reload();
                    toaster.success('月结成功');
                });
            });
        };

        $scope.export = function (opt) {
            var y = $scope.dt.getFullYear(), m = $scope.dt.getMonth() + 1;
            var params = {};
            params['start'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
            params['opt'] = opt;
            FileHelper.download(C.URL.RWAGE_DOWNLOAD, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = y + '年' + m + '月' + '员工月工资报表' + '.xls';
                SaveAs.download(data, filename, options);
            }, function (error) {
                toaster.error('导出失败!');
            });
        };

        $scope.selectExport = function () {
            Dlg.show({
                template: 'templates/wage/wageExportDlg.html',
                ctrl: 'UserWageExportDlgCtrl',
                data: {
                    url: C.URL.USER_RWAGE_DOWNLOAD
                }
            });
        };

        $scope.exportAll = WageReport.exportYearWageStat;

        $scope.import = function () {
            dialogs.create('templates/wage/tax_dlg.html', 'WageTaxDlgCtrl', {opt: 1},
                {size: 'md'}).result.then(function (data) {
                angular.forEach(data, function (wage) {
                    var index = F.indexOfKey(wage.username, $scope.wages, 'username');
                    if (index >= 0) {
                        $scope.wages[index].r_wtd = wage.wtd;
                        ////计算扣款合计
                        //$scope.wages[index].r_td = getTd($scope.wages[index]);
                        //
                        ////计算实发合计
                        //$scope.wages[index].r_np = eval($scope.wages[index].r_tw + '-' + $scope.wages[index].r_td).toFixed(2)
                    }
                });
            });
        };

        $scope.importInsurance = function () {
            dialogs.create('templates/wage/tax_dlg.html', 'WageTaxDlgCtrl', {opt: 2},
                {size: 'md'}).result.then(function (data) {
                angular.forEach(data, function (wage) {
                    var index = F.indexOfKey(wage.username, $scope.wages, 'username');
                    if (index >= 0) {
                        $scope.wages[index].r_css = wage.css;
                        $scope.wages[index].r_ss = wage.ss;
                        $scope.wages[index].r_pss = wage.css;
                        ////计算扣款合计
                        //$scope.wages[index].r_td = getTd($scope.wages[index]);
                        //$scope.wages[index].r_tw = getTw($scope.wages[index]);
                        //
                        ////计算实发合计
                        //$scope.wages[index].r_np = eval($scope.wages[index].r_tw + '-' + $scope.wages[index].r_td).toFixed(2)
                    }
                });
            });

        };

        //function addComments(row, string, value) {
        //    table.getCellMeta(row, 2).comment = string + '，预扣款合计为' + value;
        //    commentsPlugin.showAtCell(row, 2);
        //    commentsPlugin.saveCommentAtCell(row, 2);
        //}

        $scope.changeAfter = function (a) {

            if (a) {
                if (a[0].length > 0) {
                    $scope.canSave = true;
                    $scope.canGen = false;
                    $scope.canSubmit = false;
                    $scope.editAwd = false;
                    $scope.canSave2 = false;
                    for (var i = 0; i < a.length; i++) {
                        var row = a[i][0],
                            column = a[i][1],
                            old_value = a[i][2],
                            new_value = a[i][3];
                        var w = $scope.wages[row];

                        if (column == 'r_awd') {
                            $scope.canSave = false;
                            $scope.canSave2 = true;
                        }

                        if (column != 'remark' && column != 'opinion') {
                            if (isNaN(new_value)) {
                                w[column] = old_value;
                                toaster.warning('请输入数字!');
                                $scope.isFullscreen = false;
                            } else if (new_value.length == 0) {
                                w[column] = old_value;
                                toaster.warning('输入不能为空!');
                                $scope.isFullscreen = false;
                            } else {
                                if (new_value < 0 && column != 'r_rwd') {
                                    w[column] = old_value;
                                    toaster.warning('不能输入负数!');
                                    $scope.isFullscreen = false;
                                } else {
                                    if ($scope.opt == 1|| $scope.opt == 20) {
                                        w.r_pss = w.r_css;
                                    }
                                    if ($scope.opt == 2) {
                                        commentsPlugin.removeCommentAtCell(row, 2);
                                        w.r_phaf = w.r_haf = w.r_chaf;

                                        //扣税基数
                                        w.r_tdb = getTdb(w);
                                        ////代扣税
                                        //if (w.out_tax == '0' || w.out_tax == null) {
                                        //    w.r_wtd = F.getTax(w.r_tdb).toFixed(2);
                                        //}
                                        if (w.r_awd == '全月病假' || w.r_awd == '全月事假' || w.r_awd == '全月事病假') {
                                            //计算扣款合计、应发合计
                                            w.r_tw = w.r_td = getTw(w);
                                            //var t1 = eval(w.r_ss + '+' + w.r_haf);//自付公积金和保险
                                            //var t2 = eval(w.r_css + '+' + w.r_chaf);//单位缴纳公积金和保险
                                            //var t3 = eval(w.r_rent + '+' + w.r_weof + '+' + w.r_pf + '+' + w.r_rwd
                                            //    + '+' + w.r_od + '+' + w.r_rwtd);

                                            //var t1 = w.r_ss + w.r_haf;//自付公积金和保险
                                            //var t2 = w.r_css + w.r_chaf;//单位缴纳公积金和保险
                                            //var t3 = w.r_rent + w.r_weof + w.r_pf + w.r_rwd + w.r_od + w.r_rwtd;

                                            //switch (w.r_awd) {
                                            //    case '全月病假':
                                            //        w.r_tw = w.r_td = (t1 + t3).toFixed(2);
                                            //        //addComments(row, '全月病假', w.r_td);
                                            //        break;
                                            //    case '全月事假':
                                            //        w.r_tw = w.r_td = (t1 + t2 + t3).toFixed(2);
                                            //        //addComments(row, '全月事假', w.r_td);
                                            //        break;
                                            //    case '全月事病假':
                                            //        w.r_tw = w.r_td = (t1 / w.days * w.sick_days + (t1 + t2) / w.days * w.affair_days + t3).toFixed(2);
                                            //        //addComments(row, '全月事病假', w.r_td);
                                            //        break;
                                            //}
                                        } else {
                                            //计算扣款合计、应发合计
                                            w.r_tw = getTw(w);
                                            w.r_td = getTd(w);
                                            //实发合计
                                            w.r_np = eval(w.r_tw + '-' + w.r_td).toFixed(2);


                                            //if (w.r_np < 0) {
                                            //    //addComments(row, '实发合计为负', -w.r_np);
                                            //    w.s = 0.00
                                            //} else {
                                            //    w.s = w.r_np;
                                            //    //commentsPlugin.removeCommentAtCell(row, 2);
                                            //}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    });

angular.module('c.c').controller('RehireWageCtrl',
    function ($scope, $filter, dialogs, toaster, Dept, WageReport, C, F, SaveAs, $timeout, FileHelper, Dlg) {
        $scope.$on('wageItemSumbit', function () {
            $scope.reload();
            $scope.canSave = true;
            $scope.canGen = false;
            $scope.canSubmit = false;
            $scope.editAwd = false;
            $scope.canSave2 = false;
        });

        var allData;
        var table, commentsPlugin, sortIndex, tableData;

        $scope.change_users = [];

        $scope.tableSettings = {
            //search: true,
            afterInit: function () {
                table = this;
                commentsPlugin = table.getPlugin('comments');
            },
            manualColumnResize: true, fixedColumnsLeft: 5, colWidths: 60, stretchH: 'all', columnSorting: true,
            sortIndicator: true, comments: true,
            afterColumnSort: function () {
                sortIndex = table.sortIndex;
                tableData = table.getSourceData();

                var wages = [];
                if (sortIndex.length != 0) {
                    for (var i = 0; i < sortIndex.length; i++) {
                        var index = sortIndex[i][0];
                        wages.push(tableData[index])
                    }
                    $scope.wages = wages;
                }
            },
            afterOnCellMouseDown: function (event, c, TD) {
                var row = $scope.wages[c.row];
                if (c.col === 4) {
                    $scope.change_users.push(row.id);
                }
            }
        };

        $scope.myCustomRenderer = function (hotInstance, td, row, col, prop, value, cellProperties) {
            value = value === null ? '' : value;
            if (prop === 'diff') {
                td.innerHTML = '<span class="htDimmed-red">' + value + '</span>';
            }
            if (prop === 'opinion') {
                td.innerHTML = '<span class="htDimmed-green">' + value + '</span>';
            }
        };

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
            $scope.depts = resp.depts;
            if ($scope.depts && $scope.depts.length > 0) {
                $scope.depts.splice(0, 0, {name: '全部科室'});
            }
        });

        $scope.query = {dept: {name: '全部科室'}};
        $scope.change = function (query) {
            var wages = $filter('filter')(allData, {name: query.name});
            $scope.wages = $filter('filter')(wages, {dept_id: query.dept.id}, true);
        };

        var date = new Date((new Date()).setDate(1));
        $scope.dt = new Date(date.setMonth(date.getMonth() - 1));
        $scope.prevMonth = function (curr) {
            var prev = curr.getMonth() - 1;
            $scope.dt = new Date(curr.setMonth(prev));
        };
        $scope.nextMonth = function (curr) {
            var next = curr.getMonth() + 1;
            $scope.dt = new Date(curr.setMonth(next));
        };

        $scope.$watch('dt', function (newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.reload();
            }
        });

        //计算应发合计
        function getTw(wage) {
            var total2 = eval(wage.h_bw + '+' + wage.h_gw + '+' + wage.h_chaf + '+' + wage.h_ma + '+' + wage.h_rw + '+' + wage.h_ow + '+' + wage.h_esa);
            return total2.toFixed(2);
        }


        //计算扣款合计(排除特殊请假情况)
        function getTd(wage) {
            var total4 = eval(wage.h_rent + '+' + wage.h_weof + '+' + wage.h_phaf + '+' + wage.h_haf + '+' +
                wage.h_mad + '+' + wage.h_pf + '+' + wage.h_rwd + '+' + wage.h_od + '+' + wage.h_awd);
            return total4.toFixed(2);
        }

        $scope.init = function (opt) {
            $scope.opt = opt;
            $scope.reload = function () {
                $scope.stage = null;
                $scope.loading = true;
                var params = [];
                params['opt'] = opt;
                params['month'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                WageReport.query(params, function (resp) {
                    $scope.loading = false;
                    var wages = resp.wages;
                    if (wages.length > 0) {
                        $scope.stage = wages[0].stage;
                        $scope.reportId = wages[0].report_id;
                    }

                    var comments = [];
                    angular.forEach(wages, function (wage, index) {
                        if (wage.other) wage.opinion = wage.other.remark
                        //if (wage.h_np < 0) {
                        //    comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.h_td});
                        //}
                        switch (wage.p_awd) {
                            case '-1.00':
                                wage.h_awd = '全月病假';
                                break;
                            case '-2.00':
                                wage.h_awd = '全月事假';
                                break;
                            case '-3.00':
                                wage.h_awd = '全月事病假';
                                break;
                        }

                        if (wage.h_np == 0) {
                            switch (wage.h_awd) {
                                case '-1.00':
                                case '-2.00':
                                case '-3.00':
                                    wage.h_tw = wage.h_td = getTw(wage);
                                    break;
                                default:
                                    wage.h_tw = getTw(wage);
                                    wage.h_td = getTd(wage);
                                    //计算实发合计
                                    wage.h_np = eval(wage.h_tw + '-' + wage.h_td).toFixed(2);
                            }
                        }
                    });
                    $scope.wages = allData = wages;
                });
            };
            $scope.reload();
        };

        $scope.tableReload = function () {
            $scope.reload();
        };

        $scope.submitting = false;
        $scope.genWages = function () {
            $scope.canSubmit = true;
            $scope.editAwd = true;
            $scope.canGen = false;
            $scope.submitting = true;
            WageReport.genWages({'opt': $scope.opt}).$promise.then(function () {
                $scope.submitting = false;
                $scope.reload();
                toaster.success('计算成功');
            }, function () {
                $scope.submitting = false;
            });
        };

        $scope.canSave = true;

        $scope.save = function (type) {
            if (type == 1) {
                $scope.canSave = false;
                $scope.canGen = true;
            } else {
                $scope.canSubmit = true;
                $scope.canSave2 = false;
            }

            var wages = $scope.wages;
            angular.forEach(wages, function (wage) {
                switch (wage.h_awd) {
                    case '全月病假':
                        wage.h_awd = -1.00;
                        break;
                    case '全月事假':
                        wage.h_awd = -2.00;
                        break;
                    case '全月事病假':
                        wage.h_awd = -3.00;
                        break;
                }
            });
            var params = {};
            params['wages'] = wages;
            params['opt'] = $scope.opt;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
            });
        };

        $scope.edit = function () {
            dialogs.confirm('修改考勤工资', '<strong class="text-red">修改后请保存并提交,否则会被计算的考勤工资覆盖数据</strong>')
                .result.then(function () {
                $scope.editAwd = false;
                $scope.canSave2 = true;
                $scope.canSubmit = false;
                table.updateSettings({
                    cells: function (row, col, prop) {
                        var cellProperties = {};
                        if ((col == 13 && $scope.opt != 23) || (col == 14 && $scope.opt == 23)) {
                            cellProperties.readOnly = false;
                        } else {
                            cellProperties.readOnly = true;
                        }
                        return cellProperties;
                    }
                });
            });
        };

        $scope.submit = function () {
            if (($scope.opt == 11 || $scope.opt == 23) && !$scope.submitting) {
                dialogs.confirm('提交至'+ ($scope.opt == 23 ? '财务科' : '科室负责人'), '<strong class="text-red">提交后无法再修改工资,是否提交?</strong>')
                    .result.then(function () {
                    $scope.submitting = true;
                    var params = {};
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['opt'] = $scope.opt;
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('提交成功');
                        $scope.submitting = false;
                    }, function () {
                        $scope.submitting = false;
                    });
                });
            }

            if ($scope.opt == 12) {
                dialogs.confirm('发放返聘员工月工资', '发放后仍可以修改,是否确定?')
                    .result.then(function () {
                    var params = {};
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['opt'] = $scope.opt;
                    WageReport.setStage(params).$promise.then(function () {
                        $scope.reload();
                        toaster.success('发放成功');
                    });
                });
            }

        };

        $scope.back = function (type) {
            if (type == 1) {
                opinionHandle(type);
            } else {
                dialogs.confirm('返聘员工月工资退回', '保存审批意见并退回，是否确定?')
                    .result.then(function () {
                    opinionHandle(type);
                });
            }
        };

        function opinionHandle(type) {
            $scope.submitting = true;
            var params = {};
            params['wages'] = $scope.wages;
            params['opt'] = 99;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if (type == 2) {
                params['stage'] = 1;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            params['change_users'] = $scope.change_users;
            WageReport.save(params).$promise.then(function () {
                $scope.reload();
                toaster.success('保存成功');
                $scope.submitting = false;
                $scope.change_users = [];
            });
        }

        $scope.end = function () {
            dialogs.confirm('返聘员工月工资月结', '月结后不可修改,是否确定?')
                .result.then(function () {
                var params = {};
                if ($scope.reportId) {
                    params['report_id'] = $scope.reportId;
                }
                params['opt'] = 13;   //月结
                WageReport.setStage(params).$promise.then(function () {
                    $scope.reload();
                    toaster.success('月结成功');
                });
            });
        };

        $scope.export = function (opt) {
            var y = $scope.dt.getFullYear(), m = $scope.dt.getMonth() + 1;
            var params = {};
            params['start'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
            params['opt'] = opt;
            FileHelper.download(C.URL.RWAGE_DOWNLOAD, params, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = y + '年' + m + '月' + '员工月工资报表' + '.xls';
                SaveAs.download(data, filename, options);
            }, function (error) {
                toaster.error('导出失败!');
            });
        };

        $scope.selectExport = function () {
            Dlg.show({
                template: 'templates/wage/wageExportDlg.html',
                ctrl: 'UserWageExportDlgCtrl',
                data: {
                    url: C.URL.USER_RWAGE_DOWNLOAD
                }
            });
        };


        $scope.changeAfter = function (a) {
            if (a) {
                if (a[0].length > 0) {
                    $scope.canSave = true;
                    $scope.canGen = false;
                    $scope.canSubmit = false;
                    $scope.editAwd = false;
                    $scope.canSave2 = false;
                    for (var i = 0; i < a.length; i++) {
                        var row = a[i][0],
                            column = a[i][1],
                            old_value = a[i][2],
                            new_value = a[i][3];
                        var w = $scope.wages[row];

                        if (column == 'h_awd') {
                            $scope.canSave = false;
                            $scope.canSave2 = true;
                        }

                        if (column != 'remark' && column != 'opinion') {
                            if (isNaN(new_value)) {
                                w[column] = old_value;
                                toaster.warning('请输入数字!');
                                $scope.isFullscreen = false;
                            } else if (new_value.length == 0) {
                                w[column] = old_value;
                                toaster.warning('输入不能为空!');
                                $scope.isFullscreen = false;
                            } else {
                                if (new_value < 0 && column != 'h_rwd') {
                                    w[column] = old_value;
                                    toaster.warning('不能输入负数!');
                                    $scope.isFullscreen = false;
                                } else {
                                    if ($scope.opt == 12) {   //财务科返聘
                                        w.h_phaf = w.h_haf = w.h_chaf;
                                        commentsPlugin.removeCommentAtCell(row, 2);
                                        if (w.h_awd == '全月病假' || w.h_awd == '全月事假' || w.h_awd == '全月事病假') {
                                            //计算扣款合计、应发合计
                                            w.h_tw = w.h_td = getTw(w);
                                        } else {
                                            //计算扣款合计、应发合计
                                            w.h_tw = getTw(w);
                                            w.h_td = getTd(w);
                                            //实发合计
                                            w.h_np = eval(w.h_tw + '-' + w.h_td).toFixed(2);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    });

//angular.module('c.c').controller('UserTempWageCtrl',
//    function ($scope, $filter, dialogs, toaster, NgTableParams, F,
//              Dept, UserStatus, UserTempWage, C) {
//        $scope.dt = new Date();
//        $scope.prevMonth = function (curr) {
//            var prev = curr.getMonth() - 1;
//            $scope.dt = new Date(curr.setMonth(prev));
//        };
//        $scope.nextMonth = function (curr) {
//            var next = curr.getMonth() + 1;
//            $scope.dt = new Date(curr.setMonth(next));
//        };
//
//        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
//            $scope.depts = resp.depts;
//            if ($scope.depts && $scope.depts.length > 0) {
//                $scope.depts.splice(0, 0, {name: '全部科室'});
//                $scope.deptSelectedFn($scope.depts[0]);
//            }
//        });
//
//        $scope.deptSelectedFn = function (d) {
//            $scope.dept = d;
//            $scope.tableParams.$params.page = 1;
//            $scope.tableParams.reload();
//        };
//
//        $scope.$watch('dt', function (newVal, oldVal) {
//            if (newVal != oldVal) {
//                $scope.tableParams.reload();
//            }
//        });
//
//        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
//        $scope.yesNo = F.get('yesNo');
//
//        $scope.cols = [
//            {title: '员工姓名', field: 'user_name', filter: {'users.name': 'text'}, show: true}, //0
//            {title: '工号', field: 'username', filter: {'username': 'text'}, show: true}, //0
//            {title: '条目名称', field: 'name', filter: {'user_temp_wages.name': 'text'}, show: true}, //0
//            {title: '金额', field: 'money', show: true}, //6
//            {title: '计入科室成本', filter: {is_cost: 'select'}, data: yesNoOpts, field: 'is_cost', show: true}, //6
//            {title: '计入个税', filter: {is_tax: 'select'}, data: yesNoOpts, field: 'is_tax', show: true}, //6
//            {title: '计入缺勤扣费', filter: {is_ad: 'select'}, data: yesNoOpts, field: 'is_ad', show: true}, //6
//            {title: '计入工资', filter: {is_wage: 'select'}, data: yesNoOpts, field: 'is_wage', show: true} //6
//        ];
//
//        $scope.optColWidth = 68;
//        $scope.optInFront = true;
//        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {sorting: 'asc'}}, {
//            counts: [30, 50, 100], total: 0,
//            getData: function ($defer, params) {
//                if ($scope.dept) {
//                    var url = params.url();
//                    url['opt'] = C.OPT.USER_TEMP_WAGE.INDEX.ALL_WAGES;
//                    url['month'] = $filter('date')($scope.dt, 'yyyy-MM-01');
//                    url['main_dept_id'] = $scope.dept.id;
//                    F.query(UserTempWage, url, $defer, params, 'wages');
//                } else {
//                    $defer.resolve([]);
//                }
//            }
//        });
//
//        $scope.tableReload = function () {
//            $scope.tableParams.reload();
//        };
//
//        $scope.clearFilters = function () {
//            $scope.tableParams.filter({});
//        };
//
//        $scope.add = function () {
//            dialogs.create('templates/wage/temp_wage_dlg.html', 'TempWageDlgCtrl',
//                {dt: $scope.dt}, {
//                     size: 'md'
//                }).result.then(function (w) {
//                UserTempWage.save(w).$promise.then(function () {
//                    toaster.success('条目添加成功!');
//                    $scope.tableReload();
//                }, function () {
//                    toaster.error('条目添加失败!');
//                });
//            });
//        };
//
//        $scope.edit = function (w) {
//            dialogs.create('templates/wage/temp_wage_dlg.html', 'TempWageDlgCtrl',
//                {wage: w, dt: $scope.dt}, {
//                     size: 'md'
//                }).result.then(function (pa) {
//                UserTempWage.update({id: w.id}, pa).$promise.then(function () {
//                    toaster.success('条目修改成功!');
//                    $scope.tableReload();
//                }, function () {
//                    toaster.error('条目修改失败!');
//                });
//            });
//        };
//
//        $scope.delete = function (w) {
//            dialogs.confirm('删除临时工资条目', '确定要删除<strong>' + w.name + '</strong>条目吗?')
//                .result.then(function () {
//                UserTempWage.delete({id: w.id}).$promise.then(function (resp) {
//                    toaster.success('条目删除成功!');
//                    $scope.tableReload();
//                }, function (error) {
//                    toaster.error('条目删除失败!');
//                });
//            });
//        };
//
//    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('CbCarManageCtrl', CbCarManageCtrl);

    /** @ngInject */
    function CbCarManageCtrl($scope, C, UIHelper, Table, Dlg, CbCar) {
        var vm = $scope;

        init();


        function init() {
            UIHelper.loadTab($scope, 'cb_car');

            var options = {
                service: CbCar,
                optInFront: true,
                hideOpt: true,
                cols: [
                    {field: "name", title: "单位", filter: {name: "text"}},
                    {field: "plate_num", title: "车牌", filter: {plate_num: "text"}}
                ]
            };
            Table.load(vm, options);
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('ErrorParkRecordCtrl', ErrorParkRecordCtrl);

    /** @ngInject */
    function ErrorParkRecordCtrl($scope, C, UIHelper, Table, Dlg, ParkRelation, ArrayHelper, DateHelper) {
        var vm = $scope;
        var types = [
            {id:1,name:'VIP车'},
            {id:2,name:'军警车'},
            {id:3,name:'临时车'},
            {id:4,name:'月租车'}
        ];
        vm.typSelect = typSelect;


        init();


        function init() {
            UIHelper.loadTab($scope, 'cb_car');
            var initDate = new Date();
            initDate.setDate(1);

            var options = {
                service: ParkRelation,
                optInFront: true,
                hideOpt: true,
                filter: {'start.start': DateHelper.date2Str(initDate)},
                cols: [
                    {field: "plate_num", title: "车牌", filter: {plate_num: "text"}},
                    {field: "start", title: "入场时间", filter: {start: "date_range"}},
                    {field: "end", title: "离场时间", filter: {end: "date_range"}},
                    {field: "time", title: "停车时长(小时)", filter: {time: "num_range"}},
                    {field: "type", title: "类型", filter: {type: "select"}, data: Table.getNgTableOpts(types)},
                    {field: "note", title: "备注", filter: {time: "text"}}
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = ArrayHelper.getItem(item.type, types);
                    item.time = (parseInt(item.time)/ 60).toFixed(2);
                });
            });
        }

        function typSelect(loadType,loadTime,select) {
            if (!loadType&&select==1) return;
            vm.tableParams.filter({car_type: loadType,car_time: loadTime});
        }

        vm.clearFilters = function () {
            vm.loadType = null;
            vm.loadTime = null;
            $scope.tableParams.filter({});
        };
    }

})();



angular.module('c.c')
    .controller('RushParkCtrl', function ($scope, $filter, dialogs, toaster, FileHelper,
                                          RushPark, C, SaveAs, F, Table) {
        $scope.$on('practiceRoundChange', function () {
            $scope.tableReload();
        });
        $scope.$on('practiceInfChange', function () {
            $scope.tableReload();
        });

        var yesNo = F.getNgTableOpts(F.get('yesNo'));

        $scope.init = function () {
            var options = {
                service: RushPark,
                params: {},
                optColWidth: 120,
                sorting: {'rush_parks.user_id': 'desc', 'rush_parks.confirm': 'asc'},
                items: 'records',
                cols: [
                    {title: '姓名', filter: {'users.name': 'text'}},
                    {title: '工号', filter: {'users.username': 'text'}},
                    {title: '手机号', filter: {'users.phone': 'text'}},
                    {title: '科室', filter: {'depts.name': 'text'}},
                    {title: '车牌号', filter: {'plate_num': 'text'}},
                    {title: '车牌号2', filter: {'plate_num2': 'text'}},
                    {title: '申请电子通行证', filter: {rush: 'select'}, data: yesNo},
                    {title: '是否确认', filter: {confirm: 'select'}, data: yesNo}
                ]
            };
            Table.loadNgTable($scope, options, function (data) {
            });
        };

        $scope.init();

        //修改车辆信息
        $scope.edit = function (park) {
            dialogs.create('templates/rush_park.html', 'RushParkDlgCtrl', {'park': park, 'edit': true}, {
                size: 'md'
            }).result.then(function (rush) {
                RushPark.update({'id': park.id}, rush).$promise.then(function () {
                    toaster.success('车辆信息修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('此车牌信息已被占用或您已登记过!');
                });
            });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除车牌', '确认要删除' + record.user_name + '的车牌吗?').result.then(function () {
                RushPark.delete({id: record.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        //添加车牌号信息
        $scope.add = function () {
            dialogs.create('templates/rush_park.html', 'RushParkDlgCtrl', {'add': true}, {
                size: 'md'
            }).result.then(function (rush) {
                RushPark.save(rush).$promise.then(function () {
                    toaster.success('车辆信息添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('此车牌信息已被占用或您已登记过!');
                });
            });
        };

        //确认
        $scope.confirm = function (park) {
            RushPark.update({'id': park.id}, {'confirm': 1}).$promise.then(function () {
                toaster.success('车辆信息确认成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('车辆信息确认失败!');
            });
        };

        $scope.export = function () {
            FileHelper.download(C.URL.RUSH_PARK_DOWNLOAD, {}, function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = '车牌号列表.xls';
                SaveAs.download(data, filename, options);
            }, function () {
                toaster.error('导出失败!');
            });

        };


    });


(function () {
    'use strict';

    angular.module('c')
        .controller('StoreMealAdvanceItemCtrl', StoreMealAdvanceItemCtrl);

    /** @ngInject */
    function StoreMealAdvanceItemCtrl($scope, $q, UIHelper, ArrayHelper, Order, MealAdvanceItem, Dlg) {
        var vm = this;
        var types = Order.getTypes(true);
        vm.onGoodSelected = onGoodSelected;
        vm.typeGoods = typeGoods;
        vm.tableReload = tableReload;

        init();


        function init() {
            UIHelper.loadTab($scope, 'advanceItem', tableReload);
            vm.items = [
                {type: Order.TYPE.AM, type_name: types[0].name},
                {type: Order.TYPE.PM, type_name: types[1].name},
                {type: Order.TYPE.NIGHT, type_name: types[2].name},
            ];
            vm.tableReload();
        }

        function tableReload() {
            vm.loading = true;
            $q.all([
                MealAdvanceItem.query({op: 'default'}).$promise,
                Order.query({opt: 2 /*INDEX_OPTIONS*/}).$promise,
            ]).then(function (respArray) {
                angular.forEach(respArray[0].items, function (item) {
                    var m = ArrayHelper.getItem(item.type, vm.items, 'type');
                    if (m) {
                        m.good = item.good;
                        m.total_paid = item.total_paid;
                        m.subsidy = item.subsidy;
                    }
                });
                vm.goods = respArray[1].items;
                vm.goods.splice(0, 0, {id: null, name: '—— 空置 ——'})
            }, function (err) {
                Dlg.error(err.data.msg);
            }).finally(function () {
                vm.loading = false;
            });
        }

        function typeGoods(m) {
            return ArrayHelper.filter(vm.goods, function(g) {
                return !g.type || g.type === m.type;
            })
        }

        function onGoodSelected(m, selected) {
            MealAdvanceItem.save({type: m.type, order_id: selected.id}).$promise.then(
                function (resp) {
                    m.good = resp.item.good;
                    m.total_paid = resp.item.total_paid;
                    m.subsidy = resp.item.subsidy;
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('StoreMealAdvanceItemDlgCtrl', StoreMealAdvanceItemDlgCtrl);

    /** @ngInject */
    function StoreMealAdvanceItemDlgCtrl($uibModalInstance, $q, ArrayHelper, Dlg, MealAdvanceItem, Order, data) {
        var vm = this;
        var types = Order.getTypes();
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.onGoodSelected = onGoodSelected;

        init(data.id);


        function init(id) {
            if (id) {
                vm.loading = true;
                vm.m = {id: id};
                $q.all([
                    MealAdvanceItem.get({id: id}).$promise,
                    Order.query({opt: 2 /*INDEX_OPTIONS*/}).$promise,
                ]).then(function (respArray) {
                    vm.m = respArray[0];
                    vm.goods = respArray[1].items;
                    angular.forEach(respArray[1].items, function (item, key) {
                        item.type = ArrayHelper.getItem(item.type, types);
                    });
                }, function (err) {
                    Dlg.error(err.data.msg);
                    vm.cancel();
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                vm.m = {sorting: 1};
                vm.loading = true;
                $q.all([
                    Order.query({opt: 2 /*INDEX_OPTIONS*/}).$promise,
                ]).then(function (respArray) {
                    vm.goods = respArray[0].items;
                    angular.forEach(respArray[0].items, function (item, key) {
                        item.type = ArrayHelper.getItem(item.type, types);
                    });
                }, function (err) {
                    Dlg.error(err.data.msg);
                    vm.cancel();
                }).finally(function () {
                    vm.loading = false;
                });
            }
        }

        function onGoodSelected(m, selected) {
            if (!m.name) m.name = selected.name;
        }

        function ok(m) {
            return Dlg.addEditOk(vm, MealAdvanceItem, function () {
                return {
                    name: m.name,
                    order_id: m.good.id,
                    sorting: m.sorting,
                };
            });
        }
    }

})();


angular.module('c.c')
    .controller('StoreGoodsCtrl', function ($scope, Order, F, Table, dialogs, toaster, $ocLazyLoad) {
        var vm = $scope;
        vm.init = init;
        vm.add = add;
        vm.edit = edit;
        //vm.remove = remove;
        vm.setStop = setStop;
        vm.setResidue = setResidue;
        vm.qrCode = qrCode;
        vm.stirFryShow = stirFryShow;
        vm.stir_fry = false;

        init();

        function init() {
            var options = {
                service: Order,
                params: {opt: 3/*ORDER.INDEX_STORE_ORDERS*/},
                filter: {stir_fry: 0},
                sorting: {created_at: 'desc'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "type",
                        title: "供应时间",
                        filter: {type: "select"},
                        data: F.getNgTableOpts(F.get('orderTypes'))
                    },
                    {field: "self_paid", title: "售价"},
                    {field: "subsidy", title: "补贴"},
                    {field: "positive", title: "好评数"},
                    {field: 'intro', title: '更多'}
                ]
            };
            Table.load(vm, options, function (resp) {
                vm.store = resp.store;
                angular.forEach(resp.items, function (item) {
                    item.type = F.getItem(item.type, F.get('orderTypes'));
                    item.limit_mode = F.getItem(item.limit_mode, F.get('limitModes'));
                    if (item.limit_mode.id == '3') {
                        item.time = '';
                    } else {
                        item.time = item.start.substr(0, 5) + '~' + item.end.substr(0, 5);
                    }
                    item.slider = {
                        value: item.residue_supply,//residue_supply
                        options: {
                            showSelectionBar: true,
                            ceil: item.daily_supply,
                            getSelectionBarColor: function (value) {
                                var max = item.daily_supply;
                                if (value / max <= 0.3)
                                    return 'red';
                                if (value / max <= 0.6)
                                    return 'orange';
                                if (value / max <= 0.9)
                                    return 'yellow';
                                return '#2AE02A';
                            }
                        }
                    };
                })
            });

            vm.clearFilters = function () {
                vm.tableParams.filter({stir_fry: vm.stir_fry ? 1 : 0});
            };
        }

        function add() {
            dialogs.create('StoreOrderDlg.html', 'StoreOrderDlgCtrl', {
                    name: vm.store
                }, {size: 'md'})
                .result.then(function (pa) {
                Order.save(pa).$promise.then(function (resp) {
                    if (resp.result > 0) {
                        toaster.warning('非商店管理员无法操作');
                    } else {
                        toaster.success('保存成功');
                        vm.tableReload();
                    }
                });
            });
        }

        function edit(m) {
            dialogs.create('StoreOrderDlg.html', 'StoreOrderDlgCtrl', {
                id: m.id, store: vm.store
            }, {size: 'md'}).result.then(function (pa) {
                pa.opt = 1;
                Order.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                })
            });
        }

        //function remove(m) {
        //    dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗？')
        //        .result.then(function () {
        //            Order.delete({id: m.id}).$promise.then(function (resp) {
        //                switch (resp.result) {
        //                    case 0:
        //                        toaster.success('删除成功');
        //                        vm.tableReload();
        //                        break;
        //                    case 1:
        //                        toaster.warning('无法删除,因有订单或消费记录关联到该商品');
        //                        break;
        //                }
        //            });
        //        });
        //}

        function setStop(m) {
            Order.update({id: m.id}, {opt: 2 /*ORDER.EDIT_STOP*/, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        function qrCode(m) {
            $ocLazyLoad.load(['qrCode']).then(function () {
                dialogs.create('templates/meal/order_qrcode.html', 'OrderQrCodeCtrl', {order: m}, {
                    size: 'md'
                });
            });
        }

        function setResidue(item, value) {
            var pa = {residue_supply: value};
            Order.update({id: item.id, opt: 5 /*ORDER.EDIT_RESIDUE_SUPPLY*/}, pa)
                .$promise.then(function () {
                item.residue_supply = value;
                toaster.success('修改成功');
            }, function () {
                toaster.error('修改失败');
            });
        }

        function stirFryShow() {
            vm.tableParams.filter({stir_fry: vm.stir_fry ? 1 : 0});
        }
    });

angular.module('c.c').controller('StoreOrderDlgCtrl',
    function ($scope, $uibModalInstance, uibDateParser, toaster, F, Order, data, Store, dialogs, $filter) {
        var vm = $scope;
        vm.types = F.get('orderTypes');
        vm.ok = ok;
        vm.addOrderImg = addOrderImg;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            Store.query({opt: 2 /* STORE.INDEX_OPTIONS */}, function (resp) {
                vm.stores = resp.items;
            });
            if (id) {
                Order.get({id: id}, function (resp) {
                    var m = resp;
                    if (m.result == 0) {
                        var order = m.order;
                        order.special = order.special == '1';
                        order.has_price = order.has_price == '1';
                        order.is_delivery = order.is_delivery == '1';
                        order.is_working_meal_allowed = order.is_working_meal_allowed == '1';
                        order.type = F.getItem(order.type, vm.types);
                        vm.m = order;
                    } else {
                        toaster.warning(m.msg);
                    }
                });
            } else {
                vm.m = {has_price: true, special: true, type: vm.types[3]};
            }
        }

        function ok(m) {
            if (angular.isUndefined(m.type)) {
                toaster.warning('请填入商品类型');
            } else if (m.type.id == '1' && m.is_working_meal_allowed) {
                toaster.warning('早餐不能作为手术餐');
            } else if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    img: m.img,
                    type: m.type.id,
                    has_price: m.has_price ? 1 : 0,
                    is_delivery: m.is_delivery ? 1 : 0,
                    special: m.special ? 1 : 0,
                    intro: m.intro
                };
                if (m.has_price) {
                    pa.self_paid = m.self_paid;
                }
                if (pa.type != '4') {
                    pa.daily_supply = m.daily_supply;
                    pa.is_working_meal_allowed = m.is_working_meal_allowed ? 1 : 0;
                } else {
                    pa.subsidy = 0;
                    pa.is_working_meal_allowed = false;
                }
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }

        function addOrderImg(order) {
            dialogs.create('templates/order/order_img_dlg.html',
                'OrderImgDlgCtrl', {store: data.store}, {

                    size: 'md'
                }
            ).result.then(function (url) {
                order.img = url;
            });
        }
    });

angular.module('c.c')
    .controller('StoreTipsCtrl', function ($scope, StoreTips, Table, Dlg) {
        var vm = $scope;
        vm.init = init;
        vm.addEdit = addEdit;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: StoreTips,
                params: {op: 'option'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "morning", title: "早", filter: {morning: "text"}},
                    {field: "afternoon", title: "中", filter: {afternoon: "text"}},
                    {field: "evening", title: "晚", filter: {evening: "text"}},
                    {field: "date", title: "日期", filter: {date: "date_range"}}
                ]
            };
            Table.load(vm, options);
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/store/goods/tipsDlg.html', 'StoreTipsDlgCtrl', m, null, 'lg');
        }

        function remove(m) {
            Dlg.confirm('确定要删除<strong>' + m.date + '</strong>的提示吗？', function () {
                StoreTips.delete({id: m.id}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                });
            });
        }

    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('StoreTipsDlgCtrl', StoreTipsDlgCtrl);

    /** @ngInject */
    function StoreTipsDlgCtrl($uibModalInstance, $q, Dlg, StoreTips, DateHelper, data) {
        var vm = this;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            vm.loading = true;
            if (id) {
                StoreTips.get({id: id}).$promise.then(function (resp) {
                    vm.m = resp.item;
                    vm.loading = false;
                });
            } else {
                vm.loading = false;
            }

        }

        function ok(m) {
            return Dlg.addEditOk(vm, StoreTips, function () {
                var pa = {
                    morning: m.morning,
                    evening: m.evening,
                    afternoon: m.afternoon,
                    date: DateHelper.date2Str(m.date)
                };
                return pa;
            });
        }
    }

})();


angular.module('c.c')
    .controller('StorePhHandleCtrl', function ($scope, $rootScope, $q, Table, UIHelper,
                                               PurchaseHistory, F, $ocLazyLoad, dialogs, toaster, Store, Dlg, DateHelper) {
        var vm = $scope;
        vm.init = init;
        vm.setState = setState;
        vm.pass = pass;
        vm.back = back;

        function init(data) {
            if (data == 1) {
                UIHelper.loadTab(vm, 'approval');
            } else {
                UIHelper.loadTab(vm, 'check');
            }

            //vm.$on('storePHCheck', function () {
            //    vm.tableReload();
            //});
            var now = new Date();
            var year = now.getFullYear();
            var month = now.getMonth();
            if (month == 0) {
                month = 12;
                year = year - 1;
            }
            var firstDay = new Date(year, month - 1, 1);
            var lastDay = new Date(year, month, 1);
            vm.type = data;
            var options = {
                service: PurchaseHistory,
                params: {opt: 3, /*PURCHASE_HISTORY.INDEX_STORE_HANDLE*/type: data},
                sorting: {time: 'desc'},
                optColWidth: Table._2_BTN,
                hideOpt: data == '1',
                showSn: true,
                filter: {
                    'start.time': firstDay,
                    'end.time': lastDay,
                    'checkType': 0
                },
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time'}
                ]
            };
            Table.load(vm, options, function (resp) {
                vm.store = resp.store;
                vm.periodTotal = resp.periodTotal;
                vm.ph = resp.ph;
            });
        }

        function setState() {
            if (angular.isUndefined(vm.tableParams.filter()['start.time']) || angular.isUndefined(vm.tableParams.filter()['end.time'])) {
                Dlg.w('请设置消费时间段!')
            } else {
                dialogs.confirm(vm.type == '1' ? '转商家核对' : '转医院销账',
                    vm.type == '1' ? '确定要将筛选的待销账记录转商家核对吗?' : '确定要将筛选的核对记录转医院销账吗')
                    .result.then(function () {
                    Store.setState({
                        storeId: vm.store.id,
                        start: DateHelper.datetime2Str(vm.tableParams.filter()['start.time']),
                        end: DateHelper.datetime2Str(vm.tableParams.filter()['end.time']),
                        opt: vm.type == '1' ? 1 : 2/*1.STORE.STORE_CHECK 2.STORE.STORE_APPLY*/
                    }).$promise.then(function (resp) {
                        toaster.success(resp.msg);
                        vm.tabs['check'] = true;
                        //$rootScope.$broadcast('storePHCheck');
                        vm.tableReload();
                    });
                });
            }
        }

        function pass(m) {
            var defer = $q.defer();
            PurchaseHistory.update({id: m.id}, {opt: 3/*PURCHASEHISTORY.EDIT_BACK*/}).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success(resp.msg);
                        defer.resolve();
                        break;
                    default:
                        toaster.warning(resp.msg);
                        defer.reject();
                }
                vm.tableReload();
            });
            return defer.promise;
        }

        function back(m) {
            var defer = $q.defer();
            PurchaseHistory.update({id: m.id}, {opt: 2/*PURCHASEHISTORY.EDIT_BACK*/}).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success(resp.msg);
                        vm.tabs['approval'] = true;
                        //$rootScope.$broadcast('storePHCheck');
                        defer.resolve();
                        break;
                    default:
                        toaster.warning(resp.msg);
                        defer.reject();
                }
                vm.tableReload();
            });
            return defer.promise;
        }


    });





angular.module('c.c')
    .controller('StorePhSearchCtrl', function ($scope, PurchaseHistory, F, Table,
                                               $ocLazyLoad, dialogs, toaster, Store, Dlg) {
        var vm = $scope;
        vm.refund = refund;
        vm.pHStates = F.get('pHStates');
        vm.changeState = changeState;
        vm.changeType = changeType;
        vm.init = init;
        vm.download = download;

        function init(type) {
            var date = new Date();
            vm.states = Table.getNgTableOpts(vm.pHStates);
            vm.state = vm.states[1];
            var checkTypes2 = [
                {id: '1', name: '手术餐'},
                {id: '2', name: '现场消费'},
                {id: '3', name: '外卖'},
                {id: '4', name: '小炒'}
            ];
            vm.checkTypes2 = Table.getNgTableOpts(checkTypes2);
            vm.type2 = '';
            var options = {
                service: PurchaseHistory,
                params: {opt: 2/*PURCHASE_HISTORY.INDEX_STORE_SEARCH*/},
                sorting: {time: 'desc'},
                optColWidth: Table._1_BTN,
                hideOpt: type == 1,
                showSn: true,
                filter: {
                    'start.time': new Date(date.setHours(0, 0)),
                    'end.time': new Date(new Date().setTime(date.getTime() + 24 * 60 * 60 * 1000)),
                    'state': 1,
                    'checkType': 0
                },
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: "phone", title: '手机号', filter: {phone: 'text'}},
                    {field: "trade_no", title: '订单号', filter: {trade_no: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time'},
                    {
                        field: "state",
                        title: "状态"
                    },
                    {field: "handler", title: '操作人', filter: {handler: 'text'}}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (i) {
                    i.state = F.getItem(i.state, vm.pHStates);
                });
                vm.periodTotal = resp.periodTotal;
                vm.store = resp.store;
            });

            //vm.clearFilters = function () {
            //    vm.tableParams.filter({
            //        'start.time': new Date(date.setHours(0, 0)),
            //        'end.time': new Date(new Date().setTime(date.getTime() + 24 * 60 * 60 * 1000))
            //    });
            //};
        }

        function changeState(m) {
            vm.tableParams.filter()['state'] = m.id;
        }

        function changeType(m) {
            console.log('m.id', m);
            switch (m.id) {
                case '1':
                    vm.tableParams.filter()['is_spot'] = 0;
                    vm.tableParams.filter()['is_working_meal'] = 1;
                    vm.tableParams.filter()['stir_fry'] = 0;
                    break;
                case '2':
                    vm.tableParams.filter()['is_spot'] = 1;
                    vm.tableParams.filter()['is_working_meal'] = 0;
                    vm.tableParams.filter()['stir_fry'] = 0;
                    break;
                case '3':
                    vm.tableParams.filter()['is_spot'] = 0;
                    vm.tableParams.filter()['is_working_meal'] = 0;
                    vm.tableParams.filter()['stir_fry'] = 0;
                    break;
                case '4':
                    vm.tableParams.filter()['is_spot'] = 0;
                    vm.tableParams.filter()['is_working_meal'] = 0;
                    vm.tableParams.filter()['stir_fry'] = 1;
                    break;
                default:
                    vm.tableParams.filter()['is_spot'] = '';
                    vm.tableParams.filter()['is_working_meal'] = '';
                    vm.tableParams.filter()['stir_fry'] = '';
                    break;

            }
        }


        function refund(m) {
            if (m.stir_fry == 1) {
                toaster.warning('请在小炒已确认订单中处理退款');
                return;
            }
            dialogs.confirm('商家退款', '确定要退款给<strong>' + m.user.name + '</strong>吗?')
                .result.then(function () {
                Store.refund({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }

        function download() {
            Dlg.exportDR('/api/v1/purchase_history/list_export', "消费明细");
        }
    });





(function () {
    'use strict';

    angular.module('c')
        .controller('StoreMealAdvanceRecordCtrl', StoreMealAdvanceRecordCtrl);

    /** @ngInject */
    function StoreMealAdvanceRecordCtrl($scope, Table, UIHelper, ArrayHelper, Order, MealAdvanceRecord, Dlg, $q, FileHelper) {
        var vm = $scope;
        var types = Order.getTypes();
        var states = Order.getStates();
        var typeOpts = Table.getNgTableOpts(types);
        var stateOpts = Table.getNgTableOpts(states);
        vm.addEdit = addEdit;
        vm.remove = remove;
        vm.download = download;

        init();


        function init() {
            UIHelper.loadTab(vm, 'advanceRecord');
            var options = {
                service: MealAdvanceRecord,
                params: {op: 'default'},
                optColWidth: Table._2_BTN,
                optInFront: true,
                cols: [
                    {field: "sn", title: "序号", width: Table._1_CHAR},
                    {field: "user_name", title: "消费用户", filter: {user_name: "text"}, width: Table._2_CHAR},
                    {field: "date", title: "预扣日期", filter: {date: "date_range"}},
                    {field: "type", title: "预扣类型", filter: {type: "select"}, data: typeOpts},
                    {field: "fee", title: "预扣金额"},
                    {field: "subsidy", title: "实际补贴"},
                    {field: "paid_at", title: "实扣时间", filter: {paid_at: "date_range"}},
                    {field: "good_name", title: "餐补商品", filter: {good_name: "text"}, width: Table._2_CHAR},
                    {field: "state", title: "支付状态", filter: {state: "select"}, data: stateOpts},
                    {field: "note", title: "备注"},
                    {field: "handler_name", title: "操作人", filter: {handler_name: "text"}, width: Table._2_CHAR},
                    {field: "created_at", title: "创建日期", filter: {created_at: "date_range"}},
                ]
            };
            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                    item.type = ArrayHelper.getItem(item.type, types).name;
                    item.state = ArrayHelper.getItem(item.state, states).name;
                })
            });

            $scope.$on('meal.advanceRecord.saved', function (event) {
                vm.tableReload();
            });
        }

        function addEdit(m) {
            Dlg.show({
                template: 'pages/store/spot/advanceRecordDlg.html',
                ctrl: 'StoreMealAdvanceRecordDlgCtrl',
                data: {user: m ? {id: m.user_id, name: m.user_name, username: m.user_username} : undefined},
                pos: 'right', backdrop: false
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.user_name + m.good_name + '</strong>的预扣款记录吗？', function (resp) {
                MealAdvanceRecord.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });

            }, '删除预扣款项目');
        }

        function download() {
            var defer = $q.defer();
            FileHelper.dnExcel('/api/v1/meal/meal_advance_records/download', {}, "提前消费统计.xls")
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('StoreMealAdvanceRecordDlgCtrl', StoreMealAdvanceRecordDlgCtrl);

    /** @ngInject */
    function StoreMealAdvanceRecordDlgCtrl($uibModalInstance, $rootScope, $state, $q, Dlg, ArrayHelper, FormHelper, DateHelper,
                                           User, Api, Order, MealAdvanceItem, MealAdvanceRecord, data) {
        var vm = this;
        var TYPE = Order.TYPE;
        vm.filter = {};
        vm.onUserSelected = onUserSelected;
        vm.usernameAcdOption = {trigLen: 3, data: Api.usernameLoadFn, onSelect: chooseUser};
        vm.chooseUser = chooseUser;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.user);


        function init(user) {
            if (user) {
                onUserSelected(user);
                vm.user = user;
            } else initRecords();
            getMealAdvanceItem();
        }

        function onUserSelected(user) {
            MealAdvanceRecord.query({op: 'user', user_id: user.id}).$promise.then(function (resp) {
                initRecords();
                angular.forEach(resp.items, function (item) {
                    var r = ArrayHelper.getItem(item.date, vm.records, 'dateStr');
                    if (r) {
                        if (item.type === TYPE.AM && r.hasOwnProperty('am')) r.am.checked = r.am.locked = true;
                        else if (item.type === TYPE.PM && r.hasOwnProperty('pm')) r.pm.checked = r.pm.locked = true;
                        else if (item.type === TYPE.NIGHT && r.hasOwnProperty('night')) r.night.checked = r.night.locked = true;
                    }
                });
            });
        }

        function getMealAdvanceItem() {
            var mealAdvanceItems;
            MealAdvanceItem.query({op: 'default'}).$promise.then(function (resp) {
                mealAdvanceItems = resp.items;
            }).finally(function () {
                if (!mealAdvanceItems || mealAdvanceItems.length < 3) { // 三餐
                    Dlg.confirm("预扣款项目未设置完整，请先转到【商品管理】中设置！").then(function () {
                        $state.go('app.store_goods', {tab: 'advanceItem'});
                    }, function () {
                        vm.close();
                    });
                } else {
                    vm.mealAdvanceItems = {
                        am: ArrayHelper.getItem(TYPE.AM, mealAdvanceItems, 'type'),
                        pm: ArrayHelper.getItem(TYPE.PM, mealAdvanceItems, 'type'),
                        night: ArrayHelper.getItem(TYPE.NIGHT, mealAdvanceItems, 'type'),
                    };
                }
            });
        }

        function initRecords() {
            vm.records = [];
            // 当天的时段是否显示取决于当前时间
            var today = new Date();
            var hour = today.getHours();
            var recordToday = {date: today, dateStr: DateHelper.date2Str(today)};
            if (hour < 7) recordToday.am = {}; // checked: false, locked: false
            if (hour < 10) recordToday.pm = {}; // checked: false, locked: false
            if (hour < 17) {
                recordToday.night = {};
                vm.records.push(recordToday);
            }
            // 除了当天，还会显示剩余其他
            var i = 0, curr = new Date();
            do {
                var tmp = curr.getDate() + 1;
                var newDate = new Date(curr.setDate(tmp));
                vm.records.push({
                    date: newDate, dateStr: DateHelper.date2Str(newDate),
                    am: {}, pm: {}, night: {}
                });
                i++;
            } while (i < 14);
        }

        function chooseUser(username) {
            if (username) {
                User.get({id: username, op: 'by_username'}).$promise.then(function (resp) {
                    onUserSelected(resp);
                    vm.user = resp;
                    delete vm.filter.username;
                }, function (err) {
                    if (err.data.msg) Dlg.e(err.data.msg);
                });
            } else Dlg.e('请先输入工号！');
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.user) {
                Dlg.w("请先选择提前扣款用户！");
                return;
            }
            var records = [];
            angular.forEach(vm.records, function (r) {
                if (r.am && r.am.checked && !r.am.locked) {
                    records.push({
                        user_id: vm.user.id,
                        order_id: vm.mealAdvanceItems.am.good.id,
                        date: DateHelper.date2Str(r.date),
                        fee: vm.mealAdvanceItems.am.total_paid,
                        type: TYPE.AM
                    });
                }
                if (r.pm && r.pm.checked && !r.pm.locked) {
                    records.push({
                        user_id: vm.user.id,
                        order_id: vm.mealAdvanceItems.pm.good.id,
                        date: DateHelper.date2Str(r.date),
                        fee: vm.mealAdvanceItems.pm.total_paid,
                        type: TYPE.PM
                    });
                }
                if (r.night && r.night.checked && !r.night.locked) {
                    records.push({
                        user_id: vm.user.id,
                        order_id: vm.mealAdvanceItems.night.good.id,
                        date: DateHelper.date2Str(r.date),
                        fee: vm.mealAdvanceItems.night.total_paid,
                        type: TYPE.NIGHT
                    });
                }
            });

            if (records.length === 0) {
                Dlg.notify("请勾选至少一条新的提前扣款项目");
                return;
            }

            MealAdvanceRecord.save(records).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.user = null;
                $rootScope.$broadcast('meal.advanceRecord.saved');
            }, function (err) {
                if (err.data.msg) Dlg.error(err.data.msg);
            }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('StoreSpotCtrl', StoreSpotCtrl);

    function StoreSpotCtrl($scope, Regex, PurchaseHistory, Table, C, F, $ocLazyLoad, dialogs, toaster, Store) {
        var vm = $scope;
        vm.init = init;
        vm.buying = buying;
        vm.PASSWORD = Regex.PASSWORD;
        vm.doTTS = doTTS;


        init();


        function init() {
            vm.$on(C.P + 'shop.send', function (event, data) {
                var item = data.data.task;
                if (vm.store && item['store_id'] == vm.store.id) {
                    var text = '现场消费：' + item['total_paid'] + '元';
                    if (item['shopMoney'] > 0) {
                        text += '，其中消费券付款：' + item['shopMoney'] + '元'
                    }
                    doTTS(text)
                }
            });

            vm.$on(C.P + 'wechat.orderPay', function (event, data) {
                var newPurchase = data.data.wechat;
                if (vm.store && newPurchase['store_id'] == vm.store.id) {
                    if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                        vm.tableParams.data.pop();
                    }
                    vm.tableParams.data.unshift(newPurchase);
                    if (!data.data.forShop) {
                        doTTS('现场消费：' + newPurchase['total_paid'] + '元')
                    }
                }
            });

            vm.$on('newPurchase', function (event, data) {
                if (!angular.isUndefined(data.newPurchase)) {
                    var newPurchase = data.newPurchase;
                    if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                        vm.tableParams.data.pop();
                    }
                    vm.tableParams.data.unshift(newPurchase);
                } else {
                    var paidUsers = data.paidUsers;
                    angular.forEach(paidUsers, function (p) {
                        if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                            vm.tableParams.data.pop();
                        }
                        vm.tableParams.data.unshift(p.purchase);
                    });
                }
            });
            var options = {
                service: PurchaseHistory,
                params: {opt: 2/*PURCHASE_HISTORY.INDEX_STORE_SEARCH*/, is_spot: true},
                sorting: {time: 'desc'},
                optColWidth: Table._3_BTN,
                hideOpt: true,
                cols: [
                    {field: "order", title: '商品名称', width: '20%', filter: {order: 'text'}},
                    {field: "user", title: '消费者', filter: {user: 'text'}},
                    {field: 'self_paid', title: '用户消费', filter: {self_paid: 'num_range'}},
                    {field: 'total_paid', title: '商品价格', filter: {total_paid: 'num_range'}},
                    {field: 'time', title: '消费时间', sortable: 'time', filter: {time: 'date_range'}},
                    {field: 'handler', title: '操作人', filter: {handler: 'text'}}
                ]
            };
            Table.load(vm, options, function (resp) {
                vm.store = resp.store;
            });
        }

        function buying() {
            $ocLazyLoad.load(['qrCode']).then(function () {
                dialogs.create('pages/store/spot/spotBuyingDlg.html', 'BuyingCtrl', {store: vm.store},
                    {size: 'md'}).result.then(function (resp) {
                    switch (resp.paidMethod) {
                        //用户密码支付
                        case 2:
                            if (resp.is_success) {
                                var newPurchase = resp.newPurchase;
                                if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                                    vm.tableParams.data.pop();
                                }
                                vm.tableParams.data.unshift(newPurchase);
                                toaster.success('交易成功');
                            }
                            break;
                        //直接工号支付
                        case 3:

                            break;
                    }

                });
            });
        }

        function doTTS(text) {
            Store.query({opt: 9/*STORE.INDEX_BAIDU_TTS_URL*/, text: text}, function (resp) {
                var ttsDiv = document.getElementById('bdtts_div_id');
                var au1 = '<audio id="tts_autio_id" autoplay="autoplay">';
                //var sss = '<source id="tts_source_id" src="https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ie=UTF-8&ctp=1&pdt=301&vol=15&rate=32&per=0&spd=5&tex=' + text + '" type="audio/mpeg">';
                var sss = '<source id="tts_source_id" src="' + resp.url + '" type="audio/mpeg">';
                var eee = '<embed id="tts_embed_id" height="0" width="0" src="">';
                var au2 = '</audio>';
                ttsDiv.innerHTML = au1 + sss + eee + au2;

                var ttsAudio = document.getElementById('tts_autio_id');

                ttsAudio.play();
            });

        }
    }
})();




(function () {
    'use strict';


    angular.module('c.c')
        .controller('BuyingCtrl', BuyingCtrl);

    function BuyingCtrl($scope, $uibModalInstance, toaster, Store, User, $q, $filter, data, $rootScope,
                        C, dialogs) {
        var vm = $scope;
        vm.paid = paid;
        vm.directPaid = directPaid;
        vm.cancel = $uibModalInstance.dismiss;
        var time = new Date();
        vm.time = setTimeFilter(time);
        vm.store = data.store;
        vm.reset = reset;

        vm.$on(C.P + 'wechat.orderPay', function (event, data) {
            var newPurchase = data.data.wechat;
            if (vm.store && newPurchase['store_id'] == vm.store.id) {
                toaster.success('交易成功');
                vm.reset();
            }
        });

        User.query({opt: 17/*USER:INDEX_USER_NOT_ASSIST*/}, function (resp) {
            vm.existMembers = resp.users;
        });

        function setTimeFilter(time) {
            time.setYear(1900);
            time.setMonth(0);
            time.setDate(1);
            return time;
        }

        function reset() {
            vm.user = {};
            vm.customers = [];
            vm.isGetInfo = false;
        }

        //is_qr是是否未二维码支付
        function paid(user, order) {
            var defer = $q.defer();
            if (vm.Form.$valid) {
                var pa = {
                    /* 请只把有必要的数据作为参数传递给服务器，避免网络数据过多，
                     例如此处应该只传递order_id */
                    opt: 4, user: user, order_id: order.id, paid: order.paid
                };
                Store.paid(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('交易成功');
                            var pa = {
                                'newPurchase': resp.newPurchase
                            };
                            $rootScope.$broadcast('newPurchase', pa);
                            vm.reset();
                            defer.resolve();
                            break;
                        default:
                            toaster.warning(resp.msg);  //看来以后这些提示语应该尽量从后台传过来（可以有效减少前端大小）
                            defer.reject();
                    }
                });
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
                defer.reject();
            }
            return defer.promise;
        }

        function directPaid(customers, order, isGetInfo) {
            var defer = $q.defer();
            if (!isGetInfo) {
                toaster.warning('请确认信息后支付');
                defer.reject();
            } else {
                var pa = {
                    customers: customers, order_id: order.id, order_paid: order.paid
                };
                Store.directPaid(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            var canNotPaidUsers = resp.canNotPaidUsers;
                            var paidUsers = resp.paidUsers;
                            var msg = '';
                            if (paidUsers.length == 0 && canNotPaidUsers.length == 0) {
                                toaster.warning('消费者为空');
                            } else {
                                if (paidUsers.length == 0) {
                                    msg = '所有人余额不足，消费失败';
                                } else if (canNotPaidUsers.length == 0) {
                                    msg = '消费人数共<strong>' + (canNotPaidUsers.length + paidUsers.length)
                                        + '</strong>人,全体人员消费成功。';
                                } else {
                                    msg = '消费人数共<strong>' + (canNotPaidUsers.length + paidUsers.length)
                                        + '</strong>人' +
                                        '<br/>消费成功<strong>' + paidUsers.length + '</strong>人:<strong>';
                                    angular.forEach(paidUsers, function (user) {
                                        msg += user.name + ' ';
                                    });
                                    msg += '</strong>';
                                    msg += '<br/>余额不足的成员有：<strong>';
                                    angular.forEach(canNotPaidUsers, function (user) {
                                        msg += user.name + ' ';
                                    });
                                    msg += '</strong>';
                                }
                                dialogs.notify('消费结果', msg);
                            }
                            var pa = {};
                            pa['paidUsers'] = resp.paidUsers;
                            $rootScope.$broadcast('newPurchase', pa);
                            vm.reset();
                            defer.resolve();
                            break;
                        default:
                            toaster.warning(resp.msg);
                            defer.reject();
                    }
                });
            }
            return defer.promise;
        }

        vm.$watchCollection('customers', function (newValue, oldValue) {
            if (!angular.isUndefined(vm.paidMethod) && vm.paidMethod == 3 &&
                newValue.length != 0) {
                var params = {};
                params['customers'] = newValue;
                Store.getCustomersInfo(params).$promise.then(function (resp) {
                    var customerInfo = resp.items;
                    var i;
                    angular.forEach(vm.customers, function (c) {
                        i = -1;
                        while (++i < customerInfo.length) {
                            if (c.id == customerInfo[i].id) {
                                c.getInfo = customerInfo[i];
                            }
                        }
                    });
                    vm.isGetInfo = true;
                });
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('StoreSteamedConfirmCtrl', StoreSteamedConfirmCtrl);

    /** @ngInject */
    function StoreSteamedConfirmCtrl($scope, UIHelper, Dlg, Table, steamedBread, DateHelper) {
        var vm = $scope;
        // vm.add = add;
        vm.export = exportIn;
        vm.today = DateHelper.date2Str(new Date());


        init();


        function init() {
            UIHelper.loadTab(vm, 'confirm');
            $scope.$on('SteamedBreadConfirm', function (event, data) {
                vm.tableReload();
            });
            var options = {
                service: steamedBread,
                params: {op: 'confirm'},
                hideOpt: true,
                cols: [
                    {field: "patient_name", title: "姓名", filter: {patient_name: "text"}, width: Table._5_CHAR},
                    {field: "dept", title: "科室", width: Table._4_CHAR},
                    {field: "bed_num", title: "床号", width: Table._4_CHAR},
                    {field: "date", title: "时间", width: Table._4_CHAR}
                ]
            };

            Table.load(vm, options);
        }

        // function add() {
        //     Dlg.show({
        //         template: 'pages/user/meal/addSteamedBreadDlg.html',
        //         ctrl: 'addSteamedBreadDlgCtrl',
        //         size: 'md'
        //     }).then(function () {
        //         vm.tableReload();
        //     });
        // }

        function exportIn() {
            Dlg.exportDR('/api/v1/steamed_bread_records' + '/in_export', '馒头餐导出', vm.today, vm.today);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('StoreSteamedPendingCtrl', StoreSteamedPendingCtrl);

    /** @ngInject */
    function StoreSteamedPendingCtrl($scope, UIHelper, Dlg, Table, steamedBread, Api, DateHelper) {
        var vm = $scope;
        vm.today = DateHelper.date2Str(new Date());
        var checker = Table.loadMultiSelectedFn(vm);
        vm.pass = pass;

        init();


        function init() {
            $scope.$on('SteamedBreadPending', function (event, data) {
                vm.tableReload();
            });
            var options = {
                service: steamedBread,
                params: {op: 'pending'},
                hideOpt: true,
                cols: [
                    {field: "patient_name", title: "姓名", filter: {patient_name: "text"}, width: Table._5_CHAR},
                    {field: "dept", title: "科室", width: Table._4_CHAR},
                    {field: "bed_num", title: "床号", width: Table._4_CHAR},
                    {field: "date", title: "时间", width: Table._4_CHAR}
                ]
            };

            Table.load(vm, options);
        }


        function pass(items) {
            if (!checker.hasChecked()) {
                Api.w('请选择处理对象');
                return;
            }
            var itemIds = checker.getCheckedIds(items);

            steamedBread.update({id: '-'}, {ids: itemIds}).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });

        }
    }

})();

angular.module('c.c')
    .controller('StoreTOApprovalCtrl', function ($scope, $rootScope, $q, Table, dialogs, toaster, TakeOut, C, F) {
        var vm = $scope;
        vm.batch = batch;
        vm.pass = pass;
        vm.back = back;
        var checker = Table.loadMultiSelectedFn(vm);


        init();

        function init() {
            vm.$on(C.P + 'takeOut.send', function (event, data) {
                var record = data.data.task;
                var index = F.indexOfKey(record['id'], vm.tableParams.data);
                if (index >= 0) {
                    vm.tableParams.data.splice(index, 1);
                }
                if (vm.store && record['order']['store_id'] == vm.store.id) {
                    if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                        vm.tableParams.data.pop();
                    }
                    vm.tableParams.data.unshift(record);
                }
            });

            var options = {
                service: TakeOut,
                params: {opt: 2/*TAKEOUT.INDEX_STORE_HANDLE*/, forApproval: true},
                sorting: {meal_time: 'asc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {
                        field: "meal_time",
                        title: "送餐时间",
                        sortable: "meal_time",
                        filter: {meal_time: "date_range"}
                    },
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "applicant", title: "填单人", filter: {applicant: "text"}},
                    {field: "created_at", title: "填单时间", sortable: "created_at", filter: {created_at: "date_range"}}
                ]
            };
            Table.load(vm, options, function (resp) {
                var items = resp.items;
                vm.store = resp.store;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed(parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy), 1);
                });
                vm.items = items;
            });
        }


        function batch(items, opt) {
            var defer = $q.defer();
            for (var i = 0; i < items.length; i++) {
                if (items[i].type == '3') {
                    toaster.warning('存在已删除订单，请刷新');
                    defer.reject();
                    return;
                }
            }

            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                defer.reject();
                return;
            }

            TakeOut.storeBatch({
                itemIds: checker.getCheckedIds(items), opt: opt
            }, function () {
                toaster.success('处理成功');
                vm.tableReload();
                $rootScope.$broadcast('storeTOApproved');
                defer.resolve();
            });
            return defer.promise;
        }

        function pass(m) {
            storeHandle(m, 1);
        }

        function back(m) {
            storeHandle(m, 2);
        }

        function storeHandle(m, opt) {
            var defer = $q.defer();
            TakeOut.update({id: m.id}, {opt: opt/*1:TAKEOUT.EDIT_STORE_PASS 2:TAKEOUT.EDIT_STORE_BACK*/})
                .$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('处理成功');
                        $rootScope.$broadcast('storeTOApproved');
                        defer.resolve();
                        break;
                    default:
                        toaster.warning(resp.msg);
                        defer.reject();
                        break;
                }
                vm.tableReload();
            }, function () {
                toaster.error('订单已删除，请刷新');
            });
            return defer.promise;
        }
    });


angular.module('c.c')
    .controller('StoreTOApprovedCtrl', function ($scope, $filter, Table, dialogs, toaster, TakeOut, C, F) {
        var vm = $scope;
        vm.prevDay = prevDay;
        vm.nextDay = nextDay;
        vm.dt = new Date();

        init();

        function init() {
            vm.$on('storeTOApproved', function () {
                vm.tableReload();
            });

            vm.$on('storeTOBack', function () {
                vm.tableReload();
            });
            var options = {
                service: TakeOut,
                params: {opt: 2 /*TAKEOUT.INDEX_STORE_HANDLE*/},
                sorting: {handler_time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {
                        field: "meal_time",
                        width: '20%',
                        title: "送餐时间",
                        sortable: "meal_time"
                    },
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "handler", title: "处理人", filter: {handler: "text"}},
                    {
                        field: "handler_time",
                        width: '20%',
                        title: "确认时间",
                        sortable: "handler_time",
                        filter: {handler_time: "date_range"}
                    }
                ]
            };

            $scope.$watch('dt', function (dt, old, scope) {
                scope.tableParams.$params.page = 1;
                options.params.time = $filter('date')(dt, 'yyyy-MM-dd');
                options.params.forApproved = vm.type;
                scope.tableReload();
            }, true);
            Table.load(vm, options, function (resp) {
                var items = resp.items;
                vm.store = resp.store;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed(parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy), 1);
                });
                vm.items = items;
            });
        }

        function prevDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() - 1));
        }

        function nextDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() + 1));
        }

    });
angular.module('c.c')
    .controller('StoreTOPassCtrl', function ($scope, $rootScope, $filter, Table, FileHelper, PrintHelper,
                                             dialogs, toaster, TakeOut, C, F) {
        var vm = $scope;
        vm.prevDay = prevDay;
        vm.nextDay = nextDay;
        vm.export = exportTO;
        vm.export2 = exportTO2;
        vm.back = back;
        vm.print = print;
        vm.add = add;
        vm.dt = new Date();
        var oscript = document.createElement("script");
        oscript.src = "http://localhost:8019/CLodopfuncs.js?priority=1";
        var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
        head.insertBefore(oscript, head.firstChild);
        var priceOpts = Table.getNgTableOpts([
            {id: '5', name: '5元'},
            {id: '6', name: '6元'},
            {id: '10', name: '10元'}
        ]);

        init();

        function init() {
            vm.$on('storeTOApproved', function () {
                vm.tableReload();
            });

            vm.$on('storeTOAdd', function () {
                vm.tableReload();
            });

            var options = {
                service: TakeOut,
                params: {opt: 2 /*TAKEOUT.INDEX_STORE_HANDLE*/},
                sorting: {handler_time: 'desc'},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {
                        field: "meal_time",
                        width: '20%',
                        title: "送餐时间",
                        sortable: "meal_time"
                    },
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "self_paid", title: "单价", filter: {self_paid: 'select'}, data: priceOpts},
                    {field: "subsidy", title: "补贴"},
                    {field: "handler", title: "处理人", filter: {handler: "text"}},
                    {
                        field: "handler_time",
                        width: '20%',
                        title: "确认时间",
                        sortable: "handler_time",
                        filter: {handler_time: "date_range"}
                    }
                ]
            };

            $scope.$watch('dt', function (dt, old, scope) {
                scope.tableParams.$params.page = 1;
                options.params.time = $filter('date')(dt, 'yyyy-MM-dd');
                options.params.forApproved = vm.type;
                scope.tableReload();
            }, true);
            Table.load(vm, options, function (resp) {
                var items = resp.items;
                vm.store = resp.store;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed(parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy), 1);
                });
                vm.items = items;
            });
        }

        function prevDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() - 1));
        }

        function nextDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() + 1));
        }

        function back(m) {
            dialogs.confirm('取消订单并退款', '确定要退款给<strong>' + m.user.name + '</strong>吗?')
                .result.then(function () {
                TakeOut.update({id: m.id}, {opt: 3/*TAKEOUT.EDIT_STORE_BACK_REFUND*/}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            $rootScope.$broadcast('storeTOBack');
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }

        //导出外卖
        function exportTO() {
            dialogs.create('TOE.html', 'TOECtrl', {day: vm.dt, storeId: vm.store.id}, {
                size: 'md'
            }).result.then(function (m) {
                FileHelper.dnExcel(C.URL.TAKE_OUT_DOWNLOAD, m,
                    m.start.substr(0, 16) + '至' + m.end.substr(11, 5) + '外卖导出表.xls');
            });
        }

        function exportTO2() {
            dialogs.create('TOE2.html', 'TOE2Ctrl', {day: vm.dt, end_day: vm.dt, storeId: vm.store.id}, {
                size: 'md'
            }).result.then(function (m) {
                FileHelper.dnExcel(C.URL.TAKE_OUT_DOWNLOAD2, m,
                    m.day + "到" + m.end_day + '外卖导出表.xls');
            });
        }

        function print(m) {
            var LODOP = getCLodop();
            LODOP.PRINT_INIT("配送打印");
            var count = LODOP.GET_PRINTER_COUNT;
            for (var i = 0; i < count; i++) {
                var name = LODOP.GET_PRINTER_NAME(i);
                if (name == 'XP-76C（副本1）') {
                    LODOP.SET_PRINTER_INDEXA(i);
                }
            }
            var html = '';
            html += '<div style="font-size: 20px;font-family: \'黑体\';"><p>' + m.place.name + '</p>';
            html += '<p style="font-size: 24px; font-weight: bold;">' + m.user.name + '<small>（' + m.dept.name + '）</small></p>';
            html += '<p>' + m.order.name + '</p>';
            if (m.note) {
                html += '<div style="margin-top: 3px;font-size: 16px;">' + m.note + '</div>';
            }
            html += '</div><br/><br/>';
            LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", html);
            LODOP.SET_PRINT_PAGESIZE(3, 720, 0, 'LodopCustomPage');
            LODOP.PRINT();
            //
            // PrintHelper.print(window.open('', '打印预览'), 'templates/print/meal.html', function () {
            //     var html = '';
            //     html += '<div class="receipt"><p>' + m.place.name + '</p>';
            //     html += '<p class="name">' + m.user.name + '<small>（' + m.dept.name + '）</small></p>';
            //     html += '<p>' + m.order.name + '</p>';
            //     if (m.note) {
            //         html += '<div class="note">' + m.note + '</div>';
            //     }
            //     html += '</div>';
            //     return html;
            // }, true);
        }

        function add() {
            dialogs.create('StoreTODetailDlg.html', 'StoreTODetailDlgCtrl', {store: vm.store}, {

                size: 'md'
            });
        }
    });

angular.module('c.c').controller('TOECtrl',
    function ($scope, $uibModalInstance, toaster, $filter, TakeOut, F, PrintHelper, data) {
        var vm = $scope;
        vm.print = print;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        var end1 = new Date(new Date().valueOf() + 2 * 60 * 60 * 1000),
            end2 = new Date(new Date().setHours(23, 59, 59)),
            end;
        if (end1 < end2) {
            end = end1;
        } else {
            end = end2
        }
        vm.m = {day: data.day, start: new Date(), end: end};

        function ok(m) {
            if (m.start > m.end) {
                toaster.warning('开始时间不能大于结束时间');
            } else {
                var pa = {};
                var day = $filter('date')(m.day, 'yyyy-MM-dd');
                var start = $filter('date')(m.start, 'HH:mm');
                var end = $filter('date')(m.end, 'HH:mm');
                pa.start = day + ' ' + start;
                pa.end = day + ' ' + end;
                pa.storeId = data.storeId;
                $uibModalInstance.close(pa);
            }
        }

        function print(m) {
            if (m.start > m.end) {
                toaster.warning('开始时间不能大于结束时间');
            } else {
                var pa = {};
                var day = $filter('date')(m.day, 'yyyy-MM-dd');
                var start = $filter('date')(m.start, 'HH:mm');
                var end = $filter('date')(m.end, 'HH:mm');
                pa.start = day + ' ' + start;
                pa.end = day + ' ' + end;
                pa.storeId = data.storeId;
                TakeOut.printAll(pa, function (resp) {
                    angular.forEach(resp.items, function (m) {
                        var LODOP = getCLodop();
                        LODOP.PRINT_INIT("配送打印");
                        var count = LODOP.GET_PRINTER_COUNT;
                        for (var i = 0; i < count; i++) {
                            var name = LODOP.GET_PRINTER_NAME(i);
                            if (name == 'XP-76C（副本1）') {
                                LODOP.SET_PRINTER_INDEXA(i);
                            }
                        }
                        var html = '';
                        html += '<div style="font-size: 20px;font-family: \'黑体\';"><p>' + m.place.name + '</p>';
                        html += '<p style="font-size: 24px; font-weight: bold;">' + m.user.name + '<small>（' + m.dept.name + '）</small></p>';
                        html += '<p>' + m.order.name + (m.num > 1 ? '（' + m.num + '份）' : '') + '</p>';
                        if (m.note) {
                            html += '<div style="margin-top: 3px;font-size: 16px;">' + m.note + '</div>';
                        }
                        html += '</div><br/><br/>';
                        LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", html);
                        LODOP.SET_PRINT_PAGESIZE(3, 720, 0, 'LodopCustomPage');
                        LODOP.PRINT();
                    });


                    // PrintHelper.print(window.open('', '打印预览'), 'templates/print/meal.html', function () {
                    //     var html = '';
                    //     angular.forEach(resp.items, function (m) {
                    //         html += '<div class="receipt"><p>' + m.place.name + '</p>';
                    //         html += '<p class="name">' + m.user.name + '<small>（' + m.dept.name + '）</small></p>';
                    //         html += '<p>' + m.order.name + (m.num > 1 ? '（' + m.num + '份）' : '') + '</p>';
                    //         if (m.note) {
                    //             html += '<div class="note">' + m.note + '</div>';
                    //         }
                    //         html += '</div><br/>';
                    //     });
                    //     return html;
                    // }, true);
                });

            }
        }
    });

angular.module('c.c').controller('TOE2Ctrl',
    function ($scope, $uibModalInstance, toaster, $filter, TakeOut, F, PrintHelper, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        var end1 = new Date(new Date().valueOf() + 2 * 60 * 60 * 1000),
            end2 = new Date(new Date().setHours(23, 59, 59)),
            end;
        if (end1 < end2) {
            end = end1;
        } else {
            end = end2
        }
        vm.m = {day: data.day, end_day: data.end_day};

        function ok(m) {
            if (m.day > m.end_day) {
                toaster.warning('开始时间不能大于结束时间');
            } else {
                var pa = {};
                pa.day = $filter('date')(m.day, 'yyyy-MM-dd');
                pa.end_day = $filter('date')(m.end_day, 'yyyy-MM-dd');
                pa.storeId = data.storeId;
                $uibModalInstance.close(pa);
            }
        }
    });

angular.module('c.c').controller('StoreTODetailDlgCtrl',
    function ($scope, $uibModalInstance, $filter, F, dialogs, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.canOrder = false;
        var now = $filter('date')(new Date(), 'HH:mm');
        if (F.checkTime(now, '06:00', '22:00')) {
            vm.canOrder = true;
        }

        function ok() {
            vm.cancel();
            dialogs.create('StoreTODlg.html', 'StoreTODlgCtrl', {store: data.store}, {size: 'md'});
        }
    });

angular.module('c.c').controller('StoreTODlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, toaster, uibDateParser, $filter, F, Dept, DeptTakeoutPlace,
              User, TakeOut, data, $q) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.today = new Date();

        init();

        function init() {
            User.query({opt: 17/*USER:INDEX_USER_NOT_ASSIST*/}, function (resp) {
                vm.existMembers = resp.users;
                vm.m = {
                    bOrders: [],
                    lOrders: [],
                    dOrders: [],
                    aOrders: [],
                    note: '',
                    date: vm.today,
                    time: vm.today
                };
            });

            vm.$watch('m.user', function (user, old) {
                if (user) {
                    Dept.query({opt: 13/*INDEX_USER_DEPTS_OPTIONS3*/, user_id: user.id}, function (resp) {
                        vm.depts = resp.depts;
                        vm.m.dept = vm.depts[0];
                    });
                }
            }, true);

            vm.$watch('m.dept', function (dept, old) {
                if (dept) {
                    DeptTakeoutPlace.query({
                        opt: 2, /*DEPTTAKEOUTPLACE.INDEX_OPTIONS*/
                        deptId: dept.id
                    }, function (resp) {
                        vm.places = resp.places;
                        vm.m.place = vm.places[0]
                    });
                }
            }, true);
        }

        function ok(m) {
            if (!m.breakfast && !m.lunch && !m.dinner && !m.all) {
                toaster.warning('请选择预定类型');
            } else if (m.breakfast && m.bOrders.length == 0) {
                toaster.warning('请选择早餐商品');
            } else if (m.lunch && m.lOrders.length == 0) {
                toaster.warning('请选择中餐商品');
            } else if (m.dinner && m.dOrders.length == 0) {
                toaster.warning('请选择晚餐商品');
            } else if (m.all && m.aOrders.length == 0) {
                toaster.warning('请选择全天商品');
            } else if (!m.user) {
                toaster.warning('请选择订餐人');
            } else if (!m.dept) {
                toaster.warning('请选择订餐科室');
            } else if (!m.place) {
                toaster.warning('请选择送餐地点');
            } else {
                var defer = $q.defer();
                var pa = {};
                var keepGoing = true;
                if (m.breakfast) {
                    var bOrders = [],
                        bTotalPrice = 0;
                    angular.forEach(m.bOrders, function (o) {
                        if (keepGoing) {
                            if (o.residue_supply < o.count) {
                                keepGoing = false;
                                defer.reject();
                                toaster.warning(o.name + '库存不足');
                            } else if (!data.store || (data.store && o.store_id != data.store.id)) {
                                keepGoing = false;
                                defer.reject();
                                toaster.warning(o.name + '不属于本商家');
                            } else {
                                bOrders.push({id: o.id, name: o.name, num: o.count});
                                bTotalPrice += o.total_paid;
                            }
                        }
                    });
                    pa.bOrders = bOrders;
                    pa.bTotalPrice = F.toFixed(bTotalPrice, 1);

                    var criticalTime = new Date();
                    criticalTime.setHours(13, 0, 0);
                    if (new Date() > criticalTime) {
                        var newTime = new Date(new Date().setDate(new Date().getDate() + 1));
                        pa.bMealTime = $filter('date')(newTime, 'yyyy-MM-dd 08:00');
                    } else {
                        pa.bMealTime = $filter('date')(new Date(), 'yyyy-MM-dd 08:00');
                    }
                }

                if (m.lunch) {
                    var lOrders = [],
                        lTotalPrice = 0;
                    angular.forEach(m.lOrders, function (o) {
                        if (keepGoing) {
                            if (o.residue_supply < o.count) {
                                keepGoing = false;
                                defer.reject();
                                toaster.warning(o.name + '库存不足');
                            } else if (!data.store || (data.store && o.store_id != data.store.id)) {
                                keepGoing = false;
                                defer.reject();
                                toaster.warning(o.name + '不属于本商家');
                            } else {
                                lOrders.push({id: o.id, name: o.name, num: o.count});
                                lTotalPrice += o.total_paid;
                            }
                        }
                    });
                    pa.lOrders = lOrders;
                    pa.lTotalPrice = F.toFixed(lTotalPrice, 1);
                    pa.lMealTime = $filter('date')(new Date(), 'yyyy-MM-dd 12:00');

                }

                if (m.dinner) {
                    var dOrders = [],
                        dTotalPrice = 0;
                    angular.forEach(m.dOrders, function (o) {
                        if (keepGoing) {
                            if (o.residue_supply < o.count) {
                                keepGoing = false;
                                defer.reject();
                                toaster.warning(o.name + '库存不足');
                            } else if (!data.store || (data.store && o.store_id != data.store.id)) {
                                keepGoing = false;
                                defer.reject();
                                toaster.warning(o.name + '不属于本商家');
                            } else {
                                dOrders.push({id: o.id, name: o.name, num: o.count});
                                dTotalPrice += o.total_paid;
                            }
                        }
                    });
                    pa.dOrders = dOrders;
                    pa.dTotalPrice = F.toFixed(dTotalPrice, 1);
                    pa.dMealTime = $filter('date')(new Date(), 'yyyy-MM-dd 18:00');
                }


                if (m.all) {
                    var aOrders = [],
                        aTotalPrice = 0;
                    angular.forEach(m.aOrders, function (o) {
                        if (keepGoing) {
                            if (!data.store || (data.store && o.store_id != data.store.id)) {
                                keepGoing = false;
                                defer.reject();
                                toaster.warning(o.name + '不属于本商家');
                            } else {
                                aOrders.push({id: o.id, name: o.name, num: o.count});
                                aTotalPrice += o.total_paid;
                            }
                        }
                    });
                    pa.aOrders = aOrders;
                    pa.aTotalPrice = F.toFixed(aTotalPrice, 1);
                    var date = $filter('date')(m.date, 'yyyy-MM-dd'),
                        time = $filter('date')(m.time, 'HH:mm');
                    pa.aMealTime = date + ' ' + time;
                }

                pa.breakfast = m.breakfast;
                pa.lunch = m.lunch;
                pa.dinner = m.dinner;
                pa.all = m.all;
                pa.note = m.note;
                pa.place_id = m.place.id;
                pa.dept_id = m.dept.id;
                pa.user_id = m.user.id;
                if (data.store) {
                    pa.storeId = data.store.id;
                }
                pa.isStore = true;
                pa.localDate = $filter('date')(new Date(), 'yyyy-MM-dd');
                if (keepGoing) {
                    TakeOut.save(pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                defer.resolve();
                                toaster.success('订购成功');
                                $rootScope.$broadcast('storeTOAdd');
                                vm.cancel();
                                break;
                            default:
                                toaster.warning(resp.msg);
                                defer.reject();
                        }
                    });
                }
                return defer.promise;
            }
        }

    });

angular.module('c.c')
    .controller('StoreWMApprovalCtrl', function ($scope, $rootScope, $q, Table, dialogs, toaster, WorkingMeal, C, F) {
        var vm = $scope;
        //vm.add = add;
        vm.batch = batch;
        vm.pass = pass;
        vm.back = back;
        vm.wMStates = F.get('wMStates');
        var checker = Table.loadMultiSelectedFn(vm);

        vm.$on(C.P + 'workingMeal.send', function (event, data) {
            var record = data.data.workingMeal;
            record.totalMoney = F.toFixed((parseFloat(record.order.self_paid) + parseFloat(record.order.subsidy)) * parseFloat(record.num), 1);
            var index = F.indexOfKey(record['id'], vm.tableParams.data);
            if (index >= 0) {
                vm.tableParams.data.splice(index, 1);
            }
            if (vm.store && record['order']['store_id'] == vm.store.id) {
                if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                    vm.tableParams.data.pop();
                }
                record['state'] = F.getItem(record['state'], vm.wMStates);
                vm.tableParams.data.unshift(record);
            }
        });

        init();


        function init() {
            var options = {
                service: WorkingMeal,
                params: {opt: 3/*WORKING_MEAL.INDEX_STORE_APPROVAL*/},
                sorting: {meal_time: 'asc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "num", title: "数量"},
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: F.getNgTableOpts(vm.wMStates)
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                vm.store = resp.store;
                vm.periodTotal = resp.periodTotal;
                var items = resp.items;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                    i.state = F.getItem(i.state, vm.wMStates);
                });
                vm.items = items;
            });
        }


        function batch(items, opt) {
            var defer = $q.defer();
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                defer.reject();
                return;
            }

            for (var i = 0; i < items.length; i++) {
                if (items[i].type == '3') {
                    toaster.warning('存在已删除订单，请刷新');
                    defer.reject();
                    return;
                }
            }

            WorkingMeal.storeBatch({
                itemIds: checker.getCheckedIds(items), opt: opt
            }, function () {
                toaster.success('处理成功');
                vm.tableReload();
                $rootScope.$broadcast('storeWMApproved');
                defer.resolve();
            });
            return defer.promise;
        }

        function pass(m) {
            storeHandle(m, 4);
        }

        function back(m) {
            storeHandle(m, 5);
        }


        function storeHandle(m, opt) {
            var defer = $q.defer();
            WorkingMeal.update({id: m.id}, {opt: opt/*4:WORKINGMEAL.EDIT_STORE_PASS 5:WORKINGMEAL.EDIT_STORE_BACK*/})
                .$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('处理成功');
                        $rootScope.$broadcast('storeWMApproved');
                        defer.resolve();
                        break;
                    case 1:
                        toaster.warning('订单已处理');
                        defer.reject();
                        break;
                }
                vm.tableReload();
            }, function () {
                toaster.error('订单已删除，请刷新');
            });
            return defer.promise;
        }

        //function add() {
        //    dialogs.create('StoreWMDetailDlg.html', 'StoreWMDetailDlgCtrl', {store: vm.store}, {
        //
        //        size: 'md'
        //    });
        //}
    });

//angular.module('c.c').controller('StoreWMDetailDlgCtrl',
//    function ($scope, $uibModalInstance, $filter, F, dialogs, data) {
//        var vm = $scope;
//        vm.ok = ok;
//        vm.cancel = $uibModalInstance.dismiss;
//
//        var now = $filter('date')(new Date(), 'HH:mm');
//        if (F.checkTime(now, '11:00', '18:00')) {
//            vm.type = '2'
//        }
//        if (F.checkTime(now, '18:00', '23:59')) {
//            vm.type = '3'
//        }
//
//        function ok() {
//            vm.cancel();
//            dialogs.create('StoreWMDlg.html', 'StoreWMDlgCtrl', {type: vm.type, store: data.store}, {
//
//                size: 'md'
//            });
//        }
//    });
//
//angular.module('c.c').controller('StoreWMDlgCtrl',
//    function ($scope, $rootScope, $uibModalInstance, toaster, uibDateParser, $filter, F, WorkingMeal, DeliveryPlace,
//              User, data, $q) {
//        var vm = $scope;
//        vm.ok = ok;
//        vm.cancel = $uibModalInstance.dismiss;
//
//        init();
//
//        function init() {
//            DeliveryPlace.query({opt: 2/*DELIVERYPLACE.INDEX_USER_OPTIONS*/}, function (resp) {
//                vm.places = resp.items;
//                vm.m = {
//                    in: true,
//                    out: false,
//                    users: [],
//                    place: vm.places[0],
//                    note: '',
//                    note2: '',
//                    type: data.type
//                };
//            });
//        }
//
//        function ok(m) {
//            if (m.in && m.users.length == 0) {
//                toaster.warning('请选择订餐人!');
//            } else if (m.out && (m.num == null || Number(m.num) == 0)) {
//                toaster.warning('请确认订餐数量!');
//            } else if (m.out && (m.note == null || m.note == "")) {
//                toaster.warning('院外备注不能为空!');
//            } else if (m.out && !m.user) {
//                toaster.warning('请选择订餐人!');
//            } else if (!m.place) {
//                toaster.warning('请选择送餐地点!');
//            } else if (!m.order) {
//                toaster.warning('请选择商品!');
//            } else if (!m.in && !m.out) {
//                toaster.warning('请选择订餐类型!');
//            } else {
//                var defer = $q.defer();
//                var pa = {};
//                var keepGoing = true,
//                    num = 0;
//                if (m.in) {
//                    var userIds = [];
//                    angular.forEach(m.users, function (u) {
//                        userIds.push(u.id);
//                    });
//                    pa.users = userIds;
//                    pa.note2 = m.note2;
//                    num += parseInt(m.users.length);
//                }
//                if (m.out) {
//                    pa.user_id = m.user.id;
//                    pa.num = m.num;
//                    pa.note = m.note;
//                    num += parseInt(m.num);
//                }
//                var o = m.order;
//                if (o.residue_supply < num) {
//                    keepGoing = false;
//                    defer.reject();
//                    toaster.warning(o.name + '库存不足');
//                } else if (!data.store || (data.store && o.store_id != data.store.id)) {
//                    keepGoing = false;
//                    defer.reject();
//                    toaster.warning(o.name + '不属于本商家');
//                } else {
//                    pa.order_id = o.id;
//                }
//                pa.place_id = m.place.id;
//                pa.isStore = true;
//                if (data.store) {
//                    pa.storeId = data.store.id;
//                }
//                if (keepGoing) {
//                    WorkingMeal.save(pa).$promise.then(function (resp) {
//                        switch (resp.result) {
//                            case 0:
//                                defer.resolve();
//                                toaster.success('订购成功');
//                                $rootScope.$broadcast('storeWMAdd');
//                                vm.cancel();
//                                break;
//                            default:
//                                toaster.warning(resp.msg);
//                                defer.reject();
//                        }
//                    });
//                }
//                return defer.promise;
//            }
//        }
//    });


angular.module('c.c')
    .controller('StoreWMApprovedCtrl', function ($scope, $filter, Table, FileHelper,
                                                 dialogs, toaster, WorkingMeal, C, F) {
        var vm = $scope;
        vm.dt = new Date();
        vm.prevDay = prevDay;
        vm.nextDay = nextDay;
        vm.export = exportWM;
        vm.type = '2';

        init();


        function init() {
            vm.$on('storeWMApproved', function () {
                vm.tableReload();
            });

            vm.$on('storeWMAdd', function () {
                vm.tableReload();
            });

            vm.$on('storeWMBack', function () {
                vm.tableReload();
            });

            var options = {
                service: WorkingMeal,
                params: {opt: 5 /*WORKINGMEAL.INDEX_STORE_APPROVED*/},
                sorting: {handler_time: 'desc'},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "num", title: "数量"},
                    {field: "handler", title: "处理人", filter: {handler: "text"}},
                    {
                        field: "handler_time",
                        width: '20%',
                        title: "确认时间",
                        sortable: "handler_time"
                    }
                ]
            };

            vm.$watch('dt', function (dt, old, scope) {
                scope.tableParams.$params.page = 1;
                options.params.time = $filter('date')(dt, 'yyyy-MM-dd');
                options.params.stateType = vm.stateType;
                scope.tableReload();
            }, true);

            vm.$watch('type',
                function (type, old, scope) {
                    scope.tableParams.$params.page = 1;
                    options.params.type = type;
                    scope.tableReload();
                }, true);

            Table.load(vm, options, function (resp) {
                vm.store = resp.store;
                var items = resp.items;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                });
                vm.items = items;
            });
        }

        function nextDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() + 1));
        }

        function prevDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() - 1));
        }

        //导出手术餐
        function exportWM() {
            dialogs.create('/templates/meal/wme.html', 'WMECtrl', {day: vm.dt, end_day: vm.dt, storeId: vm.store.id}, {
                size: 'md'
            }).result.then(function (m) {
                FileHelper.dnExcel(C.URL.WORKING_MEALS_DOWNLOAD, m, m.day +
                    (m.time === '1' ? '午餐' : '晚餐') + '手术餐导出表.xls');
            });
        }
    });




angular.module('c.c')
    .controller('StoreWMPassCtrl', function ($scope, $rootScope, $filter, Table, FileHelper, PrintHelper,
                                             dialogs, toaster, WorkingMeal, C, F) {
        var vm = $scope;
        vm.dt = new Date();
        vm.add = add;
        vm.prevDay = prevDay;
        vm.nextDay = nextDay;
        vm.export = exportWM;
        vm.print = print;
        vm.type = '2';
        vm.back = back;
        var oscript = document.createElement("script");
        oscript.src = "http://localhost:8019/CLodopfuncs.js?priority=1";
        var head = document.head || document.getElementsByTagName("head")[0] || document.documentElement;
        head.insertBefore(oscript, head.firstChild);

        init();


        function init() {
            vm.$on('storeWMApproved', function () {
                vm.tableReload();
            });

            vm.$on('storeWMAdd', function () {
                vm.tableReload();
            });

            var options = {
                service: WorkingMeal,
                params: {opt: 5 /*WORKINGMEAL.INDEX_STORE_APPROVED*/},
                sorting: {handler_time: 'desc'},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "order", title: "商品名称", sortable: "order_id", filter: {order: "text"}},
                    {field: "num", title: "数量"},
                    {field: "handler", title: "处理人", filter: {handler: "text"}},
                    {
                        field: "handler_time",
                        width: '20%',
                        title: "确认时间",
                        sortable: "handler_time"
                    }
                ]
            };

            vm.$watch('dt', function (dt, old, scope) {
                scope.tableParams.$params.page = 1;
                options.params.time = $filter('date')(dt, 'yyyy-MM-dd');
                options.params.stateType = vm.stateType;
                scope.tableReload();
            }, true);

            vm.$watch('type',
                function (type, old, scope) {
                    scope.tableParams.$params.page = 1;
                    options.params.type = type;
                    scope.tableReload();
                }, true);

            Table.load(vm, options, function (resp) {
                vm.store = resp.store;
                var items = resp.items;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                });
                vm.items = items;
            });
        }

        function nextDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() + 1));
        }

        function prevDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() - 1));
        }

        //导出手术餐
        function exportWM() {
            dialogs.create('/templates/meal/wme.html', 'WMECtrl', {day: vm.dt, end_day: vm.dt, storeId: vm.store.id}, {
                size: 'md'
            }).result.then(function (m) {
                FileHelper.dnExcel(C.URL.WORKING_MEALS_DOWNLOAD, m, m.day + "到" + m.end_day +
                    (m.time == '3' ? '午餐和晚餐' : (m.time === '1' ? '午餐' : '晚餐')) + '手术餐导出表.xls');
            });
        }

        function print(m) {
            var LODOP = getCLodop();
            LODOP.PRINT_INIT("配送打印");
            var count = LODOP.GET_PRINTER_COUNT;
            for (var i = 0; i < count; i++) {
                var name = LODOP.GET_PRINTER_NAME(i);
                if (name == 'XP-76C（副本1）') {
                    LODOP.SET_PRINTER_INDEXA(i);
                }
            }
            var html = '';
            html += '<div style="font-size: 20px;font-family: \'黑体\';"><p>' + m.place.name + '</p>';
            html += '<p style="font-size: 24px; font-weight: bold;">' + m.user.name + '<small>（' + m.dept.name + '）</small></p>';
            html += '<p>' + m.order.name + (m.num > 1 ? '（' + m.num + '份）' : '') + '</p>';
            if (m.note) {
                html += '<div style="margin-top: 3px;font-size: 16px;">' + m.note + '</div>';
            }
            html += '</div><br/><br/>';
            LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", html);
            LODOP.SET_PRINT_PAGESIZE(3, 720, 0, 'LodopCustomPage');
            LODOP.PRINT();
            // PrintHelper.print(window.open('', '打印预览'), 'templates/print/meal.html', function () {
            //     var html = '';
            //     html += '<div class="receipt"><p>' + m.place.name + '</p>';
            //     html += '<p class="name">' + m.user.name + '<small>（' + m.dept.name + '）</small></p>';
            //     html += '<p>' + m.order.name + (m.num > 1 ? '（' + m.num + '份）' : '') + '</p>';
            //     if (m.note) {
            //         html += '<div class="note">' + m.note + '</div>';
            //     }
            //     html += '</div>';
            //     return html;
            // }, true);
        }

        function add() {
            dialogs.create('StoreWMDetailDlg.html', 'StoreWMDetailDlgCtrl', {store: vm.store}, {
                size: 'md'
            });
        }

        function back(m) {
            dialogs.confirm('取消订单并退款', '确定要退款给<strong>' + m.user.name + '</strong>吗?')
                .result.then(function () {
                WorkingMeal.update({id: m.id}, {opt: 6/*WORKINGMEAL.EDIT_STORE_BACK_REFUND*/}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            $rootScope.$broadcast('storeWMBack');
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }

    });

angular.module('c.c').controller('StoreWMDetailDlgCtrl',
    function ($scope, $uibModalInstance, $filter, F, dialogs, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.canOrder = false;
        var now = $filter('date')(new Date(), 'HH:mm');
        if (F.checkTime(now, '06:00', '22:00')) {
            vm.canOrder = true;
        }

        function ok() {
            vm.cancel();
            dialogs.create('StoreWMDlg.html', 'StoreWMDlgCtrl', {store: data.store}, {size: 'md'});
        }
    });

angular.module('c.c').controller('StoreWMDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, toaster, uibDateParser, $filter, F, WorkingMeal, DeliveryPlace,
              User, data, $q) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            DeliveryPlace.query({opt: 2/*DELIVERYPLACE.INDEX_USER_OPTIONS*/}, function (resp) {
                vm.places = resp.items;
                vm.m = {
                    in: true,
                    out: false,
                    users: [],
                    place: vm.places[0],
                    note: '',
                    note2: ''
                };
            });
        }

        function ok(m) {
            if (m.in && m.users.length == 0) {
                toaster.warning('请选择院内订餐人!');
            } else if (m.out && !m.user) {
                toaster.warning('请选择院外订餐人!');
            } else if (m.out && (m.num == null || Number(m.num) == 0)) {
                toaster.warning('请确认订餐数量!');
            } else if (m.out && (m.note == null || m.note == "")) {
                toaster.warning('院外备注不能为空!');
            } else if (!m.place) {
                toaster.warning('请选择送餐地点!');
            } else if (!m.lunch && !m.dinner) {
                toaster.warning('请选择送餐类型!');
            } else if (m.lunch && !m.lOrder) {
                toaster.warning('请选择中餐商品!');
            } else if (m.dinner && !m.dOrder) {
                toaster.warning('请选择晚餐商品!');
            } else if (!m.in && !m.out) {
                toaster.warning('请选择订餐类型!');
            } else {
                var defer = $q.defer();
                var pa = {};
                var keepGoing = true,
                    num = 0;
                if (m.in) {
                    var userIds = [];
                    angular.forEach(m.users, function (u) {
                        userIds.push(u.id);
                    });
                    pa.users = userIds;
                    pa.note2 = m.note2;
                    num += parseInt(m.users.length);
                }
                if (m.out) {
                    pa.user_id = m.user.id;
                    pa.num = m.num;
                    pa.note = m.note;
                    num += parseInt(m.num);
                }
                if (m.lunch) {
                    var o1 = m.lOrder;
                    if (o1.residue_supply < num) {
                        keepGoing = false;
                        defer.reject();
                        toaster.warning(o1.name + '库存不足');
                    } else if (!data.store || (data.store && o1.store_id != data.store.id)) {
                        keepGoing = false;
                        defer.reject();
                        toaster.warning(o1.name + '不属于本商家');
                    } else {
                        pa.lOrder = {id: o1.id, name: o1.name};
                    }
                }

                if (m.dinner) {
                    var o2 = m.dOrder;
                    if (o2.residue_supply < num) {
                        keepGoing = false;
                        defer.reject();
                        toaster.warning(o2.name + '库存不足');
                    } else if (!data.store || (data.store && o2.store_id != data.store.id)) {
                        keepGoing = false;
                        defer.reject();
                        toaster.warning(o2.name + '不属于本商家');
                    } else {
                        pa.dOrder = {id: o2.id, name: o2.name};
                    }
                }

                pa.lunch = m.lunch;
                pa.dinner = m.dinner;
                pa.place_id = m.place.id;
                pa.isStore = true;
                if (data.store) {
                    pa.storeId = data.store.id;
                }
                if (keepGoing) {
                    WorkingMeal.save(pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                defer.resolve();
                                toaster.success('订购成功');
                                $rootScope.$broadcast('storeWMAdd');
                                vm.cancel();
                                break;
                            default:
                                toaster.warning(resp.msg);
                                defer.reject();
                        }
                    });
                }
                return defer.promise;
            }
        }
    });




(function () {
    'use strict';

    angular.module('c.c')
        .controller('CommentTypeCtrl', CommentTypeCtrl)
    ;

    /** @ngInject */
    function CommentTypeCtrl($scope, Table, ArrayHelper, Dlg, Api, commentType) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();


        function init() {

            var options = {
                service: commentType,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: '72'},
                    {field: "name", title: "名称"},
                    {title: '排序', field: 'sorting', show: true} //0
                ]
            };

            Table.load(vm, options, function (data) {
                console.log('data',data);
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/commentTypeDlg.html', 'CommentTypeDlgCtrl', m);
        }

        function setStop(m) {
            Api.setDisable(commentType, m);
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的评论类型吗？', function () {
                commentType.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除评论类型');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('CommentTypeDlgCtrl', CommentTypeDlgCtrl);

    /** @ngInject */
    function CommentTypeDlgCtrl($uibModalInstance, ArrayHelper, Dlg, commentType, data, FormHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            if (id) {
                vm.$edit = true;
                commentType.get({id: id}).$promise.then(function (resp) {
                    vm.m = resp;
                });
            } else {
                vm.m = {
                    is_stop: 0
                };
            }
        }

        function ok(m) {

            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    sorting: m.sorting,
                    is_stop: m.is_stop
                };
                var promise;
                if (vm.$edit) {
                    promise = commentType.update({id: m.id}, pa).$promise;
                } else {
                    promise = commentType.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.close();
                }, function (err) {
                    if (err.msg) Dlg.e(err.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.s')
        .controller('CommonPhoneCtrl', CommonPhoneCtrl)
        .controller('CommonPhoneDlgCtrl', CommonPhoneDlgCtrl);

    /** @ngInject */
    function CommonPhoneCtrl($scope, dialogs, toaster, Table, CommonPhone, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {phone: "text"}},
                    {field: "cornet", title: "小号", filter: {cornet: "text"}},
                    {field: "sort", title: "排序"},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }


        function add() {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                CommonPhone.save(m).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit(m) {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {id: m.id}, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                CommonPhone.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                CommonPhone.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }

    }

    /** @ngInject */
    function CommonPhoneDlgCtrl($scope, $uibModalInstance, toaster, F, CommonPhone, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                CommonPhone.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                    sort: m.sort,
                    is_stop: m.is_stop ? '1' : '0'
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }
})();


angular.module('c.c')
    .controller('ContractTypeCtrl', function ($scope, dialogs, toaster, $filter, Table, F, ContractType) {
        var vm = $scope;
        vm.add = add;
        vm.setStop = setStop;
        vm.edit = edit;
        vm.ok = ok;
        vm.remove = remove;
        vm.yesNo = F.get('yesNo');

        init();
        function init() {
            var options = {
                service: ContractType,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "类型名称", filter: {name: "text"}},
                    {field: "description", title: "类型描述", filter: {description: "text"}},
                    {field: "sorting", title: "类型排序"}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('AddContractTypeDlg.html', 'AddContractTypeCtrl', null, {
                size: 'md'
            }).result.then(function (params) {
                ContractType.save(params).$promise.then(function () {
                    toaster.success('保存成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('保存失败!');
                });
            });
        }

        function setStop(type, is_stop) {
            ContractType.update({id: type.id}, {opt: 1, is_stop: is_stop});
            type.is_stop = is_stop ? '1' : '0';
        }

        function edit(type) {
            type.$edit = true;
            type.$nameChanged = type.name;
            type.$sortingChanged = parseInt(type.sorting);
            type.$descChanged = type.description;
        }

        function ok(type) {
            if (type.$nameChanged == '') {
                toaster.error('名称不能为空!');
            } else if (type.$sortingChanged == '') {
                toaster.error('排序不能为空!');
            } else {
                var params = {};
                params['opt'] = 1/*EDIT_UPDATE*/;
                params['name'] = type.$nameChanged;
                params['sorting'] = type.$sortingChanged;
                params['description'] = type.$descChanged;
                ContractType.update({id: type.id}, params).$promise.then(function () {
                    type.$edit = false;
                    type.name = params.name;
                    type.description = params.description;
                    type.sorting = params.sorting;
                }, function () {
                    toaster.error('更改失败!');
                });
            }
        }

        function remove(type) {
            dialogs.confirm('删除新闻类型', '确定要删除该类型吗?')
                .result.then(function () {
                ContractType.delete({id: type.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该类型的合同,无法删除!');
                            break;
                    }
                    vm.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }
    });

angular.module('c.c').controller('AddContractTypeCtrl',
    function ($scope, toaster, $uibModalInstance) {
        var vm = $scope;
        vm.add = add;
        vm.cancel = cancel;
        vm.type = {};

        function add(contract_form, type) {
            if (contract_form.$invalid) {
                toaster.warning('表单有误!');
            } else {
                var params = {};
                params['name'] = type.name;
                params['description'] = type.description;
                params['sorting'] = type.sorting;
                $uibModalInstance.close(params);
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    });



(function () {
    'use strict';

    angular.module('c.c')
        .controller('DocTypeCtrl', DocTypeCtrl)
        .controller('DocTypeDlgCtrl', DocTypeDlgCtrl)
        .controller('StepDlgCtrl', StepDlgCtrl)
        .controller('BatchStepDlgCtrl', BatchStepDlgCtrl)
    ;

    /** @ngInject */
    function DocTypeCtrl($scope, dialogs, toaster, FileHelper, Api, Table, Dlg,
                         NgTableParams, C, F, SaveAs, Dept, Doc, DocType) {
        var checker = Table.loadMultiSelectedFn($scope);
        var results = Doc.getDocStepResults();
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.cols = [
            {title: '名称', filter: {name: 'text'}, show: true}, //1
            {title: '归档科室', filter: {dept: 'text'}, show: true}, //6
            {title: '备注', show: true}, //6
            {title: '排列顺序', sortable: 'sorting', show: true}, //6
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, show: true} //6
        ];

        Dept.query({opt: 4}, function (resp) {
            $scope.depts = resp.depts;
        });

        $scope.optColWidth = 108;
        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            sorting: {
                sorting: 'asc'
            }
        }, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.DOC_TYPE.INDEX.MANAGE;
                DocType.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.types, function (type) {
                        type.sorting = parseInt(type.sorting);
                        if (type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS) {
                            angular.forEach(type.steps, function (step) {
                                step.result = F.getItem(step.result, results);
                            });
                        }
                    });
                    $defer.resolve(resp.types);
                });
            }
        });

        $scope.detail = function (steps) {
            dialogs.create('templates/doc/process_dlg.html', 'ProcessDlgCtrl', {steps: steps}, {
                size: 'md'
            });
        };

        $scope.download = function (type) {
            var params = {filename: type.filename, mime: type.mime};
            type.downloading = true;
            FileHelper.download(C.URL.DOC_TYPE_DOWNLOAD, params, function (resp) {
                type.downloading = false;
                var data = [resp];
                var options = {type: type.mime};
                SaveAs.download(data, type.attach_name, options);
            }, function (error) {
                type.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.batch = function () {
            if (!checker.hasChecked()) {
                Api.w('请选择处理对象');
                return;
            }
            var data = $scope.tableParams.settings().$scope.$data;
            var event = checker.getChecked(data);
            var ids = [];
            angular.forEach(event, function (e) {
                ids.push({id: e.id});
            });
            Dlg.show({
                template: 'BatchStepDlg.html',
                ctrl: 'BatchStepDlgCtrl', size: 'md',
                data: {
                    ids: ids
                }
            }).then(function () {
                $scope.tableParams.reload();
            });
        };

        $scope.setStop = function (type, stop) {
            DocType.update({id: type.id}, {is_stop: stop}).$promise.then(function () {
                type.is_stop = stop ? '1' : '0';
            });
        };

        $scope.add = function () {
            dialogs.create('DocTypeDlg.html', 'DocTypeDlgCtrl', {depts: $scope.depts}, {
                size: 'md'
            }).result.then(function (data) {
                DocType.save(data).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.edit = function (type) {
            function updateType(exist) {
                dialogs.create('DocTypeDlg.html', 'DocTypeDlgCtrl', {type: type, depts: $scope.depts}, {
                    size: 'md'
                }).result.then(function (data) {
                    DocType.update({id: type.id}, data).$promise.then(function (data) {
                        toaster.success('修改成功');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('修改失败');
                    })
                });
            }

            DocType.get({id: type.id, opt: 3 /*SHOW_PROCESSING_DOC_EXIST*/}, function (resp) {
                var exist = resp.type;
                if (exist) {
                    dialogs.confirm('提示', "存在正在执行的《" + type.name +
                        "》公文,<span class=\"text-red\">请谨慎修改规定步骤!</span>").result.then(function (data) {
                        updateType(exist);
                    });
                } else {
                    updateType(exist);
                }
            });
        };

        $scope.delete = function (type) {
            dialogs.confirm('删除公文类型', '确定要删除<strong>' + type.name + '</strong>' + '吗?')
                .result.then(function () {
                DocType.delete({id: type.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该类型的公文记录,无法删除该分类!');
                            break;
                    }
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };
    }

    /** @ngInject */
    function DocTypeDlgCtrl($scope, $uibModalInstance, dialogs, toaster, C,
                            Doc, DocType, DocTypeStep, data, FileHelper, F, ArrayHelper) {
        $scope.depts = data.depts;

        var edit = false;
        if (data.type) {
            $scope.$edit = edit = true;
            var t = data.type;
            $scope.type = {
                id: t.id,
                name: t.name,
                sorting: t.sorting,
                dept: t.dept,
                note: t.note,
                attach_name: t.attach_name,
                filename: t.filename,
                mime: t.mime,
                size: t.size,
                desc_way: t.desc_way,
                steps: t.steps,
                attachments: t.attachments
            };
            DocType.get({id: data.type.id, opt: C.OPT.DOC_TYPE.SHOW.BODY}, function (resp) {
                $scope.type.body = resp.type.body;
            });
        } else {
            $scope.type = {
                sorting: 100,
                dept: data.depts[0],
                desc_way: C.DOC.DESC_BY.FIXED_PROCESS,
                steps: [],
                attachments: []
            };
        }

        function checkSteps(steps) {
            var ok = false;
            if (steps.length > 0) {
                //除最后一步外，其余步骤不能是结束状态
                for (var i = 0; i < steps.length - 1; i++) {
                    var step = steps[i];
                    if (step.result.id <= C.DOC.STEP.RESULT.MAX_END) {
                        toaster.warning('除最后一步外,其余步骤不能是结束状态');
                        break;
                    }
                }

                if (i == steps.length - 1) {
                    //最后一步必须是肯定结束状态
                    switch (steps[steps.length - 1].result.id) {
                        case C.DOC.STEP.RESULT.OK_END:
                        case C.DOC.STEP.RESULT.EXECUTE:
                            ok = true;
                            break;
                        default:
                            toaster.warning('最后一步应该是肯定结束状态（同意并完成/已执行）');
                            break;
                    }
                }
            } else {
                toaster.warning('未设置预期处理步骤');
            }
            return ok;
        }

        $scope.handlerName = function (step) {
            return Doc.getDocHandlerName(step);
        };

        $scope.addStep = function (type, index) {
            var results = Doc.getDocStepResults();
            //type.insertStep = true;
            dialogs.create('StepDlg.html', 'StepDlgCtrl', {depts: data.depts, edit: edit, isLast: false}, {
                size: 'md'
            }).result.then(function (step) {
                if (edit) {
                    var step2 = {handler_type: step.handler_type, result: step.result.id};
                    if (step.handler_type == C.DOC.HANDLE_BY.USER) {
                        step2['handler_id'] = step.handler.id;
                    } else if (step.handler_type == C.DOC.HANDLE_BY.DEPT) {
                        step2['dept_id'] = step.dept.id;
                    }
                    step2['note'] = step.note;
                    step2['step'] = index + 1;
                    step2['type_id'] = type.id;
                    DocTypeStep.save(step2).$promise.then(function (data) {
                        console.log('data', data);
                        var step = data.item;
                        step.result = F.getItem(step.result, results);
                        $scope.type.steps.splice(index, 0, data.item);
                        toaster.success('修改成功');
                    }, function () {
                        toaster.error('修改失败');
                    });
                } else {
                    $scope.type.steps.splice(index, 0, step);
                }
            });
        };

        $scope.editStep = function (index, type) {
            dialogs.create('StepDlg.html', 'StepDlgCtrl', {
                depts: data.depts,
                step: type.steps[index],
                edit: edit, isLast: index == type.steps.length - 1
            }, {
                size: 'md'
            }).result.then(function (step) {
                if (edit) {
                    var step2 = {handler_type: step.handler_type, result: step.result.id};
                    step2['handler_id'] = step.handler_type == C.DOC.HANDLE_BY.USER ? step.handler.id : null;
                    step2['dept_id'] = step.handler_type == C.DOC.HANDLE_BY.DEPT ? step.dept.id : null;
                    step2['note'] = step.note;
                    step.id = type.steps[index].id;
                    DocTypeStep.update({id: step.id}, step2).$promise.then(function (data) {
                        toaster.success('修改成功');
                        $scope.type.steps[index] = step;
                    }, function () {
                        toaster.error('修改失败');
                    });
                } else {
                    $scope.type.steps[index] = step;
                }
            });
        };

        $scope.deleteStep = function (index, type) {
            if (edit) {
                dialogs.confirm('提示', '<span class="text-red">删除步骤将立即生效，并会对正在执行的公文流程造成影响</span>!!是否继续?')
                    .result.then(function () {
                    DocTypeStep.delete({id: type.steps[index].id}).$promise.then(function (data) {
                        toaster.success('删除成功');
                        $scope.type.steps.splice(index, 1);
                    }, function () {
                        toaster.error('删除失败');
                    });
                });
            } else {
                $scope.type.steps.splice(index, 1);
            }
        };

        $scope.editBody = function (type) {
            dialogs.create('templates/rich_edit_dlg.html', 'RichEditDlgCtrl', {
                body: type.body,
                title: '编辑内容模板'
            }, {
                size: 'lg'
            }).result.then(function (body) {
                type.body = body;
            });
        };

        $scope.upload = function (file, type, e) {
            FileHelper.upload1(C.URL.DOC_TYPE_UPLOAD, file, type, e);
        };

        $scope.ok = function (type) {
            if (type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS && !checkSteps(type.steps)) {
                return;
            }

            if ($scope.type_form.$valid) {
                var params = {};
                params['name'] = type.name;
                params['dept_id'] = type.dept.id;
                params['sorting'] = type.sorting;
                params['body'] = type.body;
                params['note'] = type.note;
                params['attach_name'] = type.attach_name;
                params['filename'] = type.filename;
                params['mime'] = type.mime;
                params['size'] = type.size;

                params['desc_way'] = type.desc_way;
                params['attachments'] = ArrayHelper.map(type.attachments, function (attachment) {
                    return attachment.id ? {id: attachment.id} : {
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    };
                });
                /* 存在正在执行的该类型公文，则不允许这样直接提交修改的步骤 */
                if (type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS && !edit) {
                    params['steps'] = [];
                    for (var i = 0; i < type.steps.length; i++) {
                        var step = type.steps[i];
                        var step2 = {handler_type: step.handler_type, result: step.result.id};
                        if (step.handler_type == C.DOC.HANDLE_BY.USER) {
                            step2['handler_id'] = step.handler.id;
                        } else if (step.handler_type == C.DOC.HANDLE_BY.DEPT) {
                            step2['dept_id'] = step.dept.id;
                        }
                        step2['note'] = step.note;
                        params['steps'].push(step2);
                    }
                }
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.type_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function StepDlgCtrl($scope, $uibModalInstance, toaster, C, data) {
        $scope.depts = data.depts;
        $scope.prompt = data.edit;
        $scope.results = [
            {id: '7', name: '转审批'}, {id: '8', name: '转执行'},
            {id: '1', name: '同意并完成'}, {id: '3', name: '已执行'},
            {id: '9', name: '转评估'}
        ];

        if (data.step) {
            $scope.$edit = true;
            var step = data.step;
            $scope.step = {
                result: step.result,
                handler: step.handler,
                dept: step.dept,
                handler_type: step.handler_type,
                note: step.note
            };
        } else {
            $scope.step = {result: $scope.results[0], handler_type: C.DOC.HANDLE_BY.DEPT_LEADER};
        }

        $scope.ok = function (step) {
            if (step.handler_type == C.DOC.HANDLE_BY.USER && !step.handler) {
                toaster.warning('请设置处理人');
            } else if (step.handler_type == C.DOC.HANDLE_BY.DEPT && !step.dept) {
                toaster.warning('请设置职能科室');
            } else if (data.edit && data.isLast && +step.result.id > +C.DOC.STEP.RESULT.MAX_END) {
                toaster.warning('最后一个步骤必须是表示结束的步骤');
            } else if (data.edit && !data.isLast && +step.result.id < +C.DOC.STEP.RESULT.MAX_END) {
                toaster.warning('中间步骤不能是结束步骤');
            } else {
                var params = {};
                params['result'] = step.result;
                params['handler_type'] = step.handler_type;
                params['dept'] = step.handler_type == C.DOC.HANDLE_BY.DEPT ? step.dept : null;
                params['handler'] = step.handler_type == C.DOC.HANDLE_BY.USER ? step.handler : null;
                params['note'] = step.note;
                $uibModalInstance.close(params);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    /** @ngInject */
    function BatchStepDlgCtrl($scope, $uibModalInstance, Dlg, DocType, FormHelper, data) {
        var vm = this;
        var defVal = {
            old_user: null,
            new_user: null
        };
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        init();

        function init() {
            vm.m = angular.copy(defVal);
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    ids: data.ids,
                    old_id: m.old_user.id,
                    new_id: m.new_user.id,
                    opt: 3
                };
                DocType.update({id: '-'}, pa).$promise.then(function () {
                    Dlg.s('修改成功');
                    $uibModalInstance.close();
                }, function () {
                    Dlg.e('修改失败');
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('JobTitleCtrl', JobTitleCtrl)
    ;

    /** @ngInject */
    function JobTitleCtrl($scope, Table, ArrayHelper, Dlg, Api, JobTitle) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();


        function init() {
            var types = JobTitle.getTypes();
            var Levels = JobTitle.getLevels();
            var options = {
                service: JobTitle,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: '72'},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "type", title: '类型', filter: {type: 'select'},
                        data: Table.getNgTableOpts(types)
                    },
                    {
                        field: "level", title: '等级', filter: {level: 'select'},
                        data: Table.getNgTableOpts(Levels)
                    }
                ]
            };

            Table.load(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    item.type = ArrayHelper.getItem(item.type, types);
                    item.level = ArrayHelper.getItem(item.level, Levels);
                });
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/jobTitleDlg.html', 'JobTitleDlgCtrl', m);
        }

        function setStop(m) {
            Api.setDisable(JobTitle, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的职称吗？', function () {
                JobTitle.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除请假类型');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('JobTitleDlgCtrl', JobTitleDlgCtrl);

    /** @ngInject */
    function JobTitleDlgCtrl($uibModalInstance, ArrayHelper, Dlg, JobTitle, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.types = JobTitle.getTypes();
        vm.levels = JobTitle.getLevels();


        init(data.id);


        function init(id) {
            if (id) {
                JobTitle.get({id: id}).$promise.then(function (resp) {
                    var m = resp;
                    m.type = ArrayHelper.getItem(m.type, vm.types);
                    m.level = ArrayHelper.getItem(m.level, vm.levels);
                    vm.m = m;
                });
            } else {
                vm.m = {
                    sorting: 1
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, JobTitle, function () {
                return {
                    name: m.name,
                    sorting: m.sorting,
                    type: m.type.id,
                    level: m.level.id
                };
            });
        }
    }

})();

angular.module('c.c')
    .controller('ManualTypeCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, Table, ManualType, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '名称', filter: {'name': 'text'}, field: 'name', show: true}, //0
            {title: '排序', field: 'sorting', show: true}, //0
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', show: true} //6
        ];
        $scope.optColWidth = 70;
        $scope.hideFilter = true;

        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            filter: {}
        }, {
            counts: [5, 10],
            total: 0,
            getData: function ($defer, params) {
                if (!$scope.cachedData) {
                    ManualType.query({'opt': 2}, function (data) {
                        $scope.cachedData = data.types;
                        Table.getTableData(data.types, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.cachedData;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });


        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('ManualTypeDlg.html', 'ManualTypeDlgCtrl', {}, {
                size: 'md'
            }).result.then(function (type) {
                ManualType.save(type).$promise.then(function (data) {
                    toaster.success('类型添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('类型添加失败!');
                });
            });
        };

        $scope.edit = function (record) {
            dialogs.create('ManualTypeDlg.html', 'ManualTypeDlgCtrl', {
                    edit: true, type: record
                }, {
                    size: 'md'
                }
            ).result.then(function (type) {
                ManualType.update({id: record.id}, type).$promise.then(function (data) {
                    toaster.success('类型修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('类型修改失败!');
                });
            });
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除类型', '确定要删除<strong>' + record.name + '</strong>的类型吗?')
                .result.then(function () {
                ManualType.delete({id: record.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('类型删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在使用该类型的记录,因此无法删除!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('车型删除失败!');
                });
            });

        };
    });

angular.module('c.c').controller('ManualTypeDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.yesNo = F.get('yesNo');
        $scope.edit = data.edit;

        if (data.type) {
            var type = data.type;
            $scope.$edit = true;
            $scope.type = {
                name: type.name,
                sorting: type.sorting,
                is_stop: type.is_stop == 1
            }
        } else {
            $scope.type = {
                is_stop: 0
            };
        }

        $scope.ok = function (type) {
            if ($scope.type_form.$valid) {
                var params = {};
                params['name'] = type.name;
                params['sorting'] = type.sorting;
                params['is_stop'] = type.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.type_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    })
;
angular.module('c.c')
    .controller('MeetingTypeCtrl', function ($scope, $filter, dialogs, toaster, Table,
                                             NgTableParams, MeetingType, Api, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '名称', filter: {'name': 'text'}, field: 'name', show: true}, //0
            {title: '排序', field: 'sorting', show: true}, //0
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', show: true} //6
        ];
        $scope.optColWidth = 70;
        $scope.hideFilter = true;

        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            filter: {}
        }, {
            counts: [5, 10],
            total: 0,
            getData: function ($defer, params) {
                if (!$scope.cachedData) {
                    MeetingType.query({'opt': 1}, function (data) {
                        $scope.cachedData = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.cachedData;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });


        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('templates/basic/data_dlg.html', 'BasicDataDlgCtrl', {title: '会议类型'}, {
                size: 'md'
            }).result.then(function (data) {
                MeetingType.save(data).$promise.then(function (data) {
                    toaster.success('会议类型添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('会议类型添加失败!');
                })
            });
        };

        $scope.edit = function (data) {
            data.$edit = true;
            data.$nameChanged = data.name;
            data.$sortingChanged = data.sorting;
        };

        $scope.save = function (data) {
            data.$edit = false;
            if (data.$nameChanged == "") {
                toaster.error('会议类型名称不能为空!');
            } else if (data.name != data.$nameChanged || data.sorting != data.$sortingChanged) {
                var params = {};
                params['name'] = data.$nameChanged;
                params['sorting'] = data.$sortingChanged;
                MeetingType.update({id: data.id}, params).$promise.then(function () {
                    toaster.success('会议类型修改成功!');
                    data.name = data.$nameChanged;
                    data.sorting = parseInt(data.$sortingChanged);
                    $scope.tableParams.reload();
                }, function (error) {
                    toaster.error('会议类型修改失败!');
                });
            }
        };

        $scope.delete = function (data) {
            dialogs.confirm('删除会议类型', '确定要删除<strong>' + data.name + '</strong>' + '会议类型吗?')
                .result.then(function () {
                MeetingType.delete({id: data.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('会议类型删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该会议类型的会议记录,因此无法删除该分类!');
                            break;
                    }
                    $scope.tableReload();
                }, function () {
                    toaster.error('会议类型删除失败!');
                });
            });
        };

        $scope.setStop = function (m) {
            Api.setStop(MeetingType, m);
        }


    });

angular.module('c.c').controller('CarTypeDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.yesNo = F.get('yesNo');
        $scope.edit = data.edit;

        if (data.type) {
            var type = data.type;
            $scope.$edit = true;
            $scope.type = {
                name: type.name,
                spare_num: type.spare_num,
                is_stop: type.is_stop == 1
            }
        }
        else {
            $scope.type = {
                is_stop: '0'
            };
        }

        $scope.ok = function (type) {
            if ($scope.car_type_form.$valid) {
                var params = {};
                params['name'] = type.name;
                params['spare_num'] = type.spare_num;
                params['is_stop'] = type.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.car_type_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    })
;
(function() {
    'use strict';

    angular.module('c.c')
        .controller('PneumoniaCollectTypeCtrl', PneumoniaCollectTypeCtrl)
        .controller('PneumoniaCollectTypeDlgCtrl', PneumoniaCollectTypeDlgCtrl)
    ;

    /** @ngInject */
    function PneumoniaCollectTypeCtrl($scope, Table, $http, Dlg) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;

        init();


        function init() {
            var options = {
                service: $http,
                params: {
                    url: '/api/v1/pneumonia/collect_records',
                    method: 'GET',
                    params: {
                        op: 'typeDefault'
                    }
                },
                sorting: {num: 'asc'},
                optInFront: true,
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "num", title: "序号"},
                    {field: "name", title: "分类名称"},
                    {field: "group_name", title: "收集组"},
                    {field: "desc", title: "分类说明"}
                ]
            };
            Table.load(vm, options, null, '$http');
        }

        function addEdit(m) {
            Dlg.addEdit2(vm, 'PneumoniaCollectTypeDlg.html', 'PneumoniaCollectTypeDlgCtrl',
                m, null, 'md', function() {
                    vm.tableReload();
                });
        }

        function setStop(m) {
        }
    }

    /** @ngInject */
    function PneumoniaCollectTypeDlgCtrl($uibModalInstance, Dlg, $http, FormHelper, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.m = {
            num: 1
        };

        init(data.id);


        function init(id) {
            if (id) {
                $http.get('/api/v1/pneumonia/collect_records/' + id, {params: {op: 'typeDefault'}})
                    .success(function(data) {
                        vm.m = data.item;
                    }).error(function(error) {
                    var data = error.data;
                    Dlg.e(data.msg);
                });
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                var requireMethod = 'Post';
                var requireUrl = '/api/v1/pneumonia/collect_records';
                var params = {
                    op: 'typeDefault',
                    num: m.num,
                    name: m.name,
                    group_name: m.group_name,
                    desc: m.desc
                };

                if (m.id) { //修改
                    requireMethod = 'Put';
                    requireUrl = requireUrl + '/' + m.id;
                }
                $http({
                    url: requireUrl,
                    method: requireMethod,
                    data: params
                }).success(function(resp) {
                    Dlg.s(resp.msg);
                    defer.resolve();
                    vm.close();
                }).error(function(error) {
                    var data = error.data;
                    Dlg.e(data.msg);
                    defer.reject();
                });
            });
        }
    }
})();

angular.module('c.c')
    .controller('RedHeadApproverCtrl', function ($scope, toaster, RedHeadApprover) {
        $scope.reload = function () {
            RedHeadApprover.get({id: 1}).$promise.then(function (resp) {
                $scope.setting = {
                    first_approver: resp.first_approver,
                    second_approver: resp.second_approver
                }
            });
        };
        $scope.reload();

        $scope.submit = function (setting) {
            if (setting.first_approver == null || setting.second_approver == null) {
                toaster.warning('审批人不能为空!');
            } else if (setting.first_approver.id == setting.second_approver.id) {
                toaster.warning('审批人不能相同!');
            }
            else {
                var params = {};
                params['first_approver_id'] = setting.first_approver.id;
                params['second_approver_id'] = setting.second_approver.id;

                RedHeadApprover.update({id: 1}, params).$promise.then(function (resp) {
                    toaster.success('审批人设置成功!');
                    $scope.reload();
                }, function () {
                    toaster.error('审批人设置失败!');
                });
            }
        }
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('WardDeptDlgCtrl', WardDeptDlgCtrl);

    /** @ngInject */
    function WardDeptDlgCtrl($scope, $uibModalInstance, Table, Dlg, DeptWard, DeptType, data) {
        var vm = $scope;
        vm.add = add;
        vm.remove = remove;
        vm.cancel = $uibModalInstance.dismiss;


        init(data.m);


        function init(m) {
            vm.ward = m.name;
            vm.type_id = m.type_id;

            var options = {
                service: DeptWard,
                params: {op: 'sys_dept', ward_id: m.id},
                optInFront: true,
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "name", title: "科室名称", filter: {name: "text"}},
                    {field: "type", title: "类别", filter: {type_id: "select"}}
                ]
            };

            DeptType.query(function (resp) {
                options.cols[1].data = Table.getNgTableOpts(resp.items);
            });

            Table.load(vm, options);
        }

        function add() {
            Dlg.show({
                template: 'directives/form/dept-selector/dept_selector_dlg.html',
                ctrl: 'DeptSelectCtrl',
                data: {
                    multiSelect: true
                }
            }).then(function (depts) {
                if (depts.length > 0) {
                    for (var i = 0; i < depts.length; i++) {
                        if (depts[i].type_id != vm.type_id) {
                            Dlg.w(depts[i].name + '类别不符合，无法添加');
                            return
                        }
                    }
                    var pa = {depts: [], op: 'add_dept'};
                    angular.forEach(depts, function (dept) {
                        pa.depts.push(dept.id)
                    });
                    DeptWard.update({id: data.m.id}, pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        vm.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                    });
                }
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除病区<strong>' + vm.ward + '</strong>下的' + m.name + '吗？', function () {
                DeptWard.update({id: data.m.id, op: 'del_dept'}, {deptId: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除科室');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptManageCtrl', DeptManageCtrl)
        .controller('DeptDlgCtrl', DeptDlgCtrl);

    function DeptManageCtrl($scope, $filter, $q, dialogs, toaster, NgTableParams, Dept, DeptType, F, Table, $http) {
        var needRefresh = true;


        $scope.$on('basicDataChange', function () {
            needRefresh = true;
        });

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');

        $scope.cols = [
            {title: '科室名称', filter: {name: 'text'}, field: 'name', show: true}, //0
            {title: '类别', filter: {type_id: 'select'}, field: 'type_id', show: true}, //1
            {title: '是否核算科室', filter: {can_account: 'select'}, data: yesNoOpts, field: 'can_account', show: true}, //6
            {title: '允许申请耗材', filter: {csmb: 'select'}, data: yesNoOpts, field: 'csmb', show: true}, //6
            {title: 'his耗材科室', filter: {csmb_dept_id: 'select'}, field: 'csmb_dept_id', show: true}, //6
            {title: '排列顺序', sortable: 'sorting', filter: {sorting: 'num_range'}, field: 'sorting', show: true} //6
        ];
        var types_col = $scope.cols[1];
        var depts_col = $scope.cols[4];

        $scope.deptTabSelected = function () {
            if (needRefresh) {
                DeptType.query(function (resp) {
                    $scope.types = resp.items;
                    types_col.data = F.getNgTableOpts(resp);
                });
                needRefresh = false;
            }
        };

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        function getTableData(data, $defer, params, $filter) {
            if (params.filter()) {
                var filters = params.filter();
                if (filters['type_id']) {
                    data = $filter('filter')(data, {type_id: filters['type_id']}, function (actual, expected) {
                        return angular.equals(actual, +expected);
                    });
                }
                if (filters['can_account']) {
                    data = $filter('filter')(data, {can_account: filters['can_account']}, true);
                }
                if (filters['punch_card']) {
                    data = $filter('filter')(data, {punch_card: filters['punch_card']}, true);
                }

                if (filters['is_stop']) {
                    data = $filter('filter')(data, {is_stop: !filters['is_stop']}, true);
                }
                if (filters['csmb']) {
                    data = $filter('filter')(data, {csmb: filters['csmb']}, true);
                }
                if (filters['csmb_dept_id']) {
                    data = $filter('filter')(data, {csmb_dept_id: filters['csmb_dept_id']}, function (actual, expected) {
                        return angular.equals(actual, +expected);
                    });
                }
                if (filters['name']) {
                    data = $filter('filter')(data, {name: filters['name']});
                }
            }
            data = params.sorting() ?
                $filter('orderBy')(data, params.orderBy()) : data;
            params.total(data.length);
            if (params.page() > Math.ceil(data.length / params.count())) {
                params.$params.page = params.page() - 1;
            }
            if (params.page() == 0) {
                params.$params.page = 1;
            }
            $defer.resolve(data.slice((params.page() - 1) * params.count(),
                params.page() * params.count()));
        }

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if (!$scope.cachedData) {
                    Dept.query(function (data) {
                        $scope.depts = data.depts;
                        $scope.types = data.types;
                        $scope.hisDepts = data.hisDepts;
                        types_col.data = F.getNgTableOpts(data.types);
                        var depts = [{id: '', title: '-'}];
                        angular.forEach(data.hisDepts, function (item) {
                            depts.push({id: item.id, title: item.desc});
                        });
                        depts_col.data = depts;
                        angular.forEach(data.depts, function (dept) {
                            dept.sorting = parseInt(dept.sorting);
                            dept.type_id = parseInt(dept.type_id);
                            dept.csmb_dept_id = parseInt(dept.csmb_dept_id);
                            dept.is_stop = dept.is_stop == 1;
                        });
                        $scope.cachedData = data.depts;
                        data = $filter('numInRange')(data.depts, $scope.numRangeFilter);
                        getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.cachedData;
                    data = $filter('numInRange')(data, $scope.numRangeFilter);
                    getTableData(data, $defer, params, $filter);
                }
            }
        });

        var checker = Table.loadMultiSelectedFn($scope);

        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
        };

        $scope.add = function () {
            dialogs.create('DeptDlg.html', 'DeptDlgCtrl', {types: $scope.types, hisDepts: $scope.hisDepts}, {
                size: 'md'
            }).result.then(function (dept) {
                Dept.save(dept).$promise.then(function (data) {
                    toaster.success('科室添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('科室添加失败!');
                });
            });
        };

        $scope.edit = function (dept) {
            dept.$edit = true;
            dept.$nameChanged = dept.name;
            dept.$typeChanged = dept.type;
            dept.$canAccountChanged = F.getItem(dept.can_account, $scope.yesNo);
            dept.$csmbChanged = F.getItem(dept.csmb, $scope.yesNo);
            dept.$csmbDeptChanged = dept.csmb_dept;
            dept.$sortingChanged = dept.sorting;
        };

        $scope.save = function (dept) {
            dept.$edit = false;
            if (dept.$nameChanged == "") {
                toaster.warning('科室名称不能为空!', '');
            } else if (dept.name != dept.$nameChanged || dept.can_account != dept.$canAccountChanged.id || dept.csmb != dept.$csmbChanged.id
                || (dept.$csmbDeptChanged && dept.csmb_dept_id != dept.$csmbDeptChanged.id) || dept.$csmbDeptChanged == null || dept.type_id != dept.$typeChanged.id || dept.sorting != dept.$sortingChanged) {
                var data = {};
                data['name'] = dept.$nameChanged;
                data['type_id'] = dept.$typeChanged.id;
                data['can_account'] = dept.$canAccountChanged.id;
                data['csmb'] = dept.$csmbChanged.id;
                data['csmb_dept_id'] = dept.$csmbDeptChanged ? dept.$csmbDeptChanged.id : null;
                data['sorting'] = dept.$sortingChanged;
                data['opt'] = 2;
                Dept.update({id: dept.id}, data).$promise.then(function (resp) {
                    toaster.success('科室修改成功!');
                    dept.name = dept.$nameChanged;
                    dept.type_id = dept.$typeChanged.id;
                    dept.type = dept.$typeChanged;
                    dept.can_account = dept.$canAccountChanged.id;
                    dept.csmb = dept.$csmbChanged.id;
                    dept.csmb_dept = dept.$csmbDeptChanged;
                    dept.sorting = parseInt(dept.$sortingChanged);
                    $scope.tableParams.reload();
                }, function (error) {
                    toaster.error('科室信息修改失败!');
                });
            }
        };

        $scope.delete = function (dept) {
            dialogs.confirm('删除科室记录', '确定要删除<strong>' + dept.name + '</strong>的科室吗?')
                .result.then(function () {
                Dept.delete({id: dept.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('科室记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该科室的成员,因此无法删除该科室!');
                            break;
                    }
                    $scope.tableReload();
                }, function () {
                    toaster.error('科室记录删除失败!');

                });
            });
        };

        $scope.setStop = function (m) {
            Dept.update({id: m.id}, {opt: 2, is_stop: !(m.is_stop == '1')})
                .$promise.then(function () {
                m.is_stop = !(m.is_stop == '1');
            })
        };

        $scope.batch = function (state) {
            var defer = $q.defer();
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }
            var deptIds = checker.getCheckedIds();
            Dept.update({id: '-'}, {opt: 3, state: state, dept_ids: deptIds}).$promise.then(function (data) {
                toaster.success('设置成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('设置失败!');
            });
        };
    }

    function DeptDlgCtrl($scope, $uibModalInstance, toaster, data, Dlg) {

        $scope.types = data.types;
        $scope.hisDepts = data.hisDepts;
        $scope.dept = {type: data.types[0], can_account: false, csmb: true, sorting: 100};

        $scope.ok = function (dept) {
            if ($scope.dept_form.$valid) {
                Dlg.confirm('<span class="text-danger">注意：新增科室请联系人事科和工会，确认是否需要将此科室纳入工会小组！！</span>', function () {
                    var params = {};
                    params['name'] = dept.name;
                    params['type_id'] = dept.type.id;
                    params['can_account'] = dept.can_account;
                    params['csmb'] = dept.csmb;
                    params['csmb_dept_id'] = dept.csmb_dept ? dept.csmb_dept.id : null;
                    params['sorting'] = dept.sorting;
                    $uibModalInstance.close(params);
                });

            } else {
                toaster.warning('表单中有错误!');
                $scope.dept_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})
();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptLeaderSwitchCtrl', DeptLeaderSwitchCtrl)
        .controller('DeptLeaderSwitchDlgCtrl', DeptLeaderSwitchDlgCtrl)

    ;

    function DeptLeaderSwitchCtrl($scope, DeptSwitchLeaderRecord, Table, Dlg) {
        var vm = $scope;
        vm.apply = apply;
        vm.withdraw = withdraw;

        init();

        function init() {
            var options = {
                service: DeptSwitchLeaderRecord,
                params: {op: 'default'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "selector", title: "分管院领导", filter: {selector: "text"}},
                    {field: "replacer", title: "替换人", filter: {replacer: "text"}},
                    {field: "user", title: "添加人", filter: {name: "text"}},
                    {field: "created_at", title: "添加时间", filter: {created_at: "date_range"}},
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                });
            });
        }

        function apply() {
            Dlg.show({
                template: 'DeptLeaderSwitchDlg.html',
                ctrl: 'DeptLeaderSwitchDlgCtrl',
                data: {}
            }).then(function () {
                vm.tableReload();
            });
        }

        function withdraw(m) {
            Dlg.confirm('确认要撤回该记录吗?', function () {
                DeptSwitchLeaderRecord.update({id: m.id, op: 'withdraw'}, {}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                });
            });
        }
    }


    function DeptLeaderSwitchDlgCtrl($scope, DeptSwitchLeaderRecord, $uibModalInstance, User, FormHelper, Dlg) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            User.query({opt: 4/*USER.INDEX_ROLE_USERS*/, role_id: 3/*分管院领导*/}, function (resp) {
                vm.leaders = resp.items;
            });
            vm.m = {
                selector: null,
                replacer: null,
                change_hospital_leader: true,
                change_doc_step: true,
            };
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    selector_id: m.selector.id,
                    replacer_id: m.replacer.id,
                    change_hospital_leader: m.change_hospital_leader ? 1 : 0,
                    change_doc_step: m.change_doc_step ? 1 : 0,
                    note: m.note
                };

                DeptSwitchLeaderRecord.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                });
            });
        }
    }

})();

angular.module('c.c')
    .controller('TakeoutPlaceCtrl', function ($scope, dialogs, toaster, TakeoutPlace, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.dept = dept;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: TakeoutPlace,
                params: {opt: 1/*TAKEOUTPLACE.INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('TakeoutPlaceDlg.html', 'TakeoutPlaceDlgCtrl', {}, {size: 'md'})
                .result.then(function (pa) {
                TakeoutPlace.save(pa).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit(m) {
            dialogs.create('TakeoutPlaceDlg.html', 'TakeoutPlaceDlgCtrl', {
                id: m.id
            }, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //TAKEOUTPLACE.EDIT_SAVE
                TakeoutPlace.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function dept(m) {
            dialogs.create('TakeoutPlaceDeptsDlg.html', 'TakeoutPlaceDeptsDlgCtrl', {place: m}, {

                size: 'lg'
            });
        }

        function remove(m) {
            dialogs.confirm('删除送餐地点', '确定要删除<strong>' + m.name + '</strong>送餐地点吗?')
                .result.then(function () {
                TakeoutPlace.delete({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功');
                            break;
                        case 1:
                            toaster.warning('存在引用数据,删除失败!');
                            break;
                    }
                    vm.tableReload();
                });
            });
        }
    });

angular.module('c.c').controller('TakeoutPlaceDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, TakeoutPlace, data) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                TakeoutPlace.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    is_stop: m.is_stop ? '1' : '0'
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });

angular.module('c.c').controller('TakeoutPlaceDeptsDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, F, Table,
              DeptTakeoutPlace, TakeoutPlace, DeptType, data) {
        var vm = $scope;
        vm.place = data.place;
        vm.add = add;
        vm.remove = remove;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.place.id);


        function init(id) {
            var options = {
                service: DeptTakeoutPlace,
                params: {opt: 1/*DEPTTAKEOUTPLACE.INDEX_ALL*/, place_id: id, need_depts: true},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "科室名称", filter: {name: "text"}},
                    {field: "type", title: "类别", filter: {type: "select"}}
                ]
            };

            var typeCol = options.cols[1];
            DeptType.query(function (resp) {
                var types = resp.items;
                typeCol.data = F.getNgTableOpts(types);
                vm.types = types;
            });
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('TakeoutPlaceDeptDlg.html', 'TakeoutPlaceDeptDlgCtrl', {existDepts: vm.deptIds}, {

                size: 'md'
            }).result.then(function (pa) {
                TakeoutPlace.addDepts({id: vm.place.id}, pa).$promise.then(function () {
                    toaster.success('添加成功');
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除员工', '确定要删除<strong>' + m.name + '的送餐地点' +
                vm.place.name + '</strong>吗?'
            ).result.then(function () {
                TakeoutPlace.deleteDept({id: vm.place.id}, {dept_id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    });

angular.module('c.c').controller('TakeoutPlaceDeptDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        var vm = $scope;
        vm.existDepts = data.existDepts;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            vm.m = {depts: []};
        }

        function ok(m) {
            if (m.depts && m.depts.length == 0) {
                toaster.warning('请选择科室');
            } else {
                var pa = {};
                if (m.depts) {
                    var deptIds = [];
                    angular.forEach(m.depts, function (d) {
                        deptIds.push(d.id);
                    });
                    pa.depts = deptIds;
                }
                $uibModalInstance.close(pa);
            }
        }
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptTypeManageCtrl', DeptTypeManageCtrl)
        .controller('DeptTypeDlgCtrl', DeptTypeDlgCtrl);

    function DeptTypeManageCtrl($scope, Dlg, DeptType, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: DeptType,
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "sorting", title: "排序", filter: {sorting: "text"}},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            Dlg.show({
                template: 'DeptTypeDlg.html',
                ctrl: 'DeptTypeDlgCtrl',
                data: {},
            }).then(function () {
                vm.tableReload();
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'DeptTypeDlg.html',
                ctrl: 'DeptTypeDlgCtrl',
                data: {
                    id: m.id
                },
            }).then(function () {
                vm.tableReload();
            });
        }


        function setStop(m) {
            DeptType.update({id: m.id}, {opt: 2, is_stop: !(m.is_stop)})
                .$promise.then(function () {
                m.is_stop = !(m.is_stop);
            }).finally(function () {
                vm.tableReload();
            })
        }

        function remove(m) {
            Dlg.confirm('删除科室类型', '确定要删除<strong>' + m.name + '</strong>科室类型吗?')
                .result.then(function () {
                DeptType.delete({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('删除成功');
                            break;
                        case 1:
                            Dlg.w('存在引用数据,删除失败!');
                            break;
                    }
                    vm.tableReload();
                });
            });
        }
    }

    function DeptTypeDlgCtrl($scope, $uibModalInstance, DeptType, data, Dlg, FormHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);

        function init(id) {
            if (id) {
                DeptType.get({id: id}, function (resp) {
                    vm.m = resp;
                });
            } else {
                vm.m = {sorting : 100};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    sorting: m.sorting,
                };
                //
                var promise;

                if (m.id) {
                    promise = DeptType.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = DeptType.save(pa).$promise;
                }
                promise.then(function () {
                    Dlg.s('操作成功');
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})
();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('SysDeptWardCtrl', SysDeptWardCtrl)
        .controller('SysDeptWardDlgCtrl', SysDeptWardDlgCtrl)
    ;

    /** @ngInject */
    function SysDeptWardCtrl($scope, DeptWard, Dlg, Table, Api) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.disable = disable;
        vm.ward = ward;
        vm.remove = remove;

        init();


        function init() {
            var options = {
                service: DeptWard,
                params: {op: 'sys'},
                optColWidth: Table._3_BTN,
                optInFront: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "type", title: "类型", filter: {type: "text"}},
                    {field: "leader", title: "负责人", filter: {leader: "text"}},
                    {field: "sorting", title: "排序", filter: {sorting: "text"}}
                ]
            };
            Table.load(vm, options);
        }

        function addEdit(m) {
            var pa = {};
            if (m) {
                pa.id = m.id;
            }
            Dlg.show({
                template: 'DeptWardDlg.html',
                ctrl: 'SysDeptWardDlgCtrl',
                data: pa
            }).then(function () {
                vm.tableReload();
            });
        }

        function disable(m) {
            Api.setDisable(DeptWard, m);
        }

        function ward(m) {
            Dlg.show({
                template: 'pages/sys/dept/WardDeptDlg.html',
                ctrl: 'WardDeptDlgCtrl',
                size: 'lg',
                data: {m: m}
            });
        }

        function remove(m) {
            Dlg.confirm('确定删除该病区吗？', function () {
                DeptWard.delete({id: m.id}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                });
            }, '删除');
        }
    }

    /** @ngInject */
    function SysDeptWardDlgCtrl(DeptType, DeptWard, Dlg, $uibModalInstance, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            DeptType.query({}, function (resp) {
                vm.types = resp.items;
                if (id) {
                    DeptWard.get({id: id}, function (resp) {
                        var c = resp;
                        vm.m = c;
                    })
                } else {
                    vm.m = {
                        type: vm.types[0],
                        sorting: 10
                    };
                }
            })
        }

        function ok(m) {
            return Dlg.addEditOk(vm, DeptWard, function () {
                var pa = {
                    name: m.name,
                    type_id: m.type.id,
                    leader_id: m.leader.id,
                    sorting: m.sorting
                };
                return pa;
            });
        }
    }

})();



angular.module('c.c')
    .controller('NonRechargeCtrl', function ($scope, dialogs, toaster, NonRecharge, Table) {
        var vm = $scope;
        vm.add = add;
        vm.delete = remove;

        init();

        function init() {
            var options = {
                service: NonRecharge,
                params: {},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                hideFilter: true,
                cols: [
                    {field: "user", title: "姓名"},
                    {field: "dept", title: "科室"},
                    {field: "remark", title: "备注"}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('NonRechargeDlg.html', 'NonRechargeDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                    NonRecharge.save(m).$promise.then(function () {
                        toaster.success('保存成功');
                        vm.tableReload();
                    });
                });
        }


        function remove(m) {
            dialogs.confirm('删除人员', '确定重新给此用户充值吗？')
                .result.then(function () {
                    NonRecharge.delete({id: m.id}).$promise.then(function (resp) {
                        toaster.success('删除成功');
                        vm.tableReload();
                    });
                });
        }

    });

angular.module('c.c').controller('NonRechargeDlgCtrl',
    function ($scope, $uibModalInstance, toaster) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(m) {
            if (!m.user) {
                toaster.warning('对象必选!');
            } else
                var pa = {
                    user_id: m.user.id,
                    remark: m.remark
                };
            $uibModalInstance.close(pa);

        }
    });

angular.module('c.c')
    .controller('OrderCtrl', function ($scope, $filter, F, Table, Order, $ocLazyLoad, dialogs, toaster) {
        var vm = $scope;
        vm.add = add;
        vm.qrCode = qrCode;
        vm.edit = edit;
        vm.remove = remove;
        vm.setStop = setStop;
        vm.stirFryShow = stirFryShow;
        vm.stir_fry = false;
        vm.setTop = setTop;
        vm.hidden = hidden;

        init();

        function init() {
            var options = {
                service: Order,
                params: {opt: 1/*ORDER.INDEX_ALL*/},
                filter: {stir_fry: 0},
                sorting: {created_at: 'desc'},
                optColWidth: Table._6_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "store", title: "商家", filter: {store: 'text'}},
                    {
                        field: "type",
                        title: "供应时间",
                        filter: {type: "select"},
                        data: F.getNgTableOpts(F.get('orderTypes'))
                    },
                    {field: "self_paid", title: "单价"},
                    {field: "subsidy", title: "补贴"},
                    {field: 'intro', title: '更多'}
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = F.getItem(item.type, F.get('orderTypes'));
                    item.limit_mode = F.getItem(item.limit_mode, F.get('limitModes'));
                    if (item.limit_mode.id == '3'/*不限时间*/) {
                        item.time = '';
                    } else {
                        item.time = item.start.substr(0, 5) + '~' + item.end.substr(0, 5);
                    }
                })
            });

            vm.clearFilters = function () {
                vm.tableParams.filter({stir_fry: vm.stir_fry ? 1 : 0});
            };
        }

        function add() {
            dialogs.create('OrderDlg.html', 'OrderDlgCtrl', {allEdit: true}, {size: 'md'})
                .result.then(function (pa) {
                Order.save(pa).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function qrCode(m) {
            $ocLazyLoad.load(['qrCode']).then(function () {
                dialogs.create('templates/meal/order_qrcode.html', 'OrderQrCodeCtrl', {order: m}, {

                    size: 'md'
                });
            });
        }

        function edit(m, allEdit) {
            dialogs.create(allEdit ? 'OrderDlg.html' : 'Order2Dlg.html', 'OrderDlgCtrl', {
                id: m.id, allEdit: allEdit
            }, {size: 'md'}).result.then(function (pa) {
                Order.update({id: m.id, opt: 1 /*ORDER.EDIT_SAVE*/}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                })
            });
        }

        function remove(m) {
            dialogs.confirm('删除商品', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                Order.delete({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功');
                            vm.tableReload();
                            break;
                        case 1:
                            toaster.warning('无法删除,因有订单或消费记录关联到该商品');
                            break;
                    }
                });
            });
        }

        function setStop(m) {
            Order.update({id: m.id}, {opt: 2 /*ORDER.EDIT_STOP*/, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        function stirFryShow() {
            vm.tableParams.filter({stir_fry: vm.stir_fry ? 1 : 0});
        }

        function setTop(m) {
            Order.update({id: m.id}, {opt: 6 /*ORDER.EDIT_TOP*/, top: !(m.top == '1')})
                .$promise.then(function (resp) {
                m.top = resp.top;
            });
        }

        function hidden(m) {
            Order.update({id: m.id}, {opt: 7 /*ORDER.EDIT_HIDDEN*/, hidden: !(m.hidden == '1')})
                .$promise.then(function (resp) {
                m.hidden = resp.hidden;
            });
        }
    });

angular.module('c.c').controller('OrderDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, Order, data, Store, dialogs, $filter, uibDateParser) {
        var vm = $scope;
        vm.types = F.get('orderTypes');
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.addOrderImg = addOrderImg;
        vm.cancel = $uibModalInstance.dismiss;
        vm.sysEdit = !data.allEdit;
        vm.special = special;

        loadModel(data.id);

        function loadModel(id) {
            Store.query({opt: 2 /* STORE.INDEX_OPTIONS */}, function (resp) {
                vm.stores = resp.items;
            });
            if (id) {
                Order.get({id: id}, function (resp) {
                    var m = resp;
                    if (m.result == 0) {
                        var order = m.order;
                        order.special = order.special == '1';
                        order.has_price = order.has_price == '1';
                        order.is_delivery = order.is_delivery == '1';
                        order.is_working_meal_allowed = order.is_working_meal_allowed == '1';
                        order.is_direct_mode_allowed = order.is_direct_mode_allowed == '1';
                        order.type = F.getItem(order.type, vm.types);
                        vm.m = order;
                    } else {
                        toaster.warning(m.msg);
                    }
                });
            } else {
                vm.m = {
                    has_price: true,
                    special: false
                };
            }
        }

        function special(m) {
            if (m.special) {
                m.type = vm.types[3];
                m.has_price = true;
            }
        }

        function ok(m) {
            if (angular.isUndefined(m.type) || angular.isUndefined(m.store)) {
                toaster.warning('请填入商品店家以及类型');
            } else if (m.type.id == '1' && m.is_working_meal_allowed) {
                toaster.warning('早餐不能作为手术餐');
            } else if (m.special && !m.has_price) {
                toaster.warning('小炒必须定价');
            } else if (vm.Form.$valid) {
                var pa;
                if (vm.sysEdit) {
                    pa = {
                        is_direct_mode_allowed: m.is_direct_mode_allowed ? 1 : 0,
                        subsidy: m.subsidy
                    };
                } else {
                    pa = {
                        name: m.name,
                        img: m.img,
                        store_id: m.store.id,
                        type: m.type.id,
                        special: m.special ? 1 : 0,
                        has_price: m.has_price ? 1 : 0,
                        is_delivery: m.is_delivery ? 1 : 0,
                        is_direct_mode_allowed: m.is_direct_mode_allowed ? 1 : 0,
                        intro: m.intro
                    };
                    if (m.has_price) {
                        pa.self_paid = m.self_paid;
                        pa.subsidy = m.subsidy;
                    }
                    if (pa.type != '4') {
                        pa.daily_supply = m.daily_supply;
                        pa.is_working_meal_allowed = m.is_working_meal_allowed ? 1 : 0;
                    } else {
                        //pa.subsidy = 0;
                        pa.is_working_meal_allowed = false;
                    }
                }
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }

        function addOrderImg(order) {
            if (order.store) {
                dialogs.create('templates/order/order_img_dlg.html',
                    'OrderImgDlgCtrl', {store: order.store}, {

                        size: 'md'
                    }
                ).result.then(function (url) {
                    order.img = url;
                });
            } else {
                toaster.warning('请填入商家');
            }
        }
    });


angular.module('c.c')
    .controller('DeliveryPlaceCtrl', function ($scope, dialogs, toaster, DeliveryPlace, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.admin = admin;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: DeliveryPlace,
                params: {opt: 1/*DELIVERYPLACE.INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('DeliveryPlaceDlg.html', 'DeliveryPlaceDlgCtrl', {}, { size: 'md'})
                .result.then(function (pa) {
                    DeliveryPlace.save(pa).$promise.then(function () {
                        toaster.success('保存成功');
                        vm.tableReload();
                    });
                });
        }

        function edit(m) {
            dialogs.create('DeliveryPlaceDlg.html', 'DeliveryPlaceDlgCtrl', {
                id: m.id
            }, { size: 'md'})
                .result.then(function (pa) {
                    pa.opt = 1; //DELIVERYPLACE.EDIT_SAVE
                    DeliveryPlace.update({id: m.id}, pa).$promise.then(function () {
                        toaster.success('修改成功');
                        vm.tableReload();
                    });
                });
        }

        function admin(m) {
            dialogs.create('templates/meal/place_admin.html', 'DeliveryPlaceAdminsDlgCtrl', {
                place: m
            }, {

                size: 'lg'
            });
        }

        function remove(m) {
            dialogs.confirm('删除送餐地点', '确定要删除<strong>' + m.name + '</strong>送餐地点吗?')
                .result.then(function () {
                    DeliveryPlace.delete({id: m.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('删除成功');
                                break;
                            case 1:
                                toaster.warning('存在引用数据,删除失败!');
                                break;
                        }
                        vm.tableReload();
                    });
                });
        }
    });

angular.module('c.c').controller('DeliveryPlaceDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, DeliveryPlace, data) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                DeliveryPlace.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    is_stop: m.is_stop ? '1' : '0'
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });
angular.module('c.c')
    .controller('RechargeItemCtrl', function ($scope, dialogs, toaster, RechargeItem, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.dept = dept;
        vm.remove = remove;
        vm.testRecharge = testRecharge;

        init();


        function init() {
            var options = {
                service: RechargeItem,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "money", title: "金额"},
                    {
                        field: "is_by_day",
                        title: "发放方式",
                        filter: {is_by_day: "select"},
                        data: F.getNgTableOpts(F.get('byDayMonth'))
                    },
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }

        function dept(m) {
            dialogs.create('RechargeItemDeptsDlg.html', 'RechargeItemDeptsDlgCtrl', {item: m}, {

                size: 'lg'
            });
        }

        function add() {
            dialogs.create('RechargeItemDlg.html', 'RechargeItemDlgCtrl', {}, { size: 'md'})
                .result.then(function (m) {
                RechargeItem.save(m).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit(m) {
            dialogs.create('RechargeItemDlg.html', 'RechargeItemDlgCtrl', {id: m.id}, { size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                RechargeItem.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                RechargeItem.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }

        function testRecharge(is_day_recharge) {
            /*测试每日充值，暂时放在index里，后期上线后再删除掉*/
            RechargeItem.query({
                opt: 3,
                is_day_recharge: is_day_recharge ? 1 : 0
            }/*INDEX_TEST*/).$promise.then(function (resp) {
                if (resp.result == 0) {
                    toaster.success(resp.msg);
                    vm.tableReload();
                }
            });
        }

    });

angular.module('c.c').controller('RechargeItemDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, RechargeItem, data) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                RechargeItem.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_by_day = m.is_by_day == '1';
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false, is_by_day: true};
            }
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    money: m.money,
                    is_stop: m.is_stop ? '1' : '0',
                    is_by_day: m.is_by_day ? '1' : '0'
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });

angular.module('c.c').controller('RechargeItemDeptsDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, F, Table, RechargeItem, RechargeItemDept, data) {
        var vm = $scope;
        vm.item = data.item;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.item.id);


        function init(id) {
            var yesNoOpts = F.getNgTableOpts(F.get('YesNo'));
            var options = {
                service: RechargeItemDept,
                params: {opt: 1/*INDEX_ALL*/, item_id: id},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "is_cost", title: "计入科室成本", filter: {is_cost: "select"}, data: yesNoOpts},
                    {field: "is_stop", title: "是否停用", filter: {is_stop: "select"}, data: yesNoOpts}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('RechargeItemDeptDlg.html', 'RechargeItemDeptDlgCtrl', {}, {

                size: 'md'
            }).result.then(function (pa) {
                RechargeItem.addDepts({id: vm.item.id}, pa).$promise.then(function () {
                    toaster.success('添加成功');
                    vm.tableReload();
                });
            });
        }

        function edit(m) {
            dialogs.create('RechargeItemDeptDlg.html', 'RechargeItemDeptDlgCtrl', {
                    id: m.id
                }, { size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                RechargeItemDept.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除条目科室', '确定要删除<strong>' + m.dept.name + '的' +
                vm.item.name + '</strong>吗?'
            ).result.then(function () {
                RechargeItemDept.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    });

angular.module('c.c').controller('RechargeItemDeptDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, RechargeItemDept, data) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                RechargeItemDept.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    m.is_cost = m.is_cost == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false, is_cost: false, depts: []};
            }
        }

        function ok(m) {
            if (m.depts && m.depts.length == 0) {
                toaster.warning('请设置条目科室');
            } else {
                var pa = {is_stop: m.is_stop ? '1' : '0', is_cost: m.is_cost ? '1' : '0'};
                if (m.depts) {
                    var deptIds = [];
                    angular.forEach(m.depts, function (d) {
                        deptIds.push(d.id);
                    });
                    pa.depts = deptIds;
                }
                $uibModalInstance.close(pa);
            }
        }
    });

angular.module('c.c')
    .controller('StoreCtrl', function ($scope, dialogs, toaster, Store, Table) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.user = user;
        vm.remove = remove;
        vm.setStirFry = setStirFry;

        init();

        function init() {
            var options = {
                service: Store,
                params: {opt: 1/*STORE.INDEX_ALL*/},
                sorting: {is_stop: 'asc'},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "联系电话", filter: {phone: "text"}},
                    {field: "admin", title: "管理员", filter: {admin: "text"}},
                    {field: "note", title: "备注", filter: {note: "text"}}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('StoreDlg.html', 'StoreDlgCtrl', {}, {size: 'md'})
                .result.then(function (pa) {
                Store.save(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('保存成功');
                            vm.tableReload();
                            break;
                        case 1:
                            toaster.warning('所选管理员属于其他店铺员工');
                            break;
                    }
                });
            });
        }

        function edit(m) {
            dialogs.create('StoreDlg.html', 'StoreDlgCtrl', {
                    id: m.id
                }, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //STORE.EDIT_SAVE
                Store.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function user(m) {
            dialogs.create('StoreUsersDlg.html', 'StoreUsersDlgCtrl', {store: m}, {
                size: 'lg'
            });
        }

        function remove(m) {
            dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                Store.delete({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功');
                            break;
                        case 1:
                            toaster.warning('存在引用数据,删除失败!');
                            break;
                    }
                    vm.tableReload();
                });
            });
        }

        function setStirFry(m) {
            dialogs.create('StoreSetStirFryDlg.html', 'StoreSetStirFryDlgCtrl', {
                    id: m.id
                }, {size: 'md'}, 'vm')
                .result.then(function () {
                vm.tableReload();
            });
        }
    });

angular.module('c.c').controller('StoreDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, Store, User, data) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                Store.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
                User.query({opt: 15/*USER.INDEX_USER_STORE_OPTIONS*/, store_id: id}, function (resp) {
                    $scope.users = resp.users;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok(m) {
            if (!m.admin) {
                toaster.warning('请设置管理员');
            } else if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    admin_id: m.admin.id,
                    is_stop: m.is_stop ? '1' : '0',
                    note: m.note
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });

angular.module('c.c').controller('StoreSetStirFryDlgCtrl',
    function ($scope, $uibModalInstance, Store, Order, data, Dlg, ArrayHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                Order.query({opt: 5/*ORDER.INDEX_ORDERS_FOR_STIR_FRY*/, store_id: id}, function (resp) {
                    vm.noonOrders = resp.noonOrders;
                    vm.nightOrders = resp.nightOrders;
                    Store.getStirFry({id: id}, function (resp) {
                        vm.m = {id: id};
                        if (resp.items.length > 0) {
                            angular.forEach(resp.items, function (item) {
                                if (item.type == 2) {
                                    vm.m.noon = ArrayHelper.getItem(item.order_id, vm.noonOrders);
                                } else {
                                    vm.m.night = ArrayHelper.getItem(item.order_id, vm.nightOrders);
                                }

                            });
                        }
                    });
                });
            }
        }

        function ok(m, form) {
            if (form.$valid) {
                var items = [];
                items.push({order_id: m.noon.id, store_id: m.id, type: 2});
                items.push({order_id: m.night.id, store_id: m.id, type: 3});
                var pa = {
                    items: items
                };
                Store.setStirFry({id: m.id}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                });
            } else {
                Dlg.w('表单中有错误!');
                form.$submitted = true;
            }
        }
    });

angular.module('c.c').controller('StoreUsersDlgCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, Table, F, UserStore, Store, data) {
        var vm = $scope;
        vm.store = data.store;
        vm.add = add;
        vm.remove = remove;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.store.id);


        function init(id) {
            var options = {
                service: UserStore,
                params: {opt: 1/*USERSTORE.INDEX_ALL*/, store_id: id, need_users: true},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "工号", filter: {username: "text"}},
                    {field: "phone", title: "联系电话", filter: {phone: "text"}}
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.userIds = [];
                angular.forEach(resp.users, function (u) {
                    vm.userIds.push({id: u.id});
                });
            });
        }

        function add() {
            dialogs.create('StoreUserDlg.html', 'StoreUserDlgCtrl', {existMembers: vm.userIds}, {

                size: 'md'
            }).result.then(function (pa) {
                Store.addUsers({id: vm.store.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('添加成功');
                            vm.tableReload();
                            break;
                        case 1:
                            var names = [];
                            angular.forEach(resp.users, function (u) {
                                names.push(u.name)
                            });
                            toaster.warning(names + '属于其他店铺员工');
                            break;
                    }
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除员工', '确定要删除<strong>' + vm.store.name + '的' +
                m.name + '</strong>吗?'
            ).result.then(function () {
                Store.deleteUser({id: vm.store.id}, {user_id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功');
                            break;
                        case 1:
                            toaster.warning('不能删除管理员');
                            break;
                    }
                    vm.tableReload();
                });
            });
        }
    });

angular.module('c.c').controller('StoreUserDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        var vm = $scope;
        vm.existMembers = data.existMembers;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            vm.m = {users: []};
        }

        function ok(m) {
            if (m.users && m.users.length == 0) {
                toaster.warning('请选择员工');
            } else {
                var pa = {};
                if (m.users) {
                    var userIds = [];
                    angular.forEach(m.users, function (u) {
                        userIds.push(u.id);
                    });
                    pa.users = userIds;
                }
                $uibModalInstance.close(pa);
            }
        }
    });
angular.module('c.c')
    .controller('TempRechargeCtrl', function ($scope, dialogs, toaster, Recharge, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        //vm.remove = remove;

        init();


        function init() {
            var options = {
                service: Recharge,
                params: {opt: 1/*INDEX_ALL*/, is_temp: '1'},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "money", title: "金额"},
                    {
                        field: "is_cost",
                        title: "计入科室成本",
                        filter: {is_cost: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    },
                    {field: "created_at", title: "充值时间", filter: {created_at: "date_range"}},
                    {field: "handler", title: "充值人", filter: {handler: "text"}},
                    {field: "note", title: "充值理由"}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            dialogs.create('TempRechargeDlg.html', 'TempRechargeDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                    Recharge.save(m).$promise.then(function () {
                        toaster.success('保存成功');
                        vm.tableReload();
                    });
                });
        }

        function edit(m) {
            dialogs.create('TempRechargeDlg.html', 'TempRechargeDlgCtrl', {id: m.id}, {size: 'md'})
                .result.then(function (pa) {
                    pa.opt = 1; //EDIT_SAVE
                    Recharge.update({id: m.id}, pa).$promise.then(function () {
                        toaster.success('修改成功');
                        vm.tableReload();
                    });
                });
        }

        //function remove(m) {
        //    dialogs.confirm('撤销充值', '只有3小时内的临时充值能成功撤销,确定要撤销吗?')
        //        .result.then(function () {
        //            Recharge.delete({id: m.id}).$promise.then(function (resp) {
        //                switch (resp.result) {
        //                    case 1:
        //                        toaster.warning('充值操作已超过3小时,无法撤销');
        //                        break;
        //                    case 0:
        //                        toaster.success('删除成功');
        //                        vm.tableReload();
        //                        break;
        //                }
        //            });
        //        });
        //}

    });

angular.module('c.c').controller('TempRechargeDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, Recharge, data) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                Recharge.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_cost = m.is_cost == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false, users: []};
            }
        }

        function ok(m) {
            if (m.users && m.users.length == 0) {
                toaster.warning('充值对象必选!');
            } else if (m.money > 1000) {
                toaster.warning('单次充值不能超过1000!');
            } else if (vm.Form.$valid) {
                var pa = {
                    money: m.money,
                    is_cost: m.is_cost ? '1' : '0',
                    is_temp: true,
                    note: m.note
                };
                if (m.users) {
                    var userIds = [];
                    angular.forEach(m.users, function (u) {
                        userIds.push(u.id);
                    });
                    pa.users = userIds;
                }
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });

angular.module('c.c')
    .controller('TempRechargeItemCtrl', function ($scope, dialogs, toaster, TempRechargeItem, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();


        function init() {
            var options = {
                service: TempRechargeItem,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "money", title: "金额"},
                    {
                        field: "is_cost",
                        title: "计入科室成本",
                        filter: {is_cost: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    },
                    {field: "time", title: "生效时间"},
                    {field: "created_at", title: "添加时间", filter: {created_at: "date_range"}},
                    {field: "handler", title: "添加人", filter: {handler: "text"}},
                    {field: "note", title: "充值理由"}
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (m) {
                    m.time = m.start.substr(0, 10) + '~' + m.end.substr(0, 10);
                });
            })
        }

        function add() {
            dialogs.create('TempRechargeItemDlg.html', 'TempRechargeItemDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                TempRechargeItem.save(m).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit(m) {
            dialogs.create('TempRechargeItemDlg.html', 'TempRechargeItemDlgCtrl', {id: m.id}, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                TempRechargeItem.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            TempRechargeItem.delete({id: m.id}).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('删除成功');
                        vm.tableReload();
                        break;
                }
            });
        }

    });

angular.module('c.c').controller('TempRechargeItemDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, TempRechargeItem, data, DateHelper) {
        var vm = $scope;
        vm.yesNo = F.get('yesNo');
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                TempRechargeItem.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_cost = m.is_cost == '1';
                    m.start = DateHelper.str2Date(m.start);
                    m.end = DateHelper.str2Date(m.end);
                    console.log(m);
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false, users: []};
            }
        }

        function ok(m) {
            if (m.users && m.users.length == 0) {
                toaster.warning('充值对象必选!');
            } else if (m.money > 1000) {
                toaster.warning('单次充值不能超过1000!');
            } else if (!m.start || !m.end) {
                toaster.warning('开始时间和结束时间必填!');
            } else if (m.start > m.end) {
                toaster.warning('开始时间不能大于结束时间!');
            } else if (vm.Form.$valid) {
                var pa = {
                    money: m.money,
                    is_cost: m.is_cost ? '1' : '0',
                    is_temp: true,
                    note: m.note,
                    start: DateHelper.date2Str(m.start),
                    end: DateHelper.date2Str(m.end),
                };
                var userIds = [];
                angular.forEach(m.users, function (u) {
                    userIds.push(u.id);
                });
                pa.users = userIds;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    });

angular.module('c.c')
    .controller('MeetingDeviceCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams,
                                             MeetingDevice,F) {

        $scope.dev_types = F.get('device_types');
        var dev_typesOpts = F.getNgTableOpts( $scope.dev_types);


        $scope.cols = [
            {title: '设备名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '设备类型',  filter: {type: 'select'},  data: dev_typesOpts, field: 'type', show: true}, //6
            {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true}, //6
            {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name',  show: true}, //6
            {title: '备注', field: 'remark',  width: '30%',show: true} //6
        ];

        $scope.optColWidth = 67;
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                MeetingDevice.query(url, function (resp) {
                    angular.forEach(resp.devices, function (d) {
                        d.type = F.getItem(d.type, $scope.dev_types);
                    });
                    params.total(resp.total);
                    $defer.resolve(resp.devices);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };
        $scope.add = function () {
            dialogs.create('MeetingDeviceDlg.html', 'MeetingDeviceDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (d) {
                MeetingDevice.save(d).$promise.then(function (data) {
                    toaster.success('设备信息添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设备信息添加失败!');
                });
            });
        };

        $scope.edit = function (d) {
            dialogs.create('MeetingDeviceDlg.html', 'MeetingDeviceDlgCtrl', {device: d}, {
                 size: 'md'
            }).result.then(function (pa) {
                MeetingDevice.update({id: d.id}, pa).$promise.then(function (data) {
                    toaster.success('设备信息修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设备信息修改失败!');
                });
            });
        };

        $scope.delete = function (d) {
            dialogs.confirm('删除设备信息', '确定要删除<strong>' + d.name + '</strong>相关信息吗?')
                .result.then(function () {
                MeetingDevice.delete({id: d.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('设备信息删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在引用该设备信息的内容,因此无法删除该信息!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('设备信息删除失败!');
                });
            });
        };
    });

angular.module('c.c').controller('MeetingDeviceDlgCtrl', function ($scope, $uibModalInstance,
                                                                                 toaster, Dept, F, data) {

    $scope.dev_types = F.get('device_types');
    if (data.device) {
        $scope.$edit = true;
        var d = data.device;
        $scope.d = {
            name: d.name,
            type: d.type,
            remark: d.remark,
            admin: {id: d.admin_id, name: d.admin_name},
            dept: {id: d.dept_id, name: d.dept_name}
        };

    } else {
        $scope.d = {type:  $scope.dev_types[0]};
    }

    Dept.query({opt: 4}, function (resp) {
        $scope.depts = resp.depts;
        if (!$scope.d.dept && $scope.depts && $scope.depts.length > 0) {
            $scope.d.dept = $scope.depts[0];
        }
    });

    $scope.ok = function (d) {
        if (!d.admin) {
            toaster.warning('管理员不能为空!');
        } else if ($scope.d_form.$valid) {
            var pa = {};
            pa['name'] = d.name;
            pa['type'] = d.type.id;
            pa['admin_id'] = d.admin.id;
            pa['remark'] = d.remark;
            pa['dept_id'] = d.dept.id;
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('表单中有错误!');
            $scope.d_form.submitted = true;
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});



angular.module('c.c')
    .controller('MeetingRoomCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams,
                                             MeetingRoom, F) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesOrNo2'));
        $scope.yesNo = F.get('yesOrNo2');

        $scope.cols = [
            {title: '会议室名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '排列顺序', sortable: 'sorting', filter: {sorting: 'number_range'}, field: 'sorting', show: true}, //6
            {title: '容纳人数', sortable: 'capacity', filter: {capacity: 'number_range'}, field: 'capacity', show: true}, //6
            {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true}, //6
            {title: '投影仪', filter: {has_projector: 'select'}, data: yesNoOpts, field: 'has_projector', show: true}, //6
            {title: '音响', filter: {has_audio: 'select'}, data: yesNoOpts, field: 'has_audio', show: true}, //6
            {title: '电脑', filter: {has_computer: 'select'}, data: yesNoOpts, field: 'has_computer', show: true}, //6
            {title: '信标', filter: {ibeacon_name: 'text'}, field: 'ibeacon_name', show: true}, //6
            {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name', show: true}, //6
            {title: '是否停用', field: 'is_stop', show: true}, //6
            {title: '备注', field: 'remark', width: '61', show: true} //6
        ];

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.optColWidth = 67;
        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                if ($scope.numRangeFilter.capacity != null) {
                    url['startCap'] = $scope.numRangeFilter.capacity.start;
                    url['endCap'] = $scope.numRangeFilter.capacity.end;
                }
                if ($scope.numRangeFilter.sorting != null) {
                    url['startSorting'] = $scope.numRangeFilter.sorting.start;
                    url['endSorting'] = $scope.numRangeFilter.sorting.end;
                }
                MeetingRoom.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.rooms);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
        };
        $scope.add = function () {
            dialogs.create('MeetingRoomDlg.html', 'MeetingRoomDlgCtrl', {}, {
                size: 'md'
            }).result.then(function (r) {
                MeetingRoom.save(r).$promise.then(function (data) {
                    toaster.success('会议室信息添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('会议室信息添加失败!');
                });
            });
        };

        $scope.edit = function (r) {
            dialogs.create('MeetingRoomDlg.html', 'MeetingRoomDlgCtrl', {room: r}, {
                size: 'md'
            }).result.then(function (pa) {
                MeetingRoom.update({id: r.id}, pa).$promise.then(function (data) {
                    toaster.success('会议室信息修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('会议室信息修改失败!');
                });
            });
        };

        $scope.delete = function (r) {
            dialogs.confirm('删除会议室信息', '确定要删除<strong>' + r.name + '</strong>相关信息吗?')
                .result.then(function () {
                MeetingRoom.delete({id: r.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('会议室信息删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在引用该会议室信息的内容,因此无法删除该信息!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('会议室信息删除失败!');
                });
            });
        };
        $scope.editRemarks = function (r) {
            r.$edit = true;
            r.$remarkChanged = r.remark;
        };

        $scope.saveRemarks = function (r) {
            if (r.$remarkChanged.length > 255) {
                toaster.warning('备注应该在255字以内!');
                return;
            }

            r.$edit = false;
            if (r.$remarkChanged != r.remark) {
                MeetingRoom.update({id: r.id}, {remark: r.$remarkChanged}).$promise.then(function () {
                    r.remark = r.$remarkChanged;
                    toaster.success('备注保存成功!');
                }, function () {
                    toaster.error('备注保存失败!');
                });
            }
        };
    });

angular.module('c.c').controller('MeetingRoomDlgCtrl', function ($scope, $uibModalInstance, MeetingRoom,
                                                                 toaster, Dept, data) {
    if (data.room) {
        $scope.$edit = true;
        var r = data.room;
        $scope.r = {
            name: r.name,
            capacity: r.capacity,
            remark: r.remark,
            has_projector: r.has_projector == '1',
            has_audio: r.has_audio == '1',
            has_computer: r.has_computer == '1',
            admin: {id: r.admin_id, name: r.admin_name},
            is_stop: r.is_stop == '1',
            dept: {id: r.dept_id, name: r.dept_name},
            sorting: r.sorting,
        };

    } else {
        $scope.r = {
            has_projector: true, has_audio: true, has_computer: true, sorting: 100
        };
    }

    Dept.query({opt: 4}, function (resp) {
        $scope.depts = resp.depts;
        if (!$scope.r.dept && $scope.depts && $scope.depts.length > 0) {
            $scope.r.dept = $scope.depts[0];
        }
    });

    MeetingRoom.ibeacons({}, function (resp) {
        $scope.ibeacons = resp.items;
    });

    $scope.ok = function (r) {
        if (!r.admin) {
            toaster.warning('管理员不能为空!');
        } else if ($scope.r_form.$valid) {
            var pa = {};
            pa['name'] = r.name;
            pa['capacity'] = r.capacity;
            pa['has_projector'] = r.has_projector ? '1' : '0';
            pa['has_audio'] = r.has_audio ? '1' : '0';
            pa['has_computer'] = r.has_computer ? '1' : '0';
            pa['is_stop'] = r.is_stop ? '1' : '0';
            pa['admin_id'] = r.admin.id;
            pa['ibeacon_id'] = r.ibeacon ? r.ibeacon.id : null;
            pa['remark'] = r.remark;
            pa['dept_id'] = r.dept.id;
            pa['sorting'] = r.sorting;
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('表单中有错误!');
            $scope.r_form.submitted = true;
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});

(function () {
    'use strict';

    angular.module('c')
        .controller('SysTibetNemtCtrl', SysTibetNemtCtrl)
        .controller('SysTibetNemtQrcodeCtrl', SysTibetNemtQrcodeCtrl)
        .controller('SysTibetNemtDlgCtrl', SysTibetNemtDlgCtrl)
        .controller('SysTibetNemtSmsDlgCtrl', SysTibetNemtSmsDlgCtrl)
        .controller('SysTibetNemtUploadDlgCtrl', SysTibetNemtUploadDlgCtrl)
    ;

    /** @ngInject */
    function SysTibetNemtCtrl($scope, UIHelper, Table, TibetNemt, $ocLazyLoad, Dlg) {
        var vm = $scope;
        vm.qrcode = qrcode;
        vm.addEdit = addEdit;
        vm.batch = batch;
        vm.upload = upload;
        var checker = Table.loadMultiSelectedFn(vm);

        var sexes = [
            {id: 1, name: '男'},
            {id: 0, name: '女'}
        ];

        var types = TibetNemt.getTypes();

        vm.init = init;

        function init(tab) {
            UIHelper.loadTab(vm, tab);
            var options = {
                service: TibetNemt,
                params: {op: 'default', tab: tab},
                optInFront: true,
                optColWidth: Table._1_BTN,
                counts: [10, 30, 50, 300],
                cols: [
                    {field: "sorting", title: "序号", filter: {sorting: "text"}, width: Table._1_CHAR},
                    {field: "date", title: "体检日期", filter: {date: "date_range"}, width: Table._2_CHAR},
                    {field: "type", title: "分类", filter: {type: "select"}, data: Table.getNgTableOpts(types)},
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "male", title: "性别", filter: {male: "select"}, data: Table.getNgTableOpts(sexes)},
                    {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                    {field: "no", title: "考生号", filter: {no: "text"}},
                    {field: "phone", title: "联系电话", filter: {phone: "text"}},
                    {field: "birthday", title: "出生年月", filter: {birthday: "date_range"}, width: Table._2_CHAR},
                    {field: "age", title: "年龄", filter: {age: "text"}},
                    {field: "room", title: "考场", filter: {room: "text"}},
                    {field: "r_num", title: "报名号", filter: {r_num: "text"}},
                    {field: "group", title: "组别", filter: {group: "text"}},
                    {field: "sign_time", title: "签到时间", filter: {sign_time: "date_range"}},
                    {field: "reason", title: "修改原因", filter: {reason: "text"}},
                    {field: "note", title: "备注", filter: {note: "text"}},
                ]
            };
            Table.load(vm, options);
        }

        function qrcode(type) {
            $ocLazyLoad.load(['qrCode']).then(function () {
                Dlg.show({
                    template: 'SysTibetNemtQrcode.html',
                    ctrl: 'SysTibetNemtQrcodeCtrl',
                    data: {type: type}
                })
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'SysTibetNemtDlg.html', 'SysTibetNemtDlgCtrl', m, {m: m});
        }

        function batch() {
            var itemIds = checker.getCheckedIds();
            if (!checker.hasChecked() || itemIds.length === 0) {
                Dlg.w('请选择处理对象');
                return;
            }
            var items = checker.getChecked();
            Dlg.show({
                template: 'SysTibetNemtSmsDlg.html',
                ctrl: 'SysTibetNemtSmsDlgCtrl',
                data: {
                    itemIds: itemIds,
                    items: items,
                },
                size: 'lg'
            });
        }

        function upload() {
            Dlg.show({
                template: 'SysTibetNemtUploadDlg.html',
                ctrl: 'SysTibetNemtUploadDlgCtrl',
                size: 'md'
            });
        }
    }

    /** @ngInject */
    function SysTibetNemtQrcodeCtrl($scope, $uibModalInstance, PrintHelper, data) {
        var vm = $scope;
        vm.print = print;
        vm.download = download;
        vm.cancel = $uibModalInstance.dismiss;
        vm.typeName = '';

        initQrCode(data.type);

        function initQrCode(type) {
            console.log(type);
            vm.typeName = ['', '高考', '中考', '小升初'][data.type];
            if (type == 1) {
                vm.m = 'https://oa.tcd120.cn/examination_search';
            } else if (type == 2) {
                vm.m = 'https://oa.tcd120.cn/examination_search1';
            } else {
                vm.m = 'https://oa.tcd120.cn/examination_search_small';
            }
        }

        function getPrintHtml() {
            var html = '';
            var qrUrl = $('#orderQr .qrcode')[0].toDataURL();
            html += '<div><img src="' + qrUrl + '"></div>';
            html += '<div class="info"><strong>2020年西藏' + vm.typeName + '体检二维码</strong></div>';
            return html;
        }

        function print(m) {
            PrintHelper.print(window.open('', '打印预览'), 'templates/print/order.html', function () {
                var html = getPrintHtml();
                return html;
            });
        }

        function download(m) {
            PrintHelper.printAsWord('二维码', 'templates/print/order.html',
                function () {
                    var html = getPrintHtml();
                    return html;
                });

        }
    }

    /** @ngInject */
    function SysTibetNemtDlgCtrl($uibModalInstance, TibetNemt, Dlg, DateHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.save = save;

        init(data.m);

        function init(m) {
            vm.m = m;
        }

        function save(m) {
            return Dlg.addEditOk(vm, TibetNemt, function () {
                    var pa = {
                        group: m.group,
                        date: DateHelper.date2Str(m.date),
                        sorting: m.sorting,
                    };
                    return pa;
                }
            );
        }
    }

    /** @ngInject */
    function SysTibetNemtSmsDlgCtrl($uibModalInstance, TibetNemt, Dlg, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.save = save;
        vm.items = data.items;

        init();

        function init() {
            vm.m = {id: '-', note: ''};
        }

        function save(m) {
            return Dlg.addEditOk(vm, TibetNemt, function () {
                    var pa = {
                        note: m.note,
                        itemIds: data.itemIds
                    };
                    return pa;
                }, {op: 'sms'}
            );
        }
    }

    /** @ngInject */
    function SysTibetNemtUploadDlgCtrl($uibModalInstance, TibetNemt, Dlg, FileHelper, DateHelper) {
        var vm = this;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init();

        function init() {
            vm.types = TibetNemt.getTypes();
            vm.m = {
                file: {}
            };
        }

        function deleteAttachment(m) {
            m.file = {};
        }

        function upload(file, m, e) {
            FileHelper.uploadSingle(file, m, e);
        }

        function ok(m) {
            if (!m.file.filename) {
                Dlg.e('请选择上传文件');
                return;
            }

            return Dlg.addEditOk(vm, TibetNemt, function () {
                    var pa = {
                        file: m.file.filename,
                        date: DateHelper.date2Str(m.date),
                        type: m.type.id,
                        address: m.address
                    };
                    return pa;
                }, {op: 'default', form: vm.ImportForm, formId: 'ImportForm'}
            );
        }
    }
})();
angular.module('c.c').controller('TMInSeriesWageCtrl',
    function($scope, $filter, dialogs, toaster, Dept, WageReport, C, F, FileHelper, SaveAs, $timeout, Dlg) {
        $scope.$on('wageItemSumbit', function() {
            $scope.reload();
            $scope.canSave = true;
            $scope.canGen = false;
            $scope.canSubmit = false;
            $scope.editAwd = false;
            $scope.canSave2 = false;
        });

        var allData;
        var table, commentsPlugin, sortIndex, tableData;

        $scope.change_users = [];

        $scope.exportAll = WageReport.exportYearWageStat;

        $scope.tableSettings = {
            //search: true,
            afterInit: function() {
                table = this;
                commentsPlugin = table.getPlugin('comments');
            },
            manualColumnResize: true, fixedColumnsLeft: 4, colWidths: 80, stretchH: 'all',
            columnSorting: true, sortIndicator: true, comments: true,
            afterColumnSort: function() {
                sortIndex = table.sortIndex;
                tableData = table.getSourceData();

                var wages = [];
                if (sortIndex.length != 0) {
                    for(var i = 0; i < sortIndex.length; i++) {
                        var index = sortIndex[i][0];
                        wages.push(tableData[index])
                    }
                    $scope.wages = wages;
                }
            },
            afterOnCellMouseDown: function(event, c, TD) {
                //console.log('event', event);
                //console.log('c', c);
                //console.log('TD', TD);
                var row = $scope.wages[c.row];
                //console.log('row', row);
                if (c.col === 20 || c.col === 34) {
                    dialogs.create(C.T + 'wage/wage_other_dlg.html', 'WageOtherDlgCtrl', {}, {
                        size: 'md'
                    }).result.then(function(pa) {
                            if (c.col === 20) {
                                row.i_ow = parseFloat(row.i_ow) + parseFloat(pa.money);
                                row.remark = row.remark + ';' + pa.remark;
                                row.i_hpw = getHpw(row);
                                row.i_tw = getTw(row);
                                row.i_tbw = getTbw(row);
                            }
                            if (c.col === 34) {
                                row.i_od = parseFloat(row.i_od) + parseFloat(pa.money);
                                row.remark = row.remark + ';' + pa.remark;

                                //计算扣款合计
                                row.i_td = getTd(row);
                            }
                            //计算实发合计
                            row.i_np = getNp(row);
                            table.updateSettings(row, 1);
                            $scope.change_users.push(row.id);
                        }
                    );
                }


            }
        };

        $scope.dt = new Date((new Date()).setDate(1));
        $scope.prevMonth = function(curr) {
            var prev = curr.getMonth() - 1;
            $scope.dt = new Date(curr.setMonth(prev));
        };
        $scope.nextMonth = function(curr) {
            var next = curr.getMonth() + 1;
            $scope.dt = new Date(curr.setMonth(next));
        };

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function(resp) {
            $scope.depts = resp.depts;
            if ($scope.depts && $scope.depts.length > 0) {
                $scope.depts.splice(0, 0, {name: '全部科室'});
            }
        });

        $scope.query = {dept: {name: '全部科室'}};
        $scope.change = function(query) {
            var wages = $filter('filter')(allData, {name: query.name});
            $scope.wages = $filter('filter')(wages, {dept_id: query.dept.id}, true);

            $timeout(function() {
                var comments = [];
                angular.forEach($scope.wages, function(wage, index) {
                    if (wage.i_np < 0) {
                        comments.push({
                            row: index,
                            col: 2,
                            comment: "实发合计为负,预扣款合计为" + -wage.i_np
                        });
                    }
                });
                table.updateSettings({});
            }, 1000);

        };


        $scope.$watch('dt', function(newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.reload();
            }
        });

        //计算基本工资倍数
        function getBgw(wage) {
            var total1 = eval(wage.i_bw + '+' + wage.i_gw);
            //var total1 = wage.i_bw + wage.i_gw;
            return (total1 * 0.8).toFixed(0);
        }

        //计算教护补贴
        function getEsa(wage) {
            var total2 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw);
            //var total2 = wage.i_bw + wage.i_gw + wage.i_bgw;
            return (total2 * 0.1).toFixed(0);
        }

        //计算百分百合计
        // function getHpw(wage) {
        //     var total3 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_tca + '+' + wage.i_allowance
        //     + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_ocf
        //     + '+' + wage.i_rw + '+' + wage.i_ow + '+' + wage.i_css + '+' +wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa
        //         + '+' + wage.i_ma + '+' + wage.chaf);
        //     return total3.toFixed(2);
        // }

        //计算应发差额合计
        // function getTbw(wage) {
        //     var total4 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_tca + '+' + wage.i_allowance
        //         + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_ocf
        //         + '+' + wage.i_rw + '+' + wage.i_ow);
        //     var total5=0;
        //     if (wage.out_percent == '1') {
        //          total5=eval(total4+"+"+ wage.i_css + '+' +wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa
        //              + '+' + wage.i_ma + '+' + wage.chaf);
        //     }else{
        //         total5=eval(total4*0.86.toFixed(2)+"+"+ wage.i_css + '+' +wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa
        //         + '+' + wage.i_ma + '+' + wage.chaf);
        //     }
        //     return total5;
        // }

        //计算百分百合计
        function getHpw(wage) {
            var total3 = eval(wage.i_bw + '+' + wage.i_gw + '+' + wage.i_bgw + '+' + wage.i_tca + '+' + wage.i_allowance
                + '+' + wage.i_esa + '+' + wage.i_rrw + '+' + wage.i_ha + '+' + wage.i_tsa + '+' + wage.i_ocf
                + '+' + wage.i_rw + '+' + wage.i_ow);
            return total3.toFixed(2);
        }

        //计算应发差额合计
        function getTbw(wage) {
            var total4 = getHpw(wage);
            if (wage.out_percent == '1') {
                return total4;
            }
            return (total4 * 0.86).toFixed(2);
        }


        //计算应发合计
        function getTw(wage) {
            var total5 = eval(getTbw(wage) + '+' + wage.i_kpiw);
            //var total5 = getTbw(wage) + wage.i_kpiw;
            return total5.toFixed(2);
        }

        //计算个人医保
        function getMi(wage) {
            var total6 = getHpw(wage);
            return (total6 * 0.02).toFixed(2);
        }

        //计算个人公积金
        function getHaf(wage) {
            var total7 = Math.round(getHpw(wage) / 10) * 10;
            return total7 * 0.12;
        }

        //计算个人月度失业金
        function getUc(wage) {
            var total8 = getHpw(wage);
            return (total8 * 0.005).toFixed(2);
        }

        //计算个人预扣社保及年金
        function getSsap(wage) {
            var total9 = getHpw(wage) - wage.i_ha;
            return (total9 * 0.12).toFixed(2);
        }

        //
        ////计算扣税基数
        //function getTdb(wage) {
        //    var total10 = eval(getTbw(wage) + '-' + wage.i_mi + '-' + wage.i_haf + '-' + wage.i_uc + '-' +
        //    wage.i_ssap + '-' + wage.i_pension);
        //    //var total10 = getTbw(wage) - wage.i_mi - wage.i_haf - wage.i_uc - wage.i_ssap - wage.i_pension;
        //    return total10.toFixed(2);
        //}

        //计算扣款合计
        function getTd(wage) {
            var total11 = eval(wage.i_mi + '+' + wage.i_haf + '+' + wage.i_uc + '+' + wage.i_pension
                + '+' + wage.i_wae + '+' + wage.i_pty + '+' + wage.i_rent + '+' + wage.i_cf + '+' + wage.i_of + '+' + wage.i_di + '+' + wage.i_ocfd
                + '+' + wage.i_od + '+' + wage.i_lf + '+' + wage.i_pf + '+' + wage.i_kpid + '+' + wage.i_ss + '+' + wage.i_ap + '+' + wage.i_awd);
            //var total11 = wage.i_mi + wage.i_haf + wage.i_uc + wage.i_pension + wage.i_wtd + wage.i_wae + wage.i_rent
            //    + wage.i_cf + wage.i_of + wage.i_ocfd + wage.i_od + wage.i_lf + wage.i_pf + wage.i_kpid + wage.i_ssap + wage.i_awd;
            return total11.toFixed(2);
        }

        function getSpf(wage) {
            var totalspf = eval(wage.i_css + '+' + wage.i_ei + '+' + wage.i_ui + '+' + wage.i_oa + '+' + wage.i_chaf);
            return totalspf.toFixed(2);
        }


        //计算实发合计
        function getNp(wage) {
            var total12 = eval(wage.i_ha + '+' + wage.i_tsa) * 0.14;
            if (wage.out_percent != null) {
                total12 = 0;
            }
            var total13 = eval(total12 + '+' + getTw(wage) + '-' + getTd(wage));
            //var total12 = (wage.i_ha + wage.i_tsa) * 0.14;
            //var total13 = total12 + getTw(wage) - getTd(wage);
            return total13.toFixed(2);
        }

        $scope.init = function(opt) {
            $scope.opt = opt;//5.人事科 6.财务科 13. 运管科
            $scope.reload = function() {
                $scope.loading = true;
                var params = [];
                params['opt'] = opt;
                params['month'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                WageReport.query(params, function(resp) {
                    $scope.loading = false;
                    var wages = resp.wages;
                    if (wages.length > 0) {
                        $scope.stage = wages[0].stage;
                        $scope.reportId = wages[0].report_id;
                    }
                    var comments = [];
                    angular.forEach(wages, function(wage, index) {
                        if (opt == 5) {
                            if (wage.i_np < 0) {
                                comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.i_np});
                            }

                            //计算基本工资倍数
                            wage.i_bgw = getBgw(wage);

                            if (wage.i_esa == 9999) {
                                //计算教护补贴
                                wage.i_esa = getEsa(wage);
                            }

                            //计算百分百合计
                            wage.i_hpw = getHpw(wage);

                            //计算应发差额合计
                            wage.i_tbw = getTbw(wage);

                        }

                        if (opt == 6) {
                            if (wage.i_np == 0) {
                                //计算应发合计
                                wage.i_tw = getTw(wage);

                                ////计算医保
                                //if (wage.i_mi == 0) {
                                //    wage.i_mi = getMi(wage);
                                //}

                                ////计算公积金
                                //if (wage.i_haf == 0) {
                                //    wage.i_haf = getHaf(wage);
                                //}

                                ////计算月度失业金
                                //if (wage.i_uc == 0) {
                                //    wage.i_uc = getUc(wage);
                                //}

                                //计算预扣社保及年金
                                //wage.i_ssap = getSsap(wage);

                                ////计算扣税基数
                                //wage.i_tdb = getTdb(wage);

                                ////计算个税
                                //if (wage.i_wtd == 0 && (wage.out_tax == '0' || wage.out_tax == null)) {
                                //    wage.i_wtd = F.getTax(wage.i_tdb).toFixed(2);
                                //}

                                //计算扣款合计
                                wage.i_td = getTd(wage);

                                //计算实发合计
                                wage.i_np = getNp(wage);
                            }

                            if (wage.i_np < 0) {
                                comments.push({row: index, col: 2, comment: "实发合计为负,预扣款合计为" + -wage.i_np});
                            }
                        }
                    });
                    $scope.wages = allData = wages;
                    $timeout(function() {
                        table.updateSettings({
                            cell: comments
                        });
                    }, 1000);
                });
            };
            $scope.reload();
        };


        $scope.tableReload = function() {
            $scope.reload();
        };

        $scope.submitting = false;
        $scope.genWages = function() {
            $scope.canSubmit = true;
            $scope.editAwd = true;
            $scope.canGen = false;
            $scope.submitting = true;
            var params = {};
            params['opt'] = $scope.opt;
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            WageReport.genWages(params).$promise.then(function() {
                $scope.reload();
                toaster.success('计算成功');
                $scope.submitting = false;
            }, function() {
                $scope.submitting = false;
            });
        };

        $scope.canSave = true;

        $scope.save = function(type) {
            if (type == 1) {
                $scope.canSave = false;
                $scope.canGen = true;
            } else {
                $scope.canSubmit = true;
                $scope.canSave2 = false;
            }
            var params = {};
            params['wages'] = $scope.wages;
            params['opt'] = $scope.opt;
            if ($scope.stage) {
                params['stage'] = $scope.stage;
            }
            if ($scope.reportId) {
                params['report_id'] = $scope.reportId;
            }
            params['change_users'] = $scope.change_users;
            WageReport.save(params).$promise.then(function() {
                $scope.reload();
                toaster.success('保存成功');
            });
        };

        $scope.edit = function() {
            dialogs.confirm('修改考勤工资', '<strong class="text-red">修改后请保存并提交至财务科,否则会被计算的考勤工资覆盖数据</strong>')
                .result.then(function() {
                $scope.editAwd = false;
                $scope.canSave2 = true;
                $scope.canSubmit = false;
                table.updateSettings({
                    cells: function(row, col, prop) {
                        var cellProperties = {};
                        if (col == 22) {
                            cellProperties.readOnly = false;
                        } else {
                            cellProperties.readOnly = true;
                        }
                        return cellProperties;
                    }
                });
            });
        };

        $scope.submit = function() {
            if ($scope.opt == 5) {
                dialogs.confirm('提交至财务科', '<strong class="text-red">提交后无法再修改工资,是否提交?</strong>')
                    .result.then(function() {
                    $scope.submitting = true;
                    var params = {};
                    params['opt'] = $scope.opt;
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    params['change_users'] = $scope.change_users;
                    WageReport.setStage(params).$promise.then(function() {
                        $scope.reload();
                        toaster.success('提交成功');
                        $scope.submitting = false;
                    }, function() {
                        $scope.submitting = false;
                    });
                });
            }

            if ($scope.opt == 6) {
                dialogs.confirm('发放在编员工月工资', '发放后仍可以修改,是否确定?')
                    .result.then(function() {
                    var params = {};
                    params['opt'] = $scope.opt;
                    if ($scope.reportId) {
                        params['report_id'] = $scope.reportId;
                    }
                    WageReport.setStage(params).$promise.then(function() {
                        $scope.reload();
                        toaster.success('发放成功');
                    });
                });
            }

        };

        // $scope.end = function() {
        //     dialogs.confirm('在编员工月工资月结', '月结后不可修改,是否确定?')
        //         .result.then(function() {
        //         var params = {};
        //         if ($scope.reportId) {
        //             params['report_id'] = $scope.reportId;
        //         }
        //         params['opt'] = 7;
        //         WageReport.setStage(params).$promise.then(function() {
        //             $scope.reload();
        //             toaster.success('月结成功');
        //         });
        //     });
        // };

        $scope.export = function(opt) {
            var y = $scope.dt.getFullYear(), m = $scope.dt.getMonth() + 1;
            var params = {};
            params['start'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
            params['opt'] = opt;
            FileHelper.download(C.URL.RWAGE_DOWNLOAD, params, function(resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                var filename = y + '年' + m + '月' + '员工月工资报表' + '.xls';
                SaveAs.download(data, filename, options);
            }, function(error) {
                toaster.error('导出失败!');
            });
        };

        $scope.selectExport = function() {
            Dlg.show({
                template: 'templates/wage/wageExportDlg.html',
                ctrl: 'UserWageExportDlgCtrl',
                data: {
                    url: C.URL.USER_RWAGE_DOWNLOAD
                }
            });
        };

        // $scope.import = function() {
        //     dialogs.create('templates/wage/tax_dlg.html', 'WageTaxDlgCtrl', {opt: 1},
        //         {size: 'md'}).result.then(function(data) {
        //         angular.forEach(data, function(wage) {
        //             var index = F.indexOfKey(wage.username, $scope.wages, 'username');
        //             if (index >= 0) {
        //                 $scope.wages[index].i_wtd = wage.wtd;
        //                 ////计算扣款合计
        //                 //$scope.wages[index].i_td = getTd($scope.wages[index]);
        //                 //
        //                 ////计算实发合计
        //                 //$scope.wages[index].i_np = getNp($scope.wages[index]);
        //             }
        //         });
        //     });
        // };


        //function addComments(row, string, value) {
        //    table.getCellMeta(row, 2).comment = string + '，预扣款合计为' + value;
        //    commentsPlugin.showAtCell(row, 2);
        //    commentsPlugin.saveCommentAtCell(row, 2);
        //}

        // $scope.changeAfter = function(a) {
        //     if (a) {
        //         if (a[0].length > 0) {
        //             $scope.canSave = true;
        //             $scope.canGen = false;
        //             $scope.canSubmit = false;
        //             $scope.editAwd = false;
        //             $scope.canSave2 = false;
        //             for(var i = 0; i < a.length; i++) {
        //                 var row = a[i][0],
        //                     column = a[i][1],
        //                     old_value = a[i][2],
        //                     new_value = a[i][3];
        //
        //                 var w = $scope.wages[row];
        //
        //                 if (column == 'i_awd') {
        //                     $scope.canSave = false;
        //                     $scope.canSave2 = true;
        //                 }
        //
        //                 if (column != 'remark') {
        //                     if (isNaN(new_value)) {
        //                         w[column] = old_value;
        //                         toaster.warning('请输入数字!');
        //                         $scope.isFullscreen = false;
        //                     } else if (new_value.length == 0) {
        //                         w[column] = old_value;
        //                         toaster.warning('输入不能为空!');
        //                         $scope.isFullscreen = false;
        //                     } else {
        //                         if (new_value < 0 && column != 'i_od') {
        //                             w[column] = old_value;
        //                             toaster.warning('不能输入负数!');
        //                             $scope.isFullscreen = false;
        //                         } else {
        //                             if ($scope.opt == 5) {
        //                                 //计算百分百合计
        //                                 w.i_hpw = getHpw(w);
        //
        //                                 //计算应发差额合计
        //                                 w.i_tbw = getTbw(w);
        //                             }
        //
        //                             if ($scope.opt == 6) {
        //                                 commentsPlugin.removeCommentAtCell(row, 2);
        //                                 //计算百分百合计
        //                                 w.i_hpw = getHpw(w);
        //
        //                                 //计算应发差额合计
        //                                 w.i_tbw = getTbw(w);
        //
        //                                 ////计算医保
        //                                 //w.i_mi = getMi(w);
        //                                 //
        //                                 ////计算公积金
        //                                 //w.i_haf = getHaf(w);
        //                                 //
        //                                 ////计算月度失业金
        //                                 //w.i_uc = getUc(w);
        //                                 //
        //                                 ////计算预扣社保及年金
        //                                 //w.i_ssap = getSsap(w);
        //
        //                                 //计算应发合计
        //                                 w.i_tw = getTw(w);
        //
        //                                 ////计算扣税基数
        //                                 //w.i_tdb = getTdb(w);
        //
        //                                 ////计算个税
        //                                 //if (column != 'i_wtd' && (w.out_tax == '0' || w.out_tax == null)) {
        //                                 //    w.i_wtd = F.getTax(w.i_tdb).toFixed(2);
        //                                 //}
        //
        //                                 //自付公积金跟单位缴付公积金一样
        //                                 w.i_chaf = w.i_haf;
        //
        //                                 //计算单位负担社保及公积金
        //                                 w.i_spf = getSpf(w);
        //
        //                                 //计算扣款合计
        //                                 w.i_td = getTd(w);
        //
        //                                 //计算实发合计
        //                                 w.i_np = getNp(w);
        //
        //                                 //if (w.i_np < 0) {
        //                                 //    addComments(row, '实发合计为负', -w.i_np);
        //                                 //    w.s = 0.00
        //                                 //} else {
        //                                 //    w.s = w.i_np;
        //                                 //    commentsPlugin.removeCommentAtCell(row, 2);
        //                                 //}
        //                             }
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // };
    });



'use strict';

angular.module('c.c')
    .controller('BulletinReleaseCtrl', function ($rootScope, $scope, $state, dialogs, $filter, Upload, toaster,
                                                 C, F, Auth, Bulletin, Dept, FileHelper, ArrayHelper,UIHelper,Dlg) {
        $scope.bulletin = {attachments: [], with_wx: true, public: false, all_attend: false};

        UIHelper.loadTab($scope, 'release', function () {
            Dlg.error("公告功能已迁移至飞书，请前往飞书发布，谢谢！")
        });
        $scope.$on('bulletinRelease', function (ev, doc) {
            var getData = $scope.bulletin;
            getData['title'] = doc.subject;
            getData['body'] = doc.body;
            getData['attachments'] = doc.attachments;
            $scope.bulletin = getData;
        });
        Dept.query({opt: '5'}, function (resp) {
            $scope.depts = resp.depts;
            $scope.bulletin.dept = $scope.depts[0];
        });

        $scope.user = Auth.getAccount();
        $scope.deleteAttachment = function ($index, bulletin) {
            bulletin.attachments.splice($index, 1);
        };

        $scope.upload = function (file, bulletin, e) {
            FileHelper.upload(C.URL.BULLETIN_UPLOAD, file, bulletin, e);
        };

        $scope.ok = function (bulletin, isDraft) {
            Dlg.error("公告功能已迁移至飞书，请前往飞书发布，谢谢！")
            var promise = submitEmail(bulletin, isDraft);
            if (promise) {
                if (isDraft) {
                    promise.then(function (resp) {
                        toaster.success('公告已保存为草稿!');
                        bulletin.title = null;
                        bulletin.body = null;
                        bulletin.attachments = [];
                        bulletin.recipients = [];
                        bulletin.mime = [];
                    }, function () {
                        toaster.error('公告保存失败了!');
                    });
                } else {
                    promise.then(function (resp) {
                        toaster.success('提交成功!');
                        $rootScope.$broadcast('bulletinSend');
                        bulletin.title = null;
                        bulletin.body = null;
                        bulletin.attachments = [];
                        bulletin.recipients = [];
                        bulletin.mime = [];
                        $scope.tabs['released'] = true;
                    }, function () {
                        toaster.error('公告提交失败了!');
                    });
                }
            }
        };

        function submitEmail(bulletin, isDraft) {
            var promise = null;
            if (bulletin.title == null) {
                toaster.warning('公告标题不能为空!');
            } else if (!bulletin.body || /^\s*$/.test(bulletin.body)) {
                toaster.warning('公告内容不能为空!');
            } else if (!FileHelper.isAttachmentsUploaded(bulletin)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {is_draft: isDraft};
                params['dept'] = bulletin.dept.name;
                params['title'] = bulletin.title;
                params['body'] = bulletin.body;
                params['with_sms'] = bulletin.with_sms == true ? 1 : 0;
                params['with_wx'] = bulletin.with_wx == true ? 1 : 0;
                params['public'] = bulletin.public ? 1 : 0;
                params['all_attend'] = bulletin.all_attend ? 1 : 0;
                params['attachments'] = [];
                params['recipients'] = ArrayHelper.listKey(bulletin.recipients);
                angular.forEach(bulletin.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });
                promise = Bulletin.save(params).$promise
            }
            return promise;
        }

        $scope.preview = function (bulletin) {
            dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                id: 0, preview: bulletin
            }, {
                size: 'lg'
            });
        }
    });


angular.module('c.c').controller('BulletinReleasedCtrl',
    function ($scope, $state, $filter, dialogs, toaster, C, F, UIHelper, NgTableParams, DeptType, Bulletin, Dept) {
        $scope.$on('bulletin.send', function (event, data) {
            $scope.tableParams.reload();
        });

        $scope.$on('bulletinSend', function (event, data) {
            $scope.tableParams.reload();
        });

        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');

        UIHelper.loadTab($scope, 'released', function () {
            $scope.tableParams.reload();
        });

        var stages = F.getApprovalStages1();
        var stagesOpts = F.getNgTableOpts(stages);

        $scope.cols = [
            {title: '科室', filter: {dept_id: 'select'}, show: true},
            {title: '公告标题', filter: {title: 'text'}, show: true},
            {title: '发布时间', filter: {release_time: 'date_range'}, show: true},
            {title: '状态', filter: {is_pass: 'select'}, data: stagesOpts, show: true, width: '10%'}
        ];
        var deptCol = $scope.cols[0];
        Dept.query({opt: 12}, function (resp) {
            var depts = resp.depts;
            deptCol.data = F.getNgTableOpts(depts);
            $scope.depts = depts;
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.optColWidth = 70;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                release_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 0;
                if ($scope.dateRangeFilter.release_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.release_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.release_time.endDate, 'yyyy-MM-dd');
                }
                Bulletin.query(url, function (data) {
                    params.total(data.total);
                    angular.forEach(data.bulletins, function (bulletin) {
                        bulletin.stage = F.getItem(bulletin.is_pass, stages);
                    });
                    $defer.resolve(data.bulletins);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.dm = {start: new Date(), end: new Date()};
        $scope.screen = function () {
            $scope.bulletins = null;
        };

        $scope.seeRemark = function (bulletin) {
            dialogs.create('RemarkDlg.html', 'RemarkCtrl', {
                remark: bulletin.remark
            }, {
                size: 'md'
            });
        };

        $scope.edit = function (bulletin) {
            if (bulletin.is_pass == C.STAGE1.DEPT_APPROVAL) {
                dialogs.create('templates/article/bulletin_edit.html', 'EditBulletinCtrl', {
                    id: bulletin.id, depts: $scope.depts, edit: true
                }, {
                    size: 'lg'
                }).result.then(function (params) {
                    Bulletin.update({id: bulletin.id}, params).$promise.then(function () {
                        toaster.success('修改成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('修改失败!');
                    })
                });
            } else {
                dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                    id: bulletin.id
                }, {
                    size: 'lg'
                });
            }
        };

        $scope.check = function (bulletin) {
            dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id
            }, {
                size: 'lg'
            });
        };

        $scope.delete = function (bulletin) {
            dialogs.confirm('删除公告', '确定要删除该公告吗?')
                .result.then(function () {
                Bulletin.delete({id: bulletin.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功!');
                            break;
                        case 1:
                            toaster.warning('!');
                            break;
                    }
                    $scope.tableParams.reload();
                }, function (error) {
                    toaster.error('删除失败!');
                });
            });

        };

        $scope.detail = function (bulletin) {
            dialogs.create('BulletinRecipients.html', 'BulletinRecipientsDlgCtrl', {
                id: bulletin.id
            }, {
                size: 'lg'
            });
        };
    });

angular.module('c.c').controller('RemarkCtrl',
    function ($scope, $uibModalInstance, Dept, Bulletin, data) {
        $scope.remark = data.remark;
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('BulletinRecipientsDlgCtrl',
    function ($scope, $uibModalInstance, Table, Bulletin, ArrayHelper, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            var readStatusOpts = Table.getNgTableOpts(ArrayHelper.get('readOrUnread'));

            var options = {
                service: Bulletin,
                params: {opt: 13/*INDEX_RECIPIENT_LIST*/, bulletin_id: id},
                hideOpt: true,
                cols: [
                    {field: "recipient", filter: {recipient: 'text'}, title: "员工"},
                    {field: "dept", filter: {dept: 'text'}, title: "科室"},
                    {field: "is_read", filter: {is_read: 'select'}, data: readStatusOpts, title: "是否阅读"},
                    {field: "time", title: "阅读时间(秒)"}
                ],
                items: 'bulletins'
            };
            Table.load(vm, options);
        }
    });

angular.module('c.c').controller('EditBulletinCtrl',
    function ($scope, $sce, dialogs, $uibModalInstance, C, F, FileHelper,
              SaveAs, Upload, toaster, Dept, Bulletin, data) {

        var deleteAttachments = [];

        function initData() {
            $scope.draftStage = data.draftStage;
            Bulletin.get({id: data.id}, function (resp) {
                var bulletin = resp;
                $scope.progress = 0;
                var dept = {name: bulletin.dept};
                $scope.edit = true;
                $scope.init = function () {
                    Dept.query({'opt': 5}, function (resp) {
                        $scope.depts = resp.depts;
                    })
                };
                $scope.bulletin = {
                    name: bulletin.sender_id,
                    release_time: bulletin.release_time,
                    title: bulletin.title,
                    dept: dept,
                    body: bulletin.body,
                    attachments: bulletin.attachments,
                    with_wx: bulletin.with_wx,
                    public: bulletin.public,
                };
                $scope.bulletin.body_sce = $sce.trustAsHtml(bulletin.body);
                console.log($scope.bulletin);
            });
        }

        $scope.deleteAttachment = function ($index, bulletin) {
            if (bulletin.attachments[$index].bulletin_id)
                deleteAttachments.push(bulletin.attachments[$index].id);
            bulletin.attachments.splice($index, 1);
        };

        $scope.upload = function (file, bulletin, e) {
            FileHelper.upload(C.URL.BULLETIN_UPLOAD, file, bulletin, e);
        };
        initData();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.BULLETIN_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.ok = function (bulletin) {

            if (bulletin.title == null || bulletin.body == null) {
                toaster.error('请仔细检查表单');
            } else if (!FileHelper.isAttachmentsUploaded(bulletin)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {
                    with_wx: bulletin.with_wx,
                    public: bulletin.public
                };
                params['attachments'] = [];
                angular.forEach(bulletin.attachments, function (attachment) {
                    if (!attachment.bulletin_id)
                        params['attachments'].push({
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        });
                });
                params['deleteAttachments'] = deleteAttachments;
                params['dept'] = bulletin.dept.name;
                params['title'] = bulletin.title;
                params['body'] = bulletin.body;
                params['is_draft'] = false;
                $uibModalInstance.close(params);
            }
        }
    });

angular.module('c.c').controller('ApprovalBulletinCtrl',
    function ($rootScope, $scope, $sce, dialogs, $uibModalInstance, FileHelper,
              C, F, SaveAs, Upload, toaster, Dept, Bulletin, data) {

        var deleteAttachments = [];

        function initData() {
            $scope.loading = true;
            Bulletin.get({id: data.id}, function (resp) {
                var bulletin = resp;
                $scope.progress = 0;
                var dept = {name: bulletin.dept};
                $scope.approval = true;
                $scope.bulletin = {
                    release_time: bulletin.release_time,
                    title: bulletin.title,
                    dept: dept,
                    body: bulletin.body,
                    attachments: bulletin.attachments,
                    with_wx: bulletin.with_wx,
                    public: bulletin.public
                };
                $scope.bulletin.body_sce = $sce.trustAsHtml(bulletin.body);
                $scope.loading = false;
            });
        }

        $scope.back = function () {
            dialogs.create('templates/article/back.html', 'BulletinBackDlgCtrl', {
                stage: data.is_pass
            }, {
                size: 'xs'
            }).result.then(function (params) {
                Bulletin.update({id: data.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('bulletinBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            })
        };

        $scope.deleteAttachment = function ($index, bulletin) {
            if (bulletin.attachments[$index].bulletin_id)
                deleteAttachments.push(bulletin.attachments[$index].id);
            bulletin.attachments.splice($index, 1);
        };

        $scope.upload = function (file, bulletin, e) {
            FileHelper.upload(C.URL.BULLETIN_UPLOAD, file, bulletin, e);
        };

        initData();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.BULLETIN_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.pass = function (bulletin) {
            dialogs.confirm('公告审批', '确定该公告通过审批吗?')
                .result.then(function () {
                    if (bulletin.title == null || bulletin.title === '' || bulletin.body == null || bulletin.body === '') {
                        toaster.error('公告内容或标题不能为空');
                    } else if (!FileHelper.isAttachmentsUploaded(bulletin)) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                    } else {
                        var params = {
                            with_wx: bulletin.with_wx,
                            public: bulletin.public
                        };
                        params['attachments'] = [];
                        angular.forEach(bulletin.attachments, function (attachment) {
                            if (!attachment.bulletin_id)
                                params['attachments'].push({
                                    name: attachment.name, mime: attachment.mime,
                                    filename: attachment.filename, size: attachment.size
                                });
                        });
                        params['is_pass'] = data.is_pass;
                        params['deleteAttachments'] = deleteAttachments;
                        params['dept'] = bulletin.dept.name;
                        params['title'] = bulletin.title;
                        params['body'] = bulletin.body;
                        $uibModalInstance.close(params);
                    }
                }
            )
        };
    });


'use strict';

angular.module('c.c')
    .controller('BulletinSearchCtrl', function ($scope, $filter, dialogs, NgTableParams, F, Dept, Bulletin) {
        $scope.$on('ReadBulletin', function (event, data) {
            $scope.tableParams.reload();
        });

        var readOpts = F.getNgTableOpts(F.get('readOrUnread'));
        $scope.cols = [
            {title: '状态', data: readOpts, filter: {read_state: 'select'}, show: true},
            {title: '公告标题', filter: {title: 'text'}, show: true},
            {title: '发布时间', filter: {release_time: 'date_range'}, show: true},
            {title: '科室', filter: {dept: 'text'}, show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                release_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                if ($scope.dateRangeFilter.release_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.release_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.release_time.endDate, 'yyyy-MM-dd');
                }
                Bulletin.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.bulletins);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.check = function (bulletin) {
            dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id
            }, {
                 size: 'lg'
            });
        };
    });

angular.module('c.c')
    .controller('BulletinCollectCtrl', function ($scope, $filter, dialogs, NgTableParams, Dept, Bulletin) {
        $scope.$on('CancelCollect', function (event, data) {
            $scope.tableParams.reload();
        });

        $scope.$on('Collect', function (event, data) {
            $scope.tableParams.reload();
        });

        $scope.cols = [
            {title: '公告标题', filter: {title: 'text'}, show: true},
            {title: '发布时间', filter: {updated_at: 'date_range'}, show: true},
            {title: '科室', filter: {dept: 'text'}, show: true}
        ];

        $scope.dateRangeFilter = {};
        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 6;
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                Bulletin.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.bulletins);
                });
            }
        });

        $scope.check = function (bulletin) {
            dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id
            }, {
                 size: 'lg'
            });
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('BulletinDraftCtrl', BulletinDraftCtrl);

    /** @ngInject */
    function BulletinDraftCtrl ($scope, Table, $q, Bulletin, Dlg, UIHelper) {
        var vm = $scope;
        var checker = Table.loadMultiSelectedFn(vm);
        vm.relaunch = relaunch;
        vm.remove = remove;


        init();

        function init () {
            UIHelper.loadTab(vm, 'draft');
            var options = {
                service: Bulletin,
                params: {opt: 11}, /*草稿箱*/
                optInFront: true,
                optColWidth: Table._2_BTN,
                sorting: {},
                items: 'bulletins',
                cols: [
                    {field: 'title', title: '公告标题', filter: {title: 'text'}},
                    {
                        field: 'dept',
                        title: '科室',
                        filter: {dept: 'text'},
                        width: '20%'
                    },
                    {
                        field: 'created_at',
                        title: '创建时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        width: '20%'
                    }
                ]
            };
            Table.load(vm, options);
        }

        function relaunch (bulletin) {
            Dlg.show({
                template: 'templates/article/bulletin_edit.html',
                ctrl: 'EditBulletinCtrl',
                data: {id: bulletin.id, draftStage: true},
                size: 'lg'
            }).then(function (params) {
                Bulletin.update({id: bulletin.id}, params).$promise.then(function () {
                    Dlg.s('提交成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('提交失败!');
                });
            });
        }

        function remove (isBatch, m) {
            var defer = $q.defer();
            var mailIds = [];
            if (isBatch) {
                var items = checker.getCheckedIds();
                var count = items.length;
                if (count === 0) {
                    checker.clearChecked();
                    Dlg.w("请至少选中一个待处理选项");
                    return;
                } else {
                    mailIds = items;
                    Bulletin.update({id: '-', opt: 3}, {mails: mailIds}).$promise.then(
                        function () {
                            Dlg.s('公告草稿删除成功!');
                        },
                        function () {
                            Dlg.e('公告删除失败!');
                        }
                    ).finally(function () {
                        defer.resolve();
                        vm.tableReload();
                    });
                }
            } else {
                Dlg.confirm('确定要删除标题为<strong>' + m.title + '</strong>的公告吗？', function () {
                    mailIds.push(m.id);
                    Bulletin.update({id: '-', opt: 3}, {mails: mailIds}).$promise.then(
                        function () {
                            Dlg.s('公告草稿删除成功!');
                        },
                        function () {
                            Dlg.e('公告删除失败!');
                        }
                    ).finally(function () {
                        defer.resolve();
                        vm.tableReload();
                    });
                }, '删除公告');
            }
            return defer.promise;
        }
    }

})();




angular.module('c.c').controller('CarApplyController',
    function ($scope, $rootScope, $filter, toaster, C, F, Auth, $q,
              CApply, CarType, Car, Dept, CarWaitLocation, CarDestination, CarContact, uibDateParser, ArrayHelper,User) {

        function time2SliderVal(time) {
            var hour = parseInt(time.substr(0, 2));
            var minute = parseInt(time.substr(3, 2));
            return hour * 12 + minute / 5;
        }

        $scope.CarLFees = F.get('CarLFees');
        $scope.$on('carEdit', function (ev, car) {
            //$scope.firstSearch = true;
            $scope.car['type'] = car.type;
            $scope.car['destination'] = car.destination;
            $scope.car['remarks'] = car.remarks;
            $scope.car['urgent'] = car.urgent == '1';
            $scope.car['passengers'] = car.passengers;
            $scope.car['dept'] = car.dept;
            $scope.car['date'] = uibDateParser.parse(car.start_time.substr(0, 10), 'yyyy-MM-dd');
            $scope.car.s.min = time2SliderVal(car.start_time.substr(11, 5));
            $scope.car.s.max = time2SliderVal(car.end_time.substr(11, 5));
        });

        $scope.searchIdle = function (car) {
            if (car.s.min == car.s.max) {
                toaster.warning('开始和结束时间不能相等');
            } else if (car.date == null) {
                toaster.warning('用车时间不能为空');
            } else if ($scope.dateRange && (car.start == null || car.end == null || car.start >= car.end)) {
                toaster.warning('开始和结束时间错误');
            } else {
                if ($scope.dateRange) {
                    var start = $filter('date')(car.start, 'yyyy-MM-dd') + ' ' + car.s.options.translate(car.s.min);
                    var end = $filter('date')(car.end, 'yyyy-MM-dd') + ' ' + car.s.options.translate(car.s.max);
                } else {
                    var date = $filter('date')(car.date, 'yyyy-MM-dd');
                    var start = date + ' ' + car.s.options.translate(car.s.min);
                    var end = date + ' ' + car.s.options.translate(car.s.max);
                }

                Car.query({
                    opt: 2,
                    start: start,
                    end: end,
                    type_id: car.type.id,
                    schedule_on: car.schedule_on == true ? 1 : 0
                }, function (resp) {
                    $scope.cars = resp.records;
                    $scope.duty_caller = resp.duty_caller;
                    if (car.type.id == 4) {
                        $scope.cars.push({plate_num: '滴滴用车', limit_day: '无'});
                    }
                });
                //$scope.firstSearch = false;

                if (car.type.id != 2) {
                    $scope.car.send_schedule = false;
                }
            }
        };

        $scope.getCaller = function (car) {
            CarContact.query({
                opt: 2,
                type_id: car.type.id,
                schedule_on: car.schedule_on == true ? 1 : 0
            }, function (resp) {
                $scope.duty_caller = resp[0];
            });
            //$scope.firstSearch = false;
        };


        $scope.today = new Date();


        Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS}, function (resp) {
            var depts = resp.depts;
            if ($scope.car) {
                if ($scope.car.dept_id) {
                    $scope.car.dept = F.getItem($scope.dept_id, depts);
                } else {
                    $scope.car.dept = depts[0];
                }
            }
            $scope.depts = depts;
        });

        CarWaitLocation.query(function (resp) {
            var locations = resp;
            if ($scope.car) {
                if ($scope.car.wait_id) {
                    $scope.car.location = F.getItem($scope.wait_id, locations);
                } else {
                    $scope.car.location = locations[0];
                }
            }
            $scope.locations = locations;
        });

        CarDestination.query({opt: 2}, function (resp) {
            var destinations = $scope.CarLFees.concat(resp.items);
            if ($scope.car) {
                if ($scope.car.de_id) {
                    $scope.car.destination = [ArrayHelper.getItem($scope.car.de_id, destinations)];
                } else {
                    $scope.car.destination = [destinations[0]];
                }
            }
            $scope.destinations = destinations;
        });

        var out_str = '某某-电话-地址(选填);某某-电话-地址(选填)';
        $scope.submit = function (car) {
            var defer = $q.defer();
            var reject = false;
            if (car.date == null) {
                toaster.warning('用车日期不能为空');
                reject = true;
            } else if (car.s.min == car.s.max) {
                toaster.warning('开始和结束时间不能相等');
                reject = true;
            } else if ($scope.cars.length == 0 && car.type.id != 4) {
                toaster.warning('此时间段已无车可用,请更换时间');
                reject = true;
            } else if (car.location == null || (Array.isArray(car.location) && car.location.length === 0)) {
                toaster.warning('请选择或输入出发地点');
                reject = true;
            } else if (car.contact == null) {
                toaster.warning('联系人不能为空');
                reject = true;
            } else if (!car.destination || (Array.isArray(car.destination) && car.destination.length === 0)) {
                toaster.warning('请选择或输入目的地');
                reject = true;
            } else {
                var params = {};
                params['type_id'] = car.type.id;
                params['send_schedule'] = car.send_schedule == true ? 1 : 0;
                params['schedule_on'] = car.schedule_on == true ? 1 : 0;
                params['remarks'] = car.remarks;
                params['dept_id'] = car.dept.id;
                params['dept_charge_id'] = car.dept.leader_id;
                params['location'] = car.location;
                params['contact_id'] = car.contact.id;
                params['destination'] = car.destination;
                if (car.out_passenger == out_str) {
                    params['out_passenger'] = '';
                } else {
                    params['out_passenger'] = car.out_passenger;
                }
                var temp = [];
                angular.forEach(car.passengers, function (passenger) {
                    temp.push(passenger.id);
                });
                params['passengers'] = temp;
                if ($scope.dateRange) {
                    var start = $filter('date')(car.start, 'yyyy-MM-dd') + ' ' + car.s.options.translate(car.s.min);
                    var end = $filter('date')(car.end, 'yyyy-MM-dd') + ' ' + car.s.options.translate(car.s.max);
                } else {
                    var date = $filter('date')(car.date, 'yyyy-MM-dd');
                    var start = date + ' ' + car.s.options.translate(car.s.min);
                    var end = date + ' ' + car.s.options.translate(car.s.max);
                }
                params['start_time'] = start;
                params['end_time'] = end;
                params['send_out'] = car.send_out == true ? 1 : 0;
                params['set_location'] = car.set_location ? 1 : 0;
                params['set_destination'] = car.set_destination ? 1 : 0;

                if (car.type.id == 4) {
                    params['is_de'] = true;
                    // params['d_driver'] = car.d_driver; //滴滴司机
                    // params['d_plate_num'] = car.d_plate; //滴滴车牌
                    // params['d_pay'] = car.d_pay; //滴滴费用
                    // params['d_phone'] = car.d_phone; // 滴滴联系方式
                    // params['status'] = 6; //直接通过
                }

                CApply.save(params).$promise.then(function (resp) {
                    toaster.success('用车申请成功!');
                    $scope.reset();
                    $rootScope.$broadcast('fresh');
                    $scope.tabs['pending'] = true;
                }, function () {
                    toaster.error('用车申请失败了!');
                }).finally(function () {
                    defer.resolve();
                });
            }
            if (reject) {
                defer.reject();
            }
            return defer.promise;
        };
        $scope.contactChange = function (user) {
            if (user.phone){
                $scope.phone=user.phone;
            }else {
                User.get({id:user.id}).$promise.then(function (resp) {
                    $scope.phone = resp.user.phone?resp.user.phone:'暂无电话';
                });
            }

            // var params = {};
            // params['type_id'] = car.type.id;
            // params['send_schedule'] = car.send_schedule == true ? 1 : 0;
            // params['schedule_on'] = car.schedule_on == true ? 1 : 0;
            // params['remarks'] = car.remarks;
            // CApply.save(params).$promise.then(function (resp) {
            //     toaster.success('用车申请成功!');
            //     $scope.reset();
            //     $rootScope.$broadcast('fresh');
            //     $scope.tabs['pending'] = true;
            // }, function () {
            //     toaster.error('用车申请失败了!');
            // }).finally(function () {
            //     defer.resolve();
            // });
            // return defer.promise;
        };

        //判断当前时间，是否为周末或者17:30~08:00 为下班，否则则为上班   day  0为星期天
        var date = new Date();
        var day = date.getDay();
        var hour = date.getHours();
        var schedule_on = 0;

        if (day == 0 || day == 6) {
            schedule_on = 0
        } else {
            if (hour >= 8 && hour < 17) {
                schedule_on = 1;
            } else {
                if (hour == 17) {
                    if (date.getMinutes() <= 30) {
                        schedule_on = 1;
                    }
                }
            }
        }

        var user = Auth.getAccount();
        $scope.phone=user.phone?user.phone:'暂无电话';
        $scope.reset = function () {
            $scope.dateRange = false;
            CarType.query({'opt': 2}, function (resp) {
                    $scope.types = resp.types;
                    var car = {
                        type: $scope.types[1],   //默认救护车
                        date: new Date(),
                        start: new Date(),
                        schedule_on: schedule_on,
                        //passengers: [{id: user.id, name: user.name}],
                        passengers: [],
                        contact: {id: user.id, name: user.name},
                        s: {
                            min: 144, max: 168, options: {
                                floor: 0,
                                ceil: 288,
                                translate: function (val) {
                                    var h = Math.floor(val / 12);
                                    var m = (val % 12) * 5;
                                    return h + ':' + (m >= 10 ? '' : '0') + m;
                                }
                            }
                        },
                        out_passenger: out_str,
                        set_location: false,
                        set_destination: false
                    };

                    if ($scope.depts) {
                        car['dept'] = $scope.depts[0];
                    }
                    //if ($scope.locations) {
                    //    car['location'] = $scope.locations[0];
                    //}

                    if (car.type.id == 2) {    //救护车默认短信审批提醒
                        car['send_schedule'] = true;
                    }
                    $scope.car = car;
                    $scope.getCaller(car);
                    $scope.searchIdle(car);
                }
            )
            ;
        };

        $scope.reset();

        $scope.tagTransform = function (newTag) {
            var item = F.getItem(newTag, $scope.locations, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        };

        $scope.tagTrans = function (newTag) {
            var item = F.getItem(newTag, $scope.destinations, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        };

    })
;
angular.module('c.c').controller('CarPendingController',
    function ($scope, $filter, $rootScope, dialogs, toaster, NgTableParams, CApply,
              $templateRequest, $sce, $timeout, Auth, F) {

        $scope.opt = 1;
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');
        var stage_list2 = F.getNgTableOpts(F.get('stage_list2'));
        $scope.stage_list2 = F.get('stage_list2');

        $scope.cols = [
            {title: '详情', field: 'more', show: true},
            {
                title: '状态',
                filter: {'car_applications.status': 'select'},
                field: 'status',
                data: stage_list2,
                show: true
            },
            {
                title: '申请人',
                filter: {'users.name': 'text'},
                field: 'users.name',
                show: true
            }
            , //6
            {
                title: '科室',
                field: 'dept_id',
                show: true
            }
            , //6
            {
                title: '车型',
                filter: {'car_applications.type_id': 'select'},
                field: 'type_id',
                show: true
            }
            , //6
            {
                title: '出发时间', filter: {start_time: 'date_range'},
                field: 'start_time', show: true
            }
            ,
            {
                title: '返程时间', filter: {end_time: 'date_range'},
                field: 'end_time', show: true
            }
            ,
            {
                title: '申请时间', filter: {created_at: 'date_range'},
                field: 'created_at', show: true
            }
            ,
            {
                title: '是否滴滴用车', filter: {is_de: 'select'},
                field: 'is_de', show: true, data: yesNoOpts
            }

        ];

        $scope.$on('fresh', function () {
            $scope.tableParams.reload();
        });
        $scope.type_cols = $scope.cols[4];
        $scope.user_cols = $scope.cols[2];
        $scope.optColWidth = 70;
        $scope.optInFront = true;
        $scope.dateRangeFilter = {};

        if ($scope.opt == 1 || $scope.opt == 2 || $scope.opt == 11) {
            $scope.user_cols.show = false;
        }

        if ($scope.opt == 2 || $scope.opt == 4 || $scope.opt == 11) {
            $scope.hideOpt = true;
        }

        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function () {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt;
                var startDate, endDate;
                if ($scope.dateRangeFilter.created_at != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        created_at: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.start_time != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        start_time: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.end_time != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.end_time.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.end_time.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        end_time: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                CApply.query(url, function (data) {
                    $scope.types = data.types;
                    $scope.type_cols.data = F.getNgTableOpts(data.types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        //编辑用车申请
        $scope.edit = function (record) {
            $scope.tabs['apply'] = true;
            $timeout(function () {
                $rootScope.$broadcast('carEdit', record);
            }, 200);
        };
        //删除用车申请
        $scope.delete = function (record) {
            dialogs.confirm('删除用车申请', '确定要删除<strong>' + record.type.name + '</strong>的记录吗?')
                .result.then(function () {
                CApply.delete({id: record.id}).$promise.then(function () {
                    toaster.success('用车申请删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('用车申请删除失败!');
                });
            });
        };

        //分配车辆
        $scope.assign = function (record) {
            dialogs.create('/templates/car_manage/car_pending_dlg.html', 'CarPendingDlgCtrl', {
                record: record
            }, {
                size: 'lg'
            }).result.then(function (para) {
                $scope.tableReload();
                $rootScope.$broadcast('fresh');
            });
        };

        //审批同意
        $scope.agree = function (record) {
            dialogs.confirm('用车审批', '确定要同意<strong>' + record.user_name + '</strong>的用户申请吗?')
                .result.then(function () {
                var data = {};
                data['status'] = 3;
                CApply.update({id: record.id}, data).$promise.then(function () {
                    $rootScope.$broadcast('fresh');
                }, function (error) {
                    toaster.error('审批失败!');
                });
            });

        };

        //审批拒绝
        $scope.disagree = function (record) {
            dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
                title: '退回车辆申请',
                icon: 'reply',
                label: '原因'
            }, {
                size: 'sm'
            }).result.then(function (pa) {
                var user = Auth.getAccount();
                var params = {};
                params['refuse'] = pa;
                if ($scope.opt == 3) {  //如果是科室审批
                    params['status'] = 2;
                } else if ($scope.opt == 5) {  //院办审批
                    params['status'] = 4;
                }
                params['confirm_id'] = user.id;
                params['confirm_time'] = $filter('date')(new Date(), 'yyyy-MM-dd MM:HH');
                CApply.update({id: record.id}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('fresh');
                }, function () {
                    toaster.error('退回失败!');
                })
            });
        };

        //撤消派车
        $scope.cancel = function (record) {
            dialogs.confirm('用车撤消', '确定要撤消<strong>' + record.user_name + '</strong>的派车吗?')
                .result.then(function () {
                var data = {};
                data['status'] = 5;
                CApply.update({id: record.id}, data).$promise.then(function () {
                    toaster.success('撤消成功!');
                    $rootScope.$broadcast('fresh');
                }, function (error) {
                    toaster.error('审批失败!');
                });
            });
        };

        //出发前里程填写
        $scope.pre_fill = function (record) {
            dialogs.create('templates/basic/float_dlg.html', 'FloatDlgCtrl', {
                title: '派车里程填写',
                icon: 'reply',
                label: '出发里程'
            }, {

                size: 'md'
            }).result.then(function (pa) {
                var params = {};
                params['pre_mile'] = pa;
                params['status'] = 7;
                CApply.update({id: record.id}, params).$promise.then(function () {
                    toaster.success('出发里程填写成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('出发里程填写失败!');
                })
            });
        };

        //回程里程填写
        $scope.later_fill = function (record) {
            dialogs.create('templates/basic/float_dlg.html', 'FloatDlgCtrl', {
                title: '派车里程填写',
                icon: 'reply',
                label: '回程里程'
            }, {

                size: 'md'
            }).result.then(function (pa) {
                var params = {};
                params['later_mile'] = pa;
                params['status'] = 8;
                CApply.update({id: record.id}, params).$promise.then(function () {
                    toaster.success('回程里程填写成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('回程里程填写失败!');
                })
            });
        };


        //打印派车单
        var templateUrl = $sce.getTrustedResourceUrl('templates/print/table2.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.print = function (record) {
            var w = window.open("", "打印预览");

            var html = '<html><body>';

            html += '<table class="print">' +
                '<caption>成办医院派车单</caption>' +
                '<tbody><tr>';
            html += '<td width="120" rowspan="4">申请部门填写</td>';
            html += '<td width="180">用车事由</td>';
            html += '<td colspan="5" width="600">' + record.remarks + '</td>';

            html += '</tr>';

            html += '<tr><td width="120">目的地</td>';
            html += '<td colspan="5">' + (record.de ? record.de.name : record.destination) + '</td>';
            html += '</tr>';
            html += '<tr><td width="180">搭乘人员</td>';
            html += '<td colspan="5" width="200">';
            angular.forEach(record.passengers, function (u) {
                html += u.user.name + '&nbsp;';
            });
            html += record.out_passenger;
            html += '</td>';
            html += '</tr>';
            html += '<tr><td width="120">出发时间</td>';
            html += '<td width="200">' + record.start_time + '</td>';
            html += '<td width="120">申请人</td>';
            html += '<td width="200">' + record.user_name + '</td>';
            html += '<td width="120">科室负责人</td>';
            html += '<td width="200">' + record.dept_charge.name + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td width="120">审核部门填写</td>';
            html += '<td width="120">车牌号</td>';
            html += '<td width="200">' + record.plate_num + '</td>';
            html += '<td width="120">驾驶员</td>';
            html += '<td width="200">' + record.driver.name + '</td>';
            html += '<td width="120">派车人</td>';
            html += '<td width="200">' + record.confirm.name + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td width="120">驾驶员填写</td>';
            html += '<td width="120">出车前里程</td>';
            html += '<td width="200">' + record.pre_mile + '</td>';
            html += '<td width="120">收车后里程</td>';
            html += '<td width="200">' + record.later_mile + '</td>';
            html += '<td width="120">收车时间</td>';
            html += '<td width="300">' + record.end_time + '</td>';
            html += '</tr>';
            html += '</tbody></table></body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };


    });

angular.module('c.c')
    .controller('HaveGroupCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F, Dept) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1

            {
                title: '是否公开',
                filter: {is_public: 'select'},
                data: yesNoOpts,
                field: 'is_public',
                width: '10%',
                show: true
            }, //6
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                ContactGroup.query({opt: 3}, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                size: 'md'
            }).result.then(function (group) {
                ContactGroup.save(group).$promise.then(function (data) {
                    toaster.success('群添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('群添加失败!');
                });
            });
        };

        $scope.bind = function (group) {
            dialogs.create('templates/contactGroupBindDlg.html', 'ContactGroupBindDlgCtrl', {group: group}, {
                size: 'md'
            }).result.then(function (data) {
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('绑定信息修改成功!');
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('绑定信息修改失败!');
                });
            });
        };

        $scope.edit = function (group) {

            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
            if (group.dept_id) {
                group.$deptChanged = {id: group.dept_id, name: group.dept.name};
            } else {
                group.$deptChanged = {id: null, name: '暂无'};
            }
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                data['dept_id'] = group.$deptChanged.id;
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                    group.dept = group.$deptChanged;
                    group.dept_id = group.$deptChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('群记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该群的成员,因此无法删除该群!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('群记录删除失败!');
                });
            });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, {size: 'md'}).result.then(function () {
            }, function () {
                $scope.tableParams.reload();
            });
        };

    });

angular.module('c.c').controller('ContactGroupDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.yesNo = F.get('yesNo');

        $scope.group = {is_public: false, is_stop: false, type: '0'};

        $scope.ok = function (group) {
            if ($scope.g_form.$valid) {
                if (group.type != 0 && group.depts.length == 0) {

                    return toaster.warning('请填写科室!');

                }
                var params = {};
                params['name'] = group.name;
                params['is_public'] = group.is_public;
                params['is_stop'] = group.is_stop;
                params['type'] = group.type;
                params['depts'] = group.depts;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('ContactGroupBindDlgCtrl',
    function ($scope, $uibModalInstance, toaster, ContactGroup, data) {

        $scope.group = {type: data.group.type};


        ContactGroup.get({id: data.group.id}, function (resp) {
            $scope.group.depts = resp.depts;
        }, function (error) {
            toaster.error(error);
        });

        $scope.ok = function (group) {
            if ($scope.g_form.$valid) {
                if (group.type != 0 && group.depts.length == 0) {

                    return toaster.warning('请填写科室!');

                }
                var params = {};
                params['type'] = group.type;
                params['depts'] = group.depts;

                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


angular.module('c.c')
    .controller('MyGroupCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0

            {
                title: '是否公开',
                filter: {is_public: 'select'},
                data: yesNoOpts,
                field: 'is_public',
                width: '10%',
                show: true
            }, //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 54;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                ContactGroup.query({opt: 6}, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.delete = function (group) {
            dialogs.confirm('退出群', '您确定要退出<strong>' + group.name + '</strong>该群吗?')
                .result.then(function () {
                ContactGroup.delete({id: group.id, type: 1/* 退出用户所在该群*/}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('退出成功!');
                            break;
                        case 1:
                            toaster.warning('退出失败，您可能已经不在该群中!');
                            break;
                        case 2:
                            toaster.warning('退出失败，公开群不允许随意退出，请联系群管理员!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('退出失败!');
                });
            });

        };


    });
// angular.module('c.c').controller('DocAppliedCtrl',
//     function ($rootScope, $scope, $filter, $timeout, dialogs, toaster, C, F, NgTableParams, DocType, Doc) {
//         $scope.$on('docSubmit', function () {
//             $scope.tableParams.reload();
//         });
//
//         var results = Doc.getDocStepResults();
//         var stateOpts = F.getNgTableOpts(F.get('handle_states'));
//
//         $scope.cols = [
//             {title: '公文主题', filter: {subject: 'text'}, show: true},
//             {title: '类型', filter: {type_name: 'text'}, show: true},
//             {title: '归档科室', filter: {dept: 'text'}, show: true},
//             {title: '申请时间', filter: {created_at: 'date_range'}, show: true},
//             {title: '状态', filter: {state: 'select'}, data: stateOpts, show: true, width: '10%'}
//         ];
//
//         $scope.dateRangeFilter = {};
//         $scope.$watch('dateRangeFilter',
//             function (newValue, oldValue) {
//                 $scope.tableParams.reload();
//             }, true
//         );
//
//         $scope.optColWidth = 53;
//         $scope.tableParams = new NgTableParams({
//             page: 1, count: 10, sorting: {
//                 created_at: 'desc'
//             }
//         }, {
//             counts: [10, 30, 50], total: 0,
//             getData: function ($defer, params) {
//                 var url = params.url();
//                 url['opt'] = C.OPT.DOC.INDEX.USER_APPLIED;
//                 if ($scope.dateRangeFilter.created_at != null) {
//                     url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
//                     url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
//                 }
//                 Doc.query(url, function (resp) {
//                     params.total(resp.total);
//                     angular.forEach(resp.docs, function (doc) {
//                         doc.disable = doc.state != C.DOC.STATE.INIT;
//                         if (!doc.type) {
//                             doc.type = {name: '其他'};
//                         }
//                         if (doc.steps && doc.steps.length > 0) {
//                             doc.result = F.getItem(doc.steps[0].result, results);
//                         } else {
//                             doc.result = {name: '创建公文'};
//                         }
//                     });
//                     $defer.resolve(resp.docs);
//                 });
//             }
//         });
//
//         $scope.clearFilters = function () {
//             $scope.tableParams.filter({});
//             $scope.dateRangeFilter = {};
//         };
//
//         $scope.detail = function (doc) {
//             dialogs.create('templates/doc/show_dlg.html', 'DocShowDlgCtrl',
//                 {id: doc.id, forArchive: +doc.state > 2, canEdit: true},
//                 { size: 'lg'}).result.then(function (params) {
//                     switch (params.opt) {
//                         case C.DOC.EDIT:
//                             $scope.tabs['new'] = true;
//                             $timeout(function () {
//                                 $rootScope.$broadcast('docEdit', params.doc);
//                             }, 800);
//                             break;
//                     }
//                 });
//         };
//
//         $scope.delete = function (doc) {
//             dialogs.confirm('删除公文', '确定要删除<strong>' + doc.subject + '</strong>吗?')
//                 .result.then(function () {
//                     Doc.delete({id: doc.id}).$promise.then(function (resp) {
//                         switch (resp.result) {
//                             case 0:
//                                 toaster.success('删除成功!');
//                                 break;
//                             case 1:
//                                 toaster.warning('该公文已被处理,无法删除');
//                                 break;
//                         }
//                         $scope.tableParams.reload();
//                     }, function () {
//                         toaster.error('删除失败!');
//                     });
//                 });
//         };
//     });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('DocAppliedCtrl', DocAppliedCtrl);

    /** @ngInject */
    function DocAppliedCtrl($rootScope, $scope, $timeout, Table, $q, Doc, Dlg, UIHelper, ArrayHelper, C) {
        var vm = $scope;
        var results = Doc.getDocStepResults();
        var stateOpts = Table.getNgTableOpts(ArrayHelper.get('handle_states'));
        vm.detail = detail;
        vm.remove = remove;
        var states = ArrayHelper.get('handle_states');

        $scope.$on('docSubmit', function () {
            vm.tableReload();
        });


        init();

        function init() {
            UIHelper.loadTab(vm, 'applied');

            var options = {
                service: Doc,
                params: {opt: C.OPT.DOC.INDEX.USER_APPLIED}, /*已申请*/
                optInFront: true,
                optColWidth: Table._2_BTN,
                sorting: {created_at: 'desc'},
                items: 'docs',
                cols: [
                    {field: 'subject', title: '公文主题', filter: {subject: 'text'}},
                    {field: 'type_name', title: '类型', filter: {type_name: 'text'}},
                    {field: 'dept', title: '归档科室', filter: {dept: 'text'}},
                    {field: 'created_at', title: '申请时间', filter: {created_at: 'date_range'}},
                    {field: 'state', title: '状态', filter: {state: 'select'}, data: stateOpts, width: '10%'}
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.docs, function (item) {
                    item.disable = item.state != C.DOC.STATE.INIT;

                    item.state = ArrayHelper.getItem(item.state, states);
                })
            });
        }

        function detail(m) {
            Dlg.show({
                template: 'templates/doc/show_dlg.html',
                ctrl: 'DocShowDlgCtrl',
                data: {
                    id: m.id,
                    forArchive: +m.state.id > 2,
                    canEdit: true
                },
                size: 'lg'
            }).then(function (resp) {
                switch (resp.opt) {
                    case C.DOC.EDIT:
                        UIHelper.tabTo('new');
                        $timeout(function () {
                            $rootScope.$broadcast('docEdit', resp.doc);
                        }, 800);
                        break;
                }
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除<strong>' + m.subject + '</strong>吗?', function () {
                Doc.delete({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('删除成功!');
                            break;
                        case 1:
                            Dlg.w('该公文已被处理,无法删除');
                            break;
                    }
                    $scope.tableParams.reload();
                }, function () {
                    Dlg.e('删除失败!');
                });
            }, '删除公文')
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DocApprovalCtrl', DocApprovalCtrl)
        .controller('BindCustomTypeDlgCtrl', BindCustomTypeDlgCtrl)
    ;

    /** @ngInject */
    function DocApprovalCtrl($scope, Dlg, C, deviceDetector, ArrayHelper, Table, NgTableParams, Doc, DocCustomType) {
        //approval_list_dlg中使用
        $scope.$on('approval', function (event, data) {
            if (data.tab == 'doc') {
                $scope.tableParams.reload();
            }
        });

        $scope.$on('DocHandled', function () {
            $scope.tableParams.reload();
        });

        var results = Doc.getDocStepResults();
        var stateOpts = Table.getNgTableOpts(ArrayHelper.get('handle_states'));
        var isDesktop = deviceDetector.isDesktop();
        $scope.isDesktop = isDesktop;
        $scope.showSn = isDesktop;
        DocCustomType.query({op: 'options'}, function (resp) {
            var customTypes = Table.getNgTableOpts(resp.items);

            $scope.cols = [
                {title: '自定义类型', filter: {custom_type: 'select'}, data: customTypes, show: isDesktop, width: Table._3_CHAR},
                {title: '公文号', filter: {number: 'text'}, show: isDesktop, width: Table._4_BTN},
                {title: '公文主题', filter: {subject: 'text'}, show: true},
                {title: '类型', filter: {type_name: 'text'}, show: isDesktop},
                {title: '申请人', filter: {applicant: 'text'}, show: isDesktop, width: Table._3_BTN},
                {title: '申请时间', filter: {created_at: 'date_range'}, show: isDesktop},
                {title: '上一步处理时间', sortable: 'last_time', show: isDesktop, width: Table._4_BTN},
                {title: '状态', filter: {state: 'select'}, data: stateOpts, show: isDesktop, width: Table._3_BTN}
            ];


            $scope.optColWidth = Table._4_CHAR;
            $scope.tableParams = new NgTableParams({
                page: 1, count: 10, sorting: {
                    last_time: 'desc'
                }
            }, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = C.OPT.DOC.INDEX.APPROVAL_LIST;
                    Doc.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.docs, function (doc) {
                            if (!doc.type) {
                                doc.type = {name: '其他'};
                            }
                            if (doc.steps.length == 0) {
                                doc.result = {name: '待评论'};
                            } else if (doc.steps[0].prev) {
                                var r = ArrayHelper.getItem(doc.steps[0].prev.result, results);
                                doc.result = {name: '待' + r.name.substr(1)};
                            } else {
                                doc.result = {name: '待审批'};
                            }
                        });
                        //approval_list_dlg中使用
                        if ($scope.c) {
                            if (resp.total <= params.count()) {
                                $scope.c.doc = resp.docs.length;
                            } else {
                                $scope.c.doc = '> ' + params.count();
                            }
                        }
                        $defer.resolve(resp.docs);
                    });
                }
            });
        });

        $scope.handle = function (doc) {
            Dlg.show({
                template: 'templates/doc/show_dlg.html',
                ctrl: 'DocShowDlgCtrl',
                data: {
                    id: doc.id,
                    forHandle: true,
                    account_id: $scope.account.id
                },
                size: 'lg'
            }).then(function () {
                $scope.tableParams.reload();
            });
        };

        $scope.customType = function (doc) {
            Dlg.show({
                template: 'templates/doc/BindCustomTypeDlg.html',
                ctrl: 'BindCustomTypeDlgCtrl',
                data: {
                    id: doc.id
                }
            }).then(function () {
                $scope.tableParams.reload();
            });
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
    }

    /** @ngInject */
    function BindCustomTypeDlgCtrl(data, $uibModalInstance, Dlg, DocCustomType, Doc, FormHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);

        function init(id) {
            DocCustomType.query({op: 'options'}, function (resp) {
                vm.types = resp.items;
                vm.types.unshift({id: 0, name: '设置为空'});
                if (id) {
                    Doc.get({id: id}, function (resp) {
                        vm.m = resp.doc;
                    })
                } else {
                    vm.m = {};
                }
            });
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var promise;
                var pa = {
                    opt: 6,
                    custom_type_id: m.custom_type_relation.custom_type.id
                };
                promise = Doc.update({id: data.id}, pa).$promise;
                promise.then(function (resp) {
                    if (resp.msg) {
                        Dlg.s(resp.msg);
                    } else {
                        Dlg.s('修改成功');
                    }
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                    vm.close();
                });
            });
        }
    }

})();

angular.module('c.c').controller('DocApprovedCtrl',
    function ($rootScope, $scope, $filter, $timeout, deviceDetector, dialogs, toaster, C, F, Table, DocType, Doc, Dlg) {
        $scope.$on('DocHandled', function () {
            $scope.tableParams.reload();
        });
        $scope.pinYinSort = 1;
        $

        var results = Doc.getDocStepResults();
        var stateOpts = F.getNgTableOpts(F.get('handle_states'));
        var isDesktop = deviceDetector.isDesktop();
        $scope.isDesktop = isDesktop;
        $scope.showSn = isDesktop;
        var options = {
            service: Doc,
            params: {opt: C.OPT.DOC.INDEX.USER_HANDLED, pinyinSort: $scope.pinYinSort},
            optColWidth: Table._2_BTN,
            dateFilters: [{name: 'created_at'}],
            items: 'docs',
            cols: [
                {title: '公文号', filter: {number: 'text'}, show: isDesktop},
                {title: '公文主题', filter: {subject: 'text'}, show: true},
                {title: '类型', filter: {type_name: 'text'}, show: isDesktop},
                {title: '申请人', filter: {applicant: 'text'}, show: isDesktop},
                {title: '申请科室', filter: {dept_from: 'text'}, show: isDesktop},
                {title: '申请时间', filter: {created_at: 'date_range'}, show: isDesktop},
                {title: '状态', filter: {state: 'select'}, data: stateOpts, show: isDesktop, width: '10%'}
            ]
        };

        var optionFn = Table.loadNgTable($scope, options, function (data) {
            angular.forEach(data.docs, function (doc) {
                if (!doc.type) {
                    doc.type = {name: '其他'};
                }
                if (doc.steps && doc.steps.length > 0) {
                    doc.result = F.getItem(doc.steps[0].result, results);
                } else {
                    doc.result = {name: '创建公文'};
                }
            });
        }).options;

        $scope.detail = function (doc) {
            dialogs.create('templates/doc/show_dlg.html', 'DocShowDlgCtrl', {id: doc.id, forArchive: +doc.state > 2},
                {size: 'lg'});
        };
        $scope.changeSort = function () {
            if ($scope.pinYinSort > 0) {
                optionFn().params = {opt: C.OPT.DOC.INDEX.USER_HANDLED, pinyinSort: $scope.pinYinSort};
            } else {
                optionFn().params = {opt: C.OPT.DOC.INDEX.USER_HANDLED};
            }
            $scope.tableReload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.back = function (doc) {
            Dlg.confirm('确定要撤销已处理记录吗?', function () {
                Doc.update({id: doc.id}, {
                    opt: 9/*EDIT_BACK*/,
                    docStep: doc.userStep.id
                }).$promise.then(function (resp) {
                    console.log(resp);
                    if (resp.result == 1) {
                        Dlg.e(resp.msg);
                    } else {
                        Dlg.confirm('是否跳转到待处理界面？', function () {
                            $rootScope.$broadcast('DocHandled');
                            $scope.tabs['approval'] = true;
                        });
                    }
                    $scope.tableParams.reload();
                }, function () {
                    Dlg.e('操作失败!');
                });
            }, '撤销已处理公文');
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DocCustomTypeCtrl', DocCustomTypeCtrl)
        .controller('DocCustomTypeDlgCtrl', DocCustomTypeDlgCtrl)
    ;

    /** @ngInject */
    function DocCustomTypeCtrl ($scope, Table, Api, DocCustomType, Dlg, UIHelper) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.disable = disable;


        init();

        function init () {
            UIHelper.loadTab(vm, 'custom_type');
            var options = {
                service: DocCustomType,
                params: {op: 'record'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: 'name', title: '类型名称', filter: {name: 'text'}},
                    {field: 'color', title: '颜色'},
                    {field: 'sorting', title: '排序'}
                ]
            };
            Table.load(vm, options);
        }

        function addEdit(m) {
            var pa = {};
            if (m) {
                pa.id = m.id;
            }
            Dlg.show({
                template: 'DocCustomTypeEditDlg.html',
                ctrl: 'DocCustomTypeDlgCtrl',
                data: pa
            }).then(function (resp) {
                vm.tableReload();
            });
        }

        function disable(m) {
            Api.setDisable(DocCustomType, m);
        }
    }

    /** @ngInject */
    function DocCustomTypeDlgCtrl(data, $uibModalInstance, Dlg, DocCustomType, UIHelper, FormHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);

        function init(id) {
            if (id) {
                DocCustomType.get({id: id}, function (resp) {
                    vm.m = resp;
                });
            } else {
                vm.m = {sorting: 1};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var promise;
                var pa = {
                    op: 'default',
                    name: m.name,
                    color: m.color,
                    fore_color: UIHelper.isTooDark(m.color) ? 'white' : 'black',
                    sorting: m.sorting
                };

                if (m.id) { //修改
                    promise = DocCustomType.update({id: m.id}, pa).$promise;
                } else { //添加
                    promise = DocCustomType.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) {
                        Dlg.s(resp.msg);
                    } else {
                        Dlg.s('保存成功');
                    }
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                    vm.close();
                });
            });
        }
    }

})();




(function () {
    'use strict';

    angular.module('c.c')
        .controller('DocDraftCtrl', DocDraftCtrl);

    /** @ngInject */
    function DocDraftCtrl ($rootScope, $scope, $timeout, Table, $q, Doc, Dlg, UIHelper) {
        var vm = $scope;
        var checker = Table.loadMultiSelectedFn(vm);
        vm.relaunch = relaunch;
        vm.remove = remove;


        init();

        function init () {
            UIHelper.loadTab(vm, 'draft');
            var options = {
                service: Doc,
                params: {opt: 11}, /*草稿箱*/
                optInFront: true,
                optColWidth: Table._2_BTN,
                sorting: {},
                items: 'docs',
                cols: [
                    {field: 'subject', title: '公文主题', filter: {subject: 'text'}},
                    {field: 'type', title: '类型', filter: {type: 'text'}, width: '20%'},
                    {field: 'dept', title: '归档科室', filter: {dept: 'text'}, width: '20%'},
                    {
                        field: 'created_at',
                        title: '创建时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        width: '20%'
                    }
                ]
            };
            Table.load(vm, options);
        }

        function relaunch (doc) {
            $scope.tabs['new'] = true;
            $timeout(function () {
                $rootScope.$broadcast('docEdit', doc);
            }, 800);
        }

        function remove (isBatch, m) {
            var defer = $q.defer();
            var items = [];
            var count = 0;
            if (isBatch) {
                items = checker.getChecked();
                count = items.length;
                if (count === 0) {
                    checker.clearChecked();
                    Dlg.w("请至少选中一个待处理选项");
                    return;
                }
            } else {
                items.push(m);
                count = 1;
            }
            angular.forEach(items, function (item) {
                var tip = "主题为" + item.subject + '公文';
                Doc.delete({id: item.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('删除成功!');
                            break;
                        case 1:
                            Dlg.w('该公文已被处理,无法删除');
                            break;
                    }
                }, function (error) {
                    var resp = error.data;
                    Dlg.e(tip + "删除失败：" + resp.msg);
                }).finally(function () {
                    count--;
                    if (count === 0) {
                        defer.resolve();
                        checker.clearChecked();
                        vm.tableReload();
                    }
                });
            });
            return defer.promise;
        }
    }

})();




(function () {
    'use strict';

    angular.module('c.c')
        .controller('DocFollowCtrl', DocFollowCtrl);

    /** @ngInject */
    function DocFollowCtrl($rootScope, $scope, $filter, $timeout, deviceDetector, dialogs, toaster, C, F, Table, DocType, Doc, Dlg) {
        var vm = $scope;

        var results = Doc.getDocStepResults();
        var stateOpts = F.getNgTableOpts(F.get('handle_states'));
        var isDesktop = true;
        vm.isDesktop = isDesktop;
        vm.showSn = isDesktop;
        var checker = Table.loadMultiSelectedFn(vm);
        vm.detail = detail;
        vm.notFollow = notFollow;


        init();

        function init () {
            vm.$on('DocFollow', function () {
                vm.tableParams.reload();
            });
            vm.pinYinSort = 1;

            var options = {
                service: Doc,
                params: {opt: C.OPT.DOC.INDEX.USER_FOLLOW, pinyinSort: vm.pinYinSort},
                optInFront: true,
                hideOpt: true,
                dateFilters: [{name: 'created_at'}],
                items: 'docs',
                cols: [
                    {field: 'number', title: '公文号', filter: {number: 'text'}, show: isDesktop},
                    {field: 'subject', title: '公文主题', filter: {subject: 'text'}, show: true},
                    {field: 'type', title: '类型', filter: {type_name: 'text'}, show: isDesktop},
                    {field: 'applicant', title: '申请人', filter: {applicant: 'text'}, show: isDesktop},
                    {field: 'dept_from', title: '申请科室', filter: {dept_from: 'text'}, show: isDesktop},
                    {field: 'created_at', title: '申请时间', filter: {created_at: 'date_range'}, show: isDesktop},
                    {field: 'result', title: '状态', filter: {state: 'select'}, data: stateOpts, show: isDesktop, width: '10%'}
                ]
            };

            var optionFn = Table.load(vm, options, function (data) {
                angular.forEach(data.docs, function (doc) {
                    if (!doc.type) {
                        doc.type = {name: '其他'};
                    }
                    if (doc.steps && doc.steps.length > 0) {
                        doc.result = F.getItem(doc.steps[0].result, results);
                    } else {
                        doc.result = {name: '创建公文'};
                    }
                });
            }).options;
            console.log(checker);
        }

        function detail (doc) {
            dialogs.create('templates/doc/show_dlg.html', 'DocShowDlgCtrl', {id: doc.id, forArchive: true},
                { size: 'lg'});
        }

        function notFollow () {
          var count = checker.getCheckedIds().length;
          if (count === 0) {
              checker.clearChecked();
              Dlg.w("请至少选中一个待处理选项");
              return;
          } else {
            Doc.update({id: '-', opt: 8}, {ids: checker.getCheckedIds()}).$promise.then(
                function() {
                    Dlg.s('取消关注成功!');
                    vm.tableParams.reload();
                },
                function() {
                    Dlg.e('取消关注失败!');
                }
            ).finally(function() {
                defer.resolve();
                vm.tableReload();
            });
          }
        }

        function clearFilters () {
            vm.dateRangeFilter = {};
            vm.tableParams.filter({});
        }

        function changeSort () {
            if (vm.pinYinSort === 1) {
                optionFn().params = {opt: C.OPT.DOC.INDEX.USER_FOLLOW, pinyinSort: vm.pinYinSort};
            } else {
                optionFn().params = {opt: C.OPT.DOC.INDEX.USER_FOLLOW};
            }
            vm.tableReload();
        }
    }

})();





angular.module('c.c').controller('DocNewCtrl',
    function ($rootScope, $scope, dialogs, toaster, Upload, SaveAs, $q, $sce, C, F, DocType, Dept, Doc, FileHelper, Dlg) {
        $scope.$on('docEdit', function (ev, doc) {
            doc.is_urgent = doc.is_urgent == '1';
            doc.isTmpStep = false;
            doc.isTmpStepVote = false;
            if ($scope.types) {
                doc.type = F.getItem(doc.type_id, $scope.types);
                $scope.typeSelectedFn(doc.type, doc);
            }
            // if ($scope.depts) {
            //     doc.dept = F.getItem(doc.dept_id, $scope.depts);
            // doc.dept_from = null;
            // }
            // doc.attachments = [];
            // angular.forEach(doc.attachments, function (attachment) {
            //     attachment.removeTip = true;
            // });

            $scope.doc = doc;
        });

        $scope.$on('docAdd', function (ev, data) {
            var doc = {
                is_urgent: false, body: '', handler_type: C.DOC.HANDLE_BY.DEPT_LEADER, attachments: [],
                isTmpStep: false, evaluators: [], isFront: false, type_id: data.type_id
            };
            if ($scope.types) {
                doc.type = F.getItem(data.type_id, $scope.types);
                $scope.typeSelectedFn(doc.type, doc);
            }

            $scope.doc = doc;
        });

        var results = Doc.getDocStepResults();

        DocType.query({opt: C.OPT.DOC_TYPE.INDEX.OPTIONS}, function (resp) {
            var types = resp.types;
            angular.forEach(types, function (type) {
                if (type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS) {
                    angular.forEach(type.steps, function (step) {
                        step.result = F.getItem(step.result, results);
                    });
                }
            });
            types.splice(0, 0, {name: '其他', dept: {name: '其他'}, attachments: []});
            if ($scope.doc) {
                if ($scope.doc.type_id) {
                    $scope.doc.type = F.getItem($scope.type_id, types);
                } else {
                    //$scope.doc.type = types[0];
                }
            }
            $scope.types = types;
        });

        $scope.aiReview = function (doc) {
            var defer = $q.defer();
            if (doc.body) {
                $scope.aiReviewing = true;
                Doc.ai_review({
                    requirement: doc.type.note ? doc.type.note : '无额外要求',
                    body: doc.body, template: doc.type.body ?
                        doc.type.body : '无模板'
                })
                    .$promise.then(function (resp) {
                    $scope.aiReviewed = true;
                    $scope.aiReviewResult = resp.result;
                    $scope.aiCorrectedContent = resp.aiCorrectedContent;
                    $scope.trustAiCorrectedContent = $sce.trustAsHtml(resp.aiCorrectedContent);
                    $scope.reviewComment = $sce.trustAsHtml(resp.reviewComment);
                }, function (err) {
                    Dlg.error(err.data.msg);
                }).finally(function () {
                    $scope.aiReviewing = false;
                    defer.resolve();
                });
            } else {
                Dlg.notify("公文内容不能为空").finally(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        }

        $scope.typeDetail = function (type) {
            dialogs.create('templates/doc/process_dlg.html', 'ProcessDlgCtrl', {steps: type.steps}, {
                size: 'md'
            });
        };

        $scope.isTmpStepChange = function (m, isTmpStep) {
            if (isTmpStep) {
                if (m.isTmpStep) m.isTmpStepVote = false;
            } else {
                if (m.isTmpStepVote) m.isTmpStep = false;
            }
        };

        $scope.typeDn = function (type) {
            FileHelper.download1(C.URL.DOC_TYPE_DOWNLOAD, type, {name: 'attach_name'});
        };

        $scope.docTypeFn = function (type) {
            return type.dept.name;
        };

        function getFixedHandler(doc, type) {
            var step = type.steps[0];
            doc.handler_type = step.handler_type;
            switch (step.handler_type) {
                case C.DOC.HANDLE_BY.DEPT:
                    doc.dept_to = step.dept;
                    break;
                case C.DOC.HANDLE_BY.USER:
                    doc.handler = step.handler;
                    break;
            }
        }

        $scope.typeSelectedFn = function (type, doc) {
            doc.isTmpStep = false;
            doc.isTmpStepVote = false;
            $scope.aiReviewed = false;
            if (type.desc_way == C.DOC.DESC_BY.FIXED_PROCESS) {
                $scope.disable = true;
                getFixedHandler(doc, type);
            } else {
                $scope.disable = false;
                doc.handler_type = C.DOC.HANDLE_BY.DEPT_LEADER;
            }

            if (type.id) {
                DocType.get({id: type.id, opt: C.OPT.DOC_TYPE.SHOW.BODY}, function (resp) {
                    var body = doc.type.body = resp.type.body;
                    if (body != null && body != '') {
                        if (doc.body != null && doc.body != '') {
                            dialogs.confirm('提示', '改变类型会在正文中导入该类型公文的内容模板,<strong>确认</strong>导入,或者<strong>取消</strong>以保留当前正文内容?')
                                .result.then(function () {
                                doc.body = body;
                            });
                        } else {
                            doc.body = body;
                        }
                    }
                });
            }
        };

        Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
            var depts = resp.depts;
            if ($scope.doc) {
                if ($scope.doc.dept_id) {
                    $scope.doc.dept = F.getItem($scope.dept_id, depts);
                }
            }
            $scope.depts = depts;
        });

        Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS2}, function (resp) {
            var depts = resp.depts;
            if ($scope.doc) {
                if ($scope.doc.dept_from_id) {
                    $scope.doc.dept_from = F.getItem($scope.dept_from_id, depts);
                } else {
                    $scope.doc.dept_from = depts[0];
                }
            }
            $scope.depts_from = depts;
        });

        $scope.deleteAttachment = function ($index, doc) {
            doc.attachments.splice($index, 1);
        };

        $scope.upload = function (file, doc, e) {
            FileHelper.upload(C.URL.DOC_UPLOAD, file, doc, e);
        };

        $scope.submitting = false;
        $scope.submit = function (doc, isDraft) {
            if (doc.type && doc.type.attachments.length > 0 && doc.attachments.length == 0) {
                Dlg.confirm('未按模板上传附件，继续提交?', function () {
                    doSubmit();
                });
            } else {
                doSubmit();
            }

            function doSubmit() {
                var promise = submitEmail(doc, isDraft);
                if (promise) {
                    if (isDraft) {
                        promise.then(function (resp) {
                            toaster.success('公文已保存为草稿!');
                            $scope.reset();
                            $scope.submitting = false;
                        }, function () {
                            toaster.error('公文保存失败了!');
                            $scope.submitting = false;
                        });
                    } else {
                        promise.then(function (resp) {
                            toaster.success('提交成功!');
                            $scope.reset();
                            $rootScope.$broadcast('docSubmit');
                            $scope.tabs['applied'] = true;
                            $scope.submitting = false;
                        }, function () {
                            toaster.error('公文提交失败了!');
                            $scope.submitting = false;
                        });
                    }
                }
            }
        };

        function submitEmail(doc, isDraft) {
            var promise = null;
            if (doc.subject == null || doc.subject == "") {
                toaster.warning('公文主题不能为空!');
            } else if (doc.type == null) {
                toaster.warning('请选择公文类型!');
            } else if (!doc.type.id && doc.dept == null) {
                toaster.warning('请选择归档科室!');
            } else if (doc.isTmpStep && doc.evaluators.length == 0) {
                toaster.warning('请选择评估人!');
            } else if (doc.isTmpStepVote && doc.evaluators.length == 0) {
                toaster.warning('请选择投票人!');
            } else if (doc.handler_type == C.DOC.HANDLE_BY.USER && doc.handler == null) {
                toaster.warning('请填写处理人!');
            } else if (doc.handler_type == C.DOC.HANDLE_BY.DEPT && doc.dept_to == null) {
                toaster.warning('请选择职能科室!');
            } else if (doc.body == null || doc.body == "") {
                toaster.warning('公文内容不能为空!');
            } else if (!FileHelper.isAttachmentsUploaded(doc)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {is_draft: isDraft};
                params['subject'] = doc.subject;
                params['dept_from_id'] = doc.dept_from.id;
                if (doc.type.id) {
                    params['type_id'] = doc.type.id;
                    params['dept_id'] = doc.type.dept.id;
                } else {
                    params['dept_id'] = doc.dept.id;
                }
                params['handler_type'] = doc.handler_type;
                switch (doc.handler_type) {
                    case C.DOC.HANDLE_BY.DEPT:
                        params['dept_to_id'] = doc.dept_to.id;
                        break;
                    case C.DOC.HANDLE_BY.USER:
                        params['handler_id'] = doc.handler.id;
                        break;
                }
                params['is_urgent'] = doc.is_urgent ? '1' : '0';
                params['body'] = doc.body;
                params['attachments'] = [];
                angular.forEach(doc.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                params['isTmpStep'] = doc.isTmpStep;
                params['isTmpStepVote'] = doc.isTmpStepVote;
                params['anonymous'] = doc.anonymous;

                if (doc.isTmpStep || doc.isTmpStepVote) {
                    params['evaluators'] = [];
                    angular.forEach(doc.evaluators, function (evaluator) {
                        params['evaluators'].push(evaluator.id);
                    });
                    params['isFront'] = doc.isFront;
                }
                if (doc.is_draft && doc.id) {//从草稿转向提交
                    params['delete_old_id'] = doc.id;
                }
                if (!$scope.submitting) {
                    $scope.submitting = true;
                    promise = Doc.save(params).$promise;
                }
            }
            return promise;
        }

        $scope.reset = function () {
            var doc = {
                is_urgent: false, body: '', handler_type: C.DOC.HANDLE_BY.DEPT_LEADER, attachments: [],
                isTmpStep: false, evaluators: [], isFront: false, isTmpStepVote: false
            };
            //if ($scope.types) {
            //    doc['type'] = $scope.types[0];
            //}
            if ($scope.depts_from) {
                doc['dept_from'] = $scope.depts_from[0];
            }
            $scope.doc = doc;
        };

        $scope.reset();
    });


angular.module('c.c').controller('DocRedCtrl',
    function ($rootScope, $scope, $filter, $timeout, dialogs, toaster, C, F, Table, NgTableParams, Doc) {

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var states = F.get('handle_states');
        $scope.xxx = states;
        var stateOpts = F.getNgTableOpts(states);
        $scope.cols = [
            {title: '主题', filter: {subject: 'text'}, show: true},
            {title: '类型', show: true},
            {title: '申请人', filter: {applicant: 'text'}, show: true},
            {title: '申请科室', show: true},
            {title: '申请时间', filter: {created_at: 'date_range'}, show: true},
            {title: '状态', filter: {state: 'select'}, data: stateOpts, show: true, width: '10%'}
        ];

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                number: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.DOC.INDEX.RED;
                Table.query(Doc, url, $defer, params, 'docs', function (resp) {
                    angular.forEach(resp.docs, function (doc) {
                        doc.state = F.getItem(doc.state, states);
                        if (!doc.type) {
                            doc.type = {name: '其他'};
                        }
                    });
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.detail = function (doc) {
            dialogs.create('templates/doc/show_dlg.html', 'DocShowDlgCtrl', {id: doc.id},
                {size: 'lg'});
        };
    });
angular.module('c.c')
    .controller('RuleRedHeadApprovalCtrl', function ($rootScope, $scope, $filter, dialogs, toaster, NgTableParams,
                                                     Table, C, F, Rule) {
        //approval_list_dlg中使用
        $scope.$on('approval', function (event, data) {
            if (data.tab == 'red_head') {
                $scope.tableParams.reload();
            }
        });

        $scope.$on('ruleBack', function () {
            $scope.tableParams.reload();
        });
        $scope.stages = F.get('approval_stages7');

        $scope.cols = [
            {title: '标题', show: true},
            {title: '关键词', show: true},
            {title: '类型', show: true},
            {title: '发布人', show: true},
            {title: '发布时间', show: true},
            {title: '状态', show: true}
        ];

        $scope.optColWidth = 53;
        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.RULE.INDEX.RED_HEAD_APPROVAL_LIST;
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    //approval_list_dlg中使用
                    if ($scope.c) {
                        if (data.total <= params.count()) {
                            $scope.c.red_head = data.rules.length;
                        } else {
                            $scope.c.red_head = '> ' + params.count();
                        }
                    }
                    angular.forEach(data.rules, function (rule) {
                        rule.red_head = F.getItem(rule.red_head, $scope.stages);
                    });
                });
            }
        });

        $scope.approval = function (rule) {
            dialogs.create('templates/rule/edit_dlg.html', 'RuleEditDlgCtrl', {
                id: rule.id, ForRedHead: true
            }, {size: 'lg'}).result.then(function (params) {
                Rule.update({id: rule.id}, params).$promise.then(
                    function (resp) {
                        toaster.success('套红头规章制度审批成功');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('套红头规章制度审批失败了!');
                    }
                );
            });
        }
    });


angular.module('c.c')
    .controller('UserDutyFeeCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ReportMember, F) {

        var yesOrNo = F.getNgTableOpts(F.get('yesNo'));

        $scope.cols = [
            {title: '值班月份', filter: {month: 'date_range'}, field: 'month', width: '20%', show: true},
            {
                title: '值班组',
                filter: {'duty_groups.name': 'text'},
                filed: 'group_name',
                width: '20%',
                show: true
            },
            {
                title: '值班次数',
                sortable: 'count',
                filter: {count: 'number_range'},
                field: 'count',
                width: '20%',
                show: true
            }, //6
            {
                title: '值班费用',
                sortable: 'duty_fee',
                filter: {duty_fee: 'number_range'},
                field: 'duty_fee',
                width: '20%',
                show: true
            }, //6
            {
                title: '是否发放',
                filter: {'is_payed': 'select'},
                field: 'is_payed',
                width: '20%',
                data: yesOrNo,
                show: true
            } //0
        ];
        //$scope.optColWidth = 70;
        $scope.hideOpt = true;


        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                'duty_reports.created_at': 'desc'
            }
        }, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.numRangeFilter.count) {
                    url['count_start'] = $scope.numRangeFilter.count.start;
                    url['count_end'] = $scope.numRangeFilter.count.end;
                }
                if ($scope.numRangeFilter.total_count) {
                    url['duty_fee_start'] = $scope.numRangeFilter.duty_fee.start;
                    url['duty_fee_end'] = $scope.numRangeFilter.duty_fee.end;
                }
                url['date_range_filters'] = $scope.dateRangeFilter;
                url['opt'] = 1;
                ReportMember.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.members);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.numRangeFilter = {};
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('HisSchedulesCtrl', HisSchedulesCtrl)
        .controller('HisScheduleDlgCtrl', HisScheduleDlgCtrl);

    function HisSchedulesCtrl($scope, $filter, Dlg, toaster, DateHelper,
                              DutyGroup, Schedule, NgTableParams, F) {
        $scope.dt = new Date();
        $scope.prevWeek = function (curr) {
            var prev = curr.getDate() - curr.getDay() - 6;
            $scope.dt = new Date(curr.setDate(prev));
        };
        $scope.nextWeek = function (curr) {
            var next = curr.getDate() - curr.getDay() + 8;
            $scope.dt = new Date(curr.setDate(next));
        };

        DutyGroup.query({opt: 7}, function (resp) {
            $scope.groups = resp.groups;
        });

        $scope.groupSelectedFn = function (group) {
            if (group) {
                $scope.group = group;
                $scope.tableParams.$params.page = 1;
                $scope.tableParams.reload();
            }
        };

        var week_days = F.get('weekdays');
        $scope.weekDays = [];
        $scope.$watch('dt', function (newVal, oldVal, scope) {
            var curr = newVal;
            if ($scope.weekDays.length == 0 || (curr < scope.weekDays[0] || curr > scope.weekDays[6])) {
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        scope.weekDays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = scope.weekDays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        scope.weekDays[i] = now;
                    }
                    var d = scope.weekDays[i];
                    $scope.cols[i + 1].title = week_days[i].name + ' ' + d.getDate();
                    $scope.cols[i + 1].field = 'Date' + $filter('date')(d, 'yyyy-MM-dd');
                }
                $scope.tableParams.reload();
            }
            DateHelper.linarCalendar($scope, $scope.weekDays, $scope.dt);
        }, true);

        $scope.cols = [
            {title: '姓名', field: 'name', width: '12.5%', show: true},
            {title: '周一', field: 'mon', width: '12.5%', show: true},
            {title: '周二', field: 'tue', width: '12.5%', show: true},
            {title: '周三', field: 'wed', width: '12.5%', show: true},
            {title: '周四', field: 'thu', width: '12.5%', show: true},
            {title: '周五', field: 'fri', width: '12.5%', show: true},
            {title: '周六', field: 'sat', width: '12.5%', show: true},
            {title: '周日', field: 'sun', width: '12.5%', show: true}
        ];

        $scope.tableParams = new NgTableParams({page: 1, count: 50, sorting: {created_at: 'desc'}}, {
            counts: [999], total: 0,
            getData: function ($defer, params) {
                if ($scope.group && $scope.weekDays.length == 7) {
                    var url = params.url();
                    url['opt'] = 6;
                    url['group_id'] = $scope.group.rw;
                    url['start'] = $scope.cols[1].field.substr(4, 10);
                    url['end'] = $scope.cols[7].field.substr(4, 10);
                    Schedule.query(url, function (resp) {
                        var members = [];
                        params.total(resp.total);
                        angular.forEach(resp.members, function (m) {
                            if (m.RealPerName) {
                                members.push(m);
                            }
                            // m.dateKeySchedules[s.shift_date] = s;
                        });
                        $scope.members = members;
                        $defer.resolve(resp.members);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.hideFilter = true;
        $scope.hideOpt = true;
        $scope.justDataCol = true;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.show = function (s, m, f) {
            Dlg.show({
                template: 'HisScheduleDlg.html',
                ctrl: 'HisScheduleDlgCtrl',
                data: {
                    dr: m.ArgPerDR,
                    date: f.substr(4, 10),
                    name: m.RealPerName
                },
            })
        }
    }

    function HisScheduleDlgCtrl($scope, $uibModalInstance, Schedule, data, Dlg, FormHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data);

        function init(m) {
            vm.m = m;
            Schedule.query({opt: 7, dr: m.dr, date: m.date}, function (resp) {
                vm.items = resp.records;
            });
        }
    }
})
();
angular.module('c.c')
    .controller('UserScheduleCtrl', function ($scope, $filter, dialogs, toaster, DateHelper,
                                              DutyGroup, Schedule, NgTableParams, F) {

        $scope.dt = new Date();

        $scope.prevWeek = function (curr) {
            var prev = curr.getDate() - curr.getDay() - 6;
            $scope.dt = new Date(curr.setDate(prev));
        };
        $scope.nextWeek = function (curr) {
            var next = curr.getDate() - curr.getDay() + 8;
            $scope.dt = new Date(curr.setDate(next));
        };

        var lastGroupId = null;
        $scope.groupSelectedFn = function ($index) {
            $scope.group = $scope.groups[$index];
            lastGroupId = $scope.group.id;
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        var week_days = F.get('weekdays');
        $scope.weekDays = [];

        $scope.$watch('dt', function (newVal, oldVal, scope) {
            var curr = newVal;
            if ($scope.weekDays.length == 0 || (curr < scope.weekDays[0] || curr > scope.weekDays[6])) {
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        scope.weekDays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = scope.weekDays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        scope.weekDays[i] = now;
                    }
                    var d = scope.weekDays[i];
                    $scope.cols[i + 1].title = week_days[i].name + ' ' + d.getDate();
                    $scope.cols[i + 1].field = $filter('date')(d, 'yyyy-MM-dd');
                }
                $scope.group = null;
                $scope.tableParams.reload();
            }
            DateHelper.linarCalendar($scope, $scope.weekDays, $scope.dt);
        }, true);

        $scope.cols = [
            {title: '成员', field: 'member', width: '12.5%', show: true},
            {title: '周一', field: 'mon', width: '12.5%', show: true},
            {title: '周二', field: 'tue', width: '12.5%', show: true},
            {title: '周三', field: 'wed', width: '12.5%', show: true},
            {title: '周四', field: 'thu', width: '12.5%', show: true},
            {title: '周五', field: 'fri', width: '12.5%', show: true},
            {title: '周六', field: 'sat', width: '12.5%', show: true},
            {title: '周日', field: 'sun', width: '12.5%', show: true}
        ];

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [], total: 0,
            getData: function ($defer, params) {
                if ($scope.weekDays.length == 7) {
                    if (!$scope.group) {
                        DutyGroup.query({
                            opt: 6, start: $scope.cols[1].field,
                            end: $scope.cols[7].field
                        }, function (resp) {
                            $scope.groups = resp.groups;
                            if (resp.groups && resp.groups.length > 0) {
                                if (lastGroupId) {
                                    var i = F.indexOfKey(lastGroupId, resp.groups);
                                    $scope.groupSelectedFn(i < 0 ? 0 : i);
                                } else {
                                    $scope.groupSelectedFn(0);
                                }
                            } else {
                                $defer.resolve([]);
                            }
                        });
                    } else {
                        var url = params.url();
                        url['opt'] = 3;
                        url['group_id'] = $scope.group.id;
                        url['start'] = $scope.cols[1].field;
                        url['end'] = $scope.cols[7].field;
                        url['member_id'] = $scope.account.id;
                        Schedule.query(url, function (resp) {
                            params.total(resp.total);
                            angular.forEach(resp.members, function (m) {
                                m.dateKeySchedules = [];
                                angular.forEach(m.schedules, function (s) {
                                    m.dateKeySchedules[s.shift_date] = s;
                                });
                            });
                            $scope.members = resp.members;
                            $defer.resolve(resp.members);
                        });
                    }
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.hideFilter = true;
        $scope.hideOpt = true;
        $scope.justDataCol = true;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

    });
angular.module('c.c')
    .controller('UserSchedulesCtrl', function ($scope, $filter, $timeout, $templateRequest, $sce,
                                               dialogs, toaster, DateHelper, SeniorityStandard, ArrayHelper,
                                               DutyGroup, Schedule, NgTableParams, F) {

        $scope.dt = new Date();
        $scope.prevWeek = function (curr) {
            var prev = curr.getDate() - curr.getDay() - 6;
            $scope.dt = new Date(curr.setDate(prev));
        };
        $scope.nextWeek = function (curr) {
            var next = curr.getDate() - curr.getDay() + 8;
            $scope.dt = new Date(curr.setDate(next));
        };

        DutyGroup.query({opt: 4}, function (resp) {
            $scope.groups = resp.groups;
            if (resp.groups && resp.groups.length > 0) {
                DutyGroup.query({opt: 6}, function (resp) {
                    $scope.groupSelectedFn(resp.groups[0]);
                });
            }
        });

        SeniorityStandard.query(function (resp) {
            // console.log('resp', resp);
            $scope.standards = resp;
        });

        $scope.memberSelectedFn = function (m) {
            $scope.member = m;
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.groupSelectedFn = function (group) {
            if (group) {
                $scope.group = group;
                DutyGroup.index_members({id: group.id, opt: 1}, function (resp) {
                    resp.members.splice(0, 0, {name: '全部成员'});
                    $scope.mopts = resp.members;
                    $scope.member = $scope.mopts[0];
                });
                $scope.tableParams.$params.page = 1;
                $scope.tableParams.reload();
            }
        };

        var week_days = F.get('weekdays');
        $scope.weekDays = [];
        $scope.$watch('dt', function (newVal, oldVal, scope) {
            var curr = newVal;
            if ($scope.weekDays.length == 0 || (curr < scope.weekDays[0] || curr > scope.weekDays[6])) {
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        scope.weekDays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = scope.weekDays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        scope.weekDays[i] = now;
                    }
                    var d = scope.weekDays[i];
                    $scope.cols[i + 1].title = week_days[i].name + ' ' + d.getDate();
                    $scope.cols[i + 1].field = $filter('date')(d, 'yyyy-MM-dd');
                }
                $scope.tableParams.reload();
            }
            DateHelper.linarCalendar($scope, $scope.weekDays, $scope.dt);
        }, true);

        $scope.cols = [
            {title: '成员', field: 'member', width: '12.5%', show: true},
            {title: '周一', field: 'mon', width: '12.5%', show: true},
            {title: '周二', field: 'tue', width: '12.5%', show: true},
            {title: '周三', field: 'wed', width: '12.5%', show: true},
            {title: '周四', field: 'thu', width: '12.5%', show: true},
            {title: '周五', field: 'fri', width: '12.5%', show: true},
            {title: '周六', field: 'sat', width: '12.5%', show: true},
            {title: '周日', field: 'sun', width: '12.5%', show: true}
        ];

        $scope.tableParams = new NgTableParams({page: 1, count: 50, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.group && $scope.weekDays.length == 7) {
                    var url = params.url();
                    url['opt'] = 1;
                    url['group_id'] = $scope.group.id;
                    url['start'] = $scope.cols[1].field;
                    url['end'] = $scope.cols[7].field;
                    url['exclude_draft'] = true;
                    if ($scope.member) {
                        url['member_id'] = $scope.member.member_id;
                    }
                    Schedule.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.members, function (m) {
                            m.dateKeySchedules = [];
                            angular.forEach(m.schedules, function (s) {
                                m.dateKeySchedules[s.shift_date] = s;
                            });
                        });
                        angular.forEach(resp.members, function (m) {
                            if (m.member.type_id == 2 && m.member.nurse_seniority) {
                                m.standard = ArrayHelper.getItem(m.member.nurse_seniority.seniority_id, $scope.standards);
                            }
                        });
                        $scope.members = resp.members;

                        angular.forEach(resp.temp_members, function (m) {
                            m.dateKeySchedules = [];
                            angular.forEach(m.schedules, function (s) {
                                m.dateKeySchedules[s.shift_date] = s;
                            });
                        });
                        $scope.temp_members = resp.temp_members;
                        $defer.resolve(resp.members);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.hideFilter = true;
        $scope.hideOpt = true;
        $scope.justDataCol = true;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.exportSchedules = function () {
            if ($scope.group) {
                dialogs.create('templates/export_schedule_dlg.html', 'ExportScheduleCtrl',
                    {
                        group: $scope.group, start: $scope.weekDays[0], end: $scope.weekDays[6]
                    },
                    {size: 'md'});
            }
        };

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/table.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.printSchedules = function (members) {
            if (!$scope.group) {
                return;
            }

            var w = window.open("", "打印预览");

            var html = '<html><body>';

            var start = $scope.weekDays[0];
            var end = $scope.weekDays[6];
            start = $filter('date')(start, 'yyyy年MM月dd日');
            end = $filter('date')(end, 'yyyy年MM月dd日');

            html += '<table class="print">' +
                '<caption>' + start + ' - ' + end + $scope.group.name + '排班表</caption>' +
                '<thead><tr>';
            angular.forEach($scope.cols, function (c) {
                html += '<th>' + c.title + '</th>';
            });
            html += '</tr></thead><tbody>';

            angular.forEach($scope.members, function (m) {
                html += '<tr>';
                angular.forEach($scope.cols, function (c) {
                    html += '<td>';
                    if (c.field == 'member') {
                        html += m.member.name;
                    } else {
                        var schedule = m.dateKeySchedules[c.field];
                        if (schedule && schedule.stage != 1) {
                            var shifts = schedule.shifts;
                            html += '<div class="cell">';
                            angular.forEach(shifts, function (s) {
                                html += '<div class="shift-item">';

                                var name = s.name;
                                if (s.type_id == 3) {//TYPE_ASK4LEAVE
                                    name = '<strong>' + name + '</strong>';
                                }
                                html += name + '</div>'
                            });
                            html += '</div>';
                        }
                    }
                    html += '</td>';
                });
                html += '</tr>';
            });

            html += '</tbody></table>';

            html += '<br>';

            html += '<br>';

            html += '<div style="border:3px solid black; height: 100px;">备注:</div>';

            html += '</body></html>';


            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };
    });
angular.module('c.c')
    .controller('ApprovedLeaveCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, AskForLeave, SaveAs, F) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');
        var statues = F.getNgTableOpts(F.get('processStatus'));
        $scope.statues = F.get('processStatus');

        $scope.cols = [
            {
                title: '类别',
                sortable: 'leave_type_id',
                filter: {leave_type_id: 'select'},
                field: 'leave_type_id',
                width: '8%',
                show: true
            }, //6
            {title: '事由', filter: {leave_reason: 'text'}, field: 'leave_reason', show: true}, //6
            {title: '天数', field: 'day_num', show: true}, //6
            {
                title: '补助与机票',
                sortable: 'is_subsidy',
                filter: {is_subsidy: 'select'},
                field: 'is_subsidy',
                width: '100',
                data: yesNoOpts,
                show: true
            }, //6
            // {
            //     title: '是否离开大成都范围',
            //     sortable: 'is_leave_cd',
            //     filter: {is_leave_cd: 'select'},
            //     field: 'is_leave_cd',
            //     width: '105',
            //     data: yesNoOpts,
            //     show: true
            // },
            {title: '开始时间', filter: {start: 'date_range'}, field: 'start', width: '10%', show: true},
            {title: '结束时间', filter: {end: 'date_range'}, field: 'end', width: '10%', show: true},
            {
                title: '意见',
                filter: {current_opinion: 'select'},
                field: 'status',
                width: '80',
                data: statues,
                show: true
            }, //6
            {title: '备注', show: true}, //6
            {title: '申请时间', filter: {created_at: 'date_range'}, field: 'created_at', width: '200', show: true},
            {title: '上班时间', filter: {on_time: 'date_range'}, field: 'on_time', width: '200', show: true}
        ];
        $scope.leave_type_col = $scope.cols[0];
        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.optInFront = true;

        $scope.optColWidth = 60;
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 2;  //用户已批假条
                var startDate, endDate;
                if ($scope.dateRangeFilter.start != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        start: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                if ($scope.dateRangeFilter.end != null) {
                    startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                    endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                    url['date_range_filters'] = {
                        end: {
                            startDate: startDate,
                            endDate: endDate
                        }
                    };
                }
                AskForLeave.query(url, function (data) {
                    $scope.data_types = data.dataTypes;
                    $scope.leave_types = data.leave_types;
                    $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.backLeave = function (record) {
            dialogs.create('BackLeaveDlg.html', 'BackLeaveDlgCtrl', {leave: record}, {
                 size: 'md'
            }).result.then(function (leave) {
                    /*AskForLeave.update({id: record.id}, leave).$promise.then(function (data) {
                        toaster.success('销假申请成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('销假申请失败!');
                    });*/
                $scope.tableReload();
                });
        };
    });

angular.module('c.c').controller('BackLeaveDlgCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, uibDateParser, data, ArrayHelper, FormHelper, AskForLeave) {
    var vm =$scope;
    // console.log('vm',vm);
    $scope.leave = {
            id: data.leave.id,
            is_leave_cd: data.leave.is_leave_cd,
            on_time: new Date(),
            later_end: uibDateParser.parse(data.leave.end, 'yyyy-MM-dd'),
            attachments: []
        };
        // console.log('data.leave', data.leave);

        $scope.ok = function (leave) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var params = {};
                params['on_time'] = $filter('date')(leave.on_time, 'yyyy-MM-dd HH:mm:ss');
                params['later_end'] = $filter('date')(leave.later_end, 'yyyy-MM-dd');
                params['attachments'] = ArrayHelper.map(leave.attachments, function (attachment) {
                    return {
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    };
                });
                params['confirm'] = 1;
                AskForLeave.update({id: leave.id}, params).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close(params);
                }, function (err) {
                    var data = err.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
            /*if ($scope.back_leave_form.$valid) {
                var params = {};
                params['on_time'] = $filter('date')(leave.on_time, 'yyyy-MM-dd HH:mm:ss');
                params['later_end'] = $filter('date')(leave.later_end, 'yyyy-MM-dd');
                params['attachments'] = ArrayHelper.map(leave.attachments, function (attachment) {
                    return {
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    };
                });
                params['confirm'] = 1;
                console.log(params['attachments']);
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.back_leave_form.submitted = true;
            }*/
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    })
;
angular.module('c.c')
    .controller('PendingLeaveCtrl',
        function ($scope, $filter, dialogs, toaster, FileHelper,
                  NgTableParams, AskForLeave, SaveAs, C, F, Dlg) {
            var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
            $scope.yesNo = F.get('yesNo');

            $scope.cols = [
                {title: '编号', field: 'id', show: true}, //0
                {title: '状态', field: 'next_step', show: true}, //0
                {
                    title: '类别',
                    sortable: 'leave_type_id',
                    filter: {leave_type_id: 'select'},
                    field: 'leave_type_id',
                    show: true
                }, //6
                {title: '详情', show: true},
                {title: '开始时间', filter: {start: 'date_range'}, field: 'start', show: true},
                {title: '结束时间', filter: {end: 'date_range'}, field: 'end', show: true}
            ];

            $scope.leave_type_col = $scope.cols[2];
            //$scope.attach_type_col = $scope.cols[6];

            $scope.download = function (m) {
                var params = {filename: m.attach_filename, mime: m.attach_mime};
                m.downloading = true;
                FileHelper.download(C.URL.LEAVE_ATTACHMENT_DOWNLOAD, params, function (resp) {
                    m.downloading = false;
                    var data = [resp];
                    var options = {type: m.attach_mime};
                    SaveAs.download(data, m.attach_name, options);
                }, function () {
                    m.downloading = false;
                    //toaster.error('服务端文件丢失，请联系管理员!');
                });
            };

            $scope.optColWidth = 70;
            $scope.optInFront = true;

            $scope.dateRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function () {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = 1;
                    var startDate, endDate;
                    if ($scope.dateRangeFilter.start != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.start.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.start.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            start: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    if ($scope.dateRangeFilter.end != null) {
                        startDate = $filter('date')($scope.dateRangeFilter.end.startDate, 'yyyy-MM-dd');
                        endDate = $filter('date')($scope.dateRangeFilter.end.endDate, 'yyyy-MM-dd');
                        url['date_range_filters'] = {
                            end: {
                                startDate: startDate,
                                endDate: endDate
                            }
                        };
                    }
                    AskForLeave.query(url, function (data) {
                        $scope.expense_items = data.expense_items;
                        $scope.leave_types = data.leave_types;
                        $scope.leave_type_col.data = F.getNgTableOpts($scope.leave_types);
                        $scope.attach_types = data.attach_types;
                        //$scope.attach_type_col.data = F.getNgTableOpts($scope.attach_types);
                        params.total(data.total);
                        $defer.resolve(data.records);
                    });
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.dateRangeFilter = {};
                $scope.tableParams.filter({});
            };

            function leaveToSave(leave) {
                AskForLeave.save(leave).$promise.then(function (resp) {
                    if (resp.result == 1) {
                        toaster.error(resp.msg);
                    } else {
                        toaster.success('请假添加成功!');
                        $scope.tableReload();
                    }
                }, function () {
                    toaster.error('请假添加失败!');
                });
            }

            function leaveToUpdate(leave, record) {
                AskForLeave.update({id: record.id}, leave).$promise.then(function (resp) {
                    if (resp.result == 1) {
                        toaster.error(resp.msg);
                    } else {
                        toaster.success('请假申请修改成功!');
                        $scope.tableReload();
                    }
                }, function () {
                    toaster.error('请假申请修改失败!');
                });
            }

            $scope.add = function () {
                dialogs.create('templates/leave/edit_leave.html', 'PendingLeaveDlgCtrl', {
                    leave_types: $scope.leave_types,
                    attach_types: $scope.attach_types,
                    expense_items: $scope.expense_items
                }, {
                    size: 'md'
                }).result.then(function (leave) {
                    if (leave['leave_type_id'] == 13) {   //请假值班联动：排除基层锻炼 13
                        AskForLeave.is_dept_leader(leave).$promise.then(function (resp) {
                            //  是否是科室负责人请假5天及以上
                            if (resp.result == 1) {
                                dialogs.create('templates/leave/dept_agent_dlg.html', 'deptAgentDlgCtrl', {
                                    leave_type_id: leave['leave_type_id']
                                }, {
                                    size: 'md'
                                }).result.then(function (m) {
                                    leave['dept_agent_id'] = m.dept_agent_id;
                                    leaveToSave(leave);
                                });
                            }
                            //  科室负责人（含科室代管人）在OA上请假（请假类型不限）时间为1-4天
                            if (resp.result == 2) {
                                dialogs.create('templates/leave/dept_temporary_dlg.html', 'deptTemporaryDlgCtrl', {}, {
                                    size: 'md'
                                }).result.then(function (m) {
                                    leave['dept_temporary_id'] = m.dept_temporary_id;
                                    leaveToSave(leave);
                                });
                            }
                            if (resp.result == 0) {
                                leaveToSave(leave);
                            }
                        }, function () {
                            toaster.error('请假添加失败!');
                        });
                    } else {
                        AskForLeave.is_duty(leave).$promise.then(function (resp) {//请假值班联动：请假时间内是否有值班
                            if (resp.result == 1) {
                                Dlg.notify("您在<strong class=\"text-red\"> " + resp.schedule + " </strong>已有值班，无法请假！");
                            }
                            if (resp.result == 0) {
                                AskForLeave.is_dept_leader(leave).$promise.then(function (resp) {
                                    //  是否是科室负责人请假5天及以上
                                    if (resp.result == 1) {
                                        dialogs.create('templates/leave/dept_agent_dlg.html', 'deptAgentDlgCtrl', {
                                            leave_type_id: leave['leave_type_id']
                                        }, {
                                            size: 'md'
                                        }).result.then(function (m) {
                                            leave['dept_agent_id'] = m.dept_agent_id;
                                            leaveToSave(leave);
                                        });
                                    }
                                    //  科室负责人（含科室代管人）在OA上请假（请假类型不限）时间为1-4天
                                    if (resp.result == 2) {
                                        dialogs.create('templates/leave/dept_temporary_dlg.html', 'deptTemporaryDlgCtrl', {}, {
                                            size: 'md'
                                        }).result.then(function (m) {
                                            leave['dept_temporary_id'] = m.dept_temporary_id;
                                            leaveToSave(leave);
                                        });
                                    }
                                    if (resp.result == 0) {
                                        leaveToSave(leave);
                                    }
                                }, function () {
                                    toaster.error('请假添加失败!');
                                });
                            }
                        }, function () {
                            toaster.error('请假添加失败!');
                        });
                    }
                });
            };

            $scope.edit = function (record) {
                dialogs.create('templates/leave/edit_leave.html', 'PendingLeaveDlgCtrl', {
                        leave: record, edit: true, leave_types: $scope.leave_types, expense_items: $scope.expense_items,
                        attach_types: $scope.attach_types
                    }, {
                        size: 'md'
                    }
                ).result.then(function (leave) {
                    if (leave['leave_type_id'] == 13) {   //请假值班联动：排除基层锻炼 13
                        leaveToUpdate(leave, record);
                    } else {
                        AskForLeave.is_duty(leave).$promise.then(function (resp) { //请假值班联动：请假时间内是否有值班
                            if (resp.result == 1) {
                                Dlg.notify("您在<strong class=\"text-red\"> " + resp.schedule + " </strong>已有值班，无法请假！");
                            }
                            if (resp.result == 0) {
                                leaveToUpdate(leave, record);
                            }
                        }, function () {
                            toaster.error('请假申请修改失败!');
                        });
                    }
                });
            };

            $scope.delete = function (record) {
                dialogs.confirm('删除请假记录', '确定要删除编号为<strong>' + record.id + '</strong>的记录吗?')
                    .result.then(function () {
                    AskForLeave.delete({id: record.id}).$promise.then(function () {
                        toaster.success('请假记录删除成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('请假记录删除失败!');
                    });
                });
            };
        })
;


angular.module('c.c').controller('PendingLeaveDlgCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, C, Upload, dialogs, uibDateParser, data, Auth, Dept, ArrayHelper,
              $state, DateHelper, AskForLeave, Dlg) {

        $scope.leave_types = data.leave_types;
        $scope.attach_types = data.attach_types;
        $scope.expense_items = data.expense_items;
        var personnel_edit = data.personnel_edit;
        $scope.personnel_edit = personnel_edit;
        $scope.isNurse = false;
        $scope.needAttachment = false;

        //主科室实习护士由轮转科室审批，少于2天护士长审批，超过2天护理部审批
        if (Auth.getAccount().dept_id == 111) {
            $scope.isPNurse = true;
            $scope.leave_types = [$scope.leave_types[0], $scope.leave_types[1], $scope.leave_types[27], $scope.leave_types[30]];
            Dept.query({opt: 25}, function (resp) {
                $scope.depts = resp.depts;
                loadLeave();
            });
        } else {
            loadLeave();
        }

        $scope.$watch('leave.start', leaveTimeChanged);
        $scope.$watch('leave.end', leaveTimeChanged);
        $scope.$watch('leave.start_spot', leaveTimeChanged);
        $scope.$watch('leave.end_spot', leaveTimeChanged);

        //判断是不是护士
        if (Auth.getAccount().type == 2) {
            $scope.isNurse = true;
        }

        $scope.typeSelectedFn = function (m) {
            if (m.id == 7 || m.id == 9 || m.id == 10) {
                $scope.needAttachment = true;
                $scope.leave.has_paper = true;
            } else {
                $scope.needAttachment = false;
            }
            if (m.id == 31) {
                dialogs.notify('确认疫情防控隔离', '如涉及门诊停替诊，请务必公文申请或联系门诊部');
            }
        }

        $scope.toClinic = function () {
            $state.go('app.coop_clinic_stop_application', {
                data: {}
            });
        }

        function leaveTimeChanged(n, o) {
            var invalid, m = $scope.leave;

            if (angular.isDefined(n) && angular.isUndefined(o)) return;

            $scope.leave.day_num = NaN;
            $scope.leave.dayNumTip = false;

            $scope.l_form.day_num.$setValidity('zero', true);

            var valid = isNaN($scope.leave.day_num) ? true : Number.isInteger($scope.leave.day_num * 2);
            $scope.l_form.day_num.$setValidity('dayNumFormat', valid);

            if (!m.start || !m.end) return;

            var days = DateHelper.diffInDays(m.start, m.end);
            var start_spot = m.start_spot == 1 ? 0 : 0.5;
            var end_spot = m.end_spot == 1 ? 0.5 : 1;
            //  年休假5 育儿假44 支援西藏疫情后休假39 只算工作日
            if (m.leave_type.id == 5 || m.leave_type.id == 44 || m.leave_type.id == 39) {
                $scope.calculating = true;
                // 开始计算年休假的请假时间...
                AskForLeave.calcDayNum({
                    start: DateHelper.date2Str(m.start),
                    start_spot: m.start_spot == 1 ? false : true,
                    end: DateHelper.date2Str(m.end),
                    end_spot: m.end_spot == 1 ? false : true
                }).$promise.then(function (resp) {
                    if (resp.result === 1) {
                        $scope.leave.day_num = resp.num;
                        $scope.leave.dayNumTip = resp.tip;
                        $scope.l_form.day_num.$setValidity('zero', $scope.leave.day_num > 0);
                    } else {
                        Dlg.w('结束时间不能小于开始时间');
                    }

                }).finally(function () {
                    $scope.calculating = false;
                });
            } else {
                $scope.leave.day_num = days + (end_spot - start_spot);
                $scope.l_form.day_num.$setValidity('zero', $scope.leave.day_num > 0);
            }
        }

        $scope.dayNumChange = function () {
            var valid = isNaN($scope.leave.day_num) ? true : Number.isInteger($scope.leave.day_num * 2);
            $scope.l_form.day_num.$setValidity('dayNumFormat', valid);
            $scope.l_form.day_num.$setValidity('zero', $scope.leave.day_num > 0);
        };

        function loadLeave() {
            if (data.leave) {
                var leave = data.leave;
                $scope.$edit = true;
                $scope.leave = {
                    leave_type: leave.leave_type,
                    has_paper: leave.has_paper == '1',
                    is_leave_cd: leave.is_leave_cd == '1',
                    start: uibDateParser.parse(leave.start, 'yyyy-MM-dd'),
                    end: uibDateParser.parse(leave.end, 'yyyy-MM-dd'),
                    start_spot: leave.start_spot,
                    end_spot: leave.end_spot,
                    is_subsidy: leave.is_subsidy == '1',
                    attach_type: leave.type,
                    leave_reason: leave.leave_reason,
                    attach_name: leave.attach_name, attach_mime: leave.attach_mime,
                    attach_filename: leave.attach_filename, attach_size: leave.attach_size,
                    day_num: leave.day_num
                };
                if ($scope.depts && $scope.depts.length > 0) {
                    $scope.leave['dept'] = ArrayHelper.getItem(leave.dept_id, $scope.depts);
                }
                angular.forEach(leave.leave_expenses, function (expense) {
                    angular.forEach($scope.expense_items, function (item) {
                        if (expense.expense_id == item.id) {
                            item.is_checked = true;
                        }
                    });
                });

                if (leave.airfares.length > 0) {
                    $scope.leave['airfare'] = true;
                    $scope.go = {
                        'id': leave.airfares[0].id,
                        'id_card': leave.airfares[0].id_card,
                        'from': leave.airfares[0].from,
                        'to': leave.airfares[0].to,
                        'from_time': leave.airfares[0].from_time,
                        'plane_time': leave.airfares[0].plane_time,
                        'airline': leave.airfares[0].airline,
                        'flight_num': leave.airfares[0].flight_num,
                        'remark': leave.airfares[0].remark
                    };
                }

                if (leave.airfares.length > 1) {
                    $scope.be_back = {
                        'id': leave.airfares[1].id,
                        'from': leave.airfares[1].from,
                        'to': leave.airfares[1].to,
                        'from_time': leave.airfares[1].from_time,
                        'plane_time': leave.airfares[1].plane_time,
                        'airline': leave.airfares[1].airline,
                        'flight_num': leave.airfares[1].flight_num,
                        'remark': leave.airfares[1].remark
                    };
                }

            } else {
                $scope.leave = {
                    leave_type: $scope.leave_types[0],
                    has_paper: false,
                    is_leave_cd: false,
                    start: new Date(),
                    end: new Date(),
                    start_spot: '1',
                    end_spot: '0',
                    is_subsidy: false,
                    attach_type: $scope.attach_types[0],
                    airfare: false
                };

                if ($scope.depts && $scope.depts.length > 0) {
                    $scope.leave['dept'] = $scope.depts[0];
                }

                for (var i = 0; i < $scope.expense_items.length; i++) {
                    $scope.expense_items[i].is_checked = false;
                }
                $scope.go = {};
                $scope.be_back = {};
            }

        }


        var getFileInfo = true;
        $scope.upload = function (file, leave) {
            if (file == null) {
                return;
            }

            if (file.$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + file.$errorParam + '</strong>' + '\n' + file.name);
                return;
            }

            if (!file.$error) {
                $scope.progress = 0;
                getFileInfo = false;
                Upload.upload({
                    url: C.URL.LEAVE_ATTACHMENT_UPLOAD, file: file
                }).progress(function (evt) {
                    $scope.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (resp) {
                    switch (resp.result) {
                        case 0:
                            leave.attach_name = resp.attach_name;
                            leave.attach_mime = resp.attach_mime;
                            leave.attach_filename = resp.attach_filename;
                            leave.attach_size = resp.attach_size;
                            getFileInfo = true;
                            break;
                        case 1:
                            $scope.progress = -1;
                            $scope.errorInfo = '服务器空间不足!';
                            break;
                    }
                }).error(function () {
                    $scope.progress = -1;
                    $scope.errorInfo = '服务器错误!';
                });
            }
        };

        $scope.airfare = function () {
            dialogs.create('/templates/airfare/oairfare_dlg.html', 'OAirfareDlgCtrl', {
                leave: $scope.leave,
                go: $scope.go,
                be_back: $scope.be_back
            }, {
                size: 'md'
            }).result.then(function (para) {
                $scope.para = para;
                if (para['go']) {
                    $scope.go = para['go'];
                    $scope.leave.airfare = true;
                }
                if (para['be_back']) {
                    $scope.be_back = para['be_back'];
                    $scope.leave.airfare = true;
                }
            });
        };

        $scope.ok = function (leave) {
            if ($scope.l_form.$valid) {
                if (leave.start > leave.end) {
                    toaster.warning('请假结束日期必须大于开始日期,请仔细检查!');
                    $scope.l_form.submitted = true;
                } else if (!$scope.leave.attach_name && $scope.isNurse && $scope.needAttachment) {
                    toaster.warning('该类型的请假必须上传外出培训任务书!');
                } else if (!getFileInfo) {
                    toaster.warning('您的附件可能还没传完,请再等待2秒钟!');
                } else if ($scope.isPNurse && !leave.dept) {
                    toaster.warning('请选择请假科室，若不存在请联系护理部!');
                } else {
                    // if (leave.is_leave_cd) {
                    //     toaster.warning('返岗须提供48小时内核酸报告!');
                    // }

                    //获取科室请假人数，若超过1/3给予提醒
                    AskForLeave.query({
                        opt: 29, start: $filter('date')(leave.start, 'yyyy-MM-dd'),
                        end: $filter('date')(leave.end, 'yyyy-MM-dd'), dept: leave.dept ? leave.dept.id : null
                    }, function (resp) {
                        if (resp.over) {
                            dialogs.confirm('提醒', '<strong class="text-red">你所在的科室同时段请假人数已达预警线！请谨慎申请！</strong>')
                                .result.then(function () {
                                closeParam(leave)
                            });
                        } else {
                            closeParam(leave)
                        }
                    });
                }
            } else {
                toaster.warning('表单中有错误!');
                $scope.l_form.submitted = true;
            }
        };

        function closeParam(leave) {
            var params = {};
            params['start'] = $filter('date')(leave.start, 'yyyy-MM-dd');
            params['end'] = $filter('date')(leave.end, 'yyyy-MM-dd');
            params['leave_type_id'] = leave.leave_type.id;
            params['leave_reason'] = leave.leave_reason;
            params['has_paper'] = leave.has_paper;
            params['is_leave_cd'] = leave.is_leave_cd;
            params['leave_reason'] = leave.leave_reason;
            params['start_spot'] = leave.start_spot;
            params['end_spot'] = leave.end_spot;
            params['day_num'] = leave.day_num;
            params['is_nurse'] = $scope.isNurse;
            params['need_attachment'] = $scope.needAttachment;
            params['end_spot'] = leave.end_spot;
            params['send'] = leave.send == true ? 1 : 0;
            if (leave.has_paper) {
                params['type_id'] = leave.attach_type.id;
                params['attach_name'] = leave.attach_name;
                params['attach_mime'] = leave.attach_mime;
                params['attach_filename'] = leave.attach_filename;
                params['attach_size'] = leave.attach_size;
            }
            params['is_subsidy'] = leave.is_subsidy == true ? 1 : 0;
            if (leave.is_subsidy) {
                var items = [];
                for (var i = 0; i < $scope.expense_items.length; i++) {
                    if ($scope.expense_items[i].is_checked) {
                        items.push($scope.expense_items[i].id);
                    }
                    params['items'] = items;
                }
            }
            params['edit'] = $scope.$edit;
            params['airfare'] = leave.airfare;
            if (leave.airfare) {
                if ($scope.go) {
                    params['go'] = $scope.go;
                }
                if ($scope.be_back) {
                    params['be_back'] = $scope.be_back;
                }
            }
            params['personnel_edit'] = personnel_edit;
            if (personnel_edit) {
                params['day_num'] = leave.day_num;
            }
            if ($scope.isPNurse) {
                params['dept_id'] = leave.dept.id;
            }
            $uibModalInstance.close(params);
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
)
;

angular.module('c.c').controller('OAirfareDlgCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, uibDateParser, data) {

        $scope.leave = data.leave;
        $scope.users = data.users;   //若不为空，则表示差务安排

        if (data.go || data.be_back) {
            var go = data.go;
            var be_back = data.be_back;
            $scope.go = {
                'id': go.id,
                'id_card': go.id_card,
                'from': go.from,
                'to': go.to,
                'from_time': uibDateParser.parse(go.from_time, 'yyyy-MM-dd'),
                'plane_time': go.plane_time,
                'airline': go.airline,
                'flight_num': go.flight_num,
                'remark': go.remark
            };
            $scope.be_back = {
                'id': be_back.id,
                'id_card': be_back.id_card,
                'from': be_back.from,
                'to': be_back.to,
                'from_time': uibDateParser.parse(be_back.from_time, 'yyyy-MM-dd'),
                'plane_time': be_back.plane_time,
                'airline': be_back.airline,
                'flight_num': be_back.flight_num,
                'remark': be_back.remark
            };

        }
        //else {
        //    $scope.go = {'from': '成都'};
        //    $scope.be_back = {'to': '成都'};
        //}
        $scope.ok = function (go, be_back) {
            if ($scope.airfare_form.$valid) {
                if (!(go.from_time || be_back.from_time)) {
                    toaster.warning('出发日期不能为空');
                } else {
                    var skip = true;
                    if (!$scope.users) {
                        if (go.id_card == null || go.id_card == "") {
                            toaster.warning('身份证号不能为空!');
                            skip = false;
                        }
                    } else {
                        angular.forEach($scope.users, function (user) {
                            if (user.id_card == null || user.id_card == "") {
                                toaster.warning('身份证号不能为空!');
                                skip = false;
                            }
                        });
                    }
                    if (skip) {
                        var params = {};

                        //if (go.id) {
                        //    params['go']['id'] = go.id;
                        //}
                        if (go) {
                            params['go'] = {};
                            params['go']['id_card'] = go.id_card;
                            params['go']['from'] = go.from;
                            params['go']['to'] = go.to;
                            params['go']['from_time'] = $filter('date')(go.from_time, 'yyyy-MM-dd');
                            params['go']['plane_time'] = go.plane_time;
                            params['go']['airline'] = go.airline;
                            params['go']['flight_num'] = go.flight_num;
                            params['go']['remark'] = go.remark;
                            params['go']['status'] = 1;
                        }

                        if (be_back) {
                            params['be_back'] = {};
                            params['be_back']['id_card'] = go.id_card;
                            params['be_back']['from'] = be_back.from;
                            params['be_back']['to'] = be_back.to;
                            params['be_back']['from_time'] = $filter('date')(be_back.from_time, 'yyyy-MM-dd');
                            params['be_back']['plane_time'] = be_back.plane_time;
                            params['be_back']['airline'] = be_back.airline;
                            params['be_back']['flight_num'] = be_back.flight_num;
                            params['be_back']['remark'] = be_back.remark;
                            params['be_back']['status'] = 2;
                        }
                        //if (be_back.id) {
                        //    params['be_back']['id'] = be_back.id;
                        //}
                        if (go || be_back) {
                            params['users'] = $scope.users;
                        }
                        $uibModalInstance.close(params);
                    }
                }

            } else {
                toaster.warning('表单中有错误!');
                $scope.airfare_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    })
;

(function () {
    'use strict';

    angular.module('c.c')
        .controller('InUserCommentDlgCtrl', InUserCommentDlgCtrl);

    /** @ngInject */
    function InUserCommentDlgCtrl($uibModalInstance, $scope, $q, Auth, $filter, ArrayHelper, $rootScope,
                                  DateHelper, PurchaseHistory, FormHelper, Dlg, data, toaster,commentType, PurchaseHistoryPathRecord) {
        var vm = this;
        vm.ok = ok;
        vm.addProductImg = addProductImg;

        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.comment);

        function init(comment) {
            vm.loading = true;
            commentType.query({op: 'stop'}).$promise.then(function (resp){

                vm.comment_types = resp.items;

                if (comment.comment){
                    vm.disable = true;
                    vm.$edit = true;
                    vm.m = {
                        id: comment.id
                    };
                    $q.all([
                        PurchaseHistory.get({id: comment.id}).$promise,
                        PurchaseHistoryPathRecord.get({id: comment.id}).$promise
                    ]).then(function (respArr){
                        vm.m = respArr[0];
                        vm.m.comment_type = ArrayHelper.getItem(vm.m.comment_type_id, vm.comment_types);
                        vm.m.paths = respArr[1].record;
                        vm.newPaths = [];
                        angular.forEach(vm.m.paths, function (i) {
                            vm.newPaths.push(i.path);
                        });
                        vm.m.paths = vm.newPaths;
                    }).finally(function () {
                        vm.loading = false;
                    });
                } else {
                    vm.$edit = false;
                    vm.m = {
                        id: comment.id
                    };
                    vm.m.paths = [];
                    vm.loading = false;
                }
            });

        }

        function addProductImg($index,i) {

            Dlg.show({
                template: 'templates/order/order_img_dlg.html',
                ctrl: 'OrderImgDlgCtrl',
                data: {
                    store: data.store
                },
                size: 'md'
            }).then(function (url) {
                if (i){
                    vm.m.paths[$index] = url;
                } else {
                    vm.m.path = url;
                    vm.m.paths.push(url);
                }
            });
        }

        function ok(m) {
            if (m.paths.length === 0) {
                Dlg.w('商品图片不能为空!');
            } else {
                return FormHelper.handleSubmit(vm, function (defer) {
                    var pa = {
                        comment_type_id: m.comment_type.id,
                        comment: m.comment,
                        paths: m.paths
                    };

                    var promise;
                    promise = PurchaseHistory.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                    promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success(resp.msg);
                                $q.defer().resolve();
                                break;
                            default:
                                toaster.warning(resp.msg);
                                $q.defer().reject();
                        }
                        vm.close();
                    });
                    return $q.defer().promise;

                });
            }

        }
    }

})();


(function () {
    'use strict';

    angular.module('c.c')
        .controller('addSteamedBreadDlgCtrl', addSteamedBreadDlgCtrl);

    /** @ngInject */
    function addSteamedBreadDlgCtrl($uibModalInstance, $scope, $q, $rootScope, ArrayHelper, Upload, DateHelper, FileHelper, C, FormHelper, Patient, Dept, steamedBread, Dlg) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.getPatient = getPatient;
        vm.upload = upload;
        vm.download = download;

        init();


        function init() {
            vm.m = {
                mode: '1',
                patient: null,
                doc: {},
                date: DateHelper.date2Str(new Date(new Date().setDate(new Date().getDate() + 1))),
                attachment: {
                    filename: 'docTemp/steamed_bread.xlsx',
                    mime: 'application/wps-office.xlsx',
                    name: '上报模板.xlsx',
                    size: 8632
                }
            };
            getPatient();
        }

        function getPatient(str) {
            $q.all([
                Patient.query({op: 'in_search', queryStr: str, count: 20}).$promise,
                Dept.query({opt: '5'}).$promise
            ]).then(function (respArray) {
                vm.depts = respArray[1].depts;
                vm.m.dept = ArrayHelper.getItem(respArray[0].dept_id, vm.depts);
            });
        }

        // function patientChange() {
        //     console.log(vm.m.patient);
        //     if (vm.m.patient) {
        //         var data = vm.m.patient;
        //         vm.m.dept = data.dept;
        //         vm.m.in_num = data.in_num;
        //         vm.m.bed_num = data.bed_num;
        //     }
        // }


        function download(attachment) {
            FileHelper.download1('/api/v1/steamed_bread_records/download', attachment)
        }

        function upload(file, data, e, rename, extra) {
            if (file == null) {
                return;
            }
            vm.loading = true;
            vm.m.items = [];
            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                ArrayHelper.mergeObj(pa, extra);
            }
            delete data[rename.filename];
            Upload.upload({
                url: C.URL.UPLOAD_ATTACHMENT, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        steamedBread.save({
                            op: 'input',
                            filename: resp[rename.filename],
                            type: vm.forPO ? 1 : (vm.forFinance ? 2 : 0)
                        }, function (excelData) {
                            vm.m.items = excelData.items;
                            vm.loading = false;
                            Dlg.s('上传完毕')
                        }, function (error) {
                            vm.loading = false;
                            Dlg.e('上传失败');
                        });
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });
        }

        function ok(m) {
            if (m.mode == 1) {
                if (Object.keys(m.doc).length == 0) {
                    Dlg.w('请上传附件');
                    return;
                }
                return FormHelper.handleSubmit(vm, function (defer) {
                    var pa = {
                        op: 'virtual',
                        items: m.items,
                        dept_id: m.dept.id,
                        date: DateHelper.date2Str(m.date)
                    };
                    steamedBread.save(pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        vm.close();
                    }, function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            } else {
                return FormHelper.handleSubmit(vm, function (defer) {
                    var pa = {
                        op: 'default',
                        patient_name: m.name,
                        dept_id: m.dept.id,
                        bed_num: m.bed_num,
                        date: DateHelper.date2Str(m.date)

                    };
                    steamedBread.save(pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        vm.close();
                    }, function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            }
        }
    }

})();

angular.module('c.c')
    .controller('UserPHCtrl', function ($scope, dialogs, toaster, PurchaseHistory, User, Order, Table, Dlg, DateHelper) {
        var vm = $scope;
        vm.submit = submit;
        vm.addEdit = addEdit;
        vm.show = show;
        init();

        function init() {
            var options = {
                service: PurchaseHistory,
                params: {opt: 1/*PURCHASEHISTORY.INDEX_USER_SEARCH*/},
                sorting: {time: 'desc'},
                optColWidth: Table._3_BTN,
                // hideOpt: true,
                cols: [
                    {field: "time", width: '20%', title: "消费时间", sortable: "time", filter: {time: "date_range"}},
                    {field: "order", title: "商品", filter: {order: "text"}},
                    {field: "store", title: "商家", filter: {store: "text"}},
                    {field: "self_paid", title: "消费金额", sortable: "self_paid", filter: {self_paid: "num_range"}},
                    {field: "handler", title: "操作人", filter: {handler: "text"}}
                ]
            };
            Table.load(vm, options, function (resp) {
                var user = resp.user;
                user.is_assist = user.is_assist == '1';
                vm.user = user;
                angular.forEach(resp.items, function (i) {
                    var date = DateHelper.date2Str(new Date());
                    var time = i.time.split(" ",1);
                    var diffDay = DateHelper.diffInDays(DateHelper.str2Date(time[0]), DateHelper.str2Date(date));
                    if (diffDay > 3){
                        i.edit = false;
                    } else {
                        i.edit = true;
                    }
                });

            });
        }

        function addEdit(m) {
            Dlg.show({
                template: 'pages/user/meal/InUserCommentDlg.html',
                ctrl: 'InUserCommentDlgCtrl',
                data: { comment: m },
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/user/userCommentDlg.html',
                ctrl: 'userCommentDlgCtrl',
                data: m.id,
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function submit(m) {
            User.update({id: m.id}, {opt: 1, is_assist: m.is_assist ? '1' : '0'}).$promise.then(function (resp) {
                toaster.success('设置成功!');
                vm.tableReload();
            });
        }
    });



angular.module('c.c')
    .controller('UserRechargeCtrl', function ($scope, Recharge, Table) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: Recharge,
                params: {opt: 3/*INDEX_USER_RECHARGE*/},
                sorting: {created_at: 'desc'},
                hideOpt: true,
                cols: [
                    {field: "created_at", title: "充值时间", filter: {'created_at': "date_range"}},
                    {field: "money", title: "金额", filter: {'money': "num_range"}},
                    {field: "handler", title: "充值人", filter: {handler: "text"}},
                    {field: "note", title: "充值理由", filter: {note: "text"}}
                ]
            };
            Table.load(vm, options, function (resp) {
                    vm.balance = resp.balance;
                    vm.user = resp.user;
                    vm.periodTotal = resp.periodTotal;
                }
            );
        }
    });


angular.module('c.c')
    .controller('TOSchedulerCtrl', function ($scope, TakeoutSchedule, dialogs, toaster) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.setStop = setStop;
        vm.remove = remove;
        vm.reload = init;


        init();

        function init() {
            vm.loading = true;
            TakeoutSchedule.query({opt: 1/*TAKEOUTSCHEDULE.INDEX_USER_TOS*/}, function (resp) {
                vm.loading = false;
                vm.breakfast = [];
                vm.lunch = [];
                vm.dinner = [];
                angular.forEach(resp.items, function (i) {
                    switch (i.type) {
                        case '1':
                            vm.breakfast = i;
                            break;
                        case '2':
                            vm.lunch = i;
                            break;
                        case '3':
                            vm.dinner = i;
                            break;
                    }
                });
            });
        }


        function add(type, weekday) {
            dialogs.create('TOSDlg.html', 'TOSDlgCtrl', {type: type, weekday: weekday}, {

                size: 'md'
            }).result.then(function (pa) {
                TakeoutSchedule.save(pa).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.reload();
                });
            });
        }

        function edit(type, weekday, m) {
            dialogs.create('TOSDlg.html', 'TOSDlgCtrl', {type: type, weekday: weekday, id: m.id}, {

                size: 'md'
            }).result.then(function (pa) {
                pa.opt = 1; //TAKEOUTSCHEDULE.EDIT_SAVE
                TakeoutSchedule.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.reload();
                });
            });
        }

        function setStop(m) {
            TakeoutSchedule.update({id: m.id}, {opt: 2 /*TAKEOUTSCHEDULE.EDIT_STOP*/, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        function remove(m) {
            dialogs.confirm('删除外送商品', '确定要删除<strong>' + m.name + '</strong>吗?'
            ).result.then(function () {
                TakeoutSchedule.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.reload();
                });
            });
        }
    });

angular.module('c.c').controller('TOSDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data, TakeoutSchedule, Dept, DeptTakeoutPlace, F) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.type = F.getItem(data.type, F.get('orderTypes'));
        vm.weekday = F.getItem(data.weekday, F.get('weekdays'));

        loadModel(data.id);

        function loadModel(id) {
            Dept.query({opt: 5/*INDEX_DEPTS_OPTIONS*/}, function (resp) {
                vm.depts = resp.depts;
                if (id) {
                    TakeoutSchedule.get({id: id}, function (resp) {
                        var m = resp;
                        m.is_stop = m.is_stop == '1';
                        m.dept = F.getItem(m.dept_id, vm.depts);
                        vm.m = m;
                    });
                } else {
                    vm.m = {is_stop: false, note: '', dept: vm.depts[0]};
                }
            });

            $scope.$watch('m.dept', function (dept, old) {
                if (dept) {
                    DeptTakeoutPlace.query({
                        opt: 2, /*DEPTTAKEOUTPLACE.INDEX_OPTIONS*/
                        deptId: dept.id
                    }, function (resp) {
                        vm.places = resp.places;
                        if (id) {
                            vm.m.place = F.getItem(vm.m.place_id, vm.places);
                        } else {
                            vm.m.place = vm.places[0];
                        }
                    });
                }
            }, true);
        }

        function ok(m) {
            if (!m.order) {
                toaster.warning('请选择商品');
            } else if (!m.dept) {
                toaster.warning('请选择科室');
            } else if (!m.place) {
                toaster.warning('请选择地点');
            } else {
                var pa = {};
                pa.type = vm.type.id;
                pa.weekday = vm.weekday.id;
                pa.note = m.note;
                pa.order_id = m.order.id;
                pa.place_id = m.place.id;
                pa.dept_id = m.dept.id;
                pa.is_stop = m.is_stop ? '1' : '0';
                $uibModalInstance.close(pa);
            }
        }
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('SteamedBreadCtrl', SteamedBreadCtrl);

    /** @ngInject */
    function SteamedBreadCtrl($scope, UIHelper, Dlg, Table, ArrayHelper, steamedBread) {
        var vm = $scope;
        vm.add = add;
        vm.remove = remove;
        init();

        function init() {
            $scope.$on('SteamedBread', function (event, data) {
                vm.tableReload();
            });
            var states = [
                {id: 1, name: "未确认"},
                {id: 2, name: "已确认"}
            ];
            var options = {
                service: steamedBread,
                params: {op: 'declaration'},
                optColWidth: Table._1_BTN,
                optInFront: true,
                cols: [
                    {field: "patient_name", title: "姓名", filter: {patient_name: "text"}, width: Table._5_CHAR},
                    {field: "dept", title: "科室", width: Table._4_CHAR},
                    {field: "bed_num", title: "床号", width: Table._4_CHAR},
                    {field: "state", title: "状态", filter: {state: "select"}, data: Table.getNgTableOpts(states)},
                    {field: "date", title: "时间", width: Table._4_CHAR}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = ArrayHelper.getItem(item.state, states);
                });
            });
        }

        function add() {
            Dlg.show({
                template: 'pages/user/meal/addSteamedBreadDlg.html',
                ctrl: 'addSteamedBreadDlgCtrl',
                size: 'md'
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除该记录吗？', function () {
                steamedBread.delete({id: m.id}, {op: 'default'}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                });
            });
        }
    }

})();

angular.module('c.c')
    .controller('UserTakeOutCtrl', function ($scope, $filter, dialogs, toaster, TakeOut, Order, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.remove = remove;
        vm.feedback = feedback;
        vm.prevDay = prevDay;
        vm.nextDay = nextDay;
        vm.takeOutStates = F.get('takeOutStates');
        vm.dt = new Date();


        init();

        function init() {
            vm.$on('takeOutOk', function () {
                vm.tableReload();
            });

            var options = {
                service: TakeOut,
                params: {opt: 1/*TAKEOUT.INDEX_ALL*/},
                sorting: {meal_time: 'asc'},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {
                        field: "meal_time",
                        width: '20%',
                        title: "送餐时间",
                        sortable: "meal_time"
                    },
                    {field: "dept", title: "送餐科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "applicant", title: "填单人", filter: {applicant: "text"}},
                    {field: "order", title: "商品名称", filter: {order: "text"}},
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: F.getNgTableOpts(vm.takeOutStates)
                    }
                ]
            };

            $scope.$watch('dt', function (dt, old, scope) {
                scope.tableParams.$params.page = 1;
                options.params.time = $filter('date')(dt, 'yyyy-MM-dd');
                scope.tableReload();
            }, true);


            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (i) {
                    i.totalMoney = F.toFixed(parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy), 1);
                    i.state = F.getItem(i.state, vm.takeOutStates);
                })
            });
        }


        function prevDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() - 1));
        }

        function nextDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() + 1));
        }

        function add() {
            dialogs.create('TODetailDlg.html', 'TODetailDlgCtrl', {user: vm.account}, {

                size: 'md'
            });
        }

        function remove(m) {
            dialogs.confirm('删除外卖订单', '确定要删除<strong>' + m.order.name + '</strong>的订单吗？')
                .result.then(function () {
                TakeOut.delete({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功');
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }

        function feedback(m, opt) {
            Order.update({id: m.order_id}, {opt: opt}).$promise.then(function (resp) {
                toaster.success('评价成功');
                vm.tableReload();
            });
        }
    });

angular.module('c.c').controller('TODetailDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, toaster, $filter, F, StoreTips, TakeOut, dialogs, data) {
        var vm = $scope;
        StoreTips.get({id: '-', op: 'option'}).$promise.then(function (resp) {
            var item = resp.item;
            vm.morning = item.morning;
            vm.evening = item.evening;
            vm.afternoon = item.afternoon;
            vm.date = item.date;
        });
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        vm.type = '4';//全天
        var now = $filter('date')(new Date(), 'HH:mm');
        if (F.checkTime(now, '19:30', '06:30')) {
            vm.type = '1'
        }//早餐
        if (F.checkTime(now, '06:30', '10:30') || now === '06:30') {
            vm.type = '2'
        } //中餐
        if (F.checkTime(now, '13:30', '16:30')) {
            vm.type = '3'
        } //晚餐

        function ok() {
            dialogs.create('UserTakeOutDlg.html', 'UserTakeOutDlgCtrl', {
                type: vm.type,
                user: data.user
            }, {size: 'md'})
                .result.then(function (pa) {
                TakeOut.save(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('订购成功');
                            $rootScope.$broadcast('takeOutOk');
                            vm.cancel();
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                });
            });
        }
    });

angular.module('c.c').controller('UserTakeOutDlgCtrl',
    function ($scope, $uibModalInstance, toaster, $filter, uibDateParser, F, TakeOut, DeptTakeoutPlace, Dept, User, Auth, data) {
        var vm = $scope;
        vm.today = new Date();
        vm.ok = ok;
        vm.type = data.type;
        vm.userSelectedFn = userSelectedFn;
        vm.cancel = $uibModalInstance.dismiss;
        init();

        function init() {
            Dept.query({opt: 5/*INDEX_DEPTS_OPTIONS*/}, function (resp) {
                vm.depts = resp.depts;
                vm.m = {
                    typeOrders: [],
                    allOrders: [],
                    dept: F.getItem(data.user.dept_id, vm.depts),
                    note: '',
                    type: data.type != '4',
                    all: data.type == '4',
                    date: vm.today,
                    time: vm.today
                };
            });

            $scope.$watch('m.dept', function (dept, old) {
                if (dept) {
                    User.query({
                        opt: 3, /*USER.INDEX_DEPT_MEMBER_OPTIONS*/
                        dept_id: dept.id,
                        is_takeout: true
                    }, function (resp) {
                        vm.users = resp.users;
                        vm.users.splice(0, 0, {name: '清除', action: 2});
                        vm.users.splice(0, 0, {name: '全选', action: 1});
                        vm.m.users = [F.getItem(data.user.id, vm.users)];
                    });

                    DeptTakeoutPlace.query({
                        opt: 2, /*DEPTTAKEOUTPLACE.INDEX_OPTIONS*/
                        deptId: dept.id,
                        userId: Auth.getAccount().id,
                    }, function (resp) {
                        vm.places = resp.places;
                        if (resp.lastPlaceId) {
                            vm.m.place = F.getItem(resp.lastPlaceId, resp.places);
                            if (vm.m.place == null) vm.m.place = vm.places[0];
                        } else {
                            vm.m.place = vm.places[0];
                        }
                    });
                }
            }, true);
        }

        function userSelectedFn(action, m) {
            if (action) {
                if (action == 1) {
                    m.users = [];
                    angular.forEach(vm.users, function (user) {
                        if (!user.action) {
                            m.users.push(user);
                        }
                    });
                } else {
                    m.users = [];
                }
            }
        }

        function ok(m) {
            if (!m.type && !m.all) {
                toaster.warning('请选择预定类型');
            } else if (m.type && m.typeOrders.length == 0) {
                toaster.warning('请选择商品');
            } else if (m.users.length == 0) {
                toaster.warning('请选择订餐人');
            } else if (m.all && m.allOrders.length == 0) {
                toaster.warning('请选择全天商品');
            } else if (!m.place) {
                toaster.warning('请选择送餐地点');
            } else {
                var pa = {};
                var keepGoing = true;
                var userIds = [];
                angular.forEach(m.users, function (u) {
                    userIds.push(u.id);
                });
                var num = parseInt(m.users.length);
                if (m.type) {
                    var typeOrders = [],
                        typeTotalPrice = 0;
                    angular.forEach(m.typeOrders, function (o) {
                        if (keepGoing) {
                            if (o.residue_supply < (o.count * num)) {
                                keepGoing = false;
                                toaster.warning(o.name + '库存不足');
                            } else {
                                typeOrders.push({id: o.id, name: o.name, num: o.count});
                                typeTotalPrice += o.total_paid;
                            }
                        }
                    });
                    pa.typeOrders = typeOrders;
                    pa.typeTotalPrice = F.toFixed(typeTotalPrice, 1);
                    switch (data.type) {
                        case '1':
                            var criticalTime = new Date();
                            criticalTime.setHours(19, 30, 0);
                            if (new Date() > criticalTime) {
                                var newTime = new Date(new Date().setDate(new Date().getDate() + 1));
                                pa.typeMealTime = $filter('date')(newTime, 'yyyy-MM-dd 08:00');
                            } else {
                                pa.typeMealTime = $filter('date')(new Date(), 'yyyy-MM-dd 08:00');
                            }
                            break;
                        case '2':
                            pa.typeMealTime = $filter('date')(new Date(), 'yyyy-MM-dd 12:00');
                            break;
                        case '3':
                            pa.typeMealTime = $filter('date')(new Date(), 'yyyy-MM-dd 18:00');
                            break;
                    }
                }


                if (m.all) {
                    var allOrders = [],
                        allTotalPrice = 0;
                    angular.forEach(m.allOrders, function (o) {
                        if (keepGoing) {
                            allOrders.push({id: o.id, name: o.name, num: o.count});
                            allTotalPrice += o.total_paid;
                        }
                    });
                    pa.allOrders = allOrders;
                    pa.allTotalPrice = F.toFixed(allTotalPrice, 1);
                    var date = $filter('date')(m.date, 'yyyy-MM-dd'),
                        time = $filter('date')(m.time, 'HH:mm');
                    pa.allMealTime = date + ' ' + time;
                }

                pa.type = m.type;
                pa.all = m.all;
                pa.note = m.note;
                pa.place_id = m.place.id;
                pa.dept_id = m.dept.id;
                pa.users = userIds;
                pa.localDate = $filter('date')(new Date(), 'yyyy-MM-dd');
                if (keepGoing) {
                    $uibModalInstance.close(pa);
                }
            }
        }
    });

angular.module('c.c')
    .controller('UserWorkingMealCtrl', function ($scope, $filter, dialogs, toaster, WorkingMeal, Order, Table, F) {
        var vm = $scope;
        vm.add = add;
        vm.feedback = feedback;
        vm.remove = remove;
        vm.wMStates = F.get('wMStates');
        vm.$on('wmOk', function () {
            vm.tableReload();
        });

        var options = {
            service: WorkingMeal,
            params: {opt: 1/*WORKINGMEAL.INDEX_ALL*/},
            sorting: {meal_time: 'asc'},
            optColWidth: Table._3_BTN,
            showSn: true,
            cols: [
                {field: "user", title: "订餐人", filter: {user: "text"}},
                {field: "place", title: "送餐地点", filter: {place: "text"}},
                {
                    field: "meal_time",
                    width: '20%',
                    sortable: "meal_time",
                    title: "订餐时间"
                },
                {field: "applicant", title: "填单人", filter: {applicant: "text"}},
                {field: "order", title: "商品名称", filter: {order: "text"}},
                {field: "num", title: "数量", width: '5%'},
                {
                    field: "state",
                    title: "状态",
                    filter: {state: "select"},
                    data: F.getNgTableOpts(vm.wMStates)
                }
            ]
        };

        vm.dt = new Date();
        vm.prevDay = function (curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() - 1));
        };
        vm.nextDay = function (curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() + 1));
        };

        $scope.$watch('dt', function (dt, old, scope) {
            scope.tableParams.$params.page = 1;
            options.params.time = $filter('date')(dt, 'yyyy-MM-dd');
            scope.tableReload();
        }, true);

        function init() {
            Table.load(vm, options, function (resp) {
                vm.count = resp.count;
                angular.forEach(resp.items, function (i) {
                    i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                    i.state = F.getItem(i.state, vm.wMStates);

                })
            });
        }

        init();


        function add() {
            dialogs.create('WMDetailDlg.html', 'WMDetailDlgCtrl', {account: vm.account}, {

                size: 'md'
            });
        }


        function remove(m) {
            dialogs.confirm('删除手术餐订单', '确定要删除<strong>' + m.order.name + '</strong>的订单吗？')
                .result.then(function () {
                WorkingMeal.delete({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('删除成功');
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }

        function feedback(m, opt) {
            Order.update({id: m.order_id}, {opt: opt}).$promise.then(function (resp) {
                toaster.success('评价成功');
                vm.tableReload();
            });
        }
    });

angular.module('c.c').controller('WMDetailDlgCtrl',
    function ($scope, $uibModalInstance, $filter, F, dialogs, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.account = data.account;

        var now = $filter('date')(new Date(), 'HH:mm');
        if (F.checkTime(now, '07:30', '10:30')) {
            vm.type = '2'
        }
        if (F.checkTime(now, '13:00', '17:00')) {
            vm.type = '3'
        }

        function ok() {
            vm.cancel();
            dialogs.create('UserWorkingMealDlg.html', 'UserWorkingMealDlgCtrl', {account: vm.account, type: vm.type}, {

                size: 'md'
            });
        }

    });

angular.module('c.c').controller('UserWorkingMealDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, $q, toaster, uibDateParser, $filter, F, WorkingMeal, DeliveryPlace,
              User, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.userSelectedFn = userSelectedFn;
        vm.cancel = $uibModalInstance.dismiss;
        vm.account = data.account;

        loadModel();

        function loadModel() {
            DeliveryPlace.query({opt: 2/*DELIVERYPLACE.INDEX_OPTIONS*/}, function (resp) {
                vm.places = resp.items;
                User.query({opt: 16/*USER.INDEX_MAIN_DEPT_MEMBER_OPTIONS*/}, function (resp) {
                    vm.users = resp.users;
                    vm.users.splice(0, 0, {name: '清除', action: 2});
                    vm.users.splice(0, 0, {name: '全选', action: 1});
                    vm.m = {
                        in: true,
                        out: false,
                        users: [],
                        user: F.getItem(vm.account.id, vm.users),
                        place: vm.places[0],
                        note: '',
                        note2: '',
                        type: data.type
                    };
                });
            });
        }

        function userSelectedFn(action, m) {
            if (action) {
                if (action == 1) {
                    m.users = [];
                    angular.forEach(vm.users, function (user) {
                        if (!user.action) {
                            m.users.push(user);
                        }
                    });
                } else {
                    m.users = [];
                }
            }
        }

        function ok(m) {
            if (m.in && m.users.length == 0) {
                toaster.warning('请选择订餐人!');
            } else if (m.out && (m.num == null || Number(m.num) == 0)) {
                toaster.warning('请确认订餐数量!');
            } else if (m.out && (m.note == null || m.note == "")) {
                toaster.warning('院外备注不能为空!');
            } else if (!m.place) {
                toaster.warning('请选择送餐地点!');
            } else if (!m.order) {
                toaster.warning('请选择商品!');
            } else if (!m.in && !m.out) {
                toaster.warning('请选择订餐类型!');
            } else {
                var defer = $q.defer();
                var pa = {};
                var keepGoing = true,
                    num = 0;
                if (m.in) {
                    var userIds = [];
                    angular.forEach(m.users, function (u) {
                        userIds.push(u.id);
                    });
                    pa.users = userIds;
                    pa.note2 = m.note2;
                    num += parseInt(m.users.length);
                }
                if (m.out) {
                    pa.user_id = m.user.id;
                    pa.num = m.num;
                    pa.note = m.note;
                    num += parseInt(m.num);
                }
                var o = m.order;
                if (o.residue_supply < num) {
                    keepGoing = false;
                    defer.reject();
                    toaster.warning(o.name + '库存不足');
                } else {
                    pa.order_id = o.id;
                }
                pa.place_id = m.place.id;
                if (keepGoing) {
                    WorkingMeal.save(pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                defer.resolve();
                                toaster.success('订购成功');
                                $rootScope.$broadcast('wmOk');
                                vm.cancel();
                                break;
                            default:
                                toaster.warning(resp.msg);
                                defer.reject();
                        }
                    });
                }
                return defer.promise;
            }
        }
    });

angular.module('c.c')
    .controller('WMAdminApprovalCtrl', function ($scope, $filter, dialogs, toaster, WorkingMeal, Order, Table, C, F) {
        var vm = $scope;
        var checker = Table.loadMultiSelectedFn(vm);
        vm.pay = pay;
        vm.pass = pass;
        vm.back = back;
        vm.batch = batch;


        init();

        function init() {
            vm.$on(C.P + 'workingMeal.handle', function (event, data) {
                var record = data.data.workingMeal;
                record.totalMoney = F.toFixed((parseFloat(record.order.self_paid) + parseFloat(record.order.subsidy)) * parseFloat(record.num), 1);
                if (record['state'] == '1') {
                    var index = F.indexOfKey(record['id'], vm.tableParams.data);
                    if (index >= 0) {
                        vm.tableParams.data.splice(index, 1);
                    }
                    if (vm.placeIds && F.inArray(record['place_id'], vm.placeIds) >= 0) {
                        if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                            vm.tableParams.data.pop();
                        }
                        vm.tableParams.data.unshift(record);
                    }
                }
            });


            var options = {
                service: WorkingMeal,
                params: {opt: 2/*WORKINGMEAL.INDEX_WM_ADMIN*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sn", title: "序号"},
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "applicant", title: "填单人", filter: {applicant: "text"}},
                    {field: "order", title: "商品名称", filter: {order: "text"}},
                    {field: "num", title: "数量", width: '5%'}
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.count = resp.count;
                vm.placeIds = resp.placeIds;
                var items = resp.items;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                });
                vm.items = items;
            });

            Table.load(vm, options, function (resp, startSn) {
                vm.count = resp.count;
                vm.placeIds = resp.placeIds;
                var items = resp.items;
                Table.loadItem(resp, startSn, function (i) {
                    i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) + parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                });
                vm.items = items;
            });

        }

        function pay(m) {
            adminHandle(m, 1);
        }


        function pass(m) {
            adminHandle(m, 2);
        }

        function back(m) {
            adminHandle(m, 3);
        }

        function adminHandle(m, opt) {
            WorkingMeal.update({id: m.id}, {opt: opt/*1:WORKINGMEAL.EDIT_USER_PAY 2:WORKINGMEAL.EDIT_ADMIN_PASS 3:WORKINGMEAL.EDIT_ADMIN_BACK*/})
                .$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('处理成功');
                        break;
                    case 1:
                        toaster.warning('订单已处理');
                        break;
                }
                vm.tableReload();
            }, function () {
                toaster.error('订单已删除，请刷新');
            });
        }

        function batch(items, opt) {
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }

            for (var i = 0; i < items.length; i++) {
                if (items[i].type == '3') {
                    toaster.warning('存在已删除订单，请刷新');
                    return;
                }
            }

            WorkingMeal.adminBatch({itemIds: checker.getCheckedIds(items), opt: opt}, function () {
                toaster.success('处理成功');
                vm.tableReload();
            });
        }
    });

angular.module('c.c')
    .controller('WMAdminApprovedCtrl', function ($scope, $filter, dialogs, toaster, FileHelper,
                                                 WorkingMeal, Order, Table, C, F) {
        var vm = $scope;
        var checker = Table.loadMultiSelectedFn(vm);

        vm.wMStates = F.get('wMStates');
        vm.type = '2';
        vm.dt = new Date();

        vm.prevDay = prevDay;
        vm.nextDay = nextDay;

        vm.add = add;
        vm.pay = pay;
        vm.pass = pass;
        vm.back = back;
        vm.batch = batch;
        vm.export = exportWM;
        vm.admin = admin;
        vm.show = show;

        init();

        function init() {

            vm.$on('adminWMAdd', function (ev, q) {
                vm.type = q;
                vm.tableReload();
            });

            vm.$on(C.P + 'workingMeal.handle', function (event, data) {
                var record = data.data.workingMeal;
                record.totalMoney = F.toFixed((parseFloat(record.order.self_paid) + parseFloat(record.order.subsidy)) * parseFloat(record.num), 1);
                var time = record.meal_time.substr(0, 10),
                    now = $filter('date')(vm.dt, 'yyyy-MM-dd');
                if (vm.type == record['order']['type'] && record['state'] != '1' && time == now) {
                    var index = F.indexOfKey(record['id'], vm.tableParams.data);
                    if (index >= 0) {
                        vm.tableParams.data.splice(index, 1);
                    }
                    if (vm.placeIds && F.inArray(record['place_id'], vm.placeIds) >= 0) {
                        if (vm.tableParams.$params.count == vm.tableParams.data.length) {
                            vm.tableParams.data.pop();
                        }
                        record['state'] = F.getItem(record['state'], vm.wMStates);
                        vm.tableParams.data.unshift(record);
                    }
                }
            });

            var options = {
                service: WorkingMeal,
                params: {opt: 4/*WORKINGMEAL.INDEX_WM_ADMIN_APPROVED*/},
                optColWidth: Table._3_BTN,
                showSn: true,
                cols: [
                    {field: "user", title: "订餐人", filter: {user: "text"}},
                    {field: "dept", title: "科室", filter: {dept: "text"}},
                    {field: "place", title: "送餐地点", filter: {place: "text"}},
                    {field: "applicant", title: "填单人", filter: {applicant: "text"}},
                    {field: "order", title: "商品名称", filter: {order: "text"}},
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: F.getNgTableOpts(vm.wMStates)
                    }
                ]
            };

            vm.$watch('dt', function (dt, old, scope) {
                scope.tableParams.$params.page = 1;
                options.params.time = $filter('date')(dt, 'yyyy-MM-dd');
                scope.tableReload();
            }, true);

            vm.$watch('type',
                function (type, old, scope) {
                    scope.tableParams.$params.page = 1;
                    options.params.type = type;
                    scope.tableReload();
                }, true);

            Table.load(vm, options, function (resp) {
                vm.placeIds = resp.placeIds;
                var items = resp.items;
                angular.forEach(items, function (i) {
                    i.totalMoney = F.toFixed((parseFloat(i.order.self_paid) +
                        parseFloat(i.order.subsidy)) * parseFloat(i.num), 1);
                    i.state = F.getItem(i.state, vm.wMStates);
                });
                vm.items = items;
            });
        }

        function add() {
            dialogs.create('WMAdminDetailDlg.html', 'WMAdminDetailDlgCtrl', {}, {

                size: 'md'
            });
        }

        function prevDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() - 1));
        }

        function nextDay(curr) {
            vm.dt = new Date(curr.setDate(curr.getDate() + 1));
        }

        function pay(m) {
            adminHandle(m, 1);
        }


        function pass(m) {
            adminHandle(m, 2);
        }

        function back(m) {
            adminHandle(m, 3);
        }

        function adminHandle(m, opt) {
            WorkingMeal.update({id: m.id}, {opt: opt/*1:WORKINGMEAL.EDIT_USER_PAY 2:WORKINGMEAL.EDIT_ADMIN_PASS 3:WORKINGMEAL.EDIT_ADMIN_BACK*/})
                .$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('处理成功');
                        break;
                    case 1:
                        toaster.warning('订单已处理');
                        break;
                }
                vm.tableReload();
            }, function () {
                toaster.error('订单已删除，请刷新');
            });
        }

        function batch(items, opt) {
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }

            for (var i = 0; i < items.length; i++) {
                if (items[i].type == '3') {
                    toaster.warning('存在已删除订单，请刷新');
                    return;
                }
            }

            WorkingMeal.adminBatch({itemIds: checker.getCheckedIds(items), opt: opt}, function () {
                toaster.success('处理成功');
                vm.tableReload();
            });
        }

        function exportWM() {
            dialogs.create('/templates/meal/wme.html', 'WMECtrl', {day: vm.dt, end_day: vm.dt}, {
                size: 'md'
            }).result.then(function (m) {
                FileHelper.dnExcel(C.URL.WORKING_MEALS_DOWNLOAD, m, m.day + "到" + m.end_day +
                    (m.time == '3' ? '午餐和晚餐' : (m.time == '1' ? '午餐' : '晚餐')) + '手术餐导出表.xls');
            });
        }

        function admin(m) {
            dialogs.create('templates/meal/place_admin.html', 'DeliveryPlaceAdminsDlgCtrl', {
                place: m,
                selfId: vm.account.id
            }, {

                size: 'lg'
            });
        }

        function show() {
            dialogs.create('WMCount.html', 'WMCountDlgCtrl', {
                day: vm.dt,
                type: vm.type
            }, {

                size: 'lg'
            });
        }
    });

angular.module('c.c').controller('WMAdminDetailDlgCtrl',
    function ($scope, $uibModalInstance, $filter, F, dialogs) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        var now = $filter('date')(new Date(), 'HH:mm');
        if (F.checkTime(now, '10:30', '10:50')) {
            vm.type = '2'
        }
        if (F.checkTime(now, '17:00', '17:30')) {
            vm.type = '3'
        }

        function ok() {
            vm.cancel();
            dialogs.create('UserWMAdminDlg.html', 'UserWMAdminDlgCtrl', {type: vm.type}, {

                size: 'md'
            });
        }
    });

angular.module('c.c').controller('UserWMAdminDlgCtrl',
    function ($scope, $rootScope, $uibModalInstance, toaster, uibDateParser, $filter, F, WorkingMeal, DeliveryPlace,
              User, data, $q) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            DeliveryPlace.query({opt: 3/*DELIVERYPLACE.INDEX_USER_OPTIONS*/}, function (resp) {
                vm.places = resp.items;
                vm.m = {
                    in: true,
                    out: false,
                    users: [],
                    place: vm.places[0],
                    note: '',
                    note2: '',
                    type: data.type
                };
            });
        }

        function ok(m) {
            if (m.in && m.users.length == 0) {
                toaster.warning('请选择订餐人!');
            } else if (m.out && (m.num == null || Number(m.num) == 0)) {
                toaster.warning('请确认订餐数量!');
            } else if (m.out && (m.note == null || m.note == "")) {
                toaster.warning('院外备注不能为空!');
            } else if (m.out && !m.user) {
                toaster.warning('请选择订餐人!');
            } else if (!m.place) {
                toaster.warning('请选择送餐地点!');
            } else if (!m.order) {
                toaster.warning('请选择商品!');
            } else if (!m.in && !m.out) {
                toaster.warning('请选择订餐类型!');
            } else {
                var defer = $q.defer();
                var pa = {};
                var keepGoing = true,
                    num = 0;
                if (m.in) {
                    var userIds = [];
                    angular.forEach(m.users, function (u) {
                        userIds.push(u.id);
                    });
                    pa.users = userIds;
                    pa.note2 = m.note2;
                    num += parseInt(m.users.length);
                }
                if (m.out) {
                    pa.user_id = m.user.id;
                    pa.num = m.num;
                    pa.note = m.note;
                    num += parseInt(m.num);
                }
                var o = m.order;
                if (o.residue_supply < num) {
                    keepGoing = false;
                    defer.reject();
                    toaster.warning(o.name + '库存不足');
                } else {
                    pa.order_id = o.id;
                    pa.type = o.type.id;
                }
                pa.place_id = m.place.id;
                pa.isAdmin = true;
                if (keepGoing) {
                    WorkingMeal.save(pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                defer.resolve();
                                toaster.success('订购成功');
                                $rootScope.$broadcast('adminWMAdd', pa.type);
                                vm.cancel();
                                break;
                            default:
                                toaster.warning(resp.msg);
                                defer.reject();
                        }
                        if (resp.result != 0) {
                            defer.reject();
                        }
                    });
                }
                return defer.promise;
            }
        }
    });

angular.module('c.c').controller('WMCountDlgCtrl',
    function ($scope, $uibModalInstance, $filter, F, dialogs, WorkingMeal, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.day = $filter('date')(data.day, 'yyyy-MM-dd');
        vm.type = data.type;
        WorkingMeal.query({opt: 7/*WORKINGMEAL.INDEX_WM_ADMIN_COUNT*/, type: vm.type, day: vm.day}, function (resp) {
            vm.storeCounts = resp.storeCounts;
            vm.deptCounts = resp.deptCounts;
        });
    });
angular.module('c.c').controller('MeetingAppliedController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, C, F, Meeting, Dept, MeetingType, DateHelper) {
        $scope.$on(C.P + 'meeting.read', function (event, data) {
            var meeting = data.data.meeting;
            if ($scope.account.id == meeting.applicant_id) {
                var meetings = $scope.meetings;
                for (var i = 0; i < meetings.length; i++) {
                    if (meetings[i].id == meeting.id) {
                        var attendees = meetings[i].attendees;
                        for (var j = 0; j < attendees.length; j++) {
                            if (attendees[j].id == meeting.reader_id) {
                                attendees[j].is_read = true;
                            }
                        }
                    }
                }
            }
        });
        $scope.$on('meetingSubmit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on(C.P + 'meeting.send', function (event, data) {
            $scope.tableParams.reload();
        });

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var stages = F.getApprovalStages8();
        var stagesOpts = F.getNgTableOpts(stages);

        $scope.cols = [
            {title: '全院可见', filter: {is_public: 'select'}, data: yesNoOpts, width: '10%', show: true},
            {title: '名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '类型', sortable: 'type_id', filter: {type_id: 'select'}, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept_id: 'select'}, width: '10%', show: true},
            {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '开会时间', sortable: 'start_time', filter: {start_time: 'date_range'}, width: '20%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        var typeCol = $scope.cols[2];
        MeetingType.query({opt: 2}, function (resp) {
            $scope.types = resp;
            typeCol.data = F.getNgTableOpts($scope.types);
        });

        var deptCol = $scope.cols[3];
        Dept.query({opt: 12}, function (resp) {
            var depts = resp.depts;
            deptCol.data = F.getNgTableOpts(depts);
            $scope.depts = depts;
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                url['date_range_filters'] = {};
                if ($scope.dateRangeFilter.created_at != null) {
                    url['date_range_filters'] = {
                        created_at: {
                            startDate: $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                if ($scope.dateRangeFilter.start_time != null) {
                    url['date_range_filters'] = {
                        start_time: {
                            startDate: $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                Meeting.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.meetings, function (meeting) {
                        meeting.stage = F.getItem(meeting.stage, stages);
                        meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                        var data = new Date();
                        data = DateHelper.datetime2Str(data);
                        meeting.showCancel = data < meeting.start_time;
                    });
                    $defer.resolve(resp.meetings);
                    $scope.meetings = resp.meetings;
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (meeting) {
            dialogs.create('templates/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                    id: meeting.id,
                    ForApplied: true, SmsAgain: true, isApplicant: true
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 2:
                        $scope.tabs['apply'] = true;
                        $timeout(function () {
                            $rootScope.$broadcast('meetingEdit', params.meeting);
                        }, 200);
                        break;
                }
            });
        };

        $scope.detail = function (meeting) {
            dialogs.create('templates/meeting/leave_dlg.html', 'MeetingLeaveDlgCtrl', {
                    id: meeting.id,
                    isApplicant: true
                },
                {size: 'lg'});
        };

        $scope.qrcode = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {
                    meeting: meeting,
                    type: 'in',
                    qrCodeName: '签到'
                },
                {size: 'md'});
        };

        $scope.qrcode2 = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {
                    meeting: meeting,
                    type: 'out',
                    qrCodeName: '签退'
                },
                {size: 'md'});
        };

        //$scope.m2c = function (meeting) {
        //    dialogs.create('templates/meeting/m2c_dlg.html', 'M2CDlgCtrl', {meeting: meeting}, {
        //
        //        size: 'md'
        //    }).result.then(function (pa) {
        //            if (pa.paper) {
        //                var paper = pa.paper;
        //                paper.release_type = 4; //RELEASE_BY_COURSE
        //                paper.type = C.EDU.P.TYPE.NORMAL;
        //                paper.intro = paper.intro ? paper.intro : '';
        //                pa.paper = paper;
        //            }
        //            ECourse.save(pa).$promise.then(function (resp) {
        //                toaster.success('提交成功');
        //            }, function () {
        //                toaster.error('已存在相同课程题目,提交失败!');
        //            });
        //        });
        //};

        $scope.delete = function (meeting) {
            dialogs.confirm('删除会议', '确定要删除<strong>' + meeting.name + '</strong>吗?')
                .result.then(function () {
                Meeting.delete({id: meeting.id}).$promise.then(function (resp) {

                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }
        $scope.edit = function (meeting) {
            dialogs.create('templates/meeting/edit_dlg.html', 'MeetingEditDlgCtrl', {
                    id: meeting.id, ForEdit: true, deptId: meeting.dept_id,sendWeiXin:true
                },
                {size: 'lg'}).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议修改成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('会议室冲突,请重新修改');
                                break;
                            case 2:
                                toaster.warning('设备冲突,请重新修改');
                                break;
                        }
                    }, function () {
                        toaster.error('会议修改失败了!');
                    }
                );
            });
        };

        $scope.cancelMeeting = function (meeting) {
            dialogs.confirm('取消会议', '确定要取消<strong>' + meeting.name + '</strong>吗?')
                .result.then(function () {
                Meeting.update({id: meeting.id, opt: 4}).$promise.then(function (resp) {
                    toaster.success('取消成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('取消失败!');
                });
            });
        }
    });

angular.module('c.c').controller('AttendeesTipsCtrl',
    function ($scope, $interval) {
        var attendees = $scope.meeting.attendees;
        var n = Math.ceil(attendees.length / 20);
        var i = 0;

        $scope.attendees = attendees.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.attendees = attendees.slice(i * 20, (i + 1) * 20);
                if ($scope.attendees.length < 20) {
                    var k = 20 - $scope.attendees.length;
                    for (var j = 0; j < k; j++) {
                        $scope.attendees.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    });

angular.module('c.c').controller('MeetingApplyController',
    function ($scope, $rootScope, $q, dialogs, $filter, $timeout, toaster, Upload, C, F, Meeting, MeetingRoom, MeetingType,
              MeetingDevice, Dept, uibDateParser, FileHelper, Dlg, DateHelper) {

        $scope.has_conflict = false;   //参会人是否有冲突
        function time2SliderVal(time) {
            var hour = parseInt(time.substr(0, 2));
            var minute = parseInt(time.substr(3, 2));
            return hour * 12 + minute / 5;
        }

        $scope.$on('meetingEdit', function (ev, meeting) {
            $scope.firstSearch = true;
            $scope.meeting['devices'] = [];
            $scope.meeting['room'] = null;
            $scope.meeting['place'] = null;
            $scope.meeting['name'] = meeting.name;
            $scope.meeting['type'] = meeting.type;
            $scope.meeting['dept'] = meeting.dept;
            $scope.meeting['all_doctor'] = meeting.all_doctor == '1';
            $scope.meeting['all_nurse'] = meeting.all_nurse == '1';
            $scope.meeting['all_medical'] = meeting.all_medical == '1';
            $scope.meeting['all_attend'] = meeting.all_attend == '1';
            $scope.meeting['is_public'] = meeting.is_public == '1';
            $scope.meeting['is_dept'] = meeting.is_dept == '1';
            $scope.meeting['with_sms'] = meeting.with_sms == '1';
            $scope.meeting['with_sms2'] = meeting.with_sms2 == '1';
            $scope.meeting['mdt'] = meeting.mdt == '1';
            if (meeting.reminder_time != null) {
                $scope.meeting['is_remind'] = true;
            } else {
                $scope.meeting['is_remind'] = false;
            }
            $scope.meeting['date'] = uibDateParser.parse(meeting.start_time.substr(0, 10), 'yyyy-MM-dd');
            $scope.meeting.s.min = time2SliderVal(meeting.start_time.substr(11, 5));
            $scope.meeting.s.max = time2SliderVal(meeting.end_time.substr(11, 5));
            $scope.meeting['moderator'] = meeting.moderator;
            $scope.meeting['recorder_id'] = meeting.recorder_id;
            $scope.meeting['attendees'] = meeting.attendees;
            $scope.meeting['attachments'] = meeting.attachments;
            $scope.meeting['content'] = meeting.content;
        });

        $scope.searchIdle = function (meeting) {
            if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else {
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                MeetingRoom.query({opt: 2, start: start, end: end, date: date}, function (resp) {
                    $scope.rooms = resp.rooms;
                    $scope.rooms.splice(0, 0, {name: '无'});
                    if (meeting.room == null) {
                        meeting.room = $scope.rooms[0];
                    } else {
                        meeting.room = F.getItem(meeting.room.id, $scope.rooms);
                    }
                });
                MeetingDevice.query({opt: 2, start: start, end: end}, function (resp) {
                    $scope.devices = resp.devices;
                    var backup = meeting.devices;
                    meeting.devices = [];
                    $timeout(function () {
                        var devices = [];
                        angular.forEach(backup, function (dev) {
                            var device = F.getItem(dev.id, resp.devices);
                            if (device) {
                                devices.push(device);
                            }
                        });
                        meeting.devices = devices;
                    });
                });

                Meeting.query({opt: 12, start: start, end: end}, function (resp) {
                    if (resp.conflicts.length > 0) {
                        $scope.has_conflict = true;
                        $scope.conflicts = resp.conflicts.toString();
                    }
                });
                $scope.firstSearch = false;
            }
        };

        $scope.submit = function (meeting, isDraft, checkLeave, leaveUserIds) {
            if (DateHelper.date2Str(new Date())>='2025-10-27'){
                Dlg.error("会议预定功能已迁移至飞书，请前往飞书预定，谢谢！")
            }else {
                var promise = submitEmail(meeting, isDraft, checkLeave, leaveUserIds);
                if (promise) {
                    if (isDraft) {
                        promise.then(function (resp) {
                            if (resp.leaveUsers.length > 0) {
                                showLeaves(resp.leaveUsers, meeting, isDraft);
                            } else {
                                toaster.success('会议已保存为草稿!');
                                $scope.reset();
                            }
                        }, function () {
                            toaster.error('会议保存失败了!');
                        });
                    } else {
                        promise.then(function (resp) {
                            switch (resp.result) {
                                case 0:
                                    if (resp.leaveUsers.length > 0) {
                                        showLeaves(resp.leaveUsers, meeting, isDraft);
                                    } else {
                                        toaster.success('会议申请成功!');
                                        $scope.reset();
                                        $scope.tabs['applied'] = true;
                                        $rootScope.$broadcast('meetingSubmit');
                                    }
                                    break;
                                case 1:
                                    toaster.warning('会议室冲突,请重新申请');
                                    break;
                                case 2:
                                    toaster.warning('设备冲突,请重新申请');
                                    break;
                                case 3:
                                    toaster.warning('门诊6楼会议室11:30~13:00无法申请,请重新选择时间');
                                    break;

                            }
                        }, function () {
                            toaster.error('会议申请失败了!');
                        });
                    }
                }
            }
        };

        function showLeaves(users, meeting, isDraft) {
            Dlg.show({
                template: 'templates/meeting/show_leave.html',
                ctrl: 'MeetingShowLeaveDlgCtrl',
                data: {
                    users: users
                },
                size: 'md'
            }).then(function (resp) {
                $scope.submit(meeting, isDraft, 0, resp);
            });
        }

        function submitEmail(meeting, isDraft, checkLeave, leaveUserIds) {
            var promise = null;
            if (meeting.name == null || meeting.name == "") {
                toaster.warning('名称不能为空!');
            } else if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else if (meeting.place == null && meeting.room == null) {
                toaster.warning('请选择会议室或备注地点!');
            } else if (meeting.place == null && meeting.room.id == null) {
                toaster.warning('请选择会议室或备注地点!');
            } else if (!meeting.all_attend && !meeting.all_medical && !meeting.all_doctor && !meeting.all_nurse && meeting.attendees.length == 0) {
                toaster.warning('请填写参会人!');
            } else if (meeting.content == "") {
                toaster.warning('内容不能为空!');
            } else if (!FileHelper.isAttachmentsUploaded(meeting)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {is_draft: isDraft};
                params['name'] = meeting.name;
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                params['start_time'] = start;
                params['end_time'] = end;
                //将参会人id放入参会人组
                params['attendees'] = [];
                angular.forEach(meeting.attendees, function (attendee) {
                    params['attendees'].push(attendee.id);
                });
                if (meeting.moderator != null) {
                    params['moderator_id'] = meeting.moderator.id;
                    //var index = F.indexOf(meeting.moderator.id, params['attendees']);
                    //if (index >= 0) {
                    //    params['attendees'].splice(index, 1);
                    //}
                }
                params['content'] = meeting.content;
                if (meeting.recorder != null) {
                    params['recorder_id'] = meeting.recorder.id;
                }
                if (meeting.all_attend) {
                    params['all_attend'] = meeting.all_attend ? '1' : '0';
                } else {
                    params['all_medical'] = meeting.all_medical ? '1' : '0';
                    params['all_nurse'] = meeting.all_nurse ? '1' : '0';
                    params['all_doctor'] = meeting.all_doctor ? '1' : '0';
                    params['is_dept'] = meeting.is_dept ? '1' : '0';
                }

                params['is_public'] = meeting.is_public ? '1' : '0';
                if (meeting.is_dept) {
                    params['is_public'] = '0'
                }
                params['type_id'] = meeting.type.id;
                if (meeting.room == null) {
                    params['room_id'] = null;
                } else {
                    if (meeting.room.id == null) {
                        params['room_id'] = null;
                    } else {
                        params['room_id'] = meeting.room.id;
                    }
                }
                params['dept_id'] = meeting.dept.id;
                params['place'] = meeting.place;
                params['devices'] = [];
                angular.forEach(meeting.devices, function (dev) {
                    params['devices'].push(dev.id);
                });
                if (meeting.all_attend || meeting.all_doctor || meeting.all_nurse || meeting.all_medical) {
                    params['with_sms'] = 0;
                    params['is_remind'] = 0;
                } else {
                    // params['with_sms'] = meeting.with_sms ? '1' : '0';
                    params['with_sms'] = '0';
                    // params['is_remind'] = meeting.is_remind ? '1' : '0';
                }
                params['mdt'] = meeting.mdt ? '1' : '0';
                params['is_remind'] = meeting.is_remind ? '1' : '0';
                params['attachments'] = [];
                angular.forEach(meeting.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                params['checkLeave'] = angular.isUndefined(checkLeave) ? 1 : checkLeave;
                params['leaveUserIds'] = angular.isUndefined(leaveUserIds) ? [] : leaveUserIds;
                promise = Meeting.save(params).$promise
            }
            return promise;
        }

        $scope.reset = function () {
            $scope.today = new Date();
            $scope.firstSearch = true;
            $scope.meeting = {
                all_attend: false,
                all_doctor: false,
                all_nurse: false,
                all_medical: false,
                is_public: true,
                attachments: [],
                is_dept: false,
                devices: [],
                attendees: [],
                date: $scope.today,
                content: '',
                public: true,
                is_remind: true,
                s: {
                    min: 144, max: 168, options: {
                        floor: 84,
                        ceil: 276,
                        translate: function (val) {
                            var h = Math.floor(val / 12);
                            var m = (val % 12) * 5;
                            return h + ':' + (m >= 10 ? '' : '0') + m;
                        }
                    }
                }
            };
            MeetingType.query({opt: 2}, function (resp) {
                $scope.types = resp;
                Dept.query({opt: 12}, function (resp) {
                    $scope.depts = resp.depts;
                    $scope.meeting['dept'] = $scope.depts[0];
                    $scope.meeting['type'] = $scope.types[0];
                });
            });
        };
        $scope.reset();

        $scope.$watch('meeting.all_attend',
            function (newValue, oldValue) {
                if (newValue) {
                    $scope.meeting.is_public = true;
                    $scope.meeting.is_dept = false;
                    $scope.meeting.attendees = []
                }
            }, true);

        $scope.deleteAttachment = function ($index, meeting) {
            meeting.attachments.splice($index, 1);
        };

        $scope.upload = function (file, meeting, e) {
            FileHelper.upload(C.URL.MEETING_UPLOAD, file, meeting, e);
        };

        $scope.roomDetail = function () {
            dialogs.create('templates/meeting/room_detail.html', 'RoomDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        };

        $scope.devDetail = function () {
            dialogs.create('templates/meeting/dev_detail.html', 'DevDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        };

        $scope.preview = function (meeting) {
            Dlg.show({
                template: 'templates/meeting/previewDlg.html',
                ctrl: 'meetingPreviewDlgCtrl',
                data: {meeting: meeting},
                size: 'lg'
            });
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('MeetingDraftCtrl', MeetingDraftCtrl);

    /** @ngInject */
    function MeetingDraftCtrl ($scope, Table, $q, Meeting, MeetingRoom, MeetingType,
                               MeetingDevice, Dlg, UIHelper) {
        var vm = $scope;
        var checker = Table.loadMultiSelectedFn(vm);
        vm.relaunch = relaunch;
        vm.remove = remove;


        init();

        function init () {
            UIHelper.loadTab(vm, 'draft');
            $q.all([
                MeetingType.query({opt: 2}).$promise
            ]).then(function (respArray) {
                vm.types = respArray[0];
                var options = {
                    service: Meeting,
                    params: {opt: 14}, /*草稿箱*/
                    optInFront: true,
                    optColWidth: Table._2_BTN,
                    sorting: {},
                    items: 'meetings',
                    cols: [
                        {field: "name", title: '名称', filter: {name: 'text'}, width: '20%'},
                        {
                            field: "type",
                            title: '类型',
                            filter: {type_id: 'select'},
                            width: '20%',
                            data: Table.getNgTableOpts(vm.types)
                        },
                        {field: "time_range", title: '开会时间', filter: {start_time: 'date_range'}, width: '20%'},
                        {field: "room", title: '开会地点', width: '10%'},
                        {field: "dept", title: '科室', filter: {dept: 'text'}, width: '10%'},
                    ]
                };
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.meetings, function (meeting) {
                        meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                    });
                });
            });
        }

        function relaunch (meeting) {
            Dlg.show({
                template: 'templates/meeting/edit_dlg.html',
                ctrl: 'MeetingEditDlgCtrl',
                data: {id: meeting.id, ForEdit: true, deptId: meeting.dept_id},
                size: 'lg'
            }).then(function (params) {
                params.is_draft = false;
                params.opt = 8;
                Meeting.update({id: meeting.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('会议提交成功');
                            vm.tableReload();
                            break;
                        case 1:
                            Dlg.w('会议室冲突,请重新修改');
                            break;
                        case 2:
                            Dlg.w('设备冲突,请重新修改');
                            break;
                    }
                }, function () {
                    Dlg.e('提交失败!');
                });
            });
        }

        function remove (isBatch, m) {
            var defer = $q.defer();
            var items = [];
            var count = 0;
            if (isBatch) {
                items = checker.getChecked();
                count = items.length;
                if (count === 0) {
                    checker.clearChecked();
                    Dlg.w("请至少选中一个待处理选项");
                    return;
                }
            } else {
                items.push(m);
                count = 1;
            }
            angular.forEach(items, function (item) {
                var tip = "名称为" + item.name + '会议';
                Meeting.delete({id: item.id}).$promise.then(function (resp) {
                    Dlg.s(tip + "删除成功");
                }, function (error) {
                    var resp = error.data;
                    Dlg.e(tip + "删除失败：" + resp.msg);
                }).finally(function () {
                    count--;
                    if (count === 0) {
                        defer.resolve();
                        checker.clearChecked();
                        vm.tableReload();
                    }
                });
            });
            return defer.promise;
        }
    }

})();




(function () {
    'use strict';

    angular.module('c.c')
        .controller('MeetingRecordCtrl', MeetingRecordCtrl);

    /** @ngInject */
    function MeetingRecordCtrl($scope, ArrayHelper, UIHelper, Table, Dlg, Meeting) {
        var vm = $scope;
        vm.show = show;
        vm.finish = finish;
        vm.edit = edit;

        init();


        function init() {
            var records = Meeting.getWithRecords();
            var options = {
                service: Meeting,
                params: {opt: '13'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "会议名称", filter: {name: "text"}},
                    {field: "start_time", title: "会议时间", width: Table._1_CHAR},
                    {
                        field: "with_record", title: "状态", filter: {with_record: "select"}, width: Table._1_CHAR,
                        data: Table.getNgTableOpts(records)
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.with_record = ArrayHelper.getItem(item.with_record, records);

                });
            });

        }

        function show(m) {
            Dlg.show({
                template: 'templates/meeting/show_dlg.html',
                ctrl: 'MeetingShowDlgCtrl',
                data: {
                    id: m.id,
                    isRecorder: true
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function finish(m) {
            var pa = {
                opt: '6',
                id: m.id
            };
            Dlg.confirm('确认要结束该记录吗?', function () {
                Meeting.update(pa).$promise.then(function (resp) {
                    if (resp.result == 0) {
                        Dlg.s('记录结束成功');
                        vm.tableReload();
                    }
                }, function (error) {
                    Dlg.e(error);
                });
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'templates/meeting/recordDlg.html',
                ctrl: 'MeetingRecordDlgCtrl',
                data: {
                    id: m.id,
                    deptId: m.dept_id,
                },
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            })
        }
    }

})();


(function () {
    'use strict';

    angular.module('c.c').controller('MeetingSearchController', MeetingSearchController);

    /** @ngInject */
    function MeetingSearchController($scope, $filter, dialogs, toaster, NgTableParams, F, DateHelper,
                                     Meeting, MeetingType, uibDateParser,Dlg) {
        $scope.$on('MeetingRead', function (event, data) {
            var id = data;
            var index = F.indexOfKey(id, $scope.tableParams.data);
            if (index >= 0 && $scope.tableParams.data[index].recipient == null) {
                $scope.tableParams.data[index].recipient = 1;
            }
        });

        $scope.init = function (op) {
            if (DateHelper.date2Str(new Date())>='2025-10-27'){
                Dlg.error("会议预定功能已迁移至飞书，请前往飞书预定，谢谢！")
            }
            Meeting.loadRelevantFun($scope);

            var readStatusOpts = F.getNgTableOpts(F.get('readOrUnread'));

            $scope.cols = [
                {title: '状态', filter: {is_read: 'select'}, data: readStatusOpts, width: '10%', show: true},
                {title: '名称', filter: {name: 'text'}, width: '20%', show: true},
                {title: '类型', filter: {type_id: 'select'}, width: '20%', show: true},
                {title: '开会时间', filter: {start_time: 'date_range'}, width: '20%', show: true},
                {title: '开会地点', width: '10%', show: true},
                {title: '科室', filter: {dept: 'text'}, width: '10%', show: true},
                {title: '申请人', filter: {applicant: 'text'}, show: true}
            ];

            var typeCol = $scope.cols[2];
            MeetingType.query({opt: 2}, function (resp) {
                $scope.types = resp;
                typeCol.data = F.getNgTableOpts($scope.types);
            });

            $scope.dateRangeFilter = {};
            $scope.$watch('dateRangeFilter',
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true);

            $scope.optColWidth = 53;
            $scope.tableParams = new NgTableParams({
                page: 1, count: 10
            }, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = op;//2 查找会议 9 我的会议
                    if ($scope.dateRangeFilter.start_time != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd');
                    }
                    Meeting.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.meetings, function (meeting) {
                            meeting.forLeave = false;
                            meeting.forRemind = false;
                            meeting.isLeaver = false;
                            meeting.forRCancel = false;
                            meeting.forDayRemind = false;
                            meeting.isModerator = false;
                            meeting.isApplicant = false;
                            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                            var start = new Date(),
                                end = uibDateParser.parse(meeting.start_time, 'yyyy-MM-dd HH:mm:ss');

                            var yesterday = new Date(end - 24 * 60 * 60 * 1000),
                                time = $filter('date')(yesterday, 'yyyy-MM-dd') + ' ' + '08:30:00',
                                y_start = uibDateParser.parse(time, 'yyyy-MM-dd HH:mm:ss');

                            if (DateHelper.diffInHours(start, y_start) >= 1) {
                                if (op == 9) {
                                    if (meeting.attendees.length > 0) {
                                        if (meeting.attendees[0].reminder_time) {
                                            meeting.forRCancel = true;
                                        } else {
                                            meeting.forDayRemind = true;
                                        }
                                    }
                                }
                            }

                            if (DateHelper.diffInHours(start, end) >= 1) {
                                if (op == 9) {
                                    if (meeting.attendees.length > 0) {
                                        if (meeting.attendees[0].reminder_time) {
                                            meeting.forRCancel = true;
                                        } else {
                                            meeting.forRemind = true;
                                        }
                                    }
                                }
                            }

                            if (DateHelper.diffInMinutes(start, end) >= 30) {
                                if (meeting.attendees.length > 0) {
                                    meeting.forLeave = true;
                                }
                            }

                            if (meeting.leavers.length > 0) {
                                meeting.isLeaver = true;
                                meeting.forLeave = false;
                            }

                            if (meeting.moderator_id && meeting.moderator_id == $scope.account.id) {
                                meeting.isModerator = true;
                            }

                            if (meeting.applicant_id == $scope.account.id) {
                                meeting.isApplicant = true;
                            }
                        });
                        $defer.resolve(resp.meetings);
                        $scope.meetings = resp.meetings;
                    });
                }
            });

            $scope.clearFilters = function () {
                $scope.tableParams.filter({});
                $scope.dateRangeFilter = {};
            };
        };

        $scope.show = function (meeting) {
            dialogs.create('templates/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                    id: meeting.id,
                    ForLeave: meeting.forLeave,
                    ForRemind: meeting.forRemind,
                    ForDayRemind: meeting.forDayRemind,
                    ForRCancel: meeting.forRCancel,
                    isApplicant: meeting.isApplicant,
                    isModerator: meeting.isModerator
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        $scope.leave(meeting);
                        break;
                    case 5:
                        $scope.remind(meeting, params.op);
                        break;
                    case 6:
                        $scope.cancel(meeting);
                        break;
                }
            });
        };

        $scope.qrcode = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {
                    meeting: meeting,
                    type: 'in',
                    qrCodeName: '签到'
                },
                {size: 'md'});
        };
        $scope.qrcode2 = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {
                    meeting: meeting,
                    type: 'out',
                    qrCodeName: '签退'
                },
                {size: 'md'});
        };

        $scope.exportMeeting = function () {
            dialogs.create('templates/export_meeting_dlg.html', 'ExportMeetingCtrl', {},
                {size: 'md'});
        };

    }
})();

angular.module('c.c').controller('TopicAppliedController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, C, MeetingTopic, Dept) {
        $scope.$on('topicSubmit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicEdit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('topicApproved', function () {
            $scope.tableParams.reload();
        });

        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        var stages = F.get('approval_stages4');
        var stagesOpts = F.getNgTableOpts(stages);
        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        // 提取索引 0 到 7 的元素并添加索引 13 的元素
        var extractedItems = stagesOpts.slice(0, 8); // 包含索引 0 到 7
        extractedItems.push(stagesOpts[13]); // 添加索引 13 的元素
        var filteredItems = extractedItems;


        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '类型', sortable: 'type', filter: {type: 'select'}, data: topic_typesOpts, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept_id: 'select'}, show: true},
            {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: filteredItems, width: '10%', show: true}
        ];

        var deptCol = $scope.cols[4];
        Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS2}, function (resp) {
            var depts = resp.depts;
            deptCol.data = F.getNgTableOpts(depts);
            $scope.depts = depts;
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] =  C.OPT.MEETING_TOPIC.INDEX.USER_APPLIED;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                        topic.stage = F.getItem(topic.stage, stages);
                    });
                    $defer.resolve(resp.topics);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            console.log(stages)
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {
                    id: topic.id, ForEdit: true, ForBackToAdd: true
                },
                { size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 1:
                        $scope.tabs['apply'] = true;
                        $timeout(function () {
                            $rootScope.$broadcast('topicEdit1', params.topic);
                        }, 200);
                        break;
                }
            });
        };

        $scope.delete = function (topic) {
            dialogs.confirm('删除议题', '确定要删除<strong>' + topic.subject + '</strong>吗?')
                .result.then(function () {
                MeetingTopic.delete({id: topic.id}).$promise.then(function (resp) {
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }
    });


angular.module('c.c').controller('TopicApplyController',
    function ($scope, $rootScope, dialogs, $filter, toaster, uibDateParser, Upload, C, F, Dept, MeetingTopic, FileHelper) {
        $scope.topic_types = F.get('topic_types');

        $scope.$on('topicEdit1', function (ev, topic) {
            topic['is_public'] = topic.is_public == '1';
            topic['is_urgent'] = topic.is_urgent == '1';
            $scope.topic = topic;
        });

        $scope.$watch('topic.is_triple', function (value, old) {
            if (value) {
                $scope.topic.type = $scope.topic_types[0];
            }
        });

        $scope.deleteAttachment = function ($index, topic) {
            topic.attachments.splice($index, 1);
        };

        $scope.upload = function (file, topic, e) {
            FileHelper.upload(C.URL.TOPIC_UPLOAD, file, topic, e);
        };

        $scope.submit = function (topic) {
            if (topic.subject == null || topic.subject == "") {
                toaster.warning('标题不能为空!');
            } else if (topic.body == null || topic.body == "") {
                toaster.warning('正文内容不能为空!');
            } else if (topic.type.id == 4 && topic.recorders == 0) {
                toaster.warning('记录人必填!');
            } else if (topic.type.id == 4 && topic.hosts.length == 0) {
                toaster.warning('主持人必填!');
            } else if (!FileHelper.isAttachmentsUploaded(topic)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {};
                params['subject'] = topic.subject;
                params['body'] = topic.body;
                params['dept_id'] = topic.dept.id;
                params['type'] = topic.type.id;
                params['is_public'] = topic.is_public ? '1' : '0';
                params['is_urgent'] = topic.is_urgent ? '1' : '0';
                params['is_triple'] = topic.is_triple ? '1' : '0';
                params['rapporteurs'] = [];
                if (topic.id){
                    params['old_id']=topic.id;
                }
                angular.forEach(topic.rapporteurs, function (dev) {
                    params['rapporteurs'].push(dev.id);
                });
                params['observers'] = [];
                angular.forEach(topic.observers, function (dev) {
                    params['observers'].push(dev.id);
                });
                //当为专题会时候，读取主持人\记录人
                if (topic.type.id == 4) {
                    params['hosts'] = [];
                    angular.forEach(topic.hosts, function (dev) {
                        params['hosts'].push(dev.id);
                    });
                    params['recorders'] = [];
                    angular.forEach(topic.recorders, function (dev) {
                        params['recorders'].push(dev.id);
                    });
                }
                params['attachments'] = [];
                angular.forEach(topic.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                MeetingTopic.save(params).$promise.then(function () {
                    toaster.success('议题申请成功!');
                    $scope.reset();
                    $scope.tabs['applied'] = true;
                    $rootScope.$broadcast('topicSubmit');
                }, function () {
                    toaster.error('议题申请失败了!');
                });
            }
        };

        $scope.reset = function () {
            Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS2}, function (resp) {
                $scope.depts = resp.depts;
                $scope.topic = {
                    is_public: true,
                    is_urgent: false,
                    body: '',
                    attachments: [],
                    rapporteurs: [{
                        id: $scope.account.id,
                        name: $scope.account.name,
                        username: $scope.account.username
                    }],
                    observers: [{id: $scope.account.id, name: $scope.account.name, username: $scope.account.username}],
                    type: $scope.topic_types[0],
                    dept: $scope.depts[0]
                }
            });
        };
        $scope.reset();

        $scope.preview = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {
                id: 0, preview: topic
            }, {
                size: 'lg'
            });
        }
    });

angular.module('c.c').controller('TopicHandledController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, C, MeetingTopic, Dept) {
        $scope.$on('topicHandle', function () {
            $scope.tableParams.reload();
        });

        var stages = F.get('approval_stages4');
        var stagesOpts = F.getNgTableOpts(stages);
        var topic_types = F.get('topic_types');
        var topic_typesOpts = F.getNgTableOpts(topic_types);
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var extractedItems = stagesOpts.slice(0, 8); // 包含索引 0 到 7
        extractedItems.push(stagesOpts[13]); // 添加索引 13 的元素
        var filteredItems = extractedItems;

        $scope.cols = [
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, show: true},
            {title: '是否三重一大', filter: {is_triple: 'select'}, data: yesNoOpts, show: true},
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '类型', sortable: 'type', filter: {type: 'select'}, data: topic_typesOpts, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept_id: 'select'}, show: true},
            {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: filteredItems, width: '10%', show: true}
        ];

        var deptCol = $scope.cols[4];
        Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS2}, function (resp) {
            var depts = resp.depts;
            deptCol.data = F.getNgTableOpts(depts);
            $scope.depts = depts;
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] =  C.OPT.MEETING_TOPIC.INDEX.USER_HANDLED;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                MeetingTopic.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.topics, function (topic) {
                        topic.type = F.getItem(topic.type, topic_types);
                        topic.stage = F.getItem(topic.stage, stages);
                    });
                    $defer.resolve(resp.topics);
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.detail = function (topic) {
            dialogs.create('templates/meeting_topic/show_dlg.html', 'TopicShowDlgCtrl', {
                    id: topic.id, ForEdit: true, ForBackToAdd: true
                },
                { size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 1:
                        $scope.tabs['apply'] = true;
                        $timeout(function () {
                            $rootScope.$broadcast('topicEdit1', params.topic);
                        }, 200);
                        break;
                }
            });
        };

        $scope.delete = function (topic) {
            dialogs.confirm('删除议题', '确定要删除<strong>' + topic.subject + '</strong>吗?')
                .result.then(function () {
                MeetingTopic.delete({id: topic.id}).$promise.then(function (resp) {
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('MissionBaseApplyController', MissionBaseApplyController)
        .controller('MissionApplyController', MissionApplyController)
        .controller('MissionJobTimeDlgCtrl', MissionJobTimeDlgCtrl)
    ;

    function MissionBaseApplyController ($scope, $rootScope, $filter, $timeout, toaster, Upload
        , C, F, Auth, Mission, Dept, FileHelper, UIHelper, Dlg, DateHelper, ArrayHelper, $q) {
        var vm = $scope;
        vm.distributeJob = distributeJob;
        vm.submit = submit;
        vm.submitThen = submitThen;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.reset = reset;
        vm.onCKReady = UIHelper.onCKReady;
        var today = new Date();
        var missionSources = ArrayHelper.get('mission_sources');

        init();

        function init () {
            vm.sourceSelectFn = function () {
                Mission.query({
                    dept_id: vm.mission['dept'].id,
                    opt: 3 /*INDEX_MISSION_SOURCE*/
                }, function (resp) {
                    vm.mission_sources = missionSources;
                    vm.mission['source'] = vm.mission_sources[0];

                    vm.mission_types = resp.types;
                });
            };

            vm.timeOptions = {
                readonlyInput: false,
                showMeridian: false
            };

            reset();

            vm.$on('missionApply', function (ev, doc) {
                var getData = vm.mission;
                getData['name'] = doc.subject;
                getData = setCurrencyAtt(getData, doc);

                var publisher = doc.applicant;
                publisher.coworkers = getUsersBySteps(getData, doc, doc.applicant);
                getData['publishers'] = [publisher];
                vm.mission = getData;
            });

            vm.$on('missionApplyByNew', function (ev, model) {
                var getData = vm.mission;
                getData['name'] = model.title;
                getData['publishers'] = [model.sender];
                getData = setCurrencyAtt(getData, model);
                vm.mission = getData;
            });

            vm.$on('missionApplyByArticle', function (ev, model) {
                var getData = vm.mission;
                getData['name'] = model.title;
                getData['publishers'] = [model.sender];
                getData = setCurrencyAtt(getData, model);
                getData['attachments'] = model.attachment;
                vm.mission = getData;
            });

            vm.$on('missionApplyByMail', function (ev, model) {
                var getData = vm.mission;
                getData['name'] = model.subject;
                var publisher = model.sender;
                getData['publishers'] = [checkDuplicate(publisher, model.recipients)];
                getData = setCurrencyAtt(getData, model);
                vm.mission = getData;
            });
        }

        function setCurrencyAtt (ev, model) {
            ev['publish'] = Auth.getAccount();
            ev['content'] = model.body;
            ev['attachments'] = model.attachments;
            return ev;
        }

        function getUsersBySteps (ev, model, apply) {
            var coworkers = [];
            var coworkerIds = [];
            if (ev['publish']['id'] != apply.id) {
                coworkers.push(apply);
                coworkerIds.push(apply.id);
            }
            angular.forEach(model.steps, function (step) {
                if (step.handler.id != null && coworkerIds.indexOf(step.handler.id) == -1
                    && ev['publish']['id'] != step.handler.id) {
                    coworkers.push(step.handler);
                    coworkerIds.push(step.handler.id);
                }
            });
            return coworkers;
        }

        function checkDuplicate (publisher, coworkers) {
            publisher.coworkers = [];
            var coworkerIds = [];
            coworkerIds.push(publisher.id);
            angular.forEach(coworkers, function (coworker) {
                if (coworker.id != null && coworkerIds.indexOf(coworker.id) == -1) {
                    publisher.coworkers.push(coworker);
                    coworkerIds.push(coworker.id);
                }
            });
            return publisher;
        }

        function getNextMonth (date) {
            var a = date.getFullYear();
            var m = date.getMonth();
            var d = date.getDate();

            date = new Date(a, m + 1, d);

            if (date.getDate() !== d)
                date = getNextDay(date, -1);
            return date;
        }

        function getNextDay (date, day) {
            return new Date(date.valueOf() + day * 24 * 60 * 60 * 1000);
        }

        function setDateHour (date, hour, min, sec) {
            min = min ? min : 0;
            sec = sec ? sec : 0;
            return new Date(date.setHours(hour, min, sec));
        }

        function reset () {
            $scope.mission = {
                is_public: false,
                urgent: false,
                attachments: [],
                publishers: [],
                start: setDateHour(new Date(), 8),
                end: setDateHour(getNextMonth(new Date()), 17, 30),   //自动加一天
                content: ''
            };
            Dept.query({opt: 12}, function (resp) {
                $scope.depts = resp.depts;
                var keep_going = true;
                angular.forEach(resp.depts, function (dept) {
                    if (keep_going) {
                        if (dept.is_main) {
                            $scope.mission['dept'] = dept;
                            keep_going = false;
                        }
                    }
                });
                $scope.sourceSelectFn();
            });
        }

        function deleteAttachment ($index, mission) {
            mission.attachments.splice($index, 1);
        }

        function upload (file, mission, e) {
            FileHelper.upload(C.URL.MEETING_UPLOAD, file, mission, e);
        }

        function distributeJob (m) {
            Dlg.show({
                template: 'templates/mission/missionJobTimeDlg.html',
                ctrl: 'MissionJobTimeDlgCtrl',
                data: {
                    expect_whs: m.expect_whs,
                    publishers: m.publishers,
                    isRegular: false,
                },
                size: 'lg'
            }).then(function (resp) {
                m.expect_whs = resp.expect_whs;
                m.publishers = resp.publishers;
            });
        }

        function submit (mission) {
            var defer = $q.defer();
            var isPass = false;
            vm.workTypeError = false;
            if (mission.name == null || mission.name == "") {
                Dlg.w('任务名称不能为空!');
            } else if (mission.publishers.length == 0) {
                Dlg.w('请填写任务负责人');
            } else if (!mission.start) {
                Dlg.w('任务开始日期不能为空');
            } else if (!mission.end) {
                Dlg.w('任务结束日期不能为空');
            } else if (mission.start > mission.end) {
                Dlg.w('任务开始不能大于结束日期');
            } else if (mission.type == null) {
                Dlg.w('请选择任务类型!');
            } else if (mission.content == "") {
                Dlg.w('内容不能为空!');
            } else if (!mission.work_type_1 && !mission.work_type_2) {
                Dlg.w('请选择例行任务还是临时任务!');
                vm.workTypeError = true;
            } else {
                isPass = true;
                for (var i = 0; i < mission.attachments.length; i++) {
                    if (mission.attachments[i].filename == null) {
                        Dlg.w('请等一小会儿,部分附件还在路上');
                        return;
                    }
                }
                var params = {};
                params['name'] = mission.name;
                params['start_time'] = $filter('date')(mission.start, 'yyyy-MM-dd HH:mm');
                params['end_time'] = $filter('date')(mission.end, 'yyyy-MM-dd HH:mm');

                params['dept_id'] = mission.dept.id;
                params['publishers'] = mission.publishers;
                params['source'] = mission.source.id;
                params['type_id'] = mission.type.id;
                params['expect_whs'] = mission.expect_whs;
                params['work_type'] = mission.work_type_1 ? 1 : 2;

                params['content'] = mission.content;
                params['with_sms'] = mission.with_sms ? '1' : '0';
                params['is_public'] = mission.is_public ? '1' : '0';
                params['urgent'] = mission.urgent ? '1' : '0';
                params['is_remind'] = mission.is_remind ? '1' : '0';


                params['attachments'] = [];
                angular.forEach(mission.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                vm.submitThen(params, defer);
            }

            if (!isPass) {
                defer.reject();
            }
            return defer.promise;
        }

        function submitThen (params, defer) {
            Mission.save(params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        Dlg.s('任务申请成功!');
                        $scope.reset();
                        $scope.tabs['personal'] = true;
                        $rootScope.$broadcast('missionSubmit');
                        break;
                    case 1:
                        Dlg.w('非工作日不允许申请任务!');
                }
            }, function (err) {
                if (err.data.msg) {
                    Dlg.e(err.data.msg)
                } else {
                    Dlg.e('任务申请失败了!');
                }
            }).finally(function () {
                defer.resolve();
            });
        }
    }

    function MissionApplyController ($scope, $controller) {
        $controller('MissionBaseApplyController', {$scope: $scope});
    }

    function MissionJobTimeDlgCtrl ($scope, data, $uibModalInstance, FormHelper, Dlg) {
        var vm = this;
        vm.calculationWHS = calculationWHS;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.publishers, data.expect_whs, data.isRegular);

        function init (publishers, expect_whs, isRegular) {
            vm.isRegular = isRegular;
            vm.totalWHS = 0;

            vm.m = {
                is_auto: true,
                expect_whs: null,
                publishers: publishers
            };

            if (expect_whs && expect_whs > 0) {
                vm.m.is_auto = false;
                vm.m.expect_whs = expect_whs;
            }


            $scope.$watch('vm.m.publisher',
                function (newValue, oldValue) {
                    if (newValue) {
                        if (vm.m.publishers.length === 0 || newValue.id != vm.m.publishers[0].id) {
                            vm.m.publishers = [newValue];
                        }
                    }
                }, true);
        }

        function calculationWHS (m) {
            var totalWHS = 0;
            angular.forEach(m.publishers, function (publisher) {
                totalWHS += publisher.expect_whs ? publisher.expect_whs : 0;

                angular.forEach(publisher.coworkers, function (coworker) {
                    totalWHS += coworker.expect_whs ? coworker.expect_whs : 0;
                });
            });
            vm.totalWHS = totalWHS;
            if (totalWHS && m.is_auto) m.expect_whs = totalWHS;
        }

        function submit (m) {
            var errorNum = false;
            angular.forEach(m.publishers, function (publisher) {
                if (!errorNum && angular.isDefined(publisher.expect_whs) && publisher.expect_whs < 0) errorNum = true;

                angular.forEach(publisher.coworkers, function (coworker) {
                    if (!errorNum && angular.isDefined(coworker.expect_whs) && coworker.expect_whs < 0) errorNum = true;
                });
            });
            if (errorNum) {
                Dlg.w('工时不允许小于0，请确认后提交');
                return;
            }

            if (m.expect_whs && vm.totalWHS > m.expect_whs) {
                Dlg.w('合计工时大于预计工时，请确认后提交');
                return;
            }
            return FormHelper.handleSubmit(vm, function (defer) {
                $uibModalInstance.close({
                    publishers: m.publishers,
                    expect_whs: m.expect_whs
                });

            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('missionBrowseCtrl', missionBrowseCtrl);

    /** @ngInject */
    function missionBrowseCtrl($scope, Dlg, DateHelper, Mission, MissionReport, UIHelper, ArrayHelper) {
        var vm = $scope;
        vm.time = new Date();
        vm.eventClicked = eventClicked;
        vm.submit = submit;
        vm.pendingTableReload = pendingTableReload;
        vm.finishTableReload = finishTableReload;
        vm.dayChanged = dayChanged;
        vm.showAll = true;
        vm.onlyManage = false;
        vm.changeShowAll = changeShowAll;
        vm.changeOnlyManage = changeOnlyManage;
        vm.changeMd = changeMd;
        vm.read = read;
        vm.init = init;
        vm.tableReload = pendingTableReload;

        $scope.$on('missionSubmit', function () {
            init();
        });
        $scope.$on('missionStateChange', function () {
            init();
        });

        var remindStates = Mission.getRemindState();
        var workTypes = Mission.getWorkTypes();

        init();

        function init() {
            UIHelper.loadTab(vm, 'browse');


            pendingInit(true);
            // finishInit();
        }

        function pendingInit(firstLoad) {
            if (angular.isUndefined(firstLoad)) firstLoad = false;
            vm.pendingLoading = true;
            var selectDeptIds = [];
            angular.forEach(vm.manageDepts, function (md) {
                if (md.show) selectDeptIds.push(md.id);
            });
            Mission.query({
                op: 'pendingMission',
                opt: 14,
                time: DateHelper.date2Str(vm.time),
                show_all: vm.showAll ? 1 : 0,
                only_manage: vm.onlyManage ? 1 : 0,
                dept_ids: selectDeptIds.join(',')
            }, function (resp) {
                var items = resp.pendingMissions;
                angular.forEach(items, function (item) {
                    item.remind_state = ArrayHelper.getItem(item.remind_state, remindStates);
                    item.work_type = ArrayHelper.getItem(item.work_type, workTypes);
                });
                vm.pendingMissions = items;

                if (firstLoad) {
                    var manageDepts = resp.depts;
                    angular.forEach(manageDepts, function (d) {
                        d.show = true;
                    });
                    vm.manageDepts = manageDepts;
                }

                vm.pendingLoading = false;
            })
        }

        function finishInit() {
            vm.historyLoading = true;
            Mission.query({op: 'finishMission', opt: 15, time: DateHelper.date2Str(vm.time)}, function (resp) {
                vm.finishMissions = resp.finishMissions;
                vm.historyLoading = false;
            })
        }

        function eventClicked(m) {
            m.remind_state = 0;
            Dlg.show({
                template: 'templates/mission/missionShowDlg.html',
                ctrl: 'MissionShowDetailDlgCtrl',
                data: {
                    id: m.mission_id,
                    ForSubmit: true,
                    ForHistory: true
                },
                size: 'lg'
            }).then(function (resp) {
                switch (resp.opt) {
                    case 4:
                        vm.submit(m);
                        break;
                }
            });
        }

        function pendingTableReload() {
            pendingInit();
        }

        function finishTableReload() {
            finishInit();
        }

        function dayChanged() {
            vm.pendingLoading = true;
            vm.historyLoading = true;
            pendingTableReload();
        }

        function changeShowAll() {
            vm.showAll = !vm.showAll;
            dayChanged();
        }

        function changeOnlyManage() {
            vm.onlyManage = !vm.onlyManage;
            dayChanged();
        }

        function changeMd() {
            pendingTableReload();
        }

        function read(m) {
            m.remind_state = 0;
            Dlg.show({
                template: 'templates/mission/missionShowDlg.html',
                ctrl: 'MissionShowDetailDlgCtrl',
                data: {id: m.id},
                size: 'lg'
            }).then(function () {
                init();
            });
        }

        //作为任务的负责人或者是协助人一定有查看提交的权限
        function submit(m) {
            Dlg.show({
                template: 'pages/dlg/mission/temp/submit_dlg.html',
                ctrl: 'MissionSubmitDlgCtrl'
            }).then(function (resp) {
                var params = resp;
                params['mission_id'] = m.mission_id;
                params['state_id'] = m.state;
                MissionReport.save(params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('任务进度提交成功');
                                break;
                            case 1:
                                Dlg.w('任务状态错误!');
                        }
                    }, function () {
                        Dlg.e('任务进度提交失败!');
                    }
                );
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('MissionCalendarController', MissionCalendarController);

    /** @ngInject */
    function MissionCalendarController($scope, dialogs, toaster, DateHelper, Mission, Dlg) {
        $scope.$on('missionSubmit', function () {
            $scope.init();
        });
        $scope.$on('missionStateChange', function () {
            $scope.init();
        });

        $scope.vm = {};
        $scope.vm.calendarView = 'month';
        $scope.vm.viewDate = new Date();
        $scope.vm.isCellOpen = true;

        $scope.vm.eventClicked = function (event) {
            event.remind_state = 0;
            Dlg.show({
                template: 'templates/mission/missionShowDlg.html',
                ctrl: 'MissionShowDetailDlgCtrl',
                data: {id: event.mission_id},
                size: 'lg'
            }).then(function () {
                $scope.init();
            });
        };
        $scope.init = function () {
            Mission.query({opt: 7}, function (resp) {
                var missions = resp['missions'];
                $scope.vm.events = [];
                $scope.vm.calendarView = 'year';
                angular.forEach(missions, function (mission) {
                    var title = mission.name;
                    var now = new Date();
                    var startTime = DateHelper.str2Datetime(mission.start_time);
                    var endTime = DateHelper.str2Datetime(mission.end_time);
                    if (now > endTime) {
                        var dayCount = Math.ceil((Math.abs(now - endTime)) / 1000 / 60 / 60 / 24);
                        title += ' [过期' + dayCount + '天]'
                    }
                    $scope.vm.events.push({
                        title: title,
                        type: mission.mission_type,
                        startsAt: startTime,
                        endsAt: endTime,
                        mission_id: mission.id,
                        state: mission.state
                    });
                })
            });
        };
        $scope.init();
    }

})();

(function () {
    'use strict';

    angular.module('c.c').controller('ExportMissionDlgCtrl', ExportMissionDlgCtrl);

    /** @ngInject */
    function ExportMissionDlgCtrl($scope, $uibModalInstance, $q, toaster, FileHelper, DateHelper, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            var date = new Date(), y = date.getFullYear(), m = date.getMonth();
            vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                if (m.start > m.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                } else {
                    validFailed = false;
                    var start, end, title, deptId;
                    deptId = m.dept.id;
                    start = DateHelper.date2Str(m.start);
                    end = DateHelper.date2Str(m.end);
                    title = start + '到' + end + data.title + '.xls';


                    var pa = {start: start, end: end, dept_id: deptId};
                    FileHelper.dnExcel(data.url, pa, title, function () {
                        $uibModalInstance.close();
                    }).finally(function () {
                        defer.resolve();
                    });
                }
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
angular.module('c.c').controller('MissionManageController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, F, Table, Mission,
              MissionReport, Dept, Api, Auth, C, Dlg, ArrayHelper) {
        var vm = $scope;
        vm.select = select;
        vm.download = download;
        vm.show = show;

        $scope.user = Auth.getAccount();

        var readStatusOpts = Table.getNgTableOpts(ArrayHelper.get('readOrUnread'));
        var missionSources = ArrayHelper.get('mission_sources');
        var handleStates = ArrayHelper.get('handle_states');

        var OPT_DEPT = 6;
        var OPT_ARRANGE = 10;//我安排的任务

        function select(opt) {
            Mission.loadAssistFunction(vm);

            vm.opt = opt;
            var options = {
                service: Mission,
                params: {opt: opt},
                optInFront: true,
                optColWidth: 53,
                dateFilters: [{name: 'created_at'}],
                cols: [
                    {field: 'name', title: '名称', filter: {name: 'text'}},
                    {
                        field: 'state',
                        title: '状态',
                        filter: {state: 'select'},
                        data: Table.getNgTableOpts(handleStates),
                        width: '80px'
                    },
                    {
                        field: 'dept',
                        title: '申请科室',
                        filter: {dept: 'text'},
                        width: '140px'
                    },
                    {field: 'applicant', title: '申请人', filter: {applicant: 'text'}, width: '80px'},
                    {field: 'publish', title: '负责人', filter: {publish: 'text'}, width: '80px'},
                    {field: 'coworkers', title: '协助人'},
                    {
                        field: 'created_at',
                        title: '申请时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        width: '120px'
                    }
                ]
            };

            if (opt == OPT_DEPT) {
                options.primaryParam = 'dept_id';

                Dept.query({opt: 12}, function (resp) {
                    var deptIds = resp.depts.map(function (dept) {
                        return dept.id;
                    }).join('*');
                    $scope.depts = resp.depts;
                    $scope.depts.unshift({'id': -1, 'name': '全部'});

                    if (resp.depts.length > 0) {
                        $scope.dept = resp.depts[0];
                        options.params.dept_id = $scope.dept.id;
                        options.params.dept_ids = deptIds;
                        loadTable(opt, options);
                    }
                });
            } else {
                options.cols.unshift({
                    field: 'is_read',
                    title: '是否已读',
                    filter: {is_read: 'select'},
                    data: readStatusOpts,
                    width: '20px'
                });
                loadTable(opt, options);
            }
        }

        function loadTable(opt, options) {
            options = Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.time_range = item.start_time.substr(0, 10) + ' - ' + item.end_time.substr(0, 10);

                    item.state = ArrayHelper.getItem(item.state, handleStates);
                    item.source = ArrayHelper.getItem(item.source, missionSources);
                    item.limitMax = 3;
                });
            }).options;

            $scope.deptSelectedFn = function ($index) {
                $scope.dept = $scope.depts[$index];
                $scope.tableParams.$params.page = 1;
                options().params.dept_id = $scope.dept.id;
                $scope.tableReload();
            };
            $scope.tableReload();

            $scope.$on('missionSubmit', function () {
                $scope.tableReload();
            });
            $scope.$on('missionStateChange', function () {
                $scope.tableReload();
            });
            $scope.$on('missionRead', function () {
                $scope.tableReload();
            });
            $scope.$on('missionReading', function () {
                $scope.tableReload();
            });
        }

        function download() {
            if (vm.opt == OPT_DEPT) {
                dialogs.create('pages/user/mission/export_mission_dlg.html', 'ExportMissionDlgCtrl',
                    {url: C.URL.MISSION_EXPORT},
                    {size: 'md'}
                );
            } else {
                Dlg.exportDR(C.URL.MISSION_EXPORT, "任务统计");
            }
        }

        function show(mission) {
            Dlg.show({
                template: 'templates/mission/missionShowDlg.html',
                ctrl: 'MissionShowDetailDlgCtrl',
                data: {id: mission.id},
                size: 'lg'
            }).then(function () {
                $scope.tableParams.reload();
            });
        }

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.submit = function (mission) {
            dialogs.create('templates/mission/submit_dlg.html', 'MissionSubmitDlgCtrl', {},
                {size: 'md'}).result.then(function (pa) {
                var params = pa;
                params['mission_id'] = mission.id;
                params['state_id'] = mission.state.id;
                MissionReport.save(params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('任务进度提交成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('任务状态错误!');
                        }
                    }, function () {
                        toaster.error('任务进度提交失败!');
                    }
                )
            });
        };
        $scope.delete = function (mission) {
            dialogs.confirm('删除任务', '确定要删除<strong>' + mission.name + '</strong>吗?')
                .result.then(function () {
                Mission.delete({id: mission.id}).$promise.then(function (resp) {
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };
        $scope.state = function (mission) {
            Mission.callStateChangeDlg($scope, mission, function () {
            });
        };
        $scope.history = function (mission) {
            dialogs.create('templates/mission/history_dlg.html', 'MissionHistoryDlgCtrl', {
                    id: mission.id,
                    publish_id: mission.publish.id,
                    applicant_id: mission.applicant_id
                },
                {size: 'lg'});
        };
        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.export = function () {
            Api.exportDR(C.URL.MISSION_EXPORT, "任务统计");
        };

    });

angular.module('c.c').controller('ParticipantTipsCtrl',
    function ($scope, $interval) {
        var coworkers = $scope.mission.coworkers;
        var n = Math.ceil(coworkers.length / 20);
        var i = 0;

        $scope.coworkers = coworkers.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.coworkers = coworkers.slice(i * 20, (i + 1) * 20);
                if ($scope.coworkers.length < 20) {
                    var k = 20 - $scope.coworkers.length;
                    for (var j = 0; j < k; j++) {
                        $scope.coworkers.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    });

angular.module('c.c').controller('RegularMissionApplyController',
    function ($scope, $rootScope, dialogs, $filter, $timeout, toaster, Upload
        , C, F, RegularMission, Mission, Dept, FileHelper, UIHelper, ArrayHelper, Dlg, DateHelper, $q) {

        var vm = $scope;
        vm.submit = submit;
        vm.init = init;
        vm.sourceSelectFn = sourceSelectFn;
        vm.distributeJob = distributeJob;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;
        vm.changeRegularType = RegularMission.changeRegularType;
        vm.onCKReady = UIHelper.onCKReady;
        vm.loadTimeCount = 3;

        var missionSources = ArrayHelper.get('mission_sources');

        init();

        function init() {
            vm.mission = {
                is_public: false,
                urgent: false,
                attachments: [],
                coworkers: [],
                publisher: null,
                content: '',
                is_end_remind: false,
                is_start_remind: false,
                expect_whs: null,
                regular_type: 3,
                start: setDateHour(new Date(), 8),
                end: setDateHour(getNextDay(new Date(), 1), 17, 30),   //自动加一天
                submitted: false
            };
            vm.changeRegularType(vm.mission, vm.loadTimeCount);
            Dept.query({opt: 12}, function (resp) {
                vm.depts = resp.depts;
                angular.forEach(resp.depts, function (dept) {
                    if (dept.is_main) {
                        vm.mission['dept'] = dept;
                    }
                });
                vm.sourceSelectFn();
            });
        }

        vm.$on('missionEdit', function (ev, regularMission) {
            RegularMission.get({id: regularMission.id}, function (resp) {
                var item = resp.item;
                var coworkers = [];
                angular.forEach(item.participants, function (participant) {
                    participant.id = participant.user.id;
                    participant.name = participant.user.name;
                    participant.username = participant.user.username;

                    if (participant.is_publish == 1) {
                        item.publisher = participant;
                    } else {
                        coworkers.push(participant);
                    }
                });
                item.coworkers = coworkers;
                item.source = ArrayHelper.getItem(item.source, missionSources);

                item.start = DateHelper.str2Datetime(item.start.substr(0, 16));
                item.end = DateHelper.str2Datetime(item.end.substr(0, 16));
                vm.mission = item;
                vm.changeRegularType(vm.mission, vm.loadTimeCount);
            });
        });

        function sourceSelectFn() {
            Mission.query({
                dept_id: vm.mission['dept'].id,
                opt: 3
            }, function (resp) {
                vm.mission_sources = missionSources;
                vm.mission['source'] = missionSources[0];

                $scope.mission_types = resp.types;
            });
        }

        function __checkPublisher(m) {
            return m.publisher == null || m.publisher == {};
        }

        function distributeJob(m) {
            var publisher = m.publisher;
            if (publisher) {
                publisher.coworkers = m.coworkers;
            }
            Dlg.show({
                template: 'templates/mission/missionJobTimeDlg.html',
                ctrl: 'MissionJobTimeDlgCtrl',
                data: {
                    expect_whs: m.expect_whs,
                    publishers: publisher ? [publisher] : [],
                    isRegular: true
                },
                size: 'lg'
            }).then(function (resp) {
                m.expect_whs = resp.expect_whs;

                publisher = resp.publishers[0];
                m.publisher = publisher;
                if (publisher) {
                    m.coworkers = publisher.coworkers;
                }
            });
        }

        function deleteAttachment($index, mission) {
            mission.attachments.splice($index, 1);
        }

        function submit(form, mission) {
            var defer = $q.defer();
            var isPass = false;

            if (form.$valid) {
                if (mission.publisher == null || mission.publisher == {}) {
                    toaster.warning('请填写任务负责人');
                } else if (mission.start > mission.end) {
                    toaster.warning('任务开始不能大于等于结束日期');
                } else if (mission.type == null) {
                    toaster.warning('任务类型不能为空!');
                } else if (mission.content == "") {
                    toaster.warning('内容不能为空!');
                } else {
                    isPass = true;
                    for (var i = 0; i < mission.attachments.length; i++) {
                        if (mission.attachments[i].filename == null) {
                            toaster.warning('请等一小会儿,部分附件还在路上');
                            return;
                        }
                    }
                    var params = {};
                    params['name'] = mission.name;
                    params['source'] = mission.source.id;
                    params['type_id'] = mission.type.id;
                    params['content'] = mission.content;
                    params['dept_id'] = mission.dept.id;
                    params['expect_whs'] = mission.expect_whs;
                    params['regular_type'] = mission.regular_type;

                    params['start'] = DateHelper.datetime2Str(mission.start);
                    params['end'] = DateHelper.datetime2Str(mission.end);


                    var participants = [];
                    participants.push({
                        'participant_id': mission.publisher.id,
                        'is_publish': 1,
                        'job': mission.publisher.job,
                        'expect_whs': parseInt(mission.publisher.expect_whs)
                    });
                    angular.forEach(mission.coworkers, function (coworker) {
                        participants.push({
                            'participant_id': coworker.id,
                            'is_publish': 0,
                            'job': coworker.job,
                            'expect_whs': parseInt(coworker.expect_whs)
                        });
                    });
                    params['participants'] = participants;

                    params['is_public'] = mission.is_public ? '1' : '0';
                    params['urgent'] = mission.urgent ? '1' : '0';
                    params['is_start_reminded'] = mission.is_start_reminded ? '1' : '0';
                    params['is_end_reminded'] = mission.is_end_reminded ? '1' : '0';

                    params['attachments'] = [];
                    angular.forEach(mission.attachments, function (attachment) {
                        params['attachments'].push({
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        });
                    });
                    if (mission.id) {
                        params.opt = 2/* REGULAR_MISSION.EDIT_REGULAR_MISSION */;
                        RegularMission.update({id: mission.id}, params).$promise.then(function (resp) {
                            toaster.success('任务修改成功!');
                            vm.init();
                            vm.tabs['regular_manage'] = true;
                            $rootScope.$broadcast('regularMissionSubmit');
                        }, function () {
                            toaster.error('任务修改失败了!');
                        }).finally(function () {
                            defer.resolve();
                        });
                    } else {
                        RegularMission.save(params).$promise.then(function (resp) {
                            toaster.success('任务申请成功!');
                            vm.init();
                            vm.tabs['regular_manage'] = true;
                        }, function () {
                            toaster.error('任务申请失败了!');
                        }).finally(function () {
                            defer.resolve();
                        });
                    }
                }
                if (!isPass) {
                    defer.reject();
                }
            } else {
                toaster.warning('请确认表单无误!');
                vm.mission.submitted = true;
                defer.reject();
            }

            return defer.promise;
        }

        function upload(file, mission, e) {
            FileHelper.upload(C.URL.REGULAR_MISSION_UPLOAD, file, mission, e);
        }

        function getNextDay(date, day) {
            return new Date(date.valueOf() + day * 24 * 60 * 60 * 1000);
        }

        function setDateHour(date, hour, min, sec) {
            min = min ? min : 0;
            sec = sec ? sec : 0;
            return new Date(date.setHours(hour, min, sec));
        }
    })
;

angular.module('c.c').controller('RegularMissionManageController',
    function ($scope, $timeout, $rootScope, $filter, dialogs, toaster, RegularMission, Table, F, MissionType, ArrayHelper) {
        var vm = $scope;
        vm.clearFilters = clearFilters;
        vm.show = show;
        vm.edit = edit;
        vm.setStop = setStop;
        vm.remove = remove;
        vm.manageMission = manageMission;
        vm.init = init;
        var sources = ArrayHelper.get('mission_sources');
        var regularTypes = RegularMission.getRegularTypes();

        function init(is_search) {
            MissionType.query({opt: 2/*INDEX_OPTION*/}).$promise.then(function (resp) {
                vm.types = resp.items;

                var options = {
                    service: RegularMission,
                    params: {opt: 1/*REGULARMISSION.INDEX_OWN_REGULAR_MISSION*/, is_search: is_search ? 1 : 0},
                    sorting: {created_at: 'desc'},
                    optColWidth: is_search ? Table._1_BTN : Table._4_BTN,
                    optInFront: true,
                    cols: [
                        {
                            field: "type",
                            title: "类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(vm.types)
                        },
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {field: "source", title: "来源", filter: {source: 'select'}, data: Table.getNgTableOpts(sources)},
                        {field: "type", title: "类型", filter: {type: 'text'}},
                        {field: "dept", title: "申请科室", filter: {dept: "text"}},
                        {field: 'created_at', title: '申请时间', filter: {created_at: 'date_range'}},
                        {
                            field: "time",
                            title: "任务时间"
                        }
                    ]
                };
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.source = ArrayHelper.getItem(item.source, sources);
                        item.regular_type = ArrayHelper.getItem(item.regular_type, regularTypes);
                        item.created_at = item.created_at.substr(0, 10);
                        item.time = item.start.substr(0, 10) + '~' + item.end.substr(0, 10)
                            + '(' + item.regular_type.name + ')';
                    });
                });

                vm.$on('regularMissionSubmit', function () {
                    $scope.tableParams.reload();
                });
            });
        }

        function clearFilters() {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        }

        function show(mission) {
            dialogs.create('templates/mission/regular_show_dlg.html', 'RegularMissionShowDlgCtrl', {
                    id: mission.id
                },
                {size: 'lg'});
        }

        function remove(mission) {
            dialogs.confirm('删除规律任务', '确定要删除<strong>' + mission.name + '</strong>吗?')
                .result.then(function () {
                RegularMission.delete({id: mission.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            $scope.tableParams.reload();
                            break;
                        case 1:
                            toaster.error('已生成任务，无法删除');
                            break;
                    }
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }

        function setStop(m) {
            RegularMission.update({id: m.id}, {opt: 1, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        function edit(mission) {
            $scope.tabs['regular_apply'] = true;
            $timeout(function () {
                $rootScope.$broadcast('missionEdit', {id: mission.id});
            }, 200);
        }

        function manageMission(mission) {
            dialogs.create('templates/mission/regular_manage_dlg.html', 'RegularManageDlgCtrl', {
                regular_mission_id: mission.id
            }, {size: 'lg'});
        }
    });
angular.module('c.c').controller('MissionSearchController',
    function ($scope, $timeout, $rootScope, $filter, dialogs, toaster, Mission, NgTableParams, F, MissionReport, Table, ArrayHelper, Dlg) {
        var vm = $scope;
        vm.show = show;
        vm.showAllName = false;

        $scope.$on('missionSubmit', function () {
            vm.tableReload();
        });
        $scope.$on('missionStateChange', function () {
            vm.tableReload();
        });

        init();

        function init () {
            var missionSources = ArrayHelper.get('mission_sources');
            var handleStates = ArrayHelper.get('handle_states');

            var options = {
                service: Mission,
                params: {opt: 2/*INDEX_MISSION_SEARCH*/},
                sorting: {start_time: 'desc'},
                optInFront: true,
                optColWidth: Table._1_BTN,
                cols: [
                    {
                        field: 'state',
                        title: '状态',
                        filter: {state: 'select'},
                        data: Table.getNgTableOpts(handleStates),
                        width: '10%'
                    },
                    {field: 'name', title: '名称', filter: {name: 'text'}, width: '15%'},
                    {
                        field: 'source',
                        title: '来源',
                        sortable: 'source',
                        filter: {source: 'select'},
                        data: Table.getNgTableOpts(missionSources),
                        width: '10%'
                    },
                    {
                        field: 'time_range',
                        title: '任务时间',
                        sortable: 'start_time',
                        filter: {start_time: 'date_range'},
                        width: '25%'
                    },
                    {field: 'dept', title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, width: '10%'},
                    {field: 'applicant', title: '申请人', filter: {applicant: 'text'}, width: '10%'},
                    {field: 'publish', title: '负责人', filter: {publish: 'text'}, width: '10%'}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.time_range = item.start_time.substr(0, 10) + ' - ' + item.end_time.substr(0, 10);

                    item.state = ArrayHelper.getItem(item.state, handleStates);
                    item.source = ArrayHelper.getItem(item.source, missionSources);
                });
            });
        }

        function show (m) {
            m.remind_state = 0;
            Dlg.show({
                template: 'templates/mission/missionShowDlg.html',
                ctrl: 'MissionShowDetailDlgCtrl',
                data: {
                    id: m.id
                },
                size: 'lg'
            }).then(function (resp) {
                vm.tableReload();
            });
        }
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('MissionWorkLogController', MissionWorkLogController)
        .controller('WorkLogExcelImportDlgCtrl', WorkLogExcelImportDlgCtrl)
    ;

    function MissionWorkLogController($scope, $rootScope, $filter, $timeout, toaster, Upload
        , C, F, Auth, Mission, Dept, FileHelper, UIHelper, Dlg, DateHelper, ArrayHelper, FormHelper) {
        var vm = $scope;
        vm.submit = submit;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.reset = reset;
        vm.excelImport = excelImport;

        var now = new Date();
        vm.onCKReady = UIHelper.onCKReady;
        var initHour = 0;
        var initVal = {
            whs: initHour,
            start: plusOrSubHour(now, initHour),
            end: now,
            work_type: 2,
            attachments: []
        };

        init();

        function init() {
            vm.m = angular.copy(initVal);

            $scope.$watch('m.whs', function (newVal, oldVal, scope) {
                timeAutoAlignment(scope.m, true);
            });

            $scope.$watch('m.start', function (newVal, oldVal, scope) {
                timeAutoAlignment(scope.m, false);
            });

            $scope.$watch('m.end', function (newVal, oldVal, scope) {
                timeAutoAlignment(scope.m, true);
            });
        }

        function reset() {
            vm.m = angular.copy(initVal);
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
        }

        function timeAutoAlignment(m, changeStart) {
            var diffHour = parseInt(DateHelper.diffInHours(m.start, m.end));
            var whs = parseInt(m.whs);
            if (diffHour !== whs) {
                if (changeStart) {
                    vm.m.start = plusOrSubHour(vm.m.end, whs)
                } else {
                    vm.m.end = plusOrSubHour(vm.m.start, -1 * whs)
                }
            }
        }

        function plusOrSubHour(date, hour) {
            return new Date(date - hour * 60 * 60 * 1000);
        }

        function deleteAttachment($index, mission) {
            mission.attachments.splice($index, 1);
        }

        function upload(file, mission, e) {
            FileHelper.upload(C.URL.MEETING_UPLOAD, file, mission, e);
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var params = {};
                params['op'] = 'work_log';

                params['start'] = DateHelper.datetime2Str(m.start);
                params['end'] = DateHelper.datetime2Str(m.end);

                params['whs'] = parseInt(m.whs);
                params['content'] = m.content;
                params['work_type'] = m.work_type;

                params['attachments'] = [];
                angular.forEach(m.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });

                Mission.save(params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('工作日志记录成功!');
                            $scope.reset();
                            $rootScope.$broadcast('missionSubmit');
                            break;
                        case 1:
                            Dlg.w(resp.msg);
                    }
                }, function (err) {
                    if (err.data.msg) {
                        Dlg.e(err.data.msg)
                    } else {
                        Dlg.e('任务申请失败了!');
                    }
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

        function excelImport() {
            Dlg.show({
                template: 'WorkLogExcelImportDlg.html',
                ctrl: 'WorkLogExcelImportDlgCtrl',
                data: {}
            }).then(function (pa) {

            });
        }
    }

    function WorkLogExcelImportDlgCtrl($scope, $uibModalInstance, FileHelper, Mission, Dlg) {
        var vm = $scope;
        vm.submit = submit;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.cancel = $uibModalInstance.dismiss;

        vm.templateDownloads = [
            {
                id: 1,
                ico: 'file-excel-o',
                filename: "missions/gzrzyb.xlsx",
                mime: "application/wps-office.xlsx",
                name: "工作日志样表.xlsx",
                size: "8797"
            }
        ];

        init();

        function init() {
            vm.m = {
                file: {}
            };
        }

        function upload(file, m, e) {
            FileHelper.uploadSingle(file, m, e);
        }

        function deleteAttachment(m) {
            m.filename = null;
        }

        function submit(m) {
            var file = m.file;
            if (!file.filename) {
                Dlg.w('请上传预约附件!');
            } else {
                var pa = {
                    op: 'default',
                    file: {
                        name: file.attach_name,
                        filename: file.filename,
                        mime: file.mime,
                        size: file.size,
                    }
                };

                Mission.excelImport(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    init();
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                });
            }
        }
    }
})();
//angular.module('c.c')
//    .controller('UserHousePayCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, HousePay, F) {
//
//        $scope.pay_types = F.get('pay_types');
//        var pay_types = F.getNgTableOpts($scope.pay_types);
//        $scope.cols = [
//            {
//                title: '房屋编号',
//                field: 'house_code',
//                filter: {'houses.code': 'text'},
//                width: '15%',
//                show: true
//            }, //0
//            {
//                title: '月份',
//                sortable: 'house_wae_records.month',
//                filter: {month: 'date_range'},
//                field: 'house_wae_records.month',
//                show: true
//            },
//            {
//                title: '支付方式',
//                filter: {pay_type: 'select'},
//                field: 'house_rents.pay_type',
//                data: pay_types,
//                show: true
//            }, //6
//            {
//                title: '交纳金额',
//                sortable: 'money',
//                filter: {money: 'number_range'},
//                field: 'money',
//                show: true
//            },
//            {
//                title: '余额',
//                sortable: 'balance',
//                filter: {balance: 'number_range'},
//                field: 'balance',
//                show: true
//            },
//            {
//                title: '交费时间',
//                sortable: 'created_at',
//                filter: {created_at: 'date_range'},
//                field: 'created_at',
//                show: true
//            }
//        ];
//        $scope.hideOpt = true;
//
//        $scope.numRangeFilter = {};
//        $scope.$watch(
//            function () {
//                return $scope.numRangeFilter;
//            },
//            function (newValue, oldValue) {
//                $scope.tableParams.reload();
//            }, true
//        );
//
//        $scope.dateRangeFilter = {};
//        $scope.$watch(
//            function () {
//                return $scope.dateRangeFilter;
//            },
//            function (newValue, oldValue) {
//                $scope.tableParams.reload();
//            }, true
//        );
//
//        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
//            counts: [5, 10, 15], total: 0,
//            getData: function ($defer, params) {
//                var url = params.url();
//                if ($scope.numRangeFilter.balance) {
//                    url['balance_start'] = $scope.numRangeFilter.balance.start;
//                    url['balance_end'] = $scope.numRangeFilter.balance.end;
//                }
//                if ($scope.numRangeFilter.money) {
//                    url['money_start'] = $scope.numRangeFilter.money.start;
//                    url['money_end'] = $scope.numRangeFilter.money.end;
//                }
//
//                if ($scope.dateRangeFilter.created_at != null) {
//                    var startDate = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
//                    var endDate = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
//                    url['date_range_filters']['created_at'] = {
//                        startDate: startDate,
//                        endDate: endDate
//                    };
//                }
//                if ($scope.dateRangeFilter.month != null) {
//                    var startDate = $filter('date')($scope.dateRangeFilter.month.startDate, 'yyyy-MM-dd');
//                    var endDate = $filter('date')($scope.dateRangeFilter.month.endDate, 'yyyy-MM-dd');
//                    url['date_range_filters']['month'] = {
//                        startDate: startDate,
//                        endDate: endDate
//                    };
//                }
//                url['date_range_filters'] = $scope.dateRangeFilter;
//                url['opt'] = 1;
//                HousePay.query(url, function (resp) {
//                    params.total(resp.total);
//                    $defer.resolve(resp.records);
//                });
//            }
//        });
//
//        $scope.tableReload = function () {
//            $scope.tableParams.reload();
//        };
//
//        $scope.clearFilters = function () {
//            $scope.numRangeFilter = {};
//            $scope.dateRangeFilter = {};
//            $scope.tableParams.filter({});
//        };
//    });
//angular.module('c.c').controller('UserParkPayCtrl',
//    function ($scope, $filter, dialogs, toaster, NgTableParams, F, ParkingPay) {
//        $scope.pay_types = F.get('pay_types');
//        var pay_types = F.getNgTableOpts($scope.pay_types);
//        $scope.cols = [
//            {
//                title: '车位名称',
//                field: 'park_name',
//                filter: {'parking_lots.name': 'text'},
//                show: true
//            }, //0
//            {
//                title: '月份',
//                sortable: 'park_pay_records.month',
//                filter: {month: 'date_range'},
//                field: 'month',
//                show: true
//            },
//            {
//                title: '支付方式',
//                filter: {pay_type: 'select'},
//                field: 'user_parking.pay_type',
//                data: pay_types,
//                show: true
//            }, //6
//            {
//                title: '交纳金额',
//                sortable: 'money',
//                filter: {money: 'number_range'},
//                field: 'money',
//                show: true
//            },
//            {
//                title: '余额',
//                sortable: 'balance',
//                filter: {balance: 'number_range'},
//                field: 'balance',
//                show: true
//            },
//            {
//                title: '交费时间',
//                sortable: 'created_at',
//                filter: {created_at: 'date_range'},
//                field: 'created_at',
//                show: true
//            }
//        ];
//
//        $scope.hideOpt = true;
//
//        $scope.dateRangeFilter = {};
//        $scope.$watch(
//            function () {
//                return $scope.dateRangeFilter;
//            },
//            function (newValue, oldValue) {
//                $scope.tableParams.reload();
//            }, true
//        );
//
//        $scope.numRangeFilter = {};
//        $scope.$watch(
//            function () {
//                return $scope.numRangeFilter;
//            },
//            function (newValue, oldValue) {
//                $scope.tableParams.reload();
//            }, true
//        );
//
//        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
//            counts: [5, 10, 15], total: 0,
//            getData: function ($defer, params) {
//                var url = params.url();
//                if ($scope.numRangeFilter.balance) {
//                    url['balance_start'] = $scope.numRangeFilter.balance.start;
//                    url['balance_end'] = $scope.numRangeFilter.balance.end;
//                }
//                if ($scope.numRangeFilter.money) {
//                    url['money_start'] = $scope.numRangeFilter.money.start;
//                    url['money_end'] = $scope.numRangeFilter.money.end;
//                }
//                if ($scope.dateRangeFilter.created_at != null) {
//                    var startDate = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
//                    var endDate = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
//                    url['date_range_filters']['created_at'] = {
//                        startDate: startDate,
//                        endDate: endDate
//                    };
//                }
//                if ($scope.dateRangeFilter.month != null) {
//                    var startDate = $filter('date')($scope.dateRangeFilter.month.startDate, 'yyyy-MM-dd');
//                    var endDate = $filter('date')($scope.dateRangeFilter.month.endDate, 'yyyy-MM-dd');
//                    url['date_range_filters']['month'] = {
//                        startDate: startDate,
//                        endDate: endDate
//                    };
//                }
//                url['date_range_filters'] = $scope.dateRangeFilter;
//                url['opt'] = 1;
//                ParkingPay.query(url, function (resp) {
//                    params.total(resp.total);
//                    $defer.resolve(resp.records);
//                });
//            }
//        });
//
//
//        $scope.tableReload = function () {
//            $scope.tableParams.reload();
//        };
//
//        $scope.clearFilters = function () {
//            $scope.numRangeFilter = {};
//            $scope.dateRangeFilter = {};
//            $scope.tableParams.filter({});
//        };
//    });

(function () {
    'use strict';
    angular.module('c.c')
        .controller('UserQuickMenuCtrl', UserQuickMenuCtrl);

    /** @ngInject */
    function UserQuickMenuCtrl($scope, QuickMenu, ArrayHelper, Dlg, $rootScope) {
        var vm = $scope;
        vm.setCheckedAll = setCheckedAll;
        vm.setCheckedChildren = setCheckedChildren;
        vm.onChange = onChange;
        vm.ok = ok;
        vm.init = init;
        vm.removeSelected = removeSelected;
        vm.selected = [];

        init();

        function init() {
            vm.loading = true;
            QuickMenu.get({op: 'user', id: '-1'}).$promise.then(function (data) {
                var tree = data.category;
                var menus = data.menus;
                setParentOfChildren(tree);
                vm.data = tree;
            }, function (error) {
            }).finally(function () {
                vm.loading = false;
            });
        }

        function setSelects(menus) {
            var selectd = [];
            menus.forEach(function (menu) {
                selectd.push({
                    display_name: menu.permission.display_name,
                    id: menu.permission_id
                });
            });
            vm.selected = selectd;
        }

        function setParentOfChildren(node) {
            angular.forEach(node.children, function (child) {
                child.parent = node;
                if (child.is_checked) {
                    node.is_checked = true;
                    vm.selected.push({
                        display_name: child.permission.display_name,
                        id: child.permission.id,
                        node: child
                    });
                }
                if (child.children != null && child.children.length > 0) {
                    setParentOfChildren(child);
                }
            });
        }

        function setCheckedAll(node, checked) {
            node.is_checked = checked;
            changeSelected(node);
            setCheckedChildren(node);
        }

        function setCheckedChildren(node) {
            if (node.children != null && node.children.length > 0) {
                angular.forEach(node.children, function (child) {
                    child.is_checked = node.is_checked;
                    changeSelected(child);
                    setCheckedChildren(child);
                });
            }
        }

        function changeSelected(node) {
            var is_checked = node.is_checked;
            if (node.children != null && node.children.length > 0) return null;

            var selectNode = {
                display_name: node.permission.display_name,
                id: node.permission.id,
                node: node
            };
            if (is_checked) {
                vm.selected.push(selectNode);
            } else {
                var index = ArrayHelper.inArray(selectNode, vm.selected);
                if (index > -1) vm.selected.splice(index, 1);
            }
        }

        function removeSelected($index, node) {
            var selectNode = node.node;
            selectNode.is_checked = false;
            changeSelected(selectNode);
        }

        function setCheckedAncestors(node) {
            if (node.parent) {
                if (node.is_checked) {
                    if (!node.parent.is_checked) {
                        node.parent.is_checked = node.is_checked;
                        setCheckedAncestors(node.parent);
                    }
                } else {
                    if (node.parent.is_checked) {
                        var allUnchecked = true;
                        var children = node.parent.children;
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].is_checked) {
                                allUnchecked = false;
                                break;
                            }
                        }
                        if (allUnchecked) {
                            node.parent.is_checked = node.is_checked;
                            setCheckedAncestors(node.parent);
                        }
                    }
                }
            }
        }

        function onChange(node) {
            setCheckedChildren(node);
            setCheckedAncestors(node);
            changeSelected(node);
        }


        function ok(selecteds) {
            var perIds = [];
            angular.forEach(selecteds, function (selected, key) {
                perIds.push({
                    per_id: selected.id,
                    sorting: key
                });
            });
            QuickMenu.save({op: 'user', per_ids: perIds}).$promise.then(function (data) {
                Dlg.s('保存成功');
                $rootScope.$broadcast("quickMenuChange");
            }, function (error) {
                Dlg.s(error.msg);
            });
        }
    }
})();


angular
    .module('c.c')
    .controller('RuleAppliedController', function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, Table, F, C, RuleType, Dept, Rule) {
        $scope.$on('ruleSubmit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('ruleEdit', function () {
            $scope.tableParams.reload();
        });
        // ! 以前的审批stages 防止报错在这里备份
        // "approval_stages6": [
        //     {
        //       "id": "1",
        //       "name": "科审中"
        //     },
            // {
            //   "id": "2",
            //   "name": "院审中"
            // },
            // {
            //   "id": "3",
            //   "name": "终审中"
            // },
            // {
            //   "id": "4",
            //   "name": "会签"
            // },
            // {
            //   "id": "5",
            //   "name": "待讨论"
            // },
        //     {
        //       "id": "6",
        //       "name": "发布"
        //     },
        //     {
        //       "id": "7",
        //       "name": "停用"
        //     },
        //     {
        //       "id": "8",
        //       "name": "退回"
        //     }
        //   ],

        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);
        $scope.states = F.get('rule_states');
        var statesOpts = F.getNgTableOpts($scope.states);

        Dept.query({ opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS }, function (resp) {
            var depts = resp.depts;
            if (depts && depts.length > 0) {
                for (var i = 0; i < depts.length; i++) {
                    if (depts[i].is_main == 1) {
                        $scope.dept = depts[i];
                        $scope.tableParams.reload();
                        break;
                    }
                }
            }
            $scope.depts = depts;
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.cols = [
            { title: '标题', filter: { subject: 'text' }, show: true },
            { title: '关键词', filter: { keyword: 'text' }, show: true },
            // { title: '类型', sortable: 'type_id', filter: { type_id: 'select' }, show: true },
            { title: '发布时间', sortable: 'created_at', filter: { created_at: 'date_range' }, width: '20%', show: true },
            { title: '审核类型', filter: { state: 'select' }, data: statesOpts, show: true },
            { title: '状态', filter: { stage: 'select' }, data: stagesOpts, width: '10%', show: true }
        ];

        typeCol = $scope.cols[2];

        $scope.dateRangeFilter = {};
        $scope.$watch(
            'dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            },
            true
        );

        $scope.optColWidth = 53;
        $scope.tableParams = new NgTableParams(
            {
                page: 1,
                count: 10,
                sorting: {
                    created_at: 'desc'
                }
            },
            {
                counts: [10, 30, 50],
                total: 0,
                getData: function ($defer, params) {
                    if ($scope.dept) {
                        var url = params.url();
                        url['opt'] = C.OPT.RULE.INDEX.USER_APPLIED;
                        url['dept_id'] = $scope.dept.id;
                        if ($scope.dateRangeFilter.created_at != null) {
                            url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                            url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                        }
                        Table.query(Rule, url, $defer, params, 'rules', function (data) {
                            typeCol.data = F.getNgTableOpts(data.rule_types);
                            angular.forEach(data.rules, function (rule) {
                                rule.stage = F.getItem(rule.stage, $scope.stages);
                                rule.state = F.getItem(rule.state, $scope.states);
                            });
                        });
                    } else {
                        $defer.resolve([]);
                    }
                }
            }
        );

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs
                .create(
                    'templates/rule/show_dlg.html',
                    'RuleShowDlgCtrl',
                    {
                        id: rule.id,
                        ForEdit: true,
                        ForBack: true
                    },
                    {
                        size: 'lg'
                    }
                )
                .result.then(function (params) {
                    switch (params.opt) {
                        case 1:
                            $scope.tabs['apply'] = true;
                            $timeout(function () {
                                $rootScope.$broadcast('ruleEdit1', params.rule);
                                console.log(params.rule);
                            }, 200);
                            break;
                    }
                });
        };

        $scope.delete = function (rule) {
            dialogs.confirm('删除规章制度', '确定要删除<strong>' + rule.subject + '</strong>吗?').result.then(function () {
                Rule.delete({ id: rule.id }).$promise.then(
                    function (resp) {
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('删除失败!');
                    }
                );
            });
        };
    });

angular.module('c.c').controller('RuleApplyController', function ($scope, $rootScope, toaster, C, F, Rule, RuleType, Dept, Keyword, FileHelper) {
    $scope.$on('ruleEdit1', function (ev, rule) {
        $scope.rule_types = F.get('rule_types');
        rule['class'] = F.getItem(rule.class, $scope.rule_types);
        rule['red_head'] = false;
        rule['with_sms'] = false;
        rule['ccdepts'] = [];
        rule['keywords'] = [];
        $scope.rule = rule;
    });

    $scope.classSelectedFn = function (item) {
        $scope.classId = item.id;
        $scope.reload();
    };

    $scope.deptSelectedFn = function (dept) {
        $scope.deptId = dept.id;
        $scope.reload();
    };

    $scope.reload = function () {
        $scope.rule['type'] = null;

        if (!$scope.classId) {
            $scope.classId = $scope.rule_types[0].id;
        }
        if (!$scope.deptId) {
            $scope.deptId = $scope.depts[0].id;
        }

        RuleType.query(
            {
                opt: C.OPT.RULE_TYPE.INDEX.OPTIONS,
                class: $scope.classId,
                dept: $scope.deptId
            },
            function (resp) {
                $scope.types = resp.types;
                $scope.types.splice(0, 0, {id: 0, name: '其他'});
                $scope.rule['type'] = $scope.types[0];
            }
        );
    };

    $scope.upload = function (file, rule_attach, e) {
        if (file) {
            rule_attach.name = file.name;
            delete rule_attach.filename;
        }
        FileHelper.upload1(C.URL.RULE_ATTACH_UPLOAD, file, rule_attach, e, {name: 'tmp_dir'}, {tmp_dir: rule_attach.tmp_dir});
    };

    $scope.submit = function (rule) {
        if (rule.has_attach && !rule.rule_attach.filename) {
            toaster.warning('pdf文档还未上传或正在上传中!');
        } else if (rule.subject == null || rule.subject == '') {
            toaster.warning('标题不能为空!');
        } else if (!rule.has_attach && (rule.body == null || rule.body == '')) {
            toaster.warning('内容不能为空!');
        } else if (rule.red_head && rule.ccdepts.length == 0) {
            toaster.warning('抄送科室不能为空!');
        } else if (rule.dept.type_id > 4) {
            toaster.warning('所选科室无法发布制度!');
        } else {
            var params = {};
            params['subject'] = rule.subject;
            params['class'] = rule.class.id;
            // ! 到底是党办（140）科室还是院办（43 293）科室？
            params['dept_id'] = rule.class.id == '2' ? '293' : rule.dept.id;
            params['type_id'] = rule.type.id;
            params['keywords'] = rule.keywords;
            params['body'] = rule.body;
            params['ccdepts'] = [];
            angular.forEach(rule.ccdepts, function (dept) {
                params['ccdepts'].push(dept.id);
            });
            params['red_head'] = rule.red_head ? '1' : '0';
            params['with_sms'] = rule.with_sms ? '1' : '0';
            params['has_attach'] = rule.has_attach ? '1' : '0';
            if (rule.has_attach) {
                params['mime'] = rule.rule_attach.mime;
                params['size'] = rule.rule_attach.size;
                params['filename'] = rule.rule_attach.filename;
                params['tmp_dir'] = rule.rule_attach.tmp_dir;
            }
            Rule.save(params).$promise.then(
                function (resp) {
                    if (resp && resp.items && resp.items.msg) {
                        toaster.error(resp.items.msg);
                    } else {
                        toaster.success('提交成功!');
                        $scope.reset();
                        $rootScope.$broadcast('ruleSubmit');
                        $scope.tabs['applied'] = true;
                    }
                }
            );
        }
    };

    $scope.reset = function () {
        Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS}, function (resp) {
            $scope.depts = resp.depts;
            $scope.rule_types = F.get('rule_types');
            $scope.rule = {
                body: '',
                class: $scope.rule_types[0],
                dept: $scope.depts[0],
                keywords: [],
                ccdepts: [],
                rule_attach: {},
                has_attach: true
            };

            RuleType.query(
                {
                    opt: C.OPT.RULE_TYPE.INDEX.OPTIONS,
                    class: $scope.rule_types[0].id,
                    dept: $scope.depts[0].id
                },
                function (resp) {
                    $scope.types = resp.types;
                    $scope.types.splice(0, 0, {id: 0, name: '其他'});
                    $scope.rule['type'] = $scope.types[0];
                }
            );

            RuleType.query(
                {
                    // 查询是否党政办公室
                    opt: 6
                },
                function (resp) {
                    if (resp.is_permittied == false && $scope.rule_types.length == 2) {
                        $scope.rule_types.pop();
                    }
                }
            );

            Keyword.query(function (resp) {
                $scope.keywords = resp;
            });

            Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
                $scope.cc_depts = resp.depts;
            });
        });
    };
    $scope.reset();

    $scope.tagTransform = function (newTag) {
        var item = F.getItem(newTag, $scope.keywords, 'name');
        if (item) {
            return none;
        }
        return {name: newTag};
    };
});

angular.module('c.c').controller('RuleSearch2Controller',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, Auth, Table, F, C, RuleType, Dept, Rule) {
        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);

        Dept.query({opt: C.OPT.DEPT.INDEX.USER_DEPTS_OPTIONS}, function (resp) {
            var depts = resp.depts;
            if (depts && depts.length > 0) {
                for (var i = 0; i < depts.length; i++) {
                    if (depts[i].is_main == 1) {
                        $scope.dept = depts[i];
                        $scope.tableParams.reload();
                        break;
                    }
                }
            }
            $scope.depts = depts;
            $scope.dept_id = Auth.getAccount().dept_id;
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            {title: '发布人', filter: {sender: 'text'}, show: true},
            // {title: '类型', sortable: 'type_id', filter: {type_id: 'select'}, show: true},
            {title: '发布时间', sortable: 'release_time', filter: {release_time: 'date_range'}, width: '20%', show: true}
        ];

        var typeCol = $scope.cols[2];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = Table._3_BTN;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                release_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = C.OPT.RULE.INDEX.USER_DEPT_SEARCH;
                    url['dept_id'] = $scope.dept.id;
                    if ($scope.dateRangeFilter.release_time != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.release_time.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.release_time.endDate, 'yyyy-MM-dd');
                    }
                    Table.query(Rule, url, $defer, params, 'rules', function (data) {
                        typeCol.data = F.getNgTableOpts(data.rule_types);
                        angular.forEach(data.rules, function (rule) {
                            rule.stage = F.getItem(rule.stage, $scope.stages);
                        });
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {id: rule.id}, {

                size: 'lg'
            });
        }

        $scope.deleteRule = function (rule) {
            dialogs.confirm('删除规章制度', '确定要删除<strong>' + rule.subject + '</strong>吗?').result.then(function () {
                Rule.delete({ id: rule.id }).$promise.then(
                    function (resp) {
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('删除失败!');
                    }
                );
            });
        }

        $scope.showComment = function (rule) {
            dialogs.create(
                'templates/rule/show_comment_dlg.html',
                'RuleShowCommentDlgCtrl',
                {id: rule.id, forAll: false},
                {
                    size: 'lg'
                }
            );
        };
    });


angular.module('c.c').controller('RuleSearchController', function ($scope, $filter, dialogs, NgTableParams, Table, F, C, RuleType, Dept, Rule) {
    $scope.stages = F.get('approval_stages6');
    var stagesOpts = F.getNgTableOpts($scope.stages);

    $scope.cols = [
        {title: '标题', filter: {subject: 'text'}, show: true},
        {title: '关键词', filter: {keyword: 'text'}, show: true},
        // { title: '类型', sortable: 'type_id', filter: { type_id: 'select' }, show: true },
        // { title: '发布科室', sortable: 'dept_id', filter: { dept_id: 'select' }, show: true },
        {title: '上传时间', sortable: 'release_time', filter: {release_time: 'date_range'}, width: '20%', show: true}
    ];

    $scope.types = undefined;
    // $scope.type_col = $scope.cols[2];
    // $scope.dept_col = $scope.cols[2];
    $scope.dateRangeFilter = {};
    $scope.$watch(
        'dateRangeFilter',
        function (newValue, oldValue) {
            $scope.tableParams.reload();
        },
        true
    );

    $scope.optColWidth = Table._2_BTN;
    $scope.tableParams = new NgTableParams(
        {
            page: 1,
            count: 10,
            sorting: {
                release_time: 'desc'
            }
        },
        {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.RULE.INDEX.USER_HOSPITAL_SEARCH;
                if ($scope.dateRangeFilter.release_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.release_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.release_time.endDate, 'yyyy-MM-dd');
                }
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    $scope.types = data.rule_types;
                    $scope.types.unshift({id: '', name: '全部'});
                    // $scope.dept_col.data = F.getNgTableOpts(data.depts);
                    angular.forEach(data.rules, function (rule) {
                        rule.stage = F.getItem(rule.stage, $scope.stages);
                    });
                });
            }
        }
    );

    $scope.clearFilters = function () {
        $scope.tableParams.filter({});
        $scope.dateRangeFilter = {};
    };

    $scope.typeSelected = function (type) {
        $scope.currentType = type;
        $scope.currentRecord = null;
        PneumoniaCollectRecord.query({op: 'ContainCollect', type_id: type.id}, function (resp) {
            $scope.records = $scope.items;
            if (vm.records.length > 0) {
                vm.recordSelected(vm.records[0]);
            }
        });
    };

    $scope.show = function (rule) {
        dialogs.create(
            'templates/rule/show_dlg.html',
            'RuleShowDlgCtrl',
            {id: rule.id},
            {
                size: 'lg'
            }
        );
    };

    $scope.showComment = function (rule) {
        dialogs.create(
            'templates/rule/show_comment_dlg.html',
            'RuleShowCommentDlgCtrl',
            {id: rule.id, forAll: false},
            {
                size: 'lg'
            }
        );
    };
});

angular.module('c.c').controller('FinallyRuleSearchController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, Table, F, C, RuleType, Dept, Rule) {
        $scope.stages = F.get('approval_stages6');
        var stagesOpts = F.getNgTableOpts($scope.stages);
        // var classes = [
        //     {id: 1, name: '科内'},
        //     {id: 2, name: '全院'}
        // ];

        $scope.cols = [
            {title: '标题', filter: {subject: 'text'}, show: true},
            {title: '关键词', filter: {keyword: 'text'}, show: true},
            // {title: '查看类型', filter: {'class': 'select'}, show: true},
            // {title: '类型', sortable: 'type_id', filter: {'type_id': 'select'}, show: true},
            // {title: '发布科室', sortable: 'dept_id', filter: {'dept_id': 'select'}, show: true},
            {title: '上传时间', sortable: 'release_time', filter: {release_time: 'date_range'}, width: '20%', show: true}
        ];

        // $scope.class_col = $scope.cols[2];
        // $scope.type_col = $scope.cols[3];
        // $scope.dept_col = $scope.cols[2];
        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = Table._2_BTN;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                release_time: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = C.OPT.RULE.INDEX.FINALLY_SEARCH;
                if ($scope.dateRangeFilter.release_time != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.release_time.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.release_time.endDate, 'yyyy-MM-dd');
                }
                Table.query(Rule, url, $defer, params, 'rules', function (data) {
                    // $scope.class_col.data = F.getNgTableOpts(classes);
                    // $scope.type_col.data = F.getNgTableOpts(data.rule_types);
                    $scope.depts = data.depts;
                    $scope.depts.unshift({ id: '', name: '全部' });
                    // $scope.dept_col.data = F.getNgTableOpts(data.depts);
                    angular.forEach(data.rules, function (rule) {
                        rule.stage = F.getItem(rule.stage, $scope.stages);
                    });
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (rule) {
            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {id: rule.id}, {

                size: 'lg'
            });
        }

        $scope.showComment = function (rule) {
            dialogs.create(
                'templates/rule/show_comment_dlg.html',
                'RuleShowCommentDlgCtrl',
                {id: rule.id, forAll: false},
                {
                    size: 'lg'
                }
            );
        };
    });


angular.module('c.c').controller('SmsHistoryController',
    function ($rootScope, $scope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Sms) {

        $scope.$on('smsSend', function (event, data) {
            $scope.tableReload();
        });


        var successOrNotOpts = F.getNgTableOpts(F.get('successOrNot'));

        $scope.cols = [

            {title: '收件人', filter: {recipient: 'text'}, field: 'recipients', width: '15%', show: true},
            {title: '内容', filter: {content: 'text'}, field: 'content', show: true},
            {
                title: '状态',
                field: 'result_info',
                width: '10%',
                filter: {result_info: 'select'},
                data: successOrNotOpts,
                show: true
            },
            {
                title: '时间', sortable: 'updated_at', filter: {updated_at: 'date_range'}, field: 'updated_at',
                width: '20%', show: true
            },
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                Sms.history(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.sms);
                    $scope.sms = resp.sms;
                }, function () {

                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (sm, sms) {
            if (sm.is_checked) {
                $scope.header.checkAll = true;
            } else {
                var allUnchecked = true;
                for (var i = 0; i < sms.length; i++) {
                    if (sms[i].is_checked) {
                        allUnchecked = false;
                        break;
                    }
                }
                if (allUnchecked) {
                    $scope.header.checkAll = false;
                }
            }
        };

        $scope.checkAllFn = function (checkAll, sms) {
            if (checkAll) {
                angular.forEach(sms, function (sm) {
                    sm.is_checked = true;
                })
            } else {
                angular.forEach(sms, function (sm) {
                    sm.is_checked = false;
                })
            }
        };

        $scope.show = function (sm) {
            dialogs.create('templates/sms/show_dlg.html', 'SmsShowDlgCtrl', {sms: sm, is_outbox: true},
                { size: 'md'}).result.then(function (params) {
                    switch (params.opt) {
                        case 5:     //再次编辑
                            $scope.tabs['send'] = true;
                            $timeout(function () {
                                $rootScope.$broadcast('smsEdit', params.sms);
                            }, 200);
                            break;
                    }
                });
        };

        $scope.delete = function (data) {
            dialogs.confirm('删除短信记录', '确定要删除短信记录吗?')
                .result.then(function () {
                    var sms = [];
                    if (angular.isArray(data)) {
                        angular.forEach(data, function (sm) {
                            if (sm.is_checked) {
                                sms.push(sm.id);
                            }
                        });
                    } else {
                        sms.push(data.id);
                    }
                    Sms.remove({sms: sms},
                        function () {
                            toaster.success('短信记录删除成功!');
                            $scope.tableReload();
                        },
                        function () {
                            toaster.error('短信记录删除失败!');
                        }
                    );
                });
        }
    });
angular.module('c.c').controller('SmsSendController',
    function ($rootScope, $scope, dialogs, toaster, F, User, Sms) {
        $scope.$on('smsEdit', function (ev, sms) {
            var content = sms.content.substr(sms.sign.length, sms.content.length - sms.sign.length);
            var sign = sms.sign.substr(1, sms.sign.length - 2);
            $scope.sms = {sign: sign, content: content, recipients: sms.recipients};
        });

        $scope.$on('missionSms', function (ev, sms) {
            $scope.sms['recipients'] = sms;
        });
        User.query({opt: 7}, function (resp) {
            $scope.existMembers = resp.users;
        });

        $scope.mustKnow = function () {
            dialogs.create('templates/sms/must_know_dlg.html', 'SimpleDlgCtrl', {},
                { size: 'lg'});
        };

        $scope.send = function (sms) {
            if (sms.sign == null || sms.sign == "") {
                toaster.warning('短信签名不能为空!');
            } else if (sms.recipients == null || sms.recipients.length == 0) {
                toaster.warning('请填写收件人!');
            } else if (sms.content == null || sms.content.length == 0) {
                toaster.warning('短信内容不能为空!');
            } else {
                var params = {};
                params['sign'] = '【西藏自治区人民政府驻成都办事处医院】';
                params['content'] = sms.content;
                params['content'] += '(' + $scope.account.name + $scope.account.phone + ')';
                params['recipients'] = [];
                angular.forEach(sms.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });

                Sms.send(params, function (success) {
                    toaster.success('短信请求成功!');
                    //F.setSmsSign(sms.sign);
                    $scope.reset();
                    $rootScope.$broadcast('smsSend');
                }, function (resp) {
                    toaster.error('短信请求失败!');
                });
            }
        };

        $scope.reset = function () {
            $scope.sms = {recipients: [], sign: $scope.account.name};
        };

        $scope.reset();
    });
angular.module('c.d')
    .directive('personnelWageTable', function () {
        var controller = function ($scope, $rootScope, $filter, dialogs, toaster, NgTableParams, Dept,
                                   UserStatus, VariableWage, UVariableWage, UGradeWage, GradeWage, F, C, Table) {

            Table.loadMultiSelectedFn($scope);

            UserStatus.query(function (resp) {
                $scope.statuses = resp;
                if ($scope.statuses && $scope.statuses.length > 0) {
                    $scope.statusSelectedFn($scope.statuses[1]);
                }
            });

            Dept.query({opt: C.OPT.DEPT.INDEX.DEPTS_OPTIONS}, function (resp) {
                $scope.depts = resp.depts;
                if ($scope.depts && $scope.depts.length > 0) {
                    $scope.depts.splice(0, 0, {name: '全部科室'});
                    $scope.deptSelectedFn($scope.depts[0]);
                }
            });

            function getStatusWage(S, s) {
                S.query({opt: C.OPT.SYS_WAGE.INDEX.STATUS_WAGES, status_id: s.id},
                    function (resp) {
                        $scope.wages = resp.wages;
                    });
            }

            $scope.statusSelectedFn = function (s) {
                if (s.id) {
                    if ($scope.type == 1) {
                        getStatusWage(GradeWage, s);
                    } else if ($scope.type == 2) {
                        getStatusWage(VariableWage, s);
                    }
                }
                $scope.status = s;
                $scope.tableParams.$params.page = 1;
                $scope.tableParams.reload();
            };

            $scope.deptSelectedFn = function (d) {
                $scope.dept = d;
                $scope.tableParams.$params.page = 1;
                $scope.tableParams.reload();
            };

            $scope.cols = [
                {title: '姓名', filter: {'users.name': 'text'}, show: true}, //0
                {title: '工号', filter: {'username': 'text'}, show: true}, //0
                {title: '聘用类型', show: true}, //6
                {title: '岗位等级', filter: {'grade': 'text'}, show: true}, //6
                {width: '180', show: true} //6
            ];

            var typeCol = $scope.cols[4];
            if ($scope.type == 1) {
                typeCol.title = '薪级工资条目';
            } else if ($scope.type == 2) {
                typeCol.title = '可变工资条目';
            }

            //
            $scope.optColWidth = 68;
            $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {sorting: 'asc'}}, {
                counts: [30, 50, 100], total: 0,
                getData: function ($defer, params) {
                    if ($scope.status && $scope.dept) {
                        var url = params.url();
                        url['opt'] = C.OPT.PERSONNEL_WAGE.INDEX.ALL_USERS;  //分别获得员工薪级工资和可变工资
                        url['status_id'] = $scope.status.id;
                        url['main_dept_id'] = $scope.dept.id;
                        if ($scope.type == 1) {
                            Table.query(UGradeWage, url, $defer, params, 'records', function (resp) {
                                $scope.users = resp.records;
                            });
                        } else if ($scope.type == 2) {
                            Table.query(UVariableWage, url, $defer, params, 'records', function (resp) {
                                $scope.users = resp.records;
                            });
                        }
                    } else {
                        $defer.resolve([]);
                    }
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.tableParams.filter({});
            };

            $scope.op = {};
            $scope.addUsersWages = function (users, status, wage) {
                if (wage == null) {
                    toaster.warning('请先选择条目');
                } else {
                    var ids = [];
                    angular.forEach(users, function (u) {
                        if (u.is_checked) {
                            ids.push(u.id);
                        }
                    });
                    if (ids.length == 0) {
                        toaster.warning('请选择要操作的员工');
                    } else {
                        if ($scope.type == 1) {
                            UGradeWage.addGradeWages({
                                ids: ids,
                                wage_id: wage.id,
                                status_id: status.id
                            }, function (resp) {
                                if (resp.result == 1) {
                                    toaster.warning(resp.msg);
                                }
                                $scope.tableParams.reload();
                            });
                        } else if ($scope.type == 2) {
                            UVariableWage.addVariableWages({
                                ids: ids,
                                wage_id: wage.id,
                                status_id: status.id
                            }, function (resp) {
                                if (resp.result == 1) {
                                    toaster.warning(resp.msg);
                                }
                                $scope.tableParams.reload();
                            });
                        }
                    }
                }
            };

            $scope.unset = function (users, status) {
                var ids = [];
                angular.forEach(users, function (u) {
                    if (u.is_checked) {
                        ids.push(u.id);
                    }
                });
                if (ids.length == 0) {
                    toaster.warning('请选择要操作的员工');
                } else {
                    if ($scope.type == 1) {
                        UGradeWage.cleanGradeWages({
                            ids: ids, status_id: status.id
                        }, function () {
                            $scope.tableParams.reload();
                        });
                    } else if ($scope.type == 2) {
                        UVariableWage.cleanVariableWages({
                            ids: ids, status_id: status.id
                        }, function () {
                            $scope.tableParams.reload();
                        });
                    }
                }
            };

            $scope.submitting = false;
            $scope.genWages = function () {
                if ($scope.type == 1) {
                    if (!$scope.submitting) {
                        $scope.submitting = true;
                        UGradeWage.genWages({status_id: $scope.status.id}).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0:
                                    toaster.success('条目确定成功!');
                                    $rootScope.$broadcast('wageItemSumbit');
                                    break;
                                case 1:
                                    toaster.warning('当月员工月工资表已提交!');
                                    break;
                            }
                            $scope.submitting = false;
                        }, function () {
                            $scope.submitting = false;
                        });
                    }
                } else if ($scope.type == 2) {
                    if (!$scope.submitting) {
                        $scope.submitting = true;
                        UVariableWage.genWages({status_id: $scope.status.id}).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0:
                                    toaster.success('条目确定成功!');
                                    $rootScope.$broadcast('wageItemSumbit');
                                    break;
                                case 1:
                                    toaster.warning('当月员工月工资表已提交!');
                                    break;
                            }
                            $scope.submitting = false;
                        }, function () {
                            $scope.submitting = false;
                        });
                    }
                }
            };

            $scope.edit = function (u) {
                dialogs.create('templates/wage/personnel_wage_dlg.html', 'PersonnelWageDlgCtrl',
                    {user: u, type: $scope.type}, {
                        size: 'lg'
                    }).result.then(function () {
                    $scope.tableParams.reload();
                }, function () {
                    $scope.tableParams.reload();
                });
            };

            $scope.batch = function (status) {
                if ($scope.wages) {
                    dialogs.create('templates/wage/personnel_wage_username_dlg.html', 'PersonnelWageUsernameDlgCtrl',
                        {status: status, items: $scope.wages}, {
                            size: 'md'
                        }).result.then(function () {
                        $scope.tableParams.reload();
                    }, function () {
                        $scope.tableParams.reload();
                    });
                }
            };

            $scope.grade = function (u) {
                dialogs.create('templates/wage/wage_grade_dlg.html', 'PersonnelWageGradeDlgCtrl',
                    {user: u}, {
                        size: 'md'
                    }).result.then(function () {
                    $scope.tableParams.reload();
                }, function () {
                    $scope.tableParams.reload();
                });
            };


        };

        return {
            templateUrl: 'directives/main/wage/personnel-wage-table/personnel-wage-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'type': '@'
            },
            controller: controller
        }
    });

angular.module('c.c').controller('PersonnelWageDlgCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, NgTableParams, F, Table,
              UGradeWage, data, C, UVariableWage) {
        $scope.user = data.user;
        $scope.type = data.type;

        var options = {
            service: $scope.type == 1 ? UGradeWage : UVariableWage,
            params: {
                opt: C.OPT.PERSONNEL_WAGE.INDEX.USER_WAGES, status_id: $scope.user.status_id,
                user_id: $scope.user.id
            },
            optColWidth: 68, items: 'records', hideFilter: true, count: 30, counts: [],
            cols: [
                {title: '条目名称'},
                {title: '金额'},
                {title: '计入科室成本'},
                {title: '计入个税'},
                {title: '计入缺勤扣费'},
                {title: '计入工资'}
            ]
        };

        Table.loadNgTable($scope, options, function (data) {
            $scope.wageIds = [];
            angular.forEach(data.records, function (r) {
                $scope.wageIds.push(r.wage_id)
            });
        });

        function save(S, r) {
            S.save(r).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('条目添加成功!');
                        $scope.tableReload();
                        break;
                    case 1:
                        toaster.warning('存在相同类型的条目,无法添加!');
                        break;
                    case 2:
                        toaster.warning('工资条目与员工编制类型不一致,无法添加!');
                        break;
                }
            }, function () {
                toaster.error('条目添加失败!');
            });
        }

        $scope.add = function () {
            var openWageDialog = function () {
                return dialogs.create('templates/wage/wage_dlg.html', 'WageDlgCtrl', {
                    user: $scope.user,
                    type: $scope.type,
                    wageIds: $scope.wageIds
                }, {
                    size: 'lg'
                }).result.then(function (r) {
                    if ($scope.type == 1) {
                        save(UGradeWage, r);
                    } else if ($scope.type == 2) {
                        save(UVariableWage, r);
                    }
                });
            };

            if ($scope.user.status_id == 2) {
                UGradeWage.query({
                    opt: C.OPT.PERSONNEL_WAGE.INDEX.USER_WAGES,
                    status_id: 3,
                    user_id: $scope.user.id
                }, function (resp) {
                    if (resp.total > 0) {
                        dialogs.confirm('删除试用工资条目', '确定要删除<strong>试用工资条目和上个月试用工资</strong>吗?')
                            .result.then(function () {
                            var pa = {
                                wages: [],
                                user_id: $scope.user.id,
                                status_id: 3,
                                delWage: 1
                            };
                            UGradeWage.save(pa).$promise.then(function () {
                                toaster.success('操作成功!');
                                openWageDialog();
                            }, function () {
                                toaster.error('操作失败!');
                            });
                        }, function () {
                            openWageDialog();
                        });
                    } else {
                        openWageDialog();
                    }
                });
            } else {
                openWageDialog();
            }
        };


        function Del(S, r) {
            S.delete({id: r.id}).$promise.then(function () {
                toaster.success('条目删除成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('条目删除失败!');
            });
        }

        $scope.delete = function (r) {
            dialogs.confirm('删除薪级工资条目', '确定要删除<strong>' + r.name + '</strong>条目吗?')
                .result.then(function () {
                if ($scope.type == 1) {
                    Del(UGradeWage, r);
                } else if ($scope.type == 2) {
                    Del(UVariableWage, r);
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('WageOtherDlgCtrl',
    function ($scope, $uibModalInstance, toaster) {

        $scope.para = {'remark': ''};

        $scope.ok = function (para) {
            if ($scope.wage_other_form.$valid) {
                $uibModalInstance.close(para);
            } else {
                toaster.warning('表单中有错误!,请输入金额与备注');
                $scope.wage_other_form.submitted = true;
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('WageDlgCtrl',
    function ($scope, $uibModalInstance, toaster, GradeWage, VariableWage, data, C, F) {
        $scope.user = data.user;
        $scope.type = data.type;

        function getStatusWage(S) {
            S.query({opt: C.OPT.SYS_WAGE.INDEX.STATUS_WAGES, status_id: data.user.status_id}, function (resp) {
                $scope.wages = resp.wages;
                var wages = [];
                angular.forEach(data.wageIds, function (w) {
                    var wage = F.getItem(w, $scope.wages);
                    if (wage) {
                        wages.push(wage);
                    }
                });
                $scope.u = {wages: wages};
            });
        }

        if ($scope.type == 1) {
            getStatusWage(GradeWage);
        } else if ($scope.type == 2) {
            getStatusWage(VariableWage);
        }

        $scope.ok = function (u) {
            if (u.wages.length == 0) {
                toaster.warning('条目不能为空!');
            } else {
                var pa = {};
                pa['wages'] = [];
                pa['user_id'] = data.user.id;
                angular.forEach(u.wages, function (wage) {
                    pa['wages'].push(wage.id);
                });
                pa['status_id'] = data.user.status_id;
                $uibModalInstance.close(pa);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('PersonnelWageUsernameDlgCtrl',
    function ($scope, $uibModalInstance, $filter, data, UGradeWage, Api) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.changeAfter = changeAfter;
        vm.status = data.status;
        vm.items = data.items;

        init();

        function init() {
            vm.wages = [];
            vm.m = {};
            vm.tableSettings = {
                manualColumnResize: true, colWidths: 300, stretchH: 'default',
                columnSorting: true, sortIndicator: true
            };
        }

        function ok(m) {
            var keepGoing = true;
            if (vm.wages.length - 1 == 0) {
                keepGoing = false;
                Api.w('请输入工号!');
            } else if (!m.item) {
                keepGoing = false;
                Api.w('请选择条目!');
            } else {
                for (var i = 0; i < vm.wages.length - 1; i++) {
                    if (vm.wages[i].username == null) {
                        keepGoing = false;
                        Api.w('表格中存在错误!');
                        break;
                    }
                }
            }


            if (keepGoing) {
                var usernames = [];
                angular.forEach(vm.wages, function (wage) {
                    if (wage.username != null) {
                        usernames.push(wage.username);
                    }
                });
                UGradeWage.addGradeWages({
                    usernames: usernames,
                    wage_id: m.item.id,
                    status_id: vm.status.id
                }, function (resp) {
                    switch (resp.result) {
                        case 0 :
                            Api.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default :
                            Api.w(resp.msg);
                            break;
                    }
                });
            }
        }

        function changeAfter(a) {

            if (a) {
                if (a[0].length > 0) {
                    for (var i = 0; i < a.length; i++) {
                        var row = a[i][0],
                            column = a[i][1],
                            old_value = a[i][2],
                            new_value = a[i][3];

                        var w = $scope.wages[row];
                        if (new_value.length == 0) {
                            w[column] = old_value;
                            Api.w('输入不能为空!');
                        }
                    }
                }
            }
        }

    });

angular.module('c.c').controller('PersonnelWageGradeDlgCtrl',
    function ($scope, $uibModalInstance, $filter, data, ArrayHelper, User, Dlg) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.ok = ok;

        init();

        function init() {
            vm.grades = [
                {id: 1, name: '专技一级'},
                {id: 2, name: '专技二级'},
                {id: 3, name: '专技三级'},
                {id: 4, name: '专技四级'},
                {id: 5, name: '专技五级'},
                {id: 6, name: '专技六级'},
                {id: 7, name: '专技七级'},
                {id: 8, name: '专技八级'},
                {id: 9, name: '专技九级'},
                {id: 10, name: '专技十级'},
                {id: 11, name: '专技十一级'},
                {id: 12, name: '专技十二级'},
                {id: 13, name: '专技十三级'},
                {id: 14, name: '管理一级'},
                {id: 15, name: '管理二级'},
                {id: 16, name: '管理三级'},
                {id: 17, name: '管理四级'},
                {id: 18, name: '管理五级'},
                {id: 19, name: '管理六级'},
                {id: 20, name: '管理七级'},
                {id: 21, name: '管理八级'},
                {id: 22, name: '管理九级'},
                {id: 23, name: '管理十级'},
                {id: 24, name: '技术工一级'},
                {id: 25, name: '技术工二级'},
                {id: 26, name: '技术工三级'},
                {id: 27, name: '技术工四级'},
                {id: 28, name: '技术工五级'},
                {id: 29, name: '普通工'}
            ];
            var m = angular.copy(data.user);
            if (m.grade) m.grade = ArrayHelper.getItem(m.grade, vm.grades, 'name');
            vm.m = m;
        }

        function ok(m) {
            return Dlg.addEditOk(vm, User, function () {
                return {
                    grade: m.grade ? m.grade.name : null,
                    opt: 1
                };
            });
        }
    });






angular.module('c.d')
    .directive('checkWageTable', function () {
        var controller = function ($scope, $filter, dialogs, toaster, Dept, WageReport, Auth, C) {
            $scope.tableSettings = {
                manualColumnResize: true, fixedColumnsLeft: 3, colWidths: 60, stretchH: 'all'
            };
            var user = Auth.getAccount();
            var date = new Date((new Date()).setDate(1));
            $scope.dt = new Date(date.setMonth(date.getMonth() - 1));

            $scope.prevMonth = function (curr) {
                var prev = curr.getMonth() - 1;
                $scope.dt = new Date(curr.setMonth(prev));
            };
            $scope.nextMonth = function (curr) {
                var next = curr.getMonth() + 1;
                $scope.dt = new Date(curr.setMonth(next));
            };

            if ($scope.opt == 3 && user.status_id == '1') {
                $scope.nextMonth($scope.dt);
            }

            $scope.deptSelectedFn = function ($index) {
                $scope.dept = $scope.depts[$index];
                $scope.tableReload();
            };

            if ($scope.opt == 4) {
                Dept.query({opt: 11}, function (resp) {
                    $scope.depts = resp.depts;
                    if (resp.depts && resp.depts.length > 0) {
                        $scope.dept = resp.depts[0];
                        $scope.tableReload();
                    }
                });
            }

            $scope.$watch('dt', function (newVal, oldVal) {
                if (newVal != oldVal) {
                    $scope.reload();
                }
            });

            $scope.reload = function () {
                var params = [];
                params['opt'] = $scope.opt; //3.用户中心 4科室负责人
                params['month'] = $filter('date')($scope.dt, 'yyyy-MM-dd');
                if ($scope.dept) {
                    params['dept_id'] = $scope.dept.id;
                }
                WageReport.query(params, function (resp) {
                    $scope.series_wages = resp.in_series_wages;
                    $scope.recruitment_wages = resp.recruitment_wages;
                    $scope.rehire_wages = resp.rehire_wages;
                    $scope.probation_wages = resp.probation_wages;
                });
            };

            $scope.reload();

            $scope.check = function (record, status) {
                if (status == '1') {
                    dialogs.create('templates/wage/check_series.html', 'WageCheckCtrl', {
                        record: record
                    }, {
                        size: 'lg'
                    });
                } else if (status == '2') {
                    dialogs.create('templates/wage/check_recruitment.html', 'WageCheckCtrl', {
                        record: record
                    }, {
                        size: 'lg'
                    });
                } else if (status == '3') {
                    dialogs.create('templates/wage/check_probation.html', 'WageCheckCtrl', {
                        record: record
                    }, {
                        size: 'lg'
                    });
                } else if (status == '5') {
                    dialogs.create('templates/wage/check_rehire.html', 'WageCheckCtrl', {
                        record: record
                    }, {
                        size: 'lg'
                    });
                }

            };

            $scope.tableReload = function () {
                $scope.reload();
            };

        };

        return {
            templateUrl: 'directives/main/wage/check-wage-table/check-wage-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'opt': '@'
            },
            controller: controller
        }
    });

angular.module('c.c').controller('WageCheckCtrl',
    function ($scope, $uibModalInstance, toaster, data) {
        $scope.record = data.record;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    });







/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('c.c')
        .controller('addUnitPriceDlgCtrl', addUnitPriceDlgCtrl);

    /** @ngInject */
    function addUnitPriceDlgCtrl($scope, $rootScope,$q, $uibModalInstance, User, Auth, Dlg, Table, ArrayHelper,HouseWaeFeePrice, HouseWae, FileHelper, FormHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.edit = data.edit
        vm.submit = submit;
        vm.editRoom = editRoom;
        vm.reset = reset;

        init()

        function init() {
            if (vm.edit) {
                HouseWaeFeePrice.get({id: data.id}).$promise.then(function (resp) {
                    vm.m = resp.item;
                    vm.m.sorting = parseInt(vm.m.sorting);
                    vm.m.price = parseFloat(vm.m.price);
                });
            } else {
                vm.m = {sorting: 1};
            }
        }

        function reset() {
            vm.m = {sorting: 1};
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    price: m.price,
                    sorting: m.sorting
                };
                HouseWaeFeePrice.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    if (vm.continue) {
                        $rootScope.$broadcast('addUnitPrice');
                        reset();
                    } else {
                        $uibModalInstance.close();
                    }
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

        function editRoom(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    price: m.price,
                    sorting: m.sorting
                };
                HouseWaeFeePrice.update({id: m.id}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close()
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('email', []);
    angular.module('c').requires.push('email');
})();

(function () {
    'use strict';

    angular.module('email')
        .controller('EmailCtrl', EmailCtrl)
        .controller('InboxController', InboxController)
        .controller('OutboxController', OutboxController)
        .controller('RecipientsTipsCtrl', RecipientsTipsCtrl)
        .controller('WritEmailCtrl', WritEmailCtrl)
        .controller('EmailDraftController', EmailDraftController)
        .controller('EmailCollectionController', EmailCollectionController)
    ;

    function EmailCtrl($rootScope, $scope, $stateParams, $timeout, dialogs, Email) {
        if ($stateParams.data.tab) {
            $scope.tabs = [];
            var data = $stateParams.data;
            $scope.tabs[data.tab] = true;
            $timeout(function () {
                $rootScope.$broadcast(data.event, data.mail);
            }, 200);
        }
        $timeout(function () {
            Email.query({opt: 5}, function (resp) {
                if (resp.overflow == '1') {
                    dialogs.notify('提示', '邮箱快被撑爆了,请清理邮箱内有附件的邮件!');
                }
            });
        }, 300);
    }

    function InboxController($rootScope, $scope, $timeout, $filter, dialogs, toaster, NgTableParams, C, F, Table, Email) {
        $scope.$on('mail.send', function (event, data) {
            $scope.tableParams.reload();
        });

        $scope.$on(C.P + 'mail.withdraw', function (event, data) {
            var mail = data.data.mail;

            var mail = F.getItem(mail.id, $scope.mails);
            if (mail) {
                mail.withdraw = '1';
            }
        });

        $scope.$on('mailRead', function (event, data) {
            var mail = F.getItem(data, $scope.mails);
            if (mail) {
                mail.is_read = '1';
            }
        });

        $scope.$on('mailDel', function (event, data) {
            $scope.tableParams.reload();
        });

        Table.loadMultiSelectedFn($scope);

        var readStatusOpts = F.getNgTableOpts(F.get('readOrUnread'));
        var emailLvs = F.get('email_lvs');
        var emailLvOpts = F.getNgTableOpts(emailLvs);

        $scope.cols = [
            {
                title: '状态',
                filter: {is_read: 'select'},
                data: readStatusOpts,
                field: 'is_read',
                width: '10%',
                show: true
            },
            {title: '发件人', filter: {sender: 'text'}, field: 'sender_id', width: '15%', show: true},
            {title: '主题', filter: {subject: 'text'}, field: 'subject', show: true},
            {
                title: '重要性',
                sortable: 'level',
                filter: {level: 'select'},
                data: emailLvOpts,
                field: 'level',
                width: '10%',
                show: true
            },
            {
                title: '时间',
                sortable: 'created_at',
                filter: {created_at: 'date_range'},
                field: 'created_at',
                width: '20%',
                show: true
            }
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                Table.query(Email, url, $defer, params, 'mails', function (resp) {
                    angular.forEach(resp.mails, function (mail) {
                        mail.level = F.getItem(mail.level, emailLvs);
                    });
                    $scope.mails = resp.mails;
                });
            }
        });

        $scope.sortByAttachmentSize = function () {
            $scope.tableParams.sorting({size: 'desc'});
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.show = function (mail) {
            if (mail.withdraw == 1) {
                dialogs.notify('确认', '该邮件已经被发送者撤回');
                return;
            }

            dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 1:
                        $scope.tabs['write'] = true;
                        $timeout(function () {
                            $rootScope.$broadcast('mailReply', params.mail);
                        }, 200);
                        break;
                    case 2:
                        $scope.tabs['write'] = true;
                        $timeout(function () {
                            $rootScope.$broadcast('mailForward', params.mail);
                        }, 200);
                        break;
                    case 3:
                        Email.rm_from_inbox({mails: [params.mail.id]}).$promise.then(
                            function () {
                                $rootScope.$broadcast('mailDel', params.mail.id);
                            },
                            function () {
                                toaster.error('邮件删除失败!');
                            });
                        break;
                }
            });
        };

        $scope.delete = function (data) {
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                var mails = [];
                if (angular.isArray(data)) {
                    angular.forEach(data, function (mail) {
                        if (mail.is_checked) {
                            mails.push(mail.id);
                        }
                    });
                } else {
                    mails.push(data.id);
                }
                Email.rm_from_inbox({mails: mails}).$promise.then(
                    function () {
                        toaster.success('邮件删除成功!');
                        $rootScope.$broadcast('mailDel');
                    },
                    function () {
                        toaster.error('邮件删除失败!');
                    }
                );
            });
        }
    }

    function OutboxController($rootScope, $scope, $timeout, $filter, dialogs, toaster, NgTableParams, C, F, Table, Email) {
        $scope.$on(C.P + 'mail.read', function (event, data) {
            var mail = data.data.mail;
            if ($scope.account.id == mail.sender_id) {
                var mails = $scope.mails;
                for (var i = 0; i < mails.length; i++) {
                    if (mails[i].id == mail.id) {
                        var recipients = mails[i].recipients;
                        for (var j = 0; j < recipients.length; j++) {
                            if (recipients[j].id == mail.reader_id) {
                                recipients[j].is_read = true;
                            }
                        }
                    }
                }
            }
        });

        $scope.$on('mailSend', function (event, data) {
            $scope.tableParams.reload();
        });

        var undoOrNotOpts = F.getNgTableOpts(F.get('undoOrNot'));
        var emailLvs = F.get('email_lvs');
        var emailLvOpts = F.getNgTableOpts(emailLvs);
        $scope.cols = [
            {
                title: '状态',
                filter: {withdraw: 'select'},
                data: undoOrNotOpts,
                field: 'withdraw',
                width: '10%',
                show: true
            },
            {title: '收件人', filter: {recipient: 'text'}, field: 'recipients', width: '15%', show: true},
            {title: '主题', filter: {subject: 'text'}, field: 'subject', show: true},
            {
                title: '重要性', sortable: 'level', filter: {level: 'select'}, data: emailLvOpts, field: 'level',
                width: '10%', show: true
            },
            {
                title: '时间', sortable: 'created_at', filter: {created_at: 'date_range'}, field: 'created_at',
                width: '20%', show: true
            }
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 2;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                Table.query(Email, url, $defer, params, 'mails', function (resp) {
                    $scope.users = resp.users;
                    angular.forEach(resp.mails, function (mail) {
                        mail.level = F.getItem(mail.level, emailLvs);
                    });
                    $scope.mails = resp.mails;
                });
            }
        });

        $scope.sortByAttachmentSize = function () {
            $scope.tableParams.sorting({size: 'desc'});
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        Table.loadMultiSelectedFn($scope);

        $scope.show = function (mail) {
            dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail, is_outbox: true},
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 2:     //转发
                        $scope.tabs['write'] = true;
                        $timeout(function () {
                            $rootScope.$broadcast('mailForward', params.mail);
                        }, 200);
                        break;
                    case 3:     //删除
                        Email.rm_from_outbox({mails: [params.mail.id]});
                        $scope.tableParams.reload();
                        break;
                    case 4:     //撤回
                        $scope.tableParams.reload();
                        break;
                    case 5:     //再次编辑
                        $scope.tabs['write'] = true;
                        $timeout(function () {
                            $rootScope.$broadcast('mailEdit', params.mail);
                        }, 200);
                        break;
                }
            });
        };

        $scope.delete = function (data) {
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                var mails = [];
                if (angular.isArray(data)) {
                    angular.forEach(data, function (mail) {
                        if (mail.is_checked) {
                            mails.push(mail.id);
                        }
                    });
                } else {
                    mails.push(data.id);
                }
                Email.rm_from_outbox({mails: mails}).$promise.then(
                    function () {
                        toaster.success('邮件删除成功!');
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('邮件删除失败!');
                    }
                );
            });
        }
    }

    function RecipientsTipsCtrl($scope, $interval) {
        var recipients = $scope.mail.recipients;
        var n = Math.ceil(recipients.length / 20);
        var i = 0;

        $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);
                if ($scope.recipients.length < 20) {
                    var k = 20 - $scope.recipients.length;
                    for (var j = 0; j < k; j++) {
                        $scope.recipients.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    }

    function WritEmailCtrl($rootScope, $scope, dialogs, toaster, C, F, Sms, Email, FileHelper) {
        $scope.levels = F.get('email_lvs');

        function loadMail(mail, is_reply) {
            var header = '<br><br><br><p><i>------------------ 原始邮件 ------------------<br>';
            header += '<strong>发件人：</strong>' + mail.sender.name + '<' + mail.sender.username + '>;<br>';
            header += '<strong>发送时间：</strong>' + mail.created_at + ';<br>';
            header += '<strong>收件人：</strong>';
            angular.forEach(mail.recipients, function (recipient) {
                header += recipient.name + '<' + recipient.username + '>;';
            });
            header += '<br>';
            header += '<strong>主题：</strong>' + mail.subject + ';<br></i></p>';

            mail.body = header + mail.body;

            if (is_reply) {  //回复
                mail.subject = "回复：" + mail.subject;
                mail.recipients = [{
                    id: mail.sender.id, name: mail.sender.name,
                    username: mail.sender.username
                }];
                mail.attachments = [];
                mail.level = $scope.levels[0];
            } else { //转发
                mail.subject = "转发：" + mail.subject;
                mail.recipients = [];
            }
            $scope.mail = mail;
        }

        $scope.$on('mailReply', function (ev, mail) {
            loadMail(mail, true);
        });

        $scope.$on('mailForward', function (ev, mail) {
            loadMail(mail, false);
        });

        $scope.$on('mailEdit', function (ev, mail) {
            $scope.mail = mail;
        });

        $scope.deleteAttachment = function ($index, mail) {
            mail.attachments.splice($index, 1);
        };

        $scope.upload = function (file, mail, e) {
            FileHelper.upload(C.URL.MAIL_UPLOAD, file, mail, e);
        };

        $scope.send = function (mail, isDraft) {
            var promise = submitEmail(mail, isDraft);
            if (promise) {
                if (isDraft) {
                    promise.then(function (resp) {
                        toaster.success('邮件已保存为草稿!');
                        $scope.reset();
                    }, function () {
                        toaster.error('邮件保存失败了!');
                    });
                } else {
                    promise.then(function (resp) {
                        toaster.success('邮件发送成功!');
                        $scope.reset();
                        $rootScope.$broadcast('mailSend');

                        // if (mail.with_sms) {
                        //     var pa = {};
                        //     pa['sign'] = '【西藏自治区人民政府驻成都办事处医院】';
                        //     pa['content'] = '请查收邮件《' + $scope.submitParams['subject'] + '》';
                        //     pa['content'] += '(' + $scope.account.name + $scope.account.phone + ')';
                        //     pa['recipients'] = $scope.submitParams['recipients'];
                        //     Sms.send(pa, function() {
                        //         toaster.success('短信请求成功!');
                        //     }, function() {
                        //         toaster.error('短信请求失败!');
                        //     });
                        // }
                        if (mail.with_wx) {
                            var pa1 = {};
                            pa1['m_id'] = resp.id;
                            pa1['sign'] = '请查收邮件《' + $scope.submitParams['subject'] + '》';
                            pa1['content'] = '《' + $scope.submitParams['subject'] + '》';
                            // pa1['content'] += '(' + $scope.account.name + $scope.account.phone + ')';
                            pa1['recipients'] = $scope.submitParams['recipients'];
                            Sms.receiveEmails(pa1, function () {

                                toaster.success('微信发送成功!');
                            }, function () {
                                toaster.error('微信发送失败!');
                            });
                        }


                        if (mail.attachments.length > 0) {
                            Email.query({opt: 5}, function (resp) {
                                if (resp.overflow == '1') {
                                    dialogs.notify('提示', '邮箱快被撑爆了,请前往站内邮箱清理邮件!');
                                }
                            });
                        }
                    }, function () {
                        toaster.error('邮件发送失败了!');
                    });
                }
            }
        };

        function submitEmail(mail, isDraft) {
            var promise = null;
            if (mail.subject == null || mail.subject == "") {
                toaster.warning('邮件主题不能为空!');
            } else if (mail.recipients == null || mail.recipients.length == 0) {
                toaster.warning('请填写收件人!');
            } else if (!FileHelper.isAttachmentsUploaded(mail)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {is_draft: isDraft};
                params['subject'] = mail.subject;
                params['level'] = mail.level.id;
                params['body'] = mail.body;
                params['with_wx'] = mail.with_wx;
                params['with_sms'] = mail.with_sms;
                params['attachments'] = [];
                params['size'] = 0;
                angular.forEach(mail.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });


                params['recipients'] = [];
                angular.forEach(mail.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });
                $scope.submitParams = params;
                promise = Email.save(params).$promise;
            }
            return promise;
        }

        $scope.reset = function () {
            $scope.mail = {
                with_wx: true,
                level: $scope.levels[0],
                attachments: [],
                recipients: [],
                content: ''
            };
        };

        $scope.reset();
    }

    function EmailDraftController($scope, Table, ArrayHelper, Email, $q, Dlg, UIHelper) {
        var vm = $scope;
        var checker = Table.loadMultiSelectedFn(vm);
        var emailLvs = ArrayHelper.get('email_lvs');
        var emailLvOpts = Table.getNgTableOpts(emailLvs);
        vm.relaunch = relaunch;
        vm.remove = remove;
        vm.sortByAttachmentSize = sortByAttachmentSize;


        init();

        function init() {
            UIHelper.loadTab(vm, 'draft');
            var options = {
                service: Email,
                params: {opt: 6}, /*草稿箱*/
                optInFront: true,
                optColWidth: Table._2_BTN,
                sorting: {},
                cols: [
                    {field: 'recipientsString', title: '收件人', filter: {recipient: 'text'}, width: '15%'},
                    {field: 'subject', title: '主题', filter: {subject: 'text'}},
                    {
                        field: 'level',
                        title: '重要性',
                        sortable: 'level',
                        filter: {level: 'select'},
                        data: emailLvOpts,
                        width: '10%'
                    },
                    {
                        field: 'created_at',
                        title: '时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        width: '20%'
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (mail) {
                    mail.level = ArrayHelper.getItem(mail.level, emailLvs);
                    mail.recipientsString = '';
                    angular.forEach(mail.recipients, function (value) {
                        mail.recipientsString += (value.name + ' ');
                    });
                });
            });
        }

        function sortByAttachmentSize() {
            vm.tableParams.sorting({size: 'desc'});
            vm.tableReload();
        }

        function relaunch(m) {
            Dlg.addEdit(vm, 'pages/dlg/email/emailPublishDlg.html',
                'EmailPublishDlgCtrl', m, {account: $scope.account}, 'lg');
        }

        function remove(isBatch, m) {
            var defer = $q.defer();
            var mailIds = [];
            if (isBatch) {
                var items = checker.getCheckedIds();
                var count = items.length;
                if (count === 0) {
                    checker.clearChecked();
                    Dlg.w("请至少选中一个待处理选项");
                    return;
                } else {
                    mailIds = items;
                    Email.update({id: '-', opt: 2}, {mails: mailIds}).$promise.then(
                        function () {
                            Dlg.s('邮件草稿删除成功!');
                        },
                        function () {
                            Dlg.e('邮件删除失败!');
                        }
                    ).finally(function () {
                        defer.resolve();
                        vm.tableReload();
                    });
                }
            } else {
                Dlg.confirm('确定要删除主题为<strong>' + m.subject + '</strong>的邮件吗？', function () {
                    mailIds.push(m.id);
                    Email.update({id: '-', opt: 2}, {mails: mailIds}).$promise.then(
                        function () {
                            Dlg.s('邮件草稿删除成功!');
                        },
                        function () {
                            Dlg.e('邮件删除失败!');
                        }
                    ).finally(function () {
                        defer.resolve();
                        vm.tableReload();
                    });
                }, '删除邮件');
            }
            return defer.promise;
        }
    }

    function EmailCollectionController($scope, Table, ArrayHelper, Email, $q, Dlg, UIHelper, C) {
        var vm = $scope;
        var checker = Table.loadMultiSelectedFn(vm);
        var emailLvs = ArrayHelper.get('email_lvs');
        var emailLvOpts = Table.getNgTableOpts(emailLvs);
        vm.remove = remove;
        vm.show = show;
        vm.sortByAttachmentSize = sortByAttachmentSize;



        init();

        function init() {
            $scope.$on('EmailCancelCollect', function (event, data) {
                vm.tableReload();
            });

            $scope.$on('EmailCollect', function (event, data) {
                vm.tableReload();
            });


            UIHelper.loadTab(vm, 'collection');
            var options = {
                service: Email,
                params: {opt: 7}, /*收藏箱*/
                optInFront: true,
                optColWidth: Table._1_BTN,
                sorting: {},
                cols: [
                    {field: 'recipients', title: '收件人', filter: {recipients: 'text'}, width: '15%'},
                    {field: 'sender', title: '发件人', filter: {sender: 'text'}, width: '15%'},
                    {field: 'subject', title: '主题', filter: {subject: 'text'}},
                    {
                        field: 'level',
                        title: '重要性',
                        sortable: 'level',
                        filter: {level: 'select'},
                        data: emailLvOpts,
                        width: '10%'
                    },
                    {
                        field: 'created_at',
                        title: '时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        width: '20%'
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (mail) {
                    mail.level = ArrayHelper.getItem(mail.level, emailLvs);
                });
            });
        }

        function sortByAttachmentSize() {
            vm.tableParams.sorting({size: 'desc'});
            vm.tableReload();
        }

        function show(mail) {
            Dlg.show({
                template: C.V + 'email/show_collection_dlg.html',
                ctrl: 'MailShowDlgCtrl',
                data: {mail: mail}
            }).finally(function () {
                vm.tableReload();
            });
        }


        function remove(isBatch, m) {
            var defer = $q.defer();
            var mailIds = [];
            if (isBatch) {
                var items = checker.getCheckedIds();
                var count = items.length;
                if (count === 0) {
                    checker.clearChecked();
                    Dlg.w("请至少选中一个待处理选项");
                    return;
                } else {
                    mailIds = items;
                    Email.update({id: '-', opt: 3}, {mails: mailIds}).$promise.then(
                        function () {
                            Dlg.s('邮件取消收藏成功!');
                        },
                        function () {
                            Dlg.e('邮件取消收藏失败!');
                        }
                    ).finally(function () {
                        defer.resolve();
                        vm.tableReload();
                    });
                }
            } else {
                Dlg.confirm('确定要取消收藏主题为<strong>' + m.subject + '</strong>的邮件吗？', function () {
                    mailIds.push(m.id);
                    Email.update({id: '-', opt: 3}, {mails: mailIds}).$promise.then(
                        function () {
                            Dlg.s('邮件取消收藏成功!');
                        },
                        function () {
                            Dlg.e('邮件取消收藏失败!');
                        }
                    ).finally(function () {
                        defer.resolve();
                        vm.tableReload();
                    });
                }, '取消收藏邮件');
            }
            return defer.promise;
        }
    }

})();




(function () {
    'use strict';

    angular.module('email')
        .controller('EmailPublishDlgCtrl', EmailPublishDlgCtrl);

    /** @ngInject */
    function EmailPublishDlgCtrl($uibModalInstance, Dlg, Email, data, ArrayHelper, FileHelper, C, FormHelper, Sms) {
        var vm = this;
        vm.ok = ok;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.download = download;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.levels = ArrayHelper.get('email_lvs');
        vm.account = data.account;

        init(data.id);


        function init(id) {
            if (id) {
                Email.get({id: id}, function (resp) {
                    vm.m = resp.mail;
                    vm.m.with_sms = resp.mail.with_sms ? true : false;
                    vm.m.with_wx = resp.mail.with_wx ? true : false;
                    vm.m.level = ArrayHelper.getItem(vm.m.level, vm.levels);
                });
            } else {
                Dlg.w('草稿邮件不存在或内部错误!');
                vm.close();
            }
        }

        function upload(file, mail, e) {
            FileHelper.upload(C.URL.MAIL_UPLOAD, file, mail, e);
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function download(attachment) {
            FileHelper.download1('api/v1/emails/download', attachment);
        }

        function ok(mail) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var params = {is_draft: false};
                params['subject'] = mail.subject;
                params['level'] = mail.level.id;
                params['body'] = mail.body;
                params['attachments'] = [];
                params['size'] = 0;
                angular.forEach(mail.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });
                params['recipients'] = [];
                angular.forEach(mail.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });
                Email.update({id: mail.id, opt: 1}, params).$promise.then(function (resp) {
                    Dlg.s('邮件发送成功!');
                    // if (mail.with_sms) {
                    //     var pa = {};
                    //     pa['sign'] = '【西藏自治区人民政府驻成都办事处医院】';
                    //     pa['content'] = '请查收邮件《' + params['subject'] + '》';
                    //     pa['content'] += '(' + vm.account.name + vm.account.phone + ')';
                    //     pa['recipients'] = params['recipients'];
                    //     Sms.send(pa, function () {
                    //         Dlg.s('短信请求成功!');
                    //     }, function () {
                    //         Dlg.e('短信请求失败!');
                    //     });
                    // }
                    if (mail.with_wx) {
                        var pa1 = {};
                        pa1['m_id'] = mail.id;
                        pa1['sign'] = '请查收邮件《' + params['subject'] + '》';
                        pa1['content'] = '《' + params['subject'] + ' 》';
                        // pa1['content'] += '(' + $scope.account.name + $scope.account.phone + ')';
                        pa1['recipients'] = params['recipients'];
                        Sms.receiveEmails(pa1, function () {
                            Dlg.s('微信发送成功!');
                        }, function () {
                            Dlg.e('微信发送失败!');
                        });
                    }
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                    vm.close();
                });
            });
        }
    }

})();


angular.module('email').controller('MailShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, dialogs, toaster, SaveAs, FileHelper, C, F, Email, data, $state) {
        $scope.is_outbox = data.is_outbox;

        //$scope.mail = {subject: data.mail.subject, level: data.mail.level};
        var emailLvs = F.get('email_lvs');
        Email.get({id: data.mail.id}).$promise.then(function (resp) {
            if (data.mail.is_read != '1') {
                data.mail.is_read = '1';
                $rootScope.$broadcast('mailRead', data.mail.id);
            }
            var mail = resp.mail;
            mail.level = F.getItem(mail.level, emailLvs);
            angular.forEach(mail.attachments, function (attachment) {
                attachment.ico = F.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });

            $scope.mailContent = $sce.trustAsHtml(mail.body);
            $scope.mail = mail;
        }, function () {
            toaster.pop({
                type: 'warning', title: '邮件不存在', body: '该邮件可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.download = function (mail, attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.MAIL_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        /**
         * opt: 1--reply/回复; 2--forward/转发; 3--delete/删除; 4--withdraw/撤回
         *      5--edit/再次编辑
         */

        $scope.delete = function (mail) {
            var params = {opt: 3, mail: mail};
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                $uibModalInstance.close(params);
            });
        };

        $scope.withdraw = function (mail) {
            var params = {opt: 4, mail: mail};
            dialogs.confirm('撤回邮件', '确定要撤回邮件吗?')
                .result.then(function () {
                Email.withdraw({id: mail.id}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 2:
                                toaster.warning('邮件已被阅读,无法撤回!');
                                break;
                            case 1:
                                toaster.warning('邮件发送已超过15天,无法撤回!');
                                break;
                            case 0:
                                toaster.success('邮件撤回成功!');
                                $uibModalInstance.close(params);
                                break;
                        }
                    },
                    function () {
                        toaster.error('邮件撤回失败!');
                    }
                );
            });
        };

        $scope.forward = function (mail) {
            var params = {opt: 2, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.reply = function (mail) {
            var params = {opt: 1, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.edit = function (mail) {
            var params = {opt: 5, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.applyMission = function (m) {
            $state.go('app.coop_mission', {
                data: {
                    tab: 'apply',
                    event: 'missionApplyByMail',
                    content: m
                }
            });
        };

        $scope.collect = function (m) {
            var params = {};
            params['opt'] = 1;
            params['mail_id'] = m.id;
            Email.collect(params).$promise.then(function (data) {
                m.is_collect = 1;
                $rootScope.$broadcast('EmailCollect');
                toaster.success('已收藏!');
            });
        };

        $scope.cancel_collect = function (m) {
            var params = {};
            params['opt'] = 2;
            params['mail_id'] = m.id;
            Email.collect(params).$promise.then(function () {
                m.is_collect = 0;
                $rootScope.$broadcast('EmailCancelCollect');
                toaster.success('已取消收藏!');
            });
        };
    });
angular.module("c").run(["$templateCache", function($templateCache) {$templateCache.put("templates/cache/breadcrumb.html","<div class=\"col-lg-12 px-0\"><ul class=\"breadcrumb\" style=\"min-height: 36px\"><li class=\"hidden-xs\"><a ui-sref=\"app.home\" ng-click=\"$root.collapseVar=0\">首页</a></li><li class=\"hidden-xs\" ng-if=\"parent\"><a href=\"\">{{parent}}</a></li><li class=\"hidden-xs active\" ng-if=\"current\">{{current}}</li></ul><span class=\"home-more\"><a class=\"text-danger\" href=\"tel:{{infoDeptDuty?infoDeptDuty.user.phone:15202824670}}\"><strong class=\"hidden-sm hidden-xs\">&nbsp;&nbsp;&nbsp;&nbsp;院总值班:13678068060、护理总值班：18382209208(6120)、后勤呼叫中心:15884455916(6900)、安全报警电话:85537152(8018)、</strong> <strong ng-if=\"infoDeptDuty\">{{\"信息科:\" + infoDeptDuty.user.phone + \"(\" + infoDeptDuty.user.name + \")\"}}</strong> <strong ng-else=\"\">信息科:15202824670/610026</strong></a></span></div>");
$templateCache.put("templates/cache/footer.html","<div class=\"col-xs-12 footer\"><div>西藏自治区人民政府驻成都办事处医院移动互联信息平台©蜀ICP备15017496号-1</div><div ng-if=\"vc\" class=\"mt-2 font-sm text-muted font-italic\">登录次数：<strong>{{vc.loginCnt}}</strong>，访问次数：<strong>{{vc.apiCnt}}</strong>.</div></div>");
$templateCache.put("templates/cache/header.html","<nav class=\"navbar navbar-default navbar-fixed-top mb-0\" role=\"navigation\"><div class=\"navbar-header\"><a class=\"navbar-toggle\" ng-click=\"header.toggleSidebar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></a><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openUserD2\"><a id=\"user-dropdown-callDlg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-file-text fa-fw\"></i></a><ul class=\"dropdown-menu dp-user\" uib-dropdown-menu=\"\" aria-labelledby=\"user-dropdown-callDlg\"><i class=\"dropdown-arr\"></i><li ng-click=\"header.callFrozenDlg()\"><a><i class=\"fa fa-bed fa-fw\"></i>术中冰冻预约</a></li></ul></li><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openTaskD\" on-toggle=\"header.toggleTaskD()\"><a id=\"task-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-tasks fa-fw\"></i> <span class=\"notify-tag bg-red\" ng-show=\"header.hasTask\" ng-class=\"{\'notify-animated\':shakePoint}\">！</span></a><div class=\"dropdown-menu header-dp dp-task\" uib-dropdown-menu=\"\" aria-labelledby=\"task-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">待处理事务</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadTask()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ng-click=\"openTaskD=false\"><i class=\"fa fa-times fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.taskLoading||header.tasks.length>0\" loading-container=\"header.taskLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"task in header.tasks track by task.type\" class=\"task-item clearfix\" ng-click=\"openTaskD=false;header.toTask(task,$index)\"><i class=\"fa fa-bookmark fa-fw\"></i>{{::task.name}} <span ng-if=\"task.subName\" class=\"text-muted\">[{{::task.subName}}]</span> <span ng-if=\"task.isNew\" class=\"order-tag tag-danger\">新</span> <span class=\"pull-right text-muted small\" style=\"padding-top:3px\">进入处理..</span></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有待处理事务</div></div></div></div></li><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openMailD\"><a id=\"mail-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o fa-fw\"></i> <span ng-show=\"header.mails.length > 0\" class=\"notify-tag bg-orange\" ng-bind=\"header.mails.length\"></span></a><div class=\"dropdown-menu header-dp dp-mail\" uib-dropdown-menu=\"\" aria-labelledby=\"mail-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">未读邮件</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadMail()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ui-sref=\"app.coop_email\" uib-tooltip=\"进入邮箱\"><i class=\"fa fa-arrow-right fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.mailLoading||header.mails.length>0\" loading-container=\"header.mailLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"mail in header.mails track by mail.id\" ng-show=\"header.mails.length>0\" class=\"mail-item\" ng-click=\"header.readMail(mail,$index)\"><div class=\"mail-title\"><i class=\"fa fa-envelope-o fa-fw\"></i>{{mail.subject}}</div><div class=\"text-muted small mail-date\" am-time-ago=\"mail.created_at\"></div></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有未读邮件</div></div></div></div></li><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openMenuD\" on-toggle=\"header.toggleMenuD()\"><a id=\"menu-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-star fa-fw\"></i></a><div class=\"dropdown-menu header-dp dp-mail\" uib-dropdown-menu=\"\" aria-labelledby=\"menu-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">快捷菜单</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadMenu()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ui-sref=\"app.coop_quick_menu\" uib-tooltip=\"进入设置\"><i class=\"fa fa-arrow-right fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.menuLoading||header.menus.length>0\" loading-container=\"header.menuLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"menu in header.menus track by menu.id\" ng-show=\"header.menus.length>0\" class=\"mail-item\" ng-click=\"header.goMenu(menu)\"><div class=\"mail-title\"><i class=\"fa fa-star fa-fw\"></i>{{menu.display_name}}</div></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>还未设置快捷菜单</div></div></div></div></li><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openUserD\"><a id=\"user-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-user fa-fw\"></i></a><ul class=\"dropdown-menu dp-user\" uib-dropdown-menu=\"\" aria-labelledby=\"user-dropdown\"><i class=\"dropdown-arr\"></i><li><a ui-sref=\"app.user_profile\"><i class=\"fa fa-user fa-fw\"></i>用户资料</a></li><li><a ui-sref=\"app.user_contacts\"><i class=\"fa fa-phone-square fa-fw\"></i>通讯录</a></li><li><a ui-sref=\"app.user_help\"><i class=\"fa fa-book fa-fw\"></i>帮助</a></li><li><a ng-click=\"header.forum()\"><i class=\"fa fa-comments fa-fw\"></i>论坛</a></li><li ng-if=\"header.account.is_home_admin\"><a ng-click=\"header.homeCS()\"><i class=\"fa fa-cogs fa-fw\"></i>官网后台</a></li><li><a ng-click=\"header.toEQS()\"><i class=\"fa fa-cogs fa-fw\"></i>专家排队</a></li><li class=\"divider\"></li><li><a ng-click=\"header.logout()\"><i class=\"fa fa-sign-out fa-fw\"></i>注销</a></li></ul></li><img class=\"img-circle\" ng-if=\"header.account.photo\" style=\"margin-left:6px;margin-right:8px;cursor:pointer\" ui-sref=\"app.user_profile\" ng-src=\"{{header.account.photo}}\" width=\"36\" height=\"36\"><li class=\"dropdown hidden-sm hidden-xs\"><a class=\"dropdown-toggle\" style=\"padding-left:2px;padding-right:2px\" ui-sref=\"app.user_profile\"><span ng-bind=\"header.account.name\"></span></a></li></ul></div></nav>");
$templateCache.put("templates/cache/home.html","<script type=\"text/ng-template\" id=\"chatBot.html\"><div class=\"modal-content\" style=\"border-radius: 12px; overflow: hidden;\"> <!-- 头部 --> <div class=\"modal-header\" style=\"padding: 20px 30px; background: linear-gradient(135deg, #2c7be5 0%, #00d27a 100%);\"> <div style=\"display: flex; align-items: center; justify-content: space-between; width: 100%;\"> <h4 class=\"modal-title\" style=\"margin:0; color: white; font-size: 1.8rem; font-weight: 600; text-shadow: 0 2px 4px rgba(0,0,0,0.1);\"> 成办分院智能客服 </h4> <button type=\"button\" class=\"close\" ng-click=\"cancel()\" style=\"color: rgba(0,0,0,1); font-size: 2rem; padding: 0 8px; transition: all 0.3s ease;\" onmouseover=\"this.style.transform=\'rotate(90deg)\'\" onmouseout=\"this.style.transform=\'rotate(0deg)\'\"> &times; </button> </div> </div> <iframe ng-src=\"https://www.tcd120.cn/chatBotDify\" class=\"embed-responsive-item\" style=\"width: 100%; height: 700px; border: none; border-radius: 8px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\"></iframe> </div></script><script type=\"text/ng-template\" id=\"feedback.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-sliders fa-fw\"></i>录入意见 </h4> </div> <div class=\"modal-body body-scroll-disable\"> <form name=\"m_form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-2 control-label\">意见</label> <div class=\"col-md-8 btn-group\"> <textarea class=\"form-control\" rows=\"4\" name=\"desc\" ng-model=\"m.opinion\" maxlength=\"250\" placeholder=\"输入在250字以内\"></textarea> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"submit(m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button> </div></script><div class=\"row\"><breadcrumb></breadcrumb><div class=\"col-md-3\"><div class=\"info-box\"><a class=\"info-box-icon bg-green\" ui-sref=\"app.coop_mtv_conference\"><div class=\"mtv-icon\"><i class=\"fa fa-tv fa-fw\"></i><div class=\"mtv-icon-text\">TV</div><div class=\"mtv-icon-title\">电视晨会</div></div></a><div class=\"info-box-content\"><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-info\" href=\"/#/app/coop/bed_stat?tab=dept\"><i class=\"fa fa-medkit fa-fw\"></i>数据中心</a></div><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-info\" href=\"/#/app/coop/doc\"><i class=\"fa fa-pencil-square-o fa-fw\"></i>公文处理</a></div></div></div></div><div class=\"col-md-3\"><div class=\"info-box\"><a class=\"info-box-icon bg-red\" ng-click=\"home.loadApp()\"><div class=\"mtv-icon\" style=\"font-size: 15px; position: relative; top: -2px;\"><div><span>互联网医院</span></div><div class=\"mtv-icon-title\">APP下载</div></div></a><div class=\"info-box-content\"><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-info\" ng-click=\"home.dutyShow()\"><i class=\"fa fa-edit fa-fw\"></i>总值班记录</a></div><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-red\" href=\"/#/app/coop/task_third?tab=box\"><i class=\"fa fa-check-square-o fa-fw\"></i>任务目标</a></div></div></div></div><div class=\"col-md-3\"><div class=\"info-box\"><a class=\"info-box-icon bg-blue\" ui-sref=\"app.coop_q\"><div class=\"mtv-icon\"><i class=\"fa fa-question-circle fa-fw\"></i><div class=\"mtv-icon-title\">问卷调查</div></div></a><div class=\"info-box-content\"><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-info\" href=\"/#/app/coop/dean_report?tab=applied\"><i class=\"fa fa-share-alt fa-fw\"></i>问题收集</a></div><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-info\" href=\"/#/app/coop/dean_feedback?tab=list\"><i class=\"fa fa-share-square-o fa-fw\"></i>问题反馈</a></div></div></div></div><div class=\"col-md-3\"><div class=\"info-box\"><a class=\"info-box-icon bg-yellow\" ng-click=\"home.hrm()\"><div class=\"mtv-icon\"><i class=\"fa fa-users fa-fw\"></i><div class=\"mtv-icon-title\">人力资源</div></div></a><div class=\"info-box-content\"><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-info\" ng-click=\"home.operationShow()\"><i class=\"fa fa-bullhorn fa-fw\"></i>手术质控</a></div><div class=\"info-box-text\" style=\"flex-basis: 100%\"><a class=\"text-info\" ng-click=\"home.skipPhone()\"><i class=\"fa fa-phone fa-fw\"></i>值班电话</a></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-controller=\"BulletinListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-bullhorn fa-fw\"></i><a href=\"/#/app/coop/bulletin\">公告列表</a></div><a href=\"/#/app/coop/bulletin\" class=\"home-more\">更多>></a><div class=\"home-blk-table\" style=\"min-height:320px\"><table class=\"table table-hover table-row-clicked no-selection\"><tr ng-repeat=\"bulletin in home.bulletins track by bulletin.id\" ng-click=\"read(bulletin)\"><td title=\"{{bulletin.title}}\"><div><span class=\"text-red\" ng-if=\"bulletin.is_new\">[new]</span> <span ng-if=\"bulletin.has_attach\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"bulletin.is_top\">顶</span> {{bulletin.title}}</div></td><td width=\"100\" class=\"hidden-xs hidden-sm\"><span ng-bind=\"bulletin.release_time\"></span></td><td width=\"120\" class=\"hidden-xs hidden-sm overflow-ellipsis\" title=\"{{bulletin.dept}}\"><span ng-bind=\"bulletin.dept\"></span></td></tr><tr ng-if=\"home.bulletins.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div ng-controller=\"NewsListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-newspaper-o fa-fw\"></i> <a href=\"/#/app/coop/news\">新闻列表</a></div><a href=\"/#/app/coop/news?tab=search\" class=\"home-more\">更多>></a><div class=\"home-blk-table\" style=\"min-height:320px\"><table class=\"table table-hover table-row-clicked no-selection\"><tr ng-repeat=\"n in home.ns track by n.id\" ng-click=\"read(n)\"><td title=\"{{n.title}}\"><div>&lt;{{n.news_type ? n.news_type.name : n.type}}&gt; <span ng-if=\"n.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"n.top_time>n.release_time&&n.top_time>=home.today\">顶</span>&nbsp; {{n.title}}</div></td><td width=\"100\" class=\"hidden-sm hidden-xs\"><span ng-bind=\"n.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"120\" class=\"hidden-xs hidden-sm overflow-ellipsis\" title=\"{{n.dept}}\"><span>{{n.dept_from ? n.dept_from.name : n.dept}}</span></td></tr><tr ng-if=\"home.ns.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-controller=\"BidListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-bullhorn fa-fw\"></i><a href=\"/#/app/coop/bid\">招标采购</a></div><a href=\"/#/app/coop/bid\" class=\"home-more\">更多>></a><div class=\"home-blk-table\" style=\"min-height:320px\"><table class=\"table table-hover table-row-clicked no-selection\"><tr ng-repeat=\"bulletin in home.bids track by bulletin.id\" ng-click=\"read(bulletin)\"><td title=\"{{bulletin.title}}\"><div><span class=\"text-red\" ng-if=\"bulletin.is_new\">[new]</span> <span ng-if=\"bulletin.has_attach\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"bulletin.is_top\">顶</span> {{bulletin.title}}</div></td><td width=\"100\" class=\"hidden-xs hidden-sm\"><span ng-bind=\"bulletin.release_time\"></span></td><td width=\"120\" class=\"hidden-xs hidden-sm overflow-ellipsis\" title=\"{{bulletin.dept}}\"><span ng-bind=\"bulletin.dept\"></span></td></tr><tr ng-if=\"home.bids.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div ng-controller=\"RuleListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-book fa-fw\"></i> <a href=\"/#/app/coop/rule\">制度列表</a></div><a href=\"/#/app/coop/rule\" class=\"home-more\">更多>></a><div class=\"home-blk-table\" style=\"min-height:320px\"><table class=\"table table-hover table-row-clicked no-selection\"><tr ng-repeat=\"rule in home.rules track by rule.id\" ng-click=\"read(rule)\"><td title=\"{{rule.subject}}\"><div>{{rule.subject}}</div></td><td width=\"100\" class=\"hidden-xs hidden-sm\"><span ng-bind=\"rule.release_time|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"120\" class=\"hidden-xs hidden-sm overflow-ellipsis\" title=\"{{rule.dept.name}}\"><span ng-bind=\"rule.dept.name\"></span></td></tr><tr ng-if=\"home.rules.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-controller=\"FileListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-file-o fa-fw\"></i> <a href=\"/#/app/coop/file_cabinet\">文件列表</a></div><a href=\"/#/app/coop/file_cabinet\" class=\"home-more\">更多>></a><div class=\"home-blk-table\" style=\"min-height:263px\"><table class=\"table table-hover table-row-clicked no-selection\"><tr ng-repeat=\"file in home.files track by file.id\" ng-click=\"download(file)\"><td title=\"{{file.name}}\"><div>{{file.name}} <span class=\"text-muted\"><small>{{file.size | bytes}}</small></span></div></td><td width=\"100\" class=\"hidden-xs hidden-sm\"><span ng-bind=\"file.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"120\" class=\"hidden-xs hidden-sm overflow-ellipsis\" title=\"{{file.dept.name}}\"><span ng-bind=\"file.dept.name\"></span></td></tr><tr ng-if=\"home.files.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("templates/cache/main.html","<div id=\"wrapper\"><sidebar></sidebar><header></header><div id=\"page-wrapper\" ng-class=\"{\'page-wrapper-offset\':offset}\"><div ui-view=\"\"><div class=\"no-data\"><div class=\"font-lg\">你好！不小心让你发现我在这里了<i class=\"fa fa-smile-o text-yellow\"></i>,这里啥也米有～请到<a ui-sref=\"app.home\">首页逛逛</a> 或 出门<a ui-sref=\"login\">左拐</a>!</div></div></div></div><footer></footer><back-top></back-top></div><div id=\"preloader\" ng-if=\"!$finishedLoading\"><div></div></div>");
$templateCache.put("templates/cache/sidebar.html","<div class=\"navbar-default sidebar\" role=\"navigation\" ng-show=\"sidebar.showSidebar\"><div class=\"sidebar-nav\"><div class=\"p-1 sidebar-search\"><i class=\"fa fa-search fw text-muted\"></i> <input type=\"text\" class=\"form-control input-xs\" placeholder=\"请输入菜单检索\" ng-model=\"sidebar.search\" ng-model-options=\"{ debounce: 200 }\"> <button ng-if=\"sidebar.search\" class=\"close\" ng-click=\"sidebar.search=null\">&times;</button></div><ul class=\"nav in\" slimscroll=\"{height: \'{{menuHeight}}px\',touchScrollStep:100}\" slimscroll-watch=\"menuHeight\"><li class=\"mt-4\" ui-sref-active=\"active\" ng-click=\"check(0)\"><span ng-if=\"!sidebar.account.can_see_home\"></span> <a ng-else=\"\" ui-sref=\"app.home\"><i class=\"fa fa-home\">首页</i></a></li><li ng-repeat=\"item in sidebar.menuItems\" ng-if=\"sidebar.firstLvVisible(item)\" ng-class=\"{active: $root.collapseVar==$index+1}\"><a ng-click=\"check($index+1)\" title=\"{{::item.display_name}}\"><i ng-class=\"[\'fa\', \'fa-\' + item.icon]\">{{::item.display_name}}</i> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" uib-collapse=\"$root.collapseVar!=($index+1)\"><li ng-repeat=\"subItem in item.children\" ui-sref-active=\"active\" ng-if=\"sidebar.secondLvVisible(subItem)\"><a ui-sref=\"{{::subItem.state.name}}\">{{::subItem.display_name}}</a></li></ul></li></ul></div></div>");}]);